function e(e){this.message=e;}e.prototype=new Error,e.prototype.name="InvalidCharacterError";var r="undefined"!=typeof window&&window.atob&&window.atob.bind(window)||function(r){var t=String(r).replace(/=+$/,"");if(t.length%4==1)throw new e("'atob' failed: The string to be decoded is not correctly encoded.");for(var n,o,a=0,i=0,c="";o=t.charAt(i++);~o&&(n=a%4?64*n+o:o,a++%4)?c+=String.fromCharCode(255&n>>(-2*a&6)):0)o="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".indexOf(o);return c};function t(e){var t=e.replace(/-/g,"+").replace(/_/g,"/");switch(t.length%4){case 0:break;case 2:t+="==";break;case 3:t+="=";break;default:throw "Illegal base64url string!"}try{return function(e){return decodeURIComponent(r(e).replace(/(.)/g,(function(e,r){var t=r.charCodeAt(0).toString(16).toUpperCase();return t.length<2&&(t="0"+t),"%"+t})))}(t)}catch(e){return r(t)}}function n(e){this.message=e;}function o(e,r){if("string"!=typeof e)throw new n("Invalid token specified");var o=!0===(r=r||{}).header?0:1;try{return JSON.parse(t(e.split(".")[o]))}catch(e){throw new n("Invalid token specified: "+e.message)}}n.prototype=new Error,n.prototype.name="InvalidTokenError";

class ParseError extends Error {
    get error() { return this._error; }
    get text() { return this._text; }
    constructor(message, error, text) {
        super(message);
        this.name = "ParseError";
        this._error = error;
        this._text = text;
    }
}

/*! pako 2.1.0 https://github.com/nodeca/pako @license (MIT AND Zlib) */
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.

/* eslint-disable space-unary-ops */

/* Public constants ==========================================================*/
/* ===========================================================================*/


//const Z_FILTERED          = 1;
//const Z_HUFFMAN_ONLY      = 2;
//const Z_RLE               = 3;
const Z_FIXED$1               = 4;
//const Z_DEFAULT_STRATEGY  = 0;

/* Possible values of the data_type field (though see inflate()) */
const Z_BINARY              = 0;
const Z_TEXT                = 1;
//const Z_ASCII             = 1; // = Z_TEXT
const Z_UNKNOWN$1             = 2;

/*============================================================================*/


function zero$1(buf) { let len = buf.length; while (--len >= 0) { buf[len] = 0; } }

// From zutil.h

const STORED_BLOCK = 0;
const STATIC_TREES = 1;
const DYN_TREES    = 2;
/* The three kinds of block type */

const MIN_MATCH$1    = 3;
const MAX_MATCH$1    = 258;
/* The minimum and maximum match lengths */

// From deflate.h
/* ===========================================================================
 * Internal compression state.
 */

const LENGTH_CODES$1  = 29;
/* number of length codes, not counting the special END_BLOCK code */

const LITERALS$1      = 256;
/* number of literal bytes 0..255 */

const L_CODES$1       = LITERALS$1 + 1 + LENGTH_CODES$1;
/* number of Literal or Length codes, including the END_BLOCK code */

const D_CODES$1       = 30;
/* number of distance codes */

const BL_CODES$1      = 19;
/* number of codes used to transfer the bit lengths */

const HEAP_SIZE$1     = 2 * L_CODES$1 + 1;
/* maximum heap size */

const MAX_BITS$1      = 15;
/* All codes must not exceed MAX_BITS bits */

const Buf_size      = 16;
/* size of bit buffer in bi_buf */


/* ===========================================================================
 * Constants
 */

const MAX_BL_BITS = 7;
/* Bit length codes must not exceed MAX_BL_BITS bits */

const END_BLOCK   = 256;
/* end of block literal code */

const REP_3_6     = 16;
/* repeat previous bit length 3-6 times (2 bits of repeat count) */

const REPZ_3_10   = 17;
/* repeat a zero length 3-10 times  (3 bits of repeat count) */

const REPZ_11_138 = 18;
/* repeat a zero length 11-138 times  (7 bits of repeat count) */

/* eslint-disable comma-spacing,array-bracket-spacing */
const extra_lbits =   /* extra bits for each length code */
  new Uint8Array([0,0,0,0,0,0,0,0,1,1,1,1,2,2,2,2,3,3,3,3,4,4,4,4,5,5,5,5,0]);

const extra_dbits =   /* extra bits for each distance code */
  new Uint8Array([0,0,0,0,1,1,2,2,3,3,4,4,5,5,6,6,7,7,8,8,9,9,10,10,11,11,12,12,13,13]);

const extra_blbits =  /* extra bits for each bit length code */
  new Uint8Array([0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2,3,7]);

const bl_order =
  new Uint8Array([16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15]);
/* eslint-enable comma-spacing,array-bracket-spacing */

/* The lengths of the bit length codes are sent in order of decreasing
 * probability, to avoid transmitting the lengths for unused bit length codes.
 */

/* ===========================================================================
 * Local data. These are initialized only once.
 */

// We pre-fill arrays with 0 to avoid uninitialized gaps

const DIST_CODE_LEN = 512; /* see definition of array dist_code below */

// !!!! Use flat array instead of structure, Freq = i*2, Len = i*2+1
const static_ltree  = new Array((L_CODES$1 + 2) * 2);
zero$1(static_ltree);
/* The static literal tree. Since the bit lengths are imposed, there is no
 * need for the L_CODES extra codes used during heap construction. However
 * The codes 286 and 287 are needed to build a canonical tree (see _tr_init
 * below).
 */

const static_dtree  = new Array(D_CODES$1 * 2);
zero$1(static_dtree);
/* The static distance tree. (Actually a trivial tree since all codes use
 * 5 bits.)
 */

const _dist_code    = new Array(DIST_CODE_LEN);
zero$1(_dist_code);
/* Distance codes. The first 256 values correspond to the distances
 * 3 .. 258, the last 256 values correspond to the top 8 bits of
 * the 15 bit distances.
 */

const _length_code  = new Array(MAX_MATCH$1 - MIN_MATCH$1 + 1);
zero$1(_length_code);
/* length code for each normalized match length (0 == MIN_MATCH) */

const base_length   = new Array(LENGTH_CODES$1);
zero$1(base_length);
/* First normalized length for each code (0 = MIN_MATCH) */

const base_dist     = new Array(D_CODES$1);
zero$1(base_dist);
/* First normalized distance for each code (0 = distance of 1) */


function StaticTreeDesc(static_tree, extra_bits, extra_base, elems, max_length) {

  this.static_tree  = static_tree;  /* static tree or NULL */
  this.extra_bits   = extra_bits;   /* extra bits for each code or NULL */
  this.extra_base   = extra_base;   /* base index for extra_bits */
  this.elems        = elems;        /* max number of elements in the tree */
  this.max_length   = max_length;   /* max bit length for the codes */

  // show if `static_tree` has data or dummy - needed for monomorphic objects
  this.has_stree    = static_tree && static_tree.length;
}


let static_l_desc;
let static_d_desc;
let static_bl_desc;


function TreeDesc(dyn_tree, stat_desc) {
  this.dyn_tree = dyn_tree;     /* the dynamic tree */
  this.max_code = 0;            /* largest code with non zero frequency */
  this.stat_desc = stat_desc;   /* the corresponding static tree */
}



const d_code = (dist) => {

  return dist < 256 ? _dist_code[dist] : _dist_code[256 + (dist >>> 7)];
};


/* ===========================================================================
 * Output a short LSB first on the stream.
 * IN assertion: there is enough room in pendingBuf.
 */
const put_short = (s, w) => {
//    put_byte(s, (uch)((w) & 0xff));
//    put_byte(s, (uch)((ush)(w) >> 8));
  s.pending_buf[s.pending++] = (w) & 0xff;
  s.pending_buf[s.pending++] = (w >>> 8) & 0xff;
};


/* ===========================================================================
 * Send a value on a given number of bits.
 * IN assertion: length <= 16 and value fits in length bits.
 */
const send_bits = (s, value, length) => {

  if (s.bi_valid > (Buf_size - length)) {
    s.bi_buf |= (value << s.bi_valid) & 0xffff;
    put_short(s, s.bi_buf);
    s.bi_buf = value >> (Buf_size - s.bi_valid);
    s.bi_valid += length - Buf_size;
  } else {
    s.bi_buf |= (value << s.bi_valid) & 0xffff;
    s.bi_valid += length;
  }
};


const send_code = (s, c, tree) => {

  send_bits(s, tree[c * 2]/*.Code*/, tree[c * 2 + 1]/*.Len*/);
};


/* ===========================================================================
 * Reverse the first len bits of a code, using straightforward code (a faster
 * method would use a table)
 * IN assertion: 1 <= len <= 15
 */
const bi_reverse = (code, len) => {

  let res = 0;
  do {
    res |= code & 1;
    code >>>= 1;
    res <<= 1;
  } while (--len > 0);
  return res >>> 1;
};


/* ===========================================================================
 * Flush the bit buffer, keeping at most 7 bits in it.
 */
const bi_flush = (s) => {

  if (s.bi_valid === 16) {
    put_short(s, s.bi_buf);
    s.bi_buf = 0;
    s.bi_valid = 0;

  } else if (s.bi_valid >= 8) {
    s.pending_buf[s.pending++] = s.bi_buf & 0xff;
    s.bi_buf >>= 8;
    s.bi_valid -= 8;
  }
};


/* ===========================================================================
 * Compute the optimal bit lengths for a tree and update the total bit length
 * for the current block.
 * IN assertion: the fields freq and dad are set, heap[heap_max] and
 *    above are the tree nodes sorted by increasing frequency.
 * OUT assertions: the field len is set to the optimal bit length, the
 *     array bl_count contains the frequencies for each bit length.
 *     The length opt_len is updated; static_len is also updated if stree is
 *     not null.
 */
const gen_bitlen = (s, desc) => {
//    deflate_state *s;
//    tree_desc *desc;    /* the tree descriptor */

  const tree            = desc.dyn_tree;
  const max_code        = desc.max_code;
  const stree           = desc.stat_desc.static_tree;
  const has_stree       = desc.stat_desc.has_stree;
  const extra           = desc.stat_desc.extra_bits;
  const base            = desc.stat_desc.extra_base;
  const max_length      = desc.stat_desc.max_length;
  let h;              /* heap index */
  let n, m;           /* iterate over the tree elements */
  let bits;           /* bit length */
  let xbits;          /* extra bits */
  let f;              /* frequency */
  let overflow = 0;   /* number of elements with bit length too large */

  for (bits = 0; bits <= MAX_BITS$1; bits++) {
    s.bl_count[bits] = 0;
  }

  /* In a first pass, compute the optimal bit lengths (which may
   * overflow in the case of the bit length tree).
   */
  tree[s.heap[s.heap_max] * 2 + 1]/*.Len*/ = 0; /* root of the heap */

  for (h = s.heap_max + 1; h < HEAP_SIZE$1; h++) {
    n = s.heap[h];
    bits = tree[tree[n * 2 + 1]/*.Dad*/ * 2 + 1]/*.Len*/ + 1;
    if (bits > max_length) {
      bits = max_length;
      overflow++;
    }
    tree[n * 2 + 1]/*.Len*/ = bits;
    /* We overwrite tree[n].Dad which is no longer needed */

    if (n > max_code) { continue; } /* not a leaf node */

    s.bl_count[bits]++;
    xbits = 0;
    if (n >= base) {
      xbits = extra[n - base];
    }
    f = tree[n * 2]/*.Freq*/;
    s.opt_len += f * (bits + xbits);
    if (has_stree) {
      s.static_len += f * (stree[n * 2 + 1]/*.Len*/ + xbits);
    }
  }
  if (overflow === 0) { return; }

  // Tracev((stderr,"\nbit length overflow\n"));
  /* This happens for example on obj2 and pic of the Calgary corpus */

  /* Find the first bit length which could increase: */
  do {
    bits = max_length - 1;
    while (s.bl_count[bits] === 0) { bits--; }
    s.bl_count[bits]--;      /* move one leaf down the tree */
    s.bl_count[bits + 1] += 2; /* move one overflow item as its brother */
    s.bl_count[max_length]--;
    /* The brother of the overflow item also moves one step up,
     * but this does not affect bl_count[max_length]
     */
    overflow -= 2;
  } while (overflow > 0);

  /* Now recompute all bit lengths, scanning in increasing frequency.
   * h is still equal to HEAP_SIZE. (It is simpler to reconstruct all
   * lengths instead of fixing only the wrong ones. This idea is taken
   * from 'ar' written by Haruhiko Okumura.)
   */
  for (bits = max_length; bits !== 0; bits--) {
    n = s.bl_count[bits];
    while (n !== 0) {
      m = s.heap[--h];
      if (m > max_code) { continue; }
      if (tree[m * 2 + 1]/*.Len*/ !== bits) {
        // Tracev((stderr,"code %d bits %d->%d\n", m, tree[m].Len, bits));
        s.opt_len += (bits - tree[m * 2 + 1]/*.Len*/) * tree[m * 2]/*.Freq*/;
        tree[m * 2 + 1]/*.Len*/ = bits;
      }
      n--;
    }
  }
};


/* ===========================================================================
 * Generate the codes for a given tree and bit counts (which need not be
 * optimal).
 * IN assertion: the array bl_count contains the bit length statistics for
 * the given tree and the field len is set for all tree elements.
 * OUT assertion: the field code is set for all tree elements of non
 *     zero code length.
 */
const gen_codes = (tree, max_code, bl_count) => {
//    ct_data *tree;             /* the tree to decorate */
//    int max_code;              /* largest code with non zero frequency */
//    ushf *bl_count;            /* number of codes at each bit length */

  const next_code = new Array(MAX_BITS$1 + 1); /* next code value for each bit length */
  let code = 0;              /* running code value */
  let bits;                  /* bit index */
  let n;                     /* code index */

  /* The distribution counts are first used to generate the code values
   * without bit reversal.
   */
  for (bits = 1; bits <= MAX_BITS$1; bits++) {
    code = (code + bl_count[bits - 1]) << 1;
    next_code[bits] = code;
  }
  /* Check that the bit counts in bl_count are consistent. The last code
   * must be all ones.
   */
  //Assert (code + bl_count[MAX_BITS]-1 == (1<<MAX_BITS)-1,
  //        "inconsistent bit counts");
  //Tracev((stderr,"\ngen_codes: max_code %d ", max_code));

  for (n = 0;  n <= max_code; n++) {
    let len = tree[n * 2 + 1]/*.Len*/;
    if (len === 0) { continue; }
    /* Now reverse the bits */
    tree[n * 2]/*.Code*/ = bi_reverse(next_code[len]++, len);

    //Tracecv(tree != static_ltree, (stderr,"\nn %3d %c l %2d c %4x (%x) ",
    //     n, (isgraph(n) ? n : ' '), len, tree[n].Code, next_code[len]-1));
  }
};


/* ===========================================================================
 * Initialize the various 'constant' tables.
 */
const tr_static_init = () => {

  let n;        /* iterates over tree elements */
  let bits;     /* bit counter */
  let length;   /* length value */
  let code;     /* code value */
  let dist;     /* distance index */
  const bl_count = new Array(MAX_BITS$1 + 1);
  /* number of codes at each bit length for an optimal tree */

  // do check in _tr_init()
  //if (static_init_done) return;

  /* For some embedded targets, global variables are not initialized: */
/*#ifdef NO_INIT_GLOBAL_POINTERS
  static_l_desc.static_tree = static_ltree;
  static_l_desc.extra_bits = extra_lbits;
  static_d_desc.static_tree = static_dtree;
  static_d_desc.extra_bits = extra_dbits;
  static_bl_desc.extra_bits = extra_blbits;
#endif*/

  /* Initialize the mapping length (0..255) -> length code (0..28) */
  length = 0;
  for (code = 0; code < LENGTH_CODES$1 - 1; code++) {
    base_length[code] = length;
    for (n = 0; n < (1 << extra_lbits[code]); n++) {
      _length_code[length++] = code;
    }
  }
  //Assert (length == 256, "tr_static_init: length != 256");
  /* Note that the length 255 (match length 258) can be represented
   * in two different ways: code 284 + 5 bits or code 285, so we
   * overwrite length_code[255] to use the best encoding:
   */
  _length_code[length - 1] = code;

  /* Initialize the mapping dist (0..32K) -> dist code (0..29) */
  dist = 0;
  for (code = 0; code < 16; code++) {
    base_dist[code] = dist;
    for (n = 0; n < (1 << extra_dbits[code]); n++) {
      _dist_code[dist++] = code;
    }
  }
  //Assert (dist == 256, "tr_static_init: dist != 256");
  dist >>= 7; /* from now on, all distances are divided by 128 */
  for (; code < D_CODES$1; code++) {
    base_dist[code] = dist << 7;
    for (n = 0; n < (1 << (extra_dbits[code] - 7)); n++) {
      _dist_code[256 + dist++] = code;
    }
  }
  //Assert (dist == 256, "tr_static_init: 256+dist != 512");

  /* Construct the codes of the static literal tree */
  for (bits = 0; bits <= MAX_BITS$1; bits++) {
    bl_count[bits] = 0;
  }

  n = 0;
  while (n <= 143) {
    static_ltree[n * 2 + 1]/*.Len*/ = 8;
    n++;
    bl_count[8]++;
  }
  while (n <= 255) {
    static_ltree[n * 2 + 1]/*.Len*/ = 9;
    n++;
    bl_count[9]++;
  }
  while (n <= 279) {
    static_ltree[n * 2 + 1]/*.Len*/ = 7;
    n++;
    bl_count[7]++;
  }
  while (n <= 287) {
    static_ltree[n * 2 + 1]/*.Len*/ = 8;
    n++;
    bl_count[8]++;
  }
  /* Codes 286 and 287 do not exist, but we must include them in the
   * tree construction to get a canonical Huffman tree (longest code
   * all ones)
   */
  gen_codes(static_ltree, L_CODES$1 + 1, bl_count);

  /* The static distance tree is trivial: */
  for (n = 0; n < D_CODES$1; n++) {
    static_dtree[n * 2 + 1]/*.Len*/ = 5;
    static_dtree[n * 2]/*.Code*/ = bi_reverse(n, 5);
  }

  // Now data ready and we can init static trees
  static_l_desc = new StaticTreeDesc(static_ltree, extra_lbits, LITERALS$1 + 1, L_CODES$1, MAX_BITS$1);
  static_d_desc = new StaticTreeDesc(static_dtree, extra_dbits, 0,          D_CODES$1, MAX_BITS$1);
  static_bl_desc = new StaticTreeDesc(new Array(0), extra_blbits, 0,         BL_CODES$1, MAX_BL_BITS);

  //static_init_done = true;
};


/* ===========================================================================
 * Initialize a new block.
 */
const init_block = (s) => {

  let n; /* iterates over tree elements */

  /* Initialize the trees. */
  for (n = 0; n < L_CODES$1;  n++) { s.dyn_ltree[n * 2]/*.Freq*/ = 0; }
  for (n = 0; n < D_CODES$1;  n++) { s.dyn_dtree[n * 2]/*.Freq*/ = 0; }
  for (n = 0; n < BL_CODES$1; n++) { s.bl_tree[n * 2]/*.Freq*/ = 0; }

  s.dyn_ltree[END_BLOCK * 2]/*.Freq*/ = 1;
  s.opt_len = s.static_len = 0;
  s.sym_next = s.matches = 0;
};


/* ===========================================================================
 * Flush the bit buffer and align the output on a byte boundary
 */
const bi_windup = (s) =>
{
  if (s.bi_valid > 8) {
    put_short(s, s.bi_buf);
  } else if (s.bi_valid > 0) {
    //put_byte(s, (Byte)s->bi_buf);
    s.pending_buf[s.pending++] = s.bi_buf;
  }
  s.bi_buf = 0;
  s.bi_valid = 0;
};

/* ===========================================================================
 * Compares to subtrees, using the tree depth as tie breaker when
 * the subtrees have equal frequency. This minimizes the worst case length.
 */
const smaller = (tree, n, m, depth) => {

  const _n2 = n * 2;
  const _m2 = m * 2;
  return (tree[_n2]/*.Freq*/ < tree[_m2]/*.Freq*/ ||
         (tree[_n2]/*.Freq*/ === tree[_m2]/*.Freq*/ && depth[n] <= depth[m]));
};

/* ===========================================================================
 * Restore the heap property by moving down the tree starting at node k,
 * exchanging a node with the smallest of its two sons if necessary, stopping
 * when the heap property is re-established (each father smaller than its
 * two sons).
 */
const pqdownheap = (s, tree, k) => {
//    deflate_state *s;
//    ct_data *tree;  /* the tree to restore */
//    int k;               /* node to move down */

  const v = s.heap[k];
  let j = k << 1;  /* left son of k */
  while (j <= s.heap_len) {
    /* Set j to the smallest of the two sons: */
    if (j < s.heap_len &&
      smaller(tree, s.heap[j + 1], s.heap[j], s.depth)) {
      j++;
    }
    /* Exit if v is smaller than both sons */
    if (smaller(tree, v, s.heap[j], s.depth)) { break; }

    /* Exchange v with the smallest son */
    s.heap[k] = s.heap[j];
    k = j;

    /* And continue down the tree, setting j to the left son of k */
    j <<= 1;
  }
  s.heap[k] = v;
};


// inlined manually
// const SMALLEST = 1;

/* ===========================================================================
 * Send the block data compressed using the given Huffman trees
 */
const compress_block = (s, ltree, dtree) => {
//    deflate_state *s;
//    const ct_data *ltree; /* literal tree */
//    const ct_data *dtree; /* distance tree */

  let dist;           /* distance of matched string */
  let lc;             /* match length or unmatched char (if dist == 0) */
  let sx = 0;         /* running index in sym_buf */
  let code;           /* the code to send */
  let extra;          /* number of extra bits to send */

  if (s.sym_next !== 0) {
    do {
      dist = s.pending_buf[s.sym_buf + sx++] & 0xff;
      dist += (s.pending_buf[s.sym_buf + sx++] & 0xff) << 8;
      lc = s.pending_buf[s.sym_buf + sx++];
      if (dist === 0) {
        send_code(s, lc, ltree); /* send a literal byte */
        //Tracecv(isgraph(lc), (stderr," '%c' ", lc));
      } else {
        /* Here, lc is the match length - MIN_MATCH */
        code = _length_code[lc];
        send_code(s, code + LITERALS$1 + 1, ltree); /* send the length code */
        extra = extra_lbits[code];
        if (extra !== 0) {
          lc -= base_length[code];
          send_bits(s, lc, extra);       /* send the extra length bits */
        }
        dist--; /* dist is now the match distance - 1 */
        code = d_code(dist);
        //Assert (code < D_CODES, "bad d_code");

        send_code(s, code, dtree);       /* send the distance code */
        extra = extra_dbits[code];
        if (extra !== 0) {
          dist -= base_dist[code];
          send_bits(s, dist, extra);   /* send the extra distance bits */
        }
      } /* literal or match pair ? */

      /* Check that the overlay between pending_buf and sym_buf is ok: */
      //Assert(s->pending < s->lit_bufsize + sx, "pendingBuf overflow");

    } while (sx < s.sym_next);
  }

  send_code(s, END_BLOCK, ltree);
};


/* ===========================================================================
 * Construct one Huffman tree and assigns the code bit strings and lengths.
 * Update the total bit length for the current block.
 * IN assertion: the field freq is set for all tree elements.
 * OUT assertions: the fields len and code are set to the optimal bit length
 *     and corresponding code. The length opt_len is updated; static_len is
 *     also updated if stree is not null. The field max_code is set.
 */
const build_tree = (s, desc) => {
//    deflate_state *s;
//    tree_desc *desc; /* the tree descriptor */

  const tree     = desc.dyn_tree;
  const stree    = desc.stat_desc.static_tree;
  const has_stree = desc.stat_desc.has_stree;
  const elems    = desc.stat_desc.elems;
  let n, m;          /* iterate over heap elements */
  let max_code = -1; /* largest code with non zero frequency */
  let node;          /* new node being created */

  /* Construct the initial heap, with least frequent element in
   * heap[SMALLEST]. The sons of heap[n] are heap[2*n] and heap[2*n+1].
   * heap[0] is not used.
   */
  s.heap_len = 0;
  s.heap_max = HEAP_SIZE$1;

  for (n = 0; n < elems; n++) {
    if (tree[n * 2]/*.Freq*/ !== 0) {
      s.heap[++s.heap_len] = max_code = n;
      s.depth[n] = 0;

    } else {
      tree[n * 2 + 1]/*.Len*/ = 0;
    }
  }

  /* The pkzip format requires that at least one distance code exists,
   * and that at least one bit should be sent even if there is only one
   * possible code. So to avoid special checks later on we force at least
   * two codes of non zero frequency.
   */
  while (s.heap_len < 2) {
    node = s.heap[++s.heap_len] = (max_code < 2 ? ++max_code : 0);
    tree[node * 2]/*.Freq*/ = 1;
    s.depth[node] = 0;
    s.opt_len--;

    if (has_stree) {
      s.static_len -= stree[node * 2 + 1]/*.Len*/;
    }
    /* node is 0 or 1 so it does not have extra bits */
  }
  desc.max_code = max_code;

  /* The elements heap[heap_len/2+1 .. heap_len] are leaves of the tree,
   * establish sub-heaps of increasing lengths:
   */
  for (n = (s.heap_len >> 1/*int /2*/); n >= 1; n--) { pqdownheap(s, tree, n); }

  /* Construct the Huffman tree by repeatedly combining the least two
   * frequent nodes.
   */
  node = elems;              /* next internal node of the tree */
  do {
    //pqremove(s, tree, n);  /* n = node of least frequency */
    /*** pqremove ***/
    n = s.heap[1/*SMALLEST*/];
    s.heap[1/*SMALLEST*/] = s.heap[s.heap_len--];
    pqdownheap(s, tree, 1/*SMALLEST*/);
    /***/

    m = s.heap[1/*SMALLEST*/]; /* m = node of next least frequency */

    s.heap[--s.heap_max] = n; /* keep the nodes sorted by frequency */
    s.heap[--s.heap_max] = m;

    /* Create a new node father of n and m */
    tree[node * 2]/*.Freq*/ = tree[n * 2]/*.Freq*/ + tree[m * 2]/*.Freq*/;
    s.depth[node] = (s.depth[n] >= s.depth[m] ? s.depth[n] : s.depth[m]) + 1;
    tree[n * 2 + 1]/*.Dad*/ = tree[m * 2 + 1]/*.Dad*/ = node;

    /* and insert the new node in the heap */
    s.heap[1/*SMALLEST*/] = node++;
    pqdownheap(s, tree, 1/*SMALLEST*/);

  } while (s.heap_len >= 2);

  s.heap[--s.heap_max] = s.heap[1/*SMALLEST*/];

  /* At this point, the fields freq and dad are set. We can now
   * generate the bit lengths.
   */
  gen_bitlen(s, desc);

  /* The field len is now set, we can generate the bit codes */
  gen_codes(tree, max_code, s.bl_count);
};


/* ===========================================================================
 * Scan a literal or distance tree to determine the frequencies of the codes
 * in the bit length tree.
 */
const scan_tree = (s, tree, max_code) => {
//    deflate_state *s;
//    ct_data *tree;   /* the tree to be scanned */
//    int max_code;    /* and its largest code of non zero frequency */

  let n;                     /* iterates over all tree elements */
  let prevlen = -1;          /* last emitted length */
  let curlen;                /* length of current code */

  let nextlen = tree[0 * 2 + 1]/*.Len*/; /* length of next code */

  let count = 0;             /* repeat count of the current code */
  let max_count = 7;         /* max repeat count */
  let min_count = 4;         /* min repeat count */

  if (nextlen === 0) {
    max_count = 138;
    min_count = 3;
  }
  tree[(max_code + 1) * 2 + 1]/*.Len*/ = 0xffff; /* guard */

  for (n = 0; n <= max_code; n++) {
    curlen = nextlen;
    nextlen = tree[(n + 1) * 2 + 1]/*.Len*/;

    if (++count < max_count && curlen === nextlen) {
      continue;

    } else if (count < min_count) {
      s.bl_tree[curlen * 2]/*.Freq*/ += count;

    } else if (curlen !== 0) {

      if (curlen !== prevlen) { s.bl_tree[curlen * 2]/*.Freq*/++; }
      s.bl_tree[REP_3_6 * 2]/*.Freq*/++;

    } else if (count <= 10) {
      s.bl_tree[REPZ_3_10 * 2]/*.Freq*/++;

    } else {
      s.bl_tree[REPZ_11_138 * 2]/*.Freq*/++;
    }

    count = 0;
    prevlen = curlen;

    if (nextlen === 0) {
      max_count = 138;
      min_count = 3;

    } else if (curlen === nextlen) {
      max_count = 6;
      min_count = 3;

    } else {
      max_count = 7;
      min_count = 4;
    }
  }
};


/* ===========================================================================
 * Send a literal or distance tree in compressed form, using the codes in
 * bl_tree.
 */
const send_tree = (s, tree, max_code) => {
//    deflate_state *s;
//    ct_data *tree; /* the tree to be scanned */
//    int max_code;       /* and its largest code of non zero frequency */

  let n;                     /* iterates over all tree elements */
  let prevlen = -1;          /* last emitted length */
  let curlen;                /* length of current code */

  let nextlen = tree[0 * 2 + 1]/*.Len*/; /* length of next code */

  let count = 0;             /* repeat count of the current code */
  let max_count = 7;         /* max repeat count */
  let min_count = 4;         /* min repeat count */

  /* tree[max_code+1].Len = -1; */  /* guard already set */
  if (nextlen === 0) {
    max_count = 138;
    min_count = 3;
  }

  for (n = 0; n <= max_code; n++) {
    curlen = nextlen;
    nextlen = tree[(n + 1) * 2 + 1]/*.Len*/;

    if (++count < max_count && curlen === nextlen) {
      continue;

    } else if (count < min_count) {
      do { send_code(s, curlen, s.bl_tree); } while (--count !== 0);

    } else if (curlen !== 0) {
      if (curlen !== prevlen) {
        send_code(s, curlen, s.bl_tree);
        count--;
      }
      //Assert(count >= 3 && count <= 6, " 3_6?");
      send_code(s, REP_3_6, s.bl_tree);
      send_bits(s, count - 3, 2);

    } else if (count <= 10) {
      send_code(s, REPZ_3_10, s.bl_tree);
      send_bits(s, count - 3, 3);

    } else {
      send_code(s, REPZ_11_138, s.bl_tree);
      send_bits(s, count - 11, 7);
    }

    count = 0;
    prevlen = curlen;
    if (nextlen === 0) {
      max_count = 138;
      min_count = 3;

    } else if (curlen === nextlen) {
      max_count = 6;
      min_count = 3;

    } else {
      max_count = 7;
      min_count = 4;
    }
  }
};


/* ===========================================================================
 * Construct the Huffman tree for the bit lengths and return the index in
 * bl_order of the last bit length code to send.
 */
const build_bl_tree = (s) => {

  let max_blindex;  /* index of last bit length code of non zero freq */

  /* Determine the bit length frequencies for literal and distance trees */
  scan_tree(s, s.dyn_ltree, s.l_desc.max_code);
  scan_tree(s, s.dyn_dtree, s.d_desc.max_code);

  /* Build the bit length tree: */
  build_tree(s, s.bl_desc);
  /* opt_len now includes the length of the tree representations, except
   * the lengths of the bit lengths codes and the 5+5+4 bits for the counts.
   */

  /* Determine the number of bit length codes to send. The pkzip format
   * requires that at least 4 bit length codes be sent. (appnote.txt says
   * 3 but the actual value used is 4.)
   */
  for (max_blindex = BL_CODES$1 - 1; max_blindex >= 3; max_blindex--) {
    if (s.bl_tree[bl_order[max_blindex] * 2 + 1]/*.Len*/ !== 0) {
      break;
    }
  }
  /* Update opt_len to include the bit length tree and counts */
  s.opt_len += 3 * (max_blindex + 1) + 5 + 5 + 4;
  //Tracev((stderr, "\ndyn trees: dyn %ld, stat %ld",
  //        s->opt_len, s->static_len));

  return max_blindex;
};


/* ===========================================================================
 * Send the header for a block using dynamic Huffman trees: the counts, the
 * lengths of the bit length codes, the literal tree and the distance tree.
 * IN assertion: lcodes >= 257, dcodes >= 1, blcodes >= 4.
 */
const send_all_trees = (s, lcodes, dcodes, blcodes) => {
//    deflate_state *s;
//    int lcodes, dcodes, blcodes; /* number of codes for each tree */

  let rank;                    /* index in bl_order */

  //Assert (lcodes >= 257 && dcodes >= 1 && blcodes >= 4, "not enough codes");
  //Assert (lcodes <= L_CODES && dcodes <= D_CODES && blcodes <= BL_CODES,
  //        "too many codes");
  //Tracev((stderr, "\nbl counts: "));
  send_bits(s, lcodes - 257, 5); /* not +255 as stated in appnote.txt */
  send_bits(s, dcodes - 1,   5);
  send_bits(s, blcodes - 4,  4); /* not -3 as stated in appnote.txt */
  for (rank = 0; rank < blcodes; rank++) {
    //Tracev((stderr, "\nbl code %2d ", bl_order[rank]));
    send_bits(s, s.bl_tree[bl_order[rank] * 2 + 1]/*.Len*/, 3);
  }
  //Tracev((stderr, "\nbl tree: sent %ld", s->bits_sent));

  send_tree(s, s.dyn_ltree, lcodes - 1); /* literal tree */
  //Tracev((stderr, "\nlit tree: sent %ld", s->bits_sent));

  send_tree(s, s.dyn_dtree, dcodes - 1); /* distance tree */
  //Tracev((stderr, "\ndist tree: sent %ld", s->bits_sent));
};


/* ===========================================================================
 * Check if the data type is TEXT or BINARY, using the following algorithm:
 * - TEXT if the two conditions below are satisfied:
 *    a) There are no non-portable control characters belonging to the
 *       "block list" (0..6, 14..25, 28..31).
 *    b) There is at least one printable character belonging to the
 *       "allow list" (9 {TAB}, 10 {LF}, 13 {CR}, 32..255).
 * - BINARY otherwise.
 * - The following partially-portable control characters form a
 *   "gray list" that is ignored in this detection algorithm:
 *   (7 {BEL}, 8 {BS}, 11 {VT}, 12 {FF}, 26 {SUB}, 27 {ESC}).
 * IN assertion: the fields Freq of dyn_ltree are set.
 */
const detect_data_type = (s) => {
  /* block_mask is the bit mask of block-listed bytes
   * set bits 0..6, 14..25, and 28..31
   * 0xf3ffc07f = binary 11110011111111111100000001111111
   */
  let block_mask = 0xf3ffc07f;
  let n;

  /* Check for non-textual ("block-listed") bytes. */
  for (n = 0; n <= 31; n++, block_mask >>>= 1) {
    if ((block_mask & 1) && (s.dyn_ltree[n * 2]/*.Freq*/ !== 0)) {
      return Z_BINARY;
    }
  }

  /* Check for textual ("allow-listed") bytes. */
  if (s.dyn_ltree[9 * 2]/*.Freq*/ !== 0 || s.dyn_ltree[10 * 2]/*.Freq*/ !== 0 ||
      s.dyn_ltree[13 * 2]/*.Freq*/ !== 0) {
    return Z_TEXT;
  }
  for (n = 32; n < LITERALS$1; n++) {
    if (s.dyn_ltree[n * 2]/*.Freq*/ !== 0) {
      return Z_TEXT;
    }
  }

  /* There are no "block-listed" or "allow-listed" bytes:
   * this stream either is empty or has tolerated ("gray-listed") bytes only.
   */
  return Z_BINARY;
};


let static_init_done = false;

/* ===========================================================================
 * Initialize the tree data structures for a new zlib stream.
 */
const _tr_init$1 = (s) =>
{

  if (!static_init_done) {
    tr_static_init();
    static_init_done = true;
  }

  s.l_desc  = new TreeDesc(s.dyn_ltree, static_l_desc);
  s.d_desc  = new TreeDesc(s.dyn_dtree, static_d_desc);
  s.bl_desc = new TreeDesc(s.bl_tree, static_bl_desc);

  s.bi_buf = 0;
  s.bi_valid = 0;

  /* Initialize the first block of the first file: */
  init_block(s);
};


/* ===========================================================================
 * Send a stored block
 */
const _tr_stored_block$1 = (s, buf, stored_len, last) => {
//DeflateState *s;
//charf *buf;       /* input block */
//ulg stored_len;   /* length of input block */
//int last;         /* one if this is the last block for a file */

  send_bits(s, (STORED_BLOCK << 1) + (last ? 1 : 0), 3);    /* send block type */
  bi_windup(s);        /* align on byte boundary */
  put_short(s, stored_len);
  put_short(s, ~stored_len);
  if (stored_len) {
    s.pending_buf.set(s.window.subarray(buf, buf + stored_len), s.pending);
  }
  s.pending += stored_len;
};


/* ===========================================================================
 * Send one empty static block to give enough lookahead for inflate.
 * This takes 10 bits, of which 7 may remain in the bit buffer.
 */
const _tr_align$1 = (s) => {
  send_bits(s, STATIC_TREES << 1, 3);
  send_code(s, END_BLOCK, static_ltree);
  bi_flush(s);
};


/* ===========================================================================
 * Determine the best encoding for the current block: dynamic trees, static
 * trees or store, and write out the encoded block.
 */
const _tr_flush_block$1 = (s, buf, stored_len, last) => {
//DeflateState *s;
//charf *buf;       /* input block, or NULL if too old */
//ulg stored_len;   /* length of input block */
//int last;         /* one if this is the last block for a file */

  let opt_lenb, static_lenb;  /* opt_len and static_len in bytes */
  let max_blindex = 0;        /* index of last bit length code of non zero freq */

  /* Build the Huffman trees unless a stored block is forced */
  if (s.level > 0) {

    /* Check if the file is binary or text */
    if (s.strm.data_type === Z_UNKNOWN$1) {
      s.strm.data_type = detect_data_type(s);
    }

    /* Construct the literal and distance trees */
    build_tree(s, s.l_desc);
    // Tracev((stderr, "\nlit data: dyn %ld, stat %ld", s->opt_len,
    //        s->static_len));

    build_tree(s, s.d_desc);
    // Tracev((stderr, "\ndist data: dyn %ld, stat %ld", s->opt_len,
    //        s->static_len));
    /* At this point, opt_len and static_len are the total bit lengths of
     * the compressed block data, excluding the tree representations.
     */

    /* Build the bit length tree for the above two trees, and get the index
     * in bl_order of the last bit length code to send.
     */
    max_blindex = build_bl_tree(s);

    /* Determine the best encoding. Compute the block lengths in bytes. */
    opt_lenb = (s.opt_len + 3 + 7) >>> 3;
    static_lenb = (s.static_len + 3 + 7) >>> 3;

    // Tracev((stderr, "\nopt %lu(%lu) stat %lu(%lu) stored %lu lit %u ",
    //        opt_lenb, s->opt_len, static_lenb, s->static_len, stored_len,
    //        s->sym_next / 3));

    if (static_lenb <= opt_lenb) { opt_lenb = static_lenb; }

  } else {
    // Assert(buf != (char*)0, "lost buf");
    opt_lenb = static_lenb = stored_len + 5; /* force a stored block */
  }

  if ((stored_len + 4 <= opt_lenb) && (buf !== -1)) {
    /* 4: two words for the lengths */

    /* The test buf != NULL is only necessary if LIT_BUFSIZE > WSIZE.
     * Otherwise we can't have processed more than WSIZE input bytes since
     * the last block flush, because compression would have been
     * successful. If LIT_BUFSIZE <= WSIZE, it is never too late to
     * transform a block into a stored block.
     */
    _tr_stored_block$1(s, buf, stored_len, last);

  } else if (s.strategy === Z_FIXED$1 || static_lenb === opt_lenb) {

    send_bits(s, (STATIC_TREES << 1) + (last ? 1 : 0), 3);
    compress_block(s, static_ltree, static_dtree);

  } else {
    send_bits(s, (DYN_TREES << 1) + (last ? 1 : 0), 3);
    send_all_trees(s, s.l_desc.max_code + 1, s.d_desc.max_code + 1, max_blindex + 1);
    compress_block(s, s.dyn_ltree, s.dyn_dtree);
  }
  // Assert (s->compressed_len == s->bits_sent, "bad compressed size");
  /* The above check is made mod 2^32, for files larger than 512 MB
   * and uLong implemented on 32 bits.
   */
  init_block(s);

  if (last) {
    bi_windup(s);
  }
  // Tracev((stderr,"\ncomprlen %lu(%lu) ", s->compressed_len>>3,
  //       s->compressed_len-7*last));
};

/* ===========================================================================
 * Save the match info and tally the frequency counts. Return true if
 * the current block must be flushed.
 */
const _tr_tally$1 = (s, dist, lc) => {
//    deflate_state *s;
//    unsigned dist;  /* distance of matched string */
//    unsigned lc;    /* match length-MIN_MATCH or unmatched char (if dist==0) */

  s.pending_buf[s.sym_buf + s.sym_next++] = dist;
  s.pending_buf[s.sym_buf + s.sym_next++] = dist >> 8;
  s.pending_buf[s.sym_buf + s.sym_next++] = lc;
  if (dist === 0) {
    /* lc is the unmatched char */
    s.dyn_ltree[lc * 2]/*.Freq*/++;
  } else {
    s.matches++;
    /* Here, lc is the match length - MIN_MATCH */
    dist--;             /* dist = match distance - 1 */
    //Assert((ush)dist < (ush)MAX_DIST(s) &&
    //       (ush)lc <= (ush)(MAX_MATCH-MIN_MATCH) &&
    //       (ush)d_code(dist) < (ush)D_CODES,  "_tr_tally: bad match");

    s.dyn_ltree[(_length_code[lc] + LITERALS$1 + 1) * 2]/*.Freq*/++;
    s.dyn_dtree[d_code(dist) * 2]/*.Freq*/++;
  }

  return (s.sym_next === s.sym_end);
};

var _tr_init_1  = _tr_init$1;
var _tr_stored_block_1 = _tr_stored_block$1;
var _tr_flush_block_1  = _tr_flush_block$1;
var _tr_tally_1 = _tr_tally$1;
var _tr_align_1 = _tr_align$1;

var trees = {
	_tr_init: _tr_init_1,
	_tr_stored_block: _tr_stored_block_1,
	_tr_flush_block: _tr_flush_block_1,
	_tr_tally: _tr_tally_1,
	_tr_align: _tr_align_1
};

// Note: adler32 takes 12% for level 0 and 2% for level 6.
// It isn't worth it to make additional optimizations as in original.
// Small size is preferable.

// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.

const adler32 = (adler, buf, len, pos) => {
  let s1 = (adler & 0xffff) |0,
      s2 = ((adler >>> 16) & 0xffff) |0,
      n = 0;

  while (len !== 0) {
    // Set limit ~ twice less than 5552, to keep
    // s2 in 31-bits, because we force signed ints.
    // in other case %= will fail.
    n = len > 2000 ? 2000 : len;
    len -= n;

    do {
      s1 = (s1 + buf[pos++]) |0;
      s2 = (s2 + s1) |0;
    } while (--n);

    s1 %= 65521;
    s2 %= 65521;
  }

  return (s1 | (s2 << 16)) |0;
};


var adler32_1 = adler32;

// Note: we can't get significant speed boost here.
// So write code to minimize size - no pregenerated tables
// and array tools dependencies.

// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.

// Use ordinary array, since untyped makes no boost here
const makeTable = () => {
  let c, table = [];

  for (var n = 0; n < 256; n++) {
    c = n;
    for (var k = 0; k < 8; k++) {
      c = ((c & 1) ? (0xEDB88320 ^ (c >>> 1)) : (c >>> 1));
    }
    table[n] = c;
  }

  return table;
};

// Create table on load. Just 255 signed longs. Not a problem.
const crcTable = new Uint32Array(makeTable());


const crc32 = (crc, buf, len, pos) => {
  const t = crcTable;
  const end = pos + len;

  crc ^= -1;

  for (let i = pos; i < end; i++) {
    crc = (crc >>> 8) ^ t[(crc ^ buf[i]) & 0xFF];
  }

  return (crc ^ (-1)); // >>> 0;
};


var crc32_1 = crc32;

// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.

var messages = {
  2:      'need dictionary',     /* Z_NEED_DICT       2  */
  1:      'stream end',          /* Z_STREAM_END      1  */
  0:      '',                    /* Z_OK              0  */
  '-1':   'file error',          /* Z_ERRNO         (-1) */
  '-2':   'stream error',        /* Z_STREAM_ERROR  (-2) */
  '-3':   'data error',          /* Z_DATA_ERROR    (-3) */
  '-4':   'insufficient memory', /* Z_MEM_ERROR     (-4) */
  '-5':   'buffer error',        /* Z_BUF_ERROR     (-5) */
  '-6':   'incompatible version' /* Z_VERSION_ERROR (-6) */
};

// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.

var constants$2 = {

  /* Allowed flush values; see deflate() and inflate() below for details */
  Z_NO_FLUSH:         0,
  Z_PARTIAL_FLUSH:    1,
  Z_SYNC_FLUSH:       2,
  Z_FULL_FLUSH:       3,
  Z_FINISH:           4,
  Z_BLOCK:            5,
  Z_TREES:            6,

  /* Return codes for the compression/decompression functions. Negative values
  * are errors, positive values are used for special but normal events.
  */
  Z_OK:               0,
  Z_STREAM_END:       1,
  Z_NEED_DICT:        2,
  Z_ERRNO:           -1,
  Z_STREAM_ERROR:    -2,
  Z_DATA_ERROR:      -3,
  Z_MEM_ERROR:       -4,
  Z_BUF_ERROR:       -5,
  //Z_VERSION_ERROR: -6,

  /* compression levels */
  Z_NO_COMPRESSION:         0,
  Z_BEST_SPEED:             1,
  Z_BEST_COMPRESSION:       9,
  Z_DEFAULT_COMPRESSION:   -1,


  Z_FILTERED:               1,
  Z_HUFFMAN_ONLY:           2,
  Z_RLE:                    3,
  Z_FIXED:                  4,
  Z_DEFAULT_STRATEGY:       0,

  /* Possible values of the data_type field (though see inflate()) */
  Z_BINARY:                 0,
  Z_TEXT:                   1,
  //Z_ASCII:                1, // = Z_TEXT (deprecated)
  Z_UNKNOWN:                2,

  /* The deflate compression method */
  Z_DEFLATED:               8
  //Z_NULL:                 null // Use -1 or null inline, depending on var type
};

// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.

const { _tr_init, _tr_stored_block, _tr_flush_block, _tr_tally, _tr_align } = trees;




/* Public constants ==========================================================*/
/* ===========================================================================*/

const {
  Z_NO_FLUSH: Z_NO_FLUSH$2, Z_PARTIAL_FLUSH, Z_FULL_FLUSH: Z_FULL_FLUSH$1, Z_FINISH: Z_FINISH$3, Z_BLOCK: Z_BLOCK$1,
  Z_OK: Z_OK$3, Z_STREAM_END: Z_STREAM_END$3, Z_STREAM_ERROR: Z_STREAM_ERROR$2, Z_DATA_ERROR: Z_DATA_ERROR$2, Z_BUF_ERROR: Z_BUF_ERROR$1,
  Z_DEFAULT_COMPRESSION: Z_DEFAULT_COMPRESSION$1,
  Z_FILTERED, Z_HUFFMAN_ONLY, Z_RLE, Z_FIXED, Z_DEFAULT_STRATEGY: Z_DEFAULT_STRATEGY$1,
  Z_UNKNOWN,
  Z_DEFLATED: Z_DEFLATED$2
} = constants$2;

/*============================================================================*/


const MAX_MEM_LEVEL = 9;
/* Maximum value for memLevel in deflateInit2 */
const MAX_WBITS$1 = 15;
/* 32K LZ77 window */
const DEF_MEM_LEVEL = 8;


const LENGTH_CODES  = 29;
/* number of length codes, not counting the special END_BLOCK code */
const LITERALS      = 256;
/* number of literal bytes 0..255 */
const L_CODES       = LITERALS + 1 + LENGTH_CODES;
/* number of Literal or Length codes, including the END_BLOCK code */
const D_CODES       = 30;
/* number of distance codes */
const BL_CODES      = 19;
/* number of codes used to transfer the bit lengths */
const HEAP_SIZE     = 2 * L_CODES + 1;
/* maximum heap size */
const MAX_BITS  = 15;
/* All codes must not exceed MAX_BITS bits */

const MIN_MATCH = 3;
const MAX_MATCH = 258;
const MIN_LOOKAHEAD = (MAX_MATCH + MIN_MATCH + 1);

const PRESET_DICT = 0x20;

const INIT_STATE    =  42;    /* zlib header -> BUSY_STATE */
//#ifdef GZIP
const GZIP_STATE    =  57;    /* gzip header -> BUSY_STATE | EXTRA_STATE */
//#endif
const EXTRA_STATE   =  69;    /* gzip extra block -> NAME_STATE */
const NAME_STATE    =  73;    /* gzip file name -> COMMENT_STATE */
const COMMENT_STATE =  91;    /* gzip comment -> HCRC_STATE */
const HCRC_STATE    = 103;    /* gzip header CRC -> BUSY_STATE */
const BUSY_STATE    = 113;    /* deflate -> FINISH_STATE */
const FINISH_STATE  = 666;    /* stream complete */

const BS_NEED_MORE      = 1; /* block not completed, need more input or more output */
const BS_BLOCK_DONE     = 2; /* block flush performed */
const BS_FINISH_STARTED = 3; /* finish started, need only more output at next deflate */
const BS_FINISH_DONE    = 4; /* finish done, accept no more input or output */

const OS_CODE = 0x03; // Unix :) . Don't detect, use this default.

const err = (strm, errorCode) => {
  strm.msg = messages[errorCode];
  return errorCode;
};

const rank = (f) => {
  return ((f) * 2) - ((f) > 4 ? 9 : 0);
};

const zero = (buf) => {
  let len = buf.length; while (--len >= 0) { buf[len] = 0; }
};

/* ===========================================================================
 * Slide the hash table when sliding the window down (could be avoided with 32
 * bit values at the expense of memory usage). We slide even when level == 0 to
 * keep the hash table consistent if we switch back to level > 0 later.
 */
const slide_hash = (s) => {
  let n, m;
  let p;
  let wsize = s.w_size;

  n = s.hash_size;
  p = n;
  do {
    m = s.head[--p];
    s.head[p] = (m >= wsize ? m - wsize : 0);
  } while (--n);
  n = wsize;
//#ifndef FASTEST
  p = n;
  do {
    m = s.prev[--p];
    s.prev[p] = (m >= wsize ? m - wsize : 0);
    /* If n is not on any hash chain, prev[n] is garbage but
     * its value will never be used.
     */
  } while (--n);
//#endif
};

/* eslint-disable new-cap */
let HASH_ZLIB = (s, prev, data) => ((prev << s.hash_shift) ^ data) & s.hash_mask;
// This hash causes less collisions, https://github.com/nodeca/pako/issues/135
// But breaks binary compatibility
//let HASH_FAST = (s, prev, data) => ((prev << 8) + (prev >> 8) + (data << 4)) & s.hash_mask;
let HASH = HASH_ZLIB;


/* =========================================================================
 * Flush as much pending output as possible. All deflate() output, except for
 * some deflate_stored() output, goes through this function so some
 * applications may wish to modify it to avoid allocating a large
 * strm->next_out buffer and copying into it. (See also read_buf()).
 */
const flush_pending = (strm) => {
  const s = strm.state;

  //_tr_flush_bits(s);
  let len = s.pending;
  if (len > strm.avail_out) {
    len = strm.avail_out;
  }
  if (len === 0) { return; }

  strm.output.set(s.pending_buf.subarray(s.pending_out, s.pending_out + len), strm.next_out);
  strm.next_out  += len;
  s.pending_out  += len;
  strm.total_out += len;
  strm.avail_out -= len;
  s.pending      -= len;
  if (s.pending === 0) {
    s.pending_out = 0;
  }
};


const flush_block_only = (s, last) => {
  _tr_flush_block(s, (s.block_start >= 0 ? s.block_start : -1), s.strstart - s.block_start, last);
  s.block_start = s.strstart;
  flush_pending(s.strm);
};


const put_byte = (s, b) => {
  s.pending_buf[s.pending++] = b;
};


/* =========================================================================
 * Put a short in the pending buffer. The 16-bit value is put in MSB order.
 * IN assertion: the stream state is correct and there is enough room in
 * pending_buf.
 */
const putShortMSB = (s, b) => {

  //  put_byte(s, (Byte)(b >> 8));
//  put_byte(s, (Byte)(b & 0xff));
  s.pending_buf[s.pending++] = (b >>> 8) & 0xff;
  s.pending_buf[s.pending++] = b & 0xff;
};


/* ===========================================================================
 * Read a new buffer from the current input stream, update the adler32
 * and total number of bytes read.  All deflate() input goes through
 * this function so some applications may wish to modify it to avoid
 * allocating a large strm->input buffer and copying from it.
 * (See also flush_pending()).
 */
const read_buf = (strm, buf, start, size) => {

  let len = strm.avail_in;

  if (len > size) { len = size; }
  if (len === 0) { return 0; }

  strm.avail_in -= len;

  // zmemcpy(buf, strm->next_in, len);
  buf.set(strm.input.subarray(strm.next_in, strm.next_in + len), start);
  if (strm.state.wrap === 1) {
    strm.adler = adler32_1(strm.adler, buf, len, start);
  }

  else if (strm.state.wrap === 2) {
    strm.adler = crc32_1(strm.adler, buf, len, start);
  }

  strm.next_in += len;
  strm.total_in += len;

  return len;
};


/* ===========================================================================
 * Set match_start to the longest match starting at the given string and
 * return its length. Matches shorter or equal to prev_length are discarded,
 * in which case the result is equal to prev_length and match_start is
 * garbage.
 * IN assertions: cur_match is the head of the hash chain for the current
 *   string (strstart) and its distance is <= MAX_DIST, and prev_length >= 1
 * OUT assertion: the match length is not greater than s->lookahead.
 */
const longest_match = (s, cur_match) => {

  let chain_length = s.max_chain_length;      /* max hash chain length */
  let scan = s.strstart; /* current string */
  let match;                       /* matched string */
  let len;                           /* length of current match */
  let best_len = s.prev_length;              /* best match length so far */
  let nice_match = s.nice_match;             /* stop if match long enough */
  const limit = (s.strstart > (s.w_size - MIN_LOOKAHEAD)) ?
      s.strstart - (s.w_size - MIN_LOOKAHEAD) : 0/*NIL*/;

  const _win = s.window; // shortcut

  const wmask = s.w_mask;
  const prev  = s.prev;

  /* Stop when cur_match becomes <= limit. To simplify the code,
   * we prevent matches with the string of window index 0.
   */

  const strend = s.strstart + MAX_MATCH;
  let scan_end1  = _win[scan + best_len - 1];
  let scan_end   = _win[scan + best_len];

  /* The code is optimized for HASH_BITS >= 8 and MAX_MATCH-2 multiple of 16.
   * It is easy to get rid of this optimization if necessary.
   */
  // Assert(s->hash_bits >= 8 && MAX_MATCH == 258, "Code too clever");

  /* Do not waste too much time if we already have a good match: */
  if (s.prev_length >= s.good_match) {
    chain_length >>= 2;
  }
  /* Do not look for matches beyond the end of the input. This is necessary
   * to make deflate deterministic.
   */
  if (nice_match > s.lookahead) { nice_match = s.lookahead; }

  // Assert((ulg)s->strstart <= s->window_size-MIN_LOOKAHEAD, "need lookahead");

  do {
    // Assert(cur_match < s->strstart, "no future");
    match = cur_match;

    /* Skip to next match if the match length cannot increase
     * or if the match length is less than 2.  Note that the checks below
     * for insufficient lookahead only occur occasionally for performance
     * reasons.  Therefore uninitialized memory will be accessed, and
     * conditional jumps will be made that depend on those values.
     * However the length of the match is limited to the lookahead, so
     * the output of deflate is not affected by the uninitialized values.
     */

    if (_win[match + best_len]     !== scan_end  ||
        _win[match + best_len - 1] !== scan_end1 ||
        _win[match]                !== _win[scan] ||
        _win[++match]              !== _win[scan + 1]) {
      continue;
    }

    /* The check at best_len-1 can be removed because it will be made
     * again later. (This heuristic is not always a win.)
     * It is not necessary to compare scan[2] and match[2] since they
     * are always equal when the other bytes match, given that
     * the hash keys are equal and that HASH_BITS >= 8.
     */
    scan += 2;
    match++;
    // Assert(*scan == *match, "match[2]?");

    /* We check for insufficient lookahead only every 8th comparison;
     * the 256th check will be made at strstart+258.
     */
    do {
      /*jshint noempty:false*/
    } while (_win[++scan] === _win[++match] && _win[++scan] === _win[++match] &&
             _win[++scan] === _win[++match] && _win[++scan] === _win[++match] &&
             _win[++scan] === _win[++match] && _win[++scan] === _win[++match] &&
             _win[++scan] === _win[++match] && _win[++scan] === _win[++match] &&
             scan < strend);

    // Assert(scan <= s->window+(unsigned)(s->window_size-1), "wild scan");

    len = MAX_MATCH - (strend - scan);
    scan = strend - MAX_MATCH;

    if (len > best_len) {
      s.match_start = cur_match;
      best_len = len;
      if (len >= nice_match) {
        break;
      }
      scan_end1  = _win[scan + best_len - 1];
      scan_end   = _win[scan + best_len];
    }
  } while ((cur_match = prev[cur_match & wmask]) > limit && --chain_length !== 0);

  if (best_len <= s.lookahead) {
    return best_len;
  }
  return s.lookahead;
};


/* ===========================================================================
 * Fill the window when the lookahead becomes insufficient.
 * Updates strstart and lookahead.
 *
 * IN assertion: lookahead < MIN_LOOKAHEAD
 * OUT assertions: strstart <= window_size-MIN_LOOKAHEAD
 *    At least one byte has been read, or avail_in == 0; reads are
 *    performed for at least two bytes (required for the zip translate_eol
 *    option -- not supported here).
 */
const fill_window = (s) => {

  const _w_size = s.w_size;
  let n, more, str;

  //Assert(s->lookahead < MIN_LOOKAHEAD, "already enough lookahead");

  do {
    more = s.window_size - s.lookahead - s.strstart;

    // JS ints have 32 bit, block below not needed
    /* Deal with !@#$% 64K limit: */
    //if (sizeof(int) <= 2) {
    //    if (more == 0 && s->strstart == 0 && s->lookahead == 0) {
    //        more = wsize;
    //
    //  } else if (more == (unsigned)(-1)) {
    //        /* Very unlikely, but possible on 16 bit machine if
    //         * strstart == 0 && lookahead == 1 (input done a byte at time)
    //         */
    //        more--;
    //    }
    //}


    /* If the window is almost full and there is insufficient lookahead,
     * move the upper half to the lower one to make room in the upper half.
     */
    if (s.strstart >= _w_size + (_w_size - MIN_LOOKAHEAD)) {

      s.window.set(s.window.subarray(_w_size, _w_size + _w_size - more), 0);
      s.match_start -= _w_size;
      s.strstart -= _w_size;
      /* we now have strstart >= MAX_DIST */
      s.block_start -= _w_size;
      if (s.insert > s.strstart) {
        s.insert = s.strstart;
      }
      slide_hash(s);
      more += _w_size;
    }
    if (s.strm.avail_in === 0) {
      break;
    }

    /* If there was no sliding:
     *    strstart <= WSIZE+MAX_DIST-1 && lookahead <= MIN_LOOKAHEAD - 1 &&
     *    more == window_size - lookahead - strstart
     * => more >= window_size - (MIN_LOOKAHEAD-1 + WSIZE + MAX_DIST-1)
     * => more >= window_size - 2*WSIZE + 2
     * In the BIG_MEM or MMAP case (not yet supported),
     *   window_size == input_size + MIN_LOOKAHEAD  &&
     *   strstart + s->lookahead <= input_size => more >= MIN_LOOKAHEAD.
     * Otherwise, window_size == 2*WSIZE so more >= 2.
     * If there was sliding, more >= WSIZE. So in all cases, more >= 2.
     */
    //Assert(more >= 2, "more < 2");
    n = read_buf(s.strm, s.window, s.strstart + s.lookahead, more);
    s.lookahead += n;

    /* Initialize the hash value now that we have some input: */
    if (s.lookahead + s.insert >= MIN_MATCH) {
      str = s.strstart - s.insert;
      s.ins_h = s.window[str];

      /* UPDATE_HASH(s, s->ins_h, s->window[str + 1]); */
      s.ins_h = HASH(s, s.ins_h, s.window[str + 1]);
//#if MIN_MATCH != 3
//        Call update_hash() MIN_MATCH-3 more times
//#endif
      while (s.insert) {
        /* UPDATE_HASH(s, s->ins_h, s->window[str + MIN_MATCH-1]); */
        s.ins_h = HASH(s, s.ins_h, s.window[str + MIN_MATCH - 1]);

        s.prev[str & s.w_mask] = s.head[s.ins_h];
        s.head[s.ins_h] = str;
        str++;
        s.insert--;
        if (s.lookahead + s.insert < MIN_MATCH) {
          break;
        }
      }
    }
    /* If the whole input has less than MIN_MATCH bytes, ins_h is garbage,
     * but this is not important since only literal bytes will be emitted.
     */

  } while (s.lookahead < MIN_LOOKAHEAD && s.strm.avail_in !== 0);

  /* If the WIN_INIT bytes after the end of the current data have never been
   * written, then zero those bytes in order to avoid memory check reports of
   * the use of uninitialized (or uninitialised as Julian writes) bytes by
   * the longest match routines.  Update the high water mark for the next
   * time through here.  WIN_INIT is set to MAX_MATCH since the longest match
   * routines allow scanning to strstart + MAX_MATCH, ignoring lookahead.
   */
//  if (s.high_water < s.window_size) {
//    const curr = s.strstart + s.lookahead;
//    let init = 0;
//
//    if (s.high_water < curr) {
//      /* Previous high water mark below current data -- zero WIN_INIT
//       * bytes or up to end of window, whichever is less.
//       */
//      init = s.window_size - curr;
//      if (init > WIN_INIT)
//        init = WIN_INIT;
//      zmemzero(s->window + curr, (unsigned)init);
//      s->high_water = curr + init;
//    }
//    else if (s->high_water < (ulg)curr + WIN_INIT) {
//      /* High water mark at or above current data, but below current data
//       * plus WIN_INIT -- zero out to current data plus WIN_INIT, or up
//       * to end of window, whichever is less.
//       */
//      init = (ulg)curr + WIN_INIT - s->high_water;
//      if (init > s->window_size - s->high_water)
//        init = s->window_size - s->high_water;
//      zmemzero(s->window + s->high_water, (unsigned)init);
//      s->high_water += init;
//    }
//  }
//
//  Assert((ulg)s->strstart <= s->window_size - MIN_LOOKAHEAD,
//    "not enough room for search");
};

/* ===========================================================================
 * Copy without compression as much as possible from the input stream, return
 * the current block state.
 *
 * In case deflateParams() is used to later switch to a non-zero compression
 * level, s->matches (otherwise unused when storing) keeps track of the number
 * of hash table slides to perform. If s->matches is 1, then one hash table
 * slide will be done when switching. If s->matches is 2, the maximum value
 * allowed here, then the hash table will be cleared, since two or more slides
 * is the same as a clear.
 *
 * deflate_stored() is written to minimize the number of times an input byte is
 * copied. It is most efficient with large input and output buffers, which
 * maximizes the opportunites to have a single copy from next_in to next_out.
 */
const deflate_stored = (s, flush) => {

  /* Smallest worthy block size when not flushing or finishing. By default
   * this is 32K. This can be as small as 507 bytes for memLevel == 1. For
   * large input and output buffers, the stored block size will be larger.
   */
  let min_block = s.pending_buf_size - 5 > s.w_size ? s.w_size : s.pending_buf_size - 5;

  /* Copy as many min_block or larger stored blocks directly to next_out as
   * possible. If flushing, copy the remaining available input to next_out as
   * stored blocks, if there is enough space.
   */
  let len, left, have, last = 0;
  let used = s.strm.avail_in;
  do {
    /* Set len to the maximum size block that we can copy directly with the
     * available input data and output space. Set left to how much of that
     * would be copied from what's left in the window.
     */
    len = 65535/* MAX_STORED */;     /* maximum deflate stored block length */
    have = (s.bi_valid + 42) >> 3;     /* number of header bytes */
    if (s.strm.avail_out < have) {         /* need room for header */
      break;
    }
      /* maximum stored block length that will fit in avail_out: */
    have = s.strm.avail_out - have;
    left = s.strstart - s.block_start;  /* bytes left in window */
    if (len > left + s.strm.avail_in) {
      len = left + s.strm.avail_in;   /* limit len to the input */
    }
    if (len > have) {
      len = have;             /* limit len to the output */
    }

    /* If the stored block would be less than min_block in length, or if
     * unable to copy all of the available input when flushing, then try
     * copying to the window and the pending buffer instead. Also don't
     * write an empty block when flushing -- deflate() does that.
     */
    if (len < min_block && ((len === 0 && flush !== Z_FINISH$3) ||
                        flush === Z_NO_FLUSH$2 ||
                        len !== left + s.strm.avail_in)) {
      break;
    }

    /* Make a dummy stored block in pending to get the header bytes,
     * including any pending bits. This also updates the debugging counts.
     */
    last = flush === Z_FINISH$3 && len === left + s.strm.avail_in ? 1 : 0;
    _tr_stored_block(s, 0, 0, last);

    /* Replace the lengths in the dummy stored block with len. */
    s.pending_buf[s.pending - 4] = len;
    s.pending_buf[s.pending - 3] = len >> 8;
    s.pending_buf[s.pending - 2] = ~len;
    s.pending_buf[s.pending - 1] = ~len >> 8;

    /* Write the stored block header bytes. */
    flush_pending(s.strm);

//#ifdef ZLIB_DEBUG
//    /* Update debugging counts for the data about to be copied. */
//    s->compressed_len += len << 3;
//    s->bits_sent += len << 3;
//#endif

    /* Copy uncompressed bytes from the window to next_out. */
    if (left) {
      if (left > len) {
        left = len;
      }
      //zmemcpy(s->strm->next_out, s->window + s->block_start, left);
      s.strm.output.set(s.window.subarray(s.block_start, s.block_start + left), s.strm.next_out);
      s.strm.next_out += left;
      s.strm.avail_out -= left;
      s.strm.total_out += left;
      s.block_start += left;
      len -= left;
    }

    /* Copy uncompressed bytes directly from next_in to next_out, updating
     * the check value.
     */
    if (len) {
      read_buf(s.strm, s.strm.output, s.strm.next_out, len);
      s.strm.next_out += len;
      s.strm.avail_out -= len;
      s.strm.total_out += len;
    }
  } while (last === 0);

  /* Update the sliding window with the last s->w_size bytes of the copied
   * data, or append all of the copied data to the existing window if less
   * than s->w_size bytes were copied. Also update the number of bytes to
   * insert in the hash tables, in the event that deflateParams() switches to
   * a non-zero compression level.
   */
  used -= s.strm.avail_in;    /* number of input bytes directly copied */
  if (used) {
    /* If any input was used, then no unused input remains in the window,
     * therefore s->block_start == s->strstart.
     */
    if (used >= s.w_size) {  /* supplant the previous history */
      s.matches = 2;     /* clear hash */
      //zmemcpy(s->window, s->strm->next_in - s->w_size, s->w_size);
      s.window.set(s.strm.input.subarray(s.strm.next_in - s.w_size, s.strm.next_in), 0);
      s.strstart = s.w_size;
      s.insert = s.strstart;
    }
    else {
      if (s.window_size - s.strstart <= used) {
        /* Slide the window down. */
        s.strstart -= s.w_size;
        //zmemcpy(s->window, s->window + s->w_size, s->strstart);
        s.window.set(s.window.subarray(s.w_size, s.w_size + s.strstart), 0);
        if (s.matches < 2) {
          s.matches++;   /* add a pending slide_hash() */
        }
        if (s.insert > s.strstart) {
          s.insert = s.strstart;
        }
      }
      //zmemcpy(s->window + s->strstart, s->strm->next_in - used, used);
      s.window.set(s.strm.input.subarray(s.strm.next_in - used, s.strm.next_in), s.strstart);
      s.strstart += used;
      s.insert += used > s.w_size - s.insert ? s.w_size - s.insert : used;
    }
    s.block_start = s.strstart;
  }
  if (s.high_water < s.strstart) {
    s.high_water = s.strstart;
  }

  /* If the last block was written to next_out, then done. */
  if (last) {
    return BS_FINISH_DONE;
  }

  /* If flushing and all input has been consumed, then done. */
  if (flush !== Z_NO_FLUSH$2 && flush !== Z_FINISH$3 &&
    s.strm.avail_in === 0 && s.strstart === s.block_start) {
    return BS_BLOCK_DONE;
  }

  /* Fill the window with any remaining input. */
  have = s.window_size - s.strstart;
  if (s.strm.avail_in > have && s.block_start >= s.w_size) {
    /* Slide the window down. */
    s.block_start -= s.w_size;
    s.strstart -= s.w_size;
    //zmemcpy(s->window, s->window + s->w_size, s->strstart);
    s.window.set(s.window.subarray(s.w_size, s.w_size + s.strstart), 0);
    if (s.matches < 2) {
      s.matches++;       /* add a pending slide_hash() */
    }
    have += s.w_size;      /* more space now */
    if (s.insert > s.strstart) {
      s.insert = s.strstart;
    }
  }
  if (have > s.strm.avail_in) {
    have = s.strm.avail_in;
  }
  if (have) {
    read_buf(s.strm, s.window, s.strstart, have);
    s.strstart += have;
    s.insert += have > s.w_size - s.insert ? s.w_size - s.insert : have;
  }
  if (s.high_water < s.strstart) {
    s.high_water = s.strstart;
  }

  /* There was not enough avail_out to write a complete worthy or flushed
   * stored block to next_out. Write a stored block to pending instead, if we
   * have enough input for a worthy block, or if flushing and there is enough
   * room for the remaining input as a stored block in the pending buffer.
   */
  have = (s.bi_valid + 42) >> 3;     /* number of header bytes */
    /* maximum stored block length that will fit in pending: */
  have = s.pending_buf_size - have > 65535/* MAX_STORED */ ? 65535/* MAX_STORED */ : s.pending_buf_size - have;
  min_block = have > s.w_size ? s.w_size : have;
  left = s.strstart - s.block_start;
  if (left >= min_block ||
     ((left || flush === Z_FINISH$3) && flush !== Z_NO_FLUSH$2 &&
     s.strm.avail_in === 0 && left <= have)) {
    len = left > have ? have : left;
    last = flush === Z_FINISH$3 && s.strm.avail_in === 0 &&
         len === left ? 1 : 0;
    _tr_stored_block(s, s.block_start, len, last);
    s.block_start += len;
    flush_pending(s.strm);
  }

  /* We've done all we can with the available input and output. */
  return last ? BS_FINISH_STARTED : BS_NEED_MORE;
};


/* ===========================================================================
 * Compress as much as possible from the input stream, return the current
 * block state.
 * This function does not perform lazy evaluation of matches and inserts
 * new strings in the dictionary only for unmatched strings or for short
 * matches. It is used only for the fast compression options.
 */
const deflate_fast = (s, flush) => {

  let hash_head;        /* head of the hash chain */
  let bflush;           /* set if current block must be flushed */

  for (;;) {
    /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the next match, plus MIN_MATCH bytes to insert the
     * string following the next match.
     */
    if (s.lookahead < MIN_LOOKAHEAD) {
      fill_window(s);
      if (s.lookahead < MIN_LOOKAHEAD && flush === Z_NO_FLUSH$2) {
        return BS_NEED_MORE;
      }
      if (s.lookahead === 0) {
        break; /* flush the current block */
      }
    }

    /* Insert the string window[strstart .. strstart+2] in the
     * dictionary, and set hash_head to the head of the hash chain:
     */
    hash_head = 0/*NIL*/;
    if (s.lookahead >= MIN_MATCH) {
      /*** INSERT_STRING(s, s.strstart, hash_head); ***/
      s.ins_h = HASH(s, s.ins_h, s.window[s.strstart + MIN_MATCH - 1]);
      hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
      s.head[s.ins_h] = s.strstart;
      /***/
    }

    /* Find the longest match, discarding those <= prev_length.
     * At this point we have always match_length < MIN_MATCH
     */
    if (hash_head !== 0/*NIL*/ && ((s.strstart - hash_head) <= (s.w_size - MIN_LOOKAHEAD))) {
      /* To simplify the code, we prevent matches with the string
       * of window index 0 (in particular we have to avoid a match
       * of the string with itself at the start of the input file).
       */
      s.match_length = longest_match(s, hash_head);
      /* longest_match() sets match_start */
    }
    if (s.match_length >= MIN_MATCH) {
      // check_match(s, s.strstart, s.match_start, s.match_length); // for debug only

      /*** _tr_tally_dist(s, s.strstart - s.match_start,
                     s.match_length - MIN_MATCH, bflush); ***/
      bflush = _tr_tally(s, s.strstart - s.match_start, s.match_length - MIN_MATCH);

      s.lookahead -= s.match_length;

      /* Insert new strings in the hash table only if the match length
       * is not too large. This saves time but degrades compression.
       */
      if (s.match_length <= s.max_lazy_match/*max_insert_length*/ && s.lookahead >= MIN_MATCH) {
        s.match_length--; /* string at strstart already in table */
        do {
          s.strstart++;
          /*** INSERT_STRING(s, s.strstart, hash_head); ***/
          s.ins_h = HASH(s, s.ins_h, s.window[s.strstart + MIN_MATCH - 1]);
          hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
          s.head[s.ins_h] = s.strstart;
          /***/
          /* strstart never exceeds WSIZE-MAX_MATCH, so there are
           * always MIN_MATCH bytes ahead.
           */
        } while (--s.match_length !== 0);
        s.strstart++;
      } else
      {
        s.strstart += s.match_length;
        s.match_length = 0;
        s.ins_h = s.window[s.strstart];
        /* UPDATE_HASH(s, s.ins_h, s.window[s.strstart+1]); */
        s.ins_h = HASH(s, s.ins_h, s.window[s.strstart + 1]);

//#if MIN_MATCH != 3
//                Call UPDATE_HASH() MIN_MATCH-3 more times
//#endif
        /* If lookahead < MIN_MATCH, ins_h is garbage, but it does not
         * matter since it will be recomputed at next deflate call.
         */
      }
    } else {
      /* No match, output a literal byte */
      //Tracevv((stderr,"%c", s.window[s.strstart]));
      /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/
      bflush = _tr_tally(s, 0, s.window[s.strstart]);

      s.lookahead--;
      s.strstart++;
    }
    if (bflush) {
      /*** FLUSH_BLOCK(s, 0); ***/
      flush_block_only(s, false);
      if (s.strm.avail_out === 0) {
        return BS_NEED_MORE;
      }
      /***/
    }
  }
  s.insert = ((s.strstart < (MIN_MATCH - 1)) ? s.strstart : MIN_MATCH - 1);
  if (flush === Z_FINISH$3) {
    /*** FLUSH_BLOCK(s, 1); ***/
    flush_block_only(s, true);
    if (s.strm.avail_out === 0) {
      return BS_FINISH_STARTED;
    }
    /***/
    return BS_FINISH_DONE;
  }
  if (s.sym_next) {
    /*** FLUSH_BLOCK(s, 0); ***/
    flush_block_only(s, false);
    if (s.strm.avail_out === 0) {
      return BS_NEED_MORE;
    }
    /***/
  }
  return BS_BLOCK_DONE;
};

/* ===========================================================================
 * Same as above, but achieves better compression. We use a lazy
 * evaluation for matches: a match is finally adopted only if there is
 * no better match at the next window position.
 */
const deflate_slow = (s, flush) => {

  let hash_head;          /* head of hash chain */
  let bflush;              /* set if current block must be flushed */

  let max_insert;

  /* Process the input block. */
  for (;;) {
    /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the next match, plus MIN_MATCH bytes to insert the
     * string following the next match.
     */
    if (s.lookahead < MIN_LOOKAHEAD) {
      fill_window(s);
      if (s.lookahead < MIN_LOOKAHEAD && flush === Z_NO_FLUSH$2) {
        return BS_NEED_MORE;
      }
      if (s.lookahead === 0) { break; } /* flush the current block */
    }

    /* Insert the string window[strstart .. strstart+2] in the
     * dictionary, and set hash_head to the head of the hash chain:
     */
    hash_head = 0/*NIL*/;
    if (s.lookahead >= MIN_MATCH) {
      /*** INSERT_STRING(s, s.strstart, hash_head); ***/
      s.ins_h = HASH(s, s.ins_h, s.window[s.strstart + MIN_MATCH - 1]);
      hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
      s.head[s.ins_h] = s.strstart;
      /***/
    }

    /* Find the longest match, discarding those <= prev_length.
     */
    s.prev_length = s.match_length;
    s.prev_match = s.match_start;
    s.match_length = MIN_MATCH - 1;

    if (hash_head !== 0/*NIL*/ && s.prev_length < s.max_lazy_match &&
        s.strstart - hash_head <= (s.w_size - MIN_LOOKAHEAD)/*MAX_DIST(s)*/) {
      /* To simplify the code, we prevent matches with the string
       * of window index 0 (in particular we have to avoid a match
       * of the string with itself at the start of the input file).
       */
      s.match_length = longest_match(s, hash_head);
      /* longest_match() sets match_start */

      if (s.match_length <= 5 &&
         (s.strategy === Z_FILTERED || (s.match_length === MIN_MATCH && s.strstart - s.match_start > 4096/*TOO_FAR*/))) {

        /* If prev_match is also MIN_MATCH, match_start is garbage
         * but we will ignore the current match anyway.
         */
        s.match_length = MIN_MATCH - 1;
      }
    }
    /* If there was a match at the previous step and the current
     * match is not better, output the previous match:
     */
    if (s.prev_length >= MIN_MATCH && s.match_length <= s.prev_length) {
      max_insert = s.strstart + s.lookahead - MIN_MATCH;
      /* Do not insert strings in hash table beyond this. */

      //check_match(s, s.strstart-1, s.prev_match, s.prev_length);

      /***_tr_tally_dist(s, s.strstart - 1 - s.prev_match,
                     s.prev_length - MIN_MATCH, bflush);***/
      bflush = _tr_tally(s, s.strstart - 1 - s.prev_match, s.prev_length - MIN_MATCH);
      /* Insert in hash table all strings up to the end of the match.
       * strstart-1 and strstart are already inserted. If there is not
       * enough lookahead, the last two strings are not inserted in
       * the hash table.
       */
      s.lookahead -= s.prev_length - 1;
      s.prev_length -= 2;
      do {
        if (++s.strstart <= max_insert) {
          /*** INSERT_STRING(s, s.strstart, hash_head); ***/
          s.ins_h = HASH(s, s.ins_h, s.window[s.strstart + MIN_MATCH - 1]);
          hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
          s.head[s.ins_h] = s.strstart;
          /***/
        }
      } while (--s.prev_length !== 0);
      s.match_available = 0;
      s.match_length = MIN_MATCH - 1;
      s.strstart++;

      if (bflush) {
        /*** FLUSH_BLOCK(s, 0); ***/
        flush_block_only(s, false);
        if (s.strm.avail_out === 0) {
          return BS_NEED_MORE;
        }
        /***/
      }

    } else if (s.match_available) {
      /* If there was no match at the previous position, output a
       * single literal. If there was a match but the current match
       * is longer, truncate the previous match to a single literal.
       */
      //Tracevv((stderr,"%c", s->window[s->strstart-1]));
      /*** _tr_tally_lit(s, s.window[s.strstart-1], bflush); ***/
      bflush = _tr_tally(s, 0, s.window[s.strstart - 1]);

      if (bflush) {
        /*** FLUSH_BLOCK_ONLY(s, 0) ***/
        flush_block_only(s, false);
        /***/
      }
      s.strstart++;
      s.lookahead--;
      if (s.strm.avail_out === 0) {
        return BS_NEED_MORE;
      }
    } else {
      /* There is no previous match to compare with, wait for
       * the next step to decide.
       */
      s.match_available = 1;
      s.strstart++;
      s.lookahead--;
    }
  }
  //Assert (flush != Z_NO_FLUSH, "no flush?");
  if (s.match_available) {
    //Tracevv((stderr,"%c", s->window[s->strstart-1]));
    /*** _tr_tally_lit(s, s.window[s.strstart-1], bflush); ***/
    bflush = _tr_tally(s, 0, s.window[s.strstart - 1]);

    s.match_available = 0;
  }
  s.insert = s.strstart < MIN_MATCH - 1 ? s.strstart : MIN_MATCH - 1;
  if (flush === Z_FINISH$3) {
    /*** FLUSH_BLOCK(s, 1); ***/
    flush_block_only(s, true);
    if (s.strm.avail_out === 0) {
      return BS_FINISH_STARTED;
    }
    /***/
    return BS_FINISH_DONE;
  }
  if (s.sym_next) {
    /*** FLUSH_BLOCK(s, 0); ***/
    flush_block_only(s, false);
    if (s.strm.avail_out === 0) {
      return BS_NEED_MORE;
    }
    /***/
  }

  return BS_BLOCK_DONE;
};


/* ===========================================================================
 * For Z_RLE, simply look for runs of bytes, generate matches only of distance
 * one.  Do not maintain a hash table.  (It will be regenerated if this run of
 * deflate switches away from Z_RLE.)
 */
const deflate_rle = (s, flush) => {

  let bflush;            /* set if current block must be flushed */
  let prev;              /* byte at distance one to match */
  let scan, strend;      /* scan goes up to strend for length of run */

  const _win = s.window;

  for (;;) {
    /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the longest run, plus one for the unrolled loop.
     */
    if (s.lookahead <= MAX_MATCH) {
      fill_window(s);
      if (s.lookahead <= MAX_MATCH && flush === Z_NO_FLUSH$2) {
        return BS_NEED_MORE;
      }
      if (s.lookahead === 0) { break; } /* flush the current block */
    }

    /* See how many times the previous byte repeats */
    s.match_length = 0;
    if (s.lookahead >= MIN_MATCH && s.strstart > 0) {
      scan = s.strstart - 1;
      prev = _win[scan];
      if (prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan]) {
        strend = s.strstart + MAX_MATCH;
        do {
          /*jshint noempty:false*/
        } while (prev === _win[++scan] && prev === _win[++scan] &&
                 prev === _win[++scan] && prev === _win[++scan] &&
                 prev === _win[++scan] && prev === _win[++scan] &&
                 prev === _win[++scan] && prev === _win[++scan] &&
                 scan < strend);
        s.match_length = MAX_MATCH - (strend - scan);
        if (s.match_length > s.lookahead) {
          s.match_length = s.lookahead;
        }
      }
      //Assert(scan <= s->window+(uInt)(s->window_size-1), "wild scan");
    }

    /* Emit match if have run of MIN_MATCH or longer, else emit literal */
    if (s.match_length >= MIN_MATCH) {
      //check_match(s, s.strstart, s.strstart - 1, s.match_length);

      /*** _tr_tally_dist(s, 1, s.match_length - MIN_MATCH, bflush); ***/
      bflush = _tr_tally(s, 1, s.match_length - MIN_MATCH);

      s.lookahead -= s.match_length;
      s.strstart += s.match_length;
      s.match_length = 0;
    } else {
      /* No match, output a literal byte */
      //Tracevv((stderr,"%c", s->window[s->strstart]));
      /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/
      bflush = _tr_tally(s, 0, s.window[s.strstart]);

      s.lookahead--;
      s.strstart++;
    }
    if (bflush) {
      /*** FLUSH_BLOCK(s, 0); ***/
      flush_block_only(s, false);
      if (s.strm.avail_out === 0) {
        return BS_NEED_MORE;
      }
      /***/
    }
  }
  s.insert = 0;
  if (flush === Z_FINISH$3) {
    /*** FLUSH_BLOCK(s, 1); ***/
    flush_block_only(s, true);
    if (s.strm.avail_out === 0) {
      return BS_FINISH_STARTED;
    }
    /***/
    return BS_FINISH_DONE;
  }
  if (s.sym_next) {
    /*** FLUSH_BLOCK(s, 0); ***/
    flush_block_only(s, false);
    if (s.strm.avail_out === 0) {
      return BS_NEED_MORE;
    }
    /***/
  }
  return BS_BLOCK_DONE;
};

/* ===========================================================================
 * For Z_HUFFMAN_ONLY, do not look for matches.  Do not maintain a hash table.
 * (It will be regenerated if this run of deflate switches away from Huffman.)
 */
const deflate_huff = (s, flush) => {

  let bflush;             /* set if current block must be flushed */

  for (;;) {
    /* Make sure that we have a literal to write. */
    if (s.lookahead === 0) {
      fill_window(s);
      if (s.lookahead === 0) {
        if (flush === Z_NO_FLUSH$2) {
          return BS_NEED_MORE;
        }
        break;      /* flush the current block */
      }
    }

    /* Output a literal byte */
    s.match_length = 0;
    //Tracevv((stderr,"%c", s->window[s->strstart]));
    /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/
    bflush = _tr_tally(s, 0, s.window[s.strstart]);
    s.lookahead--;
    s.strstart++;
    if (bflush) {
      /*** FLUSH_BLOCK(s, 0); ***/
      flush_block_only(s, false);
      if (s.strm.avail_out === 0) {
        return BS_NEED_MORE;
      }
      /***/
    }
  }
  s.insert = 0;
  if (flush === Z_FINISH$3) {
    /*** FLUSH_BLOCK(s, 1); ***/
    flush_block_only(s, true);
    if (s.strm.avail_out === 0) {
      return BS_FINISH_STARTED;
    }
    /***/
    return BS_FINISH_DONE;
  }
  if (s.sym_next) {
    /*** FLUSH_BLOCK(s, 0); ***/
    flush_block_only(s, false);
    if (s.strm.avail_out === 0) {
      return BS_NEED_MORE;
    }
    /***/
  }
  return BS_BLOCK_DONE;
};

/* Values for max_lazy_match, good_match and max_chain_length, depending on
 * the desired pack level (0..9). The values given below have been tuned to
 * exclude worst case performance for pathological files. Better values may be
 * found for specific files.
 */
function Config(good_length, max_lazy, nice_length, max_chain, func) {

  this.good_length = good_length;
  this.max_lazy = max_lazy;
  this.nice_length = nice_length;
  this.max_chain = max_chain;
  this.func = func;
}

const configuration_table = [
  /*      good lazy nice chain */
  new Config(0, 0, 0, 0, deflate_stored),          /* 0 store only */
  new Config(4, 4, 8, 4, deflate_fast),            /* 1 max speed, no lazy matches */
  new Config(4, 5, 16, 8, deflate_fast),           /* 2 */
  new Config(4, 6, 32, 32, deflate_fast),          /* 3 */

  new Config(4, 4, 16, 16, deflate_slow),          /* 4 lazy matches */
  new Config(8, 16, 32, 32, deflate_slow),         /* 5 */
  new Config(8, 16, 128, 128, deflate_slow),       /* 6 */
  new Config(8, 32, 128, 256, deflate_slow),       /* 7 */
  new Config(32, 128, 258, 1024, deflate_slow),    /* 8 */
  new Config(32, 258, 258, 4096, deflate_slow)     /* 9 max compression */
];


/* ===========================================================================
 * Initialize the "longest match" routines for a new zlib stream
 */
const lm_init = (s) => {

  s.window_size = 2 * s.w_size;

  /*** CLEAR_HASH(s); ***/
  zero(s.head); // Fill with NIL (= 0);

  /* Set the default configuration parameters:
   */
  s.max_lazy_match = configuration_table[s.level].max_lazy;
  s.good_match = configuration_table[s.level].good_length;
  s.nice_match = configuration_table[s.level].nice_length;
  s.max_chain_length = configuration_table[s.level].max_chain;

  s.strstart = 0;
  s.block_start = 0;
  s.lookahead = 0;
  s.insert = 0;
  s.match_length = s.prev_length = MIN_MATCH - 1;
  s.match_available = 0;
  s.ins_h = 0;
};


function DeflateState() {
  this.strm = null;            /* pointer back to this zlib stream */
  this.status = 0;            /* as the name implies */
  this.pending_buf = null;      /* output still pending */
  this.pending_buf_size = 0;  /* size of pending_buf */
  this.pending_out = 0;       /* next pending byte to output to the stream */
  this.pending = 0;           /* nb of bytes in the pending buffer */
  this.wrap = 0;              /* bit 0 true for zlib, bit 1 true for gzip */
  this.gzhead = null;         /* gzip header information to write */
  this.gzindex = 0;           /* where in extra, name, or comment */
  this.method = Z_DEFLATED$2; /* can only be DEFLATED */
  this.last_flush = -1;   /* value of flush param for previous deflate call */

  this.w_size = 0;  /* LZ77 window size (32K by default) */
  this.w_bits = 0;  /* log2(w_size)  (8..16) */
  this.w_mask = 0;  /* w_size - 1 */

  this.window = null;
  /* Sliding window. Input bytes are read into the second half of the window,
   * and move to the first half later to keep a dictionary of at least wSize
   * bytes. With this organization, matches are limited to a distance of
   * wSize-MAX_MATCH bytes, but this ensures that IO is always
   * performed with a length multiple of the block size.
   */

  this.window_size = 0;
  /* Actual size of window: 2*wSize, except when the user input buffer
   * is directly used as sliding window.
   */

  this.prev = null;
  /* Link to older string with same hash index. To limit the size of this
   * array to 64K, this link is maintained only for the last 32K strings.
   * An index in this array is thus a window index modulo 32K.
   */

  this.head = null;   /* Heads of the hash chains or NIL. */

  this.ins_h = 0;       /* hash index of string to be inserted */
  this.hash_size = 0;   /* number of elements in hash table */
  this.hash_bits = 0;   /* log2(hash_size) */
  this.hash_mask = 0;   /* hash_size-1 */

  this.hash_shift = 0;
  /* Number of bits by which ins_h must be shifted at each input
   * step. It must be such that after MIN_MATCH steps, the oldest
   * byte no longer takes part in the hash key, that is:
   *   hash_shift * MIN_MATCH >= hash_bits
   */

  this.block_start = 0;
  /* Window position at the beginning of the current output block. Gets
   * negative when the window is moved backwards.
   */

  this.match_length = 0;      /* length of best match */
  this.prev_match = 0;        /* previous match */
  this.match_available = 0;   /* set if previous match exists */
  this.strstart = 0;          /* start of string to insert */
  this.match_start = 0;       /* start of matching string */
  this.lookahead = 0;         /* number of valid bytes ahead in window */

  this.prev_length = 0;
  /* Length of the best match at previous step. Matches not greater than this
   * are discarded. This is used in the lazy match evaluation.
   */

  this.max_chain_length = 0;
  /* To speed up deflation, hash chains are never searched beyond this
   * length.  A higher limit improves compression ratio but degrades the
   * speed.
   */

  this.max_lazy_match = 0;
  /* Attempt to find a better match only when the current match is strictly
   * smaller than this value. This mechanism is used only for compression
   * levels >= 4.
   */
  // That's alias to max_lazy_match, don't use directly
  //this.max_insert_length = 0;
  /* Insert new strings in the hash table only if the match length is not
   * greater than this length. This saves time but degrades compression.
   * max_insert_length is used only for compression levels <= 3.
   */

  this.level = 0;     /* compression level (1..9) */
  this.strategy = 0;  /* favor or force Huffman coding*/

  this.good_match = 0;
  /* Use a faster search when the previous match is longer than this */

  this.nice_match = 0; /* Stop searching when current match exceeds this */

              /* used by trees.c: */

  /* Didn't use ct_data typedef below to suppress compiler warning */

  // struct ct_data_s dyn_ltree[HEAP_SIZE];   /* literal and length tree */
  // struct ct_data_s dyn_dtree[2*D_CODES+1]; /* distance tree */
  // struct ct_data_s bl_tree[2*BL_CODES+1];  /* Huffman tree for bit lengths */

  // Use flat array of DOUBLE size, with interleaved fata,
  // because JS does not support effective
  this.dyn_ltree  = new Uint16Array(HEAP_SIZE * 2);
  this.dyn_dtree  = new Uint16Array((2 * D_CODES + 1) * 2);
  this.bl_tree    = new Uint16Array((2 * BL_CODES + 1) * 2);
  zero(this.dyn_ltree);
  zero(this.dyn_dtree);
  zero(this.bl_tree);

  this.l_desc   = null;         /* desc. for literal tree */
  this.d_desc   = null;         /* desc. for distance tree */
  this.bl_desc  = null;         /* desc. for bit length tree */

  //ush bl_count[MAX_BITS+1];
  this.bl_count = new Uint16Array(MAX_BITS + 1);
  /* number of codes at each bit length for an optimal tree */

  //int heap[2*L_CODES+1];      /* heap used to build the Huffman trees */
  this.heap = new Uint16Array(2 * L_CODES + 1);  /* heap used to build the Huffman trees */
  zero(this.heap);

  this.heap_len = 0;               /* number of elements in the heap */
  this.heap_max = 0;               /* element of largest frequency */
  /* The sons of heap[n] are heap[2*n] and heap[2*n+1]. heap[0] is not used.
   * The same heap array is used to build all trees.
   */

  this.depth = new Uint16Array(2 * L_CODES + 1); //uch depth[2*L_CODES+1];
  zero(this.depth);
  /* Depth of each subtree used as tie breaker for trees of equal frequency
   */

  this.sym_buf = 0;        /* buffer for distances and literals/lengths */

  this.lit_bufsize = 0;
  /* Size of match buffer for literals/lengths.  There are 4 reasons for
   * limiting lit_bufsize to 64K:
   *   - frequencies can be kept in 16 bit counters
   *   - if compression is not successful for the first block, all input
   *     data is still in the window so we can still emit a stored block even
   *     when input comes from standard input.  (This can also be done for
   *     all blocks if lit_bufsize is not greater than 32K.)
   *   - if compression is not successful for a file smaller than 64K, we can
   *     even emit a stored file instead of a stored block (saving 5 bytes).
   *     This is applicable only for zip (not gzip or zlib).
   *   - creating new Huffman trees less frequently may not provide fast
   *     adaptation to changes in the input data statistics. (Take for
   *     example a binary file with poorly compressible code followed by
   *     a highly compressible string table.) Smaller buffer sizes give
   *     fast adaptation but have of course the overhead of transmitting
   *     trees more frequently.
   *   - I can't count above 4
   */

  this.sym_next = 0;      /* running index in sym_buf */
  this.sym_end = 0;       /* symbol table full when sym_next reaches this */

  this.opt_len = 0;       /* bit length of current block with optimal trees */
  this.static_len = 0;    /* bit length of current block with static trees */
  this.matches = 0;       /* number of string matches in current block */
  this.insert = 0;        /* bytes at end of window left to insert */


  this.bi_buf = 0;
  /* Output buffer. bits are inserted starting at the bottom (least
   * significant bits).
   */
  this.bi_valid = 0;
  /* Number of valid bits in bi_buf.  All bits above the last valid bit
   * are always zero.
   */

  // Used for window memory init. We safely ignore it for JS. That makes
  // sense only for pointers and memory check tools.
  //this.high_water = 0;
  /* High water mark offset in window for initialized bytes -- bytes above
   * this are set to zero in order to avoid memory check warnings when
   * longest match routines access bytes past the input.  This is then
   * updated to the new high water mark.
   */
}


/* =========================================================================
 * Check for a valid deflate stream state. Return 0 if ok, 1 if not.
 */
const deflateStateCheck = (strm) => {

  if (!strm) {
    return 1;
  }
  const s = strm.state;
  if (!s || s.strm !== strm || (s.status !== INIT_STATE &&
//#ifdef GZIP
                                s.status !== GZIP_STATE &&
//#endif
                                s.status !== EXTRA_STATE &&
                                s.status !== NAME_STATE &&
                                s.status !== COMMENT_STATE &&
                                s.status !== HCRC_STATE &&
                                s.status !== BUSY_STATE &&
                                s.status !== FINISH_STATE)) {
    return 1;
  }
  return 0;
};


const deflateResetKeep = (strm) => {

  if (deflateStateCheck(strm)) {
    return err(strm, Z_STREAM_ERROR$2);
  }

  strm.total_in = strm.total_out = 0;
  strm.data_type = Z_UNKNOWN;

  const s = strm.state;
  s.pending = 0;
  s.pending_out = 0;

  if (s.wrap < 0) {
    s.wrap = -s.wrap;
    /* was made negative by deflate(..., Z_FINISH); */
  }
  s.status =
//#ifdef GZIP
    s.wrap === 2 ? GZIP_STATE :
//#endif
    s.wrap ? INIT_STATE : BUSY_STATE;
  strm.adler = (s.wrap === 2) ?
    0  // crc32(0, Z_NULL, 0)
  :
    1; // adler32(0, Z_NULL, 0)
  s.last_flush = -2;
  _tr_init(s);
  return Z_OK$3;
};


const deflateReset = (strm) => {

  const ret = deflateResetKeep(strm);
  if (ret === Z_OK$3) {
    lm_init(strm.state);
  }
  return ret;
};


const deflateSetHeader = (strm, head) => {

  if (deflateStateCheck(strm) || strm.state.wrap !== 2) {
    return Z_STREAM_ERROR$2;
  }
  strm.state.gzhead = head;
  return Z_OK$3;
};


const deflateInit2 = (strm, level, method, windowBits, memLevel, strategy) => {

  if (!strm) { // === Z_NULL
    return Z_STREAM_ERROR$2;
  }
  let wrap = 1;

  if (level === Z_DEFAULT_COMPRESSION$1) {
    level = 6;
  }

  if (windowBits < 0) { /* suppress zlib wrapper */
    wrap = 0;
    windowBits = -windowBits;
  }

  else if (windowBits > 15) {
    wrap = 2;           /* write gzip wrapper instead */
    windowBits -= 16;
  }


  if (memLevel < 1 || memLevel > MAX_MEM_LEVEL || method !== Z_DEFLATED$2 ||
    windowBits < 8 || windowBits > 15 || level < 0 || level > 9 ||
    strategy < 0 || strategy > Z_FIXED || (windowBits === 8 && wrap !== 1)) {
    return err(strm, Z_STREAM_ERROR$2);
  }


  if (windowBits === 8) {
    windowBits = 9;
  }
  /* until 256-byte window bug fixed */

  const s = new DeflateState();

  strm.state = s;
  s.strm = strm;
  s.status = INIT_STATE;     /* to pass state test in deflateReset() */

  s.wrap = wrap;
  s.gzhead = null;
  s.w_bits = windowBits;
  s.w_size = 1 << s.w_bits;
  s.w_mask = s.w_size - 1;

  s.hash_bits = memLevel + 7;
  s.hash_size = 1 << s.hash_bits;
  s.hash_mask = s.hash_size - 1;
  s.hash_shift = ~~((s.hash_bits + MIN_MATCH - 1) / MIN_MATCH);

  s.window = new Uint8Array(s.w_size * 2);
  s.head = new Uint16Array(s.hash_size);
  s.prev = new Uint16Array(s.w_size);

  // Don't need mem init magic for JS.
  //s.high_water = 0;  /* nothing written to s->window yet */

  s.lit_bufsize = 1 << (memLevel + 6); /* 16K elements by default */

  /* We overlay pending_buf and sym_buf. This works since the average size
   * for length/distance pairs over any compressed block is assured to be 31
   * bits or less.
   *
   * Analysis: The longest fixed codes are a length code of 8 bits plus 5
   * extra bits, for lengths 131 to 257. The longest fixed distance codes are
   * 5 bits plus 13 extra bits, for distances 16385 to 32768. The longest
   * possible fixed-codes length/distance pair is then 31 bits total.
   *
   * sym_buf starts one-fourth of the way into pending_buf. So there are
   * three bytes in sym_buf for every four bytes in pending_buf. Each symbol
   * in sym_buf is three bytes -- two for the distance and one for the
   * literal/length. As each symbol is consumed, the pointer to the next
   * sym_buf value to read moves forward three bytes. From that symbol, up to
   * 31 bits are written to pending_buf. The closest the written pending_buf
   * bits gets to the next sym_buf symbol to read is just before the last
   * code is written. At that time, 31*(n-2) bits have been written, just
   * after 24*(n-2) bits have been consumed from sym_buf. sym_buf starts at
   * 8*n bits into pending_buf. (Note that the symbol buffer fills when n-1
   * symbols are written.) The closest the writing gets to what is unread is
   * then n+14 bits. Here n is lit_bufsize, which is 16384 by default, and
   * can range from 128 to 32768.
   *
   * Therefore, at a minimum, there are 142 bits of space between what is
   * written and what is read in the overlain buffers, so the symbols cannot
   * be overwritten by the compressed data. That space is actually 139 bits,
   * due to the three-bit fixed-code block header.
   *
   * That covers the case where either Z_FIXED is specified, forcing fixed
   * codes, or when the use of fixed codes is chosen, because that choice
   * results in a smaller compressed block than dynamic codes. That latter
   * condition then assures that the above analysis also covers all dynamic
   * blocks. A dynamic-code block will only be chosen to be emitted if it has
   * fewer bits than a fixed-code block would for the same set of symbols.
   * Therefore its average symbol length is assured to be less than 31. So
   * the compressed data for a dynamic block also cannot overwrite the
   * symbols from which it is being constructed.
   */

  s.pending_buf_size = s.lit_bufsize * 4;
  s.pending_buf = new Uint8Array(s.pending_buf_size);

  // It is offset from `s.pending_buf` (size is `s.lit_bufsize * 2`)
  //s->sym_buf = s->pending_buf + s->lit_bufsize;
  s.sym_buf = s.lit_bufsize;

  //s->sym_end = (s->lit_bufsize - 1) * 3;
  s.sym_end = (s.lit_bufsize - 1) * 3;
  /* We avoid equality with lit_bufsize*3 because of wraparound at 64K
   * on 16 bit machines and because stored blocks are restricted to
   * 64K-1 bytes.
   */

  s.level = level;
  s.strategy = strategy;
  s.method = method;

  return deflateReset(strm);
};

const deflateInit = (strm, level) => {

  return deflateInit2(strm, level, Z_DEFLATED$2, MAX_WBITS$1, DEF_MEM_LEVEL, Z_DEFAULT_STRATEGY$1);
};


/* ========================================================================= */
const deflate$2 = (strm, flush) => {

  if (deflateStateCheck(strm) || flush > Z_BLOCK$1 || flush < 0) {
    return strm ? err(strm, Z_STREAM_ERROR$2) : Z_STREAM_ERROR$2;
  }

  const s = strm.state;

  if (!strm.output ||
      (strm.avail_in !== 0 && !strm.input) ||
      (s.status === FINISH_STATE && flush !== Z_FINISH$3)) {
    return err(strm, (strm.avail_out === 0) ? Z_BUF_ERROR$1 : Z_STREAM_ERROR$2);
  }

  const old_flush = s.last_flush;
  s.last_flush = flush;

  /* Flush as much pending output as possible */
  if (s.pending !== 0) {
    flush_pending(strm);
    if (strm.avail_out === 0) {
      /* Since avail_out is 0, deflate will be called again with
       * more output space, but possibly with both pending and
       * avail_in equal to zero. There won't be anything to do,
       * but this is not an error situation so make sure we
       * return OK instead of BUF_ERROR at next call of deflate:
       */
      s.last_flush = -1;
      return Z_OK$3;
    }

    /* Make sure there is something to do and avoid duplicate consecutive
     * flushes. For repeated and useless calls with Z_FINISH, we keep
     * returning Z_STREAM_END instead of Z_BUF_ERROR.
     */
  } else if (strm.avail_in === 0 && rank(flush) <= rank(old_flush) &&
    flush !== Z_FINISH$3) {
    return err(strm, Z_BUF_ERROR$1);
  }

  /* User must not provide more input after the first FINISH: */
  if (s.status === FINISH_STATE && strm.avail_in !== 0) {
    return err(strm, Z_BUF_ERROR$1);
  }

  /* Write the header */
  if (s.status === INIT_STATE && s.wrap === 0) {
    s.status = BUSY_STATE;
  }
  if (s.status === INIT_STATE) {
    /* zlib header */
    let header = (Z_DEFLATED$2 + ((s.w_bits - 8) << 4)) << 8;
    let level_flags = -1;

    if (s.strategy >= Z_HUFFMAN_ONLY || s.level < 2) {
      level_flags = 0;
    } else if (s.level < 6) {
      level_flags = 1;
    } else if (s.level === 6) {
      level_flags = 2;
    } else {
      level_flags = 3;
    }
    header |= (level_flags << 6);
    if (s.strstart !== 0) { header |= PRESET_DICT; }
    header += 31 - (header % 31);

    putShortMSB(s, header);

    /* Save the adler32 of the preset dictionary: */
    if (s.strstart !== 0) {
      putShortMSB(s, strm.adler >>> 16);
      putShortMSB(s, strm.adler & 0xffff);
    }
    strm.adler = 1; // adler32(0L, Z_NULL, 0);
    s.status = BUSY_STATE;

    /* Compression must start with an empty pending buffer */
    flush_pending(strm);
    if (s.pending !== 0) {
      s.last_flush = -1;
      return Z_OK$3;
    }
  }
//#ifdef GZIP
  if (s.status === GZIP_STATE) {
    /* gzip header */
    strm.adler = 0;  //crc32(0L, Z_NULL, 0);
    put_byte(s, 31);
    put_byte(s, 139);
    put_byte(s, 8);
    if (!s.gzhead) { // s->gzhead == Z_NULL
      put_byte(s, 0);
      put_byte(s, 0);
      put_byte(s, 0);
      put_byte(s, 0);
      put_byte(s, 0);
      put_byte(s, s.level === 9 ? 2 :
                  (s.strategy >= Z_HUFFMAN_ONLY || s.level < 2 ?
                   4 : 0));
      put_byte(s, OS_CODE);
      s.status = BUSY_STATE;

      /* Compression must start with an empty pending buffer */
      flush_pending(strm);
      if (s.pending !== 0) {
        s.last_flush = -1;
        return Z_OK$3;
      }
    }
    else {
      put_byte(s, (s.gzhead.text ? 1 : 0) +
                  (s.gzhead.hcrc ? 2 : 0) +
                  (!s.gzhead.extra ? 0 : 4) +
                  (!s.gzhead.name ? 0 : 8) +
                  (!s.gzhead.comment ? 0 : 16)
      );
      put_byte(s, s.gzhead.time & 0xff);
      put_byte(s, (s.gzhead.time >> 8) & 0xff);
      put_byte(s, (s.gzhead.time >> 16) & 0xff);
      put_byte(s, (s.gzhead.time >> 24) & 0xff);
      put_byte(s, s.level === 9 ? 2 :
                  (s.strategy >= Z_HUFFMAN_ONLY || s.level < 2 ?
                   4 : 0));
      put_byte(s, s.gzhead.os & 0xff);
      if (s.gzhead.extra && s.gzhead.extra.length) {
        put_byte(s, s.gzhead.extra.length & 0xff);
        put_byte(s, (s.gzhead.extra.length >> 8) & 0xff);
      }
      if (s.gzhead.hcrc) {
        strm.adler = crc32_1(strm.adler, s.pending_buf, s.pending, 0);
      }
      s.gzindex = 0;
      s.status = EXTRA_STATE;
    }
  }
  if (s.status === EXTRA_STATE) {
    if (s.gzhead.extra/* != Z_NULL*/) {
      let beg = s.pending;   /* start of bytes to update crc */
      let left = (s.gzhead.extra.length & 0xffff) - s.gzindex;
      while (s.pending + left > s.pending_buf_size) {
        let copy = s.pending_buf_size - s.pending;
        // zmemcpy(s.pending_buf + s.pending,
        //    s.gzhead.extra + s.gzindex, copy);
        s.pending_buf.set(s.gzhead.extra.subarray(s.gzindex, s.gzindex + copy), s.pending);
        s.pending = s.pending_buf_size;
        //--- HCRC_UPDATE(beg) ---//
        if (s.gzhead.hcrc && s.pending > beg) {
          strm.adler = crc32_1(strm.adler, s.pending_buf, s.pending - beg, beg);
        }
        //---//
        s.gzindex += copy;
        flush_pending(strm);
        if (s.pending !== 0) {
          s.last_flush = -1;
          return Z_OK$3;
        }
        beg = 0;
        left -= copy;
      }
      // JS specific: s.gzhead.extra may be TypedArray or Array for backward compatibility
      //              TypedArray.slice and TypedArray.from don't exist in IE10-IE11
      let gzhead_extra = new Uint8Array(s.gzhead.extra);
      // zmemcpy(s->pending_buf + s->pending,
      //     s->gzhead->extra + s->gzindex, left);
      s.pending_buf.set(gzhead_extra.subarray(s.gzindex, s.gzindex + left), s.pending);
      s.pending += left;
      //--- HCRC_UPDATE(beg) ---//
      if (s.gzhead.hcrc && s.pending > beg) {
        strm.adler = crc32_1(strm.adler, s.pending_buf, s.pending - beg, beg);
      }
      //---//
      s.gzindex = 0;
    }
    s.status = NAME_STATE;
  }
  if (s.status === NAME_STATE) {
    if (s.gzhead.name/* != Z_NULL*/) {
      let beg = s.pending;   /* start of bytes to update crc */
      let val;
      do {
        if (s.pending === s.pending_buf_size) {
          //--- HCRC_UPDATE(beg) ---//
          if (s.gzhead.hcrc && s.pending > beg) {
            strm.adler = crc32_1(strm.adler, s.pending_buf, s.pending - beg, beg);
          }
          //---//
          flush_pending(strm);
          if (s.pending !== 0) {
            s.last_flush = -1;
            return Z_OK$3;
          }
          beg = 0;
        }
        // JS specific: little magic to add zero terminator to end of string
        if (s.gzindex < s.gzhead.name.length) {
          val = s.gzhead.name.charCodeAt(s.gzindex++) & 0xff;
        } else {
          val = 0;
        }
        put_byte(s, val);
      } while (val !== 0);
      //--- HCRC_UPDATE(beg) ---//
      if (s.gzhead.hcrc && s.pending > beg) {
        strm.adler = crc32_1(strm.adler, s.pending_buf, s.pending - beg, beg);
      }
      //---//
      s.gzindex = 0;
    }
    s.status = COMMENT_STATE;
  }
  if (s.status === COMMENT_STATE) {
    if (s.gzhead.comment/* != Z_NULL*/) {
      let beg = s.pending;   /* start of bytes to update crc */
      let val;
      do {
        if (s.pending === s.pending_buf_size) {
          //--- HCRC_UPDATE(beg) ---//
          if (s.gzhead.hcrc && s.pending > beg) {
            strm.adler = crc32_1(strm.adler, s.pending_buf, s.pending - beg, beg);
          }
          //---//
          flush_pending(strm);
          if (s.pending !== 0) {
            s.last_flush = -1;
            return Z_OK$3;
          }
          beg = 0;
        }
        // JS specific: little magic to add zero terminator to end of string
        if (s.gzindex < s.gzhead.comment.length) {
          val = s.gzhead.comment.charCodeAt(s.gzindex++) & 0xff;
        } else {
          val = 0;
        }
        put_byte(s, val);
      } while (val !== 0);
      //--- HCRC_UPDATE(beg) ---//
      if (s.gzhead.hcrc && s.pending > beg) {
        strm.adler = crc32_1(strm.adler, s.pending_buf, s.pending - beg, beg);
      }
      //---//
    }
    s.status = HCRC_STATE;
  }
  if (s.status === HCRC_STATE) {
    if (s.gzhead.hcrc) {
      if (s.pending + 2 > s.pending_buf_size) {
        flush_pending(strm);
        if (s.pending !== 0) {
          s.last_flush = -1;
          return Z_OK$3;
        }
      }
      put_byte(s, strm.adler & 0xff);
      put_byte(s, (strm.adler >> 8) & 0xff);
      strm.adler = 0; //crc32(0L, Z_NULL, 0);
    }
    s.status = BUSY_STATE;

    /* Compression must start with an empty pending buffer */
    flush_pending(strm);
    if (s.pending !== 0) {
      s.last_flush = -1;
      return Z_OK$3;
    }
  }
//#endif

  /* Start a new block or continue the current one.
   */
  if (strm.avail_in !== 0 || s.lookahead !== 0 ||
    (flush !== Z_NO_FLUSH$2 && s.status !== FINISH_STATE)) {
    let bstate = s.level === 0 ? deflate_stored(s, flush) :
                 s.strategy === Z_HUFFMAN_ONLY ? deflate_huff(s, flush) :
                 s.strategy === Z_RLE ? deflate_rle(s, flush) :
                 configuration_table[s.level].func(s, flush);

    if (bstate === BS_FINISH_STARTED || bstate === BS_FINISH_DONE) {
      s.status = FINISH_STATE;
    }
    if (bstate === BS_NEED_MORE || bstate === BS_FINISH_STARTED) {
      if (strm.avail_out === 0) {
        s.last_flush = -1;
        /* avoid BUF_ERROR next call, see above */
      }
      return Z_OK$3;
      /* If flush != Z_NO_FLUSH && avail_out == 0, the next call
       * of deflate should use the same flush parameter to make sure
       * that the flush is complete. So we don't have to output an
       * empty block here, this will be done at next call. This also
       * ensures that for a very small output buffer, we emit at most
       * one empty block.
       */
    }
    if (bstate === BS_BLOCK_DONE) {
      if (flush === Z_PARTIAL_FLUSH) {
        _tr_align(s);
      }
      else if (flush !== Z_BLOCK$1) { /* FULL_FLUSH or SYNC_FLUSH */

        _tr_stored_block(s, 0, 0, false);
        /* For a full flush, this empty block will be recognized
         * as a special marker by inflate_sync().
         */
        if (flush === Z_FULL_FLUSH$1) {
          /*** CLEAR_HASH(s); ***/             /* forget history */
          zero(s.head); // Fill with NIL (= 0);

          if (s.lookahead === 0) {
            s.strstart = 0;
            s.block_start = 0;
            s.insert = 0;
          }
        }
      }
      flush_pending(strm);
      if (strm.avail_out === 0) {
        s.last_flush = -1; /* avoid BUF_ERROR at next call, see above */
        return Z_OK$3;
      }
    }
  }

  if (flush !== Z_FINISH$3) { return Z_OK$3; }
  if (s.wrap <= 0) { return Z_STREAM_END$3; }

  /* Write the trailer */
  if (s.wrap === 2) {
    put_byte(s, strm.adler & 0xff);
    put_byte(s, (strm.adler >> 8) & 0xff);
    put_byte(s, (strm.adler >> 16) & 0xff);
    put_byte(s, (strm.adler >> 24) & 0xff);
    put_byte(s, strm.total_in & 0xff);
    put_byte(s, (strm.total_in >> 8) & 0xff);
    put_byte(s, (strm.total_in >> 16) & 0xff);
    put_byte(s, (strm.total_in >> 24) & 0xff);
  }
  else
  {
    putShortMSB(s, strm.adler >>> 16);
    putShortMSB(s, strm.adler & 0xffff);
  }

  flush_pending(strm);
  /* If avail_out is zero, the application will call deflate again
   * to flush the rest.
   */
  if (s.wrap > 0) { s.wrap = -s.wrap; }
  /* write the trailer only once! */
  return s.pending !== 0 ? Z_OK$3 : Z_STREAM_END$3;
};


const deflateEnd = (strm) => {

  if (deflateStateCheck(strm)) {
    return Z_STREAM_ERROR$2;
  }

  const status = strm.state.status;

  strm.state = null;

  return status === BUSY_STATE ? err(strm, Z_DATA_ERROR$2) : Z_OK$3;
};


/* =========================================================================
 * Initializes the compression dictionary from the given byte
 * sequence without producing any compressed output.
 */
const deflateSetDictionary = (strm, dictionary) => {

  let dictLength = dictionary.length;

  if (deflateStateCheck(strm)) {
    return Z_STREAM_ERROR$2;
  }

  const s = strm.state;
  const wrap = s.wrap;

  if (wrap === 2 || (wrap === 1 && s.status !== INIT_STATE) || s.lookahead) {
    return Z_STREAM_ERROR$2;
  }

  /* when using zlib wrappers, compute Adler-32 for provided dictionary */
  if (wrap === 1) {
    /* adler32(strm->adler, dictionary, dictLength); */
    strm.adler = adler32_1(strm.adler, dictionary, dictLength, 0);
  }

  s.wrap = 0;   /* avoid computing Adler-32 in read_buf */

  /* if dictionary would fill window, just replace the history */
  if (dictLength >= s.w_size) {
    if (wrap === 0) {            /* already empty otherwise */
      /*** CLEAR_HASH(s); ***/
      zero(s.head); // Fill with NIL (= 0);
      s.strstart = 0;
      s.block_start = 0;
      s.insert = 0;
    }
    /* use the tail */
    // dictionary = dictionary.slice(dictLength - s.w_size);
    let tmpDict = new Uint8Array(s.w_size);
    tmpDict.set(dictionary.subarray(dictLength - s.w_size, dictLength), 0);
    dictionary = tmpDict;
    dictLength = s.w_size;
  }
  /* insert dictionary into window and hash */
  const avail = strm.avail_in;
  const next = strm.next_in;
  const input = strm.input;
  strm.avail_in = dictLength;
  strm.next_in = 0;
  strm.input = dictionary;
  fill_window(s);
  while (s.lookahead >= MIN_MATCH) {
    let str = s.strstart;
    let n = s.lookahead - (MIN_MATCH - 1);
    do {
      /* UPDATE_HASH(s, s->ins_h, s->window[str + MIN_MATCH-1]); */
      s.ins_h = HASH(s, s.ins_h, s.window[str + MIN_MATCH - 1]);

      s.prev[str & s.w_mask] = s.head[s.ins_h];

      s.head[s.ins_h] = str;
      str++;
    } while (--n);
    s.strstart = str;
    s.lookahead = MIN_MATCH - 1;
    fill_window(s);
  }
  s.strstart += s.lookahead;
  s.block_start = s.strstart;
  s.insert = s.lookahead;
  s.lookahead = 0;
  s.match_length = s.prev_length = MIN_MATCH - 1;
  s.match_available = 0;
  strm.next_in = next;
  strm.input = input;
  strm.avail_in = avail;
  s.wrap = wrap;
  return Z_OK$3;
};


var deflateInit_1 = deflateInit;
var deflateInit2_1 = deflateInit2;
var deflateReset_1 = deflateReset;
var deflateResetKeep_1 = deflateResetKeep;
var deflateSetHeader_1 = deflateSetHeader;
var deflate_2$1 = deflate$2;
var deflateEnd_1 = deflateEnd;
var deflateSetDictionary_1 = deflateSetDictionary;
var deflateInfo = 'pako deflate (from Nodeca project)';

/* Not implemented
module.exports.deflateBound = deflateBound;
module.exports.deflateCopy = deflateCopy;
module.exports.deflateGetDictionary = deflateGetDictionary;
module.exports.deflateParams = deflateParams;
module.exports.deflatePending = deflatePending;
module.exports.deflatePrime = deflatePrime;
module.exports.deflateTune = deflateTune;
*/

var deflate_1$2 = {
	deflateInit: deflateInit_1,
	deflateInit2: deflateInit2_1,
	deflateReset: deflateReset_1,
	deflateResetKeep: deflateResetKeep_1,
	deflateSetHeader: deflateSetHeader_1,
	deflate: deflate_2$1,
	deflateEnd: deflateEnd_1,
	deflateSetDictionary: deflateSetDictionary_1,
	deflateInfo: deflateInfo
};

const _has = (obj, key) => {
  return Object.prototype.hasOwnProperty.call(obj, key);
};

var assign = function (obj /*from1, from2, from3, ...*/) {
  const sources = Array.prototype.slice.call(arguments, 1);
  while (sources.length) {
    const source = sources.shift();
    if (!source) { continue; }

    if (typeof source !== 'object') {
      throw new TypeError(source + 'must be non-object');
    }

    for (const p in source) {
      if (_has(source, p)) {
        obj[p] = source[p];
      }
    }
  }

  return obj;
};


// Join array of chunks to single array.
var flattenChunks = (chunks) => {
  // calculate data length
  let len = 0;

  for (let i = 0, l = chunks.length; i < l; i++) {
    len += chunks[i].length;
  }

  // join chunks
  const result = new Uint8Array(len);

  for (let i = 0, pos = 0, l = chunks.length; i < l; i++) {
    let chunk = chunks[i];
    result.set(chunk, pos);
    pos += chunk.length;
  }

  return result;
};

var common = {
	assign: assign,
	flattenChunks: flattenChunks
};

// String encode/decode helpers


// Quick check if we can use fast array to bin string conversion
//
// - apply(Array) can fail on Android 2.2
// - apply(Uint8Array) can fail on iOS 5.1 Safari
//
let STR_APPLY_UIA_OK = true;

try { String.fromCharCode.apply(null, new Uint8Array(1)); } catch (__) { STR_APPLY_UIA_OK = false; }


// Table with utf8 lengths (calculated by first byte of sequence)
// Note, that 5 & 6-byte values and some 4-byte values can not be represented in JS,
// because max possible codepoint is 0x10ffff
const _utf8len = new Uint8Array(256);
for (let q = 0; q < 256; q++) {
  _utf8len[q] = (q >= 252 ? 6 : q >= 248 ? 5 : q >= 240 ? 4 : q >= 224 ? 3 : q >= 192 ? 2 : 1);
}
_utf8len[254] = _utf8len[254] = 1; // Invalid sequence start


// convert string to array (typed, when possible)
var string2buf = (str) => {
  if (typeof TextEncoder === 'function' && TextEncoder.prototype.encode) {
    return new TextEncoder().encode(str);
  }

  let buf, c, c2, m_pos, i, str_len = str.length, buf_len = 0;

  // count binary size
  for (m_pos = 0; m_pos < str_len; m_pos++) {
    c = str.charCodeAt(m_pos);
    if ((c & 0xfc00) === 0xd800 && (m_pos + 1 < str_len)) {
      c2 = str.charCodeAt(m_pos + 1);
      if ((c2 & 0xfc00) === 0xdc00) {
        c = 0x10000 + ((c - 0xd800) << 10) + (c2 - 0xdc00);
        m_pos++;
      }
    }
    buf_len += c < 0x80 ? 1 : c < 0x800 ? 2 : c < 0x10000 ? 3 : 4;
  }

  // allocate buffer
  buf = new Uint8Array(buf_len);

  // convert
  for (i = 0, m_pos = 0; i < buf_len; m_pos++) {
    c = str.charCodeAt(m_pos);
    if ((c & 0xfc00) === 0xd800 && (m_pos + 1 < str_len)) {
      c2 = str.charCodeAt(m_pos + 1);
      if ((c2 & 0xfc00) === 0xdc00) {
        c = 0x10000 + ((c - 0xd800) << 10) + (c2 - 0xdc00);
        m_pos++;
      }
    }
    if (c < 0x80) {
      /* one byte */
      buf[i++] = c;
    } else if (c < 0x800) {
      /* two bytes */
      buf[i++] = 0xC0 | (c >>> 6);
      buf[i++] = 0x80 | (c & 0x3f);
    } else if (c < 0x10000) {
      /* three bytes */
      buf[i++] = 0xE0 | (c >>> 12);
      buf[i++] = 0x80 | (c >>> 6 & 0x3f);
      buf[i++] = 0x80 | (c & 0x3f);
    } else {
      /* four bytes */
      buf[i++] = 0xf0 | (c >>> 18);
      buf[i++] = 0x80 | (c >>> 12 & 0x3f);
      buf[i++] = 0x80 | (c >>> 6 & 0x3f);
      buf[i++] = 0x80 | (c & 0x3f);
    }
  }

  return buf;
};

// Helper
const buf2binstring = (buf, len) => {
  // On Chrome, the arguments in a function call that are allowed is `65534`.
  // If the length of the buffer is smaller than that, we can use this optimization,
  // otherwise we will take a slower path.
  if (len < 65534) {
    if (buf.subarray && STR_APPLY_UIA_OK) {
      return String.fromCharCode.apply(null, buf.length === len ? buf : buf.subarray(0, len));
    }
  }

  let result = '';
  for (let i = 0; i < len; i++) {
    result += String.fromCharCode(buf[i]);
  }
  return result;
};


// convert array to string
var buf2string = (buf, max) => {
  const len = max || buf.length;

  if (typeof TextDecoder === 'function' && TextDecoder.prototype.decode) {
    return new TextDecoder().decode(buf.subarray(0, max));
  }

  let i, out;

  // Reserve max possible length (2 words per char)
  // NB: by unknown reasons, Array is significantly faster for
  //     String.fromCharCode.apply than Uint16Array.
  const utf16buf = new Array(len * 2);

  for (out = 0, i = 0; i < len;) {
    let c = buf[i++];
    // quick process ascii
    if (c < 0x80) { utf16buf[out++] = c; continue; }

    let c_len = _utf8len[c];
    // skip 5 & 6 byte codes
    if (c_len > 4) { utf16buf[out++] = 0xfffd; i += c_len - 1; continue; }

    // apply mask on first byte
    c &= c_len === 2 ? 0x1f : c_len === 3 ? 0x0f : 0x07;
    // join the rest
    while (c_len > 1 && i < len) {
      c = (c << 6) | (buf[i++] & 0x3f);
      c_len--;
    }

    // terminated by end of string?
    if (c_len > 1) { utf16buf[out++] = 0xfffd; continue; }

    if (c < 0x10000) {
      utf16buf[out++] = c;
    } else {
      c -= 0x10000;
      utf16buf[out++] = 0xd800 | ((c >> 10) & 0x3ff);
      utf16buf[out++] = 0xdc00 | (c & 0x3ff);
    }
  }

  return buf2binstring(utf16buf, out);
};


// Calculate max possible position in utf8 buffer,
// that will not break sequence. If that's not possible
// - (very small limits) return max size as is.
//
// buf[] - utf8 bytes array
// max   - length limit (mandatory);
var utf8border = (buf, max) => {

  max = max || buf.length;
  if (max > buf.length) { max = buf.length; }

  // go back from last position, until start of sequence found
  let pos = max - 1;
  while (pos >= 0 && (buf[pos] & 0xC0) === 0x80) { pos--; }

  // Very small and broken sequence,
  // return max, because we should return something anyway.
  if (pos < 0) { return max; }

  // If we came to start of buffer - that means buffer is too small,
  // return max too.
  if (pos === 0) { return max; }

  return (pos + _utf8len[buf[pos]] > max) ? pos : max;
};

var strings = {
	string2buf: string2buf,
	buf2string: buf2string,
	utf8border: utf8border
};

// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.

function ZStream() {
  /* next input byte */
  this.input = null; // JS specific, because we have no pointers
  this.next_in = 0;
  /* number of bytes available at input */
  this.avail_in = 0;
  /* total number of input bytes read so far */
  this.total_in = 0;
  /* next output byte should be put there */
  this.output = null; // JS specific, because we have no pointers
  this.next_out = 0;
  /* remaining free space at output */
  this.avail_out = 0;
  /* total number of bytes output so far */
  this.total_out = 0;
  /* last error message, NULL if no error */
  this.msg = ''/*Z_NULL*/;
  /* not visible by applications */
  this.state = null;
  /* best guess about the data type: binary or text */
  this.data_type = 2/*Z_UNKNOWN*/;
  /* adler32 value of the uncompressed data */
  this.adler = 0;
}

var zstream = ZStream;

const toString$1 = Object.prototype.toString;

/* Public constants ==========================================================*/
/* ===========================================================================*/

const {
  Z_NO_FLUSH: Z_NO_FLUSH$1, Z_SYNC_FLUSH, Z_FULL_FLUSH, Z_FINISH: Z_FINISH$2,
  Z_OK: Z_OK$2, Z_STREAM_END: Z_STREAM_END$2,
  Z_DEFAULT_COMPRESSION,
  Z_DEFAULT_STRATEGY,
  Z_DEFLATED: Z_DEFLATED$1
} = constants$2;

/* ===========================================================================*/


/**
 * class Deflate
 *
 * Generic JS-style wrapper for zlib calls. If you don't need
 * streaming behaviour - use more simple functions: [[deflate]],
 * [[deflateRaw]] and [[gzip]].
 **/

/* internal
 * Deflate.chunks -> Array
 *
 * Chunks of output data, if [[Deflate#onData]] not overridden.
 **/

/**
 * Deflate.result -> Uint8Array
 *
 * Compressed result, generated by default [[Deflate#onData]]
 * and [[Deflate#onEnd]] handlers. Filled after you push last chunk
 * (call [[Deflate#push]] with `Z_FINISH` / `true` param).
 **/

/**
 * Deflate.err -> Number
 *
 * Error code after deflate finished. 0 (Z_OK) on success.
 * You will not need it in real life, because deflate errors
 * are possible only on wrong options or bad `onData` / `onEnd`
 * custom handlers.
 **/

/**
 * Deflate.msg -> String
 *
 * Error message, if [[Deflate.err]] != 0
 **/


/**
 * new Deflate(options)
 * - options (Object): zlib deflate options.
 *
 * Creates new deflator instance with specified params. Throws exception
 * on bad params. Supported options:
 *
 * - `level`
 * - `windowBits`
 * - `memLevel`
 * - `strategy`
 * - `dictionary`
 *
 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
 * for more information on these.
 *
 * Additional options, for internal needs:
 *
 * - `chunkSize` - size of generated data chunks (16K by default)
 * - `raw` (Boolean) - do raw deflate
 * - `gzip` (Boolean) - create gzip wrapper
 * - `header` (Object) - custom header for gzip
 *   - `text` (Boolean) - true if compressed data believed to be text
 *   - `time` (Number) - modification time, unix timestamp
 *   - `os` (Number) - operation system code
 *   - `extra` (Array) - array of bytes with extra data (max 65536)
 *   - `name` (String) - file name (binary string)
 *   - `comment` (String) - comment (binary string)
 *   - `hcrc` (Boolean) - true if header crc should be added
 *
 * ##### Example:
 *
 * ```javascript
 * const pako = require('pako')
 *   , chunk1 = new Uint8Array([1,2,3,4,5,6,7,8,9])
 *   , chunk2 = new Uint8Array([10,11,12,13,14,15,16,17,18,19]);
 *
 * const deflate = new pako.Deflate({ level: 3});
 *
 * deflate.push(chunk1, false);
 * deflate.push(chunk2, true);  // true -> last chunk
 *
 * if (deflate.err) { throw new Error(deflate.err); }
 *
 * console.log(deflate.result);
 * ```
 **/
function Deflate$1(options) {
  this.options = common.assign({
    level: Z_DEFAULT_COMPRESSION,
    method: Z_DEFLATED$1,
    chunkSize: 16384,
    windowBits: 15,
    memLevel: 8,
    strategy: Z_DEFAULT_STRATEGY
  }, options || {});

  let opt = this.options;

  if (opt.raw && (opt.windowBits > 0)) {
    opt.windowBits = -opt.windowBits;
  }

  else if (opt.gzip && (opt.windowBits > 0) && (opt.windowBits < 16)) {
    opt.windowBits += 16;
  }

  this.err    = 0;      // error code, if happens (0 = Z_OK)
  this.msg    = '';     // error message
  this.ended  = false;  // used to avoid multiple onEnd() calls
  this.chunks = [];     // chunks of compressed data

  this.strm = new zstream();
  this.strm.avail_out = 0;

  let status = deflate_1$2.deflateInit2(
    this.strm,
    opt.level,
    opt.method,
    opt.windowBits,
    opt.memLevel,
    opt.strategy
  );

  if (status !== Z_OK$2) {
    throw new Error(messages[status]);
  }

  if (opt.header) {
    deflate_1$2.deflateSetHeader(this.strm, opt.header);
  }

  if (opt.dictionary) {
    let dict;
    // Convert data if needed
    if (typeof opt.dictionary === 'string') {
      // If we need to compress text, change encoding to utf8.
      dict = strings.string2buf(opt.dictionary);
    } else if (toString$1.call(opt.dictionary) === '[object ArrayBuffer]') {
      dict = new Uint8Array(opt.dictionary);
    } else {
      dict = opt.dictionary;
    }

    status = deflate_1$2.deflateSetDictionary(this.strm, dict);

    if (status !== Z_OK$2) {
      throw new Error(messages[status]);
    }

    this._dict_set = true;
  }
}

/**
 * Deflate#push(data[, flush_mode]) -> Boolean
 * - data (Uint8Array|ArrayBuffer|String): input data. Strings will be
 *   converted to utf8 byte sequence.
 * - flush_mode (Number|Boolean): 0..6 for corresponding Z_NO_FLUSH..Z_TREE modes.
 *   See constants. Skipped or `false` means Z_NO_FLUSH, `true` means Z_FINISH.
 *
 * Sends input data to deflate pipe, generating [[Deflate#onData]] calls with
 * new compressed chunks. Returns `true` on success. The last data block must
 * have `flush_mode` Z_FINISH (or `true`). That will flush internal pending
 * buffers and call [[Deflate#onEnd]].
 *
 * On fail call [[Deflate#onEnd]] with error code and return false.
 *
 * ##### Example
 *
 * ```javascript
 * push(chunk, false); // push one of data chunks
 * ...
 * push(chunk, true);  // push last chunk
 * ```
 **/
Deflate$1.prototype.push = function (data, flush_mode) {
  const strm = this.strm;
  const chunkSize = this.options.chunkSize;
  let status, _flush_mode;

  if (this.ended) { return false; }

  if (flush_mode === ~~flush_mode) _flush_mode = flush_mode;
  else _flush_mode = flush_mode === true ? Z_FINISH$2 : Z_NO_FLUSH$1;

  // Convert data if needed
  if (typeof data === 'string') {
    // If we need to compress text, change encoding to utf8.
    strm.input = strings.string2buf(data);
  } else if (toString$1.call(data) === '[object ArrayBuffer]') {
    strm.input = new Uint8Array(data);
  } else {
    strm.input = data;
  }

  strm.next_in = 0;
  strm.avail_in = strm.input.length;

  for (;;) {
    if (strm.avail_out === 0) {
      strm.output = new Uint8Array(chunkSize);
      strm.next_out = 0;
      strm.avail_out = chunkSize;
    }

    // Make sure avail_out > 6 to avoid repeating markers
    if ((_flush_mode === Z_SYNC_FLUSH || _flush_mode === Z_FULL_FLUSH) && strm.avail_out <= 6) {
      this.onData(strm.output.subarray(0, strm.next_out));
      strm.avail_out = 0;
      continue;
    }

    status = deflate_1$2.deflate(strm, _flush_mode);

    // Ended => flush and finish
    if (status === Z_STREAM_END$2) {
      if (strm.next_out > 0) {
        this.onData(strm.output.subarray(0, strm.next_out));
      }
      status = deflate_1$2.deflateEnd(this.strm);
      this.onEnd(status);
      this.ended = true;
      return status === Z_OK$2;
    }

    // Flush if out buffer full
    if (strm.avail_out === 0) {
      this.onData(strm.output);
      continue;
    }

    // Flush if requested and has data
    if (_flush_mode > 0 && strm.next_out > 0) {
      this.onData(strm.output.subarray(0, strm.next_out));
      strm.avail_out = 0;
      continue;
    }

    if (strm.avail_in === 0) break;
  }

  return true;
};


/**
 * Deflate#onData(chunk) -> Void
 * - chunk (Uint8Array): output data.
 *
 * By default, stores data blocks in `chunks[]` property and glue
 * those in `onEnd`. Override this handler, if you need another behaviour.
 **/
Deflate$1.prototype.onData = function (chunk) {
  this.chunks.push(chunk);
};


/**
 * Deflate#onEnd(status) -> Void
 * - status (Number): deflate status. 0 (Z_OK) on success,
 *   other if not.
 *
 * Called once after you tell deflate that the input stream is
 * complete (Z_FINISH). By default - join collected chunks,
 * free memory and fill `results` / `err` properties.
 **/
Deflate$1.prototype.onEnd = function (status) {
  // On success - join
  if (status === Z_OK$2) {
    this.result = common.flattenChunks(this.chunks);
  }
  this.chunks = [];
  this.err = status;
  this.msg = this.strm.msg;
};


/**
 * deflate(data[, options]) -> Uint8Array
 * - data (Uint8Array|ArrayBuffer|String): input data to compress.
 * - options (Object): zlib deflate options.
 *
 * Compress `data` with deflate algorithm and `options`.
 *
 * Supported options are:
 *
 * - level
 * - windowBits
 * - memLevel
 * - strategy
 * - dictionary
 *
 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
 * for more information on these.
 *
 * Sugar (options):
 *
 * - `raw` (Boolean) - say that we work with raw stream, if you don't wish to specify
 *   negative windowBits implicitly.
 *
 * ##### Example:
 *
 * ```javascript
 * const pako = require('pako')
 * const data = new Uint8Array([1,2,3,4,5,6,7,8,9]);
 *
 * console.log(pako.deflate(data));
 * ```
 **/
function deflate$1(input, options) {
  const deflator = new Deflate$1(options);

  deflator.push(input, true);

  // That will never happens, if you don't cheat with options :)
  if (deflator.err) { throw deflator.msg || messages[deflator.err]; }

  return deflator.result;
}


/**
 * deflateRaw(data[, options]) -> Uint8Array
 * - data (Uint8Array|ArrayBuffer|String): input data to compress.
 * - options (Object): zlib deflate options.
 *
 * The same as [[deflate]], but creates raw data, without wrapper
 * (header and adler32 crc).
 **/
function deflateRaw$1(input, options) {
  options = options || {};
  options.raw = true;
  return deflate$1(input, options);
}


/**
 * gzip(data[, options]) -> Uint8Array
 * - data (Uint8Array|ArrayBuffer|String): input data to compress.
 * - options (Object): zlib deflate options.
 *
 * The same as [[deflate]], but create gzip wrapper instead of
 * deflate one.
 **/
function gzip$1(input, options) {
  options = options || {};
  options.gzip = true;
  return deflate$1(input, options);
}


var Deflate_1$1 = Deflate$1;
var deflate_2 = deflate$1;
var deflateRaw_1$1 = deflateRaw$1;
var gzip_1$1 = gzip$1;
var constants$1 = constants$2;

var deflate_1$1 = {
	Deflate: Deflate_1$1,
	deflate: deflate_2,
	deflateRaw: deflateRaw_1$1,
	gzip: gzip_1$1,
	constants: constants$1
};

// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.

// See state defs from inflate.js
const BAD$1 = 16209;       /* got a data error -- remain here until reset */
const TYPE$1 = 16191;      /* i: waiting for type bits, including last-flag bit */

/*
   Decode literal, length, and distance codes and write out the resulting
   literal and match bytes until either not enough input or output is
   available, an end-of-block is encountered, or a data error is encountered.
   When large enough input and output buffers are supplied to inflate(), for
   example, a 16K input buffer and a 64K output buffer, more than 95% of the
   inflate execution time is spent in this routine.

   Entry assumptions:

        state.mode === LEN
        strm.avail_in >= 6
        strm.avail_out >= 258
        start >= strm.avail_out
        state.bits < 8

   On return, state.mode is one of:

        LEN -- ran out of enough output space or enough available input
        TYPE -- reached end of block code, inflate() to interpret next block
        BAD -- error in block data

   Notes:

    - The maximum input bits used by a length/distance pair is 15 bits for the
      length code, 5 bits for the length extra, 15 bits for the distance code,
      and 13 bits for the distance extra.  This totals 48 bits, or six bytes.
      Therefore if strm.avail_in >= 6, then there is enough input to avoid
      checking for available input while decoding.

    - The maximum bytes that a single length/distance pair can output is 258
      bytes, which is the maximum length that can be coded.  inflate_fast()
      requires strm.avail_out >= 258 for each loop to avoid checking for
      output space.
 */
var inffast = function inflate_fast(strm, start) {
  let _in;                    /* local strm.input */
  let last;                   /* have enough input while in < last */
  let _out;                   /* local strm.output */
  let beg;                    /* inflate()'s initial strm.output */
  let end;                    /* while out < end, enough space available */
//#ifdef INFLATE_STRICT
  let dmax;                   /* maximum distance from zlib header */
//#endif
  let wsize;                  /* window size or zero if not using window */
  let whave;                  /* valid bytes in the window */
  let wnext;                  /* window write index */
  // Use `s_window` instead `window`, avoid conflict with instrumentation tools
  let s_window;               /* allocated sliding window, if wsize != 0 */
  let hold;                   /* local strm.hold */
  let bits;                   /* local strm.bits */
  let lcode;                  /* local strm.lencode */
  let dcode;                  /* local strm.distcode */
  let lmask;                  /* mask for first level of length codes */
  let dmask;                  /* mask for first level of distance codes */
  let here;                   /* retrieved table entry */
  let op;                     /* code bits, operation, extra bits, or */
                              /*  window position, window bytes to copy */
  let len;                    /* match length, unused bytes */
  let dist;                   /* match distance */
  let from;                   /* where to copy match from */
  let from_source;


  let input, output; // JS specific, because we have no pointers

  /* copy state to local variables */
  const state = strm.state;
  //here = state.here;
  _in = strm.next_in;
  input = strm.input;
  last = _in + (strm.avail_in - 5);
  _out = strm.next_out;
  output = strm.output;
  beg = _out - (start - strm.avail_out);
  end = _out + (strm.avail_out - 257);
//#ifdef INFLATE_STRICT
  dmax = state.dmax;
//#endif
  wsize = state.wsize;
  whave = state.whave;
  wnext = state.wnext;
  s_window = state.window;
  hold = state.hold;
  bits = state.bits;
  lcode = state.lencode;
  dcode = state.distcode;
  lmask = (1 << state.lenbits) - 1;
  dmask = (1 << state.distbits) - 1;


  /* decode literals and length/distances until end-of-block or not enough
     input data or output space */

  top:
  do {
    if (bits < 15) {
      hold += input[_in++] << bits;
      bits += 8;
      hold += input[_in++] << bits;
      bits += 8;
    }

    here = lcode[hold & lmask];

    dolen:
    for (;;) { // Goto emulation
      op = here >>> 24/*here.bits*/;
      hold >>>= op;
      bits -= op;
      op = (here >>> 16) & 0xff/*here.op*/;
      if (op === 0) {                          /* literal */
        //Tracevv((stderr, here.val >= 0x20 && here.val < 0x7f ?
        //        "inflate:         literal '%c'\n" :
        //        "inflate:         literal 0x%02x\n", here.val));
        output[_out++] = here & 0xffff/*here.val*/;
      }
      else if (op & 16) {                     /* length base */
        len = here & 0xffff/*here.val*/;
        op &= 15;                           /* number of extra bits */
        if (op) {
          if (bits < op) {
            hold += input[_in++] << bits;
            bits += 8;
          }
          len += hold & ((1 << op) - 1);
          hold >>>= op;
          bits -= op;
        }
        //Tracevv((stderr, "inflate:         length %u\n", len));
        if (bits < 15) {
          hold += input[_in++] << bits;
          bits += 8;
          hold += input[_in++] << bits;
          bits += 8;
        }
        here = dcode[hold & dmask];

        dodist:
        for (;;) { // goto emulation
          op = here >>> 24/*here.bits*/;
          hold >>>= op;
          bits -= op;
          op = (here >>> 16) & 0xff/*here.op*/;

          if (op & 16) {                      /* distance base */
            dist = here & 0xffff/*here.val*/;
            op &= 15;                       /* number of extra bits */
            if (bits < op) {
              hold += input[_in++] << bits;
              bits += 8;
              if (bits < op) {
                hold += input[_in++] << bits;
                bits += 8;
              }
            }
            dist += hold & ((1 << op) - 1);
//#ifdef INFLATE_STRICT
            if (dist > dmax) {
              strm.msg = 'invalid distance too far back';
              state.mode = BAD$1;
              break top;
            }
//#endif
            hold >>>= op;
            bits -= op;
            //Tracevv((stderr, "inflate:         distance %u\n", dist));
            op = _out - beg;                /* max distance in output */
            if (dist > op) {                /* see if copy from window */
              op = dist - op;               /* distance back in window */
              if (op > whave) {
                if (state.sane) {
                  strm.msg = 'invalid distance too far back';
                  state.mode = BAD$1;
                  break top;
                }

// (!) This block is disabled in zlib defaults,
// don't enable it for binary compatibility
//#ifdef INFLATE_ALLOW_INVALID_DISTANCE_TOOFAR_ARRR
//                if (len <= op - whave) {
//                  do {
//                    output[_out++] = 0;
//                  } while (--len);
//                  continue top;
//                }
//                len -= op - whave;
//                do {
//                  output[_out++] = 0;
//                } while (--op > whave);
//                if (op === 0) {
//                  from = _out - dist;
//                  do {
//                    output[_out++] = output[from++];
//                  } while (--len);
//                  continue top;
//                }
//#endif
              }
              from = 0; // window index
              from_source = s_window;
              if (wnext === 0) {           /* very common case */
                from += wsize - op;
                if (op < len) {         /* some from window */
                  len -= op;
                  do {
                    output[_out++] = s_window[from++];
                  } while (--op);
                  from = _out - dist;  /* rest from output */
                  from_source = output;
                }
              }
              else if (wnext < op) {      /* wrap around window */
                from += wsize + wnext - op;
                op -= wnext;
                if (op < len) {         /* some from end of window */
                  len -= op;
                  do {
                    output[_out++] = s_window[from++];
                  } while (--op);
                  from = 0;
                  if (wnext < len) {  /* some from start of window */
                    op = wnext;
                    len -= op;
                    do {
                      output[_out++] = s_window[from++];
                    } while (--op);
                    from = _out - dist;      /* rest from output */
                    from_source = output;
                  }
                }
              }
              else {                      /* contiguous in window */
                from += wnext - op;
                if (op < len) {         /* some from window */
                  len -= op;
                  do {
                    output[_out++] = s_window[from++];
                  } while (--op);
                  from = _out - dist;  /* rest from output */
                  from_source = output;
                }
              }
              while (len > 2) {
                output[_out++] = from_source[from++];
                output[_out++] = from_source[from++];
                output[_out++] = from_source[from++];
                len -= 3;
              }
              if (len) {
                output[_out++] = from_source[from++];
                if (len > 1) {
                  output[_out++] = from_source[from++];
                }
              }
            }
            else {
              from = _out - dist;          /* copy direct from output */
              do {                        /* minimum length is three */
                output[_out++] = output[from++];
                output[_out++] = output[from++];
                output[_out++] = output[from++];
                len -= 3;
              } while (len > 2);
              if (len) {
                output[_out++] = output[from++];
                if (len > 1) {
                  output[_out++] = output[from++];
                }
              }
            }
          }
          else if ((op & 64) === 0) {          /* 2nd level distance code */
            here = dcode[(here & 0xffff)/*here.val*/ + (hold & ((1 << op) - 1))];
            continue dodist;
          }
          else {
            strm.msg = 'invalid distance code';
            state.mode = BAD$1;
            break top;
          }

          break; // need to emulate goto via "continue"
        }
      }
      else if ((op & 64) === 0) {              /* 2nd level length code */
        here = lcode[(here & 0xffff)/*here.val*/ + (hold & ((1 << op) - 1))];
        continue dolen;
      }
      else if (op & 32) {                     /* end-of-block */
        //Tracevv((stderr, "inflate:         end of block\n"));
        state.mode = TYPE$1;
        break top;
      }
      else {
        strm.msg = 'invalid literal/length code';
        state.mode = BAD$1;
        break top;
      }

      break; // need to emulate goto via "continue"
    }
  } while (_in < last && _out < end);

  /* return unused bytes (on entry, bits < 8, so in won't go too far back) */
  len = bits >> 3;
  _in -= len;
  bits -= len << 3;
  hold &= (1 << bits) - 1;

  /* update state and return */
  strm.next_in = _in;
  strm.next_out = _out;
  strm.avail_in = (_in < last ? 5 + (last - _in) : 5 - (_in - last));
  strm.avail_out = (_out < end ? 257 + (end - _out) : 257 - (_out - end));
  state.hold = hold;
  state.bits = bits;
  return;
};

// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.

const MAXBITS = 15;
const ENOUGH_LENS$1 = 852;
const ENOUGH_DISTS$1 = 592;
//const ENOUGH = (ENOUGH_LENS+ENOUGH_DISTS);

const CODES$1 = 0;
const LENS$1 = 1;
const DISTS$1 = 2;

const lbase = new Uint16Array([ /* Length codes 257..285 base */
  3, 4, 5, 6, 7, 8, 9, 10, 11, 13, 15, 17, 19, 23, 27, 31,
  35, 43, 51, 59, 67, 83, 99, 115, 131, 163, 195, 227, 258, 0, 0
]);

const lext = new Uint8Array([ /* Length codes 257..285 extra */
  16, 16, 16, 16, 16, 16, 16, 16, 17, 17, 17, 17, 18, 18, 18, 18,
  19, 19, 19, 19, 20, 20, 20, 20, 21, 21, 21, 21, 16, 72, 78
]);

const dbase = new Uint16Array([ /* Distance codes 0..29 base */
  1, 2, 3, 4, 5, 7, 9, 13, 17, 25, 33, 49, 65, 97, 129, 193,
  257, 385, 513, 769, 1025, 1537, 2049, 3073, 4097, 6145,
  8193, 12289, 16385, 24577, 0, 0
]);

const dext = new Uint8Array([ /* Distance codes 0..29 extra */
  16, 16, 16, 16, 17, 17, 18, 18, 19, 19, 20, 20, 21, 21, 22, 22,
  23, 23, 24, 24, 25, 25, 26, 26, 27, 27,
  28, 28, 29, 29, 64, 64
]);

const inflate_table = (type, lens, lens_index, codes, table, table_index, work, opts) =>
{
  const bits = opts.bits;
      //here = opts.here; /* table entry for duplication */

  let len = 0;               /* a code's length in bits */
  let sym = 0;               /* index of code symbols */
  let min = 0, max = 0;          /* minimum and maximum code lengths */
  let root = 0;              /* number of index bits for root table */
  let curr = 0;              /* number of index bits for current table */
  let drop = 0;              /* code bits to drop for sub-table */
  let left = 0;                   /* number of prefix codes available */
  let used = 0;              /* code entries in table used */
  let huff = 0;              /* Huffman code */
  let incr;              /* for incrementing code, index */
  let fill;              /* index for replicating entries */
  let low;               /* low bits for current root entry */
  let mask;              /* mask for low root bits */
  let next;             /* next available space in table */
  let base = null;     /* base value table to use */
//  let shoextra;    /* extra bits table to use */
  let match;                  /* use base and extra for symbol >= match */
  const count = new Uint16Array(MAXBITS + 1); //[MAXBITS+1];    /* number of codes of each length */
  const offs = new Uint16Array(MAXBITS + 1); //[MAXBITS+1];     /* offsets in table for each length */
  let extra = null;

  let here_bits, here_op, here_val;

  /*
   Process a set of code lengths to create a canonical Huffman code.  The
   code lengths are lens[0..codes-1].  Each length corresponds to the
   symbols 0..codes-1.  The Huffman code is generated by first sorting the
   symbols by length from short to long, and retaining the symbol order
   for codes with equal lengths.  Then the code starts with all zero bits
   for the first code of the shortest length, and the codes are integer
   increments for the same length, and zeros are appended as the length
   increases.  For the deflate format, these bits are stored backwards
   from their more natural integer increment ordering, and so when the
   decoding tables are built in the large loop below, the integer codes
   are incremented backwards.

   This routine assumes, but does not check, that all of the entries in
   lens[] are in the range 0..MAXBITS.  The caller must assure this.
   1..MAXBITS is interpreted as that code length.  zero means that that
   symbol does not occur in this code.

   The codes are sorted by computing a count of codes for each length,
   creating from that a table of starting indices for each length in the
   sorted table, and then entering the symbols in order in the sorted
   table.  The sorted table is work[], with that space being provided by
   the caller.

   The length counts are used for other purposes as well, i.e. finding
   the minimum and maximum length codes, determining if there are any
   codes at all, checking for a valid set of lengths, and looking ahead
   at length counts to determine sub-table sizes when building the
   decoding tables.
   */

  /* accumulate lengths for codes (assumes lens[] all in 0..MAXBITS) */
  for (len = 0; len <= MAXBITS; len++) {
    count[len] = 0;
  }
  for (sym = 0; sym < codes; sym++) {
    count[lens[lens_index + sym]]++;
  }

  /* bound code lengths, force root to be within code lengths */
  root = bits;
  for (max = MAXBITS; max >= 1; max--) {
    if (count[max] !== 0) { break; }
  }
  if (root > max) {
    root = max;
  }
  if (max === 0) {                     /* no symbols to code at all */
    //table.op[opts.table_index] = 64;  //here.op = (var char)64;    /* invalid code marker */
    //table.bits[opts.table_index] = 1;   //here.bits = (var char)1;
    //table.val[opts.table_index++] = 0;   //here.val = (var short)0;
    table[table_index++] = (1 << 24) | (64 << 16) | 0;


    //table.op[opts.table_index] = 64;
    //table.bits[opts.table_index] = 1;
    //table.val[opts.table_index++] = 0;
    table[table_index++] = (1 << 24) | (64 << 16) | 0;

    opts.bits = 1;
    return 0;     /* no symbols, but wait for decoding to report error */
  }
  for (min = 1; min < max; min++) {
    if (count[min] !== 0) { break; }
  }
  if (root < min) {
    root = min;
  }

  /* check for an over-subscribed or incomplete set of lengths */
  left = 1;
  for (len = 1; len <= MAXBITS; len++) {
    left <<= 1;
    left -= count[len];
    if (left < 0) {
      return -1;
    }        /* over-subscribed */
  }
  if (left > 0 && (type === CODES$1 || max !== 1)) {
    return -1;                      /* incomplete set */
  }

  /* generate offsets into symbol table for each length for sorting */
  offs[1] = 0;
  for (len = 1; len < MAXBITS; len++) {
    offs[len + 1] = offs[len] + count[len];
  }

  /* sort symbols by length, by symbol order within each length */
  for (sym = 0; sym < codes; sym++) {
    if (lens[lens_index + sym] !== 0) {
      work[offs[lens[lens_index + sym]]++] = sym;
    }
  }

  /*
   Create and fill in decoding tables.  In this loop, the table being
   filled is at next and has curr index bits.  The code being used is huff
   with length len.  That code is converted to an index by dropping drop
   bits off of the bottom.  For codes where len is less than drop + curr,
   those top drop + curr - len bits are incremented through all values to
   fill the table with replicated entries.

   root is the number of index bits for the root table.  When len exceeds
   root, sub-tables are created pointed to by the root entry with an index
   of the low root bits of huff.  This is saved in low to check for when a
   new sub-table should be started.  drop is zero when the root table is
   being filled, and drop is root when sub-tables are being filled.

   When a new sub-table is needed, it is necessary to look ahead in the
   code lengths to determine what size sub-table is needed.  The length
   counts are used for this, and so count[] is decremented as codes are
   entered in the tables.

   used keeps track of how many table entries have been allocated from the
   provided *table space.  It is checked for LENS and DIST tables against
   the constants ENOUGH_LENS and ENOUGH_DISTS to guard against changes in
   the initial root table size constants.  See the comments in inftrees.h
   for more information.

   sym increments through all symbols, and the loop terminates when
   all codes of length max, i.e. all codes, have been processed.  This
   routine permits incomplete codes, so another loop after this one fills
   in the rest of the decoding tables with invalid code markers.
   */

  /* set up for code type */
  // poor man optimization - use if-else instead of switch,
  // to avoid deopts in old v8
  if (type === CODES$1) {
    base = extra = work;    /* dummy value--not used */
    match = 20;

  } else if (type === LENS$1) {
    base = lbase;
    extra = lext;
    match = 257;

  } else {                    /* DISTS */
    base = dbase;
    extra = dext;
    match = 0;
  }

  /* initialize opts for loop */
  huff = 0;                   /* starting code */
  sym = 0;                    /* starting code symbol */
  len = min;                  /* starting code length */
  next = table_index;              /* current table to fill in */
  curr = root;                /* current table index bits */
  drop = 0;                   /* current bits to drop from code for index */
  low = -1;                   /* trigger new sub-table when len > root */
  used = 1 << root;          /* use root table entries */
  mask = used - 1;            /* mask for comparing low */

  /* check available table space */
  if ((type === LENS$1 && used > ENOUGH_LENS$1) ||
    (type === DISTS$1 && used > ENOUGH_DISTS$1)) {
    return 1;
  }

  /* process all codes and make table entries */
  for (;;) {
    /* create table entry */
    here_bits = len - drop;
    if (work[sym] + 1 < match) {
      here_op = 0;
      here_val = work[sym];
    }
    else if (work[sym] >= match) {
      here_op = extra[work[sym] - match];
      here_val = base[work[sym] - match];
    }
    else {
      here_op = 32 + 64;         /* end of block */
      here_val = 0;
    }

    /* replicate for those indices with low len bits equal to huff */
    incr = 1 << (len - drop);
    fill = 1 << curr;
    min = fill;                 /* save offset to next table */
    do {
      fill -= incr;
      table[next + (huff >> drop) + fill] = (here_bits << 24) | (here_op << 16) | here_val |0;
    } while (fill !== 0);

    /* backwards increment the len-bit code huff */
    incr = 1 << (len - 1);
    while (huff & incr) {
      incr >>= 1;
    }
    if (incr !== 0) {
      huff &= incr - 1;
      huff += incr;
    } else {
      huff = 0;
    }

    /* go to next symbol, update count, len */
    sym++;
    if (--count[len] === 0) {
      if (len === max) { break; }
      len = lens[lens_index + work[sym]];
    }

    /* create new sub-table if needed */
    if (len > root && (huff & mask) !== low) {
      /* if first time, transition to sub-tables */
      if (drop === 0) {
        drop = root;
      }

      /* increment past last table */
      next += min;            /* here min is 1 << curr */

      /* determine length of next table */
      curr = len - drop;
      left = 1 << curr;
      while (curr + drop < max) {
        left -= count[curr + drop];
        if (left <= 0) { break; }
        curr++;
        left <<= 1;
      }

      /* check for enough space */
      used += 1 << curr;
      if ((type === LENS$1 && used > ENOUGH_LENS$1) ||
        (type === DISTS$1 && used > ENOUGH_DISTS$1)) {
        return 1;
      }

      /* point entry in root table to sub-table */
      low = huff & mask;
      /*table.op[low] = curr;
      table.bits[low] = root;
      table.val[low] = next - opts.table_index;*/
      table[low] = (root << 24) | (curr << 16) | (next - table_index) |0;
    }
  }

  /* fill in remaining table entry if code is incomplete (guaranteed to have
   at most one remaining entry, since if the code is incomplete, the
   maximum code length that was allowed to get this far is one bit) */
  if (huff !== 0) {
    //table.op[next + huff] = 64;            /* invalid code marker */
    //table.bits[next + huff] = len - drop;
    //table.val[next + huff] = 0;
    table[next + huff] = ((len - drop) << 24) | (64 << 16) |0;
  }

  /* set return parameters */
  //opts.table_index += used;
  opts.bits = root;
  return 0;
};


var inftrees = inflate_table;

// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.






const CODES = 0;
const LENS = 1;
const DISTS = 2;

/* Public constants ==========================================================*/
/* ===========================================================================*/

const {
  Z_FINISH: Z_FINISH$1, Z_BLOCK, Z_TREES,
  Z_OK: Z_OK$1, Z_STREAM_END: Z_STREAM_END$1, Z_NEED_DICT: Z_NEED_DICT$1, Z_STREAM_ERROR: Z_STREAM_ERROR$1, Z_DATA_ERROR: Z_DATA_ERROR$1, Z_MEM_ERROR: Z_MEM_ERROR$1, Z_BUF_ERROR,
  Z_DEFLATED
} = constants$2;


/* STATES ====================================================================*/
/* ===========================================================================*/


const    HEAD = 16180;       /* i: waiting for magic header */
const    FLAGS = 16181;      /* i: waiting for method and flags (gzip) */
const    TIME = 16182;       /* i: waiting for modification time (gzip) */
const    OS = 16183;         /* i: waiting for extra flags and operating system (gzip) */
const    EXLEN = 16184;      /* i: waiting for extra length (gzip) */
const    EXTRA = 16185;      /* i: waiting for extra bytes (gzip) */
const    NAME$1 = 16186;       /* i: waiting for end of file name (gzip) */
const    COMMENT = 16187;    /* i: waiting for end of comment (gzip) */
const    HCRC = 16188;       /* i: waiting for header crc (gzip) */
const    DICTID = 16189;    /* i: waiting for dictionary check value */
const    DICT = 16190;      /* waiting for inflateSetDictionary() call */
const        TYPE = 16191;      /* i: waiting for type bits, including last-flag bit */
const        TYPEDO = 16192;    /* i: same, but skip check to exit inflate on new block */
const        STORED = 16193;    /* i: waiting for stored size (length and complement) */
const        COPY_ = 16194;     /* i/o: same as COPY below, but only first time in */
const        COPY = 16195;      /* i/o: waiting for input or output to copy stored block */
const        TABLE = 16196;     /* i: waiting for dynamic block table lengths */
const        LENLENS = 16197;   /* i: waiting for code length code lengths */
const        CODELENS = 16198;  /* i: waiting for length/lit and distance code lengths */
const            LEN_ = 16199;      /* i: same as LEN below, but only first time in */
const            LEN = 16200;       /* i: waiting for length/lit/eob code */
const            LENEXT = 16201;    /* i: waiting for length extra bits */
const            DIST = 16202;      /* i: waiting for distance code */
const            DISTEXT = 16203;   /* i: waiting for distance extra bits */
const            MATCH = 16204;     /* o: waiting for output space to copy string */
const            LIT = 16205;       /* o: waiting for output space to write literal */
const    CHECK = 16206;     /* i: waiting for 32-bit check value */
const    LENGTH$1 = 16207;    /* i: waiting for 32-bit length (gzip) */
const    DONE$1 = 16208;      /* finished check, done -- remain here until reset */
const    BAD = 16209;       /* got a data error -- remain here until reset */
const    MEM = 16210;       /* got an inflate() memory error -- remain here until reset */
const    SYNC = 16211;      /* looking for synchronization bytes to restart inflate() */

/* ===========================================================================*/



const ENOUGH_LENS = 852;
const ENOUGH_DISTS = 592;
//const ENOUGH =  (ENOUGH_LENS+ENOUGH_DISTS);

const MAX_WBITS = 15;
/* 32K LZ77 window */
const DEF_WBITS = MAX_WBITS;


const zswap32 = (q) => {

  return  (((q >>> 24) & 0xff) +
          ((q >>> 8) & 0xff00) +
          ((q & 0xff00) << 8) +
          ((q & 0xff) << 24));
};


function InflateState() {
  this.strm = null;           /* pointer back to this zlib stream */
  this.mode = 0;              /* current inflate mode */
  this.last = false;          /* true if processing last block */
  this.wrap = 0;              /* bit 0 true for zlib, bit 1 true for gzip,
                                 bit 2 true to validate check value */
  this.havedict = false;      /* true if dictionary provided */
  this.flags = 0;             /* gzip header method and flags (0 if zlib), or
                                 -1 if raw or no header yet */
  this.dmax = 0;              /* zlib header max distance (INFLATE_STRICT) */
  this.check = 0;             /* protected copy of check value */
  this.total = 0;             /* protected copy of output count */
  // TODO: may be {}
  this.head = null;           /* where to save gzip header information */

  /* sliding window */
  this.wbits = 0;             /* log base 2 of requested window size */
  this.wsize = 0;             /* window size or zero if not using window */
  this.whave = 0;             /* valid bytes in the window */
  this.wnext = 0;             /* window write index */
  this.window = null;         /* allocated sliding window, if needed */

  /* bit accumulator */
  this.hold = 0;              /* input bit accumulator */
  this.bits = 0;              /* number of bits in "in" */

  /* for string and stored block copying */
  this.length = 0;            /* literal or length of data to copy */
  this.offset = 0;            /* distance back to copy string from */

  /* for table and code decoding */
  this.extra = 0;             /* extra bits needed */

  /* fixed and dynamic code tables */
  this.lencode = null;          /* starting table for length/literal codes */
  this.distcode = null;         /* starting table for distance codes */
  this.lenbits = 0;           /* index bits for lencode */
  this.distbits = 0;          /* index bits for distcode */

  /* dynamic table building */
  this.ncode = 0;             /* number of code length code lengths */
  this.nlen = 0;              /* number of length code lengths */
  this.ndist = 0;             /* number of distance code lengths */
  this.have = 0;              /* number of code lengths in lens[] */
  this.next = null;              /* next available space in codes[] */

  this.lens = new Uint16Array(320); /* temporary storage for code lengths */
  this.work = new Uint16Array(288); /* work area for code table building */

  /*
   because we don't have pointers in js, we use lencode and distcode directly
   as buffers so we don't need codes
  */
  //this.codes = new Int32Array(ENOUGH);       /* space for code tables */
  this.lendyn = null;              /* dynamic table for length/literal codes (JS specific) */
  this.distdyn = null;             /* dynamic table for distance codes (JS specific) */
  this.sane = 0;                   /* if false, allow invalid distance too far */
  this.back = 0;                   /* bits back of last unprocessed length/lit */
  this.was = 0;                    /* initial length of match */
}


const inflateStateCheck = (strm) => {

  if (!strm) {
    return 1;
  }
  const state = strm.state;
  if (!state || state.strm !== strm ||
    state.mode < HEAD || state.mode > SYNC) {
    return 1;
  }
  return 0;
};


const inflateResetKeep = (strm) => {

  if (inflateStateCheck(strm)) { return Z_STREAM_ERROR$1; }
  const state = strm.state;
  strm.total_in = strm.total_out = state.total = 0;
  strm.msg = ''; /*Z_NULL*/
  if (state.wrap) {       /* to support ill-conceived Java test suite */
    strm.adler = state.wrap & 1;
  }
  state.mode = HEAD;
  state.last = 0;
  state.havedict = 0;
  state.flags = -1;
  state.dmax = 32768;
  state.head = null/*Z_NULL*/;
  state.hold = 0;
  state.bits = 0;
  //state.lencode = state.distcode = state.next = state.codes;
  state.lencode = state.lendyn = new Int32Array(ENOUGH_LENS);
  state.distcode = state.distdyn = new Int32Array(ENOUGH_DISTS);

  state.sane = 1;
  state.back = -1;
  //Tracev((stderr, "inflate: reset\n"));
  return Z_OK$1;
};


const inflateReset = (strm) => {

  if (inflateStateCheck(strm)) { return Z_STREAM_ERROR$1; }
  const state = strm.state;
  state.wsize = 0;
  state.whave = 0;
  state.wnext = 0;
  return inflateResetKeep(strm);

};


const inflateReset2 = (strm, windowBits) => {
  let wrap;

  /* get the state */
  if (inflateStateCheck(strm)) { return Z_STREAM_ERROR$1; }
  const state = strm.state;

  /* extract wrap request from windowBits parameter */
  if (windowBits < 0) {
    wrap = 0;
    windowBits = -windowBits;
  }
  else {
    wrap = (windowBits >> 4) + 5;
    if (windowBits < 48) {
      windowBits &= 15;
    }
  }

  /* set number of window bits, free window if different */
  if (windowBits && (windowBits < 8 || windowBits > 15)) {
    return Z_STREAM_ERROR$1;
  }
  if (state.window !== null && state.wbits !== windowBits) {
    state.window = null;
  }

  /* update state and reset the rest of it */
  state.wrap = wrap;
  state.wbits = windowBits;
  return inflateReset(strm);
};


const inflateInit2 = (strm, windowBits) => {

  if (!strm) { return Z_STREAM_ERROR$1; }
  //strm.msg = Z_NULL;                 /* in case we return an error */

  const state = new InflateState();

  //if (state === Z_NULL) return Z_MEM_ERROR;
  //Tracev((stderr, "inflate: allocated\n"));
  strm.state = state;
  state.strm = strm;
  state.window = null/*Z_NULL*/;
  state.mode = HEAD;     /* to pass state test in inflateReset2() */
  const ret = inflateReset2(strm, windowBits);
  if (ret !== Z_OK$1) {
    strm.state = null/*Z_NULL*/;
  }
  return ret;
};


const inflateInit = (strm) => {

  return inflateInit2(strm, DEF_WBITS);
};


/*
 Return state with length and distance decoding tables and index sizes set to
 fixed code decoding.  Normally this returns fixed tables from inffixed.h.
 If BUILDFIXED is defined, then instead this routine builds the tables the
 first time it's called, and returns those tables the first time and
 thereafter.  This reduces the size of the code by about 2K bytes, in
 exchange for a little execution time.  However, BUILDFIXED should not be
 used for threaded applications, since the rewriting of the tables and virgin
 may not be thread-safe.
 */
let virgin = true;

let lenfix, distfix; // We have no pointers in JS, so keep tables separate


const fixedtables = (state) => {

  /* build fixed huffman tables if first call (may not be thread safe) */
  if (virgin) {
    lenfix = new Int32Array(512);
    distfix = new Int32Array(32);

    /* literal/length table */
    let sym = 0;
    while (sym < 144) { state.lens[sym++] = 8; }
    while (sym < 256) { state.lens[sym++] = 9; }
    while (sym < 280) { state.lens[sym++] = 7; }
    while (sym < 288) { state.lens[sym++] = 8; }

    inftrees(LENS,  state.lens, 0, 288, lenfix,   0, state.work, { bits: 9 });

    /* distance table */
    sym = 0;
    while (sym < 32) { state.lens[sym++] = 5; }

    inftrees(DISTS, state.lens, 0, 32,   distfix, 0, state.work, { bits: 5 });

    /* do this just once */
    virgin = false;
  }

  state.lencode = lenfix;
  state.lenbits = 9;
  state.distcode = distfix;
  state.distbits = 5;
};


/*
 Update the window with the last wsize (normally 32K) bytes written before
 returning.  If window does not exist yet, create it.  This is only called
 when a window is already in use, or when output has been written during this
 inflate call, but the end of the deflate stream has not been reached yet.
 It is also called to create a window for dictionary data when a dictionary
 is loaded.

 Providing output buffers larger than 32K to inflate() should provide a speed
 advantage, since only the last 32K of output is copied to the sliding window
 upon return from inflate(), and since all distances after the first 32K of
 output will fall in the output data, making match copies simpler and faster.
 The advantage may be dependent on the size of the processor's data caches.
 */
const updatewindow = (strm, src, end, copy) => {

  let dist;
  const state = strm.state;

  /* if it hasn't been done already, allocate space for the window */
  if (state.window === null) {
    state.wsize = 1 << state.wbits;
    state.wnext = 0;
    state.whave = 0;

    state.window = new Uint8Array(state.wsize);
  }

  /* copy state->wsize or less output bytes into the circular window */
  if (copy >= state.wsize) {
    state.window.set(src.subarray(end - state.wsize, end), 0);
    state.wnext = 0;
    state.whave = state.wsize;
  }
  else {
    dist = state.wsize - state.wnext;
    if (dist > copy) {
      dist = copy;
    }
    //zmemcpy(state->window + state->wnext, end - copy, dist);
    state.window.set(src.subarray(end - copy, end - copy + dist), state.wnext);
    copy -= dist;
    if (copy) {
      //zmemcpy(state->window, end - copy, copy);
      state.window.set(src.subarray(end - copy, end), 0);
      state.wnext = copy;
      state.whave = state.wsize;
    }
    else {
      state.wnext += dist;
      if (state.wnext === state.wsize) { state.wnext = 0; }
      if (state.whave < state.wsize) { state.whave += dist; }
    }
  }
  return 0;
};


const inflate$2 = (strm, flush) => {

  let state;
  let input, output;          // input/output buffers
  let next;                   /* next input INDEX */
  let put;                    /* next output INDEX */
  let have, left;             /* available input and output */
  let hold;                   /* bit buffer */
  let bits;                   /* bits in bit buffer */
  let _in, _out;              /* save starting available input and output */
  let copy;                   /* number of stored or match bytes to copy */
  let from;                   /* where to copy match bytes from */
  let from_source;
  let here = 0;               /* current decoding table entry */
  let here_bits, here_op, here_val; // paked "here" denormalized (JS specific)
  //let last;                   /* parent table entry */
  let last_bits, last_op, last_val; // paked "last" denormalized (JS specific)
  let len;                    /* length to copy for repeats, bits to drop */
  let ret;                    /* return code */
  const hbuf = new Uint8Array(4);    /* buffer for gzip header crc calculation */
  let opts;

  let n; // temporary variable for NEED_BITS

  const order = /* permutation of code lengths */
    new Uint8Array([ 16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15 ]);


  if (inflateStateCheck(strm) || !strm.output ||
      (!strm.input && strm.avail_in !== 0)) {
    return Z_STREAM_ERROR$1;
  }

  state = strm.state;
  if (state.mode === TYPE) { state.mode = TYPEDO; }    /* skip check */


  //--- LOAD() ---
  put = strm.next_out;
  output = strm.output;
  left = strm.avail_out;
  next = strm.next_in;
  input = strm.input;
  have = strm.avail_in;
  hold = state.hold;
  bits = state.bits;
  //---

  _in = have;
  _out = left;
  ret = Z_OK$1;

  inf_leave: // goto emulation
  for (;;) {
    switch (state.mode) {
      case HEAD:
        if (state.wrap === 0) {
          state.mode = TYPEDO;
          break;
        }
        //=== NEEDBITS(16);
        while (bits < 16) {
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
        }
        //===//
        if ((state.wrap & 2) && hold === 0x8b1f) {  /* gzip header */
          if (state.wbits === 0) {
            state.wbits = 15;
          }
          state.check = 0/*crc32(0L, Z_NULL, 0)*/;
          //=== CRC2(state.check, hold);
          hbuf[0] = hold & 0xff;
          hbuf[1] = (hold >>> 8) & 0xff;
          state.check = crc32_1(state.check, hbuf, 2, 0);
          //===//

          //=== INITBITS();
          hold = 0;
          bits = 0;
          //===//
          state.mode = FLAGS;
          break;
        }
        if (state.head) {
          state.head.done = false;
        }
        if (!(state.wrap & 1) ||   /* check if zlib header allowed */
          (((hold & 0xff)/*BITS(8)*/ << 8) + (hold >> 8)) % 31) {
          strm.msg = 'incorrect header check';
          state.mode = BAD;
          break;
        }
        if ((hold & 0x0f)/*BITS(4)*/ !== Z_DEFLATED) {
          strm.msg = 'unknown compression method';
          state.mode = BAD;
          break;
        }
        //--- DROPBITS(4) ---//
        hold >>>= 4;
        bits -= 4;
        //---//
        len = (hold & 0x0f)/*BITS(4)*/ + 8;
        if (state.wbits === 0) {
          state.wbits = len;
        }
        if (len > 15 || len > state.wbits) {
          strm.msg = 'invalid window size';
          state.mode = BAD;
          break;
        }

        // !!! pako patch. Force use `options.windowBits` if passed.
        // Required to always use max window size by default.
        state.dmax = 1 << state.wbits;
        //state.dmax = 1 << len;

        state.flags = 0;               /* indicate zlib header */
        //Tracev((stderr, "inflate:   zlib header ok\n"));
        strm.adler = state.check = 1/*adler32(0L, Z_NULL, 0)*/;
        state.mode = hold & 0x200 ? DICTID : TYPE;
        //=== INITBITS();
        hold = 0;
        bits = 0;
        //===//
        break;
      case FLAGS:
        //=== NEEDBITS(16); */
        while (bits < 16) {
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
        }
        //===//
        state.flags = hold;
        if ((state.flags & 0xff) !== Z_DEFLATED) {
          strm.msg = 'unknown compression method';
          state.mode = BAD;
          break;
        }
        if (state.flags & 0xe000) {
          strm.msg = 'unknown header flags set';
          state.mode = BAD;
          break;
        }
        if (state.head) {
          state.head.text = ((hold >> 8) & 1);
        }
        if ((state.flags & 0x0200) && (state.wrap & 4)) {
          //=== CRC2(state.check, hold);
          hbuf[0] = hold & 0xff;
          hbuf[1] = (hold >>> 8) & 0xff;
          state.check = crc32_1(state.check, hbuf, 2, 0);
          //===//
        }
        //=== INITBITS();
        hold = 0;
        bits = 0;
        //===//
        state.mode = TIME;
        /* falls through */
      case TIME:
        //=== NEEDBITS(32); */
        while (bits < 32) {
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
        }
        //===//
        if (state.head) {
          state.head.time = hold;
        }
        if ((state.flags & 0x0200) && (state.wrap & 4)) {
          //=== CRC4(state.check, hold)
          hbuf[0] = hold & 0xff;
          hbuf[1] = (hold >>> 8) & 0xff;
          hbuf[2] = (hold >>> 16) & 0xff;
          hbuf[3] = (hold >>> 24) & 0xff;
          state.check = crc32_1(state.check, hbuf, 4, 0);
          //===
        }
        //=== INITBITS();
        hold = 0;
        bits = 0;
        //===//
        state.mode = OS;
        /* falls through */
      case OS:
        //=== NEEDBITS(16); */
        while (bits < 16) {
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
        }
        //===//
        if (state.head) {
          state.head.xflags = (hold & 0xff);
          state.head.os = (hold >> 8);
        }
        if ((state.flags & 0x0200) && (state.wrap & 4)) {
          //=== CRC2(state.check, hold);
          hbuf[0] = hold & 0xff;
          hbuf[1] = (hold >>> 8) & 0xff;
          state.check = crc32_1(state.check, hbuf, 2, 0);
          //===//
        }
        //=== INITBITS();
        hold = 0;
        bits = 0;
        //===//
        state.mode = EXLEN;
        /* falls through */
      case EXLEN:
        if (state.flags & 0x0400) {
          //=== NEEDBITS(16); */
          while (bits < 16) {
            if (have === 0) { break inf_leave; }
            have--;
            hold += input[next++] << bits;
            bits += 8;
          }
          //===//
          state.length = hold;
          if (state.head) {
            state.head.extra_len = hold;
          }
          if ((state.flags & 0x0200) && (state.wrap & 4)) {
            //=== CRC2(state.check, hold);
            hbuf[0] = hold & 0xff;
            hbuf[1] = (hold >>> 8) & 0xff;
            state.check = crc32_1(state.check, hbuf, 2, 0);
            //===//
          }
          //=== INITBITS();
          hold = 0;
          bits = 0;
          //===//
        }
        else if (state.head) {
          state.head.extra = null/*Z_NULL*/;
        }
        state.mode = EXTRA;
        /* falls through */
      case EXTRA:
        if (state.flags & 0x0400) {
          copy = state.length;
          if (copy > have) { copy = have; }
          if (copy) {
            if (state.head) {
              len = state.head.extra_len - state.length;
              if (!state.head.extra) {
                // Use untyped array for more convenient processing later
                state.head.extra = new Uint8Array(state.head.extra_len);
              }
              state.head.extra.set(
                input.subarray(
                  next,
                  // extra field is limited to 65536 bytes
                  // - no need for additional size check
                  next + copy
                ),
                /*len + copy > state.head.extra_max - len ? state.head.extra_max : copy,*/
                len
              );
              //zmemcpy(state.head.extra + len, next,
              //        len + copy > state.head.extra_max ?
              //        state.head.extra_max - len : copy);
            }
            if ((state.flags & 0x0200) && (state.wrap & 4)) {
              state.check = crc32_1(state.check, input, copy, next);
            }
            have -= copy;
            next += copy;
            state.length -= copy;
          }
          if (state.length) { break inf_leave; }
        }
        state.length = 0;
        state.mode = NAME$1;
        /* falls through */
      case NAME$1:
        if (state.flags & 0x0800) {
          if (have === 0) { break inf_leave; }
          copy = 0;
          do {
            // TODO: 2 or 1 bytes?
            len = input[next + copy++];
            /* use constant limit because in js we should not preallocate memory */
            if (state.head && len &&
                (state.length < 65536 /*state.head.name_max*/)) {
              state.head.name += String.fromCharCode(len);
            }
          } while (len && copy < have);

          if ((state.flags & 0x0200) && (state.wrap & 4)) {
            state.check = crc32_1(state.check, input, copy, next);
          }
          have -= copy;
          next += copy;
          if (len) { break inf_leave; }
        }
        else if (state.head) {
          state.head.name = null;
        }
        state.length = 0;
        state.mode = COMMENT;
        /* falls through */
      case COMMENT:
        if (state.flags & 0x1000) {
          if (have === 0) { break inf_leave; }
          copy = 0;
          do {
            len = input[next + copy++];
            /* use constant limit because in js we should not preallocate memory */
            if (state.head && len &&
                (state.length < 65536 /*state.head.comm_max*/)) {
              state.head.comment += String.fromCharCode(len);
            }
          } while (len && copy < have);
          if ((state.flags & 0x0200) && (state.wrap & 4)) {
            state.check = crc32_1(state.check, input, copy, next);
          }
          have -= copy;
          next += copy;
          if (len) { break inf_leave; }
        }
        else if (state.head) {
          state.head.comment = null;
        }
        state.mode = HCRC;
        /* falls through */
      case HCRC:
        if (state.flags & 0x0200) {
          //=== NEEDBITS(16); */
          while (bits < 16) {
            if (have === 0) { break inf_leave; }
            have--;
            hold += input[next++] << bits;
            bits += 8;
          }
          //===//
          if ((state.wrap & 4) && hold !== (state.check & 0xffff)) {
            strm.msg = 'header crc mismatch';
            state.mode = BAD;
            break;
          }
          //=== INITBITS();
          hold = 0;
          bits = 0;
          //===//
        }
        if (state.head) {
          state.head.hcrc = ((state.flags >> 9) & 1);
          state.head.done = true;
        }
        strm.adler = state.check = 0;
        state.mode = TYPE;
        break;
      case DICTID:
        //=== NEEDBITS(32); */
        while (bits < 32) {
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
        }
        //===//
        strm.adler = state.check = zswap32(hold);
        //=== INITBITS();
        hold = 0;
        bits = 0;
        //===//
        state.mode = DICT;
        /* falls through */
      case DICT:
        if (state.havedict === 0) {
          //--- RESTORE() ---
          strm.next_out = put;
          strm.avail_out = left;
          strm.next_in = next;
          strm.avail_in = have;
          state.hold = hold;
          state.bits = bits;
          //---
          return Z_NEED_DICT$1;
        }
        strm.adler = state.check = 1/*adler32(0L, Z_NULL, 0)*/;
        state.mode = TYPE;
        /* falls through */
      case TYPE:
        if (flush === Z_BLOCK || flush === Z_TREES) { break inf_leave; }
        /* falls through */
      case TYPEDO:
        if (state.last) {
          //--- BYTEBITS() ---//
          hold >>>= bits & 7;
          bits -= bits & 7;
          //---//
          state.mode = CHECK;
          break;
        }
        //=== NEEDBITS(3); */
        while (bits < 3) {
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
        }
        //===//
        state.last = (hold & 0x01)/*BITS(1)*/;
        //--- DROPBITS(1) ---//
        hold >>>= 1;
        bits -= 1;
        //---//

        switch ((hold & 0x03)/*BITS(2)*/) {
          case 0:                             /* stored block */
            //Tracev((stderr, "inflate:     stored block%s\n",
            //        state.last ? " (last)" : ""));
            state.mode = STORED;
            break;
          case 1:                             /* fixed block */
            fixedtables(state);
            //Tracev((stderr, "inflate:     fixed codes block%s\n",
            //        state.last ? " (last)" : ""));
            state.mode = LEN_;             /* decode codes */
            if (flush === Z_TREES) {
              //--- DROPBITS(2) ---//
              hold >>>= 2;
              bits -= 2;
              //---//
              break inf_leave;
            }
            break;
          case 2:                             /* dynamic block */
            //Tracev((stderr, "inflate:     dynamic codes block%s\n",
            //        state.last ? " (last)" : ""));
            state.mode = TABLE;
            break;
          case 3:
            strm.msg = 'invalid block type';
            state.mode = BAD;
        }
        //--- DROPBITS(2) ---//
        hold >>>= 2;
        bits -= 2;
        //---//
        break;
      case STORED:
        //--- BYTEBITS() ---// /* go to byte boundary */
        hold >>>= bits & 7;
        bits -= bits & 7;
        //---//
        //=== NEEDBITS(32); */
        while (bits < 32) {
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
        }
        //===//
        if ((hold & 0xffff) !== ((hold >>> 16) ^ 0xffff)) {
          strm.msg = 'invalid stored block lengths';
          state.mode = BAD;
          break;
        }
        state.length = hold & 0xffff;
        //Tracev((stderr, "inflate:       stored length %u\n",
        //        state.length));
        //=== INITBITS();
        hold = 0;
        bits = 0;
        //===//
        state.mode = COPY_;
        if (flush === Z_TREES) { break inf_leave; }
        /* falls through */
      case COPY_:
        state.mode = COPY;
        /* falls through */
      case COPY:
        copy = state.length;
        if (copy) {
          if (copy > have) { copy = have; }
          if (copy > left) { copy = left; }
          if (copy === 0) { break inf_leave; }
          //--- zmemcpy(put, next, copy); ---
          output.set(input.subarray(next, next + copy), put);
          //---//
          have -= copy;
          next += copy;
          left -= copy;
          put += copy;
          state.length -= copy;
          break;
        }
        //Tracev((stderr, "inflate:       stored end\n"));
        state.mode = TYPE;
        break;
      case TABLE:
        //=== NEEDBITS(14); */
        while (bits < 14) {
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
        }
        //===//
        state.nlen = (hold & 0x1f)/*BITS(5)*/ + 257;
        //--- DROPBITS(5) ---//
        hold >>>= 5;
        bits -= 5;
        //---//
        state.ndist = (hold & 0x1f)/*BITS(5)*/ + 1;
        //--- DROPBITS(5) ---//
        hold >>>= 5;
        bits -= 5;
        //---//
        state.ncode = (hold & 0x0f)/*BITS(4)*/ + 4;
        //--- DROPBITS(4) ---//
        hold >>>= 4;
        bits -= 4;
        //---//
//#ifndef PKZIP_BUG_WORKAROUND
        if (state.nlen > 286 || state.ndist > 30) {
          strm.msg = 'too many length or distance symbols';
          state.mode = BAD;
          break;
        }
//#endif
        //Tracev((stderr, "inflate:       table sizes ok\n"));
        state.have = 0;
        state.mode = LENLENS;
        /* falls through */
      case LENLENS:
        while (state.have < state.ncode) {
          //=== NEEDBITS(3);
          while (bits < 3) {
            if (have === 0) { break inf_leave; }
            have--;
            hold += input[next++] << bits;
            bits += 8;
          }
          //===//
          state.lens[order[state.have++]] = (hold & 0x07);//BITS(3);
          //--- DROPBITS(3) ---//
          hold >>>= 3;
          bits -= 3;
          //---//
        }
        while (state.have < 19) {
          state.lens[order[state.have++]] = 0;
        }
        // We have separate tables & no pointers. 2 commented lines below not needed.
        //state.next = state.codes;
        //state.lencode = state.next;
        // Switch to use dynamic table
        state.lencode = state.lendyn;
        state.lenbits = 7;

        opts = { bits: state.lenbits };
        ret = inftrees(CODES, state.lens, 0, 19, state.lencode, 0, state.work, opts);
        state.lenbits = opts.bits;

        if (ret) {
          strm.msg = 'invalid code lengths set';
          state.mode = BAD;
          break;
        }
        //Tracev((stderr, "inflate:       code lengths ok\n"));
        state.have = 0;
        state.mode = CODELENS;
        /* falls through */
      case CODELENS:
        while (state.have < state.nlen + state.ndist) {
          for (;;) {
            here = state.lencode[hold & ((1 << state.lenbits) - 1)];/*BITS(state.lenbits)*/
            here_bits = here >>> 24;
            here_op = (here >>> 16) & 0xff;
            here_val = here & 0xffff;

            if ((here_bits) <= bits) { break; }
            //--- PULLBYTE() ---//
            if (have === 0) { break inf_leave; }
            have--;
            hold += input[next++] << bits;
            bits += 8;
            //---//
          }
          if (here_val < 16) {
            //--- DROPBITS(here.bits) ---//
            hold >>>= here_bits;
            bits -= here_bits;
            //---//
            state.lens[state.have++] = here_val;
          }
          else {
            if (here_val === 16) {
              //=== NEEDBITS(here.bits + 2);
              n = here_bits + 2;
              while (bits < n) {
                if (have === 0) { break inf_leave; }
                have--;
                hold += input[next++] << bits;
                bits += 8;
              }
              //===//
              //--- DROPBITS(here.bits) ---//
              hold >>>= here_bits;
              bits -= here_bits;
              //---//
              if (state.have === 0) {
                strm.msg = 'invalid bit length repeat';
                state.mode = BAD;
                break;
              }
              len = state.lens[state.have - 1];
              copy = 3 + (hold & 0x03);//BITS(2);
              //--- DROPBITS(2) ---//
              hold >>>= 2;
              bits -= 2;
              //---//
            }
            else if (here_val === 17) {
              //=== NEEDBITS(here.bits + 3);
              n = here_bits + 3;
              while (bits < n) {
                if (have === 0) { break inf_leave; }
                have--;
                hold += input[next++] << bits;
                bits += 8;
              }
              //===//
              //--- DROPBITS(here.bits) ---//
              hold >>>= here_bits;
              bits -= here_bits;
              //---//
              len = 0;
              copy = 3 + (hold & 0x07);//BITS(3);
              //--- DROPBITS(3) ---//
              hold >>>= 3;
              bits -= 3;
              //---//
            }
            else {
              //=== NEEDBITS(here.bits + 7);
              n = here_bits + 7;
              while (bits < n) {
                if (have === 0) { break inf_leave; }
                have--;
                hold += input[next++] << bits;
                bits += 8;
              }
              //===//
              //--- DROPBITS(here.bits) ---//
              hold >>>= here_bits;
              bits -= here_bits;
              //---//
              len = 0;
              copy = 11 + (hold & 0x7f);//BITS(7);
              //--- DROPBITS(7) ---//
              hold >>>= 7;
              bits -= 7;
              //---//
            }
            if (state.have + copy > state.nlen + state.ndist) {
              strm.msg = 'invalid bit length repeat';
              state.mode = BAD;
              break;
            }
            while (copy--) {
              state.lens[state.have++] = len;
            }
          }
        }

        /* handle error breaks in while */
        if (state.mode === BAD) { break; }

        /* check for end-of-block code (better have one) */
        if (state.lens[256] === 0) {
          strm.msg = 'invalid code -- missing end-of-block';
          state.mode = BAD;
          break;
        }

        /* build code tables -- note: do not change the lenbits or distbits
           values here (9 and 6) without reading the comments in inftrees.h
           concerning the ENOUGH constants, which depend on those values */
        state.lenbits = 9;

        opts = { bits: state.lenbits };
        ret = inftrees(LENS, state.lens, 0, state.nlen, state.lencode, 0, state.work, opts);
        // We have separate tables & no pointers. 2 commented lines below not needed.
        // state.next_index = opts.table_index;
        state.lenbits = opts.bits;
        // state.lencode = state.next;

        if (ret) {
          strm.msg = 'invalid literal/lengths set';
          state.mode = BAD;
          break;
        }

        state.distbits = 6;
        //state.distcode.copy(state.codes);
        // Switch to use dynamic table
        state.distcode = state.distdyn;
        opts = { bits: state.distbits };
        ret = inftrees(DISTS, state.lens, state.nlen, state.ndist, state.distcode, 0, state.work, opts);
        // We have separate tables & no pointers. 2 commented lines below not needed.
        // state.next_index = opts.table_index;
        state.distbits = opts.bits;
        // state.distcode = state.next;

        if (ret) {
          strm.msg = 'invalid distances set';
          state.mode = BAD;
          break;
        }
        //Tracev((stderr, 'inflate:       codes ok\n'));
        state.mode = LEN_;
        if (flush === Z_TREES) { break inf_leave; }
        /* falls through */
      case LEN_:
        state.mode = LEN;
        /* falls through */
      case LEN:
        if (have >= 6 && left >= 258) {
          //--- RESTORE() ---
          strm.next_out = put;
          strm.avail_out = left;
          strm.next_in = next;
          strm.avail_in = have;
          state.hold = hold;
          state.bits = bits;
          //---
          inffast(strm, _out);
          //--- LOAD() ---
          put = strm.next_out;
          output = strm.output;
          left = strm.avail_out;
          next = strm.next_in;
          input = strm.input;
          have = strm.avail_in;
          hold = state.hold;
          bits = state.bits;
          //---

          if (state.mode === TYPE) {
            state.back = -1;
          }
          break;
        }
        state.back = 0;
        for (;;) {
          here = state.lencode[hold & ((1 << state.lenbits) - 1)];  /*BITS(state.lenbits)*/
          here_bits = here >>> 24;
          here_op = (here >>> 16) & 0xff;
          here_val = here & 0xffff;

          if (here_bits <= bits) { break; }
          //--- PULLBYTE() ---//
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
          //---//
        }
        if (here_op && (here_op & 0xf0) === 0) {
          last_bits = here_bits;
          last_op = here_op;
          last_val = here_val;
          for (;;) {
            here = state.lencode[last_val +
                    ((hold & ((1 << (last_bits + last_op)) - 1))/*BITS(last.bits + last.op)*/ >> last_bits)];
            here_bits = here >>> 24;
            here_op = (here >>> 16) & 0xff;
            here_val = here & 0xffff;

            if ((last_bits + here_bits) <= bits) { break; }
            //--- PULLBYTE() ---//
            if (have === 0) { break inf_leave; }
            have--;
            hold += input[next++] << bits;
            bits += 8;
            //---//
          }
          //--- DROPBITS(last.bits) ---//
          hold >>>= last_bits;
          bits -= last_bits;
          //---//
          state.back += last_bits;
        }
        //--- DROPBITS(here.bits) ---//
        hold >>>= here_bits;
        bits -= here_bits;
        //---//
        state.back += here_bits;
        state.length = here_val;
        if (here_op === 0) {
          //Tracevv((stderr, here.val >= 0x20 && here.val < 0x7f ?
          //        "inflate:         literal '%c'\n" :
          //        "inflate:         literal 0x%02x\n", here.val));
          state.mode = LIT;
          break;
        }
        if (here_op & 32) {
          //Tracevv((stderr, "inflate:         end of block\n"));
          state.back = -1;
          state.mode = TYPE;
          break;
        }
        if (here_op & 64) {
          strm.msg = 'invalid literal/length code';
          state.mode = BAD;
          break;
        }
        state.extra = here_op & 15;
        state.mode = LENEXT;
        /* falls through */
      case LENEXT:
        if (state.extra) {
          //=== NEEDBITS(state.extra);
          n = state.extra;
          while (bits < n) {
            if (have === 0) { break inf_leave; }
            have--;
            hold += input[next++] << bits;
            bits += 8;
          }
          //===//
          state.length += hold & ((1 << state.extra) - 1)/*BITS(state.extra)*/;
          //--- DROPBITS(state.extra) ---//
          hold >>>= state.extra;
          bits -= state.extra;
          //---//
          state.back += state.extra;
        }
        //Tracevv((stderr, "inflate:         length %u\n", state.length));
        state.was = state.length;
        state.mode = DIST;
        /* falls through */
      case DIST:
        for (;;) {
          here = state.distcode[hold & ((1 << state.distbits) - 1)];/*BITS(state.distbits)*/
          here_bits = here >>> 24;
          here_op = (here >>> 16) & 0xff;
          here_val = here & 0xffff;

          if ((here_bits) <= bits) { break; }
          //--- PULLBYTE() ---//
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
          //---//
        }
        if ((here_op & 0xf0) === 0) {
          last_bits = here_bits;
          last_op = here_op;
          last_val = here_val;
          for (;;) {
            here = state.distcode[last_val +
                    ((hold & ((1 << (last_bits + last_op)) - 1))/*BITS(last.bits + last.op)*/ >> last_bits)];
            here_bits = here >>> 24;
            here_op = (here >>> 16) & 0xff;
            here_val = here & 0xffff;

            if ((last_bits + here_bits) <= bits) { break; }
            //--- PULLBYTE() ---//
            if (have === 0) { break inf_leave; }
            have--;
            hold += input[next++] << bits;
            bits += 8;
            //---//
          }
          //--- DROPBITS(last.bits) ---//
          hold >>>= last_bits;
          bits -= last_bits;
          //---//
          state.back += last_bits;
        }
        //--- DROPBITS(here.bits) ---//
        hold >>>= here_bits;
        bits -= here_bits;
        //---//
        state.back += here_bits;
        if (here_op & 64) {
          strm.msg = 'invalid distance code';
          state.mode = BAD;
          break;
        }
        state.offset = here_val;
        state.extra = (here_op) & 15;
        state.mode = DISTEXT;
        /* falls through */
      case DISTEXT:
        if (state.extra) {
          //=== NEEDBITS(state.extra);
          n = state.extra;
          while (bits < n) {
            if (have === 0) { break inf_leave; }
            have--;
            hold += input[next++] << bits;
            bits += 8;
          }
          //===//
          state.offset += hold & ((1 << state.extra) - 1)/*BITS(state.extra)*/;
          //--- DROPBITS(state.extra) ---//
          hold >>>= state.extra;
          bits -= state.extra;
          //---//
          state.back += state.extra;
        }
//#ifdef INFLATE_STRICT
        if (state.offset > state.dmax) {
          strm.msg = 'invalid distance too far back';
          state.mode = BAD;
          break;
        }
//#endif
        //Tracevv((stderr, "inflate:         distance %u\n", state.offset));
        state.mode = MATCH;
        /* falls through */
      case MATCH:
        if (left === 0) { break inf_leave; }
        copy = _out - left;
        if (state.offset > copy) {         /* copy from window */
          copy = state.offset - copy;
          if (copy > state.whave) {
            if (state.sane) {
              strm.msg = 'invalid distance too far back';
              state.mode = BAD;
              break;
            }
// (!) This block is disabled in zlib defaults,
// don't enable it for binary compatibility
//#ifdef INFLATE_ALLOW_INVALID_DISTANCE_TOOFAR_ARRR
//          Trace((stderr, "inflate.c too far\n"));
//          copy -= state.whave;
//          if (copy > state.length) { copy = state.length; }
//          if (copy > left) { copy = left; }
//          left -= copy;
//          state.length -= copy;
//          do {
//            output[put++] = 0;
//          } while (--copy);
//          if (state.length === 0) { state.mode = LEN; }
//          break;
//#endif
          }
          if (copy > state.wnext) {
            copy -= state.wnext;
            from = state.wsize - copy;
          }
          else {
            from = state.wnext - copy;
          }
          if (copy > state.length) { copy = state.length; }
          from_source = state.window;
        }
        else {                              /* copy from output */
          from_source = output;
          from = put - state.offset;
          copy = state.length;
        }
        if (copy > left) { copy = left; }
        left -= copy;
        state.length -= copy;
        do {
          output[put++] = from_source[from++];
        } while (--copy);
        if (state.length === 0) { state.mode = LEN; }
        break;
      case LIT:
        if (left === 0) { break inf_leave; }
        output[put++] = state.length;
        left--;
        state.mode = LEN;
        break;
      case CHECK:
        if (state.wrap) {
          //=== NEEDBITS(32);
          while (bits < 32) {
            if (have === 0) { break inf_leave; }
            have--;
            // Use '|' instead of '+' to make sure that result is signed
            hold |= input[next++] << bits;
            bits += 8;
          }
          //===//
          _out -= left;
          strm.total_out += _out;
          state.total += _out;
          if ((state.wrap & 4) && _out) {
            strm.adler = state.check =
                /*UPDATE_CHECK(state.check, put - _out, _out);*/
                (state.flags ? crc32_1(state.check, output, _out, put - _out) : adler32_1(state.check, output, _out, put - _out));

          }
          _out = left;
          // NB: crc32 stored as signed 32-bit int, zswap32 returns signed too
          if ((state.wrap & 4) && (state.flags ? hold : zswap32(hold)) !== state.check) {
            strm.msg = 'incorrect data check';
            state.mode = BAD;
            break;
          }
          //=== INITBITS();
          hold = 0;
          bits = 0;
          //===//
          //Tracev((stderr, "inflate:   check matches trailer\n"));
        }
        state.mode = LENGTH$1;
        /* falls through */
      case LENGTH$1:
        if (state.wrap && state.flags) {
          //=== NEEDBITS(32);
          while (bits < 32) {
            if (have === 0) { break inf_leave; }
            have--;
            hold += input[next++] << bits;
            bits += 8;
          }
          //===//
          if ((state.wrap & 4) && hold !== (state.total & 0xffffffff)) {
            strm.msg = 'incorrect length check';
            state.mode = BAD;
            break;
          }
          //=== INITBITS();
          hold = 0;
          bits = 0;
          //===//
          //Tracev((stderr, "inflate:   length matches trailer\n"));
        }
        state.mode = DONE$1;
        /* falls through */
      case DONE$1:
        ret = Z_STREAM_END$1;
        break inf_leave;
      case BAD:
        ret = Z_DATA_ERROR$1;
        break inf_leave;
      case MEM:
        return Z_MEM_ERROR$1;
      case SYNC:
        /* falls through */
      default:
        return Z_STREAM_ERROR$1;
    }
  }

  // inf_leave <- here is real place for "goto inf_leave", emulated via "break inf_leave"

  /*
     Return from inflate(), updating the total counts and the check value.
     If there was no progress during the inflate() call, return a buffer
     error.  Call updatewindow() to create and/or update the window state.
     Note: a memory error from inflate() is non-recoverable.
   */

  //--- RESTORE() ---
  strm.next_out = put;
  strm.avail_out = left;
  strm.next_in = next;
  strm.avail_in = have;
  state.hold = hold;
  state.bits = bits;
  //---

  if (state.wsize || (_out !== strm.avail_out && state.mode < BAD &&
                      (state.mode < CHECK || flush !== Z_FINISH$1))) {
    if (updatewindow(strm, strm.output, strm.next_out, _out - strm.avail_out)) ;
  }
  _in -= strm.avail_in;
  _out -= strm.avail_out;
  strm.total_in += _in;
  strm.total_out += _out;
  state.total += _out;
  if ((state.wrap & 4) && _out) {
    strm.adler = state.check = /*UPDATE_CHECK(state.check, strm.next_out - _out, _out);*/
      (state.flags ? crc32_1(state.check, output, _out, strm.next_out - _out) : adler32_1(state.check, output, _out, strm.next_out - _out));
  }
  strm.data_type = state.bits + (state.last ? 64 : 0) +
                    (state.mode === TYPE ? 128 : 0) +
                    (state.mode === LEN_ || state.mode === COPY_ ? 256 : 0);
  if (((_in === 0 && _out === 0) || flush === Z_FINISH$1) && ret === Z_OK$1) {
    ret = Z_BUF_ERROR;
  }
  return ret;
};


const inflateEnd = (strm) => {

  if (inflateStateCheck(strm)) {
    return Z_STREAM_ERROR$1;
  }

  let state = strm.state;
  if (state.window) {
    state.window = null;
  }
  strm.state = null;
  return Z_OK$1;
};


const inflateGetHeader = (strm, head) => {

  /* check state */
  if (inflateStateCheck(strm)) { return Z_STREAM_ERROR$1; }
  const state = strm.state;
  if ((state.wrap & 2) === 0) { return Z_STREAM_ERROR$1; }

  /* save header structure */
  state.head = head;
  head.done = false;
  return Z_OK$1;
};


const inflateSetDictionary = (strm, dictionary) => {
  const dictLength = dictionary.length;

  let state;
  let dictid;
  let ret;

  /* check state */
  if (inflateStateCheck(strm)) { return Z_STREAM_ERROR$1; }
  state = strm.state;

  if (state.wrap !== 0 && state.mode !== DICT) {
    return Z_STREAM_ERROR$1;
  }

  /* check for correct dictionary identifier */
  if (state.mode === DICT) {
    dictid = 1; /* adler32(0, null, 0)*/
    /* dictid = adler32(dictid, dictionary, dictLength); */
    dictid = adler32_1(dictid, dictionary, dictLength, 0);
    if (dictid !== state.check) {
      return Z_DATA_ERROR$1;
    }
  }
  /* copy dictionary to window using updatewindow(), which will amend the
   existing dictionary if appropriate */
  ret = updatewindow(strm, dictionary, dictLength, dictLength);
  if (ret) {
    state.mode = MEM;
    return Z_MEM_ERROR$1;
  }
  state.havedict = 1;
  // Tracev((stderr, "inflate:   dictionary set\n"));
  return Z_OK$1;
};


var inflateReset_1 = inflateReset;
var inflateReset2_1 = inflateReset2;
var inflateResetKeep_1 = inflateResetKeep;
var inflateInit_1 = inflateInit;
var inflateInit2_1 = inflateInit2;
var inflate_2$1 = inflate$2;
var inflateEnd_1 = inflateEnd;
var inflateGetHeader_1 = inflateGetHeader;
var inflateSetDictionary_1 = inflateSetDictionary;
var inflateInfo = 'pako inflate (from Nodeca project)';

/* Not implemented
module.exports.inflateCodesUsed = inflateCodesUsed;
module.exports.inflateCopy = inflateCopy;
module.exports.inflateGetDictionary = inflateGetDictionary;
module.exports.inflateMark = inflateMark;
module.exports.inflatePrime = inflatePrime;
module.exports.inflateSync = inflateSync;
module.exports.inflateSyncPoint = inflateSyncPoint;
module.exports.inflateUndermine = inflateUndermine;
module.exports.inflateValidate = inflateValidate;
*/

var inflate_1$2 = {
	inflateReset: inflateReset_1,
	inflateReset2: inflateReset2_1,
	inflateResetKeep: inflateResetKeep_1,
	inflateInit: inflateInit_1,
	inflateInit2: inflateInit2_1,
	inflate: inflate_2$1,
	inflateEnd: inflateEnd_1,
	inflateGetHeader: inflateGetHeader_1,
	inflateSetDictionary: inflateSetDictionary_1,
	inflateInfo: inflateInfo
};

// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.

function GZheader() {
  /* true if compressed data believed to be text */
  this.text       = 0;
  /* modification time */
  this.time       = 0;
  /* extra flags (not used when writing a gzip file) */
  this.xflags     = 0;
  /* operating system */
  this.os         = 0;
  /* pointer to extra field or Z_NULL if none */
  this.extra      = null;
  /* extra field length (valid if extra != Z_NULL) */
  this.extra_len  = 0; // Actually, we don't need it in JS,
                       // but leave for few code modifications

  //
  // Setup limits is not necessary because in js we should not preallocate memory
  // for inflate use constant limit in 65536 bytes
  //

  /* space at extra (only when reading header) */
  // this.extra_max  = 0;
  /* pointer to zero-terminated file name or Z_NULL */
  this.name       = '';
  /* space at name (only when reading header) */
  // this.name_max   = 0;
  /* pointer to zero-terminated comment or Z_NULL */
  this.comment    = '';
  /* space at comment (only when reading header) */
  // this.comm_max   = 0;
  /* true if there was or will be a header crc */
  this.hcrc       = 0;
  /* true when done reading gzip header (not used when writing a gzip file) */
  this.done       = false;
}

var gzheader = GZheader;

const toString = Object.prototype.toString;

/* Public constants ==========================================================*/
/* ===========================================================================*/

const {
  Z_NO_FLUSH, Z_FINISH,
  Z_OK, Z_STREAM_END, Z_NEED_DICT, Z_STREAM_ERROR, Z_DATA_ERROR, Z_MEM_ERROR
} = constants$2;

/* ===========================================================================*/


/**
 * class Inflate
 *
 * Generic JS-style wrapper for zlib calls. If you don't need
 * streaming behaviour - use more simple functions: [[inflate]]
 * and [[inflateRaw]].
 **/

/* internal
 * inflate.chunks -> Array
 *
 * Chunks of output data, if [[Inflate#onData]] not overridden.
 **/

/**
 * Inflate.result -> Uint8Array|String
 *
 * Uncompressed result, generated by default [[Inflate#onData]]
 * and [[Inflate#onEnd]] handlers. Filled after you push last chunk
 * (call [[Inflate#push]] with `Z_FINISH` / `true` param).
 **/

/**
 * Inflate.err -> Number
 *
 * Error code after inflate finished. 0 (Z_OK) on success.
 * Should be checked if broken data possible.
 **/

/**
 * Inflate.msg -> String
 *
 * Error message, if [[Inflate.err]] != 0
 **/


/**
 * new Inflate(options)
 * - options (Object): zlib inflate options.
 *
 * Creates new inflator instance with specified params. Throws exception
 * on bad params. Supported options:
 *
 * - `windowBits`
 * - `dictionary`
 *
 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
 * for more information on these.
 *
 * Additional options, for internal needs:
 *
 * - `chunkSize` - size of generated data chunks (16K by default)
 * - `raw` (Boolean) - do raw inflate
 * - `to` (String) - if equal to 'string', then result will be converted
 *   from utf8 to utf16 (javascript) string. When string output requested,
 *   chunk length can differ from `chunkSize`, depending on content.
 *
 * By default, when no options set, autodetect deflate/gzip data format via
 * wrapper header.
 *
 * ##### Example:
 *
 * ```javascript
 * const pako = require('pako')
 * const chunk1 = new Uint8Array([1,2,3,4,5,6,7,8,9])
 * const chunk2 = new Uint8Array([10,11,12,13,14,15,16,17,18,19]);
 *
 * const inflate = new pako.Inflate({ level: 3});
 *
 * inflate.push(chunk1, false);
 * inflate.push(chunk2, true);  // true -> last chunk
 *
 * if (inflate.err) { throw new Error(inflate.err); }
 *
 * console.log(inflate.result);
 * ```
 **/
function Inflate$1(options) {
  this.options = common.assign({
    chunkSize: 1024 * 64,
    windowBits: 15,
    to: ''
  }, options || {});

  const opt = this.options;

  // Force window size for `raw` data, if not set directly,
  // because we have no header for autodetect.
  if (opt.raw && (opt.windowBits >= 0) && (opt.windowBits < 16)) {
    opt.windowBits = -opt.windowBits;
    if (opt.windowBits === 0) { opt.windowBits = -15; }
  }

  // If `windowBits` not defined (and mode not raw) - set autodetect flag for gzip/deflate
  if ((opt.windowBits >= 0) && (opt.windowBits < 16) &&
      !(options && options.windowBits)) {
    opt.windowBits += 32;
  }

  // Gzip header has no info about windows size, we can do autodetect only
  // for deflate. So, if window size not set, force it to max when gzip possible
  if ((opt.windowBits > 15) && (opt.windowBits < 48)) {
    // bit 3 (16) -> gzipped data
    // bit 4 (32) -> autodetect gzip/deflate
    if ((opt.windowBits & 15) === 0) {
      opt.windowBits |= 15;
    }
  }

  this.err    = 0;      // error code, if happens (0 = Z_OK)
  this.msg    = '';     // error message
  this.ended  = false;  // used to avoid multiple onEnd() calls
  this.chunks = [];     // chunks of compressed data

  this.strm   = new zstream();
  this.strm.avail_out = 0;

  let status  = inflate_1$2.inflateInit2(
    this.strm,
    opt.windowBits
  );

  if (status !== Z_OK) {
    throw new Error(messages[status]);
  }

  this.header = new gzheader();

  inflate_1$2.inflateGetHeader(this.strm, this.header);

  // Setup dictionary
  if (opt.dictionary) {
    // Convert data if needed
    if (typeof opt.dictionary === 'string') {
      opt.dictionary = strings.string2buf(opt.dictionary);
    } else if (toString.call(opt.dictionary) === '[object ArrayBuffer]') {
      opt.dictionary = new Uint8Array(opt.dictionary);
    }
    if (opt.raw) { //In raw mode we need to set the dictionary early
      status = inflate_1$2.inflateSetDictionary(this.strm, opt.dictionary);
      if (status !== Z_OK) {
        throw new Error(messages[status]);
      }
    }
  }
}

/**
 * Inflate#push(data[, flush_mode]) -> Boolean
 * - data (Uint8Array|ArrayBuffer): input data
 * - flush_mode (Number|Boolean): 0..6 for corresponding Z_NO_FLUSH..Z_TREE
 *   flush modes. See constants. Skipped or `false` means Z_NO_FLUSH,
 *   `true` means Z_FINISH.
 *
 * Sends input data to inflate pipe, generating [[Inflate#onData]] calls with
 * new output chunks. Returns `true` on success. If end of stream detected,
 * [[Inflate#onEnd]] will be called.
 *
 * `flush_mode` is not needed for normal operation, because end of stream
 * detected automatically. You may try to use it for advanced things, but
 * this functionality was not tested.
 *
 * On fail call [[Inflate#onEnd]] with error code and return false.
 *
 * ##### Example
 *
 * ```javascript
 * push(chunk, false); // push one of data chunks
 * ...
 * push(chunk, true);  // push last chunk
 * ```
 **/
Inflate$1.prototype.push = function (data, flush_mode) {
  const strm = this.strm;
  const chunkSize = this.options.chunkSize;
  const dictionary = this.options.dictionary;
  let status, _flush_mode, last_avail_out;

  if (this.ended) return false;

  if (flush_mode === ~~flush_mode) _flush_mode = flush_mode;
  else _flush_mode = flush_mode === true ? Z_FINISH : Z_NO_FLUSH;

  // Convert data if needed
  if (toString.call(data) === '[object ArrayBuffer]') {
    strm.input = new Uint8Array(data);
  } else {
    strm.input = data;
  }

  strm.next_in = 0;
  strm.avail_in = strm.input.length;

  for (;;) {
    if (strm.avail_out === 0) {
      strm.output = new Uint8Array(chunkSize);
      strm.next_out = 0;
      strm.avail_out = chunkSize;
    }

    status = inflate_1$2.inflate(strm, _flush_mode);

    if (status === Z_NEED_DICT && dictionary) {
      status = inflate_1$2.inflateSetDictionary(strm, dictionary);

      if (status === Z_OK) {
        status = inflate_1$2.inflate(strm, _flush_mode);
      } else if (status === Z_DATA_ERROR) {
        // Replace code with more verbose
        status = Z_NEED_DICT;
      }
    }

    // Skip snyc markers if more data follows and not raw mode
    while (strm.avail_in > 0 &&
           status === Z_STREAM_END &&
           strm.state.wrap > 0 &&
           data[strm.next_in] !== 0)
    {
      inflate_1$2.inflateReset(strm);
      status = inflate_1$2.inflate(strm, _flush_mode);
    }

    switch (status) {
      case Z_STREAM_ERROR:
      case Z_DATA_ERROR:
      case Z_NEED_DICT:
      case Z_MEM_ERROR:
        this.onEnd(status);
        this.ended = true;
        return false;
    }

    // Remember real `avail_out` value, because we may patch out buffer content
    // to align utf8 strings boundaries.
    last_avail_out = strm.avail_out;

    if (strm.next_out) {
      if (strm.avail_out === 0 || status === Z_STREAM_END) {

        if (this.options.to === 'string') {

          let next_out_utf8 = strings.utf8border(strm.output, strm.next_out);

          let tail = strm.next_out - next_out_utf8;
          let utf8str = strings.buf2string(strm.output, next_out_utf8);

          // move tail & realign counters
          strm.next_out = tail;
          strm.avail_out = chunkSize - tail;
          if (tail) strm.output.set(strm.output.subarray(next_out_utf8, next_out_utf8 + tail), 0);

          this.onData(utf8str);

        } else {
          this.onData(strm.output.length === strm.next_out ? strm.output : strm.output.subarray(0, strm.next_out));
        }
      }
    }

    // Must repeat iteration if out buffer is full
    if (status === Z_OK && last_avail_out === 0) continue;

    // Finalize if end of stream reached.
    if (status === Z_STREAM_END) {
      status = inflate_1$2.inflateEnd(this.strm);
      this.onEnd(status);
      this.ended = true;
      return true;
    }

    if (strm.avail_in === 0) break;
  }

  return true;
};


/**
 * Inflate#onData(chunk) -> Void
 * - chunk (Uint8Array|String): output data. When string output requested,
 *   each chunk will be string.
 *
 * By default, stores data blocks in `chunks[]` property and glue
 * those in `onEnd`. Override this handler, if you need another behaviour.
 **/
Inflate$1.prototype.onData = function (chunk) {
  this.chunks.push(chunk);
};


/**
 * Inflate#onEnd(status) -> Void
 * - status (Number): inflate status. 0 (Z_OK) on success,
 *   other if not.
 *
 * Called either after you tell inflate that the input stream is
 * complete (Z_FINISH). By default - join collected chunks,
 * free memory and fill `results` / `err` properties.
 **/
Inflate$1.prototype.onEnd = function (status) {
  // On success - join
  if (status === Z_OK) {
    if (this.options.to === 'string') {
      this.result = this.chunks.join('');
    } else {
      this.result = common.flattenChunks(this.chunks);
    }
  }
  this.chunks = [];
  this.err = status;
  this.msg = this.strm.msg;
};

const { Deflate, deflate, deflateRaw, gzip } = deflate_1$1;
var deflateRaw_1 = deflateRaw;

class Base64 {
    static encode(buffer) {
        if (Utility.isNullOrUndefined(buffer))
            return null;
        const binary = [];
        for (let i = 0; i < buffer.byteLength; i++)
            binary.push(String.fromCharCode(buffer[i]));
        return btoa(binary.join(""));
    }
    static decode(base64) {
        if (Utility.isNullOrUndefined(base64))
            return null;
        if (!this._base64Regex.test(base64))
            return null;
        const binary = atob(base64);
        const buffer = new Uint8Array(binary.length);
        for (let i = 0; i < binary.length; i++)
            buffer[i] = binary.charCodeAt(i);
        return buffer;
    }
}
Base64._base64Regex = /^(?:[A-Za-z0-9+\/]{4})*(?:[A-Za-z0-9+\/]{2}==|[A-Za-z0-9+\/]{3}=|[A-Za-z0-9+\/]*)?$/;

class Utility {
    static blobToDataUrl(blob) {
        return new Promise((resolve, _) => {
            const reader = new FileReader();
            reader.onloadend = () => resolve(reader.result);
            reader.readAsDataURL(blob);
        });
    }
    static delay(delay) {
        return new Promise(resolve => {
            setTimeout(() => {
                resolve(null);
            }, delay);
        });
    }
    static emptyGuid() {
        return "00000000-0000-0000-0000-000000000000";
    }
    /**
     *
     * @param input The input string from which to extract values.
     * @param pattern The regular expression pattern containing a capture group.
     * @returns An array of strings representing the values of the specified capture group in all matches.
     */
    static extractCaptureGroups(input, pattern) {
        const result = [];
        let match;
        while ((match = pattern.exec(input)) !== null) {
            if (match.length > 1) {
                // match[1] is the first capture group, match[0] would be the entire match
                result.push(match[1]);
            }
        }
        return result;
    }
    static generateGuid() {
        return "10000000-1000-4000-8000-100000000000".replace(/[018]/g, c => (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16));
    }
    static getTokenPayload(token) {
        try {
            const tokenPayload = o(token);
            return {
                attendeeId: tokenPayload.attendeeId,
                clusterId: tokenPayload.clusterId,
                deviceId: tokenPayload.deviceId,
                meetingId: tokenPayload.meetingId,
            };
        }
        catch { /* best effort */ }
        return null;
    }
    static isArray(value) {
        return Array.isArray(value);
    }
    static isBoolean(value) {
        return typeof value == "boolean" || value instanceof Boolean;
    }
    static isFakeAttendeeId(attendeeId) {
        return attendeeId.startsWith("f0000000-0000-0000-0000");
    }
    static isIso8601(value) {
        return this._regexIso8601.test(value);
    }
    static isNumber(value) {
        return typeof value == "number" || value instanceof Number;
    }
    static isNullOrUndefined(value) {
        return (value == null || value == undefined);
    }
    static isNodeProcess() {
        return typeof (globalThis.process) === 'object';
    }
    static isReplicatedAttendeeId(attendeeId) {
        return attendeeId.startsWith("e0000000-0000-0000");
    }
    static isString(value) {
        return typeof value == "string" || value instanceof String;
    }
    static isMobileBrowser() {
        const agent = navigator.userAgent;
        let mobile = /Android|iPhone|iPad|iPod|Mobile/i.test(agent) || this.isIOS() || this.isTablet();
        if (/X11; Linux/.test(agent) && this.isTouch()) {
            mobile = true;
        }
        return mobile;
    }
    static isIOS() {
        return [
            'iPad Simulator',
            'iPhone Simulator',
            'iPod Simulator',
            'iPad',
            'iPhone',
            'iPod'
        ].includes(navigator.platform)
            // iPad on iOS 13 detection
            || this.isIpad();
    }
    static isIpad() {
        return /iPad/i.test(navigator.userAgent) || (navigator.userAgent.includes("Mac") && "ontouchend" in document);
    }
    static isMac() {
        return navigator.userAgent?.toLowerCase().includes("mac");
    }
    static isTablet() {
        return /iPad/i.test(navigator.userAgent) || window.matchMedia("only screen and (min-device-width: 768px) and (max-device-width: 1366px) and (-webkit-min-device-pixel-ratio: 2)").matches;
    }
    static isMobileSafari() {
        return this.isMobileBrowser() && this.isSafari();
    }
    static isTouch() {
        return (('ontouchstart' in window) || ('maxTouchPoints' in navigator && navigator.maxTouchPoints > 0));
    }
    static isSafari() {
        return /Safari/i.test(navigator.userAgent) && !/Chrome/i.test(navigator.userAgent);
    }
    static parseGuid(buffer) {
        if (Utility.isNullOrUndefined(buffer))
            throw new Error(`Buffer cannot be null or undefined.`);
        if (buffer.byteLength != 16)
            throw new Error(`Buffer must have exactly 16 bytes. Buffer has ${buffer.byteLength} byte(s).`);
        const s = [];
        for (let i = 0; i < buffer.byteLength; i++)
            s.push(buffer[i].toString(16).padStart(2, "0"));
        return `${s[0]}${s[1]}${s[2]}${s[3]}-${s[4]}${s[5]}-${s[6]}${s[7]}-${s[8]}${s[9]}-${s[10]}${s[11]}${s[12]}${s[13]}${s[14]}${s[15]}`;
    }
    static parseJson(text) {
        try {
            return JSON.parse(text, (_, value) => {
                if (this.isString(value) && this.isIso8601(value))
                    return new Date(value);
                return value;
            });
        }
        catch (error) {
            throw new ParseError("Could not parse JSON.", this.sanitizeError(error), text);
        }
    }
    static sanitizeError(error) {
        if (this.isNullOrUndefined(error))
            return error;
        if (error instanceof Error)
            return error;
        return new Error(error);
    }
    static async time(task) {
        const startMillis = performance.now();
        const result = await task();
        const duration = Math.round(performance.now() - startMillis);
        return [duration, result];
    }
    static deflate(uncompressed) {
        return Base64.encode(deflateRaw_1(new TextEncoder().encode(uncompressed)));
    }
}
Utility._regexIso8601 = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(\.\d+)?(([+-]\d{2}:\d{2})|Z)$/;

class Guard {
    static isEqualTo(value, equalTo, name) {
        if (value == equalTo)
            return;
        throw new Error(`Parameter ${name} has value ${value} but must be equal to ${equalTo}.`);
    }
    static isGreaterThan(value, greaterThan, name) {
        if (value > greaterThan)
            return;
        throw new Error(`Parameter ${name} has value ${value} but must be greater than ${greaterThan}.`);
    }
    static isGreaterThanOrEqualTo(value, greaterThanOrEqualTo, name) {
        if (value >= greaterThanOrEqualTo)
            return;
        throw new Error(`Parameter ${name} has value ${value} but must be greater than or equal to ${greaterThanOrEqualTo}.`);
    }
    static isLengthWithinBounds(value, name, max, min) {
        if (Utility.isNullOrUndefined(value))
            return;
        if (Utility.isNullOrUndefined(min))
            min = 0;
        if (value.length < min)
            throw new Error(`Parameter ${name} has length ${value.length}. Minimum length is ${min}.`);
        if (value.length > max)
            throw new Error(`Parameter ${name} has length ${value.length}. Maximum length is ${max}.`);
    }
    static isLessThan(value, lessThan, name) {
        if (value < lessThan)
            return;
        throw new Error(`Parameter ${name} has value ${value} but must be less than ${lessThan}.`);
    }
    static isLessThanOrEqualTo(value, lessThanOrEqualTo, name) {
        if (value <= lessThanOrEqualTo)
            return;
        throw new Error(`Parameter ${name} has value ${value} but must be less than or equal to ${lessThanOrEqualTo}.`);
    }
    static isNotNullOrUndefined(value, name) {
        if (Utility.isNullOrUndefined(value))
            throw new Error(`Parameter ${name} cannot be null or undefined.`);
    }
}

class ServerError extends Error {
    constructor(message) {
        super(message);
    }
}

class AcceptedError extends ServerError {
    constructor(message) {
        super(`The request was accepted. ${message}`);
        this.name = "AcceptedError";
    }
}

class BadRequestError extends ServerError {
    constructor(requestFields) {
        super("The request failed validation.");
        this.name = "BadRequestError";
        this._requestFields = requestFields;
    }
    get requestFields() { return this._requestFields; }
}

class BadRequestField {
    constructor(name, messages) {
        this._name = name;
        this._messages = messages;
    }
    get name() { return this._name; }
    get messages() { return this._messages; }
}

class HttpError extends Error {
    get request() { return this._request; }
    get response() { return this._response; }
    constructor(message, request, response) {
        super(message);
        this.name = "HttpError";
        this._request = request;
        this._response = response;
    }
}

class HttpRequestAbortedError extends Error {
    get request() { return this._request; }
    constructor(message, request) {
        super(message);
        this.name = "HttpRequestAbortedError";
        this._request = request;
    }
}

class InternalServerError extends ServerError {
    constructor(type, message) {
        super(`An internal server error was encountered. (${type ? type + ": " : ""}${message})`);
        this.name = "InternalServerError";
        this._serverExceptionType = type;
        this._serverExceptionMessage = message;
    }
    get serverExceptionType() { return this._serverExceptionType; }
    get serverExceptionMessage() { return this._serverExceptionMessage; }
}

class ConsoleLogger {
    getFunction(level) {
        if (level == "fatal")
            return console.error;
        if (level == "error")
            return console.error;
        if (level == "warn")
            return console.warn;
        if (level == "info")
            return console.info;
        if (level == "debug")
            return console.debug;
        return console.debug;
    }
    write(item) {
        const fn = this.getFunction(item.level);
        if (item.debug) {
            item.debug = "\n" + item.debug; // force debug printout onto new line
            if (item.error) {
                fn(item.timestamp.toISOString(), item.message, item.error, item.debug);
            }
            else {
                fn(item.timestamp.toISOString(), item.message, item.debug);
            }
        }
        else {
            if (item.error) {
                fn(item.timestamp.toISOString(), item.message, item.error);
            }
            else {
                fn(item.timestamp.toISOString(), item.message);
            }
        }
    }
}

class Log {
    static get defaultLevel() {
        switch (globalThis.process?.env?.NODE_ENV) {
            case "production":
            case "staging":
                return "error";
            case "test":
                return "warn";
            case "development":
                return "info";
        }
        return "none";
    }
    static get level() { return this._level; }
    static set level(value) { this._level = value; }
    static get loggers() { return this._loggers; }
    static getIndexOfLevel(level) {
        if (level == "none")
            return 6;
        if (level == "fatal")
            return 5;
        if (level == "error")
            return 4;
        if (level == "warn")
            return 3;
        if (level == "info")
            return 2;
        if (level == "debug")
            return 1;
        return 0; // verbose
    }
    /** @internal */
    static write(item) {
        if (this.getIndexOfLevel(item.level) < this.getIndexOfLevel(Log.level))
            return;
        if (this.getIndexOfLevel("debug") < this.getIndexOfLevel(Log.level))
            delete item.debug;
        for (const logger of this._loggers) {
            logger.write(item);
        }
    }
    static addLogger(logger) {
        if (this._loggers.indexOf(logger) != -1)
            return false;
        this._loggers.push(logger);
        return true;
    }
    static removeLogger(logger) {
        const index = this._loggers.indexOf(logger);
        if (index == -1)
            return false;
        this._loggers.splice(index, 1);
        return true;
    }
    static removeLoggers(loggers) {
        for (const logger of loggers ?? this._loggers) {
            this.removeLogger(logger);
        }
    }
    static debug(message, error) {
        Guard.isNotNullOrUndefined(message, "message");
        this.write({
            error: Utility.sanitizeError(error),
            level: "debug",
            message: message,
            timestamp: new Date(),
        });
    }
    static error(message, error) {
        Guard.isNotNullOrUndefined(message, "message");
        this.write({
            error: Utility.sanitizeError(error),
            level: "error",
            message: message,
            timestamp: new Date(),
        });
    }
    static fatal(message, error) {
        Guard.isNotNullOrUndefined(message, "message");
        this.write({
            error: Utility.sanitizeError(error),
            level: "fatal",
            message: message,
            timestamp: new Date(),
        });
    }
    static info(message, error) {
        Guard.isNotNullOrUndefined(message, "message");
        this.write({
            error: Utility.sanitizeError(error),
            level: "info",
            message: message,
            timestamp: new Date(),
        });
    }
    static warn(message, error) {
        Guard.isNotNullOrUndefined(message, "message");
        this.write({
            error: Utility.sanitizeError(error),
            level: "warn",
            message: message,
            timestamp: new Date(),
        });
    }
    static verbose(message, error) {
        Guard.isNotNullOrUndefined(message, "message");
        this.write({
            error: Utility.sanitizeError(error),
            level: "verbose",
            message: message,
            timestamp: new Date(),
        });
    }
}
Log._level = "none";
Log._loggers = [new ConsoleLogger()];
(() => {
    Log.level = Log.defaultLevel;
})();

class ServiceUnavailableError extends ServerError {
    constructor(type, message) {
        super(`The service is currently unavailable. (${type ? type + ": " : ""}${message})`);
        this.name = "ServiceUnavailableError";
        this._serverExceptionType = type;
        this._serverExceptionMessage = message;
    }
    get serverExceptionType() { return this._serverExceptionType; }
    get serverExceptionMessage() { return this._serverExceptionMessage; }
}

class UnauthorizedError extends ServerError {
    constructor(type, message) {
        super(`The request was not authorized. (${type ? type + ": " : ""}${message})`);
        this.name = "UnauthorizedError";
        this._serverExceptionType = type;
        this._serverExceptionMessage = message;
    }
    get serverExceptionType() { return this._serverExceptionType; }
    get serverExceptionMessage() { return this._serverExceptionMessage; }
}

class UnknownError extends Error {
    constructor(message) {
        super(message);
        this.name = "UnknownError";
    }
}

var _a$d;
class HttpClient {
    constructor() {
        this._apiKey = null;
        this._attendeeId = null;
        this._baseUrl = null;
        this._clusterId = null;
        this._deviceId = null;
        this._maxRetries = 2;
        this._meetingId = null;
        this._requestTimeout = 30000;
        this._tokenFactory = null;
        this._token = null;
    }
    static get createRequest() { return HttpClient._createRequest; }
    static set createRequest(value) { HttpClient._createRequest = value; }
    static get gatewayUrl() { return this._gatewayUrl; }
    static set gatewayUrl(value) { this._gatewayUrl = value; }
    get baseUrl() { return this._baseUrl; }
    get clusterId() { return this._clusterId; }
    get maxRetries() { return this._maxRetries; }
    set maxRetries(value) { this._maxRetries = value; }
    get requestTimeout() { return this._requestTimeout; }
    set requestTimeout(value) { this._requestTimeout = value; }
    static sanitizeBaseUrl(baseUrl) {
        while (baseUrl.endsWith("/"))
            baseUrl = baseUrl.substring(0, baseUrl.length - 1);
        return baseUrl;
    }
    static withApiKey(apiKey, baseUrl) {
        Guard.isNotNullOrUndefined(apiKey, "apiKey");
        Guard.isNotNullOrUndefined(baseUrl, "baseUrl");
        const http = new HttpClient();
        http._apiKey = apiKey;
        http._baseUrl = this.sanitizeBaseUrl(baseUrl);
        return http;
    }
    static withTokenFactory(tokenFactory) {
        Guard.isNotNullOrUndefined(tokenFactory, "tokenFactory");
        const http = new HttpClient();
        http._tokenFactory = tokenFactory;
        return http;
    }
    async tryUpdateToken() {
        if (!this._tokenFactory)
            return false;
        const token = await this._tokenFactory();
        if (this._baseUrl == token.baseUrl && this._token == token.value)
            return false;
        this._token = token.value;
        this._baseUrl = HttpClient.sanitizeBaseUrl(token.baseUrl);
        const tokenPayload = Utility.getTokenPayload(this._token);
        if (tokenPayload) {
            this._attendeeId = tokenPayload.attendeeId;
            this._clusterId = tokenPayload.clusterId;
            this._deviceId = tokenPayload.deviceId;
            this._meetingId = tokenPayload.meetingId;
        }
        return true;
    }
    async send(method, path, requestBody, requestIndex, abortSignal, blob, retryCounter = 0) {
        await this.tryUpdateToken();
        const isForm = requestBody instanceof FormData;
        // initialize abort controller
        const abortController = new AbortController();
        if (abortSignal)
            abortSignal.addEventListener("abort", () => {
                abortController.abort(abortSignal.reason);
            });
        if (abortSignal?.aborted)
            abortController.abort();
        const requestTimeout = this._requestTimeout;
        const requestTimeoutId = Utility.isNullOrUndefined(requestTimeout) ? 0 : setTimeout(() => {
            abortController.abort(`${method} request (${requestIndex}) timed out after ${requestTimeout.toLocaleString()}ms.`);
        }, requestTimeout);
        // initialize URL
        const baseUrl = new URL(this._baseUrl);
        const requestPath = baseUrl.pathname === "/" ? path : `${baseUrl.pathname}/${path}`;
        const url = new URL(requestPath, baseUrl.origin);
        if (this._attendeeId)
            url.searchParams.append("aid", this._attendeeId);
        if (this._deviceId)
            url.searchParams.append("did", this._deviceId);
        if (this._meetingId)
            url.searchParams.append("mid", this._meetingId);
        // initialize headers
        const headers = {};
        if (!blob)
            headers["Accept"] = "application/json";
        if (requestBody && !isForm)
            headers["Content-Type"] = "application/json";
        if (this._apiKey)
            headers["X-API-Key"] = this._apiKey;
        if (this._token)
            headers["Authorization"] = `Bearer ${this._token}`;
        // initialize request
        const request = HttpClient.createRequest(url, method, headers, abortController.signal, requestBody && !isForm ? JSON.stringify(requestBody) : (isForm ? requestBody : undefined), requestIndex);
        Log.debug(`Sending ${request.method} request (${requestIndex}) to ${request.url}...`);
        let response;
        const performanceStart = performance.now();
        try {
            response = await fetch(request);
        }
        catch (error) {
            // clear timeout
            if (requestTimeoutId)
                clearTimeout(requestTimeoutId);
            // handle abort signal
            if (abortController.signal.aborted)
                throw new HttpRequestAbortedError(abortController.signal.reason, request);
            // handle retry exhaustion
            if (retryCounter >= this.maxRetries)
                throw error;
            // handle retry
            const delay = 200 * Math.pow(2, retryCounter);
            Log.warn(`Resending ${request.method} request (${requestIndex}) to ${request.url} after ${delay.toLocaleString()}ms.`, error);
            await Utility.delay(delay);
            return await this.send(method, path, requestBody, requestIndex, abortSignal, blob, retryCounter + 1);
        }
        Log.debug(`Received ${request.method} response (${requestIndex}) from ${request.url} with status code ${response.status}. [Duration: ${Math.round(performance.now() - performanceStart).toLocaleString()}]`);
        // clear timeout
        if (requestTimeoutId)
            clearTimeout(requestTimeoutId);
        // handle blob
        if (blob && response.ok)
            return await response.blob();
        // get response
        const responseText = await response.text();
        // handle empty response
        if (!responseText) {
            if (response.ok)
                return null;
            throw new HttpError(`${response.status} ${response.statusText}`, request, response);
        }
        // parse response
        const apiResponse = Utility.parseJson(responseText);
        if (!apiResponse.errors)
            return apiResponse;
        // handle errors
        const errorKeys = Object.keys(apiResponse.errors);
        if (errorKeys.length > 0) {
            if (response.status == 202)
                throw new AcceptedError(apiResponse.errors[errorKeys[0]][0]);
            if (response.status == 401)
                throw new UnauthorizedError(errorKeys[0], apiResponse.errors[errorKeys[0]][0]);
            if (response.status == 500)
                throw new InternalServerError(errorKeys[0], apiResponse.errors[errorKeys[0]][0]);
            if (response.status == 503)
                throw new ServiceUnavailableError(errorKeys[0], apiResponse.errors[errorKeys[0]][0]);
            if (response.status == 400 || response.ok)
                throw new BadRequestError(errorKeys.map((errorKey) => new BadRequestField(errorKey, apiResponse.errors[errorKey])));
        }
        throw new UnknownError(`${response.status} ${JSON.stringify(apiResponse.errors)}`);
    }
    delete(path, abortSignal) {
        return this.send("DELETE", path, null, HttpClient._requestCounter++, abortSignal);
    }
    get(path, abortSignal) {
        return this.send("GET", path, null, HttpClient._requestCounter++, abortSignal);
    }
    getBlob(path, abortSignal) {
        return this.send("GET", path, null, HttpClient._requestCounter++, abortSignal, true);
    }
    patch(path, request, abortSignal) {
        return this.send("PATCH", path, request, HttpClient._requestCounter++, abortSignal);
    }
    post(path, request, abortSignal) {
        return this.send("POST", path, request, HttpClient._requestCounter++, abortSignal);
    }
    postForm(path, formData, abortSignal) {
        return this.send("POST", path, formData, HttpClient._requestCounter++, abortSignal);
    }
    put(path, request, abortSignal) {
        return this.send("PUT", path, request, HttpClient._requestCounter++, abortSignal);
    }
}
_a$d = HttpClient;
HttpClient._createRequest = (url, method, headers, signal, body, requestIndex) => {
    if (_a$d._gatewayUrl) {
        Log.debug(`Using ${_a$d._gatewayUrl} to proxy ${method} request (${requestIndex}) to ${url}...`);
        headers["X-Target"] = url.toString();
        url = new URL(`${_a$d._gatewayUrl}?target=${url.toString()}`);
    }
    const request = new Request(url, {
        method: method,
        headers: headers,
        signal: signal,
        body: body
    });
    return request;
};
HttpClient._gatewayUrl = null;
HttpClient._requestCounter = 0;

var ApiKeyNameLength;
(function (ApiKeyNameLength) {
    ApiKeyNameLength[ApiKeyNameLength["Max"] = 50] = "Max";
})(ApiKeyNameLength || (ApiKeyNameLength = {}));
var ApiKeySecretLength;
(function (ApiKeySecretLength) {
    ApiKeySecretLength[ApiKeySecretLength["Max"] = 255] = "Max";
})(ApiKeySecretLength || (ApiKeySecretLength = {}));
var ApiKeyTypeLength;
(function (ApiKeyTypeLength) {
    ApiKeyTypeLength[ApiKeyTypeLength["Max"] = 20] = "Max";
})(ApiKeyTypeLength || (ApiKeyTypeLength = {}));
var ApiKeyValueLength;
(function (ApiKeyValueLength) {
    ApiKeyValueLength[ApiKeyValueLength["Max"] = 50] = "Max";
})(ApiKeyValueLength || (ApiKeyValueLength = {}));

var AttendeeClientTypeLength;
(function (AttendeeClientTypeLength) {
    AttendeeClientTypeLength[AttendeeClientTypeLength["Max"] = 20] = "Max";
})(AttendeeClientTypeLength || (AttendeeClientTypeLength = {}));
var AttendeeDisplayNameLength;
(function (AttendeeDisplayNameLength) {
    AttendeeDisplayNameLength[AttendeeDisplayNameLength["Max"] = 50] = "Max";
})(AttendeeDisplayNameLength || (AttendeeDisplayNameLength = {}));
var AttendeeSdkVersionLength;
(function (AttendeeSdkVersionLength) {
    AttendeeSdkVersionLength[AttendeeSdkVersionLength["Max"] = 10] = "Max";
})(AttendeeSdkVersionLength || (AttendeeSdkVersionLength = {}));
var AttendeeSipConnectorIdLength;
(function (AttendeeSipConnectorIdLength) {
    AttendeeSipConnectorIdLength[AttendeeSipConnectorIdLength["Max"] = 50] = "Max";
})(AttendeeSipConnectorIdLength || (AttendeeSipConnectorIdLength = {}));
var AttendeeSourceLanguageLength;
(function (AttendeeSourceLanguageLength) {
    AttendeeSourceLanguageLength[AttendeeSourceLanguageLength["Max"] = 10] = "Max";
})(AttendeeSourceLanguageLength || (AttendeeSourceLanguageLength = {}));

var ClusterAdminApiKeyLength;
(function (ClusterAdminApiKeyLength) {
    ClusterAdminApiKeyLength[ClusterAdminApiKeyLength["Max"] = 100] = "Max";
})(ClusterAdminApiKeyLength || (ClusterAdminApiKeyLength = {}));
var ClusterAdminApiUrlLength;
(function (ClusterAdminApiUrlLength) {
    ClusterAdminApiUrlLength[ClusterAdminApiUrlLength["Max"] = 255] = "Max";
})(ClusterAdminApiUrlLength || (ClusterAdminApiUrlLength = {}));
var ClusterNameLength;
(function (ClusterNameLength) {
    ClusterNameLength[ClusterNameLength["Max"] = 50] = "Max";
})(ClusterNameLength || (ClusterNameLength = {}));
var ClusterKeyLength;
(function (ClusterKeyLength) {
    ClusterKeyLength[ClusterKeyLength["Max"] = 50] = "Max";
})(ClusterKeyLength || (ClusterKeyLength = {}));
var ClusterSecretLength;
(function (ClusterSecretLength) {
    ClusterSecretLength[ClusterSecretLength["Max"] = 255] = "Max";
})(ClusterSecretLength || (ClusterSecretLength = {}));
var ClusterUrlLength;
(function (ClusterUrlLength) {
    ClusterUrlLength[ClusterUrlLength["Max"] = 255] = "Max";
})(ClusterUrlLength || (ClusterUrlLength = {}));
var ClusterMeetingUrlLength;
(function (ClusterMeetingUrlLength) {
    ClusterMeetingUrlLength[ClusterMeetingUrlLength["Max"] = 255] = "Max";
})(ClusterMeetingUrlLength || (ClusterMeetingUrlLength = {}));
var ClusterSipUrlLength;
(function (ClusterSipUrlLength) {
    ClusterSipUrlLength[ClusterSipUrlLength["Max"] = 255] = "Max";
})(ClusterSipUrlLength || (ClusterSipUrlLength = {}));
var ClusterSipSecretLength;
(function (ClusterSipSecretLength) {
    ClusterSipSecretLength[ClusterSipSecretLength["Max"] = 100] = "Max";
})(ClusterSipSecretLength || (ClusterSipSecretLength = {}));

var DeviceIdentifierLength;
(function (DeviceIdentifierLength) {
    DeviceIdentifierLength[DeviceIdentifierLength["Max"] = 100] = "Max";
})(DeviceIdentifierLength || (DeviceIdentifierLength = {}));
var DeviceIpNumberLength;
(function (DeviceIpNumberLength) {
    DeviceIpNumberLength[DeviceIpNumberLength["Max"] = 50] = "Max";
})(DeviceIpNumberLength || (DeviceIpNumberLength = {}));
var DevicePlatformLength;
(function (DevicePlatformLength) {
    DevicePlatformLength[DevicePlatformLength["Max"] = 50] = "Max";
})(DevicePlatformLength || (DevicePlatformLength = {}));
var DevicePlatformVersionLength;
(function (DevicePlatformVersionLength) {
    DevicePlatformVersionLength[DevicePlatformVersionLength["Max"] = 50] = "Max";
})(DevicePlatformVersionLength || (DevicePlatformVersionLength = {}));

var MeetingInviteEmailLength;
(function (MeetingInviteEmailLength) {
    MeetingInviteEmailLength[MeetingInviteEmailLength["Max"] = 255] = "Max";
})(MeetingInviteEmailLength || (MeetingInviteEmailLength = {}));

var MeetingSettingNameLength;
(function (MeetingSettingNameLength) {
    MeetingSettingNameLength[MeetingSettingNameLength["Max"] = 50] = "Max";
})(MeetingSettingNameLength || (MeetingSettingNameLength = {}));
var MeetingSettingValueLength;
(function (MeetingSettingValueLength) {
    MeetingSettingValueLength[MeetingSettingValueLength["Max"] = 255] = "Max";
})(MeetingSettingValueLength || (MeetingSettingValueLength = {}));

var PlanTemplateNameLength;
(function (PlanTemplateNameLength) {
    PlanTemplateNameLength[PlanTemplateNameLength["Max"] = 50] = "Max";
})(PlanTemplateNameLength || (PlanTemplateNameLength = {}));

var RoomKeyLength;
(function (RoomKeyLength) {
    RoomKeyLength[RoomKeyLength["Min"] = 4] = "Min";
    RoomKeyLength[RoomKeyLength["Max"] = 20] = "Max";
})(RoomKeyLength || (RoomKeyLength = {}));

var RoomScheduleRecurrenceLength;
(function (RoomScheduleRecurrenceLength) {
    RoomScheduleRecurrenceLength[RoomScheduleRecurrenceLength["Max"] = 215] = "Max";
})(RoomScheduleRecurrenceLength || (RoomScheduleRecurrenceLength = {}));

var ServerNameLength;
(function (ServerNameLength) {
    ServerNameLength[ServerNameLength["Max"] = 50] = "Max";
})(ServerNameLength || (ServerNameLength = {}));
var ServerAppVersionLength;
(function (ServerAppVersionLength) {
    ServerAppVersionLength[ServerAppVersionLength["Max"] = 50] = "Max";
})(ServerAppVersionLength || (ServerAppVersionLength = {}));
var ServerArchitectureLength;
(function (ServerArchitectureLength) {
    ServerArchitectureLength[ServerArchitectureLength["Max"] = 50] = "Max";
})(ServerArchitectureLength || (ServerArchitectureLength = {}));
var ServerInternalHostLength;
(function (ServerInternalHostLength) {
    ServerInternalHostLength[ServerInternalHostLength["Max"] = 255] = "Max";
})(ServerInternalHostLength || (ServerInternalHostLength = {}));
var ServerInternalProtocolLength;
(function (ServerInternalProtocolLength) {
    ServerInternalProtocolLength[ServerInternalProtocolLength["Max"] = 20] = "Max";
})(ServerInternalProtocolLength || (ServerInternalProtocolLength = {}));
var ServerMediaHostLength;
(function (ServerMediaHostLength) {
    ServerMediaHostLength[ServerMediaHostLength["Max"] = 255] = "Max";
})(ServerMediaHostLength || (ServerMediaHostLength = {}));
var ServerMediaProtocolLength;
(function (ServerMediaProtocolLength) {
    ServerMediaProtocolLength[ServerMediaProtocolLength["Max"] = 20] = "Max";
})(ServerMediaProtocolLength || (ServerMediaProtocolLength = {}));
var ServerOperatingSystemLength;
(function (ServerOperatingSystemLength) {
    ServerOperatingSystemLength[ServerOperatingSystemLength["Max"] = 50] = "Max";
})(ServerOperatingSystemLength || (ServerOperatingSystemLength = {}));
var ServerOperatingSystemVersionLength;
(function (ServerOperatingSystemVersionLength) {
    ServerOperatingSystemVersionLength[ServerOperatingSystemVersionLength["Max"] = 10] = "Max";
})(ServerOperatingSystemVersionLength || (ServerOperatingSystemVersionLength = {}));
var ServerExternalHostLength;
(function (ServerExternalHostLength) {
    ServerExternalHostLength[ServerExternalHostLength["Max"] = 255] = "Max";
})(ServerExternalHostLength || (ServerExternalHostLength = {}));
var ServerExternalProtocolLength;
(function (ServerExternalProtocolLength) {
    ServerExternalProtocolLength[ServerExternalProtocolLength["Max"] = 20] = "Max";
})(ServerExternalProtocolLength || (ServerExternalProtocolLength = {}));

var TenantBannerLength;
(function (TenantBannerLength) {
    TenantBannerLength[TenantBannerLength["Max"] = 255] = "Max";
})(TenantBannerLength || (TenantBannerLength = {}));
var TenantImageLength;
(function (TenantImageLength) {
    TenantImageLength[TenantImageLength["Max"] = 255] = "Max";
})(TenantImageLength || (TenantImageLength = {}));
var TenantNameLength;
(function (TenantNameLength) {
    TenantNameLength[TenantNameLength["Max"] = 100] = "Max";
})(TenantNameLength || (TenantNameLength = {}));
var TenantUrlLength;
(function (TenantUrlLength) {
    TenantUrlLength[TenantUrlLength["Max"] = 255] = "Max";
})(TenantUrlLength || (TenantUrlLength = {}));

var ClusterSettingNameLength;
(function (ClusterSettingNameLength) {
    ClusterSettingNameLength[ClusterSettingNameLength["Max"] = 50] = "Max";
})(ClusterSettingNameLength || (ClusterSettingNameLength = {}));
var ClusterSettingTypeLength;
(function (ClusterSettingTypeLength) {
    ClusterSettingTypeLength[ClusterSettingTypeLength["Max"] = 20] = "Max";
})(ClusterSettingTypeLength || (ClusterSettingTypeLength = {}));
var ClusterSettingValueLength;
(function (ClusterSettingValueLength) {
    ClusterSettingValueLength[ClusterSettingValueLength["Max"] = 512] = "Max";
})(ClusterSettingValueLength || (ClusterSettingValueLength = {}));

var ServerSettingNameLength;
(function (ServerSettingNameLength) {
    ServerSettingNameLength[ServerSettingNameLength["Max"] = 50] = "Max";
})(ServerSettingNameLength || (ServerSettingNameLength = {}));
var ServerSettingValueLength;
(function (ServerSettingValueLength) {
    ServerSettingValueLength[ServerSettingValueLength["Max"] = 512] = "Max";
})(ServerSettingValueLength || (ServerSettingValueLength = {}));

var TenantSettingNameLength;
(function (TenantSettingNameLength) {
    TenantSettingNameLength[TenantSettingNameLength["Max"] = 50] = "Max";
})(TenantSettingNameLength || (TenantSettingNameLength = {}));
var TenantSettingValueLength;
(function (TenantSettingValueLength) {
    TenantSettingValueLength[TenantSettingValueLength["Max"] = 512] = "Max";
})(TenantSettingValueLength || (TenantSettingValueLength = {}));

var UserAccountAvatarUrlLength;
(function (UserAccountAvatarUrlLength) {
    UserAccountAvatarUrlLength[UserAccountAvatarUrlLength["Max"] = 255] = "Max";
})(UserAccountAvatarUrlLength || (UserAccountAvatarUrlLength = {}));
var UserAccountDisplayNameLength;
(function (UserAccountDisplayNameLength) {
    UserAccountDisplayNameLength[UserAccountDisplayNameLength["Max"] = 50] = "Max";
})(UserAccountDisplayNameLength || (UserAccountDisplayNameLength = {}));
var UserAccountUserNameLength;
(function (UserAccountUserNameLength) {
    UserAccountUserNameLength[UserAccountUserNameLength["Max"] = 255] = "Max";
})(UserAccountUserNameLength || (UserAccountUserNameLength = {}));

var WebhookKeyLength;
(function (WebhookKeyLength) {
    WebhookKeyLength[WebhookKeyLength["Max"] = 50] = "Max";
})(WebhookKeyLength || (WebhookKeyLength = {}));
var WebhookUrlLength;
(function (WebhookUrlLength) {
    WebhookUrlLength[WebhookUrlLength["Max"] = 512] = "Max";
})(WebhookUrlLength || (WebhookUrlLength = {}));

let Client$6 = class Client {
    get maxRetries() { return this._httpClient.maxRetries; }
    set maxRetries(value) { this._httpClient.maxRetries = value; }
    get requestTimeout() { return this._httpClient.requestTimeout; }
    set requestTimeout(value) { this._httpClient.requestTimeout = value; }
    constructor(init) {
        this._accountsPath = "/accounts";
        this._apiKeysPath = "/apikeys";
        this._attendeePermissionsPath = "/attendeepermissions";
        this._attendeesPath = "/attendees";
        this._chatChannelAttendeesPath = "/chatchannelattendees";
        this._chatChannelsPath = "/chatchannels";
        this._chatMessageReactionsPath = "/chatmessagereactions";
        this._chatMessagesPath = "/chatmessages";
        this._clustersPath = "/clusters";
        this._clusterLogsPath = "/clusterlogs";
        this._clusterSettingsPath = "/clusters/settings";
        this._countiresPath = "/countries";
        this._devicesPath = "/devices";
        this._filesPath = "/files";
        this._meetingInvitesPath = "/meetinginvites";
        this._meetingPlansPath = "/meetingplans";
        this._meetingPlanServersPath = "/meetingplanservers";
        this._meetingPlanSlotsPath = "/meetingplanslots";
        this._meetingRecordingsPath = "/meetingrecordings";
        this._meetingsPath = "/meetings";
        this._meetingSettingsPath = "/meetingsettings";
        this._permissionsPath = "/permissions";
        this._planTemplatesPath = "/plantemplates";
        this._roomsPath = "/rooms";
        this._roomSchedulesPath = "/roomschedules";
        this._roomSipInboundNumbersPath = "/roomsipinboundnumbers";
        this._roomUserAccountsPath = "/roomusers";
        this._serversPath = "/servers";
        this._serverSettingsPath = "/serversettings";
        this._sipInboundNumbersPath = "/sipinboundnumbers";
        this._tenantsPath = "/tenants";
        this._tenantSettingsPath = "/tenantsettings";
        this._tenantUserAccountsPath = "/tenantusers";
        this._userAccountsPath = "/users";
        this._webhooksPath = "/webhooks";
        Guard.isNotNullOrUndefined(init, "init");
        Guard.isNotNullOrUndefined(init.identity, "init.identity");
        this._init = init;
        this._httpClient = HttpClient.withTokenFactory(async () => {
            const token = await this._init.identity.token();
            return {
                baseUrl: new URL(token.clusterAssignment.clusterUrl).origin,
                value: token.token
            };
        });
    }
    async admitAttendeeToMeeting(attendeeId, abortSignal) {
        Guard.isNotNullOrUndefined(attendeeId, "attendeeId");
        return await this._httpClient.post(`${this._attendeesPath}/${attendeeId}/admit`, null, abortSignal);
    }
    async blockAttendeeFromLobby(attendeeId, abortSignal) {
        Guard.isNotNullOrUndefined(attendeeId, "attendeeId");
        return await this._httpClient.post(`${this._attendeesPath}/${attendeeId}/block-from-lobby`, null, abortSignal);
    }
    async blockAttendeeFromRoom(attendeeId, abortSignal) {
        Guard.isNotNullOrUndefined(attendeeId, "attendeeId");
        return await this._httpClient.post(`${this._attendeesPath}/${attendeeId}/block-from-room`, null, abortSignal);
    }
    async createAccount(account, abortSignal) {
        Guard.isNotNullOrUndefined(account, "account");
        return await this._httpClient.post(`${this._accountsPath}`, account, abortSignal);
    }
    async createApiKey(apiKey, abortSignal) {
        Guard.isNotNullOrUndefined(apiKey, "apiKey");
        Guard.isLengthWithinBounds(apiKey.name, "name", ApiKeyNameLength.Max);
        Guard.isLengthWithinBounds(apiKey.secret, "secret", ApiKeySecretLength.Max);
        Guard.isLengthWithinBounds(apiKey.type, "type", ApiKeyTypeLength.Max);
        Guard.isLengthWithinBounds(apiKey.value, "value", ApiKeyValueLength.Max);
        return await this._httpClient.post(`${this._apiKeysPath}`, apiKey, abortSignal);
    }
    async createAttendee(attendee, abortSignal) {
        Guard.isNotNullOrUndefined(attendee, "attendee");
        Guard.isLengthWithinBounds(attendee.clientType, "clientType", AttendeeClientTypeLength.Max);
        Guard.isLengthWithinBounds(attendee.displayName, "displayName", AttendeeDisplayNameLength.Max);
        Guard.isLengthWithinBounds(attendee.sdkVersion, "sdkVersion", AttendeeSdkVersionLength.Max);
        Guard.isLengthWithinBounds(attendee.sipConnectorId, "sipConnectorId", AttendeeSipConnectorIdLength.Max);
        Guard.isLengthWithinBounds(attendee.sourceLanguage, "sourceLanguage", AttendeeSourceLanguageLength.Max);
        return await this._httpClient.post(`${this._attendeesPath}`, attendee, abortSignal);
    }
    async createAttendeePermission(attendeePermission, abortSignal) {
        Guard.isNotNullOrUndefined(attendeePermission, "attendeePermission");
        return await this._httpClient.post(`${this._attendeePermissionsPath}`, attendeePermission, abortSignal);
    }
    async createAttendeePermissionByName(permissionName, abortSignal) {
        Guard.isNotNullOrUndefined(permissionName, "permissionName");
        return await this._httpClient.post(`${this._attendeePermissionsPath}/permissionname`, permissionName, abortSignal);
    }
    async createCluster(cluster, abortSignal) {
        Guard.isNotNullOrUndefined(cluster, "cluster");
        Guard.isLengthWithinBounds(cluster.adminApiKey, "adminApiKey", ClusterAdminApiKeyLength.Max);
        Guard.isLengthWithinBounds(cluster.adminApiUrl, "adminApiUrl", ClusterAdminApiUrlLength.Max);
        Guard.isLengthWithinBounds(cluster.name, "name", ClusterNameLength.Max);
        Guard.isLengthWithinBounds(cluster.key, "key", ClusterKeyLength.Max);
        Guard.isLengthWithinBounds(cluster.secret, "secret", ClusterSecretLength.Max);
        Guard.isLengthWithinBounds(cluster.meetingServiceUrl, "meetingServiceUrl", ClusterMeetingUrlLength.Max);
        Guard.isLengthWithinBounds(cluster.sipUrl, "sipUrl", ClusterSipUrlLength.Max);
        Guard.isLengthWithinBounds(cluster.sipSecret, "sipSecret", ClusterSipSecretLength.Max);
        return await this._httpClient.post(`${this._clustersPath}`, cluster, abortSignal);
    }
    async createClusterLog(clusterLog, abortSignal) {
        Guard.isNotNullOrUndefined(clusterLog, "clusterLog");
        return await this._httpClient.post(`${this._clusterLogsPath}`, clusterLog, abortSignal);
    }
    async createClusterSetting(clusterSetting, abortSignal) {
        Guard.isNotNullOrUndefined(clusterSetting, "clusterSetting");
        Guard.isLengthWithinBounds(clusterSetting.name, "name", ClusterSettingNameLength.Max);
        Guard.isLengthWithinBounds(clusterSetting.type, "type", ClusterSettingTypeLength.Max);
        Guard.isLengthWithinBounds(clusterSetting.value, "value", ClusterSettingValueLength.Max);
        return await this._httpClient.post(`${this._clusterSettingsPath}`, clusterSetting, abortSignal);
    }
    async createCountry(country, abortSignal) {
        Guard.isNotNullOrUndefined(country, "country");
        return await this._httpClient.post(`${this._countiresPath}`, country, abortSignal);
    }
    async createDevice(device, abortSignal) {
        Guard.isNotNullOrUndefined(device, "device");
        Guard.isLengthWithinBounds(device.deviceIdentifier, "deviceIdentifier", DeviceIdentifierLength.Max);
        Guard.isLengthWithinBounds(device.deviceIPNumber, "deviceIPNumber", DeviceIpNumberLength.Max);
        Guard.isLengthWithinBounds(device.devicePlatform, "devicePlatform", DevicePlatformLength.Max);
        return await this._httpClient.post(`${this._devicesPath}`, device, abortSignal);
    }
    async createFile(request, abortSignal) {
        Guard.isNotNullOrUndefined(request, "request");
        Guard.isNotNullOrUndefined(request.file, "request.file");
        Guard.isNotNullOrUndefined(request.meetingId, "request.meetingId");
        const formData = new FormData();
        formData.append("file", request.file);
        return await this._httpClient.postForm(`${this._filesPath}/${request.meetingId}`, formData, abortSignal);
    }
    async createMeeting(meeting, abortSignal) {
        Guard.isNotNullOrUndefined(meeting, "meeting");
        return await this._httpClient.post(`${this._meetingsPath}`, meeting, abortSignal);
    }
    async createMeetingInvite(meetingInvite, abortSignal) {
        Guard.isNotNullOrUndefined(meetingInvite, "meetingInvite");
        Guard.isLengthWithinBounds(meetingInvite.emailAddress, "emailAddress", MeetingInviteEmailLength.Max);
        return await this._httpClient.post(`${this._meetingInvitesPath}`, meetingInvite, abortSignal);
    }
    async createMeetingPlan(meetingPlan, abortSignal) {
        Guard.isNotNullOrUndefined(meetingPlan, "meetingPlan");
        return await this._httpClient.post(`${this._meetingPlansPath}`, meetingPlan, abortSignal);
    }
    async createMeetingPlanServer(meetingPlanServer, abortSignal) {
        Guard.isNotNullOrUndefined(meetingPlanServer, "meetingPlanServer");
        return await this._httpClient.post(`${this._meetingPlanServersPath}`, meetingPlanServer, abortSignal);
    }
    async createMeetingPlanSlot(meetingPlanSlot, abortSignal) {
        Guard.isNotNullOrUndefined(meetingPlanSlot, "meetingPlanSlot");
        return await this._httpClient.post(`${this._meetingPlanSlotsPath}`, meetingPlanSlot, abortSignal);
    }
    async createMeetingSetting(meetingSetting, abortSignal) {
        Guard.isNotNullOrUndefined(meetingSetting, "meetingSetting");
        Guard.isLengthWithinBounds(meetingSetting.name, "name", MeetingSettingValueLength.Max);
        Guard.isLengthWithinBounds(meetingSetting.value, "value", MeetingSettingValueLength.Max);
        return await this._httpClient.post(`${this._meetingSettingsPath}`, meetingSetting, abortSignal);
    }
    async createPermission(permission, abortSignal) {
        Guard.isNotNullOrUndefined(permission, "permission");
        return await this._httpClient.post(`${this._permissionsPath}`, permission, abortSignal);
    }
    async createPlannedMeeting(plannedMeeting, abortSignal) {
        Guard.isNotNullOrUndefined(plannedMeeting, "plannedMeeting");
        return await this._httpClient.post(`${this._meetingsPath}/planned`, plannedMeeting, abortSignal);
    }
    async createPlanTemplate(planTemplate, abortSignal) {
        Guard.isNotNullOrUndefined(planTemplate, "planTemplate");
        Guard.isLengthWithinBounds(planTemplate.name, "name", PlanTemplateNameLength.Max);
        return await this._httpClient.post(`${this._planTemplatesPath}`, planTemplate, abortSignal);
    }
    async createRoom(room, abortSignal) {
        Guard.isNotNullOrUndefined(room, "room");
        Guard.isLengthWithinBounds(room.key, "key", RoomKeyLength.Max, RoomKeyLength.Min);
        room.planType ??= "2TIER";
        room.roomType ??= "PERMANENT";
        room.meetingType ??= "CONFERENCE";
        return await this._httpClient.post(`${this._roomsPath}`, room, abortSignal);
    }
    async createRoomSchedule(roomschedule, abortSignal) {
        Guard.isNotNullOrUndefined(roomschedule, "roomschedule");
        Guard.isLengthWithinBounds(roomschedule.recurrence, "recurrence", RoomScheduleRecurrenceLength.Max);
        return await this._httpClient.post(`${this._roomSchedulesPath}`, roomschedule, abortSignal);
    }
    async createRoomSipInboundNumber(roomSipInboundNumber, abortSignal) {
        Guard.isNotNullOrUndefined(roomSipInboundNumber, "roomSipInboundNumber");
        return await this._httpClient.post(`${this._roomSipInboundNumbersPath}`, roomSipInboundNumber, abortSignal);
    }
    async createRoomUserAccount(roomUserAccount, abortSignal) {
        Guard.isNotNullOrUndefined(roomUserAccount, "roomUserAccount");
        return await this._httpClient.post(`${this._roomUserAccountsPath}`, roomUserAccount, abortSignal);
    }
    async createServer(server, abortSignal) {
        Guard.isNotNullOrUndefined(server, "server");
        Guard.isLengthWithinBounds(server.name, "name", ServerNameLength.Max);
        return await this._httpClient.post(`${this._serversPath}`, server, abortSignal);
    }
    async createServerSetting(serverSetting, abortSignal) {
        Guard.isNotNullOrUndefined(serverSetting, "serverSetting");
        Guard.isLengthWithinBounds(serverSetting.settingName, "settingName", ServerSettingNameLength.Max);
        Guard.isLengthWithinBounds(serverSetting.settingValue, "settingValue", ServerSettingValueLength.Max);
        return await this._httpClient.post(`${this._serverSettingsPath}`, serverSetting, abortSignal);
    }
    async createSipInboundNumber(sipInboundNumber, abortSignal) {
        Guard.isNotNullOrUndefined(sipInboundNumber, "sipInboundNumber");
        return await this._httpClient.post(`${this._sipInboundNumbersPath}`, sipInboundNumber, abortSignal);
    }
    async createTenant(tenant, abortSignal) {
        Guard.isNotNullOrUndefined(tenant, "tenant");
        Guard.isLengthWithinBounds(tenant.banner, "banner", TenantBannerLength.Max);
        Guard.isLengthWithinBounds(tenant.image, "image", TenantImageLength.Max);
        Guard.isLengthWithinBounds(tenant.name, "name", TenantNameLength.Max);
        Guard.isLengthWithinBounds(tenant.url, "url", TenantUrlLength.Max);
        return await this._httpClient.post(`${this._tenantsPath}`, tenant, abortSignal);
    }
    async createTenantSetting(tenantSetting, abortSignal) {
        Guard.isNotNullOrUndefined(tenantSetting, "tenantSetting");
        Guard.isLengthWithinBounds(tenantSetting.settingName, "settingName", TenantSettingNameLength.Max);
        Guard.isLengthWithinBounds(tenantSetting.settingValue, "settingValue", TenantSettingValueLength.Max);
        return await this._httpClient.post(`${this._tenantSettingsPath}`, tenantSetting, abortSignal);
    }
    async createTenantUserAccount(tenantUserAccount, abortSignal) {
        Guard.isNotNullOrUndefined(tenantUserAccount, "tenantUserAccount");
        return await this._httpClient.post(`${this._tenantUserAccountsPath}`, tenantUserAccount, abortSignal);
    }
    async createUserAccount(userAccount, abortSignal) {
        Guard.isNotNullOrUndefined(userAccount, "userAccount");
        Guard.isLengthWithinBounds(userAccount.avatarUrl, "avatarUrl", UserAccountAvatarUrlLength.Max);
        Guard.isLengthWithinBounds(userAccount.displayName, "displayName", UserAccountDisplayNameLength.Max);
        Guard.isLengthWithinBounds(userAccount.username, "username", UserAccountUserNameLength.Max);
        return await this._httpClient.post(`${this._userAccountsPath}`, userAccount, abortSignal);
    }
    async createWebhook(webhook, abortSignal) {
        Guard.isNotNullOrUndefined(webhook, "webhook");
        Guard.isLengthWithinBounds(webhook.key, "key", WebhookKeyLength.Max);
        Guard.isLengthWithinBounds(webhook.url, "url", WebhookUrlLength.Max);
        return await this._httpClient.post(`${this._webhooksPath}`, webhook, abortSignal);
    }
    async deleteAccount(accountId, abortSignal) {
        Guard.isNotNullOrUndefined(accountId, "accountId");
        return await this._httpClient.delete(`${this._accountsPath}/${accountId}`, abortSignal);
    }
    async deleteApiKey(apiKeyId, abortSignal) {
        Guard.isNotNullOrUndefined(apiKeyId, "apiKeyId");
        return await this._httpClient.delete(`${this._apiKeysPath}/${apiKeyId}`, abortSignal);
    }
    async deleteAttendee(attendeeId, abortSignal) {
        Guard.isNotNullOrUndefined(attendeeId, "attendeeId");
        return await this._httpClient.delete(`${this._attendeesPath}/${attendeeId}`, abortSignal);
    }
    async deleteAttendeePermission(attendeePermissionId, abortSignal) {
        Guard.isNotNullOrUndefined(attendeePermissionId, "attendeePermissionId");
        return await this._httpClient.delete(`${this._attendeePermissionsPath}/${attendeePermissionId}`, abortSignal);
    }
    async deleteAttendeePermissionByPermissionId(permissionId, attendeeId, abortSignal) {
        Guard.isNotNullOrUndefined(permissionId, "permissionId");
        return await this._httpClient.delete(`${this._attendeePermissionsPath}/permissionId?permissionId=${permissionId}&attendeeId=${attendeeId}`, abortSignal);
    }
    async deleteAttendeePermissionByPermissionName(permissionName, permissionType, attendeeId, abortSignal) {
        Guard.isNotNullOrUndefined(permissionName, "permissionName");
        Guard.isNotNullOrUndefined(permissionType, "permissionType");
        Guard.isNotNullOrUndefined(attendeeId, "attendeeId");
        return await this._httpClient.delete(`${this._attendeePermissionsPath}/permissionname?permissionName=${permissionName}&permissionType=${permissionType}&attendeeId=${attendeeId}`, abortSignal);
    }
    async deleteCluster(clusterId, abortSignal) {
        Guard.isNotNullOrUndefined(clusterId, "clusterId");
        return await this._httpClient.delete(`${this._clustersPath}/${clusterId}`, abortSignal);
    }
    async deleteCountry(countryId, abortSignal) {
        Guard.isNotNullOrUndefined(countryId, "countryId");
        return await this._httpClient.delete(`${this._countiresPath}/${countryId}`, abortSignal);
    }
    async deleteDevice(deviceId, abortSignal) {
        Guard.isNotNullOrUndefined(deviceId, "deviceId");
        return await this._httpClient.delete(`${this._devicesPath}/${deviceId}`, abortSignal);
    }
    async deleteMeeting(meetingId, abortSignal) {
        Guard.isNotNullOrUndefined(meetingId, "meetingId");
        return await this._httpClient.delete(`${this._meetingsPath}/${meetingId}`, abortSignal);
    }
    async deleteMeetingInvite(meetingInviteId, abortSignal) {
        Guard.isNotNullOrUndefined(meetingInviteId, "meetingInviteId");
        return await this._httpClient.delete(`${this._meetingInvitesPath}/${meetingInviteId}`, abortSignal);
    }
    async deleteMeetingPlan(meetingPlanId, abortSignal) {
        Guard.isNotNullOrUndefined(meetingPlanId, "meetingPlanId");
        return await this._httpClient.delete(`${this._meetingPlansPath}/${meetingPlanId}`, abortSignal);
    }
    async deleteMeetingPlanServer(meetingPlanServerId, abortSignal) {
        Guard.isNotNullOrUndefined(meetingPlanServerId, "meetingPlanServerId");
        return await this._httpClient.delete(`${this._meetingPlanServersPath}/${meetingPlanServerId}`, abortSignal);
    }
    async deleteMeetingPlanSlot(meetingPlanSlotId, abortSignal) {
        Guard.isNotNullOrUndefined(meetingPlanSlotId, "meetingPlanSlotId");
        return await this._httpClient.delete(`${this._meetingPlanSlotsPath}/${meetingPlanSlotId}`, abortSignal);
    }
    async deleteMeetingRecording(meetingRecordingId, abortSignal) {
        Guard.isNotNullOrUndefined(meetingRecordingId, "meetingRecordingId");
        return await this._httpClient.delete(`${this._meetingRecordingsPath}/${meetingRecordingId}`, abortSignal);
    }
    async deleteMeetingSetting(meetingSettingId, abortSignal) {
        Guard.isNotNullOrUndefined(meetingSettingId, "meetingSettingId");
        return await this._httpClient.delete(`${this._meetingSettingsPath}/${meetingSettingId}`, abortSignal);
    }
    async deletePermission(permissionId, abortSignal) {
        Guard.isNotNullOrUndefined(permissionId, "permissionId");
        return await this._httpClient.delete(`${this._permissionsPath}/${permissionId}`, abortSignal);
    }
    async deletePlanTemplate(planTemplateId, abortSignal) {
        Guard.isNotNullOrUndefined(planTemplateId, "planTemplateId");
        return await this._httpClient.delete(`${this._planTemplatesPath}/${planTemplateId}`, abortSignal);
    }
    async deleteRoom(roomId, abortSignal) {
        Guard.isNotNullOrUndefined(roomId, "roomId");
        return await this._httpClient.delete(`${this._roomsPath}/${roomId}`, abortSignal);
    }
    async deleteRoomSchedule(roomScheduleId, abortSignal) {
        Guard.isNotNullOrUndefined(roomScheduleId, "roomScheduleId");
        return await this._httpClient.delete(`${this._roomSchedulesPath}/${roomScheduleId}`, abortSignal);
    }
    async deleteRoomSipInboundNumber(roomSipInboundNumberId, abortSignal) {
        Guard.isNotNullOrUndefined(roomSipInboundNumberId, "roomSipInboundNumberId");
        return await this._httpClient.delete(`${this._roomSipInboundNumbersPath}/${roomSipInboundNumberId}`, abortSignal);
    }
    async deleteRoomUserAccount(roomUserAccountId, abortSignal) {
        Guard.isNotNullOrUndefined(roomUserAccountId, "roomUserAccountId");
        return await this._httpClient.delete(`${this._roomUserAccountsPath}/${roomUserAccountId}`, abortSignal);
    }
    async deleteServer(serverId, abortSignal) {
        Guard.isNotNullOrUndefined(serverId, "serverId");
        return await this._httpClient.delete(`${this._serversPath}/${serverId}`, abortSignal);
    }
    async deleteServerSetting(serverSettingId, abortSignal) {
        Guard.isNotNullOrUndefined(serverSettingId, "serverSettingId");
        return await this._httpClient.delete(`${this._serverSettingsPath}/${serverSettingId}`, abortSignal);
    }
    async deleteSipInboundNumber(sipInboundNumberId, abortSignal) {
        Guard.isNotNullOrUndefined(sipInboundNumberId, "sipInboundNumberId");
        return await this._httpClient.delete(`${this._sipInboundNumbersPath}/${sipInboundNumberId}`, abortSignal);
    }
    async deleteTenant(tenantId, abortSignal) {
        Guard.isNotNullOrUndefined(tenantId, "tenantId");
        return await this._httpClient.delete(`${this._tenantsPath}/${tenantId}`, abortSignal);
    }
    async deleteTenantSetting(tenantSettingId, abortSignal) {
        Guard.isNotNullOrUndefined(tenantSettingId, "tenantSettingId");
        return await this._httpClient.delete(`${this._tenantSettingsPath}/${tenantSettingId}`, abortSignal);
    }
    async deleteTenantUserAccount(tenantUserAccountId, abortSignal) {
        Guard.isNotNullOrUndefined(tenantUserAccountId, "tenantUserAccountId");
        return await this._httpClient.delete(`${this._tenantUserAccountsPath}/${tenantUserAccountId}`, abortSignal);
    }
    async deleteUserAccount(userAccountId, abortSignal) {
        Guard.isNotNullOrUndefined(userAccountId, "userAccountId");
        return await this._httpClient.delete(`${this._userAccountsPath}/${userAccountId}`, abortSignal);
    }
    async deleteWebhook(webhookId, abortSignal) {
        Guard.isNotNullOrUndefined(webhookId, "webhookId");
        return await this._httpClient.delete(`${this._webhooksPath}/${webhookId}`, abortSignal);
    }
    async disableSipByRoomId(roomId, abortSignal) {
        return await this._httpClient.post("/room/disable-sip", { roomId: roomId }, abortSignal);
    }
    async disableStorageByRoomId(roomId, abortSignal) {
        return await this._httpClient.post("/room/disable-storage", { roomId: roomId }, abortSignal);
    }
    async enableSipByRoomId(roomId, abortSignal) {
        return await this._httpClient.post("/room/enable-sip", { roomId: roomId }, abortSignal);
    }
    async enableStorageByRoomId(roomId, abortSignal) {
        return await this._httpClient.post("/room/enable-storage", { roomId: roomId }, abortSignal);
    }
    async getAccount(accountId, abortSignal) {
        Guard.isNotNullOrUndefined(accountId, "accountId");
        return await this._httpClient.get(`${this._accountsPath}/${accountId}`, abortSignal);
    }
    async getApiKey(apiKeyId, abortSignal) {
        Guard.isNotNullOrUndefined(apiKeyId, "apiKeyId");
        return await this._httpClient.get(`${this._apiKeysPath}/${apiKeyId}`, abortSignal);
    }
    async getAttendee(attendeeId, abortSignal) {
        Guard.isNotNullOrUndefined(attendeeId, "attendeeId");
        return await this._httpClient.get(`${this._attendeesPath}/${attendeeId}`, abortSignal);
    }
    async getChatChannel(chatChannelId, abortSignal) {
        Guard.isNotNullOrUndefined(chatChannelId, "chatChannelId");
        return await this._httpClient.get(`${this._chatChannelsPath}/${chatChannelId}`, abortSignal);
    }
    async getChatChannelAttendee(chatChannelAttendeeId, abortSignal) {
        Guard.isNotNullOrUndefined(chatChannelAttendeeId, "chatChannelAttendeeId");
        return await this._httpClient.get(`${this._chatChannelAttendeesPath}/${chatChannelAttendeeId}`, abortSignal);
    }
    async getChatMessage(chatMessageId, abortSignal) {
        Guard.isNotNullOrUndefined(chatMessageId, "chatMessageId");
        return await this._httpClient.get(`${this._chatMessagesPath}/${chatMessageId}`, abortSignal);
    }
    async getCluster(clusterId, abortSignal) {
        Guard.isNotNullOrUndefined(clusterId, "clusterId");
        return await this._httpClient.get(`${this._clustersPath}/${clusterId}`, abortSignal);
    }
    async getClusterSetting(clusterId, settingName, abortSignal) {
        Guard.isNotNullOrUndefined(clusterId, "clusterId");
        Guard.isNotNullOrUndefined(settingName, "settingName");
        return await this._httpClient.get(`${this._clustersPath}/${clusterId}/settings/${settingName}`, abortSignal);
    }
    async getFileData(meetingId, fileId, abortSignal) {
        Guard.isNotNullOrUndefined(meetingId, "meetingId");
        Guard.isNotNullOrUndefined(fileId, "fileId");
        return await this._httpClient.getBlob(`${this._filesPath}/${meetingId}/${fileId}`, abortSignal);
    }
    async getFileDataUrl(meetingId, fileId, abortSignal) {
        return await Utility.blobToDataUrl(await this.getFileData(meetingId, fileId, abortSignal));
    }
    async getMeeting(meetingId, abortSignal) {
        Guard.isNotNullOrUndefined(meetingId, "meetingId");
        return await this._httpClient.get(`${this._meetingsPath}/${meetingId}`, abortSignal);
    }
    async getMeetingInvite(meetingInviteId, abortSignal) {
        Guard.isNotNullOrUndefined(meetingInviteId, "meetingInviteId");
        return await this._httpClient.get(`${this._meetingInvitesPath}/${meetingInviteId}`, abortSignal);
    }
    async getMeetingPlan(meetingPlanId, abortSignal) {
        Guard.isNotNullOrUndefined(meetingPlanId, "meetingPlanId");
        return await this._httpClient.get(`${this._meetingPlansPath}/${meetingPlanId}`, abortSignal);
    }
    async getMeetingPlanServer(meetingPlanServerId, abortSignal) {
        Guard.isNotNullOrUndefined(meetingPlanServerId, "meetingPlanServerId");
        return await this._httpClient.get(`${this._meetingPlanServersPath}/${meetingPlanServerId}`, abortSignal);
    }
    async getMeetingPlanSlot(meetingPlanSlotId, abortSignal) {
        Guard.isNotNullOrUndefined(meetingPlanSlotId, "meetingPlanSlotId");
        return await this._httpClient.get(`${this._meetingPlanSlotsPath}/${meetingPlanSlotId}`, abortSignal);
    }
    async getMeetingRecording(meetingRecordingId, recordingUrlTtl, abortSignal) {
        Guard.isNotNullOrUndefined(meetingRecordingId, "meetingRecordingId");
        const query = Utility.isNullOrUndefined(recordingUrlTtl) ? "" : `?recordingUrlTtl=${recordingUrlTtl}`;
        return await this._httpClient.get(`${this._meetingRecordingsPath}/${meetingRecordingId}${query}`, abortSignal);
    }
    async getMeetingSetting(meetingSettingId, abortSignal) {
        Guard.isNotNullOrUndefined(meetingSettingId, "meetingSettingId");
        return await this._httpClient.get(`${this._meetingSettingsPath}/${meetingSettingId}`, abortSignal);
    }
    async getPlanTemplate(planTemplateId, abortSignal) {
        Guard.isNotNullOrUndefined(planTemplateId, "planTemplateId");
        return await this._httpClient.get(`${this._planTemplatesPath}/${planTemplateId}`, abortSignal);
    }
    async getRoom(roomId, abortSignal) {
        Guard.isNotNullOrUndefined(roomId, "roomId");
        return await this._httpClient.get(`${this._roomsPath}/${roomId}`, abortSignal);
    }
    async getRoomInfoByKey(roomKey, abortSignal) {
        Guard.isNotNullOrUndefined(roomKey, "roomKey");
        Guard.isLengthWithinBounds(roomKey, "roomkey", 20);
        return await this._httpClient.get(`${this._roomsPath}/${roomKey}/info`, abortSignal);
    }
    async getRoomSipInboundNumber(roomSipInboundNumberId, abortSignal) {
        Guard.isNotNullOrUndefined(roomSipInboundNumberId, "roomSipInboundNumberId");
        return await this._httpClient.get(`${this._roomSipInboundNumbersPath}/${roomSipInboundNumberId}`, abortSignal);
    }
    async getRoomUserAccount(roomUserAccountId, abortSignal) {
        Guard.isNotNullOrUndefined(roomUserAccountId, "roomUserAccountId");
        return await this._httpClient.get(`${this._roomUserAccountsPath}/${roomUserAccountId}`, abortSignal);
    }
    async getServer(serverId, abortSignal) {
        Guard.isNotNullOrUndefined(serverId, "serverId");
        return await this._httpClient.get(`${this._serversPath}/${serverId}`, abortSignal);
    }
    async getServerSetting(serverSettingId, abortSignal) {
        Guard.isNotNullOrUndefined(serverSettingId, "serverSettingId");
        return await this._httpClient.get(`${this._serverSettingsPath}/${serverSettingId}`, abortSignal);
    }
    async getTenant(tenantId, abortSignal) {
        Guard.isNotNullOrUndefined(tenantId, "tenantId");
        return await this._httpClient.get(`${this._tenantsPath}/${tenantId}`, abortSignal);
    }
    async getTenantSetting(tenantSettingId, abortSignal) {
        Guard.isNotNullOrUndefined(tenantSettingId, "tenantSettingId");
        return await this._httpClient.get(`${this._tenantSettingsPath}/${tenantSettingId}`, abortSignal);
    }
    async getUserAccount(userAccountId, abortSignal) {
        Guard.isNotNullOrUndefined(userAccountId, "userAccountId");
        return await this._httpClient.get(`${this._userAccountsPath}/${userAccountId}`, abortSignal);
    }
    async getUserAccountByUserName(userName, abortSignal) {
        Guard.isNotNullOrUndefined(userName, "userName");
        return await this._httpClient.post(`${this._userAccountsPath}/username`, { value: userName }, abortSignal);
    }
    async kickAttendee(attendeeId, abortSignal) {
        Guard.isNotNullOrUndefined(attendeeId, "attendeeId");
        return await this._httpClient.post(`${this._attendeesPath}/${attendeeId}/kick`, null, abortSignal);
    }
    async listAccounts(request, abortSignal) {
        Guard.isNotNullOrUndefined(request, "request");
        return await this._httpClient.get(`${this._accountsPath}?${this.getBaseListRequestString(request)}`, abortSignal);
    }
    async listApiKeys(request, abortSignal) {
        Guard.isNotNullOrUndefined(request, "request");
        return await this._httpClient.get(`${this._apiKeysPath}?${this.getBaseListRequestString(request)}`, abortSignal);
    }
    async listAttendeePermissionByAttendeeId(attendeeId, abortSignal) {
        Guard.isNotNullOrUndefined(attendeeId, "attendeeId");
        return await this._httpClient.get(`${this._attendeePermissionsPath}/${attendeeId}`, abortSignal);
    }
    async listAttendees(request, abortSignal) {
        Guard.isNotNullOrUndefined(request, "request");
        let query = this.getBaseListRequestString(request);
        if (request.meetingId) {
            query += `&meetingId=${request.meetingId}`;
        }
        if (request.userAccountId) {
            query += `&userAccountId=${request.userAccountId}`;
        }
        if (request.idsToExclude && request.idsToExclude.length > 0) {
            for (let i = 0; i < request.idsToExclude.length; i++) {
                query += `&idsToExclude=${request.idsToExclude[i]}`;
            }
        }
        return await this._httpClient.get(`${this._attendeesPath}?${query}`, abortSignal);
    }
    async listChatChannelAttendeesByChannelId(channelId, abortSignal) {
        Guard.isNotNullOrUndefined(channelId, "channelId");
        return await this._httpClient.get(`${this._chatChannelAttendeesPath}?channelId=${channelId}`, abortSignal);
    }
    async listChatChannels(request, abortSignal) {
        Guard.isNotNullOrUndefined(request, "request");
        return await this._httpClient.get(`${this._chatChannelsPath}?${this.getBaseListRequestString(request)}`, abortSignal);
    }
    async listAttendeeChatChannels(request, abortSignal) {
        Guard.isNotNullOrUndefined(request, "request");
        return await this._httpClient.get(`${this._chatChannelsPath}/attendee?limit=100&attendeeId=${request.attendeeId}${this.getBaseListRequestString(request)}`, abortSignal);
    }
    async listChatMessageReactionsByMessageId(messageId, abortSignal) {
        Guard.isNotNullOrUndefined(messageId, "messageId");
        return await this._httpClient.get(`${this._chatMessageReactionsPath}/${messageId}`, abortSignal);
    }
    async listChatMessages(request, abortSignal) {
        Guard.isNotNullOrUndefined(request, "request");
        let query = this.getBaseListRequestString(request);
        if (request.meetingId) {
            query += `&meetingId=${request.meetingId}`;
        }
        if (request.attendeeId) {
            query += `&attendeeId=${request.attendeeId}`;
        }
        if (request.channelId) {
            query += `&channelId=${request.channelId}`;
        }
        if (request.createdBy) {
            query += `&createdBy=${request.createdBy}`;
        }
        if (request.flaggedBy) {
            query += `&flaggedBy=${request.flaggedBy}`;
        }
        if (request.sortDirection) {
            query += `&sortDirection=${request.sortDirection}`;
        }
        return await this._httpClient.get(`${this._chatMessagesPath}?${query}`, abortSignal);
    }
    async listChatMessagesAsJson(request, abortSignal) {
        Guard.isNotNullOrUndefined(request, "request");
        let query = this.getBaseListRequestString(request);
        if (request.meetingId) {
            query += `&meetingId=${request.meetingId}`;
        }
        if (request.attendeeId) {
            query += `&attendeeId=${request.attendeeId}`;
        }
        if (request.channelId) {
            query += `&channelId=${request.channelId}`;
        }
        if (request.createdBy) {
            query += `&createdBy=${request.createdBy}`;
        }
        if (request.flaggedBy) {
            query += `&flaggedBy=${request.flaggedBy}`;
        }
        if (request.sortDirection) {
            query += `&sortDirection=${request.sortDirection}`;
        }
        return await this._httpClient.get(`${this._chatMessagesPath}/json?${query}`, abortSignal);
    }
    async listClusters(request, abortSignal) {
        Guard.isNotNullOrUndefined(request, "request");
        return await this._httpClient.get(`${this._clustersPath}?${this.getBaseListRequestString(request)}`, abortSignal);
    }
    async listClusterSettingsByClusterId(clusterId, abortSignal) {
        Guard.isNotNullOrUndefined(clusterId, "clusterId");
        return await this._httpClient.get(`${this._clustersPath}/${clusterId}/settings`, abortSignal);
    }
    async listCountries(request, abortSignal) {
        Guard.isNotNullOrUndefined(request, "request");
        return await this._httpClient.get(`${this._countiresPath}?${this.getBaseListRequestString(request)}`, abortSignal);
    }
    async listDevices(request, abortSignal) {
        Guard.isNotNullOrUndefined(request, "request");
        let query = this.getBaseListRequestString(request);
        if (request.userAccountId) {
            query += `&userAccountId=${request.userAccountId}`;
        }
        return await this._httpClient.get(`${this._devicesPath}?${query}`, abortSignal);
    }
    async listMeetingInvites(request, abortSignal) {
        Guard.isNotNullOrUndefined(request, "request");
        return await this._httpClient.get(`${this._meetingInvitesPath}?${this.getBaseListRequestString(request)}`, abortSignal);
    }
    async listMeetingPlans(request, abortSignal) {
        Guard.isNotNullOrUndefined(request, "request");
        return await this._httpClient.get(`${this._meetingPlansPath}?${this.getBaseListRequestString(request)}`, abortSignal);
    }
    async listMeetingPlanServers(request, abortSignal) {
        Guard.isNotNullOrUndefined(request, "request");
        return await this._httpClient.get(`${this._meetingPlanServersPath}?${this.getBaseListRequestString(request)}`, abortSignal);
    }
    async listMeetingPlanSlots(request, abortSignal) {
        Guard.isNotNullOrUndefined(request, "request");
        return await this._httpClient.get(`${this._meetingPlanSlotsPath}?${this.getBaseListRequestString(request)}`, abortSignal);
    }
    async listMeetingRecordings(request, abortSignal) {
        Guard.isNotNullOrUndefined(request, "request");
        let query = this.getBaseListRequestString(request);
        if (request.meetingId) {
            query += `&meetingId=${request.meetingId}`;
        }
        if (request.serverId) {
            query += `&serverId=${request.serverId}`;
        }
        if (request.attendeeId) {
            query += `&attendeeId=${request.attendeeId}`;
        }
        if (request.recordingUrlTtl)
            query += `&recordingUrlTtl=${request.recordingUrlTtl}`;
        return await this._httpClient.get(`${this._meetingRecordingsPath}?${query}`, abortSignal);
    }
    async listMeetingRecordingsByUserAccountId(userAccountId, request, abortSignal) {
        Guard.isNotNullOrUndefined(request, "request");
        let query = this.getBaseListRequestString(request);
        if (request.meetingId) {
            query += `&meetingId=${request.meetingId}`;
        }
        if (request.serverId) {
            query += `&serverId=${request.serverId}`;
        }
        if (request.attendeeId) {
            query += `&attendeeId=${request.attendeeId}`;
        }
        if (request.recordingUrlTtl)
            query += `&recordingUrlTtl=${request.recordingUrlTtl}`;
        return await this._httpClient.get(`${this._meetingRecordingsPath}/userAccount/${userAccountId}?${query}`, abortSignal);
    }
    async listMeetings(request, abortSignal) {
        Guard.isNotNullOrUndefined(request, "request");
        let query = this.getBaseListRequestString(request);
        if (request.roomId) {
            query += `&roomId=${request.roomId}`;
        }
        if (request.clusterId) {
            query += `&clusterId=${request.clusterId}`;
        }
        if (request.scheduleId) {
            query += `&scheduleId=${request.scheduleId}`;
        }
        if (request.userAccountId) {
            query += `&userAccountId=${request.userAccountId}`;
        }
        if (request.filterTerm) {
            query += `&filterTerm=${request.filterTerm}`;
        }
        if (request.filterListType && request.filterListType.length > 0) {
            for (let i = 0; i < request.filterListType.length; i++) {
                query += `&filterListType=${request.filterListType[i]}`;
            }
        }
        if (request.filterListStatus && request.filterListStatus.length > 0) {
            for (let i = 0; i < request.filterListStatus.length; i++) {
                query += `&filterListStatus=${request.filterListStatus[i]}`;
            }
        }
        if (request.status && request.status.length > 0) {
            for (let i = 0; i < request.status.length; i++) {
                query += `&status=${request.status[i]}`;
            }
        }
        return await this._httpClient.get(`${this._meetingsPath}?${query}`, abortSignal);
    }
    async listMeetingsByUserAccountId(userAccountId, request, abortSignal) {
        Guard.isNotNullOrUndefined(request, "request");
        let query = this.getBaseListRequestString(request);
        if (request.roomId) {
            query += `&roomId=${request.roomId}`;
        }
        if (request.clusterId) {
            query += `&clusterId=${request.clusterId}`;
        }
        if (request.scheduleId) {
            query += `&scheduleId=${request.scheduleId}`;
        }
        if (request.userAccountId) {
            query += `&userAccountId=${request.userAccountId}`;
        }
        if (request.filterTerm) {
            query += `&filterTerm=${request.filterTerm}`;
        }
        if (request.filterListType && request.filterListType.length > 0) {
            for (let i = 0; i < request.filterListType.length; i++) {
                query += `&filterListType=${request.filterListType[i]}`;
            }
        }
        if (request.filterListStatus && request.filterListStatus.length > 0) {
            for (let i = 0; i < request.filterListStatus.length; i++) {
                query += `&filterListStatus=${request.filterListStatus[i]}`;
            }
        }
        if (request.status && request.status.length > 0) {
            for (let i = 0; i < request.status.length; i++) {
                query += `&status=${request.status[i]}`;
            }
        }
        return await this._httpClient.get(`${this._meetingsPath}/useraccount/${userAccountId}?${query}`, abortSignal);
    }
    async listMeetingSettings(request, abortSignal) {
        Guard.isNotNullOrUndefined(request, "request");
        return await this._httpClient.get(`${this._meetingSettingsPath}?${this.getBaseListRequestString(request)}`, abortSignal);
    }
    async listPermissions(request, abortSignal) {
        Guard.isNotNullOrUndefined(request, "request");
        return await this._httpClient.get(`${this._permissionsPath}?${this.getBaseListRequestString(request)}`, abortSignal);
    }
    async listRooms(request, abortSignal) {
        Guard.isNotNullOrUndefined(request, "request");
        let query = this.getBaseListRequestString(request);
        if (request.key) {
            query += `&key=${request.key}`;
        }
        if (request.clusterId) {
            query += `&clusterId=${request.clusterId}`;
        }
        if (request.userAccountId) {
            query += `&userAccountId=${request.userAccountId}`;
        }
        return await this._httpClient.get(`${this._roomsPath}?${query}`, abortSignal);
    }
    async listRoomSchedules(request, abortSignal) {
        Guard.isNotNullOrUndefined(request, "request");
        let query = this.getBaseListRequestString(request);
        if (request.roomId) {
            query += `&roomId=${request.roomId}`;
        }
        return await this._httpClient.get(`${this._roomSchedulesPath}?${query}`, abortSignal);
    }
    async listRoomSipInboundNumbers(request, abortSignal) {
        Guard.isNotNullOrUndefined(request, "request");
        let query = this.getBaseListRequestString(request);
        if (request.roomId) {
            query += `&roomId=${request.roomId}`;
        }
        return await this._httpClient.get(`${this._roomSipInboundNumbersPath}?${query}`, abortSignal);
    }
    async listRoomUserAccounts(request, abortSignal) {
        Guard.isNotNullOrUndefined(request, "request");
        let query = this.getBaseListRequestString(request);
        if (request.roomId) {
            query += `&roomId=${request.roomId}`;
        }
        if (request.userAccountId) {
            query += `&userAccountId=${request.userAccountId}`;
        }
        if (request.filterListType && request.filterListType.length > 0) {
            for (let i = 0; i < request.filterListType.length; i++) {
                query += `&filterListType=${request.filterListType[i]}`;
            }
        }
        if (request.filterListStatus && request.filterListStatus.length > 0) {
            for (let i = 0; i < request.filterListStatus.length; i++) {
                query += `&filterListStatus=${request.filterListStatus[i]}`;
            }
        }
        return await this._httpClient.get(`${this._roomUserAccountsPath}?${query}`, abortSignal);
    }
    async listServers(request, abortSignal) {
        Guard.isNotNullOrUndefined(request, "request");
        return await this._httpClient.get(`${this._serversPath}?${this.getBaseListRequestString(request)}`, abortSignal);
    }
    async listServerSettings(request, abortSignal) {
        Guard.isNotNullOrUndefined(request, "request");
        return await this._httpClient.get(`${this._serverSettingsPath}?${this.getBaseListRequestString(request)}`, abortSignal);
    }
    async listServerSettingsByServerId(serverId, abortSignal) {
        Guard.isNotNullOrUndefined(serverId, "serverId");
        return await this._httpClient.get(`${this._serversPath}/${serverId}/settings`, abortSignal);
    }
    async listSipInboundNumbers(request, abortSignal) {
        Guard.isNotNullOrUndefined(request, "request");
        let query = this.getBaseListRequestString(request);
        if (request.clusterId) {
            query += `&clusterId=${request.clusterId}`;
        }
        if (request.countryId) {
            query += `&countryId=${request.countryId}`;
        }
        if (request.filterListType && request.filterListType.length > 0) {
            for (let i = 0; i < request.filterListType.length; i++) {
                query += `&filterListType=${request.filterListType[i]}`;
            }
        }
        if (request.filterListStatus && request.filterListStatus.length > 0) {
            for (let i = 0; i < request.filterListStatus.length; i++) {
                query += `&filterListStatus=${request.filterListStatus[i]}`;
            }
        }
        return await this._httpClient.get(`${this._sipInboundNumbersPath}?${query}`, abortSignal);
    }
    async listTenants(request, abortSignal) {
        Guard.isNotNullOrUndefined(request, "request");
        return await this._httpClient.get(`${this._tenantsPath}?${this.getBaseListRequestString(request)}`, abortSignal);
    }
    async listTenantSettings(request, abortSignal) {
        Guard.isNotNullOrUndefined(request, "request");
        return await this._httpClient.get(`${this._tenantSettingsPath}?${this.getBaseListRequestString(request)}`, abortSignal);
    }
    async listTenantSettingsByTenantId(tenantId, abortSignal) {
        Guard.isNotNullOrUndefined(tenantId, "tenantId");
        return await this._httpClient.get(`${this._tenantsPath}/${tenantId}/settings`, abortSignal);
    }
    async listTenantUserAccounts(request, abortSignal) {
        Guard.isNotNullOrUndefined(request, "request");
        return await this._httpClient.get(`${this._tenantUserAccountsPath}?${this.getBaseListRequestString(request)}`, abortSignal);
    }
    async listUserAccounts(request, abortSignal) {
        Guard.isNotNullOrUndefined(request, "request");
        return await this._httpClient.get(`${this._userAccountsPath}?${this.getBaseListRequestString(request)}`, abortSignal);
    }
    async listUserAccountPermissionsByUserAccountId(userAccountId, abortSignal) {
        Guard.isNotNullOrUndefined(userAccountId, "userAccountId");
        return await this._httpClient.get(`${this._userAccountsPath}/${userAccountId}/permissions`, abortSignal);
    }
    async listUserAccountSettingsByUserAccountId(userAccountId, abortSignal) {
        Guard.isNotNullOrUndefined(userAccountId, "userAccountId");
        return await this._httpClient.get(`${this._userAccountsPath}/${userAccountId}/settings`, abortSignal);
    }
    async listWebhooks(request, abortSignal) {
        Guard.isNotNullOrUndefined(request, "request");
        let query = this.getBaseListRequestString(request);
        if (request.tenantId) {
            query += `&tenantId=${request.tenantId}`;
        }
        if (request.userAccountId) {
            query += `&userAccountId=${request.userAccountId}`;
        }
        return await this._httpClient.get(`${this._webhooksPath}?${query}`, abortSignal);
    }
    async startMeetingRecording(meetingRecordingId, request, abortSignal) {
        Guard.isNotNullOrUndefined(meetingRecordingId, "meetingRecordingId");
        Guard.isNotNullOrUndefined(request, "request");
        return await this._httpClient.put(`${this._meetingRecordingsPath}/startrecording/${meetingRecordingId}`, request, abortSignal);
    }
    async stopMeetingRecording(meetingRecordingId, request, abortSignal) {
        Guard.isNotNullOrUndefined(meetingRecordingId, "meetingRecordingId");
        Guard.isNotNullOrUndefined(request, "request");
        return await this._httpClient.put(`${this._meetingRecordingsPath}/stoprecording/${meetingRecordingId}`, request, abortSignal);
    }
    async updateAccount(accountId, request, abortSignal) {
        Guard.isNotNullOrUndefined(accountId, "accountId");
        Guard.isNotNullOrUndefined(request, "request");
        return await this._httpClient.put(`${this._accountsPath}/${accountId}`, request, abortSignal);
    }
    async updateApiKey(apiKeyId, request, abortSignal) {
        Guard.isNotNullOrUndefined(apiKeyId, "apiKeyId");
        Guard.isNotNullOrUndefined(request, "request");
        return await this._httpClient.put(`${this._apiKeysPath}/${apiKeyId}`, request, abortSignal);
    }
    async updateAttendeePermission(attendeePermissionId, request, abortSignal) {
        Guard.isNotNullOrUndefined(attendeePermissionId, "attendeePermissionId");
        Guard.isNotNullOrUndefined(request, "request");
        return await this._httpClient.put(`${this._attendeePermissionsPath}/${attendeePermissionId}`, request, abortSignal);
    }
    async updateAttendeeRole(attendeeId, role, abortSignal) {
        Guard.isNotNullOrUndefined(attendeeId, "attendeeId");
        Guard.isNotNullOrUndefined(role, "role");
        return await this._httpClient.post(`${this._attendeesPath}/${attendeeId}/update-attendeerole`, { value: `${role}` }, abortSignal);
    }
    async updateCluster(clusterId, request, abortSignal) {
        Guard.isNotNullOrUndefined(clusterId, "clusterId");
        Guard.isNotNullOrUndefined(request, "request");
        return await this._httpClient.put(`${this._clustersPath}/${clusterId}`, request, abortSignal);
    }
    async updateClusterSetting(request, abortSignal) {
        Guard.isNotNullOrUndefined(request, "request");
        return await this._httpClient.put(`${this._clusterSettingsPath}`, request, abortSignal);
    }
    async updateCountry(countryId, request, abortSignal) {
        Guard.isNotNullOrUndefined(countryId, "countryId");
        Guard.isNotNullOrUndefined(request, "request");
        return await this._httpClient.put(`${this._countiresPath}/${countryId}`, request, abortSignal);
    }
    async updateMeetingInvite(meetingInviteId, request, abortSignal) {
        Guard.isNotNullOrUndefined(meetingInviteId, "meetingInviteId");
        Guard.isNotNullOrUndefined(request, "request");
        return await this._httpClient.put(`${this._meetingInvitesPath}/${meetingInviteId}`, request, abortSignal);
    }
    async updateMeetingPlan(meetingPlanId, request, abortSignal) {
        Guard.isNotNullOrUndefined(meetingPlanId, "meetingPlanId");
        Guard.isNotNullOrUndefined(request, "request");
        return await this._httpClient.put(`${this._meetingPlansPath}/${meetingPlanId}`, request, abortSignal);
    }
    async updateMeetingPlanServer(meetingPlanServerId, request, abortSignal) {
        Guard.isNotNullOrUndefined(meetingPlanServerId, "meetingPlanServerId");
        Guard.isNotNullOrUndefined(request, "request");
        return await this._httpClient.put(`${this._meetingPlanServersPath}/${meetingPlanServerId}`, request, abortSignal);
    }
    async updateMeetingPlanSlot(meetingPlanSlotId, request, abortSignal) {
        Guard.isNotNullOrUndefined(meetingPlanSlotId, "meetingPlanSlotId");
        Guard.isNotNullOrUndefined(request, "request");
        return await this._httpClient.put(`${this._meetingPlanSlotsPath}/${meetingPlanSlotId}`, request, abortSignal);
    }
    async updateMeetingSetting(meetingSettingId, request, abortSignal) {
        Guard.isNotNullOrUndefined(meetingSettingId, "meetingSettingId");
        Guard.isNotNullOrUndefined(request, "request");
        return await this._httpClient.put(`${this._meetingSettingsPath}/${meetingSettingId}`, request, abortSignal);
    }
    async updatePermission(permissionId, request, abortSignal) {
        Guard.isNotNullOrUndefined(permissionId, "permissionId");
        Guard.isNotNullOrUndefined(request, "request");
        return await this._httpClient.put(`${this._permissionsPath}/${permissionId}`, request, abortSignal);
    }
    async updatePlanTemplate(planTemplateId, request, abortSignal) {
        Guard.isNotNullOrUndefined(planTemplateId, "planTemplateId");
        Guard.isNotNullOrUndefined(request, "request");
        return await this._httpClient.put(`${this._planTemplatesPath}/${planTemplateId}`, request, abortSignal);
    }
    async updateRoom(roomId, request, abortSignal) {
        Guard.isNotNullOrUndefined(roomId, "roomId");
        Guard.isNotNullOrUndefined(request, "request");
        return await this._httpClient.put(`${this._roomsPath}/${roomId}`, request, abortSignal);
    }
    async updateRoomSchedule(roomScheduleId, request, abortSignal) {
        Guard.isNotNullOrUndefined(roomScheduleId, "roomScheduleId");
        Guard.isNotNullOrUndefined(request, "request");
        return await this._httpClient.put(`${this._roomSchedulesPath}/${roomScheduleId}`, request, abortSignal);
    }
    async updateRoomSipInboundNumber(roomSipInboundNumberId, request, abortSignal) {
        Guard.isNotNullOrUndefined(roomSipInboundNumberId, "roomSipInboundNumberId");
        Guard.isNotNullOrUndefined(request, "request");
        return await this._httpClient.put(`${this._roomSipInboundNumbersPath}/${roomSipInboundNumberId}`, request, abortSignal);
    }
    async updateRoomUserAccount(roomUserAccountId, request, abortSignal) {
        Guard.isNotNullOrUndefined(roomUserAccountId, "roomUserAccountId");
        Guard.isNotNullOrUndefined(request, "request");
        return await this._httpClient.put(`${this._roomUserAccountsPath}/${roomUserAccountId}`, request, abortSignal);
    }
    async updateServer(serverId, request, abortSignal) {
        Guard.isNotNullOrUndefined(serverId, "serverId");
        Guard.isNotNullOrUndefined(request, "request");
        return await this._httpClient.put(`${this._serversPath}/${serverId}`, request, abortSignal);
    }
    async updateServerSetting(serverSettingId, request, abortSignal) {
        Guard.isNotNullOrUndefined(serverSettingId, "serverSettingId");
        Guard.isNotNullOrUndefined(request, "request");
        return await this._httpClient.put(`${this._serverSettingsPath}/${serverSettingId}`, request, abortSignal);
    }
    async updateTenant(tenantId, request, abortSignal) {
        Guard.isNotNullOrUndefined(tenantId, "tenantId");
        Guard.isNotNullOrUndefined(request, "request");
        return await this._httpClient.put(`${this._tenantsPath}/${tenantId}`, request, abortSignal);
    }
    async updateTenantSetting(tenantSettingId, request, abortSignal) {
        Guard.isNotNullOrUndefined(tenantSettingId, "tenantSettingId");
        Guard.isNotNullOrUndefined(request, "request");
        return await this._httpClient.put(`${this._tenantSettingsPath}/${tenantSettingId}`, request, abortSignal);
    }
    async updateTenantUserAccount(tenantUserAccountId, request, abortSignal) {
        Guard.isNotNullOrUndefined(tenantUserAccountId, "tenantUserAccountId");
        Guard.isNotNullOrUndefined(request, "request");
        return await this._httpClient.put(`${this._tenantUserAccountsPath}/${tenantUserAccountId}`, request, abortSignal);
    }
    async updateUserAccount(userAccountId, request, abortSignal) {
        Guard.isNotNullOrUndefined(userAccountId, "userAccountId");
        Guard.isNotNullOrUndefined(request, "request");
        return await this._httpClient.put(`${this._userAccountsPath}/${userAccountId}`, request, abortSignal);
    }
    async updateWebhook(webhookId, request, abortSignal) {
        Guard.isNotNullOrUndefined(webhookId, "userAccountId");
        Guard.isNotNullOrUndefined(request, "request");
        return await this._httpClient.put(`${this._webhooksPath}/${webhookId}`, request, abortSignal);
    }
    getBaseListRequestString(request) {
        let query = "";
        if (request.where) {
            query += `&where=${request.where}`;
        }
        if (request.orderBy) {
            query += `&orderby=${request.orderBy}`;
        }
        if (request.limit) {
            query += `&limit=${request.limit}`;
        }
        if (request.offset) {
            query += `&offset=${request.offset}`;
        }
        return query;
    }
};

var AccountPasswordHashLength;
(function (AccountPasswordHashLength) {
    AccountPasswordHashLength[AccountPasswordHashLength["Max"] = 512] = "Max";
})(AccountPasswordHashLength || (AccountPasswordHashLength = {}));
var AccountPasswordSaltLength;
(function (AccountPasswordSaltLength) {
    AccountPasswordSaltLength[AccountPasswordSaltLength["Max"] = 50] = "Max";
})(AccountPasswordSaltLength || (AccountPasswordSaltLength = {}));

var ChatChannelNameLength;
(function (ChatChannelNameLength) {
    ChatChannelNameLength[ChatChannelNameLength["Max"] = 100] = "Max";
})(ChatChannelNameLength || (ChatChannelNameLength = {}));

var ChatMessageContentLength;
(function (ChatMessageContentLength) {
    ChatMessageContentLength[ChatMessageContentLength["Max"] = 1024] = "Max";
})(ChatMessageContentLength || (ChatMessageContentLength = {}));
var ChatMessageFileNameLength;
(function (ChatMessageFileNameLength) {
    ChatMessageFileNameLength[ChatMessageFileNameLength["Max"] = 255] = "Max";
})(ChatMessageFileNameLength || (ChatMessageFileNameLength = {}));

var ChatMessageReactionContentLength;
(function (ChatMessageReactionContentLength) {
    ChatMessageReactionContentLength[ChatMessageReactionContentLength["Max"] = 255] = "Max";
})(ChatMessageReactionContentLength || (ChatMessageReactionContentLength = {}));

var ClusterTagTagLength;
(function (ClusterTagTagLength) {
    ClusterTagTagLength[ClusterTagTagLength["Max"] = 50] = "Max";
})(ClusterTagTagLength || (ClusterTagTagLength = {}));

var CountryCodeLength;
(function (CountryCodeLength) {
    CountryCodeLength[CountryCodeLength["Max"] = 3] = "Max";
})(CountryCodeLength || (CountryCodeLength = {}));
var CountryNameLength;
(function (CountryNameLength) {
    CountryNameLength[CountryNameLength["Max"] = 100] = "Max";
})(CountryNameLength || (CountryNameLength = {}));
var CountryNumericLength;
(function (CountryNumericLength) {
    CountryNumericLength[CountryNumericLength["Max"] = 3] = "Max";
})(CountryNumericLength || (CountryNumericLength = {}));

var DatabaseLogMessageLength;
(function (DatabaseLogMessageLength) {
    DatabaseLogMessageLength[DatabaseLogMessageLength["Max"] = 255] = "Max";
})(DatabaseLogMessageLength || (DatabaseLogMessageLength = {}));
var DatabaseLogNameLength;
(function (DatabaseLogNameLength) {
    DatabaseLogNameLength[DatabaseLogNameLength["Max"] = 255] = "Max";
})(DatabaseLogNameLength || (DatabaseLogNameLength = {}));
var DatabaseLogTypeLength;
(function (DatabaseLogTypeLength) {
    DatabaseLogTypeLength[DatabaseLogTypeLength["Max"] = 20] = "Max";
})(DatabaseLogTypeLength || (DatabaseLogTypeLength = {}));

var LocationNameLength;
(function (LocationNameLength) {
    LocationNameLength[LocationNameLength["Max"] = 100] = "Max";
})(LocationNameLength || (LocationNameLength = {}));

var PlanSettingNameLength;
(function (PlanSettingNameLength) {
    PlanSettingNameLength[PlanSettingNameLength["Max"] = 50] = "Max";
})(PlanSettingNameLength || (PlanSettingNameLength = {}));
var PlanSettingValueLength;
(function (PlanSettingValueLength) {
    PlanSettingValueLength[PlanSettingValueLength["Max"] = 255] = "Max";
})(PlanSettingValueLength || (PlanSettingValueLength = {}));

var RegionAbbreviationLength;
(function (RegionAbbreviationLength) {
    RegionAbbreviationLength[RegionAbbreviationLength["Max"] = 10] = "Max";
})(RegionAbbreviationLength || (RegionAbbreviationLength = {}));
var RegionCodeLength;
(function (RegionCodeLength) {
    RegionCodeLength[RegionCodeLength["Max"] = 3] = "Max";
})(RegionCodeLength || (RegionCodeLength = {}));
var RegionNameLength;
(function (RegionNameLength) {
    RegionNameLength[RegionNameLength["Max"] = 100] = "Max";
})(RegionNameLength || (RegionNameLength = {}));

var RoomSettingNameLength;
(function (RoomSettingNameLength) {
    RoomSettingNameLength[RoomSettingNameLength["Max"] = 50] = "Max";
})(RoomSettingNameLength || (RoomSettingNameLength = {}));
var RoomSettingValueLength;
(function (RoomSettingValueLength) {
    RoomSettingValueLength[RoomSettingValueLength["Max"] = 255] = "Max";
})(RoomSettingValueLength || (RoomSettingValueLength = {}));

var RoomSipInboundNumberPasscodeLength;
(function (RoomSipInboundNumberPasscodeLength) {
    RoomSipInboundNumberPasscodeLength[RoomSipInboundNumberPasscodeLength["Max"] = 20] = "Max";
})(RoomSipInboundNumberPasscodeLength || (RoomSipInboundNumberPasscodeLength = {}));
var RoomSipInboundNumberPasscodeHostLength;
(function (RoomSipInboundNumberPasscodeHostLength) {
    RoomSipInboundNumberPasscodeHostLength[RoomSipInboundNumberPasscodeHostLength["Max"] = 20] = "Max";
})(RoomSipInboundNumberPasscodeHostLength || (RoomSipInboundNumberPasscodeHostLength = {}));

var RoomStorageKeyLength;
(function (RoomStorageKeyLength) {
    RoomStorageKeyLength[RoomStorageKeyLength["Max"] = 100] = "Max";
})(RoomStorageKeyLength || (RoomStorageKeyLength = {}));
var RoomStorageUrlLength;
(function (RoomStorageUrlLength) {
    RoomStorageUrlLength[RoomStorageUrlLength["Max"] = 512] = "Max";
})(RoomStorageUrlLength || (RoomStorageUrlLength = {}));

var RoomTagTagLength;
(function (RoomTagTagLength) {
    RoomTagTagLength[RoomTagTagLength["Max"] = 50] = "Max";
})(RoomTagTagLength || (RoomTagTagLength = {}));

var ServerTagTagLength;
(function (ServerTagTagLength) {
    ServerTagTagLength[ServerTagTagLength["Max"] = 50] = "Max";
})(ServerTagTagLength || (ServerTagTagLength = {}));

var StorageKeyLength;
(function (StorageKeyLength) {
    StorageKeyLength[StorageKeyLength["Max"] = 100] = "Max";
})(StorageKeyLength || (StorageKeyLength = {}));
var StorageUrlLength;
(function (StorageUrlLength) {
    StorageUrlLength[StorageUrlLength["Max"] = 512] = "Max";
})(StorageUrlLength || (StorageUrlLength = {}));
var StorageRetentionUnitLength;
(function (StorageRetentionUnitLength) {
    StorageRetentionUnitLength[StorageRetentionUnitLength["Max"] = 20] = "Max";
})(StorageRetentionUnitLength || (StorageRetentionUnitLength = {}));

var TenantTagTagLength;
(function (TenantTagTagLength) {
    TenantTagTagLength[TenantTagTagLength["Max"] = 50] = "Max";
})(TenantTagTagLength || (TenantTagTagLength = {}));

var TimezoneNameLength;
(function (TimezoneNameLength) {
    TimezoneNameLength[TimezoneNameLength["Max"] = 50] = "Max";
})(TimezoneNameLength || (TimezoneNameLength = {}));

var TraceLogEnvironmentLength;
(function (TraceLogEnvironmentLength) {
    TraceLogEnvironmentLength[TraceLogEnvironmentLength["Max"] = 20] = "Max";
})(TraceLogEnvironmentLength || (TraceLogEnvironmentLength = {}));
var TraceLogComponentLength;
(function (TraceLogComponentLength) {
    TraceLogComponentLength[TraceLogComponentLength["Max"] = 255] = "Max";
})(TraceLogComponentLength || (TraceLogComponentLength = {}));
var TraceLogOperationLength;
(function (TraceLogOperationLength) {
    TraceLogOperationLength[TraceLogOperationLength["Max"] = 255] = "Max";
})(TraceLogOperationLength || (TraceLogOperationLength = {}));

var UserAccountSettingNameLength;
(function (UserAccountSettingNameLength) {
    UserAccountSettingNameLength[UserAccountSettingNameLength["Max"] = 50] = "Max";
})(UserAccountSettingNameLength || (UserAccountSettingNameLength = {}));
var UserAccountSettingValueLength;
(function (UserAccountSettingValueLength) {
    UserAccountSettingValueLength[UserAccountSettingValueLength["Max"] = 512] = "Max";
})(UserAccountSettingValueLength || (UserAccountSettingValueLength = {}));

var UserAccountTagTagLength;
(function (UserAccountTagTagLength) {
    UserAccountTagTagLength[UserAccountTagTagLength["Max"] = 50] = "Max";
})(UserAccountTagTagLength || (UserAccountTagTagLength = {}));

var _a$c;
let Constants$2 = class Constants {
};
_a$c = Constants$2;
Constants$2.Codecs = {
    H264: "video/H264",
    VP8: "video/VP8",
    VP9: "video/VP9",
    isValid: (codec) => {
        if (codec === _a$c.Codecs.H264 || codec === _a$c.Codecs.VP8 || codec == _a$c.Codecs.VP9) {
            return true;
        }
        return false;
    }
};
Constants$2.Errors = {
    Account: {
        invalidPasswordHashLength: `Password hash is not valid. It must be less than ${AccountPasswordHashLength.Max} characters.`,
        invalidPasswordSaltLength: `Password salt is not valid. It must be less than ${AccountPasswordSaltLength.Max} characters.`,
    },
    ApiKey: {
        invalidNameLength: `Name is not valid. It must be less than ${ApiKeyNameLength.Max} characters.`,
        invalidSecretLength: `Secret is not valid. It must be less than ${ApiKeySecretLength.Max} characters.`,
        invalidTypeLength: `Type is not valid. It must be less than ${ApiKeyTypeLength.Max} characters.`,
        invalidValueLength: `Value is not valid. It must be less than ${ApiKeyValueLength.Max} characters.`,
    },
    Attendee: {
        cannotLowerOtherAttendeesHand: "Cannot lower other attendees hand.",
        cannotRaiseOtherAttendeesHand: "Cannot raise other attendees hand.",
        cannotRefreshAttendeeList: "Attendee list cannot be refreshed until a meeting has been joined.",
        invalidClientTypeLength: `Client type is not valid. It must be less than ${AttendeeClientTypeLength.Max} characters.`,
        invalidDisplayNameLength: `Display name is not valid. It must be less than ${AttendeeDisplayNameLength.Max} characters.`,
        invalidSDKVersionLength: `SDK version is not valid. It must be less than ${AttendeeSdkVersionLength.Max} characters.`,
        invalidSipConnectorIDLength: `Sip connector ID is not valid. It must be less than ${AttendeeSipConnectorIdLength.Max} characters.`,
        invalidSourceLanguageLength: `Source language is not valid. It must be less than ${AttendeeSourceLanguageLength.Max} characters.`,
        Permissions: {
            update: "Insufficient permissions to update attendee.",
        }
    },
    ChatChannel: {
        invalidNameLength: `Name is not valid. It must be less than ${ChatChannelNameLength.Max} characters.`,
    },
    ChatMessage: {
        invalidContentLength: `Content is not valid. It must be less than ${ChatMessageContentLength.Max} characters.`,
        invalidFileNameLength: `Filename is not valid. It must be less than ${ChatMessageFileNameLength.Max} characters.`,
    },
    ChatMessageReaction: {
        invalidContentLength: `Content is not valid. It must be less than ${ChatMessageReactionContentLength.Max} characters.`,
    },
    Cluster: {
        invalidAdminAPIKeyLength: `Admin API Key is not valid. It must be less than ${ClusterAdminApiKeyLength.Max} characters.`,
        invalidAdminAPIUrlLength: `Admin API Url is not valid. It must be less than ${ClusterAdminApiUrlLength.Max} characters.`,
        invalidNameLength: `Name is not valid. It must be less than ${ClusterNameLength.Max} characters.`,
        invalidKeyLength: `Key is not valid. It must be less than ${ClusterKeyLength.Max} characters.`,
        invalidSecretLength: `Secret is not valid. It must be less than ${ClusterSecretLength.Max} characters.`,
        invalidUrlLength: `Url is not valid. It must be less than ${ClusterUrlLength.Max} characters.`,
        invalidMeetingUrlLength: `Meeting Url is not valid. It must be less than ${ClusterMeetingUrlLength.Max} characters.`,
        invalidSipUrlLength: `Sip Url is not valid. It must be less than ${ClusterSipUrlLength.Max} characters.`,
        invalidSipSecretLength: `Sip Secret is not valid. It must be less than ${ClusterSipSecretLength.Max} characters.`,
    },
    ClusterSetting: {
        invalidNameLength: `Name is not valid. It must be less than ${ClusterSettingNameLength.Max} characters.`,
        invalidTypeLength: `Type is not valid. It must be less than ${ClusterSettingTypeLength.Max} characters.`,
        invalidValueLength: `Value is not valid. It must be less than ${ClusterSettingValueLength.Max} characters.`,
    },
    ClusterTag: {
        invalidTagLength: `Tag is not valid. It must be less than ${ClusterTagTagLength.Max} characters.`,
    },
    Country: {
        invalidCodeLength: `Code is not valid. It must be less than ${CountryCodeLength.Max} characters.`,
        invalidNameLength: `Name is not valid. It must be less than ${CountryNameLength.Max} characters.`,
        invalidNumericLength: `Numeric is not valid. It must be less than ${CountryNumericLength.Max} characters.`,
    },
    DatabaseLog: {
        invalidEventMessageLength: `Event message is not valid. It must be less than ${DatabaseLogMessageLength.Max} characters.`,
        invalidEventNameLength: `Event name is not valid. It must be less than ${DatabaseLogNameLength.Max} characters.`,
        invalidEventTypeLength: `Event type is not valid. It must be less than ${DatabaseLogTypeLength.Max} characters.`,
    },
    Device: {
        invalidIdentifierLength: `Identifier is not valid. It must be less than ${DeviceIdentifierLength.Max} characters.`,
        invalidIPNumberLength: `IP number is not valid. It must be less than ${DeviceIpNumberLength.Max} characters.`,
        invalidPlatformLength: `Platform is not valid. It must be less than ${DevicePlatformLength.Max} characters.`,
        invalidPlatformVersionLength: `Platform Version is not valid. It must be less than ${DevicePlatformVersionLength.Max} characters.`,
    },
    General: {
        Operation: {
            aborted: "Operation aborted.",
        }
    },
    Location: {
        invalidNameLength: `Name is not valid. It must be less than ${LocationNameLength.Max} characters.`,
    },
    Media: {
        Destroy: {
            isDestroying: "Media is already destroying.",
            notInitialized: "Media cannot be destroyed until it is initialized.",
        },
        Devices: {
            Audio: {
                remoteCannotSet: "Remote tracks cannot set an audio device.",
                noTrack: "No audio track.",
            },
            Video: {
                remoteCannotSet: "Remote tracks cannot set a video device.",
                noTrack: "No video track.",
            }
        },
        Initialize: {
            isInitializing: "Media is already initializing.",
        },
        Permissions: {
            record: "Insufficient permissions to record.",
            canStart: "Insufficient permissions to start media.",
        },
        Start: {
            isDestroyed: "Media cannot be started after it is destroyed.",
            isStarting: "Media is already starting.",
            isStopping: "Media cannot be started while it is stopping.",
            notInitialized: "Media cannot be started until it is initialized.",
        },
        Stop: {
            isDestroyed: "Media cannot be stopped after it is destroyed.",
            isStarting: "Media cannot be stopped while it is starting.",
            isStopping: "Media is already stopping.",
            notInitialized: "Media cannot be stopped until it is initialized.",
        },
        Transform: {
            notSupported: "Transforms are not supported on this device.",
        },
    },
    Meeting: {
        notJoined: "Haven't joined the meeting.",
        noLobby: "Meeting does not have a lobby.",
        cannotSubscribe: "Could not subscribe to attendee.",
        Chat: {
            cannotUpdateDefaultChannel: "Cannot update the default channel.",
            cannotDeleteDefaultChannel: "Cannot delete the default channel.",
            cannotDisable: "Chat could not be disabled.",
            cannotEnable: "Chat could not be enabled.",
            cannotAddChatMember: "Unable to add member to chat.",
            cannotAddChatMemberToDefaultChannel: "Cannot add members to the default channel.",
            cannotFlagMessage: "Unable to flag chat message.",
            cannotSendMessage: "Could not send message.",
            cannotGetMessage: "Could not get message.",
            cannotGetChannel: "Error getting chat channel."
        },
        Permissions: {
            cannotAddPermission: "Insufficient permissions to add permission.",
            cannotAdmit: "Insufficient permissions to admit attendee.",
            cannotAdministerChat: "Insufficient permissions to administer chat.",
            cannotBlock: "Insufficient permissions to block attendee.",
            cannotChat: "Insufficient permissions to chat.",
            cannotCreateChatChannel: "Insufficient permissions to create chat channel.",
            cannotDeleteChatChannel: "Insufficient permissions to delete chat channel.",
            cannotUpdateChatChannel: "Insufficient permissions to update chat channel.",
            cannotCreateChatChannelMember: "Insufficient permissions to add member to chat channel.",
            cannotDeleteChatChannelMember: "Insufficient permissions to remove member from chat channel.",
            cannotUpdateChatChannelMember: "Insufficient permissions to update member in chat channel.",
            cannotDeleteChatMessage: "Insufficient permissions to delete chat message.",
            cannotUpdateChatMessage: "Insufficient permissions to update chat message.",
            cannotUpdateChatMessageNotOwner: "Cannot update message. You did not create it.",
            cannotDisableUnmute: "Insufficient permissions to disable unmute.",
            cannotDisableChat: "Insufficient permissions to disable chat.",
            cannotEnableChat: "Insufficient permissions to enable chat.",
            cannotEnableUnmute: "Insufficient permissions to enable unmute.",
            cannotKick: "Insufficient permissions to kick attendee.",
            cannotMute: "Insufficient permissions to mute attendee.",
            cannotRemovePermission: "Insufficient permissions to remove permission.",
            cannotSuppressNoise: "Insufficient permission to suppress audio noise for attendee.",
            cannotUpdateAttendee: "Insufficient permissions to update attendee.",
            cannotUpdateMeeting: "Insufficient permissions to update meeting.",
            cannotUnmute: "Insufficient permissions to unmute attendee.",
            cannotUnsuppressNoise: "Insufficient permission to unsuppress audio noise for attendee.",
            cannotRecordMeeting: "Insufficient permissions to start/stop recording.",
        },
        Join: {
            isJoining: "Already joining meeting.",
            isLeaving: "Cannot join meeting while you are leaving.",
        },
        Leave: {
            isJoining: "Cannot leave meeting while you are joining.",
            isLeaving: "Already leaving meeting.",
        },
        Recording: {
            cannotDisable: "Recording could not be disabled.",
            cannotEnable: "Recording could not be enabled.",
            cannotStart: "Recording could not be started.",
            cannotStop: "Recording could not be stopped.",
            isStarted: "Recording already started.",
            isStopped: "Recording already stopped.",
        }
    },
    MeetingInvite: {
        invalidEmailLength: `E-mail is not valid. It must be less than ${MeetingInviteEmailLength.Max} characters.`,
    },
    MeetingSetting: {
        invalidNameLength: `Name is not valid. It must be less than ${MeetingSettingNameLength.Max} characters.`,
        invalidValueLength: `Value is not valid. It must be less than ${MeetingSettingValueLength.Max} characters.`,
    },
    PlanSetting: {
        invalidNameLength: `Name is not valid. It must be less than ${PlanSettingNameLength.Max} characters.`,
        invalidValueLength: `Value is not valid. It must be less than ${PlanSettingValueLength.Max} characters.`,
    },
    PlanTemplate: {
        invalidNameLength: `Name is not valid. It must be less than ${PlanTemplateNameLength.Max} characters.`,
    },
    ReadOnlyCollection: {
        copyWithin: "copyWithin not allowed.",
        fill: "fill not allowed.",
        missingElement: "Missing required parameter 'element'.",
        missingKey: "Missing required parameter 'key'.",
        pop: "pop not allowed.",
        push: "push not allowed.",
        reverse: "reverse not allowed.",
        shift: "shift not allowed.",
        sort: "sort not allowed.",
        splice: "splice not allowed.",
        unshift: "unshift not allowed.",
    },
    Region: {
        invalidAbbreviationLength: `Abbreviation is not valid. It must be less than ${RegionAbbreviationLength.Max} characters.`,
        invalidCodeLength: `Code is not valid. It must be less than ${RegionCodeLength.Max} characters.`,
        invalidNameLength: `Name is not valid. It must be less than ${RegionNameLength.Max} characters.`,
    },
    Room: {
        invalidKeyLength: `Key is not valid. It must be between ${RoomKeyLength.Min} - ${RoomKeyLength.Max} characters.`,
    },
    RoomSchedule: {
        invalidRecurrenceLength: `Recurrence is not valid. It must be less than ${RoomScheduleRecurrenceLength.Max} characters.`,
    },
    RoomSetting: {
        invalidNameLength: `Name is not valid. It must be less than ${RoomSettingNameLength.Max} characters.`,
        invalidValueLength: `Value is not valid. It must be less than ${RoomSettingValueLength.Max} characters.`,
    },
    RoomSipInboundNumber: {
        invalidPasscodeLength: `Passcode is not valid. It must be less than ${RoomSipInboundNumberPasscodeLength.Max} characters.`,
        invalidPasscodeHostLength: `Passcode host is not valid. It must be less than ${RoomSipInboundNumberPasscodeHostLength.Max} characters.`,
    },
    RoomStorage: {
        invalidKeyLength: `Key is not valid. It must be less than ${RoomStorageKeyLength.Max} characters.`,
        invalidUrlLength: `Url is not valid. It must be less than ${RoomStorageUrlLength.Max} characters.`,
    },
    RoomTag: {
        invalidTagLength: `Tag is not valid. It must be less than ${RoomTagTagLength.Max} characters.`,
    },
    Server: {
        invalidNameLength: `Name is not valid. It must be less than ${ServerNameLength.Max} characters.`,
        invalidAppVersionLength: `App version is not valid. It must be less than ${ServerAppVersionLength.Max} characters.`,
        invalidArchitectureLength: `Architecture is not valid. It must be less than ${ServerArchitectureLength.Max} characters.`,
        invalidInternalHostLength: `Internal host is not valid. It must be less than ${ServerInternalHostLength.Max} characters.`,
        invalidInternalProtocolLength: `Internal protocol is not valid. It must be less than ${ServerInternalProtocolLength.Max} characters.`,
        invalidMediaHostLength: `Media host is not valid. It must be less than ${ServerMediaHostLength.Max} characters.`,
        invalidMediaProtocolLength: `Media protocol is not valid. It must be less than ${ServerMediaProtocolLength.Max} characters.`,
        invalidOperatingSystemLength: `Operating system is not valid. It must be less than ${ServerOperatingSystemLength.Max} characters.`,
        invalidOperatingSystemVersionLength: `Operating system version is not valid. It must be less than ${ServerOperatingSystemVersionLength.Max} characters.`,
        invalidExternalHostLength: `External host is not valid. It must be less than ${ServerExternalHostLength.Max} characters.`,
        invalidExternalProtocolLength: `External protocol is not valid. It must be less than ${ServerExternalProtocolLength.Max} characters.`,
    },
    ServerSetting: {
        invalidNameLength: `Name is not valid. It must be less than ${ServerSettingNameLength.Max} characters.`,
        invalidValueLength: `Value is not valid. It must be less than ${ServerSettingValueLength.Max} characters.`,
    },
    ServerTag: {
        invalidTagLength: `Tag is not valid. It must be less than ${ServerTagTagLength.Max} characters.`,
    },
    Storage: {
        invalidKeyLength: `Key is not valid. It must be less than ${StorageKeyLength.Max} characters.`,
        invalidUrlLength: `Url is not valid. It must be less than ${StorageUrlLength.Max} characters.`,
        invalidRetentionUnitLength: `Retention unit is not valid. It must be less than ${StorageRetentionUnitLength.Max} characters.`,
    },
    Tenant: {
        invalidBannerLength: `Banner is not valid. It must be less than ${TenantBannerLength.Max} characters.`,
        invalidImageLength: `Image is not valid. It must be less than ${TenantImageLength.Max} characters.`,
        invalidNameLength: `Name is not valid. It must be less than ${TenantNameLength.Max} characters.`,
        invalidUrlLength: `Url is not valid. It must be less than ${TenantUrlLength.Max} characters.`,
    },
    TenantSetting: {
        invalidNameLength: `Name is not valid. It must be less than ${TenantSettingNameLength.Max} characters.`,
        invalidValueLength: `Value is not valid. It must be less than ${TenantSettingValueLength.Max} characters.`,
    },
    TenantTag: {
        invalidTagLength: `Tag is not valid. It must be less than ${TenantTagTagLength.Max} characters.`,
    },
    Timezone: {
        invalidTimezoneNameLength: `Timezone name is not valid. It must be less than ${TimezoneNameLength.Max} characters.`,
    },
    TraceLog: {
        invalidEnvironmentLength: `Environment is not valid. It must be less than ${TraceLogEnvironmentLength.Max} characters.`,
        invalidComponentLength: `Component is not valid. It must be less than ${TraceLogComponentLength.Max} characters.`,
        invalidOperationLength: `Operation is not valid. It must be less than ${TraceLogOperationLength.Max} characters.`,
    },
    Track: {
        Destroy: {
            isDestroying: "Track is already destroying.",
            isStarting: "Track cannot be destroyed while it is starting.",
            isStopping: "Track cannot be destroyed while it is stopping.",
            isStarted: "Track cannot be destroyed until it is stopped.",
            notInitialized: "Track cannot be destroyed until it is initialized.",
        },
        Initialize: {
            isInitializing: "Track is already initializing.",
        },
        Start: {
            isDestroyed: "Track cannot be started after it is destroyed.",
            isStarting: "Track is already starting.",
            isStopping: "Track cannot be started while it is stopping.",
            notInitialized: "Track cannot be started until it is initialized.",
        },
        Stop: {
            isDestroyed: "Track cannot be stopped after it is destroyed.",
            isStarting: "Track cannot be stopped while it is starting.",
            isStopping: "Track is already stopping.",
            notInitialized: "Track cannot be stopped until it is initialized.",
        },
    },
    UserAccount: {
        invalidAvatarUrlLength: `Avatar Url is not valid. It must be less than ${UserAccountAvatarUrlLength.Max} characters.`,
        invalidDisplayNameLength: `Display name is not valid. It must be less than ${UserAccountDisplayNameLength.Max} characters.`,
        invalidUserNameLength: `Username is not valid. It must be less than ${UserAccountUserNameLength.Max} characters.`,
    },
    UserAccountSetting: {
        invalidNameLength: `Name is not valid. It must be less than ${UserAccountSettingNameLength.Max} characters.`,
        invalidValueLength: `Value is not valid. It must be less than ${UserAccountSettingValueLength.Max} characters.`,
    },
    UserAccountTag: {
        invalidTagLength: `Tag is not valid. It must be less than ${UserAccountTagTagLength.Max} characters.`,
    },
    Webhook: {
        invalidKeyLength: `Key is not valid. It must be less than ${WebhookKeyLength.Max} characters.`,
        invalidUrlLength: `Url is not valid. It must be less than ${WebhookUrlLength.Max} characters.`,
    },
};
Constants$2.Settings = {
    Meeting: {
        Chat: {
            DefaultMessageCollectionLoadLimit: 100,
        }
    }
};

class EventOwner {
    constructor() {
        this._handlers = [];
    }
    static get handleUncaughtExceptions() { return this._handleUncaughtExceptions; }
    static set handleUncaughtExceptions(value) { this._handleUncaughtExceptions = value; }
    /** @internal */
    get handlerCount() { return this._handlers.length; }
    /** @internal */
    dispatch(args) {
        for (const handler of this._handlers) {
            try {
                handler(args);
            }
            catch (error) {
                const errorMessage = error instanceof Error ? error.message : error;
                const handlerInfo = handler.name || 'anonymous handler';
                Log.error(`Error caught in event handler '${handlerInfo}': ${errorMessage}`);
                if (!EventOwner._handleUncaughtExceptions) {
                    throw error;
                }
            }
        }
    }
    bind(handler) {
        if (this._handlers.indexOf(handler) != -1)
            return false;
        this._handlers.push(handler);
        return true;
    }
    unbind(handler) {
        const index = this._handlers.indexOf(handler);
        if (index == -1)
            return false;
        this._handlers.splice(index, 1);
        return true;
    }
}
EventOwner._handleUncaughtExceptions = true;

class ReadOnlyCollection extends Array {
    get added() { return this._added; }
    get count() { return this.length; }
    get removed() { return this._removed; }
    /** @internal */
    constructor(keySelector) {
        super();
        this._added = new EventOwner();
        this._removed = new EventOwner();
        this._elementMap = new Map();
        this._keySelector = keySelector;
    }
    /** @internal */
    removeAll() {
        const elements = super.splice(0, this.length);
        this._elementMap.clear();
        elements.forEach(element => {
            this._removed.dispatch({
                element: element,
            });
        });
        return elements;
    }
    /** @internal */
    tryAdd(element) {
        Guard.isNotNullOrUndefined(element, "element");
        const key = this._keySelector(element);
        if (this._elementMap.has(key))
            return false;
        this._elementMap.set(key, element);
        super.push(element);
        this._added.dispatch({
            element: element,
        });
        return true;
    }
    /** @internal */
    tryInsert(element, index) {
        Guard.isNotNullOrUndefined(element, "element");
        Guard.isNotNullOrUndefined(index, "index");
        Guard.isLessThanOrEqualTo(index, this.length, "index");
        const key = this._keySelector(element);
        if (this._elementMap.has(key))
            return false;
        this._elementMap.set(key, element);
        super.splice(index, 0, element);
        this._added.dispatch({
            element: element,
        });
        return true;
    }
    /** @internal */
    tryRemove(key) {
        Guard.isNotNullOrUndefined(key, "key");
        const element = this._elementMap.get(key);
        if (element == null)
            return false;
        const index = this.indexOf(element);
        super.splice(index, 1);
        this._elementMap.delete(key);
        this._removed.dispatch({
            element: element,
        });
        return true;
    }
    /** @internal */
    tryReplace(key, element) {
        Guard.isNotNullOrUndefined(key, "key");
        const oldElement = this._elementMap.get(key);
        if (oldElement == null)
            return false;
        const newKey = this._keySelector(element);
        if (this._elementMap.has(newKey))
            return false;
        // splice is required to support reactive frameworks
        const index = this.indexOf(oldElement);
        super.splice(index, 1, element);
        this._elementMap.delete(key);
        this._elementMap.set(newKey, element);
        this._removed.dispatch({
            element: oldElement,
        });
        this._added.dispatch({
            element: element,
        });
        return true;
    }
    /**
     * Checks if an element with a given key exists in the collection.
     * @param key The element key.
     * @returns true if the element exists; otherwise, false.
     */
    containsKey(key) {
        return this._elementMap.has(key);
    }
    /**
     * This method is not allowed and will throw an error if invoked.
     * @param target This parameter is not used.
     * @param start This parameter is not used.
     * @param end This parameter is not used.
     */
    copyWithin(target, start, end) {
        throw new Error(Constants$2.Errors.ReadOnlyCollection.copyWithin);
    }
    /**
     * This method is not allowed and will throw an error if invoked.
     * @param value This parameter is not used.
     * @param start This parameter is not used.
     * @param end This parameter is not used.
     */
    fill(value, start, end) {
        throw new Error(Constants$2.Errors.ReadOnlyCollection.fill);
    }
    /**
     * Gets an element from the collection.
     * @param key The element key.
     * @returns The element if the key exists; otherwise null.
     */
    get(key) {
        Guard.isNotNullOrUndefined(key, "key");
        if (this.containsKey(key)) {
            return this._elementMap.get(key);
        }
        return null;
    }
    /**
     * This method is not allowed and will throw an error if invoked.
     */
    pop() {
        throw new Error(Constants$2.Errors.ReadOnlyCollection.pop);
    }
    /**
     * This method is not allowed and will throw an error if invoked.
     * @param items This parameter is not used.
     */
    push(...items) {
        throw new Error(Constants$2.Errors.ReadOnlyCollection.push);
    }
    /**
     * This method is not allowed and will throw an error if invoked.
     */
    reverse() {
        throw new Error(Constants$2.Errors.ReadOnlyCollection.reverse);
    }
    /**
     * This method is not allowed and will throw an error if invoked.
     */
    shift() {
        throw new Error(Constants$2.Errors.ReadOnlyCollection.shift);
    }
    /**
     * This method is not allowed and will throw an error if invoked.
     * @param compareFn This parameter is not used.
     */
    sort(compareFn) {
        throw new Error(Constants$2.Errors.ReadOnlyCollection.sort);
    }
    /**
     * This method is not allowed and will throw an error if invoked.
     * @param start This parameter is not used.
     * @param deleteCount This parameter is not used.
     * @param rest This parameter is not used.
     */
    splice(start, deleteCount, ...rest) {
        throw new Error(Constants$2.Errors.ReadOnlyCollection.splice);
    }
    /**
     * This method is not allowed and will throw an error if invoked.
     * @param items This parameter is not used.
     */
    unshift(...items) {
        throw new Error(Constants$2.Errors.ReadOnlyCollection.unshift);
    }
}

class AttendeeSettingCollection extends ReadOnlyCollection {
    /** @internal */
    constructor() {
        super(attendeeSetting => attendeeSetting.name);
    }
}

class DispatchQueue {
    constructor() {
        this._queue = [];
        this._active = false;
    }
    async processQueue() {
        while (this._queue.length > 0) {
            const item = this._queue.splice(0, 1)[0];
            try {
                item.resolve(await item.task());
            }
            catch (reason) {
                item.reject(reason);
            }
        }
        this._active = false;
    }
    dispatch(task) {
        return new Promise((resolve, reject) => {
            this._queue.push({
                resolve: resolve,
                reject: reject,
                task: task,
            });
            if (this._active)
                return;
            this._active = true;
            setTimeout(() => void this.processQueue(), 0);
        });
    }
}

class EventOwnerAsync {
    constructor() {
        this._handlers = [];
    }
    static get handleUncaughtExceptions() { return this._handleUncaughtExceptions; }
    static set handleUncaughtExceptions(value) { this._handleUncaughtExceptions = value; }
    /** @internal */
    get handlerCount() { return this._handlers.length; }
    /** @internal */
    async dispatch(args) {
        for (const handler of this._handlers) {
            try {
                await handler(args);
            }
            catch (error) {
                const errorMessage = error instanceof Error ? error.message : error;
                const handlerInfo = handler.name || 'anonymous handler';
                Log.error(`Error caught in event handler '${handlerInfo}': ${errorMessage}`);
                if (!EventOwnerAsync._handleUncaughtExceptions) {
                    throw error;
                }
            }
        }
    }
    bind(handler) {
        this._handlers.push(handler);
    }
    unbind(handler) {
        this._handlers = this._handlers.filter(h => h != handler);
    }
}
EventOwnerAsync._handleUncaughtExceptions = true;

class Permissions {
    static hasPermission(attendee, permissionType, permissionName) {
        return attendee?.permissions?.indexOf(`${permissionType}:${permissionName}`) !== -1;
    }
    static getPermissionTypeFromName(permissionName) {
        let permissionType = "ATTENDEE";
        switch (permissionName) {
            case "AdministerChat":
            case "CreateChannel":
            case "DeleteChannel":
            case "UpdateChannel":
            case "DeleteMessage":
            case "SendMessage":
                permissionType = "CHAT";
                break;
            case "EnableChat":
            case "RecordMeeting":
                permissionType = "MEETING";
                break;
            case "DeleteUserAccountLink":
            case "HostLargeMeeting":
                permissionType = "USERACCOUNT";
                break;
            case "EnableSip":
            case "ManageStorage":
                permissionType = "ROOM";
        }
        return permissionType;
    }
}

class Attendee {
    /** @internal */
    set avatarUrl(value) { this._model.avatarUrl = value; }
    /** @internal */
    get canBlock() { return Permissions.hasPermission(this, "ATTENDEE", "BlockAttendee"); }
    /** @internal */
    get canCreateChatChannel() { return Permissions.hasPermission(this, "CHAT", "CreateChannel"); }
    /** @internal */
    get canDeleteChatChannel() { return Permissions.hasPermission(this, "CHAT", "DeleteChannel"); }
    /** @internal */
    get canDeleteChatMessage() { return Permissions.hasPermission(this, "CHAT", "DeleteMessage"); }
    /** @internal */
    get canEnableChat() { return Permissions.hasPermission(this, "MEETING", "EnableChat"); }
    /** @internal */
    get canKick() { return Permissions.hasPermission(this, "ATTENDEE", "KickAttendee"); }
    /** @internal */
    get canMute() { return Permissions.hasPermission(this, "ATTENDEE", "MuteAttendee"); }
    /** @internal */
    get canReceiveMedia() { return Permissions.hasPermission(this, "ATTENDEE", "ReceiveMedia"); }
    /** @internal */
    get canRecord() { return Permissions.hasPermission(this, "MEETING", "RecordMeeting"); }
    /** @internal */
    get canSendChatMessage() { return Permissions.hasPermission(this, "CHAT", "SendMessage"); }
    /** @internal */
    get canSendUserMedia() { return Permissions.hasPermission(this, "ATTENDEE", "SendUserMedia"); }
    /** @internal */
    get canSendDisplayMedia() { return Permissions.hasPermission(this, "ATTENDEE", "SendDisplayMedia"); }
    /** @internal */
    get canUpdate() { return Permissions.hasPermission(this, "ATTENDEE", "UpdateAttendee"); }
    /** @internal */
    get canUnmute() { return Permissions.hasPermission(this, "ATTENDEE", "UnmuteAttendee"); }
    /** @internal */
    set displayName(value) { this._model.displayName = value; }
    /** @internal */
    set isPinned(value) { this._isPinned = value; }
    /** @internal */
    get model() { return this._model; }
    /** @internal */
    set model(value) { this._model = value; }
    /** @internal */
    set permissions(value) { this._model.permissions = value; }
    /** @internal */
    set role(value) { this._model.role = value; }
    /** @event */
    get audioMuted() { return this._audioMuted; }
    /** @event */
    get audioPaused() { return this._audioPaused; }
    /** @event */
    get audioResumed() { return this._audioResumed; }
    /** @event */
    get audioUnmuted() { return this._audioUnmuted; }
    /** @event */
    get audioUnmuteDisabled() { return this._audioUnmuteDisabled; }
    /** @event */
    get audioUnmuteEnabled() { return this._audioUnmuteEnabled; }
    /** @event */
    get avatarUrlUpdated() { return this._avatarUrlUpdated; }
    /** @event */
    get displayNameUpdated() { return this._displayNameUpdated; }
    /** @event */
    get handRaised() { return this._handRaised; }
    /** @event */
    get handLowered() { return this._handLowered; }
    /** @event */
    get mediaBound() { return this._mediaBound; }
    /** @event */
    get mediaUnbound() { return this._mediaUnbound; }
    /** @event */
    get networkStatusReceiveUpdated() { return this._networkStatusReceiveUpdated; }
    /** @event */
    get networkStatusSendUpdated() { return this._networkStatusSendUpdated; }
    /** @event */
    get noiseSuppressed() { return this._noiseSuppressed; }
    /** @event */
    get noiseUnsuppressed() { return this._noiseUnsuppressed; }
    /** @event */
    get permissionAdded() { return this._permissionAdded; }
    /** @event */
    get permissionRemoved() { return this._permissionRemoved; }
    /** @event */
    get permissionsUpdated() { return this._permissionsUpdated; }
    /** @event */
    get qualityUpdated() { return this._qualityUpdated; }
    /** @event */
    get roleUpdated() { return this._roleUpdated; }
    /** @event */
    get settingAdded() { return this._settingAdded; }
    /** @event */
    get settingRemoved() { return this._settingRemoved; }
    /** @event */
    get videoMuted() { return this._videoMuted; }
    /** @event */
    get videoPaused() { return this._videoPaused; }
    /** @event */
    get videoResumed() { return this._videoResumed; }
    /** @event */
    get videoUnmuted() { return this._videoUnmuted; }
    /** @event */
    get videoUnmuteDisabled() { return this._videoUnmuteDisabled; }
    /** @event */
    get videoUnmuteEnabled() { return this._videoUnmuteEnabled; }
    get avatarUrl() { return this._model.avatarUrl; }
    get displayName() { return this._model.displayName; }
    get id() { return this._model.id; }
    get isAudioMuted() { return this._model.isUserAudioMuted; }
    get isAudioPaused() { return this._model.isUserAudioPaused; }
    get isAudioUnmuteDisabled() { return !this._model.allowUnmuteAudio; }
    get isLocal() { return this._isLocal; }
    get isNoiseSuppressed() { return this._model.isNoiseSuppressed; }
    get isPinned() { return this._isPinned; }
    get isRemote() { return !this._isLocal; }
    get isVideoMuted() { return this._model.isUserVideoMuted; }
    get isVideoPaused() { return this._model.isUserVideoPaused; }
    get isVideoUnmuteDisabled() { return !this._model.allowUnmuteVideo; }
    get media() { return this._media; }
    get networkStatusReceive() { return this._networkStatusReceive; }
    get networkStatusSend() { return this._networkStatusSend; }
    get permissions() { return this._model.permissions; }
    get quality() { return this._quality; }
    get role() { return this._model.role; }
    get settings() { return this._settings; }
    get status() { return this._model.status; }
    get type() { return this._model.type; }
    get userAccountId() { return this._model.userAccountId; }
    /** @internal */
    constructor(init) {
        this._audioMuted = new EventOwnerAsync();
        this._audioPaused = new EventOwnerAsync();
        this._audioResumed = new EventOwnerAsync();
        this._audioUnmuted = new EventOwnerAsync();
        this._audioUnmuteDisabled = new EventOwnerAsync();
        this._audioUnmuteEnabled = new EventOwnerAsync();
        this._avatarUrlUpdated = new EventOwnerAsync();
        this._displayNameUpdated = new EventOwnerAsync();
        this._eventQueue = new DispatchQueue();
        this._handRaised = new EventOwnerAsync();
        this._handLowered = new EventOwnerAsync();
        this._mediaBound = new EventOwnerAsync();
        this._mediaUnbound = new EventOwner();
        this._networkStatusReceiveUpdated = new EventOwnerAsync();
        this._networkStatusSendUpdated = new EventOwnerAsync();
        this._noiseSuppressed = new EventOwnerAsync();
        this._noiseUnsuppressed = new EventOwnerAsync();
        this._permissionAdded = new EventOwnerAsync();
        this._permissionRemoved = new EventOwnerAsync();
        this._permissionsUpdated = new EventOwnerAsync();
        this._qualityUpdated = new EventOwnerAsync();
        this._roleUpdated = new EventOwnerAsync();
        this._settings = new AttendeeSettingCollection();
        this._settingAdded = new EventOwnerAsync();
        this._settingRemoved = new EventOwnerAsync();
        this._videoMuted = new EventOwnerAsync();
        this._videoPaused = new EventOwnerAsync();
        this._videoResumed = new EventOwnerAsync();
        this._videoUnmuted = new EventOwnerAsync();
        this._videoUnmuteDisabled = new EventOwnerAsync();
        this._videoUnmuteEnabled = new EventOwnerAsync();
        this._isPinned = false;
        this._media = null;
        this._model = null;
        this._networkStatusReceive = "unknown";
        this._networkStatusSend = "unknown";
        this._quality = "high";
        Guard.isNotNullOrUndefined(init, "init");
        Guard.isNotNullOrUndefined(init.controlConnection, "init.controlConnection");
        Guard.isNotNullOrUndefined(init.isLocal, "init.isLocal");
        Guard.isNotNullOrUndefined(init.meeting, "init.meeting");
        Guard.isNotNullOrUndefined(init.model, "init.model");
        this._controlConnection = init.controlConnection;
        this._isLocal = init.isLocal;
        this._meeting = init.meeting;
        this._model = init.model;
        this._model.settings?.forEach((setting) => {
            this._settings.tryAdd(setting);
        });
        this._networkStatusReceive = this.getNetworkStatusReceive();
        this._networkStatusSend = this.getNetworkStatusSend();
        this._quality = this.getQuality();
    }
    getQuality() {
        if (this._networkStatusReceive == "offline" || this._networkStatusSend == "offline" || this.isAudioPaused || this.isVideoPaused)
            return "low";
        if (this._networkStatusReceive == "degraded" || this._networkStatusSend == "degraded")
            return "medium";
        return "high";
    }
    getNetworkStatusReceive() {
        const edgeAudioQualityDisplay = this._model.edgeAudioQualityDisplay ?? null;
        const edgeAudioQualityUser = this._model.edgeAudioQualityUser ?? null;
        const edgeVideoQualityDisplay = this._model.edgeVideoQualityDisplay ?? null;
        const edgeVideoQualityUser = this._model.edgeVideoQualityUser ?? null;
        if (edgeAudioQualityDisplay == 0 ||
            edgeAudioQualityUser == 0 ||
            edgeVideoQualityDisplay == 0 ||
            edgeVideoQualityUser == 0)
            return "offline";
        if ((edgeAudioQualityDisplay > 0 && edgeAudioQualityDisplay < 1) ||
            (edgeAudioQualityUser > 0 && edgeAudioQualityUser < 1) ||
            (edgeVideoQualityDisplay > 0 && edgeVideoQualityDisplay < 1) ||
            (edgeVideoQualityUser > 0 && edgeVideoQualityUser < 1))
            return "degraded";
        if (edgeAudioQualityDisplay == 1 ||
            edgeAudioQualityUser == 1 ||
            edgeVideoQualityDisplay == 1 ||
            edgeVideoQualityUser == 1)
            return "online";
        return "unknown";
    }
    getNetworkStatusSend() {
        const originAudioQualityDisplay = this._model.originAudioQualityDisplay ?? null;
        const originAudioQualityUser = this._model.originAudioQualityUser ?? null;
        const originVideoQualityDisplay = this._model.originVideoQualityDisplay ?? null;
        const originVideoQualityUser = this._model.originVideoQualityUser ?? null;
        if (originAudioQualityDisplay == 0 ||
            originAudioQualityUser == 0 ||
            originVideoQualityDisplay == 0 ||
            originVideoQualityUser == 0)
            return "offline";
        if ((originAudioQualityDisplay > 0 && originAudioQualityDisplay < 1) ||
            (originAudioQualityUser > 0 && originAudioQualityUser < 1) ||
            (originVideoQualityDisplay > 0 && originVideoQualityDisplay < 1) ||
            (originVideoQualityUser > 0 && originVideoQualityUser < 1))
            return "degraded";
        if (originAudioQualityDisplay == 1 ||
            originAudioQualityUser == 1 ||
            originVideoQualityDisplay == 1 ||
            originVideoQualityUser == 1)
            return "online";
        return "unknown";
    }
    async tryUpdateQuality() {
        const quality = this.getQuality();
        if (quality == this._quality)
            return false;
        this._quality = quality;
        await this._qualityUpdated.dispatch({
            attendee: this
        });
        return true;
    }
    /** @internal */
    async bindMedia(media) {
        Guard.isNotNullOrUndefined(media, "media");
        if (this._media == media)
            return;
        this._media = media;
        await this._mediaBound.dispatch({
            attendee: this,
        });
    }
    /** @internal */
    async setHandRaised() {
        if (this._settings.tryAdd({ attendeeId: this.id, name: "handraised" })) {
            await this.handRaised.dispatch({ attendee: this });
        }
    }
    /** @internal */
    async setHandLowered() {
        if (this._settings.tryRemove("handraised")) {
            await this._handLowered.dispatch({ attendee: this });
        }
    }
    /** @internal */
    async processDisableAudioUnmute() {
        if (!this._model.allowUnmuteAudio)
            return;
        this._model.allowUnmuteAudio = false;
        await this.audioUnmuteDisabled.dispatch({ attendee: this });
    }
    /** @internal */
    async processDisableVideoUnmute() {
        if (!this._model.allowUnmuteVideo)
            return;
        this._model.allowUnmuteVideo = false;
        await this.videoUnmuteDisabled.dispatch({ attendee: this });
    }
    /** @internal */
    async processEnableAudioUnmute() {
        if (this._model.allowUnmuteAudio)
            return;
        this._model.allowUnmuteAudio = true;
        await this.audioUnmuteEnabled.dispatch({ attendee: this });
    }
    /** @internal */
    async processEnableVideoUnmute() {
        if (this._model.allowUnmuteVideo)
            return;
        this._model.allowUnmuteVideo = true;
        await this.videoUnmuteEnabled.dispatch({ attendee: this });
    }
    /** @internal */
    async processMuteAudio() {
        if (this._model.isUserAudioMuted)
            return;
        this._model.isUserAudioMuted = true;
        await this.audioMuted.dispatch({ attendee: this });
    }
    /** @internal */
    async processMuteVideo() {
        if (this._model.isUserVideoMuted)
            return;
        this._model.isUserVideoMuted = true;
        await this.videoMuted.dispatch({ attendee: this });
    }
    /** @internal */
    async processPausedUpdated(attendee) {
        // update model
        if (this._model.isDisplayAudioPaused != attendee.isDisplayAudioPaused) {
            this._model.isDisplayAudioPaused = attendee.isDisplayAudioPaused;
        }
        if (this._model.isDisplayVideoPaused != attendee.isDisplayVideoPaused) {
            this._model.isDisplayVideoPaused = attendee.isDisplayVideoPaused;
        }
        if (this._model.isUserAudioPaused != attendee.isUserAudioPaused) {
            this._model.isUserAudioPaused = attendee.isUserAudioPaused;
            if (this._model.isUserAudioPaused)
                this._audioPaused.dispatch({ attendee: this });
            else
                this._audioResumed.dispatch({ attendee: this });
        }
        if (this._model.isUserVideoPaused != attendee.isUserVideoPaused) {
            this._model.isUserVideoPaused = attendee.isUserVideoPaused;
            if (this._model.isUserVideoPaused)
                this._videoPaused.dispatch({ attendee: this });
            else
                this._videoResumed.dispatch({ attendee: this });
        }
        // update attendee quality
        await this.tryUpdateQuality();
    }
    /** @internal */
    async processPermissionAdded(permissionName) {
        const permissionType = Permissions.getPermissionTypeFromName(permissionName);
        const newPermission = `${permissionType}:${permissionName}`;
        if (this.permissions.indexOf(newPermission) == -1) {
            this.permissions.push(newPermission);
            await this.permissionAdded.dispatch({
                attendee: this,
                permission: `${permissionType}:${permissionName}`
            });
        }
    }
    /** @internal */
    async processPermissionRemoved(permissionName) {
        const permissionType = Permissions.getPermissionTypeFromName(permissionName);
        const removeAt = this.permissions.indexOf(`${permissionType}:${permissionName}`);
        if (removeAt != -1) {
            this.permissions.splice(removeAt, 1);
            await this.permissionRemoved.dispatch({
                attendee: this,
                permission: `${permissionType}:${permissionName}`
            });
        }
    }
    /** @internal */
    async processSettingAdded(setting) {
        if (this._settings.tryAdd(setting)) {
            await this.settingAdded.dispatch({ attendee: this, attendeeSetting: setting });
        }
    }
    /** @internal */
    async processSettingRemoved(setting) {
        if (this._settings.tryRemove(setting.name)) {
            await this.settingRemoved.dispatch({ attendee: this, attendeeSetting: setting });
        }
    }
    /** @internal */
    async processQualityEdgeUpdate(attendee) {
        // update model
        this._model.edgeAudioQualityDisplay = attendee.edgeAudioQualityDisplay;
        this._model.edgeAudioQualityUser = attendee.edgeAudioQualityUser;
        this._model.edgeVideoQualityDisplay = attendee.edgeVideoQualityDisplay;
        this._model.edgeVideoQualityUser = attendee.edgeVideoQualityUser;
        // update network status
        this._networkStatusReceive = this.getNetworkStatusReceive();
        await this._networkStatusReceiveUpdated.dispatch({
            attendee: this
        });
        // update attendee quality
        await this.tryUpdateQuality();
    }
    /** @internal */
    async processQualityOriginUpdate(attendee) {
        // update model
        this._model.originAudioQualityDisplay = attendee.originAudioQualityDisplay;
        this._model.originAudioQualityUser = attendee.originAudioQualityUser;
        this._model.originVideoQualityDisplay = attendee.originVideoQualityDisplay;
        this._model.originVideoQualityUser = attendee.originVideoQualityUser;
        // update network status
        this._networkStatusSend = this.getNetworkStatusSend();
        await this._networkStatusSendUpdated.dispatch({
            attendee: this
        });
        // update attendee quality
        await this.tryUpdateQuality();
    }
    /** @internal */
    async processSuppressNoise() {
        if (this._model.isNoiseSuppressed)
            return;
        this._model.isNoiseSuppressed = true;
        await this.noiseSuppressed.dispatch({ attendee: this });
    }
    /** @internal */
    async processUnmuteAudio() {
        if (!this._model.isUserAudioMuted)
            return;
        this._model.isUserAudioMuted = false;
        await this.audioUnmuted.dispatch({ attendee: this });
    }
    /** @internal */
    async processUnmuteVideo() {
        if (!this._model.isUserVideoMuted)
            return;
        this._model.isUserVideoMuted = false;
        await this.videoUnmuted.dispatch({ attendee: this });
    }
    /** @internal */
    async processUnsuppressNoise() {
        if (!this._model.isNoiseSuppressed)
            return;
        this._model.isNoiseSuppressed = false;
        await this.noiseUnsuppressed.dispatch({ attendee: this });
    }
    /** @internal */
    async processUpdate(attendee) {
        const avatarUrl = attendee.avatarUrl;
        if (avatarUrl != null && this.avatarUrl != avatarUrl) {
            this.avatarUrl = avatarUrl;
            await this._avatarUrlUpdated.dispatch({
                attendee: this,
            });
        }
        const displayName = attendee.displayName;
        if (displayName != null && this.displayName != displayName) {
            this.displayName = displayName;
            await this._displayNameUpdated.dispatch({
                attendee: this,
            });
        }
        const role = attendee.role;
        if (role != null && this._model.role != role) {
            this._model.role = role;
            await this._roleUpdated.dispatch({
                attendee: this,
            });
        }
        const permissions = attendee.permissions;
        if (permissions != null && permissions.length != this.permissions.length) {
            this.permissions = permissions;
            await this._permissionsUpdated.dispatch({
                attendee: this,
            });
        }
    }
    /** @internal */
    unbindMedia() {
        if (!this._media)
            return;
        this._media = null;
        this._mediaUnbound.dispatch({
            attendee: this,
        });
    }
    /**
     * Add a permission to this attendee.
     * @param permissionName The permissionName to add.
     * @returns The promise object representing the asynchronous operation.
     */
    async addPermission(permissionName) {
        const permissionType = Permissions.getPermissionTypeFromName(permissionName);
        if (this.permissions.indexOf(`${permissionType}:${permissionName}`) != -1) {
            return;
        }
        const permission = {
            permissionName: permissionName,
            permissionType: permissionType,
            attendeePermission: {
                attendeeId: this.id
            },
            meetingId: this._meeting.id,
        };
        const response = await this._controlConnection.addAttendeePermission(permission);
        await this._meeting.processAttendeePermissionAdded({ attendeePermission: response.attendeePermissionRequest });
    }
    async admit() {
        if (!this._meeting.hasLobby)
            throw new Error(Constants$2.Errors.Meeting.noLobby);
        if (this._model.status != "LOBBY")
            return;
        await this._controlConnection.admitAttendee(this.model);
    }
    async block() {
        if (this._model.status == "LOBBY") {
            await this._controlConnection.blockAttendeeFromLobby(this.model);
        }
        else {
            await this._controlConnection.blockAttendeeFromRoom(this.model);
        }
    }
    /**
     * Checks if attendee has permission.
     * @param permissionName
     */
    hasPermission(permissionName) {
        const permissionType = Permissions.getPermissionTypeFromName(permissionName);
        return this.permissions.includes(`${permissionType}:${permissionName}`);
    }
    /**
     * Disables the attendees ability to unmute audio.
     */
    async disableAudioUnmute() {
        await this._controlConnection.disableAttendeeAudioUnmute(this.model);
        await this._meeting.processAttendeeAudioUnmuteDisabled({ attendee: this.model });
    }
    /**
     * Disables the attendees ability to unmute video.
     */
    async disableVideoUnmute() {
        await this._controlConnection.disableAttendeeVideoUnmute(this.model);
        await this._meeting.processAttendeeVideoUnmuteDisabled({ attendee: this.model });
    }
    /**
     * Enables the attendees ability to unmute audio.
     */
    async enableAudioUnmute() {
        await this._controlConnection.enableAttendeeAudioUnmute(this.model);
        await this._meeting.processAttendeeAudioUnmuteEnabled({ attendee: this.model });
    }
    /**
     * Enables the attendees ability to unmute video.
     */
    async enableVideoUnmute() {
        await this._controlConnection.enableAttendeeVideoUnmute(this.model);
        await this._meeting.processAttendeeVideoUnmuteEnabled({ attendee: this.model });
    }
    /**
     * Checks if Attendees hand is raised.
     */
    isHandRaised() {
        if (this._settings.get("handraised")) {
            return true;
        }
        return false;
    }
    /**
     * Kicks the attendee from the meeting.
     */
    async kick() {
        if (this._meeting.localAttendee.userAccountId == this.userAccountId)
            throw new Error("Cannot kick self.");
        await this._controlConnection.kickAttendee(this.model);
    }
    /**
     * Lowers attendees hand.
     */
    async lowerHand() {
        if (this._meeting.localAttendee.id != this.id)
            throw new Error(Constants$2.Errors.Attendee.cannotLowerOtherAttendeesHand);
        if (this.isLocal && this._settings.get("handraised")) {
            const message = await this._controlConnection.lowerAttendeeHand(this.model, this._settings.get("handraised"));
            await this._meeting.processAttendeeHandLowered(message);
        }
    }
    /**
     * Mutes the attendees audio.
     */
    muteAudio() {
        return this._eventQueue.dispatch(async () => {
            if (this._model.isUserAudioMuted)
                return;
            this._model.isUserAudioMuted = true;
            if (this.isLocal)
                this._meeting.localUserMedia?.audioTrack?.muteInternal();
            try {
                await this._controlConnection.muteAttendeeAudio(this.model);
                await this._meeting.processAttendeeAudioMuted({ attendee: this.model });
            }
            catch (error) {
                if (this.isLocal)
                    this._meeting.localUserMedia?.audioTrack?.unmuteInternal();
                this._model.isUserAudioMuted = false;
                throw error;
            }
        });
    }
    /**
     * Mutes the attendees video.
     */
    muteVideo() {
        return this._eventQueue.dispatch(async () => {
            if (this._model.isUserVideoMuted)
                return;
            this._model.isUserVideoMuted = true;
            if (this.isLocal)
                this._meeting.localUserMedia?.videoTrack?.muteInternal();
            try {
                await this._controlConnection.muteAttendeeVideo(this.model);
                await this._meeting.processAttendeeVideoMuted({ attendee: this.model });
            }
            catch (error) {
                if (this.isLocal)
                    this._meeting.localUserMedia?.videoTrack?.unmuteInternal();
                this._model.isUserVideoMuted = false;
                throw error;
            }
        });
    }
    /**
     * Pins the attendee
     */
    async pin() {
        await this._controlConnection.pinAttendee(this.model);
        await this._meeting.processAttendeePinned({ attendee: this.model });
    }
    /**
     * Raises attendees hand.
     */
    async raiseHand() {
        if (this._meeting.localAttendee.id != this.id)
            throw new Error(Constants$2.Errors.Attendee.cannotRaiseOtherAttendeesHand);
        if (this.isLocal && !this._settings.get("handraised")) {
            const message = await this._controlConnection.raiseAttendeeHand(this.model, {
                attendeeId: this.id,
                name: "handraised",
            });
            await this._meeting.processAttendeeHandRaised(message);
        }
    }
    /**
     * Adds attendee setting
     */
    async addSetting(setting) {
        if (this.isLocal && !this._settings.get(setting.name)) {
            const message = await this._controlConnection.addAttendeeSetting(this.model, setting);
            await this._meeting.processAttendeeSettingAdded(message);
        }
    }
    /**
   * Removes attendee setting
   */
    async removeSetting(attendeeSettingName) {
        if (this.isLocal && this._settings.get(attendeeSettingName)) {
            const message = await this._controlConnection.removeAttendeeSetting(this.model, {
                attendeeId: this.id,
                name: attendeeSettingName
            });
            await this._meeting.processAttendeeSettingRemoved(message);
        }
    }
    /**
     * Remove a permission from this attendee.
     * @param permission The permission {@link permissionName} to remove.
     * @returns The promise object representing the asynchronous operation.
     */
    async removePermission(permissionName) {
        const permissionType = Permissions.getPermissionTypeFromName(permissionName);
        const permission = {
            permissionName: permissionName,
            permissionType: permissionType,
            attendeePermission: {
                attendeeId: this.id
            },
            meetingId: this._meeting.id,
        };
        await this._controlConnection.removeAttendeePermission(permission);
        await this._meeting.processAttendeePermissionRemoved({ attendeePermission: permission });
    }
    /**
     * Update the avatarUrl on this attendee.
     * @param avatarUrl The new avatarUrl.
     * @returns The promise object representing the asynchronous operation.
     */
    async setAvatarUrl(avatarUrl) {
        if (!Utility.isNullOrUndefined(avatarUrl) && avatarUrl.length > UserAccountAvatarUrlLength.Max) {
            throw new Error(Constants$2.Errors.UserAccount.invalidAvatarUrlLength);
        }
        Guard.isLengthWithinBounds(avatarUrl, "avatarUrl", UserAccountAvatarUrlLength.Max);
        const oldAvatarUrl = this.avatarUrl;
        if (this.isLocal)
            this._meeting.localAttendee.avatarUrl = avatarUrl;
        const sendModel = {};
        Object.assign(sendModel, this.model);
        sendModel.avatarUrl = avatarUrl;
        try {
            await this._controlConnection.updateAttendeeAvatarUrl(sendModel);
            await this._meeting.processAttendeeUpdated({ attendee: sendModel });
        }
        catch (error) {
            if (this.isLocal)
                this._meeting.localAttendee.avatarUrl = oldAvatarUrl;
            throw error;
        }
    }
    /**
     * Update the display name on this attendee.
     * @param displayName The new display name.
     */
    async setDisplayName(displayName) {
        Guard.isLengthWithinBounds(displayName, "displayName", AttendeeDisplayNameLength.Max);
        const oldDisplayName = this.displayName;
        if (this.isLocal)
            this._meeting.localAttendee.displayName = displayName;
        const sendModel = {};
        Object.assign(sendModel, this.model);
        sendModel.displayName = displayName;
        try {
            await this._controlConnection.updateAttendeeDisplayName(sendModel);
            await this._meeting.processAttendeeUpdated({ attendee: sendModel });
        }
        catch (error) {
            if (this.isLocal)
                this._meeting.localAttendee.displayName = oldDisplayName;
            throw error;
        }
    }
    /**
     * Update the role on this attendee.
     * @param role The new role.
     */
    async setRole(role) {
        const oldRole = this.role;
        if (this.isLocal)
            this._meeting.localAttendee.role = role;
        const sendModel = {};
        Object.assign(sendModel, this.model);
        sendModel.role = role;
        try {
            const response = await this._controlConnection.updateAttendeeRole(sendModel);
            await this._meeting.processAttendeeUpdated({ attendee: response.attendee });
        }
        catch (error) {
            if (this.isLocal)
                this._meeting.localAttendee.role = oldRole;
            throw error;
        }
    }
    /**
     * Suppresses audio noise.
     */
    async suppressNoise() {
        await this._controlConnection.suppressAttendeeNoise(this.model);
        await this.processSuppressNoise();
    }
    /**
     * Unmutes the attendees audio.
     */
    unmuteAudio() {
        return this._eventQueue.dispatch(async () => {
            if (!this._model.isUserAudioMuted)
                return;
            this._model.isUserAudioMuted = false;
            if (this.isLocal)
                this._meeting.localUserMedia?.audioTrack?.unmuteInternal();
            try {
                await this._controlConnection.unmuteAttendeeAudio(this.model);
                await this._meeting.processAttendeeAudioUnmuted({ attendee: this.model });
            }
            catch (error) {
                if (this.isLocal)
                    this._meeting.localUserMedia?.audioTrack?.muteInternal();
                this._model.isUserAudioMuted = true;
                throw error;
            }
        });
    }
    /**
     * Unmutes the attendees video.
     */
    unmuteVideo() {
        return this._eventQueue.dispatch(async () => {
            if (!this._model.isUserVideoMuted)
                return;
            this._model.isUserVideoMuted = false;
            if (this.isLocal)
                this._meeting.localUserMedia?.videoTrack?.unmuteInternal();
            try {
                await this._controlConnection.unmuteAttendeeVideo(this.model);
                await this._meeting.processAttendeeVideoUnmuted({ attendee: this.model });
            }
            catch (error) {
                if (this.isLocal)
                    this._meeting.localUserMedia?.videoTrack?.muteInternal();
                this._model.isUserVideoMuted = true;
                throw error;
            }
        });
    }
    /**
     * Unpins the attendee.
     */
    async unpin() {
        await this._controlConnection.unpinAttendee(this.model);
        await this._meeting.processAttendeeUnpinned({ attendee: this.model });
    }
    /**
     * Unsuppress audio noise.
     */
    async unsuppressNoise() {
        await this._controlConnection.unsuppressAttendeeNoise(this.model);
        await this.processUnsuppressNoise();
    }
}

class AttendeeListStateMachine {
    get state() { return this._state; }
    constructor(initialState) {
        this._state = initialState ?? "new";
    }
    setState(state) {
        if (this.state === state)
            return;
        if (this.trySetState(state))
            return;
        throw new Error(`Cannot transition to '${state}' state while in '${this._state}' state.`);
    }
    trySetState(state) {
        switch (state) {
            case "busy":
            case "impaired":
                if (this._state != "started")
                    return false;
                break;
            case "error":
                break;
            case "initialized":
                if (this._state != "new" && this._state != "initialized")
                    return false;
                break;
            case "started":
                if (this._state != "starting")
                    return false;
                break;
            case "starting":
                if (this._state != "initialized" && this._state != "stopped")
                    return false;
                break;
            case "stopped":
                if (this._state != "starting" && this._state != "stopping" && this._state != "initialized")
                    return false;
                break;
            case "stopping":
                if (this._state != "started")
                    return false;
                break;
            default:
                return false;
        }
        this._state = state;
        return true;
    }
}

class AttendeeCollection extends ReadOnlyCollection {
    /** @internal */
    set totalCount(value) {
        this._totalCount = value;
    }
    get isBusy() { return this.state == "busy"; }
    get isError() { return this.state == "error"; }
    get isImpaired() { return this.state == "impaired"; }
    get isInitialized() { return this.state == "initialized"; }
    get isNew() { return this.state == "new"; }
    get isStarted() { return this.state == "started"; }
    get isStarting() { return this.state == "starting"; }
    get isStopped() { return this.state == "stopped"; }
    get isStopping() { return this.state == "stopping"; }
    get pageCount() { return Math.max(1, Math.ceil(this._totalCount / Math.max(1, this._pageSize))); }
    get pageNumber() { return this._pageNumber; }
    get pageSize() { return this._pageSize; }
    get sortType() { return this._sortType; }
    get state() { return this._stateMachine.state; }
    /** @event */
    get stateChanged() { return this._stateChanged; }
    get statusFilter() { return this._statusFilter; }
    get totalCount() { return this._totalCount; }
    /** @internal */
    constructor() {
        super(attendee => attendee.id);
        this._sortIndexes = {
            "displayName": 0,
            "status": 1,
            "type": 2,
            "update": 3,
            "dateEntered": 4,
            "dateLeft": 5,
        };
        this._stateChanged = new EventOwnerAsync();
        this._stateEvents = new Map();
        this._stateMachine = new AttendeeListStateMachine();
        this._controlConnection = null;
        this._localAttendee = null;
        this._pageNumber = 1;
        this._pageSize = 10;
        this._sortType = "dateEntered";
        this._statusFilter = "ACTIVE";
        this._subscribedView = null;
        this._totalCount = 0;
        this._stateEvents.set("busy", new EventOwnerAsync());
        this._stateEvents.set("error", new EventOwnerAsync());
        this._stateEvents.set("impaired", new EventOwnerAsync());
        this._stateEvents.set("initialized", new EventOwnerAsync());
        this._stateEvents.set("new", new EventOwnerAsync());
        this._stateEvents.set("started", new EventOwnerAsync());
        this._stateEvents.set("starting", new EventOwnerAsync());
        this._stateEvents.set("stopped", new EventOwnerAsync());
        this._stateEvents.set("stopping", new EventOwnerAsync());
    }
    /** @internal */
    async init(init) {
        Guard.isNotNullOrUndefined(init, "init");
        Guard.isNotNullOrUndefined(init.controlConnection, "init.controlConnection");
        Guard.isNotNullOrUndefined(init.localAttendee, "init.localAttendee");
        Guard.isNotNullOrUndefined(init.subscribedView, "init.subscribedView");
        this._controlConnection = init.controlConnection;
        this._localAttendee = init.localAttendee;
        this._subscribedView = init.subscribedView;
        this._pageSize = init.attendeePageSize ?? this._pageSize;
        this.setState("initialized");
    }
    async start() {
        this.setState("starting");
        await this.refresh({
            pageSize: this._pageSize,
            sortType: this._sortType
        });
        this.setState("started");
    }
    /** @internal */
    async tryRemoveAndUpdate(key) {
        if (!this.tryRemove(key))
            return false;
        if (this._pageNumber > this.pageCount)
            await this.previousPage();
        return true;
    }
    async nextPage() {
        if (this._pageNumber >= this.pageCount)
            return;
        await this.refresh({
            pageNumber: this._pageNumber + 1
        });
    }
    async previousPage() {
        if (this._pageNumber <= 1)
            return;
        await this.refresh({
            pageNumber: this._pageNumber - 1
        });
    }
    async refresh(options) {
        if (this.state == "started")
            this.setState("busy");
        options ??= {};
        if (!Utility.isNullOrUndefined(options.pageNumber))
            this._pageNumber = options.pageNumber;
        if (!Utility.isNullOrUndefined(options.pageSize))
            this._pageSize = options.pageSize;
        if (!Utility.isNullOrUndefined(options.sortType))
            this._sortType = options.sortType;
        if (!Utility.isNullOrUndefined(options.statusFilter))
            this._statusFilter = options.statusFilter;
        Guard.isGreaterThanOrEqualTo(this._pageNumber, 1, "options.pageNumber");
        if (this._pageSize == 0) {
            this.removeAll();
            return;
        }
        const message = await this._controlConnection.listAttendees({
            limit: this._pageSize,
            offset: (this._pageNumber - 1) * this._pageSize,
            attendeeStatus: this._statusFilter,
            sortIndex: this._sortIndexes[this._sortType],
            isPaging: true,
        });
        const attendeeModels = message.attendees.values;
        this._totalCount = message.attendees.totalCount ?? 0;
        this.removeAll();
        for (const attendeeModel of attendeeModels) {
            if (attendeeModel.id == this._localAttendee.id) {
                this.tryAdd(this._localAttendee);
                continue;
            }
            if (!this._subscribedView.containsKey(attendeeModel.id))
                this._subscribedView.tryAddAttendee(attendeeModel);
            const attendee = this._subscribedView.get(attendeeModel.id);
            attendee.model = attendeeModel;
            this.tryAdd(attendee);
        }
        if (this.state == "busy")
            this.setState("started");
    }
    stop() {
        this.setState("stopping");
        this.removeAll();
        this.setState("stopped");
    }
    async setState(state) {
        const previousState = this._stateMachine.state;
        this._stateMachine.setState(state);
        const e = {
            attendees: this,
            previousState: previousState,
            state: state,
        };
        await this._stateEvents.get(state).dispatch(e);
        await this._stateChanged.dispatch(e);
    }
}

var AttendeeConnectionStatus;
(function (AttendeeConnectionStatus) {
    AttendeeConnectionStatus[AttendeeConnectionStatus["HEALTHY"] = 1] = "HEALTHY";
    AttendeeConnectionStatus[AttendeeConnectionStatus["DEGRADED"] = 0.8] = "DEGRADED";
    AttendeeConnectionStatus[AttendeeConnectionStatus["POOR"] = 0.5] = "POOR";
    AttendeeConnectionStatus[AttendeeConnectionStatus["RECOVERING"] = 0] = "RECOVERING";
})(AttendeeConnectionStatus || (AttendeeConnectionStatus = {}));
var AttendeeConnectionStatus$1 = AttendeeConnectionStatus;

class AudioTrack {
    constructor() {
        this._levelChanged = new EventOwner();
        this._speechStarted = new EventOwner();
        this._speechStopped = new EventOwner();
        //public get Stats(): StatisticAudio { return this._statAudio; }
        //private _bitrate: number = null;
        //private _bytesReceived: number = null;
        //private _bytesSent: number = null;
        //private _candidateAddress: string = null;
        //private _candidateRelayProtocol: string = null;
        //private _candidateType: string = null;
        this._isSpeaking = null;
        //private _jitter: number = null;
        //private _keepAliveRequestsReceived: number;
        //private _keepAliveRequestsSent: number;
        //private _keepAliveResponsesReceived: number;
        //private _keepAliveResponsesSent: number;
        this._level = null;
        //private _networkQuality: number = null;
        this._packetLoss = null;
        //private _packetsLost: number = null;
        //private _packetsReceived: number = null;
        //private _packetsSent: number = null;
        //private _remoteCandidateAddress: string = null;
        //private _remoteCandidateType: string = null;
        //private _roundTripTime: number = null;
        this._speechLevel = Math.pow(10, -26 / 20.0); // -26 dBov per ITU-T Rec.P.56
        this._lastTargetBitrate = null;
        this._lastPacketsLost = null;
        this._lastPacketsSent = null;
        this._lastPacketsReceived = null;
        // Degradation level
        this._currentLevelBitrate = null;
    }
    get bitrate() {
        return this._statAudio?.BitrateActual;
    }
    get bytesReceived() {
        return this._statAudio?.Rtp_BytesReceived;
    }
    get bytesSent() {
        return this._statAudio?.Rtp_BytesSent;
    }
    get candidateAddress() {
        return this._statPair?.Lcl_Ip;
    }
    get candidateId() {
        return this._statPair?.Lcl_Id;
    }
    get candidatePairId() {
        return this._statPair?.Pair_Id;
    }
    get candidateRelayProtocol() {
        return this._statPair?.Lcl_Protocol;
    }
    get candidateType() {
        return this._statPair?.Lcl_CandidateType;
    }
    get candidateNetworkAdapterType() {
        return this._statPair?.Lcl_NetworkAdapterType;
    }
    get candidateNetworkType() {
        return this._statPair?.Lcl_NetworkType;
    }
    get isLocal() {
        return !this.isRemote;
    }
    get isSpeaking() {
        return this._isSpeaking;
    }
    get jitter() {
        return this._statAudio?.Rtp_Jitter;
    }
    get keepAliveRequestsReceived() {
        return this._statPair?.Pair_RequestsReceived;
    }
    get keepAliveRequestsSent() {
        return this._statPair?.Pair_RequestsSent;
    }
    get keepAliveResponsesReceived() {
        return this._statPair?.Pair_ResponsesReceived;
    }
    get keepAliveResponsesSent() {
        return this._statPair?.Pair_ResponsesSent;
    }
    get level() {
        return this._level;
    }
    // public get networkQuality(): number { return this._networkQuality; }
    get packetsLost() {
        return this._statAudio?.Rtp_PacketsLost;
    }
    get packetsReceived() {
        return this._statAudio?.Rtp_PacketsReceived;
    }
    get packetsSent() {
        return this._statAudio?.Rtp_PacketsSent;
    }
    get remoteCandidateAddress() {
        return this._statPair?.Rmt_Ip;
    }
    get remoteCandidateId() {
        return this._statPair?.Rmt_Id;
    }
    get remoteCandidateType() {
        return this._statPair?.Rmt_CandidateType;
    }
    get roundTripTime() {
        return this._statAudio?.Rtp_RoundTripTime;
    }
    get speechLevel() {
        return this._speechLevel;
    }
    set speechLevel(value) {
        this._speechLevel = value;
    }
    get packetLoss() {
        if (this.isRemote) {
            if (Utility.isNullOrUndefined(this._statAudio?.Rtp_PacketsLost) || Utility.isNullOrUndefined(this._statAudio?.Rtp_PacketsReceived))
                return null;
            if (this._statAudio?.Rtp_PacketsLost == this._lastPacketsLost && this._statAudio?.Rtp_PacketsReceived == this._lastPacketsReceived)
                return 0;
            const packetsLostDelta = this._statAudio?.Rtp_PacketsLost - this._lastPacketsLost;
            const packetsReceivedDelta = this._statAudio?.Rtp_PacketsReceived - this._lastPacketsReceived;
            if (packetsReceivedDelta == 0)
                return 0;
            const packetLoss = packetsLostDelta / packetsReceivedDelta;
            this._packetLoss = packetLoss;
        }
        else {
            if (Utility.isNullOrUndefined(this._statAudio?.Rtp_PacketsLost) || Utility.isNullOrUndefined(this._statAudio?.Rtp_PacketsSent))
                return null;
            if (this._statAudio?.Rtp_PacketsLost == this._lastPacketsLost && this._statAudio?.Rtp_PacketsSent == this._lastPacketsSent)
                return 0;
            const packetsLostDelta = this._statAudio?.Rtp_PacketsLost - this._lastPacketsLost;
            const packetsSentDelta = this._statAudio?.Rtp_PacketsSent - this._lastPacketsSent;
            if (packetsSentDelta == 0)
                return 0;
            const packetLoss = packetsLostDelta / packetsSentDelta;
            this._packetLoss = packetLoss;
        }
        return this._packetLoss;
    }
    // Degradation levels
    get currentLevelBitrate() {
        return this._currentLevelBitrate;
    }
    // Media info
    get codecMimeType() {
        return this._statAudio?.Codec_MimeType;
    }
    get codecSdpFmtpLine() {
        return this._statAudio?.Codec_SdpFmtpLine;
    }
    /** @internal */
    set currentLevelBitrate(bitrateLevel) {
        this._currentLevelBitrate = bitrateLevel;
    }
    /** @event */
    get levelChanged() {
        return this._levelChanged;
    }
    /** @event */
    get speechStarted() {
        return this._speechStarted;
    }
    /** @event */
    get speechStopped() {
        return this._speechStopped;
    }
    /** @internal */
    updateLevel(level) {
        if (level == this._level)
            return;
        const previousLevel = this._level;
        this._level = level;
        this._levelChanged.dispatch({
            level: level,
            previousLevel: previousLevel,
            track: this,
        });
        const isSpeaking = level >= this._speechLevel;
        if (isSpeaking == this._isSpeaking)
            return;
        this._isSpeaking = isSpeaking;
        if (this._isSpeaking) {
            this._speechStarted.dispatch({
                track: this,
            });
        }
        else {
            this._speechStopped.dispatch({
                track: this,
            });
        }
    }
    updateStats(statAudio, statPair) {
        if (this._statAudio) {
            this._lastPacketsLost = this._statAudio.Rtp_PacketsLost;
            this._lastPacketsSent = this._statAudio.Rtp_PacketsSent;
            this._lastPacketsReceived = this._statAudio.Rtp_PacketsReceived;
        }
        this._statAudio = statAudio;
        if (statPair != null) {
            this._statPair = statPair;
        }
    }
}

class Member {
    get attendee() {
        return this._attendee;
    }
    get channel() {
        return this._channel;
    }
    get id() {
        return this._model.id;
    }
    get role() {
        return this._model.roleType;
    }
    /** @event */
    get updated() {
        return this._updated;
    }
    /** @internal */
    constructor(init) {
        this._updated = new EventOwnerAsync();
        Guard.isNotNullOrUndefined(init, "init");
        Guard.isNotNullOrUndefined(init.attendee, "init.attendee");
        Guard.isNotNullOrUndefined(init.channel, "init.channel");
        Guard.isNotNullOrUndefined(init.controlConnection, "init.controlConnection");
        Guard.isNotNullOrUndefined(init.model, "init.model");
        this._attendee = init.attendee;
        this._channel = init.channel;
        this._controlConnection = init.controlConnection;
        this._model = init.model;
        this._apiClient = init.apiClient;
    }
    /** @internal */
    async refreshModel(chatChannelAttendee) {
        if (!chatChannelAttendee) {
            const response = await this._apiClient.getChatChannelAttendee(this.id);
            if (!response || response.value == null)
                return;
            chatChannelAttendee = response.value;
        }
        if (!chatChannelAttendee)
            return;
        this._model = chatChannelAttendee;
        await this._updated.dispatch({
            member: this,
        });
    }
    async remove() {
        const response = await this._controlConnection.sendChatChannelAttendeeNotification({
            channelId: this.channel.id,
            chatChannelAttendeeId: this._model.id,
            roleType: "DELETED",
        });
        if (response == null || response.chatChannelAttendeeNotification == null)
            throw new Error("Failed to remove chat channel member");
        await this.channel.removeMemberInternal(this._model.id);
    }
    async update(options) {
        Guard.isNotNullOrUndefined(options, "options");
        await this._controlConnection.sendChatChannelAttendeeNotification({
            channelId: this.channel.id,
            chatChannelAttendeeId: this._model.id,
            roleType: options.role,
        });
        const model = { ...this._model };
        model.roleType = options.role;
        await this.refreshModel(model);
    }
}

class MemberCollection extends ReadOnlyCollection {
    /** @internal */
    constructor(apiClient) {
        super((member) => member.id);
        this._apiClient = apiClient;
    }
    /** @internal */
    async load(init) {
        Guard.isNotNullOrUndefined(init, "init");
        Guard.isNotNullOrUndefined(init.channel, "init.channel");
        Guard.isNotNullOrUndefined(init.controlConnection, "init.controlConnection");
        Guard.isNotNullOrUndefined(init.subscribedView, "init.subscribedView");
        this._channel = init.channel;
        this._controlConnection = init.controlConnection;
        this._subscribedView = init.subscribedView;
        const response = await this._apiClient.listChatChannelAttendeesByChannelId(this._channel.id);
        if (response == null || response.values == null)
            throw new Error("Failed to load members");
        const memberModels = response.values;
        const attendees = await Promise.all(memberModels.map((mm) => this._subscribedView.subscribeToAttendee(mm.attendeeId, "chatMemberPaging")));
        const members = attendees
            .filter((a) => !!a)
            .map((a, i) => new Member({
            attendee: a,
            channel: this._channel,
            apiClient: this._apiClient,
            controlConnection: this._controlConnection,
            model: memberModels[i],
        }));
        for (const member of members)
            this.tryAdd(member);
    }
}

class Message {
    get attendee() {
        return this._attendee;
    }
    get channel() {
        return this._channel;
    }
    get file() {
        return this._fileInfo?.Content;
    }
    get id() {
        return this._model.id;
    }
    get isAudio() {
        return this._model.messageType == "AUDIO";
    }
    get isCard() {
        return this._model.messageType == "CARD";
    }
    get isImage() {
        return this._model.messageType == "IMAGE";
    }
    get isFile() {
        return this._model.messageType == "FILE";
    }
    get isFlagged() {
        return !!this._model.flagged;
    }
    get inlineContent() {
        if (this._model.messageContent.startsWith("data:"))
            return this._model.messageContent;
        return undefined;
    }
    get fileName() {
        return this._fileInfo?.FileName || "";
    }
    get isDownloadable() {
        return !!this._model.mediaId;
    }
    get isText() {
        return this._model.messageType == "TEXT";
    }
    get isVideo() {
        return this._model.messageType == "VIDEO";
    }
    get priority() {
        return this._model.messagePriority;
    }
    get text() {
        return this._model.messageContent;
    }
    get timestamp() {
        return this._model.created;
    }
    get type() {
        return this._model.messageType;
    }
    /** @event */
    get updated() {
        return this._updated;
    }
    /** @internal */
    constructor(init) {
        this._updated = new EventOwnerAsync();
        Guard.isNotNullOrUndefined(init, "init");
        Guard.isNotNullOrUndefined(init.apiClient, "init.apiClient");
        Guard.isNotNullOrUndefined(init.attendee, "init.attendee");
        Guard.isNotNullOrUndefined(init.channel, "init.channel");
        Guard.isNotNullOrUndefined(init.controlConnection, "init.controlConnection");
        Guard.isNotNullOrUndefined(init.model, "init.model");
        this._apiClient = init.apiClient;
        this._attendee = init.attendee;
        this._channel = init.channel;
        this._controlConnection = init.controlConnection;
        this._model = init.model;
        this._uploadClient = init.uploadClient;
    }
    /** @internal */
    async load() {
        await this.download();
    }
    /** @internal */
    async refreshModel(messageModel) {
        if (!messageModel) {
            const response = await this._apiClient.getChatMessage(this._model.id);
            if (response == null || response.value == null)
                throw new Error("Failed to get chat message");
            messageModel = response.value;
        }
        if (!messageModel)
            return;
        this._model = messageModel;
        await this.download();
        await this._updated.dispatch({
            message: this,
        });
    }
    async delete() {
        const response = await this._controlConnection.sendChatMessageNotification({
            channelId: this.channel.id,
            messageId: this._model.id,
            messageStatus: "DELETED",
            sentBy: this._attendee.id,
        });
        if (response == null || response.chatMessageNotification == null)
            throw new Error("Failed to delete chat message");
        await this._channel.removeMessageInternal(this._model.id);
    }
    async download() {
        if (this._model.mediaId) {
            try {
                const content = JSON.parse(this._model.messageContent);
                if (content) {
                    const fileInfo = await this._uploadClient.GetMediaFile(this._model.mediaId, "ATTENDEE");
                    this._fileInfo = fileInfo;
                }
            }
            catch (ex) { /* empty */ }
        }
    }
    async flag() {
        await this._controlConnection.sendChatMessageNotification({
            channelId: this._channel.id,
            messageId: this._model.id,
            messageStatus: "FLAGGED",
            sentBy: this._attendee.id,
        });
        await this.refreshModel();
    }
    async update(options) {
        Guard.isNotNullOrUndefined(options, "options");
        const response = await this._controlConnection.sendChatChannelNotification({
            channelId: this._channel.id,
            channelName: this._channel.name,
            channelStatus: this._channel.status,
            channelType: this._channel.type,
        });
        if (response == null || response.chatChannelNotification == null)
            throw new Error("Failed to update chat channel");
        //clone _model and update the content
        const model = { ...this._model };
        model.messageContent = options.content;
        model.messagePriority = options.priority;
        await this.refreshModel(model);
    }
}

class MessageCollection extends ReadOnlyCollection {
    get hasMore() {
        return this._hasMore;
    }
    /** @internal */
    constructor(apiClient, uploadClient) {
        super((message) => message.id);
        this._hasMore = true;
        this._loading = false;
        this._apiClient = apiClient;
        this._uploadClient = uploadClient;
    }
    async getOlderMessages(count) {
        if (this._loading)
            return false;
        this._loading = true;
        try {
            const response = await this._apiClient.listChatMessages({
                attendeeId: this._controlConnection.attendeeId,
                meetingId: this._controlConnection.meetingId,
                channelId: this._channel.id,
                limit: count,
                offset: 0,
                sortDirection: "DESC",
            });
            const messageModels = response.values;
            this._hasMore = response.totalCount > messageModels.length;
            if (messageModels.length == 0)
                return false;
            this._offsetId = messageModels[messageModels.length - 1].id;
            const attendees = await Promise.all(messageModels.map((m) => this._subscribedView.subscribeToAttendee(m.createdBy, "chatMessageReceived")));
            const messages = messageModels.map((mm, i) => new Message({
                apiClient: this._apiClient,
                attendee: attendees[i],
                channel: this._channel,
                controlConnection: this._controlConnection,
                model: mm,
                uploadClient: this._uploadClient,
            }));
            await Promise.all(messages.map((m) => m.load()));
            for (const message of messages)
                this.tryInsert(message, 0);
            return true;
        }
        finally {
            this._loading = false;
        }
    }
    /** @internal */
    async load(init, count = Constants$2.Settings.Meeting.Chat.DefaultMessageCollectionLoadLimit) {
        Guard.isNotNullOrUndefined(init, "init");
        Guard.isNotNullOrUndefined(init.apiClient, "init.apiClient");
        Guard.isNotNullOrUndefined(init.channel, "init.channel");
        Guard.isNotNullOrUndefined(init.controlConnection, "init.controlConnection");
        Guard.isNotNullOrUndefined(init.subscribedView, "init.subscribedView");
        this._apiClient = init.apiClient;
        this._channel = init.channel;
        this._controlConnection = init.controlConnection;
        this._subscribedView = init.subscribedView;
        return await this.getOlderMessages(count);
    }
    async loadMore(count = Constants$2.Settings.Meeting.Chat.DefaultMessageCollectionLoadLimit) {
        return await this.getOlderMessages(count);
    }
}

/**
 * Vue-specific implementation details.
 */
class Vue {
    /**
     * Gets the reactive function.
     */
    static get reactive() { return this._reactive; }
    /**
     * Sets the reactive function.
     */
    static set reactive(reactive) { this._reactive = reactive; }
}
Vue._reactive = null;

class Reactive {
    static wrap(element) {
        if (Vue.reactive)
            element = Vue.reactive(element);
        return element;
    }
}

class Channel {
    get chat() {
        return this._chat;
    }
    get id() {
        return this._model.id;
    }
    get isDefault() {
        return this._isDefault;
    }
    get members() {
        return this._members;
    }
    /** @event */
    get memberAdded() {
        return this._memberAdded;
    }
    /** @event */
    get memberRemoved() {
        return this._memberRemoved;
    }
    get messages() {
        return this._messages;
    }
    /** @event */
    get messageDeleted() {
        return this._messageDeleted;
    }
    /** @event */
    get messageReceived() {
        return this._messageReceived;
    }
    /** @event */
    get messageSent() {
        return this._messageSent;
    }
    get name() {
        return this._model.name;
    }
    get status() {
        return this._model.status;
    }
    get type() {
        return this._model.type;
    }
    /** @event */
    get updated() {
        return this._updated;
    }
    /** @internal */
    constructor(init) {
        this._memberAdded = new EventOwnerAsync();
        this._memberRemoved = new EventOwnerAsync();
        this._messageDeleted = new EventOwnerAsync();
        this._messageReceived = new EventOwnerAsync();
        this._messageSent = new EventOwnerAsync();
        this._updated = new EventOwnerAsync();
        Guard.isNotNullOrUndefined(init, "init");
        Guard.isNotNullOrUndefined(init.apiClient, "init.apiClient");
        Guard.isNotNullOrUndefined(init.chat, "init.chat");
        Guard.isNotNullOrUndefined(init.controlConnection, "init.controlConnection");
        Guard.isNotNullOrUndefined(init.localAttendee, "init.localAttendee");
        Guard.isNotNullOrUndefined(init.model, "init.model");
        Guard.isNotNullOrUndefined(init.subscribedView, "init.subscribedView");
        this._apiClient = init.apiClient;
        this._chat = init.chat;
        this._controlConnection = init.controlConnection;
        this._isDefault = Utility.isNullOrUndefined(init.model.id);
        this._localAttendee = init.localAttendee;
        this._model = init.model;
        this._subscribedView = init.subscribedView;
        this._members = new MemberCollection(init.apiClient);
        this._messages = new MessageCollection(init.apiClient, init.uploadClient);
        this._uploadClient = init.uploadClient;
    }
    async sendMessage(messageContent, file, options) {
        let notification;
        if (file) {
            let type = "FILE";
            if (file.type?.startsWith("audio/"))
                type = "AUDIO";
            if (file.type?.startsWith("image/"))
                type = "IMAGE";
            if (file.type?.startsWith("video/"))
                type = "VIDEO";
            //upload file and get mediaId
            const uploadResult = await this._uploadClient.UploadAttendeeAttachmentAsync(this._localAttendee.id, file, type);
            //Simple or Multipart
            if (uploadResult.uploadPlan) {
                const attachmentInfo = {
                    fileName: file.name,
                    contentLength: file.size,
                    mimeType: file.type,
                    downloadUrl: uploadResult.downloadUrl
                };
                notification = {
                    messageType: type,
                    sentBy: this._localAttendee.id,
                    messageContent: JSON.stringify(attachmentInfo),
                    channelId: this._model.id,
                    messagePriority: options?.priority ?? "NORMAL",
                    mediaId: uploadResult.uploadPlan.MediaId,
                };
            }
            else {
                notification = {
                    messageType: type,
                    sentBy: this._localAttendee.id,
                    messageContent: uploadResult.inlineContent,
                    channelId: this._model.id,
                    messagePriority: options?.priority ?? "NORMAL",
                    mediaId: uploadResult.mediaId.replaceAll("\"", "")
                };
            }
        }
        else {
            notification = {
                messageType: "TEXT",
                sentBy: this._localAttendee.id,
                messageContent: messageContent,
                channelId: this._model.id,
                messagePriority: options?.priority ?? "NORMAL",
            };
        }
        const response = await this._controlConnection.sendChatMessageNotification(notification);
        if (!response)
            throw new Error(Constants$2.Errors.Meeting.Chat.cannotSendMessage);
        const message = new Message({
            apiClient: this._apiClient,
            attendee: this._localAttendee,
            channel: Reactive.wrap(this),
            controlConnection: this._controlConnection,
            uploadClient: this._uploadClient,
            model: {
                id: response.chatMessageNotification.messageId,
                meetingId: this._controlConnection.meetingId,
                channelId: this._model.id,
                createdBy: this._localAttendee.id,
                created: new Date(),
                mediaId: response.chatMessageNotification.mediaId,
                messageContent: response.chatMessageNotification.messageContent,
                messageType: response.chatMessageNotification.messageType,
                messagePriority: response.chatMessageNotification.messagePriority,
            },
        });
        if (file) {
            await message.refreshModel();
        }
        this._messages.tryAdd(message);
        await this._messageSent.dispatch({ message });
        return message;
    }
    /** @internal */
    async addMemberInternal(memberId, chatChannelAttendee) {
        if (this._members.get(memberId))
            return;
        if (!chatChannelAttendee) {
            const response = await this._apiClient.getChatChannelAttendee(memberId);
            if (response.errors || !response.value)
                throw new Error("Error getting chat channel attendee");
            const memberModel = response.value;
            if (!memberModel)
                return;
            chatChannelAttendee = memberModel;
        }
        const attendee = await this._subscribedView.subscribeToAttendee(chatChannelAttendee.attendeeId, "chatMemberPaging");
        if (!attendee)
            return;
        const member = new Member({
            attendee: attendee,
            channel: Reactive.wrap(this),
            controlConnection: this._controlConnection,
            model: chatChannelAttendee,
            apiClient: this._apiClient,
        });
        this._members.tryAdd(member);
        await this._memberAdded.dispatch({ member });
        return member;
    }
    /** @internal */
    async addMessageInternal(messageId, attendeeId, messageModel) {
        const attendee = await this._subscribedView.subscribeToAttendee(attendeeId, "chatMessageReceived");
        if (!attendee) {
            console.warn(Constants$2.Errors.Meeting.cannotSubscribe);
            return;
        }
        if (!messageModel) {
            const response = await this._apiClient.getChatMessage(messageId);
            if (response.errors || !response.value)
                throw new Error("Error getting chat message");
            messageModel = response.value;
        }
        if (messageModel == null)
            throw new Error(Constants$2.Errors.Meeting.Chat.cannotGetMessage);
        const message = new Message({
            apiClient: this._apiClient,
            attendee: attendee,
            channel: Reactive.wrap(this),
            controlConnection: this._controlConnection,
            model: messageModel,
            uploadClient: this._uploadClient,
        });
        await message.load();
        this._messages.tryAdd(message);
        await this._messageReceived.dispatch({ message });
        return message;
    }
    /** @internal */
    async load() {
        await this._messages.load({
            apiClient: this._apiClient,
            channel: Reactive.wrap(this),
            controlConnection: this._controlConnection,
            subscribedView: this._subscribedView,
        });
        if (this._isDefault)
            return;
        await this._members.load({
            channel: Reactive.wrap(this),
            controlConnection: this._controlConnection,
            subscribedView: this._subscribedView,
        });
    }
    /** @internal */
    async refreshModel(channelModel) {
        if (this._isDefault)
            return;
        if (!channelModel) {
            const response = await this._apiClient.getChatChannel(this._model.id);
            if (response.errors || !response.value)
                throw new Error(Constants$2.Errors.Meeting.Chat.cannotGetChannel);
            channelModel = response.value;
        }
        this._model = channelModel;
        await this._updated.dispatch({
            channel: this,
        });
    }
    /** @internal */
    async removeMemberInternal(memberId) {
        const member = this._members.get(memberId);
        if (!member || !this._members.tryRemove(memberId))
            return;
        await this._memberRemoved.dispatch({ member });
    }
    /** @internal */
    async removeMessageInternal(messageId) {
        const message = this._messages.get(messageId);
        if (!message || !this._messages.tryRemove(messageId))
            return;
        await this._messageDeleted.dispatch({ message });
    }
    /** @internal */
    async updateMemberInternal(memberId) {
        await this._members.get(memberId)?.refreshModel();
    }
    /** @internal */
    async updateMessageInternal(messageId) {
        await this._messages.get(messageId)?.refreshModel();
    }
    async addMember(options) {
        if (this._isDefault) {
            console.warn(Constants$2.Errors.Meeting.Chat.cannotAddChatMemberToDefaultChannel);
            return;
        }
        const response = await this._controlConnection.sendChatChannelAttendeeNotification({
            attendeeId: options.attendeeId,
            channelId: this._model.id,
            roleType: options.role,
        });
        if (response == null ||
            !response.chatChannelAttendeeNotification.chatChannelAttendeeId)
            throw new Error("Could not add member.");
        const attendee = await this._subscribedView.subscribeToAttendee(options.attendeeId, "chatMemberPaging");
        if (!attendee)
            throw new Error(`${Constants$2.Errors.Meeting.Chat.cannotAddChatMember} ${Constants$2.Errors.Meeting.cannotSubscribe}`);
        const member = new Member({
            attendee: attendee,
            channel: Reactive.wrap(this),
            controlConnection: this._controlConnection,
            model: {
                id: response.chatChannelAttendeeNotification.chatChannelAttendeeId,
                attendeeId: options.attendeeId,
                channelId: this._model.id,
                roleType: options.role,
            },
            apiClient: this._apiClient,
        });
        this._members.tryAdd(member);
        await this._memberAdded.dispatch({ member });
        return member;
    }
    async delete() {
        if (this._isDefault) {
            console.warn(Constants$2.Errors.Meeting.Chat.cannotDeleteDefaultChannel);
            return;
        }
        await this._controlConnection.sendChatChannelNotification({
            channelId: this._model.id,
            channelStatus: "DELETED",
        });
        await this._chat.removeChannelInternal(this._model.id);
    }
    async search(options) {
        const response = await this._apiClient.listChatMessages({
            channelId: this._model.id,
            meetingId: this._controlConnection.meetingId,
            where: options.filter,
            limit: options.limit,
            offset: options.offset,
        });
        if (response.errors || !response.values)
            throw new Error("Error getting chat messages");
        const messages = [];
        for (const messageModel of response.values) {
            const attendee = await this._subscribedView.subscribeToAttendee(messageModel.createdBy, "chatMessageReceived");
            const message = new Message({
                apiClient: this._apiClient,
                attendee: attendee,
                channel: Reactive.wrap(this),
                controlConnection: this._controlConnection,
                model: messageModel,
                uploadClient: this._uploadClient,
            });
            await message.load();
            messages.push(message);
        }
        return {
            totalCount: response.totalCount,
            values: messages,
        };
    }
    async send(content, options) {
        Guard.isNotNullOrUndefined(content, "content");
        options ??= {};
        if (Utility.isString(content)) {
            return await this.sendMessage(content, undefined, options);
        }
        const file = content;
        return await this.sendMessage(undefined, file, options);
    }
    async update(options) {
        if (this._isDefault)
            throw new Error(Constants$2.Errors.Meeting.Chat.cannotUpdateDefaultChannel);
        Guard.isNotNullOrUndefined(options, "options");
        Guard.isNotNullOrUndefined(options.name, "options.name");
        Guard.isNotNullOrUndefined(options.type, "options.type");
        Guard.isNotNullOrUndefined(options.status, "options.status");
        const response = await this._controlConnection.sendChatChannelNotification({
            channelId: this._model.id,
            channelName: options.name,
            channelType: options.type,
            channelStatus: options.status,
        });
        void this.refreshModel({
            id: this._model.id,
            name: response.chatChannelNotification.channelName,
            type: response.chatChannelNotification.channelType,
            status: response.chatChannelNotification.channelStatus,
        });
    }
}

class ChannelCollection extends ReadOnlyCollection {
    /** @internal */
    constructor() {
        super(chatChannel => chatChannel.id);
    }
    /** @internal */
    async load(init) {
        Guard.isNotNullOrUndefined(init, "init");
        Guard.isNotNullOrUndefined(init.apiClient, "init.apiClient");
        Guard.isNotNullOrUndefined(init.chat, "init.chat");
        Guard.isNotNullOrUndefined(init.controlConnection, "init.controlConnection");
        Guard.isNotNullOrUndefined(init.defaultChannel, "init.defaultChannel");
        Guard.isNotNullOrUndefined(init.localAttendee, "init.localAttendee");
        Guard.isNotNullOrUndefined(init.subscribedView, "init.subscribedView");
        this._apiClient = init.apiClient;
        this._chat = init.chat;
        this._controlConnection = init.controlConnection;
        this._defaultChannel = init.defaultChannel;
        this._localAttendee = init.localAttendee;
        this._subscribedView = init.subscribedView;
        this._uploadClient = init.uploadClient;
        const response = await this._apiClient.listAttendeeChatChannels({
            attendeeId: this._controlConnection.attendeeId
        });
        if (response == null || response.values == null)
            throw new Error("Failed to get chat channels");
        const channelModels = response.values;
        const channels = channelModels.map(cm => new Channel({
            apiClient: this._apiClient,
            chat: this._chat,
            controlConnection: this._controlConnection,
            localAttendee: this._localAttendee,
            model: cm,
            subscribedView: this._subscribedView,
            uploadClient: this._uploadClient
        }));
        await this._defaultChannel.load();
        await Promise.all(channels.map(c => c.load()));
        this.tryAdd(this._defaultChannel);
        for (const channel of channels)
            this.tryAdd(channel);
    }
}

class ChatStateMachine {
    get state() { return this._state; }
    constructor(initialState) {
        this._state = initialState ?? "new";
    }
    setState(state) {
        if (this.state === state)
            return;
        if (this.trySetState(state))
            return;
        throw new Error(`Cannot transition to '${state}' state while in '${this._state}' state.`);
    }
    trySetState(state) {
        switch (state) {
            case "busy":
            case "impaired":
                if (this._state != "started")
                    return false;
                break;
            case "error":
                break;
            case "initialized":
                if (this._state != "new" && this._state != "initialized")
                    return false;
                break;
            case "started":
                if (this._state != "starting")
                    return false;
                break;
            case "starting":
                if (this._state != "initialized" && this._state != "stopped")
                    return false;
                break;
            case "stopped":
                if (this._state != "initialized" && this._state != "starting" && this._state != "stopping")
                    return false;
                break;
            case "stopping":
                if (this._state != "new" && this._state != "initialized" && this._state != "started")
                    return false;
                break;
            default:
                return false;
        }
        this._state = state;
        return true;
    }
}

class Chat {
    get channels() {
        return this._channels;
    }
    get defaultChannel() {
        return this._defaultChannel;
    }
    get isBusy() {
        return this.state == "busy";
    }
    get isError() {
        return this.state == "error";
    }
    get isImpaired() {
        return this.state == "impaired";
    }
    get isInitialized() {
        return this.state == "initialized";
    }
    get isNew() {
        return this.state == "new";
    }
    get isStarted() {
        return this.state == "started";
    }
    get isStarting() {
        return this.state == "starting";
    }
    get isStopped() {
        return this.state == "stopped";
    }
    get isStopping() {
        return this.state == "stopping";
    }
    /** @event */
    get channelAdded() {
        return this._channelAdded;
    }
    /** @event */
    get channelRemoved() {
        return this._channelRemoved;
    }
    /** @event */
    get memberAdded() {
        return this._memberAdded;
    }
    /** @event */
    get memberRemoved() {
        return this._memberRemoved;
    }
    /** @event */
    get messageDeleted() {
        return this._messageDeleted;
    }
    /** @event */
    get messageReceived() {
        return this._messageReceived;
    }
    /** @event */
    get messageSent() {
        return this._messageSent;
    }
    get state() {
        return this._stateMachine.state;
    }
    /** @event */
    get stateChanged() {
        return this._stateChanged;
    }
    /** @internal */
    constructor() {
        this._stateChanged = new EventOwnerAsync();
        this._stateEvents = new Map();
        this._stateMachine = new ChatStateMachine();
        this._channelAdded = new EventOwnerAsync();
        this._channelRemoved = new EventOwnerAsync();
        this._memberAdded = new EventOwnerAsync();
        this._memberRemoved = new EventOwnerAsync();
        this._messageDeleted = new EventOwnerAsync();
        this._messageReceived = new EventOwnerAsync();
        this._messageSent = new EventOwnerAsync();
        this._onChatMessageNotification = this.onChatMessageNotification.bind(Reactive.wrap(this));
        this._onChatChannelNotification = this.onChatChannelNotification.bind(Reactive.wrap(this));
        this._onChatChannelAttendeeNotification =
            this.onChatChannelAttendeeNotification.bind(Reactive.wrap(this));
        this._onLocalChannelAdded = this.onLocalChannelAdded.bind(Reactive.wrap(this));
        this._onLocalChannelRemoved = this.onLocalChannelRemoved.bind(Reactive.wrap(this));
        this._onLocalMemberAdded = this.onLocalMemberAdded.bind(Reactive.wrap(this));
        this._onLocalMemberRemoved = this.onLocalMemberRemoved.bind(Reactive.wrap(this));
        this._onLocalMessageDeleted = this.onLocalMessageDeleted.bind(Reactive.wrap(this));
        this._onLocalMessageReceived = this.onLocalMessageReceived.bind(Reactive.wrap(this));
        this._onLocalMessageSent = this.onLocalMessageSent.bind(Reactive.wrap(this));
        this._stateEvents.set("busy", new EventOwnerAsync());
        this._stateEvents.set("error", new EventOwnerAsync());
        this._stateEvents.set("impaired", new EventOwnerAsync());
        this._stateEvents.set("initialized", new EventOwnerAsync());
        this._stateEvents.set("new", new EventOwnerAsync());
        this._stateEvents.set("started", new EventOwnerAsync());
        this._stateEvents.set("starting", new EventOwnerAsync());
        this._stateEvents.set("stopped", new EventOwnerAsync());
        this._stateEvents.set("stopping", new EventOwnerAsync());
    }
    /** @internal */
    init(init) {
        Guard.isNotNullOrUndefined(init, "init");
        Guard.isNotNullOrUndefined(init.apiClient, "init.apiClient");
        Guard.isNotNullOrUndefined(init.controlConnection, "init.controlConnection");
        Guard.isNotNullOrUndefined(init.localAttendee, "init.localAttendee");
        Guard.isNotNullOrUndefined(init.subscribedView, "init.subscribedView");
        this._apiClient = init.apiClient;
        this._controlConnection = init.controlConnection;
        this._localAttendee = init.localAttendee;
        this._subscribedView = init.subscribedView;
        this._uploadClient = init.uploadClient;
        this._defaultChannel = new Channel({
            apiClient: this._apiClient,
            chat: Reactive.wrap(this),
            controlConnection: this._controlConnection,
            localAttendee: this._localAttendee,
            model: {
                createdBy: null,
                id: null,
                meetingId: this._controlConnection.meetingId,
                name: "Default",
                status: "ACTIVE",
                type: "PUBLIC",
                updatedBy: null,
                updatedOn: null,
            },
            subscribedView: this._subscribedView,
            uploadClient: this._uploadClient,
        });
        this._channels = new ChannelCollection();
        this._channels.tryAdd(this._defaultChannel);
        void this._defaultChannel.load();
        this._channels.added.bind(this._onLocalChannelAdded);
        this._channels.removed.bind(this._onLocalChannelRemoved);
        void this.setState("initialized");
        //Get Channel list from server and add to collection
        void this._apiClient.listAttendeeChatChannels({
            attendeeId: this._controlConnection.attendeeId,
        }).then((response) => {
            if (response == null || response.values == null)
                return;
            for (const channel of response.values) {
                void this.addChannelInternal(channel.id, channel);
            }
        });
    }
    async getChannel(channelId) {
        const channel = channelId ? this._channels.get(channelId) : this._defaultChannel;
        if (!channel) {
            const response = await this._apiClient.getChatChannel(channelId);
            if (response == null || response.value == null)
                return null;
            return await this.addChannelInternal(channelId, response.value);
        }
        return channel;
    }
    onLocalChannelAdded(e) {
        e.element.memberAdded.bind(this._onLocalMemberAdded);
        e.element.memberRemoved.bind(this._onLocalMemberRemoved);
        e.element.messageDeleted.bind(this._onLocalMessageDeleted);
        e.element.messageReceived.bind(this._onLocalMessageReceived);
        e.element.messageSent.bind(this._onLocalMessageSent);
    }
    onLocalChannelRemoved(e) {
        e.element.memberAdded.unbind(this._onLocalMemberAdded);
        e.element.memberRemoved.unbind(this._onLocalMemberRemoved);
        e.element.messageDeleted.unbind(this._onLocalMessageDeleted);
        e.element.messageReceived.unbind(this._onLocalMessageReceived);
        e.element.messageSent.unbind(this._onLocalMessageSent);
    }
    onLocalMemberAdded(e) {
        return this._memberAdded.dispatch(e);
    }
    onLocalMemberRemoved(e) {
        return this._memberRemoved.dispatch(e);
    }
    onLocalMessageDeleted(e) {
        return this._messageDeleted.dispatch(e);
    }
    onLocalMessageReceived(e) {
        return this._messageReceived.dispatch(e);
    }
    onLocalMessageSent(e) {
        return this._messageSent.dispatch(e);
    }
    async onChatChannelNotification(notification) {
        const channelId = notification?.channelId;
        const channel = this._channels.get(channelId);
        if (notification.channelStatus == "DELETED") {
            //Delete record
            if (!channelId)
                return;
            void this.removeChannelInternal(channelId);
        }
        else if (channelId && !channel) {
            void this.addChannelInternal(channelId, {
                id: channelId,
                name: notification.channelName,
                status: notification.channelStatus,
                type: notification.channelType,
            });
        }
        else {
            //Update
            const channel = await this.getChannel(channelId);
            void channel.refreshModel({
                id: channelId,
                meetingId: this._controlConnection.meetingId,
                name: notification.channelName,
                status: notification.channelStatus,
                type: notification.channelType,
            });
        }
        return Promise.resolve();
    }
    async onChatChannelAttendeeNotification(notification) {
        const channelId = notification?.channelId;
        if (notification.roleType == "DELETED") {
            const attendeeId = notification?.attendeeId;
            const memberId = notification?.chatChannelAttendeeId;
            if (!attendeeId || !channelId || !memberId)
                return;
            if (attendeeId == this._controlConnection.attendeeId) {
                void this.removeChannelInternal(channelId);
            }
            else {
                const channel = await this.getChannel(channelId);
                if (channel)
                    void channel.removeMemberInternal(memberId);
            }
        }
        else if (channelId) {
            const channel = await this.getChannel(channelId);
            if (channel)
                void channel.updateMemberInternal(notification.chatChannelAttendeeId);
        }
        else {
            //Add the role
            void this._defaultChannel.addMemberInternal(notification.chatChannelAttendeeId);
        }
        return Promise.resolve();
    }
    onChatMessageNotification(notification) {
        const channel = notification.channelId
            ? this._channels.get(notification.channelId)
            : this._defaultChannel;
        const messageId = notification.messageId;
        Guard.isNotNullOrUndefined(messageId, "messageId");
        if (notification.messageStatus == "DELETED") {
            //Delete Message
            void channel.removeMessageInternal(notification.messageId);
        }
        else if (notification.messageStatus == "FLAGGED") ;
        else {
            void channel.addMessageInternal(notification.messageId, notification.sentBy, {
                id: notification.messageId,
                channelId: notification.channelId,
                meetingId: this._controlConnection.meetingId,
                mediaId: notification.mediaId,
                messageContent: notification.messageContent,
                messageType: notification.messageType,
                messagePriority: notification.messagePriority,
                messageStatus: notification.messageStatus,
            });
        }
        return Promise.resolve();
    }
    /** @internal */
    async addChannelInternal(channelId, channelModel) {
        if (this._channels.get(channelId))
            return;
        if (!channelModel) {
            const response = await this._apiClient.getChatChannel(channelId);
            if (response == null || response.value == null)
                throw new Error("Failed to get chat channel");
            channelModel = response.value;
        }
        const channel = new Channel({
            apiClient: this._apiClient,
            chat: Reactive.wrap(this),
            controlConnection: this._controlConnection,
            localAttendee: this._localAttendee,
            model: channelModel,
            subscribedView: this._subscribedView,
            uploadClient: this._uploadClient,
        });
        await channel.load();
        this._channels.tryAdd(channel);
        await this._channelAdded.dispatch({ channel });
        return channel;
    }
    async setState(state) {
        const previousState = this._stateMachine.state;
        this._stateMachine.setState(state);
        const e = {
            chat: this,
            previousState: previousState,
            state: state,
        };
        await this._stateEvents.get(state).dispatch(e);
        await this._stateChanged.dispatch(e);
    }
    /** @internal */
    async removeChannelInternal(channelId) {
        const channel = this._channels.get(channelId);
        if (!channel || !this._channels.tryRemove(channelId))
            return;
        await this._channelRemoved.dispatch({ channel });
    }
    async createChannel(options) {
        Guard.isNotNullOrUndefined(options, "options");
        Guard.isNotNullOrUndefined(options.name, "options.name");
        Guard.isNotNullOrUndefined(options.type, "options.type");
        const response = await this._controlConnection.sendChatChannelNotification({
            channelName: options.name,
            channelStatus: "ACTIVE",
            channelType: options.type,
        });
        if (response == null ||
            response.chatChannelNotification == null ||
            response.chatChannelNotification.channelId == null)
            throw new Error("Failed to create chat channel");
        const channel = new Channel({
            apiClient: this._apiClient,
            chat: Reactive.wrap(this),
            controlConnection: this._controlConnection,
            localAttendee: this._localAttendee,
            model: {
                id: response.chatChannelNotification.channelId,
                meetingId: this._controlConnection.meetingId,
                name: response.chatChannelNotification.channelName,
                status: response.chatChannelNotification.channelStatus,
                type: response.chatChannelNotification.channelType,
            },
            subscribedView: this._subscribedView,
            uploadClient: this._uploadClient,
        });
        await channel.load();
        this._channels.tryAdd(channel);
        await this._channelAdded.dispatch({ channel });
        return channel;
    }
    async search(options) {
        const collection = await this._apiClient.listChatMessages({
            meetingId: this._controlConnection.meetingId,
            channelId: options.channelId,
            limit: options.limit,
            offset: options.offset,
            sortDirection: "DESC",
            where: options.filter,
        });
        const messages = [];
        for (const messageModel of collection.values) {
            const attendee = await this._subscribedView.subscribeToAttendee(messageModel.createdBy, "chatMessageReceived");
            const message = new Message({
                apiClient: this._apiClient,
                attendee: attendee,
                channel: await this.getChannel(messageModel.channelId),
                controlConnection: this._controlConnection,
                model: messageModel,
                uploadClient: this._uploadClient,
            });
            await message.load();
            messages.push(message);
        }
        return {
            totalCount: collection.totalCount,
            values: messages,
        };
    }
    async start() {
        if (!this.isInitialized && !this.isStopped)
            throw Error("Can not start chat until meeting is joined.");
        await this.setState("starting");
        try {
            this._controlConnection.chatChannelNotification.bind(this._onChatChannelNotification);
            this._controlConnection.chatChannelAttendeeNotification.bind(this._onChatChannelAttendeeNotification);
            this._controlConnection.chatMessageNotification.bind(this._onChatMessageNotification);
            await this._channels.load({
                apiClient: this._apiClient,
                chat: Reactive.wrap(this),
                controlConnection: this._controlConnection,
                defaultChannel: this._defaultChannel,
                localAttendee: this._localAttendee,
                subscribedView: this._subscribedView,
                uploadClient: this._uploadClient,
            });
            await this.setState("started");
        }
        catch (error) {
            await this.setState("error");
            throw error;
        }
    }
    async stop() {
        if (this.isInitialized || this.isStopped || this.isStopping || this.isNew)
            return;
        await this.setState("stopping");
        try {
            this._controlConnection.chatChannelNotification.unbind(this._onChatChannelNotification);
            this._controlConnection.chatChannelAttendeeNotification.unbind(this._onChatChannelAttendeeNotification);
            this._controlConnection.chatMessageNotification.unbind(this._onChatMessageNotification);
        }
        catch {
            /* best effort */
        }
        finally {
            await this.setState("stopped");
        }
    }
}

class LocalAudioTrackStateMachine {
    get state() { return this._state; }
    constructor(initialState) {
        this._state = initialState ?? "new";
    }
    setState(state) {
        if (this.trySetState(state))
            return;
        throw new Error(`Cannot transition to '${state}' state while in '${this._state}' state.`);
    }
    trySetState(state) {
        switch (state) {
            case "started":
                if (this._state != "starting")
                    return false;
                break;
            case "starting":
                if (this._state != "new" && this._state != "stopped")
                    return false;
                break;
            case "stopped":
                if (this._state != "starting" && this._state != "stopping" && this._state != "new")
                    return false;
                break;
            case "stopping":
                if (this._state != "started")
                    return false;
                break;
            default:
                return false;
        }
        this._state = state;
        return true;
    }
}

class LocalAudioTrack extends AudioTrack {
    /** @internal */
    set media(value) { this._media = value; }
    get bitrateMax() { return this._media?.connection?.audioBitrateMax; }
    get fallbackReason() { return this._fallbackReason; }
    get isInFallbackMode() { return this._isInFallbackMode; }
    get isRemote() { return false; }
    get isStarted() { return this.state == "started"; }
    get isStarting() { return this.state == "starting"; }
    get isStopped() { return this.state == "stopped" || this.state == "new"; }
    get isStopping() { return this.state == "stopping"; }
    get media() { return this._media; }
    get state() { return this._stateMachine.state; }
    get stream() { return this._stream; }
    /** @event */
    get ended() { return this._ended; }
    /** @event */
    get paused() { return this._paused; }
    /** @event */
    get resumed() { return this._resumed; }
    /** @event */
    get started() { return this._stateEvents.get("started"); }
    /** @event */
    get starting() { return this._stateEvents.get("starting"); }
    /** @event */
    get stateChanged() { return this._stateChanged; }
    /** @event */
    get stopped() { return this._stateEvents.get("stopped"); }
    /** @event */
    get stopping() { return this._stateEvents.get("stopping"); }
    /** @event */
    get streamBound() { return this._streamBound; }
    /** @event */
    get streamUnbound() { return this._streamUnbound; }
    constructor() {
        super();
        this._ended = new EventOwner();
        this._paused = new EventOwner();
        this._resumed = new EventOwner();
        this._stateChanged = new EventOwnerAsync();
        this._stateEvents = new Map();
        this._stateMachine = new LocalAudioTrackStateMachine();
        this._streamBound = new EventOwnerAsync();
        this._streamUnbound = new EventOwner();
        this._isInFallbackMode = false;
        this._media = null;
        this._stream = null;
        this._onEnded = this.onEnded.bind(Reactive.wrap(this));
        this._onPaused = this.onPaused.bind(Reactive.wrap(this));
        this._onResumed = this.onResumed.bind(Reactive.wrap(this));
        this._stateEvents.set("started", new EventOwnerAsync());
        this._stateEvents.set("starting", new EventOwnerAsync());
        this._stateEvents.set("stopped", new EventOwnerAsync());
        this._stateEvents.set("stopping", new EventOwnerAsync());
    }
    async bindStream(stream) {
        if (!stream)
            return;
        if (this._stream == stream)
            return;
        if (this._stream)
            this.unbindStream();
        this.prepareStream(stream);
        this._stream = stream;
        this._stream.addEventListener("ended", this._onEnded);
        this._stream.addEventListener("mute", this._onPaused);
        this._stream.addEventListener("unmute", this._onResumed);
        this._stream.enabled = !this.isMuted;
        await this._streamBound.dispatch({
            track: this
        });
    }
    async setState(state) {
        const previousState = this._stateMachine.state;
        this._stateMachine.setState(state);
        const e = {
            audioTrack: this,
            previousState: previousState,
            state: state,
        };
        await this._stateEvents.get(state).dispatch(e);
        await this._stateChanged.dispatch(e);
    }
    unbindStream() {
        if (!this._stream)
            return;
        this._stream.stop();
        this._stream.removeEventListener("ended", this._onEnded);
        this._stream.removeEventListener("mute", this._onPaused);
        this._stream.removeEventListener("unmute", this._onResumed);
        this._stream = null;
        this._streamUnbound.dispatch({
            track: this
        });
    }
    onEnded() {
        Log.warn(`Local ${this.media.type} audio track has ended.`);
        this._ended.dispatch({
            track: this
        });
    }
    onPaused() {
        Log.debug(`Local ${this.media.type} audio track has paused.`);
        this._paused.dispatch({
            track: this
        });
    }
    onResumed() {
        Log.debug(`Local ${this.media.type} audio track has resumed.`);
        this._resumed.dispatch({
            track: this
        });
    }
    async onStarted() { }
    async onStarting() { }
    async onStopped() { }
    async onStopping() { }
    prepareStream(stream) { }
    async replaceStream() {
        if (this._isReplacingStream) {
            Log.warn('Ignoring request to replace audio stream as a previous request is still in progress.');
            return;
        }
        if (!this._media?.stream)
            return;
        try {
            if (this._stream) {
                this._media.stream.removeTrack(this._stream);
                this.unbindStream();
            }
            const mediaStream = await this._media.getStreamInternal({ audio: this.getConstraints() }, this._media.fallbackIfDeviceNotAvailable);
            const [trackStream] = mediaStream.getAudioTracks();
            this._media.stream.addTrack(trackStream);
            await this.bindStream(trackStream);
        }
        finally {
            this._isReplacingStream = false;
        }
    }
    /** @internal */
    clearFallback() {
        this._isInFallbackMode = false;
        this._fallbackReason = null;
    }
    /** @internal */
    setFallback(errorName) {
        this._isInFallbackMode = true;
        this._fallbackReason = errorName;
    }
    /**
     * For testing only.
     */
    /** @internal */
    end() {
        this.stream?.stop();
        this.stream?.dispatchEvent(new Event("ended"));
    }
    /**
     * For testing only.
     */
    /** @internal */
    pause() {
        this.stream?.dispatchEvent(new Event("mute"));
    }
    /**
     * For testing only.
     */
    /** @internal */
    resume() {
        this.stream?.dispatchEvent(new Event("unmute"));
    }
    /** @internal */
    async startInternal(stream) {
        if (this.state == "started")
            return;
        try {
            await this.setState("starting");
            await this.onStarting();
            await this.bindStream(stream);
            await this.onStarted();
            await this.setState("started");
        }
        catch (error) {
            await this.setState("stopped");
            await this.onStopped();
            throw error;
        }
    }
    /** @internal */
    async stopInternal() {
        if (this.state == "new")
            await this.setState("stopped");
        if (this.state == "stopped")
            return;
        try {
            await this.setState("stopping");
            await this.onStopping();
            this.unbindStream();
        }
        finally {
            await this.setState("stopped");
            await this.onStopped();
        }
    }
    getConstraints() {
        return {};
    }
    reload() {
        return this.replaceStream();
    }
    start() {
        return this._media.startAudio();
    }
    async stop() {
        return this._media.stopAudio();
    }
}

class DisplayAudioTrack extends LocalAudioTrack {
    static get contentHint() { return this._contentHint; }
    static set contentHint(value) { this._contentHint = value; }
    get isMuted() { return false; }
    get isPaused() { return false; }
    onEnded() {
        if (this.media.isStarted)
            void this.media.stop();
        super.onEnded();
    }
    prepareStream(stream) {
        try {
            if ("contentHint" in stream)
                stream.contentHint = DisplayAudioTrack.contentHint;
        }
        catch { /* best effort */ }
    }
}
DisplayAudioTrack._contentHint = "music";

class LocalVideoTrackStateMachine {
    get state() { return this._state; }
    constructor(initialState) {
        this._state = initialState ?? "new";
    }
    setState(state) {
        if (this.trySetState(state))
            return;
        throw new Error(`Cannot transition to '${state}' state while in '${this._state}' state.`);
    }
    trySetState(state) {
        switch (state) {
            case "started":
                if (this._state != "starting")
                    return false;
                break;
            case "starting":
                if (this._state != "new" && this._state != "stopped")
                    return false;
                break;
            case "stopped":
                if (this._state != "starting" && this._state != "stopping" && this._state != "new")
                    return false;
                break;
            case "stopping":
                if (this._state != "started")
                    return false;
                break;
            default:
                return false;
        }
        this._state = state;
        return true;
    }
}

class VideoTrack {
    constructor() {
        this._frameSizeChanged = new EventOwner();
        //private _bitrate: number = null;
        //private _bytesReceived: number = null;
        //private _bytesSent: number = null;
        //private _candidateAddress: string = null;
        //private _candidateRelayProtocol: string = null;
        //private _candidateType: string = null;
        //private _frameRate: number = null;
        this._frameSize = null;
        //private _jitter: number = null;
        //private _keepAliveRequestsReceived: number;
        //private _keepAliveRequestsSent: number;
        //private _keepAliveResponsesReceived: number;
        //private _keepAliveResponsesSent: number;
        //private _keyFrameRequestsReceived: number = null;
        //private _keyFrameRequestsSent: number = null;
        //private _keyFramesReceived: number = null;
        //private _keyFramesSent: number = null;
        //private _nacksReceived: number = null;
        //private _nacksSent: number = null;
        //private _networkQuality: number = null;
        this._packetLoss = null;
        //private _packetsLost: number = null;
        //private _packetsReceived: number = null;
        //private _packetsSent: number = null;
        //private _remoteCandidateAddress: string = null;
        //private _remoteCandidateType: string = null;
        //private _roundTripTime: number = null;
        this._currentPacketsSent = 0;
        this._lastFrameRate = null;
        this._lastTargetBitrate = null;
        this._lastPacketsLost = null;
        this._lastPacketsSent = null;
        this._lastPacketsReceived = null;
        this._lastNacksReceived = null;
        this._lastPliCount = null;
        // Degradation Levels
        this._currentLevelBitrate = null;
        this._currentLevelFrameRate = null;
        this._currentLevelPixelCount = null;
        // Connection stats
        this._lastAvailableOutgoingBitrate = null;
    }
    get bitrate() {
        return this._statVideo?.BitrateActual;
    }
    get bytesReceived() {
        return this._statVideo?.Rtp_BytesReceived;
    }
    get bytesSent() {
        return this._statVideo?.Rtp_BytesSent;
    }
    get candidateAddress() {
        return this._statPair?.Lcl_Ip;
    }
    get candidateId() {
        return this._statPair?.Lcl_Id;
    }
    get candidatePairId() {
        return this._statPair?.Pair_Id;
    }
    get candidateRelayProtocol() {
        return this._statPair?.Lcl_Protocol;
    }
    get candidateType() {
        return this._statPair?.Lcl_CandidateType;
    }
    get candidateNetworkAdapterType() {
        return this._statPair?.Lcl_NetworkAdapterType;
    }
    get candidateNetworkType() {
        return this._statPair?.Lcl_NetworkType;
    }
    get frameRate() {
        return this._statVideo?.FramerateActual;
    }
    get frameSize() {
        return this._frameSize;
    }
    get isLocal() {
        return !this.isRemote;
    }
    get jitter() {
        return this._statVideo?.Rtp_Jitter;
    }
    get keepAliveRequestsReceived() {
        return this._statPair?.Pair_RequestsReceived;
    }
    get keepAliveRequestsSent() {
        return this._statPair?.Pair_RequestsSent;
    }
    get keepAliveResponsesReceived() {
        return this._statPair?.Pair_ResponsesReceived;
    }
    get keepAliveResponsesSent() {
        return this._statPair?.Pair_ResponsesSent;
    }
    get keyFrameRequestsReceived() {
        return this._statVideo?.getKeyFrameRequestCount();
    }
    get keyFrameRequestsSent() {
        return this._statVideo?.getKeyFrameRequestCount();
    }
    get keyFramesReceived() {
        return this._statVideo?.Rtp_KeyFramesDecoded;
    }
    get keyFramesSent() {
        return this._statVideo?.Rtp_KeyFramesDecoded;
    }
    get nacksReceived() {
        return this._statVideo?.Rtp_NackCount;
    }
    get nackCount() {
        return this._statVideo?.Rtp_NackCount - this._lastNacksReceived;
    }
    get lastFrameRate() {
        return this._lastFrameRate;
    }
    get pliCount() {
        return this._statVideo?.Rtp_PliCount - this._lastPliCount;
    }
    get qualityLimitationReason() {
        return this._statVideo?.Rtp_QualityLimitationReason;
    }
    // public get nacksSent(): number { return this._nacksSent; }
    //public get networkQuality(): number { return this._networkQuality; }
    get packetLoss() {
        if (this.isRemote) {
            if (Utility.isNullOrUndefined(this._statVideo?.Rtp_PacketsLost) || Utility.isNullOrUndefined(this._statVideo?.Rtp_PacketsReceived))
                return null;
            if (this._statVideo?.Rtp_PacketsLost == this._lastPacketsLost && this._statVideo?.Rtp_PacketsReceived == this._lastPacketsReceived)
                return 0;
            const packetsLostDelta = this._statVideo?.Rtp_PacketsLost - this._lastPacketsLost;
            const packetsReceivedDelta = this._statVideo?.Rtp_PacketsReceived - this._lastPacketsReceived;
            if (packetsReceivedDelta == 0)
                return 0;
            const packetLoss = packetsLostDelta / packetsReceivedDelta;
            this._packetLoss = packetLoss;
        }
        else {
            if (Utility.isNullOrUndefined(this._statVideo?.Rtp_PacketsLost) || Utility.isNullOrUndefined(this._statVideo?.Rtp_PacketsSent))
                return null;
            if (this._statVideo?.Rtp_PacketsLost == this._lastPacketsLost && this._statVideo?.Rtp_PacketsSent == this._lastPacketsSent)
                return 0;
            const packetsLostDelta = this._statVideo?.Rtp_PacketsLost - this._lastPacketsLost;
            const packetsSentDelta = this._statVideo?.Rtp_PacketsSent - this._lastPacketsSent;
            if (packetsSentDelta == 0)
                return 0;
            const packetLoss = packetsLostDelta / packetsSentDelta;
            this._packetLoss = packetLoss;
        }
        return this._packetLoss;
    }
    get packetsLost() {
        return this._statVideo?.Rtp_PacketsLost;
    }
    get packetsReceived() {
        return this._statVideo?.Rtp_PacketsReceived;
    }
    get packetsSent() {
        return this._statVideo?.Rtp_PacketsSent;
    }
    get remoteCandidateAddress() {
        return this._statPair?.Rmt_Ip;
    }
    get remoteCandidateId() {
        return this._statPair?.Rmt_Id;
    }
    get remoteCandidateType() {
        return this._statPair?.Rmt_CandidateType;
    }
    get roundTripTime() {
        return this._statVideo?.Rtp_RoundTripTime;
    }
    get availableOutgoingBitrate() {
        return this._statPair?.Pair_AvailableOutgoing;
    }
    get targetBitrate() {
        return this._statVideo?.Rtp_TargetBitrate;
    }
    get currentPacketsSent() {
        return this._currentPacketsSent ?? this._statVideo?.Rtp_PacketsSent;
    }
    // Degradation levels
    get currentLevelBitrate() {
        return this._currentLevelBitrate;
    }
    get currentLevelFrameRate() {
        return this._currentLevelFrameRate;
    }
    get currentLevelPixelCount() {
        return this._currentLevelPixelCount;
    }
    // Media info
    get codecMimeType() {
        return this._statVideo?.Codec_MimeType;
    }
    get codecSdpFmtpLine() {
        return this._statVideo?.Codec_SdpFmtpLine;
    }
    /** @event */
    get frameSizeChanged() {
        return this._frameSizeChanged;
    }
    updateFrameSize(frameSize) {
        if (frameSize.width == this._frameSize?.width && frameSize.height == this._frameSize?.height)
            return;
        const previousFrameSize = this._frameSize;
        this._frameSize = frameSize;
        this._frameSizeChanged.dispatch({
            frameSize: frameSize,
            previousFrameSize: previousFrameSize,
            track: this,
        });
    }
    /** @internal */
    updateStats(statVideo, statPair) {
        if (this._statVideo) {
            this._currentPacketsSent = statVideo.Rtp_PacketsSent - this._statVideo.Rtp_PacketsSent;
            this._lastFrameRate = this._statVideo.FramerateActual;
            this._lastTargetBitrate = this._statVideo.Rtp_TargetBitrate;
            this._lastPacketsLost = this._statVideo.Rtp_PacketsLost;
            this._lastPacketsSent = this._statVideo.Rtp_PacketsSent;
            this._lastPacketsReceived = this._statVideo.Rtp_PacketsReceived;
            this._lastNacksReceived = this._statVideo.Rtp_NackCount;
            this._lastPliCount = this._statVideo.Rtp_PliCount;
        }
        this._statVideo = statVideo;
        this._frameSize = {
            height: this._statVideo?.ResolutionHeight,
            width: this._statVideo?.ResolutionWidth,
        };
        if (statPair != null) {
            this._lastAvailableOutgoingBitrate = this._statPair?.Pair_AvailableOutgoing;
            this._statPair = statPair;
        }
    }
    /** @internal */
    updateDegradationLevels(bitrateLevel, frameRateLevel, pixelCountLevel) {
        this._currentLevelBitrate = bitrateLevel;
        this._currentLevelFrameRate = frameRateLevel;
        this._currentLevelPixelCount = pixelCountLevel;
    }
    /** @internal */
    didAvailableOutgoingBitrateIncrease() {
        return this._statPair.Pair_AvailableOutgoing > this._lastAvailableOutgoingBitrate;
    }
    /** @internal */
    didAvailableOutgoingBitrateDecrease() {
        return this._statPair.Pair_AvailableOutgoing < this._lastAvailableOutgoingBitrate;
    }
    /** @internal */
    didTargetBitrateIncrease() {
        return this._statVideo.Rtp_TargetBitrate > this._lastTargetBitrate;
    }
    /** @internal */
    didTargetBitrateDecrease() {
        return this._statVideo.Rtp_TargetBitrate < this._lastTargetBitrate;
    }
    /** @internal */
    getSenderPacketLoss() {
        if (Utility.isNullOrUndefined(this._statVideo?.Rtp_PacketsLost) || Utility.isNullOrUndefined(this._statVideo?.Rtp_PacketsSent))
            return null;
        if (this._statVideo?.Rtp_PacketsLost == this._lastPacketsLost && this._statVideo?.Rtp_PacketsSent == this._lastPacketsSent)
            return 0;
        const packetsLostDelta = this._statVideo?.Rtp_PacketsLost - this._lastPacketsLost;
        const packetsSentDelta = this._statVideo?.Rtp_PacketsSent - this._lastPacketsSent;
        if (packetsSentDelta == 0)
            return 0;
        const packetLoss = packetsLostDelta / packetsSentDelta;
        return packetLoss;
    }
}

class LocalVideoTrack extends VideoTrack {
    /** @internal */
    set media(value) { this._media = value; }
    get bitrateMax() { return this._media?.connection?.videoBitrateMax; }
    get fallbackReason() { return this._fallbackReason; }
    get isDisabled() { return false; }
    get isInFallbackMode() { return this._isInFallbackMode; }
    get isRemote() { return false; }
    get isStarted() { return this.state == "started"; }
    get isStarting() { return this.state == "starting"; }
    get isStopped() { return this.state == "stopped" || this.state == "new"; }
    get isStopping() { return this.state == "stopping"; }
    get media() { return this._media; }
    get pixelCountMax() { return this._media?.connection?.videoPixelCountMax; }
    get requestedFrameRate() { return this._requestedFrameRate; }
    get requestedFrameSize() { return this._requestedFrameSize; }
    get spatialLayerIndex() { return 0; }
    get state() { return this._stateMachine.state; }
    get stream() { return this._stream; }
    get temporalLayerIndex() { return 0; }
    /** @event */
    get ended() { return this._ended; }
    /** @event */
    get paused() { return this._paused; }
    /** @event */
    get resumed() { return this._resumed; }
    /** @event */
    get started() { return this._stateEvents.get("started"); }
    /** @event */
    get starting() { return this._stateEvents.get("starting"); }
    /** @event */
    get stateChanged() { return this._stateChanged; }
    /** @event */
    get stopped() { return this._stateEvents.get("stopped"); }
    /** @event */
    get stopping() { return this._stateEvents.get("stopping"); }
    /** @event */
    get streamBound() { return this._streamBound; }
    /** @event */
    get streamUnbound() { return this._streamUnbound; }
    constructor() {
        super();
        this._ended = new EventOwner();
        this._paused = new EventOwner();
        this._resumed = new EventOwner();
        this._stateChanged = new EventOwnerAsync();
        this._stateEvents = new Map();
        this._stateMachine = new LocalVideoTrackStateMachine();
        this._streamBound = new EventOwnerAsync();
        this._streamUnbound = new EventOwner();
        this._isInFallbackMode = false;
        this._isReplacingStream = false;
        this._media = null;
        this._requestedFrameRate = null;
        this._requestedFrameSize = null;
        this._stream = null;
        this._onEnded = this.onEnded.bind(Reactive.wrap(this));
        this._onPaused = this.onPaused.bind(Reactive.wrap(this));
        this._onResumed = this.onResumed.bind(Reactive.wrap(this));
        this._stateEvents.set("started", new EventOwnerAsync());
        this._stateEvents.set("starting", new EventOwnerAsync());
        this._stateEvents.set("stopped", new EventOwnerAsync());
        this._stateEvents.set("stopping", new EventOwnerAsync());
    }
    async bindStream(stream) {
        if (!stream)
            return;
        if (this._stream == stream)
            return;
        if (this._stream)
            this.unbindStream();
        this.prepareStream(stream);
        this._stream = stream;
        this._stream.addEventListener("ended", this._onEnded);
        this._stream.addEventListener("mute", this._onPaused);
        this._stream.addEventListener("unmute", this._onResumed);
        this._stream.enabled = !this.isMuted;
        await this._streamBound.dispatch({
            track: this
        });
    }
    async setState(state) {
        const previousState = this._stateMachine.state;
        this._stateMachine.setState(state);
        const e = {
            videoTrack: this,
            previousState: previousState,
            state: state,
        };
        await this._stateEvents.get(state).dispatch(e);
        await this._stateChanged.dispatch(e);
    }
    unbindStream() {
        if (!this._stream)
            return;
        this._stream.stop();
        this._stream.removeEventListener("ended", this._onEnded);
        this._stream.removeEventListener("mute", this._onPaused);
        this._stream.removeEventListener("unmute", this._onResumed);
        this._stream = null;
        this._streamUnbound.dispatch({
            track: this
        });
    }
    onEnded() {
        Log.warn(`Local ${this.media.type} video track has ended.`);
        this._ended.dispatch({
            track: this
        });
    }
    onPaused() {
        Log.debug(`Local ${this.media.type} video track has paused.`);
        this._paused.dispatch({
            track: this
        });
    }
    onResumed() {
        Log.debug(`Local ${this.media.type} video track has resumed.`);
        this._resumed.dispatch({
            track: this
        });
    }
    async onStarted() { }
    async onStarting() { }
    async onStopped() { }
    async onStopping() { }
    prepareStream(stream) { }
    async replaceStream() {
        if (this._isReplacingStream) {
            Log.warn('Ignoring request to replace video stream as as a previous request is still in progress.');
            return;
        }
        if (!this._media?.stream)
            return;
        this._isReplacingStream = true;
        try {
            if (this._stream) {
                this._media.stream.removeTrack(this._stream);
                this.unbindStream();
            }
            const mediaStream = await this._media.getStreamInternal({ video: this.getConstraints() }, this._media.fallbackIfDeviceNotAvailable);
            const [trackStream] = mediaStream.getVideoTracks();
            this._media.stream.addTrack(trackStream);
            await this.bindStream(trackStream);
        }
        finally {
            this._isReplacingStream = false;
        }
    }
    /** @internal */
    clearFallback() {
        this._isInFallbackMode = false;
        this._fallbackReason = null;
    }
    /**
     * For testing only.
     */
    /** @internal */
    end() {
        this.stream?.stop();
        this.stream?.dispatchEvent(new Event("ended"));
    }
    /**
     * For testing only.
     */
    /** @internal */
    pause() {
        this.stream?.dispatchEvent(new Event("mute"));
    }
    /**
     * For testing only.
     */
    /** @internal */
    resume() {
        this.stream?.dispatchEvent(new Event("unmute"));
    }
    /* @internal */
    setFallback(errorName) {
        this._isInFallbackMode = true;
        this._fallbackReason = errorName;
    }
    /** @internal */
    async startInternal(stream) {
        if (this.state == "started")
            return;
        try {
            await this.setState("starting");
            await this.onStarting();
            await this.bindStream(stream);
            await this.onStarted();
            await this.setState("started");
        }
        catch (error) {
            await this.setState("stopped");
            await this.onStopped();
            throw error;
        }
    }
    /** @internal */
    async stopInternal() {
        if (this.state == "new")
            await this.setState("stopped");
        if (this.state == "stopped")
            return;
        try {
            await this.setState("stopping");
            await this.onStopping();
            this.unbindStream();
        }
        finally {
            await this.setState("stopped");
            await this.onStopped();
        }
    }
    async applyContraints(constraints) {
        if (!this._stream)
            return;
        try {
            const constraintsToApply = constraints ?? this.getConstraints();
            await this.stream.applyConstraints(constraintsToApply);
        }
        catch (error) {
            Log.warn('Error when applying constraints to video track. Trying with min constraints...', error);
            try {
                await this.stream?.applyConstraints(this.getMinConstraints());
            }
            catch (minError) {
                Log.warn('Error when applying min constraints to video track.', error);
            }
        }
    }
    getConstraints(isDisplay) {
        const room = this._media.room;
        var constraints = {};
        // for browser compatibility, only use ideal for framerate. Setting max value can cause issues in Firefox
        if (room) {
            if (isDisplay) {
                constraints.frameRate = { ideal: room.maxVideoFramerateDisplay };
                constraints.width = { ideal: room.maxVideoWidthDisplay };
                constraints.height = { ideal: room.maxVideoHeightDisplay };
            }
            else {
                constraints.width = { max: room.maxVideoWidthUser };
                constraints.height = { max: room.maxVideoHeightUser };
            }
        }
        // allow overrides
        if (this._requestedFrameRate) {
            constraints.frameRate = { ideal: this._requestedFrameRate };
        }
        if (this._requestedFrameSize && !isDisplay) {
            constraints.width = { ideal: this._requestedFrameSize.width, max: room?.maxVideoWidthUser ?? undefined };
            constraints.height = { ideal: this._requestedFrameSize.height, max: room?.maxVideoHeightUser ?? undefined };
        }
        return constraints;
    }
    getMinConstraints(isDisplay) {
        const room = this._media.room;
        const constraints = {};
        if (room) {
            if (isDisplay) {
                constraints.frameRate = { ideal: room.minVideoFramerateDisplay };
                constraints.width = { ideal: room.minVideoWidthDisplay };
                constraints.height = { ideal: room.minVideoHeightDisplay };
            }
            else {
                constraints.frameRate = { ideal: room.minVideoFramerateUser };
                constraints.width = { ideal: room.minVideoWidthUser };
                constraints.height = { ideal: room.minVideoHeightUser };
            }
        }
        else {
            constraints.frameRate = { ideal: 5 };
            constraints.width = { ideal: 240 };
            constraints.height = { ideal: 320 };
        }
        return constraints;
    }
    async reload() {
        return await this.replaceStream();
    }
    async setFrameRate(frameRate) {
        if (this._requestedFrameRate == frameRate)
            return;
        this._requestedFrameRate = frameRate ?? null;
        await this.applyContraints();
    }
    async setFrameSize(frameSize) {
        if (this._requestedFrameSize?.width == frameSize?.width && this._requestedFrameSize?.height == frameSize?.height)
            return;
        this._requestedFrameSize = frameSize ?? null;
        await this.applyContraints();
    }
    start() {
        return this._media.startVideo();
    }
    async stop() {
        return this._media.stopVideo();
    }
}

class DisplayVideoTrack extends LocalVideoTrack {
    static get contentHint() { return this._contentHint; }
    static set contentHint(value) { this._contentHint = value; }
    get isMuted() { return false; }
    get isPaused() { return false; }
    onEnded() {
        if (this.media.isStarted)
            void this.media.stop();
        super.onEnded();
    }
    prepareStream(stream) {
        try {
            if ("contentHint" in stream)
                stream.contentHint = DisplayVideoTrack.contentHint;
        }
        catch { /* best effort */ }
    }
    getConstraints() {
        const constraints = super.getConstraints(true);
        constraints.frameRate ??= { ideal: 5 };
        return constraints;
    }
}
DisplayVideoTrack._contentHint = "detail";

class LocalMediaStateMachine {
    get state() { return this._state; }
    constructor(initialState) {
        this._state = initialState ?? "new";
    }
    setState(state) {
        if (this.trySetState(state))
            return;
        throw new Error(`Cannot transition to '${state}' state while in '${this._state}' state.`);
    }
    trySetState(state) {
        switch (state) {
            case "started":
                if (this._state != "starting")
                    return false;
                break;
            case "starting":
                if (this._state != "new" && this._state != "stopped")
                    return false;
                break;
            case "stopped":
                if (this._state != "starting" && this._state != "stopping" && this._state != "new")
                    return false;
                break;
            case "stopping":
                if (this._state != "started")
                    return false;
                break;
            default:
                return false;
        }
        this._state = state;
        return true;
    }
}

class Media {
    get id() { return this._id; }
    get isDisplay() { return this._type == "display"; }
    get isLocal() { return !this.isRemote; }
    get isUser() { return this._type == "user"; }
    get type() { return this._type; }
    constructor(type) {
        this._id = Utility.generateGuid();
        this._type = type;
    }
}

class LocalMedia extends Media {
    /** @internal */
    get connection() { return this._connection; }
    /** @internal */
    set connection(value) { this._connection = value; }
    get attendee() { return this._attendee; }
    get audioTrack() { return this._audioTrack; }
    get fallbackIfDeviceNotAvailable() { return this._fallbackIfDeviceNotAvailable; }
    get isConnected() { return this._attendee != null; }
    get isDisconnected() { return !this.isConnected; }
    get isRemote() { return false; }
    get isStarted() { return this.state == "started"; }
    get isStarting() { return this.state == "starting"; }
    get isStopped() { return this.state == "stopped" || this.state == "new"; }
    get isStopping() { return this.state == "stopping"; }
    get state() { return this._stateMachine.state; }
    get stream() { return this._stream; }
    get videoTrack() { return this._videoTrack; }
    get room() { return this._room; }
    set room(value) { this._room = value; }
    /** @event */
    get attendeeBound() { return this._attendeeBound; }
    /** @event */
    get attendeeUnbound() { return this._attendeeUnbound; }
    /** @event */
    get connected() { return this._connected; }
    /** @event */
    get disconnected() { return this._disconnected; }
    /** @event */
    get started() { return this._stateEvents.get("started"); }
    /** @event */
    get starting() { return this._stateEvents.get("starting"); }
    /** @event */
    get stateChanged() { return this._stateChanged; }
    /** @event */
    get stopped() { return this._stateEvents.get("stopped"); }
    /** @event */
    get stopping() { return this._stateEvents.get("stopping"); }
    constructor(audioTrack, type, videoTrack, deviceOptions) {
        super(type);
        this._attendeeBound = new EventOwnerAsync();
        this._attendeeUnbound = new EventOwner();
        this._connected = new EventOwnerAsync();
        this._disconnected = new EventOwner();
        this._eventQueue = new DispatchQueue();
        this._stateChanged = new EventOwnerAsync();
        this._stateEvents = new Map();
        this._stateMachine = new LocalMediaStateMachine();
        this._attendee = null;
        this._connection = null;
        this._stream = null;
        this._room = null;
        if (Utility.isNullOrUndefined(audioTrack) && Utility.isNullOrUndefined(videoTrack))
            throw new Error("Parameters audioTrack and videoTrack cannot both be null or undefined.");
        this._fallbackIfDeviceNotAvailable = deviceOptions?.fallbackIfDeviceNotAvailable;
        this._audioTrack = audioTrack;
        this._videoTrack = videoTrack;
        if (this._audioTrack)
            this._audioTrack.media = this;
        if (this._videoTrack)
            this._videoTrack.media = this;
        this._stateEvents.set("started", new EventOwnerAsync());
        this._stateEvents.set("starting", new EventOwnerAsync());
        this._stateEvents.set("stopped", new EventOwnerAsync());
        this._stateEvents.set("stopping", new EventOwnerAsync());
    }
    static getDeviceIdConstraint(constraints) {
        const deviceId = constraints?.deviceId;
        if (Utility.isNullOrUndefined(deviceId) || Utility.isString(deviceId))
            return null;
        return deviceId;
    }
    static getTrackConstraints(constraints) {
        if (Utility.isNullOrUndefined(constraints) || Utility.isBoolean(constraints))
            return null;
        return constraints;
    }
    async setState(state) {
        const previousState = this._stateMachine.state;
        this._stateMachine.setState(state);
        const e = {
            media: this,
            previousState: previousState,
            state: state,
        };
        await this._stateEvents.get(state).dispatch(e);
        await this._stateChanged.dispatch(e);
    }
    async startInternal(audio, video) {
        if (this.state == "started")
            return;
        try {
            await this.setState("starting");
            await this.onStarting();
            const stream = await this.getStreamInternal({
                audio: audio && this.audioTrack ? this.audioTrack.getConstraints() : false,
                video: video && this.videoTrack ? this.videoTrack.getConstraints() : false,
            }, this._fallbackIfDeviceNotAvailable);
            this._stream = stream;
            const [audioTrackStream] = stream.getAudioTracks();
            const [videoTrackStream] = stream.getVideoTracks();
            if (audioTrackStream)
                await this.audioTrack?.startInternal(audioTrackStream);
            if (videoTrackStream)
                await this.videoTrack?.startInternal(videoTrackStream);
            await this.setState("started");
            await this.onStarted();
        }
        catch (error) {
            await this.setState("stopped");
            await this.onStopped();
            throw error;
        }
    }
    async testAudioConstraints(constraints) {
        try {
            const stream = await this.getStream({ audio: constraints });
            stream.getAudioTracks()[0].stop();
            return true;
        }
        catch {
            return false;
        }
    }
    async testVideoConstraints(constraints) {
        try {
            const stream = await this.getStream({ video: constraints });
            stream.getVideoTracks()[0].stop();
            return true;
        }
        catch {
            return false;
        }
    }
    async onStarted() { }
    async onStarting() { }
    async onStopped() { }
    async onStopping() { }
    /** @internal */
    async bindAttendee(attendee) {
        Guard.isNotNullOrUndefined(attendee, "attendee");
        if (this._attendee == attendee)
            return;
        const previousAttendee = this._attendee;
        this._attendee = attendee;
        if (this.type == "user")
            await this._attendee.bindMedia(this);
        await this._attendeeBound.dispatch({
            attendee: attendee,
            media: this,
            previousAttendee: previousAttendee,
        });
        await this._connected.dispatch({
            media: this,
        });
    }
    /** @internal */
    async getStreamInternal(constraints, fallbackIfDeviceNotAvailable = false) {
        try {
            if (constraints.audio)
                this._audioTrack?.clearFallback();
            if (constraints.video)
                this._videoTrack?.clearFallback();
            return await this.getStream(constraints);
        }
        catch (error) {
            if ('name' in error) { // we're expecting an instanceof DOMException, but using "error instanceof DOMException" check doesnt work in Safari
                switch (error.name) {
                    case "AbortError": // some problem occurred which prevented the device from being used
                    case "NotAllowedError": // one or more of the requested source devices cannot be used at this time
                    case "NotFoundError": // no media tracks of the type specified were found that satisfy the given constraints
                    case "NotReadableError": // a hardware error occurred at the operating system, browser, or Web page level which prevented access to the device
                    case "OverconstrainedError": // the specified constraints resulted in no candidate devices which met the criteria requested
                        const audioConstraints = LocalMedia.getTrackConstraints(constraints.audio);
                        const videoConstraints = LocalMedia.getTrackConstraints(constraints.video);
                        const audioDeviceIdConstraint = LocalMedia.getDeviceIdConstraint(audioConstraints);
                        const videoDeviceIdConstraint = LocalMedia.getDeviceIdConstraint(videoConstraints);
                        if (audioDeviceIdConstraint?.ideal && videoDeviceIdConstraint?.ideal) {
                            Log.debug(`Could not get local ${this.type} media with optional audio/video device IDs. Retrying without audio/video device IDs...`, error);
                            if (!await this.testAudioConstraints(audioConstraints)) {
                                delete audioConstraints.deviceId;
                                if (!await this.testAudioConstraints(audioConstraints) && !fallbackIfDeviceNotAvailable)
                                    throw error;
                            }
                            if (!await this.testVideoConstraints(videoConstraints)) {
                                delete videoConstraints.deviceId;
                                if (!await this.testVideoConstraints(videoConstraints) && !fallbackIfDeviceNotAvailable)
                                    throw error;
                            }
                            return await this.getStreamInternal(constraints, fallbackIfDeviceNotAvailable);
                        }
                        if (audioDeviceIdConstraint?.ideal) {
                            Log.info(`Could not get local ${this.type} media with optional audio device ID. Retrying without audio device ID...`, error);
                            delete audioConstraints.deviceId;
                            return await this.getStreamInternal(constraints, fallbackIfDeviceNotAvailable);
                        }
                        if (videoDeviceIdConstraint?.ideal) {
                            Log.info(`Could not get local ${this.type} media with optional video device ID. Retrying without video device ID...`, error);
                            delete videoConstraints.deviceId;
                            return await this.getStreamInternal(constraints, fallbackIfDeviceNotAvailable);
                        }
                        if (fallbackIfDeviceNotAvailable) {
                            let stream = new MediaStream();
                            if (this._audioTrack != null) {
                                try {
                                    const audioConstraints = this._audioTrack.getConstraints();
                                    const audioStream = await this.getStreamInternal({ audio: audioConstraints }, false);
                                    const [audioTrack] = audioStream.getAudioTracks();
                                    stream.addTrack(audioTrack);
                                }
                                catch (audioError) {
                                    Log.warn('Falling back to audio context for audio...', audioError);
                                    stream.addTrack(this.createFallbackAudioTrack());
                                    this._audioTrack.setFallback(audioError.name);
                                }
                            }
                            if (this._videoTrack != null) {
                                try {
                                    const videoConstraints = this._videoTrack.getConstraints();
                                    const videoStream = await this.getStreamInternal({ video: videoConstraints }, false);
                                    const [videoTrack] = videoStream.getVideoTracks();
                                    stream.addTrack(videoTrack);
                                }
                                catch (videoError) {
                                    Log.warn('Falling back to canvas for video...', videoError);
                                    stream.addTrack(this.createFallbackVideoTrack());
                                    this._videoTrack.setFallback(videoError.name);
                                }
                            }
                            return stream;
                        }
                        break;
                }
            }
            throw error;
        }
    }
    createFallbackAudioTrack() {
        const audioContext = new AudioContext();
        const silentAudioNode = audioContext.createBufferSource();
        const buffer = audioContext.createBuffer(1, 1, audioContext.sampleRate);
        silentAudioNode.buffer = buffer;
        silentAudioNode.connect(audioContext.destination);
        return audioContext.createMediaStreamDestination().stream.getAudioTracks()[0];
    }
    createFallbackVideoTrack() {
        const canvas = document.createElement('canvas');
        return canvas.captureStream().getVideoTracks()[0];
    }
    async startAudio() {
        if (!this._audioTrack)
            throw new Error("Audio is disabled.");
        await this._eventQueue.dispatch(async () => {
            if (this.state == "started") {
                if (this._audioTrack.stream)
                    return;
                const stream = await this.getStreamInternal({ audio: this._audioTrack.getConstraints() }, this._fallbackIfDeviceNotAvailable);
                const [trackStream] = stream.getAudioTracks();
                this._stream.addTrack(trackStream);
                await this._audioTrack.startInternal(trackStream);
            }
            else {
                await this.startInternal(true, false);
            }
        });
    }
    async startVideo() {
        if (!this._videoTrack)
            throw new Error("Video is disabled.");
        await this._eventQueue.dispatch(async () => {
            if (this.state == "started") {
                if (this._videoTrack.stream)
                    return;
                const stream = await this.getStreamInternal({ video: this._videoTrack.getConstraints() }, this._fallbackIfDeviceNotAvailable);
                const [trackStream] = stream.getVideoTracks();
                this._stream.addTrack(trackStream);
                await this._videoTrack.startInternal(trackStream);
            }
            else {
                await this.startInternal(false, true);
            }
        });
    }
    async stopAudio() {
        if (!this._audioTrack)
            throw new Error("Audio is disabled.");
        await this._eventQueue.dispatch(async () => {
            if (this.state == "stopped")
                return;
            if (!this._audioTrack.stream)
                return;
            await this._audioTrack.stopInternal();
            this._stream.getAudioTracks().forEach(track => this.stream.removeTrack(track));
        });
    }
    async stopVideo() {
        if (!this._videoTrack)
            throw new Error("Video is disabled.");
        await this._eventQueue.dispatch(async () => {
            if (this.state == "stopped")
                return;
            if (!this._videoTrack.stream)
                return;
            await this._videoTrack.stopInternal();
            this._stream.getVideoTracks().forEach(track => this.stream.removeTrack(track));
        });
    }
    /** @internal */
    unbindAttendee() {
        if (!this._attendee)
            return;
        const previousAttendee = this._attendee;
        if (this.type == "user")
            this._attendee.unbindMedia();
        this._attendee = null;
        this._attendeeUnbound.dispatch({
            attendee: null,
            media: this,
            previousAttendee: previousAttendee,
        });
        this._disconnected.dispatch({
            media: this,
        });
    }
    async start() {
        await this._eventQueue.dispatch(() => {
            return this.startInternal(this._audioTrack ? true : false, this._videoTrack ? true : false);
        });
    }
    async stop() {
        await this._eventQueue.dispatch(async () => {
            if (this.state == "new")
                await this.setState("stopped");
            if (this.state == "stopped")
                return;
            try {
                await this.setState("stopping");
                await this.onStopping();
                if (this._audioTrack?.isStarted)
                    await this._audioTrack.stopInternal();
                if (this._videoTrack?.isStarted)
                    await this._videoTrack.stopInternal();
                this._stream = null;
            }
            finally {
                await this.setState("stopped");
                await this.onStopped();
            }
        });
    }
}

class DisplayMedia extends LocalMedia {
    get audioTrack() { return super.audioTrack; }
    get videoTrack() { return super.videoTrack; }
    constructor(audio, video) {
        super(audio ? new DisplayAudioTrack() : null, "display", video ? new DisplayVideoTrack() : null);
    }
    getStream(constraints) {
        return globalThis.navigator.mediaDevices.getDisplayMedia(constraints);
    }
}

// NOTE: this list must be up-to-date with browsers listed in
// test/acceptance/useragentstrings.yml
const BROWSER_ALIASES_MAP = {
  'Amazon Silk': 'amazon_silk',
  'Android Browser': 'android',
  Bada: 'bada',
  BlackBerry: 'blackberry',
  Chrome: 'chrome',
  Chromium: 'chromium',
  Electron: 'electron',
  Epiphany: 'epiphany',
  Firefox: 'firefox',
  Focus: 'focus',
  Generic: 'generic',
  'Google Search': 'google_search',
  Googlebot: 'googlebot',
  'Internet Explorer': 'ie',
  'K-Meleon': 'k_meleon',
  Maxthon: 'maxthon',
  'Microsoft Edge': 'edge',
  'MZ Browser': 'mz',
  'NAVER Whale Browser': 'naver',
  Opera: 'opera',
  'Opera Coast': 'opera_coast',
  PhantomJS: 'phantomjs',
  Puffin: 'puffin',
  QupZilla: 'qupzilla',
  QQ: 'qq',
  QQLite: 'qqlite',
  Safari: 'safari',
  Sailfish: 'sailfish',
  'Samsung Internet for Android': 'samsung_internet',
  SeaMonkey: 'seamonkey',
  Sleipnir: 'sleipnir',
  Swing: 'swing',
  Tizen: 'tizen',
  'UC Browser': 'uc',
  Vivaldi: 'vivaldi',
  'WebOS Browser': 'webos',
  WeChat: 'wechat',
  'Yandex Browser': 'yandex',
  Roku: 'roku',
};

const BROWSER_MAP = {
  amazon_silk: 'Amazon Silk',
  android: 'Android Browser',
  bada: 'Bada',
  blackberry: 'BlackBerry',
  chrome: 'Chrome',
  chromium: 'Chromium',
  electron: 'Electron',
  epiphany: 'Epiphany',
  firefox: 'Firefox',
  focus: 'Focus',
  generic: 'Generic',
  googlebot: 'Googlebot',
  google_search: 'Google Search',
  ie: 'Internet Explorer',
  k_meleon: 'K-Meleon',
  maxthon: 'Maxthon',
  edge: 'Microsoft Edge',
  mz: 'MZ Browser',
  naver: 'NAVER Whale Browser',
  opera: 'Opera',
  opera_coast: 'Opera Coast',
  phantomjs: 'PhantomJS',
  puffin: 'Puffin',
  qupzilla: 'QupZilla',
  qq: 'QQ Browser',
  qqlite: 'QQ Browser Lite',
  safari: 'Safari',
  sailfish: 'Sailfish',
  samsung_internet: 'Samsung Internet for Android',
  seamonkey: 'SeaMonkey',
  sleipnir: 'Sleipnir',
  swing: 'Swing',
  tizen: 'Tizen',
  uc: 'UC Browser',
  vivaldi: 'Vivaldi',
  webos: 'WebOS Browser',
  wechat: 'WeChat',
  yandex: 'Yandex Browser',
};

const PLATFORMS_MAP = {
  tablet: 'tablet',
  mobile: 'mobile',
  desktop: 'desktop',
  tv: 'tv',
};

const OS_MAP = {
  WindowsPhone: 'Windows Phone',
  Windows: 'Windows',
  MacOS: 'macOS',
  iOS: 'iOS',
  Android: 'Android',
  WebOS: 'WebOS',
  BlackBerry: 'BlackBerry',
  Bada: 'Bada',
  Tizen: 'Tizen',
  Linux: 'Linux',
  ChromeOS: 'Chrome OS',
  PlayStation4: 'PlayStation 4',
  Roku: 'Roku',
};

const ENGINE_MAP = {
  EdgeHTML: 'EdgeHTML',
  Blink: 'Blink',
  Trident: 'Trident',
  Presto: 'Presto',
  Gecko: 'Gecko',
  WebKit: 'WebKit',
};

class Utils {
  /**
   * Get first matched item for a string
   * @param {RegExp} regexp
   * @param {String} ua
   * @return {Array|{index: number, input: string}|*|boolean|string}
   */
  static getFirstMatch(regexp, ua) {
    const match = ua.match(regexp);
    return (match && match.length > 0 && match[1]) || '';
  }

  /**
   * Get second matched item for a string
   * @param regexp
   * @param {String} ua
   * @return {Array|{index: number, input: string}|*|boolean|string}
   */
  static getSecondMatch(regexp, ua) {
    const match = ua.match(regexp);
    return (match && match.length > 1 && match[2]) || '';
  }

  /**
   * Match a regexp and return a constant or undefined
   * @param {RegExp} regexp
   * @param {String} ua
   * @param {*} _const Any const that will be returned if regexp matches the string
   * @return {*}
   */
  static matchAndReturnConst(regexp, ua, _const) {
    if (regexp.test(ua)) {
      return _const;
    }
    return void (0);
  }

  static getWindowsVersionName(version) {
    switch (version) {
      case 'NT': return 'NT';
      case 'XP': return 'XP';
      case 'NT 5.0': return '2000';
      case 'NT 5.1': return 'XP';
      case 'NT 5.2': return '2003';
      case 'NT 6.0': return 'Vista';
      case 'NT 6.1': return '7';
      case 'NT 6.2': return '8';
      case 'NT 6.3': return '8.1';
      case 'NT 10.0': return '10';
      default: return undefined;
    }
  }

  /**
   * Get macOS version name
   *    10.5 - Leopard
   *    10.6 - Snow Leopard
   *    10.7 - Lion
   *    10.8 - Mountain Lion
   *    10.9 - Mavericks
   *    10.10 - Yosemite
   *    10.11 - El Capitan
   *    10.12 - Sierra
   *    10.13 - High Sierra
   *    10.14 - Mojave
   *    10.15 - Catalina
   *
   * @example
   *   getMacOSVersionName("10.14") // 'Mojave'
   *
   * @param  {string} version
   * @return {string} versionName
   */
  static getMacOSVersionName(version) {
    const v = version.split('.').splice(0, 2).map(s => parseInt(s, 10) || 0);
    v.push(0);
    if (v[0] !== 10) return undefined;
    switch (v[1]) {
      case 5: return 'Leopard';
      case 6: return 'Snow Leopard';
      case 7: return 'Lion';
      case 8: return 'Mountain Lion';
      case 9: return 'Mavericks';
      case 10: return 'Yosemite';
      case 11: return 'El Capitan';
      case 12: return 'Sierra';
      case 13: return 'High Sierra';
      case 14: return 'Mojave';
      case 15: return 'Catalina';
      default: return undefined;
    }
  }

  /**
   * Get Android version name
   *    1.5 - Cupcake
   *    1.6 - Donut
   *    2.0 - Eclair
   *    2.1 - Eclair
   *    2.2 - Froyo
   *    2.x - Gingerbread
   *    3.x - Honeycomb
   *    4.0 - Ice Cream Sandwich
   *    4.1 - Jelly Bean
   *    4.4 - KitKat
   *    5.x - Lollipop
   *    6.x - Marshmallow
   *    7.x - Nougat
   *    8.x - Oreo
   *    9.x - Pie
   *
   * @example
   *   getAndroidVersionName("7.0") // 'Nougat'
   *
   * @param  {string} version
   * @return {string} versionName
   */
  static getAndroidVersionName(version) {
    const v = version.split('.').splice(0, 2).map(s => parseInt(s, 10) || 0);
    v.push(0);
    if (v[0] === 1 && v[1] < 5) return undefined;
    if (v[0] === 1 && v[1] < 6) return 'Cupcake';
    if (v[0] === 1 && v[1] >= 6) return 'Donut';
    if (v[0] === 2 && v[1] < 2) return 'Eclair';
    if (v[0] === 2 && v[1] === 2) return 'Froyo';
    if (v[0] === 2 && v[1] > 2) return 'Gingerbread';
    if (v[0] === 3) return 'Honeycomb';
    if (v[0] === 4 && v[1] < 1) return 'Ice Cream Sandwich';
    if (v[0] === 4 && v[1] < 4) return 'Jelly Bean';
    if (v[0] === 4 && v[1] >= 4) return 'KitKat';
    if (v[0] === 5) return 'Lollipop';
    if (v[0] === 6) return 'Marshmallow';
    if (v[0] === 7) return 'Nougat';
    if (v[0] === 8) return 'Oreo';
    if (v[0] === 9) return 'Pie';
    return undefined;
  }

  /**
   * Get version precisions count
   *
   * @example
   *   getVersionPrecision("1.10.3") // 3
   *
   * @param  {string} version
   * @return {number}
   */
  static getVersionPrecision(version) {
    return version.split('.').length;
  }

  /**
   * Calculate browser version weight
   *
   * @example
   *   compareVersions('1.10.2.1',  '1.8.2.1.90')    // 1
   *   compareVersions('1.010.2.1', '1.09.2.1.90');  // 1
   *   compareVersions('1.10.2.1',  '1.10.2.1');     // 0
   *   compareVersions('1.10.2.1',  '1.0800.2');     // -1
   *   compareVersions('1.10.2.1',  '1.10',  true);  // 0
   *
   * @param {String} versionA versions versions to compare
   * @param {String} versionB versions versions to compare
   * @param {boolean} [isLoose] enable loose comparison
   * @return {Number} comparison result: -1 when versionA is lower,
   * 1 when versionA is bigger, 0 when both equal
   */
  /* eslint consistent-return: 1 */
  static compareVersions(versionA, versionB, isLoose = false) {
    // 1) get common precision for both versions, for example for "10.0" and "9" it should be 2
    const versionAPrecision = Utils.getVersionPrecision(versionA);
    const versionBPrecision = Utils.getVersionPrecision(versionB);

    let precision = Math.max(versionAPrecision, versionBPrecision);
    let lastPrecision = 0;

    const chunks = Utils.map([versionA, versionB], (version) => {
      const delta = precision - Utils.getVersionPrecision(version);

      // 2) "9" -> "9.0" (for precision = 2)
      const _version = version + new Array(delta + 1).join('.0');

      // 3) "9.0" -> ["000000000"", "000000009"]
      return Utils.map(_version.split('.'), chunk => new Array(20 - chunk.length).join('0') + chunk).reverse();
    });

    // adjust precision for loose comparison
    if (isLoose) {
      lastPrecision = precision - Math.min(versionAPrecision, versionBPrecision);
    }

    // iterate in reverse order by reversed chunks array
    precision -= 1;
    while (precision >= lastPrecision) {
      // 4) compare: "000000009" > "000000010" = false (but "9" > "10" = true)
      if (chunks[0][precision] > chunks[1][precision]) {
        return 1;
      }

      if (chunks[0][precision] === chunks[1][precision]) {
        if (precision === lastPrecision) {
          // all version chunks are same
          return 0;
        }

        precision -= 1;
      } else if (chunks[0][precision] < chunks[1][precision]) {
        return -1;
      }
    }

    return undefined;
  }

  /**
   * Array::map polyfill
   *
   * @param  {Array} arr
   * @param  {Function} iterator
   * @return {Array}
   */
  static map(arr, iterator) {
    const result = [];
    let i;
    if (Array.prototype.map) {
      return Array.prototype.map.call(arr, iterator);
    }
    for (i = 0; i < arr.length; i += 1) {
      result.push(iterator(arr[i]));
    }
    return result;
  }

  /**
   * Array::find polyfill
   *
   * @param  {Array} arr
   * @param  {Function} predicate
   * @return {Array}
   */
  static find(arr, predicate) {
    let i;
    let l;
    if (Array.prototype.find) {
      return Array.prototype.find.call(arr, predicate);
    }
    for (i = 0, l = arr.length; i < l; i += 1) {
      const value = arr[i];
      if (predicate(value, i)) {
        return value;
      }
    }
    return undefined;
  }

  /**
   * Object::assign polyfill
   *
   * @param  {Object} obj
   * @param  {Object} ...objs
   * @return {Object}
   */
  static assign(obj, ...assigners) {
    const result = obj;
    let i;
    let l;
    if (Object.assign) {
      return Object.assign(obj, ...assigners);
    }
    for (i = 0, l = assigners.length; i < l; i += 1) {
      const assigner = assigners[i];
      if (typeof assigner === 'object' && assigner !== null) {
        const keys = Object.keys(assigner);
        keys.forEach((key) => {
          result[key] = assigner[key];
        });
      }
    }
    return obj;
  }

  /**
   * Get short version/alias for a browser name
   *
   * @example
   *   getBrowserAlias('Microsoft Edge') // edge
   *
   * @param  {string} browserName
   * @return {string}
   */
  static getBrowserAlias(browserName) {
    return BROWSER_ALIASES_MAP[browserName];
  }

  /**
   * Get short version/alias for a browser name
   *
   * @example
   *   getBrowserAlias('edge') // Microsoft Edge
   *
   * @param  {string} browserAlias
   * @return {string}
   */
  static getBrowserTypeByAlias(browserAlias) {
    return BROWSER_MAP[browserAlias] || '';
  }
}

/**
 * Browsers' descriptors
 *
 * The idea of descriptors is simple. You should know about them two simple things:
 * 1. Every descriptor has a method or property called `test` and a `describe` method.
 * 2. Order of descriptors is important.
 *
 * More details:
 * 1. Method or property `test` serves as a way to detect whether the UA string
 * matches some certain browser or not. The `describe` method helps to make a result
 * object with params that show some browser-specific things: name, version, etc.
 * 2. Order of descriptors is important because a Parser goes through them one by one
 * in course. For example, if you insert Chrome's descriptor as the first one,
 * more then a half of browsers will be described as Chrome, because they will pass
 * the Chrome descriptor's test.
 *
 * Descriptor's `test` could be a property with an array of RegExps, where every RegExp
 * will be applied to a UA string to test it whether it matches or not.
 * If a descriptor has two or more regexps in the `test` array it tests them one by one
 * with a logical sum operation. Parser stops if it has found any RegExp that matches the UA.
 *
 * Or `test` could be a method. In that case it gets a Parser instance and should
 * return true/false to get the Parser know if this browser descriptor matches the UA or not.
 */


const commonVersionIdentifier = /version\/(\d+(\.?_?\d+)+)/i;

const browsersList = [
  /* Googlebot */
  {
    test: [/googlebot/i],
    describe(ua) {
      const browser = {
        name: 'Googlebot',
      };
      const version = Utils.getFirstMatch(/googlebot\/(\d+(\.\d+))/i, ua) || Utils.getFirstMatch(commonVersionIdentifier, ua);

      if (version) {
        browser.version = version;
      }

      return browser;
    },
  },

  /* Opera < 13.0 */
  {
    test: [/opera/i],
    describe(ua) {
      const browser = {
        name: 'Opera',
      };
      const version = Utils.getFirstMatch(commonVersionIdentifier, ua) || Utils.getFirstMatch(/(?:opera)[\s/](\d+(\.?_?\d+)+)/i, ua);

      if (version) {
        browser.version = version;
      }

      return browser;
    },
  },

  /* Opera > 13.0 */
  {
    test: [/opr\/|opios/i],
    describe(ua) {
      const browser = {
        name: 'Opera',
      };
      const version = Utils.getFirstMatch(/(?:opr|opios)[\s/](\S+)/i, ua) || Utils.getFirstMatch(commonVersionIdentifier, ua);

      if (version) {
        browser.version = version;
      }

      return browser;
    },
  },
  {
    test: [/SamsungBrowser/i],
    describe(ua) {
      const browser = {
        name: 'Samsung Internet for Android',
      };
      const version = Utils.getFirstMatch(commonVersionIdentifier, ua) || Utils.getFirstMatch(/(?:SamsungBrowser)[\s/](\d+(\.?_?\d+)+)/i, ua);

      if (version) {
        browser.version = version;
      }

      return browser;
    },
  },
  {
    test: [/Whale/i],
    describe(ua) {
      const browser = {
        name: 'NAVER Whale Browser',
      };
      const version = Utils.getFirstMatch(commonVersionIdentifier, ua) || Utils.getFirstMatch(/(?:whale)[\s/](\d+(?:\.\d+)+)/i, ua);

      if (version) {
        browser.version = version;
      }

      return browser;
    },
  },
  {
    test: [/MZBrowser/i],
    describe(ua) {
      const browser = {
        name: 'MZ Browser',
      };
      const version = Utils.getFirstMatch(/(?:MZBrowser)[\s/](\d+(?:\.\d+)+)/i, ua) || Utils.getFirstMatch(commonVersionIdentifier, ua);

      if (version) {
        browser.version = version;
      }

      return browser;
    },
  },
  {
    test: [/focus/i],
    describe(ua) {
      const browser = {
        name: 'Focus',
      };
      const version = Utils.getFirstMatch(/(?:focus)[\s/](\d+(?:\.\d+)+)/i, ua) || Utils.getFirstMatch(commonVersionIdentifier, ua);

      if (version) {
        browser.version = version;
      }

      return browser;
    },
  },
  {
    test: [/swing/i],
    describe(ua) {
      const browser = {
        name: 'Swing',
      };
      const version = Utils.getFirstMatch(/(?:swing)[\s/](\d+(?:\.\d+)+)/i, ua) || Utils.getFirstMatch(commonVersionIdentifier, ua);

      if (version) {
        browser.version = version;
      }

      return browser;
    },
  },
  {
    test: [/coast/i],
    describe(ua) {
      const browser = {
        name: 'Opera Coast',
      };
      const version = Utils.getFirstMatch(commonVersionIdentifier, ua) || Utils.getFirstMatch(/(?:coast)[\s/](\d+(\.?_?\d+)+)/i, ua);

      if (version) {
        browser.version = version;
      }

      return browser;
    },
  },
  {
    test: [/opt\/\d+(?:.?_?\d+)+/i],
    describe(ua) {
      const browser = {
        name: 'Opera Touch',
      };
      const version = Utils.getFirstMatch(/(?:opt)[\s/](\d+(\.?_?\d+)+)/i, ua) || Utils.getFirstMatch(commonVersionIdentifier, ua);

      if (version) {
        browser.version = version;
      }

      return browser;
    },
  },
  {
    test: [/yabrowser/i],
    describe(ua) {
      const browser = {
        name: 'Yandex Browser',
      };
      const version = Utils.getFirstMatch(/(?:yabrowser)[\s/](\d+(\.?_?\d+)+)/i, ua) || Utils.getFirstMatch(commonVersionIdentifier, ua);

      if (version) {
        browser.version = version;
      }

      return browser;
    },
  },
  {
    test: [/ucbrowser/i],
    describe(ua) {
      const browser = {
        name: 'UC Browser',
      };
      const version = Utils.getFirstMatch(commonVersionIdentifier, ua) || Utils.getFirstMatch(/(?:ucbrowser)[\s/](\d+(\.?_?\d+)+)/i, ua);

      if (version) {
        browser.version = version;
      }

      return browser;
    },
  },
  {
    test: [/Maxthon|mxios/i],
    describe(ua) {
      const browser = {
        name: 'Maxthon',
      };
      const version = Utils.getFirstMatch(commonVersionIdentifier, ua) || Utils.getFirstMatch(/(?:Maxthon|mxios)[\s/](\d+(\.?_?\d+)+)/i, ua);

      if (version) {
        browser.version = version;
      }

      return browser;
    },
  },
  {
    test: [/epiphany/i],
    describe(ua) {
      const browser = {
        name: 'Epiphany',
      };
      const version = Utils.getFirstMatch(commonVersionIdentifier, ua) || Utils.getFirstMatch(/(?:epiphany)[\s/](\d+(\.?_?\d+)+)/i, ua);

      if (version) {
        browser.version = version;
      }

      return browser;
    },
  },
  {
    test: [/puffin/i],
    describe(ua) {
      const browser = {
        name: 'Puffin',
      };
      const version = Utils.getFirstMatch(commonVersionIdentifier, ua) || Utils.getFirstMatch(/(?:puffin)[\s/](\d+(\.?_?\d+)+)/i, ua);

      if (version) {
        browser.version = version;
      }

      return browser;
    },
  },
  {
    test: [/sleipnir/i],
    describe(ua) {
      const browser = {
        name: 'Sleipnir',
      };
      const version = Utils.getFirstMatch(commonVersionIdentifier, ua) || Utils.getFirstMatch(/(?:sleipnir)[\s/](\d+(\.?_?\d+)+)/i, ua);

      if (version) {
        browser.version = version;
      }

      return browser;
    },
  },
  {
    test: [/k-meleon/i],
    describe(ua) {
      const browser = {
        name: 'K-Meleon',
      };
      const version = Utils.getFirstMatch(commonVersionIdentifier, ua) || Utils.getFirstMatch(/(?:k-meleon)[\s/](\d+(\.?_?\d+)+)/i, ua);

      if (version) {
        browser.version = version;
      }

      return browser;
    },
  },
  {
    test: [/micromessenger/i],
    describe(ua) {
      const browser = {
        name: 'WeChat',
      };
      const version = Utils.getFirstMatch(/(?:micromessenger)[\s/](\d+(\.?_?\d+)+)/i, ua) || Utils.getFirstMatch(commonVersionIdentifier, ua);

      if (version) {
        browser.version = version;
      }

      return browser;
    },
  },
  {
    test: [/qqbrowser/i],
    describe(ua) {
      const browser = {
        name: (/qqbrowserlite/i).test(ua) ? 'QQ Browser Lite' : 'QQ Browser',
      };
      const version = Utils.getFirstMatch(/(?:qqbrowserlite|qqbrowser)[/](\d+(\.?_?\d+)+)/i, ua) || Utils.getFirstMatch(commonVersionIdentifier, ua);

      if (version) {
        browser.version = version;
      }

      return browser;
    },
  },
  {
    test: [/msie|trident/i],
    describe(ua) {
      const browser = {
        name: 'Internet Explorer',
      };
      const version = Utils.getFirstMatch(/(?:msie |rv:)(\d+(\.?_?\d+)+)/i, ua);

      if (version) {
        browser.version = version;
      }

      return browser;
    },
  },
  {
    test: [/\sedg\//i],
    describe(ua) {
      const browser = {
        name: 'Microsoft Edge',
      };

      const version = Utils.getFirstMatch(/\sedg\/(\d+(\.?_?\d+)+)/i, ua);

      if (version) {
        browser.version = version;
      }

      return browser;
    },
  },
  {
    test: [/edg([ea]|ios)/i],
    describe(ua) {
      const browser = {
        name: 'Microsoft Edge',
      };

      const version = Utils.getSecondMatch(/edg([ea]|ios)\/(\d+(\.?_?\d+)+)/i, ua);

      if (version) {
        browser.version = version;
      }

      return browser;
    },
  },
  {
    test: [/vivaldi/i],
    describe(ua) {
      const browser = {
        name: 'Vivaldi',
      };
      const version = Utils.getFirstMatch(/vivaldi\/(\d+(\.?_?\d+)+)/i, ua);

      if (version) {
        browser.version = version;
      }

      return browser;
    },
  },
  {
    test: [/seamonkey/i],
    describe(ua) {
      const browser = {
        name: 'SeaMonkey',
      };
      const version = Utils.getFirstMatch(/seamonkey\/(\d+(\.?_?\d+)+)/i, ua);

      if (version) {
        browser.version = version;
      }

      return browser;
    },
  },
  {
    test: [/sailfish/i],
    describe(ua) {
      const browser = {
        name: 'Sailfish',
      };

      const version = Utils.getFirstMatch(/sailfish\s?browser\/(\d+(\.\d+)?)/i, ua);

      if (version) {
        browser.version = version;
      }

      return browser;
    },
  },
  {
    test: [/silk/i],
    describe(ua) {
      const browser = {
        name: 'Amazon Silk',
      };
      const version = Utils.getFirstMatch(/silk\/(\d+(\.?_?\d+)+)/i, ua);

      if (version) {
        browser.version = version;
      }

      return browser;
    },
  },
  {
    test: [/phantom/i],
    describe(ua) {
      const browser = {
        name: 'PhantomJS',
      };
      const version = Utils.getFirstMatch(/phantomjs\/(\d+(\.?_?\d+)+)/i, ua);

      if (version) {
        browser.version = version;
      }

      return browser;
    },
  },
  {
    test: [/slimerjs/i],
    describe(ua) {
      const browser = {
        name: 'SlimerJS',
      };
      const version = Utils.getFirstMatch(/slimerjs\/(\d+(\.?_?\d+)+)/i, ua);

      if (version) {
        browser.version = version;
      }

      return browser;
    },
  },
  {
    test: [/blackberry|\bbb\d+/i, /rim\stablet/i],
    describe(ua) {
      const browser = {
        name: 'BlackBerry',
      };
      const version = Utils.getFirstMatch(commonVersionIdentifier, ua) || Utils.getFirstMatch(/blackberry[\d]+\/(\d+(\.?_?\d+)+)/i, ua);

      if (version) {
        browser.version = version;
      }

      return browser;
    },
  },
  {
    test: [/(web|hpw)[o0]s/i],
    describe(ua) {
      const browser = {
        name: 'WebOS Browser',
      };
      const version = Utils.getFirstMatch(commonVersionIdentifier, ua) || Utils.getFirstMatch(/w(?:eb)?[o0]sbrowser\/(\d+(\.?_?\d+)+)/i, ua);

      if (version) {
        browser.version = version;
      }

      return browser;
    },
  },
  {
    test: [/bada/i],
    describe(ua) {
      const browser = {
        name: 'Bada',
      };
      const version = Utils.getFirstMatch(/dolfin\/(\d+(\.?_?\d+)+)/i, ua);

      if (version) {
        browser.version = version;
      }

      return browser;
    },
  },
  {
    test: [/tizen/i],
    describe(ua) {
      const browser = {
        name: 'Tizen',
      };
      const version = Utils.getFirstMatch(/(?:tizen\s?)?browser\/(\d+(\.?_?\d+)+)/i, ua) || Utils.getFirstMatch(commonVersionIdentifier, ua);

      if (version) {
        browser.version = version;
      }

      return browser;
    },
  },
  {
    test: [/qupzilla/i],
    describe(ua) {
      const browser = {
        name: 'QupZilla',
      };
      const version = Utils.getFirstMatch(/(?:qupzilla)[\s/](\d+(\.?_?\d+)+)/i, ua) || Utils.getFirstMatch(commonVersionIdentifier, ua);

      if (version) {
        browser.version = version;
      }

      return browser;
    },
  },
  {
    test: [/firefox|iceweasel|fxios/i],
    describe(ua) {
      const browser = {
        name: 'Firefox',
      };
      const version = Utils.getFirstMatch(/(?:firefox|iceweasel|fxios)[\s/](\d+(\.?_?\d+)+)/i, ua);

      if (version) {
        browser.version = version;
      }

      return browser;
    },
  },
  {
    test: [/electron/i],
    describe(ua) {
      const browser = {
        name: 'Electron',
      };
      const version = Utils.getFirstMatch(/(?:electron)\/(\d+(\.?_?\d+)+)/i, ua);

      if (version) {
        browser.version = version;
      }

      return browser;
    },
  },
  {
    test: [/MiuiBrowser/i],
    describe(ua) {
      const browser = {
        name: 'Miui',
      };
      const version = Utils.getFirstMatch(/(?:MiuiBrowser)[\s/](\d+(\.?_?\d+)+)/i, ua);

      if (version) {
        browser.version = version;
      }

      return browser;
    },
  },
  {
    test: [/chromium/i],
    describe(ua) {
      const browser = {
        name: 'Chromium',
      };
      const version = Utils.getFirstMatch(/(?:chromium)[\s/](\d+(\.?_?\d+)+)/i, ua) || Utils.getFirstMatch(commonVersionIdentifier, ua);

      if (version) {
        browser.version = version;
      }

      return browser;
    },
  },
  {
    test: [/chrome|crios|crmo/i],
    describe(ua) {
      const browser = {
        name: 'Chrome',
      };
      const version = Utils.getFirstMatch(/(?:chrome|crios|crmo)\/(\d+(\.?_?\d+)+)/i, ua);

      if (version) {
        browser.version = version;
      }

      return browser;
    },
  },
  {
    test: [/GSA/i],
    describe(ua) {
      const browser = {
        name: 'Google Search',
      };
      const version = Utils.getFirstMatch(/(?:GSA)\/(\d+(\.?_?\d+)+)/i, ua);

      if (version) {
        browser.version = version;
      }

      return browser;
    },
  },

  /* Android Browser */
  {
    test(parser) {
      const notLikeAndroid = !parser.test(/like android/i);
      const butAndroid = parser.test(/android/i);
      return notLikeAndroid && butAndroid;
    },
    describe(ua) {
      const browser = {
        name: 'Android Browser',
      };
      const version = Utils.getFirstMatch(commonVersionIdentifier, ua);

      if (version) {
        browser.version = version;
      }

      return browser;
    },
  },

  /* PlayStation 4 */
  {
    test: [/playstation 4/i],
    describe(ua) {
      const browser = {
        name: 'PlayStation 4',
      };
      const version = Utils.getFirstMatch(commonVersionIdentifier, ua);

      if (version) {
        browser.version = version;
      }

      return browser;
    },
  },

  /* Safari */
  {
    test: [/safari|applewebkit/i],
    describe(ua) {
      const browser = {
        name: 'Safari',
      };
      const version = Utils.getFirstMatch(commonVersionIdentifier, ua);

      if (version) {
        browser.version = version;
      }

      return browser;
    },
  },

  /* Something else */
  {
    test: [/.*/i],
    describe(ua) {
      /* Here we try to make sure that there are explicit details about the device
       * in order to decide what regexp exactly we want to apply
       * (as there is a specific decision based on that conclusion)
       */
      const regexpWithoutDeviceSpec = /^(.*)\/(.*) /;
      const regexpWithDeviceSpec = /^(.*)\/(.*)[ \t]\((.*)/;
      const hasDeviceSpec = ua.search('\\(') !== -1;
      const regexp = hasDeviceSpec ? regexpWithDeviceSpec : regexpWithoutDeviceSpec;
      return {
        name: Utils.getFirstMatch(regexp, ua),
        version: Utils.getSecondMatch(regexp, ua),
      };
    },
  },
];

var osParsersList = [
  /* Roku */
  {
    test: [/Roku\/DVP/],
    describe(ua) {
      const version = Utils.getFirstMatch(/Roku\/DVP-(\d+\.\d+)/i, ua);
      return {
        name: OS_MAP.Roku,
        version,
      };
    },
  },

  /* Windows Phone */
  {
    test: [/windows phone/i],
    describe(ua) {
      const version = Utils.getFirstMatch(/windows phone (?:os)?\s?(\d+(\.\d+)*)/i, ua);
      return {
        name: OS_MAP.WindowsPhone,
        version,
      };
    },
  },

  /* Windows */
  {
    test: [/windows /i],
    describe(ua) {
      const version = Utils.getFirstMatch(/Windows ((NT|XP)( \d\d?.\d)?)/i, ua);
      const versionName = Utils.getWindowsVersionName(version);

      return {
        name: OS_MAP.Windows,
        version,
        versionName,
      };
    },
  },

  /* Firefox on iPad */
  {
    test: [/Macintosh(.*?) FxiOS(.*?)\//],
    describe(ua) {
      const result = {
        name: OS_MAP.iOS,
      };
      const version = Utils.getSecondMatch(/(Version\/)(\d[\d.]+)/, ua);
      if (version) {
        result.version = version;
      }
      return result;
    },
  },

  /* macOS */
  {
    test: [/macintosh/i],
    describe(ua) {
      const version = Utils.getFirstMatch(/mac os x (\d+(\.?_?\d+)+)/i, ua).replace(/[_\s]/g, '.');
      const versionName = Utils.getMacOSVersionName(version);

      const os = {
        name: OS_MAP.MacOS,
        version,
      };
      if (versionName) {
        os.versionName = versionName;
      }
      return os;
    },
  },

  /* iOS */
  {
    test: [/(ipod|iphone|ipad)/i],
    describe(ua) {
      const version = Utils.getFirstMatch(/os (\d+([_\s]\d+)*) like mac os x/i, ua).replace(/[_\s]/g, '.');

      return {
        name: OS_MAP.iOS,
        version,
      };
    },
  },

  /* Android */
  {
    test(parser) {
      const notLikeAndroid = !parser.test(/like android/i);
      const butAndroid = parser.test(/android/i);
      return notLikeAndroid && butAndroid;
    },
    describe(ua) {
      const version = Utils.getFirstMatch(/android[\s/-](\d+(\.\d+)*)/i, ua);
      const versionName = Utils.getAndroidVersionName(version);
      const os = {
        name: OS_MAP.Android,
        version,
      };
      if (versionName) {
        os.versionName = versionName;
      }
      return os;
    },
  },

  /* WebOS */
  {
    test: [/(web|hpw)[o0]s/i],
    describe(ua) {
      const version = Utils.getFirstMatch(/(?:web|hpw)[o0]s\/(\d+(\.\d+)*)/i, ua);
      const os = {
        name: OS_MAP.WebOS,
      };

      if (version && version.length) {
        os.version = version;
      }
      return os;
    },
  },

  /* BlackBerry */
  {
    test: [/blackberry|\bbb\d+/i, /rim\stablet/i],
    describe(ua) {
      const version = Utils.getFirstMatch(/rim\stablet\sos\s(\d+(\.\d+)*)/i, ua)
        || Utils.getFirstMatch(/blackberry\d+\/(\d+([_\s]\d+)*)/i, ua)
        || Utils.getFirstMatch(/\bbb(\d+)/i, ua);

      return {
        name: OS_MAP.BlackBerry,
        version,
      };
    },
  },

  /* Bada */
  {
    test: [/bada/i],
    describe(ua) {
      const version = Utils.getFirstMatch(/bada\/(\d+(\.\d+)*)/i, ua);

      return {
        name: OS_MAP.Bada,
        version,
      };
    },
  },

  /* Tizen */
  {
    test: [/tizen/i],
    describe(ua) {
      const version = Utils.getFirstMatch(/tizen[/\s](\d+(\.\d+)*)/i, ua);

      return {
        name: OS_MAP.Tizen,
        version,
      };
    },
  },

  /* Linux */
  {
    test: [/linux/i],
    describe() {
      return {
        name: OS_MAP.Linux,
      };
    },
  },

  /* Chrome OS */
  {
    test: [/CrOS/],
    describe() {
      return {
        name: OS_MAP.ChromeOS,
      };
    },
  },

  /* Playstation 4 */
  {
    test: [/PlayStation 4/],
    describe(ua) {
      const version = Utils.getFirstMatch(/PlayStation 4[/\s](\d+(\.\d+)*)/i, ua);
      return {
        name: OS_MAP.PlayStation4,
        version,
      };
    },
  },
];

/*
 * Tablets go first since usually they have more specific
 * signs to detect.
 */

var platformParsersList = [
  /* Googlebot */
  {
    test: [/googlebot/i],
    describe() {
      return {
        type: 'bot',
        vendor: 'Google',
      };
    },
  },

  /* Huawei */
  {
    test: [/huawei/i],
    describe(ua) {
      const model = Utils.getFirstMatch(/(can-l01)/i, ua) && 'Nova';
      const platform = {
        type: PLATFORMS_MAP.mobile,
        vendor: 'Huawei',
      };
      if (model) {
        platform.model = model;
      }
      return platform;
    },
  },

  /* Nexus Tablet */
  {
    test: [/nexus\s*(?:7|8|9|10).*/i],
    describe() {
      return {
        type: PLATFORMS_MAP.tablet,
        vendor: 'Nexus',
      };
    },
  },

  /* iPad */
  {
    test: [/ipad/i],
    describe() {
      return {
        type: PLATFORMS_MAP.tablet,
        vendor: 'Apple',
        model: 'iPad',
      };
    },
  },

  /* Firefox on iPad */
  {
    test: [/Macintosh(.*?) FxiOS(.*?)\//],
    describe() {
      return {
        type: PLATFORMS_MAP.tablet,
        vendor: 'Apple',
        model: 'iPad',
      };
    },
  },

  /* Amazon Kindle Fire */
  {
    test: [/kftt build/i],
    describe() {
      return {
        type: PLATFORMS_MAP.tablet,
        vendor: 'Amazon',
        model: 'Kindle Fire HD 7',
      };
    },
  },

  /* Another Amazon Tablet with Silk */
  {
    test: [/silk/i],
    describe() {
      return {
        type: PLATFORMS_MAP.tablet,
        vendor: 'Amazon',
      };
    },
  },

  /* Tablet */
  {
    test: [/tablet(?! pc)/i],
    describe() {
      return {
        type: PLATFORMS_MAP.tablet,
      };
    },
  },

  /* iPod/iPhone */
  {
    test(parser) {
      const iDevice = parser.test(/ipod|iphone/i);
      const likeIDevice = parser.test(/like (ipod|iphone)/i);
      return iDevice && !likeIDevice;
    },
    describe(ua) {
      const model = Utils.getFirstMatch(/(ipod|iphone)/i, ua);
      return {
        type: PLATFORMS_MAP.mobile,
        vendor: 'Apple',
        model,
      };
    },
  },

  /* Nexus Mobile */
  {
    test: [/nexus\s*[0-6].*/i, /galaxy nexus/i],
    describe() {
      return {
        type: PLATFORMS_MAP.mobile,
        vendor: 'Nexus',
      };
    },
  },

  /* Mobile */
  {
    test: [/[^-]mobi/i],
    describe() {
      return {
        type: PLATFORMS_MAP.mobile,
      };
    },
  },

  /* BlackBerry */
  {
    test(parser) {
      return parser.getBrowserName(true) === 'blackberry';
    },
    describe() {
      return {
        type: PLATFORMS_MAP.mobile,
        vendor: 'BlackBerry',
      };
    },
  },

  /* Bada */
  {
    test(parser) {
      return parser.getBrowserName(true) === 'bada';
    },
    describe() {
      return {
        type: PLATFORMS_MAP.mobile,
      };
    },
  },

  /* Windows Phone */
  {
    test(parser) {
      return parser.getBrowserName() === 'windows phone';
    },
    describe() {
      return {
        type: PLATFORMS_MAP.mobile,
        vendor: 'Microsoft',
      };
    },
  },

  /* Android Tablet */
  {
    test(parser) {
      const osMajorVersion = Number(String(parser.getOSVersion()).split('.')[0]);
      return parser.getOSName(true) === 'android' && (osMajorVersion >= 3);
    },
    describe() {
      return {
        type: PLATFORMS_MAP.tablet,
      };
    },
  },

  /* Android Mobile */
  {
    test(parser) {
      return parser.getOSName(true) === 'android';
    },
    describe() {
      return {
        type: PLATFORMS_MAP.mobile,
      };
    },
  },

  /* desktop */
  {
    test(parser) {
      return parser.getOSName(true) === 'macos';
    },
    describe() {
      return {
        type: PLATFORMS_MAP.desktop,
        vendor: 'Apple',
      };
    },
  },

  /* Windows */
  {
    test(parser) {
      return parser.getOSName(true) === 'windows';
    },
    describe() {
      return {
        type: PLATFORMS_MAP.desktop,
      };
    },
  },

  /* Linux */
  {
    test(parser) {
      return parser.getOSName(true) === 'linux';
    },
    describe() {
      return {
        type: PLATFORMS_MAP.desktop,
      };
    },
  },

  /* PlayStation 4 */
  {
    test(parser) {
      return parser.getOSName(true) === 'playstation 4';
    },
    describe() {
      return {
        type: PLATFORMS_MAP.tv,
      };
    },
  },

  /* Roku */
  {
    test(parser) {
      return parser.getOSName(true) === 'roku';
    },
    describe() {
      return {
        type: PLATFORMS_MAP.tv,
      };
    },
  },
];

/*
 * More specific goes first
 */
var enginesParsersList = [
  /* EdgeHTML */
  {
    test(parser) {
      return parser.getBrowserName(true) === 'microsoft edge';
    },
    describe(ua) {
      const isBlinkBased = /\sedg\//i.test(ua);

      // return blink if it's blink-based one
      if (isBlinkBased) {
        return {
          name: ENGINE_MAP.Blink,
        };
      }

      // otherwise match the version and return EdgeHTML
      const version = Utils.getFirstMatch(/edge\/(\d+(\.?_?\d+)+)/i, ua);

      return {
        name: ENGINE_MAP.EdgeHTML,
        version,
      };
    },
  },

  /* Trident */
  {
    test: [/trident/i],
    describe(ua) {
      const engine = {
        name: ENGINE_MAP.Trident,
      };

      const version = Utils.getFirstMatch(/trident\/(\d+(\.?_?\d+)+)/i, ua);

      if (version) {
        engine.version = version;
      }

      return engine;
    },
  },

  /* Presto */
  {
    test(parser) {
      return parser.test(/presto/i);
    },
    describe(ua) {
      const engine = {
        name: ENGINE_MAP.Presto,
      };

      const version = Utils.getFirstMatch(/presto\/(\d+(\.?_?\d+)+)/i, ua);

      if (version) {
        engine.version = version;
      }

      return engine;
    },
  },

  /* Gecko */
  {
    test(parser) {
      const isGecko = parser.test(/gecko/i);
      const likeGecko = parser.test(/like gecko/i);
      return isGecko && !likeGecko;
    },
    describe(ua) {
      const engine = {
        name: ENGINE_MAP.Gecko,
      };

      const version = Utils.getFirstMatch(/gecko\/(\d+(\.?_?\d+)+)/i, ua);

      if (version) {
        engine.version = version;
      }

      return engine;
    },
  },

  /* Blink */
  {
    test: [/(apple)?webkit\/537\.36/i],
    describe() {
      return {
        name: ENGINE_MAP.Blink,
      };
    },
  },

  /* WebKit */
  {
    test: [/(apple)?webkit/i],
    describe(ua) {
      const engine = {
        name: ENGINE_MAP.WebKit,
      };

      const version = Utils.getFirstMatch(/webkit\/(\d+(\.?_?\d+)+)/i, ua);

      if (version) {
        engine.version = version;
      }

      return engine;
    },
  },
];

/**
 * The main class that arranges the whole parsing process.
 */
class Parser {
  /**
   * Create instance of Parser
   *
   * @param {String} UA User-Agent string
   * @param {Boolean} [skipParsing=false] parser can skip parsing in purpose of performance
   * improvements if you need to make a more particular parsing
   * like {@link Parser#parseBrowser} or {@link Parser#parsePlatform}
   *
   * @throw {Error} in case of empty UA String
   *
   * @constructor
   */
  constructor(UA, skipParsing = false) {
    if (UA === void (0) || UA === null || UA === '') {
      throw new Error("UserAgent parameter can't be empty");
    }

    this._ua = UA;

    /**
     * @typedef ParsedResult
     * @property {Object} browser
     * @property {String|undefined} [browser.name]
     * Browser name, like `"Chrome"` or `"Internet Explorer"`
     * @property {String|undefined} [browser.version] Browser version as a String `"12.01.45334.10"`
     * @property {Object} os
     * @property {String|undefined} [os.name] OS name, like `"Windows"` or `"macOS"`
     * @property {String|undefined} [os.version] OS version, like `"NT 5.1"` or `"10.11.1"`
     * @property {String|undefined} [os.versionName] OS name, like `"XP"` or `"High Sierra"`
     * @property {Object} platform
     * @property {String|undefined} [platform.type]
     * platform type, can be either `"desktop"`, `"tablet"` or `"mobile"`
     * @property {String|undefined} [platform.vendor] Vendor of the device,
     * like `"Apple"` or `"Samsung"`
     * @property {String|undefined} [platform.model] Device model,
     * like `"iPhone"` or `"Kindle Fire HD 7"`
     * @property {Object} engine
     * @property {String|undefined} [engine.name]
     * Can be any of this: `WebKit`, `Blink`, `Gecko`, `Trident`, `Presto`, `EdgeHTML`
     * @property {String|undefined} [engine.version] String version of the engine
     */
    this.parsedResult = {};

    if (skipParsing !== true) {
      this.parse();
    }
  }

  /**
   * Get UserAgent string of current Parser instance
   * @return {String} User-Agent String of the current <Parser> object
   *
   * @public
   */
  getUA() {
    return this._ua;
  }

  /**
   * Test a UA string for a regexp
   * @param {RegExp} regex
   * @return {Boolean}
   */
  test(regex) {
    return regex.test(this._ua);
  }

  /**
   * Get parsed browser object
   * @return {Object}
   */
  parseBrowser() {
    this.parsedResult.browser = {};

    const browserDescriptor = Utils.find(browsersList, (_browser) => {
      if (typeof _browser.test === 'function') {
        return _browser.test(this);
      }

      if (_browser.test instanceof Array) {
        return _browser.test.some(condition => this.test(condition));
      }

      throw new Error("Browser's test function is not valid");
    });

    if (browserDescriptor) {
      this.parsedResult.browser = browserDescriptor.describe(this.getUA());
    }

    return this.parsedResult.browser;
  }

  /**
   * Get parsed browser object
   * @return {Object}
   *
   * @public
   */
  getBrowser() {
    if (this.parsedResult.browser) {
      return this.parsedResult.browser;
    }

    return this.parseBrowser();
  }

  /**
   * Get browser's name
   * @return {String} Browser's name or an empty string
   *
   * @public
   */
  getBrowserName(toLowerCase) {
    if (toLowerCase) {
      return String(this.getBrowser().name).toLowerCase() || '';
    }
    return this.getBrowser().name || '';
  }


  /**
   * Get browser's version
   * @return {String} version of browser
   *
   * @public
   */
  getBrowserVersion() {
    return this.getBrowser().version;
  }

  /**
   * Get OS
   * @return {Object}
   *
   * @example
   * this.getOS();
   * {
   *   name: 'macOS',
   *   version: '10.11.12'
   * }
   */
  getOS() {
    if (this.parsedResult.os) {
      return this.parsedResult.os;
    }

    return this.parseOS();
  }

  /**
   * Parse OS and save it to this.parsedResult.os
   * @return {*|{}}
   */
  parseOS() {
    this.parsedResult.os = {};

    const os = Utils.find(osParsersList, (_os) => {
      if (typeof _os.test === 'function') {
        return _os.test(this);
      }

      if (_os.test instanceof Array) {
        return _os.test.some(condition => this.test(condition));
      }

      throw new Error("Browser's test function is not valid");
    });

    if (os) {
      this.parsedResult.os = os.describe(this.getUA());
    }

    return this.parsedResult.os;
  }

  /**
   * Get OS name
   * @param {Boolean} [toLowerCase] return lower-cased value
   * @return {String} name of the OS — macOS, Windows, Linux, etc.
   */
  getOSName(toLowerCase) {
    const { name } = this.getOS();

    if (toLowerCase) {
      return String(name).toLowerCase() || '';
    }

    return name || '';
  }

  /**
   * Get OS version
   * @return {String} full version with dots ('10.11.12', '5.6', etc)
   */
  getOSVersion() {
    return this.getOS().version;
  }

  /**
   * Get parsed platform
   * @return {{}}
   */
  getPlatform() {
    if (this.parsedResult.platform) {
      return this.parsedResult.platform;
    }

    return this.parsePlatform();
  }

  /**
   * Get platform name
   * @param {Boolean} [toLowerCase=false]
   * @return {*}
   */
  getPlatformType(toLowerCase = false) {
    const { type } = this.getPlatform();

    if (toLowerCase) {
      return String(type).toLowerCase() || '';
    }

    return type || '';
  }

  /**
   * Get parsed platform
   * @return {{}}
   */
  parsePlatform() {
    this.parsedResult.platform = {};

    const platform = Utils.find(platformParsersList, (_platform) => {
      if (typeof _platform.test === 'function') {
        return _platform.test(this);
      }

      if (_platform.test instanceof Array) {
        return _platform.test.some(condition => this.test(condition));
      }

      throw new Error("Browser's test function is not valid");
    });

    if (platform) {
      this.parsedResult.platform = platform.describe(this.getUA());
    }

    return this.parsedResult.platform;
  }

  /**
   * Get parsed engine
   * @return {{}}
   */
  getEngine() {
    if (this.parsedResult.engine) {
      return this.parsedResult.engine;
    }

    return this.parseEngine();
  }

  /**
   * Get engines's name
   * @return {String} Engines's name or an empty string
   *
   * @public
   */
  getEngineName(toLowerCase) {
    if (toLowerCase) {
      return String(this.getEngine().name).toLowerCase() || '';
    }
    return this.getEngine().name || '';
  }

  /**
   * Get parsed platform
   * @return {{}}
   */
  parseEngine() {
    this.parsedResult.engine = {};

    const engine = Utils.find(enginesParsersList, (_engine) => {
      if (typeof _engine.test === 'function') {
        return _engine.test(this);
      }

      if (_engine.test instanceof Array) {
        return _engine.test.some(condition => this.test(condition));
      }

      throw new Error("Browser's test function is not valid");
    });

    if (engine) {
      this.parsedResult.engine = engine.describe(this.getUA());
    }

    return this.parsedResult.engine;
  }

  /**
   * Parse full information about the browser
   * @returns {Parser}
   */
  parse() {
    this.parseBrowser();
    this.parseOS();
    this.parsePlatform();
    this.parseEngine();

    return this;
  }

  /**
   * Get parsed result
   * @return {ParsedResult}
   */
  getResult() {
    return Utils.assign({}, this.parsedResult);
  }

  /**
   * Check if parsed browser matches certain conditions
   *
   * @param {Object} checkTree It's one or two layered object,
   * which can include a platform or an OS on the first layer
   * and should have browsers specs on the bottom-laying layer
   *
   * @returns {Boolean|undefined} Whether the browser satisfies the set conditions or not.
   * Returns `undefined` when the browser is no described in the checkTree object.
   *
   * @example
   * const browser = Bowser.getParser(window.navigator.userAgent);
   * if (browser.satisfies({chrome: '>118.01.1322' }))
   * // or with os
   * if (browser.satisfies({windows: { chrome: '>118.01.1322' } }))
   * // or with platforms
   * if (browser.satisfies({desktop: { chrome: '>118.01.1322' } }))
   */
  satisfies(checkTree) {
    const platformsAndOSes = {};
    let platformsAndOSCounter = 0;
    const browsers = {};
    let browsersCounter = 0;

    const allDefinitions = Object.keys(checkTree);

    allDefinitions.forEach((key) => {
      const currentDefinition = checkTree[key];
      if (typeof currentDefinition === 'string') {
        browsers[key] = currentDefinition;
        browsersCounter += 1;
      } else if (typeof currentDefinition === 'object') {
        platformsAndOSes[key] = currentDefinition;
        platformsAndOSCounter += 1;
      }
    });

    if (platformsAndOSCounter > 0) {
      const platformsAndOSNames = Object.keys(platformsAndOSes);
      const OSMatchingDefinition = Utils.find(platformsAndOSNames, name => (this.isOS(name)));

      if (OSMatchingDefinition) {
        const osResult = this.satisfies(platformsAndOSes[OSMatchingDefinition]);

        if (osResult !== void 0) {
          return osResult;
        }
      }

      const platformMatchingDefinition = Utils.find(
        platformsAndOSNames,
        name => (this.isPlatform(name)),
      );
      if (platformMatchingDefinition) {
        const platformResult = this.satisfies(platformsAndOSes[platformMatchingDefinition]);

        if (platformResult !== void 0) {
          return platformResult;
        }
      }
    }

    if (browsersCounter > 0) {
      const browserNames = Object.keys(browsers);
      const matchingDefinition = Utils.find(browserNames, name => (this.isBrowser(name, true)));

      if (matchingDefinition !== void 0) {
        return this.compareVersion(browsers[matchingDefinition]);
      }
    }

    return undefined;
  }

  /**
   * Check if the browser name equals the passed string
   * @param browserName The string to compare with the browser name
   * @param [includingAlias=false] The flag showing whether alias will be included into comparison
   * @returns {boolean}
   */
  isBrowser(browserName, includingAlias = false) {
    const defaultBrowserName = this.getBrowserName().toLowerCase();
    let browserNameLower = browserName.toLowerCase();
    const alias = Utils.getBrowserTypeByAlias(browserNameLower);

    if (includingAlias && alias) {
      browserNameLower = alias.toLowerCase();
    }
    return browserNameLower === defaultBrowserName;
  }

  compareVersion(version) {
    let expectedResults = [0];
    let comparableVersion = version;
    let isLoose = false;

    const currentBrowserVersion = this.getBrowserVersion();

    if (typeof currentBrowserVersion !== 'string') {
      return void 0;
    }

    if (version[0] === '>' || version[0] === '<') {
      comparableVersion = version.substr(1);
      if (version[1] === '=') {
        isLoose = true;
        comparableVersion = version.substr(2);
      } else {
        expectedResults = [];
      }
      if (version[0] === '>') {
        expectedResults.push(1);
      } else {
        expectedResults.push(-1);
      }
    } else if (version[0] === '=') {
      comparableVersion = version.substr(1);
    } else if (version[0] === '~') {
      isLoose = true;
      comparableVersion = version.substr(1);
    }

    return expectedResults.indexOf(
      Utils.compareVersions(currentBrowserVersion, comparableVersion, isLoose),
    ) > -1;
  }

  isOS(osName) {
    return this.getOSName(true) === String(osName).toLowerCase();
  }

  isPlatform(platformType) {
    return this.getPlatformType(true) === String(platformType).toLowerCase();
  }

  isEngine(engineName) {
    return this.getEngineName(true) === String(engineName).toLowerCase();
  }

  /**
   * Is anything? Check if the browser is called "anything",
   * the OS called "anything" or the platform called "anything"
   * @param {String} anything
   * @param [includingAlias=false] The flag showing whether alias will be included into comparison
   * @returns {Boolean}
   */
  is(anything, includingAlias = false) {
    return this.isBrowser(anything, includingAlias) || this.isOS(anything)
      || this.isPlatform(anything);
  }

  /**
   * Check if any of the given values satisfies this.is(anything)
   * @param {String[]} anythings
   * @returns {Boolean}
   */
  some(anythings = []) {
    return anythings.some(anything => this.is(anything));
  }
}

/*!
 * Bowser - a browser detector
 * https://github.com/lancedikson/bowser
 * MIT License | (c) Dustin Diaz 2012-2015
 * MIT License | (c) Denis Demchenko 2015-2019
 */

/**
 * Bowser class.
 * Keep it simple as much as it can be.
 * It's supposed to work with collections of {@link Parser} instances
 * rather then solve one-instance problems.
 * All the one-instance stuff is located in Parser class.
 *
 * @class
 * @classdesc Bowser is a static object, that provides an API to the Parsers
 * @hideconstructor
 */
class Bowser {
  /**
   * Creates a {@link Parser} instance
   *
   * @param {String} UA UserAgent string
   * @param {Boolean} [skipParsing=false] Will make the Parser postpone parsing until you ask it
   * explicitly. Same as `skipParsing` for {@link Parser}.
   * @returns {Parser}
   * @throws {Error} when UA is not a String
   *
   * @example
   * const parser = Bowser.getParser(window.navigator.userAgent);
   * const result = parser.getResult();
   */
  static getParser(UA, skipParsing = false) {
    if (typeof UA !== 'string') {
      throw new Error('UserAgent should be a string');
    }
    return new Parser(UA, skipParsing);
  }

  /**
   * Creates a {@link Parser} instance and runs {@link Parser.getResult} immediately
   *
   * @param UA
   * @return {ParsedResult}
   *
   * @example
   * const result = Bowser.parse(window.navigator.userAgent);
   */
  static parse(UA) {
    return (new Parser(UA)).getResult();
  }

  static get BROWSER_MAP() {
    return BROWSER_MAP;
  }

  static get ENGINE_MAP() {
    return ENGINE_MAP;
  }

  static get OS_MAP() {
    return OS_MAP;
  }

  static get PLATFORMS_MAP() {
    return PLATFORMS_MAP;
  }
}

class DeviceUtility {
    static get platform() {
        this.tryInitializePlatform();
        return this._platform;
    }
    /** @internal */
    static get platformInitialized() { return this._platformInitialized; }
    /** @internal */
    static set platformInitialized(value) { this._platformInitialized = value; }
    static get platformVersion() {
        this.tryInitializePlatform();
        return this._platformVersion;
    }
    static tryInitializePlatform() {
        if (this._platformInitialized)
            return false;
        const navigator = globalThis.navigator;
        const process = globalThis.process;
        if (navigator && navigator.userAgent) {
            const parser = Bowser.getParser(navigator.userAgent);
            this._platform = parser.getBrowserName();
            this._platformVersion = parser.getBrowserVersion() ?? "Unknown";
        }
        else if (process) {
            this._platform = process.platform;
            this._platformVersion = process.version;
        }
        else {
            this._platform = "Unknown";
            this._platformVersion = "Unknown";
        }
        this._platformInitialized = true;
    }
    static getIdentifier() {
        let deviceIdentifier = localStorage.getItem(this._identifierStorageKey);
        if (!deviceIdentifier) {
            deviceIdentifier = Utility.generateGuid();
            localStorage.setItem(this._identifierStorageKey, deviceIdentifier);
        }
        return deviceIdentifier;
    }
    static hasCachedIdentifier() {
        return !!localStorage.getItem(this._identifierStorageKey);
    }
    static removeCachedIdentifier() {
        localStorage.removeItem(this._identifierStorageKey);
    }
}
DeviceUtility._identifierStorageKey = "deviceIdentifier";
DeviceUtility._platformInitialized = false;

let Client$5 = class Client {
    get apiKey() { return this._init.apiKey; }
    get maxRetries() { return this._httpClients[0].maxRetries; }
    set maxRetries(value) { this._httpClients.forEach(hc => hc.maxRetries = value); }
    get requestTimeout() { return this._httpClients[0].requestTimeout; }
    set requestTimeout(value) { this._httpClients.forEach(hc => hc.requestTimeout = value); }
    get identityServiceUrl() { return this._init.identityServiceUrl; }
    constructor(init) {
        Guard.isNotNullOrUndefined(init, "init");
        Guard.isNotNullOrUndefined(init.apiKey, "init.apiKey");
        Guard.isNotNullOrUndefined(init.identityServiceUrl, "init.identityServiceUrl");
        if (Utility.isArray(init.identityServiceUrl))
            Guard.isGreaterThan(init.identityServiceUrl.length, 0, "init.identityServiceUrl");
        this._init = init;
        const identityServiceUrls = Utility.isArray(init.identityServiceUrl) ? init.identityServiceUrl : [init.identityServiceUrl];
        this._httpClients = identityServiceUrls.map(isu => HttpClient.withApiKey(this._init.apiKey, isu));
    }
    async retry(action) {
        for (let i = 0; i < this._httpClients.length; i++) {
            try {
                return await action(this._httpClients[0]);
            }
            catch (error) {
                if (i == (this._httpClients.length - 1) || error instanceof ServerError)
                    throw error;
                this._httpClients.push(this._httpClients.shift()); // rotate
            }
        }
    }
    async changePassword(request, abortSignal) {
        Guard.isNotNullOrUndefined(request, "request");
        Guard.isNotNullOrUndefined(request.email, "request.email");
        Guard.isNotNullOrUndefined(request.oldPassword, "request.oldPassword");
        Guard.isNotNullOrUndefined(request.password, "request.password");
        await this.retry(async (httpClient) => {
            await httpClient.post("/password/change", {
                email: request.email,
                oldPassword: request.oldPassword,
                password: request.password,
            }, abortSignal);
        });
    }
    async forgotPassword(request, abortSignal) {
        Guard.isNotNullOrUndefined(request, "request");
        Guard.isNotNullOrUndefined(request.email, "request.email");
        await this.retry(async (httpClient) => {
            await httpClient.post("/password/forgot", {
                email: request.email,
            }, abortSignal);
        });
    }
    async getToken(request, abortSignal) {
        Guard.isNotNullOrUndefined(request, "request");
        const deviceStatus = DeviceUtility.hasCachedIdentifier() ? "KNOWN" : "NEW";
        const deviceType = "WEB";
        return await this.retry(async (httpClient) => {
            const response = await httpClient.post("/token", {
                device: {
                    deviceIdentifier: DeviceUtility.getIdentifier(),
                    devicePlatform: DeviceUtility.platform,
                    devicePlatformVersion: DeviceUtility.platformVersion,
                    deviceStatus: deviceStatus,
                    deviceType: deviceType,
                },
                displayName: request.displayName,
                externalToken: request.externalToken,
                name: request.username,
                password: request.password,
            }, abortSignal);
            if (response.value) {
                const tokenResponse = {
                    token: response.value.token,
                    tokenTtl: response.value.tokenTtl,
                    clusterAssignment: {
                        identityUrl: this._init.identityServiceUrl,
                        clusterUrl: response.value.apiServiceUrl,
                        meetingUrl: response.value.meetingServiceUrl,
                    }
                };
                return tokenResponse;
            }
            return response;
        });
    }
    async register(request, abortSignal) {
        Guard.isNotNullOrUndefined(request, "request");
        const accountType = "CREDENTIAL";
        return await this.retry(async (httpClient) => {
            return (await httpClient.post("/register", {
                accountType: accountType,
                displayName: request.displayName,
                name: request.username,
                password: request.password,
            }, abortSignal)).value;
        });
    }
    async resetPassword(request, abortSignal) {
        Guard.isNotNullOrUndefined(request, "request");
        Guard.isNotNullOrUndefined(request.email, "request.email");
        Guard.isNotNullOrUndefined(request.password, "request.password");
        Guard.isNotNullOrUndefined(request.resetToken, "request.resetToken");
        await this.retry(async (httpClient) => {
            await httpClient.post("/password/reset", {
                email: request.email,
                password: request.password,
                resetToken: request.resetToken,
            }, abortSignal);
        });
    }
};

class Identity {
    get apiKey() {
        return this._client.apiKey;
    }
    get identityServiceUrl() {
        return this._client.identityServiceUrl;
    }
    get maxRetries() {
        return this._client.maxRetries;
    }
    set maxRetries(value) {
        this._client.maxRetries = value;
    }
    get requestTimeout() {
        return this._client.requestTimeout;
    }
    set requestTimeout(value) {
        this._client.requestTimeout = value;
    }
    get type() {
        return this._init.type;
    }
    constructor(init) {
        Guard.isNotNullOrUndefined(init, "init");
        Guard.isNotNullOrUndefined(init.apiKey, "init.apiKey");
        Guard.isNotNullOrUndefined(init.identityServiceUrl, "init.identityServiceUrl");
        if (Utility.isArray(init.identityServiceUrl))
            Guard.isGreaterThan(init.identityServiceUrl.length, 0, "init.identityServiceUrl");
        this._init = init;
        this._client = new Client$5(this._init);
        this._tokenRequest = this.getTokenRequest();
    }
    getTokenRequest() {
        switch (this._init.type) {
            default:
            case "anonymous":
                this._init.type = "anonymous";
                return {
                    displayName: this._init.displayName ??
                        `Anonymous #${Math.floor(Math.random() * 999)}`, //TODO: remove once database can handle null values
                };
            case "credentials":
                return {
                    password: this._init.password,
                    username: this._init.username,
                };
            case "externalToken":
                return {
                    externalToken: this._init.externalToken,
                };
        }
    }
    timespanToMilliseconds(timespan) {
        if (!timespan) {
            throw new Error("Invalid timespan string");
        }
        const parts = timespan.split(":");
        if (parts.length !== 3) {
            throw new Error("Invalid timespan string");
        }
        const hours = parseInt(parts[0], 10);
        const minutes = parseInt(parts[1], 10);
        const seconds = parseInt(parts[2], 10);
        return (hours * 60 * 60 + minutes * 60 + seconds) * 1000;
    }
    async token(abortSignal) {
        if (this._tokenResponse &&
            this._tokenRefreshAfterTime &&
            new Date().getTime() < this._tokenRefreshAfterTime)
            return this._tokenResponse;
        this._tokenResponse = await this._client.getToken(this._tokenRequest, abortSignal);
        if (!this._tokenResponse.token || !this._tokenResponse.tokenTtl) {
            return Promise.reject("Failed to get token");
        }
        //Cluster identity response format
        if (typeof this._tokenResponse.tokenTtl === "number") {
            // tokenTtl is a number
            const milliseconds = this._tokenResponse.tokenTtl * 1000;
            this._tokenRefreshAfterTime = new Date().getTime() + milliseconds - 60000; // within 1 minute of expiring
        }
        else {
            // tokenTtl is not a number
            this._tokenRefreshAfterTime =
                new Date().getTime() +
                    this.timespanToMilliseconds(this._tokenResponse.tokenTtl) -
                    60000; // within 1 minute of expiring
        }
        return this._tokenResponse;
    }
}

class MediaCollection extends ReadOnlyCollection {
    constructor() {
        super(media => media.id);
    }
}

class DeviceCollection extends ReadOnlyCollection {
    constructor() {
        super(device => device.id);
    }
    next(deviceId) {
        if (this.length == 0)
            return null;
        const currentDeviceId = deviceId ?? this[0].id;
        const currentDeviceIndex = this.findIndex(device => device.id == currentDeviceId);
        if (currentDeviceIndex == -1)
            return null;
        const nextDeviceIndex = currentDeviceIndex == this.length - 1 ? 0 : currentDeviceIndex + 1;
        return this[nextDeviceIndex];
    }
    previous(deviceId) {
        if (this.length == 0)
            return null;
        const currentDeviceId = deviceId ?? this[0].id;
        const currentDeviceIndex = this.findIndex(device => device.id == currentDeviceId);
        if (currentDeviceIndex == -1)
            return null;
        const previousDeviceIndex = currentDeviceIndex == 0 ? this.length - 1 : currentDeviceIndex - 1;
        return this[previousDeviceIndex];
    }
}

class DeviceManagerStateMachine {
    get state() { return this._state; }
    constructor(initialState) {
        this._state = initialState ?? "new";
    }
    setState(state) {
        if (this.trySetState(state))
            return;
        throw new Error(`Cannot transition to '${state}' state while in '${this._state}' state.`);
    }
    trySetState(state) {
        switch (state) {
            case "started":
                if (this._state != "starting")
                    return false;
                break;
            case "starting":
                if (this._state != "new" && this._state != "stopped")
                    return false;
                break;
            case "stopped":
                if (this._state != "starting" && this._state != "stopping" && this._state != "new")
                    return false;
                break;
            case "stopping":
                if (this._state != "started")
                    return false;
                break;
            default:
                return false;
        }
        this._state = state;
        return true;
    }
}

class DeviceManager {
    static get shared() {
        if (!this._shared)
            this._shared = new DeviceManager();
        return this._shared;
    }
    get audioInputs() { return this._audioInputs; }
    /** @event */
    get audioInputsUpdated() { return this._audioInputsUpdated; }
    get audioOutputs() { return this._audioOutputs; }
    /** @event */
    get audioOutputsUpdated() { return this._audioOutputsUpdated; }
    get isStarted() { return this.state == "started"; }
    get isStarting() { return this.state == "starting"; }
    get isStopped() { return this.state == "stopped" || this.state == "new"; }
    get isStopping() { return this.state == "stopping"; }
    set pollingInteral(milliseconds) { this._pollDevicesTimoutInterval = milliseconds; }
    get pollingInterval() { return this._pollDevicesTimoutInterval; }
    /** @event */
    get started() { return this._stateEvents.get("started"); }
    /** @event */
    get starting() { return this._stateEvents.get("starting"); }
    /** @event */
    get stopped() { return this._stateEvents.get("stopped"); }
    /** @event */
    get stopping() { return this._stateEvents.get("stopping"); }
    get state() { return this._stateMachine.state; }
    /** @event */
    get stateChanged() { return this._stateChanged; }
    get videoInputs() { return this._videoInputs; }
    /** @event */
    get videoInputsUpdated() { return this._videoInputsUpdated; }
    constructor() {
        this._audioInputs = new DeviceCollection();
        this._audioInputsUpdated = new EventOwnerAsync();
        this._audioOutputs = new DeviceCollection();
        this._audioOutputsUpdated = new EventOwnerAsync();
        this._eventQueue = new DispatchQueue();
        this._stateChanged = new EventOwnerAsync();
        this._stateEvents = new Map();
        this._stateMachine = new DeviceManagerStateMachine();
        this._videoInputs = new DeviceCollection();
        this._videoInputsUpdated = new EventOwnerAsync();
        this._pollDevicesTimoutInterval = 1000;
        this._isDeviceMonitorRunning = false;
        this._stateEvents.set("started", new EventOwnerAsync());
        this._stateEvents.set("starting", new EventOwnerAsync());
        this._stateEvents.set("stopped", new EventOwnerAsync());
        this._stateEvents.set("stopping", new EventOwnerAsync());
        this.pollDevicesOnInterval = this.pollDevicesOnInterval.bind(Reactive.wrap(this)); // contextualize 'this'
    }
    async pollDevicesOnInterval() {
        await this.refresh();
        Log.verbose('Refreshed device list.');
        this._pollDevicesTimeoutId = setTimeout(this.pollDevicesOnInterval, this._pollDevicesTimoutInterval);
    }
    async setState(state) {
        const previousState = this._stateMachine.state;
        this._stateMachine.setState(state);
        const e = {
            manager: this,
            previousState: previousState,
            state: state,
        };
        await this._stateEvents.get(state).dispatch(e);
        await this._stateChanged.dispatch(e);
    }
    async startDeviceMonitor() {
        if (this._isDeviceMonitorRunning)
            return;
        this._isDeviceMonitorRunning = true;
        await this.pollDevicesOnInterval();
    }
    stopDeviceMonitor() {
        this._isDeviceMonitorRunning = false;
        clearTimeout(this._pollDevicesTimeoutId);
    }
    async update(collection, newDevices, eventOwner) {
        const newDevicesById = {};
        for (const newDevice of newDevices)
            newDevicesById[newDevice.id] = newDevice;
        let devicesUpdated = false;
        // remove detached devices
        const removed = [];
        const updated = [];
        for (let index = collection.length - 1; index >= 0; index--) {
            const existingDevice = collection[index];
            const newDevice = newDevicesById[existingDevice.id];
            if (newDevice) {
                // check if device label has changed, mainly for detecting when "default" device has changed, in Chrome
                if (existingDevice.label != newDevice.label) {
                    updated.push(newDevice);
                    devicesUpdated = true;
                }
                existingDevice.label = newDevice.label;
                continue;
            }
            removed.push(existingDevice);
            collection.tryRemove(existingDevice.id);
            devicesUpdated = true;
        }
        // add newly attached devices
        const added = [];
        for (let i = 0; i < newDevices.length; i++) {
            const newDevice = newDevices[i];
            if (collection.get(newDevice.id))
                continue;
            added.push(newDevice);
            collection.tryInsert(newDevice, i);
            devicesUpdated = true;
        }
        if (!devicesUpdated)
            return;
        await eventOwner.dispatch({
            added: added,
            manager: this,
            removed: removed,
            updated: updated,
        });
    }
    async onStarted() { }
    async onStarting() { }
    async onStopped() { }
    async onStopping() { }
    async promptForAudioPermissions() {
        try {
            const stream = await globalThis.navigator.mediaDevices.getUserMedia({ audio: true });
            stream.getAudioTracks()[0].stop();
            return true;
        }
        catch {
            return false;
        }
    }
    async promptForVideoPermissions() {
        try {
            const stream = await globalThis.navigator.mediaDevices.getUserMedia({ video: true });
            stream.getVideoTracks()[0].stop();
            return true;
        }
        catch {
            return false;
        }
    }
    async refresh() {
        return this._eventQueue.dispatch(async () => {
            const infos = await globalThis.navigator?.mediaDevices.enumerateDevices() ?? [];
            const audioInputs = infos.filter(info => info.kind == "audioinput").map(info => ({ id: info.deviceId, groupId: info.groupId, label: info.label }));
            const audioOutputs = infos.filter(info => info.kind == "audiooutput").map(info => ({ id: info.deviceId, groupId: info.groupId, label: info.label }));
            const videoInputs = infos.filter(info => info.kind == "videoinput").map(info => ({ id: info.deviceId, groupId: info.groupId, label: info.label }));
            await this.update(this._audioInputs, audioInputs, this._audioInputsUpdated);
            await this.update(this._audioOutputs, audioOutputs, this._audioOutputsUpdated);
            await this.update(this._videoInputs, videoInputs, this._videoInputsUpdated);
        });
    }
    async start() {
        if (this.state == "started")
            return;
        try {
            await this.setState("starting");
            await this.onStarting();
            await this.startDeviceMonitor();
            await this.setState("started");
            await this.onStarted();
        }
        catch (error) {
            await this.setState("stopped");
            await this.onStopped();
            throw error;
        }
    }
    async stop() {
        if (this.state == "new")
            await this.setState("stopped");
        if (this.state == "stopped")
            return;
        try {
            await this.setState("stopping");
            await this.onStopping();
            this.stopDeviceMonitor();
            this._audioInputs.removeAll();
            this._videoInputs.removeAll();
            this._audioOutputs.removeAll();
        }
        finally {
            await this.setState("stopped");
            await this.onStopped();
        }
    }
}

const version$1 = "2.28.0-rc.39";

let Client$4 = class Client {
    get maxRetries() { return this._httpClient.maxRetries; }
    set maxRetries(value) { this._httpClient.maxRetries = value; }
    get requestTimeout() { return this._httpClient.requestTimeout; }
    set requestTimeout(value) { this._httpClient.requestTimeout = value; }
    constructor(init) {
        Guard.isNotNullOrUndefined(init, "init");
        Guard.isNotNullOrUndefined(init.controlServerUrl, "init.controlServerUrl");
        Guard.isNotNullOrUndefined(init.meetingSession, "init.meetingSession");
        this._init = init;
        this._httpClient = HttpClient.withTokenFactory(async () => {
            const token = await this._init.meetingSession.token();
            return {
                baseUrl: new URL(this._init.controlServerUrl).origin,
                value: token.value
            };
        });
    }
    static deflate(offer) {
        return Base64.encode(deflateRaw_1(new TextEncoder().encode(offer)));
    }
    async negotiate(request, abortSignal) {
        Guard.isNotNullOrUndefined(request, "request");
        Guard.isNotNullOrUndefined(request.offer, "request.offer");
        return (await this._httpClient.post("/negotiate", {
            offerDeflate: Client.deflate(request.offer),
            sdkVersion: version$1,
        }, abortSignal)).value;
    }
    async renegotiate(request, abortSignal) {
        Guard.isNotNullOrUndefined(request, "request");
        Guard.isNotNullOrUndefined(request.offer, "request.offer");
        return (await this._httpClient.post("/renegotiate", {
            offerDeflate: Client.deflate(request.offer),
        }, abortSignal)).value;
    }
};

class ConnectionStateMachine {
    get previousStateDuration() { return this._lastStateDuration; }
    get state() { return this._state; }
    constructor(initialState) {
        this._lastTransitionTimestamp = performance.now();
        this._state = initialState ?? "new";
    }
    setState(state) {
        if (this.trySetState(state))
            return;
        throw new Error(`Cannot transition to '${state}' state while in '${this._state}' state.`);
    }
    trySetState(state) {
        switch (state) {
            case "closed":
                if (this._state == "closed" || this._state == "failed")
                    return false;
                break;
            case "connected":
                if (this._state != "connecting" && this._state != "reconnecting")
                    return false;
                break;
            case "connecting":
                if (this._state != "new")
                    return false;
                break;
            case "failed":
                if (this._state == "closed" || this._state == "failed")
                    return false;
                break;
            case "reconnecting":
                if (this._state != "connected")
                    return false;
                break;
            default:
                return false;
        }
        this._state = state;
        const now = performance.now();
        if (this._lastTransitionTimestamp)
            this._lastStateDuration = now - this._lastTransitionTimestamp;
        this._lastTransitionTimestamp = now;
        return true;
    }
}

class PromiseCompletionSource {
    get completed() { return this._completed; }
    get promise() { return this._promise; }
    get reason() { return this._reason; }
    get resolved() { return this._resolved; }
    get rejected() { return this._rejected; }
    get value() { return this._value; }
    constructor(abortSignal) {
        this._completed = false;
        this._resolved = false;
        this._rejected = false;
        this._promise = new Promise((resolve, reject) => {
            this._resolve = resolve;
            this._reject = reject;
        });
        if (abortSignal) {
            abortSignal.onabort = () => {
                this.reject(new Error(Constants$2.Errors.General.Operation.aborted));
            };
            if (abortSignal.aborted) {
                this.reject(new Error(Constants$2.Errors.General.Operation.aborted));
            }
        }
    }
    resolve(value) {
        this._completed = true;
        this._resolved = true;
        this._value = value ?? null;
        this._resolve(this._value);
    }
    reject(reason) {
        this._completed = true;
        this._rejected = true;
        this._reason = reason;
        this._reject(this._reason);
    }
}

function parseIPAddressFromSdp(sdp) {
    const results = Utility.extractCaptureGroups(sdp, /IN IP4 (\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3})/g)
        .filter(x => x != "0.0.0.0");
    return results.length > 0 ? results[0] : null;
}
function parseIcePasswordFromSdp(sdp) {
    const results = Utility.extractCaptureGroups(sdp, /a=ice-pwd:(.+)\r\n/g);
    return results.length > 0 ? results[0] : null;
}
function parseRelayPortFromIceCandidate(sdpCandidate) {
    const results = Utility.extractCaptureGroups(sdpCandidate, /\s(\d+)\styp\srelay/g)
        .map(x => parseInt(x));
    return results.length > 0 ? results[0] : null;
}
function parseSdpUserNameFragment(sdp) {
    const results = Utility.extractCaptureGroups(sdp, /a=ice-ufrag:(.+)\r\n/g);
    return results.length > 0 ? results[0] : null;
}

const defaultIceRestartFailedBackoff = 100;
let Connection$3 = class Connection {
    get eventLogger() { return this._eventLogger; }
    get connection() { return this._connection; }
    get eventQueue() { return this._eventQueue; }
    get type() { return this._type; }
    /** @internal */
    get pendingMessages() { return this._pendingMessages; }
    get attendeeId() { return this._attendeeId; }
    get answerReceived() { return this._answerReceived; }
    get controlChannelState() { return this._controlChannel.readyState; }
    get controlChannelStateChanged() { return this._controlChannelStateChanged; }
    get closed() { return this._stateEvents.get("closed"); }
    get connected() { return this._stateEvents.get("connected"); }
    get connecting() { return this._stateEvents.get("connecting"); }
    get failed() { return this._stateEvents.get("failed"); }
    get iceCandidateFailed() { return this._iceCandidateFailed; }
    get iceCandidateGathered() { return this._iceCandidateGathered; }
    get iceConnectionStateChanged() { return this._iceConnectionStateChanged; }
    get iceConnectionState() { return this._connection.iceConnectionState; }
    get iceGatheringStateChanged() { return this._iceGatheringStateChanged; }
    get iceGatheringState() { return this._connection.iceGatheringState; }
    get isClosed() { return this.state == "closed"; }
    get isConnected() { return this.state == "connected"; }
    get isConnecting() { return this.state == "connecting"; }
    get isFailed() { return this.state == "failed"; }
    get isReconnecting() { return this.state == "reconnecting"; }
    get isTerminated() { return this.isClosed || this.isFailed; }
    get meetingId() { return this._meetingId; }
    get offerCreated() { return this._offerCreated; }
    get negotiationNeeded() { return this._negotiationNeeded; }
    get peerConnectionStateChanged() { return this._peerConnectionStateChanged; }
    get peerConnectionState() { return this._connection.connectionState; }
    get reconnecting() { return this._stateEvents.get("reconnecting"); }
    get requestTimeout() { return this._requestTimeout; }
    set requestTimeout(value) { this._requestTimeout = value; }
    get signalingState() { return this._connection.signalingState; }
    get signalingStateChanged() { return this._signalingStateChanged; }
    get state() { return this._stateMachine.state; }
    get stateChanged() { return this._stateChanged; }
    constructor(init) {
        this._answerReceived = new EventOwnerAsync();
        this._controlChannelStateChanged = new EventOwner();
        this._eventQueue = new DispatchQueue();
        this._iceCandidateFailed = new EventOwner();
        this._iceCandidateGathered = new EventOwner();
        this._iceConnectionStateChanged = new EventOwner();
        this._iceGatheringStateChanged = new EventOwner();
        this._iceReconnectionTimeoutMax = 10000;
        this._iceRestartTimeout = 5000;
        this._negotiationNeeded = new EventOwner();
        this._offerCreated = new EventOwnerAsync();
        this._peerConnectionStateChanged = new EventOwner();
        this._pendingMessages = [];
        this._relayPorts = [];
        this._signalingStateChanged = new EventOwner();
        this._stateChanged = new EventOwner();
        this._stateEvents = new Map();
        this._stateMachine = new ConnectionStateMachine();
        this._supportsSetCodecPreferences = window.RTCRtpTransceiver && 'setCodecPreferences' in window.RTCRtpTransceiver.prototype;
        this._transactions = new Map();
        this._controlChannelBytesReceived = 0;
        this._controlChannelBytesSent = 0;
        this._currentIceCandidates = new Array();
        this._currentIceCandidateRemoteIp = null;
        this._currentNetworkId = null;
        this._dtlsTransport = null;
        this._iceRestarting = false;
        this._iceRestartFailedBackoff = defaultIceRestartFailedBackoff;
        this._iceRestartFailedTimeoutId = 0;
        this._iceRestartTimeoutId = 0;
        this._iceTransport = null;
        this._lastDisconnectedTime = 0;
        this._localIcePassword = null;
        this._localIceUsernameFragment = null;
        this._opened = null;
        this._reconnectedTimeoutId = null;
        this._remoteIcePassword = null;
        this._remoteIceUsernameFragment = null;
        this._remoteIPAddress = null;
        this._requestTimeout = 15000;
        this._terminatedReason = "";
        this._transactionId = 0;
        this._attendeeId = init.attendeeId;
        this._eventLogger = init.eventLogger;
        this._iceRestartEnabled = init.iceRestartEnabled;
        this._iceReconnectionTimeout = Math.min(init.iceReconnectionTimeout, this._iceReconnectionTimeoutMax);
        this._meetingId = init.meetingId;
        this._redAudioEnabled = init.redAudioEnabled;
        this._turnSession = init.turnSession;
        this._type = init.type;
        this._stateEvents.set("closed", new EventOwner());
        this._stateEvents.set("connected", new EventOwner());
        this._stateEvents.set("connecting", new EventOwner());
        this._stateEvents.set("failed", new EventOwner());
        this._stateEvents.set("reconnecting", new EventOwner());
        this._onControlChannelClose = this.onControlChannelClose.bind(Reactive.wrap(this));
        this._onControlChannelClosing = this.onControlChannelClosing.bind(Reactive.wrap(this));
        this._onControlChannelError = this.onControlChannelError.bind(Reactive.wrap(this));
        this._onControlChannelMessage = this.onControlChannelMessage.bind(Reactive.wrap(this));
        this._onControlChannelOpen = this.onControlChannelOpen.bind(Reactive.wrap(this));
        this._onDtlsTransportError = this.onDtlsTransportError.bind(Reactive.wrap(this));
        this._onDtlsTransportStateChange = this.onDtlsTransportStateChange.bind(Reactive.wrap(this));
        this._onIceCandidate = this.onIceCandidate.bind(Reactive.wrap(this));
        this._onIceCandidateError = this.onIceCandidateError.bind(Reactive.wrap(this));
        this._onIceConnectionStateChange = this.onIceConnectionStateChange.bind(Reactive.wrap(this));
        this._onIceGatheringStateChange = this.onIceGatheringStateChange.bind(Reactive.wrap(this));
        this._onIceTransportGatheringStateChange = this.onIceTransportGatheringStateChange.bind(Reactive.wrap(this));
        this._onIceTransportSelectedCandidatePairChange = this.onIceTransportSelectedCandidatePairChange.bind(Reactive.wrap(this));
        this._onIceTransportStateChange = this.onIceTransportStateChange.bind(Reactive.wrap(this));
        this._onNegotiationNeeded = this.onNegotiationNeeded.bind(Reactive.wrap(this));
        this._onPeerConnectionStateChange = this.onPeerConnectionStateChange.bind(Reactive.wrap(this));
        this._onSignalingStateChange = this.onSignalingStateChange.bind(Reactive.wrap(this));
        this._onWindowUnload = this.onWindowUnload.bind(Reactive.wrap(this));
        this._connection = new RTCPeerConnection({
            bundlePolicy: "max-bundle",
            iceTransportPolicy: init.turnRequired ? "relay" : "all",
            rtcpMuxPolicy: "require",
        });
        this._controlChannel = this._connection.createDataChannel("control");
        this._controlChannel.binaryType = "arraybuffer";
    }
    fail(reason, force = false) {
        void this._eventLogger.information("fail", `${this._type} failing with ${reason} force=${force}`);
        if (this._connection.iceConnectionState === "connected" && !force) {
            void this._eventLogger.information("fail", `${this._type} attempted to fail with reason ${reason} but the ICE connection state is ${this._connection.iceConnectionState}`);
            return;
        }
        this.terminate("failed", reason);
    }
    getDtlsTransport() {
        for (const sender of this._connection.getSenders()) {
            if (sender.transport)
                return sender.transport;
        }
        for (const receiver of this._connection.getReceivers()) {
            if (receiver.transport)
                return receiver.transport;
        }
        return null;
    }
    onControlChannelClose() {
        const message = `${this._type} connection control channel has closed.`;
        void this._eventLogger.debug("onControlChannelClose", message);
        this.onControlChannelStateChange();
        this.fail(message, true);
    }
    onControlChannelClosing() {
        const message = `${this._type} connection control channel is closing.`;
        void this._eventLogger.debug("onControlChannelClosing", message);
        this.onControlChannelStateChange();
    }
    onControlChannelError(ev) {
        const message = `${this._type} connection control channel has failed. ${ev.error?.errorDetail ?? ev.error ?? null}`.trimEnd();
        void this._eventLogger.debug("onControlChannelError", message);
        this.onControlChannelStateChange();
        this.fail(message, true);
    }
    onControlChannelMessage(ev) {
        const messageJson = ev.data;
        this._controlChannelBytesReceived += messageJson.length;
        const message = JSON.parse(messageJson);
        if (message.batch) {
            for (const m of message.batch) {
                this.processMessage(m);
            }
        }
        else {
            this.processMessage(message);
        }
    }
    onControlChannelOpen() {
        const message = `${this._type} connection control channel has opened.`;
        void this._eventLogger.debug("onControlChannelOpen", message);
        this.onControlChannelStateChange();
        this._opened?.resolve(null);
        this._opened = null;
        this.trySetState("connected");
        for (const message of this._pendingMessages) {
            this.send(message);
        }
        this._pendingMessages.length = 0;
    }
    onControlChannelStateChange() {
        void this._eventLogger.debug("onControlChannelStateChange", `${this._type} connection control channel ready-state is now '${this._controlChannel.readyState}'.`);
        this._controlChannelStateChanged.dispatch({
            connection: this,
        });
    }
    onDtlsTransportError(ev) {
        const errDetail = ev.error?.errorDetail ?? ev.error ?? "";
        void this._eventLogger.debug("onDtlsTransportError", `${this._type} connection DTLS transport has failed. ${errDetail}`.trimEnd());
    }
    onDtlsTransportStateChange() {
        void this._eventLogger.debug("onDtlsTransportStateChange", `${this._type} connection DTLS transport state is now '${this._dtlsTransport.state}'.`);
    }
    onIceCandidate(ev) {
        if (!ev.candidate) {
            void this._eventLogger.debug("onIceCandidate", `${this._type} connection ICE candidate gathering complete.`);
            return;
        }
        if (!ev.candidate.candidate) {
            void this._eventLogger.debug("onIceCandidate", `${this._type} connection ICE candidate generation gathering complete.`);
            return;
        }
        const candidate = ev.candidate;
        candidate.wifiCandidate = false;
        candidate.lanCandidate = false;
        // Safari does not report the networkType or networkAdapterType in the stats.
        // If the device is connected to a LAN, the candidate will have a relatedAddress 
        // which is the local LAN IP that's related to the public IP
        // We check to see if it is a LAN IP and then determine the networkType
        if (ev.candidate.relatedAddress?.match(/^(192\.168|10\.)/)) {
            if (Utility.isMobileBrowser()) {
                candidate.wifiCandidate = true;
            }
            else {
                candidate.lanCandidate = true;
            }
        }
        else {
            // If media is not attached to the offer (I think) the candidates do not report a real local IP in Safari.
            // To find a local candidate, you need to check if the candidate port matches and the IP contains .local. Example below.
            // The public IP port is the same as the local port. This is the best we can do determine if this is a LAN candidate.
            // Local a=candidate:3781818601 1 udp 2122260223 0a783e55-5096-42b4-a590-dd5de2288d01.local 60266 typ host generation 0 ufrag XZyj network-id 1 network-cost 50
            // Public a=candidate:980080808 1 udp 1686052607 74.102.103.173 60266 typ srflx raddr 0.0.0.0 rport 0 generation 0 ufrag XZyj network-id 1 network-cost 50
            const localHostCandidate = this._currentIceCandidates.find(x => x.address?.includes(".local") && x.port == ev.candidate.port);
            if (localHostCandidate) {
                if (Utility.isMobileBrowser()) {
                    candidate.wifiCandidate = true;
                }
                else {
                    candidate.lanCandidate = true;
                }
            }
        }
        this._currentIceCandidates.push(candidate);
        // TODO: MK - Removing this but leaving for reference as there is still something to explore on the server side to force certain candidates.
        // It can't be done from the client alone. Changing priority/network cost does nothing.
        // const excludedCandidates = this.getExcludedIceCandidates();
        // const networkId = ev.candidate.candidate.match(/network-id \d+/);
        // if (excludedCandidates.length > 0) {
        //   const candidate = excludedCandidates.find(x => x == ev.candidate.address);
        //   if (candidate) {
        //     this._currentNetworkId = networkId[0];
        //     void this._eventLogger.debug("onIceCandidate", `${this._type} connection ICE candidate ignoring candidate IP ${candidate}`);
        //     return;
        //   }
        // } else if (ev.candidate.address.startsWith("192.168")) {
        //   const match = ev.candidate.candidate.match(/network-id \d+/);
        //   this._currentNetworkId = match[0];
        // }
        const iceCandidate = {
            sdpCandidate: `a=${ev.candidate.candidate}`,
            sdpMid: ev.candidate.sdpMid,
            sdpMLineIndex: ev.candidate.sdpMLineIndex,
        };
        // discard TCP candidates
        if (iceCandidate.sdpCandidate.toLowerCase().indexOf(" tcp ") != -1 || ev.candidate.protocol == "tcp") {
            void this._eventLogger.debug("onIceCandidate", `${this._type} connection ICE candidate discarded with mid ${iceCandidate.sdpMid} and m-line index ${iceCandidate.sdpMLineIndex}: ${iceCandidate.sdpCandidate}`);
            return;
        }
        void this._eventLogger.debug("onIceCandidate", `${this._type} connection ICE candidate gathered with mid ${iceCandidate.sdpMid} and m-line index ${iceCandidate.sdpMLineIndex}: ${iceCandidate.sdpCandidate}`);
        this._iceCandidateGathered.dispatch({
            connection: this,
            iceCandidate: iceCandidate,
        });
        this.sendNotification({
            iceCandidate: iceCandidate,
            type: "iceCandidate",
        });
        const relayPort = parseRelayPortFromIceCandidate(iceCandidate.sdpCandidate);
        if (relayPort) {
            if (this._remoteIPAddress) {
                void this.setIceInfo([relayPort]);
            }
            else {
                this._relayPorts.push(relayPort);
            }
        }
    }
    onIceCandidateError(ev) {
        if (this.state != "connecting")
            return;
        void this._eventLogger.debug("onIceCandidateError", `${this._type} connection ICE candidate failed.`, null, {
            address: ev.address,
            errorCode: ev.errorCode,
            errorText: ev.errorText,
            port: ev.port,
            url: ev.url,
        });
        this._iceCandidateFailed.dispatch({
            address: ev.address,
            connection: this,
            errorCode: ev.errorCode,
            errorText: ev.errorText,
            port: ev.port,
            url: ev.url,
        });
    }
    onIceConnectionStateChange() {
        void this._eventLogger.debug("onIceConnectionStateChange", `${this._type} connection ICE-connection-state is now '${this._connection.iceConnectionState}'.`);
        this._iceConnectionStateChanged.dispatch({
            connection: this,
        });
        switch (this._connection.iceConnectionState) {
            case "connected":
                this._lastDisconnectedTime = 0;
                if (!this.trySetState("connected"))
                    break;
                this.clearReconnectTimeout();
                this.clearIceRestartTimeout();
                break;
            case "disconnected":
                this._lastDisconnectedTime = performance.now();
                if (!this.trySetState("reconnecting"))
                    break;
                // If the connection is disconnected, let it try to recover for 5 seconds before triggering an ICE restart
                // Start the reconnection timeout timer and the ICE restart timer. If the connection recovers, the timers will be cleared.
                this.clearReconnectTimeout();
                this.setReconnectionTimeout();
                this.clearIceRestartTimeout();
                this.setIceRestartTimeout();
                break;
            case "failed":
                // Note: 'failed' is mostly called on Safari. It is rare for the ICE connection to get into a failed state in other browsers.
                // Fail the connection immediately because the client tried to reconnect to the server and the server rejected the connection
                const timeToFail = this._lastDisconnectedTime - performance.now();
                void this._eventLogger.information("onIceConnectionStateChange", `ICE connection 'failed'. Failing ${this._type} connection. Time to failure ${timeToFail}.`);
                this.fail("Network failed.", true);
                break;
        }
    }
    onIceGatheringStateChange() {
        void this._eventLogger.debug("onIceGatheringStateChange", `${this._type} connection ICE-gathering-state is now '${this._connection.iceGatheringState}'.`);
        this._iceGatheringStateChanged.dispatch({
            connection: this,
        });
    }
    onIceTransportGatheringStateChange() {
        void this._eventLogger.debug("onIceTransportGatheringStateChange", `${this._type} connection ICE transport gathering state is now '${this._iceTransport.gatheringState}'.`);
    }
    onIceTransportSelectedCandidatePairChange() {
        let localSdpCandidate = null;
        let remoteSdpCandidate = null;
        if (this._iceTransport.getSelectedCandidatePair) {
            const selectedCandidatePair = this._iceTransport.getSelectedCandidatePair();
            if (selectedCandidatePair) {
                if (selectedCandidatePair.local)
                    localSdpCandidate = `a=${selectedCandidatePair.local.candidate}`;
                if (selectedCandidatePair.remote) {
                    remoteSdpCandidate = `a=${selectedCandidatePair.remote.candidate}`;
                    try {
                        const remoteIpMatch = remoteSdpCandidate.match(/(\d{1,3}\.){3}\d{1,3}/);
                        if (remoteIpMatch?.length > 0) {
                            this._currentIceCandidateRemoteIp = remoteIpMatch[0];
                        }
                    }
                    catch (err) {
                        void this._eventLogger.error(err, "onIceTransportSelectedCandidatePairChange", `Error parsing remote IP from candidate ${remoteSdpCandidate} from ${this._type} server.`);
                    }
                }
            }
        }
        void this._eventLogger.debug("onIceTransportSelectedCandidatePairChange", `${this._type} connection ICE transport selected candidate pair has changed.`, null, {
            localSdpCandidate: localSdpCandidate,
            remoteSdpCandidate: remoteSdpCandidate,
        });
    }
    onIceTransportStateChange() {
        void this._eventLogger.debug("onIceTransportStateChange", `${this._type} connection ICE transport state is now '${this._iceTransport.state}'.`);
    }
    onNegotiationNeeded() {
        void this._eventLogger.debug("onNegotiationNeeded", `${this._type} connection needs negotiation.`);
        this._negotiationNeeded.dispatch({
            connection: this,
        });
    }
    onPeerConnectionStateChange() {
        void this._eventLogger.debug("onPeerConnectionStateChange", `${this._type} connection peer-connection-state is now '${this._connection.connectionState}'.`);
        this._peerConnectionStateChanged.dispatch({
            connection: this,
        });
    }
    onSignalingStateChange() {
        if (this._connection.signalingState == "have-local-offer") {
            this._dtlsTransport = this.getDtlsTransport();
            if (this._dtlsTransport) {
                this._dtlsTransport.addEventListener("error", this._onDtlsTransportError);
                this._dtlsTransport.addEventListener("statechange", this._onDtlsTransportStateChange);
                this._iceTransport = this._dtlsTransport.iceTransport ?? null;
                if (this._iceTransport) {
                    this._iceTransport.addEventListener("gatheringstatechange", this._onIceTransportGatheringStateChange);
                    this._iceTransport.addEventListener("selectedcandidatepairchange", this._onIceTransportSelectedCandidatePairChange);
                    this._iceTransport.addEventListener("statechange", this._onIceTransportStateChange);
                }
            }
        }
        void this._eventLogger.debug("onSignalingStateChange", `${this._type} connection signaling-state is now '${this._connection.signalingState}'.`);
        this._signalingStateChanged.dispatch({
            connection: this,
        });
    }
    clearReconnectTimeout() {
        if (this._reconnectedTimeoutId) {
            void this._eventLogger.information("clearReconnectTimeout", `Clearing reconnection timeout for ${this._type} TimeoutId=${this._reconnectedTimeoutId}`);
            clearTimeout(this._reconnectedTimeoutId);
            this._reconnectedTimeoutId = null;
        }
        else {
            void this._eventLogger.information("clearReconnectTimeout", `No reconnect timeout to clear ${this._type}`);
        }
    }
    setReconnectionTimeout(timeout) {
        this._reconnectedTimeoutId = setTimeout(() => {
            const timeToFail = this._lastDisconnectedTime - performance.now();
            void this._eventLogger.information("setReconnectionTimeout", `Reconnection timeout hit for ${this._type}. Time to fail ${timeToFail}`);
            this.fail("Network failed (timeout).");
        }, timeout ?? this._iceReconnectionTimeout);
        void this._eventLogger.information("setReconnectionTimeout", `Setting reconnection timeout for ${this._type} TimeoutId=${this._reconnectedTimeoutId}`);
    }
    clearIceRestartTimeout() {
        if (this._iceRestartTimeoutId) {
            void this._eventLogger.information("clearIceRestartTimeout", `Clearing ICE restart timeout for ${this._type}`);
            clearTimeout(this._iceRestartTimeoutId);
            this._iceRestartTimeoutId = null;
        }
    }
    setIceRestartTimeout() {
        void this._eventLogger.information("setIceRestartTimeout", `Setting ICE restart timeout for ${this._type}`);
        this._iceRestartTimeoutId = setTimeout(async () => {
            void this._eventLogger.information("setIceRestartTimeout", `ICE restart timeout hit for ${this._type}. RTC connection did not recover, triggering ICE restart`);
            await this.iceRestart();
        }, this._iceRestartTimeout);
    }
    onWindowUnload() {
        this.close("Window is being unloaded.");
    }
    processMessage(message) {
        if ("transactionId" in message) {
            const transaction = this._transactions.get(message.transactionId);
            if (transaction) {
                void this._eventLogger.debug("onControlChannelMessage", `Received ${message.type} response (${message.transactionId}) from ${this._type} server.`, Math.round(performance.now() - transaction.performanceStart), {
                    "response": JSON.stringify(message)
                });
            }
            this.processResponse(message);
        }
        else {
            void this._eventLogger.debug("onControlChannelMessage", `Received ${message.type} notification from ${this._type} server.`, undefined, {
                "notification": JSON.stringify(message)
            });
            if (message.type == "connectionClosed") {
                void this._eventLogger.information("onControlChannelMessage", `Received ${message.type} notification from ${this._type} server. Closing the connection.`);
                this.close(`Server connection has closed. ${message.description ?? ''}`.trimEnd());
            }
            else if (message.type == "connectionFailed") {
                void this._eventLogger.information("onControlChannelMessage", `Received ${message.type} notification from ${this._type} server. Failing the connection`);
                this.fail(`Server connection has failed. ${message.description ?? ''}`.trimEnd());
            }
            else if (message.type == "operationFailed" || message.type == "permissionDenied") {
                void this._eventLogger.error("onControlChannelMessage", `Received ${message.type} notification from ${this._type} server.`);
            }
            else {
                this.processNotification(message);
            }
        }
    }
    processResponse(response) {
        const transaction = this._transactions.get(response.transactionId);
        if (transaction) {
            this._transactions.delete(response.transactionId);
            if (transaction.timeoutId)
                clearTimeout(transaction.timeoutId);
            if (response.type == "operationFailed" || response.type == "permissionDenied") {
                transaction.reject(new Error(response.description));
            }
            else {
                transaction.resolve(response);
            }
        }
        else {
            void this._eventLogger.warning("processResponse", `Discarding late ${response.type} response (${response.transactionId}) from ${this._type} server.`, undefined, {
                "response": JSON.stringify(response)
            });
        }
    }
    async setIceInfo(relayPorts) {
        try {
            await this._turnSession?.setIceInfo({
                localPassword: this._localIcePassword,
                localUsernameFragment: this._localIceUsernameFragment,
                relayPorts: relayPorts,
                remoteIPAddress: this._remoteIPAddress,
                remotePassword: this._remoteIcePassword,
                remoteUsernameFragment: this._remoteIceUsernameFragment,
            });
        }
        catch (error) {
            const ports = relayPorts.join(", ");
            void this._eventLogger.error(error, "onIceCandidate", `${this._type} connection relay port(s) (${ports}) could not be signalled to the server.`);
        }
    }
    setState(state) {
        const previousState = this._stateMachine.state;
        this._stateMachine.setState(state);
        void this._eventLogger.debug("setState", `${this._type} connection state is now '${state}'.`);
        const e = {
            connection: this,
            previousState: previousState,
            previousStateDuration: this._stateMachine.previousStateDuration,
            state: state,
        };
        this._stateEvents.get(state).dispatch(e);
        this._stateChanged.dispatch(e);
    }
    /**
     * Sets the preferred audio codecs for the transceiver. Specifically, this enables RED audio for downstream connections.
     * @returns
     */
    setPreferredAudioCodecs() {
        if (!this._supportsSetCodecPreferences || this._redAudioEnabled !== true) {
            return;
        }
        const { codecs } = RTCRtpReceiver.getCapabilities('audio');
        const redCodecIndex = codecs.findIndex(c => c.mimeType === 'audio/red');
        if (redCodecIndex == -1) {
            Log.info('audio/red codec not supported');
            return;
        }
        const redCodec = codecs[redCodecIndex];
        codecs.splice(redCodecIndex, 1);
        codecs.unshift(redCodec);
        this.connection.getTransceivers().filter(x => x.direction == "recvonly" && x.receiver.track.kind == "audio").forEach((transceiver) => {
            try {
                transceiver.setCodecPreferences(codecs);
            }
            catch (err) {
                console.error(`TransceiverId=${transceiver.mid}`, err);
            }
        });
        void this._eventLogger.debug("setPreferredAudioCodecs", `audio/red codec preference set: ${JSON.stringify(codecs)}`);
    }
    /**
     * Sets the preferred video codec on the transceiver. Specfically, this is forcing Edge connections
     * to use VP8 because on iOS, the browser is trying to negotiate H264 downstream but we do not support it.
     * @returns
     */
    setPreferredVideoCodecs() {
        if (!this._supportsSetCodecPreferences) {
            return;
        }
        const { codecs } = RTCRtpReceiver.getCapabilities("video");
        const vp8Codec = codecs.find(c => c.mimeType === 'video/VP8');
        if (!vp8Codec) {
            Log.info('video/VP8 codec not supported');
            return;
        }
        const downstreamCodecs = [vp8Codec];
        this.connection.getTransceivers().filter(x => x.direction == "recvonly" && x.receiver.track.kind == "video").forEach((transceiver) => {
            try {
                transceiver.setCodecPreferences(downstreamCodecs);
            }
            catch (err) {
                console.error(`TransceiverId=${transceiver.mid}`, err);
            }
        });
        void this._eventLogger.debug("setPreferredVideoCodecs", `video/VP8 codec preference set: ${JSON.stringify(downstreamCodecs)}`);
    }
    terminate(state, reason) {
        if (!this.trySetState(state))
            return;
        this._terminatedReason = reason;
        this.tryRejectOpen(`Connection ${state}. (${reason})`);
        if (this._controlChannel.readyState == "open")
            this.send({ type: state == "closed" ? "connectionClosed" : "connectionFailed" });
        this.onTerminating();
        this.detachEventHandlers();
        this._controlChannel.close();
        this._connection.close();
        for (const transaction of this._transactions.values())
            transaction.reject(new Error(`Connection ${state}. (${this._terminatedReason}) Could not receive ${transaction.request.type} response (${transaction.request.transactionId}).`));
        this._transactions.clear();
        this.onTerminated();
        void this._eventLogger.debug("terminate", `${this._type} connection ${state}. (${reason})`);
    }
    tryRejectOpen(reason) {
        this._opened?.resolve(new Error(reason));
        this._opened = null;
    }
    trySetState(state) {
        const previousState = this._stateMachine.state;
        if (!this._stateMachine.trySetState(state))
            return false;
        void this._eventLogger.debug("setState", `${this._type} connection state is now '${state}'.`);
        const e = {
            connection: this,
            previousState: previousState,
            previousStateDuration: this._stateMachine.previousStateDuration,
            state: state,
        };
        this._stateEvents.get(state).dispatch(e);
        this._stateChanged.dispatch(e);
        return true;
    }
    iceRestart() {
        if (!this._iceRestartEnabled)
            return;
        if (this.state != "connected" && this.state != "reconnecting")
            return;
        if (this._iceRestarting)
            return;
        this._iceRestarting = true;
        return this._eventQueue.dispatch(async () => {
            let iceRestartSucceeded = false;
            try {
                void this._eventLogger.information("iceRestart", `${this._type} connection ICE restarting...`);
                await this.onOpening();
                if (this._turnSession) {
                    const iceServer = await this._turnSession.iceServer();
                    const configuration = this._connection.getConfiguration();
                    configuration.iceServers = [iceServer];
                    this._connection.setConfiguration(configuration);
                }
                this._currentIceCandidates = new Array();
                let offer = (await this._connection.createOffer({ iceRestart: true })).sdp;
                this._localIcePassword = parseIcePasswordFromSdp(offer);
                this._localIceUsernameFragment = parseSdpUserNameFragment(offer);
                offer = await this.mungeOffer(offer);
                Log.debug(`${this._type} connection ICE restart SDP offer:\n${offer}`);
                await this._connection.setLocalDescription({ sdp: offer, type: "offer" });
                let answer = await this.renegotiate(offer, null);
                // Reset the failure timeout after renegotiation is successful.
                this.clearReconnectTimeout();
                this.setReconnectionTimeout();
                this._remoteIcePassword = parseIcePasswordFromSdp(answer);
                this._remoteIceUsernameFragment = parseSdpUserNameFragment(answer);
                this._remoteIPAddress = parseIPAddressFromSdp(answer);
                answer = await this.mungeAnswer(answer);
                Log.debug(`${this._type} connection ICE restart SDP answer:\n${answer}`);
                if (this.isClosed) {
                    void this._eventLogger.information("iceRestart", `${this._type} connection ICE restart failed. Connection closed.`);
                    return;
                }
                if (this.isFailed) {
                    void this._eventLogger.warning("iceRestart", `${this._type} connection ICE restart failed. Connection failed.`);
                    return;
                }
                if (this._relayPorts.length)
                    void this.setIceInfo(this._relayPorts.splice(0));
                await this._connection.setRemoteDescription({ sdp: answer, type: "answer" });
                await this.onOpened();
                void this._eventLogger.information("iceRestart", `${this._type} connection ICE restart succeeded.`);
                this._iceRestartFailedBackoff = defaultIceRestartFailedBackoff;
                if (this._iceRestartFailedTimeoutId) {
                    clearTimeout(this._iceRestartFailedTimeoutId);
                }
                iceRestartSucceeded = true;
            }
            catch (error) {
                void this._eventLogger.error(error, "iceRestart", `${this._type} connection ICE restart failed.`);
                if (error.name === "BadRequestError") {
                    this.fail("ICE Restart failed. (renegotiation failed)");
                }
            }
            finally {
                this._iceRestarting = false;
                if (!iceRestartSucceeded && this.state != "failed") {
                    void this._eventLogger.information("iceRestart", `Setting ICE restart failed retry: Backoff=${this._iceRestartFailedBackoff}`);
                    this._iceRestartFailedTimeoutId = setTimeout(() => {
                        this._iceRestartFailedBackoff += 200;
                        void this.iceRestart();
                        void this._eventLogger.information("iceRestart", `ICE restart failed retry hit: NewBackoff=${this._iceRestartFailedBackoff}`);
                    }, this._iceRestartFailedBackoff);
                }
            }
        });
    }
    attachEventHandlers() {
        this._connection.addEventListener("connectionstatechange", this._onPeerConnectionStateChange);
        this._connection.addEventListener("icecandidate", this._onIceCandidate);
        this._connection.addEventListener("icecandidateerror", this._onIceCandidateError);
        this._connection.addEventListener("iceconnectionstatechange", this._onIceConnectionStateChange);
        this._connection.addEventListener("icegatheringstatechange", this._onIceGatheringStateChange);
        this._connection.addEventListener("negotiationNeeded", this._onNegotiationNeeded);
        this._connection.addEventListener("signalingstatechange", this._onSignalingStateChange);
        this._controlChannel.addEventListener("close", this._onControlChannelClose);
        this._controlChannel.addEventListener("closing", this._onControlChannelClosing);
        this._controlChannel.addEventListener("error", this._onControlChannelError);
        this._controlChannel.addEventListener("message", this._onControlChannelMessage);
        this._controlChannel.addEventListener("open", this._onControlChannelOpen);
        globalThis.window?.addEventListener("unload", this._onWindowUnload);
    }
    detachEventHandlers() {
        this._connection.removeEventListener("connectionstatechange", this._onPeerConnectionStateChange);
        this._connection.removeEventListener("icecandidate", this._onIceCandidate);
        this._connection.removeEventListener("icecandidateerror", this._onIceCandidateError);
        this._connection.removeEventListener("iceconnectionstatechange", this._onIceConnectionStateChange);
        this._connection.removeEventListener("icegatheringstatechange", this._onIceGatheringStateChange);
        this._connection.removeEventListener("negotiationNeeded", this._onNegotiationNeeded);
        this._connection.removeEventListener("signalingstatechange", this._onSignalingStateChange);
        this._controlChannel.removeEventListener("close", this._onControlChannelClose);
        this._controlChannel.removeEventListener("closing", this._onControlChannelClosing);
        this._controlChannel.removeEventListener("error", this._onControlChannelError);
        this._controlChannel.removeEventListener("message", this._onControlChannelMessage);
        this._controlChannel.removeEventListener("open", this._onControlChannelOpen);
        globalThis.window?.removeEventListener("unload", this._onWindowUnload);
    }
    async mungeAnswer(answer) {
        const answerEvent = {
            answer: answer,
            connection: this,
        };
        await this._answerReceived.dispatch(answerEvent);
        return answerEvent.answer;
    }
    async mungeOffer(offer) {
        const offerEvent = {
            connection: this,
            offer: offer,
        };
        await this._offerCreated.dispatch(offerEvent);
        return offerEvent.offer;
    }
    async onOpened() { }
    async onOpening() { }
    onTerminated() { }
    onTerminating() { }
    processReceiverStats(receiverStats) { }
    processSenderStats(senderStats) { }
    close(reason) {
        this.terminate("closed", reason);
    }
    open(abortSignal) {
        if (this.state == "connected" || this.state == "reconnecting")
            return;
        this.setState("connecting");
        this.onControlChannelStateChange();
        const opened = this._opened = new PromiseCompletionSource(abortSignal);
        return this._eventQueue.dispatch(async () => {
            await this.onOpening();
            const performanceStart = performance.now();
            try {
                if (this._turnSession) {
                    const [iceServerDuration, iceServer] = await Utility.time(() => this._turnSession.iceServer());
                    const configuration = this._connection.getConfiguration();
                    configuration.iceServers = [iceServer];
                    this._connection.setConfiguration(configuration);
                    void this._eventLogger.information("open.iceServers", `${this._type} connection set ICE server.`, iceServerDuration);
                }
                if (this._type === "Edge") {
                    this.setPreferredAudioCodecs();
                    this.setPreferredVideoCodecs();
                }
                // negotiation phase
                const [offerDuration, result] = await Utility.time(() => this._connection.createOffer());
                let offer = result.sdp;
                this._localIcePassword = parseIcePasswordFromSdp(offer);
                this._localIceUsernameFragment = parseSdpUserNameFragment(offer);
                void this._eventLogger.information("open.offerCreated", `${this._type} connection created offer.`, offerDuration);
                const [mungeOfferDuration, mungedOffer] = await Utility.time(() => this.mungeOffer(offer));
                offer = mungedOffer;
                void this._eventLogger.information("open.offerMunged", `${this._type} connection munged offer.`, mungeOfferDuration);
                Log.debug(`${this._type} connection SDP offer:\n${offer}`);
                const [setLocalDescriptionDuration] = await Utility.time(() => this._connection.setLocalDescription({ sdp: offer, type: "offer" }));
                void this._eventLogger.information("open.localDescriptionSet", `${this._type} connection set local description.`, setLocalDescriptionDuration);
                let [negotationDuration, answer] = await Utility.time(() => this.negotiate(offer, abortSignal));
                this._remoteIcePassword = parseIcePasswordFromSdp(answer);
                this._remoteIceUsernameFragment = parseSdpUserNameFragment(answer);
                this._remoteIPAddress = parseIPAddressFromSdp(answer);
                const rmAddr = this._remoteIPAddress ? this._remoteIPAddress : "unknown address";
                void this._eventLogger.information("open.negotiated", `${this._type} connection negotiated with ${rmAddr}.`, negotationDuration);
                const [mungeAnswerDuration, mungedAnswer] = await Utility.time(() => this.mungeAnswer(answer));
                answer = mungedAnswer;
                void this._eventLogger.information("open.answerMunged", `${this._type} connection munged answer.`, mungeAnswerDuration);
                Log.debug(`${this._type} connection SDP answer:\n${answer}`);
                if (this._relayPorts.length)
                    void this.setIceInfo(this._relayPorts.splice(0));
                const [setRemoteDescriptionDuration] = await Utility.time(() => this._connection.setRemoteDescription({ sdp: answer, type: "answer" }));
                void this._eventLogger.information("open.remoteDescriptionSet", `${this._type} connection set remote description.`, setRemoteDescriptionDuration);
                void this._eventLogger.information("open.negotationCompleted", `${this._type} connection completed negotation phase.`, Math.round(performance.now() - performanceStart));
                // connection phase
                let dtlsConnectionDuration;
                let whenConnectionStateConnected;
                let whenIceStateConnected;
                let whenNegotationComplete = performance.now();
                this._connection.addEventListener("iceconnectionstatechange", () => {
                    if (this._connection.iceConnectionState === 'connected') {
                        whenIceStateConnected = performance.now();
                        void this._eventLogger.information("open.iceConnected", `${this._type} connection completed ICE connection.`, Math.round(performance.now() - whenNegotationComplete));
                    }
                });
                this._connection.addEventListener("connectionstatechange", () => {
                    if (this._connection.connectionState === 'connected') {
                        // FF does not currently support connection states, thus this event will never fire. DTLS duration will remain undefined.
                        if (whenIceStateConnected) {
                            dtlsConnectionDuration = Math.round(performance.now() - whenIceStateConnected);
                            whenConnectionStateConnected = performance.now();
                            void this._eventLogger.information("open.connected", `${this._type} connection completed DTLS handshake.`, dtlsConnectionDuration);
                        }
                    }
                });
                const error = await opened.promise;
                const connDuration = dtlsConnectionDuration ? " ${dtlsConnectionDuration}ms" : "";
                void this._eventLogger.information("open.controlChannelOpened", `${this._type} connection opened control channel (including DTLS handshake${connDuration}).`, Math.round(performance.now() - whenIceStateConnected));
                void this._eventLogger.information("open.connectionCompleted", `${this._type} connection completed connection phase.`, Math.round(performance.now() - whenNegotationComplete));
                if (error)
                    throw error;
                void this._eventLogger.debug("open.succeeded", `${this._type} connection opened.`, Math.round(performance.now() - performanceStart));
            }
            catch (error) {
                void this._eventLogger.warning("open.failed", `${this._type} connection failed.`, Math.round(performance.now() - performanceStart));
                throw error;
            }
            await this.onOpened();
        });
    }
    send(message) {
        if (Utility.isNullOrUndefined(message.transactionId)) {
            void this._eventLogger.debug("send", `Sending ${message.type} notification to ${this._type} server...`, undefined, {
                "notification": JSON.stringify(message)
            });
        }
        else {
            void this._eventLogger.debug("send", `Sending ${message.type} request (${message.transactionId}) to ${this._type} server...`, undefined, {
                "request": JSON.stringify(message)
            });
        }
        const messageJson = JSON.stringify(message);
        try {
            this._controlChannel.send(messageJson);
            this._controlChannelBytesSent += messageJson.length;
        }
        catch (err) {
            void this._eventLogger.error(err, "send", `Error sending ${message.type} from ${this._type} server.`);
        }
    }
    sendNotification(notification) {
        Guard.isNotNullOrUndefined(notification, "notification");
        switch (this.state) {
            case "new":
            case "connecting":
                this._pendingMessages.push(notification);
                break;
            case "connected":
            case "reconnecting":
                this.send(notification);
                break;
            case "closed":
            case "failed":
                throw new Error(`Connection ${this.state}. (${this._terminatedReason}) Could not send ${notification.type} notification.`);
        }
    }
    sendRequest(request) {
        Guard.isNotNullOrUndefined(request, "request");
        request.transactionId = this._transactionId++;
        const promise = new Promise((resolve, reject) => {
            if (this.isTerminated)
                return;
            const requestTimeout = this._requestTimeout;
            const timeoutId = Utility.isNullOrUndefined(requestTimeout) ? 0 : setTimeout(() => {
                this._transactions.delete(request.transactionId);
                reject(new Error(`Transaction timed out for ${request.type} request (${request.transactionId}) from ${this._type} server after ${requestTimeout.toLocaleString()}ms.`));
            }, requestTimeout);
            this._transactions.set(request.transactionId, { reject, request, resolve, timeoutId, performanceStart: performance.now() });
        });
        switch (this.state) {
            case "new":
            case "connecting":
                this._pendingMessages.push(request);
                break;
            case "connected":
            case "reconnecting":
                this.send(request);
                break;
            case "closed":
            case "failed":
                throw new Error(`Connection ${this.state}. (${this._terminatedReason}) Could not send ${request.type} request.`);
        }
        return promise;
    }
};

/*
 * @nevware21/ts-utils
 * https://github.com/nevware21/ts-utils
 *
 * Copyright (c) 2022 Nevware21
 * Licensed under the MIT license.
 */
// These constants are currently NOT exported directly, we may export them later associated with a frozen namespace (maybe)
// For now do NOT expect that we will export these values.
var UNDEF_VALUE = undefined;
var NULL_VALUE = null;
var EMPTY = "";
var BOOLEAN = "boolean";
var FUNCTION = "function";
var NUMBER = "number";
var OBJECT = "object";
var PROTOTYPE = "prototype";
var __PROTO__ = "__proto__";
var STRING = "string";
var UNDEFINED = "undefined";
var CONSTRUCTOR = "constructor";
var SYMBOL = "Symbol";
var POLYFILL_TAG = "_polyfill";
var INDEX_OF = "indexOf";
var LAST_INDEX_OF = "lastIndexOf";
var LENGTH = "length";
var DONE = "done";
var VALUE = "value";
var NAME = "name";
var SLICE = "slice";
/**
 * @ignore
 */
var ObjClass$1 = Object;
/**
 * @ignore
 */
var ObjProto$1 = ObjClass$1[PROTOTYPE];
/**
 * @ignore
 */
var StrCls = String;
/**
 * @ignore
 */
var StrProto = StrCls[PROTOTYPE];
/**
 * @ignore
 */
var MathCls = Math;
/**
 * @ignore
 */
var ArrCls = Array;
/**
 * @ignore
 */
var ArrProto = ArrCls[PROTOTYPE];

/*
 * @nevware21/ts-utils
 * https://github.com/nevware21/ts-utils
 *
 * Copyright (c) 2022 Nevware21
 * Licensed under the MIT license.
 */
/**
 * Function to safely execute a callback function, if the function throws the provided default
 * value will be returned.
 * @since 0.9.5
 * @group Safe
 * @param cb - Callback function be wrapped with an exception
 * @param defValue - The default value to return when an exception is thrown
 * @returns The result of the callback function or the default if an exception occurred calling the callback
 * function.
 * @example
 * ```ts
 * let theExpression = "{ invalid: json value";
 *
 * let result = safeGet(() => {
 *     return JSON.parse(theExpression);
 * }, {});
 *
 * // result === {};
 * ```
 */
function safeGet(cb, defValue) {
    var result = defValue;
    try {
        result = cb();
    }
    catch (e) {
        // Do nothing
    }
    return result;
}

/*
 * @nevware21/ts-utils
 * https://github.com/nevware21/ts-utils
 *
 * Copyright (c) 2022 Nevware21
 * Licensed under the MIT license.
 */
var PRIMITIVE_TYPES = [STRING, NUMBER, BOOLEAN, UNDEFINED, "symbol", "bigint"];
/**
 * @ignore
 * @internal
 * Create and returns a function that will return `true` if the argument passed
 * to it matches the provided type.
 * @param theType - The type to match against the `typeof value`
 * @returns A function which takes a single argument and returns a boolean
 */
function _createIs(theType) {
    return function (value) {
        return typeof value === theType;
    };
}
/**
 * @ignore
 * @internal
 * Create and returns a function that will return `true` if the argument passed
 * to it matches the object type specified based on {@link objToString}.
 * @param - The object name to match for the `objToString(value)`
 * @returns A function which takes a single argument and returns a boolean
 */
function _createObjIs(theName) {
    var theType = "[object " + theName + "]";
    return function (value) {
        return !!(value && objToString(value) === theType);
    };
}
/**
 * The `objToString()` method returns a string representing the object. This explicitly
 * always calls the `Object.prototype.toString()` method.
 *
 * An object's toString() method is most commonly invoked when that object undergoes:
 * - explicit type conversion to a string (for example, String(myObject))
 * - implicit type coercion into a string (for example, myObject + "hello world")
 *
 * @group Object
 * @param value - The object to be converted into a string
 * @returns A string representation of the object
 * @example
 * ```ts
 * objToString(new Date()); // [object Date]
 * objToString(new String()); // [object String]
 *
 * // Math has its Symbol.toStringTag
 * objToString(Math); // [object Math]
 *
 * objToString(undefined); // [object Undefined]
 * objToString(null); // [object Null]
 * ```
 */
function objToString(value) {
    return ObjProto$1.toString.call(value);
}
/**
 * Checks if the provided value is undefined or contains the string value "undefined",
 * if you want to consider the string value as undefined see {@link isStrictUndefined}
 * @group Type Identity
 * @group Value Check
 * @param value - The value to check
 * @returns true if the value is undefined or "undefined", otherwise false
 * @example
 * ```ts
 * isUndefined(undefined);              // true
 * isUndefined("undefined");            // true
 *
 * isUndefined(null);                   // false
 * isUndefined("null");                 // false
 * isUndefined("1");                    // false
 * isUndefined("aa");                   // false
 * isUndefined(new Date());             // false
 * isUndefined(1);                      // false
 * isUndefined("");                     // false
 * isUndefined(_dummyFunction);         // false
 * isUndefined([]);                     // false
 * isUndefined(new Array(1));           // false
 * isUndefined(true);                   // false
 * isUndefined(false);                  // false
 * isUndefined("true");                 // false
 * isUndefined("false");                // false
 * isUndefined(new Boolean(true));      // false
 * isUndefined(new Boolean(false));     // false
 * isUndefined(new Boolean("true"));    // false
 * isUndefined(new Boolean("false"));   // false
 * isUndefined(Boolean(true));          // false
 * isUndefined(Boolean(false));         // false
 * isUndefined(Boolean("true"));        // false
 * isUndefined(Boolean("false"));       // false
 * isUndefined(new RegExp(""));         // false
 * isUndefined(new ArrayBuffer(0));     // false
 * isUndefined(new Error("Test Error"));// false
 * isUndefined(new TypeError("Test TypeError"));    // false
 * isUndefined(new TestError("Test TestError"));    // false
 * isUndefined(_dummyError());          // false
 * isUndefined(Promise.reject());       // false
 * isUndefined(Promise.resolve());      // false
 * isUndefined(new Promise(() => {}));  // false
 * isUndefined(_simplePromise());       // false
 * isUndefined(_simplePromiseLike());   // false
 * isUndefined(Object.create(null));    // false
 * isUndefined(polyObjCreate(null));    // false
 * ```
 */
function isUndefined(value) {
    return typeof value === UNDEFINED || value === UNDEFINED;
}
/**
 * Checks if the provided value is null, undefined or contains the string value of "undefined".
 * @group Type Identity
 * @group Value Check
 * @param value - The value to check
 * @returns `true` if the value is `null` or `undefined`
 * @example
 * ```ts
 * isNullOrUndefined(null);         // true
 * isNullOrUndefined(undefined);    // true
 * isNullOrUndefined("undefined");  // true
 *
 * let value = null;
 * isNullOrUndefined(value);        // true
 * let value = undefined;
 * isNullOrUndefined(value);        // true
 *
 * isNullOrUndefined("");           // false
 * isNullOrUndefined(0);            // false
 * isNullOrUndefined(new Date());   // false
 * isNullOrUndefined(true);         // false
 * isNullOrUndefined(false);        // false
 * ```
 */
function isNullOrUndefined(value) {
    return value === NULL_VALUE || isUndefined(value);
}
/**
 * Checks if the provided value is null, undefined only, a string value of "undefined" is NOT considered
 * to be undefined.
 * @group Type Identity
 * @group Value Check
 * @param value - The value to check
 * @returns
 * @example
 * ```ts
 * isStrictNullOrUndefined(null);         // true
 * isStrictNullOrUndefined(undefined);    // true
 * isStrictNullOrUndefined("undefined");  // false
 *
 * let value = null;
 * isStrictNullOrUndefined(value);        // true
 * let value = undefined;
 * isStrictNullOrUndefined(value);        // true
 *
 * isStrictNullOrUndefined("");           // false
 * isStrictNullOrUndefined(0);            // false
 * isStrictNullOrUndefined(new Date());   // false
 * isStrictNullOrUndefined(true);         // false
 * isStrictNullOrUndefined(false);        // false
 * ```
 */
function isStrictNullOrUndefined(value) {
    return value === NULL_VALUE || !isDefined(value);
}
/**
 * Checks if the passed value is defined, which means it has any value and is not undefined.
 * A string value of "undefined" is considered to be defined.
 * @group Value Check
 * @param arg - The value to check
 * @returns true if arg has a value (is not === undefined)
 * @example
 * ```ts
 * isDefined(null);         // false
 * isDefined(undefined);    // false
 * isDefined("undefined");  // true
 *
 * let value = null;
 * isDefined(value);        // false
 * let value = undefined;
 * isDefined(value);        // false
 *
 * isDefined("");           // true
 * isDefined(0);            // true
 * isDefined(new Date());   // true
 * isDefined(true);         // true
 * isDefined(false);        // true
 * ```
 */
function isDefined(arg) {
    return !!arg || arg !== UNDEF_VALUE;
}
/**
 * Identifies whether the provided value is a JavaScript [primitive](https://developer.mozilla.org/en-US/docs/Glossary/Primitive)
 * which is when is it not an object and has no methods or properties. There are 6 primitive data types:
 * - string
 * - number
 * - bigint
 * - boolean
 * - undefined
 * - symbol
 *
 * Most of the time, a primitive value is represented directly at the lowest level of the language implementation.
 *
 * All primitives are immutable; that is, they cannot be altered. It is important not to confuse a primitive itself
 * with a variable assigned a primitive value. The variable may be reassigned to a new value, but the existing value
 * can not be changed in the ways that objects, arrays, and functions can be altered. The language does not offer
 * utilities to mutate primitive values.
 * @since 0.9.6
 * @group Type Identity
 * @param theType - The type as a string value to be checked whther it's a primitive type, this should be the value
 * returned from `typeof value`.
 * @example
 * ```ts
 * isPrimitiveType(null);                   // false
 * isPrimitiveType(undefined);              // false
 * isPrimitiveType("null");                 // false
 * isPrimitiveType("undefined");            // false
 * isPrimitiveType("1");                    // false
 * isPrimitiveType("aa");                   // false
 * isPrimitiveType(1);                      // false
 * isPrimitiveType(Number(2));              // false
 * isPrimitiveType("");                     // false
 * isPrimitiveType(String(""));             // false
 * isPrimitiveType(true);                   // false
 * isPrimitiveType(false);                  // false
 * isPrimitiveType("true");                 // false
 * isPrimitiveType("false");                // false
 * isPrimitiveType(BigInt(42));             // false
 * isPrimitiveType(Symbol.for("Hello"));    // false
 *
 * isPrimitiveType("string");               // true
 * isPrimitiveType("number");               // true
 * isPrimitiveType("boolean");              // true
 * isPrimitiveType("undefined");            // true
 * isPrimitiveType("symbol");               // true
 * isPrimitiveType("bigint");               // true
 * ```
 */
var isPrimitiveType = function (theType) {
    return theType !== OBJECT && PRIMITIVE_TYPES.indexOf(theType) !== -1;
};
/**
 * Checks to see if the past value is a string value
 * @group Type Identity
 * @group String
 * @param value - The value to check
 * @returns
 * @example
 * ```ts
 * isString("");            // true
 * isString("null");        // true
 * isString("undefined");   // true
 * isString(String(""));    // true
 *
 * isString(null);          // false
 * isString(undefined);     // false
 * isString(0);             // false
 * ```
 */
var isString = _createIs(STRING);
/**
 * Checks to see if the past value is a function value
 * @group Type Identity
 * @param value - The value to check
 * @returns
 * @example
 * ```ts
 * function myFunction() { }
 * isFunction(null);            // false
 * isFunction(undefined);       // false
 * isFunction("null");          // false
 * isFunction("undefined");     // false
 * isFunction("1");             // false
 * isFunction("aa");            // false
 * isFunction(new Date());      // false
 * isFunction(1);               // false
 * isFunction("");              // false
 * isFunction(myFunction);      // true
 * isFunction([]);              // false
 * isFunction(new Array(1));    // false
 * ```
 */
var isFunction = _createIs(FUNCTION);
/**
 * Checks to see if the past value is an object value
 * @group Type Identity
 * @group Object
 * @typeParam T - The object type, defaults to any
 * @param value - The value to check
 * @returns
 */
function isObject(value) {
    if (!value && isNullOrUndefined(value)) {
        return false;
    }
    return !!value && typeof value === OBJECT;
}
/**
 * Checks if the type of value is an Array.
 *
 * @group Type Identity
 * @group Array
 * @param {any} value - Value to be checked.
 * @return {boolean} True if the value is a Array, false otherwise.
 * @example
 * ```ts
 * import { isArray, isObject } from "@nevware21/ts-utils";
 *
 * function performAction(value: any) {
 *     if (isArray(value) || isObject(value)) {
 *         // Do something
 *     } else {
 *         // Do something else
 *     }
 * }
 * ```
 */
var isArray = ArrCls.isArray;
/**
 * Check if an object is of type Date
 * @group Type Identity
 * @example
 * ```ts
 * import { isDate } from "@nevware21/ts-utils";
 *
 * let _theDate = null;
 *
 * function getSetDate(newDate?: any) {
 *     _theDate = isDate(newDate) ? newDate : new Date();
 *
 *     return _theDate;
 * }
 * ```
 */
var isDate = _createObjIs("Date");
/**
 * Checks if the type of value is a number.
 * @group Type Identity
 * @param {any} value - Value to be checked.
 * @return {boolean} True if the value is a number, false otherwise.
 */
var isNumber = _createIs(NUMBER);
/**
 * Checks if the type of value is a boolean.
 * @group Type Identity
 * @param {any} value - Value to be checked.
 * @return {boolean} True if the value is a boolean, false otherwise.
 */
var isBoolean = _createIs(BOOLEAN);
/**
 * Checks if the type of value is a Error object.
 * @group Type Identity
 * @group Error
 * @param {any} value - Value to be checked.
 * @return {boolean} True if the value is a Error, false otherwise.
 */
var isError = _createObjIs("Error");
/**
 * Checks if the type of value is a PromiseLike instance (contains a then function).
 * @group Type Identity
 * @param {any} value - Value to be checked.
 * @return {boolean} True if the value is a PromiseLike, false otherwise.
 */
function isPromiseLike(value) {
    return !!value && isFunction(value.then);
}
/**
 * Checks if the type of value evaluates to true value, handling some special
 * case usages of Boolean(true/false) and new Boolean(true/false).
 * @group Value Check
 * @param {any} value - Value to be checked.
 * @return {boolean} True if the value is not truthy, false otherwise.
 */
function isTruthy(value) {
    // Objects created with no prototype (Object.create(null)) cannot be converted to primitives
    // Which causes this code to throw, additionally just using !! also fails for Boolean objects
    // !!(new Boolean(false)) evaluates to true
    return !(!value || safeGet(function () { return !(value && (0 + value)); }, !value));
    //return !(!value || !(value && (0 + value)));
}

/*
 * @nevware21/ts-utils
 * https://github.com/nevware21/ts-utils
 *
 * Copyright (c) 2022 Nevware21
 * Licensed under the MIT license.
 */
/**
 * The objGetOwnPropertyDescriptor() method returns an object describing the configuration of a specific property on
 * a given object (that is, one directly present on an object and not in the object's prototype chain). The object
 * returned is mutable but mutating it has no effect on the original property's configuration.
 * @since 0.4.3
 * @group Object
 * @param target - Object that contains the property.
 * @param prop - Name of the property.
 * @returns A property descriptor of the given property if it exists on the object, otherwise undefined.
 *
 * @example
 * ```ts
 * o = {};
 * objDefineProp(o, 'qux', {
 *   value: 8675309,
 *   writable: false,
 *   enumerable: false
 * });
 * d = objGetOwnPropertyDescriptor(o, 'qux');
 * // d is {
 * //   value: 8675309,
 * //   writable: false,
 * //   enumerable: false,
 * //   configurable: false
 * // }
 *
 * objGetOwnPropertyDescriptor('foo', 0);
 * // TypeError: "foo" is not an object  // ES5 code
 *
 * objGetOwnPropertyDescriptor('foo', 0);
 * // Object returned by ES2015 code: {
 * //   configurable: false,
 * //   enumerable: true,
 * //   value: "f",
 * //   writable: false
 * // }
 * ```
 * Note: In ES5, if the first argument to this method is not an object (a primitive), then it will cause a TypeError. In ES2015, a non-object first argument will be coerced to an object at first.
 */
var objGetOwnPropertyDescriptor = ObjClass$1.getOwnPropertyDescriptor;

/*
 * @nevware21/ts-utils
 * https://github.com/nevware21/ts-utils
 *
 * Copyright (c) 2022 Nevware21
 * Licensed under the MIT license.
 */
/**
 * The objHasOwnProperty() method returns a boolean indicating whether the object
 * has the specified property as its own property (as opposed to inheriting it).
 *
 * The objHasOwnProperty() method returns true if the specified property is a direct
 * property of the object — even if the value is null or undefined. The method returns
 * false if the property is inherited, or has not been declared at all. Unlike the in
 * operator, this method does not check for the specified property in the object's
 * prototype chain.
 *
 * The method can be called on most JavaScript objects, because most objects descend
 * from Object, and hence inherit its methods. For example Array is an Object, so you
 * can use objHasOwnProperty() method to check whether an index exists:
 * @group Object
 * @param obj - The object being evaluated
 * @param prop - The String or Symbol of the property to test
 * @returns `true` if the object has the specified property as own property; otherwise `false`
 * @example
 * ```ts
 * let example = {};
 * objHasOwnProperty(example, 'prop');   // false
 *
 * example.prop = 'exists';
 * objHasOwnProperty(example, 'prop');   // true - 'prop' has been defined
 *
 * example.prop = null;
 * objHasOwnProperty(example, 'prop');   // true - own property exists with value of null
 *
 * example.prop = undefined;
 * objHasOwnProperty(example, 'prop');   // true - own property exists with value of undefined
 * ```
 */
function objHasOwnProperty(obj, prop) {
    return obj && ObjProto$1.hasOwnProperty.call(obj, prop);
}

/*
 * @nevware21/ts-utils
 * https://github.com/nevware21/ts-utils
 *
 * Copyright (c) 2022 Nevware21
 * Licensed under the MIT license.
 */
/**
 * The objHasOwn() method returns a boolean indicating whether the object
 * has the specified property as its own property (as opposed to inheriting it).
 * If the property is inherited, or does not exist, the method returns false.
 *
 * The objHasOwn() method returns true if the specified property is a direct property
 * of the object — even if the property value is null or undefined. The method returns
 * false if the property is inherited, or has not been declared at all. Unlike the in operator,
 * this method does not check for the specified property in the object's prototype chain.
 *
 * It is recommended over {@link objHasOwnProperty} () because it works for objects created using
 * objCreate(null) and with objects that have overridden the inherited hasOwnProperty() method.
 * While it is possible to workaround these problems by calling Object.prototype.hasOwnProperty()
 * on an external object, Object.hasOwn() is more intuitive.
 *
 * @since 0.4.3
 * @group Object
 * @param obj - The object being evaluated
 * @param prop - The String or Symbol of the property to test
 * @returns `true` if the object has the specified property as own property; otherwise `false`
 * @example
 * ```ts
 * let example = {};
 * objHasOwn(example, 'prop');   // false
 *
 * example.prop = 'exists';
 * objHasOwn(example, 'prop');   // true - 'prop' has been defined
 *
 * example.prop = null;
 * objHasOwn(example, 'prop');   // true - own property exists with value of null
 *
 * example.prop = undefined;
 * objHasOwn(example, 'prop');   // true - own property exists with value of undefined
 * ```
 */
var objHasOwn = ObjClass$1["hasOwn"] || polyObjHasOwn;
/**
 * The polyObjHasOwn() method is a polyfill for {@link objHasOwn} when the native
 * [Object.hasOwnreturns](https://caniuse.com/?search=hasOwn) is not supported, it returns a
 * boolean indicating whether the object has the specified property as its own property (as
 * opposed to inheriting it). If the property is inherited, or does not exist, the method
 * returns false.
 *
 * The objHasOwn() method returns true if the specified property is a direct property
 * of the object — even if the property value is null or undefined. The method returns
 * false if the property is inherited, or has not been declared at all. Unlike the in operator,
 * this method does not check for the specified property in the object's prototype chain.
 *
 * It is recommended over objHasOwnProperty() because it works for objects created using
 * objCreate(null) and with objects that have overridden the inherited hasOwnProperty() method.
 * While it is possible to workaround these problems by calling Object.prototype.hasOwnProperty()
 * on an external object, Object.hasOwn() is more intuitive.
 *
 * @since 0.4.3
 * @group Object
 * @group Polyfill
 * @param obj - The object being evaluated
 * @param prop - The String or Symbol of the property to test
 * @returns `true` if the object has the specified property as own property; otherwise `false`
 * @example
 * ```ts
 * let example = {};
 * polyObjHasOwn(example, 'prop');   // false
 *
 * example.prop = 'exists';
 * polyObjHasOwn(example, 'prop');   // true - 'prop' has been defined
 *
 * example.prop = null;
 * polyObjHasOwn(example, 'prop');   // true - own property exists with value of null
 *
 * example.prop = undefined;
 * polyObjHasOwn(example, 'prop');   // true - own property exists with value of undefined
 * ```
 */
function polyObjHasOwn(obj, prop) {
    return objHasOwnProperty(obj, prop) || !!objGetOwnPropertyDescriptor(obj, prop);
}

/*
 * @nevware21/ts-utils
 * https://github.com/nevware21/ts-utils
 *
 * Copyright (c) 2022 Nevware21
 * Licensed under the MIT license.
 */
/**
 * Calls the provided `callbackFn` function once for each key in an object. This is equivelent to `arrForEach(Object.keys(theObject), callbackFn)` or
 * if not using the array helper `Object.keys(theObject).forEach(callbackFn)` except that this helper avoid creating a temporary of the object
 * keys before iterating over them and like the `arrForEach` helper you CAN stop or break the iteration by returning -1 from the `callbackFn` function.
 * @group Object
 * @typeParam T - The object type
 * @param callbackfn  A function that accepts up to two arguments, the key name and the current value of the property represented by the key.
 * @param thisArg  [Optional] An object to which the this keyword can refer in the callbackfn function. If thisArg is omitted, null or undefined
 * the object will be used as the this value.
 * @example
 * ```ts
 * function performAction<T>(target: T, source: any) {
 *    if (!isNullOrUndefined(source)) {
 *        objForEachKey(source, (key, value) => {
 *            // Set the target with a reference to the same value with the same name
 *            target[key] = value;
 *        });
 *    }
 *
 *    return target;
 * }
 * ```
 */
function objForEachKey(theObject, callbackfn, thisArg) {
    if (theObject && isObject(theObject)) {
        for (var prop in theObject) {
            if (objHasOwn(theObject, prop)) {
                if (callbackfn.call(thisArg || theObject, prop, theObject[prop]) === -1) {
                    break;
                }
            }
        }
    }
}

/*
 * @nevware21/ts-utils
 * https://github.com/nevware21/ts-utils
 *
 * Copyright (c) 2022 Nevware21
 * Licensed under the MIT license.
 */
/**
 * @internal
 * @ignore
 * Internal Helper function to create a key and value mapped representation of the values
 * @param values - The source values
 * @param keyType - Identifies the value to populate against the key
 * @param valueType - Identifies the value to populate against the value
 * @param completeFn - The function to call to complete the map (used to freeze the instance)
 * @returns
 */
function _createKeyValueMap(values, keyType, valueType, completeFn) {
    var theMap = {};
    objForEachKey(values, function (key, value) {
        theMap[key] = keyType ? value : key;
        theMap[value] = valueType ? value : key;
    });
    return completeFn(theMap);
}

/*
 * @nevware21/ts-utils
 * https://github.com/nevware21/ts-utils
 *
 * Copyright (c) 2022 Nevware21
 * Licensed under the MIT license.
 */
/**
 * Throw an error exception with the specified optional message
 * @group Error
 * @param message
 */
function throwError(message) {
    throw new Error(message);
}
/**
 * Throw a type error with the specified optional message
 * @group Error
 * @param message
 */
function throwTypeError(message) {
    throw new TypeError(message);
}

/*
 * @nevware21/ts-utils
 * https://github.com/nevware21/ts-utils
 *
 * Copyright (c) 2022 Nevware21
 * Licensed under the MIT license.
 */
var _objFreeze = ObjClass$1["freeze"];
var _doNothing = function (value) { return value; };
var _getProto = function (value) { return value[__PROTO__] || NULL_VALUE; };
/**
 * The `objAssign()` method copies all enumerable own properties from one or more source objects
 * to a target object. It returns the modified target object.
 *
 * Properties in the target object are overwritten by properties in the sources if they have the
 * same key. Later sources' properties overwrite earlier ones.
 *
 * The objAssign() method only copies enumerable and own properties from a source object to a
 * target object. It uses `Get` on the source and `Set` on the target, so it will invoke
 * [getters](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Functions/get) and
 * [setters](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Functions/set).
 * Therefore it assigns properties, versus copying or defining new properties. This may make it
 * unsuitable for merging new properties into a prototype if the merge sources contain getters.
 *
 * For copying property definitions (including their enumerability) into prototypes, use
 * {@link objGetOwnPropertyDescriptor} and {@link objDefineProp} instead.
 *
 * Both String and Symbol properties are copied.
 *
 * In case of an error, for example if a property is non-writable, a TypeError is raised, and
 * the target object is changed if any properties are added before the error is raised.
 * @group Object
 * @example
 * ```ts
 * const obj = { a: 1 };
 * const copy = objAssign({}, obj);
 * console.log(copy); // { a: 1 }
 *
 * const o1 = { a: 1 };
 * const o2 = { b: 2 };
 * const o3 = { c: 3 };
 *
 * const obj = objAssign(o1, o2, o3);
 * console.log(obj); // { a: 1, b: 2, c: 3 }
 * console.log(o1);  // { a: 1, b: 2, c: 3 }, target object itself is changed.
 * ```
 */
var objAssign = ObjClass$1["assign"];
/**
 * The `objKeys()` method returns an array of a given object's own enumerable property names, iterated in
 * the same order that a normal loop would.
 *
 * objKeys() returns an array whose elements are strings corresponding to the enumerable properties found
 * directly upon object. The ordering of the properties is the same as that given by looping over the
 * properties of the object manually.
 * @group Object
 * @param value - The object to obtain a copy of the keys from
 * @returns An array of the properties names for the value object.
 * @example
 * ```ts
 * // simple array
 * const arr = ['a', 'b', 'c'];
 * console.log(objKeys(arr)); // console: ['0', '1', '2']
 *
 * // array-like object
 * const obj = { 0: 'a', 1: 'b', 2: 'c' };
 * console.log(objKeys(obj)); // console: ['0', '1', '2']
 *
 * // array-like object with random key ordering
 * const anObj = { 100: 'a', 2: 'b', 7: 'c' };
 * console.log(objKeys(anObj)); // console: ['2', '7', '100']
 *
 * // getFoo is a property which isn't enumerable
 * const myObj = objCreate({}, {
 *   getFoo: {
 *     value() { return this.foo; }
 *   }
 * });
 * myObj.foo = 1;
 * console.log(objKeys(myObj)); // console: ['foo']
 * ```
 */
function objKeys(value) {
    if (!isObject(value) || value === NULL_VALUE) {
        throwTypeError("objKeys called on non-object");
    }
    return ObjClass$1.keys(value);
}
/**
 * Perform a deep freeze on the object and all of it's contained values / properties by recursively calling
 * `objFreeze()` on all enumerable properties of the object and on each property returned.
 * @group Object
 * @param value - the object to be completly frozen.
 * @returns The originally passed in object.
 */
function objDeepFreeze(value) {
    if (_objFreeze) {
        objForEachKey(value, function (key, value) {
            if (isArray(value) || isObject(value)) {
                _objFreeze(value);
            }
        });
    }
    return objFreeze(value);
}
/**
 * The `objFreeze()` method freezes an object. A frozen object can no longer be changed; freezing an object
 * prevents new properties from being added to it, existing properties from being removed, prevents changing the
 * enumerability, configurability, or writability of existing properties, and prevents the values of existing
 * properties from being changed. In addition, freezing an object also prevents its prototype from being changed.
 * `objFreeze()` returns the same object that was passed in.
 *
 * Nothing can be added to or removed from the properties set of a frozen object. Any attempt to do so will fail,
 * either silently or by throwing a TypeError exception (most commonly, but not exclusively, when in strict mode).
 *
 * For data properties of a frozen object, values cannot be changed, the writable and configurable attributes are
 * set to false. Accessor properties (getters and setters) work the same (and still give the illusion that you are
 * changing the value). Note that values that are objects can still be modified, unless they are also frozen. As
 * an object, an array can be frozen; after doing so, its elements cannot be altered and no elements can be added
 * to or removed from the array.
 *
 * `objFreeze()` returns the same object that was passed into the function. It does not create a frozen copy.
 * @group Object
 * @param value - The object to freeze.
 * @returns The object that was passed to the function.
 */
var objFreeze = _objFreeze || _doNothing;
/**
 * The objGetPrototypeOf() method returns the prototype (i.e. the value of the internal `Prototype` property)
 * of the specified value.
 * @since 0.4.4
 * @group Object
 * @param value - The object whose prototype is to be returned, which may be null.
 */
var objGetPrototypeOf = ObjClass$1["getPrototypeOf"] || _getProto;

/*
 * @nevware21/ts-utils
 * https://github.com/nevware21/ts-utils
 *
 * Copyright (c) 2022 Nevware21
 * Licensed under the MIT license.
 */
/**
 * Create a TypeScript style enum class which is a mapping that maps from the key -> value and the value -> key.
 * This is effectively the same as defining a non-constant enum, but this only repeats the "Name" of the enum value once.
 * @group Enum
 * @example
 * ```ts
 * const enum Animal {
 *    Dog = 0,
 *    Cat = 1,
 *    Butterfly = 2,
 *    Bear = 3
 * }
 * const Animals = createEnum<typeof Animal>({
 *    Dog: Animal.Dog,
 *    Cat: Animal.Cat,
 *    Butterfly: Animal.Butterfly,
 *    Bear: Animal.Bear
 * });
 * // You end up with an object that maps everything to the name
 * Animals.Dog === 0;           // true
 * Animals[0] === "Dog";        // true
 * Animals["Dog"] === 0;        // true
 * Animals.Cat === 1;           // true
 * Animals[1] === "Cat";        // true
 * Animals["Cat"] === 1;        // true
 * ```

 * @param values - The values to populate on the new object
 * @typeParam E - Identifies the const enum type being mapped
 * @returns A new frozen (immutable) object which looks and acts like a TypeScript Enum class.
 */
function createEnum(values) {
    return _createKeyValueMap(values, 1 /* eMapValues.Value */, 0 /* eMapValues.Key */, objDeepFreeze);
}
/**
 * Create a map object which contains both the property key and value which both map to the key,
 * E[key] => key and E[value] => key.
 * @group Enum
 * @example
 * ```ts
 * const enum Animal {
 *    Dog = 0,
 *    Cat = 1,
 *    Butterfly = 2,
 *    Bear = 3
 * }
 * const animalMap = createEnumKeyMap<typeof Animal>({
 *    Dog: Animal.Dog,
 *    Cat: Animal.Cat,
 *    Butterfly: Animal.Butterfly,
 *    Bear: Animal.Bear
 * });
 * // You end up with an object that maps everything to the name
 * animalMap.Dog === "Dog";         // true
 * animalMap[0] === "Dog";          // true
 * animalMap["Dog"] === "Dog";      // true
 * animalMap.Cat === "Cat";         // true
 * animalMap[1] === "Cat";          // true
 * animalMap["Cat"] === "Cat";      // true
 * // Helper function to always return the "Name" of the type of animal
 * function getAnimalType(type: string | number | Animal) {
 *     return animalMap[type];
 * }
 * ```
 * @param values - The values to populate on the new object
 * @typeParam E - Identifies the const enum type being mapped
 * @returns A new frozen (immutable) object which contains a property for each key and value that returns the value.
 */
function createEnumKeyMap(values) {
    return _createKeyValueMap(values, 0 /* eMapValues.Key */, 0 /* eMapValues.Key */, objDeepFreeze);
}
/**
 * Create a map object which contains both the perperty key and value which both map to the requested
 * generic mapValue with a type of V, E[key] => mapValue and E[value] => mapValue.
 * @group Enum
 * @example
 * ```ts
 * const enum Animal {
 *    Dog = 0,
 *    Cat = 1,
 *    Butterfly = 2,
 *    Bear = 3
 * };
 * // Creates a simple mapping to a string value
 * const animalFamilyMap = createValueMap<typeof Animal, string>({
 *    Dog: [ Animal.Dog, "Canidae"],
 *    Cat: [ Animal.Cat, "Felidae"],
 *    Butterfly: [ Animal.Butterfly, "Papilionidae"],
 *    Bear: [ Animal.Bear, "Ursidae"]
 * });
 * // You end up with an object that maps everything to the name
 * animalMap.Dog === "Canidae";     // true with typeof animalMap.Dog is "string"
 * animalMap[0] === "Canidae";      // true with typeof animalMap[0] is "string"
 * animalMap["Dog"] === "Canidae";  // true with typeof animalMap["Dog"] is "string"
 * animalMap.Cat === "Felidae";     // true with typeof animalMap.Cat is "string"
 * animalMap[1] === "Felidae";      // true with typeof animalMap[1] is "string"
 * animalMap["Cat"] === "Felidae";  // true with typeof animalMap["Cat"] is "string"
 * ```
 * @param values - The values to populate on the new object
 * @typeParam E - Identifies the const enum type (eg. typeof Animal);
 * @typeParam V - Identifies the type of the mapping `string`; `number`; etc is not restructed to primitive types.
 * @returns A new frozen (immutable) object which contains a property for each key and value that returns the defiend mapped value.
 */
function createSimpleMap(values) {
    var mapClass = {};
    objForEachKey(values, function (key, value) {
        mapClass[key] = value[1];
        mapClass[value[0]] = value[1];
    });
    return objDeepFreeze(mapClass);
}
/**
 * Create a strongly types map object which contains both the perperty key and value which both map
 * to the requested mapValue,
 * E[key] => mapValue and E[value] => mapValue.
 * - E = the const enum type (typeof Animal);
 * - V = Identifies the valid values for the keys, this should include both the enum numeric and string key of the type. The
 * resulting "Value" of each entry identifies the valid values withing the assignments.
 * @group Enum
 * @example
 * ```ts
 * // Create a strongly types map
 * const animalFamilyMap = createTypeMap<typeof Animal, {
 *     // Defined the enum lookups
 *     [Animal.Dog]: "Canidae",
 *     [Animal.Cat]: "Felidae",
 *     [Animal.Butterfly]: "Papilionidae",
 *     [Animal.Bear]: "Ursidae",
 *     // Defined Named reference
 *     Dog: "Canidae",
 *     Cat: "Felidae",
 *     Butterfly: "Papilionidae",
 *     Bear: "Ursidae",
 * }>({
 *     Dog: [ Animal.Dog, "Canidae"],
 *     Cat: [ Animal.Cat, "Felidae"],
 *     Butterfly: [ Animal.Butterfly, "Papilionidae"],
 *     Bear: [ Animal.Bear, "Ursidae"]
 * });
 * // You end up with a strongly types result for each value
 * animalMap.Dog === "Canidae";     // true with typeof animalMap.Dog is (const) "Canidae"
 * animalMap[0] === "Canidae";      // true with typeof animalMap[0] is "Canidae"
 * animalMap["Dog"] === "Canidae";  // true with typeof animalMap["Dog"] is "Canidae"
 * animalMap.Cat === "Felidae";     // true with typeof animalMap.Cat is "Felidae"
 * animalMap[1] === "Felidae";      // true with typeof animalMap[1] is "Felidae"
 * animalMap["Cat"] === "Felidae";  // true with typeof animalMap["Cat"] is "Felidae"
 *
 * or using an interface to define the direct string mappings
 *
 * interface IAnimalFamilyMap {
 *     Dog: "Canidae",
 *     Cat: "Felidae",
 *     Butterfly: "Papilionidae",
 *     Bear: "Ursidae"
 * }
 *
 * // Create a strongly types map
 * const animalFamilyMap = createTypeMap<typeof Animal, IAnimalFamilyMap & {
 *     // Defined the enum lookups
 *     [Animal.Dog]: "Canidae",
 *     [Animal.Cat]: "Felidae",
 *     [Animal.Butterfly]: "Papilionidae",
 *     [Animal.Bear]: "Ursidae"
 * }>({
 *     Dog: [ Animal.Dog, "Canidae"],
 *     Cat: [ Animal.Cat, "Felidae"],
 *     Butterfly: [ Animal.Butterfly, "Papilionidae"],
 *     Bear: [ Animal.Bear, "Ursidae"]
 * });
 *
 * // You also end up with a strongly types result for each value
 * animalMap.Dog === "Canidae";     // true with typeof animalMap.Dog is (const) "Canidae"
 * animalMap[0] === "Canidae";      // true with typeof animalMap[0] is "Canidae"
 * animalMap["Dog"] === "Canidae";  // true with typeof animalMap["Dog"] is "Canidae"
 * animalMap.Cat === "Felidae";     // true with typeof animalMap.Cat is "Felidae"
 * animalMap[1] === "Felidae";      // true with typeof animalMap[1] is "Felidae"
 * animalMap["Cat"] === "Felidae";  // true with typeof animalMap["Cat"] is "Felidae"
 * ```
 * @param values - The values to populate on the new object
 * @typeParam E - Identifies the enum type
 * @typeParam T - Identifies the return type that is being created via the mapping.
 * @returns A new frozen (immutable) object which contains a property for each key and value that returns the defined mapped value.
 */
function createTypeMap(values) {
    return createSimpleMap(values);
}

/*
 * @nevware21/ts-utils
 * https://github.com/nevware21/ts-utils
 *
 * Copyright (c) 2022 Nevware21
 * Licensed under the MIT license.
 */
/**
 * @ignore
 * @internal
 */
var _wellKnownSymbolMap = createEnumKeyMap({
    asyncIterator: 0 /* WellKnownSymbols.asyncIterator */,
    hasInstance: 1 /* WellKnownSymbols.hasInstance */,
    isConcatSpreadable: 2 /* WellKnownSymbols.isConcatSpreadable */,
    iterator: 3 /* WellKnownSymbols.iterator */,
    match: 4 /* WellKnownSymbols.match */,
    matchAll: 5 /* WellKnownSymbols.matchAll */,
    replace: 6 /* WellKnownSymbols.replace */,
    search: 7 /* WellKnownSymbols.search */,
    species: 8 /* WellKnownSymbols.species */,
    split: 9 /* WellKnownSymbols.split */,
    toPrimitive: 10 /* WellKnownSymbols.toPrimitive */,
    toStringTag: 11 /* WellKnownSymbols.toStringTag */,
    unscopables: 12 /* WellKnownSymbols.unscopables */
});

/*
 * @nevware21/ts-utils
 * https://github.com/nevware21/ts-utils
 *
 * Copyright (c) 2022 Nevware21
 * Licensed under the MIT license.
 */
/**
 * The asString() method returns a string representing the value by
 * explicitly using `String(`value`)`.
 *
 * @since 0.4.3
 * @group String
 * @group Conversion
 * @group Value
 * @param value - The value to get a string representation of
 * @example
 * ```ts
 * const arr = [ 1, 2, 3];
 * asString(arr);       // "1,2,3"
 * asString(null);      // "null"
 * asString(undefined); // "undefined"
 * asString(42);        // "42"
 * asString(Symbol.for("Hello"));   // "Symbol(Hello)"
 * ```
 */
var asString = StrCls;

/*
 * @nevware21/ts-utils
 * https://github.com/nevware21/ts-utils
 *
 * Copyright (c) 2022 Nevware21
 * Licensed under the MIT license.
 */
var GLOBAL_CONFIG_KEY = "__tsUtils$gblCfg";
var _globalCfg;
/**
 * @internal
 * @ignore
 * Helper to get the current global value
 * @returns
 */
function _getGlobalValue() {
    var result;
    if (typeof globalThis !== UNDEFINED) {
        result = globalThis;
    }
    if (!result && typeof self !== UNDEFINED) {
        result = self;
    }
    if (!result && typeof window !== UNDEFINED) {
        result = window;
    }
    if (!result && typeof global !== UNDEFINED) {
        result = global;
    }
    return result;
}
/**
 * @internal
 * @ignore
 * Gets/Sets the named value from the global config store, this is used to share configuration across
 * multiple modules. Primarily used for poly symbol and test hooks.
 * @returns The globally registered value.
 */
function _getGlobalConfig() {
    if (!_globalCfg) {
        var gbl = _getGlobalValue() || {};
        _globalCfg = gbl[GLOBAL_CONFIG_KEY] = gbl[GLOBAL_CONFIG_KEY] || {};
    }
    return _globalCfg;
}

/*
 * @nevware21/ts-utils
 * https://github.com/nevware21/ts-utils
 *
 * Copyright (c) 2022 Nevware21
 * Licensed under the MIT license.
 */
/**
 * Returns string representation of an object suitable for diagnostics logging.
 * @group Error
 * @group Diagnostic
 * @param object - The object to be converted to a diagnostic string value
 * @param format - Identifies whether the JSON value should be formated
 * - `true` - Format with 4 spaces
 * - 'number' - The number of spaces to format with
 * - `false` (or not Truthy) - Do not format
 */
function dumpObj(object, format) {
    var propertyValueDump = EMPTY;
    if (isError(object)) {
        propertyValueDump = "{ stack: '" + object.stack + "', message: '" + object.message + "', name: '" + object.name + "'";
    }
    else {
        try {
            propertyValueDump = JSON.stringify(object, NULL_VALUE, format ? (isNumber(format) ? format : 4) : UNDEF_VALUE);
        }
        catch (e) {
            // Unable to convert object (probably circular)
            propertyValueDump = " - " + dumpObj(e, format);
        }
    }
    return objToString(object) + ": " + propertyValueDump;
}

/*
 * @nevware21/ts-utils
 * https://github.com/nevware21/ts-utils
 *
 * Copyright (c) 2022 Nevware21
 * Licensed under the MIT license.
 */
var _arrSlice = ArrProto[SLICE];
var _throwMissingFunction = function (funcName, thisArg) {
    throwTypeError("'" + asString(funcName) + "' not defined for " + dumpObj(thisArg));
};
/**
 * @internal
 * @ignore
 * Internal helper to run the named function on the passed first argument, this does not support polyfill
 * or prototype fallback, so the function must exist on the provided first argument.
 * If the first argument is null, undefined or the function does not exist an exception will be thrown
 * by the runtime
 * @param funcName - The function name to call on the first argument passed to the wrapped function
 * @returns A function which will call the funcName against the first passed argument and pass on the remaining arguments
 */
var _unwrapInstFunction = function (funcName) {
    return function (thisArg) {
        return thisArg[funcName].apply(thisArg, _arrSlice.call(arguments, 1));
    };
};
/**
 * @internal
 * @ignore
 * Internal helper to convert an expanded function back into an instance `this` function call
 * @param funcName - The function name to call on the first argument passed to the wrapped function
 * @param clsProto - The Class or class prototype to fallback to if the instance doesn't have the function.
 * @returns A function which will call the funcName against the first passed argument and pass on the remaining arguments
 */
var _unwrapFunction = function (funcName, clsProto) {
    var clsFn = clsProto && clsProto[funcName];
    return function (thisArg) {
        var theFunc = (thisArg && thisArg[funcName]) || clsFn;
        if (theFunc) {
            return theFunc.apply(thisArg, _arrSlice.call(arguments, 1));
        }
        _throwMissingFunction(funcName, thisArg);
    };
};
/**
 * @internal
 * @ignore
 * Internal helper to convert an expanded function back into an instance `this` function call
 * @param funcName - The function name to call on the first argument passed to the wrapped function
 * @param clsProto - The Class or class prototype to fallback to if the instance doesn't have the function.
 * @param polyFunc - The function to call if not available on the thisArg, act like the polyfill
 * @returns A function which will call the funcName against the first passed argument and pass on the remaining arguments
 */
var _unwrapFunctionWithPoly = function (funcName, clsProto, polyFunc) {
    var clsFn = clsProto && clsProto[funcName];
    return function (thisArg) {
        var theFunc = (thisArg && thisArg[funcName]) || clsFn;
        if (theFunc || polyFunc) {
            var theArgs = arguments;
            return (theFunc || polyFunc).apply(thisArg, theFunc ? _arrSlice.call(theArgs, 1) : theArgs);
        }
        _throwMissingFunction(funcName, thisArg);
    };
};
/**
 * @internal
 * @ignore
 * Internal helper to lookup and return the named property from the first argument (which becomes the this)
 *
 * @since 0.4.2
 * @typeParam T - The type of the object which contains the propName
 * @param propName - The property name
 * @returns The value of the property
 */
function _unwrapProp(propName) {
    return function (thisArg) {
        return thisArg[propName];
    };
}

/*
 * @nevware21/ts-utils
 * https://github.com/nevware21/ts-utils
 *
 * Copyright (c) 2022 Nevware21
 * Licensed under the MIT license.
 */
/**
 * The `mathMax()` function returns the largest of the zero or more numbers given as input
 * parameters, or NaN if any parameter isn't a number and can't be converted into one.
 *
 * If no arguments are given, the result is -Infinity.
 *
 * If at least one of arguments cannot be converted to a number, the result is NaN.
 *
 * @since 0.4.2
 * @group Math
 * @param values - Zero or more numbers among which the largest value will be selected and returned.
 * @returns The largest of the given numbers. If any one or more of the parameters cannot be
 * converted into a number, NaN is returned. The result is -Infinity if no parameters are provided.
 * @example
 * ```ts
 * mathMax(10, 20);   //  20
 * mathMax(-10, -20); // -10
 * mathMax(-10, 20);  //  20
 * ```
 */
var mathMax = MathCls.max;

/*
 * @nevware21/ts-utils
 * https://github.com/nevware21/ts-utils
 *
 * Copyright (c) 2022 Nevware21
 * Licensed under the MIT license.
 */
/**
 * The `strSlice()` method extracts a section of a string and returns it as a new string, without
 * modifying the original string.
 * `strSlice()` extracts the text from one string and returns a new string. Changes to the text in one
 * string do not affect the other string.
 * `strSlice()` extracts up to but not including endIndex. str.slice(1, 4) extracts the second character
 * through the fourth character (characters indexed 1, 2, and 3).
 * As an example, strSlice(2, -1) extracts the third character through the second to last character
 * in the string.
 * @group String
 * @param value - The value to haveextract a number
 * @param beginIndex - The zero-based index at which to begin extraction.
 * If `beginIndex` is negative, `strSlice()` begins extraction from `value.length + beginIndex`.
 * (E.g. `strSlice("test", -2)` returns "st")
 * If `beginIndex` is omitted, undefined, or cannot be converted to a number (using Number(`beginIndex`)),
 * strSlice() begins extraction from the beginning of the string. (E.g. `strSlice("test")` returns "test")
 * If `beginIndex` is greater than or equal to `value.length`, an empty string is returned.
 * (E.g. `strSlice("test", 4)` returns "")
 * @param endIndex - The index of the first character to exclude from the returned substring.
 * If `endIndex` is omitted, undefined, or cannot be converted to a number (using Number(`endIndex`))
 * strSlice() extracts to the end of the string. (E.g. `strSlice("test", 2)` returns "st")
 * If `endIndex` is greater than `value.length`, strSlice() also extracts to the end of the string.
 * (E.g. strSlice("test", 2, 10)` returns "st")
 * If `endIndex` is negative, `strSlice()` treats it as `value.length + endIndex`. (E.g, if `endIndex`
 * is -2, it is treated as `value.length - 2` and `strSlice("test", 1, -2)` returns "e") .
 * If `endIndex` represents a position that is before the one represented by startIndex, `strSlice()`
 * returns "". (E.g `strSlice("test", 2, -10)`, strSlice("test", -1, -2)` or `strSlice("test", 3, 2)`).
 * @returns A new string containing the extracted section of the string.
 */
var strSlice = _unwrapFunction(SLICE, StrProto);

/*
 * @nevware21/ts-utils
 * https://github.com/nevware21/ts-utils
 *
 * Copyright (c) 2022 Nevware21
 * Licensed under the MIT license.
 */
/**
 * The `strSubstring()` method returns the part of the string between the start and end indexes, or to the end of the string.
 *
 * `strSubstring()` extracts characters from indexStart up to but not including indexEnd. In particular:
 * - If `indexEnd` is omitted, strSubstring() extracts characters to the end of the string.
 * - If `indexStart` is equal to indexEnd, strSubstring() returns an empty string.
 * - If `indexStart` is greater than indexEnd, then the effect of strSubstring() is as if the two arguments were swapped; see example below.
 *
 * Any argument value that is less than 0 or greater than `value.length` is treated as if it were 0 and `value.length`, respectively.
 *
 * Any argument value that is NaN is treated as if it were 0.
 * @group String
 * @param value - The string value to return the substring from.
 * @param indexStart - The index of the first character to include in the returned substring.
 * @param indexEnd - The index of the first character to exclude from the returned substring.
 * @return A new string containing the specified part of the given string
 * @example
 * ```ts
 * const anyString = 'Nevware21';
 * // Displays 'N'
 * console.log(strSubstring(anyString, 0, 1));
 * console.log(strSubstring(anyString, 1, 0));
 *
 * // Displays 'Nevwar'
 * console.log(strSubstring(anyString, 0, 6));
 *
 * // Displays 'are21'
 * console.log(strSubstring(anyString, 4));
 *
 * // Displays 'are'
 * console.log(strSubstring(anyString, 4, 7));
 *
 * // Displays '21'
 * console.log(strSubstring(anyString, 7, 4));
 *
 * // Displays 'Nevware'
 * console.log(strSubstring(anyString, 0, 7));
 *
 * // Displays 'Nevware21'
 * console.log(strSubstring(anyString, 0, 10));
 * ```
 */
var strSubstring = _unwrapFunction("substring", StrProto);
/**
 * The strSubstr() method returns a portion of the string, starting at the specified index and extending for a given
 * number of characters afterwards.
 *
 * @since 0.4.2
 * @group String
 * @param value - The string value to return the substring from.
 * @param start - The index of the first character to include in the returned substring.
 * @param length - The number of characters to extract.
 * @returns A new string containing the specified part of the given string.
 */
var strSubstr = _unwrapFunctionWithPoly("substr", StrProto, polyStrSubstr);
/**
 * The polyStrSubstr() method returns a portion of the string, starting at the specified index and extending for a given
 * number of characters afterwards.
 *
 * @since 0.4.2
 * @group String
 * @group Polyfill
 * @param value - The string value to return the substring from.
 * @param start - The index of the first character to include in the returned substring.
 * @param length - The number of characters to extract.
 * @returns A new string containing the specified part of the given string.
 */
function polyStrSubstr(value, start, length) {
    if (isNullOrUndefined(value)) {
        throwTypeError("'polyStrSubstr called with invalid " + dumpObj(value));
    }
    if (length < 0) {
        return EMPTY;
    }
    // If start is omitted or undefined, its treated as zero
    start = start || 0;
    if (start < 0) {
        start = mathMax(start + value[LENGTH], 0);
    }
    if (isUndefined(length)) {
        return strSlice(value, start);
    }
    return strSlice(value, start, start + length);
}
/**
 * Returns a substring of the string starting from the left.
 *
 * `strLeft()` extracts the number of characters from left of the string up to the count. In particular:
 * - If `count` is less than zero, strLeft() returns an empty string.
 * - If `count` is less than `value.length', strLeft() returns a new string with the `count` number of characters from the left of the string.
 * - If `count` is greater than `value.length`, then the value original value is returned.
 *
 * Any argument value that is NaN is treated as if it were 0.
 *
 * @since 0.4.2
 * @group String
 * @param value - The string value to return the substring from.
 * @param count - The number of characters to extract
 * @returns The substring based on the count number of characters from the right
 * @example
 * ```ts
 * strLeft("Nevware21", -1); // ""
 * strLeft("Nevware21", 0); // ""
 * strLeft("Nevware21", 1); // "N"
 * strLeft("Nevware21", 3); // "Nev"
 * strLeft("Nevware21", 21); // "Nevware21"
 * ```
 */
function strLeft(value, count) {
    return strSubstring(value, 0, count);
}

/*
 * @nevware21/ts-utils
 * https://github.com/nevware21/ts-utils
 *
 * Copyright (c) 2022 Nevware21
 * Licensed under the MIT license.
 */
var UNIQUE_REGISTRY_ID = "_urid";
var _polySymbols;
function _globalSymbolRegistry() {
    if (!_polySymbols) {
        var gblCfg = _getGlobalConfig();
        _polySymbols = gblCfg.gblSym = gblCfg.gblSym || { k: {}, s: {} };
    }
    return _polySymbols;
}
var _wellKnownSymbolCache = {};
/**
 * Returns a new (polyfill) Symbol object for the provided description that's guaranteed to be unique.
 * Symbols are often used to add unique property keys to an object that won't collide with keys any
 * other code might add to the object, and which are hidden from any mechanisms other code will
 * typically use to access the object. That enables a form of weak encapsulation, or a weak form of
 * information hiding.
 * @group Polyfill
 * @group Symbol
 * @param description - The description of the symbol
 * @returns A new polyfill version of a Symbol object
 */
function polyNewSymbol(description) {
    var theSymbol = {
        description: asString(description),
        toString: function () { return SYMBOL + "(" + description + ")"; }
    };
    // Tag the symbol so we know it a polyfill
    theSymbol[POLYFILL_TAG] = true;
    return theSymbol;
}
/**
 * Returns a Symbol object from the global symbol registry matching the given key if found.
 * Otherwise, returns a new symbol with this key.
 * @group Polyfill
 * @group Symbol
 * @param key key to search for.
 */
function polySymbolFor(key) {
    var registry = _globalSymbolRegistry();
    if (!objHasOwn(registry.k, key)) {
        var newSymbol_1 = polyNewSymbol(key);
        var regId_1 = objKeys(registry.s).length;
        newSymbol_1[UNIQUE_REGISTRY_ID] = function () { return regId_1 + "_" + newSymbol_1.toString(); };
        registry.k[key] = newSymbol_1;
        registry.s[newSymbol_1[UNIQUE_REGISTRY_ID]()] = asString(key);
    }
    return registry.k[key];
}
/**
 * Returns the polyfill version of a well-known global symbol, this will only return
 * known values.
 * @example
 * ```ts
 * // Always returns the polyfill version, even if Symbols are supported in the runtime
 * polyGetKnownSymbol("toStringTag") === polyGetKnownSymbol("toStringTag");                // true
 * polyGetKnownSymbol(WellKnownSymbols.toStringTag) === polyGetKnownSymbol("toStringTag"); // true
 * polyGetKnownSymbol("toStringTag") !== Symbol.toStringTag;                // true
 * polyGetKnownSymbol(WellKnownSymbols.toStringTag) !== Symbol.toStringTag; // true
 * polyGetKnownSymbol("toStringTag") !== polySymbolFor("toStringTag");      // true
 * polyGetKnownSymbol(WellKnownSymbols.toStringTag) !== polySymbolFor("toStringTag"); // true
 * polyGetKnownSymbol("toStringTag") !== polyNewSymbol("toStringTag");      // true
 * polyGetKnownSymbol(WellKnownSymbols.toStringTag) !== polyNewSymbol("toStringTag"); // true
 * ```
 * @group Polyfill
 * @group Symbol
 * @param name - The property name to return (if it exists) for Symbol
 * @returns The value of the property if present
 */
function polyGetKnownSymbol(name) {
    var result;
    var knownName = _wellKnownSymbolMap[name];
    if (knownName) {
        result = _wellKnownSymbolCache[knownName] = _wellKnownSymbolCache[knownName] || polyNewSymbol(SYMBOL + "." + knownName);
    }
    return result;
}

/*
 * @nevware21/ts-utils
 * https://github.com/nevware21/ts-utils
 *
 * Copyright (c) 2022 Nevware21
 * Licensed under the MIT license.
 */
/**
 * @internal
 * @ignore
 * Mapping from ObjDefinePropDescriptor key to PropertyDescriptor key
 */
var propMap = {
    e: "enumerable",
    c: "configurable",
    v: VALUE,
    w: "writable",
    g: "get",
    s: "set"
};
/**
 * @internal
 * @ignore
 * Helper to convert ObjDefinePropDescriptor into PropertyDescriptor
 * @param value - The prop descriptor to convert
 * @returns
 */
function _createProp(value) {
    var prop = {};
    prop[propMap["c"]] = true;
    prop[propMap["e"]] = true;
    if (value.l) {
        // Asign a getter function to return the value when requested
        prop.get = function () { return value.l.v; };
        // If it has a setter then expose it as well
        var desc = objGetOwnPropertyDescriptor(value.l, "v");
        if (desc && desc.set) {
            prop.set = function (newValue) {
                value.l.v = newValue;
            };
        }
    }
    objForEachKey(value, function (key, value) {
        prop[propMap[key]] = isUndefined(value) ? prop[propMap[key]] : value;
    });
    return prop;
}
/**
 * Defines a new property directly on an object, or modifies an existing property on an object, and returns the object.
 * This is a wrapper for [Object.defineProperty](https://developer.mozilla.org/en-US/docs/web/javascript/reference/global_objects/object/defineproperty)
 *
 * This method allows a precise addition to or modification of a property on an object. Normal property addition through
 * assignment creates properties which show up during property enumeration (for...in loop or objKeys method), whose
 * values may be changed, and which may be deleted. This method allows these extra details to be changed from their
 * defaults. By default, properties added using objDefineProp() are not writable, not enumerable, and not configurable.
 *
 * Property descriptors present in objects come in two main flavors: data descriptors and accessor descriptors. A data
 * descriptor is a property that has a value, which may or may not be writable. An accessor descriptor is a property
 * described by a getter-setter pair of functions. A descriptor must be one of these two flavors; it cannot be both.
 *
 * This is an alias for Object.defineProperty
 * @group Object
 * @param target - The object on which to define the property.
 * @param key - The name or Symbol of the property to be defined or modified.
 * @param descriptor - The descriptor for the property being defined or modified.
 */
var objDefineProp = ObjClass$1["defineProperty"];
/**
 * The objDefine() method defines a new or modifies an existing single property accessors for the target object based
 * on the configuration defined for the propDesc argument of type {@link ObjDefinePropDescriptor}. This will call
 * {@link objDefineProp} after creating the required PropertyDescriptor populating defaults for the propDesc values.
 * Note, the default values (true) for `configurable` and `enumerable` are different from the defaults provided by objDefineProp.
 * @since 0.6.0
 * @group Object
 * @param target - The object on which to define the property.
 * @param key - The name of the property to be defined or modified
 * @param propDesc - An object which defines the Property Descriptor mappings for the mapping.
 * @returns The target object.
 */
function objDefine(target, key, propDesc) {
    return objDefineProp(target, key, _createProp(propDesc));
}

/*
 * @nevware21/ts-utils
 * https://github.com/nevware21/ts-utils
 *
 * Copyright (c) 2022 Nevware21
 * Licensed under the MIT license.
 */
/**
 * @internal
 * Internal flag which is set by the public {@link setBypassLazyCache}, should not be externally exported
 */
var _globalLazyTestHooks;
var _fetchLazyTestHooks = function () {
    _globalLazyTestHooks = _getGlobalConfig();
    _fetchLazyTestHooks = NULL_VALUE;
};
/**
 * Create and return an readonly {@link ILazyValue} instance which will cache and return the value returned
 * by the callback function. The callback function will only be called once, multiple access of the value
 * does not cause re-execution of the callback as the result from the first call is cached internally.
 * @since 0.4.5
 * @group Lazy
 * @param cb - The callback function to fetch the value to be lazily evaluated and cached
 * @returns A new readonly {@link ILazyValue} instance which wraps the callback and will be used to cache
 * the result of the callback
 * @example
 * ```ts
 * // This does not cause the evaluation to occur
 * let cachedValue = getLazy(() => callSomeExpensiveFunction());
 * let theValue;
 *
 * // Just checking if there is an object still does not cause the evaluation
 * if (cachedValue) {
 *     // This will cause the evaluation to occur and the result will be cached
 *     theValue = cachedValue.v;
 * }
 *
 * // Accessing the value again will not cause the re-evaluation to occur, it will just return the same
 * // result value again.
 * theValue === cachedValue.v;  // true
 *
 * ```
 */
function getLazy(cb) {
    var lazyValue = {};
    _fetchLazyTestHooks && _fetchLazyTestHooks();
    lazyValue.b = _globalLazyTestHooks.lzy;
    objDefineProp(lazyValue, "v", {
        configurable: true,
        get: function () {
            var result = cb();
            if (!_globalLazyTestHooks.lzy) {
                // Just replace the value
                objDefineProp(lazyValue, "v", {
                    value: result
                });
                if (lazyValue.b) {
                    delete lazyValue.b;
                }
            }
            if (_globalLazyTestHooks.lzy && lazyValue.b !== _globalLazyTestHooks.lzy) {
                lazyValue.b = _globalLazyTestHooks.lzy;
            }
            return result;
        }
    });
    return lazyValue;
}

/*
 * @nevware21/ts-utils
 * https://github.com/nevware21/ts-utils
 *
 * Copyright (c) 2022 Nevware21
 * Licensed under the MIT license.
 */
/**
 * Create and return an readonly {@link ILazyValue} instance which will cache and return the value returned
 * by the callback function. The callback function will only be called once, multiple access of the value
 * does not cause re-execution of the callback as the result from the first call is cached internally.
 * If the callback throws the default value will be returned.
 * @since 0.9.5
 * @group Lazy
 * @group Safe
 * @param cb - The callback function to fetch the value to be lazily evaluated and cached
 * @param defValue - The default value to return when an exception is thrown
 * @returns A new readonly {@link ILazyValue} instance which wraps the callback and will be used to cache
 * the result of the callback
 * @example
 * ```ts
 * // This does not cause the evaluation to occur
 * let cachedValue = safeGetLazy(() => callSomeExpensiveFunctionWhichMightThrow(), "someDefaultValue");
 * let theValue;
 *
 * // Just checking if there is an object still does not cause the evaluation
 * if (cachedValue) {
 *     // This will cause the evaluation to occur and the result will be cached
 *     theValue = cachedValue.v;
 * }
 *
 * // Accessing the value again will not cause the re-evaluation to occur, it will just return the same
 * // result value again.
 * theValue === cachedValue.v;  // true
 *
 * ```
 */
function safeGetLazy(cb, defValue) {
    return getLazy(function () { return safeGet(cb, defValue); });
}

/*
 * @nevware21/ts-utils
 * https://github.com/nevware21/ts-utils
 *
 * Copyright (c) 2022 Nevware21
 * Licensed under the MIT license.
 */
var WINDOW = "window";
var _cachedGlobal;
var _cachedWindow;
var _cachedDocument;
var _cachedNavigator;
var _cachedHistory;
var _isWebWorker;
var _isNode;
/**
 * Create and return an readonly {@link ILazyValue} instance which will cache and return the named global
 * value if available, will return `null` if the named global object is not available or if the runtime
 * throws an exception when attempting to access the global object.
 * Unlike {@link getInst} the value is cached after the first access, so if the global value changes after
 * the initial fetch the original cached value is still returned.
 * @since 0.9.5
 * @group Environment
 * @group Lazy
 * @group Safe
 * @param name The name of the global object to get.
 * @returns A new readonly {@link ILazyValue} instance which will lazily attempt to return the globally
 * available named instance.
 * @example
 * ```ts
 * // This does not cause the evaluation to occur
 * window.myGlobal = "Hello";
 * let cachedValue = lazySafeGetInst("myGlobal");
 * // cachedValue.v === "Hello"
 *
 * window.myGlobal = "Darkness";
 * // cachedValue.v === "Hello"
 *
 * let promiseCls = lazySafeGetInst("Promise");
 * // null if Promise is not supported in the runtime
 * // otherwise the Promise class.
 * ```
 */
var lazySafeGetInst = function (name) { return safeGetLazy(function () { return getInst(name) || UNDEF_VALUE; }, UNDEF_VALUE); };
/**
 * Returns the current global scope object, for a normal web page this will be the current
 * window, for a Web Worker this will be current worker global scope via "self". The internal
 * implementation returns the first available instance object in the following order
 * - globalThis (New standard)
 * - self (Will return the current window instance for supported browsers)
 * - window (fallback for older browser implementations)
 * - global (NodeJS standard)
 * - <null> (When all else fails)
 * While the return type is a Window for the normal case, not all environments will support all
 * of the properties or functions. And this caches the lookup of the global as in some environments
 * this can be an expensive operation.
 * @group Environment
 * @param useCached - [Optional] used for testing to bypass the cached lookup, when `true` this will
 * cause the cached global to be reset.
 */
var getGlobal = function (useCached) {
    (!_cachedGlobal || useCached === false || (_globalLazyTestHooks && _globalLazyTestHooks.lzy && !_cachedGlobal.b)) && (_cachedGlobal = safeGetLazy(_getGlobalValue, NULL_VALUE));
    return _cachedGlobal.v;
};
/**
 * Return the named global object if available, will return null if the object is not available.
 * @group Environment
 * @param name The globally named object
 * @param useCached - [Optional] used for testing to bypass the cached lookup, when `true` this will
 * cause the cached global to be reset.
 * @example
 * ```ts
 * // This does not cause the evaluation to occur
 * window.myGlobal = "Hello";
 * let cachedValue = getInst("myGlobal");
 * // cachedValue === "Hello"
 *
 * window.myGlobal = "Darkness";
 * // getInst("myGlobal") === "Darkness"
 *
 * let promiseCls = getInst("Promise");
 * // May throw if the global is not supported by the runtime
 * // otherwise the Promise class.
 * ```
 */
var getInst = function (name, useCached) {
    var gbl = (!_cachedGlobal || useCached === false) ? getGlobal(useCached) : _cachedGlobal.v;
    if (gbl && gbl[name]) {
        return gbl[name];
    }
    // Test workaround, for environments where <global>.window (when global == window) doesn't return the base window
    if (name === WINDOW && _cachedWindow) {
        // tslint:disable-next-line: no-angle-bracket-type-assertion
        return _cachedWindow.v;
    }
    return NULL_VALUE;
};
/**
 * Identify whether the runtime contains a `document` object
 * @group Environment
 * @returns - True if a `document` exists
 */
var hasDocument = function () { return !!getDocument(); };
/**
 * Return the global `document` instance.
 * @group Environment
 * @returns
 */
var getDocument = function () {
    (!_cachedDocument || (_globalLazyTestHooks && _globalLazyTestHooks.lzy && !_cachedDocument.b)) && (_cachedDocument = lazySafeGetInst("document"));
    return _cachedDocument.v;
};
/**
 * Identify whether the runtime contains a `window` object
 * @group Environment
 * @returns
 */
var hasWindow = function () { return !!getWindow(); };
/**
 * Return the global `window` instance.
 * @group Environment
 * @returns
 */
var getWindow = function () {
    (!_cachedWindow || (_globalLazyTestHooks && _globalLazyTestHooks.lzy && !_cachedWindow.b)) && (_cachedWindow = lazySafeGetInst(WINDOW));
    return _cachedWindow.v;
};
/**
 * Identify whether the runtimne contains a `navigator` object
 * @group Environment
 * @returns
 */
var hasNavigator = function () { return !!getNavigator(); };
/**
 * Returns the global `navigator` instance
 * @group Environment
 * @returns
 */
var getNavigator = function () {
    (!_cachedNavigator || (_globalLazyTestHooks && _globalLazyTestHooks.lzy && !_cachedNavigator.b)) && (_cachedNavigator = lazySafeGetInst("navigator"));
    return _cachedNavigator.v;
};
/**
 * Identifies whether the runtime contains a `history` object
 * @group Environment
 * @returns
 */
var hasHistory = function () { return !!getHistory(); };
/**
 * Returns the global `history` instance
 * @group Environment
 * @returns
 */
var getHistory = function () {
    (!_cachedHistory || (_globalLazyTestHooks && _globalLazyTestHooks.lzy && !_cachedHistory.b)) && (_cachedHistory = lazySafeGetInst("history"));
    return _cachedHistory.v;
};
/**
 * Simple method to determine if we are running in a node environment
 * @group Environment
 * @returns True if you are
 */
var isNode = function () {
    !_isNode && (_isNode = safeGetLazy(function () { return !!(process && (process.versions || {}).node); }, false));
    return _isNode.v;
};
/**
 * Helper to identify if you are running as a Dedicated, Shared or Service worker
 * @group Environment
 * @returns True if the environment you are in looks like a Web Worker
 */
var isWebWorker = function () {
    !_isWebWorker && (_isWebWorker = safeGetLazy(function () { return !!(self && self instanceof WorkerGlobalScope); }, false));
    return _isWebWorker.v;
};

/*
 * @nevware21/ts-utils
 * https://github.com/nevware21/ts-utils
 *
 * Copyright (c) 2022 Nevware21
 * Licensed under the MIT license.
 */
var _symbol;
var _symbolFor;
var _symbolKeyFor;
function _getSymbolValue(name) {
    return safeGetLazy(function () {
        return (_symbol.v ? _symbol.v[name] : UNDEF_VALUE);
    }, UNDEF_VALUE);
}
/**
 * Helper to identify whether the runtime support the Symbols either via native or an installed polyfill
 * @group Symbol
 * @returns true if Symbol's are support otherwise false
 */
function hasSymbol() {
    return !!getSymbol();
}
/**
 * If Symbols are supported then attempt to return the named Symbol
 * @group Symbol
 * @returns The value of the named Symbol (if available)
 */
function getSymbol() {
    var resetCache = !_symbol || (_globalLazyTestHooks && _globalLazyTestHooks.lzy && !_symbol.b);
    resetCache && (_symbol = lazySafeGetInst(SYMBOL));
    (!_symbolFor || resetCache) && (_symbolFor = _getSymbolValue("for"));
    (!_symbolKeyFor || resetCache) && (_symbolKeyFor = _getSymbolValue("keyFor"));
    return _symbol.v;
}
/**
 * If Symbols are supported then get the property of the global Symbol, if Symbol's are
 * not supported and noPoly is true it returns null. Used to access the well known symbols.
 * @group Symbol
 * @param name - The property name to return (if it exists) for Symbol
 * @param noPoly - Flag indicating whether to return a polyfill if symbols are not supported.
 * @returns The value of the property if present
 * @example
 * ```ts
 * // If Symbol is supported in the runtime
 * getKnownSymbol("toStringTag") === Symbol.toStringTag;                // true
 * getKnownSymbol(WellKnownSymbols.toStringTag) === Symbol.toStringTag; // true
 * ```
 */
function getKnownSymbol(name, noPoly) {
    var knownName = _wellKnownSymbolMap[name];
    // Cause lazy symbol to get initialized
    (!_symbol || (_globalLazyTestHooks.lzy && !_symbol.b)) && getSymbol();
    return _symbol.v ? _symbol.v[knownName || name] : (!noPoly ? polyGetKnownSymbol(name) : UNDEF_VALUE);
}
/**
 * Returns a new unique Symbol value. If noPoly is true and symbols are not supported
 * then this will return null.
 * @group Symbol
 * @param description Description of the new Symbol object.
 * @param noPoly - Flag indicating whether to return a polyfil if symbols are not supported.
 * @returns The new symbol
 */
function newSymbol(description, noPoly) {
    // Cause lazy _symbol to get initialized
    (!_symbol || (_globalLazyTestHooks.lzy && !_symbol.b)) && getSymbol();
    return _symbol.v ? _symbol.v(description) : (!noPoly ? polyNewSymbol(description) : NULL_VALUE);
}
/**
 * Returns a Symbol object from the global symbol registry matching the given key if found.
 * Otherwise, returns a new symbol with this key. This will always return a polyfill if symbols
 * are not supported.
 * @group Symbol
 * @param key key to search for.
 */
function symbolFor(key) {
    // Cause lazy symbol to get initialized
    (!_symbolFor || (_globalLazyTestHooks.lzy && !_symbol.b)) && getSymbol();
    return (_symbolFor.v || polySymbolFor)(key);
}

/*
 * @nevware21/ts-utils
 * https://github.com/nevware21/ts-utils
 *
 * Copyright (c) 2022 Nevware21
 * Licensed under the MIT license.
 */
/**
 * Checks if the type of value looks like an iterator instance (contains a next function).
 *
 * @since 0.4.0
 * @group Type Identity
 * @group Iterator
 * @typeParam T - Identifies the return type of the iterator defaults to any
 * @param value - The value to be checked
 * @returns {boolean} True if the value is an Iterator, otherwise false
 * @example
 * ```ts
 * isIterator(null);        // false
 * isIterator(undefined);   // false
 * isIterator("null");      // false (Strings are iterable but not iterators)
 * isIterator([]);          // false (Arrays are iterable but not iterators)
 * isIterator({
 *     next: function() { return true }
 * });                      // true, iterators must contain a "next" function
 * ```
 */
function isIterator(value) {
    return !!value && isFunction(value.next);
}
/**
 * Checks if the value looks like it is iterable, contains a [symbol.iterator].
 *
 * @since 0.4.0
 * @group Type Identity
 * @group Iterator
 * @typeParam T - Identifies the return type of the iterator
 * @param value - The value to be checked
 * @returns {boolean} True if the value is an Iterable, otherwise false
 * @example
 * ```ts
 * isIterable(null);        // false
 * isIterable(undefined);   // false
 * isIterable("null");      // true (Strings are iterable)
 * isIterable([]);          // true (Arrays are iterable)
 * ```
 */
function isIterable(value) {
    return !isStrictNullOrUndefined(value) && isFunction(value[getKnownSymbol(3 /* WellKnownSymbols.iterator */)]);
}

/*
 * @nevware21/ts-utils
 * https://github.com/nevware21/ts-utils
 *
 * Copyright (c) 2022 Nevware21
 * Licensed under the MIT license.
 */
var _iterSymbol;
/**
 * Calls the provided `callbackFn` function once for each element in the iterator or iterator returned by
 * the iterable and processed in the same order as returned by the iterator. As with the {@link arrForEach}
 * you CAN stop / break the iteration by returning -1 from the`callbackFn` function.
 *
 * The order of processing is not reset if you add or remove elements to the iterator, the actual behavior
 * will depend on the iterator imeplementation.
 *
 * If the passed `iter` is both an Iterable<T> and Iterator<T> the Iterator<T> interface takes preceedence.
 * @remarks
 * If Symbols are NOT supported then the iterable MUST be using the same polyFill for the well know symbols,
 * if you are targetting a mixed environment you SHOULD either
 * - only use the polyfill Symbol's provided by this library
 * - ensure that you add any symbol polyfills BEFORE these utilities
 * iterForOf expects a `synchronous` function.
 * iterForOf does not wait for promises. Make sure you are aware of the implications while using
 * promises (or async functions) as forEach callback.
 *
 * @since 0.4.2
 * @group Iterator
 * @typeParam T - Identifies the element type of the iterator
 * @param callbackfn A `synchronous` function that accepts up to three arguments. iterForOf calls the
 * callbackfn function one time for each element returned by the iterator.
 * @param thisArg An object to which the this keyword can refer in the callbackfn function. If thisArg is
 * omitted, null or undefined the iterator will be used as the this value.
 * @throws Any exception thrown while processing the iterator
 * @example
 * ```ts
 * const items = {
 *     'item1': 'value1',
 *     'item2': 'value2',
 *     'item3': 'value3
 * };
 * const copyItems = [];
 *
 * iterForOf(items, (item) => {
 *   copyItems.push(item);
 *   // May return -1 to abort the iteration
 * });
 * ```
 */
function iterForOf(iter, callbackfn, thisArg) {
    if (iter) {
        if (!isIterator(iter)) {
            !_iterSymbol && (_iterSymbol = getLazy(function () { return getKnownSymbol(3 /* WellKnownSymbols.iterator */); }));
            iter = iter[_iterSymbol.v] ? iter[_iterSymbol.v]() : null;
        }
        if (isIterator(iter)) {
            var err = void 0;
            var iterResult = void 0;
            try {
                var count = 0;
                while (!(iterResult = iter.next())[DONE]) {
                    if (callbackfn.call(thisArg || iter, iterResult[VALUE], count, iter) === -1) {
                        break;
                    }
                    count++;
                }
            }
            catch (failed) {
                err = { e: failed };
                if (iter.throw) {
                    iterResult = null;
                    iter.throw(err);
                }
            }
            finally {
                try {
                    if (iterResult && !iterResult[DONE]) {
                        iter.return && iter.return(iterResult);
                    }
                }
                finally {
                    if (err) {
                        // eslint-disable-next-line no-unsafe-finally
                        throw err.e;
                    }
                }
            }
        }
    }
}

/*
 * @nevware21/ts-utils
 * https://github.com/nevware21/ts-utils
 *
 * Copyright (c) 2023 Nevware21
 * Licensed under the MIT license.
 */
/**
 * The `fnApply` function calls the specified `fn` function with the given `thisArg` as the `this` value,
 * and the optional `argArray` arguments provided as an array (or an Array-Like Object).
 *
 * Normally, when calling a function, the value of `this` inside the function is the object that the
 * function was accessed on. With `fnApply()`, you can assign an arbitrary value as this when calling an
 * existing function, without first attaching the function to the object as a property. This allows you
 * to use methods of one object as generic utility functions.
 *
 * You can also use any kind of object which is ArrayLike as the second parameter. In practice, this means
 * that it needs to have a length property, and integer ("index") properties in the range (0..length - 1).
 * For example, you could use a NodeList, or a custom object like `{ 'length': 2, '0': 'eat', '1': 'bananas' }`.
 * You can also use `arguments`.
 *
 * @since 0.9.8
 * @group Function
 *
 * @param fn - The function to be called
 * @param thisArg - The value of `this` provided for the call to `fn`. If the function is not in strict mode,
 * `null` and `undefined` will be replaced with the global object, and primitive values will be converted to objects.
 * @param argArray - An array-like object, specifying the arguments with which `fn` should be called, or `null` or
 * `undefined` if no arguments should be provided to the function.
 * @returns The result of calling the function with the specified `this` value and arguments.
 * @example
 * ```ts
 * // min / max number in an array
 * let max = fnApply(Math.max, null, [ 21, 42, 84, 168, 7, 3 ]);
 * // 168
 *
 * let min = fnApply(Math.min, null, [ 21, 42, 84, 168, 7, 3 ]);
 * // 3
 *
 * const module1 = {
 *     prefix: "Hello",
 *     x: 21,
 *     getX() {
 *         return this.x;
 *     },
 *     log(value: string) {
 *         return this.prefix + " " + value + " : " + this.x
 *     }
 * };
 *
 * // The 'this' parameter of 'getX' is bound to 'module'.
 * module1.getX(); // 21
 * module1.log("Darkness"); // Hello Darkness : 21
 *
 * // Create a new function 'boundGetX' with the 'this' parameter bound to 'module'.
 * let module2 = {
 *     prefix: "my",
 *     x: 42
 * };
 *
 * // Call the function of module1 with module2 as it's this
 * fnApply(module1.getX, module2); // 42
 * fnApply(module1.log, module2, [ "friend" ]); // my friend : 42
 * ```
 */
var fnApply = _unwrapInstFunction("apply");

/*
 * @nevware21/ts-utils
 * https://github.com/nevware21/ts-utils
 *
 * Copyright (c) 2022 Nevware21
 * Licensed under the MIT license.
 */
/**
 * Appends the `elms` to the `target` where the elms may be an array, a single object
 * or an iterator object
 * @group Array
 * @group Iterator
 * @example
 * ```ts
 * let theArray = arrAppend([], 1);
 * arrAppend(theArray, [ 2, 3, 4 ]);
 * arrAppend(theArray, [ "a", "b", "c" ]);
 * // theArray is now [ 1, 2, 3, 4, "a", "b", "c" ]
 * ```
 * @param target - The target array
 * @param elms - The item, array of items an iterable or iterator object of items to add to the target
 * @returns The passed in target array
 * @example
 * ```ts
 * // Adding a single value
 * arrAppend([], undefined);            // []
 * arrAppend([], 0);                    // [ 0 ]
 * arrAppend([1], undefined);           // [ 1 ]
 * arrAppend([1], 2);                   // [ 1, 2 ]
 *
 * // Adding an array
 * arrAppend([], [] as number[]);       // []
 * arrAppend([], [0]);                  // [ 0 ]
 * arrAppend([1], []);                  // [ 1 ]
 * arrAppend([1], [2]);                 // [ 1, 2 ]
 *
 * // Adding with an iterator
 * arrAppend([], ([] as number[]).values());    // []
 * arrAppend([], [0].values());         // [ 0 ]
 * arrAppend([1], [].keys());           // [ 1 ]
 * arrAppend([1], [2].values());        // [ 1, 2 ]
 * arrAppend([1], [2].keys());          // [ 1, 0 ] - 0 is from the index from the first element
 * ```
 */
function arrAppend(target, elms) {
    if (!isUndefined(elms) && target) {
        if (isArray(elms)) {
            // This is not just "target.push(elms)" but becomes effectively "target.push(elms[0], elms[1], ...)"
            fnApply(target.push, target, elms);
        }
        else if (isIterator(elms) || isIterable(elms)) {
            iterForOf(elms, function (elm) {
                target.push(elm);
            });
        }
        else {
            target.push(elms);
        }
    }
    return target;
}

/*
 * @nevware21/ts-utils
 * https://github.com/nevware21/ts-utils
 *
 * Copyright (c) 2022 Nevware21
 * Licensed under the MIT license.
 */
/**
 * Calls the provided `callbackFn` function once for each element in an array in ascending index order. It is not invoked for index properties
 * that have been deleted or are uninitialized. And unlike the ES6 forEach() you CAN stop or break the iteration by returning -1 from the
 * `callbackFn` function.
 *
 * The range (number of elements) processed by arrForEach() is set before the first call to the `callbackFn`. Any elements added beyond the range
 * or elements which as assigned to indexes already processed will not be visited by the `callbackFn`.
 * @group Array
 * @group ArrayLike
 * @typeParam T - Identifies the element type of the array
 * @param theArray - The array or array like object of elements to be searched.
 * @param callbackfn A `synchronous` function that accepts up to three arguments. arrForEach calls the callbackfn function one time for each element in the array.
 * @param thisArg An object to which the this keyword can refer in the callbackfn function. If thisArg is omitted, null or undefined
 * the array will be used as the this value.
 * @remarks
 * arrForEach expects a `synchronous` function.
 * arrForEach does not wait for promises. Make sure you are aware of the implications while using promises (or async functions) as forEach callback.
 * @example
 * ```ts
 * const items = ['item1', 'item2', 'item3'];
 * const copyItems = [];
 *
 * // before using for loop
 * for (let i = 0; i < items.length; i++) {
 *   copyItems.push(items[i]);
 * }
 *
 * // before using forEach()
 * items.forEach((item) => {
 *   copyItems.push(item);
 * });
 *
 * // after
 * arrForEach(items, (item) => {
 *   copyItems.push(item);
 *   // May return -1 to abort the iteration
 * });
 *
 * // Also supports input as an array like object
 * const items = { length: 3, 0: 'item1', 1: 'item2', 2: 'item3' };
 * ```
 */
function arrForEach(theArray, callbackfn, thisArg) {
    if (theArray) {
        var len = theArray[LENGTH] >>> 0;
        for (var idx = 0; idx < len; idx++) {
            if (idx in theArray) {
                if (callbackfn.call(thisArg || theArray, theArray[idx], idx, theArray) === -1) {
                    break;
                }
            }
        }
    }
}

/*
 * @nevware21/ts-utils
 * https://github.com/nevware21/ts-utils
 *
 * Copyright (c) 2022 Nevware21
 * Licensed under the MIT license.
 */
/**
 * The arrIndexOf() method returns the first index at which a given element can be found in the array,
 * or -1 if it is not present.
 * `arrIndexOf()` compares searchElement to elements of the Array using strict equality (the same
 * method used by the === or triple-equals operator).
 * @group Array
 * @group ArrayLike
 * @typeParam T - Identifies the type of array elements
 * @param theArray - The array or array like object of elements to be searched.
 * @param searchElement - The element to locate in the array.
 * @param fromIndex - The index to start the search at. If the index is greater than or equal to
 * the array's length, -1 is returned, which means the array will not be searched. If the provided
 * index value is a negative number, it is taken as the offset from the end of the array.
 * Note: if the provided index is negative, the array is still searched from front to back. If the
 * provided index is 0, then the whole array will be searched. Default: 0 (entire array is searched).
 * @return The first index of the element in the array; -1 if not found.
 * @example
 * ```ts
 * const array = [2, 9, 9];
 * arrIndexOf(array, 2);     // 0
 * arrIndexOf(array, 7);     // -1
 * arrIndexOf(array, 9, 2);  // 2
 * arrIndexOf(array, 2, -1); // -1
 * arrIndexOf(array, 2, -3); // 0
 *
 * let indices: number[] = [];
 * const array = ['a', 'b', 'a', 'c', 'a', 'd'];
 * const element = 'a';
 * let idx = arrIndexOf(array, element);
 * while (idx !== -1) {
 *   indices.push(idx);
 *   idx = arrIndexOf(array, element, idx + 1);
 * }
 * console.log(indices);
 * // [0, 2, 4]
 *
 * function updateVegetablesCollection (veggies, veggie) {
 *     if (arrIndexOf(veggies, veggie) === -1) {
 *         veggies.push(veggie);
 *         console.log('New veggies collection is : ' + veggies);
 *     } else {
 *         console.log(veggie + ' already exists in the veggies collection.');
 *     }
 * }
 *
 * let veggies = ['potato', 'tomato', 'chillies', 'green-pepper'];
 *
 * updateVegetablesCollection(veggies, 'spinach');
 * // New veggies collection is : potato,tomato,chillies,green-pepper,spinach
 * updateVegetablesCollection(veggies, 'spinach');
 * // spinach already exists in the veggies collection.
 *
 * // Array Like
 * let arrayLike = {
 *   length: 3,
 *   0: "potato",
 *   1: "tomato",
 *   2: "chillies",
 *   3: "green-pepper"  // Not checked as index is > length
 * };
 *
 * arrIndexOf(arrayLike, "potato"); // 0
 * arrIndexOf(arrayLike, "tomato"); // 1
 * arrIndexOf(arrayLike, "chillies"); 2
 * arrIndexOf(arrayLike, "green-pepper"); // -1
 * ```
 */
var arrIndexOf = _unwrapFunction(INDEX_OF, ArrProto);
/**
 * The arrLastIndexOf() method returns the last index at which a given element can be found in the array,
 * or -1 if it is not present.
 * `arrLastIndexOf()` compares searchElement to elements of the Array using strict equality (the same
 * method used by the === or triple-equals operator). [NaN](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/NaN)
 * values are never compared as equal, so arrLastIndexOf() always returns -1 when searchElement is NaN.
 *
 * The arrLastIndexOf() method skips empty slots in sparse arrays.
 *
 * The arrLastIndexOf() method is generic. It only expects the this value to have a length property and integer-keyed properties.
 *
 * @since 0.8.0
 * @group Array
 * @group ArrayLike
 * @typeParam T - Identifies the type of array elements
 * @param theArray - The array or array like object of elements to be searched.
 * @param searchElement - The element to locate in the array.
 * @param fromIndex - Zero-based index at which to start searching backwards, converted to an integer.
 * - Negative index counts back from the end of the array — if fromIndex < 0, fromIndex + array.length is used.
 * - If fromIndex < -array.length, the array is not searched and -1 is returned. You can think of it conceptually
 * as starting at a nonexistent position before the beginning of the array and going backwards from there. There
 * are no array elements on the way, so searchElement is never found.
 * - If fromIndex >= array.length or fromIndex is omitted, array.length - 1 is used, causing the entire array to
 * be searched. You can think of it conceptually as starting at a nonexistent position beyond the end of the array and going backwards from there. It eventually reaches the real end position of the array, at which point it starts searching backwards through the actual array elements.
 * @return The first index of the element in the array; -1 if not found.
 * @example
 * ```ts
 * const numbers = [2, 5, 9, 2];
 * arrLastIndexOf(numbers, 2); // 3
 * arrLastIndexOf(numbers, 7); // -1
 * arrLastIndexOf(numbers, 2, 3); // 3
 * arrLastIndexOf(numbers, 2, 2); // 0
 * arrLastIndexOf(numbers, 2, -2); // 0
 * arrLastIndexOf(numbers, 2, -1); // 3
 *
 * let indices: number[] = [];
 * const array = ["a", "b", "a", "c", "a", "d"];
 * const element = "a";
 * let idx = arrLastIndexOf(array, element);
 * while (idx !== -1) {
 *   indices.push(idx);
 *   idx = arrLastIndexOf(array, element, idx ? idx - 1 : -(array.length + 1));
 * }
 * console.log(indices);
 * // [4, 2, 0]
 *
 * function updateVegetablesCollection (veggies, veggie) {
 *     if (arrLastIndexOf(veggies, veggie) === -1) {
 *         veggies.push(veggie);
 *         console.log('New veggies collection is : ' + veggies);
 *     } else {
 *         console.log(veggie + ' already exists in the veggies collection.');
 *     }
 * }
 *
 * let veggies = ['potato', 'tomato', 'chillies', 'green-pepper'];
 *
 * updateVegetablesCollection(veggies, 'spinach');
 * // New veggies collection is : potato,tomato,chillies,green-pepper,spinach
 * updateVegetablesCollection(veggies, 'spinach');
 * // spinach already exists in the veggies collection.
 *
 * // Array Like
 * let arrayLike = {
 *   length: 3,
 *   0: "potato",
 *   1: "tomato",
 *   2: "chillies",
 *   3: "green-pepper"  // Not checked as index is > length
 * };
 *
 * arrLastIndexOf(arrayLike, "potato"); // 0
 * arrLastIndexOf(arrayLike, "tomato"); // 1
 * arrLastIndexOf(arrayLike, "chillies"); 2
 * arrLastIndexOf(arrayLike, "green-pepper"); // -1
 * ```
 */
_unwrapFunction(LAST_INDEX_OF, ArrProto);

/*
 * @nevware21/ts-utils
 * https://github.com/nevware21/ts-utils
 *
 * Copyright (c) 2022 Nevware21
 * Licensed under the MIT license.
 */
/**
 * The arrMap() method creates a new array populated with the results of calling a provided function on every
 * element in the calling array.
 *
 * `arrMap` calls a provided callbackFn function once for each element in an array, in order, and constructs
 * a new array from the results. callbackFn is invoked only for indexes of the array which have assigned
 * values (including undefined).
 *
 * It is not called for missing elements of the array; that is:
 * - indexes that have never been set;
 * - indexes which have been deleted.
 *
 * @since 0.3.3
 * @group Array
 * @group ArrayLike
 * @typeParam T - Identifies the type of the array elements
 * @typeParam R - Identifies the type of the elements returned by the callback function, defaults to T.
 * @param theArray - The array or array like object of elements to be searched.
 * @param callbackFn - The function that is called for evetn element of `theArray`.
 * @param thisArg - The value to use as the `this` when executing the `callbackFn`.
 * @example
 * ```ts
 * const numbers = [1, 4, 9];
 * const roots = arrMap(numbers, (num) => Math.sqrt(num));
 *
 * // roots is now     [1, 2, 3]
 * // numbers is still [1, 4, 9]
 *
 * const kvArray = [{ key: 1, value: 10 },
 *                  { key: 2, value: 20 },
 *                  { key: 3, value: 30 }];
 *
 * const reformattedArray = arrMap(kvArray, ({ key, value}) => ({ [key]: value }));
 *
 * // reformattedArray is now [{1: 10}, {2: 20}, {3: 30}],
 *
 * // kvArray is still:
 * // [{key: 1, value: 10},
 * //  {key: 2, value: 20},
 * //  {key: 3, value: 30}]
 *
 * // Also supports Array Like objects with same output
 * const kvArray = {
 *   length: 3,
 *   0: { key: 1, value: 10 },
 *   1: { key: 2, value: 20 },
 *   2: { key: 3, value: 30 }
 * };
 * ```
 */
var arrMap = _unwrapFunction("map", ArrProto);

/*
 * @nevware21/ts-utils
 * https://github.com/nevware21/ts-utils
 *
 * Copyright (c) 2022 Nevware21
 * Licensed under the MIT license.
 */
/**
 * The arrSlice() method returns a shallow copy of a portion of an array into a new array object
 * selected from start to end (end not included) where start and end represent the index of items
 * in that array. The original array will not be modified.
 *
 * The `arrSlice()` method is a copying method. It does not alter this but instead returns a shallow
 * copy that contains some of the same elements as the ones from the original array.
 *
 * The `arrSlice()` method preserves empty slots. If the sliced portion is sparse, the returned arra
 * is sparse as well.
 *
 * The `arrSlice()` method is generic. It only expects the this value to have a length property and
 * integer-keyed properties.
 *
 * For both start and end, a negative index can be used to indicate an offset from the end of the array.
 * For example, -2 refers to the second to last element of the array.
 * @since 0.9.3
 * @group Array
 * @group ArrayLike
 * @param start Zero-based index at which to start extraction, converted to an integer.
 * - Negative index counts back from the end of the array — if start < 0, start + array.length is used.
 * - If start < -array.length or start is omitted, 0 is used.
 * - If start >= array.length, nothing is extracted.
 * @param end Zero-based index at which to end extraction, converted to an integer. slice() extracts
 * up to but not including end.
 * - Negative index counts back from the end of the array — if end < 0, end + array.length is used.
 * - If end < -array.length, 0 is used.
 * - If end >= array.length or end is omitted, array.length is used, causing all elements until the
 * end to be extracted.
 * - If end is positioned before or at start after normalization, nothing is extracted.
 * @example
 * ```ts
 * const lyrics = ["Hello", "Darkness", "my", "old", "friend.", "I've", "come", "to", "talk" ];
 *
 * arrSlice(lyrics);        // [ "Hello", "Darkness", "my", "old", "friend.", "I've", "come", "to", "talk" ]
 * arrSlice(lyrics, 1, 3);  // [ "Darkness", "my" ]
 * arrSlicw(lyrics, 2);     // [ "my", "old", "friend.", "I've", "come", "to", "talk" ]
 * arrSlice(lyrics, 2, 4);  // [ "my", "old" ]
 * arrSlice(lyrics, 1, 5);  // [ "Darkness", "my", "old", "friend." ]
 * arrSlice(lyrics, -2);    // [ "to", "talk" ]
 * arrSlice(lyrics, 2, -1); // [ "my", "old", "friend.", "I've", "come", "to" ]
 * ```
 */
var arrSlice = _unwrapFunction(SLICE, ArrProto);

/*
 * @nevware21/ts-utils
 * https://github.com/nevware21/ts-utils
 *
 * Copyright (c) 2023 Nevware21
 * Licensed under the MIT license.
 */
/**
 * The `fnCall` function calls the function with the given `thisArg` as the `this` value and with
 * al of the `_args` provided as it's `arguments.
 *
 * > This is almost identical to `fnApply`, except that the function arguments are passed to `fnCall`
 * individually as a list, while with `fnApply` that are combined into a single array argument.
 *
 * Normally, when calling a function, the value of `this` inside the function is the object that the
 * function was accessed on. With `fnCall()`, you can pass an arbitrary value as the `this` when calling an
 * existing function, without first attaching the function to the object as a property. This allows you
 * to use methods of one object as generic utility functions.
 *
 * @since 0.9.8
 * @group Function
 *
 * @param fn - The function to be called
 * @param thisArg - The value of `this` provided for the call to `fn`. If the function is not in strict mode,
 * `null` and `undefined` will be replaced with the global object, and primitive values will be converted to objects.
 * @param _args - The zero or more arguments to be passed to the `fn` function.
 * @returns The result of calling the function with the specified `this` value and arguments.
 * @example
 * ```ts
 * // min / max number in an array
 * let max = fnCall(Math.max, null, 21, 42, 84, 168, 7, 3);
 * // 168
 *
 * let min = fnCall(Math.min, null, 21, 42, 84, 168, 7, 3);
 * // 3
 *
 * const module1 = {
 *     prefix: "Hello",
 *     x: 21,
 *     getX() {
 *         return this.x;
 *     },
 *     log(value: string) {
 *         return this.prefix + " " + value + " : " + this.x
 *     }
 * };
 *
 * // The 'this' parameter of 'getX' is bound to 'module'.
 * module1.getX(); // 21
 * module1.log("Darkness"); // Hello Darkness : 21
 *
 * // Create a new function 'boundGetX' with the 'this' parameter bound to 'module'.
 * let module2 = {
 *     prefix: "my",
 *     x: 42
 * };
 *
 * // Call the function of module1 with module2 as it's this
 * fnCall(module1.getX, module2); // 42
 * fnCall(module1.log, module2, "friend"); // my friend : 42
 * ```
 */
var fnCall = _unwrapInstFunction("call");

/*
 * @nevware21/ts-utils
 * https://github.com/nevware21/ts-utils
 *
 * Copyright (c) 2022 Nevware21
 * Licensed under the MIT license.
 */
/**
 * The arrReduce() method executes a user-supplied "reducer" callback function on each element of the array,
 * in order, passing in the return value from the calculation on the preceding element. The final result of
 * running the reducer across all elements of the array is a single value.
 *
 * The first time that the callback is run there is no "return value of the previous calculation". If supplied,
 * an initial value may be used in its place. Otherwise the array element at index 0 is used as the initial
 * value and iteration starts from the next element (index 1 instead of index 0).
 * @group Array
 * @group ArrayLike
 * @typeParam T - Identifies the type of array elements
 * @param theArray - The array or array like object of elements to be searched.
 * @param callbackfn A function that accepts up to four arguments. The reduce method calls the callbackfn function one time for each element in the array.
 * @param initialValue If initialValue is specified, it is used as the initial value to start the accumulation. The first call to the callbackfn function provides this value as an argument instead of an array value.
 * @returns The value that results from running the "reducer" callback function to completion over the entire array.
 * @example
 * ```ts
 * const getMax = (a: number, b: number) => Math.max(a, b);
 *
 * // callback is invoked for each element in the array starting at index 0
 * arrReduce([1, 100], getMax, 50); // 100
 * arrReduce([    50], getMax, 10); // 50
 *
 * // callback is invoked once for element at index 1
 * arrReduce([1, 100], getMax);     // 100
 *
 * // callback is not invoked
 * arrReduce([    50], getMax);     // 50
 * arrReduce([      ], getMax, 1);  // 1
 *
 * arrReduce([      ], getMax);     // throws TypeError
 *
 * // Also supports Array like objects
 * arrReduce({ length: 2, 0: 1, 1: 100 }, getMax, 50); // 100
 * arrReduce({ length: 1, 0: 50 }, getMax, 10); // 50
 *
 * // callback is invoked once for element at index 1
 * arrReduce({ length: 2, 0: 1, 1: 100 }, getMax);     // 100
 *
 * // callback is not invoked
 * arrReduce({ length: 1, 0: 50 }, getMax);     // 50
 * arrReduce({ length: 0 }, getMax, 1);  // 1
  * ```
 */
var arrReduce = _unwrapFunction("reduce", ArrProto);

/*
 * @nevware21/ts-utils
 * https://github.com/nevware21/ts-utils
 *
 * Copyright (c) 2022 Nevware21
 * Licensed under the MIT license.
 */
var _objCreate = ObjClass$1["create"];
/**
 * Creates an object that has the specified prototype, and that optionally contains specified properties. This helper exists to avoid adding a polyfil
 * for older browsers that do not define Object.create eg. ES3 only, IE8 just in case any page checks for presence/absence of the prototype implementation.
 * Note: For consistency this will not use the Object.create implementation if it exists as this would cause a testing requirement to test with and without the implementations
 * @group Object
 * @param obj Object to use as a prototype. May be null
 */
var objCreate = _objCreate || polyObjCreate;
/**
 * Creates an object that has the specified prototype, and that optionally contains specified properties. This helper exists to avoid adding a polyfil
 * for older browsers that do not define Object.create eg. ES3 only, IE8 just in case any page checks for presence/absence of the prototype implementation.
 * Note: For consistency this will not use the Object.create implementation if it exists as this would cause a testing requirement to test with and without the implementations
 * @group Polyfill
 * @group Object
 * @param obj Object to use as a prototype. May be null
 */
function polyObjCreate(obj) {
    if (!obj) {
        return {};
    }
    var type = typeof obj;
    if (type !== OBJECT && type !== FUNCTION) {
        throw new TypeError("Prototype must be an Object or function: " + dumpObj(obj));
    }
    function tempFunc() { }
    tempFunc[PROTOTYPE] = obj;
    return new tempFunc();
}

/*
 * @nevware21/ts-utils
 * https://github.com/nevware21/ts-utils
 *
 * Copyright (c) 2022 Nevware21
 * Licensed under the MIT license.
 */
var _isProtoArray;
/**
 * The objSetPrototypeOf() method sets the prototype (i.e., the internal [Prototype] property) of a specified
 * object to another object or null.
 * @group Object
 * @param obj - The object which is to have it's prototype set.
 * @param proto - The object's new prototype (an object or null)
 * @returns The specified object.
 */
function objSetPrototypeOf(obj, proto) {
    var fn = ObjClass$1["setPrototypeOf"] ||
        // tslint:disable-next-line: only-arrow-functions
        function (d, b) {
            !_isProtoArray && (_isProtoArray = getLazy(function () {
                var _a;
                return ((_a = {}, _a[__PROTO__] = [], _a) instanceof Array);
            }));
            _isProtoArray.v ? d[__PROTO__] = b : objForEachKey(b, function (key, value) { return d[key] = value; });
        };
    return fn(obj, proto);
}

/*
 * @nevware21/ts-utils
 * https://github.com/nevware21/ts-utils
 *
 * Copyright (c) 2022 Nevware21
 * Licensed under the MIT license.
 */
/**
 * @internal
 * @ignore
 */
var _createCustomError = function (name, d, b) {
    _safeDefineName(d, name);
    d = objSetPrototypeOf(d, b);
    function __() {
        this.constructor = d;
        _safeDefineName(this, name);
    }
    d[PROTOTYPE] = b === NULL_VALUE ? objCreate(b) : (__[PROTOTYPE] = b[PROTOTYPE], new __());
    return d;
};
var _safeSetName = function (baseClass, name) {
    try {
        name && (baseClass[NAME] = name);
        //name && (baseClass[PROTOTYPE][NAME] = name);
    }
    catch (e) {
        // Do nothing
    }
};
var _safeDefineName = function (target, name) {
    try {
        objDefine(target, NAME, { v: name, c: true, e: false });
    }
    catch (e) {
        // Do nothing
    }
};
/**
 * Create a Custom Error class which may be used to throw custom errors.
 * @group Error
 * @param name - The name of the Custom Error
 * @param constructCb - [Optional] An optional callback function to call when a
 * new Customer Error instance is being created.
 * @param errorBase - [Optional] (since v0.9.6) The error class to extend for this class, defaults to Error.
 * @returns A new Error `class`
 * @example
 * ```ts
 * import { createCustomError, isError } from "@nevware21/ts-utils";
 *
 * // For an error that just contains a message
 * let myCustomErrorError = createCustomError("MessageError");
 *
 * try {
 *     throw new myCustomErrorError("Error Message!");
 * } catch(e) {
 *      // e.name === MessageError
 *      // isError(e) === true;
 *      // Object.prototype.toString.call(e) === "[object Error]";
 * }
 *
 * // Or a more complex error object
 * interface MyCriticalErrorConstructor extends CustomErrorConstructor {
 *     new(message: string, file: string, line: number, col: number): MyCriticalError;
 *     (message: string, file: string, line: number, col: number): MyCriticalError;
 * }
 *
 * interface MyCriticalError extends Error {
 *     readonly errorId: number;
 *     readonly args: any[];        // Holds all of the arguments passed during construction
 * }
 *
 * let _totalErrors = 0;
 * let myCustomError = createCustomError<MyCriticalErrorConstructor>("CriticalError", (self, args) => {
 *     _totalErrors++;
 *     self.errorId = _totalErrors;
 *     self.args = args;
 * });
 *
 * try {
 *     throw new myCustomError("Not Again!");
 * } catch(e) {
 *      // e.name === CriticalError
 *      // isError(e) === true;
 *      // Object.prototype.toString.call(e) === "[object Error]";
 * }
 *
 * // ----------------------------------------------------------
 * // Extending another custom error class
 * // ----------------------------------------------------------
 *
 * let AppError = createCustomError("ApplicationError");
 * let theAppError = new appError();
 *
 * isError(theAppError);                    // true
 * theAppError instanceof Error;            // true
 * theAppError instanceof AppError;         // true
 *
 * let StartupError = createCustomError("StartupError", null, AppError);
 * let theStartupError = new StartupError();
 *
 * isError(theStartupError);                // true
 * theStartupError instanceof Error;        // true
 * theStartupError instanceof AppError;     // true
 * theStartupError instanceof StartupError; // true
 * ```
 */
function createCustomError(name, constructCb, errorBase) {
    var theBaseClass = errorBase || Error;
    var orgName = theBaseClass[PROTOTYPE][NAME];
    var captureFn = Error.captureStackTrace;
    return _createCustomError(name, function () {
        var _this = this;
        try {
            _safeSetName(theBaseClass, name);
            var _self = fnApply(theBaseClass, _this, arrSlice(arguments)) || _this;
            if (_self !== _this) {
                // Looks like runtime error constructor reset the prototype chain, so restore it
                var orgProto = objGetPrototypeOf(_this);
                if (orgProto !== objGetPrototypeOf(_self)) {
                    objSetPrototypeOf(_self, orgProto);
                }
            }
            // Make sure we only capture our stack details
            captureFn && captureFn(_self, _this[CONSTRUCTOR]);
            // Run the provided construction function
            constructCb && constructCb(_self, arguments);
            return _self;
        }
        finally {
            _safeSetName(theBaseClass, orgName);
        }
    }, theBaseClass);
}
/**
 * @internal
 * @ignore
 */
var _unsupportedError;
/**
 * Throw a custom `UnsupportedError` Error instance with the given message.
 * @group Error
 * @param message - The message to include in the exception
 * @example
 * ```ts
 * import { throwUnsupported } from "@nevware21/ts-utils";
 *
 * if (!window) {
 *     throwUnsupported("A window is needed for this operation");
 * }
 * ```
 */
function throwUnsupported(message) {
    if (!_unsupportedError) {
        // Lazily create the class
        _unsupportedError = createCustomError("UnsupportedError");
    }
    throw new _unsupportedError(message);
}

/*
 * @nevware21/ts-utils
 * https://github.com/nevware21/ts-utils
 *
 * Copyright (c) 2022 Nevware21
 * Licensed under the MIT license.
 */
/**
 * Return the number of milliseconds that have elapsed since January 1, 1970 00:00:00 UTC.
 *
 * To offer protection against timing attacks and fingerprinting, the precision of dateNow()
 * might get rounded depending on browser settings. In Firefox, the privacy.reduceTimerPrecision
 * preference is enabled by default and defaults to 20µs in Firefox 59; in 60 it will be 2ms.
 *
 * @since 0.4.4
 * @group Timer
 *
 * @returns A Number representing the milliseconds elapsed since the UNIX epoch.
 * @example
 * ```ts
 * let now = utcNow();
 * ```
 */
function utcNow() {
    return (Date.now || polyUtcNow)();
}
/**
 * Polyfill fallback to return the number of milliseconds that have elapsed since January 1, 1970 00:00:00 UTC.
 *
 * To offer protection against timing attacks and fingerprinting, the precision of dateNow()
 * might get rounded depending on browser settings. In Firefox, the privacy.reduceTimerPrecision
 * preference is enabled by default and defaults to 20µs in Firefox 59; in 60 it will be 2ms.
 *
 * @since 0.4.4
 * @group Timer
 * @group Polyfill
 *
 * @returns A Number representing the milliseconds elapsed since the UNIX epoch.
  * @example
 * ```ts
 * let now = polyUtcNow();
 * ```
*/
function polyUtcNow() {
    return new Date().getTime();
}

/*
 * @nevware21/ts-utils
 * https://github.com/nevware21/ts-utils
 *
 * Copyright (c) 2022 Nevware21
 * Licensed under the MIT license.
 */
function _createTrimFn(exp) {
    return function _doTrim(value) {
        if (isNullOrUndefined(value)) {
            throwTypeError("strTrim called [" + dumpObj(value) + "]");
        }
        if (value && value.replace) {
            value = value.replace(exp, EMPTY);
        }
        return value;
    };
}
/**
 * The trim() method removes whitespace from both ends of a string and returns a new string,
 * without modifying the original string. Whitespace in this context is all the whitespace
 * characters (space, tab, no-break space, etc.) and all the line terminator characters
 * (LF, CR, etc.).
 * @group Polyfill
 * @group String
 * @param value - The string value to be trimmed.
 * @returns A new string representing str stripped of whitespace from both its beginning and end.
 * If neither the beginning or end of str has any whitespace, a new string is still returned (essentially
 * a copy of str), with no exception being thrown.
 * To return a new string with whitespace trimmed from just one end, use `strTrimStart()` or `strTrimEnd()`.
 */
var polyStrTrim = _createTrimFn(/^\s+|(?=\s)\s+$/g);
/**
 * The `polyStrTrimStart()` method removes whitespace from the beginning of a string.
 * @group Polyfill
 * @group String
 * @param value - The value to be trimmed.
 * @returns A new string representing str stripped of whitespace from its beginning (left side).
 * If the beginning of str has no whitespace, a new string is still returned (essentially a copy of str),
 * with no exception being thrown.
 */
var polyStrTrimStart = _createTrimFn(/^\s+/g);
/**
 * The `polyStrTrimEnd()` method removes whitespace from the end of a string.
 * @group Polyfill
 * @group String
 * @param value - The value to be trimmed.
 * @returns A new string representing str stripped of whitespace from its end (right side).
 * If the end of str has no whitespace, a new string is still returned (essentially a copy of str),
 * with no exception being thrown.
 */
var polyStrTrimEnd = _createTrimFn(/(?=\s)\s+$/g);

/*
 * @nevware21/ts-utils
 * https://github.com/nevware21/ts-utils
 *
 * Copyright (c) 2022 Nevware21
 * Licensed under the MIT license.
 */
/**
 * The trim() method removes whitespace from both ends of a string and returns a new string,
 * without modifying the original string. Whitespace in this context is all the whitespace
 * characters (space, tab, no-break space, etc.) and all the line terminator characters
 * (LF, CR, etc.).
 * @group String
 * @param value - The string value to be trimmed.
 * @returns A new string representing str stripped of whitespace from both its beginning and end.
 * If neither the beginning or end of str has any whitespace, a new string is still returned (essentially
 * a copy of str), with no exception being thrown.
 * To return a new string with whitespace trimmed from just one end, use `strTrimStart()` or `strTrimEnd()`.
 */
var strTrim = _unwrapFunctionWithPoly("trim", StrProto, polyStrTrim);
/**
 * The `strTrimStart()` method removes whitespace from the beginning of a string.
 * @group String
 * @param value - The value to be trimmed.
 * @returns A new string representing str stripped of whitespace from its beginning (left side).
 * If the beginning of str has no whitespace, a new string is still returned (essentially a copy of str),
 * with no exception being thrown.
 */
_unwrapFunctionWithPoly("trimStart", StrProto, polyStrTrimStart);
/**
 * The `strTrimEnd()` method removes whitespace from the end of a string.
 * @group String
 * @param value - The value to be trimmed.
 * @returns A new string representing str stripped of whitespace from its end (right side).
 * If the end of str has no whitespace, a new string is still returned (essentially a copy of str),
 * with no exception being thrown.
 */
_unwrapFunctionWithPoly("trimEnd", StrProto, polyStrTrimEnd);

/*
 * @nevware21/ts-utils
 * https://github.com/nevware21/ts-utils
 *
 * Copyright (c) 2022 Nevware21
 * Licensed under the MIT license.
 */
// Use to cache the result of Object.cont
var _fnToString;
var _objCtrFnString;
var _gblWindow;
/**
 * Checks to see if the past value is a plain object (not a class/array) value.
 * Object are considered to be "plain" if they are created with no prototype `Object.create(null)`
 * or by using the Object global (native) function, all other "objects" ar
 * @since 0.4.4
 * @group Type Identity
 * @group Object
 * @param value - The value to check
 * @returns true if `value` is a normal plain object
 * @example
 * ```ts
 * console.log(isPlainObject({ 0: 'a', 1: 'b', 2: 'c' }));      // true
 * console.log(isPlainObject({ 100: 'a', 2: 'b', 7: 'c' }));    // true
 * console.log(isPlainObject(objCreate(null)));                 // true
 *
 * const myObj = objCreate({}, {
 *   getFoo: {
 *     value() { return this.foo; }
 *   }
 * });
 * myObj.foo = 1;
 * console.log(isPlainObject(myObj));                   // true
 *
 * console.log(isPlainObject(['a', 'b', 'c']));         // false
 * console.log(isPlainObject(new Date()));              // false
 * console.log(isPlainObject(new Error("An Error")));   // false
 * console.log(isPlainObject(null));                    // false
 * console.log(isPlainObject(undefined));               // false
 * console.log(isPlainObject("null"));                  // false
 * console.log(isPlainObject("undefined"));             // false
 * console.log(isPlainObject("1"));                     // false
 * console.log(isPlainObject("aa"));                    // false
 * ```
 */
function isPlainObject(value) {
    if (!value || typeof value !== OBJECT) {
        return false;
    }
    if (!_gblWindow) {
        // Lazily cache the current global window value and default it to "true" (so we bypass this check in the future)
        _gblWindow = hasWindow() ? getWindow() : true;
    }
    var result = false;
    if (value !== _gblWindow) {
        if (!_objCtrFnString) {
            // Lazily caching what the runtime reports as the object function constructor (as a string)
            // Using an current function lookup to find what this runtime calls a "native" function
            _fnToString = Function[PROTOTYPE].toString;
            _objCtrFnString = fnCall(_fnToString, ObjClass$1);
        }
        try {
            var proto = objGetPrototypeOf(value);
            // No prototype so looks like an object created with Object.create(null)
            result = !proto;
            if (!result) {
                if (objHasOwnProperty(proto, CONSTRUCTOR)) {
                    proto = proto[CONSTRUCTOR];
                }
                result = proto && typeof proto === FUNCTION && _fnToString.call(proto) === _objCtrFnString;
            }
        }
        catch (ex) {
            // Something went wrong, so it's not an object we are playing with
        }
    }
    return result;
}

/*
 * @nevware21/ts-utils
 * https://github.com/nevware21/ts-utils
 *
 * Copyright (c) 2022 Nevware21
 * Licensed under the MIT license.
 */
/**
 * @internal
 * @ignore
 * Generic Object deep copy handler which creates a new plain object and copies enumerable properties from
 * the source to the new target plain object. The source object does not have to be a plain object.
 * @param details - The details object for the current property being copied
 * @returns true if the handler processed the field.
 */
var _defaultDeepCopyHandler = function (details) {
    // Make sure we at least copy plain objects
    details.value && plainObjDeepCopyHandler(details);
    // Always return true so that the iteration completes
    return true;
};
/**
 * @internal
 * @ignore
 * The ordered default deep copy handlers
 */
var defaultDeepCopyHandlers = [
    arrayDeepCopyHandler,
    plainObjDeepCopyHandler,
    functionDeepCopyHandler,
    dateDeepCopyHandler
];
/**
 * @internal
 * @ignore
 * Helper function used for detecting and handling recursive properties
 * @param visitMap - The current map of objects that have been visited
 * @param source - The value (object) to be copied
 * @param newPath - The new access path from the origin to the current property
 * @param cb - The callback function to call if the current object has not already been processed.
 * @returns The new deep copied property, may be incomplete as the object is recursive and is still in the process of being copied
 */
function _getSetVisited(visitMap, source, newPath, cb) {
    var theEntry;
    arrForEach(visitMap, function (entry) {
        if (entry.k === source) {
            theEntry = entry;
            return -1;
        }
    });
    if (!theEntry) {
        // Add the target to the visit map so that deep nested objects refer to the single instance
        // Even if we have not finished processing it yet.
        theEntry = { k: source, v: source };
        visitMap.push(theEntry);
        // Now call the copy callback so that it populates the target
        cb(theEntry);
    }
    return theEntry.v;
}
/**
 * @internal
 * @ignore
 * Internal helper which performs the recursive deep copy
 * @param visitMap - The current map of objects that have been visited
 * @param value - The value being copied
 * @param ctx - The current copy context
 * @param key - [Optional] the current `key` for the value from the source object
 * @returns The new deep copied instance of the value.
 */
function _deepCopy(visitMap, value, ctx, key) {
    var userHandler = ctx.handler;
    var newPath = ctx.path ? (key ? ctx.path.concat(key) : ctx.path) : [];
    var newCtx = {
        handler: ctx.handler,
        src: ctx.src,
        path: newPath
    };
    var theType = typeof value;
    var isPlain = false;
    var isPrim = false;
    if (value && theType === OBJECT) {
        isPlain = isPlainObject(value);
    }
    else {
        isPrim = value === NULL_VALUE || isPrimitiveType(theType);
    }
    var details = {
        type: theType,
        isPrim: isPrim,
        isPlain: isPlain,
        value: value,
        result: value,
        path: newPath,
        origin: ctx.src,
        copy: function (source, newKey) {
            return _deepCopy(visitMap, source, newKey ? newCtx : ctx, newKey);
        },
        copyTo: function (target, source) {
            return _copyProps(visitMap, target, source, newCtx);
        }
    };
    if (!details.isPrim) {
        return _getSetVisited(visitMap, value, newPath, function (newEntry) {
            // Use an accessor to set the new value onto the new entry
            objDefine(details, "result", {
                g: function () {
                    return newEntry.v;
                },
                s: function (newValue) {
                    newEntry.v = newValue;
                }
            });
            var idx = 0;
            var handler = userHandler;
            while (!fnCall(handler || (idx < defaultDeepCopyHandlers.length ? defaultDeepCopyHandlers[idx++] : _defaultDeepCopyHandler), ctx, details)) {
                handler = NULL_VALUE;
            }
        });
    }
    // Allow the user handler to override the provided value
    if (userHandler && fnCall(userHandler, ctx, details)) {
        return details.result;
    }
    return value;
}
/**
 * @internal
 * @ignore
 * Internal helper to copy all of the enumerable properties from the source object to the new target object
 * @param visitMap - The current map of objects that have been visited
 * @param target - The target object to copy the properties to.
 * @param source - The source object to copy the properties from.
 * @param ctx - The current deep copy context
 * @returns The populated target object
 */
function _copyProps(visitMap, target, source, ctx) {
    if (!isNullOrUndefined(source)) {
        // Copy all properties (not just own properties)
        for (var key in source) {
            // Perform a deep copy of the object
            target[key] = _deepCopy(visitMap, source[key], ctx, key);
        }
    }
    return target;
}
/**
 * Object helper to copy all of the enumerable properties from the source object to the target, the
 * properties are copied via {@link objDeepCopy}. Automatic handling of recursive properties was added in v0.4.4
 * @group Object
 * @param target - The target object to populated
 * @param source - The source object to copy the properties from
 * @param handler - An optional callback that lets you provide / overide the deep cloning (Since 0.4.4)
 * @returns The target object
 * @example
 * ```ts
 * let a: any = { a: 1 };
 * let b: any = { b: 2, d: new Date(), e: new TestClass("Hello Darkness") };
 * a.b = b;        // { a: 1, b: { b: 2} }
 * b.a = a;        // { a: 1, b: { b: 2, a: { a: 1, { b: 2, a: ... }}}}
 *
 * function copyHandler(details: IObjDeepCopyHandlerDetails) {
 *     // details.origin === a
 *     // details.path[] is the path to the current value
 *     if (details.value && isDate(details.value)) {
 *         // So for the date path === [ "b", "d" ] which represents
 *         // details.origin["b"]["d"] === The Date
 *
 *         // Create a clone the Date object and set as the "newValue"
 *         details.value = new Date(details.value.getTime());
 *
 *         // Return true to indicate that we have "handled" the conversion
 *         // See objDeepCopy example for just reusing the original value (just don't replace details.value)
 *         return true;
 *     }
 *
 *     return false;
 * }
 *
 * let c: any = objCopyProps({}, a, copyHandler);
 *
 * assert.notEqual(a, c, "check a and c are not the same");
 * assert.ok(c !== c.b.a, "The root object won't be the same for the target reference as are are copying properties to our target");
 * assert.ok(c.b === c.b.a.b, "Check that the 2 'b' references are the same object");
 * assert.ok(c.b.a === c.b.a.b.a, "Check that the 2 'a' references are the same object");
 * assert.ok(c.b.d === c.b.a.b.d, "Check that the 2 'd' references are the same object");
 * assert.ok(isDate(c.b.d), "The copied date is still real 'Date' instance");
 * assert.notEqual(c.b.d, a.b.d, "And the copied date is not the same as the original");
 * assert.equal(c.b.d.getTime(), a.b.d.getTime(), "But the dates are the same");
 *
 * assert.ok(isObject(c.b.d), "The copied date is now an object");
 * ```
 */
function objCopyProps(target, source, handler) {
    var ctx = {
        handler: handler,
        src: source,
        path: []
    };
    return _copyProps([], target, source, ctx);
}
/**
 * Performs a deep copy of the source object, this is designed to work with base (plain) objects, arrays and primitives
 * if the source object contains class objects they will either be not cloned or may be considered non-operational after
 * performing a deep copy. ie. This is performing a deep copy of the objects properties so that altering the copy will
 * not mutate the source object hierarchy.
 * Automatic handling of recursive properties was added in v0.4.4.
 * @group Object
 * @group Object - Deep Copy
 * @param source - The source object to be copied
 * @param handler - An optional callback that lets you provide / overide the deep cloning (Since 0.4.4)
 * @return A new object which contains a deep copy of the source properties
 * @example
 * ```ts
 * let a: any = { a: 1 };
 * let b: any = { b: 2, d: new Date(), e: new TestClass("Hello Darkness") };
 * a.b = b;        // { a: 1, b: { b: 2} }
 * b.a = a;        // { a: 1, b: { b: 2, a: { a: 1, { b: 2, a: ... }}}}
 *
 * function copyHandler(details: IObjDeepCopyHandlerDetails) {
 *     // details.origin === a
 *     // details.path[] is the path to the current value
 *     if (details.value && isDate(details.value)) {
 *         // So for the date path === [ "b", "d" ] which represents
 *         // details.origin["b"]["d"] === The Date
 *
 *         // Return true to indicate that we have "handled" the conversion
 *         // Which in this case will reuse the existing instance (as we didn't replace details.value)
 *         // See objCopyProps example for replacing the Date instance
 *         return true;
 *     }
 *
 *     return false;
 * }
 *
 * let c: any = objDeepCopy(a, copyHandler);
 *
 * assert.notEqual(a, c, "check a and c are not the same");
 * assert.ok(c === c.b.a, "The root object won't be the same for the target reference");
 * assert.ok(c.b === c.b.a.b, "Check that the 2 'b' references are the same object");
 * assert.ok(c.b.a === c.b.a.b.a, "Check that the 2 'a' references are the same object");
 * assert.ok(c.b.d === c.b.a.b.d, "Check that the 2 'd' references are the same object");
 * assert.ok(isDate(c.b.d), "The copied date is still real 'Date' instance");
 * assert.equal(c.b.d, a.b.d, "And the copied date is the original date");
 * assert.equal(c.b.d.getTime(), a.b.d.getTime(), "But the dates are the same");
 * assert.ok(isObject(c.b.d), "The copied date is now an object");
 * assert.ok(!isError(c.b.e), "The copied error is no longer a real 'Error' instance");
 * assert.ok(isObject(c.b.e), "The copied error is now an object");
 * assert.equal(42, c.b.e.value, "Expect that the local property was copied");
 * ```
 */
function objDeepCopy(source, handler) {
    var ctx = {
        handler: handler,
        src: source
    };
    return _deepCopy([], source, ctx);
}
/**
 * Deep copy handler to identify and copy arrays.
 * @since 0.4.4
 * @group Object - Deep Copy
 * @param details - The details object for the current property being copied
 * @returns `true` if the current value is a function otherwise `false`
 */
function arrayDeepCopyHandler(details) {
    var value = details.value;
    if (isArray(value)) {
        // Assign the "result" value before performing any additional deep Copying, so any recursive object get a reference to this instance
        var target = details.result = [];
        target.length = value.length;
        // Copying all properties as arrays can contain non-indexed based properties
        details.copyTo(target, value);
        return true;
    }
    return false;
}
/**
 * Deep copy handler to identify and copy Date instances.
 * @since 0.4.4
 * @group Object - Deep Copy
 * @param details - The details object for the current property being copied
 * @returns `true` if the current value is a function otherwise `false`
 */
function dateDeepCopyHandler(details) {
    var value = details.value;
    if (isDate(value)) {
        details.result = new Date(value.getTime());
        return true;
    }
    return false;
}
/**
 * Deep copy handler to identify and copy functions. This handler just returns the original
 * function so the original function will be assigned to any new deep copied instance.
 * @since 0.4.4
 * @group Object - Deep Copy
 * @param details - The details object for the current property being copied
 * @returns `true` if the current value is a function otherwise `false`
 */
function functionDeepCopyHandler(details) {
    if (details.type === FUNCTION) {
        return true;
    }
    return false;
}
/**
 * Deep copy handler to identify and copy plain objects.
 * @since 0.4.4
 * @group Object - Deep Copy
 * @param details - The details object for the current property being copied
 * @returns `true` if the current value is a function otherwise `false`
 */
function plainObjDeepCopyHandler(details) {
    var value = details.value;
    if (value && details.isPlain) {
        // Assign the "result" value before performing any additional deep Copying, so any recursive object get a reference to this instance
        var target = details.result = {};
        details.copyTo(target, value);
        return true;
    }
    return false;
}

/*
 * @nevware21/ts-utils
 * https://github.com/nevware21/ts-utils
 *
 * Copyright (c) 2022 Nevware21
 * Licensed under the MIT license.
 */
/**
 * @internal
 * @ignore
 */
function _doExtend(target, theArgs) {
    arrForEach(theArgs, function (theArg) {
        objCopyProps(target, theArg);
    });
    return target;
}
function deepExtend(target, obj1, obj2, obj3, obj4, obj5, obj6) {
    return _doExtend(objDeepCopy(target) || {}, arrSlice(arguments));
}
function objExtend$1(target, obj1, obj2, obj3, obj4, obj5, obj6) {
    return _doExtend(target || {}, arrSlice(arguments));
}

/*
 * @nevware21/ts-utils
 * https://github.com/nevware21/ts-utils
 *
 * Copyright (c) 2022 Nevware21
 * Licensed under the MIT license.
 */
/**
 * Helper to return the length value of an object, this will return the value
 * of the "length" property. Generally used to return the length of a string or array.
 *
 * @since 0.4.2
 * @group Array
 * @group String
 * @group String
 * @group Array
 * @group Object
 * @param value - The value to return the length property from, must contain a `length` property
 * @example
 * ```ts
 * getLength("");               // returns 0
 * getLength("Hello World");    // returns 11
 * getLength([]);               // returns 0;
 * getLength([0, 1, 2, 3]);     // returns 4;
 * getLength({ length: 42});    // returns 42
 * getLength({ length: () => 53; }); // returns the function that if called would return 53
 * ```
 */
var getLength = _unwrapProp(LENGTH);

/*
 * @nevware21/ts-utils
 * https://github.com/nevware21/ts-utils
 *
 * Copyright (c) 2022 Nevware21
 * Licensed under the MIT license.
 */
var _perf;
/**
 * Returns the global `performance` Object if available, which can be used to
 * gather performance information about the current document. It serves as the
 * point of exposure for the Performance Timeline API, the High Resolution Time
 * API, the Navigation Timing API, the User Timing API, and the Resource Timing API.
 *
 * @since 0.4.4
 * @group Environment
 * @returns The global performance object if available.
 */
function getPerformance() {
    (!_perf || (!_perf.b && _globalLazyTestHooks && _globalLazyTestHooks.lzy)) && (_perf = lazySafeGetInst("performance"));
    return _perf.v;
}

/*
 * @nevware21/ts-utils
 * https://github.com/nevware21/ts-utils
 *
 * Copyright (c) 2023 Nevware21
 * Licensed under the MIT license.
 */
/**
 * The `polyStrSymSplit()` splits a string into substrings using the [`Symbol.split`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol/split)
 * method from the splitter object to provide custom behavior. It uses {@link getKnownSymbol}
 * to get the {@link WellKnownSymbols.split} symbol which will return the polyfill symbol value.
 * @since 0.9.1
 * @group Polyfill
 * @group String
 * @param value - The string value to be split into substrings.
 * @param splitter - The object which contains a Symbol.split method, Omitting splitter or passing
 * an object that doesn't contain a Symbol.split causes it to return an array with the calling
 * string as a single element.
 * @param limit - A non-negative integer specifying a limit on the number of substrings to be
 * included in the array. If provided, splits the string at each occurrence of the specified
 * separator, but stops when limit entries have been placed in the array. Any leftover text is
 * not included in the array at all.
 * - The array may contain fewer entries than limit if the end of the string is reached before
 * the limit is reached.
 * - If limit is 0, [] is returned.
 * @return An Array of strings, split at each point where the separator occurs in the given string.
 * @example
 * ```ts
 * const splitByNumber = {
 *   [getKnownSymbol<typeof Symbol.split>(WellKnownSymbols.split)]: (str: string) => {
 *     let num = 1;
 *     let pos = 0;
 *     const result = [];
 *     while (pos < str.length) {
 *       const matchPos = strIndexOf(str, asString(num), pos);
 *       if (matchPos === -1) {
 *         result.push(strSubstring(str, pos));
 *         break;
 *       }
 *       result.push(strSubstring(str, pos, matchPos));
 *       pos = matchPos + asString(num).length;
 *       num++;
 *     }
 *     return result;
 *   }
 * };
 *
 * const myString = "a1bc2c5d3e4f";
 * console.log(polyStrSymSplit(myString, splitByNumber)); // [ "a", "bc", "c5d", "e", "f" ]
 * ```
 */
function polyStrSymSplit(value, splitter, limit) {
    var splitFn = splitter && splitter[getKnownSymbol(9 /* WellKnownSymbols.split */)];
    return splitFn ? splitFn(value, limit) : [value];
}

/*
 * @nevware21/ts-utils
 * https://github.com/nevware21/ts-utils
 *
 * Copyright (c) 2023 Nevware21
 * Licensed under the MIT license.
 */
/**
 * The `strSplit()` splits a string into substrings using the pattern and divides a String
 * into an ordered list of substrings by searching for the pattern, puts these substrings
 * into an array, and returns the array.
 * @since 0.9.1
 * @group String
 * @param value - The string value to be split into substrings.
 * @param separator - The pattern describing where each split should occur. Can be undefined, a
 * string, or an object with a [`Symbol.split`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol/split)
 * method (if supported) — the typical example being a regular expression. Omitting separator or
 * passing undefined causes strSplit() to return an array with the calling string as a single
 * element. All values that are not undefined or objects with a `@@split` method are coerced to strings.
 * @param limit - A non-negative integer specifying a limit on the number of substrings to be
 * included in the array. If provided, splits the string at each occurrence of the specified
 * separator, but stops when limit entries have been placed in the array. Any leftover text is
 * not included in the array at all.
 * - The array may contain fewer entries than limit if the end of the string is reached before
 * the limit is reached.
 * - If limit is 0, [] is returned.
 * @return An Array of strings, split at each point where the separator occurs in the given string.
 * @example
 * ```ts
 * strSplit("Oh brave new world that has such people in it.", " ");
 * // [ "Oh", "brave", "new", "world", "that", "has", "such", "people", "in", "it." ]
 *
 * strSplit("Jan,Feb,Mar,Apr,May,Jun,Jul,Aug,Sep,Oct,Nov,Dec", ",");
 * // [ "Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec" ]
 * ```
 */
var strSplit = _unwrapFunction("split", StrProto);
/**
 * The `strSymSplit()` splits a string into substrings using the [`Symbol.split`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol/split)
 * method from the splitter object to provide custom behavior. If the runtime supports symbols
 * then the default runtime `split` method will be called, It will use {@link getKnownSymbol}
 * to get the {@link WellKnownSymbols.split} symbol which will return the runtime symbol or the
 * polyfill symbol when not supported by the runtime.
 * @since 0.9.1
 * @group String
 * @param value - The string value to be split into substrings.
 * @param splitter - The object which contains a Symbol.split method, Omitting splitter or passing
 * an object that doesn't contain a Symbol.split causes it to return an array with the calling
 * string as a single element.
 * @param limit - A non-negative integer specifying a limit on the number of substrings to be
 * included in the array. If provided, splits the string at each occurrence of the specified
 * separator, but stops when limit entries have been placed in the array. Any leftover text is
 * not included in the array at all.
 * - The array may contain fewer entries than limit if the end of the string is reached before
 * the limit is reached.
 * - If limit is 0, [] is returned.
 * @return An Array of strings, split at each point where the separator occurs in the given string.
 * @example
 * ```ts
 * const splitByNumber = {
 *   [Symbol.split]: (str: string) => {
 *     let num = 1;
 *     let pos = 0;
 *     const result = [];
 *     while (pos < str.length) {
 *       const matchPos = strIndexOf(str, asString(num), pos);
 *       if (matchPos === -1) {
 *         result.push(strSubstring(str, pos));
 *         break;
 *       }
 *       result.push(strSubstring(str, pos, matchPos));
 *       pos = matchPos + asString(num).length;
 *       num++;
 *     }
 *     return result;
 *   }
 * };
 *
 * const myString = "a1bc2c5d3e4f";
 * console.log(strSymSplit(myString, splitByNumber)); // [ "a", "bc", "c5d", "e", "f" ]
 * ```
 */
hasSymbol() ? _unwrapFunction("split", StrProto) : polyStrSymSplit;

/*
 * @nevware21/ts-utils
 * https://github.com/nevware21/ts-utils
 *
 * Copyright (c) 2022 Nevware21
 * Licensed under the MIT license.
 */
/**
 * Set the named value on the target object where the path may be presented by a string which
 * contains "." characters to separate the nested objects of the heirarchy / path to the value.
 * @since 0.9.1
 * @group Value
 * @param target - The target object
 * @param path - The path identifying the location of the final key value
 * @param value - The value to set
 * @example
 * ```ts
 * let theValue = { };
 * setValueByKey(theValue, "Hello.Darkness.my", "old");
 * // Resulting Object: { Hello: { Darkness: { my: "old" } } }
 * setValueByKey(theValue, "friend", "I've");
 * // Resulting Object: { Hello: { Darkness: { my: "old" } }, friend: "I've" }
 * setValueByKey(theValue, "come.to.see", "you");
 * // Resulting Object: { Hello: { Darkness: { my: "old" } }, friend: "I've", come: { to : { see: "you" } } }
 * ```
 */
function setValueByKey(target, path, value) {
    if (target && path) {
        var parts = strSplit(path, ".");
        var lastKey = parts.pop();
        arrForEach(parts, function (key) {
            if (isNullOrUndefined(target[key])) {
                // Add an empty object / map
                target[key] = {};
            }
            target = target[key];
        });
        target[lastKey] = value;
    }
}

/*
 * @nevware21/ts-utils
 * https://github.com/nevware21/ts-utils
 *
 * Copyright (c) 2022 Nevware21
 * Licensed under the MIT license.
 */
/**
 * This method lets you determine whether or not a string ends with another string. This method is case-sensitive.
 * @group String
 * @param value - The value to be checked
 * @param searchString - The characters to be searched for at the end of `value` string.
 * @param length - If provided, it is used as the length of `value`. Defaults to value.length.
 */
var strEndsWith = _unwrapFunctionWithPoly("endsWith", StrProto, polyStrEndsWith);
/**
 * This method lets you determine whether or not a string ends with another string. This method is case-sensitive.
 * @group Polyfill
 * @group String
 * @param value - The value to be checked
 * @param searchString - The characters to be searched for at the end of `value` string.
 * @param length - If provided, it is used as the length of `value`. Defaults to value.length.
 */
function polyStrEndsWith(value, searchString, length) {
    if (!isString(value)) {
        throwTypeError("'" + dumpObj(value) + "' is not a string");
    }
    var searchValue = isString(searchString) ? searchString : asString(searchString);
    var chkLen = searchValue[LENGTH];
    var len = value[LENGTH];
    var end = !isUndefined(length) && length < len ? length : len;
    return strSubstring(value, end - chkLen, end) === searchValue;
}

/*
 * @nevware21/ts-utils
 * https://github.com/nevware21/ts-utils
 *
 * Copyright (c) 2022 Nevware21
 * Licensed under the MIT license.
 */
/**
 * The `strIndexOf()` method, given two arguments: the string and a substring to search for, searches
 * the entire calling string, and returns the index of the first occurrence of the specified substring.
 * Given a thrid argument: a number, the method returns the first occurrence of the specified substring
 * at an index greater than or equal to the specified number.
 * @group String
 * @param value - The value to be checked for the seeach string
 * @param searchString - The substring to search for in the value
 * @param position - The starting position to search from
 * @example
 * ```ts
 * strIndexOf('hello world', '') // returns 0
 * strIndexOf('hello world', '', 0) // returns 0
 * strIndexOf('hello world', '', 3) // returns 3
 * strIndexOf('hello world', '', 8) // returns 8
 *
 * // However, if the thrid argument is greater than the length of the string
 * strIndexOf('hello world', '', 11) // returns 11
 * strIndexOf('hello world', '', 13) // returns 11
 * strIndexOf('hello world', '', 22) // returns 11
 *
 * strIndexOf('Blue Whale', 'Blue')      // returns  0
 * strIndexOf('Blue Whale', 'Blute')     // returns -1
 * strIndexOf('Blue Whale', 'Whale', 0)  // returns  5
 * strIndexOf('Blue Whale', 'Whale', 5)  // returns  5
 * strIndexOf('Blue Whale', 'Whale', 7)  // returns -1
 * strIndexOf('Blue Whale', '')          // returns  0
 * strIndexOf('Blue Whale', '', 9)       // returns  9
 * strIndexOf('Blue Whale', '', 10)      // returns 10
 * strIndexOf('Blue Whale', '', 11)      // returns 10
 * ```
 */
var strIndexOf = _unwrapFunction(INDEX_OF, StrProto);
/**
 * The `strLastIndexOf()` method, given two arguments: the string and a substring to search for, searches
 * the entire calling string, and returns the index of the last occurrence of the specified substring.
 * Given a third argument: a number, the method returns the last occurrence of the specified substring
 * at an index less than or equal to the specified number.
 * @group String
 * @param value - The value to be checked for the seeach string
 * @param searchString - The substring to search for in the value
 * @param position - The starting position to search from
 * @example
 * ```ts
 * strLastIndexOf('canal', 'a');     // returns 3
 * strLastIndexOf('canal', 'a', 2);  // returns 1
 * strLastIndexOf('canal', 'a', 0);  // returns -1
 * strLastIndexOf('canal', 'x');     // returns -1
 * strLastIndexOf('canal', 'c', -5); // returns 0
 * strLastIndexOf('canal', 'c', 0);  // returns 0
 * strLastIndexOf('canal', '');      // returns 5
 * strLastIndexOf('canal', '', 2);   // returns 2
 * ```
 */
_unwrapFunction(LAST_INDEX_OF, StrProto);

/*
 * @nevware21/ts-utils
 * https://github.com/nevware21/ts-utils
 *
 * Copyright (c) 2022 Nevware21
 * Licensed under the MIT license.
 */
var REF = "ref";
var UNREF = "un" + REF;
var HAS_REF = "hasRef";
var ENABLED = "enabled";
/**
 * @ignore
 * @internal
 * Internal function to create and manage an ITimerHandler implementation, the object returned from this function
 * it directly used / returned by the pulic functions used to create timers (idle, interval and timeout)
 * @param startTimer - Should the timer be started as part of creating the handler
 * @param refreshFn - The function used to create/start or refresh the timer
 * @param cancelFn - The function used to cancel the timer.
 * @returns The new ITimerHandler instance
 */
function _createTimerHandler(startTimer, refreshFn, cancelFn) {
    var _a;
    var ref = true;
    var timerId = startTimer ? refreshFn(NULL_VALUE) : NULL_VALUE;
    var theTimerHandler;
    var _unref = function () {
        ref = false;
        timerId && timerId[UNREF] && timerId[UNREF]();
        return theTimerHandler;
    };
    var _ref = function () {
        ref = true;
        timerId && timerId[REF] && timerId[REF]();
        return theTimerHandler;
    };
    var _hasRef = function () {
        if (timerId && timerId[HAS_REF]) {
            return timerId[HAS_REF]();
        }
        return ref;
    };
    var _refresh = function () {
        timerId = refreshFn(timerId);
        if (!ref) {
            _unref();
        }
        return theTimerHandler;
    };
    var _cancel = function () {
        timerId && cancelFn(timerId);
        timerId = NULL_VALUE;
    };
    var _setEnabled = function (value) {
        !value && timerId && _cancel();
        value && !timerId && _refresh();
    };
    theTimerHandler = (_a = {
            cancel: _cancel,
            refresh: _refresh
        },
        _a[HAS_REF] = _hasRef,
        _a[REF] = _ref,
        _a[UNREF] = _unref,
        _a[ENABLED] = false,
        _a);
    objDefineProp(theTimerHandler, ENABLED, {
        get: function () { return !!timerId; },
        set: _setEnabled
    });
    return {
        h: theTimerHandler,
        dn: function () {
            timerId = NULL_VALUE;
        }
    };
}

/*
 * @nevware21/ts-utils
 * https://github.com/nevware21/ts-utils
 *
 * Copyright (c) 2022 Nevware21
 * Licensed under the MIT license.
 */
function _createTimeoutWith(self, startTimer, overrideFn, theArgs) {
    var isArr = isArray(overrideFn);
    var len = isArr ? overrideFn.length : 0;
    var setFn = (len > 0 ? overrideFn[0] : (!isArr ? overrideFn : UNDEF_VALUE)) || setTimeout;
    var clearFn = (len > 1 ? overrideFn[1] : UNDEF_VALUE) || clearTimeout;
    var timerFn = theArgs[0];
    theArgs[0] = function () {
        handler.dn();
        fnApply(timerFn, self, arrSlice(arguments));
    };
    var handler = _createTimerHandler(startTimer, function (timerId) {
        if (timerId) {
            if (timerId.refresh) {
                timerId.refresh();
                return timerId;
            }
            fnApply(clearFn, self, [timerId]);
        }
        return fnApply(setFn, self, theArgs);
    }, function (timerId) {
        fnApply(clearFn, self, [timerId]);
    });
    return handler.h;
}
function scheduleTimeout(callback, timeout) {
    return _createTimeoutWith(this, true, UNDEF_VALUE, arrSlice(arguments));
}
function createTimeout(callback, timeout) {
    return _createTimeoutWith(this, false, UNDEF_VALUE, arrSlice(arguments));
}

// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.
var _a$b;
/**
 * Constant string defined to support minimization
 * @ignore
 */
var Constructor = 'constructor';
/**
 * Constant string defined to support minimization
 * @ignore
 */
var Prototype = 'prototype';
/**
 * Constant string defined to support minimization
 * @ignore
 */
var strFunction = 'function';
/**
 * Used to define the name of the instance function lookup table
 * @ignore
 */
var DynInstFuncTable = '_dynInstFuncs';
/**
 * Name used to tag the dynamic prototype function
 * @ignore
 */
var DynProxyTag = '_isDynProxy';
/**
 * Name added to a prototype to define the dynamic prototype "class" name used to lookup the function table
 * @ignore
 */
var DynClassName = '_dynClass';
/**
 * Prefix added to the classname to avoid any name clashes with other instance level properties
 * @ignore
 */
var DynClassNamePrefix = '_dynCls$';
/**
 * A tag which is used to check if we have already to attempted to set the instance function if one is not present
 * @ignore
 */
var DynInstChkTag = '_dynInstChk';
/**
 * A tag which is used to check if we are allows to try and set an instance function is one is not present. Using the same
 * tag name as the function level but a different const name for readability only.
 */
var DynAllowInstChkTag = DynInstChkTag;
/**
 * The global (imported) instances where the global performance options are stored
 */
var DynProtoDefaultOptions = '_dfOpts';
/**
 * Value used as the name of a class when it cannot be determined
 * @ignore
 */
var UnknownValue = '_unknown_';
/**
 * Constant string defined to support minimization
 * @ignore
 */
var str__Proto = "__proto__";
/**
 * The polyfill version of __proto__ so that it doesn't cause issues for anyone not expecting it to exist
 */
var DynProtoBaseProto = "_dyn" + str__Proto;
/**
 * Runtime Global holder for dynamicProto settings
 */
var DynProtoGlobalSettings = "__dynProto$Gbl";
/**
 * Track the current prototype for IE8 as you can't look back to get the prototype
 */
var DynProtoCurrent = "_dynInstProto";
/**
 * Constant string defined to support minimization
 * @ignore
 */
var strUseBaseInst = 'useBaseInst';
/**
 * Constant string defined to support minimization
 * @ignore
 */
var strSetInstFuncs = 'setInstFuncs';
var Obj = Object;
/**
 * Pre-lookup to check if we are running on a modern browser (i.e. not IE8)
 * @ignore
 */
var _objGetPrototypeOf = Obj["getPrototypeOf"];
/**
 * Pre-lookup to check for the existence of this function
 */
var _objGetOwnProps = Obj["getOwnPropertyNames"];
// Since 1.1.7 moving these to the runtime global to work around mixed version and module issues
// See Issue https://github.com/microsoft/DynamicProto-JS/issues/57 for details
var _gbl = getGlobal();
var _gblInst = _gbl[DynProtoGlobalSettings] || (_gbl[DynProtoGlobalSettings] = {
    o: (_a$b = {},
        _a$b[strSetInstFuncs] = true,
        _a$b[strUseBaseInst] = true,
        _a$b),
    n: 1000 // Start new global index @ 1000 so we "fix" some cases when mixed with 1.1.6 or earlier
});
/**
 * Helper used to check whether the target is an Object prototype or Array prototype
 * @ignore
 */
function _isObjectOrArrayPrototype(target) {
    return target && (target === Obj[Prototype] || target === Array[Prototype]);
}
/**
 * Helper used to check whether the target is an Object prototype, Array prototype or Function prototype
 * @ignore
 */
function _isObjectArrayOrFunctionPrototype(target) {
    return _isObjectOrArrayPrototype(target) || target === Function[Prototype];
}
/**
 * Helper used to get the prototype of the target object as getPrototypeOf is not available in an ES3 environment.
 * @ignore
 */
function _getObjProto$1(target) {
    var newProto;
    if (target) {
        // This method doesn't exist in older browsers (e.g. IE8)
        if (_objGetPrototypeOf) {
            return _objGetPrototypeOf(target);
        }
        var curProto = target[str__Proto] || target[Prototype] || (target[Constructor] ? target[Constructor][Prototype] : null);
        // Using the pre-calculated value as IE8 doesn't support looking up the prototype of a prototype and thus fails for more than 1 base class
        newProto = target[DynProtoBaseProto] || curProto;
        if (!objHasOwnProperty(target, DynProtoBaseProto)) {
            // As this prototype doesn't have this property then this is from an inherited class so newProto is the base to return so save it
            // so we can look it up value (which for a multiple hierarchy dynamicProto will be the base class)
            delete target[DynProtoCurrent]; // Delete any current value allocated to this instance so we pick up the value from prototype hierarchy
            newProto = target[DynProtoBaseProto] = target[DynProtoCurrent] || target[DynProtoBaseProto];
            target[DynProtoCurrent] = curProto;
        }
    }
    return newProto;
}
/**
 * Helper to get the properties of an object, including none enumerable ones as functions on a prototype in ES6
 * are not enumerable.
 * @param target
 */
function _forEachProp(target, func) {
    var props = [];
    if (_objGetOwnProps) {
        props = _objGetOwnProps(target);
    }
    else {
        for (var name_1 in target) {
            if (typeof name_1 === "string" && objHasOwnProperty(target, name_1)) {
                props.push(name_1);
            }
        }
    }
    if (props && props.length > 0) {
        for (var lp = 0; lp < props.length; lp++) {
            func(props[lp]);
        }
    }
}
/**
 * Helper function to check whether the provided function name is a potential candidate for dynamic
 * callback and prototype generation.
 * @param target The target object, may be a prototype or class object
 * @param funcName The function name
 * @param skipOwn Skips the check for own property
 * @ignore
 */
function _isDynamicCandidate(target, funcName, skipOwn) {
    return (funcName !== Constructor && typeof target[funcName] === strFunction && (skipOwn || objHasOwnProperty(target, funcName)));
}
/**
 * Helper to throw a TypeError exception
 * @param message the message
 * @ignore
 */
function _throwTypeError(message) {
    throwTypeError("DynamicProto: " + message);
}
/**
 * Returns a collection of the instance functions that are defined directly on the thisTarget object, it does
 * not return any inherited functions
 * @param thisTarget The object to get the instance functions from
 * @ignore
 */
function _getInstanceFuncs(thisTarget) {
    // Get the base proto
    var instFuncs = {};
    // Save any existing instance functions
    _forEachProp(thisTarget, function (name) {
        // Don't include any dynamic prototype instances - as we only want the real functions
        if (!instFuncs[name] && _isDynamicCandidate(thisTarget, name, false)) {
            // Create an instance callback for passing the base function to the caller
            instFuncs[name] = thisTarget[name];
        }
    });
    return instFuncs;
}
/**
 * Returns whether the value is included in the array
 * @param values The array of values
 * @param value  The value
 */
function _hasVisited(values, value) {
    for (var lp = values.length - 1; lp >= 0; lp--) {
        if (values[lp] === value) {
            return true;
        }
    }
    return false;
}
/**
 * Returns an object that contains callback functions for all "base/super" functions, this is used to "save"
 * enabling calling super.xxx() functions without requiring that the base "class" has defined a prototype references
 * @param target The current instance
 * @ignore
 */
function _getBaseFuncs(classProto, thisTarget, instFuncs, useBaseInst) {
    function _instFuncProxy(target, funcHost, funcName) {
        var theFunc = funcHost[funcName];
        if (theFunc[DynProxyTag] && useBaseInst) {
            // grab and reuse the hosted looking function (if available) otherwise the original passed function
            var instFuncTable = target[DynInstFuncTable] || {};
            if (instFuncTable[DynAllowInstChkTag] !== false) {
                theFunc = (instFuncTable[funcHost[DynClassName]] || {})[funcName] || theFunc;
            }
        }
        return function () {
            // eslint-disable-next-line prefer-rest-params
            return theFunc.apply(target, arguments);
        };
    }
    // Start creating a new baseFuncs by creating proxies for the instance functions (as they may get replaced)
    var baseFuncs = {};
    _forEachProp(instFuncs, function (name) {
        // Create an instance callback for passing the base function to the caller
        baseFuncs[name] = _instFuncProxy(thisTarget, instFuncs, name);
    });
    // Get the base prototype functions
    var baseProto = _getObjProto$1(classProto);
    var visited = [];
    // Don't include base object functions for Object, Array or Function
    while (baseProto && !_isObjectArrayOrFunctionPrototype(baseProto) && !_hasVisited(visited, baseProto)) {
        // look for prototype functions
        _forEachProp(baseProto, function (name) {
            // Don't include any dynamic prototype instances - as we only want the real functions
            // For IE 7/8 the prototype lookup doesn't provide the full chain so we need to bypass the 
            // hasOwnProperty check we get all of the methods, main difference is that IE7/8 doesn't return
            // the Object prototype methods while bypassing the check
            if (!baseFuncs[name] && _isDynamicCandidate(baseProto, name, !_objGetPrototypeOf)) {
                // Create an instance callback for passing the base function to the caller
                baseFuncs[name] = _instFuncProxy(thisTarget, baseProto, name);
            }
        });
        // We need to find all possible functions that might be overloaded by walking the entire prototype chain
        // This avoids the caller from needing to check whether it's direct base class implements the function or not
        // by walking the entire chain it simplifies the usage and issues from upgrading any of the base classes.
        visited.push(baseProto);
        baseProto = _getObjProto$1(baseProto);
    }
    return baseFuncs;
}
function _getInstFunc(target, funcName, proto, currentDynProtoProxy) {
    var instFunc = null;
    // We need to check whether the class name is defined directly on this prototype otherwise
    // it will walk the proto chain and return any parent proto classname.
    if (target && objHasOwnProperty(proto, DynClassName)) {
        var instFuncTable = target[DynInstFuncTable] || {};
        instFunc = (instFuncTable[proto[DynClassName]] || {})[funcName];
        if (!instFunc) {
            // Avoid stack overflow from recursive calling the same function
            _throwTypeError("Missing [" + funcName + "] " + strFunction);
        }
        // We have the instance function, lets check it we can speed up further calls
        // by adding the instance function back directly on the instance (avoiding the dynamic func lookup)
        if (!instFunc[DynInstChkTag] && instFuncTable[DynAllowInstChkTag] !== false) {
            // If the instance already has an instance function we can't replace it
            var canAddInst = !objHasOwnProperty(target, funcName);
            // Get current prototype
            var objProto = _getObjProto$1(target);
            var visited = [];
            // Lookup the function starting at the top (instance level prototype) and traverse down, if the first matching function
            // if nothing is found or if the first hit is a dynamic proto instance then we can safely add an instance shortcut
            while (canAddInst && objProto && !_isObjectArrayOrFunctionPrototype(objProto) && !_hasVisited(visited, objProto)) {
                var protoFunc = objProto[funcName];
                if (protoFunc) {
                    canAddInst = (protoFunc === currentDynProtoProxy);
                    break;
                }
                // We need to find all possible initial functions to ensure that we don't bypass a valid override function
                visited.push(objProto);
                objProto = _getObjProto$1(objProto);
            }
            try {
                if (canAddInst) {
                    // This instance doesn't have an instance func and the class hierarchy does have a higher level prototype version
                    // so it's safe to directly assign for any subsequent calls (for better performance)
                    target[funcName] = instFunc;
                }
                // Block further attempts to set the instance function for any
                instFunc[DynInstChkTag] = 1;
            }
            catch (e) {
                // Don't crash if the object is readonly or the runtime doesn't allow changing this
                // And set a flag so we don't try again for any function
                instFuncTable[DynAllowInstChkTag] = false;
            }
        }
    }
    return instFunc;
}
function _getProtoFunc(funcName, proto, currentDynProtoProxy) {
    var protoFunc = proto[funcName];
    // Check that the prototype function is not a self reference -- try to avoid stack overflow!
    if (protoFunc === currentDynProtoProxy) {
        // It is so lookup the base prototype
        protoFunc = _getObjProto$1(proto)[funcName];
    }
    if (typeof protoFunc !== strFunction) {
        _throwTypeError("[" + funcName + "] is not a " + strFunction);
    }
    return protoFunc;
}
/**
 * Add the required dynamic prototype methods to the the class prototype
 * @param proto - The class prototype
 * @param className - The instance classname
 * @param target - The target instance
 * @param baseInstFuncs - The base instance functions
 * @param setInstanceFunc - Flag to allow prototype function to reset the instance function if one does not exist
 * @ignore
 */
function _populatePrototype(proto, className, target, baseInstFuncs, setInstanceFunc) {
    function _createDynamicPrototype(proto, funcName) {
        var dynProtoProxy = function () {
            // Use the instance or prototype function
            var instFunc = _getInstFunc(this, funcName, proto, dynProtoProxy) || _getProtoFunc(funcName, proto, dynProtoProxy);
            // eslint-disable-next-line prefer-rest-params
            return instFunc.apply(this, arguments);
        };
        // Tag this function as a proxy to support replacing dynamic proxy elements (primary use case is for unit testing
        // via which can dynamically replace the prototype function reference)
        dynProtoProxy[DynProxyTag] = 1;
        return dynProtoProxy;
    }
    if (!_isObjectOrArrayPrototype(proto)) {
        var instFuncTable = target[DynInstFuncTable] = target[DynInstFuncTable] || {};
        var instFuncs_1 = instFuncTable[className] = (instFuncTable[className] || {}); // fetch and assign if as it may not exist yet
        // Set whether we are allow to lookup instances, if someone has set to false then do not re-enable
        if (instFuncTable[DynAllowInstChkTag] !== false) {
            instFuncTable[DynAllowInstChkTag] = !!setInstanceFunc;
        }
        _forEachProp(target, function (name) {
            // Only add overridden functions
            if (_isDynamicCandidate(target, name, false) && target[name] !== baseInstFuncs[name]) {
                // Save the instance Function to the lookup table and remove it from the instance as it's not a dynamic proto function
                instFuncs_1[name] = target[name];
                delete target[name];
                // Add a dynamic proto if one doesn't exist or if a prototype function exists and it's not a dynamic one
                if (!objHasOwnProperty(proto, name) || (proto[name] && !proto[name][DynProxyTag])) {
                    proto[name] = _createDynamicPrototype(proto, name);
                }
            }
        });
    }
}
/**
 * Checks whether the passed prototype object appears to be correct by walking the prototype hierarchy of the instance
 * @param classProto The class prototype instance
 * @param thisTarget The current instance that will be checked whether the passed prototype instance is in the hierarchy
 * @ignore
 */
function _checkPrototype(classProto, thisTarget) {
    // This method doesn't existing in older browsers (e.g. IE8)
    if (_objGetPrototypeOf) {
        // As this is primarily a coding time check, don't bother checking if running in IE8 or lower
        var visited = [];
        var thisProto = _getObjProto$1(thisTarget);
        while (thisProto && !_isObjectArrayOrFunctionPrototype(thisProto) && !_hasVisited(visited, thisProto)) {
            if (thisProto === classProto) {
                return true;
            }
            // This avoids the caller from needing to check whether it's direct base class implements the function or not
            // by walking the entire chain it simplifies the usage and issues from upgrading any of the base classes.
            visited.push(thisProto);
            thisProto = _getObjProto$1(thisProto);
        }
        return false;
    }
    // If objGetPrototypeOf doesn't exist then just assume everything is ok.
    return true;
}
/**
 * Gets the current prototype name using the ES6 name if available otherwise falling back to a use unknown as the name.
 * It's not critical for this to return a name, it's used to decorate the generated unique name for easier debugging only.
 * @param target
 * @param unknownValue
 * @ignore
 */
function _getObjName(target, unknownValue) {
    if (objHasOwnProperty(target, Prototype)) {
        // Look like a prototype
        return target.name || unknownValue || UnknownValue;
    }
    return (((target || {})[Constructor]) || {}).name || unknownValue || UnknownValue;
}
/**
 * Helper function when creating dynamic (inline) functions for classes, this helper performs the following tasks :-
 * - Saves references to all defined base class functions
 * - Calls the delegateFunc with the current target (this) and a base object reference that can be used to call all "super" functions.
 * - Will populate the class prototype for all overridden functions to support class extension that call the prototype instance.
 * Callers should use this helper when declaring all function within the constructor of a class, as mentioned above the delegateFunc is
 * passed both the target "this" and an object that can be used to call any base (super) functions, using this based object in place of
 * super.XXX() (which gets expanded to _super.prototype.XXX()) provides a better minification outcome and also ensures the correct "this"
 * context is maintained as TypeScript creates incorrect references using super.XXXX() for dynamically defined functions i.e. Functions
 * defined in the constructor or some other function (rather than declared as complete typescript functions).
 * ### Usage
 * ```typescript
 * import dynamicProto from "@microsoft/dynamicproto-js";
 * class ExampleClass extends BaseClass {
 *     constructor() {
 *         dynamicProto(ExampleClass, this, (_self, base) => {
 *             // This will define a function that will be converted to a prototype function
 *             _self.newFunc = () => {
 *                 // Access any "this" instance property
 *                 if (_self.someProperty) {
 *                     ...
 *                 }
 *             }
 *             // This will define a function that will be converted to a prototype function
 *             _self.myFunction = () => {
 *                 // Access any "this" instance property
 *                 if (_self.someProperty) {
 *                     // Call the base version of the function that we are overriding
 *                     base.myFunction();
 *                 }
 *                 ...
 *             }
 *             _self.initialize = () => {
 *                 ...
 *             }
 *             // Warnings: While the following will work as _self is simply a reference to
 *             // this, if anyone overrides myFunction() the overridden will be called first
 *             // as the normal JavaScript method resolution will occur and the defined
 *             // _self.initialize() function is actually gets removed from the instance and
 *             // a proxy prototype version is created to reference the created method.
 *             _self.initialize();
 *         });
 *     }
 * }
 * ```
 * @typeparam DPType This is the generic type of the class, used to keep intellisense valid
 * @typeparam DPCls The type that contains the prototype of the current class
 * @param theClass - This is the current class instance which contains the prototype for the current class
 * @param target - The current "this" (target) reference, when the class has been extended this.prototype will not be the 'theClass' value.
 * @param delegateFunc - The callback function (closure) that will create the dynamic function
 * @param options - Additional options to configure how the dynamic prototype operates
 */
function dynamicProto(theClass, target, delegateFunc, options) {
    // Make sure that the passed theClass argument looks correct
    if (!objHasOwnProperty(theClass, Prototype)) {
        _throwTypeError("theClass is an invalid class definition.");
    }
    // Quick check to make sure that the passed theClass argument looks correct (this is a common copy/paste error)
    var classProto = theClass[Prototype];
    if (!_checkPrototype(classProto, target)) {
        _throwTypeError("[" + _getObjName(theClass) + "] not in hierarchy of [" + _getObjName(target) + "]");
    }
    var className = null;
    if (objHasOwnProperty(classProto, DynClassName)) {
        // Only grab the class name if it's defined on this prototype (i.e. don't walk the prototype chain)
        className = classProto[DynClassName];
    }
    else {
        // As not all browser support name on the prototype creating a unique dynamic one if we have not already
        // assigned one, so we can use a simple string as the lookup rather than an object for the dynamic instance
        // function table lookup.
        className = DynClassNamePrefix + _getObjName(theClass, "_") + "$" + _gblInst.n;
        _gblInst.n++;
        classProto[DynClassName] = className;
    }
    var perfOptions = dynamicProto[DynProtoDefaultOptions];
    var useBaseInst = !!perfOptions[strUseBaseInst];
    if (useBaseInst && options && options[strUseBaseInst] !== undefined) {
        useBaseInst = !!options[strUseBaseInst];
    }
    // Get the current instance functions
    var instFuncs = _getInstanceFuncs(target);
    // Get all of the functions for any base instance (before they are potentially overridden)
    var baseFuncs = _getBaseFuncs(classProto, target, instFuncs, useBaseInst);
    // Execute the delegate passing in both the current target "this" and "base" function references
    // Note casting the same type as we don't actually have the base class here and this will provide some intellisense support
    delegateFunc(target, baseFuncs);
    // Don't allow setting instance functions for older IE instances
    var setInstanceFunc = !!_objGetPrototypeOf && !!perfOptions[strSetInstFuncs];
    if (setInstanceFunc && options) {
        setInstanceFunc = !!options[strSetInstFuncs];
    }
    // Populate the Prototype for any overridden instance functions
    _populatePrototype(classProto, className, target, instFuncs, setInstanceFunc !== false);
}
/**
 * Exposes the default global options to allow global configuration, if the global values are disabled these will override
 * any passed values. This is primarily exposed to support unit-testing without the need for individual classes to expose
 * their internal usage of dynamic proto.
 */
dynamicProto[DynProtoDefaultOptions] = _gblInst.o;

// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.
var strShimFunction = "function";
var strShimObject = "object";
var strShimUndefined = "undefined";
var strShimPrototype = "prototype";
var ObjClass = Object;
var ObjProto = ObjClass[strShimPrototype];

// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.
// Most of these functions have been directly shamelessly "lifted" from the https://github.com/@microsoft/tslib and
// modified to be ES5 compatible and applying several minification and tree-shaking techniques so that Application Insights
// can successfully use TypeScript "importHelpers" which imports tslib during compilation but it will use these at runtime
// Which is also why all of the functions have not been included as Application Insights currently doesn't use or require
// them.
(getGlobal() || {})["Symbol"];
(getGlobal() || {})["Reflect"];
var strHasOwnProperty = "hasOwnProperty";
var __objAssignFnImpl = function (t) {
    // tslint:disable-next-line: ban-comma-operator
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) {
            if (ObjProto[strHasOwnProperty].call(s, p)) {
                t[p] = s[p];
            }
        }
    }
    return t;
};
var __assignFn = objAssign || __objAssignFnImpl;
// tslint:disable-next-line: only-arrow-functions
var extendStaticsFn = function (d, b) {
    extendStaticsFn = ObjClass["setPrototypeOf"] ||
        // tslint:disable-next-line: only-arrow-functions
        ({ __proto__: [] } instanceof Array && function (d, b) {
            d.__proto__ = b;
        }) ||
        // tslint:disable-next-line: only-arrow-functions
        function (d, b) {
            for (var p in b) {
                if (b[strHasOwnProperty](p)) {
                    d[p] = b[p];
                }
            }
        };
    return extendStaticsFn(d, b);
};
function __extendsFn(d, b) {
    if (typeof b !== strShimFunction && b !== null) {
        throwTypeError("Class extends value " + String(b) + " is not a constructor or null");
    }
    extendStaticsFn(d, b);
    function __() {
        this.constructor = d;
    }
    // tslint:disable-next-line: ban-comma-operator
    d[strShimPrototype] = b === null ? objCreate(b) : (__[strShimPrototype] = b[strShimPrototype], new __());
}
function __spreadArrayFn(to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++) {
        to[j] = from[i];
    }
    return to;
}

/*
 * Application Insights JavaScript SDK - Core, 3.0.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */

/**
 * Create an enum style object which has both the key => value and value => key mappings
 * @param values - The values to populate on the new object
 * @returns
 */
var createEnumStyle = createEnum;
/**
 * Create a 2 index map that maps an enum's key and value to the defined map value, X["key"] => mapValue and X[0] => mapValue.
 * Generic values
 * - E = the const enum type (typeof eRequestHeaders);
 * - V = Identifies the valid values for the keys, this should include both the enum numeric and string key of the type. The
 * resulting "Value" of each entry identifies the valid values withing the assignments.
 * @param values - The values to populate on the new object
 * @returns
 */
var createValueMap = createTypeMap;

/*
 * Application Insights JavaScript SDK - Core, 3.0.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


// @skip-file-minify
// ##############################################################
// AUTO GENERATED FILE: This file is Auto Generated during build.
// ##############################################################
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
// Note: DON'T Export these const from the package as we are still targeting ES3 this will export a mutable variables that someone could change!!!
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
var _DYN_TO_LOWER_CASE$2 = "toLowerCase"; // Count: 9
var _DYN_BLK_VAL = "blkVal"; // Count: 5
var _DYN_LENGTH$5 = "length"; // Count: 43
var _DYN_RD_ONLY = "rdOnly"; // Count: 4
var _DYN_NOTIFY = "notify"; // Count: 4
var _DYN_WARN_TO_CONSOLE = "warnToConsole"; // Count: 4
var _DYN_THROW_INTERNAL = "throwInternal"; // Count: 5
var _DYN_SET_DF = "setDf"; // Count: 6
var _DYN_WATCH = "watch"; // Count: 9
var _DYN_LOGGER = "logger"; // Count: 21
var _DYN_APPLY = "apply"; // Count: 7
var _DYN_PUSH$1 = "push"; // Count: 31
var _DYN_SPLICE = "splice"; // Count: 8
var _DYN_HDLR = "hdlr"; // Count: 6
var _DYN_CANCEL = "cancel"; // Count: 5
var _DYN_INITIALIZE = "initialize"; // Count: 4
var _DYN_IDENTIFIER = "identifier"; // Count: 8
var _DYN_IS_INITIALIZED = "isInitialized"; // Count: 10
var _DYN_GET_PLUGIN = "getPlugin"; // Count: 6
var _DYN_POLL_INTERNAL_LOGS = "pollInternalLogs"; // Count: 2
var _DYN_NAME$3 = "name"; // Count: 11
var _DYN_TIME = "time"; // Count: 6
var _DYN_PROCESS_NEXT = "processNext"; // Count: 15
var _DYN_GET_PROCESS_TEL_CONT0 = "getProcessTelContext"; // Count: 2
var _DYN_GET_NOTIFY_MGR = "getNotifyMgr"; // Count: 5
var _DYN_ADD_NOTIFICATION_LIS1 = "addNotificationListener"; // Count: 4
var _DYN_REMOVE_NOTIFICATION_2 = "removeNotificationListener"; // Count: 4
var _DYN_ENABLED = "enabled"; // Count: 6
var _DYN_STOP_POLLING_INTERNA3 = "stopPollingInternalLogs"; // Count: 2
var _DYN_UNLOAD = "unload"; // Count: 9
var _DYN_ON_COMPLETE = "onComplete"; // Count: 5
var _DYN_VERSION$1 = "version"; // Count: 6
var _DYN_LOGGING_LEVEL_CONSOL4 = "loggingLevelConsole"; // Count: 2
var _DYN_CREATE_NEW$1 = "createNew"; // Count: 7
var _DYN_TEARDOWN = "teardown"; // Count: 9
var _DYN_MESSAGE_ID = "messageId"; // Count: 4
var _DYN_MESSAGE$2 = "message"; // Count: 6
var _DYN_IS_ASYNC = "isAsync"; // Count: 6
var _DYN_DIAG_LOG$2 = "diagLog"; // Count: 10
var _DYN__DO_TEARDOWN = "_doTeardown"; // Count: 4
var _DYN_UPDATE$1 = "update"; // Count: 6
var _DYN_GET_NEXT = "getNext"; // Count: 12
var _DYN_SET_NEXT_PLUGIN = "setNextPlugin"; // Count: 5
var _DYN_USER_AGENT = "userAgent"; // Count: 5
var _DYN_SPLIT$1 = "split"; // Count: 6
var _DYN_NODE_TYPE = "nodeType"; // Count: 3
var _DYN_REPLACE = "replace"; // Count: 8
var _DYN_LOG_INTERNAL_MESSAGE = "logInternalMessage"; // Count: 2
var _DYN_TYPE = "type"; // Count: 14
var _DYN_HANDLER = "handler"; // Count: 5
var _DYN_IS_CHILD_EVT = "isChildEvt"; // Count: 3
var _DYN_GET_CTX = "getCtx"; // Count: 6
var _DYN_SET_CTX = "setCtx"; // Count: 10
var _DYN_COMPLETE = "complete"; // Count: 3
var _DYN_TRACE_ID$2 = "traceId"; // Count: 5
var _DYN_SPAN_ID$1 = "spanId"; // Count: 5
var _DYN_TRACE_FLAGS$1 = "traceFlags"; // Count: 6

/*
 * Application Insights JavaScript SDK - Core, 3.0.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */

var aggregationErrorType;
/**
 * Throws an Aggregation Error which includes all of the errors that led to this error occurring
 * @param message - The message describing the aggregation error (the sourceError details are added to this)
 * @param sourceErrors - An array of the errors that caused this situation
 */
function throwAggregationError(message, sourceErrors) {
    if (!aggregationErrorType) {
        aggregationErrorType = createCustomError("AggregationError", function (self, args) {
            if (args[_DYN_LENGTH$5 /* @min:%2elength */] > 1) {
                // Save the provided errors
                self.errors = args[1];
            }
        });
    }
    var theMessage = message || "One or more errors occurred.";
    arrForEach(sourceErrors, function (srcError, idx) {
        theMessage += "\n".concat(idx, " > ").concat(dumpObj(srcError));
    });
    throw new aggregationErrorType(theMessage, sourceErrors || []);
}

/*
 * @nevware21/ts-async
 * https://github.com/nevware21/ts-async
 *
 * Copyright (c) 2022 Nevware21
 * Licensed under the MIT license.
 */
function doAwaitResponse(value, cb) {
    return doAwait(value, function (value) {
        cb && cb({
            value: value,
            rejected: false
        });
    }, function (reason) {
        cb && cb({
            rejected: true,
            reason: reason
        });
    });
}
/**
 * Wait for the promise to resolve or reject, if resolved the callback function will be called with it's value and if
 * rejected the rejectFn will be called with the reason. If the passed promise argument is not a promise the callback
 * will be called synchronously with the value.
 * @group Await Helper
 * @param value - The value or promise like value to wait for
 * @param resolveFn - The callback to call on the promise successful resolving.
 * @param rejectFn - The callback to call when the promise rejects
 * @returns The passed value, if it is a promise and there is either a resolve or reject handler
 * then it will return a chained promise with the value from the resolve or reject handler (depending
 * whether it resolve or rejects)
 * @example
 * ```ts
 * let promise = createPromise<number>((resolve, reject) => {
 *     resolve(42);
 * });
 *
 * // Handle via a chained promise
 * let chainedPromise = promise.then((value) => {
 *     // Do something with the value
 * });
 *
 * // Handle via doAwait
 * doAwait(promise, (value) => {
 *     // Do something with the value
 * });
 *
 * // It can also handle the raw value, so you could process the result of either a
 * // synchrounous return of the value or a Promise
 * doAwait(42, (value) => {
 *     // Do something with the value
 * });
 * ```
 */
function doAwait(value, resolveFn, rejectFn, finallyFn) {
    var result = value;
    if (isPromiseLike(value)) {
        if (resolveFn || rejectFn) {
            result = value.then(resolveFn, rejectFn);
        }
    }
    else {
        resolveFn && resolveFn(value);
    }
    if (finallyFn) {
        result = doFinally(result, finallyFn);
    }
    return result;
}
/**
 * Wait for the promise to resolve or reject and then call the finallyFn. If the passed promise argument is not a promise the callback
 * will be called synchronously with the value. If the passed promise doesn't implement finally then a finally implementation will be
 * simulated using then(..., ...).
 * @group Await Helper
 * @param value - The value or promise like value to wait for
 * @param finallyFn - The finally function to call once the promise has resolved or rejected
 */
function doFinally(value, finallyFn) {
    var result = value;
    if (finallyFn) {
        if (isPromiseLike(value)) {
            if (value.finally) {
                result = value.finally(finallyFn);
            }
            else {
                // Simulate finally if not available
                result = value.then(function (value) {
                    finallyFn();
                    return value;
                }, function (reason) {
                    finallyFn();
                    throw reason;
                });
            }
        }
        else {
            finallyFn();
        }
    }
    return result;
}

/*
 * @nevware21/ts-async
 * https://github.com/nevware21/ts-async
 *
 * Copyright (c) 2022 Nevware21
 * Licensed under the MIT license.
 */
/**
 * @ignore -- Don't include in the generated documentation
 * @internal
 */
var STRING_STATES = [
    "pending", "resolving", "resolved", "rejected"
];

/*
 * @nevware21/ts-async
 * https://github.com/nevware21/ts-async
 *
 * Copyright (c) 2022 Nevware21
 * Licensed under the MIT license.
 */
var DISPATCH_EVENT = "dispatchEvent";
var _hasInitEvent;
/**
 * @internal
 * @ignore
 * @param target
 * @param evtName
 * @param populateEvent
 * @param useNewEvent
 */
function emitEvent(target, evtName, populateEvent, useNewEvent) {
    var doc = getDocument();
    !_hasInitEvent && (_hasInitEvent = safeGetLazy(function () {
        var evt;
        if (doc && doc.createEvent) {
            evt = doc.createEvent("Event");
        }
        return (!!evt && evt.initEvent);
    }, null));
    var theEvt = _hasInitEvent.v ? doc.createEvent("Event") : (useNewEvent ? new Event(evtName) : {});
    populateEvent && populateEvent(theEvt);
    if (_hasInitEvent.v) {
        theEvt.initEvent(evtName, false, true);
    }
    if (theEvt && target[DISPATCH_EVENT]) {
        target[DISPATCH_EVENT](theEvt);
    }
    else {
        var handler = target["on" + evtName];
        if (handler) {
            handler(theEvt);
        }
        else {
            var theConsole = getInst("console");
            theConsole && (theConsole["error"] || theConsole["log"])(evtName, dumpObj(theEvt));
        }
    }
}

/*
 * @nevware21/ts-async
 * https://github.com/nevware21/ts-async
 *
 * Copyright (c) 2023 Nevware21
 * Licensed under the MIT license.
 */
var STR_PROMISE = "Promise";

/*
 * @nevware21/ts-async
 * https://github.com/nevware21/ts-async
 *
 * Copyright (c) 2022 Nevware21
 * Licensed under the MIT license.
 */
var NODE_UNHANDLED_REJECTION = "unhandledRejection";
var UNHANDLED_REJECTION = NODE_UNHANDLED_REJECTION.toLowerCase();
var _currentPromiseId = [];
var _uniquePromiseId = 0;
var _unhandledRejectionTimeout = 10;
var _hasPromiseRejectionEvent;
function dumpFnObj(value) {
    if (isFunction(value)) {
        return value.toString();
    }
    return dumpObj(value);
}
function _createPromise(newPromise, processor, executor) {
    var additionalArgs = arrSlice(arguments, 3);
    var _state = 0 /* ePromiseState.Pending */;
    var _hasResolved = false;
    var _settledValue;
    var _queue = [];
    var _id = _uniquePromiseId++;
    var _handled = false;
    var _unHandledRejectionHandler = null;
    var _thePromise;
    !_hasPromiseRejectionEvent && (_hasPromiseRejectionEvent = lazySafeGetInst(STR_PROMISE + "RejectionEvent"));
    // https://tc39.es/ecma262/#sec-promise.prototype.then
    var _then = function (onResolved, onRejected) {
        try {
            _currentPromiseId.push(_id);
            _handled = true;
            _unHandledRejectionHandler && _unHandledRejectionHandler.cancel();
            _unHandledRejectionHandler = null;
            //#ifdef DEBUG
            //#:(!DEBUG) _debugLog(_toString(), "then(" + dumpFnObj(onResolved)+ ", " + dumpFnObj(onResolved) +  ")");
            //#endif
            var thenPromise = newPromise(function (resolve, reject) {
                // Queue the new promise returned to be resolved or rejected
                // when this promise settles.
                _queue.push(function () {
                    // https://tc39.es/ecma262/#sec-newpromisereactionjob
                    //let value: any;
                    try {
                        // First call the onFulfilled or onRejected handler, on the settled value
                        // of this promise. If the corresponding `handler` does not exist, simply
                        // pass through the settled value.
                        //#ifdef DEBUG
                        //#:(!DEBUG) _debugLog(_toString(), "Handling settled value " + dumpFnObj(_settledValue));
                        //#endif
                        var handler = _state === 2 /* ePromiseState.Resolved */ ? onResolved : onRejected;
                        var value = isUndefined(handler) ? _settledValue : (isFunction(handler) ? handler(_settledValue) : handler);
                        //#ifdef DEBUG
                        //#:(!DEBUG) _debugLog(_toString(), "Handling Result " + dumpFnObj(value));
                        //#endif
                        if (isPromiseLike(value)) {
                            // The called handlers returned a new promise, so the chained promise
                            // will follow the state of this promise.
                            value.then(resolve, reject);
                        }
                        else if (handler) {
                            // If we have a handler then chained promises are always "resolved" with the result returned
                            resolve(value);
                        }
                        else if (_state === 3 /* ePromiseState.Rejected */) {
                            // If this promise is rejected then the chained promise should be rejected
                            // with either the settled value of this promise or the return value of the handler.
                            reject(value);
                        }
                        else {
                            // If this promise is fulfilled, then the chained promise is also fulfilled
                            // with either the settled value of this promise or the return value of the handler.
                            resolve(value);
                        }
                    }
                    catch (e) {
                        reject(e);
                    }
                });
                //#ifdef DEBUG
                //#:(!DEBUG) _debugLog(_toString(), "Added to Queue " + _queue.length);
                //#endif
                // If this promise is already settled, then immediately process the callback we
                // just added to the queue.
                if (_hasResolved) {
                    _processQueue();
                }
            }, additionalArgs);
            //#ifdef DEBUG
            //#:(!DEBUG) _debugLog(_toString(), "Created -> " + thenPromise.toString());
            //#endif
            return thenPromise;
        }
        finally {
            _currentPromiseId.pop();
        }
    };
    // https://tc39.es/ecma262/#sec-promise.prototype.catch
    var _catch = function (onRejected) {
        // Reuse then onRejected to support rejection
        return _then(undefined, onRejected);
    };
    // https://tc39.es/ecma262/#sec-promise.prototype.finally
    var _finally = function (onFinally) {
        var thenFinally = onFinally;
        var catchFinally = onFinally;
        if (isFunction(onFinally)) {
            thenFinally = function (value) {
                onFinally && onFinally();
                return value;
            };
            catchFinally = function (reason) {
                onFinally && onFinally();
                throw reason;
            };
        }
        return _then(thenFinally, catchFinally);
    };
    var _strState = function () {
        return STRING_STATES[_state];
    };
    var _processQueue = function () {
        if (_queue.length > 0) {
            // The onFulfilled and onRejected handlers must be called asynchronously. Thus,
            // we make a copy of the queue and work on it once the current call stack unwinds.
            var pending = _queue.slice();
            _queue = [];
            //#ifdef DEBUG
            //#:(!DEBUG) _debugLog(_toString(), "Processing queue " + pending.length);
            //#endif
            _handled = true;
            processor(pending);
            //#ifdef DEBUG
            //#:(!DEBUG) _debugLog(_toString(), "Processing done");
            //#endif
            _unHandledRejectionHandler && _unHandledRejectionHandler.cancel();
            _unHandledRejectionHandler = null;
        }
    };
    var _createSettleIfFn = function (newState, allowState) {
        return function (theValue) {
            if (_state === allowState) {
                if (newState === 2 /* ePromiseState.Resolved */ && isPromiseLike(theValue)) {
                    _state = 1 /* ePromiseState.Resolving */;
                    //#ifdef DEBUG
                    //#:(!DEBUG) _debugLog(_toString(), "Resolving");
                    //#endif
                    theValue.then(_createSettleIfFn(2 /* ePromiseState.Resolved */, 1 /* ePromiseState.Resolving */), _createSettleIfFn(3 /* ePromiseState.Rejected */, 1 /* ePromiseState.Resolving */));
                    return;
                }
                _state = newState;
                _hasResolved = true;
                _settledValue = theValue;
                //#ifdef DEBUG
                //#:(!DEBUG) _debugLog(_toString(), _strState());
                //#endif
                _processQueue();
                if (!_handled && newState === 3 /* ePromiseState.Rejected */ && !_unHandledRejectionHandler) {
                    _unHandledRejectionHandler = scheduleTimeout(_notifyUnhandledRejection, _unhandledRejectionTimeout);
                }
            }
        };
    };
    var _notifyUnhandledRejection = function () {
        if (!_handled) {
            if (isNode()) {
                //#ifdef DEBUG
                //#:(!DEBUG) _debugLog(_toString(), "Emitting " + NODE_UNHANDLED_REJECTION);
                //#endif
                process.emit(NODE_UNHANDLED_REJECTION, _settledValue, _thePromise);
            }
            else {
                var gbl = getWindow() || getGlobal();
                //#ifdef DEBUG
                //#:(!DEBUG) _debugLog(_toString(), "Emitting " + UNHANDLED_REJECTION);
                //#endif
                emitEvent(gbl, UNHANDLED_REJECTION, function (theEvt) {
                    objDefine(theEvt, "promise", { g: function () { return _thePromise; } });
                    theEvt.reason = _settledValue;
                    return theEvt;
                }, !!_hasPromiseRejectionEvent.v);
            }
        }
    };
    _thePromise = {
        then: _then,
        "catch": _catch,
        finally: _finally
    };
    objDefineProp(_thePromise, "state", {
        get: _strState
    });
    if (hasSymbol()) {
        _thePromise[getKnownSymbol(11 /* WellKnownSymbols.toStringTag */)] = "IPromise";
    }
    var _toString = function () {
        return "IPromise" + ("") + " " + _strState() + (_hasResolved ? (" - " + dumpFnObj(_settledValue)) : "");
    };
    _thePromise.toString = _toString;
    (function _initialize() {
        if (!isFunction(executor)) {
            throwTypeError(STR_PROMISE + ": executor is not a function - " + dumpFnObj(executor));
        }
        var _rejectFn = _createSettleIfFn(3 /* ePromiseState.Rejected */, 0 /* ePromiseState.Pending */);
        try {
            //#ifdef DEBUG
            //#:(!DEBUG) _debugLog(_toString(), "Executing");
            //#endif
            executor.call(_thePromise, _createSettleIfFn(2 /* ePromiseState.Resolved */, 0 /* ePromiseState.Pending */), _rejectFn);
        }
        catch (e) {
            _rejectFn(e);
        }
    })();
    //#ifdef DEBUG
    //#:(!DEBUG) _debugLog(_toString(), "Returning");
    //#endif
    return _thePromise;
}
/**
 * @ignore
 * @internal
 * Returns a function which when called will return a new Promise object that resolves to an array of the
 * results from the input promises. The returned promise will resolve when all of the inputs' promises have
 * resolved, or if the input contains no promises. It rejects immediately upon any of the input promises
 * rejected or non-promises throwing an error, and will reject with this first rejection message / error.
 * @param newPromise - The delegate function used to create a new promise object the new promise instance.
 * @returns A function to create a promise that will be resolved when all arguments are resolved.
 */
function _createAllPromise(newPromise) {
    return function (input) {
        var additionalArgs = arrSlice(arguments, 1);
        return newPromise(function (resolve, reject) {
            try {
                var values_1 = [];
                var pending_1 = 1; // Prefix to 1 so we finish iterating over all of the input promises first
                arrForEach(input, function (item, idx) {
                    if (item) {
                        pending_1++;
                        doAwait(item, function (value) {
                            // Set the result values
                            values_1[idx] = value;
                            if (--pending_1 === 0) {
                                resolve(values_1);
                            }
                        }, reject);
                    }
                });
                // Now decrement the pending so that we finish correctly
                pending_1--;
                if (pending_1 === 0) {
                    // All promises were either resolved or where not a promise
                    resolve(values_1);
                }
            }
            catch (e) {
                reject(e);
            }
        }, additionalArgs);
    };
}

/*
 * @nevware21/ts-async
 * https://github.com/nevware21/ts-async
 *
 * Copyright (c) 2022 Nevware21
 * Licensed under the MIT license.
 */
var _processPendingItems = function (pending) {
    arrForEach(pending, function (fn) {
        try {
            fn();
        }
        catch (e) {
            // Don't let 1 failing handler break all others
            // TODO: Add some form of error reporting (i.e. Call any registered JS error handler so the error is reported)
        }
    });
};
/**
 * @internal
 * @ignore
 * Return an item processor that processes all of the pending items asynchronously using the optional timeout.
 * @param timeout - Optional timeout to wait before processing the items, defaults to zero.
 * @return An item processor
 */
function timeoutItemProcessor(timeout) {
    var callbackTimeout = isNumber(timeout) ? timeout : 0;
    return function (pending) {
        scheduleTimeout(function () {
            _processPendingItems(pending);
        }, callbackTimeout);
    };
}

/*
 * @nevware21/ts-async
 * https://github.com/nevware21/ts-async
 *
 * Copyright (c) 2022 Nevware21
 * Licensed under the MIT license.
 */
/**
 * Creates an asynchronous Promise instance that when resolved or rejected will execute it's pending chained operations
 * __asynchronously__ using the optional provided timeout value to schedule when the chained items will be ececuted.
 * @group Async
 * @group Promise
 * @param executor - The function to be executed during the creation of the promise. Any errors thrown in the executor will
 * cause the promise to be rejected. The return value of the executor is always ignored
 * @param timeout - Optional timeout to wait before processing the items, defaults to zero.
 */
function createAsyncPromise(executor, timeout) {
    return _createPromise(createAsyncPromise, timeoutItemProcessor(timeout), executor, timeout);
}

/*
 * @nevware21/ts-async
 * https://github.com/nevware21/ts-async
 *
 * Copyright (c) 2022 Nevware21
 * Licensed under the MIT license.
 */
var _isPromiseSupported;
/**
 * Creates a Promise instance that when resolved or rejected will execute it's pending chained operations using the
 * available native Promise implementation.
 * If runtime does not support native `Promise` class (or no polyfill is available) this function will fallback to using
 * `createAsyncPromise` which will resolve them __asynchronously__ using the optional provided timeout value to
 * schedule when the chained items will be executed.
 * @group Alias
 * @group Promise
 * @group Native
 * @param executor - The function to be executed during the creation of the promise. Any errors thrown in the executor will
 * cause the promise to be rejected. The return value of the executor is always ignored
 * @param timeout - Optional timeout to wait before processing the items, defaults to zero.
 */
function createNativePromise(executor, timeout) {
    !_isPromiseSupported && (_isPromiseSupported = lazySafeGetInst(STR_PROMISE));
    var PrmCls = _isPromiseSupported.v;
    if (!PrmCls) {
        return createAsyncPromise(executor);
    }
    if (!isFunction(executor)) {
        throwTypeError(STR_PROMISE + ": executor is not a function - " + dumpObj(executor));
    }
    var _state = 0 /* ePromiseState.Pending */;
    function _strState() {
        return STRING_STATES[_state];
    }
    var thePromise = new PrmCls(function (resolve, reject) {
        function _resolve(value) {
            _state = 2 /* ePromiseState.Resolved */;
            resolve(value);
        }
        function _reject(reason) {
            _state = 3 /* ePromiseState.Rejected */;
            reject(reason);
        }
        executor(_resolve, _reject);
    });
    objDefineProp(thePromise, "state", {
        get: _strState
    });
    return thePromise;
}

/*
 * @nevware21/ts-async
 * https://github.com/nevware21/ts-async
 *
 * Copyright (c) 2022 Nevware21
 * Licensed under the MIT license.
 */
var _promiseCreator;
/**
 * Creates a Promise instance using the current default promise creator that when resolved or rejected will execute
 * it's pending chained operations.
 * @group Alias
 * @group Promise
 * @param executor - The function to be executed during the creation of the promise. Any errors thrown in the executor will
 * cause the promise to be rejected. The return value of the executor is always ignored
 * @param timeout - [Optional] timeout to wait before processing the items, defaults to zero.
 */
function createPromise(executor, timeout) {
    !_promiseCreator && (_promiseCreator = getLazy(function () { return createNativePromise; }));
    return _promiseCreator.v.call(this, executor, timeout);
}
/**
 * Returns a single asynchronous Promise instance that resolves to an array of the results from the input promises.
 * This returned promise will resolve and execute it's pending chained operations __asynchronously__ using the optional
 * provided timeout value to schedule when the chained items will be executed, or if the input contains no promises.
 * It rejects immediately upon any of the input promises rejected or non-promises throwing an error,
 * and will reject with this first rejection message / error.
 * If the runtime doesn't support the Promise.all it will fallback back to an asynchronous Promise implementation.
 * @group Alias
 * @group All
 * @param input - The array of promises to wait to be resolved / rejected before resolving or rejecting the new promise
 * @param timeout
 * @returns
 * <ul>
 * <li> An already resolved `Promise`, if the input passed is empty.
 * <li> A pending `Promise` in all other cases. This returned promise is then resolved/rejected __synchronously__
 * (as soon as the pending items is empty) when all the promises in the given input have resolved, or if any of the
 * promises reject.
 * </ul>
 */
var createAllPromise = _createAllPromise(createPromise);

/*
 * Application Insights JavaScript SDK - Core, 3.0.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


// ###################################################################################################################################################
// Note: DON'T Export these const from the package as we are still targeting IE/ES5 this will export a mutable variables that someone could change ###
// ###################################################################################################################################################
var UNDEFINED_VALUE$2 = undefined;
var STR_EMPTY = "";
var STR_CHANNELS = "channels";
var STR_CORE = "core";
var STR_CREATE_PERF_MGR = "createPerfMgr";
var STR_DISABLED = "disabled";
var STR_EXTENSION_CONFIG = "extensionConfig";
var STR_EXTENSIONS = "extensions";
var STR_PROCESS_TELEMETRY = "processTelemetry";
var STR_PRIORITY = "priority";
var STR_EVENTS_SENT = "eventsSent";
var STR_EVENTS_DISCARDED = "eventsDiscarded";
var STR_EVENTS_SEND_REQUEST = "eventsSendRequest";
var STR_PERF_EVENT = "perfEvent";
var STR_GET_PERF_MGR = "getPerfMgr";
var STR_DOMAIN = "domain";
var STR_PATH = "path";
var STR_NOT_DYNAMIC_ERROR = "Not dynamic - ";

/*
 * Application Insights JavaScript SDK - Core, 3.0.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */

// RESTRICT and AVOID circular dependencies you should not import other contained modules or export the contents of this file directly
// Added to help with minification
var strGetPrototypeOf = "getPrototypeOf";
var rCamelCase = /-([a-z])/g;
var rNormalizeInvalid = /([^\w\d_$])/g;
var rLeadingNumeric = /^(\d+[\w\d_$])/;
var _getObjProto = Object[strGetPrototypeOf];
function isNotNullOrUndefined(value) {
    return !isNullOrUndefined(value);
}
/**
 * Validates that the string name conforms to the JS IdentifierName specification and if not
 * normalizes the name so that it would. This method does not identify or change any keywords
 * meaning that if you pass in a known keyword the same value will be returned.
 * This is a simplified version
 * @param name - The name to validate
 */
function normalizeJsName(name) {
    var value = name;
    if (value && isString(value)) {
        // CamelCase everything after the "-" and remove the dash
        value = value[_DYN_REPLACE /* @min:%2ereplace */](rCamelCase, function (_all, letter) {
            return letter.toUpperCase();
        });
        value = value[_DYN_REPLACE /* @min:%2ereplace */](rNormalizeInvalid, "_");
        value = value[_DYN_REPLACE /* @min:%2ereplace */](rLeadingNumeric, function (_all, match) {
            return "_" + match;
        });
    }
    return value;
}
/**
 * A simple wrapper (for minification support) to check if the value contains the search string.
 * @param value - The string value to check for the existence of the search value
 * @param search - The value search within the value
 */
function strContains(value, search) {
    if (value && search) {
        return strIndexOf(value, search) !== -1;
    }
    return false;
}
/**
 * Convert a date to I.S.O. format in IE8
 */
function toISOString(date) {
    return date && date.toISOString() || "";
}
/**
 * Returns the name of object if it's an Error. Otherwise, returns empty string.
 */
function getExceptionName(object) {
    if (isError(object)) {
        return object[_DYN_NAME$3 /* @min:%2ename */];
    }
    return STR_EMPTY;
}
/**
 * Sets the provided value on the target instance using the field name when the provided chk function returns true, the chk
 * function will only be called if the new value is no equal to the original value.
 * @param target - The target object
 * @param field - The key of the target
 * @param value - The value to set
 * @param valChk - [Optional] Callback to check the value that if supplied will be called check if the new value can be set
 * @param srcChk - [Optional] Callback to check to original value that if supplied will be called if the new value should be set (if allowed)
 * @returns The existing or new value, depending what was set
 */
function setValue(target, field, value, valChk, srcChk) {
    var theValue = value;
    if (target) {
        theValue = target[field];
        if (theValue !== value && (!srcChk || srcChk(theValue)) && (!valChk || valChk(value))) {
            theValue = value;
            target[field] = theValue;
        }
    }
    return theValue;
}
/**
 * Returns the current value from the target object if not null or undefined otherwise sets the new value and returns it
 * @param target - The target object to return or set the default value
 * @param field - The key for the field to set on the target
 * @param defValue - [Optional] The value to set if not already present, when not provided a empty object will be added
 */
function getSetValue(target, field, defValue) {
    var theValue;
    if (target) {
        theValue = target[field];
        if (!theValue && isNullOrUndefined(theValue)) {
            // Supports having the default as null
            theValue = !isUndefined(defValue) ? defValue : {};
            target[field] = theValue;
        }
    }
    else {
        // Expanded for performance so we only check defValue if required
        theValue = !isUndefined(defValue) ? defValue : {};
    }
    return theValue;
}
function _createProxyFunction(source, funcName) {
    var srcFunc = null;
    var src = null;
    if (isFunction(source)) {
        srcFunc = source;
    }
    else {
        src = source;
    }
    return function () {
        // Capture the original arguments passed to the method
        var originalArguments = arguments;
        if (srcFunc) {
            src = srcFunc();
        }
        if (src) {
            return src[funcName][_DYN_APPLY /* @min:%2eapply */](src, originalArguments);
        }
    };
}
/**
 * Effectively assigns all enumerable properties (not just own properties) and functions (including inherited prototype) from
 * the source object to the target, it attempts to use proxy getters / setters (if possible) and proxy functions to avoid potential
 * implementation issues by assigning prototype functions as instance ones
 *
 * This method is the primary method used to "update" the snippet proxy with the ultimate implementations.
 *
 * Special ES3 Notes:
 * Updates (setting) of direct property values on the target or indirectly on the source object WILL NOT WORK PROPERLY, updates to the
 * properties of "referenced" object will work (target.context.newValue = 10 => will be reflected in the source.context as it's the
 * same object). ES3 Failures: assigning target.myProp = 3 -> Won't change source.myProp = 3, likewise the reverse would also fail.
 * @param target - The target object to be assigned with the source properties and functions
 * @param source - The source object which will be assigned / called by setting / calling the targets proxies
 * @param chkSet - An optional callback to determine whether a specific property/function should be proxied
 */
function proxyAssign(target, source, chkSet) {
    if (target && source && isObject(target) && isObject(source)) {
        var _loop_1 = function (field) {
            if (isString(field)) {
                var value = source[field];
                if (isFunction(value)) {
                    if (!chkSet || chkSet(field, true, source, target)) {
                        // Create a proxy function rather than just copying the (possible) prototype to the new object as an instance function
                        target[field] = _createProxyFunction(source, field);
                    }
                }
                else if (!chkSet || chkSet(field, false, source, target)) {
                    if (objHasOwn(target, field)) {
                        // Remove any previous instance property
                        delete target[field];
                    }
                    objDefine(target, field, {
                        g: function () {
                            return source[field];
                        },
                        s: function (theValue) {
                            source[field] = theValue;
                        }
                    });
                }
            }
        };
        // effectively apply/proxy full source to the target instance
        for (var field in source) {
            _loop_1(field);
        }
    }
    return target;
}
/**
 * Creates a proxy function on the target which internally will call the source version with all arguments passed to the target method.
 *
 * @param target - The target object to be assigned with the source properties and functions
 * @param name - The function name that will be added on the target
 * @param source - The source object which will be assigned / called by setting / calling the targets proxies
 * @param theFunc - The function name on the source that will be proxied on the target
 * @param overwriteTarget - If `false` this will not replace any pre-existing name otherwise (the default) it will overwrite any existing name
 */
function proxyFunctionAs(target, name, source, theFunc, overwriteTarget) {
    if (target && name && source) {
        if (overwriteTarget !== false || isUndefined(target[name])) {
            target[name] = _createProxyFunction(source, theFunc);
        }
    }
}
/**
 * Creates proxy functions on the target which internally will call the source version with all arguments passed to the target method.
 *
 * @param target - The target object to be assigned with the source properties and functions
 * @param source - The source object which will be assigned / called by setting / calling the targets proxies
 * @param functionsToProxy - An array of function names that will be proxied on the target
 * @param overwriteTarget - If false this will not replace any pre-existing name otherwise (the default) it will overwrite any existing name
 */
function proxyFunctions(target, source, functionsToProxy, overwriteTarget) {
    if (target && source && isObject(target) && isArray(functionsToProxy)) {
        arrForEach(functionsToProxy, function (theFuncName) {
            if (isString(theFuncName)) {
                proxyFunctionAs(target, theFuncName, source, theFuncName, overwriteTarget);
            }
        });
    }
    return target;
}
/**
 * Simpler helper to create a dynamic class that implements the interface and populates the values with the defaults.
 * Only instance properties (hasOwnProperty) values are copied from the defaults to the new instance
 * @param defaults - Simple helper
 */
function createClassFromInterface(defaults) {
    return /** @class */ (function () {
        function class_1() {
            var _this = this;
            if (defaults) {
                objForEachKey(defaults, function (field, value) {
                    _this[field] = value;
                });
            }
        }
        return class_1;
    }());
}
/**
 * A helper function to assist with JIT performance for objects that have properties added / removed dynamically
 * this is primarily for chromium based browsers and has limited effects on Firefox and none of IE. Only call this
 * function after you have finished "updating" the object, calling this within loops reduces or defeats the benefits.
 * This helps when iterating using for..in, objKeys() and objForEach()
 * @param theObject - The object to be optimized if possible
 */
function optimizeObject(theObject) {
    // V8 Optimization to cause the JIT compiler to create a new optimized object for looking up the own properties
    // primarily for object with <= 19 properties for >= 20 the effect is reduced or non-existent
    if (theObject && objAssign) {
        theObject = ObjClass(objAssign({}, theObject));
    }
    return theObject;
}
function objExtend(obj1, obj2, obj3, obj4, obj5, obj6) {
    // Variables
    var theArgs = arguments;
    var extended = theArgs[0] || {};
    var argLen = theArgs[_DYN_LENGTH$5 /* @min:%2elength */];
    var deep = false;
    var idx = 1;
    // Check for "Deep" flag
    if (argLen > 0 && isBoolean(extended)) {
        deep = extended;
        extended = theArgs[idx] || {};
        idx++;
    }
    // Handle case when target is a string or something (possible in deep copy)
    if (!isObject(extended)) {
        extended = {};
    }
    // Loop through each remaining object and conduct a merge
    for (; idx < argLen; idx++) {
        var arg = theArgs[idx];
        var isArgArray = isArray(arg);
        var isArgObj = isObject(arg);
        for (var prop in arg) {
            var propOk = (isArgArray && (prop in arg)) || (isArgObj && objHasOwn(arg, prop));
            if (!propOk) {
                continue;
            }
            var newValue = arg[prop];
            var isNewArray = void 0;
            // If deep merge and property is an object, merge properties
            if (deep && newValue && ((isNewArray = isArray(newValue)) || isPlainObject(newValue))) {
                // Grab the current value of the extended object
                var clone = extended[prop];
                if (isNewArray) {
                    if (!isArray(clone)) {
                        // We can't "merge" an array with a non-array so overwrite the original
                        clone = [];
                    }
                }
                else if (!isPlainObject(clone)) {
                    // We can't "merge" an object with a non-object
                    clone = {};
                }
                // Never move the original objects always clone them
                newValue = objExtend(deep, clone, newValue);
            }
            // Assign the new (or previous) value (unless undefined)
            if (newValue !== undefined) {
                extended[prop] = newValue;
            }
        }
    }
    return extended;
}
function isFeatureEnabled(feature, cfg) {
    var rlt = false;
    var ft = cfg && cfg.featureOptIn && cfg.featureOptIn[feature];
    if (feature && ft) {
        var mode = ft.mode;
        // NOTE: None will be considered as true
        rlt = (mode == 3 /* FeatureOptInMode.enable */) || (mode == 1 /* FeatureOptInMode.none */);
    }
    return rlt;
}

/*
 * Application Insights JavaScript SDK - Core, 3.0.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */

/**
 * This file exists to hold environment utilities that are required to check and
 * validate the current operating environment. Unless otherwise required, please
 * only use defined methods (functions) in this class so that users of these
 * functions/properties only need to include those that are used within their own modules.
 */
var strDocumentMode = "documentMode";
var strLocation = "location";
var strConsole = "console";
var strJSON = "JSON";
var strCrypto = "crypto";
var strMsCrypto = "msCrypto";
var strReactNative = "ReactNative";
var strMsie = "msie";
var strTrident = "trident/";
var strXMLHttpRequest = "XMLHttpRequest";
var _isTrident = null;
var _navUserAgentCheck = null;
var _enableMocks = false;
var _useXDomainRequest = null;
var _beaconsSupported = null;
function _hasProperty(theClass, property) {
    var supported = false;
    if (theClass) {
        try {
            supported = property in theClass;
            if (!supported) {
                var proto = theClass[strShimPrototype];
                if (proto) {
                    supported = property in proto;
                }
            }
        }
        catch (e) {
            // Do Nothing
        }
        if (!supported) {
            try {
                var tmp = new theClass();
                supported = !isUndefined(tmp[property]);
            }
            catch (e) {
                // Do Nothing
            }
        }
    }
    return supported;
}
/**
 * Returns the global location object if it is present otherwise null.
 * This helper is used to access the location object without causing an exception
 * "Uncaught ReferenceError: location is not defined"
 */
function getLocation(checkForMock) {
    if (checkForMock && _enableMocks) {
        var mockLocation = getInst("__mockLocation");
        if (mockLocation) {
            return mockLocation;
        }
    }
    if (typeof location === strShimObject && location) {
        return location;
    }
    return getInst(strLocation);
}
/**
 * Returns the global console object
 */
function getConsole() {
    if (typeof console !== strShimUndefined) {
        return console;
    }
    return getInst(strConsole);
}
/**
 * Checks if JSON object is available, this is required as we support the API running without a
 * window /document (eg. Node server, electron webworkers) and if we attempt to assign a history
 * object to a local variable or pass as an argument an "Uncaught ReferenceError: JSON is not defined"
 * exception will be thrown.
 * Defined as a function to support lazy / late binding environments.
 */
function hasJSON() {
    return Boolean((typeof JSON === strShimObject && JSON) || getInst(strJSON) !== null);
}
/**
 * Returns the global JSON object if it is present otherwise null.
 * This helper is used to access the JSON object without causing an exception
 * "Uncaught ReferenceError: JSON is not defined"
 */
function getJSON() {
    if (hasJSON()) {
        return JSON || getInst(strJSON);
    }
    return null;
}
/**
 * Returns the crypto object if it is present otherwise null.
 * This helper is used to access the crypto object from the current
 * global instance which could be window or globalThis for a web worker
 */
function getCrypto() {
    return getInst(strCrypto);
}
/**
 * Returns the crypto object if it is present otherwise null.
 * This helper is used to access the crypto object from the current
 * global instance which could be window or globalThis for a web worker
 */
function getMsCrypto() {
    return getInst(strMsCrypto);
}
/**
 * Returns whether the environment is reporting that we are running in a React Native Environment
 */
function isReactNative() {
    // If running in React Native, navigator.product will be populated
    var nav = getNavigator();
    if (nav && nav.product) {
        return nav.product === strReactNative;
    }
    return false;
}
/**
 * Identifies whether the current environment appears to be IE
 */
function isIE() {
    var nav = getNavigator();
    if (nav && (nav[_DYN_USER_AGENT /* @min:%2euserAgent */] !== _navUserAgentCheck || _isTrident === null)) {
        // Added to support test mocking of the user agent
        _navUserAgentCheck = nav[_DYN_USER_AGENT /* @min:%2euserAgent */];
        var userAgent = (_navUserAgentCheck || STR_EMPTY)[_DYN_TO_LOWER_CASE$2 /* @min:%2etoLowerCase */]();
        _isTrident = (strContains(userAgent, strMsie) || strContains(userAgent, strTrident));
    }
    return _isTrident;
}
/**
 * Gets IE version returning the document emulation mode if we are running on IE, or null otherwise
 */
function getIEVersion(userAgentStr) {
    if (userAgentStr === void 0) { userAgentStr = null; }
    if (!userAgentStr) {
        var navigator_1 = getNavigator() || {};
        userAgentStr = navigator_1 ? (navigator_1.userAgent || STR_EMPTY)[_DYN_TO_LOWER_CASE$2 /* @min:%2etoLowerCase */]() : STR_EMPTY;
    }
    var ua = (userAgentStr || STR_EMPTY)[_DYN_TO_LOWER_CASE$2 /* @min:%2etoLowerCase */]();
    // Also check for documentMode in case X-UA-Compatible meta tag was included in HTML.
    if (strContains(ua, strMsie)) {
        var doc = getDocument() || {};
        return Math.max(parseInt(ua[_DYN_SPLIT$1 /* @min:%2esplit */](strMsie)[1]), (doc[strDocumentMode] || 0));
    }
    else if (strContains(ua, strTrident)) {
        var tridentVer = parseInt(ua[_DYN_SPLIT$1 /* @min:%2esplit */](strTrident)[1]);
        if (tridentVer) {
            return tridentVer + 4;
        }
    }
    return null;
}
/**
 * Checks if HTML5 Beacons are supported in the current environment.
 * @param useCached - [Optional] used for testing to bypass the cached lookup, when `true` this will
 * cause the cached global to be reset.
 * @returns True if supported, false otherwise.
 */
function isBeaconsSupported(useCached) {
    if (_beaconsSupported === null || useCached === false) {
        _beaconsSupported = hasNavigator() && Boolean(getNavigator().sendBeacon);
    }
    return _beaconsSupported;
}
/**
 * Checks if the Fetch API is supported in the current environment.
 * @param withKeepAlive - [Optional] If True, check if fetch is available and it supports the keepalive feature, otherwise only check if fetch is supported
 * @returns True if supported, otherwise false
 */
function isFetchSupported(withKeepAlive) {
    var isSupported = false;
    try {
        isSupported = !!getInst("fetch");
        var request = getInst("Request");
        if (isSupported && withKeepAlive && request) {
            isSupported = _hasProperty(request, "keepalive");
        }
    }
    catch (e) {
        // Just Swallow any failure during availability checks
    }
    return isSupported;
}
function useXDomainRequest() {
    if (_useXDomainRequest === null) {
        _useXDomainRequest = (typeof XDomainRequest !== strShimUndefined);
        if (_useXDomainRequest && isXhrSupported()) {
            _useXDomainRequest = _useXDomainRequest && !_hasProperty(getInst(strXMLHttpRequest), "withCredentials");
        }
    }
    return _useXDomainRequest;
}
/**
 * Checks if XMLHttpRequest is supported
 * @returns True if supported, otherwise false
 */
function isXhrSupported() {
    var isSupported = false;
    try {
        var xmlHttpRequest = getInst(strXMLHttpRequest);
        isSupported = !!xmlHttpRequest;
    }
    catch (e) {
        // Just Swallow any failure during availability checks
    }
    return isSupported;
}
// TODO: should reuse this method for analytics plugin
function dispatchEvent(target, evnt) {
    if (target && target.dispatchEvent && evnt) {
        target.dispatchEvent(evnt);
        return true;
    }
    return false;
}
function createCustomDomEvent(eventName, details) {
    var event = null;
    var detail = { detail: details || null };
    if (isFunction(CustomEvent)) { // Use CustomEvent constructor when available
        event = new CustomEvent(eventName, detail);
    }
    else { // CustomEvent has no constructor in IE
        var doc = getDocument();
        if (doc && doc.createEvent) {
            event = doc.createEvent("CustomEvent");
            event.initCustomEvent(eventName, true, true, detail);
        }
    }
    return event;
}
function sendCustomEvent(evtName, cfg, customDetails) {
    var global = getGlobal();
    if (global && global.CustomEvent) {
        try {
            var details = { cfg: cfg || null, customDetails: customDetails || null };
            return dispatchEvent(global, createCustomDomEvent(evtName, details));
        }
        catch (e) {
            // eslint-disable-next-line no-empty
        }
    }
    return false;
}

/*
 * Application Insights JavaScript SDK - Core, 3.0.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */

var UInt32Mask = 0x100000000;
var MaxUInt32 = 0xffffffff;
var SEED1 = 123456789;
var SEED2 = 987654321;
// MWC based Random generator (for IE)
var _mwcSeeded = false;
var _mwcW = SEED1;
var _mwcZ = SEED2;
// Takes any integer
function _mwcSeed(seedValue) {
    if (seedValue < 0) {
        // Make sure we end up with a positive number and not -ve one.
        seedValue >>>= 0;
    }
    _mwcW = (SEED1 + seedValue) & MaxUInt32;
    _mwcZ = (SEED2 - seedValue) & MaxUInt32;
    _mwcSeeded = true;
}
function _autoSeedMwc() {
    // Simple initialization using default Math.random() - So we inherit any entropy from the browser
    // and bitwise XOR with the current milliseconds
    try {
        var now = utcNow() & 0x7fffffff;
        _mwcSeed(((Math.random() * UInt32Mask) ^ now) + now);
    }
    catch (e) {
        // Don't crash if something goes wrong
    }
}
/**
 * Generate a random value between 0 and maxValue, max value should be limited to a 32-bit maximum.
 * So maxValue(16) will produce a number from 0..16 (range of 17)
 * @param maxValue
 */
function randomValue(maxValue) {
    if (maxValue > 0) {
        return Math.floor((random32() / MaxUInt32) * (maxValue + 1)) >>> 0;
    }
    return 0;
}
/**
 * generate a random 32-bit number (0x000000..0xFFFFFFFF) or (-0x80000000..0x7FFFFFFF), defaults un-unsigned.
 * @param signed - True to return a signed 32-bit number (-0x80000000..0x7FFFFFFF) otherwise an unsigned one (0x000000..0xFFFFFFFF)
 */
function random32(signed) {
    var value = 0;
    var c = getCrypto() || getMsCrypto();
    if (c && c.getRandomValues) {
        // Make sure the number is converted into the specified range (-0x80000000..0x7FFFFFFF)
        value = c.getRandomValues(new Uint32Array(1))[0] & MaxUInt32;
    }
    if (value === 0 && isIE()) {
        // For IE 6, 7, 8 (especially on XP) Math.random is not very random
        if (!_mwcSeeded) {
            // Set the seed for the Mwc algorithm
            _autoSeedMwc();
        }
        // Don't use Math.random for IE
        // Make sure the number is converted into the specified range (-0x80000000..0x7FFFFFFF)
        value = mwcRandom32() & MaxUInt32;
    }
    if (value === 0) {
        // Make sure the number is converted into the specified range (-0x80000000..0x7FFFFFFF)
        value = Math.floor((UInt32Mask * Math.random()) | 0);
    }
    if (!signed) {
        // Make sure we end up with a positive number and not -ve one.
        value >>>= 0;
    }
    return value;
}
/**
 * Generate a random 32-bit number between (0x000000..0xFFFFFFFF) or (-0x80000000..0x7FFFFFFF), using MWC (Multiply with carry)
 * instead of Math.random() defaults to un-signed.
 * Used as a replacement random generator for IE to avoid issues with older IE instances.
 * @param signed - True to return a signed 32-bit number (-0x80000000..0x7FFFFFFF) otherwise an unsigned one (0x000000..0xFFFFFFFF)
 */
function mwcRandom32(signed) {
    _mwcZ = (36969 * (_mwcZ & 0xFFFF) + (_mwcZ >> 16)) & MaxUInt32;
    _mwcW = (18000 * (_mwcW & 0xFFFF) + (_mwcW >> 16)) & MaxUInt32;
    var value = (((_mwcZ << 16) + (_mwcW & 0xFFFF)) >>> 0) & MaxUInt32 | 0;
    if (!signed) {
        // Make sure we end up with a positive number and not -ve one.
        value >>>= 0;
    }
    return value;
}
/**
 * Generate random base64 id string.
 * The default length is 22 which is 132-bits so almost the same as a GUID but as base64 (the previous default was 5)
 * @param maxLength - Optional value to specify the length of the id to be generated, defaults to 22
 */
function newId(maxLength) {
    if (maxLength === void 0) { maxLength = 22; }
    var base64chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
    // Start with an initial random number, consuming the value in reverse byte order
    var number = random32() >>> 0; // Make sure it's a +ve number
    var chars = 0;
    var result = STR_EMPTY;
    while (result[_DYN_LENGTH$5 /* @min:%2elength */] < maxLength) {
        chars++;
        result += base64chars.charAt(number & 0x3F);
        number >>>= 6; // Zero fill with right shift
        if (chars === 5) {
            // 5 base64 characters === 30 bits so we don't have enough bits for another base64 char
            // So add on another 30 bits and make sure it's +ve
            number = (((random32() << 2) & 0xFFFFFFFF) | (number & 0x03)) >>> 0;
            chars = 0; // We need to reset the number every 5 chars (30 bits)
        }
    }
    return result;
}

/*
 * Application Insights JavaScript SDK - Core, 3.0.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */

var version = '3.0.3';
var instanceName = "." + newId(6);
var _dataUid = 0;
// Accepts only:
//  - Node
//    - Node.ELEMENT_NODE
//    - Node.DOCUMENT_NODE
//  - Object
//    - Any
function _canAcceptData(target) {
    return target[_DYN_NODE_TYPE /* @min:%2enodeType */] === 1 || target[_DYN_NODE_TYPE /* @min:%2enodeType */] === 9 || !(+target[_DYN_NODE_TYPE /* @min:%2enodeType */]);
}
function _getCache(data, target) {
    var theCache = target[data.id];
    if (!theCache) {
        theCache = {};
        try {
            if (_canAcceptData(target)) {
                objDefine(target, data.id, {
                    e: false,
                    v: theCache
                });
            }
        }
        catch (e) {
            // Not all environments allow extending all objects, so just ignore the cache in those cases
        }
    }
    return theCache;
}
function createUniqueNamespace(name, includeVersion) {
    if (includeVersion === void 0) { includeVersion = false; }
    return normalizeJsName(name + (_dataUid++) + (includeVersion ? "." + version : STR_EMPTY) + instanceName);
}
function createElmNodeData(name) {
    var data = {
        id: createUniqueNamespace("_aiData-" + (name || STR_EMPTY) + "." + version),
        accept: function (target) {
            return _canAcceptData(target);
        },
        get: function (target, name, defValue, addDefault) {
            var theCache = target[data.id];
            if (!theCache) {
                if (addDefault) {
                    // Side effect is adds the cache
                    theCache = _getCache(data, target);
                    theCache[normalizeJsName(name)] = defValue;
                }
                return defValue;
            }
            return theCache[normalizeJsName(name)];
        },
        kill: function (target, name) {
            if (target && target[name]) {
                try {
                    delete target[name];
                }
                catch (e) {
                    // Just cleaning up, so if this fails -- ignore
                }
            }
        }
    };
    return data;
}

/*
 * Application Insights JavaScript SDK - Core, 3.0.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */

function _isConfigDefaults(value) {
    return (value && isObject(value) && (value.isVal || value.fb || objHasOwn(value, "v") || objHasOwn(value, "mrg") || objHasOwn(value, "ref") || value.set));
}
function _getDefault(dynamicHandler, theConfig, cfgDefaults) {
    var defValue;
    var isDefaultValid = cfgDefaults.dfVal || isDefined;
    // There is a fallback config key so try and grab that first
    if (theConfig && cfgDefaults.fb) {
        var fallbacks = cfgDefaults.fb;
        if (!isArray(fallbacks)) {
            fallbacks = [fallbacks];
        }
        for (var lp = 0; lp < fallbacks[_DYN_LENGTH$5 /* @min:%2elength */]; lp++) {
            var fallback = fallbacks[lp];
            var fbValue = theConfig[fallback];
            if (isDefaultValid(fbValue)) {
                defValue = fbValue;
            }
            else if (dynamicHandler) {
                // Needed to ensure that the fallback value (and potentially) new field is also dynamic even if null/undefined
                fbValue = dynamicHandler.cfg[fallback];
                if (isDefaultValid(fbValue)) {
                    defValue = fbValue;
                }
                // Needed to ensure that the fallback value (and potentially) new field is also dynamic even if null/undefined
                dynamicHandler.set(dynamicHandler.cfg, asString(fallback), fbValue);
            }
            if (isDefaultValid(defValue)) {
                // We have a valid default so break out of the look
                break;
            }
        }
    }
    // If the value is still not defined and we have a default value then use that
    if (!isDefaultValid(defValue) && isDefaultValid(cfgDefaults.v)) {
        defValue = cfgDefaults.v;
    }
    return defValue;
}
/**
 * Recursively resolve the default value
 * @param dynamicHandler
 * @param theConfig
 * @param cfgDefaults
 * @returns
 */
function _resolveDefaultValue(dynamicHandler, theConfig, cfgDefaults) {
    var theValue = cfgDefaults;
    if (cfgDefaults && _isConfigDefaults(cfgDefaults)) {
        theValue = _getDefault(dynamicHandler, theConfig, cfgDefaults);
    }
    if (theValue) {
        if (_isConfigDefaults(theValue)) {
            theValue = _resolveDefaultValue(dynamicHandler, theConfig, theValue);
        }
        var newValue_1;
        if (isArray(theValue)) {
            newValue_1 = [];
            newValue_1[_DYN_LENGTH$5 /* @min:%2elength */] = theValue[_DYN_LENGTH$5 /* @min:%2elength */];
        }
        else if (isPlainObject(theValue)) {
            newValue_1 = {};
        }
        if (newValue_1) {
            objForEachKey(theValue, function (key, value) {
                if (value && _isConfigDefaults(value)) {
                    value = _resolveDefaultValue(dynamicHandler, theConfig, value);
                }
                newValue_1[key] = value;
            });
            theValue = newValue_1;
        }
    }
    return theValue;
}
/**
 * Applies the default value on the config property and makes sure that it's dynamic
 * @param theConfig
 * @param name
 * @param defaultValue
 */
function _applyDefaultValue(dynamicHandler, theConfig, name, defaultValue) {
    // Resolve the initial config value from the provided value or use the defined default
    var isValid;
    var setFn;
    var defValue;
    var cfgDefaults = defaultValue;
    var mergeDf;
    var reference;
    var readOnly;
    var blkDynamicValue;
    if (_isConfigDefaults(cfgDefaults)) {
        // looks like a IConfigDefault
        isValid = cfgDefaults.isVal;
        setFn = cfgDefaults.set;
        readOnly = cfgDefaults[_DYN_RD_ONLY /* @min:%2erdOnly */];
        blkDynamicValue = cfgDefaults[_DYN_BLK_VAL /* @min:%2eblkVal */];
        mergeDf = cfgDefaults.mrg;
        reference = cfgDefaults.ref;
        if (!reference && isUndefined(reference)) {
            reference = !!mergeDf;
        }
        defValue = _getDefault(dynamicHandler, theConfig, cfgDefaults);
    }
    else {
        defValue = defaultValue;
    }
    if (blkDynamicValue) {
        // Mark the property so that any value assigned will be blocked from conversion, we need to do this
        // before assigning or fetching the value to ensure it's not converted
        dynamicHandler[_DYN_BLK_VAL /* @min:%2eblkVal */](theConfig, name);
    }
    // Set the value to the default value;
    var theValue;
    var usingDefault = true;
    var cfgValue = theConfig[name];
    // try and get and user provided values
    if (cfgValue || !isNullOrUndefined(cfgValue)) {
        // Use the defined theConfig[name] value
        theValue = cfgValue;
        usingDefault = false;
        // The values are different and we have a special default value check, which is used to
        // override config values like empty strings to continue using the default
        if (isValid && theValue !== defValue && !isValid(theValue)) {
            theValue = defValue;
            usingDefault = true;
        }
        if (setFn) {
            theValue = setFn(theValue, defValue, theConfig);
            usingDefault = theValue === defValue;
        }
    }
    if (!usingDefault) {
        if (isPlainObject(theValue) || isArray(defValue)) {
            // we are using the user supplied value and it's an object
            if (mergeDf && defValue && (isPlainObject(defValue) || isArray(defValue))) {
                // Resolve/apply the defaults
                objForEachKey(defValue, function (dfName, dfValue) {
                    // Sets the value and makes it dynamic (if it doesn't already exist)
                    _applyDefaultValue(dynamicHandler, theValue, dfName, dfValue);
                });
            }
        }
    }
    else if (defValue) {
        // Just resolve the default
        theValue = _resolveDefaultValue(dynamicHandler, theConfig, defValue);
    }
    else {
        theValue = defValue;
    }
    // if (theValue && usingDefault && (isPlainObject(theValue) || isArray(theValue))) {
    //     theValue = _cfgDeepCopy(theValue);
    // }
    // Needed to ensure that the (potentially) new field is dynamic even if null/undefined
    dynamicHandler.set(theConfig, name, theValue);
    if (reference) {
        dynamicHandler.ref(theConfig, name);
    }
    if (readOnly) {
        dynamicHandler[_DYN_RD_ONLY /* @min:%2erdOnly */](theConfig, name);
    }
}

/*
 * Application Insights JavaScript SDK - Core, 3.0.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */

// Using Symbol.for so that if the same symbol was already created it would be returned
// To handle multiple instances using potentially different versions we are not using
// createUniqueNamespace()
var CFG_HANDLER_LINK = symbolFor("[[ai_dynCfg_1]]");
/**
 * @internal
 * @ignore
 * The symbol to tag objects / arrays with if they should not be converted
 */
var BLOCK_DYNAMIC = symbolFor("[[ai_blkDynCfg_1]]");
/**
 * @internal
 * @ignore
 * The symbol to tag objects to indicate that when included into the configuration that
 * they should be converted into a trackable dynamic object.
 */
var FORCE_DYNAMIC = symbolFor("[[ai_frcDynCfg_1]]");
function _cfgDeepCopy(source) {
    if (source) {
        var target_1;
        if (isArray(source)) {
            target_1 = [];
            target_1[_DYN_LENGTH$5 /* @min:%2elength */] = source[_DYN_LENGTH$5 /* @min:%2elength */];
        }
        else if (isPlainObject(source)) {
            target_1 = {};
        }
        if (target_1) {
            // Copying index values by property name as the extensionConfig can be an array or object
            objForEachKey(source, function (key, value) {
                // Perform a deep copy of the object
                target_1[key] = _cfgDeepCopy(value);
            });
            return target_1;
        }
    }
    return source;
}
/**
 * @internal
 * Get the dynamic config handler if the value is already dynamic
 * @param value
 * @returns
 */
function getDynamicConfigHandler(value) {
    if (value) {
        var handler = value[CFG_HANDLER_LINK] || value;
        if (handler.cfg && (handler.cfg === value || handler.cfg[CFG_HANDLER_LINK] === handler)) {
            return handler;
        }
    }
    return null;
}
/**
 * Mark the provided value so that if it's included into the configuration it will NOT have
 * its properties converted into a dynamic (reactive) object. If the object is not a plain object
 * or an array (ie. a class) this function has not affect as only Objects and Arrays are converted
 * into dynamic objects in the dynamic configuration.
 *
 * When you have tagged a value as both {@link forceDynamicConversion} and blocked force will take precedence.
 *
 * You should only need to use this function, if you are creating dynamic "classes" from objects
 * which confirm to the require interface. A common case for this is during unit testing where it's
 * easier to create mock extensions.
 *
 * If `value` is falsy (null / undefined / 0 / empty string etc) it will not be tagged and
 * if there is an exception adding the property to the value (because its frozen etc) the
 * exception will be swallowed
 *
 * @example
 * ```ts
 * // This is a valid "extension", but it is technically an object
 * // So when included in the config.extensions it WILL be cloned and then
 * // converted into a dynamic object, where all of its properties will become
 * // get/set object properties and will be tracked. While this WILL still
 * // function, when attempt to use a mocking framework on top of this the
 * // functions are now technically get accessors which return a function
 * // and this can cause some mocking frameworks to fail.
 * let mockChannel = {
 *      pause: () => { },
*      resume: () => { },
*      teardown: () => { },
*      flush: (async: any, callBack: any) => { },
*      processTelemetry: (env: any) => { },
*      setNextPlugin: (next: any) => { },
*      initialize: (config: any, core: any, extensions: any) => { },
*      identifier: "testChannel",
*      priority: 1003
* };
 * ```
 * @param value - The object that you want to block from being converted into a
 * trackable dynamic object
 * @returns The original value
 */
function blockDynamicConversion(value) {
    if (value && (isPlainObject(value) || isArray(value))) {
        try {
            value[BLOCK_DYNAMIC] = true;
        }
        catch (e) {
            // Don't throw for this case as it's an ask only
        }
    }
    return value;
}
/**
 * @internal
 * @ignore
 * Helper function to check whether an object can or should be converted into a dynamic
 * object.
 * @param value - The object to check whether it should be converted
 * @returns `true` if the value should be converted otherwise `false`.
 */
function _canMakeDynamic(getFunc, state, value) {
    var result = false;
    // Object must exist and be truthy
    if (value && !getFunc[state.blkVal]) {
        // Tagged as always convert
        result = value[FORCE_DYNAMIC];
        // Check that it's not explicitly tagged as blocked
        if (!result && !value[BLOCK_DYNAMIC]) {
            // Only convert plain objects or arrays by default
            result = isPlainObject(value) || isArray(value);
        }
    }
    return result;
}
/**
 * Throws an invalid access exception
 * @param message - The message to include in the exception
 */
function throwInvalidAccess(message) {
    throwTypeError("InvalidAccess:" + message);
}

/*
 * Application Insights JavaScript SDK - Core, 3.0.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */

var arrayMethodsToPatch = [
    "push",
    "pop",
    "shift",
    "unshift",
    "splice"
];
var _throwDynamicError = function (logger, name, desc, e) {
    logger && logger[_DYN_THROW_INTERNAL /* @min:%2ethrowInternal */](3 /* eLoggingSeverity.DEBUG */, 108 /* _eInternalMessageId.DynamicConfigException */, "".concat(desc, " [").concat(name, "] failed - ") + dumpObj(e));
};
function _patchArray(state, target, name) {
    if (isArray(target)) {
        // Monkey Patch the methods that might change the array
        arrForEach(arrayMethodsToPatch, function (method) {
            var orgMethod = target[method];
            target[method] = function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                var result = orgMethod[_DYN_APPLY /* @min:%2eapply */](this, args);
                // items may be added, removed or moved so need to make some new dynamic properties
                _makeDynamicObject(state, target, name, "Patching");
                return result;
            };
        });
    }
}
function _getOwnPropGetter(target, name) {
    var propDesc = objGetOwnPropertyDescriptor(target, name);
    return propDesc && propDesc.get;
}
function _createDynamicProperty(state, theConfig, name, value) {
    // Does not appear to be dynamic so lets make it so
    var detail = {
        n: name,
        h: [],
        trk: function (handler) {
            if (handler && handler.fn) {
                if (arrIndexOf(detail.h, handler) === -1) {
                    // Add this handler to the collection that should be notified when the value changes
                    detail.h[_DYN_PUSH$1 /* @min:%2epush */](handler);
                }
                state.trk(handler, detail);
            }
        },
        clr: function (handler) {
            var idx = arrIndexOf(detail.h, handler);
            if (idx !== -1) {
                detail.h[_DYN_SPLICE /* @min:%2esplice */](idx, 1);
            }
        }
    };
    // Flag to optimize lookup response time by avoiding additional function calls
    var checkDynamic = true;
    var isObjectOrArray = false;
    function _getProperty() {
        if (checkDynamic) {
            isObjectOrArray = isObjectOrArray || _canMakeDynamic(_getProperty, state, value);
            // Make sure that if it's an object that we make it dynamic
            if (value && !value[CFG_HANDLER_LINK] && isObjectOrArray) {
                // It doesn't look like it's already dynamic so lets make sure it's converted the object into a dynamic Config as well
                value = _makeDynamicObject(state, value, name, "Converting");
            }
            // If it needed to be converted it now has been
            checkDynamic = false;
        }
        // If there is an active handler then add it to the tracking set of handlers
        var activeHandler = state.act;
        if (activeHandler) {
            detail.trk(activeHandler);
        }
        return value;
    }
    // Tag this getter as our dynamic property and provide shortcut for notifying a change
    _getProperty[state.prop] = {
        chng: function () {
            state.add(detail);
        }
    };
    function _setProperty(newValue) {
        if (value !== newValue) {
            if (!!_getProperty[state.ro] && !state.upd) {
                // field is marked as readonly so return false
                throwInvalidAccess("[" + name + "] is read-only:" + dumpObj(theConfig));
            }
            if (checkDynamic) {
                isObjectOrArray = isObjectOrArray || _canMakeDynamic(_getProperty, state, value);
                checkDynamic = false;
            }
            // The value must be a plain object or an array to enforce the reference (in-place updates)
            var isReferenced = isObjectOrArray && _getProperty[state.rf];
            if (isObjectOrArray) {
                // We are about to replace a plain object or an array
                if (isReferenced) {
                    // Reassign the properties from the current value to the same properties from the newValue
                    // This will set properties not in the newValue to undefined
                    objForEachKey(value, function (key) {
                        value[key] = newValue ? newValue[key] : UNDEFINED_VALUE$2;
                    });
                    // Now assign / re-assign value with all of the keys from newValue
                    try {
                        objForEachKey(newValue, function (key, theValue) {
                            _setDynamicProperty(state, value, key, theValue);
                        });
                        // Now drop newValue so when we assign value later it keeps the existing reference
                        newValue = value;
                    }
                    catch (e) {
                        // Unable to convert to dynamic property so just leave as non-dynamic
                        _throwDynamicError((state.hdlr || {})[_DYN_LOGGER /* @min:%2elogger */], name, "Assigning", e);
                        // Mark as not an object or array so we don't try and do this again
                        isObjectOrArray = false;
                    }
                }
                else if (value && value[CFG_HANDLER_LINK]) {
                    // As we are replacing the value, if it's already dynamic then we need to notify the listeners
                    // for every property it has already
                    objForEachKey(value, function (key) {
                        // Check if the value is dynamic
                        var getter = _getOwnPropGetter(value, key);
                        if (getter) {
                            // And if it is tell it's listeners that the value has changed
                            var valueState = getter[state.prop];
                            valueState && valueState.chng();
                        }
                    });
                }
            }
            if (newValue !== value) {
                var newIsObjectOrArray = newValue && _canMakeDynamic(_getProperty, state, newValue);
                if (!isReferenced && newIsObjectOrArray) {
                    // As the newValue is an object/array lets preemptively make it dynamic
                    newValue = _makeDynamicObject(state, newValue, name, "Converting");
                }
                // Now assign the internal "value" to the newValue
                value = newValue;
                isObjectOrArray = newIsObjectOrArray;
            }
            // Cause any listeners to be scheduled for notification
            state.add(detail);
        }
    }
    objDefine(theConfig, detail.n, { g: _getProperty, s: _setProperty });
}
function _setDynamicProperty(state, target, name, value) {
    if (target) {
        // To be a dynamic property it needs to have a get function
        var getter = _getOwnPropGetter(target, name);
        var isDynamic = getter && !!getter[state.prop];
        if (!isDynamic) {
            _createDynamicProperty(state, target, name, value);
        }
        else {
            // Looks like it's already dynamic just assign the new value
            target[name] = value;
        }
    }
    return target;
}
function _setDynamicPropertyState(state, target, name, flags) {
    if (target) {
        // To be a dynamic property it needs to have a get function
        var getter = _getOwnPropGetter(target, name);
        var isDynamic = getter && !!getter[state.prop];
        var inPlace = flags && flags[0 /* _eSetDynamicPropertyFlags.inPlace */];
        var rdOnly = flags && flags[1 /* _eSetDynamicPropertyFlags.readOnly */];
        var blkProp = flags && flags[2 /* _eSetDynamicPropertyFlags.blockDynamicProperty */];
        if (!isDynamic) {
            if (blkProp) {
                try {
                    // Attempt to mark the target as blocked from conversion
                    blockDynamicConversion(target);
                }
                catch (e) {
                    _throwDynamicError((state.hdlr || {})[_DYN_LOGGER /* @min:%2elogger */], name, "Blocking", e);
                }
            }
            try {
                // Make sure it's dynamic so that we can tag the property as per the state
                _setDynamicProperty(state, target, name, target[name]);
                getter = _getOwnPropGetter(target, name);
            }
            catch (e) {
                // Unable to convert to dynamic property so just leave as non-dynamic
                _throwDynamicError((state.hdlr || {})[_DYN_LOGGER /* @min:%2elogger */], name, "State", e);
            }
        }
        // Assign the optional flags if true
        if (inPlace) {
            getter[state.rf] = inPlace;
        }
        if (rdOnly) {
            getter[state.ro] = rdOnly;
        }
        if (blkProp) {
            getter[state.blkVal] = true;
        }
    }
    return target;
}
function _makeDynamicObject(state, target, name, desc) {
    try {
        // Assign target with new value properties (converting into dynamic properties in the process)
        objForEachKey(target, function (key, value) {
            // Assign and/or make the property dynamic
            _setDynamicProperty(state, target, key, value);
        });
        if (!target[CFG_HANDLER_LINK]) {
            // Link the config back to the dynamic config details
            objDefineProp(target, CFG_HANDLER_LINK, {
                get: function () {
                    return state[_DYN_HDLR /* @min:%2ehdlr */];
                }
            });
            _patchArray(state, target, name);
        }
    }
    catch (e) {
        // Unable to convert to dynamic property so just leave as non-dynamic
        _throwDynamicError((state.hdlr || {})[_DYN_LOGGER /* @min:%2elogger */], name, desc, e);
    }
    return target;
}

/*
 * Application Insights JavaScript SDK - Core, 3.0.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */

var symPrefix = "[[ai_";
var symPostfix = "]]";
function _createState(cfgHandler) {
    var _a;
    var dynamicPropertySymbol = newSymbol(symPrefix + "get" + cfgHandler.uid + symPostfix);
    var dynamicPropertyReadOnly = newSymbol(symPrefix + "ro" + cfgHandler.uid + symPostfix);
    var dynamicPropertyReferenced = newSymbol(symPrefix + "rf" + cfgHandler.uid + symPostfix);
    var dynamicPropertyBlockValue = newSymbol(symPrefix + "blkVal" + cfgHandler.uid + symPostfix);
    var dynamicPropertyDetail = newSymbol(symPrefix + "dtl" + cfgHandler.uid + symPostfix);
    var _waitingHandlers = null;
    var _watcherTimer = null;
    var theState;
    function _useHandler(activeHandler, callback) {
        var prevWatcher = theState.act;
        try {
            theState.act = activeHandler;
            if (activeHandler && activeHandler[dynamicPropertyDetail]) {
                // Clear out the previously tracked details for this handler, so that access are re-evaluated
                arrForEach(activeHandler[dynamicPropertyDetail], function (detail) {
                    detail.clr(activeHandler);
                });
                activeHandler[dynamicPropertyDetail] = [];
            }
            callback({
                cfg: cfgHandler.cfg,
                set: cfgHandler.set.bind(cfgHandler),
                setDf: cfgHandler[_DYN_SET_DF /* @min:%2esetDf */].bind(cfgHandler),
                ref: cfgHandler.ref.bind(cfgHandler),
                rdOnly: cfgHandler[_DYN_RD_ONLY /* @min:%2erdOnly */].bind(cfgHandler)
            });
        }
        catch (e) {
            var logger = cfgHandler[_DYN_LOGGER /* @min:%2elogger */];
            if (logger) {
                // Don't let one individual failure break everyone
                logger[_DYN_THROW_INTERNAL /* @min:%2ethrowInternal */](1 /* eLoggingSeverity.CRITICAL */, 107 /* _eInternalMessageId.ConfigWatcherException */, dumpObj(e));
            }
            // Re-throw the exception so that any true "error" is reported back to the called
            throw e;
        }
        finally {
            theState.act = prevWatcher || null;
        }
    }
    function _notifyWatchers() {
        if (_waitingHandlers) {
            var notifyHandlers = _waitingHandlers;
            _waitingHandlers = null;
            // Stop any timer as we are running them now anyway
            _watcherTimer && _watcherTimer[_DYN_CANCEL /* @min:%2ecancel */]();
            _watcherTimer = null;
            var watcherFailures_1 = [];
            // Now run the handlers
            arrForEach(notifyHandlers, function (handler) {
                if (handler) {
                    if (handler[dynamicPropertyDetail]) {
                        arrForEach(handler[dynamicPropertyDetail], function (detail) {
                            // Clear out this handler from  previously tracked details, so that access are re-evaluated
                            detail.clr(handler);
                        });
                        handler[dynamicPropertyDetail] = null;
                    }
                    // The handler may have self removed as part of another handler so re-check
                    if (handler.fn) {
                        try {
                            _useHandler(handler, handler.fn);
                        }
                        catch (e) {
                            // Don't let a single failing watcher cause other watches to fail
                            watcherFailures_1[_DYN_PUSH$1 /* @min:%2epush */](e);
                        }
                    }
                }
            });
            // During notification we may have had additional updates -- so notify those updates as well
            if (_waitingHandlers) {
                try {
                    _notifyWatchers();
                }
                catch (e) {
                    watcherFailures_1[_DYN_PUSH$1 /* @min:%2epush */](e);
                }
            }
            if (watcherFailures_1[_DYN_LENGTH$5 /* @min:%2elength */] > 0) {
                throwAggregationError("Watcher error(s): ", watcherFailures_1);
            }
        }
    }
    function _addWatcher(detail) {
        if (detail && detail.h[_DYN_LENGTH$5 /* @min:%2elength */] > 0) {
            if (!_waitingHandlers) {
                _waitingHandlers = [];
            }
            if (!_watcherTimer) {
                _watcherTimer = scheduleTimeout(function () {
                    _watcherTimer = null;
                    _notifyWatchers();
                }, 0);
            }
            // Add all of the handlers for this detail (if not already present) - using normal for-loop for performance
            for (var idx = 0; idx < detail.h[_DYN_LENGTH$5 /* @min:%2elength */]; idx++) {
                var handler = detail.h[idx];
                // Add this handler to the collection of handlers to re-execute
                if (handler && arrIndexOf(_waitingHandlers, handler) === -1) {
                    _waitingHandlers[_DYN_PUSH$1 /* @min:%2epush */](handler);
                }
            }
        }
    }
    function _trackHandler(handler, detail) {
        if (handler) {
            var details = handler[dynamicPropertyDetail] = handler[dynamicPropertyDetail] || [];
            if (arrIndexOf(details, detail) === -1) {
                // If this detail is not already listed as tracked then add it so that we re-evaluate it's usage
                details[_DYN_PUSH$1 /* @min:%2epush */](detail);
            }
        }
    }
    theState = (_a = {
            prop: dynamicPropertySymbol,
            ro: dynamicPropertyReadOnly,
            rf: dynamicPropertyReferenced
        },
        _a[_DYN_BLK_VAL /* @min:blkVal */] = dynamicPropertyBlockValue,
        _a[_DYN_HDLR /* @min:hdlr */] = cfgHandler,
        _a.add = _addWatcher,
        _a[_DYN_NOTIFY /* @min:notify */] = _notifyWatchers,
        _a.use = _useHandler,
        _a.trk = _trackHandler,
        _a);
    return theState;
}

/*
 * Application Insights JavaScript SDK - Core, 3.0.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */

/**
 * Identifies a function which will be re-called whenever any of it's accessed configuration values
 * change.
 * @param configHandler - The callback that will be called for the initial request and then whenever any
 * accessed configuration changes are identified.
 */
function _createAndUseHandler(state, configHandler) {
    var handler = {
        fn: configHandler,
        rm: function () {
            // Clear all references to the handler so it can be garbage collected
            // This will also cause this handler to never get called and eventually removed
            handler.fn = null;
            state = null;
            configHandler = null;
        }
    };
    state.use(handler, configHandler);
    return handler;
}
/**
 * Creates the dynamic config handler and associates with the target config as the root object
 * @param target - The config that you want to be root of the dynamic config
 * @param inPlace - Should the passed config be converted in-place or a new proxy returned
 * @returns The existing dynamic handler or a new instance with the provided config values
 */
function _createDynamicHandler(logger, target, inPlace) {
    var _a;
    var dynamicHandler = getDynamicConfigHandler(target);
    if (dynamicHandler) {
        // The passed config is already dynamic so return it's tracker
        return dynamicHandler;
    }
    var uid = createUniqueNamespace("dyncfg", true);
    var newTarget = (target && inPlace !== false) ? target : _cfgDeepCopy(target);
    var theState;
    function _notifyWatchers() {
        theState[_DYN_NOTIFY /* @min:%2enotify */]();
    }
    function _setValue(target, name, value) {
        try {
            target = _setDynamicProperty(theState, target, name, value);
        }
        catch (e) {
            // Unable to convert to dynamic property so just leave as non-dynamic
            _throwDynamicError(logger, name, "Setting value", e);
        }
        return target[name];
    }
    function _watch(configHandler) {
        return _createAndUseHandler(theState, configHandler);
    }
    function _block(configHandler, allowUpdate) {
        theState.use(null, function (details) {
            var prevUpd = theState.upd;
            try {
                if (!isUndefined(allowUpdate)) {
                    theState.upd = allowUpdate;
                }
                configHandler(details);
            }
            finally {
                theState.upd = prevUpd;
            }
        });
    }
    function _ref(target, name) {
        var _a;
        // Make sure it's dynamic and mark as referenced with it's current value
        return _setDynamicPropertyState(theState, target, name, (_a = {}, _a[0 /* _eSetDynamicPropertyFlags.inPlace */] = true, _a))[name];
    }
    function _rdOnly(target, name) {
        var _a;
        // Make sure it's dynamic and mark as readonly with it's current value
        return _setDynamicPropertyState(theState, target, name, (_a = {}, _a[1 /* _eSetDynamicPropertyFlags.readOnly */] = true, _a))[name];
    }
    function _blkPropValue(target, name) {
        var _a;
        // Make sure it's dynamic and mark as readonly with it's current value
        return _setDynamicPropertyState(theState, target, name, (_a = {}, _a[2 /* _eSetDynamicPropertyFlags.blockDynamicProperty */] = true, _a))[name];
    }
    function _applyDefaults(theConfig, defaultValues) {
        if (defaultValues) {
            // Resolve/apply the defaults
            objForEachKey(defaultValues, function (name, value) {
                // Sets the value and makes it dynamic (if it doesn't already exist)
                _applyDefaultValue(cfgHandler, theConfig, name, value);
            });
        }
        return theConfig;
    }
    var cfgHandler = (_a = {
            uid: null,
            cfg: newTarget
        },
        _a[_DYN_LOGGER /* @min:logger */] = logger,
        _a[_DYN_NOTIFY /* @min:notify */] = _notifyWatchers,
        _a.set = _setValue,
        _a[_DYN_SET_DF /* @min:setDf */] = _applyDefaults,
        _a[_DYN_WATCH /* @min:watch */] = _watch,
        _a.ref = _ref,
        _a[_DYN_RD_ONLY /* @min:rdOnly */] = _rdOnly,
        _a[_DYN_BLK_VAL /* @min:blkVal */] = _blkPropValue,
        _a._block = _block,
        _a);
    objDefine(cfgHandler, "uid", {
        c: false,
        e: false,
        w: false,
        v: uid
    });
    theState = _createState(cfgHandler);
    // Setup tracking for all defined default keys
    _makeDynamicObject(theState, newTarget, "config", "Creating");
    return cfgHandler;
}
/**
 * Log an invalid access message to the console
 * @param message
 */
function _logInvalidAccess(logger, message) {
    if (logger) {
        logger[_DYN_WARN_TO_CONSOLE /* @min:%2ewarnToConsole */](message);
        logger[_DYN_THROW_INTERNAL /* @min:%2ethrowInternal */](2 /* eLoggingSeverity.WARNING */, 108 /* _eInternalMessageId.DynamicConfigException */, message);
    }
    else {
        // We don't have a logger so just throw an exception
        throwInvalidAccess(message);
    }
}
/**
 * Create or return a dynamic version of the passed config, if it is not already dynamic
 * @param config - The config to be converted into a dynamic config
 * @param defaultConfig - The default values to apply on the config if the properties don't already exist
 * @param inPlace - Should the config be converted in-place into a dynamic config or a new instance returned, defaults to true
 * @returns The dynamic config handler for the config (whether new or existing)
 */
function createDynamicConfig(config, defaultConfig, logger, inPlace) {
    var dynamicHandler = _createDynamicHandler(logger, config || {}, inPlace);
    if (defaultConfig) {
        dynamicHandler[_DYN_SET_DF /* @min:%2esetDf */](dynamicHandler.cfg, defaultConfig);
    }
    return dynamicHandler;
}
/**
 * Watch and track changes for accesses to the current config, the provided config MUST already be
 * a dynamic config or a child accessed via the dynamic config
 * @param config
 * @param configHandler
 * @param logger - The logger instance to use if there is no existing handler
 * @returns A watcher handler instance that can be used to remove itself when being unloaded
 * @throws TypeError if the provided config is not a dynamic config instance
 */
function onConfigChange(config, configHandler, logger) {
    var handler = config[CFG_HANDLER_LINK] || config;
    if (handler.cfg && (handler.cfg === config || handler.cfg[CFG_HANDLER_LINK] === handler)) {
        return handler[_DYN_WATCH /* @min:%2ewatch */](configHandler);
    }
    _logInvalidAccess(logger, STR_NOT_DYNAMIC_ERROR + dumpObj(config));
    return createDynamicConfig(config, null, logger)[_DYN_WATCH /* @min:%2ewatch */](configHandler);
}

/*
 * Application Insights JavaScript SDK - Core, 3.0.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */

/**
 * Run the unload function of the target object if it exists
 * @param target - The target object that contains the unload function
 * @param isAsync - The caller identifies whether it is expecting the operation to complete synchronously or asynchronously. Even
 * if the caller is not waiting the operation may still be performed asynchronously depending on the component and the reverse is
 * also true.
 * @returns The result of the target function
 */
function runTargetUnload(target, isAsync) {
    if (target && target[_DYN_UNLOAD /* @min:%2eunload */]) {
        return target[_DYN_UNLOAD /* @min:%2eunload */](isAsync);
    }
}
/**
 * Call the unload function on all targets handling any returned [IPromise](https://nevware21.github.io/ts-async/typedoc/interfaces/IPromise.html)
 * / Promise before calling the next targets unload
 * @param targets - An array of the targets to unload
 * @param isAsync - The caller identifies whether it is expecting the operations to complete synchronously or asynchronously.  Even
 * if the caller is not waiting the operation may still be performed asynchronously depending on the component and the reverse is
 * also true.
 * @param done - Optional callback function to call once all of the unload functions have been called.
 */
function doUnloadAll(targets, isAsync, done) {
    var result;
    if (!done) {
        result = createPromise(function (resolved) {
            done = resolved;
        });
    }
    if (targets && getLength(targets) > 0) {
        doAwaitResponse(runTargetUnload(targets[0], isAsync), function () {
            doUnloadAll(arrSlice(targets, 1), isAsync, done);
        });
    }
    else {
        done();
    }
    return result;
}

/*
 * Application Insights JavaScript SDK - Core, 3.0.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


var ChannelControllerPriority = 500;

/*
 * Application Insights JavaScript SDK - Core, 3.0.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */

/**
 * @internal
 * @ignore
 * @param str
 * @param defaultValue
 * @returns
 */
function _stringToBoolOrDefault(theValue, defaultValue, theConfig) {
    if (!theValue && isNullOrUndefined(theValue)) {
        return defaultValue;
    }
    if (isBoolean(theValue)) {
        return theValue;
    }
    return asString(theValue)[_DYN_TO_LOWER_CASE$2 /* @min:%2etoLowerCase */]() === "true";
}
/**
 * Helper which returns an IConfigDefaultCheck instance with the field defined as an object
 * that should be merged
 * @param defaultValue - The default value to apply it not provided or it's not valid
 * @returns a new IConfigDefaultCheck structure
 */
function cfgDfMerge(defaultValue) {
    return {
        mrg: true,
        v: defaultValue
    };
}
/**
 * Helper which returns an IConfigDefaultCheck instance with the provided field set function
 * @param setter - The IConfigCheckFn function to validate the user provided value
 * @param defaultValue - The default value to apply it not provided or it's not valid
 * @returns a new IConfigDefaultCheck structure
 */
function cfgDfSet(setter, defaultValue) {
    return {
        set: setter,
        v: defaultValue
    };
}
/**
 * Helper which returns an IConfigDefaultCheck instance with the provided field validator
 * @param validator - The IConfigCheckFn function to validate the user provided value
 * @param defaultValue - The default value to apply it not provided or it's not valid
 * @param fallBackName - The fallback configuration name if the current value is not available
 * @returns a new IConfigDefaultCheck structure
 */
function cfgDfValidate(validator, defaultValue, fallBackName) {
    return {
        fb: fallBackName,
        isVal: validator,
        v: defaultValue
    };
}
/**
 * Helper which returns an IConfigDefaultCheck instance that will validate and convert the user
 * provided value to a boolean from a string or boolean value
 * @param defaultValue - The default value to apply it not provided or it's not valid
 * @param fallBackName - The fallback configuration name if the current value is not available
 * @returns a new IConfigDefaultCheck structure
 */
function cfgDfBoolean(defaultValue, fallBackName) {
    return {
        fb: fallBackName,
        set: _stringToBoolOrDefault,
        v: !!defaultValue
    };
}
/**
 * Helper which returns an IConfigDefaultCheck instance that will validate that the user
 * provided value is a function.
 * @param defaultValue - The default string value to apply it not provided or it's not valid, defaults to an empty string
 * @returns a new IConfigDefaultCheck structure
 */
function cfgDfString(defaultValue) {
    return {
        isVal: isString,
        v: asString(defaultValue || STR_EMPTY)
    };
}

/*
 * Application Insights JavaScript SDK - Core, 3.0.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */

var listenerFuncs = [STR_EVENTS_SENT, STR_EVENTS_DISCARDED, STR_EVENTS_SEND_REQUEST, STR_PERF_EVENT];
var _aiNamespace = null;
var _debugListener;
function _listenerProxyFunc(name, config) {
    return function () {
        var args = arguments;
        var dbgExt = getDebugExt(config);
        if (dbgExt) {
            var listener = dbgExt.listener;
            if (listener && listener[name]) {
                listener[name][_DYN_APPLY /* @min:%2eapply */](listener, args);
            }
        }
    };
}
function _getExtensionNamespace() {
    // Cache the lookup of the global namespace object
    var target = getInst("Microsoft");
    if (target) {
        _aiNamespace = target["ApplicationInsights"];
    }
    return _aiNamespace;
}
function getDebugExt(config) {
    var ns = _aiNamespace;
    if (!ns && config.disableDbgExt !== true) {
        ns = _aiNamespace || _getExtensionNamespace();
    }
    return ns ? ns["ChromeDbgExt"] : null;
}
function getDebugListener(config) {
    if (!_debugListener) {
        _debugListener = {};
        for (var lp = 0; lp < listenerFuncs[_DYN_LENGTH$5 /* @min:%2elength */]; lp++) {
            _debugListener[listenerFuncs[lp]] = _listenerProxyFunc(listenerFuncs[lp], config);
        }
    }
    return _debugListener;
}

/*
 * Application Insights JavaScript SDK - Core, 3.0.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */

var _a$a;
var STR_WARN_TO_CONSOLE = "warnToConsole";
/**
 * For user non actionable traces use AI Internal prefix.
 */
var AiNonUserActionablePrefix = "AI (Internal): ";
/**
 * Prefix of the traces in portal.
 */
var AiUserActionablePrefix = "AI: ";
/**
 *  Session storage key for the prefix for the key indicating message type already logged
 */
var AIInternalMessagePrefix = "AITR_";
var defaultValues$3 = {
    loggingLevelConsole: 0,
    loggingLevelTelemetry: 1,
    maxMessageLimit: 25,
    enableDebug: false
};
var _logFuncs = (_a$a = {},
    _a$a[0 /* eLoggingSeverity.DISABLED */] = null,
    _a$a[1 /* eLoggingSeverity.CRITICAL */] = "errorToConsole",
    _a$a[2 /* eLoggingSeverity.WARNING */] = STR_WARN_TO_CONSOLE,
    _a$a[3 /* eLoggingSeverity.DEBUG */] = "debugToConsole",
    _a$a);
function _sanitizeDiagnosticText(text) {
    if (text) {
        return "\"" + text[_DYN_REPLACE /* @min:%2ereplace */](/\"/g, STR_EMPTY) + "\"";
    }
    return STR_EMPTY;
}
function _logToConsole(func, message) {
    var theConsole = getConsole();
    if (!!theConsole) {
        var logFunc = "log";
        if (theConsole[func]) {
            logFunc = func;
        }
        if (isFunction(theConsole[logFunc])) {
            theConsole[logFunc](message);
        }
    }
}
var _InternalLogMessage = /** @class */ (function () {
    function _InternalLogMessage(msgId, msg, isUserAct, properties) {
        if (isUserAct === void 0) { isUserAct = false; }
        var _self = this;
        _self[_DYN_MESSAGE_ID /* @min:%2emessageId */] = msgId;
        _self[_DYN_MESSAGE$2 /* @min:%2emessage */] =
            (isUserAct ? AiUserActionablePrefix : AiNonUserActionablePrefix) +
                msgId;
        var strProps = STR_EMPTY;
        if (hasJSON()) {
            strProps = getJSON().stringify(properties);
        }
        var diagnosticText = (msg ? " message:" + _sanitizeDiagnosticText(msg) : STR_EMPTY) +
            (properties ? " props:" + _sanitizeDiagnosticText(strProps) : STR_EMPTY);
        _self[_DYN_MESSAGE$2 /* @min:%2emessage */] += diagnosticText;
    }
    _InternalLogMessage.dataType = "MessageData";
    return _InternalLogMessage;
}());
function safeGetLogger(core, config) {
    return (core || {})[_DYN_LOGGER /* @min:%2elogger */] || new DiagnosticLogger(config);
}
var DiagnosticLogger = /** @class */ (function () {
    function DiagnosticLogger(config) {
        this.identifier = "DiagnosticLogger";
        /**
         * The internal logging queue
         */
        this.queue = [];
        /**
         * Count of internal messages sent
         */
        var _messageCount = 0;
        /**
         * Holds information about what message types were already logged to console or sent to server.
         */
        var _messageLogged = {};
        var _loggingLevelConsole;
        var _loggingLevelTelemetry;
        var _maxInternalMessageLimit;
        var _enableDebug;
        var _unloadHandler;
        dynamicProto(DiagnosticLogger, this, function (_self) {
            _unloadHandler = _setDefaultsFromConfig(config || {});
            _self.consoleLoggingLevel = function () { return _loggingLevelConsole; };
            /**
             * This method will throw exceptions in debug mode or attempt to log the error as a console warning.
             * @param severity - {LoggingSeverity} - The severity of the log message
             * @param message - {_InternalLogMessage} - The log message.
             */
            _self[_DYN_THROW_INTERNAL /* @min:%2ethrowInternal */] = function (severity, msgId, msg, properties, isUserAct) {
                if (isUserAct === void 0) { isUserAct = false; }
                var message = new _InternalLogMessage(msgId, msg, isUserAct, properties);
                if (_enableDebug) {
                    throw dumpObj(message);
                }
                else {
                    // Get the logging function and fallback to warnToConsole of for some reason errorToConsole doesn't exist
                    var logFunc = _logFuncs[severity] || STR_WARN_TO_CONSOLE;
                    if (!isUndefined(message[_DYN_MESSAGE$2 /* @min:%2emessage */])) {
                        if (isUserAct) {
                            // check if this message type was already logged to console for this page view and if so, don't log it again
                            var messageKey = +message[_DYN_MESSAGE_ID /* @min:%2emessageId */];
                            if (!_messageLogged[messageKey] && _loggingLevelConsole >= severity) {
                                _self[logFunc](message[_DYN_MESSAGE$2 /* @min:%2emessage */]);
                                _messageLogged[messageKey] = true;
                            }
                        }
                        else {
                            // Only log traces if the console Logging Level is >= the throwInternal severity level
                            if (_loggingLevelConsole >= severity) {
                                _self[logFunc](message[_DYN_MESSAGE$2 /* @min:%2emessage */]);
                            }
                        }
                        _logInternalMessage(severity, message);
                    }
                    else {
                        _debugExtMsg("throw" + (severity === 1 /* eLoggingSeverity.CRITICAL */ ? "Critical" : "Warning"), message);
                    }
                }
            };
            _self.debugToConsole = function (message) {
                _logToConsole("debug", message);
                _debugExtMsg("warning", message);
            };
            _self[_DYN_WARN_TO_CONSOLE /* @min:%2ewarnToConsole */] = function (message) {
                _logToConsole("warn", message);
                _debugExtMsg("warning", message);
            };
            _self.errorToConsole = function (message) {
                _logToConsole("error", message);
                _debugExtMsg("error", message);
            };
            _self.resetInternalMessageCount = function () {
                _messageCount = 0;
                _messageLogged = {};
            };
            _self[_DYN_LOG_INTERNAL_MESSAGE /* @min:%2elogInternalMessage */] = _logInternalMessage;
            _self[_DYN_UNLOAD /* @min:%2eunload */] = function (isAsync) {
                _unloadHandler && _unloadHandler.rm();
                _unloadHandler = null;
            };
            function _logInternalMessage(severity, message) {
                if (_areInternalMessagesThrottled()) {
                    return;
                }
                // check if this message type was already logged for this session and if so, don't log it again
                var logMessage = true;
                var messageKey = AIInternalMessagePrefix + message[_DYN_MESSAGE_ID /* @min:%2emessageId */];
                // if the session storage is not available, limit to only one message type per page view
                if (_messageLogged[messageKey]) {
                    logMessage = false;
                }
                else {
                    _messageLogged[messageKey] = true;
                }
                if (logMessage) {
                    // Push the event in the internal queue
                    if (severity <= _loggingLevelTelemetry) {
                        _self.queue[_DYN_PUSH$1 /* @min:%2epush */](message);
                        _messageCount++;
                        _debugExtMsg((severity === 1 /* eLoggingSeverity.CRITICAL */ ? "error" : "warn"), message);
                    }
                    // When throttle limit reached, send a special event
                    if (_messageCount === _maxInternalMessageLimit) {
                        var throttleLimitMessage = "Internal events throttle limit per PageView reached for this app.";
                        var throttleMessage = new _InternalLogMessage(23 /* _eInternalMessageId.MessageLimitPerPVExceeded */, throttleLimitMessage, false);
                        _self.queue[_DYN_PUSH$1 /* @min:%2epush */](throttleMessage);
                        if (severity === 1 /* eLoggingSeverity.CRITICAL */) {
                            _self.errorToConsole(throttleLimitMessage);
                        }
                        else {
                            _self[_DYN_WARN_TO_CONSOLE /* @min:%2ewarnToConsole */](throttleLimitMessage);
                        }
                    }
                }
            }
            function _setDefaultsFromConfig(config) {
                // make sure the config is dynamic
                return onConfigChange(createDynamicConfig(config, defaultValues$3, _self).cfg, function (details) {
                    var config = details.cfg;
                    _loggingLevelConsole = config[_DYN_LOGGING_LEVEL_CONSOL4 /* @min:%2eloggingLevelConsole */];
                    _loggingLevelTelemetry = config.loggingLevelTelemetry;
                    _maxInternalMessageLimit = config.maxMessageLimit;
                    _enableDebug = config.enableDebug;
                });
            }
            function _areInternalMessagesThrottled() {
                return _messageCount >= _maxInternalMessageLimit;
            }
            function _debugExtMsg(name, data) {
                var dbgExt = getDebugExt(config || {});
                if (dbgExt && dbgExt[_DYN_DIAG_LOG$2 /* @min:%2ediagLog */]) {
                    dbgExt[_DYN_DIAG_LOG$2 /* @min:%2ediagLog */](name, data);
                }
            }
        });
    }
// Removed Stub for DiagnosticLogger.prototype.consoleLoggingLevel.
// Removed Stub for DiagnosticLogger.prototype.throwInternal.
// Removed Stub for DiagnosticLogger.prototype.debugToConsole.
// Removed Stub for DiagnosticLogger.prototype.warnToConsole.
// Removed Stub for DiagnosticLogger.prototype.errorToConsole.
// Removed Stub for DiagnosticLogger.prototype.resetInternalMessageCount.
// Removed Stub for DiagnosticLogger.prototype.logInternalMessage.
// Removed Stub for DiagnosticLogger.prototype.unload.
    // This is a workaround for an IE bug when using dynamicProto() with classes that don't have any
    // non-dynamic functions or static properties/functions when using uglify-js to minify the resulting code.
    DiagnosticLogger.__ieDyn=1;

    return DiagnosticLogger;
}());
function _getLogger(logger) {
    return (logger || new DiagnosticLogger());
}
/**
 * This is a helper method which will call throwInternal on the passed logger, will throw exceptions in
 * debug mode or attempt to log the error as a console warning. This helper is provided mostly to better
 * support minification as logger.throwInternal() will not compress the publish "throwInternal" used throughout
 * the code.
 * @param logger - The Diagnostic Logger instance to use.
 * @param severity - {LoggingSeverity} - The severity of the log message
 * @param message - {_InternalLogMessage} - The log message.
 */
function _throwInternal(logger, severity, msgId, msg, properties, isUserAct) {
    if (isUserAct === void 0) { isUserAct = false; }
    _getLogger(logger)[_DYN_THROW_INTERNAL /* @min:%2ethrowInternal */](severity, msgId, msg, properties, isUserAct);
}
/**
 * This is a helper method which will call warnToConsole on the passed logger with the provided message.
 * @param logger - The Diagnostic Logger instance to use.
 * @param message - {_InternalLogMessage} - The log message.
 */
function _warnToConsole(logger, message) {
    _getLogger(logger)[_DYN_WARN_TO_CONSOLE /* @min:%2ewarnToConsole */](message);
}
/**
 * Logs a message to the internal queue.
 * @param logger - The Diagnostic Logger instance to use.
 * @param severity - {LoggingSeverity} - The severity of the log message
 * @param message - {_InternalLogMessage} - The message to log.
 */
function _logInternalMessage(logger, severity, message) {
    _getLogger(logger)[_DYN_LOG_INTERNAL_MESSAGE /* @min:%2elogInternalMessage */](severity, message);
}

/*
 * Application Insights JavaScript SDK - Core, 3.0.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */
var _a$9, _b$2;
var strToGMTString = "toGMTString";
var strToUTCString = "toUTCString";
var strCookie = "cookie";
var strExpires = "expires";
var strIsCookieUseDisabled = "isCookieUseDisabled";
var strDisableCookiesUsage = "disableCookiesUsage";
var strConfigCookieMgr = "_ckMgr";
var _supportsCookies = null;
var _allowUaSameSite = null;
var _parsedCookieValue = null;
var _doc;
var _cookieCache = {};
var _globalCookieConfig = {};
// // `isCookieUseDisabled` is deprecated, so explicitly casting as a key of IConfiguration to avoid typing error
// // when both isCookieUseDisabled and disableCookiesUsage are used disableCookiesUsage will take precedent, which is
// // why its listed first
/**
 * Set the supported dynamic config values as undefined (or an empty object) so that
 * any listeners will be informed of any changes.
 * Explicitly NOT including the deprecated `isCookieUseDisabled` as we don't want to support
 * the v1 deprecated field as dynamic for updates
 */
var rootDefaultConfig = (_a$9 = {
        cookieCfg: cfgDfMerge((_b$2 = {},
            _b$2[STR_DOMAIN] = { fb: "cookieDomain", dfVal: isNotNullOrUndefined },
            _b$2.path = { fb: "cookiePath", dfVal: isNotNullOrUndefined },
            _b$2.enabled = UNDEFINED_VALUE$2,
            _b$2.ignoreCookies = UNDEFINED_VALUE$2,
            _b$2.blockedCookies = UNDEFINED_VALUE$2,
            _b$2)),
        cookieDomain: UNDEFINED_VALUE$2,
        cookiePath: UNDEFINED_VALUE$2
    },
    _a$9[strDisableCookiesUsage] = UNDEFINED_VALUE$2,
    _a$9);
function _getDoc() {
    !_doc && (_doc = getLazy(function () { return getDocument(); }));
}
/**
 * @ignore
 * DO NOT USE or export from the module, this is exposed as public to support backward compatibility of previous static utility methods only.
 * If you want to manager cookies either use the ICookieMgr available from the core instance via getCookieMgr() or create
 * your own instance of the CookieMgr and use that.
 * Using this directly for enabling / disabling cookie handling will not only affect your usage but EVERY user of cookies.
 * Example, if you are using a shared component that is also using Application Insights you will affect their cookie handling.
 * @param logger - The DiagnosticLogger to use for reporting errors.
 */
function _gblCookieMgr(config, logger) {
    // Stash the global instance against the BaseCookieMgr class
    var inst = createCookieMgr[strConfigCookieMgr] || _globalCookieConfig[strConfigCookieMgr];
    if (!inst) {
        // Note: not using the getSetValue() helper as that would require always creating a temporary cookieMgr
        // that ultimately is never used
        inst = createCookieMgr[strConfigCookieMgr] = createCookieMgr(config, logger);
        _globalCookieConfig[strConfigCookieMgr] = inst;
    }
    return inst;
}
function _isMgrEnabled(cookieMgr) {
    if (cookieMgr) {
        return cookieMgr.isEnabled();
    }
    return true;
}
function _isIgnoredCookie(cookieMgrCfg, name) {
    if (name && cookieMgrCfg && isArray(cookieMgrCfg.ignoreCookies)) {
        return arrIndexOf(cookieMgrCfg.ignoreCookies, name) !== -1;
    }
    return false;
}
function _isBlockedCookie(cookieMgrCfg, name) {
    if (name && cookieMgrCfg && isArray(cookieMgrCfg.blockedCookies)) {
        if (arrIndexOf(cookieMgrCfg.blockedCookies, name) !== -1) {
            return true;
        }
    }
    return _isIgnoredCookie(cookieMgrCfg, name);
}
function _isCfgEnabled(rootConfig, cookieMgrConfig) {
    var isCfgEnabled = cookieMgrConfig[_DYN_ENABLED /* @min:%2eenabled */];
    if (isNullOrUndefined(isCfgEnabled)) {
        // Set the enabled from the provided setting or the legacy root values
        var cookieEnabled = void 0;
        // This field is deprecated and dynamic updates will not be fully supported
        if (!isUndefined(rootConfig[strIsCookieUseDisabled])) {
            cookieEnabled = !rootConfig[strIsCookieUseDisabled];
        }
        // If this value is defined it takes precedent over the above
        if (!isUndefined(rootConfig[strDisableCookiesUsage])) {
            cookieEnabled = !rootConfig[strDisableCookiesUsage];
        }
        // Not setting the cookieMgrConfig.enabled as that will update (set) the global dynamic config
        // So future "updates" then may not be as expected
        isCfgEnabled = cookieEnabled;
    }
    return isCfgEnabled;
}
/**
 * Helper to return the ICookieMgr from the core (if not null/undefined) or a default implementation
 * associated with the configuration or a legacy default.
 * @param core
 * @param config
 * @returns
 */
function safeGetCookieMgr(core, config) {
    var cookieMgr;
    if (core) {
        // Always returns an instance
        cookieMgr = core.getCookieMgr();
    }
    else if (config) {
        var cookieCfg = config.cookieCfg;
        if (cookieCfg && cookieCfg[strConfigCookieMgr]) {
            cookieMgr = cookieCfg[strConfigCookieMgr];
        }
        else {
            cookieMgr = createCookieMgr(config);
        }
    }
    if (!cookieMgr) {
        // Get or initialize the default global (legacy) cookie manager if we couldn't find one
        cookieMgr = _gblCookieMgr(config, (core || {})[_DYN_LOGGER /* @min:%2elogger */]);
    }
    return cookieMgr;
}
function createCookieMgr(rootConfig, logger) {
    var _a;
    var cookieMgrConfig;
    var _path;
    var _domain;
    var unloadHandler;
    // Explicitly checking against false, so that setting to undefined will === true
    var _enabled;
    var _getCookieFn;
    var _setCookieFn;
    var _delCookieFn;
    // Make sure the root config is dynamic as it may be the global config
    rootConfig = createDynamicConfig(rootConfig || _globalCookieConfig, null, logger).cfg;
    // Will get recalled if the referenced configuration is changed
    unloadHandler = onConfigChange(rootConfig, function (details) {
        // Make sure the root config has all of the the defaults to the root config to ensure they are dynamic
        details[_DYN_SET_DF /* @min:%2esetDf */](details.cfg, rootDefaultConfig);
        // Create and apply the defaults to the cookieCfg element
        cookieMgrConfig = details.ref(details.cfg, "cookieCfg"); // details.setDf(details.cfg.cookieCfg, defaultConfig);
        _path = cookieMgrConfig[STR_PATH /* @min:%2epath */] || "/";
        _domain = cookieMgrConfig[STR_DOMAIN /* @min:%2edomain */];
        // Explicitly checking against false, so that setting to undefined will === true
        _enabled = _isCfgEnabled(rootConfig, cookieMgrConfig) !== false;
        _getCookieFn = cookieMgrConfig.getCookie || _getCookieValue;
        _setCookieFn = cookieMgrConfig.setCookie || _setCookieValue;
        _delCookieFn = cookieMgrConfig.delCookie || _setCookieValue;
    }, logger);
    var cookieMgr = (_a = {
            isEnabled: function () {
                var enabled = _isCfgEnabled(rootConfig, cookieMgrConfig) !== false && _enabled && areCookiesSupported(logger);
                // Using an indirect lookup for any global cookie manager to support tree shaking for SDK's
                // that don't use the "applicationinsights-core" version of the default cookie function
                var gblManager = _globalCookieConfig[strConfigCookieMgr];
                if (enabled && gblManager && cookieMgr !== gblManager) {
                    // Make sure the GlobalCookie Manager instance (if not this instance) is also enabled.
                    // As the global (deprecated) functions may have been called (for backward compatibility)
                    enabled = _isMgrEnabled(gblManager);
                }
                return enabled;
            },
            setEnabled: function (value) {
                // Explicitly checking against false, so that setting to undefined will === true
                _enabled = value !== false;
                cookieMgrConfig[_DYN_ENABLED /* @min:%2eenabled */] = value;
            },
            set: function (name, value, maxAgeSec, domain, path) {
                var result = false;
                if (_isMgrEnabled(cookieMgr) && !_isBlockedCookie(cookieMgrConfig, name)) {
                    var values = {};
                    var theValue = strTrim(value || STR_EMPTY);
                    var idx = strIndexOf(theValue, ";");
                    if (idx !== -1) {
                        theValue = strTrim(strLeft(value, idx));
                        values = _extractParts(strSubstring(value, idx + 1));
                    }
                    // Only update domain if not already present (isUndefined) and the value is truthy (not null, undefined or empty string)
                    setValue(values, STR_DOMAIN, domain || _domain, isTruthy, isUndefined);
                    if (!isNullOrUndefined(maxAgeSec)) {
                        var _isIE = isIE();
                        if (isUndefined(values[strExpires])) {
                            var nowMs = utcNow();
                            // Only add expires if not already present
                            var expireMs = nowMs + (maxAgeSec * 1000);
                            // Sanity check, if zero or -ve then ignore
                            if (expireMs > 0) {
                                var expiry = new Date();
                                expiry.setTime(expireMs);
                                setValue(values, strExpires, _formatDate(expiry, !_isIE ? strToUTCString : strToGMTString) || _formatDate(expiry, _isIE ? strToGMTString : strToUTCString) || STR_EMPTY, isTruthy);
                            }
                        }
                        if (!_isIE) {
                            // Only replace if not already present
                            setValue(values, "max-age", STR_EMPTY + maxAgeSec, null, isUndefined);
                        }
                    }
                    var location_1 = getLocation();
                    if (location_1 && location_1.protocol === "https:") {
                        setValue(values, "secure", null, null, isUndefined);
                        // Only set same site if not also secure
                        if (_allowUaSameSite === null) {
                            _allowUaSameSite = !uaDisallowsSameSiteNone((getNavigator() || {})[_DYN_USER_AGENT /* @min:%2euserAgent */]);
                        }
                        if (_allowUaSameSite) {
                            setValue(values, "SameSite", "None", null, isUndefined);
                        }
                    }
                    setValue(values, STR_PATH, path || _path, null, isUndefined);
                    //let setCookieFn = cookieMgrConfig.setCookie || _setCookieValue;
                    _setCookieFn(name, _formatCookieValue(theValue, values));
                    result = true;
                }
                return result;
            },
            get: function (name) {
                var value = STR_EMPTY;
                if (_isMgrEnabled(cookieMgr) && !_isIgnoredCookie(cookieMgrConfig, name)) {
                    value = _getCookieFn(name);
                }
                return value;
            },
            del: function (name, path) {
                var result = false;
                if (_isMgrEnabled(cookieMgr)) {
                    // Only remove the cookie if the manager and cookie support has not been disabled
                    result = cookieMgr.purge(name, path);
                }
                return result;
            },
            purge: function (name, path) {
                var _a;
                var result = false;
                if (areCookiesSupported(logger)) {
                    // Setting the expiration date in the past immediately removes the cookie
                    var values = (_a = {},
                        _a[STR_PATH] = path ? path : "/",
                        _a[strExpires] = "Thu, 01 Jan 1970 00:00:01 GMT",
                        _a);
                    if (!isIE()) {
                        // Set max age to expire now
                        values["max-age"] = "0";
                    }
                    // let delCookie = cookieMgrConfig.delCookie || _setCookieValue;
                    _delCookieFn(name, _formatCookieValue(STR_EMPTY, values));
                    result = true;
                }
                return result;
            }
        },
        _a[_DYN_UNLOAD /* @min:unload */] = function (isAsync) {
            unloadHandler && unloadHandler.rm();
            unloadHandler = null;
        },
        _a);
    // Associated this cookie manager with the config
    cookieMgr[strConfigCookieMgr] = cookieMgr;
    return cookieMgr;
}
/*
* Helper method to tell if document.cookie object is supported by the runtime
*/
function areCookiesSupported(logger) {
    if (_supportsCookies === null) {
        _supportsCookies = false;
        !_doc && _getDoc();
        try {
            var doc = _doc.v || {};
            _supportsCookies = doc[strCookie] !== undefined;
        }
        catch (e) {
            _throwInternal(logger, 2 /* eLoggingSeverity.WARNING */, 68 /* _eInternalMessageId.CannotAccessCookie */, "Cannot access document.cookie - " + getExceptionName(e), { exception: dumpObj(e) });
        }
    }
    return _supportsCookies;
}
function _extractParts(theValue) {
    var values = {};
    if (theValue && theValue[_DYN_LENGTH$5 /* @min:%2elength */]) {
        var parts = strTrim(theValue)[_DYN_SPLIT$1 /* @min:%2esplit */](";");
        arrForEach(parts, function (thePart) {
            thePart = strTrim(thePart || STR_EMPTY);
            if (thePart) {
                var idx = strIndexOf(thePart, "=");
                if (idx === -1) {
                    values[thePart] = null;
                }
                else {
                    values[strTrim(strLeft(thePart, idx))] = strTrim(strSubstring(thePart, idx + 1));
                }
            }
        });
    }
    return values;
}
function _formatDate(theDate, func) {
    if (isFunction(theDate[func])) {
        return theDate[func]();
    }
    return null;
}
function _formatCookieValue(value, values) {
    var cookieValue = value || STR_EMPTY;
    objForEachKey(values, function (name, theValue) {
        cookieValue += "; " + name + (!isNullOrUndefined(theValue) ? "=" + theValue : STR_EMPTY);
    });
    return cookieValue;
}
function _getCookieValue(name) {
    var cookieValue = STR_EMPTY;
    !_doc && _getDoc();
    if (_doc.v) {
        var theCookie = _doc.v[strCookie] || STR_EMPTY;
        if (_parsedCookieValue !== theCookie) {
            _cookieCache = _extractParts(theCookie);
            _parsedCookieValue = theCookie;
        }
        cookieValue = strTrim(_cookieCache[name] || STR_EMPTY);
    }
    return cookieValue;
}
function _setCookieValue(name, cookieValue) {
    !_doc && _getDoc();
    if (_doc.v) {
        _doc.v[strCookie] = name + "=" + cookieValue;
    }
}
function uaDisallowsSameSiteNone(userAgent) {
    if (!isString(userAgent)) {
        return false;
    }
    // Cover all iOS based browsers here. This includes:
    // - Safari on iOS 12 for iPhone, iPod Touch, iPad
    // - WkWebview on iOS 12 for iPhone, iPod Touch, iPad
    // - Chrome on iOS 12 for iPhone, iPod Touch, iPad
    // All of which are broken by SameSite=None, because they use the iOS networking stack
    if (strContains(userAgent, "CPU iPhone OS 12") || strContains(userAgent, "iPad; CPU OS 12")) {
        return true;
    }
    // Cover Mac OS X based browsers that use the Mac OS networking stack. This includes:
    // - Safari on Mac OS X
    // This does not include:
    // - Internal browser on Mac OS X
    // - Chrome on Mac OS X
    // - Chromium on Mac OS X
    // Because they do not use the Mac OS networking stack.
    if (strContains(userAgent, "Macintosh; Intel Mac OS X 10_14") && strContains(userAgent, "Version/") && strContains(userAgent, "Safari")) {
        return true;
    }
    // Cover Mac OS X internal browsers that use the Mac OS networking stack. This includes:
    // - Internal browser on Mac OS X
    // This does not include:
    // - Safari on Mac OS X
    // - Chrome on Mac OS X
    // - Chromium on Mac OS X
    // Because they do not use the Mac OS networking stack.
    if (strContains(userAgent, "Macintosh; Intel Mac OS X 10_14") && strEndsWith(userAgent, "AppleWebKit/605.1.15 (KHTML, like Gecko)")) {
        return true;
    }
    // Cover Chrome 50-69, because some versions are broken by SameSite=None, and none in this range require it.
    // Note: this covers some pre-Chromium Edge versions, but pre-Chromim Edge does not require SameSite=None, so this is fine.
    // Note: this regex applies to Windows, Mac OS X, and Linux, deliberately.
    if (strContains(userAgent, "Chrome/5") || strContains(userAgent, "Chrome/6")) {
        return true;
    }
    // Unreal Engine runs Chromium 59, but does not advertise as Chrome until 4.23. Treat versions of Unreal
    // that don't specify their Chrome version as lacking support for SameSite=None.
    if (strContains(userAgent, "UnrealEngine") && !strContains(userAgent, "Chrome")) {
        return true;
    }
    // UCBrowser < 12.13.2 ignores Set-Cookie headers with SameSite=None
    // NB: this rule isn't complete - you need regex to make a complete rule.
    // See: https://www.chromium.org/updates/same-site/incompatible-clients
    if (strContains(userAgent, "UCBrowser/12") || strContains(userAgent, "UCBrowser/11")) {
        return true;
    }
    return false;
}

/*
 * Application Insights JavaScript SDK - Core, 3.0.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */

var defaultValues$2 = {
    perfEvtsSendAll: false
};
function _runListeners(listeners, name, isAsync, callback) {
    arrForEach(listeners, function (listener) {
        if (listener && listener[name]) {
            if (isAsync) {
                scheduleTimeout(function () { return callback(listener); }, 0);
            }
            else {
                try {
                    callback(listener);
                }
                catch (e) {
                    // Catch errors to ensure we don't block sending the requests
                }
            }
        }
    });
}
/**
 * Class to manage sending notifications to all the listeners.
 */
var NotificationManager = /** @class */ (function () {
    function NotificationManager(config) {
        this.listeners = [];
        var perfEvtsSendAll;
        var unloadHandler;
        var _listeners = [];
        var cfgHandler = createDynamicConfig(config, defaultValues$2);
        unloadHandler = cfgHandler[_DYN_WATCH /* @min:%2ewatch */](function (details) {
            perfEvtsSendAll = !!details.cfg.perfEvtsSendAll;
        });
        dynamicProto(NotificationManager, this, function (_self) {
            objDefine(_self, "listeners", {
                g: function () { return _listeners; }
            });
            _self[_DYN_ADD_NOTIFICATION_LIS1 /* @min:%2eaddNotificationListener */] = function (listener) {
                _listeners[_DYN_PUSH$1 /* @min:%2epush */](listener);
            };
            /**
             * Removes all instances of the listener.
             * @param listener - AWTNotificationListener to remove.
             */
            _self[_DYN_REMOVE_NOTIFICATION_2 /* @min:%2eremoveNotificationListener */] = function (listener) {
                var index = arrIndexOf(_listeners, listener);
                while (index > -1) {
                    _listeners[_DYN_SPLICE /* @min:%2esplice */](index, 1);
                    index = arrIndexOf(_listeners, listener);
                }
            };
            /**
             * Notification for events sent.
             * @param events - The array of events that have been sent.
             */
            _self[STR_EVENTS_SENT /* @min:%2eeventsSent */] = function (events) {
                _runListeners(_listeners, STR_EVENTS_SENT, true, function (listener) {
                    listener[STR_EVENTS_SENT /* @min:%2eeventsSent */](events);
                });
            };
            /**
             * Notification for events being discarded.
             * @param events - The array of events that have been discarded by the SDK.
             * @param reason - The reason for which the SDK discarded the events. The EventsDiscardedReason
             * constant should be used to check the different values.
             */
            _self[STR_EVENTS_DISCARDED /* @min:%2eeventsDiscarded */] = function (events, reason) {
                _runListeners(_listeners, STR_EVENTS_DISCARDED, true, function (listener) {
                    listener[STR_EVENTS_DISCARDED /* @min:%2eeventsDiscarded */](events, reason);
                });
            };
            /**
             * [Optional] A function called when the events have been requested to be sent to the sever.
             * @param sendReason - The reason why the event batch is being sent.
             * @param isAsync - A flag which identifies whether the requests are being sent in an async or sync manner.
             */
            _self[STR_EVENTS_SEND_REQUEST /* @min:%2eeventsSendRequest */] = function (sendReason, isAsync) {
                _runListeners(_listeners, STR_EVENTS_SEND_REQUEST, isAsync, function (listener) {
                    listener[STR_EVENTS_SEND_REQUEST /* @min:%2eeventsSendRequest */](sendReason, isAsync);
                });
            };
            _self[STR_PERF_EVENT /* @min:%2eperfEvent */] = function (perfEvent) {
                if (perfEvent) {
                    // Send all events or only parent events
                    if (perfEvtsSendAll || !perfEvent[_DYN_IS_CHILD_EVT /* @min:%2eisChildEvt */]()) {
                        _runListeners(_listeners, STR_PERF_EVENT, false, function (listener) {
                            if (perfEvent[_DYN_IS_ASYNC /* @min:%2eisAsync */]) {
                                scheduleTimeout(function () { return listener[STR_PERF_EVENT /* @min:%2eperfEvent */](perfEvent); }, 0);
                            }
                            else {
                                listener[STR_PERF_EVENT /* @min:%2eperfEvent */](perfEvent);
                            }
                        });
                    }
                }
            };
            _self[_DYN_UNLOAD /* @min:%2eunload */] = function (isAsync) {
                var _finishUnload = function () {
                    unloadHandler && unloadHandler.rm();
                    unloadHandler = null;
                    _listeners = [];
                };
                var waiting;
                _runListeners(_listeners, "unload", false, function (listener) {
                    var asyncUnload = listener[_DYN_UNLOAD /* @min:%2eunload */](isAsync);
                    if (asyncUnload) {
                        if (!waiting) {
                            waiting = [];
                        }
                        waiting[_DYN_PUSH$1 /* @min:%2epush */](asyncUnload);
                    }
                });
                if (waiting) {
                    return createPromise(function (resolve) {
                        return doAwaitResponse(createAllPromise(waiting), function () {
                            _finishUnload();
                            resolve();
                        });
                    });
                }
                else {
                    _finishUnload();
                }
            };
        });
    }
// Removed Stub for NotificationManager.prototype.addNotificationListener.
// Removed Stub for NotificationManager.prototype.removeNotificationListener.
// Removed Stub for NotificationManager.prototype.eventsSent.
// Removed Stub for NotificationManager.prototype.eventsDiscarded.
// Removed Stub for NotificationManager.prototype.eventsSendRequest.
// Removed Stub for NotificationManager.prototype.perfEvent.
// Removed Stub for NotificationManager.prototype.unload.
    // This is a workaround for an IE bug when using dynamicProto() with classes that don't have any
    // non-dynamic functions or static properties/functions when using uglify-js to minify the resulting code.
    NotificationManager.__ieDyn=1;

    return NotificationManager;
}());

/*
 * Application Insights JavaScript SDK - Core, 3.0.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */

var strExecutionContextKey = "ctx";
var strParentContextKey = "ParentContextKey";
var strChildrenContextKey = "ChildrenContextKey";
var _defaultPerfManager = null;
var PerfEvent = /** @class */ (function () {
    function PerfEvent(name, payloadDetails, isAsync) {
        var _self = this;
        _self.start = utcNow();
        _self[_DYN_NAME$3 /* @min:%2ename */] = name;
        _self[_DYN_IS_ASYNC /* @min:%2eisAsync */] = isAsync;
        _self[_DYN_IS_CHILD_EVT /* @min:%2eisChildEvt */] = function () { return false; };
        if (isFunction(payloadDetails)) {
            // Create an accessor to minimize the potential performance impact of executing the payloadDetails callback
            var theDetails_1;
            objDefine(_self, "payload", {
                g: function () {
                    // Delay the execution of the payloadDetails until needed
                    if (!theDetails_1 && isFunction(payloadDetails)) {
                        theDetails_1 = payloadDetails();
                        // clear it out now so the referenced objects can be garbage collected
                        payloadDetails = null;
                    }
                    return theDetails_1;
                }
            });
        }
        _self[_DYN_GET_CTX /* @min:%2egetCtx */] = function (key) {
            if (key) {
                // The parent and child links are located directly on the object (for better viewing in the DebugPlugin)
                if (key === PerfEvent[strParentContextKey] || key === PerfEvent[strChildrenContextKey]) {
                    return _self[key];
                }
                return (_self[strExecutionContextKey] || {})[key];
            }
            return null;
        };
        _self[_DYN_SET_CTX /* @min:%2esetCtx */] = function (key, value) {
            if (key) {
                // Put the parent and child links directly on the object (for better viewing in the DebugPlugin)
                if (key === PerfEvent[strParentContextKey]) {
                    // Simple assumption, if we are setting a parent then we must be a child
                    if (!_self[key]) {
                        _self[_DYN_IS_CHILD_EVT /* @min:%2eisChildEvt */] = function () { return true; };
                    }
                    _self[key] = value;
                }
                else if (key === PerfEvent[strChildrenContextKey]) {
                    _self[key] = value;
                }
                else {
                    var ctx = _self[strExecutionContextKey] = _self[strExecutionContextKey] || {};
                    ctx[key] = value;
                }
            }
        };
        _self[_DYN_COMPLETE /* @min:%2ecomplete */] = function () {
            var childTime = 0;
            var childEvts = _self[_DYN_GET_CTX /* @min:%2egetCtx */](PerfEvent[strChildrenContextKey]);
            if (isArray(childEvts)) {
                for (var lp = 0; lp < childEvts[_DYN_LENGTH$5 /* @min:%2elength */]; lp++) {
                    var childEvt = childEvts[lp];
                    if (childEvt) {
                        childTime += childEvt[_DYN_TIME /* @min:%2etime */];
                    }
                }
            }
            _self[_DYN_TIME /* @min:%2etime */] = utcNow() - _self.start;
            _self.exTime = _self[_DYN_TIME /* @min:%2etime */] - childTime;
            _self[_DYN_COMPLETE /* @min:%2ecomplete */] = function () { };
        };
    }
    PerfEvent.ParentContextKey = "parent";
    PerfEvent.ChildrenContextKey = "childEvts";
    return PerfEvent;
}());
var PerfManager = /** @class */ (function () {
    function PerfManager(manager) {
        /**
         * General bucket used for execution context set and retrieved via setCtx() and getCtx.
         * Defined as private so it can be visualized via the DebugPlugin
         */
        this.ctx = {};
        dynamicProto(PerfManager, this, function (_self) {
            _self.create = function (src, payloadDetails, isAsync) {
                // TODO (@MSNev): at some point we will want to add additional configuration to "select" which events to instrument
                // for now this is just a simple do everything.
                return new PerfEvent(src, payloadDetails, isAsync);
            };
            _self.fire = function (perfEvent) {
                if (perfEvent) {
                    perfEvent[_DYN_COMPLETE /* @min:%2ecomplete */]();
                    if (manager && isFunction(manager[STR_PERF_EVENT /* @min:%2eperfEvent */])) {
                        manager[STR_PERF_EVENT /* @min:%2eperfEvent */](perfEvent);
                    }
                }
            };
            _self[_DYN_SET_CTX /* @min:%2esetCtx */] = function (key, value) {
                if (key) {
                    var ctx = _self[strExecutionContextKey] = _self[strExecutionContextKey] || {};
                    ctx[key] = value;
                }
            };
            _self[_DYN_GET_CTX /* @min:%2egetCtx */] = function (key) {
                return (_self[strExecutionContextKey] || {})[key];
            };
        });
    }
// Removed Stub for PerfManager.prototype.create.
// Removed Stub for PerfManager.prototype.fire.
// Removed Stub for PerfManager.prototype.setCtx.
// Removed Stub for PerfManager.prototype.getCtx.
    // This is a workaround for an IE bug when using dynamicProto() with classes that don't have any
    // non-dynamic functions or static properties/functions when using uglify-js to minify the resulting code.
    PerfManager.__ieDyn=1;

    return PerfManager;
}());
var doPerfActiveKey = "CoreUtils.doPerf";
/**
 * Helper function to wrap a function with a perf event
 * @param mgrSource - The Performance Manager or a Performance provider source (may be null)
 * @param getSource - The callback to create the source name for the event (if perf monitoring is enabled)
 * @param func - The function to call and measure
 * @param details - A function to return the payload details
 * @param isAsync - Is the event / function being call asynchronously or synchronously
 */
function doPerf(mgrSource, getSource, func, details, isAsync) {
    if (mgrSource) {
        var perfMgr = mgrSource;
        if (perfMgr[STR_GET_PERF_MGR]) {
            // Looks like a perf manager provider object
            perfMgr = perfMgr[STR_GET_PERF_MGR]();
        }
        if (perfMgr) {
            var perfEvt = void 0;
            var currentActive = perfMgr[_DYN_GET_CTX /* @min:%2egetCtx */](doPerfActiveKey);
            try {
                perfEvt = perfMgr.create(getSource(), details, isAsync);
                if (perfEvt) {
                    if (currentActive && perfEvt[_DYN_SET_CTX /* @min:%2esetCtx */]) {
                        perfEvt[_DYN_SET_CTX /* @min:%2esetCtx */](PerfEvent[strParentContextKey], currentActive);
                        if (currentActive[_DYN_GET_CTX /* @min:%2egetCtx */] && currentActive[_DYN_SET_CTX /* @min:%2esetCtx */]) {
                            var children = currentActive[_DYN_GET_CTX /* @min:%2egetCtx */](PerfEvent[strChildrenContextKey]);
                            if (!children) {
                                children = [];
                                currentActive[_DYN_SET_CTX /* @min:%2esetCtx */](PerfEvent[strChildrenContextKey], children);
                            }
                            children[_DYN_PUSH$1 /* @min:%2epush */](perfEvt);
                        }
                    }
                    // Set this event as the active event now
                    perfMgr[_DYN_SET_CTX /* @min:%2esetCtx */](doPerfActiveKey, perfEvt);
                    return func(perfEvt);
                }
            }
            catch (ex) {
                if (perfEvt && perfEvt[_DYN_SET_CTX /* @min:%2esetCtx */]) {
                    perfEvt[_DYN_SET_CTX /* @min:%2esetCtx */]("exception", ex);
                }
            }
            finally {
                // fire the perf event
                if (perfEvt) {
                    perfMgr.fire(perfEvt);
                }
                // Reset the active event to the previous value
                perfMgr[_DYN_SET_CTX /* @min:%2esetCtx */](doPerfActiveKey, currentActive);
            }
        }
    }
    return func();
}
/**
 * Get the current global performance manager that will be used with no performance manager is supplied.
 * @returns - The current default manager
 */
function getGblPerfMgr() {
    return _defaultPerfManager;
}

/*
 * Application Insights JavaScript SDK - Core, 3.0.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */

/**
 * generate W3C trace id
 */
function generateW3CId() {
    var hexValues = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "a", "b", "c", "d", "e", "f"];
    // rfc4122 version 4 UUID without dashes and with lowercase letters
    var oct = STR_EMPTY, tmp;
    for (var a = 0; a < 4; a++) {
        tmp = random32();
        oct +=
            hexValues[tmp & 0xF] +
                hexValues[tmp >> 4 & 0xF] +
                hexValues[tmp >> 8 & 0xF] +
                hexValues[tmp >> 12 & 0xF] +
                hexValues[tmp >> 16 & 0xF] +
                hexValues[tmp >> 20 & 0xF] +
                hexValues[tmp >> 24 & 0xF] +
                hexValues[tmp >> 28 & 0xF];
    }
    // "Set the two most significant bits (bits 6 and 7) of the clock_seq_hi_and_reserved to zero and one, respectively"
    var clockSequenceHi = hexValues[8 + (random32() & 0x03) | 0];
    return strSubstr(oct, 0, 8) + strSubstr(oct, 9, 4) + "4" + strSubstr(oct, 13, 3) + clockSequenceHi + strSubstr(oct, 16, 3) + strSubstr(oct, 19, 12);
}

/*
 * Application Insights JavaScript SDK - Core, 3.0.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */
var DEFAULT_VERSION = "00";
var INVALID_VERSION = "ff";
var INVALID_TRACE_ID = "00000000000000000000000000000000";
var INVALID_SPAN_ID = "0000000000000000";
function _isValid(value, len, invalidValue) {
    if (value && value[_DYN_LENGTH$5 /* @min:%2elength */] === len && value !== invalidValue) {
        return !!value.match(/^[\da-f]*$/i);
    }
    return false;
}
function _formatValue(value, len, defValue) {
    if (_isValid(value, len)) {
        return value;
    }
    return defValue;
}
function _formatFlags(value) {
    if (isNaN(value) || value < 0 || value > 255) {
        value = 0x01;
    }
    var result = value.toString(16);
    while (result[_DYN_LENGTH$5 /* @min:%2elength */] < 2) {
        result = "0" + result;
    }
    return result;
}
/**
 * Create a new ITraceParent instance using the provided values.
 * @param traceId - The traceId to use, when invalid a new random W3C id will be generated.
 * @param spanId - The parent/span id to use, a new random value will be generated if it is invalid.
 * @param flags - The traceFlags to use, defaults to zero (0) if not supplied or invalid
 * @param version - The version to used, defaults to version "01" if not supplied or invalid.
 * @returns
 */
function createTraceParent(traceId, spanId, flags, version) {
    var _a;
    return _a = {},
        _a[_DYN_VERSION$1 /* @min:version */] = _isValid(version, 2, INVALID_VERSION) ? version : DEFAULT_VERSION,
        _a[_DYN_TRACE_ID$2 /* @min:traceId */] = isValidTraceId(traceId) ? traceId : generateW3CId(),
        _a[_DYN_SPAN_ID$1 /* @min:spanId */] = isValidSpanId(spanId) ? spanId : strLeft(generateW3CId(), 16),
        _a.traceFlags = flags >= 0 && flags <= 0xFF ? flags : 1,
        _a;
}
/**
 * Is the provided W3c Trace Id a valid string representation, it must be a 32-character string
 * of lowercase hexadecimal characters for example, 4bf92f3577b34da6a3ce929d0e0e4736.
 * If all characters as zero (00000000000000000000000000000000) it will be considered an invalid value.
 * @param value - The W3c trace Id to be validated
 * @returns true if valid otherwise false
 */
function isValidTraceId(value) {
    return _isValid(value, 32, INVALID_TRACE_ID);
}
/**
 * Is the provided W3c span id (aka. parent id) a valid string representation, it must be a 16-character
 * string of lowercase hexadecimal characters, for example, 00f067aa0ba902b7.
 * If all characters are zero (0000000000000000) this is considered an invalid value.
 * @param value - The W3c span id to be validated
 * @returns true if valid otherwise false
 */
function isValidSpanId(value) {
    return _isValid(value, 16, INVALID_SPAN_ID);
}
/**
 * Format the ITraceParent value as a string using the supported and know version formats.
 * So even if the passed traceParent is a later version the string value returned from this
 * function will convert it to only the known version formats.
 * This currently only supports version "00" and invalid "ff"
 * @param value - The parsed traceParent value
 * @returns
 */
function formatTraceParent(value) {
    if (value) {
        // Special Note: This only supports formatting as version 00, future versions should encode any known supported version
        // So parsing a future version will populate the correct version value but reformatting will reduce it to version 00.
        var flags = _formatFlags(value[_DYN_TRACE_FLAGS$1 /* @min:%2etraceFlags */]);
        if (!_isValid(flags, 2)) {
            flags = "01";
        }
        var version = value[_DYN_VERSION$1 /* @min:%2eversion */] || DEFAULT_VERSION;
        if (version !== "00" && version !== "ff") {
            // Reduce version to "00"
            version = DEFAULT_VERSION;
        }
        // Format as version 00
        return "".concat(version.toLowerCase(), "-").concat(_formatValue(value.traceId, 32, INVALID_TRACE_ID).toLowerCase(), "-").concat(_formatValue(value.spanId, 16, INVALID_SPAN_ID).toLowerCase(), "-").concat(flags.toLowerCase());
    }
    return "";
}

/*
 * Application Insights JavaScript SDK - Core, 3.0.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */

var pluginStateData = createElmNodeData("plugin");
function _getPluginState(plugin) {
    return pluginStateData.get(plugin, "state", {}, true);
}
/**
 * Initialize the queue of plugins
 * @param plugins - The array of plugins to initialize and setting of the next plugin
 * @param config - The current config for the instance
 * @param core - THe current core instance
 * @param extensions - The extensions
 */
function initializePlugins(processContext, extensions) {
    // Set the next plugin and identified the uninitialized plugins
    var initPlugins = [];
    var lastPlugin = null;
    var proxy = processContext[_DYN_GET_NEXT /* @min:%2egetNext */]();
    var pluginState;
    while (proxy) {
        var thePlugin = proxy[_DYN_GET_PLUGIN /* @min:%2egetPlugin */]();
        if (thePlugin) {
            if (lastPlugin && lastPlugin[_DYN_SET_NEXT_PLUGIN /* @min:%2esetNextPlugin */] && thePlugin[STR_PROCESS_TELEMETRY /* @min:%2eprocessTelemetry */]) {
                // Set this plugin as the next for the previous one
                lastPlugin[_DYN_SET_NEXT_PLUGIN /* @min:%2esetNextPlugin */](thePlugin);
            }
            pluginState = _getPluginState(thePlugin);
            var isInitialized = !!pluginState[_DYN_IS_INITIALIZED /* @min:%2eisInitialized */];
            if (thePlugin[_DYN_IS_INITIALIZED /* @min:%2eisInitialized */]) {
                isInitialized = thePlugin[_DYN_IS_INITIALIZED /* @min:%2eisInitialized */]();
            }
            if (!isInitialized) {
                initPlugins[_DYN_PUSH$1 /* @min:%2epush */](thePlugin);
            }
            lastPlugin = thePlugin;
            proxy = proxy[_DYN_GET_NEXT /* @min:%2egetNext */]();
        }
    }
    // Now initialize the plugins
    arrForEach(initPlugins, function (thePlugin) {
        var core = processContext[STR_CORE /* @min:%2ecore */]();
        thePlugin[_DYN_INITIALIZE /* @min:%2einitialize */](processContext.getCfg(), core, extensions, processContext[_DYN_GET_NEXT /* @min:%2egetNext */]());
        pluginState = _getPluginState(thePlugin);
        // Only add the core to the state if the plugin didn't set it (doesn't extend from BaseTelemetryPlugin)
        if (!thePlugin[STR_CORE] && !pluginState[STR_CORE]) {
            pluginState[STR_CORE] = core;
        }
        pluginState[_DYN_IS_INITIALIZED /* @min:%2eisInitialized */] = true;
        delete pluginState[_DYN_TEARDOWN /* @min:%2eteardown */];
    });
}
function sortPlugins(plugins) {
    // Sort by priority
    return plugins.sort(function (extA, extB) {
        var result = 0;
        if (extB) {
            var bHasProcess = extB[STR_PROCESS_TELEMETRY];
            if (extA[STR_PROCESS_TELEMETRY]) {
                result = bHasProcess ? extA[STR_PRIORITY] - extB[STR_PRIORITY] : 1;
            }
            else if (bHasProcess) {
                result = -1;
            }
        }
        else {
            result = extA ? 1 : -1;
        }
        return result;
    });
    // sort complete
}
/**
 * Creates a IDistributedTraceContext which optionally also "sets" the value on a parent
 * @param parentCtx - An optional parent distributed trace instance
 * @returns A new IDistributedTraceContext instance that uses an internal temporary object
 */
function createDistributedTraceContext(parentCtx) {
    var trace = {};
    return {
        getName: function () {
            return trace[_DYN_NAME$3 /* @min:%2ename */];
        },
        setName: function (newValue) {
            parentCtx && parentCtx.setName(newValue);
            trace[_DYN_NAME$3 /* @min:%2ename */] = newValue;
        },
        getTraceId: function () {
            return trace[_DYN_TRACE_ID$2 /* @min:%2etraceId */];
        },
        setTraceId: function (newValue) {
            parentCtx && parentCtx.setTraceId(newValue);
            if (isValidTraceId(newValue)) {
                trace[_DYN_TRACE_ID$2 /* @min:%2etraceId */] = newValue;
            }
        },
        getSpanId: function () {
            return trace[_DYN_SPAN_ID$1 /* @min:%2espanId */];
        },
        setSpanId: function (newValue) {
            parentCtx && parentCtx.setSpanId(newValue);
            if (isValidSpanId(newValue)) {
                trace[_DYN_SPAN_ID$1 /* @min:%2espanId */] = newValue;
            }
        },
        getTraceFlags: function () {
            return trace[_DYN_TRACE_FLAGS$1 /* @min:%2etraceFlags */];
        },
        setTraceFlags: function (newTraceFlags) {
            parentCtx && parentCtx.setTraceFlags(newTraceFlags);
            trace[_DYN_TRACE_FLAGS$1 /* @min:%2etraceFlags */] = newTraceFlags;
        }
    };
}

/*
 * Application Insights JavaScript SDK - Core, 3.0.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */

var strTelemetryPluginChain = "TelemetryPluginChain";
var strHasRunFlags = "_hasRun";
var strGetTelCtx = "_getTelCtx";
var _chainId = 0;
function _getNextProxyStart(proxy, core, startAt) {
    while (proxy) {
        if (proxy[_DYN_GET_PLUGIN /* @min:%2egetPlugin */]() === startAt) {
            return proxy;
        }
        proxy = proxy[_DYN_GET_NEXT /* @min:%2egetNext */]();
    }
    // This wasn't found in the existing chain so create an isolated one with just this plugin
    return createTelemetryProxyChain([startAt], core.config || {}, core);
}
/**
 * @ignore
 * @param telemetryChain
 * @param dynamicHandler
 * @param core
 * @param startAt - Identifies the next plugin to execute, if null there is no "next" plugin and if undefined it should assume the start of the chain
 * @returns
 */
function _createInternalContext(telemetryChain, dynamicHandler, core, startAt) {
    // We have a special case where we want to start execution from this specific plugin
    // or we simply reuse the existing telemetry plugin chain (normal execution case)
    var _nextProxy = null; // By Default set as no next plugin
    var _onComplete = [];
    if (!dynamicHandler) {
        dynamicHandler = createDynamicConfig({}, null, core[_DYN_LOGGER /* @min:%2elogger */]);
    }
    if (startAt !== null) {
        // There is no next element (null) vs not defined (undefined) so use the full chain
        _nextProxy = startAt ? _getNextProxyStart(telemetryChain, core, startAt) : telemetryChain;
    }
    var context = {
        _next: _moveNext,
        ctx: {
            core: function () {
                return core;
            },
            diagLog: function () {
                return safeGetLogger(core, dynamicHandler.cfg);
            },
            getCfg: function () {
                return dynamicHandler.cfg;
            },
            getExtCfg: _resolveExtCfg,
            getConfig: _getConfig,
            hasNext: function () {
                return !!_nextProxy;
            },
            getNext: function () {
                return _nextProxy;
            },
            setNext: function (nextPlugin) {
                _nextProxy = nextPlugin;
            },
            iterate: _iterateChain,
            onComplete: _addOnComplete
        }
    };
    function _addOnComplete(onComplete, that) {
        var args = [];
        for (var _i = 2; _i < arguments.length; _i++) {
            args[_i - 2] = arguments[_i];
        }
        if (onComplete) {
            _onComplete[_DYN_PUSH$1 /* @min:%2epush */]({
                func: onComplete,
                self: !isUndefined(that) ? that : context.ctx,
                args: args
            });
        }
    }
    function _moveNext() {
        var nextProxy = _nextProxy;
        // Automatically move to the next plugin
        _nextProxy = nextProxy ? nextProxy[_DYN_GET_NEXT /* @min:%2egetNext */]() : null;
        if (!nextProxy) {
            var onComplete = _onComplete;
            if (onComplete && onComplete[_DYN_LENGTH$5 /* @min:%2elength */] > 0) {
                arrForEach(onComplete, function (completeDetails) {
                    try {
                        completeDetails.func.call(completeDetails.self, completeDetails.args);
                    }
                    catch (e) {
                        _throwInternal(core[_DYN_LOGGER /* @min:%2elogger */], 2 /* eLoggingSeverity.WARNING */, 73 /* _eInternalMessageId.PluginException */, "Unexpected Exception during onComplete - " + dumpObj(e));
                    }
                });
                _onComplete = [];
            }
        }
        return nextProxy;
    }
    function _getExtCfg(identifier, createIfMissing) {
        var idCfg = null;
        var cfg = dynamicHandler.cfg;
        if (cfg && identifier) {
            var extCfg = cfg[STR_EXTENSION_CONFIG /* @min:%2eextensionConfig */];
            if (!extCfg && createIfMissing) {
                extCfg = {};
            }
            // Always set the value so that the property always exists
            cfg[STR_EXTENSION_CONFIG] = extCfg; // Note: it is valid for the "value" to be undefined
            // Calling `ref()` has a side effect of causing the referenced property to become dynamic  (if not already)
            extCfg = dynamicHandler.ref(cfg, STR_EXTENSION_CONFIG);
            if (extCfg) {
                idCfg = extCfg[identifier];
                if (!idCfg && createIfMissing) {
                    idCfg = {};
                }
                // Always set the value so that the property always exists
                extCfg[identifier] = idCfg; // Note: it is valid for the "value" to be undefined
                // Calling `ref()` has a side effect of causing the referenced property to become dynamic  (if not already)
                idCfg = dynamicHandler.ref(extCfg, identifier);
            }
        }
        return idCfg;
    }
    function _resolveExtCfg(identifier, defaultValues) {
        var newConfig = _getExtCfg(identifier, true);
        if (defaultValues) {
            // Enumerate over the defaultValues and if not already populated attempt to
            // find a value from the root config or use the default value
            objForEachKey(defaultValues, function (field, defaultValue) {
                // for each unspecified field, set the default value
                if (isNullOrUndefined(newConfig[field])) {
                    var cfgValue = dynamicHandler.cfg[field];
                    if (cfgValue || !isNullOrUndefined(cfgValue)) {
                        newConfig[field] = cfgValue;
                    }
                }
                _applyDefaultValue(dynamicHandler, newConfig, field, defaultValue);
            });
        }
        return dynamicHandler[_DYN_SET_DF /* @min:%2esetDf */](newConfig, defaultValues);
    }
    function _getConfig(identifier, field, defaultValue) {
        if (defaultValue === void 0) { defaultValue = false; }
        var theValue;
        var extConfig = _getExtCfg(identifier, false);
        var rootConfig = dynamicHandler.cfg;
        if (extConfig && (extConfig[field] || !isNullOrUndefined(extConfig[field]))) {
            theValue = extConfig[field];
        }
        else if (rootConfig[field] || !isNullOrUndefined(rootConfig[field])) {
            theValue = rootConfig[field];
        }
        return (theValue || !isNullOrUndefined(theValue)) ? theValue : defaultValue;
    }
    function _iterateChain(cb) {
        // Keep processing until we reach the end of the chain
        var nextPlugin;
        while (!!(nextPlugin = context._next())) {
            var plugin = nextPlugin[_DYN_GET_PLUGIN /* @min:%2egetPlugin */]();
            if (plugin) {
                // callback with the current on
                cb(plugin);
            }
        }
    }
    return context;
}
/**
 * Creates a new Telemetry Item context with the current config, core and plugin execution chain
 * @param plugins - The plugin instances that will be executed
 * @param config - The current config
 * @param core - The current core instance
 * @param startAt - Identifies the next plugin to execute, if null there is no "next" plugin and if undefined it should assume the start of the chain
 */
function createProcessTelemetryContext(telemetryChain, cfg, core, startAt) {
    var config = createDynamicConfig(cfg);
    var internalContext = _createInternalContext(telemetryChain, config, core, startAt);
    var context = internalContext.ctx;
    function _processNext(env) {
        var nextPlugin = internalContext._next();
        if (nextPlugin) {
            // Run the next plugin which will call "processNext()"
            nextPlugin[STR_PROCESS_TELEMETRY /* @min:%2eprocessTelemetry */](env, context);
        }
        return !nextPlugin;
    }
    function _createNew(plugins, startAt) {
        if (plugins === void 0) { plugins = null; }
        if (isArray(plugins)) {
            plugins = createTelemetryProxyChain(plugins, config.cfg, core, startAt);
        }
        return createProcessTelemetryContext(plugins || context[_DYN_GET_NEXT /* @min:%2egetNext */](), config.cfg, core, startAt);
    }
    context[_DYN_PROCESS_NEXT /* @min:%2eprocessNext */] = _processNext;
    context[_DYN_CREATE_NEW$1 /* @min:%2ecreateNew */] = _createNew;
    return context;
}
/**
 * Creates a new Telemetry Item context with the current config, core and plugin execution chain for handling the unloading of the chain
 * @param plugins - The plugin instances that will be executed
 * @param config - The current config
 * @param core - The current core instance
 * @param startAt - Identifies the next plugin to execute, if null there is no "next" plugin and if undefined it should assume the start of the chain
 */
function createProcessTelemetryUnloadContext(telemetryChain, core, startAt) {
    var config = createDynamicConfig(core.config);
    var internalContext = _createInternalContext(telemetryChain, config, core, startAt);
    var context = internalContext.ctx;
    function _processNext(unloadState) {
        var nextPlugin = internalContext._next();
        nextPlugin && nextPlugin[_DYN_UNLOAD /* @min:%2eunload */](context, unloadState);
        return !nextPlugin;
    }
    function _createNew(plugins, startAt) {
        if (plugins === void 0) { plugins = null; }
        if (isArray(plugins)) {
            plugins = createTelemetryProxyChain(plugins, config.cfg, core, startAt);
        }
        return createProcessTelemetryUnloadContext(plugins || context[_DYN_GET_NEXT /* @min:%2egetNext */](), core, startAt);
    }
    context[_DYN_PROCESS_NEXT /* @min:%2eprocessNext */] = _processNext;
    context[_DYN_CREATE_NEW$1 /* @min:%2ecreateNew */] = _createNew;
    return context;
}
/**
 * Creates a new Telemetry Item context with the current config, core and plugin execution chain for updating the configuration
 * @param plugins - The plugin instances that will be executed
 * @param config - The current config
 * @param core - The current core instance
 * @param startAt - Identifies the next plugin to execute, if null there is no "next" plugin and if undefined it should assume the start of the chain
 */
function createProcessTelemetryUpdateContext(telemetryChain, core, startAt) {
    var config = createDynamicConfig(core.config);
    var internalContext = _createInternalContext(telemetryChain, config, core, startAt);
    var context = internalContext.ctx;
    function _processNext(updateState) {
        return context.iterate(function (plugin) {
            if (isFunction(plugin[_DYN_UPDATE$1 /* @min:%2eupdate */])) {
                plugin[_DYN_UPDATE$1 /* @min:%2eupdate */](context, updateState);
            }
        });
    }
    function _createNew(plugins, startAt) {
        if (plugins === void 0) { plugins = null; }
        if (isArray(plugins)) {
            plugins = createTelemetryProxyChain(plugins, config.cfg, core, startAt);
        }
        return createProcessTelemetryUpdateContext(plugins || context[_DYN_GET_NEXT /* @min:%2egetNext */](), core, startAt);
    }
    context[_DYN_PROCESS_NEXT /* @min:%2eprocessNext */] = _processNext;
    context[_DYN_CREATE_NEW$1 /* @min:%2ecreateNew */] = _createNew;
    return context;
}
/**
 * Creates an execution chain from the array of plugins
 * @param plugins - The array of plugins that will be executed in this order
 * @param defItemCtx - The default execution context to use when no telemetry context is passed to processTelemetry(), this
 * should be for legacy plugins only. Currently, only used for passing the current core instance and to provide better error
 * reporting (hasRun) when errors occur.
 */
function createTelemetryProxyChain(plugins, config, core, startAt) {
    var firstProxy = null;
    var add = startAt ? false : true;
    if (isArray(plugins) && plugins[_DYN_LENGTH$5 /* @min:%2elength */] > 0) {
        // Create the proxies and wire up the next plugin chain
        var lastProxy_1 = null;
        arrForEach(plugins, function (thePlugin) {
            if (!add && startAt === thePlugin) {
                add = true;
            }
            if (add && thePlugin && isFunction(thePlugin[STR_PROCESS_TELEMETRY /* @min:%2eprocessTelemetry */])) {
                // Only add plugins that are processors
                var newProxy = createTelemetryPluginProxy(thePlugin, config, core);
                if (!firstProxy) {
                    firstProxy = newProxy;
                }
                if (lastProxy_1) {
                    // Set this new proxy as the next for the previous one
                    lastProxy_1._setNext(newProxy);
                }
                lastProxy_1 = newProxy;
            }
        });
    }
    if (startAt && !firstProxy) {
        // Special case where the "startAt" was not in the original list of plugins
        return createTelemetryProxyChain([startAt], config, core);
    }
    return firstProxy;
}
/**
 * Create the processing telemetry proxy instance, the proxy is used to abstract the current plugin to allow monitoring and
 * execution plugins while passing around the dynamic execution state (IProcessTelemetryContext), the proxy instance no longer
 * contains any execution state and can be reused between requests (this was not the case for 2.7.2 and earlier with the
 * TelemetryPluginChain class).
 * @param plugin - The plugin instance to proxy
 * @param config - The default execution context to use when no telemetry context is passed to processTelemetry(), this
 * should be for legacy plugins only. Currently, only used for passing the current core instance and to provide better error
 * reporting (hasRun) when errors occur.
 * @returns
 */
function createTelemetryPluginProxy(plugin, config, core) {
    var nextProxy = null;
    var hasProcessTelemetry = isFunction(plugin[STR_PROCESS_TELEMETRY /* @min:%2eprocessTelemetry */]);
    var hasSetNext = isFunction(plugin[_DYN_SET_NEXT_PLUGIN /* @min:%2esetNextPlugin */]);
    var chainId;
    if (plugin) {
        chainId = plugin[_DYN_IDENTIFIER /* @min:%2eidentifier */] + "-" + plugin[STR_PRIORITY /* @min:%2epriority */] + "-" + _chainId++;
    }
    else {
        chainId = "Unknown-0-" + _chainId++;
    }
    var proxyChain = {
        getPlugin: function () {
            return plugin;
        },
        getNext: function () {
            return nextProxy;
        },
        processTelemetry: _processTelemetry,
        unload: _unloadPlugin,
        update: _updatePlugin,
        _id: chainId,
        _setNext: function (nextPlugin) {
            nextProxy = nextPlugin;
        }
    };
    function _getTelCtx() {
        var itemCtx;
        // Looks like a plugin didn't pass the (optional) context, so create a new one
        if (plugin && isFunction(plugin[strGetTelCtx])) {
            // This plugin extends from the BaseTelemetryPlugin so lets use it
            itemCtx = plugin[strGetTelCtx]();
        }
        if (!itemCtx) {
            // Create a temporary one
            itemCtx = createProcessTelemetryContext(proxyChain, config, core);
        }
        return itemCtx;
    }
    function _processChain(itemCtx, processPluginFn, name, details, isAsync) {
        var hasRun = false;
        var identifier = plugin ? plugin[_DYN_IDENTIFIER /* @min:%2eidentifier */] : strTelemetryPluginChain;
        var hasRunContext = itemCtx[strHasRunFlags];
        if (!hasRunContext) {
            // Assign and populate
            hasRunContext = itemCtx[strHasRunFlags] = {};
        }
        // Ensure that we keep the context in sync
        itemCtx.setNext(nextProxy);
        if (plugin) {
            doPerf(itemCtx[STR_CORE /* @min:%2ecore */](), function () { return identifier + ":" + name; }, function () {
                // Mark this component as having run
                hasRunContext[chainId] = true;
                try {
                    // Set a flag on the next plugin so we know if it was attempted to be executed
                    var nextId = nextProxy ? nextProxy._id : STR_EMPTY;
                    if (nextId) {
                        hasRunContext[nextId] = false;
                    }
                    hasRun = processPluginFn(itemCtx);
                }
                catch (error) {
                    var hasNextRun = nextProxy ? hasRunContext[nextProxy._id] : true;
                    if (hasNextRun) {
                        // The next plugin after us has already run so set this one as complete
                        hasRun = true;
                    }
                    if (!nextProxy || !hasNextRun) {
                        // Either we have no next plugin or the current one did not attempt to call the next plugin
                        // Which means the current one is the root of the failure so log/report this failure
                        _throwInternal(itemCtx[_DYN_DIAG_LOG$2 /* @min:%2ediagLog */](), 1 /* eLoggingSeverity.CRITICAL */, 73 /* _eInternalMessageId.PluginException */, "Plugin [" + identifier + "] failed during " + name + " - " + dumpObj(error) + ", run flags: " + dumpObj(hasRunContext));
                    }
                }
            }, details, isAsync);
        }
        return hasRun;
    }
    function _processTelemetry(env, itemCtx) {
        itemCtx = itemCtx || _getTelCtx();
        function _callProcessTelemetry(itemCtx) {
            if (!plugin || !hasProcessTelemetry) {
                return false;
            }
            var pluginState = _getPluginState(plugin);
            if (pluginState[_DYN_TEARDOWN /* @min:%2eteardown */] || pluginState[STR_DISABLED]) {
                return false;
            }
            // Ensure that we keep the context in sync (for processNext()), just in case a plugin
            // doesn't calls processTelemetry() instead of itemContext.processNext() or some
            // other form of error occurred
            if (hasSetNext) {
                // Backward compatibility setting the next plugin on the instance
                plugin[_DYN_SET_NEXT_PLUGIN /* @min:%2esetNextPlugin */](nextProxy);
            }
            plugin[STR_PROCESS_TELEMETRY /* @min:%2eprocessTelemetry */](env, itemCtx);
            // Process Telemetry is expected to call itemCtx.processNext() or nextPlugin.processTelemetry()
            return true;
        }
        if (!_processChain(itemCtx, _callProcessTelemetry, "processTelemetry", function () { return ({ item: env }); }, !(env.sync))) {
            // The underlying plugin is either not defined, not enabled or does not have a processTelemetry implementation
            // so we still want the next plugin to be executed.
            itemCtx[_DYN_PROCESS_NEXT /* @min:%2eprocessNext */](env);
        }
    }
    function _unloadPlugin(unloadCtx, unloadState) {
        function _callTeardown() {
            // Setting default of hasRun as false so the proxyProcessFn() is called as teardown() doesn't have to exist or call unloadNext().
            var hasRun = false;
            if (plugin) {
                var pluginState = _getPluginState(plugin);
                var pluginCore = plugin[STR_CORE] || pluginState[STR_CORE /* @min:%2ecore */];
                // Only teardown the plugin if it was initialized by the current core (i.e. It's not a shared plugin)
                if (plugin && (!pluginCore || pluginCore === unloadCtx.core()) && !pluginState[_DYN_TEARDOWN /* @min:%2eteardown */]) {
                    // Handle plugins that don't extend from the BaseTelemetryPlugin
                    pluginState[STR_CORE /* @min:%2ecore */] = null;
                    pluginState[_DYN_TEARDOWN /* @min:%2eteardown */] = true;
                    pluginState[_DYN_IS_INITIALIZED /* @min:%2eisInitialized */] = false;
                    if (plugin[_DYN_TEARDOWN /* @min:%2eteardown */] && plugin[_DYN_TEARDOWN /* @min:%2eteardown */](unloadCtx, unloadState) === true) {
                        // plugin told us that it was going to (or has) call unloadCtx.processNext()
                        hasRun = true;
                    }
                }
            }
            return hasRun;
        }
        if (!_processChain(unloadCtx, _callTeardown, "unload", function () { }, unloadState[_DYN_IS_ASYNC /* @min:%2eisAsync */])) {
            // Only called if we hasRun was not true
            unloadCtx[_DYN_PROCESS_NEXT /* @min:%2eprocessNext */](unloadState);
        }
    }
    function _updatePlugin(updateCtx, updateState) {
        function _callUpdate() {
            // Setting default of hasRun as false so the proxyProcessFn() is called as teardown() doesn't have to exist or call unloadNext().
            var hasRun = false;
            if (plugin) {
                var pluginState = _getPluginState(plugin);
                var pluginCore = plugin[STR_CORE] || pluginState[STR_CORE /* @min:%2ecore */];
                // Only update the plugin if it was initialized by the current core (i.e. It's not a shared plugin)
                if (plugin && (!pluginCore || pluginCore === updateCtx.core()) && !pluginState[_DYN_TEARDOWN /* @min:%2eteardown */]) {
                    if (plugin[_DYN_UPDATE$1 /* @min:%2eupdate */] && plugin[_DYN_UPDATE$1 /* @min:%2eupdate */](updateCtx, updateState) === true) {
                        // plugin told us that it was going to (or has) call unloadCtx.processNext()
                        hasRun = true;
                    }
                }
            }
            return hasRun;
        }
        if (!_processChain(updateCtx, _callUpdate, "update", function () { }, false)) {
            // Only called if we hasRun was not true
            updateCtx[_DYN_PROCESS_NEXT /* @min:%2eprocessNext */](updateState);
        }
    }
    return objFreeze(proxyChain);
}

/*
 * Application Insights JavaScript SDK - Core, 3.0.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */

function createUnloadHandlerContainer() {
    var handlers = [];
    function _addHandler(handler) {
        if (handler) {
            handlers[_DYN_PUSH$1 /* @min:%2epush */](handler);
        }
    }
    function _runHandlers(unloadCtx, unloadState) {
        arrForEach(handlers, function (handler) {
            try {
                handler(unloadCtx, unloadState);
            }
            catch (e) {
                _throwInternal(unloadCtx[_DYN_DIAG_LOG$2 /* @min:%2ediagLog */](), 2 /* eLoggingSeverity.WARNING */, 73 /* _eInternalMessageId.PluginException */, "Unexpected error calling unload handler - " + dumpObj(e));
            }
        });
        handlers = [];
    }
    return {
        add: _addHandler,
        run: _runHandlers
    };
}

/*
 * Application Insights JavaScript SDK - Core, 3.0.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */

/**
 * Create a IUnloadHookContainer which can be used to remember unload hook functions to be executed during the component unloading
 * process.
 * @returns A new IUnloadHookContainer instance
 */
function createUnloadHookContainer() {
    var _hooks = [];
    function _doUnload(logger) {
        var oldHooks = _hooks;
        _hooks = [];
        // Remove all registered unload hooks
        arrForEach(oldHooks, function (fn) {
            // allow either rm or remove callback function
            try {
                (fn.rm || fn.remove).call(fn);
            }
            catch (e) {
                _throwInternal(logger, 2 /* eLoggingSeverity.WARNING */, 73 /* _eInternalMessageId.PluginException */, "Unloading:" + dumpObj(e));
            }
        });
    }
    function _addHook(hooks) {
        if (hooks) {
            arrAppend(_hooks, hooks);
        }
    }
    return {
        run: _doUnload,
        add: _addHook
    };
}

/*
 * Application Insights JavaScript SDK - Core, 3.0.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */

var _a$8;
var strGetPlugin = "getPlugin";
var defaultValues$1 = (_a$8 = {},
    _a$8[STR_EXTENSION_CONFIG] = { isVal: isNotNullOrUndefined, v: {} },
    _a$8);
/**
 * BaseTelemetryPlugin provides a basic implementation of the ITelemetryPlugin interface so that plugins
 * can avoid implementation the same set of boiler plate code as well as provide a base
 * implementation so that new default implementations can be added without breaking all plugins.
 */
var BaseTelemetryPlugin = /** @class */ (function () {
    function BaseTelemetryPlugin() {
        var _self = this; // Setting _self here as it's used outside of the dynamicProto as well
        // NOTE!: DON'T set default values here, instead set them in the _initDefaults() function as it is also called during teardown()
        var _isinitialized;
        var _rootCtx; // Used as the root context, holding the current config and initialized core
        var _nextPlugin; // Used for backward compatibility where plugins don't call the main pipeline
        var _unloadHandlerContainer;
        var _hookContainer;
        _initDefaults();
        dynamicProto(BaseTelemetryPlugin, _self, function (_self) {
            _self[_DYN_INITIALIZE /* @min:%2einitialize */] = function (config, core, extensions, pluginChain) {
                _setDefaults(config, core, pluginChain);
                _isinitialized = true;
            };
            _self[_DYN_TEARDOWN /* @min:%2eteardown */] = function (unloadCtx, unloadState) {
                var _a;
                // If this plugin has already been torn down (not operational) or is not initialized (core is not set)
                // or the core being used for unload was not the same core used for initialization.
                var core = _self[STR_CORE /* @min:%2ecore */];
                if (!core || (unloadCtx && core !== unloadCtx[STR_CORE /* @min:%2ecore */]())) {
                    // Do Nothing as either the plugin is not initialized or was not initialized by the current core
                    return;
                }
                var result;
                var unloadDone = false;
                var theUnloadCtx = unloadCtx || createProcessTelemetryUnloadContext(null, core, _nextPlugin && _nextPlugin[strGetPlugin] ? _nextPlugin[strGetPlugin]() : _nextPlugin);
                var theUnloadState = unloadState || (_a = {
                        reason: 0 /* TelemetryUnloadReason.ManualTeardown */
                    },
                    _a[_DYN_IS_ASYNC /* @min:isAsync */] = false,
                    _a);
                function _unloadCallback() {
                    if (!unloadDone) {
                        unloadDone = true;
                        _unloadHandlerContainer.run(theUnloadCtx, unloadState);
                        _hookContainer.run(theUnloadCtx[_DYN_DIAG_LOG$2 /* @min:%2ediagLog */]());
                        if (result === true) {
                            theUnloadCtx[_DYN_PROCESS_NEXT /* @min:%2eprocessNext */](theUnloadState);
                        }
                        _initDefaults();
                    }
                }
                if (!_self[_DYN__DO_TEARDOWN /* @min:%2e_doTeardown */] || _self[_DYN__DO_TEARDOWN /* @min:%2e_doTeardown */](theUnloadCtx, theUnloadState, _unloadCallback) !== true) {
                    _unloadCallback();
                }
                else {
                    // Tell the caller that we will be calling processNext()
                    result = true;
                }
                return result;
            };
            _self[_DYN_UPDATE$1 /* @min:%2eupdate */] = function (updateCtx, updateState) {
                // If this plugin has already been torn down (not operational) or is not initialized (core is not set)
                // or the core being used for unload was not the same core used for initialization.
                var core = _self[STR_CORE /* @min:%2ecore */];
                if (!core || (updateCtx && core !== updateCtx[STR_CORE /* @min:%2ecore */]())) {
                    // Do Nothing
                    return;
                }
                var result;
                var updateDone = false;
                var theUpdateCtx = updateCtx || createProcessTelemetryUpdateContext(null, core, _nextPlugin && _nextPlugin[strGetPlugin] ? _nextPlugin[strGetPlugin]() : _nextPlugin);
                var theUpdateState = updateState || {
                    reason: 0 /* TelemetryUpdateReason.Unknown */
                };
                function _updateCallback() {
                    if (!updateDone) {
                        updateDone = true;
                        _setDefaults(theUpdateCtx.getCfg(), theUpdateCtx.core(), theUpdateCtx[_DYN_GET_NEXT /* @min:%2egetNext */]());
                    }
                }
                if (!_self._doUpdate || _self._doUpdate(theUpdateCtx, theUpdateState, _updateCallback) !== true) {
                    _updateCallback();
                }
                else {
                    result = true;
                }
                return result;
            };
            proxyFunctionAs(_self, "_addUnloadCb", function () { return _unloadHandlerContainer; }, "add");
            proxyFunctionAs(_self, "_addHook", function () { return _hookContainer; }, "add");
            objDefine(_self, "_unloadHooks", { g: function () { return _hookContainer; } });
        });
        // These are added after the dynamicProto so that are not moved to the prototype
        _self[_DYN_DIAG_LOG$2 /* @min:%2ediagLog */] = function (itemCtx) {
            return _getTelCtx(itemCtx)[_DYN_DIAG_LOG$2 /* @min:%2ediagLog */]();
        };
        _self[_DYN_IS_INITIALIZED /* @min:%2eisInitialized */] = function () {
            return _isinitialized;
        };
        _self.setInitialized = function (isInitialized) {
            _isinitialized = isInitialized;
        };
        // _self.getNextPlugin = () => DO NOT IMPLEMENT
        // Sub-classes of this base class *should* not be relying on this value and instead
        // should use processNext() function. If you require access to the plugin use the
        // IProcessTelemetryContext.getNext().getPlugin() while in the pipeline, Note getNext() may return null.
        _self[_DYN_SET_NEXT_PLUGIN /* @min:%2esetNextPlugin */] = function (next) {
            _nextPlugin = next;
        };
        _self[_DYN_PROCESS_NEXT /* @min:%2eprocessNext */] = function (env, itemCtx) {
            if (itemCtx) {
                // Normal core execution sequence
                itemCtx[_DYN_PROCESS_NEXT /* @min:%2eprocessNext */](env);
            }
            else if (_nextPlugin && isFunction(_nextPlugin[STR_PROCESS_TELEMETRY /* @min:%2eprocessTelemetry */])) {
                // Looks like backward compatibility or out of band processing. And as it looks
                // like a ITelemetryPlugin or ITelemetryPluginChain, just call processTelemetry
                _nextPlugin[STR_PROCESS_TELEMETRY /* @min:%2eprocessTelemetry */](env, null);
            }
        };
        _self._getTelCtx = _getTelCtx;
        function _getTelCtx(currentCtx) {
            if (currentCtx === void 0) { currentCtx = null; }
            var itemCtx = currentCtx;
            if (!itemCtx) {
                var rootCtx = _rootCtx || createProcessTelemetryContext(null, {}, _self[STR_CORE /* @min:%2ecore */]);
                // tslint:disable-next-line: prefer-conditional-expression
                if (_nextPlugin && _nextPlugin[strGetPlugin]) {
                    // Looks like a chain object
                    itemCtx = rootCtx[_DYN_CREATE_NEW$1 /* @min:%2ecreateNew */](null, _nextPlugin[strGetPlugin]);
                }
                else {
                    itemCtx = rootCtx[_DYN_CREATE_NEW$1 /* @min:%2ecreateNew */](null, _nextPlugin);
                }
            }
            return itemCtx;
        }
        function _setDefaults(config, core, pluginChain) {
            // Make sure the extensionConfig exists and the config is dynamic
            createDynamicConfig(config, defaultValues$1, safeGetLogger(core));
            if (!pluginChain && core) {
                // Get the first plugin from the core
                pluginChain = core[_DYN_GET_PROCESS_TEL_CONT0 /* @min:%2egetProcessTelContext */]()[_DYN_GET_NEXT /* @min:%2egetNext */]();
            }
            var nextPlugin = _nextPlugin;
            if (_nextPlugin && _nextPlugin[strGetPlugin]) {
                // If it looks like a proxy/chain then get the plugin
                nextPlugin = _nextPlugin[strGetPlugin]();
            }
            // Support legacy plugins where core was defined as a property
            _self[STR_CORE /* @min:%2ecore */] = core;
            _rootCtx = createProcessTelemetryContext(pluginChain, config, core, nextPlugin);
        }
        function _initDefaults() {
            _isinitialized = false;
            _self[STR_CORE /* @min:%2ecore */] = null;
            _rootCtx = null;
            _nextPlugin = null;
            _hookContainer = createUnloadHookContainer();
            _unloadHandlerContainer = createUnloadHandlerContainer();
        }
    }
// Removed Stub for BaseTelemetryPlugin.prototype.initialize.
// Removed Stub for BaseTelemetryPlugin.prototype.teardown.
// Removed Stub for BaseTelemetryPlugin.prototype.update.
// Removed Stub for BaseTelemetryPlugin.prototype._addUnloadCb.
// Removed Stub for BaseTelemetryPlugin.prototype._addHook.
    // This is a workaround for an IE bug when using dynamicProto() with classes that don't have any
    // non-dynamic functions or static properties/functions when using uglify-js to minify the resulting code.
    BaseTelemetryPlugin.__ieDyn=1;

    return BaseTelemetryPlugin;
}());

/*
 * Application Insights JavaScript SDK - Core, 3.0.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */
// 
// 
function _addInitializer(_initializers, id, telemetryInitializer) {
    var theInitializer = {
        id: id,
        fn: telemetryInitializer
    };
    arrAppend(_initializers, theInitializer);
    var handler = {
        remove: function () {
            arrForEach(_initializers, function (initializer, idx) {
                if (initializer.id === theInitializer.id) {
                    _initializers[_DYN_SPLICE /* @min:%2esplice */](idx, 1);
                    return -1;
                }
            });
        }
    };
    return handler;
}
function _runInitializers(_initializers, item, logger) {
    var doNotSendItem = false;
    var telemetryInitializersCount = _initializers[_DYN_LENGTH$5 /* @min:%2elength */];
    for (var i = 0; i < telemetryInitializersCount; ++i) {
        var telemetryInitializer = _initializers[i];
        if (telemetryInitializer) {
            try {
                if (telemetryInitializer.fn[_DYN_APPLY /* @min:%2eapply */](null, [item]) === false) {
                    doNotSendItem = true;
                    break;
                }
            }
            catch (e) {
                // log error but dont stop executing rest of the telemetry initializers
                // doNotSendItem = true;
                _throwInternal(logger, 2 /* eLoggingSeverity.WARNING */, 64 /* _eInternalMessageId.TelemetryInitializerFailed */, "Telemetry initializer failed: " + getExceptionName(e), { exception: dumpObj(e) }, true);
            }
        }
    }
    return !doNotSendItem;
}
var TelemetryInitializerPlugin = /** @class */ (function (_super) {
    __extendsFn(TelemetryInitializerPlugin, _super);
    function TelemetryInitializerPlugin() {
        var _this = _super.call(this) || this;
        _this.identifier = "TelemetryInitializerPlugin";
        _this.priority = 199;
        // NOTE!: DON'T set default values here, instead set them in the _initDefaults() function as it is also called during teardown()
        var _id;
        var _initializers;
        _initDefaults();
        dynamicProto(TelemetryInitializerPlugin, _this, function (_self, _base) {
            _self.addTelemetryInitializer = function (telemetryInitializer) {
                return _addInitializer(_initializers, _id++, telemetryInitializer);
            };
            _self[STR_PROCESS_TELEMETRY /* @min:%2eprocessTelemetry */] = function (item, itemCtx) {
                if (_runInitializers(_initializers, item, itemCtx ? itemCtx[_DYN_DIAG_LOG$2 /* @min:%2ediagLog */]() : _self[_DYN_DIAG_LOG$2 /* @min:%2ediagLog */]())) {
                    _self[_DYN_PROCESS_NEXT /* @min:%2eprocessNext */](item, itemCtx);
                }
            };
            _self[_DYN__DO_TEARDOWN /* @min:%2e_doTeardown */] = function () {
                _initDefaults();
            };
        });
        function _initDefaults() {
            _id = 0;
            _initializers = [];
        }
        return _this;
    }
// Removed Stub for TelemetryInitializerPlugin.prototype.addTelemetryInitializer.
// Removed Stub for TelemetryInitializerPlugin.prototype.processTelemetry.
    // This is a workaround for an IE bug when using dynamicProto() with classes that don't have any
    // non-dynamic functions or static properties/functions when using uglify-js to minify the resulting code.
    TelemetryInitializerPlugin.__ieDyn=1;

    return TelemetryInitializerPlugin;
}(BaseTelemetryPlugin));

/*
 * Application Insights JavaScript SDK - Core, 3.0.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */

var _a$7;
var strValidationError = "Plugins must provide initialize method";
var strNotificationManager = "_notificationManager";
var strSdkUnloadingError = "SDK is still unloading...";
var strSdkNotInitialized = "SDK is not initialized";
// const strPluginUnloadFailed = "Failed to unload plugin";
/**
 * The default settings for the config.
 * WE MUST include all defaults here to ensure that the config is created with all of the properties
 * defined as dynamic.
 */
var defaultConfig = objDeepFreeze((_a$7 = {
        cookieCfg: {}
    },
    _a$7[STR_EXTENSIONS] = { rdOnly: true, ref: true, v: [] },
    _a$7[STR_CHANNELS] = { rdOnly: true, ref: true, v: [] },
    _a$7[STR_EXTENSION_CONFIG] = { ref: true, v: {} },
    _a$7[STR_CREATE_PERF_MGR] = UNDEFINED_VALUE$2,
    _a$7.loggingLevelConsole = 0 /* eLoggingSeverity.DISABLED */,
    _a$7.diagnosticLogInterval = UNDEFINED_VALUE$2,
    _a$7));
/**
 * Helper to create the default performance manager
 * @param core
 * @param notificationMgr
 */
function _createPerfManager(core, notificationMgr) {
    return new PerfManager(notificationMgr);
}
function _validateExtensions(logger, channelPriority, allExtensions) {
    var _a;
    // Concat all available extensions
    var coreExtensions = [];
    var channels = [];
    // Check if any two extensions have the same priority, then warn to console
    // And extract the local extensions from the
    var extPriorities = {};
    // Extension validation
    arrForEach(allExtensions, function (ext) {
        // Check for ext.initialize
        if (isNullOrUndefined(ext) || isNullOrUndefined(ext[_DYN_INITIALIZE /* @min:%2einitialize */])) {
            throwError(strValidationError);
        }
        var extPriority = ext[STR_PRIORITY /* @min:%2epriority */];
        var identifier = ext[_DYN_IDENTIFIER /* @min:%2eidentifier */];
        if (ext && extPriority) {
            if (!isNullOrUndefined(extPriorities[extPriority])) {
                _warnToConsole(logger, "Two extensions have same priority #" + extPriority + " - " + extPriorities[extPriority] + ", " + identifier);
            }
            else {
                // set a value
                extPriorities[extPriority] = identifier;
            }
        }
        // Split extensions to core and channels
        if (!extPriority || extPriority < channelPriority) {
            // Add to core extension that will be managed by AppInsightsCore
            coreExtensions[_DYN_PUSH$1 /* @min:%2epush */](ext);
        }
        else {
            channels[_DYN_PUSH$1 /* @min:%2epush */](ext);
        }
    });
    return _a = {},
        _a[STR_CORE /* @min:core */] = coreExtensions,
        _a[STR_CHANNELS /* @min:channels */] = channels,
        _a;
}
function _isPluginPresent(thePlugin, plugins) {
    var exists = false;
    arrForEach(plugins, function (plugin) {
        if (plugin === thePlugin) {
            exists = true;
            return -1;
        }
    });
    return exists;
}
function _deepMergeConfig(details, target, newValues, merge) {
    // Lets assign the new values to the existing config
    if (newValues) {
        objForEachKey(newValues, function (key, value) {
            if (merge) {
                if (isPlainObject(value) && isPlainObject(target[key])) {
                    // The target is an object and it has a value
                    _deepMergeConfig(details, target[key], value, merge);
                }
            }
            if (merge && isPlainObject(value) && isPlainObject(target[key])) {
                // The target is an object and it has a value
                _deepMergeConfig(details, target[key], value, merge);
            }
            else {
                // Just Assign (replace) and/or make the property dynamic
                details.set(target, key, value);
            }
        });
    }
}
function _findWatcher(listeners, newWatcher) {
    var theListener = null;
    var idx = -1;
    arrForEach(listeners, function (listener, lp) {
        if (listener.w === newWatcher) {
            theListener = listener;
            idx = lp;
            return -1;
        }
    });
    return { i: idx, l: theListener };
}
function _addDelayedCfgListener(listeners, newWatcher) {
    var theListener = _findWatcher(listeners, newWatcher).l;
    if (!theListener) {
        theListener = {
            w: newWatcher,
            rm: function () {
                var fnd = _findWatcher(listeners, newWatcher);
                if (fnd.i !== -1) {
                    listeners[_DYN_SPLICE /* @min:%2esplice */](fnd.i, 1);
                }
            }
        };
        listeners[_DYN_PUSH$1 /* @min:%2epush */](theListener);
    }
    return theListener;
}
function _registerDelayedCfgListener(config, listeners, logger) {
    arrForEach(listeners, function (listener) {
        var unloadHdl = onConfigChange(config, listener.w, logger);
        delete listener.w; // Clear the listener reference so it will get garbage collected.
        // replace the remove function
        listener.rm = function () {
            unloadHdl.rm();
        };
    });
}
/**
 * @group Classes
 * @group Entrypoint
 */
var AppInsightsCore = /** @class */ (function () {
    function AppInsightsCore() {
        // NOTE!: DON'T set default values here, instead set them in the _initDefaults() function as it is also called during teardown()
        var _configHandler;
        var _isInitialized;
        var _logger;
        var _eventQueue;
        var _notificationManager;
        var _perfManager;
        var _cfgPerfManager;
        var _cookieManager;
        var _pluginChain;
        var _configExtensions;
        var _channelConfig;
        var _channels;
        var _isUnloading;
        var _telemetryInitializerPlugin;
        var _internalLogsEventName;
        var _evtNamespace;
        var _unloadHandlers;
        var _hookContainer;
        var _debugListener;
        var _traceCtx;
        var _instrumentationKey;
        var _cfgListeners;
        var _extensions;
        var _pluginVersionStringArr;
        var _pluginVersionString;
        /**
         * Internal log poller
         */
        var _internalLogPoller;
        var _internalLogPollerListening;
        var _forceStopInternalLogPoller;
        dynamicProto(AppInsightsCore, this, function (_self) {
            // Set the default values (also called during teardown)
            _initDefaults();
            // Special internal method to allow the unit tests and DebugPlugin to hook embedded objects
            _self["_getDbgPlgTargets"] = function () {
                return [_extensions];
            };
            _self[_DYN_IS_INITIALIZED /* @min:%2eisInitialized */] = function () { return _isInitialized; };
            // Creating the self.initialize = ()
            _self[_DYN_INITIALIZE /* @min:%2einitialize */] = function (config, extensions, logger, notificationManager) {
                if (_isUnloading) {
                    throwError(strSdkUnloadingError);
                }
                // Make sure core is only initialized once
                if (_self[_DYN_IS_INITIALIZED /* @min:%2eisInitialized */]()) {
                    throwError("Core cannot be initialized more than once");
                }
                _configHandler = createDynamicConfig(config, defaultConfig, logger || _self[_DYN_LOGGER /* @min:%2elogger */], false);
                // Re-assigning the local config property so we don't have any references to the passed value and it can be garbage collected
                config = _configHandler.cfg;
                // This will be "re-run" if the referenced config properties are changed
                _addUnloadHook(_configHandler[_DYN_WATCH /* @min:%2ewatch */](function (details) {
                    _instrumentationKey = details.cfg.instrumentationKey;
                    // Mark the extensionConfig and all first level keys as referenced
                    // This is so that calls to getExtCfg() will always return the same object
                    // Even when a user may "re-assign" the plugin properties (or it's unloaded/reloaded)
                    var extCfg = details.ref(details.cfg, STR_EXTENSION_CONFIG);
                    objForEachKey(extCfg, function (key) {
                        details.ref(extCfg, key);
                    });
                    if (isNullOrUndefined(_instrumentationKey)) {
                        throwError("Please provide instrumentation key");
                    }
                }));
                _notificationManager = notificationManager;
                _initDebugListener();
                _initPerfManager();
                _self[_DYN_LOGGER /* @min:%2elogger */] = logger;
                var cfgExtensions = config[STR_EXTENSIONS /* @min:%2eextensions */];
                // Extension validation
                _configExtensions = [];
                _configExtensions[_DYN_PUSH$1 /* @min:%2epush */].apply(_configExtensions, __spreadArrayFn(__spreadArrayFn([], extensions, false), cfgExtensions));
                _channelConfig = config[STR_CHANNELS /* @min:%2echannels */];
                _initPluginChain(null);
                if (!_channels || _channels[_DYN_LENGTH$5 /* @min:%2elength */] === 0) {
                    throwError("No " + STR_CHANNELS + " available");
                }
                if (_channelConfig && _channelConfig[_DYN_LENGTH$5 /* @min:%2elength */] > 1) {
                    var teeController = _self[_DYN_GET_PLUGIN /* @min:%2egetPlugin */]("TeeChannelController");
                    if (!teeController || !teeController.plugin) {
                        _throwInternal(_logger, 1 /* eLoggingSeverity.CRITICAL */, 28 /* _eInternalMessageId.SenderNotInitialized */, "TeeChannel required");
                    }
                }
                _registerDelayedCfgListener(config, _cfgListeners, _logger);
                _cfgListeners = null;
                _isInitialized = true;
                _self.releaseQueue();
                _self[_DYN_POLL_INTERNAL_LOGS /* @min:%2epollInternalLogs */]();
            };
            _self.getChannels = function () {
                var controls = [];
                if (_channels) {
                    arrForEach(_channels, function (channel) {
                        controls[_DYN_PUSH$1 /* @min:%2epush */](channel);
                    });
                }
                return objFreeze(controls);
            };
            _self.track = function (telemetryItem) {
                doPerf(_self[STR_GET_PERF_MGR /* @min:%2egetPerfMgr */](), function () { return "AppInsightsCore:track"; }, function () {
                    if (telemetryItem === null) {
                        _notifyInvalidEvent(telemetryItem);
                        // throw error
                        throwError("Invalid telemetry item");
                    }
                    // do basic validation before sending it through the pipeline
                    if (!telemetryItem[_DYN_NAME$3 /* @min:%2ename */] && isNullOrUndefined(telemetryItem[_DYN_NAME$3 /* @min:%2ename */])) {
                        _notifyInvalidEvent(telemetryItem);
                        throwError("telemetry name required");
                    }
                    // setup default iKey if not passed in
                    telemetryItem.iKey = telemetryItem.iKey || _instrumentationKey;
                    // add default timestamp if not passed in
                    telemetryItem[_DYN_TIME /* @min:%2etime */] = telemetryItem[_DYN_TIME /* @min:%2etime */] || toISOString(new Date());
                    // Common Schema 4.0
                    telemetryItem.ver = telemetryItem.ver || "4.0";
                    if (!_isUnloading && _self[_DYN_IS_INITIALIZED /* @min:%2eisInitialized */]()) {
                        // Process the telemetry plugin chain
                        _createTelCtx()[_DYN_PROCESS_NEXT /* @min:%2eprocessNext */](telemetryItem);
                    }
                    else {
                        // Queue events until all extensions are initialized
                        _eventQueue[_DYN_PUSH$1 /* @min:%2epush */](telemetryItem);
                    }
                }, function () { return ({ item: telemetryItem }); }, !(telemetryItem.sync));
            };
            _self[_DYN_GET_PROCESS_TEL_CONT0 /* @min:%2egetProcessTelContext */] = _createTelCtx;
            _self[_DYN_GET_NOTIFY_MGR /* @min:%2egetNotifyMgr */] = function () {
                if (!_notificationManager) {
                    _notificationManager = new NotificationManager(_configHandler.cfg);
                    // For backward compatibility only
                    _self[strNotificationManager] = _notificationManager;
                }
                return _notificationManager;
            };
            /**
             * Adds a notification listener. The SDK calls methods on the listener when an appropriate notification is raised.
             * The added plugins must raise notifications. If the plugins do not implement the notifications, then no methods will be
             * called.
             * @param listener - An INotificationListener object.
             */
            _self[_DYN_ADD_NOTIFICATION_LIS1 /* @min:%2eaddNotificationListener */] = function (listener) {
                _self[_DYN_GET_NOTIFY_MGR /* @min:%2egetNotifyMgr */]()[_DYN_ADD_NOTIFICATION_LIS1 /* @min:%2eaddNotificationListener */](listener);
            };
            /**
             * Removes all instances of the listener.
             * @param listener - INotificationListener to remove.
             */
            _self[_DYN_REMOVE_NOTIFICATION_2 /* @min:%2eremoveNotificationListener */] = function (listener) {
                if (_notificationManager) {
                    _notificationManager[_DYN_REMOVE_NOTIFICATION_2 /* @min:%2eremoveNotificationListener */](listener);
                }
            };
            _self.getCookieMgr = function () {
                if (!_cookieManager) {
                    _cookieManager = createCookieMgr(_configHandler.cfg, _self[_DYN_LOGGER /* @min:%2elogger */]);
                }
                return _cookieManager;
            };
            _self.setCookieMgr = function (cookieMgr) {
                if (_cookieManager !== cookieMgr) {
                    runTargetUnload(_cookieManager, false);
                    _cookieManager = cookieMgr;
                }
            };
            _self[STR_GET_PERF_MGR /* @min:%2egetPerfMgr */] = function () {
                if (!_perfManager && !_cfgPerfManager) {
                    _addUnloadHook(_configHandler[_DYN_WATCH /* @min:%2ewatch */](function (details) {
                        if (details.cfg.enablePerfMgr) {
                            var createPerfMgr = details.cfg[STR_CREATE_PERF_MGR /* @min:%2ecreatePerfMgr */];
                            if (isFunction(createPerfMgr)) {
                                _cfgPerfManager = createPerfMgr(_self, _self[_DYN_GET_NOTIFY_MGR /* @min:%2egetNotifyMgr */]());
                            }
                        }
                    }));
                }
                return _perfManager || _cfgPerfManager || getGblPerfMgr();
            };
            _self.setPerfMgr = function (perfMgr) {
                _perfManager = perfMgr;
            };
            _self.eventCnt = function () {
                return _eventQueue[_DYN_LENGTH$5 /* @min:%2elength */];
            };
            _self.releaseQueue = function () {
                if (_isInitialized && _eventQueue[_DYN_LENGTH$5 /* @min:%2elength */] > 0) {
                    var eventQueue = _eventQueue;
                    _eventQueue = [];
                    arrForEach(eventQueue, function (event) {
                        _createTelCtx()[_DYN_PROCESS_NEXT /* @min:%2eprocessNext */](event);
                    });
                }
            };
            _self[_DYN_POLL_INTERNAL_LOGS /* @min:%2epollInternalLogs */] = function (eventName) {
                _internalLogsEventName = eventName || null;
                _forceStopInternalLogPoller = false;
                _internalLogPoller && _internalLogPoller[_DYN_CANCEL /* @min:%2ecancel */]();
                return _startLogPoller(true);
            };
            function _startLogPoller(alwaysStart) {
                if ((!_internalLogPoller || !_internalLogPoller[_DYN_ENABLED /* @min:%2eenabled */]) && !_forceStopInternalLogPoller) {
                    var shouldStart = alwaysStart || (_logger && _logger.queue[_DYN_LENGTH$5 /* @min:%2elength */] > 0);
                    if (shouldStart) {
                        if (!_internalLogPollerListening) {
                            _internalLogPollerListening = true;
                            // listen for any configuration changes so that changes to the
                            // interval will cause the timer to be re-initialized
                            _addUnloadHook(_configHandler[_DYN_WATCH /* @min:%2ewatch */](function (details) {
                                var interval = details.cfg.diagnosticLogInterval;
                                if (!interval || !(interval > 0)) {
                                    interval = 10000;
                                }
                                var isRunning = false;
                                if (_internalLogPoller) {
                                    // It was already created so remember it's running and cancel
                                    isRunning = _internalLogPoller[_DYN_ENABLED /* @min:%2eenabled */];
                                    _internalLogPoller[_DYN_CANCEL /* @min:%2ecancel */]();
                                }
                                // Create / reconfigure
                                _internalLogPoller = createTimeout(_flushInternalLogs, interval);
                                _internalLogPoller.unref();
                                // Restart if previously running
                                _internalLogPoller[_DYN_ENABLED /* @min:%2eenabled */] = isRunning;
                            }));
                        }
                        _internalLogPoller[_DYN_ENABLED /* @min:%2eenabled */] = true;
                    }
                }
                return _internalLogPoller;
            }
            _self[_DYN_STOP_POLLING_INTERNA3 /* @min:%2estopPollingInternalLogs */] = function () {
                _forceStopInternalLogPoller = true;
                _internalLogPoller && _internalLogPoller[_DYN_CANCEL /* @min:%2ecancel */]();
                _flushInternalLogs();
            };
            // Add addTelemetryInitializer
            proxyFunctions(_self, function () { return _telemetryInitializerPlugin; }, ["addTelemetryInitializer"]);
            _self[_DYN_UNLOAD /* @min:%2eunload */] = function (isAsync, unloadComplete, cbTimeout) {
                var _a;
                if (isAsync === void 0) { isAsync = true; }
                if (!_isInitialized) {
                    // The SDK is not initialized
                    throwError(strSdkNotInitialized);
                }
                // Check if the SDK still unloading so throw
                if (_isUnloading) {
                    // The SDK is already unloading
                    throwError(strSdkUnloadingError);
                }
                var unloadState = (_a = {
                        reason: 50 /* TelemetryUnloadReason.SdkUnload */
                    },
                    _a[_DYN_IS_ASYNC /* @min:isAsync */] = isAsync,
                    _a.flushComplete = false,
                    _a);
                var result;
                if (isAsync && !unloadComplete) {
                    result = createPromise(function (resolve) {
                        // Set the callback to the promise resolve callback
                        unloadComplete = resolve;
                    });
                }
                var processUnloadCtx = createProcessTelemetryUnloadContext(_getPluginChain(), _self);
                processUnloadCtx[_DYN_ON_COMPLETE /* @min:%2eonComplete */](function () {
                    _hookContainer.run(_self[_DYN_LOGGER /* @min:%2elogger */]);
                    // Run any "unload" functions for the _cookieManager, _notificationManager and _logger
                    doUnloadAll([_cookieManager, _notificationManager, _logger], isAsync, function () {
                        _initDefaults();
                        unloadComplete && unloadComplete(unloadState);
                    });
                }, _self);
                function _doUnload(flushComplete) {
                    unloadState.flushComplete = flushComplete;
                    _isUnloading = true;
                    // Run all of the unload handlers first (before unloading the plugins)
                    _unloadHandlers.run(processUnloadCtx, unloadState);
                    // Stop polling the internal logs
                    _self[_DYN_STOP_POLLING_INTERNA3 /* @min:%2estopPollingInternalLogs */]();
                    // Start unloading the components, from this point onwards the SDK should be considered to be in an unstable state
                    processUnloadCtx[_DYN_PROCESS_NEXT /* @min:%2eprocessNext */](unloadState);
                }
                _flushInternalLogs();
                if (!_flushChannels(isAsync, _doUnload, 6 /* SendRequestReason.SdkUnload */, cbTimeout)) ;
                return result;
            };
            _self[_DYN_GET_PLUGIN /* @min:%2egetPlugin */] = _getPlugin;
            _self.addPlugin = function (plugin, replaceExisting, isAsync, addCb) {
                if (!plugin) {
                    addCb && addCb(false);
                    _logOrThrowError(strValidationError);
                    return;
                }
                var existingPlugin = _getPlugin(plugin[_DYN_IDENTIFIER /* @min:%2eidentifier */]);
                if (existingPlugin && !replaceExisting) {
                    addCb && addCb(false);
                    _logOrThrowError("Plugin [" + plugin[_DYN_IDENTIFIER /* @min:%2eidentifier */] + "] is already loaded!");
                    return;
                }
                var updateState = {
                    reason: 16 /* TelemetryUpdateReason.PluginAdded */
                };
                function _addPlugin(removed) {
                    _configExtensions[_DYN_PUSH$1 /* @min:%2epush */](plugin);
                    updateState.added = [plugin];
                    // Re-Initialize the plugin chain
                    _initPluginChain(updateState);
                    addCb && addCb(true);
                }
                if (existingPlugin) {
                    var removedPlugins_1 = [existingPlugin.plugin];
                    var unloadState = {
                        reason: 2 /* TelemetryUnloadReason.PluginReplace */,
                        isAsync: !!isAsync
                    };
                    _removePlugins(removedPlugins_1, unloadState, function (removed) {
                        if (!removed) {
                            // Previous plugin was successfully removed or was not installed
                            addCb && addCb(false);
                        }
                        else {
                            updateState.removed = removedPlugins_1;
                            updateState.reason |= 32 /* TelemetryUpdateReason.PluginRemoved */;
                            _addPlugin();
                        }
                    });
                }
                else {
                    _addPlugin();
                }
            };
            _self.updateCfg = function (newConfig, mergeExisting) {
                if (mergeExisting === void 0) { mergeExisting = true; }
                var updateState;
                if (_self[_DYN_IS_INITIALIZED /* @min:%2eisInitialized */]()) {
                    updateState = {
                        reason: 1 /* TelemetryUpdateReason.ConfigurationChanged */,
                        cfg: _configHandler.cfg,
                        oldCfg: deepExtend({}, _configHandler.cfg),
                        newConfig: deepExtend({}, newConfig),
                        merge: mergeExisting
                    };
                    newConfig = updateState.newConfig;
                    var cfg = _configHandler.cfg;
                    // replace the immutable (if initialized) values
                    // We don't currently allow updating the extensions and channels via the update config
                    // So overwriting any user provided values to reuse the existing values
                    newConfig[STR_EXTENSIONS /* @min:%2eextensions */] = cfg[STR_EXTENSIONS /* @min:%2eextensions */];
                    newConfig[STR_CHANNELS /* @min:%2echannels */] = cfg[STR_CHANNELS /* @min:%2echannels */];
                }
                // Explicitly blocking any previous config watchers so that they don't get called because
                // of this bulk update (Probably not necessary)
                _configHandler._block(function (details) {
                    // Lets assign the new values to the existing config either overwriting or re-assigning
                    var theConfig = details.cfg;
                    _deepMergeConfig(details, theConfig, newConfig, mergeExisting);
                    if (!mergeExisting) {
                        // Remove (unassign) the values "missing" from the newConfig and also not in the default config
                        objForEachKey(theConfig, function (key) {
                            if (!objHasOwn(newConfig, key)) {
                                // Set the value to undefined
                                details.set(theConfig, key, UNDEFINED_VALUE$2);
                            }
                        });
                    }
                    // Apply defaults to the new config
                    details[_DYN_SET_DF /* @min:%2esetDf */](theConfig, defaultConfig);
                }, true);
                // Now execute all of the listeners (synchronously) so they update their values immediately
                _configHandler[_DYN_NOTIFY /* @min:%2enotify */]();
                if (updateState) {
                    _doUpdate(updateState);
                }
            };
            _self.evtNamespace = function () {
                return _evtNamespace;
            };
            _self.flush = _flushChannels;
            _self.getTraceCtx = function (createNew) {
                if (!_traceCtx) {
                    _traceCtx = createDistributedTraceContext();
                }
                return _traceCtx;
            };
            _self.setTraceCtx = function (traceCtx) {
                _traceCtx = traceCtx || null;
            };
            _self.addUnloadHook = _addUnloadHook;
            // Create the addUnloadCb
            proxyFunctionAs(_self, "addUnloadCb", function () { return _unloadHandlers; }, "add");
            _self.onCfgChange = function (handler) {
                var unloadHook;
                if (!_isInitialized) {
                    unloadHook = _addDelayedCfgListener(_cfgListeners, handler);
                }
                else {
                    unloadHook = onConfigChange(_configHandler.cfg, handler, _self[_DYN_LOGGER /* @min:%2elogger */]);
                }
                return {
                    rm: function () {
                        unloadHook.rm();
                    }
                };
            };
            _self.getWParam = function () {
                return (hasDocument() || !!_configHandler.cfg.enableWParam) ? 0 : -1;
            };
            function _setPluginVersions() {
                var thePlugins = {};
                _pluginVersionStringArr = [];
                var _addPluginVersions = function (plugins) {
                    if (plugins) {
                        arrForEach(plugins, function (plugin) {
                            if (plugin[_DYN_IDENTIFIER /* @min:%2eidentifier */] && plugin[_DYN_VERSION$1 /* @min:%2eversion */] && !thePlugins[plugin.identifier]) {
                                var ver = plugin[_DYN_IDENTIFIER /* @min:%2eidentifier */] + "=" + plugin[_DYN_VERSION$1 /* @min:%2eversion */];
                                _pluginVersionStringArr[_DYN_PUSH$1 /* @min:%2epush */](ver);
                                thePlugins[plugin.identifier] = plugin;
                            }
                        });
                    }
                };
                _addPluginVersions(_channels);
                if (_channelConfig) {
                    arrForEach(_channelConfig, function (channels) {
                        _addPluginVersions(channels);
                    });
                }
                _addPluginVersions(_configExtensions);
            }
            function _initDefaults() {
                _isInitialized = false;
                // Use a default logger so initialization errors are not dropped on the floor with full logging
                _configHandler = createDynamicConfig({}, defaultConfig, _self[_DYN_LOGGER /* @min:%2elogger */]);
                // Set the logging level to critical so that any critical initialization failures are displayed on the console
                _configHandler.cfg[_DYN_LOGGING_LEVEL_CONSOL4 /* @min:%2eloggingLevelConsole */] = 1 /* eLoggingSeverity.CRITICAL */;
                // Define _self.config
                objDefine(_self, "config", {
                    g: function () { return _configHandler.cfg; },
                    s: function (newValue) {
                        _self.updateCfg(newValue, false);
                    }
                });
                objDefine(_self, "pluginVersionStringArr", {
                    g: function () {
                        if (!_pluginVersionStringArr) {
                            _setPluginVersions();
                        }
                        return _pluginVersionStringArr;
                    }
                });
                objDefine(_self, "pluginVersionString", {
                    g: function () {
                        if (!_pluginVersionString) {
                            if (!_pluginVersionStringArr) {
                                _setPluginVersions();
                            }
                            _pluginVersionString = _pluginVersionStringArr.join(";");
                        }
                        return _pluginVersionString || STR_EMPTY;
                    }
                });
                objDefine(_self, "logger", {
                    g: function () {
                        if (!_logger) {
                            _logger = new DiagnosticLogger(_configHandler.cfg);
                            _configHandler[_DYN_LOGGER /* @min:%2elogger */] = _logger;
                        }
                        return _logger;
                    },
                    s: function (newLogger) {
                        _configHandler[_DYN_LOGGER /* @min:%2elogger */] = newLogger;
                        if (_logger !== newLogger) {
                            runTargetUnload(_logger, false);
                            _logger = newLogger;
                        }
                    }
                });
                _self[_DYN_LOGGER /* @min:%2elogger */] = new DiagnosticLogger(_configHandler.cfg);
                _extensions = [];
                var cfgExtensions = _self.config[STR_EXTENSIONS /* @min:%2eextensions */] || [];
                cfgExtensions.splice(0, cfgExtensions[_DYN_LENGTH$5 /* @min:%2elength */]);
                arrAppend(cfgExtensions, _extensions);
                _telemetryInitializerPlugin = new TelemetryInitializerPlugin();
                _eventQueue = [];
                runTargetUnload(_notificationManager, false);
                _notificationManager = null;
                _perfManager = null;
                _cfgPerfManager = null;
                runTargetUnload(_cookieManager, false);
                _cookieManager = null;
                _pluginChain = null;
                _configExtensions = [];
                _channelConfig = null;
                _channels = null;
                _isUnloading = false;
                _internalLogsEventName = null;
                _evtNamespace = createUniqueNamespace("AIBaseCore", true);
                _unloadHandlers = createUnloadHandlerContainer();
                _traceCtx = null;
                _instrumentationKey = null;
                _hookContainer = createUnloadHookContainer();
                _cfgListeners = [];
                _pluginVersionString = null;
                _pluginVersionStringArr = null;
                _forceStopInternalLogPoller = false;
            }
            function _createTelCtx() {
                var theCtx = createProcessTelemetryContext(_getPluginChain(), _configHandler.cfg, _self);
                theCtx[_DYN_ON_COMPLETE /* @min:%2eonComplete */](_startLogPoller);
                return theCtx;
            }
            // Initialize or Re-initialize the plugins
            function _initPluginChain(updateState) {
                // Extension validation
                var theExtensions = _validateExtensions(_self[_DYN_LOGGER /* @min:%2elogger */], ChannelControllerPriority, _configExtensions);
                _pluginChain = null;
                _pluginVersionString = null;
                _pluginVersionStringArr = null;
                // Get the primary channel queue and include as part of the normal extensions
                _channels = (_channelConfig || [])[0] || [];
                // Add any channels provided in the extensions and sort them
                _channels = sortPlugins(arrAppend(_channels, theExtensions[STR_CHANNELS /* @min:%2echannels */]));
                // Create an array of all extensions, including the _channels
                var allExtensions = arrAppend(sortPlugins(theExtensions[STR_CORE /* @min:%2ecore */]), _channels);
                // Required to allow plugins to call core.getPlugin() during their own initialization
                _extensions = objFreeze(allExtensions);
                // This has a side effect of adding the extensions passed during initialization
                // into the config.extensions, so you can see all of the extensions loaded.
                // This will also get updated by the addPlugin() and remove plugin code.
                var cfgExtensions = _self.config[STR_EXTENSIONS /* @min:%2eextensions */] || [];
                cfgExtensions.splice(0, cfgExtensions[_DYN_LENGTH$5 /* @min:%2elength */]);
                arrAppend(cfgExtensions, _extensions);
                var rootCtx = _createTelCtx();
                // Initializing the channels first
                if (_channels && _channels[_DYN_LENGTH$5 /* @min:%2elength */] > 0) {
                    initializePlugins(rootCtx[_DYN_CREATE_NEW$1 /* @min:%2ecreateNew */](_channels), allExtensions);
                }
                // Now initialize the normal extensions (explicitly not including the _channels as this can cause duplicate initialization)
                initializePlugins(rootCtx, allExtensions);
                if (updateState) {
                    _doUpdate(updateState);
                }
            }
            function _getPlugin(pluginIdentifier) {
                var theExt = null;
                var thePlugin = null;
                var channelHosts = [];
                arrForEach(_extensions, function (ext) {
                    if (ext[_DYN_IDENTIFIER /* @min:%2eidentifier */] === pluginIdentifier && ext !== _telemetryInitializerPlugin) {
                        thePlugin = ext;
                        return -1;
                    }
                    if (ext.getChannel) {
                        channelHosts[_DYN_PUSH$1 /* @min:%2epush */](ext);
                    }
                });
                if (!thePlugin && channelHosts[_DYN_LENGTH$5 /* @min:%2elength */] > 0) {
                    arrForEach(channelHosts, function (host) {
                        thePlugin = host.getChannel(pluginIdentifier);
                        if (!thePlugin) {
                            return -1;
                        }
                    });
                }
                if (thePlugin) {
                    theExt = {
                        plugin: thePlugin,
                        setEnabled: function (enabled) {
                            _getPluginState(thePlugin)[STR_DISABLED] = !enabled;
                        },
                        isEnabled: function () {
                            var pluginState = _getPluginState(thePlugin);
                            return !pluginState[_DYN_TEARDOWN /* @min:%2eteardown */] && !pluginState[STR_DISABLED];
                        },
                        remove: function (isAsync, removeCb) {
                            var _a;
                            if (isAsync === void 0) { isAsync = true; }
                            var pluginsToRemove = [thePlugin];
                            var unloadState = (_a = {
                                    reason: 1 /* TelemetryUnloadReason.PluginUnload */
                                },
                                _a[_DYN_IS_ASYNC /* @min:isAsync */] = isAsync,
                                _a);
                            _removePlugins(pluginsToRemove, unloadState, function (removed) {
                                if (removed) {
                                    // Re-Initialize the plugin chain
                                    _initPluginChain({
                                        reason: 32 /* TelemetryUpdateReason.PluginRemoved */,
                                        removed: pluginsToRemove
                                    });
                                }
                                removeCb && removeCb(removed);
                            });
                        }
                    };
                }
                return theExt;
            }
            function _getPluginChain() {
                if (!_pluginChain) {
                    // copy the collection of extensions
                    var extensions = (_extensions || []).slice();
                    // During add / remove this may get called again, so don't read if already present
                    if (arrIndexOf(extensions, _telemetryInitializerPlugin) === -1) {
                        extensions[_DYN_PUSH$1 /* @min:%2epush */](_telemetryInitializerPlugin);
                    }
                    _pluginChain = createTelemetryProxyChain(sortPlugins(extensions), _configHandler.cfg, _self);
                }
                return _pluginChain;
            }
            function _removePlugins(thePlugins, unloadState, removeComplete) {
                if (thePlugins && thePlugins[_DYN_LENGTH$5 /* @min:%2elength */] > 0) {
                    var unloadChain = createTelemetryProxyChain(thePlugins, _configHandler.cfg, _self);
                    var unloadCtx = createProcessTelemetryUnloadContext(unloadChain, _self);
                    unloadCtx[_DYN_ON_COMPLETE /* @min:%2eonComplete */](function () {
                        var removed = false;
                        // Remove the listed config extensions
                        var newConfigExtensions = [];
                        arrForEach(_configExtensions, function (plugin, idx) {
                            if (!_isPluginPresent(plugin, thePlugins)) {
                                newConfigExtensions[_DYN_PUSH$1 /* @min:%2epush */](plugin);
                            }
                            else {
                                removed = true;
                            }
                        });
                        _configExtensions = newConfigExtensions;
                        _pluginVersionString = null;
                        _pluginVersionStringArr = null;
                        // Re-Create the channel config
                        var newChannelConfig = [];
                        if (_channelConfig) {
                            arrForEach(_channelConfig, function (queue, idx) {
                                var newQueue = [];
                                arrForEach(queue, function (channel) {
                                    if (!_isPluginPresent(channel, thePlugins)) {
                                        newQueue[_DYN_PUSH$1 /* @min:%2epush */](channel);
                                    }
                                    else {
                                        removed = true;
                                    }
                                });
                                newChannelConfig[_DYN_PUSH$1 /* @min:%2epush */](newQueue);
                            });
                            _channelConfig = newChannelConfig;
                        }
                        removeComplete && removeComplete(removed);
                        _startLogPoller();
                    });
                    unloadCtx[_DYN_PROCESS_NEXT /* @min:%2eprocessNext */](unloadState);
                }
                else {
                    removeComplete(false);
                }
            }
            function _flushInternalLogs() {
                if (_logger && _logger.queue) {
                    var queue = _logger.queue.slice(0);
                    _logger.queue[_DYN_LENGTH$5 /* @min:%2elength */] = 0;
                    arrForEach(queue, function (logMessage) {
                        var _a;
                        var item = (_a = {},
                            _a[_DYN_NAME$3 /* @min:name */] = _internalLogsEventName ? _internalLogsEventName : "InternalMessageId: " + logMessage[_DYN_MESSAGE_ID /* @min:%2emessageId */],
                            _a.iKey = _instrumentationKey,
                            _a[_DYN_TIME /* @min:time */] = toISOString(new Date()),
                            _a.baseType = _InternalLogMessage.dataType,
                            _a.baseData = { message: logMessage[_DYN_MESSAGE$2 /* @min:%2emessage */] },
                            _a);
                        _self.track(item);
                    });
                }
            }
            function _flushChannels(isAsync, callBack, sendReason, cbTimeout) {
                // Setting waiting to one so that we don't call the callBack until we finish iterating
                var waiting = 1;
                var doneIterating = false;
                var cbTimer = null;
                cbTimeout = cbTimeout || 5000;
                function doCallback() {
                    waiting--;
                    if (doneIterating && waiting === 0) {
                        cbTimer && cbTimer[_DYN_CANCEL /* @min:%2ecancel */]();
                        cbTimer = null;
                        callBack && callBack(doneIterating);
                        callBack = null;
                    }
                }
                if (_channels && _channels[_DYN_LENGTH$5 /* @min:%2elength */] > 0) {
                    var flushCtx = _createTelCtx()[_DYN_CREATE_NEW$1 /* @min:%2ecreateNew */](_channels);
                    flushCtx.iterate(function (plugin) {
                        if (plugin.flush) {
                            waiting++;
                            var handled_1 = false;
                            // Not all channels will call this callback for every scenario
                            if (!plugin.flush(isAsync, function () {
                                handled_1 = true;
                                doCallback();
                            }, sendReason)) {
                                if (!handled_1) {
                                    // If any channel doesn't return true and it didn't call the callback, then we should assume that the callback
                                    // will never be called, so use a timeout to allow the channel(s) some time to "finish" before triggering any
                                    // followup function (such as unloading)
                                    if (isAsync && cbTimer == null) {
                                        cbTimer = scheduleTimeout(function () {
                                            cbTimer = null;
                                            doCallback();
                                        }, cbTimeout);
                                    }
                                    else {
                                        doCallback();
                                    }
                                }
                            }
                        }
                    });
                }
                doneIterating = true;
                doCallback();
                return true;
            }
            function _initDebugListener() {
                // Lazily ensure that the notification manager is created
                !_notificationManager && _self[_DYN_GET_NOTIFY_MGR /* @min:%2egetNotifyMgr */]();
                // Will get recalled if any referenced config values are changed
                _addUnloadHook(_configHandler[_DYN_WATCH /* @min:%2ewatch */](function (details) {
                    var disableDbgExt = details.cfg.disableDbgExt;
                    if (disableDbgExt === true && _debugListener) {
                        // Remove any previously loaded debug listener
                        _notificationManager[_DYN_REMOVE_NOTIFICATION_2 /* @min:%2eremoveNotificationListener */](_debugListener);
                        _debugListener = null;
                    }
                    if (_notificationManager && !_debugListener && disableDbgExt !== true) {
                        _debugListener = getDebugListener(details.cfg);
                        _notificationManager[_DYN_ADD_NOTIFICATION_LIS1 /* @min:%2eaddNotificationListener */](_debugListener);
                    }
                }));
            }
            function _initPerfManager() {
                // Will get recalled if any referenced config values are changed
                _addUnloadHook(_configHandler[_DYN_WATCH /* @min:%2ewatch */](function (details) {
                    var enablePerfMgr = details.cfg.enablePerfMgr;
                    if (!enablePerfMgr && _cfgPerfManager) {
                        // Remove any existing config based performance manager
                        _cfgPerfManager = null;
                    }
                    if (enablePerfMgr) {
                        // Set the performance manager creation function if not defined
                        getSetValue(details.cfg, STR_CREATE_PERF_MGR, _createPerfManager);
                    }
                }));
            }
            function _doUpdate(updateState) {
                var updateCtx = createProcessTelemetryUpdateContext(_getPluginChain(), _self);
                updateCtx[_DYN_ON_COMPLETE /* @min:%2eonComplete */](_startLogPoller);
                if (!_self._updateHook || _self._updateHook(updateCtx, updateState) !== true) {
                    updateCtx[_DYN_PROCESS_NEXT /* @min:%2eprocessNext */](updateState);
                }
            }
            function _logOrThrowError(message) {
                var logger = _self[_DYN_LOGGER /* @min:%2elogger */];
                if (logger) {
                    // there should always be a logger
                    _throwInternal(logger, 2 /* eLoggingSeverity.WARNING */, 73 /* _eInternalMessageId.PluginException */, message);
                    _startLogPoller();
                }
                else {
                    throwError(message);
                }
            }
            function _notifyInvalidEvent(telemetryItem) {
                var manager = _self[_DYN_GET_NOTIFY_MGR /* @min:%2egetNotifyMgr */]();
                if (manager) {
                    manager[STR_EVENTS_DISCARDED /* @min:%2eeventsDiscarded */]([telemetryItem], 2 /* eEventsDiscardedReason.InvalidEvent */);
                }
            }
            function _addUnloadHook(hooks) {
                _hookContainer.add(hooks);
            }
        });
    }
// Removed Stub for AppInsightsCore.prototype.initialize.
// Removed Stub for AppInsightsCore.prototype.getChannels.
// Removed Stub for AppInsightsCore.prototype.track.
// Removed Stub for AppInsightsCore.prototype.getProcessTelContext.
// Removed Stub for AppInsightsCore.prototype.getNotifyMgr.
// Removed Stub for AppInsightsCore.prototype.addNotificationListener.
// Removed Stub for AppInsightsCore.prototype.removeNotificationListener.
// Removed Stub for AppInsightsCore.prototype.getCookieMgr.
// Removed Stub for AppInsightsCore.prototype.setCookieMgr.
// Removed Stub for AppInsightsCore.prototype.getPerfMgr.
// Removed Stub for AppInsightsCore.prototype.setPerfMgr.
// Removed Stub for AppInsightsCore.prototype.eventCnt.
// Removed Stub for AppInsightsCore.prototype.pollInternalLogs.
// Removed Stub for AppInsightsCore.prototype.stopPollingInternalLogs.
// Removed Stub for AppInsightsCore.prototype.addTelemetryInitializer.
// Removed Stub for AppInsightsCore.prototype.unload.
// Removed Stub for AppInsightsCore.prototype.getPlugin.
// Removed Stub for AppInsightsCore.prototype.addPlugin.
// Removed Stub for AppInsightsCore.prototype.updateCfg.
// Removed Stub for AppInsightsCore.prototype.evtNamespace.
// Removed Stub for AppInsightsCore.prototype.addUnloadCb.
// Removed Stub for AppInsightsCore.prototype.flush.
// Removed Stub for AppInsightsCore.prototype.getTraceCtx.
// Removed Stub for AppInsightsCore.prototype.setTraceCtx.
// Removed Stub for AppInsightsCore.prototype.addUnloadHook.
// Removed Stub for AppInsightsCore.prototype.onCfgChange.
// Removed Stub for AppInsightsCore.prototype.releaseQueue.
// Removed Stub for AppInsightsCore.prototype._updateHook.
    // This is a workaround for an IE bug when using dynamicProto() with classes that don't have any
    // non-dynamic functions or static properties/functions when using uglify-js to minify the resulting code.
    AppInsightsCore.__ieDyn=1;

    return AppInsightsCore;
}());

/*
 * Application Insights JavaScript SDK - Core, 3.0.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */

// Added to help with minfication
var strOnPrefix = "on";
var strAttachEvent = "attachEvent";
var strAddEventHelper = "addEventListener";
var strDetachEvent = "detachEvent";
var strRemoveEventListener = "removeEventListener";
var strEvents = "events";
var strVisibilityChangeEvt = "visibilitychange";
var strPageHide = "pagehide";
var strUnload = "unload";
var strBeforeUnload = "beforeunload";
var strPageHideNamespace = createUniqueNamespace("aiEvtPageHide");
createUniqueNamespace("aiEvtPageShow");
var rRemoveEmptyNs = /\.[\.]+/g;
var rRemoveTrailingEmptyNs = /[\.]+$/;
var _guid = 1;
var elmNodeData = createElmNodeData("events");
var eventNamespace = /^([^.]*)(?:\.(.+)|)/;
function _normalizeNamespace(name) {
    if (name && name[_DYN_REPLACE /* @min:%2ereplace */]) {
        return name[_DYN_REPLACE /* @min:%2ereplace */](/^[\s\.]+|(?=[\s\.])[\.\s]+$/g, STR_EMPTY);
    }
    return name;
}
function _getEvtNamespace(eventName, evtNamespace) {
    var _a;
    if (evtNamespace) {
        var theNamespace_1 = STR_EMPTY;
        if (isArray(evtNamespace)) {
            theNamespace_1 = STR_EMPTY;
            arrForEach(evtNamespace, function (name) {
                name = _normalizeNamespace(name);
                if (name) {
                    if (name[0] !== ".") {
                        name = "." + name;
                    }
                    theNamespace_1 += name;
                }
            });
        }
        else {
            theNamespace_1 = _normalizeNamespace(evtNamespace);
        }
        if (theNamespace_1) {
            if (theNamespace_1[0] !== ".") {
                theNamespace_1 = "." + theNamespace_1;
            }
            // We may only have the namespace and not an eventName
            eventName = (eventName || STR_EMPTY) + theNamespace_1;
        }
    }
    var parsedEvent = (eventNamespace.exec(eventName || STR_EMPTY) || []);
    return _a = {},
        _a[_DYN_TYPE /* @min:type */] = parsedEvent[1],
        _a.ns = ((parsedEvent[2] || STR_EMPTY).replace(rRemoveEmptyNs, ".").replace(rRemoveTrailingEmptyNs, STR_EMPTY)[_DYN_SPLIT$1 /* @min:%2esplit */](".").sort()).join("."),
        _a;
}
// Exported for internal unit testing only
function _getRegisteredEvents(target, evtName, addDefault) {
    if (addDefault === void 0) { addDefault = true; }
    var aiEvts = elmNodeData.get(target, strEvents, {}, addDefault);
    var registeredEvents = aiEvts[evtName];
    if (!registeredEvents) {
        registeredEvents = aiEvts[evtName] = [];
    }
    return registeredEvents;
}
function _doDetach(obj, evtName, handlerRef, useCapture) {
    if (obj && evtName && evtName[_DYN_TYPE /* @min:%2etype */]) {
        if (obj[strRemoveEventListener]) {
            obj[strRemoveEventListener](evtName[_DYN_TYPE /* @min:%2etype */], handlerRef, useCapture);
        }
        else if (obj[strDetachEvent]) {
            obj[strDetachEvent](strOnPrefix + evtName[_DYN_TYPE /* @min:%2etype */], handlerRef);
        }
    }
}
function _doAttach(obj, evtName, handlerRef, useCapture) {
    var result = false;
    if (obj && evtName && evtName[_DYN_TYPE /* @min:%2etype */] && handlerRef) {
        if (obj[strAddEventHelper]) {
            // all browsers except IE before version 9
            obj[strAddEventHelper](evtName[_DYN_TYPE /* @min:%2etype */], handlerRef, useCapture);
            result = true;
        }
        else if (obj[strAttachEvent]) {
            // IE before version 9
            obj[strAttachEvent](strOnPrefix + evtName[_DYN_TYPE /* @min:%2etype */], handlerRef);
            result = true;
        }
    }
    return result;
}
function _doUnregister(target, events, evtName, unRegFn) {
    var idx = events[_DYN_LENGTH$5 /* @min:%2elength */];
    while (idx--) {
        var theEvent = events[idx];
        if (theEvent) {
            if (!evtName.ns || evtName.ns === theEvent.evtName.ns) {
                if (!unRegFn || unRegFn(theEvent)) {
                    _doDetach(target, theEvent.evtName, theEvent[_DYN_HANDLER /* @min:%2ehandler */], theEvent.capture);
                    // Remove the registered event
                    events[_DYN_SPLICE /* @min:%2esplice */](idx, 1);
                }
            }
        }
    }
}
function _unregisterEvents(target, evtName, unRegFn) {
    if (evtName[_DYN_TYPE /* @min:%2etype */]) {
        _doUnregister(target, _getRegisteredEvents(target, evtName[_DYN_TYPE /* @min:%2etype */]), evtName, unRegFn);
    }
    else {
        var eventCache = elmNodeData.get(target, strEvents, {});
        objForEachKey(eventCache, function (evtType, events) {
            _doUnregister(target, events, evtName, unRegFn);
        });
        // Cleanup
        if (objKeys(eventCache)[_DYN_LENGTH$5 /* @min:%2elength */] === 0) {
            elmNodeData.kill(target, strEvents);
        }
    }
}
function mergeEvtNamespace(theNamespace, namespaces) {
    var newNamespaces;
    if (namespaces) {
        if (isArray(namespaces)) {
            newNamespaces = [theNamespace].concat(namespaces);
        }
        else {
            newNamespaces = [theNamespace, namespaces];
        }
        // resort the namespaces so they are always in order
        newNamespaces = (_getEvtNamespace("xx", newNamespaces).ns)[_DYN_SPLIT$1 /* @min:%2esplit */](".");
    }
    else {
        newNamespaces = theNamespace;
    }
    return newNamespaces;
}
/**
 * Binds the specified function to an event, so that the function gets called whenever the event fires on the object
 * @param obj - Object to add the event too.
 * @param eventName - String that specifies any of the standard DHTML Events without "on" prefix, if may also include an optional (dot "." prefixed)
 * namespaces "click" "click.mynamespace" in addition to specific namespaces.
 * @param handlerRef - Pointer that specifies the function to call when event fires
 * @param evtNamespace - [Optional] Additional namespace(s) to append to the event listeners so they can be uniquely identified and removed based on this namespace,
 * if the eventName also includes a namespace the namespace(s) are merged into a single namespace
 * @param useCapture - [Optional] Defaults to false
 * @returns True if the function was bound successfully to the event, otherwise false
 */
function eventOn(target, eventName, handlerRef, evtNamespace, useCapture) {
    var _a;
    if (useCapture === void 0) { useCapture = false; }
    var result = false;
    if (target) {
        try {
            var evtName = _getEvtNamespace(eventName, evtNamespace);
            result = _doAttach(target, evtName, handlerRef, useCapture);
            if (result && elmNodeData.accept(target)) {
                var registeredEvent = (_a = {
                        guid: _guid++,
                        evtName: evtName
                    },
                    _a[_DYN_HANDLER /* @min:handler */] = handlerRef,
                    _a.capture = useCapture,
                    _a);
                _getRegisteredEvents(target, evtName.type)[_DYN_PUSH$1 /* @min:%2epush */](registeredEvent);
            }
        }
        catch (e) {
            // Just Ignore any error so that we don't break any execution path
        }
    }
    return result;
}
/**
 * Removes an event handler for the specified event
 * @param Object - to remove the event from
 * @param eventName - {string} - The name of the event, with optional namespaces or just the namespaces,
 * such as "click", "click.mynamespace" or ".mynamespace"
 * @param handlerRef - {any} - The callback function that needs to be removed from the given event, when using a
 * namespace (with or without a qualifying event) this may be null to remove all previously attached event handlers
 * otherwise this will only remove events with this specific handler.
 * @param evtNamespace - [Optional] Additional namespace(s) to append to the event listeners so they can be uniquely identified and removed based on this namespace,
 * if the eventName also includes a namespace the namespace(s) are merged into a single namespace
 * @param useCapture - [Optional] Defaults to false
 */
function eventOff(target, eventName, handlerRef, evtNamespace, useCapture) {
    if (useCapture === void 0) { useCapture = false; }
    if (target) {
        try {
            var evtName_1 = _getEvtNamespace(eventName, evtNamespace);
            var found_1 = false;
            _unregisterEvents(target, evtName_1, function (regEvent) {
                if ((evtName_1.ns && !handlerRef) || regEvent[_DYN_HANDLER /* @min:%2ehandler */] === handlerRef) {
                    found_1 = true;
                    return true;
                }
                return false;
            });
            if (!found_1) {
                // fallback to try and remove as requested
                _doDetach(target, evtName_1, handlerRef, useCapture);
            }
        }
        catch (e) {
            // Just Ignore any error so that we don't break any execution path
        }
    }
}
/**
 * Trys to add an event handler for the specified event to the window, body and document
 * @param eventName - {string} - The name of the event
 * @param callback - {any} - The callback function that needs to be executed for the given event
 * @param evtNamespace - [Optional] Namespace(s) to append to the event listeners so they can be uniquely identified and removed based on this namespace.
 * @return {boolean} - true if the handler was successfully added
 */
function addEventHandler(eventName, callback, evtNamespace) {
    var result = false;
    var w = getWindow();
    if (w) {
        result = eventOn(w, eventName, callback, evtNamespace);
        result = eventOn(w["body"], eventName, callback, evtNamespace) || result;
    }
    var doc = getDocument();
    if (doc) {
        result = eventOn(doc, eventName, callback, evtNamespace) || result;
    }
    return result;
}
/**
 * Trys to remove event handler(s) for the specified event/namespace to the window, body and document
 * @param eventName - {string} - The name of the event, with optional namespaces or just the namespaces,
 * such as "click", "click.mynamespace" or ".mynamespace"
 * @param callback - {any} - - The callback function that needs to be removed from the given event, when using a
 * namespace (with or without a qualifying event) this may be null to remove all previously attached event handlers
 * otherwise this will only remove events with this specific handler.
 * @param evtNamespace - [Optional] Namespace(s) to append to the event listeners so they can be uniquely identified and removed based on this namespace.
 */
function removeEventHandler(eventName, callback, evtNamespace) {
    var w = getWindow();
    if (w) {
        eventOff(w, eventName, callback, evtNamespace);
        eventOff(w["body"], eventName, callback, evtNamespace);
    }
    var doc = getDocument();
    if (doc) {
        eventOff(doc, eventName, callback, evtNamespace);
    }
}
/**
 * Bind the listener to the array of events
 * @param events - An string array of event names to bind the listener to
 * @param listener - The event callback to call when the event is triggered
 * @param excludeEvents - [Optional] An array of events that should not be hooked (if possible), unless no other events can be.
 * @param evtNamespace - [Optional] Namespace(s) to append to the event listeners so they can be uniquely identified and removed based on this namespace.
 * @returns true - when at least one of the events was registered otherwise false
 */
function _addEventListeners(events, listener, excludeEvents, evtNamespace) {
    var added = false;
    if (listener && events && events[_DYN_LENGTH$5 /* @min:%2elength */] > 0) {
        arrForEach(events, function (name) {
            if (name) {
                if (!excludeEvents || arrIndexOf(excludeEvents, name) === -1) {
                    added = addEventHandler(name, listener, evtNamespace) || added;
                }
            }
        });
    }
    return added;
}
/**
 * Bind the listener to the array of events
 * @param events - An string array of event names to bind the listener to
 * @param listener - The event callback to call when the event is triggered
 * @param excludeEvents - [Optional] An array of events that should not be hooked (if possible), unless no other events can be.
 * @param evtNamespace - [Optional] Namespace(s) to append to the event listeners so they can be uniquely identified and removed based on this namespace.
 * @returns true - when at least one of the events was registered otherwise false
 */
function addEventListeners(events, listener, excludeEvents, evtNamespace) {
    var added = false;
    if (listener && events && isArray(events)) {
        added = _addEventListeners(events, listener, excludeEvents, evtNamespace);
        if (!added && excludeEvents && excludeEvents[_DYN_LENGTH$5 /* @min:%2elength */] > 0) {
            // Failed to add any listeners and we excluded some, so just attempt to add the excluded events
            added = _addEventListeners(events, listener, null, evtNamespace);
        }
    }
    return added;
}
/**
 * Remove the listener from the array of events
 * @param events - An string array of event names to bind the listener to
 * @param listener - The event callback to call when the event is triggered
 * @param evtNamespace - [Optional] Namespace(s) to append to the event listeners so they can be uniquely identified and removed based on this namespace.
 */
function removeEventListeners(events, listener, evtNamespace) {
    if (events && isArray(events)) {
        arrForEach(events, function (name) {
            if (name) {
                removeEventHandler(name, listener, evtNamespace);
            }
        });
    }
}
/**
 * Listen to the 'beforeunload', 'unload' and 'pagehide' events which indicates a page unload is occurring,
 * this does NOT listen to the 'visibilitychange' event as while it does indicate that the page is being hidden
 * it does not *necessarily* mean that the page is being completely unloaded, it can mean that the user is
 * just navigating to a different Tab and may come back (without unloading the page). As such you may also
 * need to listen to the 'addPageHideEventListener' and 'addPageShowEventListener' events.
 * @param listener - The event callback to call when a page unload event is triggered
 * @param excludeEvents - [Optional] An array of events that should not be hooked, unless no other events can be.
 * @param evtNamespace - [Optional] Namespace(s) to append to the event listeners so they can be uniquely identified and removed based on this namespace.
 * @returns true - when at least one of the events was registered otherwise false
 */
function addPageUnloadEventListener(listener, excludeEvents, evtNamespace) {
    // Hook the unload event for the document, window and body to ensure that the client events are flushed to the server
    // As just hooking the window does not always fire (on chrome) for page navigation's.
    return addEventListeners([strBeforeUnload, strUnload, strPageHide], listener, excludeEvents, evtNamespace);
}
/**
 * Remove any matching 'beforeunload', 'unload' and 'pagehide' events that may have been added via addEventListener,
 * addEventListeners, addPageUnloadEventListener or addPageHideEventListener.
 * @param listener - The specific event callback to to be removed
 * @param evtNamespace - [Optional] Namespace(s) uniquely identified and removed based on this namespace.
 * @returns true - when at least one of the events was registered otherwise false
 */
function removePageUnloadEventListener(listener, evtNamespace) {
    removeEventListeners([strBeforeUnload, strUnload, strPageHide], listener, evtNamespace);
}
/**
 * Listen to the pagehide and visibility changing to 'hidden' events, because the 'visibilitychange' uses
 * an internal proxy to detect the visibility state you SHOULD use a unique namespace when if you plan to call
 * removePageShowEventListener as the remove ignores the listener argument for the 'visibilitychange' event.
 * @param listener - The event callback to call when a page hide event is triggered
 * @param excludeEvents - [Optional] An array of events that should not be hooked (if possible), unless no other events can be.
 * @param evtNamespace - [Optional] A Namespace to append to the event listeners so they can be uniquely identified and removed
 * based on this namespace. This call also adds an additional unique "pageshow" namespace to the events
 * so that only the matching "removePageHideEventListener" can remove these events.
 * Suggestion: pass as true if you are also calling addPageUnloadEventListener as that also hooks pagehide
 * @returns true - when at least one of the events was registered otherwise false
 */
function addPageHideEventListener(listener, excludeEvents, evtNamespace) {
    function _handlePageVisibility(evt) {
        var doc = getDocument();
        if (listener && doc && doc.visibilityState === "hidden") {
            listener(evt);
        }
    }
    // add the unique page show namespace to any provided namespace so we can only remove the ones added by "pagehide"
    var newNamespaces = mergeEvtNamespace(strPageHideNamespace, evtNamespace);
    var pageUnloadAdded = _addEventListeners([strPageHide], listener, excludeEvents, newNamespaces);
    if (!excludeEvents || arrIndexOf(excludeEvents, strVisibilityChangeEvt) === -1) {
        pageUnloadAdded = _addEventListeners([strVisibilityChangeEvt], _handlePageVisibility, excludeEvents, newNamespaces) || pageUnloadAdded;
    }
    if (!pageUnloadAdded && excludeEvents) {
        // Failed to add any listeners and we where requested to exclude some, so just call again without excluding anything
        pageUnloadAdded = addPageHideEventListener(listener, null, evtNamespace);
    }
    return pageUnloadAdded;
}
/**
 * Removes the pageHide event listeners added by addPageHideEventListener, because the 'visibilitychange' uses
 * an internal proxy to detect the visibility state you SHOULD use a unique namespace when calling addPageHideEventListener
 * as the remove ignores the listener argument for the 'visibilitychange' event.
 * @param listener - The specific listener to remove for the 'pageshow' event only (ignored for 'visibilitychange')
 * @param evtNamespace - The unique namespace used when calling addPageShowEventListener
 */
function removePageHideEventListener(listener, evtNamespace) {
    // add the unique page show namespace to any provided namespace so we only remove the ones added by "pagehide"
    var newNamespaces = mergeEvtNamespace(strPageHideNamespace, evtNamespace);
    removeEventListeners([strPageHide], listener, newNamespaces);
    removeEventListeners([strVisibilityChangeEvt], null, newNamespaces);
}

/*
 * Application Insights JavaScript SDK - Core, 3.0.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */

var aiInstrumentHooks = "_aiHooks";
var cbNames = [
    "req", "rsp", "hkErr", "fnErr"
];
/** @ignore */
function _arrLoop(arr, fn) {
    if (arr) {
        for (var lp = 0; lp < arr[_DYN_LENGTH$5 /* @min:%2elength */]; lp++) {
            if (fn(arr[lp], lp)) {
                break;
            }
        }
    }
}
/** @ignore */
function _doCallbacks(hooks, callDetails, cbArgs, hookCtx, type) {
    if (type >= 0 /* CallbackType.Request */ && type <= 2 /* CallbackType.HookError */) {
        _arrLoop(hooks, function (hook, idx) {
            var cbks = hook.cbks;
            var cb = cbks[cbNames[type]];
            if (cb) {
                // Set the specific hook context implementation using a lazy creation pattern
                callDetails.ctx = function () {
                    var ctx = hookCtx[idx] = (hookCtx[idx] || {});
                    return ctx;
                };
                try {
                    cb[_DYN_APPLY /* @min:%2eapply */](callDetails.inst, cbArgs);
                }
                catch (err) {
                    var orgEx = callDetails.err;
                    try {
                        // Report Hook error via the callback
                        var hookErrorCb = cbks[cbNames[2 /* CallbackType.HookError */]];
                        if (hookErrorCb) {
                            callDetails.err = err;
                            hookErrorCb[_DYN_APPLY /* @min:%2eapply */](callDetails.inst, cbArgs);
                        }
                    }
                    catch (e) {
                        // Not much we can do here -- swallowing the exception to avoid crashing the hosting app
                    }
                    finally {
                        // restore the original exception (if any)
                        callDetails.err = orgEx;
                    }
                }
            }
        });
    }
}
/** @ignore */
function _createFunctionHook(aiHook) {
    // Define a temporary method that queues-up a the real method call
    return function () {
        var _a;
        var funcThis = this;
        // Capture the original arguments passed to the method
        var orgArgs = arguments;
        var hooks = aiHook.h;
        var funcArgs = (_a = {},
            _a[_DYN_NAME$3 /* @min:name */] = aiHook.n,
            _a.inst = funcThis,
            _a.ctx = null,
            _a.set = _replaceArg,
            _a);
        var hookCtx = [];
        var cbArgs = _createArgs([funcArgs], orgArgs);
        funcArgs.evt = getInst("event");
        function _createArgs(target, theArgs) {
            _arrLoop(theArgs, function (arg) {
                target[_DYN_PUSH$1 /* @min:%2epush */](arg);
            });
            return target;
        }
        function _replaceArg(idx, value) {
            orgArgs = _createArgs([], orgArgs);
            orgArgs[idx] = value;
            cbArgs = _createArgs([funcArgs], orgArgs);
        }
        // Call the pre-request hooks
        _doCallbacks(hooks, funcArgs, cbArgs, hookCtx, 0 /* CallbackType.Request */);
        // Call the original function was called
        var theFunc = aiHook.f;
        if (theFunc) {
            try {
                funcArgs.rslt = theFunc[_DYN_APPLY /* @min:%2eapply */](funcThis, orgArgs);
            }
            catch (err) {
                // Report the request callback
                funcArgs.err = err;
                _doCallbacks(hooks, funcArgs, cbArgs, hookCtx, 3 /* CallbackType.FunctionError */);
                // rethrow the original exception so anyone listening for it can catch the exception
                throw err;
            }
        }
        // Call the post-request hooks
        _doCallbacks(hooks, funcArgs, cbArgs, hookCtx, 1 /* CallbackType.Response */);
        return funcArgs.rslt;
    };
}
/** @ignore */
function _getOwner(target, name, checkPrototype, checkParentProto) {
    var owner = null;
    if (target) {
        if (objHasOwnProperty(target, name)) {
            owner = target;
        }
        else if (checkPrototype) {
            owner = _getOwner(_getObjProto(target), name, checkParentProto, false);
        }
    }
    return owner;
}
/**
 * Intercept the named prototype functions for the target class / object
 * @param target - The target object
 * @param funcName - The function name
 * @param callbacks - The callbacks to configure and call whenever the function is called
 */
function InstrumentProto(target, funcName, callbacks) {
    if (target) {
        return InstrumentFunc(target[strShimPrototype], funcName, callbacks, false);
    }
    return null;
}
function _createInstrumentHook(owner, funcName, fn, callbacks) {
    var aiHook = fn && fn[aiInstrumentHooks];
    if (!aiHook) {
        // Only hook the function once
        aiHook = {
            i: 0,
            n: funcName,
            f: fn,
            h: []
        };
        // Override (hook) the original function
        var newFunc = _createFunctionHook(aiHook);
        newFunc[aiInstrumentHooks] = aiHook; // Tag and store the function hooks
        owner[funcName] = newFunc;
    }
    var theHook = {
        // tslint:disable:object-literal-shorthand
        id: aiHook.i,
        cbks: callbacks,
        rm: function () {
            // DO NOT Use () => { shorthand for the function as the this gets replaced
            // with the outer this and not the this for theHook instance.
            var id = this.id;
            _arrLoop(aiHook.h, function (hook, idx) {
                if (hook.id === id) {
                    aiHook.h[_DYN_SPLICE /* @min:%2esplice */](idx, 1);
                    return 1;
                }
            });
        }
        // tslint:enable:object-literal-shorthand
    };
    aiHook.i++;
    aiHook.h[_DYN_PUSH$1 /* @min:%2epush */](theHook);
    return theHook;
}
/**
 * Intercept the named prototype functions for the target class / object
 * @param target - The target object
 * @param funcName - The function name
 * @param callbacks - The callbacks to configure and call whenever the function is called
 * @param checkPrototype - If the function doesn't exist on the target should it attempt to hook the prototype function
 * @param checkParentProto - If the function doesn't exist on the target or it's prototype should it attempt to hook the parent's prototype
 */
function InstrumentFunc(target, funcName, callbacks, checkPrototype, checkParentProto) {
    if (checkPrototype === void 0) { checkPrototype = true; }
    if (target && funcName && callbacks) {
        var owner = _getOwner(target, funcName, checkPrototype, checkParentProto);
        if (owner) {
            var fn = owner[funcName];
            if (typeof fn === strShimFunction) {
                return _createInstrumentHook(owner, funcName, fn, callbacks);
            }
        }
    }
    return null;
}
/**
 * Add an instrumentation hook to the provided named "event" for the target class / object, this doesn't check whether the
 * named "event" is in fact a function and just assigns the instrumentation hook to the target[evtName]
 * @param target - The target object
 * @param evtName - The name of the event
 * @param callbacks - The callbacks to configure and call whenever the function is called
 * @param checkPrototype - If the function doesn't exist on the target should it attempt to hook the prototype function
 * @param checkParentProto - If the function doesn't exist on the target or it's prototype should it attempt to hook the parent's prototype
 */
function InstrumentEvent(target, evtName, callbacks, checkPrototype, checkParentProto) {
    if (target && evtName && callbacks) {
        var owner = _getOwner(target, evtName, checkPrototype, checkParentProto) || target;
        if (owner) {
            return _createInstrumentHook(owner, evtName, owner[evtName], callbacks);
        }
    }
    return null;
}

/*
 * Application Insights JavaScript SDK - Common, 3.0.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


/**
 * This is an internal property used to cause internal (reporting) requests to be ignored from reporting
 * additional telemetry, to handle polyfil implementations ALL urls used with a disabled request will
 * also be ignored for future requests even when this property is not provided.
 * Tagging as Ignore as this is an internal value and is not expected to be used outside of the SDK
 * @ignore
 */
var DisabledPropertyName = "Microsoft_ApplicationInsights_BypassAjaxInstrumentation";
var SampleRate = "sampleRate";
var ProcessLegacy = "ProcessLegacy";
var HttpMethod = "http.method";
var DEFAULT_BREEZE_ENDPOINT = "https://dc.services.visualstudio.com";
var DEFAULT_BREEZE_PATH = "/v2/track";
var strNotSpecified = "not_specified";
var strIkey = "iKey";

/*
 * Application Insights JavaScript SDK - Common, 3.0.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */

var RequestHeaders = createValueMap({
    requestContextHeader: [0 /* eRequestHeaders.requestContextHeader */, "Request-Context"],
    requestContextTargetKey: [1 /* eRequestHeaders.requestContextTargetKey */, "appId"],
    requestContextAppIdFormat: [2 /* eRequestHeaders.requestContextAppIdFormat */, "appId=cid-v1:"],
    requestIdHeader: [3 /* eRequestHeaders.requestIdHeader */, "Request-Id"],
    traceParentHeader: [4 /* eRequestHeaders.traceParentHeader */, "traceparent"],
    traceStateHeader: [5 /* eRequestHeaders.traceStateHeader */, "tracestate"],
    sdkContextHeader: [6 /* eRequestHeaders.sdkContextHeader */, "Sdk-Context"],
    sdkContextHeaderAppIdRequest: [7 /* eRequestHeaders.sdkContextHeaderAppIdRequest */, "appId"],
    requestContextHeaderLowerCase: [8 /* eRequestHeaders.requestContextHeaderLowerCase */, "request-context"]
});

/*
 * Application Insights JavaScript SDK - Common, 3.0.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


// @skip-file-minify
// ##############################################################
// AUTO GENERATED FILE: This file is Auto Generated during build.
// ##############################################################
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
// Note: DON'T Export these const from the package as we are still targeting ES3 this will export a mutable variables that someone could change!!!
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
var _DYN_SPLIT = "split"; // Count: 6
var _DYN_LENGTH$4 = "length"; // Count: 41
var _DYN_TO_LOWER_CASE$1 = "toLowerCase"; // Count: 6
var _DYN_INGESTIONENDPOINT = "ingestionendpoint"; // Count: 4
var _DYN_TO_STRING$2 = "toString"; // Count: 9
var _DYN_REMOVE_ITEM = "removeItem"; // Count: 3
var _DYN_NAME$2 = "name"; // Count: 11
var _DYN_MESSAGE$1 = "message"; // Count: 10
var _DYN_COUNT$1 = "count"; // Count: 8
var _DYN_PRE_TRIGGER_DATE = "preTriggerDate"; // Count: 4
var _DYN_DISABLED = "disabled"; // Count: 3
var _DYN_INTERVAL = "interval"; // Count: 3
var _DYN_DAYS_OF_MONTH = "daysOfMonth"; // Count: 3
var _DYN_DATE = "date"; // Count: 5
var _DYN_GET_UTCDATE = "getUTCDate"; // Count: 3
var _DYN_STRINGIFY$1 = "stringify"; // Count: 4
var _DYN_PATHNAME = "pathname"; // Count: 4
var _DYN_CORRELATION_HEADER_E0 = "correlationHeaderExcludePatterns"; // Count: 2
var _DYN_EXCEPTIONS = "exceptions"; // Count: 6
var _DYN_PARSED_STACK = "parsedStack"; // Count: 13
var _DYN_PROPERTIES = "properties"; // Count: 9
var _DYN_MEASUREMENTS$1 = "measurements"; // Count: 9
var _DYN_SIZE_IN_BYTES = "sizeInBytes"; // Count: 11
var _DYN_TYPE_NAME = "typeName"; // Count: 11
var _DYN_SEVERITY_LEVEL = "severityLevel"; // Count: 5
var _DYN_PROBLEM_GROUP = "problemGroup"; // Count: 3
var _DYN_IS_MANUAL = "isManual"; // Count: 3
var _DYN__CREATE_FROM_INTERFA1 = "CreateFromInterface"; // Count: 2
var _DYN_ASSEMBLY = "assembly"; // Count: 7
var _DYN_FILE_NAME = "fileName"; // Count: 8
var _DYN_HAS_FULL_STACK = "hasFullStack"; // Count: 6
var _DYN_LEVEL = "level"; // Count: 5
var _DYN_METHOD$1 = "method"; // Count: 7
var _DYN_LINE = "line"; // Count: 6
var _DYN_DURATION$1 = "duration"; // Count: 4
var _DYN_RECEIVED_RESPONSE = "receivedResponse"; // Count: 2

/*
 * Application Insights JavaScript SDK - Common, 3.0.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */

function dataSanitizeKeyAndAddUniqueness(logger, key, map) {
    var origLength = key[_DYN_LENGTH$4 /* @min:%2elength */];
    var field = dataSanitizeKey(logger, key);
    // validation truncated the length.  We need to add uniqueness
    if (field[_DYN_LENGTH$4 /* @min:%2elength */] !== origLength) {
        var i = 0;
        var uniqueField = field;
        while (map[uniqueField] !== undefined) {
            i++;
            uniqueField = strSubstring(field, 0, 150 /* DataSanitizerValues.MAX_NAME_LENGTH */ - 3) + dsPadNumber(i);
        }
        field = uniqueField;
    }
    return field;
}
function dataSanitizeKey(logger, name) {
    var nameTrunc;
    if (name) {
        // Remove any leading or trailing whitespace
        name = strTrim(asString(name));
        // truncate the string to 150 chars
        if (name[_DYN_LENGTH$4 /* @min:%2elength */] > 150 /* DataSanitizerValues.MAX_NAME_LENGTH */) {
            nameTrunc = strSubstring(name, 0, 150 /* DataSanitizerValues.MAX_NAME_LENGTH */);
            _throwInternal(logger, 2 /* eLoggingSeverity.WARNING */, 57 /* _eInternalMessageId.NameTooLong */, "name is too long.  It has been truncated to " + 150 /* DataSanitizerValues.MAX_NAME_LENGTH */ + " characters.", { name: name }, true);
        }
    }
    return nameTrunc || name;
}
function dataSanitizeString(logger, value, maxLength) {
    if (maxLength === void 0) { maxLength = 1024 /* DataSanitizerValues.MAX_STRING_LENGTH */; }
    var valueTrunc;
    if (value) {
        maxLength = maxLength ? maxLength : 1024 /* DataSanitizerValues.MAX_STRING_LENGTH */; // in case default parameters dont work
        value = strTrim(asString(value));
        if (value[_DYN_LENGTH$4 /* @min:%2elength */] > maxLength) {
            valueTrunc = strSubstring(value, 0, maxLength);
            _throwInternal(logger, 2 /* eLoggingSeverity.WARNING */, 61 /* _eInternalMessageId.StringValueTooLong */, "string value is too long. It has been truncated to " + maxLength + " characters.", { value: value }, true);
        }
    }
    return valueTrunc || value;
}
function dataSanitizeUrl(logger, url) {
    return dataSanitizeInput(logger, url, 2048 /* DataSanitizerValues.MAX_URL_LENGTH */, 66 /* _eInternalMessageId.UrlTooLong */);
}
function dataSanitizeMessage(logger, message) {
    var messageTrunc;
    if (message) {
        if (message[_DYN_LENGTH$4 /* @min:%2elength */] > 32768 /* DataSanitizerValues.MAX_MESSAGE_LENGTH */) {
            messageTrunc = strSubstring(message, 0, 32768 /* DataSanitizerValues.MAX_MESSAGE_LENGTH */);
            _throwInternal(logger, 2 /* eLoggingSeverity.WARNING */, 56 /* _eInternalMessageId.MessageTruncated */, "message is too long, it has been truncated to " + 32768 /* DataSanitizerValues.MAX_MESSAGE_LENGTH */ + " characters.", { message: message }, true);
        }
    }
    return messageTrunc || message;
}
function dataSanitizeException(logger, exception) {
    var exceptionTrunc;
    if (exception) {
        // Make surte its a string
        var value = "" + exception;
        if (value[_DYN_LENGTH$4 /* @min:%2elength */] > 32768 /* DataSanitizerValues.MAX_EXCEPTION_LENGTH */) {
            exceptionTrunc = strSubstring(value, 0, 32768 /* DataSanitizerValues.MAX_EXCEPTION_LENGTH */);
            _throwInternal(logger, 2 /* eLoggingSeverity.WARNING */, 52 /* _eInternalMessageId.ExceptionTruncated */, "exception is too long, it has been truncated to " + 32768 /* DataSanitizerValues.MAX_EXCEPTION_LENGTH */ + " characters.", { exception: exception }, true);
        }
    }
    return exceptionTrunc || exception;
}
function dataSanitizeProperties(logger, properties) {
    if (properties) {
        var tempProps_1 = {};
        objForEachKey(properties, function (prop, value) {
            if (isObject(value) && hasJSON()) {
                // Stringify any part C properties
                try {
                    value = getJSON()[_DYN_STRINGIFY$1 /* @min:%2estringify */](value);
                }
                catch (e) {
                    _throwInternal(logger, 2 /* eLoggingSeverity.WARNING */, 49 /* _eInternalMessageId.CannotSerializeObjectNonSerializable */, "custom property is not valid", { exception: e }, true);
                }
            }
            value = dataSanitizeString(logger, value, 8192 /* DataSanitizerValues.MAX_PROPERTY_LENGTH */);
            prop = dataSanitizeKeyAndAddUniqueness(logger, prop, tempProps_1);
            tempProps_1[prop] = value;
        });
        properties = tempProps_1;
    }
    return properties;
}
function dataSanitizeMeasurements(logger, measurements) {
    if (measurements) {
        var tempMeasurements_1 = {};
        objForEachKey(measurements, function (measure, value) {
            measure = dataSanitizeKeyAndAddUniqueness(logger, measure, tempMeasurements_1);
            tempMeasurements_1[measure] = value;
        });
        measurements = tempMeasurements_1;
    }
    return measurements;
}
function dataSanitizeId(logger, id) {
    return id ? dataSanitizeInput(logger, id, 128 /* DataSanitizerValues.MAX_ID_LENGTH */, 69 /* _eInternalMessageId.IdTooLong */)[_DYN_TO_STRING$2 /* @min:%2etoString */]() : id;
}
function dataSanitizeInput(logger, input, maxLength, _msgId) {
    var inputTrunc;
    if (input) {
        input = strTrim(asString(input));
        if (input[_DYN_LENGTH$4 /* @min:%2elength */] > maxLength) {
            inputTrunc = strSubstring(input, 0, maxLength);
            _throwInternal(logger, 2 /* eLoggingSeverity.WARNING */, _msgId, "input is too long, it has been truncated to " + maxLength + " characters.", { data: input }, true);
        }
    }
    return inputTrunc || input;
}
function dsPadNumber(num) {
    var s = "00" + num;
    return strSubstr(s, s[_DYN_LENGTH$4 /* @min:%2elength */] - 3);
}

/*
 * Application Insights JavaScript SDK - Common, 3.0.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */

var _document = getDocument() || {};
var _htmlAnchorIdx = 0;
// Use an array of temporary values as it's possible for multiple calls to parseUrl() will be called with different URLs
// Using a cache size of 5 for now as it current depth usage is at least 2, so adding a minor buffer to handle future updates
var _htmlAnchorElement = [null, null, null, null, null];
function urlParseUrl(url) {
    var anchorIdx = _htmlAnchorIdx;
    var anchorCache = _htmlAnchorElement;
    var tempAnchor = anchorCache[anchorIdx];
    if (!_document.createElement) {
        // Always create the temp instance if createElement is not available
        tempAnchor = { host: urlParseHost(url, true) };
    }
    else if (!anchorCache[anchorIdx]) {
        // Create and cache the unattached anchor instance
        tempAnchor = anchorCache[anchorIdx] = _document.createElement("a");
    }
    tempAnchor.href = url;
    // Move the cache index forward
    anchorIdx++;
    if (anchorIdx >= anchorCache[_DYN_LENGTH$4 /* @min:%2elength */]) {
        anchorIdx = 0;
    }
    _htmlAnchorIdx = anchorIdx;
    return tempAnchor;
}
function urlGetAbsoluteUrl(url) {
    var result;
    var a = urlParseUrl(url);
    if (a) {
        result = a.href;
    }
    return result;
}
function urlGetCompleteUrl(method, absoluteUrl) {
    if (method) {
        return method.toUpperCase() + " " + absoluteUrl;
    }
    return absoluteUrl;
}
// Fallback method to grab host from url if document.createElement method is not available
function urlParseHost(url, inclPort) {
    var fullHost = urlParseFullHost(url, inclPort) || "";
    if (fullHost) {
        var match = fullHost.match(/(www\d{0,5}\.)?([^\/:]{1,256})(:\d{1,20})?/i);
        if (match != null && match[_DYN_LENGTH$4 /* @min:%2elength */] > 3 && isString(match[2]) && match[2][_DYN_LENGTH$4 /* @min:%2elength */] > 0) {
            return match[2] + (match[3] || "");
        }
    }
    return fullHost;
}
function urlParseFullHost(url, inclPort) {
    var result = null;
    if (url) {
        var match = url.match(/(\w{1,150}):\/\/([^\/:]{1,256})(:\d{1,20})?/i);
        if (match != null && match[_DYN_LENGTH$4 /* @min:%2elength */] > 2 && isString(match[2]) && match[2][_DYN_LENGTH$4 /* @min:%2elength */] > 0) {
            result = match[2] || "";
            if (inclPort && match[_DYN_LENGTH$4 /* @min:%2elength */] > 2) {
                var protocol = (match[1] || "")[_DYN_TO_LOWER_CASE$1 /* @min:%2etoLowerCase */]();
                var port = match[3] || "";
                // IE includes the standard port so pass it off if it's the same as the protocol
                if (protocol === "http" && port === ":80") {
                    port = "";
                }
                else if (protocol === "https" && port === ":443") {
                    port = "";
                }
                result += port;
            }
        }
    }
    return result;
}

/*
 * Application Insights JavaScript SDK - Common, 3.0.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */

// listing only non-geo specific locations
var _internalEndpoints = [
    DEFAULT_BREEZE_ENDPOINT + DEFAULT_BREEZE_PATH,
    "https://breeze.aimon.applicationinsights.io" + DEFAULT_BREEZE_PATH,
    "https://dc-int.services.visualstudio.com" + DEFAULT_BREEZE_PATH
];
var _correlationIdPrefix = "cid-v1:";
function isInternalApplicationInsightsEndpoint(endpointUrl) {
    return arrIndexOf(_internalEndpoints, endpointUrl[_DYN_TO_LOWER_CASE$1 /* @min:%2etoLowerCase */]()) !== -1;
}
/**
 * Checks if a request url is not on a excluded domain list and if it is safe to add correlation headers.
 * Headers are always included if the current domain matches the request domain. If they do not match (CORS),
 * they are regex-ed across correlationHeaderDomains and correlationHeaderExcludedDomains to determine if headers are included.
 * Some environments don't give information on currentHost via window.location.host (e.g. Cordova). In these cases, the user must
 * manually supply domains to include correlation headers on. Else, no headers will be included at all.
 */
function correlationIdCanIncludeCorrelationHeader(config, requestUrl, currentHost) {
    if (!requestUrl || (config && config.disableCorrelationHeaders)) {
        return false;
    }
    if (config && config[_DYN_CORRELATION_HEADER_E0 /* @min:%2ecorrelationHeaderExcludePatterns */]) {
        for (var i = 0; i < config.correlationHeaderExcludePatterns[_DYN_LENGTH$4 /* @min:%2elength */]; i++) {
            if (config[_DYN_CORRELATION_HEADER_E0 /* @min:%2ecorrelationHeaderExcludePatterns */][i].test(requestUrl)) {
                return false;
            }
        }
    }
    var requestHost = urlParseUrl(requestUrl).host[_DYN_TO_LOWER_CASE$1 /* @min:%2etoLowerCase */]();
    if (requestHost && (strIndexOf(requestHost, ":443") !== -1 || strIndexOf(requestHost, ":80") !== -1)) {
        // [Bug #1260] IE can include the port even for http and https URLs so if present
        // try and parse it to remove if it matches the default protocol port
        requestHost = (urlParseFullHost(requestUrl, true) || "")[_DYN_TO_LOWER_CASE$1 /* @min:%2etoLowerCase */]();
    }
    if ((!config || !config.enableCorsCorrelation) && (requestHost && requestHost !== currentHost)) {
        return false;
    }
    var includedDomains = config && config.correlationHeaderDomains;
    if (includedDomains) {
        var matchExists_1;
        arrForEach(includedDomains, function (domain) {
            var regex = new RegExp(domain.toLowerCase().replace(/\\/g, "\\\\").replace(/\./g, "\\.").replace(/\*/g, ".*"));
            matchExists_1 = matchExists_1 || regex.test(requestHost);
        });
        if (!matchExists_1) {
            return false;
        }
    }
    var excludedDomains = config && config.correlationHeaderExcludedDomains;
    if (!excludedDomains || excludedDomains[_DYN_LENGTH$4 /* @min:%2elength */] === 0) {
        return true;
    }
    for (var i = 0; i < excludedDomains[_DYN_LENGTH$4 /* @min:%2elength */]; i++) {
        var regex = new RegExp(excludedDomains[i].toLowerCase().replace(/\\/g, "\\\\").replace(/\./g, "\\.").replace(/\*/g, ".*"));
        if (regex.test(requestHost)) {
            return false;
        }
    }
    // if we don't know anything about the requestHost, require the user to use included/excludedDomains.
    // Previously we always returned false for a falsy requestHost
    return requestHost && requestHost[_DYN_LENGTH$4 /* @min:%2elength */] > 0;
}
/**
 * Combines target appId and target role name from response header.
 */
function correlationIdGetCorrelationContext(responseHeader) {
    if (responseHeader) {
        var correlationId = correlationIdGetCorrelationContextValue(responseHeader, RequestHeaders[1 /* eRequestHeaders.requestContextTargetKey */]);
        if (correlationId && correlationId !== _correlationIdPrefix) {
            return correlationId;
        }
    }
}
/**
 * Gets key from correlation response header
 */
function correlationIdGetCorrelationContextValue(responseHeader, key) {
    if (responseHeader) {
        var keyValues = responseHeader[_DYN_SPLIT /* @min:%2esplit */](",");
        for (var i = 0; i < keyValues[_DYN_LENGTH$4 /* @min:%2elength */]; ++i) {
            var keyValue = keyValues[i][_DYN_SPLIT /* @min:%2esplit */]("=");
            if (keyValue[_DYN_LENGTH$4 /* @min:%2elength */] === 2 && keyValue[0] === key) {
                return keyValue[1];
            }
        }
    }
}
function AjaxHelperParseDependencyPath(logger, absoluteUrl, method, commandName) {
    var target, name = commandName, data = commandName;
    if (absoluteUrl && absoluteUrl[_DYN_LENGTH$4 /* @min:%2elength */] > 0) {
        var parsedUrl = urlParseUrl(absoluteUrl);
        target = parsedUrl.host;
        if (!name) {
            if (parsedUrl[_DYN_PATHNAME /* @min:%2epathname */] != null) {
                var pathName = (parsedUrl.pathname[_DYN_LENGTH$4 /* @min:%2elength */] === 0) ? "/" : parsedUrl[_DYN_PATHNAME /* @min:%2epathname */];
                if (pathName.charAt(0) !== "/") {
                    pathName = "/" + pathName;
                }
                data = parsedUrl[_DYN_PATHNAME /* @min:%2epathname */];
                name = dataSanitizeString(logger, method ? method + " " + pathName : pathName);
            }
            else {
                name = dataSanitizeString(logger, absoluteUrl);
            }
        }
    }
    else {
        target = commandName;
        name = commandName;
    }
    return {
        target: target,
        name: name,
        data: data
    };
}
function dateTimeUtilsNow() {
    // returns the window or webworker performance object
    var perf = getPerformance();
    if (perf && perf.now && perf.timing) {
        var now = perf.now() + perf.timing.navigationStart;
        // Known issue with IE where this calculation can be negative, so if it is then ignore and fallback
        if (now > 0) {
            return now;
        }
    }
    return utcNow();
}
function dateTimeUtilsDuration(start, end) {
    var result = null;
    if (start !== 0 && end !== 0 && !isNullOrUndefined(start) && !isNullOrUndefined(end)) {
        result = end - start;
    }
    return result;
}
/**
 * Creates a IDistributedTraceContext from an optional telemetryTrace
 * @param telemetryTrace - The telemetryTrace instance that is being wrapped
 * @param parentCtx - An optional parent distributed trace instance, almost always undefined as this scenario is only used in the case of multiple property handlers.
 * @returns A new IDistributedTraceContext instance that is backed by the telemetryTrace or temporary object
 */
function createDistributedTraceContextFromTrace(telemetryTrace, parentCtx) {
    var trace = telemetryTrace || {};
    return {
        getName: function () {
            return trace[_DYN_NAME$2 /* @min:%2ename */];
        },
        setName: function (newValue) {
            parentCtx && parentCtx.setName(newValue);
            trace[_DYN_NAME$2 /* @min:%2ename */] = newValue;
        },
        getTraceId: function () {
            return trace.traceID;
        },
        setTraceId: function (newValue) {
            parentCtx && parentCtx.setTraceId(newValue);
            if (isValidTraceId(newValue)) {
                trace.traceID = newValue;
            }
        },
        getSpanId: function () {
            return trace.parentID;
        },
        setSpanId: function (newValue) {
            parentCtx && parentCtx.setSpanId(newValue);
            if (isValidSpanId(newValue)) {
                trace.parentID = newValue;
            }
        },
        getTraceFlags: function () {
            return trace.traceFlags;
        },
        setTraceFlags: function (newTraceFlags) {
            parentCtx && parentCtx.setTraceFlags(newTraceFlags);
            trace.traceFlags = newTraceFlags;
        }
    };
}

/*
 * Application Insights JavaScript SDK - Common, 3.0.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */

var StorageType = createEnumStyle({
    LocalStorage: 0 /* eStorageType.LocalStorage */,
    SessionStorage: 1 /* eStorageType.SessionStorage */
});
createEnumStyle({
    AI: 0 /* eDistributedTracingModes.AI */,
    AI_AND_W3C: 1 /* eDistributedTracingModes.AI_AND_W3C */,
    W3C: 2 /* eDistributedTracingModes.W3C */
});

/*
 * Application Insights JavaScript SDK - Common, 3.0.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */

var _canUseLocalStorage = undefined;
var _canUseSessionStorage = undefined;
var _storagePrefix = "";
/**
 * Gets the localStorage object if available
 * @return {Storage} - Returns the storage object if available else returns null
 */
function _getLocalStorageObject() {
    if (utlCanUseLocalStorage()) {
        return _getVerifiedStorageObject(StorageType.LocalStorage);
    }
    return null;
}
/**
 * Tests storage object (localStorage or sessionStorage) to verify that it is usable
 * More details here: https://mathiasbynens.be/notes/localstorage-pattern
 * @param storageType - Type of storage
 * @return {Storage} Returns storage object verified that it is usable
 */
function _getVerifiedStorageObject(storageType) {
    try {
        if (isNullOrUndefined(getGlobal())) {
            return null;
        }
        var uid = (new Date)[_DYN_TO_STRING$2 /* @min:%2etoString */]();
        var storage = getInst(storageType === StorageType.LocalStorage ? "localStorage" : "sessionStorage");
        var name_1 = _storagePrefix + uid;
        storage.setItem(name_1, uid);
        var fail = storage.getItem(name_1) !== uid;
        storage[_DYN_REMOVE_ITEM /* @min:%2eremoveItem */](name_1);
        if (!fail) {
            return storage;
        }
    }
    catch (exception) {
        // eslint-disable-next-line no-empty
    }
    return null;
}
/**
 * Gets the sessionStorage object if available
 * @return {Storage} - Returns the storage object if available else returns null
 */
function _getSessionStorageObject() {
    if (utlCanUseSessionStorage()) {
        return _getVerifiedStorageObject(StorageType.SessionStorage);
    }
    return null;
}
/**
 * Disables the global SDK usage of local or session storage if available
 */
function utlDisableStorage() {
    _canUseLocalStorage = false;
    _canUseSessionStorage = false;
}
function utlSetStoragePrefix(storagePrefix) {
    _storagePrefix = storagePrefix || "";
}
/**
 * Re-enables the global SDK usage of local or session storage if available
 */
function utlEnableStorage() {
    _canUseLocalStorage = utlCanUseLocalStorage(true);
    _canUseSessionStorage = utlCanUseSessionStorage(true);
}
/**
 * Returns whether LocalStorage can be used, if the reset parameter is passed a true this will override
 * any previous disable calls.
 * @param reset - Should the usage be reset and determined only based on whether LocalStorage is available
 */
function utlCanUseLocalStorage(reset) {
    if (reset || _canUseLocalStorage === undefined) {
        _canUseLocalStorage = !!_getVerifiedStorageObject(StorageType.LocalStorage);
    }
    return _canUseLocalStorage;
}
function utlGetLocalStorage(logger, name) {
    var storage = _getLocalStorageObject();
    if (storage !== null) {
        try {
            return storage.getItem(name);
        }
        catch (e) {
            _canUseLocalStorage = false;
            _throwInternal(logger, 2 /* eLoggingSeverity.WARNING */, 1 /* _eInternalMessageId.BrowserCannotReadLocalStorage */, "Browser failed read of local storage. " + getExceptionName(e), { exception: dumpObj(e) });
        }
    }
    return null;
}
function utlSetLocalStorage(logger, name, data) {
    var storage = _getLocalStorageObject();
    if (storage !== null) {
        try {
            storage.setItem(name, data);
            return true;
        }
        catch (e) {
            _canUseLocalStorage = false;
            _throwInternal(logger, 2 /* eLoggingSeverity.WARNING */, 3 /* _eInternalMessageId.BrowserCannotWriteLocalStorage */, "Browser failed write to local storage. " + getExceptionName(e), { exception: dumpObj(e) });
        }
    }
    return false;
}
function utlRemoveStorage(logger, name) {
    var storage = _getLocalStorageObject();
    if (storage !== null) {
        try {
            storage[_DYN_REMOVE_ITEM /* @min:%2eremoveItem */](name);
            return true;
        }
        catch (e) {
            _canUseLocalStorage = false;
            _throwInternal(logger, 2 /* eLoggingSeverity.WARNING */, 5 /* _eInternalMessageId.BrowserFailedRemovalFromLocalStorage */, "Browser failed removal of local storage item. " + getExceptionName(e), { exception: dumpObj(e) });
        }
    }
    return false;
}
function utlCanUseSessionStorage(reset) {
    if (reset || _canUseSessionStorage === undefined) {
        _canUseSessionStorage = !!_getVerifiedStorageObject(StorageType.SessionStorage);
    }
    return _canUseSessionStorage;
}
function utlGetSessionStorage(logger, name) {
    var storage = _getSessionStorageObject();
    if (storage !== null) {
        try {
            return storage.getItem(name);
        }
        catch (e) {
            _canUseSessionStorage = false;
            _throwInternal(logger, 2 /* eLoggingSeverity.WARNING */, 2 /* _eInternalMessageId.BrowserCannotReadSessionStorage */, "Browser failed read of session storage. " + getExceptionName(e), { exception: dumpObj(e) });
        }
    }
    return null;
}
function utlSetSessionStorage(logger, name, data) {
    var storage = _getSessionStorageObject();
    if (storage !== null) {
        try {
            storage.setItem(name, data);
            return true;
        }
        catch (e) {
            _canUseSessionStorage = false;
            _throwInternal(logger, 2 /* eLoggingSeverity.WARNING */, 4 /* _eInternalMessageId.BrowserCannotWriteSessionStorage */, "Browser failed write to session storage. " + getExceptionName(e), { exception: dumpObj(e) });
        }
    }
    return false;
}
function utlRemoveSessionStorage(logger, name) {
    var storage = _getSessionStorageObject();
    if (storage !== null) {
        try {
            storage[_DYN_REMOVE_ITEM /* @min:%2eremoveItem */](name);
            return true;
        }
        catch (e) {
            _canUseSessionStorage = false;
            _throwInternal(logger, 2 /* eLoggingSeverity.WARNING */, 6 /* _eInternalMessageId.BrowserFailedRemovalFromSessionStorage */, "Browser failed removal of session storage item. " + getExceptionName(e), { exception: dumpObj(e) });
        }
    }
    return false;
}

/*
 * Application Insights JavaScript SDK - Common, 3.0.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */
var THROTTLE_STORAGE_PREFIX = "appInsightsThrottle";
var ThrottleMgr = /** @class */ (function () {
    function ThrottleMgr(core, namePrefix) {
        var _self = this;
        var _canUseLocalStorage;
        var _logger;
        var _config;
        var _localStorageObj;
        var _isTriggered; //_isTriggered is to make sure that we only trigger throttle once a day
        var _namePrefix;
        var _queue;
        var _isReady = false;
        var _isSpecificDaysGiven = false;
        _initConfig();
        // Special internal method to allow the unit tests and DebugPlugin to hook embedded objects
        _self["_getDbgPlgTargets"] = function () {
            return [_queue];
        };
        _self.getConfig = function () {
            return _config;
        };
        /**
         * Check if it is the correct day to send message.
         * If _isTriggered is true, even if canThrottle returns true, message will not be sent,
         * because we only allow triggering sendMessage() once a day.
         * @returns if the current date is the valid date to send message
         */
        _self.canThrottle = function (msgId) {
            var localObj = _getLocalStorageObjByKey(msgId);
            var cfg = _getCfgByKey(msgId);
            return _canThrottle(cfg, _canUseLocalStorage, localObj);
        };
        /**
         * Check if throttle is triggered on current day(UTC)
         * if canThrottle returns false, isTriggered will return false
         * @returns if throttle is triggered on current day(UTC)
         */
        _self.isTriggered = function (msgId) {
            return _isTrigger(msgId);
        };
        /**
         * Before isReady set to true, all message will be stored in queue.
         * Message will only be sent out after isReady set to true.
         * Initial and default value: false
         * @returns isReady state
         */
        _self.isReady = function () {
            return _isReady;
        };
        /**
         * Flush all message with given message key in queue with isReady state set to true.
         * @returns if message queue is flushed
         */
        _self.flush = function (msgId) {
            try {
                var queue = _getQueueByKey(msgId);
                if (queue && queue[_DYN_LENGTH$4 /* @min:%2elength */] > 0) {
                    var items = queue.slice(0);
                    _queue[msgId] = [];
                    arrForEach(items, function (item) {
                        _flushMessage(item.msgID, item[_DYN_MESSAGE$1 /* @min:%2emessage */], item.severity, false);
                    });
                    return true;
                }
            }
            catch (err) {
                // eslint-disable-next-line no-empty
            }
            return false;
        };
        /**
         * Flush all message in queue with isReady state set to true.
         * @returns if message queue is flushed
         */
        _self.flushAll = function () {
            try {
                if (_queue) {
                    var result_1 = true;
                    objForEachKey(_queue, function (key) {
                        var isFlushed = _self.flush(parseInt(key));
                        result_1 = result_1 && isFlushed;
                    });
                    return result_1;
                }
            }
            catch (err) {
                // eslint-disable-next-line no-empty
            }
            return false;
        };
        /**
         * Set isReady State
         * if isReady set to true, message queue will be flushed automatically.
         * @param isReady isReady State
         * @pa
         * @returns if message queue is flushed
         */
        _self.onReadyState = function (isReady, flushAll) {
            if (flushAll === void 0) { flushAll = true; }
            _isReady = isNullOrUndefined(isReady) ? true : isReady;
            if (_isReady && flushAll) {
                return _self.flushAll();
            }
            return null;
        };
        _self.sendMessage = function (msgID, message, severity) {
            return _flushMessage(msgID, message, severity, true);
        };
        function _flushMessage(msgID, message, severity, saveUnsentMsg) {
            if (_isReady) {
                var isSampledIn = _canSampledIn(msgID);
                if (!isSampledIn) {
                    return;
                }
                var cfg = _getCfgByKey(msgID);
                var localStorageObj = _getLocalStorageObjByKey(msgID);
                var canThrottle = _canThrottle(cfg, _canUseLocalStorage, localStorageObj);
                var throttled = false;
                var number = 0;
                var isTriggered = _isTrigger(msgID);
                try {
                    if (canThrottle && !isTriggered) {
                        number = Math.min(cfg.limit.maxSendNumber, localStorageObj[_DYN_COUNT$1 /* @min:%2ecount */] + 1);
                        localStorageObj[_DYN_COUNT$1 /* @min:%2ecount */] = 0;
                        throttled = true;
                        _isTriggered[msgID] = true;
                        localStorageObj[_DYN_PRE_TRIGGER_DATE /* @min:%2epreTriggerDate */] = new Date();
                    }
                    else {
                        _isTriggered[msgID] = canThrottle;
                        localStorageObj[_DYN_COUNT$1 /* @min:%2ecount */] += 1;
                    }
                    var localStorageName = _getLocalStorageName(msgID);
                    _resetLocalStorage(_logger, localStorageName, localStorageObj);
                    for (var i = 0; i < number; i++) {
                        _sendMessage(msgID, _logger, message, severity);
                    }
                }
                catch (e) {
                    // eslint-disable-next-line no-empty
                }
                return {
                    isThrottled: throttled,
                    throttleNum: number
                };
            }
            else {
                if (!!saveUnsentMsg) {
                    var queue = _getQueueByKey(msgID);
                    queue.push({
                        msgID: msgID,
                        message: message,
                        severity: severity
                    });
                }
            }
            return null;
        }
        function _initConfig() {
            _logger = safeGetLogger(core);
            _isTriggered = {};
            _localStorageObj = {};
            _queue = {};
            _config = {};
            _setCfgByKey(109 /* _eInternalMessageId.DefaultThrottleMsgKey */);
            _namePrefix = isNotNullOrUndefined(namePrefix) ? namePrefix : "";
            core.addUnloadHook(onConfigChange(core.config, function (details) {
                var coreConfig = details.cfg;
                _canUseLocalStorage = utlCanUseLocalStorage();
                var configMgr = coreConfig.throttleMgrCfg || {};
                objForEachKey(configMgr, function (key, cfg) {
                    _setCfgByKey(parseInt(key), cfg);
                });
            }));
        }
        function _getCfgByKey(msgID) {
            return _config[msgID] || _config[109 /* _eInternalMessageId.DefaultThrottleMsgKey */];
        }
        function _setCfgByKey(msgID, config) {
            var _a, _b;
            try {
                var cfg = config || {};
                var curCfg = {};
                curCfg[_DYN_DISABLED /* @min:%2edisabled */] = !!cfg[_DYN_DISABLED /* @min:%2edisabled */];
                var configInterval = cfg[_DYN_INTERVAL /* @min:%2einterval */] || {};
                _isSpecificDaysGiven = (configInterval === null || configInterval === void 0 ? void 0 : configInterval.daysOfMonth) && (configInterval === null || configInterval === void 0 ? void 0 : configInterval.daysOfMonth[_DYN_LENGTH$4 /* @min:%2elength */]) > 0;
                curCfg[_DYN_INTERVAL /* @min:%2einterval */] = _getIntervalConfig(configInterval);
                var limit = {
                    samplingRate: ((_a = cfg.limit) === null || _a === void 0 ? void 0 : _a.samplingRate) || 100,
                    // dafault: every time sent only 1 event
                    maxSendNumber: ((_b = cfg.limit) === null || _b === void 0 ? void 0 : _b.maxSendNumber) || 1
                };
                curCfg.limit = limit;
                _config[msgID] = curCfg;
            }
            catch (e) {
                // eslint-disable-next-line no-empty
            }
        }
        function _getIntervalConfig(interval) {
            interval = interval || {};
            var monthInterval = interval === null || interval === void 0 ? void 0 : interval.monthInterval;
            var dayInterval = interval === null || interval === void 0 ? void 0 : interval.dayInterval;
            // default: send data every 3 month each year
            if (isNullOrUndefined(monthInterval) && isNullOrUndefined(dayInterval)) {
                interval.monthInterval = 3;
                if (!_isSpecificDaysGiven) {
                    // default: send data on 28th
                    interval[_DYN_DAYS_OF_MONTH /* @min:%2edaysOfMonth */] = [28];
                    _isSpecificDaysGiven = true;
                }
            }
            interval = {
                // dafault: sent every three months
                monthInterval: interval === null || interval === void 0 ? void 0 : interval.monthInterval,
                dayInterval: interval === null || interval === void 0 ? void 0 : interval.dayInterval,
                daysOfMonth: interval === null || interval === void 0 ? void 0 : interval.daysOfMonth
            };
            return interval;
        }
        function _canThrottle(config, canUseLocalStorage, localStorageObj) {
            if (config && !config[_DYN_DISABLED /* @min:%2edisabled */] && canUseLocalStorage && isNotNullOrUndefined(localStorageObj)) {
                var curDate = _getThrottleDate();
                var date = localStorageObj[_DYN_DATE /* @min:%2edate */];
                var interval = config[_DYN_INTERVAL /* @min:%2einterval */];
                var monthCheck = 1;
                if (interval === null || interval === void 0 ? void 0 : interval.monthInterval) {
                    var monthExpand = (curDate.getUTCFullYear() - date.getUTCFullYear()) * 12 + curDate.getUTCMonth() - date.getUTCMonth();
                    monthCheck = _checkInterval(interval.monthInterval, 0, monthExpand);
                }
                var dayCheck = 1;
                if (_isSpecificDaysGiven) {
                    dayCheck = arrIndexOf(interval[_DYN_DAYS_OF_MONTH /* @min:%2edaysOfMonth */], curDate[_DYN_GET_UTCDATE /* @min:%2egetUTCDate */]());
                }
                else if (interval === null || interval === void 0 ? void 0 : interval.dayInterval) {
                    var daySpan = Math.floor((curDate.getTime() - date.getTime()) / 86400000);
                    dayCheck = _checkInterval(interval.dayInterval, 0, daySpan);
                }
                return monthCheck >= 0 && dayCheck >= 0;
            }
            return false;
        }
        function _getLocalStorageName(msgKey, prefix) {
            var fix = isNotNullOrUndefined(prefix) ? prefix : "";
            if (msgKey) {
                return THROTTLE_STORAGE_PREFIX + fix + "-" + msgKey;
            }
            return null;
        }
        // returns if throttle is triggered on current Date
        function _isTriggeredOnCurDate(preTriggerDate) {
            try {
                if (preTriggerDate) {
                    var curDate = new Date();
                    return preTriggerDate.getUTCFullYear() === curDate.getUTCFullYear() &&
                        preTriggerDate.getUTCMonth() === curDate.getUTCMonth() &&
                        preTriggerDate[_DYN_GET_UTCDATE /* @min:%2egetUTCDate */]() === curDate[_DYN_GET_UTCDATE /* @min:%2egetUTCDate */]();
                }
            }
            catch (e) {
                // eslint-disable-next-line no-empty
            }
            return false;
        }
        // transfer local storage string value to object that identifies start date, current count and preTriggerDate
        function _getLocalStorageObj(value, logger, storageName) {
            try {
                var storageObj = {
                    date: _getThrottleDate(),
                    count: 0
                };
                if (value) {
                    var obj = JSON.parse(value);
                    var curObj = {
                        date: _getThrottleDate(obj[_DYN_DATE /* @min:%2edate */]) || storageObj[_DYN_DATE /* @min:%2edate */],
                        count: obj[_DYN_COUNT$1 /* @min:%2ecount */] || storageObj[_DYN_COUNT$1 /* @min:%2ecount */],
                        preTriggerDate: obj.preTriggerDate ? _getThrottleDate(obj[_DYN_PRE_TRIGGER_DATE /* @min:%2epreTriggerDate */]) : undefined
                    };
                    return curObj;
                }
                else {
                    _resetLocalStorage(logger, storageName, storageObj);
                    return storageObj;
                }
            }
            catch (e) {
                // eslint-disable-next-line no-empty
            }
            return null;
        }
        // if datestr is not defined, current date will be returned
        function _getThrottleDate(dateStr) {
            // if new Date() can't be created through the provided dateStr, null will be returned.
            try {
                if (dateStr) {
                    var date = new Date(dateStr);
                    //make sure it is a valid Date Object
                    if (!isNaN(date.getDate())) {
                        return date;
                    }
                }
                else {
                    return new Date();
                }
            }
            catch (e) {
                // eslint-disable-next-line no-empty
            }
            return null;
        }
        function _resetLocalStorage(logger, storageName, obj) {
            try {
                return utlSetLocalStorage(logger, storageName, strTrim(JSON[_DYN_STRINGIFY$1 /* @min:%2estringify */](obj)));
            }
            catch (e) {
                // eslint-disable-next-line no-empty
            }
            return false;
        }
        function _checkInterval(interval, start, current) {
            if (interval <= 0) {
                return 1;
            }
            // count from start year
            return (current >= start) && (current - start) % interval == 0 ? Math.floor((current - start) / interval) + 1 : -1;
        }
        function _sendMessage(msgID, logger, message, severity) {
            _throwInternal(logger, severity || 1 /* eLoggingSeverity.CRITICAL */, msgID, message);
        }
        // NOTE: config.limit.samplingRate is set to 4 decimal places,
        // so config.limit.samplingRate = 1 means 0.0001%
        function _canSampledIn(msgID) {
            try {
                var cfg = _getCfgByKey(msgID);
                return randomValue(1000000) <= cfg.limit.samplingRate;
            }
            catch (e) {
                // eslint-disable-next-line no-empty
            }
            return false;
        }
        function _getLocalStorageObjByKey(key) {
            try {
                var curObj = _localStorageObj[key];
                if (!curObj) {
                    var localStorageName = _getLocalStorageName(key, _namePrefix);
                    curObj = _getLocalStorageObj(utlGetLocalStorage(_logger, localStorageName), _logger, localStorageName);
                    _localStorageObj[key] = curObj;
                }
                return _localStorageObj[key];
            }
            catch (e) {
                // eslint-disable-next-line no-empty
            }
            return null;
        }
        function _isTrigger(key) {
            var isTrigger = _isTriggered[key];
            if (isNullOrUndefined(isTrigger)) {
                isTrigger = false;
                var localStorageObj = _getLocalStorageObjByKey(key);
                if (localStorageObj) {
                    isTrigger = _isTriggeredOnCurDate(localStorageObj[_DYN_PRE_TRIGGER_DATE /* @min:%2epreTriggerDate */]);
                }
                _isTriggered[key] = isTrigger;
            }
            return _isTriggered[key];
        }
        function _getQueueByKey(key) {
            _queue = _queue || {};
            if (isNullOrUndefined(_queue[key])) {
                _queue[key] = [];
            }
            return _queue[key];
        }
    }
    return ThrottleMgr;
}());

/*
 * Application Insights JavaScript SDK - Common, 3.0.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */

var _FIELDS_SEPARATOR = ";";
var _FIELD_KEY_VALUE_SEPARATOR = "=";
function parseConnectionString(connectionString) {
    if (!connectionString) {
        return {};
    }
    var kvPairs = connectionString[_DYN_SPLIT /* @min:%2esplit */](_FIELDS_SEPARATOR);
    var result = arrReduce(kvPairs, function (fields, kv) {
        var kvParts = kv[_DYN_SPLIT /* @min:%2esplit */](_FIELD_KEY_VALUE_SEPARATOR);
        if (kvParts[_DYN_LENGTH$4 /* @min:%2elength */] === 2) { // only save fields with valid formats
            var key = kvParts[0][_DYN_TO_LOWER_CASE$1 /* @min:%2etoLowerCase */]();
            var value = kvParts[1];
            fields[key] = value;
        }
        return fields;
    }, {});
    if (objKeys(result)[_DYN_LENGTH$4 /* @min:%2elength */] > 0) {
        // this is a valid connection string, so parse the results
        if (result.endpointsuffix) {
            // use endpoint suffix where overrides are not provided
            var locationPrefix = result.location ? result.location + "." : "";
            result[_DYN_INGESTIONENDPOINT /* @min:%2eingestionendpoint */] = result[_DYN_INGESTIONENDPOINT /* @min:%2eingestionendpoint */] || ("https://" + locationPrefix + "dc." + result.endpointsuffix);
        }
        // apply the default endpoints
        result[_DYN_INGESTIONENDPOINT /* @min:%2eingestionendpoint */] = result[_DYN_INGESTIONENDPOINT /* @min:%2eingestionendpoint */] || DEFAULT_BREEZE_ENDPOINT;
    }
    return result;
}

/*
 * Application Insights JavaScript SDK - Common, 3.0.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */

var Envelope = /** @class */ (function () {
    /**
     * Constructs a new instance of telemetry data.
     */
    function Envelope(logger, data, name) {
        var _this = this;
        var _self = this;
        _self.ver = 1;
        _self.sampleRate = 100.0;
        _self.tags = {};
        _self[_DYN_NAME$2 /* @min:%2ename */] = dataSanitizeString(logger, name) || strNotSpecified;
        _self.data = data;
        _self.time = toISOString(new Date());
        _self.aiDataContract = {
            time: 1 /* FieldType.Required */,
            iKey: 1 /* FieldType.Required */,
            name: 1 /* FieldType.Required */,
            sampleRate: function () {
                return (_this.sampleRate === 100) ? 4 /* FieldType.Hidden */ : 1 /* FieldType.Required */;
            },
            tags: 1 /* FieldType.Required */,
            data: 1 /* FieldType.Required */
        };
    }
    return Envelope;
}());

/*
 * Application Insights JavaScript SDK - Common, 3.0.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */

var Event$1 = /** @class */ (function () {
    /**
     * Constructs a new instance of the EventTelemetry object
     */
    function Event(logger, name, properties, measurements) {
        this.aiDataContract = {
            ver: 1 /* FieldType.Required */,
            name: 1 /* FieldType.Required */,
            properties: 0 /* FieldType.Default */,
            measurements: 0 /* FieldType.Default */
        };
        var _self = this;
        _self.ver = 2;
        _self[_DYN_NAME$2 /* @min:%2ename */] = dataSanitizeString(logger, name) || strNotSpecified;
        _self[_DYN_PROPERTIES /* @min:%2eproperties */] = dataSanitizeProperties(logger, properties);
        _self[_DYN_MEASUREMENTS$1 /* @min:%2emeasurements */] = dataSanitizeMeasurements(logger, measurements);
    }
    Event.envelopeType = "Microsoft.ApplicationInsights.{0}.Event";
    Event.dataType = "EventData";
    return Event;
}());

/*
 * Application Insights JavaScript SDK - Common, 3.0.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */

var NoMethod = "<no_method>";
var strError = "error";
var strStack = "stack";
var strStackDetails = "stackDetails";
var strErrorSrc = "errorSrc";
var strMessage = "message";
var strDescription = "description";
function _stringify(value, convertToString) {
    var result = value;
    if (result && !isString(result)) {
        if (JSON && JSON[_DYN_STRINGIFY$1 /* @min:%2estringify */]) {
            result = JSON[_DYN_STRINGIFY$1 /* @min:%2estringify */](value);
            if (convertToString && (!result || result === "{}")) {
                if (isFunction(value[_DYN_TO_STRING$2 /* @min:%2etoString */])) {
                    result = value[_DYN_TO_STRING$2 /* @min:%2etoString */]();
                }
                else {
                    result = "" + value;
                }
            }
        }
        else {
            result = "" + value + " - (Missing JSON.stringify)";
        }
    }
    return result || "";
}
function _formatMessage(theEvent, errorType) {
    var evtMessage = theEvent;
    if (theEvent) {
        if (evtMessage && !isString(evtMessage)) {
            evtMessage = theEvent[strMessage] || theEvent[strDescription] || evtMessage;
        }
        // Make sure the message is a string
        if (evtMessage && !isString(evtMessage)) {
            // tslint:disable-next-line: prefer-conditional-expression
            evtMessage = _stringify(evtMessage, true);
        }
        if (theEvent["filename"]) {
            // Looks like an event object with filename
            evtMessage = evtMessage + " @" + (theEvent["filename"] || "") + ":" + (theEvent["lineno"] || "?") + ":" + (theEvent["colno"] || "?");
        }
    }
    // Automatically add the error type to the message if it does already appear to be present
    if (errorType && errorType !== "String" && errorType !== "Object" && errorType !== "Error" && strIndexOf(evtMessage || "", errorType) === -1) {
        evtMessage = errorType + ": " + evtMessage;
    }
    return evtMessage || "";
}
function _isExceptionDetailsInternal(value) {
    try {
        if (isObject(value)) {
            return "hasFullStack" in value && "typeName" in value;
        }
    }
    catch (e) {
        // This can happen with some native browser objects, but should not happen for the type we are checking for
    }
    return false;
}
function _isExceptionInternal(value) {
    try {
        if (isObject(value)) {
            return ("ver" in value && "exceptions" in value && "properties" in value);
        }
    }
    catch (e) {
        // This can happen with some native browser objects, but should not happen for the type we are checking for
    }
    return false;
}
function _isStackDetails(details) {
    return details && details.src && isString(details.src) && details.obj && isArray(details.obj);
}
function _convertStackObj(errorStack) {
    var src = errorStack || "";
    if (!isString(src)) {
        if (isString(src[strStack])) {
            src = src[strStack];
        }
        else {
            src = "" + src;
        }
    }
    var items = src[_DYN_SPLIT /* @min:%2esplit */]("\n");
    return {
        src: src,
        obj: items
    };
}
function _getOperaStack(errorMessage) {
    var stack = [];
    var lines = errorMessage[_DYN_SPLIT /* @min:%2esplit */]("\n");
    for (var lp = 0; lp < lines[_DYN_LENGTH$4 /* @min:%2elength */]; lp++) {
        var entry = lines[lp];
        if (lines[lp + 1]) {
            entry += "@" + lines[lp + 1];
            lp++;
        }
        stack.push(entry);
    }
    return {
        src: errorMessage,
        obj: stack
    };
}
function _getStackFromErrorObj(errorObj) {
    var details = null;
    if (errorObj) {
        try {
            /* Using bracket notation is support older browsers (IE 7/8 -- dont remember the version) that throw when using dot
            notation for undefined objects and we don't want to loose the error from being reported */
            if (errorObj[strStack]) {
                // Chrome/Firefox
                details = _convertStackObj(errorObj[strStack]);
            }
            else if (errorObj[strError] && errorObj[strError][strStack]) {
                // Edge error event provides the stack and error object
                details = _convertStackObj(errorObj[strError][strStack]);
            }
            else if (errorObj["exception"] && errorObj.exception[strStack]) {
                details = _convertStackObj(errorObj.exception[strStack]);
            }
            else if (_isStackDetails(errorObj)) {
                details = errorObj;
            }
            else if (_isStackDetails(errorObj[strStackDetails])) {
                details = errorObj[strStackDetails];
            }
            else if (window && window["opera"] && errorObj[strMessage]) {
                // Opera
                details = _getOperaStack(errorObj[_DYN_MESSAGE$1 /* @min:%2emessage */]);
            }
            else if (errorObj["reason"] && errorObj.reason[strStack]) {
                // UnhandledPromiseRejection
                details = _convertStackObj(errorObj.reason[strStack]);
            }
            else if (isString(errorObj)) {
                details = _convertStackObj(errorObj);
            }
            else {
                var evtMessage = errorObj[strMessage] || errorObj[strDescription] || "";
                if (isString(errorObj[strErrorSrc])) {
                    if (evtMessage) {
                        evtMessage += "\n";
                    }
                    evtMessage += " from " + errorObj[strErrorSrc];
                }
                if (evtMessage) {
                    details = _convertStackObj(evtMessage);
                }
            }
        }
        catch (e) {
            // something unexpected happened so to avoid failing to report any error lets swallow the exception
            // and fallback to the callee/caller method
            details = _convertStackObj(e);
        }
    }
    return details || {
        src: "",
        obj: null
    };
}
function _formatStackTrace(stackDetails) {
    var stack = "";
    if (stackDetails) {
        if (stackDetails.obj) {
            arrForEach(stackDetails.obj, function (entry) {
                stack += entry + "\n";
            });
        }
        else {
            stack = stackDetails.src || "";
        }
    }
    return stack;
}
function _parseStack(stack) {
    var parsedStack;
    var frames = stack.obj;
    if (frames && frames[_DYN_LENGTH$4 /* @min:%2elength */] > 0) {
        parsedStack = [];
        var level_1 = 0;
        var totalSizeInBytes_1 = 0;
        arrForEach(frames, function (frame) {
            var theFrame = frame[_DYN_TO_STRING$2 /* @min:%2etoString */]();
            if (_StackFrame.regex.test(theFrame)) {
                var parsedFrame = new _StackFrame(theFrame, level_1++);
                totalSizeInBytes_1 += parsedFrame[_DYN_SIZE_IN_BYTES /* @min:%2esizeInBytes */];
                parsedStack.push(parsedFrame);
            }
        });
        // DP Constraint - exception parsed stack must be < 32KB
        // remove frames from the middle to meet the threshold
        var exceptionParsedStackThreshold = 32 * 1024;
        if (totalSizeInBytes_1 > exceptionParsedStackThreshold) {
            var left = 0;
            var right = parsedStack[_DYN_LENGTH$4 /* @min:%2elength */] - 1;
            var size = 0;
            var acceptedLeft = left;
            var acceptedRight = right;
            while (left < right) {
                // check size
                var lSize = parsedStack[left][_DYN_SIZE_IN_BYTES /* @min:%2esizeInBytes */];
                var rSize = parsedStack[right][_DYN_SIZE_IN_BYTES /* @min:%2esizeInBytes */];
                size += lSize + rSize;
                if (size > exceptionParsedStackThreshold) {
                    // remove extra frames from the middle
                    var howMany = acceptedRight - acceptedLeft + 1;
                    parsedStack.splice(acceptedLeft, howMany);
                    break;
                }
                // update pointers
                acceptedLeft = left;
                acceptedRight = right;
                left++;
                right--;
            }
        }
    }
    return parsedStack;
}
function _getErrorType(errorType) {
    // Gets the Error Type by passing the constructor (used to get the true type of native error object).
    var typeName = "";
    if (errorType) {
        typeName = errorType.typeName || errorType[_DYN_NAME$2 /* @min:%2ename */] || "";
        if (!typeName) {
            try {
                var funcNameRegex = /function (.{1,200})\(/;
                var results = (funcNameRegex).exec((errorType).constructor[_DYN_TO_STRING$2 /* @min:%2etoString */]());
                typeName = (results && results[_DYN_LENGTH$4 /* @min:%2elength */] > 1) ? results[1] : "";
            }
            catch (e) {
                // eslint-disable-next-line no-empty -- Ignoring any failures as nothing we can do
            }
        }
    }
    return typeName;
}
/**
 * Formats the provided errorObj for display and reporting, it may be a String, Object, integer or undefined depending on the browser.
 * @param errorObj - The supplied errorObj
 */
function _formatErrorCode(errorObj) {
    if (errorObj) {
        try {
            if (!isString(errorObj)) {
                var errorType = _getErrorType(errorObj);
                var result = _stringify(errorObj, false);
                if (!result || result === "{}") {
                    if (errorObj[strError]) {
                        // Looks like an MS Error Event
                        errorObj = errorObj[strError];
                        errorType = _getErrorType(errorObj);
                    }
                    result = _stringify(errorObj, true);
                }
                if (strIndexOf(result, errorType) !== 0 && errorType !== "String") {
                    return errorType + ":" + result;
                }
                return result;
            }
        }
        catch (e) {
            // eslint-disable-next-line no-empty -- Ignoring any failures as nothing we can do
        }
    }
    // Fallback to just letting the object format itself into a string
    return "" + (errorObj || "");
}
var Exception = /** @class */ (function () {
    /**
     * Constructs a new instance of the ExceptionTelemetry object
     */
    function Exception(logger, exception, properties, measurements, severityLevel, id) {
        this.aiDataContract = {
            ver: 1 /* FieldType.Required */,
            exceptions: 1 /* FieldType.Required */,
            severityLevel: 0 /* FieldType.Default */,
            properties: 0 /* FieldType.Default */,
            measurements: 0 /* FieldType.Default */
        };
        var _self = this;
        _self.ver = 2; // TODO: handle the CS"4.0" ==> breeze 2 conversion in a better way
        if (!_isExceptionInternal(exception)) {
            if (!properties) {
                properties = {};
            }
            _self[_DYN_EXCEPTIONS /* @min:%2eexceptions */] = [new _ExceptionDetails(logger, exception, properties)];
            _self[_DYN_PROPERTIES /* @min:%2eproperties */] = dataSanitizeProperties(logger, properties);
            _self[_DYN_MEASUREMENTS$1 /* @min:%2emeasurements */] = dataSanitizeMeasurements(logger, measurements);
            if (severityLevel) {
                _self[_DYN_SEVERITY_LEVEL /* @min:%2eseverityLevel */] = severityLevel;
            }
            if (id) {
                _self.id = id;
            }
        }
        else {
            _self[_DYN_EXCEPTIONS /* @min:%2eexceptions */] = exception[_DYN_EXCEPTIONS /* @min:%2eexceptions */] || [];
            _self[_DYN_PROPERTIES /* @min:%2eproperties */] = exception[_DYN_PROPERTIES /* @min:%2eproperties */];
            _self[_DYN_MEASUREMENTS$1 /* @min:%2emeasurements */] = exception[_DYN_MEASUREMENTS$1 /* @min:%2emeasurements */];
            if (exception[_DYN_SEVERITY_LEVEL /* @min:%2eseverityLevel */]) {
                _self[_DYN_SEVERITY_LEVEL /* @min:%2eseverityLevel */] = exception[_DYN_SEVERITY_LEVEL /* @min:%2eseverityLevel */];
            }
            if (exception.id) {
                _self.id = exception.id;
            }
            if (exception[_DYN_PROBLEM_GROUP /* @min:%2eproblemGroup */]) {
                _self[_DYN_PROBLEM_GROUP /* @min:%2eproblemGroup */] = exception[_DYN_PROBLEM_GROUP /* @min:%2eproblemGroup */];
            }
            // bool/int types, use isNullOrUndefined
            if (!isNullOrUndefined(exception[_DYN_IS_MANUAL /* @min:%2eisManual */])) {
                _self[_DYN_IS_MANUAL /* @min:%2eisManual */] = exception[_DYN_IS_MANUAL /* @min:%2eisManual */];
            }
        }
    }
    Exception.CreateAutoException = function (message, url, lineNumber, columnNumber, error, evt, stack, errorSrc) {
        var _a;
        var errorType = _getErrorType(error || evt || message);
        return _a = {},
            _a[_DYN_MESSAGE$1 /* @min:message */] = _formatMessage(message, errorType),
            _a.url = url,
            _a.lineNumber = lineNumber,
            _a.columnNumber = columnNumber,
            _a.error = _formatErrorCode(error || evt || message),
            _a.evt = _formatErrorCode(evt || message),
            _a[_DYN_TYPE_NAME /* @min:typeName */] = errorType,
            _a.stackDetails = _getStackFromErrorObj(stack || error || evt),
            _a.errorSrc = errorSrc,
            _a;
    };
    Exception.CreateFromInterface = function (logger, exception, properties, measurements) {
        var exceptions = exception[_DYN_EXCEPTIONS /* @min:%2eexceptions */]
            && arrMap(exception[_DYN_EXCEPTIONS /* @min:%2eexceptions */], function (ex) { return _ExceptionDetails[_DYN__CREATE_FROM_INTERFA1 /* @min:%2eCreateFromInterface */](logger, ex); });
        var exceptionData = new Exception(logger, __assignFn(__assignFn({}, exception), { exceptions: exceptions }), properties, measurements);
        return exceptionData;
    };
    Exception.prototype.toInterface = function () {
        var _a;
        var _b = this, exceptions = _b.exceptions, properties = _b.properties, measurements = _b.measurements, severityLevel = _b.severityLevel, problemGroup = _b.problemGroup, id = _b.id, isManual = _b.isManual;
        var exceptionDetailsInterface = exceptions instanceof Array
            && arrMap(exceptions, function (exception) { return exception.toInterface(); })
            || undefined;
        return _a = {
                ver: "4.0"
            },
            _a[_DYN_EXCEPTIONS /* @min:exceptions */] = exceptionDetailsInterface,
            _a.severityLevel = severityLevel,
            _a.properties = properties,
            _a.measurements = measurements,
            _a.problemGroup = problemGroup,
            _a.id = id,
            _a.isManual = isManual,
            _a;
    };
    /**
     * Creates a simple exception with 1 stack frame. Useful for manual constracting of exception.
     */
    Exception.CreateSimpleException = function (message, typeName, assembly, fileName, details, line) {
        var _a;
        return {
            exceptions: [
                (_a = {},
                    _a[_DYN_HAS_FULL_STACK /* @min:hasFullStack */] = true,
                    _a.message = message,
                    _a.stack = details,
                    _a.typeName = typeName,
                    _a)
            ]
        };
    };
    Exception.envelopeType = "Microsoft.ApplicationInsights.{0}.Exception";
    Exception.dataType = "ExceptionData";
    Exception.formatError = _formatErrorCode;
    return Exception;
}());
var _ExceptionDetails = /** @class */ (function () {
    function _ExceptionDetails(logger, exception, properties) {
        this.aiDataContract = {
            id: 0 /* FieldType.Default */,
            outerId: 0 /* FieldType.Default */,
            typeName: 1 /* FieldType.Required */,
            message: 1 /* FieldType.Required */,
            hasFullStack: 0 /* FieldType.Default */,
            stack: 0 /* FieldType.Default */,
            parsedStack: 2 /* FieldType.Array */
        };
        var _self = this;
        if (!_isExceptionDetailsInternal(exception)) {
            var error = exception;
            var evt = error && error.evt;
            if (!isError(error)) {
                error = error[strError] || evt || error;
            }
            _self[_DYN_TYPE_NAME /* @min:%2etypeName */] = dataSanitizeString(logger, _getErrorType(error)) || strNotSpecified;
            _self[_DYN_MESSAGE$1 /* @min:%2emessage */] = dataSanitizeMessage(logger, _formatMessage(exception || error, _self[_DYN_TYPE_NAME /* @min:%2etypeName */])) || strNotSpecified;
            var stack = exception[strStackDetails] || _getStackFromErrorObj(exception);
            _self[_DYN_PARSED_STACK /* @min:%2eparsedStack */] = _parseStack(stack);
            // after parsedStack is inited, iterate over each frame object, sanitize its assembly field
            if (isArray(_self[_DYN_PARSED_STACK /* @min:%2eparsedStack */])) {
                arrMap(_self[_DYN_PARSED_STACK /* @min:%2eparsedStack */], function (frame) {
                    frame[_DYN_ASSEMBLY /* @min:%2eassembly */] = dataSanitizeString(logger, frame[_DYN_ASSEMBLY /* @min:%2eassembly */]);
                    frame[_DYN_FILE_NAME /* @min:%2efileName */] = dataSanitizeString(logger, frame[_DYN_FILE_NAME /* @min:%2efileName */]);
                });
            }
            _self[strStack] = dataSanitizeException(logger, _formatStackTrace(stack));
            _self.hasFullStack = isArray(_self.parsedStack) && _self.parsedStack[_DYN_LENGTH$4 /* @min:%2elength */] > 0;
            if (properties) {
                properties[_DYN_TYPE_NAME /* @min:%2etypeName */] = properties[_DYN_TYPE_NAME /* @min:%2etypeName */] || _self[_DYN_TYPE_NAME /* @min:%2etypeName */];
            }
        }
        else {
            _self[_DYN_TYPE_NAME /* @min:%2etypeName */] = exception[_DYN_TYPE_NAME /* @min:%2etypeName */];
            _self[_DYN_MESSAGE$1 /* @min:%2emessage */] = exception[_DYN_MESSAGE$1 /* @min:%2emessage */];
            _self[strStack] = exception[strStack];
            _self[_DYN_PARSED_STACK /* @min:%2eparsedStack */] = exception[_DYN_PARSED_STACK /* @min:%2eparsedStack */] || [];
            _self[_DYN_HAS_FULL_STACK /* @min:%2ehasFullStack */] = exception[_DYN_HAS_FULL_STACK /* @min:%2ehasFullStack */];
        }
    }
    _ExceptionDetails.prototype.toInterface = function () {
        var _a;
        var _self = this;
        var parsedStack = _self[_DYN_PARSED_STACK /* @min:%2eparsedStack */] instanceof Array
            && arrMap(_self[_DYN_PARSED_STACK /* @min:%2eparsedStack */], function (frame) { return frame.toInterface(); });
        var exceptionDetailsInterface = (_a = {
                id: _self.id,
                outerId: _self.outerId,
                typeName: _self[_DYN_TYPE_NAME /* @min:%2etypeName */],
                message: _self[_DYN_MESSAGE$1 /* @min:%2emessage */],
                hasFullStack: _self[_DYN_HAS_FULL_STACK /* @min:%2ehasFullStack */],
                stack: _self[strStack]
            },
            _a[_DYN_PARSED_STACK /* @min:parsedStack */] = parsedStack || undefined,
            _a);
        return exceptionDetailsInterface;
    };
    _ExceptionDetails.CreateFromInterface = function (logger, exception) {
        var parsedStack = (exception[_DYN_PARSED_STACK /* @min:%2eparsedStack */] instanceof Array
            && arrMap(exception[_DYN_PARSED_STACK /* @min:%2eparsedStack */], function (frame) { return _StackFrame[_DYN__CREATE_FROM_INTERFA1 /* @min:%2eCreateFromInterface */](frame); }))
            || exception[_DYN_PARSED_STACK /* @min:%2eparsedStack */];
        var exceptionDetails = new _ExceptionDetails(logger, __assignFn(__assignFn({}, exception), { parsedStack: parsedStack }));
        return exceptionDetails;
    };
    return _ExceptionDetails;
}());
var _StackFrame = /** @class */ (function () {
    function _StackFrame(sourceFrame, level) {
        this.aiDataContract = {
            level: 1 /* FieldType.Required */,
            method: 1 /* FieldType.Required */,
            assembly: 0 /* FieldType.Default */,
            fileName: 0 /* FieldType.Default */,
            line: 0 /* FieldType.Default */
        };
        var _self = this;
        _self[_DYN_SIZE_IN_BYTES /* @min:%2esizeInBytes */] = 0;
        // Not converting this to isString() as typescript uses this logic to "understand" the different
        // types for the 2 different code paths
        if (typeof sourceFrame === "string") {
            var frame = sourceFrame;
            _self[_DYN_LEVEL /* @min:%2elevel */] = level;
            _self[_DYN_METHOD$1 /* @min:%2emethod */] = NoMethod;
            _self[_DYN_ASSEMBLY /* @min:%2eassembly */] = strTrim(frame);
            _self[_DYN_FILE_NAME /* @min:%2efileName */] = "";
            _self[_DYN_LINE /* @min:%2eline */] = 0;
            var matches = frame.match(_StackFrame.regex);
            if (matches && matches[_DYN_LENGTH$4 /* @min:%2elength */] >= 5) {
                _self[_DYN_METHOD$1 /* @min:%2emethod */] = strTrim(matches[2]) || _self[_DYN_METHOD$1 /* @min:%2emethod */];
                _self[_DYN_FILE_NAME /* @min:%2efileName */] = strTrim(matches[4]);
                _self[_DYN_LINE /* @min:%2eline */] = parseInt(matches[5]) || 0;
            }
        }
        else {
            _self[_DYN_LEVEL /* @min:%2elevel */] = sourceFrame[_DYN_LEVEL /* @min:%2elevel */];
            _self[_DYN_METHOD$1 /* @min:%2emethod */] = sourceFrame[_DYN_METHOD$1 /* @min:%2emethod */];
            _self[_DYN_ASSEMBLY /* @min:%2eassembly */] = sourceFrame[_DYN_ASSEMBLY /* @min:%2eassembly */];
            _self[_DYN_FILE_NAME /* @min:%2efileName */] = sourceFrame[_DYN_FILE_NAME /* @min:%2efileName */];
            _self[_DYN_LINE /* @min:%2eline */] = sourceFrame[_DYN_LINE /* @min:%2eline */];
            _self[_DYN_SIZE_IN_BYTES /* @min:%2esizeInBytes */] = 0;
        }
        _self.sizeInBytes += _self.method[_DYN_LENGTH$4 /* @min:%2elength */];
        _self.sizeInBytes += _self.fileName[_DYN_LENGTH$4 /* @min:%2elength */];
        _self.sizeInBytes += _self.assembly[_DYN_LENGTH$4 /* @min:%2elength */];
        // todo: these might need to be removed depending on how the back-end settles on their size calculation
        _self[_DYN_SIZE_IN_BYTES /* @min:%2esizeInBytes */] += _StackFrame.baseSize;
        _self.sizeInBytes += _self.level.toString()[_DYN_LENGTH$4 /* @min:%2elength */];
        _self.sizeInBytes += _self.line.toString()[_DYN_LENGTH$4 /* @min:%2elength */];
    }
    _StackFrame.CreateFromInterface = function (frame) {
        return new _StackFrame(frame, null /* level is available in frame interface */);
    };
    _StackFrame.prototype.toInterface = function () {
        var _self = this;
        return {
            level: _self[_DYN_LEVEL /* @min:%2elevel */],
            method: _self[_DYN_METHOD$1 /* @min:%2emethod */],
            assembly: _self[_DYN_ASSEMBLY /* @min:%2eassembly */],
            fileName: _self[_DYN_FILE_NAME /* @min:%2efileName */],
            line: _self[_DYN_LINE /* @min:%2eline */]
        };
    };
    // regex to match stack frames from ie/chrome/ff
    // methodName=$2, fileName=$4, lineNo=$5, column=$6
    _StackFrame.regex = /^([\s]+at)?[\s]{0,50}([^\@\()]+?)[\s]{0,50}(\@|\()([^\(\n]+):([0-9]+):([0-9]+)(\)?)$/;
    _StackFrame.baseSize = 58; // '{"method":"","level":,"assembly":"","fileName":"","line":}'.length
    return _StackFrame;
}());

/*
 * Application Insights JavaScript SDK - Common, 3.0.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


var DataPoint = /** @class */ (function () {
    function DataPoint() {
        /**
         * The data contract for serializing this object.
         */
        this.aiDataContract = {
            name: 1 /* FieldType.Required */,
            kind: 0 /* FieldType.Default */,
            value: 1 /* FieldType.Required */,
            count: 0 /* FieldType.Default */,
            min: 0 /* FieldType.Default */,
            max: 0 /* FieldType.Default */,
            stdDev: 0 /* FieldType.Default */
        };
        /**
         * Metric type. Single measurement or the aggregated value.
         */
        this.kind = 0 /* DataPointType.Measurement */;
    }
    return DataPoint;
}());

/*
 * Application Insights JavaScript SDK - Common, 3.0.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */

var Metric = /** @class */ (function () {
    /**
     * Constructs a new instance of the MetricTelemetry object
     */
    function Metric(logger, name, value, count, min, max, stdDev, properties, measurements) {
        this.aiDataContract = {
            ver: 1 /* FieldType.Required */,
            metrics: 1 /* FieldType.Required */,
            properties: 0 /* FieldType.Default */
        };
        var _self = this;
        _self.ver = 2;
        var dataPoint = new DataPoint();
        dataPoint[_DYN_COUNT$1 /* @min:%2ecount */] = count > 0 ? count : undefined;
        dataPoint.max = isNaN(max) || max === null ? undefined : max;
        dataPoint.min = isNaN(min) || min === null ? undefined : min;
        dataPoint[_DYN_NAME$2 /* @min:%2ename */] = dataSanitizeString(logger, name) || strNotSpecified;
        dataPoint.value = value;
        dataPoint.stdDev = isNaN(stdDev) || stdDev === null ? undefined : stdDev;
        _self.metrics = [dataPoint];
        _self[_DYN_PROPERTIES /* @min:%2eproperties */] = dataSanitizeProperties(logger, properties);
        _self[_DYN_MEASUREMENTS$1 /* @min:%2emeasurements */] = dataSanitizeMeasurements(logger, measurements);
    }
    Metric.envelopeType = "Microsoft.ApplicationInsights.{0}.Metric";
    Metric.dataType = "MetricData";
    return Metric;
}());

/*
 * Application Insights JavaScript SDK - Common, 3.0.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */

var strEmpty = "";
/**
 * Convert ms to c# time span format
 */
function msToTimeSpan(totalms) {
    if (isNaN(totalms) || totalms < 0) {
        totalms = 0;
    }
    totalms = Math.round(totalms);
    var ms = strEmpty + totalms % 1000;
    var sec = strEmpty + Math.floor(totalms / 1000) % 60;
    var min = strEmpty + Math.floor(totalms / (1000 * 60)) % 60;
    var hour = strEmpty + Math.floor(totalms / (1000 * 60 * 60)) % 24;
    var days = Math.floor(totalms / (1000 * 60 * 60 * 24));
    ms = ms[_DYN_LENGTH$4 /* @min:%2elength */] === 1 ? "00" + ms : ms[_DYN_LENGTH$4 /* @min:%2elength */] === 2 ? "0" + ms : ms;
    sec = sec[_DYN_LENGTH$4 /* @min:%2elength */] < 2 ? "0" + sec : sec;
    min = min[_DYN_LENGTH$4 /* @min:%2elength */] < 2 ? "0" + min : min;
    hour = hour[_DYN_LENGTH$4 /* @min:%2elength */] < 2 ? "0" + hour : hour;
    return (days > 0 ? days + "." : strEmpty) + hour + ":" + min + ":" + sec + "." + ms;
}
function isCrossOriginError(message, url, lineNumber, columnNumber, error) {
    return !error && isString(message) && (message === "Script error." || message === "Script error");
}

/*
 * Application Insights JavaScript SDK - Common, 3.0.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */

var PageView = /** @class */ (function () {
    /**
     * Constructs a new instance of the PageEventTelemetry object
     */
    function PageView(logger, name, url, durationMs, properties, measurements, id) {
        this.aiDataContract = {
            ver: 1 /* FieldType.Required */,
            name: 0 /* FieldType.Default */,
            url: 0 /* FieldType.Default */,
            duration: 0 /* FieldType.Default */,
            properties: 0 /* FieldType.Default */,
            measurements: 0 /* FieldType.Default */,
            id: 0 /* FieldType.Default */
        };
        var _self = this;
        _self.ver = 2;
        _self.id = dataSanitizeId(logger, id);
        _self.url = dataSanitizeUrl(logger, url);
        _self[_DYN_NAME$2 /* @min:%2ename */] = dataSanitizeString(logger, name) || strNotSpecified;
        if (!isNaN(durationMs)) {
            _self[_DYN_DURATION$1 /* @min:%2eduration */] = msToTimeSpan(durationMs);
        }
        _self[_DYN_PROPERTIES /* @min:%2eproperties */] = dataSanitizeProperties(logger, properties);
        _self[_DYN_MEASUREMENTS$1 /* @min:%2emeasurements */] = dataSanitizeMeasurements(logger, measurements);
    }
    PageView.envelopeType = "Microsoft.ApplicationInsights.{0}.Pageview";
    PageView.dataType = "PageviewData";
    return PageView;
}());

/*
 * Application Insights JavaScript SDK - Common, 3.0.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */

var RemoteDependencyData = /** @class */ (function () {
    /**
     * Constructs a new instance of the RemoteDependencyData object
     */
    function RemoteDependencyData(logger, id, absoluteUrl, commandName, value, success, resultCode, method, requestAPI, correlationContext, properties, measurements) {
        if (requestAPI === void 0) { requestAPI = "Ajax"; }
        this.aiDataContract = {
            id: 1 /* FieldType.Required */,
            ver: 1 /* FieldType.Required */,
            name: 0 /* FieldType.Default */,
            resultCode: 0 /* FieldType.Default */,
            duration: 0 /* FieldType.Default */,
            success: 0 /* FieldType.Default */,
            data: 0 /* FieldType.Default */,
            target: 0 /* FieldType.Default */,
            type: 0 /* FieldType.Default */,
            properties: 0 /* FieldType.Default */,
            measurements: 0 /* FieldType.Default */,
            kind: 0 /* FieldType.Default */,
            value: 0 /* FieldType.Default */,
            count: 0 /* FieldType.Default */,
            min: 0 /* FieldType.Default */,
            max: 0 /* FieldType.Default */,
            stdDev: 0 /* FieldType.Default */,
            dependencyKind: 0 /* FieldType.Default */,
            dependencySource: 0 /* FieldType.Default */,
            commandName: 0 /* FieldType.Default */,
            dependencyTypeName: 0 /* FieldType.Default */
        };
        var _self = this;
        _self.ver = 2;
        _self.id = id;
        _self[_DYN_DURATION$1 /* @min:%2eduration */] = msToTimeSpan(value);
        _self.success = success;
        _self.resultCode = resultCode + "";
        _self.type = dataSanitizeString(logger, requestAPI);
        var dependencyFields = AjaxHelperParseDependencyPath(logger, absoluteUrl, method, commandName);
        _self.data = dataSanitizeUrl(logger, commandName) || dependencyFields.data; // get a value from hosturl if commandName not available
        _self.target = dataSanitizeString(logger, dependencyFields.target);
        if (correlationContext) {
            _self.target = "".concat(_self.target, " | ").concat(correlationContext);
        }
        _self[_DYN_NAME$2 /* @min:%2ename */] = dataSanitizeString(logger, dependencyFields[_DYN_NAME$2 /* @min:%2ename */]);
        _self[_DYN_PROPERTIES /* @min:%2eproperties */] = dataSanitizeProperties(logger, properties);
        _self[_DYN_MEASUREMENTS$1 /* @min:%2emeasurements */] = dataSanitizeMeasurements(logger, measurements);
    }
    RemoteDependencyData.envelopeType = "Microsoft.ApplicationInsights.{0}.RemoteDependency";
    RemoteDependencyData.dataType = "RemoteDependencyData";
    return RemoteDependencyData;
}());

/*
 * Application Insights JavaScript SDK - Common, 3.0.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */

var Trace = /** @class */ (function () {
    /**
     * Constructs a new instance of the TraceTelemetry object
     */
    function Trace(logger, message, severityLevel, properties, measurements) {
        this.aiDataContract = {
            ver: 1 /* FieldType.Required */,
            message: 1 /* FieldType.Required */,
            severityLevel: 0 /* FieldType.Default */,
            properties: 0 /* FieldType.Default */
        };
        var _self = this;
        _self.ver = 2;
        message = message || strNotSpecified;
        _self[_DYN_MESSAGE$1 /* @min:%2emessage */] = dataSanitizeMessage(logger, message);
        _self[_DYN_PROPERTIES /* @min:%2eproperties */] = dataSanitizeProperties(logger, properties);
        _self[_DYN_MEASUREMENTS$1 /* @min:%2emeasurements */] = dataSanitizeMeasurements(logger, measurements);
        if (severityLevel) {
            _self[_DYN_SEVERITY_LEVEL /* @min:%2eseverityLevel */] = severityLevel;
        }
    }
    Trace.envelopeType = "Microsoft.ApplicationInsights.{0}.Message";
    Trace.dataType = "MessageData";
    return Trace;
}());

/*
 * Application Insights JavaScript SDK - Common, 3.0.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */

var PageViewPerformance = /** @class */ (function () {
    /**
     * Constructs a new instance of the PageEventTelemetry object
     */
    function PageViewPerformance(logger, name, url, unused, properties, measurements, cs4BaseData) {
        this.aiDataContract = {
            ver: 1 /* FieldType.Required */,
            name: 0 /* FieldType.Default */,
            url: 0 /* FieldType.Default */,
            duration: 0 /* FieldType.Default */,
            perfTotal: 0 /* FieldType.Default */,
            networkConnect: 0 /* FieldType.Default */,
            sentRequest: 0 /* FieldType.Default */,
            receivedResponse: 0 /* FieldType.Default */,
            domProcessing: 0 /* FieldType.Default */,
            properties: 0 /* FieldType.Default */,
            measurements: 0 /* FieldType.Default */
        };
        var _self = this;
        _self.ver = 2;
        _self.url = dataSanitizeUrl(logger, url);
        _self[_DYN_NAME$2 /* @min:%2ename */] = dataSanitizeString(logger, name) || strNotSpecified;
        _self[_DYN_PROPERTIES /* @min:%2eproperties */] = dataSanitizeProperties(logger, properties);
        _self[_DYN_MEASUREMENTS$1 /* @min:%2emeasurements */] = dataSanitizeMeasurements(logger, measurements);
        if (cs4BaseData) {
            _self.domProcessing = cs4BaseData.domProcessing;
            _self[_DYN_DURATION$1 /* @min:%2eduration */] = cs4BaseData[_DYN_DURATION$1 /* @min:%2eduration */];
            _self.networkConnect = cs4BaseData.networkConnect;
            _self.perfTotal = cs4BaseData.perfTotal;
            _self[_DYN_RECEIVED_RESPONSE /* @min:%2ereceivedResponse */] = cs4BaseData[_DYN_RECEIVED_RESPONSE /* @min:%2ereceivedResponse */];
            _self.sentRequest = cs4BaseData.sentRequest;
        }
    }
    PageViewPerformance.envelopeType = "Microsoft.ApplicationInsights.{0}.PageviewPerformance";
    PageViewPerformance.dataType = "PageviewPerformanceData";
    return PageViewPerformance;
}());

/*
 * Application Insights JavaScript SDK - Common, 3.0.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


var Data = /** @class */ (function () {
    /**
     * Constructs a new instance of telemetry data.
     */
    function Data(baseType, data) {
        /**
         * The data contract for serializing this object.
         */
        this.aiDataContract = {
            baseType: 1 /* FieldType.Required */,
            baseData: 1 /* FieldType.Required */
        };
        this.baseType = baseType;
        this.baseData = data;
    }
    return Data;
}());

/*
 * Application Insights JavaScript SDK - Common, 3.0.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */

function _aiNameFunc(baseName) {
    var aiName = "ai." + baseName + ".";
    return function (name) {
        return aiName + name;
    };
}
var _aiApplication = _aiNameFunc("application");
var _aiDevice = _aiNameFunc("device");
var _aiLocation = _aiNameFunc("location");
var _aiOperation = _aiNameFunc("operation");
var _aiSession = _aiNameFunc("session");
var _aiUser = _aiNameFunc("user");
var _aiCloud = _aiNameFunc("cloud");
var _aiInternal = _aiNameFunc("internal");
var ContextTagKeys = /** @class */ (function (_super) {
    __extendsFn(ContextTagKeys, _super);
    function ContextTagKeys() {
        return _super.call(this) || this;
    }
    return ContextTagKeys;
}(createClassFromInterface({
    applicationVersion: _aiApplication("ver"),
    applicationBuild: _aiApplication("build"),
    applicationTypeId: _aiApplication("typeId"),
    applicationId: _aiApplication("applicationId"),
    applicationLayer: _aiApplication("layer"),
    deviceId: _aiDevice("id"),
    deviceIp: _aiDevice("ip"),
    deviceLanguage: _aiDevice("language"),
    deviceLocale: _aiDevice("locale"),
    deviceModel: _aiDevice("model"),
    deviceFriendlyName: _aiDevice("friendlyName"),
    deviceNetwork: _aiDevice("network"),
    deviceNetworkName: _aiDevice("networkName"),
    deviceOEMName: _aiDevice("oemName"),
    deviceOS: _aiDevice("os"),
    deviceOSVersion: _aiDevice("osVersion"),
    deviceRoleInstance: _aiDevice("roleInstance"),
    deviceRoleName: _aiDevice("roleName"),
    deviceScreenResolution: _aiDevice("screenResolution"),
    deviceType: _aiDevice("type"),
    deviceMachineName: _aiDevice("machineName"),
    deviceVMName: _aiDevice("vmName"),
    deviceBrowser: _aiDevice("browser"),
    deviceBrowserVersion: _aiDevice("browserVersion"),
    locationIp: _aiLocation("ip"),
    locationCountry: _aiLocation("country"),
    locationProvince: _aiLocation("province"),
    locationCity: _aiLocation("city"),
    operationId: _aiOperation("id"),
    operationName: _aiOperation("name"),
    operationParentId: _aiOperation("parentId"),
    operationRootId: _aiOperation("rootId"),
    operationSyntheticSource: _aiOperation("syntheticSource"),
    operationCorrelationVector: _aiOperation("correlationVector"),
    sessionId: _aiSession("id"),
    sessionIsFirst: _aiSession("isFirst"),
    sessionIsNew: _aiSession("isNew"),
    userAccountAcquisitionDate: _aiUser("accountAcquisitionDate"),
    userAccountId: _aiUser("accountId"),
    userAgent: _aiUser("userAgent"),
    userId: _aiUser("id"),
    userStoreRegion: _aiUser("storeRegion"),
    userAuthUserId: _aiUser("authUserId"),
    userAnonymousUserAcquisitionDate: _aiUser("anonUserAcquisitionDate"),
    userAuthenticatedUserAcquisitionDate: _aiUser("authUserAcquisitionDate"),
    cloudName: _aiCloud("name"),
    cloudRole: _aiCloud("role"),
    cloudRoleVer: _aiCloud("roleVer"),
    cloudRoleInstance: _aiCloud("roleInstance"),
    cloudEnvironment: _aiCloud("environment"),
    cloudLocation: _aiCloud("location"),
    cloudDeploymentUnit: _aiCloud("deploymentUnit"),
    internalNodeName: _aiInternal("nodeName"),
    internalSdkVersion: _aiInternal("sdkVersion"),
    internalAgentVersion: _aiInternal("agentVersion"),
    internalSnippet: _aiInternal("snippet"),
    internalSdkSrc: _aiInternal("sdkSrc")
})));

/*
 * Application Insights JavaScript SDK - Common, 3.0.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */

/**
 * Create a telemetry item that the 1DS channel understands
 * @param item - domain specific properties; part B
 * @param baseType - telemetry item type. ie PageViewData
 * @param envelopeName - name of the envelope. ie Microsoft.ApplicationInsights.<instrumentation key>.PageView
 * @param customProperties - user defined custom properties; part C
 * @param systemProperties - system properties that are added to the context; part A
 * @returns ITelemetryItem that is sent to channel
 */
function createTelemetryItem(item, baseType, envelopeName, logger, customProperties, systemProperties) {
    var _a;
    envelopeName = dataSanitizeString(logger, envelopeName) || strNotSpecified;
    if (isNullOrUndefined(item) ||
        isNullOrUndefined(baseType) ||
        isNullOrUndefined(envelopeName)) {
        throwError("Input doesn't contain all required fields");
    }
    var iKey = "";
    if (item[strIkey]) {
        iKey = item[strIkey];
        delete item[strIkey];
    }
    var telemetryItem = (_a = {},
        _a[_DYN_NAME$2 /* @min:name */] = envelopeName,
        _a.time = toISOString(new Date()),
        _a.iKey = iKey,
        _a.ext = systemProperties ? systemProperties : {},
        _a.tags = [],
        _a.data = {},
        _a.baseType = baseType,
        _a.baseData = item // Part B
    ,
        _a);
    // Part C
    if (!isNullOrUndefined(customProperties)) {
        objForEachKey(customProperties, function (prop, value) {
            telemetryItem.data[prop] = value;
        });
    }
    return telemetryItem;
}

/*
 * Application Insights JavaScript SDK - Common, 3.0.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */
var Extensions = {
    UserExt: "user",
    DeviceExt: "device",
    TraceExt: "trace",
    WebExt: "web",
    AppExt: "app",
    OSExt: "os",
    SessionExt: "ses",
    SDKExt: "sdk"
};
var CtxTagKeys = new ContextTagKeys();

/*
 * Application Insights JavaScript SDK - Common, 3.0.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */

function createDomEvent(eventName) {
    var event = null;
    if (isFunction(Event)) { // Use Event constructor when available
        event = new Event(eventName);
    }
    else { // Event has no constructor in IE
        var doc = getDocument();
        if (doc && doc.createEvent) {
            event = doc.createEvent("Event");
            event.initEvent(eventName, true, true);
        }
    }
    return event;
}

/*
 * Application Insights JavaScript SDK - Common, 3.0.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */

var PropertiesPluginIdentifier = "AppInsightsPropertiesPlugin";
var BreezeChannelIdentifier = "AppInsightsChannelPlugin";
var AnalyticsPluginIdentifier = "ApplicationInsightsAnalytics";

/*
 * Application Insights JavaScript SDK - Web Analytics, 3.0.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


// @skip-file-minify
// ##############################################################
// AUTO GENERATED FILE: This file is Auto Generated during build.
// ##############################################################
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
// Note: DON'T Export these const from the package as we are still targeting ES3 this will export a mutable variables that someone could change!!!
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
var _DYN_TO_STRING$1 = "toString"; // Count: 4
var _DYN_IS_STORAGE_USE_DISAB0 = "isStorageUseDisabled"; // Count: 3
var _DYN__ADD_HOOK$1 = "_addHook"; // Count: 6
var _DYN_CORE$1 = "core"; // Count: 7
var _DYN_DATA_TYPE$1 = "dataType"; // Count: 8
var _DYN_ENVELOPE_TYPE$1 = "envelopeType"; // Count: 7
var _DYN_DIAG_LOG$1 = "diagLog"; // Count: 13
var _DYN_TRACK = "track"; // Count: 7
var _DYN_TRACK_PAGE_VIEW = "trackPageView"; // Count: 4
var _DYN_TRACK_PREVIOUS_PAGE_1 = "trackPreviousPageVisit"; // Count: 3
var _DYN_SEND_PAGE_VIEW_INTER2 = "sendPageViewInternal"; // Count: 7
var _DYN_GET_ENTRIES_BY_TYPE = "getEntriesByType"; // Count: 5
var _DYN_START_TIME$1 = "startTime"; // Count: 4
var _DYN_DURATION = "duration"; // Count: 11
var _DYN_SEND_PAGE_VIEW_PERFO3 = "sendPageViewPerformanceInternal"; // Count: 3
var _DYN_POPULATE_PAGE_VIEW_P4 = "populatePageViewPerformanceEvent"; // Count: 3
var _DYN_HREF = "href"; // Count: 6
var _DYN_SEND_EXCEPTION_INTER5 = "sendExceptionInternal"; // Count: 2
var _DYN_EXCEPTION$1 = "exception"; // Count: 3
var _DYN_ERROR = "error"; // Count: 5
var _DYN__ONERROR = "_onerror"; // Count: 3
var _DYN_ERROR_SRC = "errorSrc"; // Count: 3
var _DYN_LINE_NUMBER = "lineNumber"; // Count: 5
var _DYN_COLUMN_NUMBER = "columnNumber"; // Count: 5
var _DYN_MESSAGE = "message"; // Count: 4
var _DYN__CREATE_AUTO_EXCEPTI6 = "CreateAutoException"; // Count: 3
var _DYN_ADD_TELEMETRY_INITIA7 = "addTelemetryInitializer"; // Count: 4
var _DYN_OVERRIDE_PAGE_VIEW_D8 = "overridePageViewDuration"; // Count: 2
var _DYN_AUTO_TRACK_PAGE_VISI9 = "autoTrackPageVisitTime"; // Count: 2
var _DYN_IS_BROWSER_LINK_TRAC10 = "isBrowserLinkTrackingEnabled"; // Count: 2
var _DYN_LENGTH$3 = "length"; // Count: 5
var _DYN_ENABLE_AUTO_ROUTE_TR11 = "enableAutoRouteTracking"; // Count: 2
var _DYN_ENABLE_UNHANDLED_PRO12 = "enableUnhandledPromiseRejectionTracking"; // Count: 2
var _DYN_AUTO_UNHANDLED_PROMI13 = "autoUnhandledPromiseInstrumented"; // Count: 3
var _DYN_IS_PERFORMANCE_TIMIN14 = "isPerformanceTimingSupported"; // Count: 2
var _DYN_GET_PERFORMANCE_TIMI15 = "getPerformanceTiming"; // Count: 2
var _DYN_NAVIGATION_START = "navigationStart"; // Count: 4
var _DYN_SHOULD_COLLECT_DURAT16 = "shouldCollectDuration"; // Count: 3
var _DYN_IS_PERFORMANCE_TIMIN17 = "isPerformanceTimingDataReady"; // Count: 2
var _DYN_RESPONSE_START = "responseStart"; // Count: 5
var _DYN_REQUEST_START = "requestStart"; // Count: 3
var _DYN_LOAD_EVENT_END = "loadEventEnd"; // Count: 4
var _DYN_RESPONSE_END = "responseEnd"; // Count: 5
var _DYN_CONNECT_END = "connectEnd"; // Count: 4
var _DYN_PAGE_VISIT_START_TIM18 = "pageVisitStartTime"; // Count: 2

/*
 * Application Insights JavaScript SDK - Web Analytics, 3.0.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */

/**
 * Class encapsulates sending page views and page view performance telemetry.
 */
var PageViewManager = /** @class */ (function () {
    function PageViewManager(appInsights, overridePageViewDuration, core, pageViewPerformanceManager) {
        dynamicProto(PageViewManager, this, function (_self) {
            var queueTimer = null;
            var itemQueue = [];
            var pageViewPerformanceSent = false;
            var _logger;
            if (core) {
                _logger = core.logger;
            }
            function _flushChannels(isAsync) {
                if (core) {
                    core.flush(isAsync, function () {
                        // Event flushed, callback added to prevent promise creation
                    });
                }
            }
            function _startTimer() {
                if (!queueTimer) {
                    queueTimer = scheduleTimeout((function () {
                        queueTimer = null;
                        var allItems = itemQueue.slice(0);
                        var doFlush = false;
                        itemQueue = [];
                        arrForEach(allItems, function (item) {
                            if (!item()) {
                                // Not processed so rescheduled
                                itemQueue.push(item);
                            }
                            else {
                                doFlush = true;
                            }
                        });
                        if (itemQueue[_DYN_LENGTH$3 /* @min:%2elength */] > 0) {
                            _startTimer();
                        }
                        if (doFlush) {
                            // We process at least one item so flush the queue
                            _flushChannels(true);
                        }
                    }), 100);
                }
            }
            function _addQueue(cb) {
                itemQueue.push(cb);
                _startTimer();
            }
            _self[_DYN_TRACK_PAGE_VIEW /* @min:%2etrackPageView */] = function (pageView, customProperties) {
                var name = pageView.name;
                if (isNullOrUndefined(name) || typeof name !== "string") {
                    var doc = getDocument();
                    name = pageView.name = doc && doc.title || "";
                }
                var uri = pageView.uri;
                if (isNullOrUndefined(uri) || typeof uri !== "string") {
                    var location_1 = getLocation();
                    uri = pageView.uri = location_1 && location_1[_DYN_HREF /* @min:%2ehref */] || "";
                }
                // case 1a. if performance timing is not supported by the browser, send the page view telemetry with the duration provided by the user. If the user
                // do not provide the duration, set duration to undefined
                // Also this is case 4
                if (!pageViewPerformanceManager[_DYN_IS_PERFORMANCE_TIMIN14 /* @min:%2eisPerformanceTimingSupported */]()) {
                    appInsights[_DYN_SEND_PAGE_VIEW_INTER2 /* @min:%2esendPageViewInternal */](pageView, customProperties);
                    _flushChannels(true);
                    if (!isWebWorker()) {
                        // no navigation timing (IE 8, iOS Safari 8.4, Opera Mini 8 - see http://caniuse.com/#feat=nav-timing)
                        _throwInternal(_logger, 2 /* eLoggingSeverity.WARNING */, 25 /* _eInternalMessageId.NavigationTimingNotSupported */, "trackPageView: navigation timing API used for calculation of page duration is not supported in this browser. This page view will be collected without duration and timing info.");
                    }
                    return;
                }
                var pageViewSent = false;
                var customDuration;
                // if the performance timing is supported by the browser, calculate the custom duration
                var start = pageViewPerformanceManager[_DYN_GET_PERFORMANCE_TIMI15 /* @min:%2egetPerformanceTiming */]()[_DYN_NAVIGATION_START /* @min:%2enavigationStart */];
                if (start > 0) {
                    customDuration = dateTimeUtilsDuration(start, +new Date);
                    if (!pageViewPerformanceManager[_DYN_SHOULD_COLLECT_DURAT16 /* @min:%2eshouldCollectDuration */](customDuration)) {
                        customDuration = undefined;
                    }
                }
                // if the user has provided duration, send a page view telemetry with the provided duration. Otherwise, if
                // overridePageViewDuration is set to true, send a page view telemetry with the custom duration calculated earlier
                var duration;
                if (!isNullOrUndefined(customProperties) &&
                    !isNullOrUndefined(customProperties[_DYN_DURATION /* @min:%2eduration */])) {
                    duration = customProperties[_DYN_DURATION /* @min:%2eduration */];
                }
                if (overridePageViewDuration || !isNaN(duration)) {
                    if (isNaN(duration)) {
                        // case 3
                        if (!customProperties) {
                            customProperties = {};
                        }
                        customProperties[_DYN_DURATION /* @min:%2eduration */] = customDuration;
                    }
                    // case 2
                    appInsights[_DYN_SEND_PAGE_VIEW_INTER2 /* @min:%2esendPageViewInternal */](pageView, customProperties);
                    _flushChannels(true);
                    pageViewSent = true;
                }
                // now try to send the page view performance telemetry
                var maxDurationLimit = 60000;
                if (!customProperties) {
                    customProperties = {};
                }
                // Queue the event for processing
                _addQueue(function () {
                    var processed = false;
                    try {
                        if (pageViewPerformanceManager[_DYN_IS_PERFORMANCE_TIMIN17 /* @min:%2eisPerformanceTimingDataReady */]()) {
                            processed = true;
                            var pageViewPerformance = {
                                name: name,
                                uri: uri
                            };
                            pageViewPerformanceManager[_DYN_POPULATE_PAGE_VIEW_P4 /* @min:%2epopulatePageViewPerformanceEvent */](pageViewPerformance);
                            if (!pageViewPerformance.isValid && !pageViewSent) {
                                // If navigation timing gives invalid numbers, then go back to "override page view duration" mode.
                                // That's the best value we can get that makes sense.
                                customProperties[_DYN_DURATION /* @min:%2eduration */] = customDuration;
                                appInsights[_DYN_SEND_PAGE_VIEW_INTER2 /* @min:%2esendPageViewInternal */](pageView, customProperties);
                            }
                            else {
                                if (!pageViewSent) {
                                    customProperties[_DYN_DURATION /* @min:%2eduration */] = pageViewPerformance.durationMs;
                                    appInsights[_DYN_SEND_PAGE_VIEW_INTER2 /* @min:%2esendPageViewInternal */](pageView, customProperties);
                                }
                                if (!pageViewPerformanceSent) {
                                    appInsights[_DYN_SEND_PAGE_VIEW_PERFO3 /* @min:%2esendPageViewPerformanceInternal */](pageViewPerformance, customProperties);
                                    pageViewPerformanceSent = true;
                                }
                            }
                        }
                        else if (start > 0 && dateTimeUtilsDuration(start, +new Date) > maxDurationLimit) {
                            // if performance timings are not ready but we exceeded the maximum duration limit, just log a page view telemetry
                            // with the maximum duration limit. Otherwise, keep waiting until performance timings are ready
                            processed = true;
                            if (!pageViewSent) {
                                customProperties[_DYN_DURATION /* @min:%2eduration */] = maxDurationLimit;
                                appInsights[_DYN_SEND_PAGE_VIEW_INTER2 /* @min:%2esendPageViewInternal */](pageView, customProperties);
                            }
                        }
                    }
                    catch (e) {
                        _throwInternal(_logger, 1 /* eLoggingSeverity.CRITICAL */, 38 /* _eInternalMessageId.TrackPVFailedCalc */, "trackPageView failed on page load calculation: " + getExceptionName(e), { exception: dumpObj(e) });
                    }
                    return processed;
                });
            };
            _self.teardown = function (unloadCtx, unloadState) {
                if (queueTimer) {
                    queueTimer.cancel();
                    queueTimer = null;
                    var allItems = itemQueue.slice(0);
                    itemQueue = [];
                    arrForEach(allItems, function (item) {
                        if (item()) ;
                    });
                }
            };
        });
    }
// Removed Stub for PageViewManager.prototype.trackPageView.
// Removed Stub for PageViewManager.prototype.teardown.
    // This is a workaround for an IE bug when using dynamicProto() with classes that don't have any
    // non-dynamic functions or static properties/functions when using uglify-js to minify the resulting code.
    PageViewManager.__ieDyn=1;

    return PageViewManager;
}());

/*
 * Application Insights JavaScript SDK - Web Analytics, 3.0.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */

var MAX_DURATION_ALLOWED = 3600000; // 1h
var botAgentNames = ["googlebot", "adsbot-google", "apis-google", "mediapartners-google"];
function _isPerformanceTimingSupported() {
    var perf = getPerformance();
    return perf && !!perf.timing;
}
function _isPerformanceNavigationTimingSupported() {
    var perf = getPerformance();
    return perf && perf[_DYN_GET_ENTRIES_BY_TYPE /* @min:%2egetEntriesByType */] && perf[_DYN_GET_ENTRIES_BY_TYPE /* @min:%2egetEntriesByType */]("navigation")[_DYN_LENGTH$3 /* @min:%2elength */] > 0;
}
function _isPerformanceTimingDataReady() {
    var perf = getPerformance();
    var timing = perf ? perf.timing : 0;
    return timing
        && timing.domainLookupStart > 0
        && timing[_DYN_NAVIGATION_START /* @min:%2enavigationStart */] > 0
        && timing[_DYN_RESPONSE_START /* @min:%2eresponseStart */] > 0
        && timing[_DYN_REQUEST_START /* @min:%2erequestStart */] > 0
        && timing[_DYN_LOAD_EVENT_END /* @min:%2eloadEventEnd */] > 0
        && timing[_DYN_RESPONSE_END /* @min:%2eresponseEnd */] > 0
        && timing[_DYN_CONNECT_END /* @min:%2econnectEnd */] > 0
        && timing.domLoading > 0;
}
function _getPerformanceTiming() {
    if (_isPerformanceTimingSupported()) {
        return getPerformance().timing;
    }
    return null;
}
function _getPerformanceNavigationTiming() {
    if (_isPerformanceNavigationTimingSupported()) {
        return getPerformance()[_DYN_GET_ENTRIES_BY_TYPE /* @min:%2egetEntriesByType */]("navigation")[0];
    }
    return null;
}
/**
* This method tells if given durations should be excluded from collection.
*/
function _shouldCollectDuration() {
    var durations = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        durations[_i] = arguments[_i];
    }
    var _navigator = getNavigator() || {};
    // a full list of Google crawlers user agent strings - https://support.google.com/webmasters/answer/1061943?hl=en
    var userAgent = _navigator.userAgent;
    var isGoogleBot = false;
    if (userAgent) {
        for (var i = 0; i < botAgentNames[_DYN_LENGTH$3 /* @min:%2elength */]; i++) {
            isGoogleBot = isGoogleBot || strIndexOf(userAgent.toLowerCase(), botAgentNames[i]) !== -1;
        }
    }
    if (isGoogleBot) {
        // Don't report durations for GoogleBot, it is returning invalid values in performance.timing API.
        return false;
    }
    else {
        // for other page views, don't report if it's outside of a reasonable range
        for (var i = 0; i < durations[_DYN_LENGTH$3 /* @min:%2elength */]; i++) {
            if (durations[i] < 0 || durations[i] >= MAX_DURATION_ALLOWED) {
                return false;
            }
        }
    }
    return true;
}
/**
 * Class encapsulates sending page view performance telemetry.
 */
var PageViewPerformanceManager = /** @class */ (function () {
    function PageViewPerformanceManager(core) {
        var _logger = safeGetLogger(core);
        dynamicProto(PageViewPerformanceManager, this, function (_self) {
            _self[_DYN_POPULATE_PAGE_VIEW_P4 /* @min:%2epopulatePageViewPerformanceEvent */] = function (pageViewPerformance) {
                pageViewPerformance.isValid = false;
                /*
                 * http://www.w3.org/TR/navigation-timing/#processing-model
                 *  |-navigationStart
                 *  |             |-connectEnd
                 *  |             ||-requestStart
                 *  |             ||             |-responseStart
                 *  |             ||             |              |-responseEnd
                 *  |             ||             |              |
                 *  |             ||             |              |         |-loadEventEnd
                 *  |---network---||---request---|---response---|---dom---|
                 *  |--------------------------total----------------------|
                 *
                 *  total = The difference between the load event of the current document is completed and the first recorded timestamp of the performance entry : https://developer.mozilla.org/en-US/docs/Web/Performance/Navigation_and_resource_timings#duration
                 *  network = Redirect time + App Cache + DNS lookup time + TCP connection time
                 *  request = Request time : https://developer.mozilla.org/en-US/docs/Web/Performance/Navigation_and_resource_timings#request_time
                 *  response = Response time
                 *  dom = Document load time : https://html.spec.whatwg.org/multipage/dom.html#document-load-timing-info
                 *      = Document processing time : https://developers.google.com/web/fundamentals/performance/navigation-and-resource-timing/#document_processing
                 *      + Loading time : https://developers.google.com/web/fundamentals/performance/navigation-and-resource-timing/#loading
                 */
                var navigationTiming = _getPerformanceNavigationTiming();
                var timing = _getPerformanceTiming();
                var total = 0;
                var network = 0;
                var request = 0;
                var response = 0;
                var dom = 0;
                if (navigationTiming || timing) {
                    if (navigationTiming) {
                        total = navigationTiming[_DYN_DURATION /* @min:%2eduration */];
                        /**
                         * support both cases:
                         * - startTime is always zero: https://developer.mozilla.org/en-US/docs/Web/API/PerformanceNavigationTiming
                         * - for older browsers where the startTime is not zero
                         */
                        network = navigationTiming[_DYN_START_TIME$1 /* @min:%2estartTime */] === 0 ? navigationTiming[_DYN_CONNECT_END /* @min:%2econnectEnd */] : dateTimeUtilsDuration(navigationTiming[_DYN_START_TIME$1 /* @min:%2estartTime */], navigationTiming[_DYN_CONNECT_END /* @min:%2econnectEnd */]);
                        request = dateTimeUtilsDuration(navigationTiming.requestStart, navigationTiming[_DYN_RESPONSE_START /* @min:%2eresponseStart */]);
                        response = dateTimeUtilsDuration(navigationTiming[_DYN_RESPONSE_START /* @min:%2eresponseStart */], navigationTiming[_DYN_RESPONSE_END /* @min:%2eresponseEnd */]);
                        dom = dateTimeUtilsDuration(navigationTiming.responseEnd, navigationTiming[_DYN_LOAD_EVENT_END /* @min:%2eloadEventEnd */]);
                    }
                    else {
                        total = dateTimeUtilsDuration(timing[_DYN_NAVIGATION_START /* @min:%2enavigationStart */], timing[_DYN_LOAD_EVENT_END /* @min:%2eloadEventEnd */]);
                        network = dateTimeUtilsDuration(timing[_DYN_NAVIGATION_START /* @min:%2enavigationStart */], timing[_DYN_CONNECT_END /* @min:%2econnectEnd */]);
                        request = dateTimeUtilsDuration(timing.requestStart, timing[_DYN_RESPONSE_START /* @min:%2eresponseStart */]);
                        response = dateTimeUtilsDuration(timing[_DYN_RESPONSE_START /* @min:%2eresponseStart */], timing[_DYN_RESPONSE_END /* @min:%2eresponseEnd */]);
                        dom = dateTimeUtilsDuration(timing.responseEnd, timing[_DYN_LOAD_EVENT_END /* @min:%2eloadEventEnd */]);
                    }
                    if (total === 0) {
                        _throwInternal(_logger, 2 /* eLoggingSeverity.WARNING */, 10 /* _eInternalMessageId.ErrorPVCalc */, "error calculating page view performance.", { total: total, network: network, request: request, response: response, dom: dom });
                    }
                    else if (!_self[_DYN_SHOULD_COLLECT_DURAT16 /* @min:%2eshouldCollectDuration */](total, network, request, response, dom)) {
                        _throwInternal(_logger, 2 /* eLoggingSeverity.WARNING */, 45 /* _eInternalMessageId.InvalidDurationValue */, "Invalid page load duration value. Browser perf data won't be sent.", { total: total, network: network, request: request, response: response, dom: dom });
                    }
                    else if (total < Math.floor(network) + Math.floor(request) + Math.floor(response) + Math.floor(dom)) {
                        // some browsers may report individual components incorrectly so that the sum of the parts will be bigger than total PLT
                        // in this case, don't report client performance from this page
                        _throwInternal(_logger, 2 /* eLoggingSeverity.WARNING */, 8 /* _eInternalMessageId.ClientPerformanceMathError */, "client performance math error.", { total: total, network: network, request: request, response: response, dom: dom });
                    }
                    else {
                        pageViewPerformance.durationMs = total;
                        // // convert to timespans
                        pageViewPerformance.perfTotal = pageViewPerformance[_DYN_DURATION /* @min:%2eduration */] = msToTimeSpan(total);
                        pageViewPerformance.networkConnect = msToTimeSpan(network);
                        pageViewPerformance.sentRequest = msToTimeSpan(request);
                        pageViewPerformance.receivedResponse = msToTimeSpan(response);
                        pageViewPerformance.domProcessing = msToTimeSpan(dom);
                        pageViewPerformance.isValid = true;
                    }
                }
            };
            _self[_DYN_GET_PERFORMANCE_TIMI15 /* @min:%2egetPerformanceTiming */] = _getPerformanceTiming;
            _self[_DYN_IS_PERFORMANCE_TIMIN14 /* @min:%2eisPerformanceTimingSupported */] = _isPerformanceTimingSupported;
            _self[_DYN_IS_PERFORMANCE_TIMIN17 /* @min:%2eisPerformanceTimingDataReady */] = _isPerformanceTimingDataReady;
            _self[_DYN_SHOULD_COLLECT_DURAT16 /* @min:%2eshouldCollectDuration */] = _shouldCollectDuration;
        });
    }
// Removed Stub for PageViewPerformanceManager.prototype.populatePageViewPerformanceEvent.
// Removed Stub for PageViewPerformanceManager.prototype.getPerformanceTiming.
// Removed Stub for PageViewPerformanceManager.prototype.isPerformanceTimingSupported.
// Removed Stub for PageViewPerformanceManager.prototype.isPerformanceTimingDataReady.
// Removed Stub for PageViewPerformanceManager.prototype.shouldCollectDuration.
    // This is a workaround for an IE bug when using dynamicProto() with classes that don't have any
    // non-dynamic functions or static properties/functions when using uglify-js to minify the resulting code.
    PageViewPerformanceManager.__ieDyn=1;

    return PageViewPerformanceManager;
}());

/*
 * Application Insights JavaScript SDK - Web Analytics, 3.0.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */

/**
 * Used to track page visit durations
 */
var PageVisitTimeManager = /** @class */ (function () {
    /**
     * Creates a new instance of PageVisitTimeManager
     * @param pageVisitTimeTrackingHandler - Delegate that will be called to send telemetry data to AI (when trackPreviousPageVisit is called)
     * @returns {}
     */
    function PageVisitTimeManager(logger, pageVisitTimeTrackingHandler) {
        var prevPageVisitDataKeyName = "prevPageVisitData";
        dynamicProto(PageVisitTimeManager, this, function (_self) {
            _self[_DYN_TRACK_PREVIOUS_PAGE_1 /* @min:%2etrackPreviousPageVisit */] = function (currentPageName, currentPageUrl) {
                try {
                    // Restart timer for new page view
                    var prevPageVisitTimeData = restartPageVisitTimer(currentPageName, currentPageUrl);
                    // If there was a page already being timed, track the visit time for it now.
                    if (prevPageVisitTimeData) {
                        pageVisitTimeTrackingHandler(prevPageVisitTimeData.pageName, prevPageVisitTimeData.pageUrl, prevPageVisitTimeData.pageVisitTime);
                    }
                }
                catch (e) {
                    _warnToConsole(logger, "Auto track page visit time failed, metric will not be collected: " + dumpObj(e));
                }
            };
            /**
             * Stops timing of current page (if exists) and starts timing for duration of visit to pageName
             * @param pageName - Name of page to begin timing visit duration
             * @returns {PageVisitData} Page visit data (including duration) of pageName from last call to start or restart, if exists. Null if not.
             */
            function restartPageVisitTimer(pageName, pageUrl) {
                var prevPageVisitData = null;
                try {
                    prevPageVisitData = stopPageVisitTimer();
                    if (utlCanUseSessionStorage()) {
                        if (utlGetSessionStorage(logger, prevPageVisitDataKeyName) != null) {
                            throwError("Cannot call startPageVisit consecutively without first calling stopPageVisit");
                        }
                        var currPageVisitDataStr = getJSON().stringify(new PageVisitData(pageName, pageUrl));
                        utlSetSessionStorage(logger, prevPageVisitDataKeyName, currPageVisitDataStr);
                    }
                }
                catch (e) {
                    _warnToConsole(logger, "Call to restart failed: " + dumpObj(e));
                    prevPageVisitData = null;
                }
                return prevPageVisitData;
            }
            /**
             * Stops timing of current page, if exists.
             * @returns {PageVisitData} Page visit data (including duration) of pageName from call to start, if exists. Null if not.
             */
            function stopPageVisitTimer() {
                var prevPageVisitData = null;
                try {
                    if (utlCanUseSessionStorage()) {
                        // Define end time of page's visit
                        var pageVisitEndTime = utcNow();
                        // Try to retrieve  page name and start time from session storage
                        var pageVisitDataJsonStr = utlGetSessionStorage(logger, prevPageVisitDataKeyName);
                        if (pageVisitDataJsonStr && hasJSON()) {
                            // if previous page data exists, set end time of visit
                            prevPageVisitData = getJSON().parse(pageVisitDataJsonStr);
                            prevPageVisitData.pageVisitTime = pageVisitEndTime - prevPageVisitData[_DYN_PAGE_VISIT_START_TIM18 /* @min:%2epageVisitStartTime */];
                            // Remove data from storage since we already used it
                            utlRemoveSessionStorage(logger, prevPageVisitDataKeyName);
                        }
                    }
                }
                catch (e) {
                    _warnToConsole(logger, "Stop page visit timer failed: " + dumpObj(e));
                    prevPageVisitData = null;
                }
                return prevPageVisitData;
            }
            // For backward compatibility
            objDefine(_self, "_logger", { g: function () { return logger; } });
            objDefine(_self, "pageVisitTimeTrackingHandler", { g: function () { return pageVisitTimeTrackingHandler; } });
        });
    }
// Removed Stub for PageVisitTimeManager.prototype.trackPreviousPageVisit.
    // This is a workaround for an IE bug when using dynamicProto() with classes that don't have any
    // non-dynamic functions or static properties/functions when using uglify-js to minify the resulting code.
    PageVisitTimeManager.__ieDyn=1;

    return PageVisitTimeManager;
}());
var PageVisitData = /** @class */ (function () {
    function PageVisitData(pageName, pageUrl) {
        this[_DYN_PAGE_VISIT_START_TIM18 /* @min:%2epageVisitStartTime */] = utcNow();
        this.pageName = pageName;
        this.pageUrl = pageUrl;
    }
    return PageVisitData;
}());

/*
 * Application Insights JavaScript SDK - Web Analytics, 3.0.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */

/**
 * Used to record timed events and page views.
 */
var Timing = /** @class */ (function () {
    function Timing(logger, name) {
        var _self = this;
        var _events = {};
        _self.start = function (name) {
            if (typeof _events[name] !== "undefined") {
                _throwInternal(logger, 2 /* eLoggingSeverity.WARNING */, 62 /* _eInternalMessageId.StartCalledMoreThanOnce */, "start was called more than once for this event without calling stop.", { name: name, key: name }, true);
            }
            _events[name] = +new Date;
        };
        _self.stop = function (name, url, properties, measurements) {
            var start = _events[name];
            if (isNaN(start)) {
                _throwInternal(logger, 2 /* eLoggingSeverity.WARNING */, 63 /* _eInternalMessageId.StopCalledWithoutStart */, "stop was called without a corresponding start.", { name: name, key: name }, true);
            }
            else {
                var end = +new Date;
                var duration = dateTimeUtilsDuration(start, end);
                _self.action(name, url, duration, properties, measurements);
            }
            delete _events[name];
            _events[name] = undefined;
        };
    }
    return Timing;
}());

/*
 * Application Insights JavaScript SDK - Web Analytics, 3.0.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */
/**
* ApplicationInsights.ts
* @copyright Microsoft 2018
*/
var _a$6;
var strEvent = "event";
function _dispatchEvent(target, evnt) {
    if (target && target.dispatchEvent && evnt) {
        target.dispatchEvent(evnt);
    }
}
function _getReason(error) {
    if (error && error.reason) {
        var reason = error.reason;
        if (!isString(reason) && isFunction(reason[_DYN_TO_STRING$1 /* @min:%2etoString */])) {
            return reason[_DYN_TO_STRING$1 /* @min:%2etoString */]();
        }
        return dumpObj(reason);
    }
    // Pass the original object down which will eventually get evaluated for any message or description
    return error || "";
}
var MinMilliSeconds = 60000;
var defaultValues = objDeepFreeze((_a$6 = {
        sessionRenewalMs: cfgDfSet(_chkConfigMilliseconds, 30 * 60 * 1000),
        sessionExpirationMs: cfgDfSet(_chkConfigMilliseconds, 24 * 60 * 60 * 1000),
        disableExceptionTracking: cfgDfBoolean()
    },
    _a$6[_DYN_AUTO_TRACK_PAGE_VISI9 /* @min:autoTrackPageVisitTime */] = cfgDfBoolean(),
    _a$6[_DYN_OVERRIDE_PAGE_VIEW_D8 /* @min:overridePageViewDuration */] = cfgDfBoolean(),
    _a$6[_DYN_ENABLE_UNHANDLED_PRO12 /* @min:enableUnhandledPromiseRejectionTracking */] = cfgDfBoolean(),
    _a$6[_DYN_AUTO_UNHANDLED_PROMI13 /* @min:autoUnhandledPromiseInstrumented */] = false,
    _a$6.samplingPercentage = cfgDfValidate(_chkSampling$1, 100),
    _a$6[_DYN_IS_STORAGE_USE_DISAB0 /* @min:isStorageUseDisabled */] = cfgDfBoolean(),
    _a$6[_DYN_IS_BROWSER_LINK_TRAC10 /* @min:isBrowserLinkTrackingEnabled */] = cfgDfBoolean(),
    _a$6[_DYN_ENABLE_AUTO_ROUTE_TR11 /* @min:enableAutoRouteTracking */] = cfgDfBoolean(),
    _a$6.namePrefix = cfgDfString(),
    _a$6.enableDebug = cfgDfBoolean(),
    _a$6.disableFlushOnBeforeUnload = cfgDfBoolean(),
    _a$6.disableFlushOnUnload = cfgDfBoolean(false, "disableFlushOnBeforeUnload"),
    _a$6));
function _chkConfigMilliseconds(value, defValue) {
    value = value || defValue;
    if (value < MinMilliSeconds) {
        value = MinMilliSeconds;
    }
    return +value;
}
function _chkSampling$1(value) {
    return !isNaN(value) && value > 0 && value <= 100;
}
function _updateStorageUsage(extConfig) {
    // Not resetting the storage usage as someone may have manually called utlDisableStorage, so this will only
    // reset based if the configuration option is provided
    if (!isUndefined(extConfig[_DYN_IS_STORAGE_USE_DISAB0 /* @min:%2eisStorageUseDisabled */])) {
        if (extConfig[_DYN_IS_STORAGE_USE_DISAB0 /* @min:%2eisStorageUseDisabled */]) {
            utlDisableStorage();
        }
        else {
            utlEnableStorage();
        }
    }
}
var AnalyticsPlugin = /** @class */ (function (_super) {
    __extendsFn(AnalyticsPlugin, _super);
    function AnalyticsPlugin() {
        var _this = _super.call(this) || this;
        _this.identifier = AnalyticsPluginIdentifier; // do not change name or priority
        _this.priority = 180; // take from reserved priority range 100- 200
        _this.autoRoutePVDelay = 500; // ms; Time to wait after a route change before triggering a pageview to allow DOM changes to take place
        var _eventTracking;
        var _pageTracking;
        var _pageViewManager;
        var _pageViewPerformanceManager;
        var _pageVisitTimeManager;
        var _preInitTelemetryInitializers;
        var _isBrowserLinkTrackingEnabled;
        var _browserLinkInitializerAdded;
        var _enableAutoRouteTracking;
        var _historyListenerAdded;
        var _disableExceptionTracking;
        var _autoExceptionInstrumented;
        var _enableUnhandledPromiseRejectionTracking;
        var _autoUnhandledPromiseInstrumented;
        var _extConfig;
        var _autoTrackPageVisitTime;
        // array with max length of 2 that store current url and previous url for SPA page route change trackPageview use.
        var _prevUri; // Assigned in the constructor
        var _currUri;
        var _evtNamespace;
        dynamicProto(AnalyticsPlugin, _this, function (_self, _base) {
            var _addHook = _base[_DYN__ADD_HOOK$1 /* @min:%2e_addHook */];
            _initDefaults();
            _self.getCookieMgr = function () {
                return safeGetCookieMgr(_self[_DYN_CORE$1 /* @min:%2ecore */]);
            };
            _self.processTelemetry = function (env, itemCtx) {
                _self.processNext(env, itemCtx);
            };
            _self.trackEvent = function (event, customProperties) {
                try {
                    var telemetryItem = createTelemetryItem(event, Event$1[_DYN_DATA_TYPE$1 /* @min:%2edataType */], Event$1[_DYN_ENVELOPE_TYPE$1 /* @min:%2eenvelopeType */], _self[_DYN_DIAG_LOG$1 /* @min:%2ediagLog */](), customProperties);
                    _self[_DYN_CORE$1 /* @min:%2ecore */][_DYN_TRACK /* @min:%2etrack */](telemetryItem);
                }
                catch (e) {
                    _throwInternal(2 /* eLoggingSeverity.WARNING */, 39 /* _eInternalMessageId.TrackTraceFailed */, "trackTrace failed, trace will not be collected: " + getExceptionName(e), { exception: dumpObj(e) });
                }
            };
            /**
             * Start timing an extended event. Call `stopTrackEvent` to log the event when it ends.
             * @param   name    A string that identifies this event uniquely within the document.
             */
            _self.startTrackEvent = function (name) {
                try {
                    _eventTracking.start(name);
                }
                catch (e) {
                    _throwInternal(1 /* eLoggingSeverity.CRITICAL */, 29 /* _eInternalMessageId.StartTrackEventFailed */, "startTrackEvent failed, event will not be collected: " + getExceptionName(e), { exception: dumpObj(e) });
                }
            };
            /**
             * Log an extended event that you started timing with `startTrackEvent`.
             * @param   name    The string you used to identify this event in `startTrackEvent`.
             * @param   properties  map[string, string] - additional data used to filter events and metrics in the portal. Defaults to empty.
             * @param   measurements    map[string, number] - metrics associated with this event, displayed in Metrics Explorer on the portal. Defaults to empty.
             */
            _self.stopTrackEvent = function (name, properties, measurements) {
                try {
                    _eventTracking.stop(name, undefined, properties, measurements);
                }
                catch (e) {
                    _throwInternal(1 /* eLoggingSeverity.CRITICAL */, 30 /* _eInternalMessageId.StopTrackEventFailed */, "stopTrackEvent failed, event will not be collected: " + getExceptionName(e), { exception: dumpObj(e) });
                }
            };
            /**
             * @description Log a diagnostic message
             * @param trace
             * @param ICustomProperties.
             * @memberof ApplicationInsights
             */
            _self.trackTrace = function (trace, customProperties) {
                try {
                    var telemetryItem = createTelemetryItem(trace, Trace[_DYN_DATA_TYPE$1 /* @min:%2edataType */], Trace[_DYN_ENVELOPE_TYPE$1 /* @min:%2eenvelopeType */], _self[_DYN_DIAG_LOG$1 /* @min:%2ediagLog */](), customProperties);
                    _self[_DYN_CORE$1 /* @min:%2ecore */][_DYN_TRACK /* @min:%2etrack */](telemetryItem);
                }
                catch (e) {
                    _throwInternal(2 /* eLoggingSeverity.WARNING */, 39 /* _eInternalMessageId.TrackTraceFailed */, "trackTrace failed, trace will not be collected: " + getExceptionName(e), { exception: dumpObj(e) });
                }
            };
            /**
             * @description Log a numeric value that is not associated with a specific event. Typically
             * used to send regular reports of performance indicators. To send single measurement, just
             * use the name and average fields of {@link IMetricTelemetry}. If you take measurements
             * frequently, you can reduce the telemetry bandwidth by aggregating multiple measurements
             * and sending the resulting average at intervals
             * @param metric - input object argument. Only name and average are mandatory.
             * @param } customProperties additional data used to filter metrics in the
             * portal. Defaults to empty.
             * @memberof ApplicationInsights
             */
            _self.trackMetric = function (metric, customProperties) {
                try {
                    var telemetryItem = createTelemetryItem(metric, Metric[_DYN_DATA_TYPE$1 /* @min:%2edataType */], Metric[_DYN_ENVELOPE_TYPE$1 /* @min:%2eenvelopeType */], _self[_DYN_DIAG_LOG$1 /* @min:%2ediagLog */](), customProperties);
                    _self[_DYN_CORE$1 /* @min:%2ecore */][_DYN_TRACK /* @min:%2etrack */](telemetryItem);
                }
                catch (e) {
                    _throwInternal(1 /* eLoggingSeverity.CRITICAL */, 36 /* _eInternalMessageId.TrackMetricFailed */, "trackMetric failed, metric will not be collected: " + getExceptionName(e), { exception: dumpObj(e) });
                }
            };
            /**
             * Logs that a page or other item was viewed.
             * @param IPageViewTelemetry - The string you used as the name in startTrackPage. Defaults to the document title.
             * @param customProperties - Additional data used to filter events and metrics. Defaults to empty.
             * If a user wants to provide duration for pageLoad, it'll have to be in pageView.properties.duration
             */
            _self[_DYN_TRACK_PAGE_VIEW /* @min:%2etrackPageView */] = function (pageView, customProperties) {
                try {
                    var inPv = pageView || {};
                    _pageViewManager[_DYN_TRACK_PAGE_VIEW /* @min:%2etrackPageView */](inPv, __assignFn(__assignFn(__assignFn({}, inPv.properties), inPv.measurements), customProperties));
                    if (_autoTrackPageVisitTime) {
                        _pageVisitTimeManager[_DYN_TRACK_PREVIOUS_PAGE_1 /* @min:%2etrackPreviousPageVisit */](inPv.name, inPv.uri);
                    }
                }
                catch (e) {
                    _throwInternal(1 /* eLoggingSeverity.CRITICAL */, 37 /* _eInternalMessageId.TrackPVFailed */, "trackPageView failed, page view will not be collected: " + getExceptionName(e), { exception: dumpObj(e) });
                }
            };
            /**
             * Create a page view telemetry item and send it to the SDK pipeline through the core.track API
             * @param pageView - Page view item to be sent
             * @param properties - Custom properties (Part C) that a user can add to the telemetry item
             * @param systemProperties - System level properties (Part A) that a user can add to the telemetry item
             */
            _self[_DYN_SEND_PAGE_VIEW_INTER2 /* @min:%2esendPageViewInternal */] = function (pageView, properties, systemProperties) {
                var doc = getDocument();
                if (doc) {
                    pageView.refUri = pageView.refUri === undefined ? doc.referrer : pageView.refUri;
                }
                var perf = getPerformance();
                // Access the performance timing object
                var navigationEntries = (perf && perf[_DYN_GET_ENTRIES_BY_TYPE /* @min:%2egetEntriesByType */] && perf[_DYN_GET_ENTRIES_BY_TYPE /* @min:%2egetEntriesByType */]("navigation"));
                // Edge Case the navigation Entries may return an empty array and the timeOrigin is not supported on IE
                if (navigationEntries && navigationEntries[0] && !isUndefined(perf.timeOrigin)) {
                    // Get the value of loadEventStart
                    var loadEventStart = navigationEntries[0].loadEventStart;
                    pageView[_DYN_START_TIME$1 /* @min:%2estartTime */] = new Date(perf.timeOrigin + loadEventStart);
                }
                else {
                    // calculate the start time manually
                    var duration = ((properties || pageView.properties || {})[_DYN_DURATION /* @min:%2eduration */] || 0);
                    pageView[_DYN_START_TIME$1 /* @min:%2estartTime */] = new Date(new Date().getTime() - duration);
                }
                var telemetryItem = createTelemetryItem(pageView, PageView[_DYN_DATA_TYPE$1 /* @min:%2edataType */], PageView[_DYN_ENVELOPE_TYPE$1 /* @min:%2eenvelopeType */], _self[_DYN_DIAG_LOG$1 /* @min:%2ediagLog */](), properties, systemProperties);
                _self[_DYN_CORE$1 /* @min:%2ecore */][_DYN_TRACK /* @min:%2etrack */](telemetryItem);
            };
            /**
             * @ignore INTERNAL ONLY
             * @param pageViewPerformance
             * @param properties
             */
            _self[_DYN_SEND_PAGE_VIEW_PERFO3 /* @min:%2esendPageViewPerformanceInternal */] = function (pageViewPerformance, properties, systemProperties) {
                var telemetryItem = createTelemetryItem(pageViewPerformance, PageViewPerformance[_DYN_DATA_TYPE$1 /* @min:%2edataType */], PageViewPerformance[_DYN_ENVELOPE_TYPE$1 /* @min:%2eenvelopeType */], _self[_DYN_DIAG_LOG$1 /* @min:%2ediagLog */](), properties, systemProperties);
                _self[_DYN_CORE$1 /* @min:%2ecore */][_DYN_TRACK /* @min:%2etrack */](telemetryItem);
            };
            /**
             * Send browser performance metrics.
             * @param pageViewPerformance
             * @param customProperties
             */
            _self.trackPageViewPerformance = function (pageViewPerformance, customProperties) {
                var inPvp = pageViewPerformance || {};
                try {
                    _pageViewPerformanceManager[_DYN_POPULATE_PAGE_VIEW_P4 /* @min:%2epopulatePageViewPerformanceEvent */](inPvp);
                    _self[_DYN_SEND_PAGE_VIEW_PERFO3 /* @min:%2esendPageViewPerformanceInternal */](inPvp, customProperties);
                }
                catch (e) {
                    _throwInternal(1 /* eLoggingSeverity.CRITICAL */, 37 /* _eInternalMessageId.TrackPVFailed */, "trackPageViewPerformance failed, page view will not be collected: " + getExceptionName(e), { exception: dumpObj(e) });
                }
            };
            /**
             * Starts the timer for tracking a page load time. Use this instead of `trackPageView` if you want to control when the page view timer starts and stops,
             * but don't want to calculate the duration yourself. This method doesn't send any telemetry. Call `stopTrackPage` to log the end of the page view
             * and send the event.
             * @param name - A string that idenfities this item, unique within this HTML document. Defaults to the document title.
             */
            _self.startTrackPage = function (name) {
                try {
                    if (typeof name !== "string") {
                        var doc = getDocument();
                        name = doc && doc.title || "";
                    }
                    _pageTracking.start(name);
                }
                catch (e) {
                    _throwInternal(1 /* eLoggingSeverity.CRITICAL */, 31 /* _eInternalMessageId.StartTrackFailed */, "startTrackPage failed, page view may not be collected: " + getExceptionName(e), { exception: dumpObj(e) });
                }
            };
            /**
             * Stops the timer that was started by calling `startTrackPage` and sends the pageview load time telemetry with the specified properties and measurements.
             * The duration of the page view will be the time between calling `startTrackPage` and `stopTrackPage`.
             * @param   name  The string you used as the name in startTrackPage. Defaults to the document title.
             * @param   url   String - a relative or absolute URL that identifies the page or other item. Defaults to the window location.
             * @param   properties  map[string, string] - additional data used to filter pages and metrics in the portal. Defaults to empty.
             * @param   measurements    map[string, number] - metrics associated with this page, displayed in Metrics Explorer on the portal. Defaults to empty.
             */
            _self.stopTrackPage = function (name, url, properties, measurement) {
                try {
                    if (typeof name !== "string") {
                        var doc = getDocument();
                        name = doc && doc.title || "";
                    }
                    if (typeof url !== "string") {
                        var loc = getLocation();
                        url = loc && loc[_DYN_HREF /* @min:%2ehref */] || "";
                    }
                    _pageTracking.stop(name, url, properties, measurement);
                    if (_autoTrackPageVisitTime) {
                        _pageVisitTimeManager[_DYN_TRACK_PREVIOUS_PAGE_1 /* @min:%2etrackPreviousPageVisit */](name, url);
                    }
                }
                catch (e) {
                    _throwInternal(1 /* eLoggingSeverity.CRITICAL */, 32 /* _eInternalMessageId.StopTrackFailed */, "stopTrackPage failed, page view will not be collected: " + getExceptionName(e), { exception: dumpObj(e) });
                }
            };
            /**
            * @ignore INTERNAL ONLY
            * @param exception
            * @param properties
            * @param systemProperties
            */
            _self[_DYN_SEND_EXCEPTION_INTER5 /* @min:%2esendExceptionInternal */] = function (exception, customProperties, systemProperties) {
                // Adding additional edge cases to handle
                // - Not passing anything (null / undefined)
                var theError = (exception && (exception[_DYN_EXCEPTION$1 /* @min:%2eexception */] || exception[_DYN_ERROR /* @min:%2eerror */])) ||
                    // - Handle someone calling trackException based of v1 API where the exception was the Error
                    isError(exception) && exception ||
                    // - Handles no error being defined and instead of creating a new Error() instance attempt to map so any stacktrace
                    //   is preserved and does not list ApplicationInsights code as the source
                    { name: (exception && typeof exception), message: exception || strNotSpecified };
                // If no exception object was passed assign to an empty object to avoid internal exceptions
                exception = exception || {};
                var exceptionPartB = new Exception(_self[_DYN_DIAG_LOG$1 /* @min:%2ediagLog */](), theError, exception.properties || customProperties, exception.measurements, exception.severityLevel, exception.id).toInterface();
                var telemetryItem = createTelemetryItem(exceptionPartB, Exception[_DYN_DATA_TYPE$1 /* @min:%2edataType */], Exception[_DYN_ENVELOPE_TYPE$1 /* @min:%2eenvelopeType */], _self[_DYN_DIAG_LOG$1 /* @min:%2ediagLog */](), customProperties, systemProperties);
                _self[_DYN_CORE$1 /* @min:%2ecore */][_DYN_TRACK /* @min:%2etrack */](telemetryItem);
            };
            /**
             * Log an exception you have caught.
             *
             * @param exception -   Object which contains exception to be sent
             * @param } customProperties   Additional data used to filter pages and metrics in the portal. Defaults to empty.
             *
             * Any property of type double will be considered a measurement, and will be treated by Application Insights as a metric.
             * @memberof ApplicationInsights
             */
            _self.trackException = function (exception, customProperties) {
                if (exception && !exception[_DYN_EXCEPTION$1 /* @min:%2eexception */] && exception[_DYN_ERROR /* @min:%2eerror */]) {
                    exception[_DYN_EXCEPTION$1 /* @min:%2eexception */] = exception[_DYN_ERROR /* @min:%2eerror */];
                }
                try {
                    _self[_DYN_SEND_EXCEPTION_INTER5 /* @min:%2esendExceptionInternal */](exception, customProperties);
                }
                catch (e) {
                    _throwInternal(1 /* eLoggingSeverity.CRITICAL */, 35 /* _eInternalMessageId.TrackExceptionFailed */, "trackException failed, exception will not be collected: " + getExceptionName(e), { exception: dumpObj(e) });
                }
            };
            /**
             * @description Custom error handler for Application Insights Analytics
             * @param exception
             * @memberof ApplicationInsights
             */
            _self[_DYN__ONERROR /* @min:%2e_onerror */] = function (exception) {
                var error = exception && exception[_DYN_ERROR /* @min:%2eerror */];
                var evt = exception && exception.evt;
                try {
                    if (!evt) {
                        var _window = getWindow();
                        if (_window) {
                            evt = _window[strEvent];
                        }
                    }
                    var url = (exception && exception.url) || (getDocument() || {}).URL;
                    // If no error source is provided assume the default window.onerror handler
                    var errorSrc = exception[_DYN_ERROR_SRC /* @min:%2eerrorSrc */] || "window.onerror@" + url + ":" + (exception[_DYN_LINE_NUMBER /* @min:%2elineNumber */] || 0) + ":" + (exception[_DYN_COLUMN_NUMBER /* @min:%2ecolumnNumber */] || 0);
                    var properties = {
                        errorSrc: errorSrc,
                        url: url,
                        lineNumber: exception[_DYN_LINE_NUMBER /* @min:%2elineNumber */] || 0,
                        columnNumber: exception[_DYN_COLUMN_NUMBER /* @min:%2ecolumnNumber */] || 0,
                        message: exception[_DYN_MESSAGE /* @min:%2emessage */]
                    };
                    if (isCrossOriginError(exception.message, exception.url, exception.lineNumber, exception.columnNumber, exception[_DYN_ERROR /* @min:%2eerror */])) {
                        _sendCORSException(Exception[_DYN__CREATE_AUTO_EXCEPTI6 /* @min:%2eCreateAutoException */]("Script error: The browser's same-origin policy prevents us from getting the details of this exception. Consider using the 'crossorigin' attribute.", url, exception[_DYN_LINE_NUMBER /* @min:%2elineNumber */] || 0, exception[_DYN_COLUMN_NUMBER /* @min:%2ecolumnNumber */] || 0, error, evt, null, errorSrc), properties);
                    }
                    else {
                        if (!exception[_DYN_ERROR_SRC /* @min:%2eerrorSrc */]) {
                            exception[_DYN_ERROR_SRC /* @min:%2eerrorSrc */] = errorSrc;
                        }
                        _self.trackException({ exception: exception, severityLevel: 3 /* eSeverityLevel.Error */ }, properties);
                    }
                }
                catch (e) {
                    var errorString = error ? (error.name + ", " + error[_DYN_MESSAGE /* @min:%2emessage */]) : "null";
                    _throwInternal(1 /* eLoggingSeverity.CRITICAL */, 11 /* _eInternalMessageId.ExceptionWhileLoggingError */, "_onError threw exception while logging error, error will not be collected: "
                        + getExceptionName(e), { exception: dumpObj(e), errorString: errorString });
                }
            };
            _self[_DYN_ADD_TELEMETRY_INITIA7 /* @min:%2eaddTelemetryInitializer */] = function (telemetryInitializer) {
                if (_self[_DYN_CORE$1 /* @min:%2ecore */]) {
                    // Just add to the core
                    return _self[_DYN_CORE$1 /* @min:%2ecore */][_DYN_ADD_TELEMETRY_INITIA7 /* @min:%2eaddTelemetryInitializer */](telemetryInitializer);
                }
                // Handle "pre-initialization" telemetry initializers (for backward compatibility)
                if (!_preInitTelemetryInitializers) {
                    _preInitTelemetryInitializers = [];
                }
                _preInitTelemetryInitializers.push(telemetryInitializer);
            };
            _self.initialize = function (config, core, extensions, pluginChain) {
                if (_self.isInitialized()) {
                    return;
                }
                if (isNullOrUndefined(core)) {
                    throwError("Error initializing");
                }
                _base.initialize(config, core, extensions, pluginChain);
                try {
                    _evtNamespace = mergeEvtNamespace(createUniqueNamespace(_self.identifier), core.evtNamespace && core.evtNamespace());
                    if (_preInitTelemetryInitializers) {
                        arrForEach(_preInitTelemetryInitializers, function (initializer) {
                            core[_DYN_ADD_TELEMETRY_INITIA7 /* @min:%2eaddTelemetryInitializer */](initializer);
                        });
                        _preInitTelemetryInitializers = null;
                    }
                    _populateDefaults(config);
                    _pageViewPerformanceManager = new PageViewPerformanceManager(_self[_DYN_CORE$1 /* @min:%2ecore */]);
                    _pageViewManager = new PageViewManager(_self, _extConfig.overridePageViewDuration, _self[_DYN_CORE$1 /* @min:%2ecore */], _pageViewPerformanceManager);
                    _pageVisitTimeManager = new PageVisitTimeManager(_self[_DYN_DIAG_LOG$1 /* @min:%2ediagLog */](), function (pageName, pageUrl, pageVisitTime) { return trackPageVisitTime(pageName, pageUrl, pageVisitTime); });
                    _eventTracking = new Timing(_self[_DYN_DIAG_LOG$1 /* @min:%2ediagLog */](), "trackEvent");
                    _eventTracking.action =
                        function (name, url, duration, properties, measurements) {
                            if (!properties) {
                                properties = {};
                            }
                            if (!measurements) {
                                measurements = {};
                            }
                            properties.duration = duration[_DYN_TO_STRING$1 /* @min:%2etoString */]();
                            _self.trackEvent({ name: name, properties: properties, measurements: measurements });
                        };
                    // initialize page view timing
                    _pageTracking = new Timing(_self[_DYN_DIAG_LOG$1 /* @min:%2ediagLog */](), "trackPageView");
                    _pageTracking.action = function (name, url, duration, properties, measurements) {
                        // duration must be a custom property in order for the collector to extract it
                        if (isNullOrUndefined(properties)) {
                            properties = {};
                        }
                        properties.duration = duration[_DYN_TO_STRING$1 /* @min:%2etoString */]();
                        var pageViewItem = {
                            name: name,
                            uri: url,
                            properties: properties,
                            measurements: measurements
                        };
                        _self[_DYN_SEND_PAGE_VIEW_INTER2 /* @min:%2esendPageViewInternal */](pageViewItem, properties);
                    };
                    if (hasWindow()) {
                        _updateExceptionTracking();
                        _updateLocationChange();
                    }
                }
                catch (e) {
                    // resetting the initialized state because of failure
                    _self.setInitialized(false);
                    throw e;
                }
            };
            _self._doTeardown = function (unloadCtx, unloadState) {
                _pageViewManager && _pageViewManager.teardown(unloadCtx, unloadState);
                // Just register to remove all events associated with this namespace
                eventOff(window, null, null, _evtNamespace);
                _initDefaults();
            };
            function _populateDefaults(config) {
                var identifier = _self.identifier;
                var core = _self[_DYN_CORE$1 /* @min:%2ecore */];
                _self[_DYN__ADD_HOOK$1 /* @min:%2e_addHook */](onConfigChange(config, function () {
                    var ctx = createProcessTelemetryContext(null, config, core);
                    _extConfig = ctx.getExtCfg(identifier, defaultValues);
                    _autoTrackPageVisitTime = _extConfig[_DYN_AUTO_TRACK_PAGE_VISI9 /* @min:%2eautoTrackPageVisitTime */];
                    if (config.storagePrefix) {
                        utlSetStoragePrefix(config.storagePrefix);
                    }
                    _updateStorageUsage(_extConfig);
                    // _updateBrowserLinkTracking
                    _isBrowserLinkTrackingEnabled = _extConfig[_DYN_IS_BROWSER_LINK_TRAC10 /* @min:%2eisBrowserLinkTrackingEnabled */];
                    _addDefaultTelemetryInitializers();
                }));
            }
            /**
             * Log a page visit time
             * @param    pageName    Name of page
             * @param    pageVisitDuration Duration of visit to the page in milliseconds
             */
            function trackPageVisitTime(pageName, pageUrl, pageVisitTime) {
                var properties = { PageName: pageName, PageUrl: pageUrl };
                _self.trackMetric({
                    name: "PageVisitTime",
                    average: pageVisitTime,
                    max: pageVisitTime,
                    min: pageVisitTime,
                    sampleCount: 1
                }, properties);
            }
            function _addDefaultTelemetryInitializers() {
                if (!_browserLinkInitializerAdded && _isBrowserLinkTrackingEnabled) {
                    var browserLinkPaths_1 = ["/browserLinkSignalR/", "/__browserLink/"];
                    var dropBrowserLinkRequests = function (envelope) {
                        if (_isBrowserLinkTrackingEnabled && envelope.baseType === RemoteDependencyData[_DYN_DATA_TYPE$1 /* @min:%2edataType */]) {
                            var remoteData = envelope.baseData;
                            if (remoteData) {
                                for (var i = 0; i < browserLinkPaths_1[_DYN_LENGTH$3 /* @min:%2elength */]; i++) {
                                    if (remoteData.target && strIndexOf(remoteData.target, browserLinkPaths_1[i]) >= 0) {
                                        return false;
                                    }
                                }
                            }
                        }
                        return true;
                    };
                    _self[_DYN__ADD_HOOK$1 /* @min:%2e_addHook */](_self[_DYN_ADD_TELEMETRY_INITIA7 /* @min:%2eaddTelemetryInitializer */](dropBrowserLinkRequests));
                    _browserLinkInitializerAdded = true;
                }
            }
            function _sendCORSException(exception, properties) {
                var telemetryItem = createTelemetryItem(exception, Exception[_DYN_DATA_TYPE$1 /* @min:%2edataType */], Exception[_DYN_ENVELOPE_TYPE$1 /* @min:%2eenvelopeType */], _self[_DYN_DIAG_LOG$1 /* @min:%2ediagLog */](), properties);
                _self[_DYN_CORE$1 /* @min:%2ecore */][_DYN_TRACK /* @min:%2etrack */](telemetryItem);
            }
            function _updateExceptionTracking() {
                var _window = getWindow();
                var locn = getLocation(true);
                _self[_DYN__ADD_HOOK$1 /* @min:%2e_addHook */](onConfigChange(_extConfig, function () {
                    _disableExceptionTracking = _extConfig.disableExceptionTracking;
                    if (!_disableExceptionTracking && !_autoExceptionInstrumented && !_extConfig.autoExceptionInstrumented) {
                        // We want to enable exception auto collection and it has not been done so yet
                        _addHook(InstrumentEvent(_window, "onerror", {
                            ns: _evtNamespace,
                            rsp: function (callDetails, message, url, lineNumber, columnNumber, error) {
                                if (!_disableExceptionTracking && callDetails.rslt !== true) {
                                    _self[_DYN__ONERROR /* @min:%2e_onerror */](Exception[_DYN__CREATE_AUTO_EXCEPTI6 /* @min:%2eCreateAutoException */](message, url, lineNumber, columnNumber, error, callDetails.evt));
                                }
                            }
                        }, false));
                        _autoExceptionInstrumented = true;
                    }
                }));
                _addUnhandledPromiseRejectionTracking(_window, locn);
            }
            function _updateLocationChange() {
                var win = getWindow();
                var locn = getLocation(true);
                _self[_DYN__ADD_HOOK$1 /* @min:%2e_addHook */](onConfigChange(_extConfig, function () {
                    _enableAutoRouteTracking = _extConfig[_DYN_ENABLE_AUTO_ROUTE_TR11 /* @min:%2eenableAutoRouteTracking */] === true;
                    /**
                     * Create a custom "locationchange" event which is triggered each time the history object is changed
                     */
                    if (win && _enableAutoRouteTracking && !_historyListenerAdded && hasHistory()) {
                        var _history = getHistory();
                        if (isFunction(_history.pushState) && isFunction(_history.replaceState) && typeof Event !== strShimUndefined) {
                            _addHistoryListener(win, _history, locn);
                        }
                    }
                }));
            }
            function _getDistributedTraceCtx() {
                var distributedTraceCtx = null;
                if (_self[_DYN_CORE$1 /* @min:%2ecore */] && _self[_DYN_CORE$1 /* @min:%2ecore */].getTraceCtx) {
                    distributedTraceCtx = _self[_DYN_CORE$1 /* @min:%2ecore */].getTraceCtx(false);
                }
                if (!distributedTraceCtx) {
                    // Fallback when using an older Core and PropertiesPlugin
                    var properties = _self[_DYN_CORE$1 /* @min:%2ecore */].getPlugin(PropertiesPluginIdentifier);
                    if (properties) {
                        var context = properties.plugin.context;
                        if (context) {
                            distributedTraceCtx = createDistributedTraceContextFromTrace(context.telemetryTrace);
                        }
                    }
                }
                return distributedTraceCtx;
            }
            /**
             * Create a custom "locationchange" event which is triggered each time the history object is changed
             */
            function _addHistoryListener(win, history, locn) {
                if (_historyListenerAdded) {
                    return;
                }
                // Name Prefix is only referenced during the initial initialization and cannot be changed afterwards
                var namePrefix = _extConfig.namePrefix || "";
                function _popstateHandler() {
                    if (_enableAutoRouteTracking) {
                        _dispatchEvent(win, createDomEvent(namePrefix + "locationchange"));
                    }
                }
                function _locationChangeHandler() {
                    // We always track the changes (if the handler is installed) to handle the feature being disabled between location changes
                    if (_currUri) {
                        _prevUri = _currUri;
                        _currUri = locn && locn[_DYN_HREF /* @min:%2ehref */] || "";
                    }
                    else {
                        _currUri = locn && locn[_DYN_HREF /* @min:%2ehref */] || "";
                    }
                    if (_enableAutoRouteTracking) {
                        var distributedTraceCtx = _getDistributedTraceCtx();
                        if (distributedTraceCtx) {
                            distributedTraceCtx.setTraceId(generateW3CId());
                            var traceLocationName = "_unknown_";
                            if (locn && locn.pathname) {
                                traceLocationName = locn.pathname + (locn.hash || "");
                            }
                            // This populates the ai.operation.name which has a maximum size of 1024 so we need to sanitize it
                            distributedTraceCtx.setName(dataSanitizeString(_self[_DYN_DIAG_LOG$1 /* @min:%2ediagLog */](), traceLocationName));
                        }
                        scheduleTimeout((function (uri) {
                            // todo: override start time so that it is not affected by autoRoutePVDelay
                            _self[_DYN_TRACK_PAGE_VIEW /* @min:%2etrackPageView */]({ refUri: uri, properties: { duration: 0 } }); // SPA route change loading durations are undefined, so send 0
                        }).bind(_self, _prevUri), _self.autoRoutePVDelay);
                    }
                }
                _addHook(InstrumentEvent(history, "pushState", {
                    ns: _evtNamespace,
                    rsp: function () {
                        if (_enableAutoRouteTracking) {
                            _dispatchEvent(win, createDomEvent(namePrefix + "pushState"));
                            _dispatchEvent(win, createDomEvent(namePrefix + "locationchange"));
                        }
                    }
                }, true));
                _addHook(InstrumentEvent(history, "replaceState", {
                    ns: _evtNamespace,
                    rsp: function () {
                        if (_enableAutoRouteTracking) {
                            _dispatchEvent(win, createDomEvent(namePrefix + "replaceState"));
                            _dispatchEvent(win, createDomEvent(namePrefix + "locationchange"));
                        }
                    }
                }, true));
                eventOn(win, namePrefix + "popstate", _popstateHandler, _evtNamespace);
                eventOn(win, namePrefix + "locationchange", _locationChangeHandler, _evtNamespace);
                _historyListenerAdded = true;
            }
            function _addUnhandledPromiseRejectionTracking(_window, _location) {
                _self[_DYN__ADD_HOOK$1 /* @min:%2e_addHook */](onConfigChange(_extConfig, function () {
                    _enableUnhandledPromiseRejectionTracking = _extConfig[_DYN_ENABLE_UNHANDLED_PRO12 /* @min:%2eenableUnhandledPromiseRejectionTracking */] === true;
                    _autoExceptionInstrumented = _autoExceptionInstrumented || _extConfig[_DYN_AUTO_UNHANDLED_PROMI13 /* @min:%2eautoUnhandledPromiseInstrumented */];
                    if (_enableUnhandledPromiseRejectionTracking && !_autoUnhandledPromiseInstrumented) {
                        // We want to enable exception auto collection and it has not been done so yet
                        _addHook(InstrumentEvent(_window, "onunhandledrejection", {
                            ns: _evtNamespace,
                            rsp: function (callDetails, error) {
                                if (_enableUnhandledPromiseRejectionTracking && callDetails.rslt !== true) { // handled could be typeof function
                                    _self[_DYN__ONERROR /* @min:%2e_onerror */](Exception[_DYN__CREATE_AUTO_EXCEPTI6 /* @min:%2eCreateAutoException */](_getReason(error), _location ? _location[_DYN_HREF /* @min:%2ehref */] : "", 0, 0, error, callDetails.evt));
                                }
                            }
                        }, false));
                        _extConfig[_DYN_AUTO_UNHANDLED_PROMI13 /* @min:%2eautoUnhandledPromiseInstrumented */] = _autoUnhandledPromiseInstrumented = true;
                    }
                }));
            }
            /**
             * This method will throw exceptions in debug mode or attempt to log the error as a console warning.
             * @param severity - {eLoggingSeverity} - The severity of the log message
             * @param msgId - {_eInternalLogMessage} - The log message.
             */
            function _throwInternal(severity, msgId, msg, properties, isUserAct) {
                _self[_DYN_DIAG_LOG$1 /* @min:%2ediagLog */]().throwInternal(severity, msgId, msg, properties, isUserAct);
            }
            function _initDefaults() {
                _eventTracking = null;
                _pageTracking = null;
                _pageViewManager = null;
                _pageViewPerformanceManager = null;
                _pageVisitTimeManager = null;
                _preInitTelemetryInitializers = null;
                _isBrowserLinkTrackingEnabled = false;
                _browserLinkInitializerAdded = false;
                _enableAutoRouteTracking = false;
                _historyListenerAdded = false;
                _disableExceptionTracking = false;
                _autoExceptionInstrumented = false;
                _enableUnhandledPromiseRejectionTracking = false;
                _autoUnhandledPromiseInstrumented = false;
                _autoTrackPageVisitTime = false;
                // array with max length of 2 that store current url and previous url for SPA page route change trackPageview use.
                var location = getLocation(true);
                _prevUri = location && location[_DYN_HREF /* @min:%2ehref */] || "";
                _currUri = null;
                _evtNamespace = null;
                _extConfig = null;
                // Define _self.config
                objDefine(_self, "config", {
                    g: function () { return _extConfig; }
                });
            }
            // For backward compatibility
            objDefine(_self, "_pageViewManager", { g: function () { return _pageViewManager; } });
            objDefine(_self, "_pageViewPerformanceManager", { g: function () { return _pageViewPerformanceManager; } });
            objDefine(_self, "_pageVisitTimeManager", { g: function () { return _pageVisitTimeManager; } });
            objDefine(_self, "_evtNamespace", { g: function () { return "." + _evtNamespace; } });
        });
        return _this;
    }
// Removed Stub for AnalyticsPlugin.prototype.getCookieMgr.
// Removed Stub for AnalyticsPlugin.prototype.processTelemetry.
// Removed Stub for AnalyticsPlugin.prototype.trackEvent.
// Removed Stub for AnalyticsPlugin.prototype.startTrackEvent.
// Removed Stub for AnalyticsPlugin.prototype.stopTrackEvent.
// Removed Stub for AnalyticsPlugin.prototype.trackTrace.
// Removed Stub for AnalyticsPlugin.prototype.trackMetric.
// Removed Stub for AnalyticsPlugin.prototype.trackPageView.
// Removed Stub for AnalyticsPlugin.prototype.sendPageViewInternal.
// Removed Stub for AnalyticsPlugin.prototype.sendPageViewPerformanceInternal.
// Removed Stub for AnalyticsPlugin.prototype.trackPageViewPerformance.
// Removed Stub for AnalyticsPlugin.prototype.startTrackPage.
// Removed Stub for AnalyticsPlugin.prototype.stopTrackPage.
// Removed Stub for AnalyticsPlugin.prototype.sendExceptionInternal.
// Removed Stub for AnalyticsPlugin.prototype.trackException.
// Removed Stub for AnalyticsPlugin.prototype._onerror.
// Removed Stub for AnalyticsPlugin.prototype.addTelemetryInitializer.
// Removed Stub for AnalyticsPlugin.prototype.initialize.
    AnalyticsPlugin.Version = '3.0.3'; // Not currently used anywhere
    return AnalyticsPlugin;
}(BaseTelemetryPlugin));

/*
 * Application Insights JavaScript SDK - Properties Plugin, 0.0.2
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


// @skip-file-minify
// ##############################################################
// AUTO GENERATED FILE: This file is Auto Generated during build.
// ##############################################################
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
// Note: DON'T Export these const from the package as we are still targeting ES3 this will export a mutable variables that someone could change!!!
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
var _DYN_FEATURE_OPT_IN = "featureOptIn"; // Count: 4
var _DYN_ON_CFG_CHANGE_RECEIV0 = "onCfgChangeReceive"; // Count: 2
var _DYN_NON_OVERRIDE_CONFIGS = "nonOverrideConfigs"; // Count: 2
var _DYN_SCHEDULE_FETCH_TIMEO1 = "scheduleFetchTimeout"; // Count: 2

/*
 * Application Insights JavaScript SDK - Properties Plugin, 0.0.2
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */
/**
 * Delete a config key in the given cfg, if the config key exists in nonOverrideConfigs and its value is set to true
 * @param cfg cfg to modify
 * @param nonOverrideConfigs nonOverrideConfigs
 * @param curLevel cur config level, starting at 0
 * @param maxLevel max config level
 * @returns new copy of modified configs
 */
function replaceByNonOverrideCfg(cfg, nonOverrideConfigs, curLevel, maxLevel) {
    try {
        var exceedMaxLevel = curLevel > maxLevel;
        if (exceedMaxLevel) {
            cfg = null;
        }
        var curCfg_1 = curLevel == 0 ? objExtend$1({}, cfg) : cfg; // only copy cfg at the begining level
        if (curCfg_1 && nonOverrideConfigs && !exceedMaxLevel) {
            objForEachKey(curCfg_1, function (key) {
                var nonOverrideVal = nonOverrideConfigs[key];
                if (!!nonOverrideVal) {
                    if (isObject(curCfg_1[key]) && isObject(nonOverrideVal)) {
                        curCfg_1[key] = replaceByNonOverrideCfg(curCfg_1[key], nonOverrideVal, ++curLevel, maxLevel);
                    }
                    else {
                        delete curCfg_1[key];
                    }
                }
            });
        }
        return curCfg_1;
    }
    catch (e) {
        // eslint-disable-next-line no-empty
    }
    // if errors happen, do nothing
    return cfg;
}
//                                                     CDN Mode, value = B (CDN value = B)
//                                |--------------------------------------------------------------------------|-----------|
//                                |                    | none        | disabled    | enabled     | forceOn   | forceOff  |
//                                | ------------------ | ----------- | ----------- | ----------- | --------- | --------- |
// | User Mode, value = A         | none               | none        | disabled    | enabled     | enabled   | disabled  |
// (user Value = A)               | disabled           | disabled    | disabled    | disabled    | enabled   | disabled  |
//                                | enabled            | enabled     | disabled    | enabled     | enabled   | disabled  |
//                                | none(blockCdn)     | none        | none        | none        | none      | none      |
//                                | disabled(blockCdn) | disabled    | disabled    | disabled    | disabled  | disabled  |
//                                | enabled(blockCdn)  | enabled     | enabled     | enabled     | enabled   | enabled   |
// This matrix identifies how feature based overrides are selected (if present)
//                                cdn Mode (cdn Value = B)
//                   |---------------------------------------------------------------------------|
//                   |                    | none     | disabled | enabled  | forceOn  | forceOff |
//                   | ------------------ | ---------| ---------| ---------| ---------|----------|
// | User Mode       | none               | A        | A        | A || B   | B || A   | B || A   |
// (user Value = A)  | disabled           | A        | A        | A        | B || A   | B || A   |
//                   | enabled            | A        | A        | A || B   | B || A   | B || A   |
//                   | none(blockCdn)     | A        | A        | A        | A        | A        |
//                   | disabled(blockCdn) | A        | A        | A        | A        | A        |
//                   | enabled(blockCdn)  | A        | A        | A        | A        | A        |
// Note:
// Where the "value" is an object (map) of encoded key/values which will be used to override the real configuration
// A = either the user supplied enable/disable value (via the `config.featureOptIn[name]`) or if not defined by the user the SDK defaults of the same.
// B = The enable/disable value obtained from the CDN for the named feature
// These are evaluated based on the above matrix to either
// - A (Always the user/sdk value)
// - B (Always the value from the CDN)
// - A || B (If A is null or undefined use the value from the CDN (B) otherwise A)
// - B || A (If B is null or undefined use the user/SDK value otherwise use the value from the CDN)
//
// The result of the value may also be null / undefined, which means there are no overrides to apply when the feature is enabled
var F = "featureOptIn.";
var M = ".mode";
var ON = ".onCfg";
var OFF = ".offCfg";
function resolveCdnFeatureCfg(field, cdnCfg, userOptInDetails) {
    var _a;
    // cdn conifg value
    if (!cdnCfg || !cdnCfg.enabled) {
        return null;
    }
    var cdnFt = (cdnCfg[_DYN_FEATURE_OPT_IN /* @min:%2efeatureOptIn */] || {})[field] || { mode: 1 /* CdnFeatureMode.none */ };
    var cdnM = cdnFt.mode;
    var cdnOnV = cdnFt.onCfg;
    var cdnOffV = cdnFt.offCfg;
    var userFt = (userOptInDetails || {})[field] || { mode: 2 /* FeatureOptInMode.disable */ }; // default user mode is disable
    var userM = userFt.mode;
    var userOnV = userFt.onCfg;
    var userOffV = userFt.offCfg;
    var blockCdn = !!userFt.blockCdnCfg;
    var mFld = F + field + M;
    var onFld = F + field + ON;
    var offFld = F + field + OFF;
    var mode = userM;
    var onV = userOnV;
    var offV = userOffV;
    if (!blockCdn) {
        if (cdnM === 4 /* CdnFeatureMode.forceOn */ || cdnM === 5 /* CdnFeatureMode.forceOff */) {
            mode = (cdnM == 4 /* CdnFeatureMode.forceOn */ ? 3 /* FeatureOptInMode.enable */ : 2 /* FeatureOptInMode.disable */);
            onV = cdnOnV || userOnV;
            offV = cdnOffV || userOffV;
        }
        else if (cdnM === 2 /* CdnFeatureMode.disable */ || userM === 2 /* FeatureOptInMode.disable */) {
            mode = 2 /* FeatureOptInMode.disable */;
            onV = userOnV || cdnOnV;
            offV = userOffV || cdnOffV;
        }
        else if (cdnM === 3 /* CdnFeatureMode.enable */) {
            mode = 3 /* FeatureOptInMode.enable */;
            onV = userOnV || cdnOnV;
            offV = userOffV || cdnOffV;
        }
        else if (cdnM === 1 /* CdnFeatureMode.none */ && userM === 1 /* FeatureOptInMode.none */) {
            mode = 1 /* FeatureOptInMode.none */;
        }
    }
    return _a = {},
        _a[mFld] = mode,
        _a[onFld] = onV,
        _a[offFld] = offV,
        _a;
}
// helper function to get cdn config with opt-in features
function applyCdnfeatureCfg(cdnCfg, core) {
    try {
        if (!cdnCfg || !cdnCfg.enabled) {
            return null;
        }
        if (!cdnCfg[_DYN_FEATURE_OPT_IN /* @min:%2efeatureOptIn */]) {
            return cdnCfg.config;
        }
        var optInMap = cdnCfg[_DYN_FEATURE_OPT_IN /* @min:%2efeatureOptIn */];
        var cdnConfig_1 = cdnCfg.config || {};
        objForEachKey(optInMap, function (key) {
            var featureVal = resolveCdnFeatureCfg(key, cdnCfg, core.config[_DYN_FEATURE_OPT_IN /* @min:%2efeatureOptIn */]);
            if (!isNullOrUndefined(featureVal)) {
                objForEachKey(featureVal, function (config, val) {
                    setValueByKey(cdnConfig_1, config, val);
                });
                _overrideCdnCfgByFeature(key, featureVal, cdnConfig_1);
            }
        });
        return cdnConfig_1;
    }
    catch (e) {
        // eslint-disable-next-line no-empty
    }
    return null;
}
function _overrideCdnCfgByFeature(field, ftVal, config) {
    var mode = ftVal[F + field + M];
    var val = ftVal[F + field + ON];
    var dVal = ftVal[F + field + OFF];
    var target = null;
    if (mode === 3 /* FeatureOptInMode.enable */) {
        target = val;
    }
    if (mode === 2 /* FeatureOptInMode.disable */) {
        target = dVal;
    }
    if (target) {
        objForEachKey(target, function (key, cfg) {
            setValueByKey(config, key, cfg);
        });
    }
}

/*
 * Application Insights JavaScript SDK - Properties Plugin, 0.0.2
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */
/**
* CfgSyncPlugin.ts
* @copyright Microsoft 2018
*/
var _a$5;
var EVENT_NAME = "ai_cfgsync";
var STR_GET_METHOD = "GET";
var FETCH_TIMEOUT = 1800000; // 30 minutes
var udfVal = undefined;
var defaultNonOverrideCfg = { instrumentationKey: true, connectionString: true, endpointUrl: true };
var _defaultConfig$2 = objDeepFreeze((_a$5 = {
        syncMode: 1 /* ICfgSyncMode.Broadcast */,
        blkCdnCfg: udfVal,
        customEvtName: udfVal,
        cfgUrl: udfVal,
        overrideSyncFn: udfVal,
        overrideFetchFn: udfVal
    },
    _a$5[_DYN_ON_CFG_CHANGE_RECEIV0 /* @min:onCfgChangeReceive */] = udfVal,
    _a$5[_DYN_SCHEDULE_FETCH_TIMEO1 /* @min:scheduleFetchTimeout */] = FETCH_TIMEOUT,
    _a$5[_DYN_NON_OVERRIDE_CONFIGS /* @min:nonOverrideConfigs */] = defaultNonOverrideCfg,
    _a$5));
var CfgSyncPlugin = /** @class */ (function (_super) {
    __extendsFn(CfgSyncPlugin, _super);
    function CfgSyncPlugin() {
        var _this = _super.call(this) || this;
        _this.priority = 198;
        _this.identifier = "AppInsightsCfgSyncPlugin";
        var _extensionConfig;
        var _mainConfig; // throttle config should be wrapped in IConfiguration
        var _evtName;
        var _evtNamespace;
        var _cfgUrl;
        var _timeoutHandle;
        var _receiveChanges;
        var _broadcastChanges;
        var _blkCdnCfg;
        var _fetchTimeout;
        var _retryCnt;
        var _onCfgChangeReceive;
        var _nonOverrideConfigs;
        var _fetchFn;
        var _overrideFetchFn;
        var _overrideSyncFn;
        var _paused = false;
        dynamicProto(CfgSyncPlugin, _this, function (_self, _base) {
            _initDefaults();
            _self.initialize = function (config, core, extensions, pluginChain) {
                _base.initialize(config, core, extensions, pluginChain);
                _evtNamespace = mergeEvtNamespace(createUniqueNamespace(_self.identifier), core.evtNamespace && core.evtNamespace());
                _populateDefaults(config);
            };
            _self.getCfg = function () {
                return _mainConfig;
            };
            _self.pause = function () {
                _paused = true;
                _clearScheduledTimer();
            };
            _self.resume = function () {
                _paused = false;
                _setupTimer();
            };
            // used for V2 to manaully trigger config udpate
            _self.setCfg = function (config) {
                return _setCfg(config);
            };
            _self.sync = function (customDetails) {
                return _sendCfgsyncEvents(customDetails);
            };
            _self.updateEventListenerName = function (eventName) {
                return _updateEventListenerName(eventName);
            };
            _self._doTeardown = function (unloadCtx, unloadState) {
                _eventOff();
                _clearScheduledTimer();
                _initDefaults();
            };
            _self["_getDbgPlgTargets"] = function () {
                return [_broadcastChanges, _receiveChanges, _evtName, _blkCdnCfg];
            };
            function _initDefaults() {
                _mainConfig = null;
                _evtName = null;
                _evtNamespace = null;
                _cfgUrl = null;
                _receiveChanges = null;
                _broadcastChanges = null;
                _nonOverrideConfigs = null;
                _timeoutHandle = null;
                _fetchTimeout = null;
                _retryCnt = null;
                _blkCdnCfg = null;
                _overrideFetchFn = null;
                _overrideSyncFn = null;
                _onCfgChangeReceive = null;
            }
            function _populateDefaults(config) {
                var identifier = _self.identifier;
                var core = _self.core;
                _self._addHook(onConfigChange(config, function () {
                    var ctx = createProcessTelemetryContext(null, config, core);
                    _extensionConfig = ctx.getExtCfg(identifier, _defaultConfig$2);
                    var preBlkCdn = _blkCdnCfg;
                    _blkCdnCfg = !!_extensionConfig.blkCdnCfg;
                    // avoid initial call
                    if (!isNullOrUndefined(preBlkCdn) && preBlkCdn !== _blkCdnCfg) {
                        if (!_blkCdnCfg && _cfgUrl) {
                            _fetchFn && _fetchFn(_cfgUrl, _onFetchComplete, _broadcastChanges);
                        }
                        else {
                            _clearScheduledTimer();
                        }
                    }
                    if (isNullOrUndefined(_receiveChanges)) {
                        _receiveChanges = _extensionConfig.syncMode === 2 /* ICfgSyncMode.Receive */;
                    }
                    if (isNullOrUndefined(_broadcastChanges)) {
                        _broadcastChanges = _extensionConfig.syncMode === 1 /* ICfgSyncMode.Broadcast */;
                    }
                    var newEvtName = _extensionConfig.customEvtName || EVENT_NAME;
                    if (_evtName !== newEvtName) {
                        if (_receiveChanges) {
                            _updateEventListenerName(newEvtName);
                        }
                        else {
                            _eventOff();
                            _evtName = newEvtName;
                        }
                    }
                    if (isNullOrUndefined(_cfgUrl)) {
                        _cfgUrl = _extensionConfig.cfgUrl;
                    }
                    // if cfgUrl is set, we will ignore core config change
                    if (!_cfgUrl) {
                        _mainConfig = config;
                        if (_broadcastChanges) {
                            _sendCfgsyncEvents();
                        }
                    }
                }));
                _overrideSyncFn = _extensionConfig.overrideSyncFn;
                _overrideFetchFn = _extensionConfig.overrideFetchFn;
                _onCfgChangeReceive = _extensionConfig[_DYN_ON_CFG_CHANGE_RECEIV0 /* @min:%2eonCfgChangeReceive */];
                _nonOverrideConfigs = _extensionConfig[_DYN_NON_OVERRIDE_CONFIGS /* @min:%2enonOverrideConfigs */];
                _fetchTimeout = _extensionConfig[_DYN_SCHEDULE_FETCH_TIMEO1 /* @min:%2escheduleFetchTimeout */];
                _fetchFn = _getFetchFnInterface();
                _retryCnt = 0;
                // NOT support cfgURL change to avoid mutiple fetch calls
                if (_cfgUrl && !_blkCdnCfg) {
                    _fetchFn && _fetchFn(_cfgUrl, _onFetchComplete, _broadcastChanges);
                }
            }
            function _setCfg(config, isAutoSync) {
                if (config) {
                    _mainConfig = config;
                    if (!!isAutoSync && !_paused) {
                        return _sendCfgsyncEvents();
                    }
                    if (_receiveChanges && !_paused) {
                        _self.core.updateCfg(config);
                        return true;
                    }
                }
                return false;
            }
            function _eventOff() {
                try {
                    var global_1 = getGlobal();
                    if (global_1) {
                        eventOff(global_1, null, null, _evtNamespace);
                    }
                }
                catch (e) {
                    // eslint-disable-next-line no-empty
                }
            }
            function _sendCfgsyncEvents(customDetails) {
                try {
                    if (!!_overrideSyncFn && isFunction(_overrideSyncFn)) {
                        return _overrideSyncFn(_mainConfig, customDetails);
                    }
                    return sendCustomEvent(_evtName, _mainConfig, customDetails);
                }
                catch (e) {
                    // eslint-disable-next-line no-empty
                }
                return false;
            }
            function _updateEventListenerName(name) {
                try {
                    _eventOff();
                    if (name) {
                        _evtName = name;
                        _addEventListener();
                    }
                    return true;
                }
                catch (e) {
                    // eslint-disable-next-line no-empty
                }
                return false;
            }
            function _getFetchFnInterface() {
                var _fetchFn = _overrideFetchFn;
                if (isNullOrUndefined(_fetchFn)) {
                    if (isFetchSupported()) {
                        _fetchFn = _fetchSender;
                    }
                    else if (isXhrSupported()) {
                        _fetchFn = _xhrSender;
                    }
                }
                return _fetchFn;
            }
            function _fetchSender(url, oncomplete, isAutoSync) {
                var global = getGlobal();
                var fetchFn = (global && global.fetch) || null;
                if (url && fetchFn && isFunction(fetchFn)) {
                    try {
                        var init = {
                            method: STR_GET_METHOD
                        };
                        var request = new Request(url, init);
                        doAwaitResponse(fetch(request), function (result) {
                            var response = result.value;
                            if (!result.rejected) {
                                if (response.ok) {
                                    doAwaitResponse(response.text(), function (res) {
                                        _doOnComplete(oncomplete, response.status, res.value, isAutoSync);
                                    });
                                }
                                else {
                                    _doOnComplete(oncomplete, response.status, null, isAutoSync);
                                }
                            }
                            else {
                                _doOnComplete(oncomplete, 400);
                            }
                        });
                    }
                    catch (e) {
                        // eslint-disable-next-line no-empty
                    }
                }
            }
            function _xhrSender(url, oncomplete, isAutoSync) {
                try {
                    var xhr_1 = new XMLHttpRequest();
                    xhr_1.open(STR_GET_METHOD, url);
                    xhr_1.onreadystatechange = function () {
                        if (xhr_1.readyState === XMLHttpRequest.DONE) {
                            _doOnComplete(oncomplete, xhr_1.status, xhr_1.responseText, isAutoSync);
                        }
                    };
                    xhr_1.onerror = function () {
                        _doOnComplete(oncomplete, 400);
                    };
                    xhr_1.ontimeout = function () {
                        _doOnComplete(oncomplete, 400);
                    };
                    xhr_1.send();
                }
                catch (e) {
                    // eslint-disable-next-line no-empty
                }
            }
            function _onFetchComplete(status, response, isAutoSync) {
                try {
                    if (status >= 200 && status < 400 && response) {
                        _retryCnt = 0; // any successful response will reset retry count to 0
                        var JSON_1 = getJSON();
                        if (JSON_1) {
                            var cdnCfg = JSON_1.parse(response); //comments are not allowed
                            var cfg = applyCdnfeatureCfg(cdnCfg, _self.core);
                            cfg && _setCfg(cfg, isAutoSync);
                        }
                    }
                    else {
                        _retryCnt++;
                    }
                    if (_retryCnt < 3) {
                        _setupTimer();
                    }
                }
                catch (e) {
                    // eslint-disable-next-line no-empty
                }
            }
            function _doOnComplete(oncomplete, status, response, isAutoSync) {
                try {
                    oncomplete(status, response, isAutoSync);
                }
                catch (e) {
                    // eslint-disable-next-line no-empty
                }
            }
            function _addEventListener() {
                if (_receiveChanges) {
                    var global_2 = getGlobal();
                    if (global_2) {
                        try {
                            eventOn(global_2, _evtName, function (event) {
                                // TODO: add more validation here
                                // may include a "name" or some other features to check
                                var cfgEvent = event && event.detail;
                                if (_onCfgChangeReceive && cfgEvent) {
                                    _onCfgChangeReceive(cfgEvent);
                                }
                                else {
                                    var cfg = cfgEvent && cfgEvent.cfg;
                                    var newCfg = cfg && isPlainObject(cfg) && _replaceTartgetByKeys(cfg);
                                    newCfg && _setCfg(newCfg);
                                }
                            }, _evtNamespace, true);
                        }
                        catch (e) {
                            // eslint-disable-next-line no-empty
                        }
                    }
                }
            }
            // 4 levels
            function _replaceTartgetByKeys(cfg, level) {
                var _cfg = null;
                try {
                    if (cfg) {
                        _cfg = replaceByNonOverrideCfg(cfg, _nonOverrideConfigs, 0, 5);
                    }
                }
                catch (e) {
                    // eslint-disable-next-line no-empty
                }
                return _cfg;
            }
            /**
             * Sets up the timer which triggers fetching cdn every 30mins after inital call
             */
            function _setupTimer() {
                if (!_timeoutHandle && _fetchTimeout) {
                    _timeoutHandle = scheduleTimeout(function () {
                        _timeoutHandle = null;
                        _fetchFn(_cfgUrl, _onFetchComplete, _broadcastChanges);
                    }, _fetchTimeout);
                    _timeoutHandle.unref();
                }
            }
            function _clearScheduledTimer() {
                _timeoutHandle && _timeoutHandle.cancel();
                _timeoutHandle = null;
                _retryCnt = 0;
            }
            _self.processTelemetry = function (env, itemCtx) {
                _self.processNext(env, itemCtx);
            };
        });
        return _this;
    }
// Removed Stub for CfgSyncPlugin.prototype.initialize.
// Removed Stub for CfgSyncPlugin.prototype.getCfg.
// Removed Stub for CfgSyncPlugin.prototype.setCfg.
// Removed Stub for CfgSyncPlugin.prototype.sync.
// Removed Stub for CfgSyncPlugin.prototype.updateEventListenerName.
// Removed Stub for CfgSyncPlugin.prototype.pause.
// Removed Stub for CfgSyncPlugin.prototype.resume.
    //// Removed Stub for CfgSyncPlugin.prototype.processTelemetry.
    // This is a workaround for an IE bug when using dynamicProto() with classes that don't have any
    // non-dynamic functions or static properties/functions when using uglify-js to minify the resulting code.
    CfgSyncPlugin.__ieDyn=1;

    return CfgSyncPlugin;
}(BaseTelemetryPlugin));

/*
 * Application Insights JavaScript SDK - Channel, 3.0.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


// ###################################################################################################################################################
// Note: DON'T Export these const from the package as we are still targeting IE/ES5 this will export a mutable variables that someone could change ###
// ###################################################################################################################################################
// Generally you should only put values that are used more than 2 times and then only if not already exposed as a constant (such as SdkCoreNames)
// as when using "short" named values from here they will be will be minified smaller than the SdkCoreNames[eSdkCoreNames.xxxx] value.
var STR_DURATION$1 = "duration";

/*
 * Application Insights JavaScript SDK - Channel, 3.0.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


// @skip-file-minify
// ##############################################################
// AUTO GENERATED FILE: This file is Auto Generated during build.
// ##############################################################
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
// Note: DON'T Export these const from the package as we are still targeting ES3 this will export a mutable variables that someone could change!!!
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
var _DYN_TAGS = "tags"; // Count: 17
var _DYN_DEVICE_TYPE = "deviceType"; // Count: 3
var _DYN_DATA = "data"; // Count: 13
var _DYN_NAME$1 = "name"; // Count: 8
var _DYN_TRACE_ID$1 = "traceID"; // Count: 5
var _DYN_LENGTH$2 = "length"; // Count: 36
var _DYN_STRINGIFY = "stringify"; // Count: 5
var _DYN_MEASUREMENTS = "measurements"; // Count: 7
var _DYN_DATA_TYPE = "dataType"; // Count: 10
var _DYN_ENVELOPE_TYPE = "envelopeType"; // Count: 7
var _DYN_TO_STRING = "toString"; // Count: 7
var _DYN_ON_LINE = "onLine"; // Count: 4
var _DYN_IS_ONLINE = "isOnline"; // Count: 3
var _DYN__GET = "_get"; // Count: 5
var _DYN_ENQUEUE = "enqueue"; // Count: 7
var _DYN_COUNT = "count"; // Count: 6
var _DYN_EVENTS_LIMIT_IN_MEM = "eventsLimitInMem"; // Count: 2
var _DYN_PUSH = "push"; // Count: 6
var _DYN_EMIT_LINE_DELIMITED_0 = "emitLineDelimitedJson"; // Count: 3
var _DYN_CLEAR = "clear"; // Count: 7
var _DYN_BATCH_PAYLOADS = "batchPayloads"; // Count: 5
var _DYN_CREATE_NEW = "createNew"; // Count: 3
var _DYN_MARK_AS_SENT = "markAsSent"; // Count: 7
var _DYN_CLEAR_SENT = "clearSent"; // Count: 5
var _DYN_BUFFER_OVERRIDE = "bufferOverride"; // Count: 3
var _DYN__BUFFER__KEY = "BUFFER_KEY"; // Count: 5
var _DYN__SENT__BUFFER__KEY = "SENT_BUFFER_KEY"; // Count: 8
var _DYN__MAX__BUFFER__SIZE = "MAX_BUFFER_SIZE"; // Count: 5
var _DYN_TRIGGER_SEND = "triggerSend"; // Count: 5
var _DYN_DIAG_LOG = "diagLog"; // Count: 16
var _DYN__SENDER = "_sender"; // Count: 5
var _DYN_CUSTOM_HEADERS = "customHeaders"; // Count: 3
var _DYN_MAX_BATCH_SIZE_IN_BY1 = "maxBatchSizeInBytes"; // Count: 2
var _DYN_ONUNLOAD_DISABLE_BEA2 = "onunloadDisableBeacon"; // Count: 2
var _DYN_IS_BEACON_API_DISABL3 = "isBeaconApiDisabled"; // Count: 3
var _DYN_ENABLE_SESSION_STORA4 = "enableSessionStorageBuffer"; // Count: 2
var _DYN__BUFFER = "_buffer"; // Count: 11
var _DYN_INSTRUMENTATION_KEY$1 = "instrumentationKey"; // Count: 2
var _DYN_DISABLE_XHR = "disableXhr"; // Count: 5
var _DYN_ONUNLOAD_DISABLE_FET5 = "onunloadDisableFetch"; // Count: 2
var _DYN_CONVERT_UNDEFINED = "convertUndefined"; // Count: 2
var _DYN_MAX_BATCH_INTERVAL = "maxBatchInterval"; // Count: 2
var _DYN_BASE_TYPE = "baseType"; // Count: 4
var _DYN_SAMPLE_RATE = "sampleRate"; // Count: 4
var _DYN__XHR_READY_STATE_CHA6 = "_xhrReadyStateChange"; // Count: 2
var _DYN__ON_ERROR = "_onError"; // Count: 11
var _DYN__ON_PARTIAL_SUCCESS = "_onPartialSuccess"; // Count: 3
var _DYN__ON_SUCCESS = "_onSuccess"; // Count: 6
var _DYN_ITEMS_ACCEPTED = "itemsAccepted"; // Count: 5
var _DYN_ITEMS_RECEIVED = "itemsReceived"; // Count: 6
var _DYN_SET_REQUEST_HEADER$1 = "setRequestHeader"; // Count: 3
var _DYN_EVENTS_SEND_REQUEST = "eventsSendRequest"; // Count: 2
var _DYN_GET_SAMPLING_SCORE = "getSamplingScore"; // Count: 2
var _DYN_GET_HASH_CODE_SCORE = "getHashCodeScore"; // Count: 4

/*
 * Application Insights JavaScript SDK - Channel, 3.0.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */
// these two constants are used to filter out properties not needed when trying to extract custom properties and measurements from the incoming payload
var strBaseType = "baseType";
var strBaseData = "baseData";
var strProperties = "properties";
var strTrue = "true";
function _setValueIf(target, field, value) {
    return setValue(target, field, value, isTruthy);
}
/*
 * Maps Part A data from CS 4.0
 */
function _extractPartAExtensions(logger, item, env) {
    // todo: switch to keys from common in this method
    var envTags = env[_DYN_TAGS /* @min:%2etags */] = env[_DYN_TAGS /* @min:%2etags */] || {};
    var itmExt = item.ext = item.ext || {};
    var itmTags = item[_DYN_TAGS /* @min:%2etags */] = item[_DYN_TAGS /* @min:%2etags */] || [];
    var extUser = itmExt.user;
    if (extUser) {
        _setValueIf(envTags, CtxTagKeys.userAuthUserId, extUser.authId);
        _setValueIf(envTags, CtxTagKeys.userId, extUser.id || extUser.localId);
    }
    var extApp = itmExt.app;
    if (extApp) {
        _setValueIf(envTags, CtxTagKeys.sessionId, extApp.sesId);
    }
    var extDevice = itmExt.device;
    if (extDevice) {
        _setValueIf(envTags, CtxTagKeys.deviceId, extDevice.id || extDevice.localId);
        _setValueIf(envTags, CtxTagKeys[_DYN_DEVICE_TYPE /* @min:%2edeviceType */], extDevice.deviceClass);
        _setValueIf(envTags, CtxTagKeys.deviceIp, extDevice.ip);
        _setValueIf(envTags, CtxTagKeys.deviceModel, extDevice.model);
        _setValueIf(envTags, CtxTagKeys[_DYN_DEVICE_TYPE /* @min:%2edeviceType */], extDevice[_DYN_DEVICE_TYPE /* @min:%2edeviceType */]);
    }
    var web = item.ext.web;
    if (web) {
        _setValueIf(envTags, CtxTagKeys.deviceLanguage, web.browserLang);
        _setValueIf(envTags, CtxTagKeys.deviceBrowserVersion, web.browserVer);
        _setValueIf(envTags, CtxTagKeys.deviceBrowser, web.browser);
        var envData = env[_DYN_DATA /* @min:%2edata */] = env[_DYN_DATA /* @min:%2edata */] || {};
        var envBaseData = envData[strBaseData] = envData[strBaseData] || {};
        var envProps = envBaseData[strProperties] = envBaseData[strProperties] || {};
        _setValueIf(envProps, "domain", web.domain);
        _setValueIf(envProps, "isManual", web.isManual ? strTrue : null);
        _setValueIf(envProps, "screenRes", web.screenRes);
        _setValueIf(envProps, "userConsent", web.userConsent ? strTrue : null);
    }
    var extOs = itmExt.os;
    if (extOs) {
        _setValueIf(envTags, CtxTagKeys.deviceOS, extOs[_DYN_NAME$1 /* @min:%2ename */]);
    }
    // No support for mapping Trace.traceState to 2.0 as it is currently empty
    var extTrace = itmExt.trace;
    if (extTrace) {
        _setValueIf(envTags, CtxTagKeys.operationParentId, extTrace.parentID);
        _setValueIf(envTags, CtxTagKeys.operationName, dataSanitizeString(logger, extTrace[_DYN_NAME$1 /* @min:%2ename */]));
        _setValueIf(envTags, CtxTagKeys.operationId, extTrace[_DYN_TRACE_ID$1 /* @min:%2etraceID */]);
    }
    // Sample 4.0 schema
    //  {
    //     "time" : "2018-09-05T22:51:22.4936Z",
    //     "name" : "MetricWithNamespace",
    //     "iKey" : "ABC-5a4cbd20-e601-4ef5-a3c6-5d6577e4398e",
    //     "ext": {  "cloud": {
    //          "role": "WATSON3",
    //          "roleInstance": "CO4AEAP00000260"
    //      },
    //      "device": {}, "correlation": {} },
    //      "tags": [
    //        { "amazon.region" : "east2" },
    //        { "os.expid" : "wp:02df239" }
    //     ]
    //   }
    var tgs = {};
    // deals with tags.push({object})
    for (var i = itmTags[_DYN_LENGTH$2 /* @min:%2elength */] - 1; i >= 0; i--) {
        var tg = itmTags[i];
        objForEachKey(tg, function (key, value) {
            tgs[key] = value;
        });
        itmTags.splice(i, 1);
    }
    // deals with tags[key]=value (and handles hasOwnProperty)
    objForEachKey(itmTags, function (tg, value) {
        tgs[tg] = value;
    });
    var theTags = __assignFn(__assignFn({}, envTags), tgs);
    if (!theTags[CtxTagKeys.internalSdkVersion]) {
        // Append a version in case it is not already set
        theTags[CtxTagKeys.internalSdkVersion] = dataSanitizeString(logger, "javascript:".concat(EnvelopeCreator.Version), 64);
    }
    env[_DYN_TAGS /* @min:%2etags */] = optimizeObject(theTags);
}
function _extractPropsAndMeasurements(data, properties, measurements) {
    if (!isNullOrUndefined(data)) {
        objForEachKey(data, function (key, value) {
            if (isNumber(value)) {
                measurements[key] = value;
            }
            else if (isString(value)) {
                properties[key] = value;
            }
            else if (hasJSON()) {
                properties[key] = getJSON()[_DYN_STRINGIFY /* @min:%2estringify */](value);
            }
        });
    }
}
function _convertPropsUndefinedToCustomDefinedValue(properties, customUndefinedValue) {
    if (!isNullOrUndefined(properties)) {
        objForEachKey(properties, function (key, value) {
            properties[key] = value || customUndefinedValue;
        });
    }
}
// TODO: Do we want this to take logger as arg or use this._logger as nonstatic?
function _createEnvelope(logger, envelopeType, telemetryItem, data) {
    var envelope = new Envelope(logger, data, envelopeType);
    _setValueIf(envelope, "sampleRate", telemetryItem[SampleRate]);
    if ((telemetryItem[strBaseData] || {}).startTime) {
        // Starting from Version 3.0.3, the time property will be assigned by the startTime value,
        // which records the loadEvent time for the pageView event.
        envelope.time = toISOString(telemetryItem[strBaseData].startTime);
    }
    envelope.iKey = telemetryItem.iKey;
    var iKeyNoDashes = telemetryItem.iKey.replace(/-/g, "");
    envelope[_DYN_NAME$1 /* @min:%2ename */] = envelope[_DYN_NAME$1 /* @min:%2ename */].replace("{0}", iKeyNoDashes);
    // extract all extensions from ctx
    _extractPartAExtensions(logger, telemetryItem, envelope);
    // loop through the envelope tags (extension of Part A) and pick out the ones that should go in outgoing envelope tags
    telemetryItem[_DYN_TAGS /* @min:%2etags */] = telemetryItem[_DYN_TAGS /* @min:%2etags */] || [];
    return optimizeObject(envelope);
}
function EnvelopeCreatorInit(logger, telemetryItem) {
    if (isNullOrUndefined(telemetryItem[strBaseData])) {
        _throwInternal(logger, 1 /* eLoggingSeverity.CRITICAL */, 46 /* _eInternalMessageId.TelemetryEnvelopeInvalid */, "telemetryItem.baseData cannot be null.");
    }
}
var EnvelopeCreator = {
    Version: '3.0.3'
};
function DependencyEnvelopeCreator(logger, telemetryItem, customUndefinedValue) {
    EnvelopeCreatorInit(logger, telemetryItem);
    var customMeasurements = telemetryItem[strBaseData][_DYN_MEASUREMENTS /* @min:%2emeasurements */] || {};
    var customProperties = telemetryItem[strBaseData][strProperties] || {};
    _extractPropsAndMeasurements(telemetryItem[_DYN_DATA /* @min:%2edata */], customProperties, customMeasurements);
    if (!isNullOrUndefined(customUndefinedValue)) {
        _convertPropsUndefinedToCustomDefinedValue(customProperties, customUndefinedValue);
    }
    var bd = telemetryItem[strBaseData];
    if (isNullOrUndefined(bd)) {
        _warnToConsole(logger, "Invalid input for dependency data");
        return null;
    }
    var method = bd[strProperties] && bd[strProperties][HttpMethod] ? bd[strProperties][HttpMethod] : "GET";
    var remoteDepData = new RemoteDependencyData(logger, bd.id, bd.target, bd[_DYN_NAME$1 /* @min:%2ename */], bd[STR_DURATION$1 /* @min:%2eduration */], bd.success, bd.responseCode, method, bd.type, bd.correlationContext, customProperties, customMeasurements);
    var data = new Data(RemoteDependencyData[_DYN_DATA_TYPE /* @min:%2edataType */], remoteDepData);
    return _createEnvelope(logger, RemoteDependencyData[_DYN_ENVELOPE_TYPE /* @min:%2eenvelopeType */], telemetryItem, data);
}
function EventEnvelopeCreator(logger, telemetryItem, customUndefinedValue) {
    EnvelopeCreatorInit(logger, telemetryItem);
    var customProperties = {};
    var customMeasurements = {};
    if (telemetryItem[strBaseType] !== Event$1[_DYN_DATA_TYPE /* @min:%2edataType */]) {
        customProperties["baseTypeSource"] = telemetryItem[strBaseType]; // save the passed in base type as a property
    }
    if (telemetryItem[strBaseType] === Event$1[_DYN_DATA_TYPE /* @min:%2edataType */]) { // take collection
        customProperties = telemetryItem[strBaseData][strProperties] || {};
        customMeasurements = telemetryItem[strBaseData][_DYN_MEASUREMENTS /* @min:%2emeasurements */] || {};
    }
    else { // if its not a known type, convert to custom event
        if (telemetryItem[strBaseData]) {
            _extractPropsAndMeasurements(telemetryItem[strBaseData], customProperties, customMeasurements);
        }
    }
    // Extract root level properties from part C telemetryItem.data
    _extractPropsAndMeasurements(telemetryItem[_DYN_DATA /* @min:%2edata */], customProperties, customMeasurements);
    if (!isNullOrUndefined(customUndefinedValue)) {
        _convertPropsUndefinedToCustomDefinedValue(customProperties, customUndefinedValue);
    }
    var eventName = telemetryItem[strBaseData][_DYN_NAME$1 /* @min:%2ename */];
    var eventData = new Event$1(logger, eventName, customProperties, customMeasurements);
    var data = new Data(Event$1[_DYN_DATA_TYPE /* @min:%2edataType */], eventData);
    return _createEnvelope(logger, Event$1[_DYN_ENVELOPE_TYPE /* @min:%2eenvelopeType */], telemetryItem, data);
}
function ExceptionEnvelopeCreator(logger, telemetryItem, customUndefinedValue) {
    EnvelopeCreatorInit(logger, telemetryItem);
    // Extract root level properties from part C telemetryItem.data
    var customMeasurements = telemetryItem[strBaseData][_DYN_MEASUREMENTS /* @min:%2emeasurements */] || {};
    var customProperties = telemetryItem[strBaseData][strProperties] || {};
    _extractPropsAndMeasurements(telemetryItem[_DYN_DATA /* @min:%2edata */], customProperties, customMeasurements);
    if (!isNullOrUndefined(customUndefinedValue)) {
        _convertPropsUndefinedToCustomDefinedValue(customProperties, customUndefinedValue);
    }
    var bd = telemetryItem[strBaseData];
    var exData = Exception.CreateFromInterface(logger, bd, customProperties, customMeasurements);
    var data = new Data(Exception[_DYN_DATA_TYPE /* @min:%2edataType */], exData);
    return _createEnvelope(logger, Exception[_DYN_ENVELOPE_TYPE /* @min:%2eenvelopeType */], telemetryItem, data);
}
function MetricEnvelopeCreator(logger, telemetryItem, customUndefinedValue) {
    EnvelopeCreatorInit(logger, telemetryItem);
    var baseData = telemetryItem[strBaseData];
    var props = baseData[strProperties] || {};
    var measurements = baseData[_DYN_MEASUREMENTS /* @min:%2emeasurements */] || {};
    _extractPropsAndMeasurements(telemetryItem[_DYN_DATA /* @min:%2edata */], props, measurements);
    if (!isNullOrUndefined(customUndefinedValue)) {
        _convertPropsUndefinedToCustomDefinedValue(props, customUndefinedValue);
    }
    var baseMetricData = new Metric(logger, baseData[_DYN_NAME$1 /* @min:%2ename */], baseData.average, baseData.sampleCount, baseData.min, baseData.max, baseData.stdDev, props, measurements);
    var data = new Data(Metric[_DYN_DATA_TYPE /* @min:%2edataType */], baseMetricData);
    return _createEnvelope(logger, Metric[_DYN_ENVELOPE_TYPE /* @min:%2eenvelopeType */], telemetryItem, data);
}
function PageViewEnvelopeCreator(logger, telemetryItem, customUndefinedValue) {
    EnvelopeCreatorInit(logger, telemetryItem);
    // Since duration is not part of the domain properties in Common Schema, extract it from part C
    var duration;
    var baseData = telemetryItem[strBaseData];
    if (!isNullOrUndefined(baseData) &&
        !isNullOrUndefined(baseData[strProperties]) &&
        !isNullOrUndefined(baseData[strProperties][STR_DURATION$1])) { // from part B properties
        duration = baseData[strProperties][STR_DURATION$1];
        delete baseData[strProperties][STR_DURATION$1];
    }
    else if (!isNullOrUndefined(telemetryItem[_DYN_DATA /* @min:%2edata */]) &&
        !isNullOrUndefined(telemetryItem[_DYN_DATA /* @min:%2edata */][STR_DURATION$1])) { // from custom properties
        duration = telemetryItem[_DYN_DATA /* @min:%2edata */][STR_DURATION$1];
        delete telemetryItem[_DYN_DATA /* @min:%2edata */][STR_DURATION$1];
    }
    var bd = telemetryItem[strBaseData];
    // special case: pageview.id is grabbed from current operation id. Analytics plugin is decoupled from properties plugin, so this is done here instead. This can be made a default telemetry intializer instead if needed to be decoupled from channel
    var currentContextId;
    if (((telemetryItem.ext || {}).trace || {})[_DYN_TRACE_ID$1 /* @min:%2etraceID */]) {
        currentContextId = telemetryItem.ext.trace[_DYN_TRACE_ID$1 /* @min:%2etraceID */];
    }
    var id = bd.id || currentContextId;
    var name = bd[_DYN_NAME$1 /* @min:%2ename */];
    var url = bd.uri;
    var properties = bd[strProperties] || {};
    var measurements = bd[_DYN_MEASUREMENTS /* @min:%2emeasurements */] || {};
    // refUri is a field that Breeze still does not recognize as part of Part B. For now, put it in Part C until it supports it as a domain property
    if (!isNullOrUndefined(bd.refUri)) {
        properties["refUri"] = bd.refUri;
    }
    // pageType is a field that Breeze still does not recognize as part of Part B. For now, put it in Part C until it supports it as a domain property
    if (!isNullOrUndefined(bd.pageType)) {
        properties["pageType"] = bd.pageType;
    }
    // isLoggedIn is a field that Breeze still does not recognize as part of Part B. For now, put it in Part C until it supports it as a domain property
    if (!isNullOrUndefined(bd.isLoggedIn)) {
        properties["isLoggedIn"] = bd.isLoggedIn[_DYN_TO_STRING /* @min:%2etoString */]();
    }
    // pageTags is a field that Breeze still does not recognize as part of Part B. For now, put it in Part C until it supports it as a domain property
    if (!isNullOrUndefined(bd[strProperties])) {
        var pageTags = bd[strProperties];
        objForEachKey(pageTags, function (key, value) {
            properties[key] = value;
        });
    }
    _extractPropsAndMeasurements(telemetryItem[_DYN_DATA /* @min:%2edata */], properties, measurements);
    if (!isNullOrUndefined(customUndefinedValue)) {
        _convertPropsUndefinedToCustomDefinedValue(properties, customUndefinedValue);
    }
    var pageViewData = new PageView(logger, name, url, duration, properties, measurements, id);
    var data = new Data(PageView[_DYN_DATA_TYPE /* @min:%2edataType */], pageViewData);
    return _createEnvelope(logger, PageView[_DYN_ENVELOPE_TYPE /* @min:%2eenvelopeType */], telemetryItem, data);
}
function PageViewPerformanceEnvelopeCreator(logger, telemetryItem, customUndefinedValue) {
    EnvelopeCreatorInit(logger, telemetryItem);
    var bd = telemetryItem[strBaseData];
    var name = bd[_DYN_NAME$1 /* @min:%2ename */];
    var url = bd.uri || bd.url;
    var properties = bd[strProperties] || {};
    var measurements = bd[_DYN_MEASUREMENTS /* @min:%2emeasurements */] || {};
    _extractPropsAndMeasurements(telemetryItem[_DYN_DATA /* @min:%2edata */], properties, measurements);
    if (!isNullOrUndefined(customUndefinedValue)) {
        _convertPropsUndefinedToCustomDefinedValue(properties, customUndefinedValue);
    }
    var baseData = new PageViewPerformance(logger, name, url, undefined, properties, measurements, bd);
    var data = new Data(PageViewPerformance[_DYN_DATA_TYPE /* @min:%2edataType */], baseData);
    return _createEnvelope(logger, PageViewPerformance[_DYN_ENVELOPE_TYPE /* @min:%2eenvelopeType */], telemetryItem, data);
}
function TraceEnvelopeCreator(logger, telemetryItem, customUndefinedValue) {
    EnvelopeCreatorInit(logger, telemetryItem);
    var message = telemetryItem[strBaseData].message;
    var severityLevel = telemetryItem[strBaseData].severityLevel;
    var props = telemetryItem[strBaseData][strProperties] || {};
    var measurements = telemetryItem[strBaseData][_DYN_MEASUREMENTS /* @min:%2emeasurements */] || {};
    _extractPropsAndMeasurements(telemetryItem[_DYN_DATA /* @min:%2edata */], props, measurements);
    if (!isNullOrUndefined(customUndefinedValue)) {
        _convertPropsUndefinedToCustomDefinedValue(props, customUndefinedValue);
    }
    var baseData = new Trace(logger, message, severityLevel, props, measurements);
    var data = new Data(Trace[_DYN_DATA_TYPE /* @min:%2edataType */], baseData);
    return _createEnvelope(logger, Trace[_DYN_ENVELOPE_TYPE /* @min:%2eenvelopeType */], telemetryItem, data);
}

/*
 * Application Insights JavaScript SDK - Channel, 3.0.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */
function _disableEvents(target, evtNamespace) {
    eventOff(target, null, null, evtNamespace);
}
/**
 * Create a new OfflineListener instance to monitor browser online / offline events
 * @param parentEvtNamespace - The parent event namespace to append to any specific events for this instance
 */
function createOfflineListener(parentEvtNamespace) {
    var _a;
    var _document = getDocument();
    var _navigator = getNavigator(); // Gets the window.navigator or workerNavigator depending on the global
    var _isListening = false;
    var _onlineStatus = true;
    var _evtNamespace = mergeEvtNamespace(createUniqueNamespace("OfflineListener"), parentEvtNamespace);
    try {
        if (_enableEvents(getWindow())) {
            _isListening = true;
        }
        if (_document) {
            // Also attach to the document.body or document
            var target = _document.body || _document;
            if (target.ononline) {
                if (_enableEvents(target)) {
                    _isListening = true;
                }
            }
        }
        if (_isListening) {
            // We are listening to events so lets set the current status rather than assuming we are online #1538
            if (_navigator && !isNullOrUndefined(_navigator[_DYN_ON_LINE /* @min:%2eonLine */])) { // navigator.onLine is undefined in react-native
                _onlineStatus = _navigator[_DYN_ON_LINE /* @min:%2eonLine */];
            }
        }
    }
    catch (e) {
        // this makes react-native less angry
        _isListening = false;
    }
    function _enableEvents(target) {
        var enabled = false;
        if (target) {
            enabled = eventOn(target, "online", _setOnline, _evtNamespace);
            if (enabled) {
                eventOn(target, "offline", _setOffline, _evtNamespace);
            }
        }
        return enabled;
    }
    function _setOnline() {
        _onlineStatus = true;
    }
    function _setOffline() {
        _onlineStatus = false;
    }
    function _isOnline() {
        var result = true;
        if (_isListening) {
            result = _onlineStatus;
        }
        else if (_navigator && !isNullOrUndefined(_navigator[_DYN_ON_LINE /* @min:%2eonLine */])) { // navigator.onLine is undefined in react-native
            result = _navigator[_DYN_ON_LINE /* @min:%2eonLine */];
        }
        return result;
    }
    function _unload() {
        var win = getWindow();
        if (win && _isListening) {
            _disableEvents(win, _evtNamespace);
            if (_document) {
                // Also attach to the document.body or document
                var target = _document.body || _document;
                if (!isUndefined(target.ononline)) {
                    _disableEvents(target, _evtNamespace);
                }
            }
            _isListening = false;
        }
    }
    return _a = {},
        _a[_DYN_IS_ONLINE /* @min:isOnline */] = _isOnline,
        _a.isListening = function () { return _isListening; },
        _a.unload = _unload,
        _a;
}

/*
 * Application Insights JavaScript SDK - Channel, 3.0.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */
var BaseSendBuffer = /** @class */ (function () {
    function BaseSendBuffer(logger, config) {
        var _buffer = [];
        var _bufferFullMessageSent = false;
        this[_DYN__GET /* @min:%2e_get */] = function () {
            return _buffer;
        };
        this._set = function (buffer) {
            _buffer = buffer;
            return _buffer;
        };
        dynamicProto(BaseSendBuffer, this, function (_self) {
            _self[_DYN_ENQUEUE /* @min:%2eenqueue */] = function (payload) {
                if (_self[_DYN_COUNT /* @min:%2ecount */]() >= config[_DYN_EVENTS_LIMIT_IN_MEM /* @min:%2eeventsLimitInMem */]) {
                    // sent internal log only once per page view
                    if (!_bufferFullMessageSent) {
                        _throwInternal(logger, 2 /* eLoggingSeverity.WARNING */, 105 /* _eInternalMessageId.InMemoryStorageBufferFull */, "Maximum in-memory buffer size reached: " + _self[_DYN_COUNT /* @min:%2ecount */](), true);
                        _bufferFullMessageSent = true;
                    }
                    return;
                }
                _buffer[_DYN_PUSH /* @min:%2epush */](payload);
            };
            _self[_DYN_COUNT /* @min:%2ecount */] = function () {
                return _buffer[_DYN_LENGTH$2 /* @min:%2elength */];
            };
            _self.size = function () {
                var size = _buffer[_DYN_LENGTH$2 /* @min:%2elength */];
                for (var lp = 0; lp < _buffer[_DYN_LENGTH$2 /* @min:%2elength */]; lp++) {
                    size += _buffer[lp][_DYN_LENGTH$2 /* @min:%2elength */];
                }
                if (!config[_DYN_EMIT_LINE_DELIMITED_0 /* @min:%2eemitLineDelimitedJson */]) {
                    size += 2;
                }
                return size;
            };
            _self[_DYN_CLEAR /* @min:%2eclear */] = function () {
                _buffer = [];
                _bufferFullMessageSent = false;
            };
            _self.getItems = function () {
                return _buffer.slice(0);
            };
            _self[_DYN_BATCH_PAYLOADS /* @min:%2ebatchPayloads */] = function (payload) {
                if (payload && payload[_DYN_LENGTH$2 /* @min:%2elength */] > 0) {
                    var batch = config[_DYN_EMIT_LINE_DELIMITED_0 /* @min:%2eemitLineDelimitedJson */] ?
                        payload.join("\n") :
                        "[" + payload.join(",") + "]";
                    return batch;
                }
                return null;
            };
            _self[_DYN_CREATE_NEW /* @min:%2ecreateNew */] = function (newLogger, newConfig, canUseSessionStorage) {
                var items = _buffer.slice(0);
                newLogger = newLogger || logger;
                newConfig = newConfig || {};
                var newBuffer = !!canUseSessionStorage ? new SessionStorageSendBuffer(newLogger, newConfig) : new ArraySendBuffer(newLogger, newConfig);
                arrForEach(items, function (payload) {
                    newBuffer[_DYN_ENQUEUE /* @min:%2eenqueue */](payload);
                });
                return newBuffer;
            };
        });
    }
// Removed Stub for BaseSendBuffer.prototype.enqueue.
// Removed Stub for BaseSendBuffer.prototype.count.
// Removed Stub for BaseSendBuffer.prototype.size.
// Removed Stub for BaseSendBuffer.prototype.clear.
// Removed Stub for BaseSendBuffer.prototype.getItems.
// Removed Stub for BaseSendBuffer.prototype.batchPayloads.
// Removed Stub for BaseSendBuffer.prototype.createNew.
    // This is a workaround for an IE bug when using dynamicProto() with classes that don't have any
    // non-dynamic functions or static properties/functions when using uglify-js to minify the resulting code.
    BaseSendBuffer.__ieDyn=1;

    return BaseSendBuffer;
}());
/*
 * An array based send buffer.
 */
var ArraySendBuffer = /** @class */ (function (_super) {
    __extendsFn(ArraySendBuffer, _super);
    function ArraySendBuffer(logger, config) {
        var _this = _super.call(this, logger, config) || this;
        dynamicProto(ArraySendBuffer, _this, function (_self, _base) {
            _self[_DYN_MARK_AS_SENT /* @min:%2emarkAsSent */] = function (payload) {
                _base[_DYN_CLEAR /* @min:%2eclear */]();
            };
            _self[_DYN_CLEAR_SENT /* @min:%2eclearSent */] = function (payload) {
                // not supported
            };
        });
        return _this;
    }
// Removed Stub for ArraySendBuffer.prototype.markAsSent.
// Removed Stub for ArraySendBuffer.prototype.clearSent.
    // This is a workaround for an IE bug when using dynamicProto() with classes that don't have any
    // non-dynamic functions or static properties/functions when using uglify-js to minify the resulting code.
    ArraySendBuffer.__ieDyn=1;

    return ArraySendBuffer;
}(BaseSendBuffer));
/*
 * Session storage buffer holds a copy of all unsent items in the browser session storage.
 */
var SessionStorageSendBuffer = /** @class */ (function (_super) {
    __extendsFn(SessionStorageSendBuffer, _super);
    function SessionStorageSendBuffer(logger, config) {
        var _this = _super.call(this, logger, config) || this;
        var _bufferFullMessageSent = false;
        //Note: should not use config.namePrefix directly, because it will always refers to the latest namePrefix
        var _namePrefix = config === null || config === void 0 ? void 0 : config.namePrefix;
        var _a = config[_DYN_BUFFER_OVERRIDE /* @min:%2ebufferOverride */] || { getItem: utlGetSessionStorage, setItem: utlSetSessionStorage }, getItem = _a.getItem, setItem = _a.setItem;
        dynamicProto(SessionStorageSendBuffer, _this, function (_self, _base) {
            var bufferItems = _getBuffer(SessionStorageSendBuffer[_DYN__BUFFER__KEY /* @min:%2eBUFFER_KEY */]);
            var notDeliveredItems = _getBuffer(SessionStorageSendBuffer[_DYN__SENT__BUFFER__KEY /* @min:%2eSENT_BUFFER_KEY */]);
            var buffer = _self._set(bufferItems.concat(notDeliveredItems));
            // If the buffer has too many items, drop items from the end.
            if (buffer[_DYN_LENGTH$2 /* @min:%2elength */] > SessionStorageSendBuffer[_DYN__MAX__BUFFER__SIZE /* @min:%2eMAX_BUFFER_SIZE */]) {
                buffer[_DYN_LENGTH$2 /* @min:%2elength */] = SessionStorageSendBuffer[_DYN__MAX__BUFFER__SIZE /* @min:%2eMAX_BUFFER_SIZE */];
            }
            _setBuffer(SessionStorageSendBuffer[_DYN__SENT__BUFFER__KEY /* @min:%2eSENT_BUFFER_KEY */], []);
            _setBuffer(SessionStorageSendBuffer[_DYN__BUFFER__KEY /* @min:%2eBUFFER_KEY */], buffer);
            _self[_DYN_ENQUEUE /* @min:%2eenqueue */] = function (payload) {
                if (_self[_DYN_COUNT /* @min:%2ecount */]() >= SessionStorageSendBuffer[_DYN__MAX__BUFFER__SIZE /* @min:%2eMAX_BUFFER_SIZE */]) {
                    // sent internal log only once per page view
                    if (!_bufferFullMessageSent) {
                        _throwInternal(logger, 2 /* eLoggingSeverity.WARNING */, 67 /* _eInternalMessageId.SessionStorageBufferFull */, "Maximum buffer size reached: " + _self[_DYN_COUNT /* @min:%2ecount */](), true);
                        _bufferFullMessageSent = true;
                    }
                    return;
                }
                _base[_DYN_ENQUEUE /* @min:%2eenqueue */](payload);
                _setBuffer(SessionStorageSendBuffer.BUFFER_KEY, _self[_DYN__GET /* @min:%2e_get */]());
            };
            _self[_DYN_CLEAR /* @min:%2eclear */] = function () {
                _base[_DYN_CLEAR /* @min:%2eclear */]();
                _setBuffer(SessionStorageSendBuffer.BUFFER_KEY, _self[_DYN__GET /* @min:%2e_get */]());
                _setBuffer(SessionStorageSendBuffer[_DYN__SENT__BUFFER__KEY /* @min:%2eSENT_BUFFER_KEY */], []);
                _bufferFullMessageSent = false;
            };
            _self[_DYN_MARK_AS_SENT /* @min:%2emarkAsSent */] = function (payload) {
                _setBuffer(SessionStorageSendBuffer[_DYN__BUFFER__KEY /* @min:%2eBUFFER_KEY */], _self._set(_removePayloadsFromBuffer(payload, _self[_DYN__GET /* @min:%2e_get */]())));
                var sentElements = _getBuffer(SessionStorageSendBuffer[_DYN__SENT__BUFFER__KEY /* @min:%2eSENT_BUFFER_KEY */]);
                if (sentElements instanceof Array && payload instanceof Array) {
                    sentElements = sentElements.concat(payload);
                    if (sentElements[_DYN_LENGTH$2 /* @min:%2elength */] > SessionStorageSendBuffer[_DYN__MAX__BUFFER__SIZE /* @min:%2eMAX_BUFFER_SIZE */]) {
                        // We send telemetry normally. If the SENT_BUFFER is too big we don't add new elements
                        // until we receive a response from the backend and the buffer has free space again (see clearSent method)
                        _throwInternal(logger, 1 /* eLoggingSeverity.CRITICAL */, 67 /* _eInternalMessageId.SessionStorageBufferFull */, "Sent buffer reached its maximum size: " + sentElements[_DYN_LENGTH$2 /* @min:%2elength */], true);
                        sentElements[_DYN_LENGTH$2 /* @min:%2elength */] = SessionStorageSendBuffer[_DYN__MAX__BUFFER__SIZE /* @min:%2eMAX_BUFFER_SIZE */];
                    }
                    _setBuffer(SessionStorageSendBuffer[_DYN__SENT__BUFFER__KEY /* @min:%2eSENT_BUFFER_KEY */], sentElements);
                }
            };
            _self[_DYN_CLEAR_SENT /* @min:%2eclearSent */] = function (payload) {
                var sentElements = _getBuffer(SessionStorageSendBuffer[_DYN__SENT__BUFFER__KEY /* @min:%2eSENT_BUFFER_KEY */]);
                sentElements = _removePayloadsFromBuffer(payload, sentElements);
                _setBuffer(SessionStorageSendBuffer[_DYN__SENT__BUFFER__KEY /* @min:%2eSENT_BUFFER_KEY */], sentElements);
            };
            _self[_DYN_CREATE_NEW /* @min:%2ecreateNew */] = function (newLogger, newConfig, canUseSessionStorage) {
                canUseSessionStorage = !!canUseSessionStorage;
                var unsentItems = _self[_DYN__GET /* @min:%2e_get */]().slice(0);
                var sentItems = _getBuffer(SessionStorageSendBuffer[_DYN__SENT__BUFFER__KEY /* @min:%2eSENT_BUFFER_KEY */]).slice(0);
                newLogger = newLogger || logger;
                newConfig = newConfig || {};
                // to make sure that we do not send duplicated payloads when it is switched back to previous one
                _self[_DYN_CLEAR /* @min:%2eclear */]();
                var newBuffer = canUseSessionStorage ? new SessionStorageSendBuffer(newLogger, newConfig) : new ArraySendBuffer(newLogger, newConfig);
                arrForEach(unsentItems, function (payload) {
                    newBuffer[_DYN_ENQUEUE /* @min:%2eenqueue */](payload);
                });
                if (canUseSessionStorage) {
                    // arr buffer will clear all payloads if markAsSent() is called
                    newBuffer[_DYN_MARK_AS_SENT /* @min:%2emarkAsSent */](sentItems);
                }
                return newBuffer;
            };
            function _removePayloadsFromBuffer(payloads, buffer) {
                var remaining = [];
                arrForEach(buffer, function (value) {
                    if (!isFunction(value) && arrIndexOf(payloads, value) === -1) {
                        remaining[_DYN_PUSH /* @min:%2epush */](value);
                    }
                });
                return remaining;
            }
            function _getBuffer(key) {
                var prefixedKey = key;
                try {
                    prefixedKey = _namePrefix ? _namePrefix + "_" + prefixedKey : prefixedKey;
                    var bufferJson = getItem(logger, prefixedKey);
                    if (bufferJson) {
                        var buffer_1 = getJSON().parse(bufferJson);
                        if (isString(buffer_1)) {
                            // When using some version prototype.js the stringify / parse cycle does not decode array's correctly
                            buffer_1 = getJSON().parse(buffer_1);
                        }
                        if (buffer_1 && isArray(buffer_1)) {
                            return buffer_1;
                        }
                    }
                }
                catch (e) {
                    _throwInternal(logger, 1 /* eLoggingSeverity.CRITICAL */, 42 /* _eInternalMessageId.FailedToRestoreStorageBuffer */, " storage key: " + prefixedKey + ", " + getExceptionName(e), { exception: dumpObj(e) });
                }
                return [];
            }
            function _setBuffer(key, buffer) {
                var prefixedKey = key;
                try {
                    prefixedKey = _namePrefix ? _namePrefix + "_" + prefixedKey : prefixedKey;
                    var bufferJson = JSON[_DYN_STRINGIFY /* @min:%2estringify */](buffer);
                    setItem(logger, prefixedKey, bufferJson);
                }
                catch (e) {
                    // if there was an error, clear the buffer
                    // telemetry is stored in the _buffer array so we won't loose any items
                    setItem(logger, prefixedKey, JSON[_DYN_STRINGIFY /* @min:%2estringify */]([]));
                    _throwInternal(logger, 2 /* eLoggingSeverity.WARNING */, 41 /* _eInternalMessageId.FailedToSetStorageBuffer */, " storage key: " + prefixedKey + ", " + getExceptionName(e) + ". Buffer cleared", { exception: dumpObj(e) });
                }
            }
        });
        return _this;
    }
// Removed Stub for SessionStorageSendBuffer.prototype.enqueue.
// Removed Stub for SessionStorageSendBuffer.prototype.clear.
// Removed Stub for SessionStorageSendBuffer.prototype.markAsSent.
// Removed Stub for SessionStorageSendBuffer.prototype.clearSent.
// Removed Stub for SessionStorageSendBuffer.prototype.createNew.
    SessionStorageSendBuffer.BUFFER_KEY = "AI_buffer";
    SessionStorageSendBuffer.SENT_BUFFER_KEY = "AI_sentBuffer";
    // Maximum number of payloads stored in the buffer. If the buffer is full, new elements will be dropped.
    SessionStorageSendBuffer.MAX_BUFFER_SIZE = 2000;
    return SessionStorageSendBuffer;
}(BaseSendBuffer));

/*
 * Application Insights JavaScript SDK - Channel, 3.0.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */
var Serializer = /** @class */ (function () {
    function Serializer(logger) {
        dynamicProto(Serializer, this, function (_self) {
            /**
             * Serializes the current object to a JSON string.
             */
            _self.serialize = function (input) {
                var output = _serializeObject(input, "root");
                try {
                    return getJSON()[_DYN_STRINGIFY /* @min:%2estringify */](output);
                }
                catch (e) {
                    // if serialization fails return an empty string
                    _throwInternal(logger, 1 /* eLoggingSeverity.CRITICAL */, 48 /* _eInternalMessageId.CannotSerializeObject */, (e && isFunction(e[_DYN_TO_STRING /* @min:%2etoString */])) ? e[_DYN_TO_STRING /* @min:%2etoString */]() : "Error serializing object", null, true);
                }
            };
            function _serializeObject(source, name) {
                var circularReferenceCheck = "__aiCircularRefCheck";
                var output = {};
                if (!source) {
                    _throwInternal(logger, 1 /* eLoggingSeverity.CRITICAL */, 48 /* _eInternalMessageId.CannotSerializeObject */, "cannot serialize object because it is null or undefined", { name: name }, true);
                    return output;
                }
                if (source[circularReferenceCheck]) {
                    _throwInternal(logger, 2 /* eLoggingSeverity.WARNING */, 50 /* _eInternalMessageId.CircularReferenceDetected */, "Circular reference detected while serializing object", { name: name }, true);
                    return output;
                }
                if (!source.aiDataContract) {
                    // special case for measurements/properties/tags
                    if (name === "measurements") {
                        output = _serializeStringMap(source, "number", name);
                    }
                    else if (name === "properties") {
                        output = _serializeStringMap(source, "string", name);
                    }
                    else if (name === "tags") {
                        output = _serializeStringMap(source, "string", name);
                    }
                    else if (isArray(source)) {
                        output = _serializeArray(source, name);
                    }
                    else {
                        _throwInternal(logger, 2 /* eLoggingSeverity.WARNING */, 49 /* _eInternalMessageId.CannotSerializeObjectNonSerializable */, "Attempting to serialize an object which does not implement ISerializable", { name: name }, true);
                        try {
                            // verify that the object can be stringified
                            getJSON()[_DYN_STRINGIFY /* @min:%2estringify */](source);
                            output = source;
                        }
                        catch (e) {
                            // if serialization fails return an empty string
                            _throwInternal(logger, 1 /* eLoggingSeverity.CRITICAL */, 48 /* _eInternalMessageId.CannotSerializeObject */, (e && isFunction(e[_DYN_TO_STRING /* @min:%2etoString */])) ? e[_DYN_TO_STRING /* @min:%2etoString */]() : "Error serializing object", null, true);
                        }
                    }
                    return output;
                }
                source[circularReferenceCheck] = true;
                objForEachKey(source.aiDataContract, function (field, contract) {
                    var isRequired = (isFunction(contract)) ? (contract() & 1 /* FieldType.Required */) : (contract & 1 /* FieldType.Required */);
                    var isHidden = (isFunction(contract)) ? (contract() & 4 /* FieldType.Hidden */) : (contract & 4 /* FieldType.Hidden */);
                    var isArray = contract & 2 /* FieldType.Array */;
                    var isPresent = source[field] !== undefined;
                    var isObj = isObject(source[field]) && source[field] !== null;
                    if (isRequired && !isPresent && !isArray) {
                        _throwInternal(logger, 1 /* eLoggingSeverity.CRITICAL */, 24 /* _eInternalMessageId.MissingRequiredFieldSpecification */, "Missing required field specification. The field is required but not present on source", { field: field, name: name });
                        // If not in debug mode, continue and hope the error is permissible
                    }
                    else if (!isHidden) { // Don't serialize hidden fields
                        var value = void 0;
                        if (isObj) {
                            if (isArray) {
                                // special case; recurse on each object in the source array
                                value = _serializeArray(source[field], field);
                            }
                            else {
                                // recurse on the source object in this field
                                value = _serializeObject(source[field], field);
                            }
                        }
                        else {
                            // assign the source field to the output even if undefined or required
                            value = source[field];
                        }
                        // only emit this field if the value is defined
                        if (value !== undefined) {
                            output[field] = value;
                        }
                    }
                });
                delete source[circularReferenceCheck];
                return output;
            }
            function _serializeArray(sources, name) {
                var output;
                if (!!sources) {
                    if (!isArray(sources)) {
                        _throwInternal(logger, 1 /* eLoggingSeverity.CRITICAL */, 54 /* _eInternalMessageId.ItemNotInArray */, "This field was specified as an array in the contract but the item is not an array.\r\n", { name: name }, true);
                    }
                    else {
                        output = [];
                        for (var i = 0; i < sources[_DYN_LENGTH$2 /* @min:%2elength */]; i++) {
                            var source = sources[i];
                            var item = _serializeObject(source, name + "[" + i + "]");
                            output[_DYN_PUSH /* @min:%2epush */](item);
                        }
                    }
                }
                return output;
            }
            function _serializeStringMap(map, expectedType, name) {
                var output;
                if (map) {
                    output = {};
                    objForEachKey(map, function (field, value) {
                        if (expectedType === "string") {
                            if (value === undefined) {
                                output[field] = "undefined";
                            }
                            else if (value === null) {
                                output[field] = "null";
                            }
                            else if (!value[_DYN_TO_STRING /* @min:%2etoString */]) {
                                output[field] = "invalid field: toString() is not defined.";
                            }
                            else {
                                output[field] = value[_DYN_TO_STRING /* @min:%2etoString */]();
                            }
                        }
                        else if (expectedType === "number") {
                            if (value === undefined) {
                                output[field] = "undefined";
                            }
                            else if (value === null) {
                                output[field] = "null";
                            }
                            else {
                                var num = parseFloat(value);
                                if (isNaN(num)) {
                                    output[field] = "NaN";
                                }
                                else {
                                    output[field] = num;
                                }
                            }
                        }
                        else {
                            output[field] = "invalid field: " + name + " is of unknown type.";
                            _throwInternal(logger, 1 /* eLoggingSeverity.CRITICAL */, output[field], null, true);
                        }
                    });
                }
                return output;
            }
        });
    }
// Removed Stub for Serializer.prototype.serialize.
    // This is a workaround for an IE bug when using dynamicProto() with classes that don't have any
    // non-dynamic functions or static properties/functions when using uglify-js to minify the resulting code.
    Serializer.__ieDyn=1;

    return Serializer;
}());

/*
 * Application Insights JavaScript SDK - Channel, 3.0.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */

// (Magic number) DJB algorithm can't work on shorter strings (results in poor distribution
var MIN_INPUT_LENGTH = 8;
var HashCodeScoreGenerator = /** @class */ (function () {
    function HashCodeScoreGenerator() {
    }
    HashCodeScoreGenerator.prototype.getHashCodeScore = function (key) {
        var score = this.getHashCode(key) / HashCodeScoreGenerator.INT_MAX_VALUE;
        return score * 100;
    };
    HashCodeScoreGenerator.prototype.getHashCode = function (input) {
        if (input === "") {
            return 0;
        }
        while (input[_DYN_LENGTH$2 /* @min:%2elength */] < MIN_INPUT_LENGTH) {
            input = input.concat(input);
        }
        // 5381 is a magic number: http://stackoverflow.com/questions/10696223/reason-for-5381-number-in-djb-hash-function
        var hash = 5381;
        for (var i = 0; i < input[_DYN_LENGTH$2 /* @min:%2elength */]; ++i) {
            hash = ((hash << 5) + hash) + input.charCodeAt(i);
            // 'hash' is of number type which means 53 bit integer (http://www.ecma-international.org/ecma-262/6.0/#sec-ecmascript-language-types-number-type)
            // 'hash & hash' will keep it 32 bit integer - just to make it clearer what the result is.
            hash = hash & hash;
        }
        return Math.abs(hash);
    };
    // We're using 32 bit math, hence max value is (2^31 - 1)
    HashCodeScoreGenerator.INT_MAX_VALUE = 2147483647;
    return HashCodeScoreGenerator;
}());

/*
 * Application Insights JavaScript SDK - Channel, 3.0.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */

var SamplingScoreGenerator = /** @class */ (function () {
    function SamplingScoreGenerator() {
        var _self = this;
        var hashCodeGenerator = new HashCodeScoreGenerator();
        var keys = new ContextTagKeys();
        _self[_DYN_GET_SAMPLING_SCORE /* @min:%2egetSamplingScore */] = function (item) {
            var score = 0;
            if (item[_DYN_TAGS /* @min:%2etags */] && item[_DYN_TAGS /* @min:%2etags */][keys.userId]) { // search in tags first, then ext
                score = hashCodeGenerator.getHashCodeScore(item[_DYN_TAGS /* @min:%2etags */][keys.userId]);
            }
            else if (item.ext && item.ext.user && item.ext.user.id) {
                score = hashCodeGenerator[_DYN_GET_HASH_CODE_SCORE /* @min:%2egetHashCodeScore */](item.ext.user.id);
            }
            else if (item[_DYN_TAGS /* @min:%2etags */] && item[_DYN_TAGS /* @min:%2etags */][keys.operationId]) { // search in tags first, then ext
                score = hashCodeGenerator.getHashCodeScore(item[_DYN_TAGS /* @min:%2etags */][keys.operationId]);
            }
            else if (item.ext && item.ext.telemetryTrace && item.ext.telemetryTrace[_DYN_TRACE_ID$1 /* @min:%2etraceID */]) {
                score = hashCodeGenerator.getHashCodeScore(item.ext.telemetryTrace[_DYN_TRACE_ID$1 /* @min:%2etraceID */]);
            }
            else {
                // tslint:disable-next-line:insecure-random
                score = (Math.random() * 100);
            }
            return score;
        };
    }
    return SamplingScoreGenerator;
}());

/*
 * Application Insights JavaScript SDK - Channel, 3.0.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */

var Sample = /** @class */ (function () {
    function Sample(sampleRate, logger) {
        // We're using 32 bit math, hence max value is (2^31 - 1)
        this.INT_MAX_VALUE = 2147483647;
        var _logger = logger || safeGetLogger(null);
        if (sampleRate > 100 || sampleRate < 0) {
            _logger.throwInternal(2 /* eLoggingSeverity.WARNING */, 58 /* _eInternalMessageId.SampleRateOutOfRange */, "Sampling rate is out of range (0..100). Sampling will be disabled, you may be sending too much data which may affect your AI service level.", { samplingRate: sampleRate }, true);
            sampleRate = 100;
        }
        this[_DYN_SAMPLE_RATE /* @min:%2esampleRate */] = sampleRate;
        this.samplingScoreGenerator = new SamplingScoreGenerator();
    }
    /**
    * Determines if an envelope is sampled in (i.e. will be sent) or not (i.e. will be dropped).
    */
    Sample.prototype.isSampledIn = function (envelope) {
        var samplingPercentage = this[_DYN_SAMPLE_RATE /* @min:%2esampleRate */]; // 0 - 100
        var isSampledIn = false;
        if (samplingPercentage === null || samplingPercentage === undefined || samplingPercentage >= 100) {
            return true;
        }
        else if (envelope.baseType === Metric[_DYN_DATA_TYPE /* @min:%2edataType */]) {
            // exclude MetricData telemetry from sampling
            return true;
        }
        isSampledIn = this.samplingScoreGenerator[_DYN_GET_SAMPLING_SCORE /* @min:%2egetSamplingScore */](envelope) < samplingPercentage;
        return isSampledIn;
    };
    return Sample;
}());

/*
 * Application Insights JavaScript SDK - Channel, 3.0.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */
var _a$4, _b$1;
var UNDEFINED_VALUE$1 = undefined;
var FetchSyncRequestSizeLimitBytes = 65000; // approx 64kb (the current Edge, Firefox and Chrome max limit)
function _getResponseText(xhr) {
    try {
        return xhr.responseText;
    }
    catch (e) {
        // Best effort, as XHR may throw while XDR wont so just ignore
    }
    return null;
}
var defaultAppInsightsChannelConfig = objDeepFreeze((_a$4 = {
        // Use the default value (handles empty string in the configuration)
        endpointUrl: cfgDfValidate(isTruthy, DEFAULT_BREEZE_ENDPOINT + DEFAULT_BREEZE_PATH)
    },
    _a$4[_DYN_EMIT_LINE_DELIMITED_0 /* @min:emitLineDelimitedJson */] = cfgDfBoolean(),
    _a$4[_DYN_MAX_BATCH_INTERVAL /* @min:maxBatchInterval */] = 15000,
    _a$4[_DYN_MAX_BATCH_SIZE_IN_BY1 /* @min:maxBatchSizeInBytes */] = 102400,
    _a$4.disableTelemetry = cfgDfBoolean(),
    _a$4[_DYN_ENABLE_SESSION_STORA4 /* @min:enableSessionStorageBuffer */] = cfgDfBoolean(true),
    _a$4.isRetryDisabled = cfgDfBoolean(),
    _a$4[_DYN_IS_BEACON_API_DISABL3 /* @min:isBeaconApiDisabled */] = cfgDfBoolean(true),
    _a$4[_DYN_DISABLE_XHR /* @min:disableXhr */] = cfgDfBoolean(),
    _a$4[_DYN_ONUNLOAD_DISABLE_FET5 /* @min:onunloadDisableFetch */] = cfgDfBoolean(),
    _a$4[_DYN_ONUNLOAD_DISABLE_BEA2 /* @min:onunloadDisableBeacon */] = cfgDfBoolean(),
    _a$4[_DYN_INSTRUMENTATION_KEY$1 /* @min:instrumentationKey */] = UNDEFINED_VALUE$1,
    _a$4.namePrefix = UNDEFINED_VALUE$1,
    _a$4.samplingPercentage = cfgDfValidate(_chkSampling, 100),
    _a$4[_DYN_CUSTOM_HEADERS /* @min:customHeaders */] = UNDEFINED_VALUE$1,
    _a$4[_DYN_CONVERT_UNDEFINED /* @min:convertUndefined */] = UNDEFINED_VALUE$1,
    _a$4[_DYN_EVENTS_LIMIT_IN_MEM /* @min:eventsLimitInMem */] = 10000,
    _a$4[_DYN_BUFFER_OVERRIDE /* @min:bufferOverride */] = false,
    _a$4));
function _chkSampling(value) {
    return !isNaN(value) && value > 0 && value <= 100;
}
var EnvelopeTypeCreator = (_b$1 = {},
    _b$1[Event$1.dataType] = EventEnvelopeCreator,
    _b$1[Trace.dataType] = TraceEnvelopeCreator,
    _b$1[PageView.dataType] = PageViewEnvelopeCreator,
    _b$1[PageViewPerformance.dataType] = PageViewPerformanceEnvelopeCreator,
    _b$1[Exception.dataType] = ExceptionEnvelopeCreator,
    _b$1[Metric.dataType] = MetricEnvelopeCreator,
    _b$1[RemoteDependencyData.dataType] = DependencyEnvelopeCreator,
    _b$1);
var Sender = /** @class */ (function (_super) {
    __extendsFn(Sender, _super);
    function Sender() {
        var _this = _super.call(this) || this;
        _this.priority = 1001;
        _this.identifier = BreezeChannelIdentifier;
        // Don't set the defaults here, set them in the _initDefaults() as this is also called during unload
        var _consecutiveErrors; // How many times in a row a retryable error condition has occurred.
        var _retryAt; // The time to retry at in milliseconds from 1970/01/01 (this makes the timer calculation easy).
        var _lastSend; // The time of the last send operation.
        var _paused; // Flag indicating that the sending should be paused
        var _timeoutHandle; // Handle to the timer for delayed sending of batches of data.
        var _serializer;
        var _stamp_specific_redirects;
        var _headers;
        var _syncFetchPayload = 0; // Keep track of the outstanding sync fetch payload total (as sync fetch has limits)
        var _fallbackSender; // The sender to use if the payload size is too large
        var _syncUnloadSender; // The identified sender to use for the synchronous unload stage
        var _offlineListener;
        var _evtNamespace;
        var _endpointUrl;
        var _orgEndpointUrl;
        var _maxBatchSizeInBytes;
        var _beaconSupported;
        var _customHeaders;
        var _disableTelemetry;
        var _instrumentationKey;
        var _convertUndefined;
        var _isRetryDisabled;
        var _maxBatchInterval;
        var _sessionStorageUsed;
        var _bufferOverrideUsed;
        var _namePrefix;
        var _enableSendPromise;
        dynamicProto(Sender, _this, function (_self, _base) {
            _initDefaults();
            _self.pause = function () {
                _clearScheduledTimer();
                _paused = true;
            };
            _self.resume = function () {
                if (_paused) {
                    _paused = false;
                    _retryAt = null;
                    // flush if we have exceeded the max-size already
                    _checkMaxSize();
                    _setupTimer();
                }
            };
            _self.flush = function (isAsync, callBack, sendReason) {
                if (isAsync === void 0) { isAsync = true; }
                if (!_paused) {
                    // Clear the normal schedule timer as we are going to try and flush ASAP
                    _clearScheduledTimer();
                    try {
                        return _self[_DYN_TRIGGER_SEND /* @min:%2etriggerSend */](isAsync, null, sendReason || 1 /* SendRequestReason.ManualFlush */);
                    }
                    catch (e) {
                        _throwInternal(_self[_DYN_DIAG_LOG /* @min:%2ediagLog */](), 1 /* eLoggingSeverity.CRITICAL */, 22 /* _eInternalMessageId.FlushFailed */, "flush failed, telemetry will not be collected: " + getExceptionName(e), { exception: dumpObj(e) });
                    }
                }
            };
            _self.onunloadFlush = function () {
                if (!_paused) {
                    if (_beaconSupported) {
                        try {
                            return _self[_DYN_TRIGGER_SEND /* @min:%2etriggerSend */](true, _doUnloadSend, 2 /* SendRequestReason.Unload */);
                        }
                        catch (e) {
                            _throwInternal(_self[_DYN_DIAG_LOG /* @min:%2ediagLog */](), 1 /* eLoggingSeverity.CRITICAL */, 20 /* _eInternalMessageId.FailedToSendQueuedTelemetry */, "failed to flush with beacon sender on page unload, telemetry will not be collected: " + getExceptionName(e), { exception: dumpObj(e) });
                        }
                    }
                    else {
                        _self.flush(false);
                    }
                }
            };
            _self.addHeader = function (name, value) {
                _headers[name] = value;
            };
            _self.initialize = function (config, core, extensions, pluginChain) {
                if (_self.isInitialized()) {
                    _throwInternal(_self[_DYN_DIAG_LOG /* @min:%2ediagLog */](), 1 /* eLoggingSeverity.CRITICAL */, 28 /* _eInternalMessageId.SenderNotInitialized */, "Sender is already initialized");
                }
                _base.initialize(config, core, extensions, pluginChain);
                var identifier = _self.identifier;
                _serializer = new Serializer(core.logger);
                _consecutiveErrors = 0;
                _retryAt = null;
                _lastSend = 0;
                _self[_DYN__SENDER /* @min:%2e_sender */] = null;
                _stamp_specific_redirects = 0;
                var diagLog = _self[_DYN_DIAG_LOG /* @min:%2ediagLog */]();
                _evtNamespace = mergeEvtNamespace(createUniqueNamespace("Sender"), core.evtNamespace && core.evtNamespace());
                _offlineListener = createOfflineListener(_evtNamespace);
                // This function will be re-called whenever any referenced configuration is changed
                _self._addHook(onConfigChange(config, function (details) {
                    var config = details.cfg;
                    if (config.storagePrefix) {
                        utlSetStoragePrefix(config.storagePrefix);
                    }
                    var ctx = createProcessTelemetryContext(null, config, core);
                    var senderConfig = ctx.getExtCfg(identifier, defaultAppInsightsChannelConfig);
                    objDefine(_self, "_senderConfig", {
                        g: function () {
                            return senderConfig;
                        }
                    });
                    // Only update the endpoint if the original config !== the current config
                    // This is so any redirect endpointUrl is not overwritten
                    if (_orgEndpointUrl !== senderConfig.endpointUrl) {
                        _endpointUrl = _orgEndpointUrl = senderConfig.endpointUrl;
                    }
                    if (_customHeaders && _customHeaders !== senderConfig[_DYN_CUSTOM_HEADERS /* @min:%2ecustomHeaders */]) {
                        // Removing any previously defined custom headers as they have changed
                        arrForEach(_customHeaders, function (customHeader) {
                            delete _headers[customHeader.header];
                        });
                    }
                    _maxBatchSizeInBytes = senderConfig[_DYN_MAX_BATCH_SIZE_IN_BY1 /* @min:%2emaxBatchSizeInBytes */];
                    _beaconSupported = (senderConfig[_DYN_ONUNLOAD_DISABLE_BEA2 /* @min:%2eonunloadDisableBeacon */] === false || senderConfig[_DYN_IS_BEACON_API_DISABL3 /* @min:%2eisBeaconApiDisabled */] === false) && isBeaconsSupported();
                    var bufferOverride = senderConfig[_DYN_BUFFER_OVERRIDE /* @min:%2ebufferOverride */];
                    var canUseSessionStorage = !!senderConfig[_DYN_ENABLE_SESSION_STORA4 /* @min:%2eenableSessionStorageBuffer */] &&
                        (!!bufferOverride || utlCanUseSessionStorage());
                    var namePrefix = senderConfig.namePrefix;
                    //Note: emitLineDelimitedJson and eventsLimitInMem is directly accessed via config in senderBuffer
                    //Therefore, if canUseSessionStorage is not changed, we do not need to re initialize a new one
                    var shouldUpdate = (canUseSessionStorage !== _sessionStorageUsed)
                        || (canUseSessionStorage && (_namePrefix !== namePrefix)) // prefixName is only used in session storage
                        || (canUseSessionStorage && (_bufferOverrideUsed !== bufferOverride));
                    if (_self[_DYN__BUFFER /* @min:%2e_buffer */]) {
                        // case1 (Pre and Now enableSessionStorageBuffer settings are same)
                        // if namePrefix changes, transfer current buffer to new buffer
                        // else no action needed
                        //case2 (Pre and Now enableSessionStorageBuffer settings are changed)
                        // transfer current buffer to new buffer
                        if (shouldUpdate) {
                            try {
                                _self._buffer = _self._buffer[_DYN_CREATE_NEW /* @min:%2ecreateNew */](diagLog, senderConfig, canUseSessionStorage);
                            }
                            catch (e) {
                                _throwInternal(_self[_DYN_DIAG_LOG /* @min:%2ediagLog */](), 1 /* eLoggingSeverity.CRITICAL */, 12 /* _eInternalMessageId.FailedAddingTelemetryToBuffer */, "failed to transfer telemetry to different buffer storage, telemetry will be lost: " + getExceptionName(e), { exception: dumpObj(e) });
                            }
                        }
                        _checkMaxSize();
                    }
                    else {
                        _self[_DYN__BUFFER /* @min:%2e_buffer */] = canUseSessionStorage
                            ? new SessionStorageSendBuffer(diagLog, senderConfig) : new ArraySendBuffer(diagLog, senderConfig);
                    }
                    _namePrefix = namePrefix;
                    _sessionStorageUsed = canUseSessionStorage;
                    _bufferOverrideUsed = bufferOverride;
                    _self._sample = new Sample(senderConfig.samplingPercentage, diagLog);
                    _instrumentationKey = senderConfig[_DYN_INSTRUMENTATION_KEY$1 /* @min:%2einstrumentationKey */];
                    if (!_validateInstrumentationKey(_instrumentationKey, config)) {
                        _throwInternal(diagLog, 1 /* eLoggingSeverity.CRITICAL */, 100 /* _eInternalMessageId.InvalidInstrumentationKey */, "Invalid Instrumentation key " + _instrumentationKey);
                    }
                    _customHeaders = senderConfig[_DYN_CUSTOM_HEADERS /* @min:%2ecustomHeaders */];
                    if (!isInternalApplicationInsightsEndpoint(_endpointUrl) && _customHeaders && _customHeaders[_DYN_LENGTH$2 /* @min:%2elength */] > 0) {
                        arrForEach(_customHeaders, function (customHeader) {
                            _this.addHeader(customHeader.header, customHeader.value);
                        });
                    }
                    else {
                        _customHeaders = null;
                    }
                    _enableSendPromise = senderConfig.enableSendPromise;
                    var sendPostFunc = null;
                    if (!senderConfig[_DYN_DISABLE_XHR /* @min:%2edisableXhr */] && useXDomainRequest()) {
                        sendPostFunc = _xdrSender; // IE 8 and 9
                    }
                    else if (!senderConfig[_DYN_DISABLE_XHR /* @min:%2edisableXhr */] && isXhrSupported()) {
                        sendPostFunc = _xhrSender;
                    }
                    if (!sendPostFunc && isFetchSupported()) {
                        sendPostFunc = _fetchSender;
                    }
                    // always fallback to XHR
                    _fallbackSender = sendPostFunc || _xhrSender;
                    if (!senderConfig[_DYN_IS_BEACON_API_DISABL3 /* @min:%2eisBeaconApiDisabled */] && isBeaconsSupported()) {
                        // Config is set to always used beacon sending
                        sendPostFunc = _beaconSender;
                    }
                    _self[_DYN__SENDER /* @min:%2e_sender */] = sendPostFunc || _xhrSender;
                    if (!senderConfig[_DYN_ONUNLOAD_DISABLE_FET5 /* @min:%2eonunloadDisableFetch */] && isFetchSupported(true)) {
                        // Try and use the fetch with keepalive
                        _syncUnloadSender = _fetchKeepAliveSender;
                    }
                    else if (isBeaconsSupported()) {
                        // Try and use sendBeacon
                        _syncUnloadSender = _beaconSender;
                    }
                    else if (!senderConfig[_DYN_DISABLE_XHR /* @min:%2edisableXhr */] && useXDomainRequest()) {
                        _syncUnloadSender = _xdrSender; // IE 8 and 9
                    }
                    else if (!senderConfig[_DYN_DISABLE_XHR /* @min:%2edisableXhr */] && isXhrSupported()) {
                        _syncUnloadSender = _xhrSender;
                    }
                    else {
                        _syncUnloadSender = _fallbackSender;
                    }
                    _disableTelemetry = senderConfig.disableTelemetry;
                    _convertUndefined = senderConfig[_DYN_CONVERT_UNDEFINED /* @min:%2econvertUndefined */] || UNDEFINED_VALUE$1;
                    _isRetryDisabled = senderConfig.isRetryDisabled;
                    _maxBatchInterval = senderConfig[_DYN_MAX_BATCH_INTERVAL /* @min:%2emaxBatchInterval */];
                }));
            };
            _self.processTelemetry = function (telemetryItem, itemCtx) {
                itemCtx = _self._getTelCtx(itemCtx);
                var diagLogger = itemCtx[_DYN_DIAG_LOG /* @min:%2ediagLog */]();
                try {
                    // if master off switch is set, don't send any data
                    if (_disableTelemetry) {
                        // Do not send/save data
                        return;
                    }
                    // validate input
                    if (!telemetryItem) {
                        _throwInternal(diagLogger, 1 /* eLoggingSeverity.CRITICAL */, 7 /* _eInternalMessageId.CannotSendEmptyTelemetry */, "Cannot send empty telemetry");
                        return;
                    }
                    // validate event
                    if (telemetryItem.baseData && !telemetryItem[_DYN_BASE_TYPE /* @min:%2ebaseType */]) {
                        _throwInternal(diagLogger, 1 /* eLoggingSeverity.CRITICAL */, 70 /* _eInternalMessageId.InvalidEvent */, "Cannot send telemetry without baseData and baseType");
                        return;
                    }
                    if (!telemetryItem[_DYN_BASE_TYPE /* @min:%2ebaseType */]) {
                        // Default
                        telemetryItem[_DYN_BASE_TYPE /* @min:%2ebaseType */] = "EventData";
                    }
                    // ensure a sender was constructed
                    if (!_self[_DYN__SENDER /* @min:%2e_sender */]) {
                        _throwInternal(diagLogger, 1 /* eLoggingSeverity.CRITICAL */, 28 /* _eInternalMessageId.SenderNotInitialized */, "Sender was not initialized");
                        return;
                    }
                    // check if this item should be sampled in, else add sampleRate tag
                    if (!_isSampledIn(telemetryItem)) {
                        // Item is sampled out, do not send it
                        _throwInternal(diagLogger, 2 /* eLoggingSeverity.WARNING */, 33 /* _eInternalMessageId.TelemetrySampledAndNotSent */, "Telemetry item was sampled out and not sent", { SampleRate: _self._sample[_DYN_SAMPLE_RATE /* @min:%2esampleRate */] });
                        return;
                    }
                    else {
                        telemetryItem[SampleRate] = _self._sample[_DYN_SAMPLE_RATE /* @min:%2esampleRate */];
                    }
                    // construct an envelope that Application Insights endpoint can understand
                    // if ikey of telemetry is provided and not empty, envelope will use this iKey instead of senderConfig iKey
                    var defaultEnvelopeIkey = telemetryItem.iKey || _instrumentationKey;
                    var aiEnvelope_1 = Sender.constructEnvelope(telemetryItem, defaultEnvelopeIkey, diagLogger, _convertUndefined);
                    if (!aiEnvelope_1) {
                        _throwInternal(diagLogger, 1 /* eLoggingSeverity.CRITICAL */, 47 /* _eInternalMessageId.CreateEnvelopeError */, "Unable to create an AppInsights envelope");
                        return;
                    }
                    var doNotSendItem_1 = false;
                    // this is for running in legacy mode, where customer may already have a custom initializer present
                    if (telemetryItem[_DYN_TAGS /* @min:%2etags */] && telemetryItem[_DYN_TAGS /* @min:%2etags */][ProcessLegacy]) {
                        arrForEach(telemetryItem[_DYN_TAGS /* @min:%2etags */][ProcessLegacy], function (callBack) {
                            try {
                                if (callBack && callBack(aiEnvelope_1) === false) {
                                    doNotSendItem_1 = true;
                                    _warnToConsole(diagLogger, "Telemetry processor check returns false");
                                }
                            }
                            catch (e) {
                                // log error but dont stop executing rest of the telemetry initializers
                                // doNotSendItem = true;
                                _throwInternal(diagLogger, 1 /* eLoggingSeverity.CRITICAL */, 64 /* _eInternalMessageId.TelemetryInitializerFailed */, "One of telemetry initializers failed, telemetry item will not be sent: " + getExceptionName(e), { exception: dumpObj(e) }, true);
                            }
                        });
                        delete telemetryItem[_DYN_TAGS /* @min:%2etags */][ProcessLegacy];
                    }
                    if (doNotSendItem_1) {
                        return; // do not send, no need to execute next plugin
                    }
                    // check if the incoming payload is too large, truncate if necessary
                    var payload = _serializer.serialize(aiEnvelope_1);
                    // flush if we would exceed the max-size limit by adding this item
                    var buffer = _self[_DYN__BUFFER /* @min:%2e_buffer */];
                    _checkMaxSize(payload);
                    // enqueue the payload
                    buffer[_DYN_ENQUEUE /* @min:%2eenqueue */](payload);
                    // ensure an invocation timeout is set
                    _setupTimer();
                }
                catch (e) {
                    _throwInternal(diagLogger, 2 /* eLoggingSeverity.WARNING */, 12 /* _eInternalMessageId.FailedAddingTelemetryToBuffer */, "Failed adding telemetry to the sender's buffer, some telemetry will be lost: " + getExceptionName(e), { exception: dumpObj(e) });
                }
                // hand off the telemetry item to the next plugin
                _self.processNext(telemetryItem, itemCtx);
            };
            /**
             * xhr state changes
             */
            _self[_DYN__XHR_READY_STATE_CHA6 /* @min:%2e_xhrReadyStateChange */] = function (xhr, payload, countOfItemsInPayload) {
                if (xhr.readyState === 4) {
                    _checkResponsStatus(xhr.status, payload, xhr.responseURL, countOfItemsInPayload, _formatErrorMessageXhr(xhr), _getResponseText(xhr) || xhr.response);
                }
            };
            /**
             * Immediately send buffered data
             * @param async - {boolean} - Indicates if the events should be sent asynchronously
             * @param forcedSender - {SenderFunction} - Indicates the forcedSender, undefined if not passed
             */
            _self[_DYN_TRIGGER_SEND /* @min:%2etriggerSend */] = function (async, forcedSender, sendReason) {
                if (async === void 0) { async = true; }
                var result;
                if (!_paused) {
                    try {
                        var buffer = _self[_DYN__BUFFER /* @min:%2e_buffer */];
                        // Send data only if disableTelemetry is false
                        if (!_disableTelemetry) {
                            if (buffer[_DYN_COUNT /* @min:%2ecount */]() > 0) {
                                var payload = buffer.getItems();
                                _notifySendRequest(sendReason || 0 /* SendRequestReason.Undefined */, async);
                                // invoke send
                                if (forcedSender) {
                                    result = forcedSender.call(_self, payload, async);
                                }
                                else {
                                    result = _self[_DYN__SENDER /* @min:%2e_sender */](payload, async);
                                }
                            }
                            // update lastSend time to enable throttling
                            _lastSend = +new Date;
                        }
                        else {
                            buffer[_DYN_CLEAR /* @min:%2eclear */]();
                        }
                        _clearScheduledTimer();
                    }
                    catch (e) {
                        /* Ignore this error for IE under v10 */
                        var ieVer = getIEVersion();
                        if (!ieVer || ieVer > 9) {
                            _throwInternal(_self[_DYN_DIAG_LOG /* @min:%2ediagLog */](), 1 /* eLoggingSeverity.CRITICAL */, 40 /* _eInternalMessageId.TransmissionFailed */, "Telemetry transmission failed, some telemetry will be lost: " + getExceptionName(e), { exception: dumpObj(e) });
                        }
                    }
                }
                return result;
            };
            _self._doTeardown = function (unloadCtx, unloadState) {
                _self.onunloadFlush();
                runTargetUnload(_offlineListener, false);
                _initDefaults();
            };
            /**
             * error handler
             */
            _self[_DYN__ON_ERROR /* @min:%2e_onError */] = function (payload, message, event) {
                _throwInternal(_self[_DYN_DIAG_LOG /* @min:%2ediagLog */](), 2 /* eLoggingSeverity.WARNING */, 26 /* _eInternalMessageId.OnError */, "Failed to send telemetry.", { message: message });
                _self._buffer && _self._buffer[_DYN_CLEAR_SENT /* @min:%2eclearSent */](payload);
            };
            /**
             * partial success handler
             */
            _self[_DYN__ON_PARTIAL_SUCCESS /* @min:%2e_onPartialSuccess */] = function (payload, results) {
                var failed = [];
                var retry = [];
                // Iterate through the reversed array of errors so that splicing doesn't have invalid indexes after the first item.
                var errors = results.errors.reverse();
                for (var _i = 0, errors_1 = errors; _i < errors_1.length; _i++) {
                    var error = errors_1[_i];
                    var extracted = payload.splice(error.index, 1)[0];
                    if (_isRetriable(error.statusCode)) {
                        retry[_DYN_PUSH /* @min:%2epush */](extracted);
                    }
                    else {
                        // All other errors, including: 402 (Monthly quota exceeded) and 439 (Too many requests and refresh cache).
                        failed[_DYN_PUSH /* @min:%2epush */](extracted);
                    }
                }
                if (payload[_DYN_LENGTH$2 /* @min:%2elength */] > 0) {
                    _self[_DYN__ON_SUCCESS /* @min:%2e_onSuccess */](payload, results[_DYN_ITEMS_ACCEPTED /* @min:%2eitemsAccepted */]);
                }
                if (failed[_DYN_LENGTH$2 /* @min:%2elength */] > 0) {
                    _self[_DYN__ON_ERROR /* @min:%2e_onError */](failed, _formatErrorMessageXhr(null, ["partial success", results[_DYN_ITEMS_ACCEPTED /* @min:%2eitemsAccepted */], "of", results.itemsReceived].join(" ")));
                }
                if (retry[_DYN_LENGTH$2 /* @min:%2elength */] > 0) {
                    _resendPayload(retry);
                    _throwInternal(_self[_DYN_DIAG_LOG /* @min:%2ediagLog */](), 2 /* eLoggingSeverity.WARNING */, 40 /* _eInternalMessageId.TransmissionFailed */, "Partial success. " +
                        "Delivered: " + payload[_DYN_LENGTH$2 /* @min:%2elength */] + ", Failed: " + failed[_DYN_LENGTH$2 /* @min:%2elength */] +
                        ". Will retry to send " + retry[_DYN_LENGTH$2 /* @min:%2elength */] + " our of " + results[_DYN_ITEMS_RECEIVED /* @min:%2eitemsReceived */] + " items");
                }
            };
            /**
             * success handler
             */
            _self[_DYN__ON_SUCCESS /* @min:%2e_onSuccess */] = function (payload, countOfItemsInPayload) {
                _self._buffer && _self._buffer[_DYN_CLEAR_SENT /* @min:%2eclearSent */](payload);
            };
            /**
             * xdr state changes
             */
            _self._xdrOnLoad = function (xdr, payload) {
                var responseText = _getResponseText(xdr);
                if (xdr && (responseText + "" === "200" || responseText === "")) {
                    _consecutiveErrors = 0;
                    _self[_DYN__ON_SUCCESS /* @min:%2e_onSuccess */](payload, 0);
                }
                else {
                    var results = _parseResponse(responseText);
                    if (results && results.itemsReceived && results.itemsReceived > results[_DYN_ITEMS_ACCEPTED /* @min:%2eitemsAccepted */]
                        && !_isRetryDisabled) {
                        _self[_DYN__ON_PARTIAL_SUCCESS /* @min:%2e_onPartialSuccess */](payload, results);
                    }
                    else {
                        _self[_DYN__ON_ERROR /* @min:%2e_onError */](payload, _formatErrorMessageXdr(xdr));
                    }
                }
            };
            function _isSampledIn(envelope) {
                return _self._sample.isSampledIn(envelope);
            }
            function _checkMaxSize(incomingPayload) {
                var incomingSize = incomingPayload ? incomingPayload[_DYN_LENGTH$2 /* @min:%2elength */] : 0;
                if ((_self[_DYN__BUFFER /* @min:%2e_buffer */].size() + incomingSize) > _maxBatchSizeInBytes) {
                    if (!_offlineListener || _offlineListener[_DYN_IS_ONLINE /* @min:%2eisOnline */]()) { // only trigger send when currently online
                        _self[_DYN_TRIGGER_SEND /* @min:%2etriggerSend */](true, null, 10 /* SendRequestReason.MaxBatchSize */);
                    }
                    return true;
                }
                return false;
            }
            function _checkResponsStatus(status, payload, responseUrl, countOfItemsInPayload, errorMessage, res) {
                var response = null;
                if (!_self._appId) {
                    response = _parseResponse(res);
                    if (response && response.appId) {
                        _self._appId = response.appId;
                    }
                }
                if ((status < 200 || status >= 300) && status !== 0) {
                    // Update End Point url if permanent redirect or moved permanently
                    // Updates the end point url before retry
                    if (status === 301 || status === 307 || status === 308) {
                        if (!_checkAndUpdateEndPointUrl(responseUrl)) {
                            _self[_DYN__ON_ERROR /* @min:%2e_onError */](payload, errorMessage);
                            return;
                        }
                    }
                    if (!_isRetryDisabled && _isRetriable(status)) {
                        _resendPayload(payload);
                        _throwInternal(_self[_DYN_DIAG_LOG /* @min:%2ediagLog */](), 2 /* eLoggingSeverity.WARNING */, 40 /* _eInternalMessageId.TransmissionFailed */, ". " +
                            "Response code " + status + ". Will retry to send " + payload[_DYN_LENGTH$2 /* @min:%2elength */] + " items.");
                    }
                    else {
                        _self[_DYN__ON_ERROR /* @min:%2e_onError */](payload, errorMessage);
                    }
                }
                else if (_offlineListener && !_offlineListener[_DYN_IS_ONLINE /* @min:%2eisOnline */]()) { // offline
                    // Note: Don't check for status == 0, since adblock gives this code
                    if (!_isRetryDisabled) {
                        var offlineBackOffMultiplier = 10; // arbritrary number
                        _resendPayload(payload, offlineBackOffMultiplier);
                        _throwInternal(_self[_DYN_DIAG_LOG /* @min:%2ediagLog */](), 2 /* eLoggingSeverity.WARNING */, 40 /* _eInternalMessageId.TransmissionFailed */, ". Offline - Response Code: ".concat(status, ". Offline status: ").concat(!_offlineListener.isOnline(), ". Will retry to send ").concat(payload.length, " items."));
                    }
                }
                else {
                    // check if the xhr's responseURL or fetch's response.url is same as endpoint url
                    // TODO after 10 redirects force send telemetry with 'redirect=false' as query parameter.
                    _checkAndUpdateEndPointUrl(responseUrl);
                    if (status === 206) {
                        if (!response) {
                            response = _parseResponse(res);
                        }
                        if (response && !_isRetryDisabled) {
                            _self[_DYN__ON_PARTIAL_SUCCESS /* @min:%2e_onPartialSuccess */](payload, response);
                        }
                        else {
                            _self[_DYN__ON_ERROR /* @min:%2e_onError */](payload, errorMessage);
                        }
                    }
                    else {
                        _consecutiveErrors = 0;
                        _self[_DYN__ON_SUCCESS /* @min:%2e_onSuccess */](payload, countOfItemsInPayload);
                    }
                }
            }
            function _checkAndUpdateEndPointUrl(responseUrl) {
                // Maximum stamp specific redirects allowed(uncomment this when breeze is ready with not allowing redirects feature)
                if (_stamp_specific_redirects >= 10) {
                    //  _self._senderConfig.endpointUrl = () => Sender._getDefaultAppInsightsChannelConfig().endpointUrl()+"/?redirect=false";
                    //  _stamp_specific_redirects = 0;
                    return false;
                }
                if (!isNullOrUndefined(responseUrl) && responseUrl !== "") {
                    if (responseUrl !== _endpointUrl) {
                        _endpointUrl = responseUrl;
                        ++_stamp_specific_redirects;
                        return true;
                    }
                }
                return false;
            }
            function _doUnloadSend(payload, isAsync) {
                if (_syncUnloadSender) {
                    // We are unloading so always call the sender with sync set to false
                    _syncUnloadSender(payload, false);
                }
                else {
                    // Fallback to the previous beacon Sender (which causes a CORB warning on chrome now)
                    _beaconSender(payload);
                }
            }
            function _doBeaconSend(payload) {
                var nav = getNavigator();
                var buffer = _self[_DYN__BUFFER /* @min:%2e_buffer */];
                var url = _endpointUrl;
                var batch = _self._buffer[_DYN_BATCH_PAYLOADS /* @min:%2ebatchPayloads */](payload);
                // Chrome only allows CORS-safelisted values for the sendBeacon data argument
                // see: https://bugs.chromium.org/p/chromium/issues/detail?id=720283
                var plainTextBatch = new Blob([batch], { type: "text/plain;charset=UTF-8" });
                // The sendBeacon method returns true if the user agent is able to successfully queue the data for transfer. Otherwise it returns false.
                var queued = nav.sendBeacon(url, plainTextBatch);
                if (queued) {
                    buffer[_DYN_MARK_AS_SENT /* @min:%2emarkAsSent */](payload);
                    // no response from beaconSender, clear buffer
                    _self._onSuccess(payload, payload[_DYN_LENGTH$2 /* @min:%2elength */]);
                }
                return queued;
            }
            /**
             * Send Beacon API request
             * @param payload - {string} - The data payload to be sent.
             * @param isAsync - {boolean} - not used
             * Note: Beacon API does not support custom headers and we are not able to get
             * appId from the backend for the correct correlation.
             */
            function _beaconSender(payload, isAsync) {
                if (isArray(payload) && payload[_DYN_LENGTH$2 /* @min:%2elength */] > 0) {
                    // The sendBeacon method returns true if the user agent is able to successfully queue the data for transfer. Otherwise it returns false.
                    if (!_doBeaconSend(payload)) {
                        // Failed to send entire payload so try and split data and try to send as much events as possible
                        var droppedPayload = [];
                        for (var lp = 0; lp < payload[_DYN_LENGTH$2 /* @min:%2elength */]; lp++) {
                            var thePayload = payload[lp];
                            if (!_doBeaconSend([thePayload])) {
                                // Can't send anymore, so split the batch and drop the rest
                                droppedPayload[_DYN_PUSH /* @min:%2epush */](thePayload);
                            }
                        }
                        if (droppedPayload[_DYN_LENGTH$2 /* @min:%2elength */] > 0) {
                            _fallbackSender && _fallbackSender(droppedPayload, true);
                            _throwInternal(_self[_DYN_DIAG_LOG /* @min:%2ediagLog */](), 2 /* eLoggingSeverity.WARNING */, 40 /* _eInternalMessageId.TransmissionFailed */, ". " + "Failed to send telemetry with Beacon API, retried with normal sender.");
                        }
                    }
                }
            }
            /**
             * Send XMLHttpRequest
             * @param payload - {string} - The data payload to be sent.
             * @param isAsync - {boolean} - Indicates if the request should be sent asynchronously
             */
            function _xhrSender(payload, isAsync) {
                var thePromise;
                var resolveFunc;
                var rejectFunc;
                var xhr = new XMLHttpRequest();
                var endPointUrl = _endpointUrl;
                try {
                    xhr[DisabledPropertyName] = true;
                }
                catch (e) {
                    // If the environment has locked down the XMLHttpRequest (preventExtensions and/or freeze), this would
                    // cause the request to fail and we no telemetry would be sent
                }
                xhr.open("POST", endPointUrl, isAsync);
                xhr[_DYN_SET_REQUEST_HEADER$1 /* @min:%2esetRequestHeader */]("Content-type", "application/json");
                // append Sdk-Context request header only in case of breeze endpoint
                if (isInternalApplicationInsightsEndpoint(endPointUrl)) {
                    xhr[_DYN_SET_REQUEST_HEADER$1 /* @min:%2esetRequestHeader */](RequestHeaders[6 /* eRequestHeaders.sdkContextHeader */], RequestHeaders[7 /* eRequestHeaders.sdkContextHeaderAppIdRequest */]);
                }
                arrForEach(objKeys(_headers), function (headerName) {
                    xhr[_DYN_SET_REQUEST_HEADER$1 /* @min:%2esetRequestHeader */](headerName, _headers[headerName]);
                });
                xhr.onreadystatechange = function () {
                    _self._xhrReadyStateChange(xhr, payload, payload[_DYN_LENGTH$2 /* @min:%2elength */]);
                    if (xhr.readyState === 4) {
                        resolveFunc && resolveFunc(true);
                    }
                };
                xhr.onerror = function (event) {
                    _self[_DYN__ON_ERROR /* @min:%2e_onError */](payload, _formatErrorMessageXhr(xhr), event);
                    rejectFunc && rejectFunc(event);
                };
                if (isAsync && _enableSendPromise) {
                    thePromise = createPromise(function (resolve, reject) {
                        resolveFunc = resolve;
                        rejectFunc = reject;
                    });
                }
                // compose an array of payloads
                var batch = _self._buffer[_DYN_BATCH_PAYLOADS /* @min:%2ebatchPayloads */](payload);
                xhr.send(batch);
                _self._buffer[_DYN_MARK_AS_SENT /* @min:%2emarkAsSent */](payload);
                return thePromise;
            }
            function _fetchKeepAliveSender(payload, isAsync) {
                if (isArray(payload)) {
                    var payloadSize = payload[_DYN_LENGTH$2 /* @min:%2elength */];
                    for (var lp = 0; lp < payload[_DYN_LENGTH$2 /* @min:%2elength */]; lp++) {
                        payloadSize += payload[lp][_DYN_LENGTH$2 /* @min:%2elength */];
                    }
                    if ((_syncFetchPayload + payloadSize) <= FetchSyncRequestSizeLimitBytes) {
                        _doFetchSender(payload, false);
                    }
                    else if (isBeaconsSupported()) {
                        // Fallback to beacon sender as we at least get told which events can't be scheduled
                        _beaconSender(payload);
                    }
                    else {
                        // Payload is going to be too big so just try and send via XHR
                        _fallbackSender && _fallbackSender(payload, true);
                        _throwInternal(_self[_DYN_DIAG_LOG /* @min:%2ediagLog */](), 2 /* eLoggingSeverity.WARNING */, 40 /* _eInternalMessageId.TransmissionFailed */, ". " + "Failed to send telemetry with Beacon API, retried with xhrSender.");
                    }
                }
            }
            /**
             * Send fetch API request
             * @param payload - {string} - The data payload to be sent.
             * @param isAsync - {boolean} - not used
             */
            function _fetchSender(payload, isAsync) {
                return _doFetchSender(payload, true);
            }
            /**
             * Send fetch API request
             * @param payload - {string} - The data payload to be sent.
             * @param isAsync - {boolean} - For fetch this identifies whether we are "unloading" (false) or a normal request
             */
            function _doFetchSender(payload, isAsync) {
                var _a;
                var endPointUrl = _endpointUrl;
                var batch = _self._buffer[_DYN_BATCH_PAYLOADS /* @min:%2ebatchPayloads */](payload);
                var plainTextBatch = new Blob([batch], { type: "application/json" });
                var thePromise;
                var resolveFunc;
                var rejectFunc;
                var requestHeaders = new Headers();
                var batchLength = batch[_DYN_LENGTH$2 /* @min:%2elength */];
                var ignoreResponse = false;
                var responseHandled = false;
                // append Sdk-Context request header only in case of breeze endpoint
                if (isInternalApplicationInsightsEndpoint(endPointUrl)) {
                    requestHeaders.append(RequestHeaders[6 /* eRequestHeaders.sdkContextHeader */], RequestHeaders[7 /* eRequestHeaders.sdkContextHeaderAppIdRequest */]);
                }
                arrForEach(objKeys(_headers), function (headerName) {
                    requestHeaders.append(headerName, _headers[headerName]);
                });
                var init = (_a = {
                        method: "POST",
                        headers: requestHeaders,
                        body: plainTextBatch
                    },
                    _a[DisabledPropertyName] = true // Mark so we don't attempt to track this request
                ,
                    _a);
                if (!isAsync) {
                    init.keepalive = true;
                    // As a sync request (during unload), it is unlikely that we will get a chance to process the response so
                    // just like beacon send assume that the events have been accepted and processed
                    ignoreResponse = true;
                    _syncFetchPayload += batchLength;
                }
                var request = new Request(endPointUrl, init);
                try {
                    // Also try and tag the request (just in case the value in init is not copied over)
                    request[DisabledPropertyName] = true;
                }
                catch (e) {
                    // If the environment has locked down the XMLHttpRequest (preventExtensions and/or freeze), this would
                    // cause the request to fail and we no telemetry would be sent
                }
                _self._buffer[_DYN_MARK_AS_SENT /* @min:%2emarkAsSent */](payload);
                if (isAsync && _enableSendPromise) {
                    thePromise = createPromise(function (resolve, reject) {
                        resolveFunc = resolve;
                        rejectFunc = reject;
                    });
                }
                try {
                    doAwaitResponse(fetch(request), function (result) {
                        if (!isAsync) {
                            _syncFetchPayload -= batchLength;
                            batchLength = 0;
                        }
                        if (!responseHandled) {
                            responseHandled = true;
                            if (!result.rejected) {
                                var response_1 = result.value;
                                /**
                                 * The Promise returned from fetch() won’t reject on HTTP error status even if the response is an HTTP 404 or 500.
                                 * Instead, it will resolve normally (with ok status set to false), and it will only reject on network failure
                                 * or if anything prevented the request from completing.
                                 */
                                if (!response_1.ok) {
                                    _self[_DYN__ON_ERROR /* @min:%2e_onError */](payload, response_1.statusText);
                                    resolveFunc && resolveFunc(false);
                                }
                                else {
                                    doAwaitResponse(response_1.text(), function (resp) {
                                        _checkResponsStatus(response_1.status, payload, response_1.url, payload[_DYN_LENGTH$2 /* @min:%2elength */], response_1.statusText, resp.value || "");
                                        resolveFunc && resolveFunc(true);
                                    });
                                }
                            }
                            else {
                                _self[_DYN__ON_ERROR /* @min:%2e_onError */](payload, result.reason && result.reason.message);
                                rejectFunc && rejectFunc(result.reason);
                            }
                        }
                    });
                }
                catch (e) {
                    if (!responseHandled) {
                        _self[_DYN__ON_ERROR /* @min:%2e_onError */](payload, dumpObj(e));
                        rejectFunc && rejectFunc(e);
                    }
                }
                if (ignoreResponse && !responseHandled) {
                    // Assume success during unload processing as we most likely won't get the response
                    responseHandled = true;
                    _self._onSuccess(payload, payload[_DYN_LENGTH$2 /* @min:%2elength */]);
                    resolveFunc && resolveFunc(true);
                }
                return thePromise;
            }
            /**
             * Parses the response from the backend.
             * @param response - XMLHttpRequest or XDomainRequest response
             */
            function _parseResponse(response) {
                try {
                    if (response && response !== "") {
                        var result = getJSON().parse(response);
                        if (result && result.itemsReceived && result.itemsReceived >= result[_DYN_ITEMS_ACCEPTED /* @min:%2eitemsAccepted */] &&
                            result.itemsReceived - result.itemsAccepted === result.errors[_DYN_LENGTH$2 /* @min:%2elength */]) {
                            return result;
                        }
                    }
                }
                catch (e) {
                    _throwInternal(_self[_DYN_DIAG_LOG /* @min:%2ediagLog */](), 1 /* eLoggingSeverity.CRITICAL */, 43 /* _eInternalMessageId.InvalidBackendResponse */, "Cannot parse the response. " + getExceptionName(e), {
                        response: response
                    });
                }
                return null;
            }
            /**
             * Resend payload. Adds payload back to the send buffer and setup a send timer (with exponential backoff).
             * @param payload
             */
            function _resendPayload(payload, linearFactor) {
                if (linearFactor === void 0) { linearFactor = 1; }
                if (!payload || payload[_DYN_LENGTH$2 /* @min:%2elength */] === 0) {
                    return;
                }
                var buffer = _self[_DYN__BUFFER /* @min:%2e_buffer */];
                buffer[_DYN_CLEAR_SENT /* @min:%2eclearSent */](payload);
                _consecutiveErrors++;
                for (var _i = 0, payload_1 = payload; _i < payload_1.length; _i++) {
                    var item = payload_1[_i];
                    buffer[_DYN_ENQUEUE /* @min:%2eenqueue */](item);
                }
                // setup timer
                _setRetryTime(linearFactor);
                _setupTimer();
            }
            /**
             * Calculates the time to wait before retrying in case of an error based on
             * http://en.wikipedia.org/wiki/Exponential_backoff
             */
            function _setRetryTime(linearFactor) {
                var SlotDelayInSeconds = 10;
                var delayInSeconds;
                if (_consecutiveErrors <= 1) {
                    delayInSeconds = SlotDelayInSeconds;
                }
                else {
                    var backOffSlot = (Math.pow(2, _consecutiveErrors) - 1) / 2;
                    // tslint:disable-next-line:insecure-random
                    var backOffDelay = Math.floor(Math.random() * backOffSlot * SlotDelayInSeconds) + 1;
                    backOffDelay = linearFactor * backOffDelay;
                    delayInSeconds = Math.max(Math.min(backOffDelay, 3600), SlotDelayInSeconds);
                }
                // TODO: Log the backoff time like the C# version does.
                var retryAfterTimeSpan = utcNow() + (delayInSeconds * 1000);
                // TODO: Log the retry at time like the C# version does.
                _retryAt = retryAfterTimeSpan;
            }
            /**
             * Sets up the timer which triggers actually sending the data.
             */
            function _setupTimer() {
                if (!_timeoutHandle && !_paused) {
                    var retryInterval = _retryAt ? Math.max(0, _retryAt - utcNow()) : 0;
                    var timerValue = Math.max(_maxBatchInterval, retryInterval);
                    _timeoutHandle = scheduleTimeout(function () {
                        _timeoutHandle = null;
                        _self[_DYN_TRIGGER_SEND /* @min:%2etriggerSend */](true, null, 1 /* SendRequestReason.NormalSchedule */);
                    }, timerValue);
                }
            }
            function _clearScheduledTimer() {
                _timeoutHandle && _timeoutHandle.cancel();
                _timeoutHandle = null;
                _retryAt = null;
            }
            /**
             * Checks if the SDK should resend the payload after receiving this status code from the backend.
             * @param statusCode
             */
            function _isRetriable(statusCode) {
                return statusCode === 401 // Unauthorized
                    || statusCode === 403 // Forbidden
                    || statusCode === 408 // Timeout
                    || statusCode === 429 // Too many requests.
                    || statusCode === 500 // Internal server error.
                    || statusCode === 502 // Bad Gateway.
                    || statusCode === 503 // Service unavailable.
                    || statusCode === 504; // Gateway timeout.
            }
            function _formatErrorMessageXhr(xhr, message) {
                if (xhr) {
                    return "XMLHttpRequest,Status:" + xhr.status + ",Response:" + _getResponseText(xhr) || xhr.response || "";
                }
                return message;
            }
            /**
             * Send XDomainRequest
             * @param payload - {string} - The data payload to be sent.
             * @param isAsync - {boolean} - Indicates if the request should be sent asynchronously
             *
             * Note: XDomainRequest does not support sync requests. This 'isAsync' parameter is added
             * to maintain consistency with the xhrSender's contract
             * Note: XDomainRequest does not support custom headers and we are not able to get
             * appId from the backend for the correct correlation.
             */
            function _xdrSender(payload, isAsync) {
                var buffer = _self[_DYN__BUFFER /* @min:%2e_buffer */];
                var _window = getWindow();
                var xdr = new XDomainRequest();
                // NOTE: xdr may send previous retry payload to new endpoint since we are not able to check response URL
                xdr.onload = function () { return _self._xdrOnLoad(xdr, payload); };
                xdr.onerror = function (event) { return _self[_DYN__ON_ERROR /* @min:%2e_onError */](payload, _formatErrorMessageXdr(xdr), event); };
                // XDomainRequest requires the same protocol as the hosting page.
                // If the protocol doesn't match, we can't send the telemetry :(.
                var hostingProtocol = _window && _window.location && _window.location.protocol || "";
                if (_endpointUrl.lastIndexOf(hostingProtocol, 0) !== 0) {
                    _throwInternal(_self[_DYN_DIAG_LOG /* @min:%2ediagLog */](), 2 /* eLoggingSeverity.WARNING */, 40 /* _eInternalMessageId.TransmissionFailed */, ". " +
                        "Cannot send XDomain request. The endpoint URL protocol doesn't match the hosting page protocol.");
                    buffer[_DYN_CLEAR /* @min:%2eclear */]();
                    return;
                }
                var endpointUrl = _endpointUrl.replace(/^(https?:)/, "");
                xdr.open("POST", endpointUrl);
                // compose an array of payloads
                var batch = buffer[_DYN_BATCH_PAYLOADS /* @min:%2ebatchPayloads */](payload);
                xdr.send(batch);
                buffer[_DYN_MARK_AS_SENT /* @min:%2emarkAsSent */](payload);
            }
            function _formatErrorMessageXdr(xdr, message) {
                if (xdr) {
                    return "XDomainRequest,Response:" + _getResponseText(xdr) || "";
                }
                return message;
            }
            // Using function lookups for backward compatibility as the getNotifyMgr() did not exist until after v2.5.6
            function _getNotifyMgr() {
                var func = "getNotifyMgr";
                if (_self.core[func]) {
                    return _self.core[func]();
                }
                // using _self.core['_notificationManager'] for backward compatibility
                return _self.core["_notificationManager"];
            }
            function _notifySendRequest(sendRequest, isAsync) {
                var manager = _getNotifyMgr();
                if (manager && manager[_DYN_EVENTS_SEND_REQUEST /* @min:%2eeventsSendRequest */]) {
                    try {
                        manager[_DYN_EVENTS_SEND_REQUEST /* @min:%2eeventsSendRequest */](sendRequest, isAsync);
                    }
                    catch (e) {
                        _throwInternal(_self[_DYN_DIAG_LOG /* @min:%2ediagLog */](), 1 /* eLoggingSeverity.CRITICAL */, 74 /* _eInternalMessageId.NotificationException */, "send request notification failed: " + getExceptionName(e), { exception: dumpObj(e) });
                    }
                }
            }
            /**
             * Validate UUID Format
             * Specs taken from https://tools.ietf.org/html/rfc4122 and breeze repo
             */
            function _validateInstrumentationKey(instrumentationKey, config) {
                var disableValidation = config.disableInstrumentationKeyValidation;
                var disableIKeyValidationFlag = isNullOrUndefined(disableValidation) ? false : disableValidation;
                if (disableIKeyValidationFlag) {
                    return true;
                }
                var UUID_Regex = "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$";
                var regexp = new RegExp(UUID_Regex);
                return regexp.test(instrumentationKey);
            }
            function _initDefaults() {
                _self[_DYN__SENDER /* @min:%2e_sender */] = null;
                _self[_DYN__BUFFER /* @min:%2e_buffer */] = null;
                _self._appId = null;
                _self._sample = null;
                _headers = {};
                _offlineListener = null;
                _consecutiveErrors = 0;
                _retryAt = null;
                _lastSend = null;
                _paused = false;
                _timeoutHandle = null;
                _serializer = null;
                _stamp_specific_redirects = 0;
                _syncFetchPayload = 0;
                _fallbackSender = null;
                _syncUnloadSender = null;
                _evtNamespace = null;
                _endpointUrl = null;
                _orgEndpointUrl = null;
                _maxBatchSizeInBytes = 0;
                _beaconSupported = false;
                _customHeaders = null;
                _disableTelemetry = false;
                _instrumentationKey = null;
                _convertUndefined = UNDEFINED_VALUE$1;
                _isRetryDisabled = false;
                _sessionStorageUsed = null;
                _namePrefix = UNDEFINED_VALUE$1;
                objDefine(_self, "_senderConfig", {
                    g: function () {
                        return objExtend({}, defaultAppInsightsChannelConfig);
                    }
                });
            }
        });
        return _this;
    }
    Sender.constructEnvelope = function (orig, iKey, logger, convertUndefined) {
        var envelope;
        if (iKey !== orig.iKey && !isNullOrUndefined(iKey)) {
            envelope = __assignFn(__assignFn({}, orig), { iKey: iKey });
        }
        else {
            envelope = orig;
        }
        var creator = EnvelopeTypeCreator[envelope.baseType] || EventEnvelopeCreator;
        return creator(logger, envelope, convertUndefined);
    };
// Removed Stub for Sender.prototype.pause.
// Removed Stub for Sender.prototype.resume.
// Removed Stub for Sender.prototype.flush.
// Removed Stub for Sender.prototype.onunloadFlush.
// Removed Stub for Sender.prototype.initialize.
// Removed Stub for Sender.prototype.processTelemetry.
// Removed Stub for Sender.prototype._xhrReadyStateChange.
// Removed Stub for Sender.prototype.triggerSend.
// Removed Stub for Sender.prototype._onError.
// Removed Stub for Sender.prototype._onPartialSuccess.
// Removed Stub for Sender.prototype._onSuccess.
// Removed Stub for Sender.prototype._xdrOnLoad.
// Removed Stub for Sender.prototype.addHeader.
    return Sender;
}(BaseTelemetryPlugin));

/*
 * Application Insights JavaScript SDK - Dependencies Plugin, 3.0.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


// ###################################################################################################################################################
// Note: DON'T Export these const from the package as we are still targeting IE/ES5 this will export a mutable variables that someone could change ###
// ###################################################################################################################################################
// Generally you should only put values that are used more than 2 times and then only if not already exposed as a constant (such as SdkCoreNames)
// as when using "short" named values from here they will be will be minified smaller than the SdkCoreNames[eSdkCoreNames.xxxx] value.
var STR_DURATION = "duration";
var STR_PROPERTIES = "properties";

/*
 * Application Insights JavaScript SDK - Dependencies Plugin, 3.0.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


// @skip-file-minify
// ##############################################################
// AUTO GENERATED FILE: This file is Auto Generated during build.
// ##############################################################
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
// Note: DON'T Export these const from the package as we are still targeting ES3 this will export a mutable variables that someone could change!!!
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
var _DYN_REQUEST_URL = "requestUrl"; // Count: 12
var _DYN_INST = "inst"; // Count: 5
var _DYN_LENGTH$1 = "length"; // Count: 10
var _DYN_TRACE_ID = "traceID"; // Count: 9
var _DYN_SPAN_ID = "spanID"; // Count: 8
var _DYN_TRACE_FLAGS = "traceFlags"; // Count: 13
var _DYN_CONTEXT$1 = "context"; // Count: 7
var _DYN_ABORTED = "aborted"; // Count: 7
var _DYN_TRACE_ID0 = "traceId"; // Count: 5
var _DYN_SPAN_ID1 = "spanId"; // Count: 5
var _DYN__ADD_HOOK = "_addHook"; // Count: 4
var _DYN_CORE = "core"; // Count: 8
var _DYN_INCLUDE_CORRELATION_2 = "includeCorrelationHeaders"; // Count: 4
var _DYN_GET_ABSOLUTE_URL = "getAbsoluteUrl"; // Count: 3
var _DYN_HEADERS = "headers"; // Count: 6
var _DYN_REQUEST_HEADERS = "requestHeaders"; // Count: 13
var _DYN_SET_REQUEST_HEADER = "setRequestHeader"; // Count: 3
var _DYN_TRACK_DEPENDENCY_DAT3 = "trackDependencyDataInternal"; // Count: 2
var _DYN_START_TIME = "startTime"; // Count: 6
var _DYN_TO_LOWER_CASE = "toLowerCase"; // Count: 6
var _DYN_ENABLE_REQUEST_HEADE4 = "enableRequestHeaderTracking"; // Count: 3
var _DYN_ENABLE_AJAX_ERROR_ST5 = "enableAjaxErrorStatusText"; // Count: 2
var _DYN_ENABLE_AJAX_PERF_TRA6 = "enableAjaxPerfTracking"; // Count: 2
var _DYN_MAX_AJAX_CALLS_PER_V7 = "maxAjaxCallsPerView"; // Count: 2
var _DYN_EXCLUDE_REQUEST_FROM8 = "excludeRequestFromAutoTrackingPatterns"; // Count: 2
var _DYN_ADD_REQUEST_CONTEXT = "addRequestContext"; // Count: 2
var _DYN_DISABLE_AJAX_TRACKIN9 = "disableAjaxTracking"; // Count: 3
var _DYN_AJAX_PERF_LOOKUP_DEL10 = "ajaxPerfLookupDelay"; // Count: 2
var _DYN_DISABLE_FETCH_TRACKI11 = "disableFetchTracking"; // Count: 2
var _DYN_ENABLE_RESPONSE_HEAD12 = "enableResponseHeaderTracking"; // Count: 2
var _DYN_STATUS = "status"; // Count: 11
var _DYN_STATUS_TEXT = "statusText"; // Count: 9
var _DYN_HEADER_MAP = "headerMap"; // Count: 8
var _DYN_OPEN_DONE = "openDone"; // Count: 3
var _DYN_SEND_DONE = "sendDone"; // Count: 3
var _DYN_REQUEST_SENT_TIME = "requestSentTime"; // Count: 9
var _DYN_ABORT_DONE = "abortDone"; // Count: 3
var _DYN_GET_TRACE_ID = "getTraceId"; // Count: 3
var _DYN_GET_TRACE_FLAGS = "getTraceFlags"; // Count: 3
var _DYN_METHOD = "method"; // Count: 8
var _DYN_ERROR_STATUS_TEXT = "errorStatusText"; // Count: 3
var _DYN_STATE_CHANGE_ATTACHE13 = "stateChangeAttached"; // Count: 2
var _DYN_RESPONSE_TEXT = "responseText"; // Count: 6
var _DYN_RESPONSE_FINISHED_TI14 = "responseFinishedTime"; // Count: 7
var _DYN__CREATE_TRACK_ITEM = "CreateTrackItem"; // Count: 3
var _DYN_RESPONSE = "response"; // Count: 4
var _DYN_GET_ALL_RESPONSE_HEA15 = "getAllResponseHeaders"; // Count: 2
var _DYN_GET_PART_APROPS = "getPartAProps"; // Count: 3
var _DYN_PERF_MARK = "perfMark"; // Count: 4
var _DYN_NAME = "name"; // Count: 6
var _DYN_PERF_TIMING = "perfTiming"; // Count: 3
var _DYN_EXCEPTION = "exception"; // Count: 5
var _DYN_AJAX_DIAGNOSTICS_MES16 = "ajaxDiagnosticsMessage"; // Count: 3
var _DYN_CORRELATION_CONTEXT = "correlationContext"; // Count: 3
var _DYN_AJAX_TOTAL_DURATION = "ajaxTotalDuration"; // Count: 3
var _DYN_EVENT_TRACE_CTX = "eventTraceCtx"; // Count: 3

/*
 * Application Insights JavaScript SDK - Dependencies Plugin, 3.0.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */

/** @ignore */
function _calcPerfDuration(resourceEntry, start, end) {
    var result = 0;
    var from = resourceEntry[start];
    var to = resourceEntry[end];
    if (from && to) {
        result = dateTimeUtilsDuration(from, to);
    }
    return result;
}
/** @ignore */
function _setPerfDuration(props, name, resourceEntry, start, end) {
    var result = 0;
    var value = _calcPerfDuration(resourceEntry, start, end);
    if (value) {
        result = _setPerfValue(props, name, msToTimeSpan(value));
    }
    return result;
}
/** @ignore */
function _setPerfValue(props, name, value) {
    var strPerf = "ajaxPerf";
    var result = 0;
    if (props && name && value) {
        var perfData = props[strPerf] = (props[strPerf] || {});
        perfData[name] = value;
        result = 1;
    }
    return result;
}
/** @ignore */
function _populatePerfData(ajaxData, dependency) {
    /*
    * https://developer.mozilla.org/en-US/docs/Web/API/Resource_Timing_API/Using_the_Resource_Timing_API
    *  | -startTime
    *  | -redirectStart
    *  |            | -redirectEnd
    *  |            | | -fetchStart
    *  |            | |   | -domainLookupStart
    *  |            | |   |                |- domainLookupEnd
    *  |            | |   |                | | -connectStart
    *  |            | |   |                | |  | -secureConnectionStart
    *  |            | |   |                | |  |        | -connectEnd
    *  |            | |   |                | |  |        | | -requestStart
    *  |            | |   |                | |  |        | |           | | -responseStart
    *  |            | |   |                | |  |        | |           | |            | | -responseEnd
    *  +------------+-+---+----------------+-+--+--------+-+-----------+-+------------+-+
    *  |--redirect--| |---|--domainLookup--| |--connect--| |--request--| |--response--| |
    *  |-------------------networkConnect----------------|
    *  |                                                   |---------sentRequest--------|
    *  |------------------------------------perfTotal-----------------------------------|
    */
    var resourceEntry = ajaxData[_DYN_PERF_TIMING /* @min:%2eperfTiming */];
    var props = dependency[STR_PROPERTIES /* @min:%2eproperties */] || {};
    var propsSet = 0;
    var strName = "name";
    var strStart = "Start";
    var strEnd = "End";
    var strDomainLookup = "domainLookup";
    var strConnect = "connect";
    var strRedirect = "redirect";
    var strRequest = "request";
    var strResponse = "response";
    var strStartTime = "startTime";
    var strDomainLookupStart = strDomainLookup + strStart;
    var strDomainLookupEnd = strDomainLookup + strEnd;
    var strConnectStart = strConnect + strStart;
    var strConnectEnd = strConnect + strEnd;
    var strRequestStart = strRequest + strStart;
    var strRequestEnd = strRequest + strEnd;
    var strResponseStart = strResponse + strStart;
    var strResponseEnd = strResponse + strEnd;
    var strRedirectStart = strRedirect + strStart;
    var strRedirectEnd = strRedirect = strEnd;
    var strTransferSize = "transferSize";
    var strEncodedBodySize = "encodedBodySize";
    var strDecodedBodySize = "decodedBodySize";
    var strServerTiming = "serverTiming";
    if (resourceEntry) {
        // redirect
        propsSet |= _setPerfDuration(props, strRedirect, resourceEntry, strRedirectStart, strRedirectEnd);
        // domainLookup
        propsSet |= _setPerfDuration(props, strDomainLookup, resourceEntry, strDomainLookupStart, strDomainLookupEnd);
        // connect
        propsSet |= _setPerfDuration(props, strConnect, resourceEntry, strConnectStart, strConnectEnd);
        // request
        propsSet |= _setPerfDuration(props, strRequest, resourceEntry, strRequestStart, strRequestEnd);
        // response
        propsSet |= _setPerfDuration(props, strResponse, resourceEntry, strResponseStart, strResponseEnd);
        // Network connection time
        propsSet |= _setPerfDuration(props, "networkConnect", resourceEntry, strStartTime, strConnectEnd);
        // Sent Request
        propsSet |= _setPerfDuration(props, "sentRequest", resourceEntry, strRequestStart, strResponseEnd);
        // PerfTotal / Duration
        var duration = resourceEntry[STR_DURATION /* @min:%2eduration */];
        if (!duration) {
            duration = _calcPerfDuration(resourceEntry, strStartTime, strResponseEnd) || 0;
        }
        propsSet |= _setPerfValue(props, STR_DURATION, duration);
        propsSet |= _setPerfValue(props, "perfTotal", duration);
        var serverTiming = resourceEntry[strServerTiming];
        if (serverTiming) {
            var server_1 = {};
            arrForEach(serverTiming, function (value, idx) {
                var name = normalizeJsName(value[strName] || "" + idx);
                var newValue = server_1[name] || {};
                objForEachKey(value, function (key, val) {
                    if (key !== strName && isString(val) || isNumber(val)) {
                        if (newValue[key]) {
                            val = newValue[key] + ";" + val;
                        }
                        if (val || !isString(val)) {
                            // Only set the value if it has a value and it's not an empty string
                            newValue[key] = val;
                        }
                    }
                });
                server_1[name] = newValue;
            });
            propsSet |= _setPerfValue(props, strServerTiming, server_1);
        }
        propsSet |= _setPerfValue(props, strTransferSize, resourceEntry[strTransferSize]);
        propsSet |= _setPerfValue(props, strEncodedBodySize, resourceEntry[strEncodedBodySize]);
        propsSet |= _setPerfValue(props, strDecodedBodySize, resourceEntry[strDecodedBodySize]);
    }
    else {
        if (ajaxData[_DYN_PERF_MARK /* @min:%2eperfMark */]) {
            propsSet |= _setPerfValue(props, "missing", ajaxData.perfAttempts);
        }
    }
    if (propsSet) {
        dependency[STR_PROPERTIES /* @min:%2eproperties */] = props;
    }
}
var XHRMonitoringState = /** @class */ (function () {
    function XHRMonitoringState() {
        var self = this;
        self[_DYN_OPEN_DONE /* @min:%2eopenDone */] = false;
        self.setRequestHeaderDone = false;
        self[_DYN_SEND_DONE /* @min:%2esendDone */] = false;
        self[_DYN_ABORT_DONE /* @min:%2eabortDone */] = false;
        // <summary>True, if onreadyStateChangeCallback function attached to xhr, otherwise false</summary>
        self[_DYN_STATE_CHANGE_ATTACHE13 /* @min:%2estateChangeAttached */] = false;
    }
    return XHRMonitoringState;
}());
var ajaxRecord = /** @class */ (function () {
    function ajaxRecord(traceId, spanId, logger, traceCtx) {
        var _a;
        var self = this;
        var _logger = logger;
        var strResponseText = "responseText";
        // Assigning the initial/default values within the constructor to avoid typescript from creating a bunch of
        // this.XXXX = null
        self[_DYN_PERF_MARK /* @min:%2eperfMark */] = null;
        self.completed = false;
        self.requestHeadersSize = null;
        self[_DYN_REQUEST_HEADERS /* @min:%2erequestHeaders */] = null;
        self.responseReceivingDuration = null;
        self.callbackDuration = null;
        self[_DYN_AJAX_TOTAL_DURATION /* @min:%2eajaxTotalDuration */] = null;
        self[_DYN_ABORTED /* @min:%2eaborted */] = 0;
        self.pageUrl = null;
        self[_DYN_REQUEST_URL /* @min:%2erequestUrl */] = null;
        self.requestSize = 0;
        self[_DYN_METHOD /* @min:%2emethod */] = null;
        self[_DYN_STATUS /* @min:%2estatus */] = null;
        self[_DYN_REQUEST_SENT_TIME /* @min:%2erequestSentTime */] = null;
        self.responseStartedTime = null;
        self[_DYN_RESPONSE_FINISHED_TI14 /* @min:%2eresponseFinishedTime */] = null;
        self.callbackFinishedTime = null;
        self.endTime = null;
        self.xhrMonitoringState = new XHRMonitoringState();
        self.clientFailure = 0;
        self[_DYN_TRACE_ID /* @min:%2etraceID */] = traceId;
        self[_DYN_SPAN_ID /* @min:%2espanID */] = spanId;
        self[_DYN_TRACE_FLAGS /* @min:%2etraceFlags */] = traceCtx === null || traceCtx === void 0 ? void 0 : traceCtx.getTraceFlags();
        if (traceCtx) {
            self[_DYN_EVENT_TRACE_CTX /* @min:%2eeventTraceCtx */] = (_a = {},
                _a[_DYN_TRACE_ID0 /* @min:traceId */] = traceCtx[_DYN_GET_TRACE_ID /* @min:%2egetTraceId */](),
                _a[_DYN_SPAN_ID1 /* @min:spanId */] = traceCtx.getSpanId(),
                _a[_DYN_TRACE_FLAGS /* @min:traceFlags */] = traceCtx[_DYN_GET_TRACE_FLAGS /* @min:%2egetTraceFlags */](),
                _a);
        }
        else {
            self[_DYN_EVENT_TRACE_CTX /* @min:%2eeventTraceCtx */] = null;
        }
        dynamicProto(ajaxRecord, self, function (self) {
            self.getAbsoluteUrl = function () {
                return self[_DYN_REQUEST_URL /* @min:%2erequestUrl */] ? urlGetAbsoluteUrl(self[_DYN_REQUEST_URL /* @min:%2erequestUrl */]) : null;
            };
            self.getPathName = function () {
                return self[_DYN_REQUEST_URL /* @min:%2erequestUrl */] ? dataSanitizeUrl(_logger, urlGetCompleteUrl(self[_DYN_METHOD /* @min:%2emethod */], self[_DYN_REQUEST_URL /* @min:%2erequestUrl */])) : null;
            };
            self[_DYN__CREATE_TRACK_ITEM /* @min:%2eCreateTrackItem */] = function (ajaxType, enableRequestHeaderTracking, getResponse) {
                var _a;
                // round to 3 decimal points
                self.ajaxTotalDuration = Math.round(dateTimeUtilsDuration(self.requestSentTime, self.responseFinishedTime) * 1000) / 1000;
                if (self[_DYN_AJAX_TOTAL_DURATION /* @min:%2eajaxTotalDuration */] < 0) {
                    return null;
                }
                var dependency = (_a = {
                        id: "|" + self[_DYN_TRACE_ID /* @min:%2etraceID */] + "." + self[_DYN_SPAN_ID /* @min:%2espanID */],
                        target: self[_DYN_GET_ABSOLUTE_URL /* @min:%2egetAbsoluteUrl */]()
                    },
                    _a[_DYN_NAME /* @min:name */] = self.getPathName(),
                    _a.type = ajaxType,
                    _a[_DYN_START_TIME /* @min:startTime */] = null,
                    _a.duration = self[_DYN_AJAX_TOTAL_DURATION /* @min:%2eajaxTotalDuration */],
                    _a.success = (+(self[_DYN_STATUS /* @min:%2estatus */])) >= 200 && (+(self[_DYN_STATUS /* @min:%2estatus */])) < 400,
                    _a.responseCode = (+(self[_DYN_STATUS /* @min:%2estatus */])),
                    _a[STR_PROPERTIES] = { HttpMethod: self[_DYN_METHOD /* @min:%2emethod */] },
                    _a);
                var props = dependency[STR_PROPERTIES];
                if (self[_DYN_ABORTED /* @min:%2eaborted */]) {
                    props[_DYN_ABORTED /* @min:%2eaborted */] = true;
                }
                if (self[_DYN_REQUEST_SENT_TIME /* @min:%2erequestSentTime */]) {
                    // Set the correct dependency start time
                    dependency[_DYN_START_TIME /* @min:%2estartTime */] = new Date();
                    dependency[_DYN_START_TIME /* @min:%2estartTime */].setTime(self[_DYN_REQUEST_SENT_TIME /* @min:%2erequestSentTime */]);
                }
                // Add Ajax perf details if available
                _populatePerfData(self, dependency);
                if (enableRequestHeaderTracking) {
                    if (objKeys(self.requestHeaders)[_DYN_LENGTH$1 /* @min:%2elength */] > 0) {
                        props[_DYN_REQUEST_HEADERS /* @min:%2erequestHeaders */] = self[_DYN_REQUEST_HEADERS /* @min:%2erequestHeaders */];
                    }
                }
                if (getResponse) {
                    var response = getResponse();
                    if (response) {
                        // enrich dependency target with correlation context from the server
                        var correlationContext = response[_DYN_CORRELATION_CONTEXT /* @min:%2ecorrelationContext */];
                        if (correlationContext) {
                            dependency.correlationContext = /* dependency.target + " | " + */ correlationContext;
                        }
                        if (response[_DYN_HEADER_MAP /* @min:%2eheaderMap */]) {
                            if (objKeys(response.headerMap)[_DYN_LENGTH$1 /* @min:%2elength */] > 0) {
                                props.responseHeaders = response[_DYN_HEADER_MAP /* @min:%2eheaderMap */];
                            }
                        }
                        if (self[_DYN_ERROR_STATUS_TEXT /* @min:%2eerrorStatusText */]) {
                            if (self[_DYN_STATUS /* @min:%2estatus */] >= 400) {
                                var responseType = response.type;
                                if (responseType === "" || responseType === "text") {
                                    props.responseText = response.responseText ? response[_DYN_STATUS_TEXT /* @min:%2estatusText */] + " - " + response[strResponseText] : response[_DYN_STATUS_TEXT /* @min:%2estatusText */];
                                }
                                if (responseType === "json") {
                                    props.responseText = response.response ? response[_DYN_STATUS_TEXT /* @min:%2estatusText */] + " - " + JSON.stringify(response[_DYN_RESPONSE /* @min:%2eresponse */]) : response[_DYN_STATUS_TEXT /* @min:%2estatusText */];
                                }
                            }
                            else if (self[_DYN_STATUS /* @min:%2estatus */] === 0) {
                                props.responseText = response[_DYN_STATUS_TEXT /* @min:%2estatusText */] || "";
                            }
                        }
                    }
                }
                return dependency;
            };
            self[_DYN_GET_PART_APROPS /* @min:%2egetPartAProps */] = function () {
                var _a;
                var partA = null;
                var traceCtx = self[_DYN_EVENT_TRACE_CTX /* @min:%2eeventTraceCtx */];
                if (traceCtx && (traceCtx[_DYN_TRACE_ID0 /* @min:%2etraceId */] || traceCtx[_DYN_SPAN_ID1 /* @min:%2espanId */])) {
                    partA = {};
                    var traceExt = partA[Extensions.TraceExt] = (_a = {},
                        _a[_DYN_TRACE_ID /* @min:traceID */] = traceCtx[_DYN_TRACE_ID0 /* @min:%2etraceId */],
                        _a.parentID = traceCtx[_DYN_SPAN_ID1 /* @min:%2espanId */],
                        _a);
                    if (!isNullOrUndefined(traceCtx[_DYN_TRACE_FLAGS /* @min:%2etraceFlags */])) {
                        traceExt[_DYN_TRACE_FLAGS /* @min:%2etraceFlags */] = traceCtx[_DYN_TRACE_FLAGS /* @min:%2etraceFlags */];
                    }
                }
                return partA;
            };
        });
    }
// Removed Stub for ajaxRecord.prototype.getAbsoluteUrl.
// Removed Stub for ajaxRecord.prototype.getPathName.
// Removed Stub for ajaxRecord.prototype.CreateTrackItem.
// Removed Stub for ajaxRecord.prototype.getPartAProps.
    // This is a workaround for an IE bug when using dynamicProto() with classes that don't have any
    // non-dynamic functions or static properties/functions when using uglify-js to minify the resulting code.
    ajaxRecord.__ieDyn=1;

    return ajaxRecord;
}());

/*
 * Application Insights JavaScript SDK - Dependencies Plugin, 3.0.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


var _a$3;
var AJAX_MONITOR_PREFIX = "ai.ajxmn.";
var strDiagLog = "diagLog";
var AJAX_DATA_CONTAINER = "_ajaxData";
var STR_FETCH = "fetch";
var ERROR_HEADER = "Failed to monitor XMLHttpRequest";
var ERROR_PREFIX = ", monitoring data for this ajax call ";
var ERROR_POSTFIX = ERROR_PREFIX + "may be incorrect.";
var ERROR_NOT_SENT = ERROR_PREFIX + "won't be sent.";
var CORRELATION_HEADER_ERROR = "Failed to get Request-Context correlation header as it may be not included in the response or not accessible.";
var CUSTOM_REQUEST_CONTEXT_ERROR = "Failed to add custom defined request context as configured call back may missing a null check.";
var FAILED_TO_CALCULATE_DURATION_ERROR = "Failed to calculate the duration of the ";
// Using a global value so that to handle same iKey with multiple app insights instances (mostly for testing)
var _markCount = 0;
/** @Ignore */
function _supportsFetch() {
    var _global = getGlobal();
    if (!_global ||
        isNullOrUndefined(_global.Request) ||
        isNullOrUndefined(_global.Request[strShimPrototype]) ||
        isNullOrUndefined(_global[STR_FETCH])) {
        return null;
    }
    return _global[STR_FETCH];
}
/**
 * Determines whether ajax monitoring can be enabled on this document
 * @returns True if Ajax monitoring is supported on this page, otherwise false
 * @ignore
 */
function _supportsAjaxMonitoring(ajaxMonitorInstance, ajaxDataId) {
    var _a, _b;
    var result = false;
    if (isXhrSupported()) {
        var proto = XMLHttpRequest[strShimPrototype];
        result = !isNullOrUndefined(proto) &&
            !isNullOrUndefined(proto.open) && // eslint-disable-line security/detect-non-literal-fs-filename -- false positive
            !isNullOrUndefined(proto.send) &&
            !isNullOrUndefined(proto.abort);
    }
    var ieVer = getIEVersion();
    if (ieVer && ieVer < 9) {
        result = false;
    }
    if (result) {
        // Disable if the XmlHttpRequest can't be extended or hooked
        try {
            var xhr = new XMLHttpRequest();
            var xhrData = {
                xh: [],
                i: (_a = {},
                    _a[ajaxDataId] = {},
                    _a)
            };
            xhr[AJAX_DATA_CONTAINER] = xhrData;
            // Check that we can update the prototype
            var theOpen = XMLHttpRequest[strShimPrototype].open;
            XMLHttpRequest[strShimPrototype].open = theOpen;
        }
        catch (e) {
            // We can't decorate the xhr object so disable monitoring
            result = false;
            _throwInternalCritical(ajaxMonitorInstance, 15 /* _eInternalMessageId.FailedMonitorAjaxOpen */, "Failed to enable XMLHttpRequest monitoring, extension is not supported", (_b = {},
                _b[_DYN_EXCEPTION /* @min:exception */] = dumpObj(e),
                _b));
        }
    }
    return result;
}
/**
 * Internal helper to fetch the SDK instance tracking data for this XHR request
 * @param xhr
 * @param ajaxDataId
 * @returns
 */
var _getAjaxData = function (xhr, ajaxDataId) {
    if (xhr && ajaxDataId && xhr[AJAX_DATA_CONTAINER]) {
        return (xhr[AJAX_DATA_CONTAINER].i || {})[ajaxDataId];
    }
    return null;
};
/**
 * @ignore
 * Internal helper to track the singleton shared tracking headers, so we can attempt to not create headers
 * that might cause an issue if multiple values are populated.
 * @param xhr - The instrumented XHR instance
 */
var _addSharedXhrHeaders = function (xhr, name, value) {
    if (xhr) {
        var headers = (xhr[AJAX_DATA_CONTAINER] || {}).xh;
        if (headers) {
            headers.push({
                n: name,
                v: value
            });
        }
    }
};
var _isHeaderSet = function (xhr, name) {
    var isPresent = false;
    if (xhr) {
        var headers = (xhr[AJAX_DATA_CONTAINER] || {}).xh;
        if (headers) {
            arrForEach(headers, function (header) {
                if (header.n === name) {
                    isPresent = true;
                    return -1;
                }
            });
        }
    }
    return isPresent;
};
/** @Ignore */
function _getFailedAjaxDiagnosticsMessage(xhr, ajaxDataId) {
    var result = "";
    try {
        var ajaxData = _getAjaxData(xhr, ajaxDataId);
        if (ajaxData && ajaxData[_DYN_REQUEST_URL /* @min:%2erequestUrl */]) {
            result += "(url: '" + ajaxData[_DYN_REQUEST_URL /* @min:%2erequestUrl */] + "')";
        }
    }
    catch (e) {
        // eslint-disable-next-line no-empty
    }
    return result;
}
/** @ignore */
function _throwInternalCritical(ajaxMonitorInstance, msgId, message, properties, isUserAct) {
    _throwInternal(ajaxMonitorInstance[strDiagLog](), 1 /* eLoggingSeverity.CRITICAL */, msgId, message, properties, isUserAct);
}
/** @ignore */
function _throwInternalWarning(ajaxMonitorInstance, msgId, message, properties, isUserAct) {
    _throwInternal(ajaxMonitorInstance[strDiagLog](), 2 /* eLoggingSeverity.WARNING */, msgId, message, properties, isUserAct);
}
/** @Ignore */
function _createErrorCallbackFunc(ajaxMonitorInstance, internalMessage, message) {
    // tslint:disable-next-line
    return function (callDetails) {
        var _a;
        _throwInternalCritical(ajaxMonitorInstance, internalMessage, message, (_a = {
                ajaxDiagnosticsMessage: _getFailedAjaxDiagnosticsMessage(callDetails[_DYN_INST /* @min:%2einst */], ajaxMonitorInstance._ajaxDataId)
            },
            _a[_DYN_EXCEPTION /* @min:exception */] = dumpObj(callDetails.err),
            _a));
    };
}
function _indexOf(value, match) {
    if (value && match) {
        return strIndexOf(value, match);
    }
    return -1;
}
function _addHandler(container, id, theFunc) {
    var theHandler = {
        id: id,
        fn: theFunc
    };
    container.push(theHandler);
    return {
        remove: function () {
            arrForEach(container, function (initializer, idx) {
                if (initializer.id === theHandler.id) {
                    container.splice(idx, 1);
                    return -1;
                }
            });
        }
    };
}
function _processDependencyContainer(core, container, details, message) {
    var result = true;
    arrForEach(container, function (theFunc, idx) {
        try {
            if (theFunc.fn.call(null, details) === false) {
                result = false;
            }
        }
        catch (e) {
            _throwInternal(core && core.logger, 1 /* eLoggingSeverity.CRITICAL */, 64 /* _eInternalMessageId.TelemetryInitializerFailed */, "Dependency " + message + " [#" + idx + "] failed: " + getExceptionName(e), { exception: dumpObj(e) }, true);
        }
    });
    return result;
}
function _processDependencyListeners(listeners, core, ajaxData, xhr, input, init) {
    var _a;
    var initializersCount = listeners[_DYN_LENGTH$1 /* @min:%2elength */];
    if (initializersCount > 0) {
        var details = (_a = {},
            _a[_DYN_CORE /* @min:core */] = core,
            _a.xhr = xhr,
            _a.input = input,
            _a.init = init,
            _a.traceId = ajaxData[_DYN_TRACE_ID /* @min:%2etraceID */],
            _a.spanId = ajaxData[_DYN_SPAN_ID /* @min:%2espanID */],
            _a.traceFlags = ajaxData[_DYN_TRACE_FLAGS /* @min:%2etraceFlags */],
            _a.context = ajaxData[_DYN_CONTEXT$1 /* @min:%2econtext */] || {},
            _a.aborted = !!ajaxData[_DYN_ABORTED /* @min:%2eaborted */],
            _a);
        _processDependencyContainer(core, listeners, details, "listener");
        ajaxData[_DYN_TRACE_ID /* @min:%2etraceID */] = details[_DYN_TRACE_ID0 /* @min:%2etraceId */];
        ajaxData[_DYN_SPAN_ID /* @min:%2espanID */] = details[_DYN_SPAN_ID1 /* @min:%2espanId */];
        ajaxData[_DYN_TRACE_FLAGS /* @min:%2etraceFlags */] = details[_DYN_TRACE_FLAGS /* @min:%2etraceFlags */];
        ajaxData[_DYN_CONTEXT$1 /* @min:%2econtext */] = details[_DYN_CONTEXT$1 /* @min:%2econtext */];
    }
}
var BLOB_CORE = "*.blob.core.";
var DfltAjaxCorrelationHeaderExDomains = objFreeze([
    BLOB_CORE + "windows.net",
    BLOB_CORE + "chinacloudapi.cn",
    BLOB_CORE + "cloudapi.de",
    BLOB_CORE + "usgovcloudapi.net"
]);
var _internalExcludeEndpoints = [
    /https:\/\/[^\/]*(\.pipe\.aria|aria\.pipe|events\.data|collector\.azure)\.[^\/]+\/(OneCollector\/1|Collector\/3)\.0/i
];
var _defaultConfig$1 = objFreeze((_a$3 = {},
    _a$3[_DYN_MAX_AJAX_CALLS_PER_V7 /* @min:maxAjaxCallsPerView */] = 500,
    _a$3[_DYN_DISABLE_AJAX_TRACKIN9 /* @min:disableAjaxTracking */] = false,
    _a$3[_DYN_DISABLE_FETCH_TRACKI11 /* @min:disableFetchTracking */] = false,
    _a$3[_DYN_EXCLUDE_REQUEST_FROM8 /* @min:excludeRequestFromAutoTrackingPatterns */] = undefined,
    _a$3.disableCorrelationHeaders = false,
    _a$3.distributedTracingMode = 1 /* eDistributedTracingModes.AI_AND_W3C */,
    _a$3.correlationHeaderExcludedDomains = DfltAjaxCorrelationHeaderExDomains,
    _a$3.correlationHeaderDomains = undefined,
    _a$3.correlationHeaderExcludePatterns = undefined,
    _a$3.appId = undefined,
    _a$3.enableCorsCorrelation = false,
    _a$3[_DYN_ENABLE_REQUEST_HEADE4 /* @min:enableRequestHeaderTracking */] = false,
    _a$3[_DYN_ENABLE_RESPONSE_HEAD12 /* @min:enableResponseHeaderTracking */] = false,
    _a$3[_DYN_ENABLE_AJAX_ERROR_ST5 /* @min:enableAjaxErrorStatusText */] = false,
    _a$3[_DYN_ENABLE_AJAX_PERF_TRA6 /* @min:enableAjaxPerfTracking */] = false,
    _a$3.maxAjaxPerfLookupAttempts = 3,
    _a$3[_DYN_AJAX_PERF_LOOKUP_DEL10 /* @min:ajaxPerfLookupDelay */] = 25,
    _a$3.ignoreHeaders = [
        "Authorization",
        "X-API-Key",
        "WWW-Authenticate"
    ],
    _a$3[_DYN_ADD_REQUEST_CONTEXT /* @min:addRequestContext */] = undefined,
    _a$3.addIntEndpoints = true,
    _a$3));
var AjaxMonitor = /** @class */ (function (_super) {
    __extendsFn(AjaxMonitor, _super);
    function AjaxMonitor() {
        var _this = _super.call(this) || this;
        _this.identifier = AjaxMonitor.identifier;
        _this.priority = 120;
        var _fetchInitialized; // fetch monitoring initialized
        var _xhrInitialized; // XHR monitoring initialized
        var _currentWindowHost;
        var _extensionConfig;
        var _enableRequestHeaderTracking;
        var _enableAjaxErrorStatusText;
        var _trackAjaxAttempts;
        var _context;
        var _isUsingW3CHeaders;
        var _isUsingAIHeaders;
        var _markPrefix;
        var _enableAjaxPerfTracking;
        var _maxAjaxCallsPerView;
        var _enableResponseHeaderTracking;
        var _disabledUrls;
        var _disableAjaxTracking;
        var _disableFetchTracking;
        var _excludeRequestFromAutoTrackingPatterns;
        var _addRequestContext;
        var _evtNamespace;
        var _ajaxDataId;
        var _dependencyHandlerId;
        var _dependencyListeners;
        var _dependencyInitializers;
        var _ignoreHeaders;
        var _maxAjaxPerfLookupAttempts;
        var _ajaxPerfLookupDelay;
        var _distributedTracingMode;
        var _appId;
        var _polyfillInitialized;
        dynamicProto(AjaxMonitor, _this, function (_self, _base) {
            var _addHook = _base[_DYN__ADD_HOOK /* @min:%2e_addHook */];
            _initDefaults();
            _self.initialize = function (config, core, extensions, pluginChain) {
                if (!_self.isInitialized()) {
                    _base.initialize(config, core, extensions, pluginChain);
                    _evtNamespace = mergeEvtNamespace(createUniqueNamespace("ajax"), core && core.evtNamespace && core.evtNamespace());
                    _populateDefaults(config);
                    _instrumentXhr();
                    _instrumentFetch();
                    _populateContext();
                }
            };
            _self._doTeardown = function () {
                _initDefaults();
            };
            _self.trackDependencyData = function (dependency, properties) {
                _reportDependencyInternal(_dependencyInitializers, _self[_DYN_CORE /* @min:%2ecore */], null, dependency, properties);
            };
            _self[_DYN_INCLUDE_CORRELATION_2 /* @min:%2eincludeCorrelationHeaders */] = function (ajaxData, input, init, xhr) {
                // Test Hook to allow the overriding of the location host
                var currentWindowHost = _self["_currentWindowHost"] || _currentWindowHost;
                _processDependencyListeners(_dependencyListeners, _self[_DYN_CORE /* @min:%2ecore */], ajaxData, xhr, input, init);
                if (input || input === "") { // Fetch
                    if (correlationIdCanIncludeCorrelationHeader(_extensionConfig, ajaxData[_DYN_GET_ABSOLUTE_URL /* @min:%2egetAbsoluteUrl */](), currentWindowHost)) {
                        if (!init) {
                            init = {};
                        }
                        // init headers override original request headers
                        // so, if they exist use only them, otherwise use request's because they should have been applied in the first place
                        // not using original request headers will result in them being lost
                        var headers = new Headers(init[_DYN_HEADERS /* @min:%2eheaders */] || (input instanceof Request ? (input[_DYN_HEADERS /* @min:%2eheaders */] || {}) : {}));
                        if (_isUsingAIHeaders) {
                            var id = "|" + ajaxData[_DYN_TRACE_ID /* @min:%2etraceID */] + "." + ajaxData[_DYN_SPAN_ID /* @min:%2espanID */];
                            headers.set(RequestHeaders[3 /* eRequestHeaders.requestIdHeader */], id);
                            if (_enableRequestHeaderTracking) {
                                ajaxData[_DYN_REQUEST_HEADERS /* @min:%2erequestHeaders */][RequestHeaders[3 /* eRequestHeaders.requestIdHeader */]] = id;
                            }
                        }
                        var appId = _appId || (_context && _context.appId());
                        if (appId) {
                            headers.set(RequestHeaders[0 /* eRequestHeaders.requestContextHeader */], RequestHeaders[2 /* eRequestHeaders.requestContextAppIdFormat */] + appId);
                            if (_enableRequestHeaderTracking) {
                                ajaxData[_DYN_REQUEST_HEADERS /* @min:%2erequestHeaders */][RequestHeaders[0 /* eRequestHeaders.requestContextHeader */]] = RequestHeaders[2 /* eRequestHeaders.requestContextAppIdFormat */] + appId;
                            }
                        }
                        if (_isUsingW3CHeaders) {
                            var traceFlags = ajaxData[_DYN_TRACE_FLAGS /* @min:%2etraceFlags */];
                            if (isNullOrUndefined(traceFlags)) {
                                traceFlags = 0x01;
                            }
                            var traceParent = formatTraceParent(createTraceParent(ajaxData[_DYN_TRACE_ID /* @min:%2etraceID */], ajaxData[_DYN_SPAN_ID /* @min:%2espanID */], traceFlags));
                            headers.set(RequestHeaders[4 /* eRequestHeaders.traceParentHeader */], traceParent);
                            if (_enableRequestHeaderTracking) {
                                ajaxData[_DYN_REQUEST_HEADERS /* @min:%2erequestHeaders */][RequestHeaders[4 /* eRequestHeaders.traceParentHeader */]] = traceParent;
                            }
                        }
                        init[_DYN_HEADERS /* @min:%2eheaders */] = headers;
                    }
                    return init;
                }
                else if (xhr) { // XHR
                    if (correlationIdCanIncludeCorrelationHeader(_extensionConfig, ajaxData[_DYN_GET_ABSOLUTE_URL /* @min:%2egetAbsoluteUrl */](), currentWindowHost)) {
                        if (_isUsingAIHeaders) {
                            if (!_isHeaderSet(xhr, RequestHeaders[3 /* eRequestHeaders.requestIdHeader */])) {
                                var id = "|" + ajaxData[_DYN_TRACE_ID /* @min:%2etraceID */] + "." + ajaxData[_DYN_SPAN_ID /* @min:%2espanID */];
                                xhr[_DYN_SET_REQUEST_HEADER /* @min:%2esetRequestHeader */](RequestHeaders[3 /* eRequestHeaders.requestIdHeader */], id);
                                if (_enableRequestHeaderTracking) {
                                    ajaxData[_DYN_REQUEST_HEADERS /* @min:%2erequestHeaders */][RequestHeaders[3 /* eRequestHeaders.requestIdHeader */]] = id;
                                }
                            }
                            else {
                                _throwInternalWarning(_self, 71 /* _eInternalMessageId.FailedMonitorAjaxSetRequestHeader */, "Unable to set [" + RequestHeaders[3 /* eRequestHeaders.requestIdHeader */] + "] as it has already been set by another instance");
                            }
                        }
                        var appId = _appId || (_context && _context.appId());
                        if (appId) {
                            if (!_isHeaderSet(xhr, RequestHeaders[0 /* eRequestHeaders.requestContextHeader */])) {
                                xhr[_DYN_SET_REQUEST_HEADER /* @min:%2esetRequestHeader */](RequestHeaders[0 /* eRequestHeaders.requestContextHeader */], RequestHeaders[2 /* eRequestHeaders.requestContextAppIdFormat */] + appId);
                                if (_enableRequestHeaderTracking) {
                                    ajaxData[_DYN_REQUEST_HEADERS /* @min:%2erequestHeaders */][RequestHeaders[0 /* eRequestHeaders.requestContextHeader */]] = RequestHeaders[2 /* eRequestHeaders.requestContextAppIdFormat */] + appId;
                                }
                            }
                            else {
                                _throwInternalWarning(_self, 71 /* _eInternalMessageId.FailedMonitorAjaxSetRequestHeader */, "Unable to set [" + RequestHeaders[0 /* eRequestHeaders.requestContextHeader */] + "] as it has already been set by another instance");
                            }
                        }
                        if (_isUsingW3CHeaders) {
                            var traceFlags = ajaxData[_DYN_TRACE_FLAGS /* @min:%2etraceFlags */];
                            if (isNullOrUndefined(traceFlags)) {
                                traceFlags = 0x01;
                            }
                            if (!_isHeaderSet(xhr, RequestHeaders[4 /* eRequestHeaders.traceParentHeader */])) {
                                var traceParent = formatTraceParent(createTraceParent(ajaxData[_DYN_TRACE_ID /* @min:%2etraceID */], ajaxData[_DYN_SPAN_ID /* @min:%2espanID */], traceFlags));
                                xhr[_DYN_SET_REQUEST_HEADER /* @min:%2esetRequestHeader */](RequestHeaders[4 /* eRequestHeaders.traceParentHeader */], traceParent);
                                if (_enableRequestHeaderTracking) {
                                    ajaxData[_DYN_REQUEST_HEADERS /* @min:%2erequestHeaders */][RequestHeaders[4 /* eRequestHeaders.traceParentHeader */]] = traceParent;
                                }
                            }
                            else {
                                _throwInternalWarning(_self, 71 /* _eInternalMessageId.FailedMonitorAjaxSetRequestHeader */, "Unable to set [" + RequestHeaders[4 /* eRequestHeaders.traceParentHeader */] + "] as it has already been set by another instance");
                            }
                        }
                    }
                    return xhr;
                }
                return undefined;
            };
            _self[_DYN_TRACK_DEPENDENCY_DAT3 /* @min:%2etrackDependencyDataInternal */] = function (dependency, properties, systemProperties) {
                if (_maxAjaxCallsPerView === -1 || _trackAjaxAttempts < _maxAjaxCallsPerView) {
                    // Hack since expected format in w3c mode is |abc.def.
                    // Non-w3c format is |abc.def
                    // @todo Remove if better solution is available, e.g. handle in portal
                    if ((_distributedTracingMode === 2 /* eDistributedTracingModes.W3C */
                        || _distributedTracingMode === 1 /* eDistributedTracingModes.AI_AND_W3C */)
                        && typeof dependency.id === "string" && dependency.id[dependency.id[_DYN_LENGTH$1 /* @min:%2elength */] - 1] !== ".") {
                        dependency.id += ".";
                    }
                    if (isNullOrUndefined(dependency[_DYN_START_TIME /* @min:%2estartTime */])) {
                        dependency[_DYN_START_TIME /* @min:%2estartTime */] = new Date();
                    }
                    var item = createTelemetryItem(dependency, RemoteDependencyData.dataType, RemoteDependencyData.envelopeType, _self[strDiagLog](), properties, systemProperties);
                    _self[_DYN_CORE /* @min:%2ecore */].track(item);
                }
                else if (_trackAjaxAttempts === _maxAjaxCallsPerView) {
                    _throwInternalCritical(_self, 55 /* _eInternalMessageId.MaxAjaxPerPVExceeded */, "Maximum ajax per page view limit reached, ajax monitoring is paused until the next trackPageView(). In order to increase the limit set the maxAjaxCallsPerView configuration parameter.", true);
                }
                ++_trackAjaxAttempts;
            };
            _self.addDependencyListener = function (dependencyListener) {
                return _addHandler(_dependencyListeners, _dependencyHandlerId++, dependencyListener);
            };
            _self.addDependencyInitializer = function (dependencyInitializer) {
                return _addHandler(_dependencyInitializers, _dependencyHandlerId++, dependencyInitializer);
            };
            function _initDefaults() {
                var location = getLocation();
                _fetchInitialized = false; // fetch monitoring initialized
                _xhrInitialized = false; // XHR monitoring initialized
                _polyfillInitialized = false; // polyfill monitoring initialized
                _currentWindowHost = location && location.host && location.host[_DYN_TO_LOWER_CASE /* @min:%2etoLowerCase */]();
                _extensionConfig = null;
                _enableRequestHeaderTracking = false;
                _enableAjaxErrorStatusText = false;
                _trackAjaxAttempts = 0;
                _context = null;
                _isUsingW3CHeaders = false;
                _isUsingAIHeaders = false;
                _markPrefix = null;
                _enableAjaxPerfTracking = false;
                _maxAjaxCallsPerView = 0;
                _enableResponseHeaderTracking = false;
                _disabledUrls = {};
                _disableAjaxTracking = false;
                _disableFetchTracking = false;
                _excludeRequestFromAutoTrackingPatterns = null;
                _addRequestContext = null;
                _evtNamespace = null;
                _dependencyHandlerId = 0;
                _dependencyListeners = [];
                _dependencyInitializers = [];
                _ajaxDataId = createUniqueNamespace("ajaxData");
                _self._ajaxDataId = _ajaxDataId;
                _ignoreHeaders = null;
                _maxAjaxPerfLookupAttempts = 1;
                _ajaxPerfLookupDelay = 1;
                _distributedTracingMode = 1 /* eDistributedTracingModes.AI_AND_W3C */;
                _appId = null;
            }
            function _populateDefaults(config) {
                _self[_DYN__ADD_HOOK /* @min:%2e_addHook */](onConfigChange(config, function (details) {
                    var config = details.cfg;
                    var ctx = createProcessTelemetryContext(null, config, _self[_DYN_CORE /* @min:%2ecore */]);
                    _extensionConfig = ctx.getExtCfg(AjaxMonitor.identifier, _defaultConfig$1);
                    _distributedTracingMode = _extensionConfig.distributedTracingMode;
                    _enableRequestHeaderTracking = _extensionConfig[_DYN_ENABLE_REQUEST_HEADE4 /* @min:%2eenableRequestHeaderTracking */];
                    _enableAjaxErrorStatusText = _extensionConfig[_DYN_ENABLE_AJAX_ERROR_ST5 /* @min:%2eenableAjaxErrorStatusText */];
                    _enableAjaxPerfTracking = _extensionConfig[_DYN_ENABLE_AJAX_PERF_TRA6 /* @min:%2eenableAjaxPerfTracking */];
                    _maxAjaxCallsPerView = _extensionConfig[_DYN_MAX_AJAX_CALLS_PER_V7 /* @min:%2emaxAjaxCallsPerView */];
                    _excludeRequestFromAutoTrackingPatterns = [].concat(_extensionConfig[_DYN_EXCLUDE_REQUEST_FROM8 /* @min:%2eexcludeRequestFromAutoTrackingPatterns */] || [], _extensionConfig.addIntEndpoints !== false ? _internalExcludeEndpoints : []);
                    _addRequestContext = _extensionConfig[_DYN_ADD_REQUEST_CONTEXT /* @min:%2eaddRequestContext */];
                    _isUsingAIHeaders = _distributedTracingMode === 0 /* eDistributedTracingModes.AI */ || _distributedTracingMode === 1 /* eDistributedTracingModes.AI_AND_W3C */;
                    _isUsingW3CHeaders = _distributedTracingMode === 1 /* eDistributedTracingModes.AI_AND_W3C */ || _distributedTracingMode === 2 /* eDistributedTracingModes.W3C */;
                    if (_enableAjaxPerfTracking) {
                        var iKey = config.instrumentationKey || "unkwn";
                        if (iKey[_DYN_LENGTH$1 /* @min:%2elength */] > 5) {
                            _markPrefix = AJAX_MONITOR_PREFIX + strSubstring(iKey, iKey[_DYN_LENGTH$1 /* @min:%2elength */] - 5) + ".";
                        }
                        else {
                            _markPrefix = AJAX_MONITOR_PREFIX + iKey + ".";
                        }
                    }
                    _disableAjaxTracking = !!_extensionConfig[_DYN_DISABLE_AJAX_TRACKIN9 /* @min:%2edisableAjaxTracking */];
                    _maxAjaxPerfLookupAttempts = _extensionConfig.maxAjaxPerfLookupAttempts;
                    _ajaxPerfLookupDelay = _extensionConfig[_DYN_AJAX_PERF_LOOKUP_DEL10 /* @min:%2eajaxPerfLookupDelay */];
                    _ignoreHeaders = _extensionConfig.ignoreHeaders;
                    _appId = _extensionConfig.appId;
                }));
            }
            function _populateContext() {
                var propExt = _self[_DYN_CORE /* @min:%2ecore */].getPlugin(PropertiesPluginIdentifier);
                if (propExt) {
                    _context = propExt.plugin[_DYN_CONTEXT$1 /* @min:%2econtext */]; // we could move IPropertiesPlugin to common as well
                }
            }
            // discard the header if it's defined as ignoreHeaders in ICorrelationConfig
            function _canIncludeHeaders(header) {
                var rlt = true;
                if (header || _ignoreHeaders) {
                    arrForEach(_ignoreHeaders, (function (key) {
                        if (key[_DYN_TO_LOWER_CASE /* @min:%2etoLowerCase */]() === header[_DYN_TO_LOWER_CASE /* @min:%2etoLowerCase */]()) {
                            rlt = false;
                            return -1;
                        }
                    }));
                }
                return rlt;
            }
            // Fetch Stuff
            function _instrumentFetch() {
                var fetch = _supportsFetch();
                if (!fetch) {
                    return;
                }
                var global = getGlobal();
                var isPolyfill = fetch.polyfill;
                _self[_DYN__ADD_HOOK /* @min:%2e_addHook */](onConfigChange(_extensionConfig, function () {
                    _disableFetchTracking = !!_extensionConfig[_DYN_DISABLE_FETCH_TRACKI11 /* @min:%2edisableFetchTracking */];
                    _enableResponseHeaderTracking = _extensionConfig[_DYN_ENABLE_RESPONSE_HEAD12 /* @min:%2eenableResponseHeaderTracking */];
                    if (!_disableFetchTracking && !_fetchInitialized) {
                        _addHook(InstrumentFunc(global, STR_FETCH, {
                            ns: _evtNamespace,
                            // Add request hook
                            req: function (callDetails, input, init) {
                                var fetchData;
                                if (!_disableFetchTracking && _fetchInitialized &&
                                    !_isDisabledRequest(null, input, init) &&
                                    // If we have a polyfil and XHR instrumented then let XHR report otherwise we get duplicates
                                    !(isPolyfill && _xhrInitialized)) {
                                    var ctx = callDetails.ctx();
                                    fetchData = _createFetchRecord(input, init);
                                    var newInit = _self[_DYN_INCLUDE_CORRELATION_2 /* @min:%2eincludeCorrelationHeaders */](fetchData, input, init);
                                    if (newInit !== init) {
                                        callDetails.set(1, newInit);
                                    }
                                    ctx.data = fetchData;
                                }
                            },
                            rsp: function (callDetails, input) {
                                if (!_disableFetchTracking) {
                                    var fetchData_1 = callDetails.ctx().data;
                                    if (fetchData_1) {
                                        // Replace the result with the new promise from this code
                                        callDetails.rslt = callDetails.rslt.then(function (response) {
                                            _reportFetchMetrics(callDetails, (response || {})[_DYN_STATUS /* @min:%2estatus */], input, response, fetchData_1, function () {
                                                var _a;
                                                var ajaxResponse = (_a = {
                                                        statusText: (response || {})[_DYN_STATUS_TEXT /* @min:%2estatusText */]
                                                    },
                                                    _a[_DYN_HEADER_MAP /* @min:headerMap */] = null,
                                                    _a[_DYN_CORRELATION_CONTEXT /* @min:correlationContext */] = _getFetchCorrelationContext(response),
                                                    _a);
                                                if (_enableResponseHeaderTracking && response) {
                                                    var responseHeaderMap_1 = {};
                                                    response.headers.forEach(function (value, name) {
                                                        if (_canIncludeHeaders(name)) {
                                                            responseHeaderMap_1[name] = value;
                                                        }
                                                    });
                                                    ajaxResponse[_DYN_HEADER_MAP /* @min:%2eheaderMap */] = responseHeaderMap_1;
                                                }
                                                return ajaxResponse;
                                            });
                                            return response;
                                        })
                                            .catch(function (reason) {
                                            _reportFetchMetrics(callDetails, 0, input, null, fetchData_1, null, { error: reason.message || dumpObj(reason) });
                                            throw reason;
                                        });
                                    }
                                }
                            },
                            // Create an error callback to report any hook errors
                            hkErr: _createErrorCallbackFunc(_self, 15 /* _eInternalMessageId.FailedMonitorAjaxOpen */, "Failed to monitor Window.fetch" + ERROR_POSTFIX)
                        }, true, isWebWorker()));
                        _fetchInitialized = true;
                    }
                    else if (isPolyfill && !_polyfillInitialized) {
                        // If fetch is a polyfill we need to capture the request to ensure that we correctly track
                        // disabled request URLS (i.e. internal urls) to ensure we don't end up in a constant loop
                        // of reporting ourselves, for example React Native uses a polyfill for fetch
                        // Note: Polyfill implementations that don't support the "polyfill" tag are not supported
                        // the workaround is to add a polyfill property to your fetch implementation before initializing
                        // App Insights
                        _addHook(InstrumentFunc(global, STR_FETCH, {
                            ns: _evtNamespace,
                            req: function (callDetails, input, init) {
                                // Just call so that we record any disabled URL
                                _isDisabledRequest(null, input, init);
                            }
                        }));
                        _polyfillInitialized = true;
                    }
                }));
                if (isPolyfill) {
                    // retag the instrumented fetch with the same polyfill settings this is mostly for testing
                    // But also supports multiple App Insights usages
                    global[STR_FETCH].polyfill = isPolyfill;
                }
            }
            function _hookProto(target, funcName, callbacks) {
                _addHook(InstrumentProto(target, funcName, callbacks));
            }
            function _instrumentXhr() {
                if (!_supportsAjaxMonitoring(_self, _ajaxDataId)) {
                    return;
                }
                _self[_DYN__ADD_HOOK /* @min:%2e_addHook */](onConfigChange(_extensionConfig, function () {
                    _disableAjaxTracking = !!_extensionConfig[_DYN_DISABLE_AJAX_TRACKIN9 /* @min:%2edisableAjaxTracking */];
                    _enableRequestHeaderTracking = _extensionConfig[_DYN_ENABLE_REQUEST_HEADE4 /* @min:%2eenableRequestHeaderTracking */];
                    if (!_disableAjaxTracking && !_xhrInitialized) {
                        // Instrument open
                        _hookProto(XMLHttpRequest, "open", {
                            ns: _evtNamespace,
                            req: function (callDetails, method, url, async) {
                                if (!_disableAjaxTracking) {
                                    var xhr = callDetails[_DYN_INST /* @min:%2einst */];
                                    var ajaxData = _getAjaxData(xhr, _ajaxDataId);
                                    if (!_isDisabledRequest(xhr, url) && _isMonitoredXhrInstance(xhr, ajaxData, true)) {
                                        if (!ajaxData || !ajaxData.xhrMonitoringState[_DYN_OPEN_DONE /* @min:%2eopenDone */]) {
                                            // Only create a single ajaxData (even when multiple AI instances are running)
                                            ajaxData = _openHandler(xhr, method, url, async);
                                        }
                                        // always attach to the on ready state change (required for handling multiple instances)
                                        _attachToOnReadyStateChange(xhr, ajaxData);
                                    }
                                }
                            },
                            hkErr: _createErrorCallbackFunc(_self, 15 /* _eInternalMessageId.FailedMonitorAjaxOpen */, ERROR_HEADER + ".open" + ERROR_POSTFIX)
                        });
                        // Instrument send
                        _hookProto(XMLHttpRequest, "send", {
                            ns: _evtNamespace,
                            req: function (callDetails, context) {
                                if (!_disableAjaxTracking) {
                                    var xhr = callDetails[_DYN_INST /* @min:%2einst */];
                                    var ajaxData = _getAjaxData(xhr, _ajaxDataId);
                                    if (_isMonitoredXhrInstance(xhr, ajaxData) && !ajaxData.xhrMonitoringState[_DYN_SEND_DONE /* @min:%2esendDone */]) {
                                        _createMarkId("xhr", ajaxData);
                                        ajaxData[_DYN_REQUEST_SENT_TIME /* @min:%2erequestSentTime */] = dateTimeUtilsNow();
                                        _self[_DYN_INCLUDE_CORRELATION_2 /* @min:%2eincludeCorrelationHeaders */](ajaxData, undefined, undefined, xhr);
                                        ajaxData.xhrMonitoringState[_DYN_SEND_DONE /* @min:%2esendDone */] = true;
                                    }
                                }
                            },
                            hkErr: _createErrorCallbackFunc(_self, 17 /* _eInternalMessageId.FailedMonitorAjaxSend */, ERROR_HEADER + ERROR_POSTFIX)
                        });
                        // Instrument abort
                        _hookProto(XMLHttpRequest, "abort", {
                            ns: _evtNamespace,
                            req: function (callDetails) {
                                if (!_disableAjaxTracking) {
                                    var xhr = callDetails[_DYN_INST /* @min:%2einst */];
                                    var ajaxData = _getAjaxData(xhr, _ajaxDataId);
                                    if (_isMonitoredXhrInstance(xhr, ajaxData) && !ajaxData.xhrMonitoringState[_DYN_ABORT_DONE /* @min:%2eabortDone */]) {
                                        ajaxData[_DYN_ABORTED /* @min:%2eaborted */] = 1;
                                        ajaxData.xhrMonitoringState[_DYN_ABORT_DONE /* @min:%2eabortDone */] = true;
                                    }
                                }
                            },
                            hkErr: _createErrorCallbackFunc(_self, 13 /* _eInternalMessageId.FailedMonitorAjaxAbort */, ERROR_HEADER + ".abort" + ERROR_POSTFIX)
                        });
                        // Instrument setRequestHeader
                        _hookProto(XMLHttpRequest, "setRequestHeader", {
                            ns: _evtNamespace,
                            req: function (callDetails, header, value) {
                                if (!_disableAjaxTracking) {
                                    var xhr = callDetails[_DYN_INST /* @min:%2einst */];
                                    var ajaxData = _getAjaxData(xhr, _ajaxDataId);
                                    if (ajaxData && _isMonitoredXhrInstance(xhr, ajaxData)) {
                                        _addSharedXhrHeaders(xhr, header, value);
                                        if (_enableRequestHeaderTracking && _canIncludeHeaders(header)) {
                                            if (ajaxData) {
                                                ajaxData[_DYN_REQUEST_HEADERS /* @min:%2erequestHeaders */][header] = value;
                                            }
                                        }
                                    }
                                }
                            },
                            hkErr: _createErrorCallbackFunc(_self, 71 /* _eInternalMessageId.FailedMonitorAjaxSetRequestHeader */, ERROR_HEADER + ".setRequestHeader" + ERROR_POSTFIX)
                        });
                        _xhrInitialized = true;
                    }
                }));
            }
            function _isDisabledRequest(xhr, request, init) {
                var isDisabled = false;
                var theUrl = ((!isString(request) ? (request || {}).url || "" : request) || "")[_DYN_TO_LOWER_CASE /* @min:%2etoLowerCase */]();
                // check excludeRequestFromAutoTrackingPatterns before stripping off any query string
                arrForEach(_excludeRequestFromAutoTrackingPatterns, function (regex) {
                    var theRegex = regex;
                    if (isString(regex)) {
                        theRegex = new RegExp(regex);
                    }
                    if (!isDisabled) {
                        isDisabled = theRegex.test(theUrl);
                    }
                });
                // if request url matches with exclude regex pattern, return true and no need to check for headers
                if (isDisabled) {
                    return isDisabled;
                }
                var idx = _indexOf(theUrl, "?");
                var idx2 = _indexOf(theUrl, "#");
                if (idx === -1 || (idx2 !== -1 && idx2 < idx)) {
                    idx = idx2;
                }
                if (idx !== -1) {
                    // Strip off any Query string
                    theUrl = theUrl.substring(0, idx);
                }
                // check that this instance is not not used by ajax call performed inside client side monitoring to send data to collector
                if (!isNullOrUndefined(xhr)) {
                    // Look on the XMLHttpRequest of the URL string value
                    isDisabled = xhr[DisabledPropertyName] === true || theUrl[DisabledPropertyName] === true;
                }
                else if (!isNullOrUndefined(request)) { // fetch
                    // Look for DisabledPropertyName in either Request or RequestInit
                    isDisabled = (typeof request === "object" ? request[DisabledPropertyName] === true : false) ||
                        (init ? init[DisabledPropertyName] === true : false);
                }
                // Also add extra check just in case the XHR or fetch objects where not decorated with the DisableProperty due to sealing or freezing
                if (!isDisabled && theUrl && isInternalApplicationInsightsEndpoint(theUrl)) {
                    isDisabled = true;
                }
                if (isDisabled) {
                    // Add the disabled url if not present
                    if (!_disabledUrls[theUrl]) {
                        _disabledUrls[theUrl] = 1;
                    }
                }
                else {
                    // Check to see if the url is listed as disabled
                    if (_disabledUrls[theUrl]) {
                        isDisabled = true;
                    }
                }
                return isDisabled;
            }
            /// <summary>Verifies that particular instance of XMLHttpRequest needs to be monitored</summary>
            /// <param name="excludeAjaxDataValidation">Optional parameter. True if ajaxData must be excluded from verification</param>
            /// <returns type="bool">True if instance needs to be monitored, otherwise false</returns>
            function _isMonitoredXhrInstance(xhr, ajaxData, excludeAjaxDataValidation) {
                var ajaxValidation = true;
                var initialized = _xhrInitialized;
                if (!isNullOrUndefined(xhr)) {
                    ajaxValidation = excludeAjaxDataValidation === true || !isNullOrUndefined(ajaxData);
                }
                // checking to see that all interested functions on xhr were instrumented
                return initialized
                    // checking on ajaxData to see that it was not removed in user code
                    && ajaxValidation;
            }
            function _getDistributedTraceCtx() {
                var distributedTraceCtx = null;
                if (_self[_DYN_CORE /* @min:%2ecore */] && _self[_DYN_CORE /* @min:%2ecore */].getTraceCtx) {
                    distributedTraceCtx = _self[_DYN_CORE /* @min:%2ecore */].getTraceCtx(false);
                }
                // Fall back
                if (!distributedTraceCtx && _context && _context.telemetryTrace) {
                    distributedTraceCtx = createDistributedTraceContextFromTrace(_context.telemetryTrace);
                }
                return distributedTraceCtx;
            }
            function _openHandler(xhr, method, url, async) {
                var _a;
                var distributedTraceCtx = _getDistributedTraceCtx();
                var traceID = (distributedTraceCtx && distributedTraceCtx[_DYN_GET_TRACE_ID /* @min:%2egetTraceId */]()) || generateW3CId();
                var spanID = strSubstr(generateW3CId(), 0, 16);
                var xhrRequestData = xhr[AJAX_DATA_CONTAINER] = (xhr[AJAX_DATA_CONTAINER] || { xh: [], i: {} });
                var ajaxDataCntr = xhrRequestData.i = (xhrRequestData.i || {});
                var ajaxData = ajaxDataCntr[_ajaxDataId] = (ajaxDataCntr[_ajaxDataId] || new ajaxRecord(traceID, spanID, _self[strDiagLog](), (_a = _self.core) === null || _a === void 0 ? void 0 : _a.getTraceCtx()));
                ajaxData[_DYN_TRACE_FLAGS /* @min:%2etraceFlags */] = distributedTraceCtx && distributedTraceCtx[_DYN_GET_TRACE_FLAGS /* @min:%2egetTraceFlags */]();
                ajaxData[_DYN_METHOD /* @min:%2emethod */] = method;
                ajaxData[_DYN_REQUEST_URL /* @min:%2erequestUrl */] = url;
                ajaxData.xhrMonitoringState[_DYN_OPEN_DONE /* @min:%2eopenDone */] = true;
                ajaxData[_DYN_REQUEST_HEADERS /* @min:%2erequestHeaders */] = {};
                ajaxData.async = async;
                ajaxData[_DYN_ERROR_STATUS_TEXT /* @min:%2eerrorStatusText */] = _enableAjaxErrorStatusText;
                return ajaxData;
            }
            function _attachToOnReadyStateChange(xhr, ajaxData) {
                ajaxData.xhrMonitoringState[_DYN_STATE_CHANGE_ATTACHE13 /* @min:%2estateChangeAttached */] = eventOn(xhr, "readystatechange", function () {
                    var _a;
                    try {
                        if (xhr && xhr.readyState === 4 && _isMonitoredXhrInstance(xhr, ajaxData)) {
                            _onAjaxComplete(xhr);
                        }
                    }
                    catch (e) {
                        var exceptionText = dumpObj(e);
                        // ignore messages with c00c023f, as this a known IE9 XHR abort issue
                        if (!exceptionText || _indexOf(exceptionText[_DYN_TO_LOWER_CASE /* @min:%2etoLowerCase */](), "c00c023f") === -1) {
                            _throwInternalCritical(_self, 16 /* _eInternalMessageId.FailedMonitorAjaxRSC */, ERROR_HEADER + " 'readystatechange' event handler" + ERROR_POSTFIX, (_a = {},
                                _a[_DYN_AJAX_DIAGNOSTICS_MES16 /* @min:ajaxDiagnosticsMessage */] = _getFailedAjaxDiagnosticsMessage(xhr, _ajaxDataId),
                                _a[_DYN_EXCEPTION /* @min:exception */] = exceptionText,
                                _a));
                        }
                    }
                }, _evtNamespace);
            }
            function _getResponseText(xhr) {
                try {
                    var responseType = xhr.responseType;
                    if (responseType === "" || responseType === "text") {
                        // As per the specification responseText is only valid if the type is an empty string or "text"
                        return xhr[_DYN_RESPONSE_TEXT /* @min:%2eresponseText */];
                    }
                }
                catch (e) {
                    // This shouldn't happen because of the above check -- but just in case, so just ignore
                }
                return null;
            }
            function _onAjaxComplete(xhr) {
                var ajaxData = _getAjaxData(xhr, _ajaxDataId);
                ajaxData[_DYN_RESPONSE_FINISHED_TI14 /* @min:%2eresponseFinishedTime */] = dateTimeUtilsNow();
                ajaxData[_DYN_STATUS /* @min:%2estatus */] = xhr[_DYN_STATUS /* @min:%2estatus */];
                function _reportXhrError(e, failedProps) {
                    var errorProps = failedProps || {};
                    errorProps["ajaxDiagnosticsMessage"] = _getFailedAjaxDiagnosticsMessage(xhr, _ajaxDataId);
                    if (e) {
                        errorProps["exception"] = dumpObj(e);
                    }
                    _throwInternalWarning(_self, 14 /* _eInternalMessageId.FailedMonitorAjaxDur */, FAILED_TO_CALCULATE_DURATION_ERROR + "ajax call" + ERROR_NOT_SENT, errorProps);
                }
                _findPerfResourceEntry("xmlhttprequest", ajaxData, function () {
                    try {
                        var dependency = ajaxData[_DYN__CREATE_TRACK_ITEM /* @min:%2eCreateTrackItem */]("Ajax", _enableRequestHeaderTracking, function () {
                            var _a;
                            var ajaxResponse = (_a = {
                                    statusText: xhr[_DYN_STATUS_TEXT /* @min:%2estatusText */]
                                },
                                _a[_DYN_HEADER_MAP /* @min:headerMap */] = null,
                                _a[_DYN_CORRELATION_CONTEXT /* @min:correlationContext */] = _getAjaxCorrelationContext(xhr),
                                _a.type = xhr.responseType,
                                _a[_DYN_RESPONSE_TEXT /* @min:responseText */] = _getResponseText(xhr),
                                _a.response = xhr[_DYN_RESPONSE /* @min:%2eresponse */],
                                _a);
                            if (_enableResponseHeaderTracking) {
                                var headers = xhr[_DYN_GET_ALL_RESPONSE_HEA15 /* @min:%2egetAllResponseHeaders */]();
                                if (headers) {
                                    // xhr.getAllResponseHeaders() method returns all the response headers, separated by CRLF, as a string or null
                                    // the regex converts the header string into an array of individual headers
                                    var arr = strTrim(headers).split(/[\r\n]+/);
                                    var responseHeaderMap_2 = {};
                                    arrForEach(arr, function (line) {
                                        var parts = line.split(": ");
                                        var header = parts.shift();
                                        var value = parts.join(": ");
                                        if (_canIncludeHeaders(header)) {
                                            responseHeaderMap_2[header] = value;
                                        }
                                    });
                                    ajaxResponse[_DYN_HEADER_MAP /* @min:%2eheaderMap */] = responseHeaderMap_2;
                                }
                            }
                            return ajaxResponse;
                        });
                        var properties = void 0;
                        try {
                            if (!!_addRequestContext) {
                                properties = _addRequestContext({ status: xhr[_DYN_STATUS /* @min:%2estatus */], xhr: xhr });
                            }
                        }
                        catch (e) {
                            _throwInternalWarning(_self, 104 /* _eInternalMessageId.FailedAddingCustomDefinedRequestContext */, CUSTOM_REQUEST_CONTEXT_ERROR);
                        }
                        if (dependency) {
                            if (properties !== undefined) {
                                dependency[STR_PROPERTIES /* @min:%2eproperties */] = __assignFn(__assignFn({}, dependency.properties), properties);
                            }
                            var sysProperties = ajaxData[_DYN_GET_PART_APROPS /* @min:%2egetPartAProps */]();
                            _reportDependencyInternal(_dependencyInitializers, _self[_DYN_CORE /* @min:%2ecore */], ajaxData, dependency, null, sysProperties);
                        }
                        else {
                            _reportXhrError(null, {
                                requestSentTime: ajaxData[_DYN_REQUEST_SENT_TIME /* @min:%2erequestSentTime */],
                                responseFinishedTime: ajaxData[_DYN_RESPONSE_FINISHED_TI14 /* @min:%2eresponseFinishedTime */]
                            });
                        }
                    }
                    finally {
                        // cleanup telemetry data
                        try {
                            var xhrRequestData = (xhr[AJAX_DATA_CONTAINER] || { i: {} });
                            var ajaxDataCntr = (xhrRequestData.i || {});
                            if (ajaxDataCntr[_ajaxDataId]) {
                                ajaxDataCntr[_ajaxDataId] = null;
                            }
                        }
                        catch (e) {
                            // May throw in environments that prevent extension or freeze xhr
                        }
                    }
                }, function (e) {
                    _reportXhrError(e, null);
                });
            }
            function _getAjaxCorrelationContext(xhr) {
                var _a;
                try {
                    var responseHeadersString = xhr[_DYN_GET_ALL_RESPONSE_HEA15 /* @min:%2egetAllResponseHeaders */]();
                    if (responseHeadersString !== null) {
                        var index = _indexOf(responseHeadersString[_DYN_TO_LOWER_CASE /* @min:%2etoLowerCase */](), RequestHeaders[8 /* eRequestHeaders.requestContextHeaderLowerCase */]);
                        if (index !== -1) {
                            var responseHeader = xhr.getResponseHeader(RequestHeaders[0 /* eRequestHeaders.requestContextHeader */]);
                            return correlationIdGetCorrelationContext(responseHeader);
                        }
                    }
                }
                catch (e) {
                    _throwInternalWarning(_self, 18 /* _eInternalMessageId.FailedMonitorAjaxGetCorrelationHeader */, CORRELATION_HEADER_ERROR, (_a = {},
                        _a[_DYN_AJAX_DIAGNOSTICS_MES16 /* @min:ajaxDiagnosticsMessage */] = _getFailedAjaxDiagnosticsMessage(xhr, _ajaxDataId),
                        _a[_DYN_EXCEPTION /* @min:exception */] = dumpObj(e),
                        _a));
                }
            }
            function _createMarkId(type, ajaxData) {
                if (ajaxData[_DYN_REQUEST_URL /* @min:%2erequestUrl */] && _markPrefix && _enableAjaxPerfTracking) {
                    var performance_1 = getPerformance();
                    if (performance_1 && isFunction(performance_1.mark)) {
                        _markCount++;
                        var markId = _markPrefix + type + "#" + _markCount;
                        performance_1.mark(markId);
                        var entries = performance_1.getEntriesByName(markId);
                        if (entries && entries[_DYN_LENGTH$1 /* @min:%2elength */] === 1) {
                            ajaxData[_DYN_PERF_MARK /* @min:%2eperfMark */] = entries[0];
                        }
                    }
                }
            }
            function _findPerfResourceEntry(initiatorType, ajaxData, trackCallback, reportError) {
                var perfMark = ajaxData[_DYN_PERF_MARK /* @min:%2eperfMark */];
                var performance = getPerformance();
                var maxAttempts = _maxAjaxPerfLookupAttempts;
                var retryDelay = _ajaxPerfLookupDelay;
                var requestUrl = ajaxData[_DYN_REQUEST_URL /* @min:%2erequestUrl */];
                var attempt = 0;
                (function locateResourceTiming() {
                    try {
                        if (performance && perfMark) {
                            attempt++;
                            var perfTiming = null;
                            var entries = performance.getEntries();
                            for (var lp = entries[_DYN_LENGTH$1 /* @min:%2elength */] - 1; lp >= 0; lp--) {
                                var entry = entries[lp];
                                if (entry) {
                                    if (entry.entryType === "resource") {
                                        if (entry.initiatorType === initiatorType &&
                                            (_indexOf(entry[_DYN_NAME /* @min:%2ename */], requestUrl) !== -1 || _indexOf(requestUrl, entry[_DYN_NAME /* @min:%2ename */]) !== -1)) {
                                            perfTiming = entry;
                                        }
                                    }
                                    else if (entry.entryType === "mark" && entry[_DYN_NAME /* @min:%2ename */] === perfMark[_DYN_NAME /* @min:%2ename */]) {
                                        // We hit the start event
                                        ajaxData[_DYN_PERF_TIMING /* @min:%2eperfTiming */] = perfTiming;
                                        break;
                                    }
                                    if (entry[_DYN_START_TIME /* @min:%2estartTime */] < perfMark[_DYN_START_TIME /* @min:%2estartTime */] - 1000) {
                                        // Fallback to try and reduce the time spent looking for the perf entry
                                        break;
                                    }
                                }
                            }
                        }
                        if (!perfMark || // - we don't have a perfMark or
                            ajaxData[_DYN_PERF_TIMING /* @min:%2eperfTiming */] || // - we have not found the perf entry or
                            attempt >= maxAttempts || // - we have tried too many attempts or
                            ajaxData.async === false) { // - this is a sync request
                            if (perfMark && isFunction(performance.clearMarks)) {
                                // Remove the mark so we don't fill up the performance resources too much
                                performance.clearMarks(perfMark[_DYN_NAME /* @min:%2ename */]);
                            }
                            ajaxData.perfAttempts = attempt;
                            // just continue and report the track event
                            trackCallback();
                        }
                        else {
                            // We need to wait for the browser to populate the window.performance entry
                            // This needs to be at least 1ms as waiting <= 1 (on firefox) is not enough time for fetch or xhr,
                            // this is a scheduling issue for the browser implementation
                            scheduleTimeout(locateResourceTiming, retryDelay);
                        }
                    }
                    catch (e) {
                        reportError(e);
                    }
                })();
            }
            function _createFetchRecord(input, init) {
                var _a;
                var distributedTraceCtx = _getDistributedTraceCtx();
                var traceID = (distributedTraceCtx && distributedTraceCtx[_DYN_GET_TRACE_ID /* @min:%2egetTraceId */]()) || generateW3CId();
                var spanID = strSubstr(generateW3CId(), 0, 16);
                var ajaxData = new ajaxRecord(traceID, spanID, _self[strDiagLog](), (_a = _self.core) === null || _a === void 0 ? void 0 : _a.getTraceCtx());
                ajaxData[_DYN_TRACE_FLAGS /* @min:%2etraceFlags */] = distributedTraceCtx && distributedTraceCtx[_DYN_GET_TRACE_FLAGS /* @min:%2egetTraceFlags */]();
                ajaxData[_DYN_REQUEST_SENT_TIME /* @min:%2erequestSentTime */] = dateTimeUtilsNow();
                ajaxData[_DYN_ERROR_STATUS_TEXT /* @min:%2eerrorStatusText */] = _enableAjaxErrorStatusText;
                if (input instanceof Request) {
                    ajaxData[_DYN_REQUEST_URL /* @min:%2erequestUrl */] = input ? input.url : "";
                }
                else {
                    ajaxData[_DYN_REQUEST_URL /* @min:%2erequestUrl */] = input;
                }
                var method = "GET";
                if (init && init[_DYN_METHOD /* @min:%2emethod */]) {
                    method = init[_DYN_METHOD /* @min:%2emethod */];
                }
                else if (input && input instanceof Request) {
                    method = input[_DYN_METHOD /* @min:%2emethod */];
                }
                ajaxData[_DYN_METHOD /* @min:%2emethod */] = method;
                var requestHeaders = {};
                if (_enableRequestHeaderTracking) {
                    var headers = new Headers((init ? init[_DYN_HEADERS /* @min:%2eheaders */] : 0) || (input instanceof Request ? (input[_DYN_HEADERS /* @min:%2eheaders */] || {}) : {}));
                    headers.forEach(function (value, key) {
                        if (_canIncludeHeaders(key)) {
                            requestHeaders[key] = value;
                        }
                    });
                }
                ajaxData[_DYN_REQUEST_HEADERS /* @min:%2erequestHeaders */] = requestHeaders;
                _createMarkId(STR_FETCH, ajaxData);
                return ajaxData;
            }
            function _getFailedFetchDiagnosticsMessage(input) {
                var result = "";
                try {
                    if (!isNullOrUndefined(input)) {
                        if (typeof (input) === "string") {
                            result += "(url: '".concat(input, "')");
                        }
                        else {
                            result += "(url: '".concat(input.url, "')");
                        }
                    }
                }
                catch (e) {
                    _throwInternalCritical(_self, 15 /* _eInternalMessageId.FailedMonitorAjaxOpen */, "Failed to grab failed fetch diagnostics message", { exception: dumpObj(e) });
                }
                return result;
            }
            function _reportFetchMetrics(callDetails, status, input, response, ajaxData, getResponse, properties) {
                if (!ajaxData) {
                    return;
                }
                function _reportFetchError(msgId, e, failedProps) {
                    var errorProps = failedProps || {};
                    errorProps["fetchDiagnosticsMessage"] = _getFailedFetchDiagnosticsMessage(input);
                    if (e) {
                        errorProps["exception"] = dumpObj(e);
                    }
                    _throwInternalWarning(_self, msgId, FAILED_TO_CALCULATE_DURATION_ERROR + "fetch call" + ERROR_NOT_SENT, errorProps);
                }
                ajaxData[_DYN_RESPONSE_FINISHED_TI14 /* @min:%2eresponseFinishedTime */] = dateTimeUtilsNow();
                ajaxData[_DYN_STATUS /* @min:%2estatus */] = status;
                _findPerfResourceEntry(STR_FETCH, ajaxData, function () {
                    var dependency = ajaxData[_DYN__CREATE_TRACK_ITEM /* @min:%2eCreateTrackItem */]("Fetch", _enableRequestHeaderTracking, getResponse);
                    var properties;
                    try {
                        if (!!_addRequestContext) {
                            properties = _addRequestContext({ status: status, request: input, response: response });
                        }
                    }
                    catch (e) {
                        _throwInternalWarning(_self, 104 /* _eInternalMessageId.FailedAddingCustomDefinedRequestContext */, CUSTOM_REQUEST_CONTEXT_ERROR);
                    }
                    if (dependency) {
                        if (properties !== undefined) {
                            dependency[STR_PROPERTIES /* @min:%2eproperties */] = __assignFn(__assignFn({}, dependency.properties), properties);
                        }
                        var sysProperties = ajaxData[_DYN_GET_PART_APROPS /* @min:%2egetPartAProps */]();
                        _reportDependencyInternal(_dependencyInitializers, _self[_DYN_CORE /* @min:%2ecore */], ajaxData, dependency, null, sysProperties);
                    }
                    else {
                        _reportFetchError(14 /* _eInternalMessageId.FailedMonitorAjaxDur */, null, {
                            requestSentTime: ajaxData[_DYN_REQUEST_SENT_TIME /* @min:%2erequestSentTime */],
                            responseFinishedTime: ajaxData[_DYN_RESPONSE_FINISHED_TI14 /* @min:%2eresponseFinishedTime */]
                        });
                    }
                }, function (e) {
                    _reportFetchError(18 /* _eInternalMessageId.FailedMonitorAjaxGetCorrelationHeader */, e, null);
                });
            }
            function _getFetchCorrelationContext(response) {
                var _a;
                if (response && response[_DYN_HEADERS /* @min:%2eheaders */]) {
                    try {
                        var responseHeader = response[_DYN_HEADERS /* @min:%2eheaders */].get(RequestHeaders[0 /* eRequestHeaders.requestContextHeader */]);
                        return correlationIdGetCorrelationContext(responseHeader);
                    }
                    catch (e) {
                        _throwInternalWarning(_self, 18 /* _eInternalMessageId.FailedMonitorAjaxGetCorrelationHeader */, CORRELATION_HEADER_ERROR, (_a = {
                                fetchDiagnosticsMessage: _getFailedFetchDiagnosticsMessage(response)
                            },
                            _a[_DYN_EXCEPTION /* @min:exception */] = dumpObj(e),
                            _a));
                    }
                }
            }
            function _reportDependencyInternal(initializers, core, ajaxData, dependency, properties, systemProperties) {
                var _a;
                var result = true;
                var initializersCount = initializers[_DYN_LENGTH$1 /* @min:%2elength */];
                if (initializersCount > 0) {
                    var details = (_a = {
                            item: dependency
                        },
                        _a[STR_PROPERTIES /* @min:properties */] = properties,
                        _a.sysProperties = systemProperties,
                        _a.context = ajaxData ? ajaxData[_DYN_CONTEXT$1 /* @min:%2econtext */] : null,
                        _a.aborted = ajaxData ? !!ajaxData[_DYN_ABORTED /* @min:%2eaborted */] : false,
                        _a);
                    result = _processDependencyContainer(core, initializers, details, "initializer");
                }
                if (result) {
                    _self[_DYN_TRACK_DEPENDENCY_DAT3 /* @min:%2etrackDependencyDataInternal */](dependency, properties, systemProperties);
                }
            }
        });
        return _this;
    }
// Removed Stub for AjaxMonitor.prototype.initialize.
    AjaxMonitor.prototype.processTelemetry = function (item, itemCtx) {
        this.processNext(item, itemCtx);
    };
// Removed Stub for AjaxMonitor.prototype.trackDependencyData.
// Removed Stub for AjaxMonitor.prototype.includeCorrelationHeaders.
// Removed Stub for AjaxMonitor.prototype.addDependencyListener.
    /**
     * Add an dependency telemetry initializer callback function to allow populating additional properties or drop the request.
     * It is called after the dependency call has completed and any available performance details are available. A dependency
     * initializer is similar to the TelemetryInitializer function but it allows you to block the reporting of the dependency
     * request so that it doesn't count against the `maxAjaxCallsPerView`.
     * @param dependencyInitializer - The Dependency Telemetry Initializer function
     * @returns - A IDependencyInitializerHandler to enable the initializer to be removed
     */
    AjaxMonitor.prototype.addDependencyInitializer = function (dependencyInitializer) {
        return null;
    };
// Removed Stub for AjaxMonitor.prototype.trackDependencyDataInternal.
    AjaxMonitor.identifier = "AjaxDependencyPlugin";
    return AjaxMonitor;
}(BaseTelemetryPlugin));

/*
 * Application Insights JavaScript SDK - Properties Plugin, 3.0.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


var Application = /** @class */ (function () {
    function Application() {
    }
    return Application;
}());

/*
 * Application Insights JavaScript SDK - Properties Plugin, 3.0.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


var Device = /** @class */ (function () {
    /**
     * Constructs a new instance of the Device class
     */
    function Device() {
        // don't attempt to fingerprint browsers
        this.id = "browser";
        // Device type is a dimension in our data platform
        // Setting it to 'Browser' allows to separate client and server dependencies/exceptions
        this.deviceClass = "Browser";
    }
    return Device;
}());

/*
 * Application Insights JavaScript SDK - Properties Plugin, 3.0.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */

var Version = '3.0.3';
var Internal = /** @class */ (function () {
    /**
     * Constructs a new instance of the internal telemetry data class.
     */
    function Internal(config, unloadHookContainer) {
        var _this = this;
        var unloadHook = onConfigChange((config), function () {
            var prefix = config.sdkExtension;
            _this.sdkVersion = (prefix ? prefix + "_" : "") + "javascript:" + Version;
        });
        unloadHookContainer && unloadHookContainer.add(unloadHook);
    }
    return Internal;
}());

/*
 * Application Insights JavaScript SDK - Properties Plugin, 3.0.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


var Location = /** @class */ (function () {
    function Location() {
    }
    return Location;
}());

/*
 * Application Insights JavaScript SDK - Properties Plugin, 3.0.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


// @skip-file-minify
// ##############################################################
// AUTO GENERATED FILE: This file is Auto Generated during build.
// ##############################################################
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
// Note: DON'T Export these const from the package as we are still targeting ES3 this will export a mutable variables that someone could change!!!
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
var _DYN_SESSION_MANAGER = "sessionManager"; // Count: 3
var _DYN_UPDATE = "update"; // Count: 4
var _DYN_IS_USER_COOKIE_SET = "isUserCookieSet"; // Count: 4
var _DYN_IS_NEW_USER = "isNewUser"; // Count: 4
var _DYN_GET_TRACE_CTX = "getTraceCtx"; // Count: 3
var _DYN_TELEMETRY_TRACE = "telemetryTrace"; // Count: 3
var _DYN_APPLY_SESSION_CONTEX0 = "applySessionContext"; // Count: 2
var _DYN_APPLY_APPLICATION_CO1 = "applyApplicationContext"; // Count: 2
var _DYN_APPLY_DEVICE_CONTEXT = "applyDeviceContext"; // Count: 2
var _DYN_APPLY_OPERATION_CONT2 = "applyOperationContext"; // Count: 2
var _DYN_APPLY_USER_CONTEXT = "applyUserContext"; // Count: 2
var _DYN_APPLY_OPERATING_SYST3 = "applyOperatingSystemContxt"; // Count: 2
var _DYN_APPLY_LOCATION_CONTE4 = "applyLocationContext"; // Count: 2
var _DYN_APPLY_INTERNAL_CONTE5 = "applyInternalContext"; // Count: 2
var _DYN_ACCOUNT_ID = "accountId"; // Count: 7
var _DYN_GET_SESSION_ID = "getSessionId"; // Count: 4
var _DYN_NAME_PREFIX = "namePrefix"; // Count: 3
var _DYN_SESSION_COOKIE_POSTF6 = "sessionCookiePostfix"; // Count: 2
var _DYN_USER_COOKIE_POSTFIX = "userCookiePostfix"; // Count: 2
var _DYN_ID_LENGTH = "idLength"; // Count: 4
var _DYN_GET_NEW_ID = "getNewId"; // Count: 3
var _DYN_LENGTH = "length"; // Count: 4
var _DYN_AUTOMATIC_SESSION = "automaticSession"; // Count: 5
var _DYN_AUTHENTICATED_ID = "authenticatedId"; // Count: 6
var _DYN_ACQUISITION_DATE = "acquisitionDate"; // Count: 5
var _DYN_RENEWAL_DATE = "renewalDate"; // Count: 4
var _DYN_JOIN = "join"; // Count: 5
var _DYN_COOKIE_SEPARATOR = "cookieSeparator"; // Count: 5
var _DYN_AUTH_USER_COOKIE_NAM7 = "authUserCookieName"; // Count: 3

/*
 * Application Insights JavaScript SDK - Properties Plugin, 3.0.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */

var SESSION_COOKIE_NAME = "ai_session";
var ACQUISITION_SPAN = 86400000; // 24 hours in ms
var RENEWAL_SPAN = 1800000; // 30 minutes in ms
var COOKIE_UPDATE_INTERVAL = 60000; // 1 minute in ms
var Session$2 = /** @class */ (function () {
    function Session() {
    }
    return Session;
}());
var _SessionManager = /** @class */ (function () {
    function _SessionManager(config, core, unloadHookContainer) {
        var self = this;
        var _storageNamePrefix;
        var _cookieUpdatedTimestamp;
        var _logger = safeGetLogger(core);
        var _cookieManager = safeGetCookieMgr(core);
        var _sessionExpirationMs;
        var _sessionRenewalMs;
        dynamicProto(_SessionManager, self, function (_self) {
            if (!config) {
                config = {};
            }
            var unloadHook = onConfigChange(config, function (details) {
                _sessionExpirationMs = config.sessionExpirationMs || ACQUISITION_SPAN;
                _sessionRenewalMs = config.sessionRenewalMs || RENEWAL_SPAN;
                // sessionCookiePostfix takes the preference if it is configured, otherwise takes namePrefix if configured.
                var sessionCookiePostfix = config.sessionCookiePostfix || config[_DYN_NAME_PREFIX /* @min:%2enamePrefix */] || "";
                _storageNamePrefix = SESSION_COOKIE_NAME + sessionCookiePostfix;
            });
            unloadHookContainer && unloadHookContainer.add(unloadHook);
            _self[_DYN_AUTOMATIC_SESSION /* @min:%2eautomaticSession */] = new Session$2();
            _self[_DYN_UPDATE /* @min:%2eupdate */] = function () {
                // Always using Date getTime() as there is a bug in older IE instances that causes the performance timings to have the hi-bit set eg 0x800000000 causing
                // the number to be incorrect.
                var nowMs = utcNow();
                var isExpired = false;
                var session = _self[_DYN_AUTOMATIC_SESSION /* @min:%2eautomaticSession */];
                if (!session.id) {
                    isExpired = !_initializeAutomaticSession(session);
                }
                if (!isExpired && _sessionExpirationMs > 0) {
                    var timeSinceAcqMs = nowMs - session[_DYN_ACQUISITION_DATE /* @min:%2eacquisitionDate */];
                    var timeSinceRenewalMs = nowMs - session[_DYN_RENEWAL_DATE /* @min:%2erenewalDate */];
                    isExpired = timeSinceAcqMs < 0 || timeSinceRenewalMs < 0; // expired if the acquisition or last renewal are in the future
                    isExpired = isExpired || timeSinceAcqMs > _sessionExpirationMs; // expired if the time since acquisition is more than session Expiration
                    isExpired = isExpired || timeSinceRenewalMs > _sessionRenewalMs; // expired if the time since last renewal is more than renewal period
                }
                // renew if acquisitionSpan or renewalSpan has elapsed
                if (isExpired) {
                    // update automaticSession so session state has correct id
                    _renew(nowMs);
                }
                else {
                    // do not update the cookie more often than cookieUpdateInterval
                    if (!_cookieUpdatedTimestamp || nowMs - _cookieUpdatedTimestamp > COOKIE_UPDATE_INTERVAL) {
                        _setCookie(session, nowMs);
                    }
                }
            };
            /**
             *  Record the current state of the automatic session and store it in our cookie string format
             *  into the browser's local storage. This is used to restore the session data when the cookie
             *  expires.
             */
            _self.backup = function () {
                var session = _self[_DYN_AUTOMATIC_SESSION /* @min:%2eautomaticSession */];
                _setStorage(session.id, session[_DYN_ACQUISITION_DATE /* @min:%2eacquisitionDate */], session[_DYN_RENEWAL_DATE /* @min:%2erenewalDate */]);
            };
            /**
             * Use config.namePrefix + ai_session cookie data or local storage data (when the cookie is unavailable) to
             * initialize the automatic session.
             * @returns true if values set otherwise false
             */
            function _initializeAutomaticSession(session, now) {
                var isValid = false;
                var cookieValue = _cookieManager.get(_storageNamePrefix);
                if (cookieValue && isFunction(cookieValue.split)) {
                    isValid = _initializeAutomaticSessionWithData(session, cookieValue);
                }
                else {
                    // There's no cookie, but we might have session data in local storage
                    // This can happen if the session expired or the user actively deleted the cookie
                    // We only want to recover data if the cookie is missing from expiry. We should respect the user's wishes if the cookie was deleted actively.
                    // The User class handles this for us and deletes our local storage object if the persistent user cookie was removed.
                    var storageValue = utlGetLocalStorage(_logger, _storageNamePrefix);
                    if (storageValue) {
                        isValid = _initializeAutomaticSessionWithData(session, storageValue);
                    }
                }
                return isValid || !!session.id;
            }
            /**
             * Extract id, acquisitionDate, and renewalDate from an ai_session payload string and
             * use this data to initialize automaticSession.
             *
             * @param sessionData - The string stored in an ai_session cookie or local storage backup
             * @returns true if values set otherwise false
             */
            function _initializeAutomaticSessionWithData(session, sessionData) {
                var isValid = false;
                var sessionReset = ", session will be reset";
                var tokens = sessionData.split("|");
                if (tokens[_DYN_LENGTH /* @min:%2elength */] >= 2) {
                    try {
                        var acqMs = +tokens[1] || 0;
                        var renewalMs = +tokens[2] || 0;
                        if (isNaN(acqMs) || acqMs <= 0) {
                            _throwInternal(_logger, 2 /* eLoggingSeverity.WARNING */, 27 /* _eInternalMessageId.SessionRenewalDateIsZero */, "AI session acquisition date is 0" + sessionReset);
                        }
                        else if (isNaN(renewalMs) || renewalMs <= 0) {
                            _throwInternal(_logger, 2 /* eLoggingSeverity.WARNING */, 27 /* _eInternalMessageId.SessionRenewalDateIsZero */, "AI session renewal date is 0" + sessionReset);
                        }
                        else if (tokens[0]) {
                            // Everything looks valid so set the values
                            session.id = tokens[0];
                            session[_DYN_ACQUISITION_DATE /* @min:%2eacquisitionDate */] = acqMs;
                            session[_DYN_RENEWAL_DATE /* @min:%2erenewalDate */] = renewalMs;
                            isValid = true;
                        }
                    }
                    catch (e) {
                        _throwInternal(_logger, 1 /* eLoggingSeverity.CRITICAL */, 9 /* _eInternalMessageId.ErrorParsingAISessionCookie */, "Error parsing ai_session value [" + (sessionData || "") + "]" + sessionReset + " - " + getExceptionName(e), { exception: dumpObj(e) });
                    }
                }
                return isValid;
            }
            function _renew(nowMs) {
                var getNewId = config[_DYN_GET_NEW_ID /* @min:%2egetNewId */] || newId;
                _self.automaticSession.id = getNewId(config[_DYN_ID_LENGTH /* @min:%2eidLength */] || 22);
                _self[_DYN_AUTOMATIC_SESSION /* @min:%2eautomaticSession */][_DYN_ACQUISITION_DATE /* @min:%2eacquisitionDate */] = nowMs;
                _setCookie(_self[_DYN_AUTOMATIC_SESSION /* @min:%2eautomaticSession */], nowMs);
                // If this browser does not support local storage, fire an internal log to keep track of it at this point
                if (!utlCanUseLocalStorage()) {
                    _throwInternal(_logger, 2 /* eLoggingSeverity.WARNING */, 0 /* _eInternalMessageId.BrowserDoesNotSupportLocalStorage */, "Browser does not support local storage. Session durations will be inaccurate.");
                }
            }
            function _setCookie(session, nowMs) {
                var acq = session[_DYN_ACQUISITION_DATE /* @min:%2eacquisitionDate */];
                session[_DYN_RENEWAL_DATE /* @min:%2erenewalDate */] = nowMs;
                var renewalPeriodMs = _sessionRenewalMs;
                // Set cookie to expire after the session expiry time passes or the session renewal deadline, whichever is sooner
                // Expiring the cookie will cause the session to expire even if the user isn't on the page
                var acqTimeLeftMs = (acq + _sessionExpirationMs) - nowMs;
                var cookie = [session.id, acq, nowMs];
                var maxAgeSec = 0;
                if (acqTimeLeftMs < renewalPeriodMs) {
                    maxAgeSec = acqTimeLeftMs / 1000;
                }
                else {
                    maxAgeSec = renewalPeriodMs / 1000;
                }
                var cookieDomain = config.cookieDomain || null;
                // if sessionExpirationMs is set to 0, it means the expiry is set to 0 for this session cookie
                // A cookie with 0 expiry in the session cookie will never expire for that browser session.  If the browser is closed the cookie expires.
                // Depending on the browser, another instance does not inherit this cookie, however, another tab will
                _cookieManager.set(_storageNamePrefix, cookie[_DYN_JOIN /* @min:%2ejoin */]("|"), _sessionExpirationMs > 0 ? maxAgeSec : null, cookieDomain);
                _cookieUpdatedTimestamp = nowMs;
            }
            function _setStorage(guid, acq, renewal) {
                // Keep data in local storage to retain the last session id, allowing us to cleanly end the session when it expires
                // Browsers that don't support local storage won't be able to end sessions cleanly from the client
                // The server will notice this and end the sessions itself, with loss of accurate session duration
                utlSetLocalStorage(_logger, _storageNamePrefix, [guid, acq, renewal][_DYN_JOIN /* @min:%2ejoin */]("|"));
            }
        });
    }
// Removed Stub for _SessionManager.prototype.update.
// Removed Stub for _SessionManager.prototype.backup.
    // This is a workaround for an IE bug when using dynamicProto() with classes that don't have any
    // non-dynamic functions or static properties/functions when using uglify-js to minify the resulting code.
    _SessionManager.__ieDyn=1;

    return _SessionManager;
}());

/*
 * Application Insights JavaScript SDK - Properties Plugin, 3.0.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */

var TelemetryTrace = /** @class */ (function () {
    function TelemetryTrace(id, parentId, name, logger) {
        var _self = this;
        _self.traceID = id || generateW3CId();
        _self.parentID = parentId;
        var location = getLocation();
        if (!name && location && location.pathname) {
            name = location.pathname;
        }
        _self.name = dataSanitizeString(logger, name);
    }
    return TelemetryTrace;
}());

/*
 * Application Insights JavaScript SDK - Properties Plugin, 3.0.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */

function _validateUserInput(id) {
    // Validate:
    // 1. Id is a non-empty string.
    // 2. It does not contain special characters for cookies.
    if (typeof id !== "string" ||
        !id ||
        id.match(/,|;|=| |\|/)) {
        return false;
    }
    return true;
}
var User = /** @class */ (function () {
    function User(config, core, unloadHookContainer) {
        /**
         * A flag indicating whether this represents a new user
         */
        this.isNewUser = false;
        /**
         * A flag indicating whether the user cookie has been set
         */
        this.isUserCookieSet = false;
        var _logger = safeGetLogger(core);
        var _cookieManager = safeGetCookieMgr(core);
        var _storageNamePrefix;
        dynamicProto(User, this, function (_self) {
            // Define _self.config
            objDefine(_self, "config", {
                g: function () { return config; }
            });
            var unloadHook = onConfigChange(config, function () {
                var userCookiePostfix = config[_DYN_USER_COOKIE_POSTFIX /* @min:%2euserCookiePostfix */] || "";
                _storageNamePrefix = User.userCookieName + userCookiePostfix;
                // get userId or create new one if none exists
                var cookie = _cookieManager.get(_storageNamePrefix);
                if (cookie) {
                    _self[_DYN_IS_NEW_USER /* @min:%2eisNewUser */] = false;
                    var params = cookie.split(User[_DYN_COOKIE_SEPARATOR /* @min:%2ecookieSeparator */]);
                    if (params[_DYN_LENGTH /* @min:%2elength */] > 0) {
                        _self.id = params[0];
                        // we already have a cookie
                        _self[_DYN_IS_USER_COOKIE_SET /* @min:%2eisUserCookieSet */] = !!_self.id;
                    }
                }
                if (!_self.id) {
                    _self.id = _generateNewId();
                    var newCookie = _generateNewCookie(_self.id);
                    _setUserCookie(newCookie[_DYN_JOIN /* @min:%2ejoin */](User[_DYN_COOKIE_SEPARATOR /* @min:%2ecookieSeparator */]));
                    // If we have an config.namePrefix() + ai_session in local storage this means the user actively removed our cookies.
                    // We should respect their wishes and clear ourselves from local storage
                    var name_1 = (config[_DYN_NAME_PREFIX /* @min:%2enamePrefix */] || "") + "ai_session";
                    utlRemoveStorage(_logger, name_1);
                }
                // We still take the account id from the ctor param for backward compatibility.
                // But if the the customer set the accountId through the newer setAuthenticatedUserContext API, we will override it.
                _self[_DYN_ACCOUNT_ID /* @min:%2eaccountId */] = config[_DYN_ACCOUNT_ID /* @min:%2eaccountId */] || undefined;
                // Get the auth user id and account id from the cookie if exists
                // Cookie is in the pattern: <authenticatedId>|<accountId>
                var authCookie = _cookieManager.get(User[_DYN_AUTH_USER_COOKIE_NAM7 /* @min:%2eauthUserCookieName */]);
                if (authCookie) {
                    authCookie = decodeURI(authCookie);
                    var authCookieString = authCookie.split(User[_DYN_COOKIE_SEPARATOR /* @min:%2ecookieSeparator */]);
                    if (authCookieString[0]) {
                        _self[_DYN_AUTHENTICATED_ID /* @min:%2eauthenticatedId */] = authCookieString[0];
                    }
                    if (authCookieString[_DYN_LENGTH /* @min:%2elength */] > 1 && authCookieString[1]) {
                        _self[_DYN_ACCOUNT_ID /* @min:%2eaccountId */] = authCookieString[1];
                    }
                }
            });
            unloadHookContainer && unloadHookContainer.add(unloadHook);
            function _generateNewId() {
                var theConfig = (config || {});
                var getNewId = theConfig[_DYN_GET_NEW_ID /* @min:%2egetNewId */] || newId;
                var id = getNewId(theConfig[_DYN_ID_LENGTH /* @min:%2eidLength */] ? config[_DYN_ID_LENGTH /* @min:%2eidLength */] : 22);
                return id;
            }
            function _generateNewCookie(userId) {
                var acqStr = toISOString(new Date());
                _self.accountAcquisitionDate = acqStr;
                _self[_DYN_IS_NEW_USER /* @min:%2eisNewUser */] = true;
                var newCookie = [userId, acqStr];
                return newCookie;
            }
            function _setUserCookie(cookie) {
                // without expiration, cookies expire at the end of the session
                // set it to 365 days from now
                // 365 * 24 * 60 * 60 = 31536000
                var oneYear = 31536000;
                _self[_DYN_IS_USER_COOKIE_SET /* @min:%2eisUserCookieSet */] = _cookieManager.set(_storageNamePrefix, cookie, oneYear);
            }
            _self.setAuthenticatedUserContext = function (authenticatedUserId, accountId, storeInCookie) {
                if (storeInCookie === void 0) { storeInCookie = false; }
                // Validate inputs to ensure no cookie control characters.
                var isInvalidInput = !_validateUserInput(authenticatedUserId) || (accountId && !_validateUserInput(accountId));
                if (isInvalidInput) {
                    _throwInternal(_logger, 2 /* eLoggingSeverity.WARNING */, 60 /* _eInternalMessageId.SetAuthContextFailedAccountName */, "Setting auth user context failed. " +
                        "User auth/account id should be of type string, and not contain commas, semi-colons, equal signs, spaces, or vertical-bars.", true);
                    return;
                }
                // Create cookie string.
                _self[_DYN_AUTHENTICATED_ID /* @min:%2eauthenticatedId */] = authenticatedUserId;
                var authCookie = _self[_DYN_AUTHENTICATED_ID /* @min:%2eauthenticatedId */];
                if (accountId) {
                    _self[_DYN_ACCOUNT_ID /* @min:%2eaccountId */] = accountId;
                    authCookie = [_self[_DYN_AUTHENTICATED_ID /* @min:%2eauthenticatedId */], _self.accountId][_DYN_JOIN /* @min:%2ejoin */](User[_DYN_COOKIE_SEPARATOR /* @min:%2ecookieSeparator */]);
                }
                if (storeInCookie) {
                    // Set the cookie. No expiration date because this is a session cookie (expires when browser closed).
                    // Encoding the cookie to handle unexpected unicode characters.
                    _cookieManager.set(User[_DYN_AUTH_USER_COOKIE_NAM7 /* @min:%2eauthUserCookieName */], encodeURI(authCookie));
                }
            };
            /**
             * Clears the authenticated user id and the account id from the user context.
             * @returns {}
             */
            _self.clearAuthenticatedUserContext = function () {
                _self[_DYN_AUTHENTICATED_ID /* @min:%2eauthenticatedId */] = null;
                _self[_DYN_ACCOUNT_ID /* @min:%2eaccountId */] = null;
                _cookieManager.del(User[_DYN_AUTH_USER_COOKIE_NAM7 /* @min:%2eauthUserCookieName */]);
            };
            _self[_DYN_UPDATE /* @min:%2eupdate */] = function (userId) {
                // Optimizations to avoid setting and processing the cookie when not needed
                if (_self.id !== userId || !_self[_DYN_IS_USER_COOKIE_SET /* @min:%2eisUserCookieSet */]) {
                    var user_id = userId ? userId : _generateNewId();
                    var user_cookie = _generateNewCookie(user_id);
                    _setUserCookie(user_cookie[_DYN_JOIN /* @min:%2ejoin */](User[_DYN_COOKIE_SEPARATOR /* @min:%2ecookieSeparator */]));
                }
            };
        });
    }
// Removed Stub for User.prototype.setAuthenticatedUserContext.
// Removed Stub for User.prototype.clearAuthenticatedUserContext.
// Removed Stub for User.prototype.update.
    User.cookieSeparator = "|";
    User.userCookieName = "ai_user";
    User.authUserCookieName = "ai_authUser";
    return User;
}());

/*
 * Application Insights JavaScript SDK - Properties Plugin, 3.0.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */
/**
* TelemetryContext.ts
* @copyright Microsoft 2018
*/
var strExt = "ext";
var strTags = "tags";
function _removeEmpty(target, name) {
    if (target && target[name] && objKeys(target[name])[_DYN_LENGTH /* @min:%2elength */] === 0) {
        delete target[name];
    }
}
function _nullResult() {
    return null;
}
var TelemetryContext = /** @class */ (function () {
    function TelemetryContext(core, defaultConfig, previousTraceCtx, unloadHookContainer) {
        var _this = this;
        var logger = core.logger;
        dynamicProto(TelemetryContext, this, function (_self) {
            _self.appId = _nullResult;
            _self[_DYN_GET_SESSION_ID /* @min:%2egetSessionId */] = _nullResult;
            _self.application = new Application();
            _self.internal = new Internal(defaultConfig, unloadHookContainer);
            if (hasWindow()) {
                _self[_DYN_SESSION_MANAGER /* @min:%2esessionManager */] = new _SessionManager(defaultConfig, core, unloadHookContainer);
                _self.device = new Device();
                _self.location = new Location();
                _self.user = new User(defaultConfig, core, unloadHookContainer);
                var traceId = void 0;
                var parentId = void 0;
                var name_1;
                if (previousTraceCtx) {
                    traceId = previousTraceCtx.getTraceId();
                    parentId = previousTraceCtx.getSpanId();
                    name_1 = previousTraceCtx.getName();
                }
                _self[_DYN_TELEMETRY_TRACE /* @min:%2etelemetryTrace */] = new TelemetryTrace(traceId, parentId, name_1, logger);
                _self.session = new Session$2();
            }
            _self[_DYN_GET_SESSION_ID /* @min:%2egetSessionId */] = function () {
                var session = _self.session;
                var sesId = null;
                // If customer set session info, apply their context; otherwise apply context automatically generated
                if (session && isString(session.id)) {
                    sesId = session.id;
                }
                else {
                    // Gets the automatic session if it exists or an empty object
                    var autoSession = (_self[_DYN_SESSION_MANAGER /* @min:%2esessionManager */] || {})[_DYN_AUTOMATIC_SESSION /* @min:%2eautomaticSession */];
                    sesId = autoSession && isString(autoSession.id) ? autoSession.id : null;
                }
                return sesId;
            };
            _self[_DYN_APPLY_SESSION_CONTEX0 /* @min:%2eapplySessionContext */] = function (evt, itemCtx) {
                setValue(getSetValue(evt.ext, Extensions.AppExt), "sesId", _self[_DYN_GET_SESSION_ID /* @min:%2egetSessionId */](), isString);
            };
            _self[_DYN_APPLY_OPERATING_SYST3 /* @min:%2eapplyOperatingSystemContxt */] = function (evt, itemCtx) {
                setValue(evt.ext, Extensions.OSExt, _self.os);
            };
            _self[_DYN_APPLY_APPLICATION_CO1 /* @min:%2eapplyApplicationContext */] = function (evt, itemCtx) {
                var application = _self.application;
                if (application) {
                    // evt.ext.app
                    var tags = getSetValue(evt, strTags);
                    setValue(tags, CtxTagKeys.applicationVersion, application.ver, isString);
                    setValue(tags, CtxTagKeys.applicationBuild, application.build, isString);
                }
            };
            _self[_DYN_APPLY_DEVICE_CONTEXT /* @min:%2eapplyDeviceContext */] = function (evt, itemCtx) {
                var device = _self.device;
                if (device) {
                    // evt.ext.device
                    var extDevice = getSetValue(getSetValue(evt, strExt), Extensions.DeviceExt);
                    setValue(extDevice, "localId", device.id, isString);
                    setValue(extDevice, "ip", device.ip, isString);
                    setValue(extDevice, "model", device.model, isString);
                    setValue(extDevice, "deviceClass", device.deviceClass, isString);
                }
            };
            _self[_DYN_APPLY_INTERNAL_CONTE5 /* @min:%2eapplyInternalContext */] = function (evt, itemCtx) {
                var internal = _self.internal;
                if (internal) {
                    var tags = getSetValue(evt, strTags);
                    setValue(tags, CtxTagKeys.internalAgentVersion, internal.agentVersion, isString); // not mapped in CS 4.0
                    setValue(tags, CtxTagKeys.internalSdkVersion, dataSanitizeString(logger, internal.sdkVersion, 64), isString);
                    if (evt.baseType === _InternalLogMessage.dataType || evt.baseType === PageView.dataType) {
                        setValue(tags, CtxTagKeys.internalSnippet, internal.snippetVer, isString);
                        setValue(tags, CtxTagKeys.internalSdkSrc, internal.sdkSrc, isString);
                    }
                }
            };
            _self[_DYN_APPLY_LOCATION_CONTE4 /* @min:%2eapplyLocationContext */] = function (evt, itemCtx) {
                var location = _this.location;
                if (location) {
                    setValue(getSetValue(evt, strTags, []), CtxTagKeys.locationIp, location.ip, isString);
                }
            };
            _self[_DYN_APPLY_OPERATION_CONT2 /* @min:%2eapplyOperationContext */] = function (evt, itemCtx) {
                var telemetryTrace = _self[_DYN_TELEMETRY_TRACE /* @min:%2etelemetryTrace */];
                if (telemetryTrace) {
                    var extTrace = getSetValue(getSetValue(evt, strExt), Extensions.TraceExt, { traceID: undefined, parentID: undefined });
                    setValue(extTrace, "traceID", telemetryTrace.traceID, isString, isNullOrUndefined);
                    setValue(extTrace, "name", telemetryTrace.name, isString, isNullOrUndefined);
                    setValue(extTrace, "parentID", telemetryTrace.parentID, isString, isNullOrUndefined);
                }
            };
            _self.applyWebContext = function (evt, itemCtx) {
                var web = _this.web;
                if (web) {
                    setValue(getSetValue(evt, strExt), Extensions.WebExt, web);
                }
            };
            _self[_DYN_APPLY_USER_CONTEXT /* @min:%2eapplyUserContext */] = function (evt, itemCtx) {
                var user = _self.user;
                if (user) {
                    var tags = getSetValue(evt, strTags, []);
                    // stays in tags
                    setValue(tags, CtxTagKeys.userAccountId, user[_DYN_ACCOUNT_ID /* @min:%2eaccountId */], isString);
                    // CS 4.0
                    var extUser = getSetValue(getSetValue(evt, strExt), Extensions.UserExt);
                    setValue(extUser, "id", user.id, isString);
                    setValue(extUser, "authId", user[_DYN_AUTHENTICATED_ID /* @min:%2eauthenticatedId */], isString);
                }
            };
            _self.cleanUp = function (evt, itemCtx) {
                var ext = evt.ext;
                if (ext) {
                    _removeEmpty(ext, Extensions.DeviceExt);
                    _removeEmpty(ext, Extensions.UserExt);
                    _removeEmpty(ext, Extensions.WebExt);
                    _removeEmpty(ext, Extensions.OSExt);
                    _removeEmpty(ext, Extensions.AppExt);
                    _removeEmpty(ext, Extensions.TraceExt);
                }
            };
        });
    }
// Removed Stub for TelemetryContext.prototype.applySessionContext.
// Removed Stub for TelemetryContext.prototype.applyOperatingSystemContxt.
// Removed Stub for TelemetryContext.prototype.applyApplicationContext.
// Removed Stub for TelemetryContext.prototype.applyDeviceContext.
// Removed Stub for TelemetryContext.prototype.applyInternalContext.
// Removed Stub for TelemetryContext.prototype.applyLocationContext.
// Removed Stub for TelemetryContext.prototype.applyOperationContext.
// Removed Stub for TelemetryContext.prototype.applyWebContext.
// Removed Stub for TelemetryContext.prototype.applyUserContext.
// Removed Stub for TelemetryContext.prototype.cleanUp.
    // This is a workaround for an IE bug when using dynamicProto() with classes that don't have any
    // non-dynamic functions or static properties/functions when using uglify-js to minify the resulting code.
    TelemetryContext.__ieDyn=1;

    return TelemetryContext;
}());

/*
 * Application Insights JavaScript SDK - Properties Plugin, 3.0.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */
/**
* PropertiesPlugin.ts
* @copyright Microsoft 2018
*/
var _a$2;
var undefString;
var nullValue = null;
var _defaultConfig = objDeepFreeze((_a$2 = {},
    _a$2[_DYN_ACCOUNT_ID /* @min:accountId */] = nullValue,
    _a$2.sessionRenewalMs = 30 * 60 * 1000,
    _a$2.samplingPercentage = 100,
    _a$2.sessionExpirationMs = 24 * 60 * 60 * 1000,
    _a$2.cookieDomain = nullValue,
    _a$2.sdkExtension = nullValue,
    _a$2.isBrowserLinkTrackingEnabled = false,
    _a$2.appId = nullValue,
    _a$2[_DYN_GET_SESSION_ID /* @min:getSessionId */] = nullValue,
    _a$2[_DYN_NAME_PREFIX /* @min:namePrefix */] = undefString,
    _a$2[_DYN_SESSION_COOKIE_POSTF6 /* @min:sessionCookiePostfix */] = undefString,
    _a$2[_DYN_USER_COOKIE_POSTFIX /* @min:userCookiePostfix */] = undefString,
    _a$2[_DYN_ID_LENGTH /* @min:idLength */] = 22,
    _a$2[_DYN_GET_NEW_ID /* @min:getNewId */] = nullValue,
    _a$2));
var PropertiesPlugin = /** @class */ (function (_super) {
    __extendsFn(PropertiesPlugin, _super);
    function PropertiesPlugin() {
        var _this = _super.call(this) || this;
        _this.priority = 110;
        _this.identifier = PropertiesPluginIdentifier;
        var _extensionConfig;
        var _distributedTraceCtx;
        var _previousTraceCtx;
        var _context;
        dynamicProto(PropertiesPlugin, _this, function (_self, _base) {
            _initDefaults();
            objDefine(_self, "context", {
                g: function () {
                    return _context;
                }
            });
            _self.initialize = function (config, core, extensions, pluginChain) {
                _base.initialize(config, core, extensions, pluginChain);
                _populateDefaults(config);
            };
            /**
             * Add Part A fields to the event
             * @param event - The event that needs to be processed
             */
            _self.processTelemetry = function (event, itemCtx) {
                if (!isNullOrUndefined(event)) {
                    itemCtx = _self._getTelCtx(itemCtx);
                    // If the envelope is PageView, reset the internal message count so that we can send internal telemetry for the new page.
                    if (event.name === PageView.envelopeType) {
                        itemCtx.diagLog().resetInternalMessageCount();
                    }
                    var theContext = (_context || {});
                    if (theContext.session) {
                        // If customer did not provide custom session id update the session manager
                        if (typeof _context.session.id !== "string" && theContext[_DYN_SESSION_MANAGER /* @min:%2esessionManager */]) {
                            theContext[_DYN_SESSION_MANAGER /* @min:%2esessionManager */][_DYN_UPDATE /* @min:%2eupdate */]();
                        }
                    }
                    var userCtx = theContext.user;
                    if (userCtx && !userCtx[_DYN_IS_USER_COOKIE_SET /* @min:%2eisUserCookieSet */]) {
                        userCtx[_DYN_UPDATE /* @min:%2eupdate */](theContext.user.id);
                    }
                    _processTelemetryInternal(event, itemCtx);
                    if (userCtx && userCtx[_DYN_IS_NEW_USER /* @min:%2eisNewUser */]) {
                        userCtx[_DYN_IS_NEW_USER /* @min:%2eisNewUser */] = false;
                        var message = new _InternalLogMessage(72 /* _eInternalMessageId.SendBrowserInfoOnUserInit */, ((getNavigator() || {}).userAgent || ""));
                        _logInternalMessage(itemCtx.diagLog(), 1 /* eLoggingSeverity.CRITICAL */, message);
                    }
                    _self.processNext(event, itemCtx);
                }
            };
            _self._doTeardown = function (unloadCtx, unloadState) {
                var core = (unloadCtx || {}).core();
                if (core && core[_DYN_GET_TRACE_CTX /* @min:%2egetTraceCtx */]) {
                    var traceCtx = core[_DYN_GET_TRACE_CTX /* @min:%2egetTraceCtx */](false);
                    if (traceCtx === _distributedTraceCtx) {
                        core.setTraceCtx(_previousTraceCtx);
                    }
                }
                _initDefaults();
            };
            function _initDefaults() {
                _extensionConfig = null;
                _distributedTraceCtx = null;
                _previousTraceCtx = null;
                _context = null;
            }
            function _populateDefaults(config) {
                var identifier = _self.identifier;
                var core = _self.core;
                // This function will be re-called whenever any referenced configuration is changed
                _self._addHook(onConfigChange(config, function () {
                    var ctx = createProcessTelemetryContext(null, config, core);
                    if (config.storagePrefix) {
                        utlSetStoragePrefix(config.storagePrefix);
                    }
                    _extensionConfig = ctx.getExtCfg(identifier, _defaultConfig);
                    // Test hook to allow accessing the internal values -- explicitly not defined as an available property on the class
                    _self["_extConfig"] = _extensionConfig;
                }));
                // This is outside of the onConfigChange as we don't want to update (replace) these values whenever a referenced config item changes
                _previousTraceCtx = core[_DYN_GET_TRACE_CTX /* @min:%2egetTraceCtx */](false);
                _context = new TelemetryContext(core, _extensionConfig, _previousTraceCtx, _self._unloadHooks);
                _distributedTraceCtx = createDistributedTraceContextFromTrace(_self.context[_DYN_TELEMETRY_TRACE /* @min:%2etelemetryTrace */], _previousTraceCtx);
                core.setTraceCtx(_distributedTraceCtx);
                _self.context.appId = function () {
                    var breezeChannel = core.getPlugin(BreezeChannelIdentifier);
                    return breezeChannel ? breezeChannel.plugin["_appId"] : null;
                };
            }
            function _processTelemetryInternal(evt, itemCtx) {
                // Set Part A fields
                getSetValue(evt, "tags", []);
                getSetValue(evt, "ext", {});
                var ctx = _self.context;
                ctx[_DYN_APPLY_SESSION_CONTEX0 /* @min:%2eapplySessionContext */](evt, itemCtx);
                ctx[_DYN_APPLY_APPLICATION_CO1 /* @min:%2eapplyApplicationContext */](evt, itemCtx);
                ctx[_DYN_APPLY_DEVICE_CONTEXT /* @min:%2eapplyDeviceContext */](evt, itemCtx);
                ctx[_DYN_APPLY_OPERATION_CONT2 /* @min:%2eapplyOperationContext */](evt, itemCtx);
                ctx[_DYN_APPLY_USER_CONTEXT /* @min:%2eapplyUserContext */](evt, itemCtx);
                ctx[_DYN_APPLY_OPERATING_SYST3 /* @min:%2eapplyOperatingSystemContxt */](evt, itemCtx);
                ctx.applyWebContext(evt, itemCtx);
                ctx[_DYN_APPLY_LOCATION_CONTE4 /* @min:%2eapplyLocationContext */](evt, itemCtx); // legacy tags
                ctx[_DYN_APPLY_INTERNAL_CONTE5 /* @min:%2eapplyInternalContext */](evt, itemCtx); // legacy tags
                ctx.cleanUp(evt, itemCtx);
            }
        });
        return _this;
    }
// Removed Stub for PropertiesPlugin.prototype.initialize.
// Removed Stub for PropertiesPlugin.prototype.processTelemetry.
    // This is a workaround for an IE bug when using dynamicProto() with classes that don't have any
    // non-dynamic functions or static properties/functions when using uglify-js to minify the resulting code.
    PropertiesPlugin.__ieDyn=1;

    return PropertiesPlugin;
}(BaseTelemetryPlugin));
var PropertiesPlugin$1 = PropertiesPlugin;

/*
 * Application Insights JavaScript SDK - Web, 3.0.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


// ###################################################################################################################################################
// Note: DON'T Export these const from the package as we are still targeting IE/ES5 this will export a mutable variables that someone could change ###
// ###################################################################################################################################################
// Generally you should only put values that are used more than 2 times and then only if not already exposed as a constant (such as SdkCoreNames)
// as when using "short" named values from here they will be will be minified smaller than the SdkCoreNames[eSdkCoreNames.xxxx] value.
var _AUTHENTICATED_USER_CONTEXT = "AuthenticatedUserContext";
var _TRACK = "track";
var STR_SNIPPET = "snippet";
var STR_GET_COOKIE_MGR = "getCookieMgr";
var STR_START_TRACK_PAGE = "startTrackPage";
var STR_STOP_TRACK_PAGE = "stopTrackPage";
var STR_FLUSH = "flush";
var STR_START_TRACK_EVENT = "startTrackEvent";
var STR_STOP_TRACK_EVENT = "stopTrackEvent";
var STR_ADD_TELEMETRY_INITIALIZER = "addTelemetryInitializer";
var STR_POLL_INTERNAL_LOGS = "pollInternalLogs";
var STR_GET_PLUGIN = "getPlugin";
var STR_EVT_NAMESPACE = "evtNamespace";
var STR_TRACK_EVENT = _TRACK + "Event";
var STR_TRACK_TRACE = _TRACK + "Trace";
var STR_TRACK_METRIC = _TRACK + "Metric";
var STR_TRACK_PAGE_VIEW = _TRACK + "PageView";
var STR_TRACK_EXCEPTION = _TRACK + "Exception";
var STR_TRACK_DEPENDENCY_DATA = _TRACK + "DependencyData";
var STR_SET_AUTHENTICATED_USER_CONTEXT = "set" + _AUTHENTICATED_USER_CONTEXT;
var STR_CLEAR_AUTHENTICATED_USER_CONTEXT = "clear" + _AUTHENTICATED_USER_CONTEXT;

/*
 * Application Insights JavaScript SDK - Web, 3.0.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


// @skip-file-minify
// ##############################################################
// AUTO GENERATED FILE: This file is Auto Generated during build.
// ##############################################################
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
// Note: DON'T Export these const from the package as we are still targeting ES3 this will export a mutable variables that someone could change!!!
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
var _DYN_VERSION = "version"; // Count: 6
var _DYN_QUEUE = "queue"; // Count: 6
var _DYN_CONNECTION_STRING = "connectionString"; // Count: 4
var _DYN_ENDPOINT_URL = "endpointUrl"; // Count: 3
var _DYN_INSTRUMENTATION_KEY = "instrumentationKey"; // Count: 3
var _DYN_ONUNLOAD_FLUSH = "onunloadFlush"; // Count: 6
var _DYN_CONTEXT = "context"; // Count: 5
var _DYN_ADD_HOUSEKEEPING_BEF0 = "addHousekeepingBeforeUnload"; // Count: 2
var _DYN_SEND_MESSAGE = "sendMessage"; // Count: 3
var _DYN_IS_THROTTLED = "isThrottled"; // Count: 3
var _DYN_UPDATE_SNIPPET_DEFIN1 = "updateSnippetDefinitions"; // Count: 2

/*
 * Application Insights JavaScript SDK - Web, 3.0.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */

var _a$1, _b, _c;
var _internalSdkSrc;
// This is an exclude list of properties that should not be updated during initialization
// They include a combination of private and internal property names
var _ignoreUpdateSnippetProperties = [
    STR_SNIPPET, "dependencies", "properties", "_snippetVersion", "appInsightsNew", "getSKUDefaults"
];
var IKEY_USAGE = "iKeyUsage";
var CDN_USAGE = "CdnUsage";
var SDK_LOADER_VER = "SdkLoaderVer";
var UNDEFINED_VALUE = undefined;
var default_throttle_config = {
    disabled: true,
    limit: {
        samplingRate: 100,
        maxSendNumber: 1
    },
    interval: {
        monthInterval: 3,
        daysOfMonth: [28]
    }
};
// We need to include all properties that we only reference that we want to be dynamically updatable here
// So they are converted even when not specified in the passed configuration
var defaultConfigValues = (_a$1 = {},
    _a$1[_DYN_CONNECTION_STRING /* @min:connectionString */] = UNDEFINED_VALUE,
    _a$1[_DYN_ENDPOINT_URL /* @min:endpointUrl */] = UNDEFINED_VALUE,
    _a$1[_DYN_INSTRUMENTATION_KEY /* @min:instrumentationKey */] = UNDEFINED_VALUE,
    _a$1.diagnosticLogInterval = cfgDfValidate(_chkDiagLevel, 10000),
    _a$1.featureOptIn = (_b = {},
        _b[IKEY_USAGE] = { mode: 2 /* FeatureOptInMode.disable */ },
        _b[CDN_USAGE] = { mode: 2 /* FeatureOptInMode.disable */ },
        _b[SDK_LOADER_VER] = { mode: 2 /* FeatureOptInMode.disable */ },
        _b),
    _a$1.throttleMgrCfg = (_c = {},
        _c[109 /* _eInternalMessageId.DefaultThrottleMsgKey */] = default_throttle_config,
        _c[106 /* _eInternalMessageId.InstrumentationKeyDeprecation */] = default_throttle_config,
        _c[111 /* _eInternalMessageId.SdkLdrUpdate */] = default_throttle_config,
        _c[110 /* _eInternalMessageId.CdnDeprecation */] = default_throttle_config,
        _c),
    _a$1);
function _chkDiagLevel(value) {
    // Make sure we have a value > 0
    return value && value > 0;
}
/**
 * Application Insights API
 * @group Entrypoint
 * @group Classes
 * @class Initialization
 * @implements {IApplicationInsights}
 */
var AppInsightsSku = /** @class */ (function () {
    function AppInsightsSku(snippet) {
        var _this = this;
        // NOTE!: DON'T set default values here, instead set them in the _initDefaults() function as it is also called during teardown()
        var dependencies;
        var properties;
        var _sender;
        var _snippetVersion;
        var _evtNamespace;
        var _houseKeepingNamespace;
        var _core;
        var _config;
        var _analyticsPlugin;
        var _cfgSyncPlugin;
        var _throttleMgr;
        var _iKeySentMessage;
        var _cdnSentMessage;
        var _sdkVerSentMessage;
        dynamicProto(AppInsightsSku, this, function (_self) {
            _initDefaults();
            objDefine(_self, "config", {
                g: function () {
                    return _config;
                }
            });
            arrForEach(["pluginVersionStringArr", "pluginVersionString"], function (key) {
                objDefine(_self, key, {
                    g: function () {
                        if (_core) {
                            return _core[key];
                        }
                        return null;
                    }
                });
            });
            // initialize the queue and config in case they are undefined
            _snippetVersion = "" + (snippet.sv || snippet[_DYN_VERSION /* @min:%2eversion */] || "");
            snippet[_DYN_QUEUE /* @min:%2equeue */] = snippet[_DYN_QUEUE /* @min:%2equeue */] || [];
            snippet[_DYN_VERSION /* @min:%2eversion */] = snippet[_DYN_VERSION /* @min:%2eversion */] || 2.0; // Default to new version
            var cfgHandler = createDynamicConfig(snippet.config || {}, defaultConfigValues);
            _config = cfgHandler.cfg;
            _analyticsPlugin = new AnalyticsPlugin();
            objDefine(_self, "appInsights", {
                g: function () {
                    return _analyticsPlugin;
                }
            });
            properties = new PropertiesPlugin$1();
            dependencies = new AjaxMonitor();
            _sender = new Sender();
            _core = new AppInsightsCore();
            objDefine(_self, "core", {
                g: function () {
                    return _core;
                }
            });
            // Will get recalled if any referenced values are changed
            _addUnloadHook(onConfigChange(cfgHandler, function () {
                if (_config[_DYN_CONNECTION_STRING /* @min:%2econnectionString */]) {
                    var cs = parseConnectionString(_config[_DYN_CONNECTION_STRING /* @min:%2econnectionString */]);
                    var ingest = cs.ingestionendpoint;
                    _config[_DYN_ENDPOINT_URL /* @min:%2eendpointUrl */] = ingest ? (ingest + DEFAULT_BREEZE_PATH) : _config[_DYN_ENDPOINT_URL /* @min:%2eendpointUrl */]; // only add /v2/track when from connectionstring
                    _config[_DYN_INSTRUMENTATION_KEY /* @min:%2einstrumentationKey */] = cs.instrumentationkey || _config[_DYN_INSTRUMENTATION_KEY /* @min:%2einstrumentationKey */];
                }
            }));
            _self[STR_SNIPPET /* @min:%2esnippet */] = snippet;
            _self[STR_FLUSH /* @min:%2eflush */] = function (async, callBack) {
                if (async === void 0) { async = true; }
                var result;
                doPerf(_core, function () { return "AISKU.flush"; }, function () {
                    if (async && !callBack) {
                        result = createPromise(function (resolve) {
                            callBack = resolve;
                        });
                    }
                    var waiting = 1;
                    var flushDone = function () {
                        waiting--;
                        if (waiting === 0) {
                            callBack();
                        }
                    };
                    arrForEach(_core.getChannels(), function (channel) {
                        if (channel) {
                            waiting++;
                            channel[STR_FLUSH /* @min:%2eflush */](async, flushDone);
                        }
                    });
                    // decrement the initial "waiting"
                    flushDone();
                }, null, async);
                return result;
            };
            _self[_DYN_ONUNLOAD_FLUSH /* @min:%2eonunloadFlush */] = function (async) {
                if (async === void 0) { async = true; }
                arrForEach(_core.getChannels(), function (channel) {
                    if (channel[_DYN_ONUNLOAD_FLUSH /* @min:%2eonunloadFlush */]) {
                        channel[_DYN_ONUNLOAD_FLUSH /* @min:%2eonunloadFlush */]();
                    }
                    else {
                        channel[STR_FLUSH /* @min:%2eflush */](async);
                    }
                });
            };
            _self.loadAppInsights = function (legacyMode, logger, notificationManager) {
                if (legacyMode === void 0) { legacyMode = false; }
                if (legacyMode) {
                    throwUnsupported("Legacy Mode is no longer supported");
                }
                function _updateSnippetProperties(snippet) {
                    if (snippet) {
                        var snippetVer = "";
                        if (!isNullOrUndefined(_snippetVersion)) {
                            snippetVer += _snippetVersion;
                        }
                        if (_self[_DYN_CONTEXT /* @min:%2econtext */] && _self[_DYN_CONTEXT /* @min:%2econtext */].internal) {
                            _self[_DYN_CONTEXT /* @min:%2econtext */].internal.snippetVer = snippetVer || "-";
                        }
                        // apply updated properties to the global instance (snippet)
                        objForEachKey(_self, function (field, value) {
                            if (isString(field) &&
                                !isFunction(value) &&
                                field && field[0] !== "_" && // Don't copy "internal" values
                                arrIndexOf(_ignoreUpdateSnippetProperties, field) === -1) {
                                if (snippet[field] !== value) {
                                    snippet[field] = value;
                                }
                            }
                        });
                    }
                }
                doPerf(_self.core, function () { return "AISKU.loadAppInsights"; }, function () {
                    // initialize core
                    _core.initialize(_config, [_sender, properties, dependencies, _analyticsPlugin, _cfgSyncPlugin], logger, notificationManager);
                    objDefine(_self, "context", {
                        g: function () { return properties[_DYN_CONTEXT /* @min:%2econtext */]; }
                    });
                    if (!_throttleMgr) {
                        _throttleMgr = new ThrottleMgr(_core);
                    }
                    var sdkSrc = _findSdkSourceFile();
                    if (sdkSrc && _self[_DYN_CONTEXT /* @min:%2econtext */]) {
                        _self[_DYN_CONTEXT /* @min:%2econtext */].internal.sdkSrc = sdkSrc;
                    }
                    _updateSnippetProperties(_self[STR_SNIPPET /* @min:%2esnippet */]);
                    // Empty queue of all api calls logged prior to sdk download
                    _self.emptyQueue();
                    _self[STR_POLL_INTERNAL_LOGS /* @min:%2epollInternalLogs */]();
                    _self[_DYN_ADD_HOUSEKEEPING_BEF0 /* @min:%2eaddHousekeepingBeforeUnload */](_self);
                    _addUnloadHook(onConfigChange(cfgHandler, function () {
                        var defaultEnable = false;
                        if (_config.throttleMgrCfg[109 /* _eInternalMessageId.DefaultThrottleMsgKey */]) {
                            defaultEnable = !_config.throttleMgrCfg[109 /* _eInternalMessageId.DefaultThrottleMsgKey */].disabled;
                        }
                        if (!_throttleMgr.isReady() && _config.extensionConfig && _config.extensionConfig[_cfgSyncPlugin.identifier] && defaultEnable) {
                            // set ready state to true will automatically trigger flush()
                            _throttleMgr.onReadyState(true);
                        }
                        var result;
                        if (!_iKeySentMessage && !_config[_DYN_CONNECTION_STRING /* @min:%2econnectionString */] && isFeatureEnabled(IKEY_USAGE, _config)) {
                            result = _throttleMgr[_DYN_SEND_MESSAGE /* @min:%2esendMessage */](106 /* _eInternalMessageId.InstrumentationKeyDeprecation */, "See Instrumentation key support at aka.ms/IkeyMigrate");
                            if (result && result[_DYN_IS_THROTTLED /* @min:%2eisThrottled */]) {
                                _iKeySentMessage = true;
                            }
                        }
                        if (!_cdnSentMessage && _self[_DYN_CONTEXT /* @min:%2econtext */].internal.sdkSrc && _self[_DYN_CONTEXT /* @min:%2econtext */].internal.sdkSrc.indexOf("az416426") != -1 && isFeatureEnabled(CDN_USAGE, _config)) {
                            result = _throttleMgr[_DYN_SEND_MESSAGE /* @min:%2esendMessage */](110 /* _eInternalMessageId.CdnDeprecation */, "See Cdn support notice at aka.ms/JsActiveCdn");
                            if (result && result[_DYN_IS_THROTTLED /* @min:%2eisThrottled */]) {
                                _cdnSentMessage = true;
                            }
                        }
                        if (!_sdkVerSentMessage && parseInt(_snippetVersion) < 6 && isFeatureEnabled(SDK_LOADER_VER, _config)) {
                            result = _throttleMgr[_DYN_SEND_MESSAGE /* @min:%2esendMessage */](111 /* _eInternalMessageId.SdkLdrUpdate */, "An updated Sdk Loader is available, see aka.ms/SnippetVer");
                            if (result && result[_DYN_IS_THROTTLED /* @min:%2eisThrottled */]) {
                                _sdkVerSentMessage = true;
                            }
                        }
                    }));
                });
                return _self;
            };
            _self[_DYN_UPDATE_SNIPPET_DEFIN1 /* @min:%2eupdateSnippetDefinitions */] = function (snippet) {
                // apply full appInsights to the global instance
                // Note: This must be called before loadAppInsights is called
                proxyAssign(snippet, _self, function (name) {
                    // Not excluding names prefixed with "_" as we need to proxy some functions like _onError
                    return name && arrIndexOf(_ignoreUpdateSnippetProperties, name) === -1;
                });
            };
            _self.emptyQueue = function () {
                // call functions that were queued before the main script was loaded
                try {
                    if (isArray(_self.snippet[_DYN_QUEUE /* @min:%2equeue */])) {
                        // note: do not check length in the for-loop conditional in case something goes wrong and the stub methods are not overridden.
                        var length_1 = _self.snippet[_DYN_QUEUE /* @min:%2equeue */].length;
                        for (var i = 0; i < length_1; i++) {
                            var call = _self.snippet[_DYN_QUEUE /* @min:%2equeue */][i];
                            call();
                        }
                        _self.snippet[_DYN_QUEUE /* @min:%2equeue */] = undefined;
                        delete _self.snippet[_DYN_QUEUE /* @min:%2equeue */];
                    }
                }
                catch (exception) {
                    var properties_1 = {};
                    if (exception && isFunction(exception.toString)) {
                        properties_1.exception = exception.toString();
                    }
                    // need from core
                    // Microsoft.ApplicationInsights._InternalLogging.throwInternal(
                    //     eLoggingSeverity.WARNING,
                    //     _eInternalMessageId.FailedToSendQueuedTelemetry,
                    //     "Failed to send queued telemetry",
                    //     properties);
                }
            };
            _self[_DYN_ADD_HOUSEKEEPING_BEF0 /* @min:%2eaddHousekeepingBeforeUnload */] = function (appInsightsInstance) {
                // Add callback to push events when the user navigates away
                if (hasWindow() || hasDocument()) {
                    var performHousekeeping_1 = function () {
                        // Adds the ability to flush all data before the page unloads.
                        // Note: This approach tries to push a sync request with all the pending events onbeforeunload.
                        // Firefox does not respect this.Other browsers DO push out the call with < 100% hit rate.
                        // Telemetry here will help us analyze how effective this approach is.
                        // Another approach would be to make this call sync with a acceptable timeout to reduce the
                        // impact on user experience.
                        // appInsightsInstance.context._sender.triggerSend();
                        appInsightsInstance[_DYN_ONUNLOAD_FLUSH /* @min:%2eonunloadFlush */](false);
                        // Back up the current session to local storage
                        // This lets us close expired sessions after the cookies themselves expire
                        if (isFunction(_self.core[STR_GET_PLUGIN /* @min:%2egetPlugin */])) {
                            var loadedPlugin = _this.core[STR_GET_PLUGIN /* @min:%2egetPlugin */](PropertiesPluginIdentifier);
                            if (loadedPlugin) {
                                var propertiesPlugin = loadedPlugin.plugin;
                                if (propertiesPlugin && propertiesPlugin[_DYN_CONTEXT /* @min:%2econtext */] && propertiesPlugin[_DYN_CONTEXT /* @min:%2econtext */]._sessionManager) {
                                    propertiesPlugin[_DYN_CONTEXT /* @min:%2econtext */]._sessionManager.backup();
                                }
                            }
                        }
                    };
                    var added_1 = false;
                    if (!_houseKeepingNamespace) {
                        _houseKeepingNamespace = mergeEvtNamespace(_evtNamespace, _core[STR_EVT_NAMESPACE /* @min:%2eevtNamespace */] && _core[STR_EVT_NAMESPACE /* @min:%2eevtNamespace */]());
                    }
                    // Will be recalled if any referenced config properties change
                    _addUnloadHook(onConfigChange(_config, function (details) {
                        var coreConfig = details.cfg;
                        var analyticsPlugin = appInsightsInstance.appInsights;
                        var ctx = createProcessTelemetryContext(null, coreConfig, analyticsPlugin.core);
                        var extConfig = ctx.getExtCfg(analyticsPlugin.identifier || AnalyticsPluginIdentifier);
                        // As we could get recalled, remove any previously registered event handlers first
                        _removePageEventHandlers();
                        var excludePageUnloadEvents = coreConfig.disablePageUnloadEvents;
                        if (!extConfig.disableFlushOnBeforeUnload) {
                            // Hook the unload event for the document, window and body to ensure that the client events are flushed to the server
                            // As just hooking the window does not always fire (on chrome) for page navigation's.
                            if (addPageUnloadEventListener(performHousekeeping_1, excludePageUnloadEvents, _houseKeepingNamespace)) {
                                added_1 = true;
                            }
                            // We also need to hook the pagehide and visibilitychange events as not all versions of Safari support load/unload events.
                            if (addPageHideEventListener(performHousekeeping_1, excludePageUnloadEvents, _houseKeepingNamespace)) {
                                added_1 = true;
                            }
                            // A reactNative app may not have a window and therefore the beforeunload/pagehide events -- so don't
                            // log the failure in this case
                            if (!added_1 && !isReactNative()) {
                                _throwInternal(_core.logger, 1 /* eLoggingSeverity.CRITICAL */, 19 /* _eInternalMessageId.FailedToAddHandlerForOnBeforeUnload */, "Could not add handler for beforeunload and pagehide");
                            }
                        }
                        if (!added_1 && !extConfig.disableFlushOnUnload) {
                            // If we didn't add the normal set then attempt to add the pagehide and visibilitychange only
                            addPageHideEventListener(performHousekeeping_1, excludePageUnloadEvents, _houseKeepingNamespace);
                        }
                    }));
                }
            };
            _self.getSender = function () {
                return _sender;
            };
            _self.unload = function (isAsync, unloadComplete, cbTimeout) {
                var unloadDone = false;
                var result;
                if (isAsync && !unloadComplete) {
                    result = createPromise(function (resolve) {
                        // Set the callback to the promise resolve callback
                        unloadComplete = resolve;
                    });
                }
                function _unloadCallback(unloadState) {
                    if (!unloadDone) {
                        unloadDone = true;
                        _initDefaults();
                        unloadComplete && unloadComplete(unloadState);
                    }
                }
                _self[_DYN_ONUNLOAD_FLUSH /* @min:%2eonunloadFlush */](isAsync);
                _removePageEventHandlers();
                _core.unload && _core.unload(isAsync, _unloadCallback, cbTimeout);
                return result;
            };
            proxyFunctions(_self, _analyticsPlugin, [
                STR_GET_COOKIE_MGR,
                STR_TRACK_EVENT,
                STR_TRACK_PAGE_VIEW,
                "trackPageViewPerformance",
                STR_TRACK_EXCEPTION,
                "_onerror",
                STR_TRACK_TRACE,
                STR_TRACK_METRIC,
                STR_START_TRACK_PAGE,
                STR_STOP_TRACK_PAGE,
                STR_START_TRACK_EVENT,
                STR_STOP_TRACK_EVENT
            ]);
            proxyFunctions(_self, _getCurrentDependencies, [
                STR_TRACK_DEPENDENCY_DATA,
                "addDependencyListener",
                "addDependencyInitializer"
            ]);
            proxyFunctions(_self, _core, [
                STR_ADD_TELEMETRY_INITIALIZER,
                STR_POLL_INTERNAL_LOGS,
                "stopPollingInternalLogs",
                STR_GET_PLUGIN,
                "addPlugin",
                STR_EVT_NAMESPACE,
                "addUnloadCb",
                "getTraceCtx",
                "updateCfg",
                "onCfgChange"
            ]);
            proxyFunctions(_self, function () {
                var context = properties[_DYN_CONTEXT /* @min:%2econtext */];
                return context ? context.user : null;
            }, [
                STR_SET_AUTHENTICATED_USER_CONTEXT,
                STR_CLEAR_AUTHENTICATED_USER_CONTEXT
            ]);
            // Using a function to support the dynamic adding / removal of plugins, so this will always return the current value
            function _getCurrentDependencies() {
                return dependencies;
            }
            function _initDefaults() {
                _evtNamespace = createUniqueNamespace("AISKU");
                _houseKeepingNamespace = null;
                dependencies = null;
                properties = null;
                _sender = null;
                _snippetVersion = null;
                _throttleMgr = null;
                _iKeySentMessage = false;
                _cdnSentMessage = false;
                _sdkVerSentMessage = false;
                _cfgSyncPlugin = new CfgSyncPlugin();
            }
            function _removePageEventHandlers() {
                // Remove any registered event handlers
                if (_houseKeepingNamespace) {
                    removePageUnloadEventListener(null, _houseKeepingNamespace);
                    removePageHideEventListener(null, _houseKeepingNamespace);
                }
            }
            function _addUnloadHook(hooks) {
                _core.addUnloadHook(hooks);
            }
        });
    }
    // Analytics Plugin
// Removed Stub for AppInsightsSku.prototype.getCookieMgr.
// Removed Stub for AppInsightsSku.prototype.trackEvent.
// Removed Stub for AppInsightsSku.prototype.trackPageView.
// Removed Stub for AppInsightsSku.prototype.trackPageViewPerformance.
// Removed Stub for AppInsightsSku.prototype.trackException.
// Removed Stub for AppInsightsSku.prototype._onerror.
// Removed Stub for AppInsightsSku.prototype.trackTrace.
// Removed Stub for AppInsightsSku.prototype.trackMetric.
// Removed Stub for AppInsightsSku.prototype.startTrackPage.
// Removed Stub for AppInsightsSku.prototype.stopTrackPage.
// Removed Stub for AppInsightsSku.prototype.startTrackEvent.
// Removed Stub for AppInsightsSku.prototype.stopTrackEvent.
// Removed Stub for AppInsightsSku.prototype.addTelemetryInitializer.
    // Properties Plugin
// Removed Stub for AppInsightsSku.prototype.setAuthenticatedUserContext.
// Removed Stub for AppInsightsSku.prototype.clearAuthenticatedUserContext.
    // Dependencies Plugin
// Removed Stub for AppInsightsSku.prototype.trackDependencyData.
    // Misc
// Removed Stub for AppInsightsSku.prototype.flush.
// Removed Stub for AppInsightsSku.prototype.onunloadFlush.
// Removed Stub for AppInsightsSku.prototype.loadAppInsights.
// Removed Stub for AppInsightsSku.prototype.updateSnippetDefinitions.
// Removed Stub for AppInsightsSku.prototype.emptyQueue.
// Removed Stub for AppInsightsSku.prototype.pollInternalLogs.
// Removed Stub for AppInsightsSku.prototype.stopPollingInternalLogs.
// Removed Stub for AppInsightsSku.prototype.addHousekeepingBeforeUnload.
// Removed Stub for AppInsightsSku.prototype.getSender.
// Removed Stub for AppInsightsSku.prototype.unload.
// Removed Stub for AppInsightsSku.prototype.getPlugin.
// Removed Stub for AppInsightsSku.prototype.addPlugin.
// Removed Stub for AppInsightsSku.prototype.updateCfg.
// Removed Stub for AppInsightsSku.prototype.evtNamespace.
// Removed Stub for AppInsightsSku.prototype.addUnloadCb.
// Removed Stub for AppInsightsSku.prototype.addDependencyListener.
    /**
     * Add an dependency telemetry initializer callback function to allow populating additional properties or drop the request.
     * It is called after the dependency call has completed and any available performance details are available. A dependency
     * initializer is similar to the TelemetryInitializer function but it allows you to block the reporting of the dependency
     * request so that it doesn't count against the `maxAjaxCallsPerView`.
     * @param dependencyInitializer - The Dependency Telemetry Initializer function
     * @returns - A IDependencyInitializerHandler to enable the initializer to be removed
     */
    AppInsightsSku.prototype.addDependencyInitializer = function (dependencyInitializer) {
        return null;
    };
// Removed Stub for AppInsightsSku.prototype.getTraceCtx.
// Removed Stub for AppInsightsSku.prototype.onCfgChange.
    return AppInsightsSku;
}());
// tslint:disable-next-line
function _findSdkSourceFile() {
    if (_internalSdkSrc) {
        // Use the cached value
        return _internalSdkSrc;
    }
    var sdkSrc = null;
    var isModule = false;
    var cdns = [
        "://js.monitor.azure.com/",
        "://az416426.vo.msecnd.net/"
    ];
    try {
        // Try and determine whether the sdk is being loaded from the CDN
        // currentScript is only valid during initial processing
        var scrpt = (document || {}).currentScript;
        if (scrpt) {
            sdkSrc = scrpt.src;
            // } else {
            //     // We need to update to at least typescript 2.9 for this to work :-(
            //     // Leaving as a stub for now so after we upgrade this breadcrumb is available
            //     let meta = import.meta;
            //     sdkSrc = (meta || {}).url;
            //     isModule = true;
        }
    }
    catch (e) {
        // eslint-disable-next-line no-empty
    }
    if (sdkSrc) {
        try {
            var url_1 = sdkSrc.toLowerCase();
            if (url_1) {
                var src_1 = "";
                arrForEach(cdns, function (value, idx) {
                    if (strIndexOf(url_1, value) !== -1) {
                        src_1 = "cdn" + (idx + 1);
                        if (strIndexOf(url_1, "/scripts/") === -1) {
                            if (strIndexOf(url_1, "/next/") !== -1) {
                                src_1 += "-next";
                            }
                            else if (strIndexOf(url_1, "/beta/") !== -1) {
                                src_1 += "-beta";
                            }
                        }
                        _internalSdkSrc = src_1 + (isModule ? ".mod" : "");
                        return -1;
                    }
                });
            }
        }
        catch (e) {
            // eslint-disable-next-line no-empty
        }
        // Cache the found value so we don't have to look it up again
        _internalSdkSrc = sdkSrc;
    }
    return _internalSdkSrc;
}

class ApplicationInsightsLogProvider {
    constructor() { }
    static async initialize(apiClient, clusterId) {
        if (this._applicationInsightsLogger)
            return;
        if (this._failedGettingConnectionString)
            return;
        if (this._initializing)
            return;
        this._initializing = true;
        try {
            const connectionString = (await apiClient.getClusterSetting(clusterId, 'AI:CONNECTIONSTRING')).value?.value;
            if (!connectionString) {
                this._failedGettingConnectionString = true;
                await apiClient.createClusterLog({
                    clusterId: clusterId,
                    eventName: "Could not get Application Insights connection string",
                    eventSeverity: "ERROR",
                    eventType: "TRACE"
                });
                return;
            }
            this._applicationInsightsLogger = new AppInsightsSku({
                config: { connectionString: connectionString }
            });
            this._applicationInsightsLogger.loadAppInsights();
        }
        catch (error) {
            Log.write({
                error: error,
                level: "error",
                message: `Could not initialize Application Insights Log Provider. Error: ${error.message}`,
                timestamp: new Date(),
            });
        }
        finally {
            this._initializing = false;
        }
    }
    static logException(error, parameters) {
        if (!this._applicationInsightsLogger)
            return;
        this._applicationInsightsLogger.trackException({ exception: error }, parameters);
    }
    static logEvent(name, parameters) {
        if (!this._applicationInsightsLogger)
            return;
        this._applicationInsightsLogger.trackEvent({ name: name }, parameters);
    }
}

class Logger {
    constructor(client, component, attendeeId, meetingId, clusterId) {
        Guard.isNotNullOrUndefined(client, "client");
        Guard.isNotNullOrUndefined(component, "component");
        Guard.isNotNullOrUndefined(attendeeId, "attendeeId");
        Guard.isNotNullOrUndefined(meetingId, "meetingId");
        this._component = component;
        this._attendeeId = attendeeId;
        this._meetingId = meetingId;
        void ApplicationInsightsLogProvider.initialize(client, clusterId);
    }
    static getLevelFromEventSeverity(eventSeverity) {
        if (eventSeverity == "FATAL")
            return "fatal";
        if (eventSeverity == "ERROR")
            return "error";
        if (eventSeverity == "WARNING")
            return "warn";
        if (eventSeverity == "INFORMATION")
            return "info";
        if (eventSeverity == "DEBUG")
            return "debug";
        return "verbose";
    }
    static getIndexOfLevel(level) {
        if (level == "none")
            return 6;
        if (level == "fatal")
            return 5;
        if (level == "error")
            return 4;
        if (level == "warn")
            return 3;
        if (level == "info")
            return 2;
        if (level == "debug")
            return 1;
        return 0; // verbose
    }
    async doLog(severity, param1, param2, param3, param4, param5) {
        const level = Logger.getLevelFromEventSeverity(severity);
        if (Logger.getIndexOfLevel(level) < Logger.getIndexOfLevel(Log.level))
            return;
        const debug = [];
        const errorProvided = Utility.isString(param3);
        if (errorProvided && !(param1 instanceof Error))
            param1 = new Error(param1);
        const error = (errorProvided ? param1 : undefined);
        const operation = (errorProvided ? param2 : param1);
        const message = (errorProvided ? param3 : param2);
        const duration = (errorProvided ? param4 : param3);
        const eventName = `${this._component}.${operation}`;
        this.validate(message, eventName);
        const parameters = {};
        Object.assign(parameters, errorProvided ? param5 : param4);
        if (parameters)
            Object.entries(parameters).forEach(([key, value]) => debug.push(`${key}=${value}`));
        parameters["attendeeId"] = this._attendeeId;
        parameters["meetingId"] = this._meetingId;
        parameters["message"] = message;
        if (duration)
            parameters["duration"] = Utility.isNumber(duration) ? Math.round(duration) : duration;
        this.writeToLocalLogger(severity, eventName, message, debug.join("\n"), duration, error);
        if (errorProvided)
            ApplicationInsightsLogProvider.logException(error, parameters);
        else
            ApplicationInsightsLogProvider.logEvent(eventName, parameters);
    }
    validate(eventMessage, eventName) {
        //if (!Utility.isNullOrUndefined(eventMessage) && eventMessage.length > DatabaseLogMessageLength.Max) {
        //  throw new Error(Constants.Errors.DatabaseLog.invalidEventMessageLength);
        //}
        //if (!Utility.isNullOrUndefined(eventName) && eventName.length > DatabaseLogNameLength.Max) {
        //  throw new Error(Constants.Errors.DatabaseLog.invalidEventNameLength);
        //}
    }
    writeToLocalLogger(eventSeverity, eventName, eventMessage, eventDebug, eventDuration, error) {
        Log.write({
            debug: eventDebug,
            error: error,
            level: Logger.getLevelFromEventSeverity(eventSeverity),
            message: `[${eventName}] ${eventMessage} ${!Utility.isNullOrUndefined(eventDuration) ? `[Duration: ${eventDuration}]` : ""}`.trimEnd(),
            timestamp: new Date(),
        });
    }
    debug(param1, param2, param3, param4, param5) {
        Guard.isNotNullOrUndefined(param1, "operation/error");
        Guard.isNotNullOrUndefined(param2, "message/operation");
        return this.doLog("DEBUG", param1, param2, param3, param4, param5);
    }
    error(param1, param2, param3, param4, param5) {
        Guard.isNotNullOrUndefined(param1, "operation/error");
        Guard.isNotNullOrUndefined(param2, "message/operation");
        return this.doLog("ERROR", param1, param2, param3, param4, param5);
    }
    fatal(param1, param2, param3, param4, param5) {
        Guard.isNotNullOrUndefined(param1, "operation/error");
        Guard.isNotNullOrUndefined(param2, "message/operation");
        return this.doLog("FATAL", param1, param2, param3, param4, param5);
    }
    information(param1, param2, param3, param4, param5) {
        Guard.isNotNullOrUndefined(param1, "operation/error");
        Guard.isNotNullOrUndefined(param2, "message/operation");
        return this.doLog("INFORMATION", param1, param2, param3, param4, param5);
    }
    warning(param1, param2, param3, param4, param5) {
        Guard.isNotNullOrUndefined(param1, "operation/error");
        Guard.isNotNullOrUndefined(param2, "message/operation");
        return this.doLog("WARNING", param1, param2, param3, param4, param5);
    }
    verbose(param1, param2, param3, param4, param5) {
        Guard.isNotNullOrUndefined(param1, "operation/error");
        Guard.isNotNullOrUndefined(param2, "message/operation");
        return this.doLog("VERBOSE", param1, param2, param3, param4, param5);
    }
}

let Connection$2 = class Connection extends Connection$3 {
    get attendee() { return this._attendee; }
    get attendeeAdmitted() { return this._attendeeAdmitted; }
    get attendeeAudioMuted() { return this._attendeeAudioMuted; }
    get attendeeAudioUnmuted() { return this._attendeeAudioUnmuted; }
    get attendeeAudioUnmuteDisabled() { return this._attendeeAudioUnmuteDisabled; }
    get attendeeAudioUnmuteEnabled() { return this._attendeeAudioUnmuteEnabled; }
    get attendeeBlockedFromLobby() { return this._attendeeBlockedFromLobby; }
    get attendeeBlockedFromRoom() { return this._attendeeBlockedFromRoom; }
    get attendeeHandLowered() { return this._attendeeHandLowered; }
    get attendeeHandRaised() { return this._attendeeHandRaised; }
    get attendeeJoined() { return this._attendeeJoined; }
    get attendeeKicked() { return this._attendeeKicked; }
    get attendeeLeft() { return this._attendeeLeft; }
    get attendeeNoiseSuppressed() { return this._attendeeNoiseSuppressed; }
    get attendeeNoiseUnsuppressed() { return this._attendeeNoiseUnsuppressed; }
    get attendeePausedUpdated() { return this._attendeePausedUpdated; }
    get attendeePermissionAdded() { return this._attendeePermissionAdded; }
    get attendeePermissionRemoved() { return this._attendeePermissionRemoved; }
    get attendeeSettingAdded() { return this._attendeeSettingAdded; }
    get attendeeSettingRemoved() { return this._attendeeSettingRemoved; }
    get attendeePinned() { return this._attendeePinned; }
    get attendeeQualityEdgeUpdated() { return this._attendeeQualityEdgeUpdated; }
    get attendeeQualityOriginUpdated() { return this._attendeeQualityOriginUpdated; }
    get attendeeUnpinned() { return this._attendeeUnpinned; }
    get attendeeUpdated() { return this._attendeeUpdated; }
    get attendeeVideoMuted() { return this._attendeeVideoMuted; }
    get attendeeVideoUnmuted() { return this._attendeeVideoUnmuted; }
    get attendeeVideoUnmuteDisabled() { return this._attendeeVideoUnmuteDisabled; }
    get attendeeVideoUnmuteEnabled() { return this._attendeeVideoUnmuteEnabled; }
    get chatChannelNotification() { return this._chatChannelNotification; }
    get chatMessageNotification() { return this._chatMessageNotification; }
    get chatChannelAttendeeNotification() { return this._chatChannelAttendeeNotification; }
    get meeting() { return this._meeting; }
    get meetingAudioMuted() { return this._meetingAudioMuted; }
    get meetingAudioUnmuted() { return this._meetingAudioUnmuted; }
    get meetingAudioUnmuteDisabled() { return this._meetingAudioUnmuteDisabled; }
    get meetingAudioUnmuteEnabled() { return this._meetingAudioUnmuteEnabled; }
    get meetingChatDisabled() { return this._meetingChatDisabled; }
    get meetingChatEnabled() { return this._meetingChatEnabled; }
    get meetingNoiseSuppressed() { return this._meetingNoiseSuppressed; }
    get meetingNoiseUnsuppressed() { return this._meetingNoiseUnsuppressed; }
    get meetingRecordingDisabled() { return this._meetingRecordingDisabled; }
    get meetingRecordingEnabled() { return this._meetingRecordingEnabled; }
    get meetingRecordingStarted() { return this._meetingRecordingStarted; }
    get meetingRecordingStopped() { return this._meetingRecordingStopped; }
    get meetingUpdated() { return this._meetingUpdated; }
    get meetingVideoMuted() { return this._meetingVideoMuted; }
    get meetingVideoUnmuted() { return this._meetingVideoUnmuted; }
    get meetingVideoUnmuteDisabled() { return this._meetingVideoUnmuteDisabled; }
    get meetingVideoUnmuteEnabled() { return this._meetingVideoUnmuteEnabled; }
    get room() { return this._room; }
    get subscribedAttendees() { return this._subscribedAttendees; }
    get tenantId() { return this._tenantId; }
    constructor(init) {
        super({
            attendeeId: init.attendeeId,
            eventLogger: new Logger(init.apiClient, "ControlConnection", init.attendeeId, init.meetingId, init.clusterId),
            iceRestartEnabled: init.iceRestartEnabled,
            iceReconnectionTimeout: init.iceReconnectionTimeout,
            meetingId: init.meetingId,
            turnRequired: init.turnRequired,
            turnSession: init.turnSession,
            type: "Control",
        });
        this._attendeeAdmitted = new EventOwnerAsync();
        this._attendeeAudioMuted = new EventOwnerAsync();
        this._attendeeAudioUnmuted = new EventOwnerAsync();
        this._attendeeAudioUnmuteDisabled = new EventOwnerAsync();
        this._attendeeAudioUnmuteEnabled = new EventOwnerAsync();
        this._attendeeBlockedFromLobby = new EventOwnerAsync();
        this._attendeeBlockedFromRoom = new EventOwnerAsync();
        this._attendeeHandLowered = new EventOwnerAsync();
        this._attendeeHandRaised = new EventOwnerAsync();
        this._attendeeJoined = new EventOwnerAsync();
        this._attendeeKicked = new EventOwnerAsync();
        this._attendeeLeft = new EventOwnerAsync();
        this._attendeeNoiseSuppressed = new EventOwnerAsync();
        this._attendeeNoiseUnsuppressed = new EventOwnerAsync();
        this._attendeePausedUpdated = new EventOwnerAsync();
        this._attendeePermissionAdded = new EventOwnerAsync();
        this._attendeePermissionRemoved = new EventOwnerAsync();
        this._attendeeSettingAdded = new EventOwnerAsync();
        this._attendeeSettingRemoved = new EventOwnerAsync();
        this._attendeePinned = new EventOwnerAsync();
        this._attendeeQualityEdgeUpdated = new EventOwnerAsync();
        this._attendeeQualityOriginUpdated = new EventOwnerAsync();
        this._attendeeUnpinned = new EventOwnerAsync();
        this._attendeeUpdated = new EventOwnerAsync();
        this._attendeeVideoMuted = new EventOwnerAsync();
        this._attendeeVideoUnmuted = new EventOwnerAsync();
        this._attendeeVideoUnmuteDisabled = new EventOwnerAsync();
        this._attendeeVideoUnmuteEnabled = new EventOwnerAsync();
        this._chatChannelNotification = new EventOwnerAsync();
        this._chatMessageNotification = new EventOwnerAsync();
        this._chatChannelAttendeeNotification = new EventOwnerAsync();
        this._meetingAudioMuted = new EventOwnerAsync();
        this._meetingAudioUnmuted = new EventOwnerAsync();
        this._meetingAudioUnmuteDisabled = new EventOwnerAsync();
        this._meetingAudioUnmuteEnabled = new EventOwnerAsync();
        this._meetingChatDisabled = new EventOwnerAsync();
        this._meetingChatEnabled = new EventOwnerAsync();
        this._meetingNoiseSuppressed = new EventOwnerAsync();
        this._meetingNoiseUnsuppressed = new EventOwnerAsync();
        this._meetingRecordingDisabled = new EventOwnerAsync();
        this._meetingRecordingEnabled = new EventOwnerAsync();
        this._meetingRecordingStarted = new EventOwnerAsync();
        this._meetingRecordingStopped = new EventOwnerAsync();
        this._meetingUpdated = new EventOwnerAsync();
        this._meetingVideoMuted = new EventOwnerAsync();
        this._meetingVideoUnmuted = new EventOwnerAsync();
        this._meetingVideoUnmuteDisabled = new EventOwnerAsync();
        this._meetingVideoUnmuteEnabled = new EventOwnerAsync();
        this._messageNotificationQueue = new DispatchQueue();
        this._subscribedAttendees = new EventOwnerAsync();
        this._client = init.client;
        this._canBlock = init.canBlock;
        this._canCreateChatChannel = init.canCreateChatChannel;
        this._canDeleteChatChannel = init.canDeleteChatChannel;
        this._canDeleteChatMessage = init.canDeleteChatMessage;
        this._canEnableChat = init.canEnableChat;
        this._canKick = init.canKick;
        this._canMute = init.canMute;
        this._canRecord = init.canRecord;
        this._canSendChatMessage = init.canSendChatMessage;
        this._canUnmute = init.canUnmute;
        this._canUpdate = init.canUpdate;
        this.attachEventHandlers();
    }
    async negotiate(offer, abortSignal) {
        const response = await this._client.negotiate({ offer }, abortSignal);
        this._attendee = response.attendee;
        this._meeting = response.meeting;
        this._room = response.room;
        this._tenantId = response.tenantId;
        return response.answer;
    }
    processNotification(notification) {
        if (notification.type == "attendeeAddPermission") {
            void this._messageNotificationQueue.dispatch(() => {
                return this._attendeePermissionAdded.dispatch({
                    attendeePermission: notification.attendeePermissionRequest,
                });
            });
        }
        else if (notification.type == "attendeeAddSetting") {
            void this._messageNotificationQueue.dispatch(() => {
                return this._attendeeSettingAdded.dispatch({
                    attendeeSetting: notification.attendeeSetting,
                });
            });
        }
        else if (notification.type == "attendeeAdmitted") {
            void this._messageNotificationQueue.dispatch(() => {
                return this._attendeeAdmitted.dispatch({
                    attendee: notification.attendee,
                });
            });
        }
        else if (notification.type == "attendeeBlockedFromLobby") {
            void this._messageNotificationQueue.dispatch(() => {
                return this._attendeeBlockedFromLobby.dispatch({
                    attendee: notification.attendee,
                });
            });
        }
        else if (notification.type == "attendeeBlockedFromRoom") {
            void this._messageNotificationQueue.dispatch(() => {
                return this._attendeeBlockedFromRoom.dispatch({
                    attendee: notification.attendee,
                });
            });
        }
        else if (notification.type == "attendeeDisableAudioUnmute") {
            void this._messageNotificationQueue.dispatch(() => {
                return this._attendeeAudioUnmuteDisabled.dispatch({
                    attendee: notification.attendee,
                });
            });
        }
        else if (notification.type == "attendeeDisableVideoUnmute") {
            void this._messageNotificationQueue.dispatch(() => {
                return this._attendeeVideoUnmuteDisabled.dispatch({
                    attendee: notification.attendee,
                });
            });
        }
        else if (notification.type == "attendeeEnableAudioUnmute") {
            void this._messageNotificationQueue.dispatch(() => {
                return this._attendeeAudioUnmuteEnabled.dispatch({
                    attendee: notification.attendee,
                });
            });
        }
        else if (notification.type == "attendeeEnableVideoUnmute") {
            void this._messageNotificationQueue.dispatch(() => {
                return this._attendeeVideoUnmuteEnabled.dispatch({
                    attendee: notification.attendee,
                });
            });
        }
        else if (notification.type == "attendeeJoined") {
            void this._messageNotificationQueue.dispatch(() => {
                return this._attendeeJoined.dispatch({
                    attendee: notification.attendee,
                    attendeeNotification: notification.attendeeNotification,
                });
            });
        }
        else if (notification.type == "attendeeKicked") {
            void this._messageNotificationQueue.dispatch(() => {
                return this._attendeeKicked.dispatch({
                    attendee: notification.attendee,
                });
            });
        }
        else if (notification.type == "attendeeLeft") {
            void this._messageNotificationQueue.dispatch(() => {
                return this._attendeeLeft.dispatch({
                    attendee: notification.attendee,
                    attendeeNotification: notification.attendeeNotification,
                });
            });
        }
        else if (notification.type == "attendeeLowerHand") {
            void this._messageNotificationQueue.dispatch(() => {
                return this._attendeeHandLowered.dispatch({
                    attendeeSetting: notification.attendeeSetting,
                });
            });
        }
        else if (notification.type == "attendeeMuteAudioDisplay") {
            void this._messageNotificationQueue.dispatch(() => {
                return this._attendeeAudioMuted.dispatch({
                    attendee: notification.attendee,
                });
            });
        }
        else if (notification.type == "attendeeMuteAudioUser") {
            void this._messageNotificationQueue.dispatch(() => {
                return this._attendeeAudioMuted.dispatch({
                    attendee: notification.attendee,
                });
            });
        }
        else if (notification.type == "attendeeMuteVideoDisplay") {
            void this._messageNotificationQueue.dispatch(() => {
                return this._attendeeVideoMuted.dispatch({
                    attendee: notification.attendee,
                });
            });
        }
        else if (notification.type == "attendeeMuteVideoUser") {
            void this._messageNotificationQueue.dispatch(() => {
                return this._attendeeVideoMuted.dispatch({
                    attendee: notification.attendee,
                });
            });
        }
        else if (notification.type == "attendeePausedUpdated") {
            void this._messageNotificationQueue.dispatch(() => {
                return this._attendeePausedUpdated.dispatch({
                    attendee: notification.attendee,
                });
            });
        }
        else if (notification.type == "attendeeQualityEdgeUpdated") {
            void this._messageNotificationQueue.dispatch(() => {
                return this._attendeeQualityEdgeUpdated.dispatch({
                    attendee: notification.attendee,
                });
            });
        }
        else if (notification.type == "attendeeQualityOriginUpdated") {
            void this._messageNotificationQueue.dispatch(() => {
                return this._attendeeQualityOriginUpdated.dispatch({
                    attendee: notification.attendee,
                });
            });
        }
        else if (notification.type == "attendeeRaiseHand") {
            void this._messageNotificationQueue.dispatch(() => {
                return this._attendeeHandRaised.dispatch({
                    attendeeSetting: notification.attendeeSetting,
                });
            });
        }
        else if (notification.type == "attendeeRemovePermission") {
            void this._messageNotificationQueue.dispatch(() => {
                return this._attendeePermissionRemoved.dispatch({
                    attendeePermission: notification.attendeePermissionRequest,
                });
            });
        }
        else if (notification.type == "attendeeRemoveSetting") {
            void this._messageNotificationQueue.dispatch(() => {
                return this._attendeeSettingRemoved.dispatch({
                    attendeeSetting: notification.attendeeSetting,
                });
            });
        }
        else if (notification.type == "attendeeSuppressNoise") {
            void this._messageNotificationQueue.dispatch(() => {
                return this._attendeeNoiseSuppressed.dispatch({
                    attendee: notification.attendee,
                });
            });
        }
        else if (notification.type == "attendeeUnmuteAudioDisplay") {
            void this._messageNotificationQueue.dispatch(() => {
                return this._attendeeAudioUnmuted.dispatch({
                    attendee: notification.attendee,
                });
            });
        }
        else if (notification.type == "attendeeUnmuteAudioUser") {
            void this._messageNotificationQueue.dispatch(() => {
                return this._attendeeAudioUnmuted.dispatch({
                    attendee: notification.attendee,
                });
            });
        }
        else if (notification.type == "attendeeUnmuteVideoDisplay") {
            void this._messageNotificationQueue.dispatch(() => {
                return this._attendeeVideoUnmuted.dispatch({
                    attendee: notification.attendee,
                });
            });
        }
        else if (notification.type == "attendeeUnmuteVideoUser") {
            void this._messageNotificationQueue.dispatch(() => {
                return this._attendeeVideoUnmuted.dispatch({
                    attendee: notification.attendee,
                });
            });
        }
        else if (notification.type == "attendeeUnsuppressNoise") {
            void this._messageNotificationQueue.dispatch(() => {
                return this._attendeeNoiseUnsuppressed.dispatch({
                    attendee: notification.attendee,
                });
            });
        }
        else if (notification.type == "attendeeUpdated" ||
            notification.type == "attendeeUpdateAvatarUrl" ||
            notification.type == "attendeeUpdateDisplayName" ||
            notification.type == "attendeeUpdateRole") {
            void this._messageNotificationQueue.dispatch(() => {
                return this._attendeeUpdated.dispatch({
                    attendee: notification.attendee,
                    attendeeNotification: notification.attendeeNotification,
                });
            });
        }
        else if (notification.type == "chatChannelNotification") {
            void this._messageNotificationQueue.dispatch(() => {
                return this._chatChannelNotification.dispatch(notification.chatChannelNotification);
            });
        }
        else if (notification.type == "chatChannelAttendeeNotification") {
            void this._messageNotificationQueue.dispatch(() => {
                return this._chatChannelAttendeeNotification.dispatch(notification.chatChannelAttendeeNotification);
            });
        }
        else if (notification.type == "chatMessageNotification") {
            void this._messageNotificationQueue.dispatch(() => {
                return this._chatMessageNotification.dispatch(notification.chatMessageNotification);
            });
        }
        else if (notification.type == "chatDisabled") {
            void this._messageNotificationQueue.dispatch(() => {
                return this._meetingChatDisabled.dispatch({
                    attendee: notification.attendee,
                    meeting: notification.meeting,
                });
            });
        }
        else if (notification.type == "chatEnabled") {
            void this._messageNotificationQueue.dispatch(() => {
                return this._meetingChatEnabled.dispatch({
                    attendee: notification.attendee,
                    meeting: notification.meeting,
                });
            });
        }
        else if (notification.type == "meetingDisableAudioUnmute") {
            void this._messageNotificationQueue.dispatch(() => {
                return this._meetingAudioUnmuteDisabled.dispatch({
                    attendee: notification.attendee,
                    exclusions: notification.exclusions,
                    meeting: notification.meeting,
                });
            });
        }
        else if (notification.type == "meetingDisableVideoUnmute") {
            void this._messageNotificationQueue.dispatch(() => {
                return this._meetingVideoUnmuteDisabled.dispatch({
                    attendee: notification.attendee,
                    exclusions: notification.exclusions,
                    meeting: notification.meeting,
                });
            });
        }
        else if (notification.type == "meetingEnableAudioUnmute") {
            void this._messageNotificationQueue.dispatch(() => {
                return this._meetingAudioUnmuteEnabled.dispatch({
                    attendee: notification.attendee,
                    exclusions: notification.exclusions,
                    meeting: notification.meeting,
                });
            });
        }
        else if (notification.type == "meetingEnableVideoUnmute") {
            void this._messageNotificationQueue.dispatch(() => {
                return this._meetingVideoUnmuteEnabled.dispatch({
                    attendee: notification.attendee,
                    exclusions: notification.exclusions,
                    meeting: notification.meeting,
                });
            });
        }
        else if (notification.type == "meetingMuteAudio") {
            void this._messageNotificationQueue.dispatch(() => {
                return this._meetingAudioMuted.dispatch({
                    attendee: notification.attendee,
                    exclusions: notification.exclusions,
                    meeting: notification.meeting,
                });
            });
        }
        else if (notification.type == "meetingMuteVideo") {
            void this._messageNotificationQueue.dispatch(() => {
                return this._meetingVideoMuted.dispatch({
                    attendee: notification.attendee,
                    exclusions: notification.exclusions,
                    meeting: notification.meeting,
                });
            });
        }
        else if (notification.type == "meetingSuppressNoise") {
            void this._messageNotificationQueue.dispatch(() => {
                return this._meetingNoiseSuppressed.dispatch({
                    attendee: notification.attendee,
                    exclusions: notification.exclusions,
                    meeting: notification.meeting,
                });
            });
        }
        else if (notification.type == "meetingStartRecording") {
            void this._messageNotificationQueue.dispatch(() => {
                return this._meetingRecordingStarted.dispatch({
                    attendee: notification.attendee,
                    meeting: notification.meeting,
                });
            });
        }
        else if (notification.type == "meetingStopRecording") {
            void this._messageNotificationQueue.dispatch(() => {
                return this._meetingRecordingStopped.dispatch({
                    attendee: notification.attendee,
                    meeting: notification.meeting,
                });
            });
        }
        else if (notification.type == "meetingUnmuteAudio") {
            void this._messageNotificationQueue.dispatch(() => {
                return this._meetingAudioUnmuted.dispatch({
                    attendee: notification.attendee,
                    exclusions: notification.exclusions,
                    meeting: notification.meeting,
                });
            });
        }
        else if (notification.type == "meetingUnmuteVideo") {
            void this._messageNotificationQueue.dispatch(() => {
                return this._meetingVideoUnmuted.dispatch({
                    attendee: notification.attendee,
                    exclusions: notification.exclusions,
                    meeting: notification.meeting,
                });
            });
        }
        else if (notification.type == "meetingUnsuppressNoise") {
            void this._messageNotificationQueue.dispatch(() => {
                return this._meetingNoiseUnsuppressed.dispatch({
                    attendee: notification.attendee,
                    exclusions: notification.exclusions,
                    meeting: notification.meeting,
                });
            });
        }
        else if (notification.type == "meetingUpdated") {
            void this._messageNotificationQueue.dispatch(() => {
                return this._meetingUpdated.dispatch({
                    attendee: notification.attendee,
                    meeting: notification.meeting,
                });
            });
        }
        else if (notification.type == "recordingDisabled") {
            void this._messageNotificationQueue.dispatch(() => {
                return this._meetingRecordingDisabled.dispatch({
                    attendee: notification.attendee,
                    meeting: notification.meeting,
                });
            });
        }
        else if (notification.type == "recordingEnabled") {
            void this._messageNotificationQueue.dispatch(() => {
                return this._meetingRecordingEnabled.dispatch({
                    attendee: notification.attendee,
                    meeting: notification.meeting,
                });
            });
        }
        else if (notification.type == "subscribedAttendees") {
            void this._messageNotificationQueue.dispatch(() => {
                return this._subscribedAttendees.dispatch({
                    attendees: notification.attendees,
                });
            });
        }
        else {
            void this.eventLogger.warning("dispatchNotification", `Unexpected "${notification.type}" control notification.`);
        }
    }
    async renegotiate(offer, abortSignal) {
        return (await this._client.renegotiate({
            offer: offer,
        }, abortSignal)).answer;
    }
    getExcludedIceCandidates() {
        return [];
    }
    /** @internal */
    async addAttendeePermission(attendeePermissionRequest) {
        if (!this._canUpdate())
            throw new Error(Constants$2.Errors.Meeting.Permissions.cannotAddPermission);
        return await this.sendRequest({
            type: "attendeeAddPermission",
            attendeePermissionRequest: attendeePermissionRequest
        });
    }
    /** @internal */
    async addAttendeeSetting(attendee, setting) {
        if (attendee.id != this.attendeeId && !this._canUpdate())
            throw new Error(Constants$2.Errors.Meeting.Permissions.cannotUpdateAttendee);
        return await this.sendRequest({
            type: "attendeeAddSetting",
            attendeeSetting: setting,
            attendee: attendee,
        });
    }
    /** @internal */
    async addChatChannelMember(chatChannel, chatChannelMember) {
        if (chatChannel.createdBy != this.attendeeId && !this._canCreateChatChannel())
            throw new Error(Constants$2.Errors.Meeting.Permissions.cannotCreateChatChannelMember);
        const response = await this.sendChatChannelAttendeeNotification({
            channelId: chatChannel.id,
            attendeeId: chatChannelMember.attendeeId,
            roleType: chatChannelMember.roleType,
        });
        if (!response || !response.chatChannelAttendeeNotification)
            throw new Error(Constants$2.Errors.Meeting.Chat.cannotAddChatMember);
        return response;
    }
    /** @internal */
    async admitAttendee(attendee) {
        if (!this._canBlock())
            throw new Error(Constants$2.Errors.Meeting.Permissions.cannotAdmit);
        await this.sendRequest({
            type: "attendeeAdmit",
            attendee: attendee
        });
    }
    /** @internal */
    async blockAttendeeFromLobby(attendee) {
        if (!this._canBlock())
            throw new Error(Constants$2.Errors.Meeting.Permissions.cannotBlock);
        await this.sendRequest({
            type: "attendeeBlockFromLobby",
            attendee: attendee
        });
    }
    /** @internal */
    async blockAttendeeFromRoom(attendee) {
        if (!this._canBlock())
            throw new Error(Constants$2.Errors.Meeting.Permissions.cannotBlock);
        await this.sendRequest({
            type: "attendeeBlockFromRoom",
            attendee: attendee
        });
    }
    /** @internal */
    async disableAttendeeAudioUnmute(attendee) {
        if (!this._canMute())
            throw new Error(Constants$2.Errors.Meeting.Permissions.cannotDisableUnmute);
        await this.sendRequest({
            type: "attendeeDisableAudioUnmute",
            attendee: attendee
        });
    }
    /** @internal */
    async disableAttendeeVideoUnmute(attendee) {
        if (!this._canMute())
            throw new Error(Constants$2.Errors.Meeting.Permissions.cannotDisableUnmute);
        await this.sendRequest({
            type: "attendeeDisableVideoUnmute",
            attendee: attendee
        });
    }
    /** @internal */
    async disableChat(meeting) {
        if (!this._canEnableChat())
            throw new Error(Constants$2.Errors.Meeting.Permissions.cannotDisableChat);
        const response = await this.sendRequest({
            type: "meetingDisableChat",
            meeting: meeting
        });
        if (response.meeting.allowChat)
            throw new Error(Constants$2.Errors.Meeting.Chat.cannotDisable);
        // is this for responsiveness? (we don't do this on enable)
        await this._messageNotificationQueue.dispatch(() => {
            return this._meetingChatDisabled.dispatch({ meeting: response.meeting });
        });
    }
    /** @internal */
    async disableMeetingAudioUnmute(meeting) {
        if (!this._canMute())
            throw new Error(Constants$2.Errors.Meeting.Permissions.cannotDisableUnmute);
        await this.sendRequest({
            type: "meetingDisableAudioUnmute",
            meeting: meeting
        });
    }
    /** @internal */
    async disableMeetingAudioUnmuteOnJoin(meeting) {
        if (!this._canMute())
            throw new Error(Constants$2.Errors.Meeting.Permissions.cannotDisableUnmute);
        await this.sendRequest({
            type: "meetingDisableAudioUnmuteOnJoin",
            meeting: meeting
        });
    }
    /** @internal */
    async disableMeetingVideoUnmute(meeting) {
        if (!this._canMute())
            throw new Error(Constants$2.Errors.Meeting.Permissions.cannotDisableUnmute);
        await this.sendRequest({
            type: "meetingDisableVideoUnmute",
            meeting: meeting
        });
    }
    /** @internal */
    async disableMeetingVideoUnmuteOnJoin(meeting) {
        if (!this._canMute())
            throw new Error(Constants$2.Errors.Meeting.Permissions.cannotDisableUnmute);
        await this.sendRequest({
            type: "meetingDisableVideoUnmuteOnJoin",
            meeting: meeting
        });
    }
    /** @internal */
    async enableAttendeeAudioUnmute(attendee) {
        if (!this._canMute())
            throw new Error(Constants$2.Errors.Meeting.Permissions.cannotEnableUnmute);
        await this.sendRequest({
            type: "attendeeEnableAudioUnmute",
            attendee: attendee
        });
    }
    /** @internal */
    async enableAttendeeVideoUnmute(attendee) {
        if (!this._canMute())
            throw new Error(Constants$2.Errors.Meeting.Permissions.cannotEnableUnmute);
        await this.sendRequest({
            type: "attendeeEnableVideoUnmute",
            attendee: attendee
        });
    }
    /** @internal */
    async enableChat(meeting) {
        if (!this._canEnableChat())
            throw new Error(Constants$2.Errors.Meeting.Permissions.cannotEnableChat);
        const response = await this.sendRequest({
            type: "meetingEnableChat",
            meeting: meeting
        });
        if (!response.meeting.allowChat)
            throw new Error(Constants$2.Errors.Meeting.Chat.cannotEnable);
    }
    /** @internal */
    async enableMeetingAudioUnmute(meeting) {
        if (!this._canMute())
            throw new Error(Constants$2.Errors.Meeting.Permissions.cannotEnableUnmute);
        await this.sendRequest({
            type: "meetingEnableAudioUnmute",
            meeting: meeting
        });
    }
    /** @internal */
    async enableMeetingAudioUnmuteOnJoin(meeting) {
        if (!this._canMute())
            throw new Error(Constants$2.Errors.Meeting.Permissions.cannotEnableUnmute);
        await this.sendRequest({
            type: "meetingEnableAudioUnmuteOnJoin",
            meeting: meeting
        });
    }
    /** @internal */
    async enableMeetingVideoUnmute(meeting) {
        if (!this._canMute())
            throw new Error(Constants$2.Errors.Meeting.Permissions.cannotEnableUnmute);
        await this.sendRequest({
            type: "meetingEnableVideoUnmute",
            meeting: meeting
        });
    }
    /** @internal */
    async enableMeetingVideoUnmuteOnJoin(meeting) {
        if (!this._canMute())
            throw new Error(Constants$2.Errors.Meeting.Permissions.cannotEnableUnmute);
        await this.sendRequest({
            type: "meetingEnableVideoUnmuteOnJoin",
            meeting: meeting
        });
    }
    /** @internal */
    async flagChatChannelMessage(chatMessage, notification) {
        if (!this._canSendChatMessage())
            throw new Error(Constants$2.Errors.Meeting.Permissions.cannotChat);
        const response = await this.sendChatMessageNotification({
            messageId: chatMessage.id,
            messageStatus: "FLAGGED",
            sentBy: this.attendeeId,
        });
        if (!response || !response.chatMessageNotification)
            throw new Error(Constants$2.Errors.Meeting.Chat.cannotFlagMessage);
        return response;
    }
    /** @internal */
    async kickAttendee(attendee) {
        if (!this._canKick())
            throw new Error(Constants$2.Errors.Meeting.Permissions.cannotKick);
        await this.sendRequest({
            type: "attendeeKick",
            attendee: attendee
        });
    }
    /** @internal */
    async listAttendees(request) {
        return await this.sendRequest({
            type: "attendeeRequest",
            attendeeRequest: request
        });
    }
    /** @internal */
    async lowerAttendeeHand(attendee, setting) {
        if (attendee.id != this.attendeeId && !this._canUpdate())
            throw new Error(Constants$2.Errors.Meeting.Permissions.cannotUpdateAttendee);
        return await this.sendRequest({
            type: "attendeeLowerHand",
            attendeeSetting: setting,
            attendee: attendee
        });
    }
    /** @internal */
    async muteAttendeeAudio(attendee) {
        if (attendee.id != this.attendeeId && !this._canMute())
            throw new Error(Constants$2.Errors.Meeting.Permissions.cannotMute);
        await this.sendRequest({
            type: "attendeeMuteAudioUser",
            attendee: attendee
        });
    }
    /** @internal */
    async muteAttendeeVideo(attendee) {
        if (attendee.id != this.attendeeId && !this._canMute())
            throw new Error(Constants$2.Errors.Meeting.Permissions.cannotMute);
        await this.sendRequest({
            type: "attendeeMuteVideoUser",
            attendee: attendee
        });
    }
    /** @internal */
    async muteMeetingAudio(meeting) {
        if (!this._canMute())
            throw new Error(Constants$2.Errors.Meeting.Permissions.cannotMute);
        await this.sendRequest({
            type: "meetingMuteAudio",
            meeting: meeting
        });
    }
    /** @internal */
    async muteMeetingAudioOnJoin(meeting) {
        if (!this._canMute())
            throw new Error(Constants$2.Errors.Meeting.Permissions.cannotMute);
        await this.sendRequest({
            type: "meetingMuteAudioOnJoin",
            meeting: meeting
        });
    }
    /** @internal */
    async muteMeetingVideo(meeting) {
        if (!this._canMute())
            throw new Error(Constants$2.Errors.Meeting.Permissions.cannotMute);
        await this.sendRequest({
            type: "meetingMuteVideo",
            meeting: meeting
        });
    }
    /** @internal */
    async muteMeetingVideoOnJoin(meeting) {
        if (!this._canMute())
            throw new Error(Constants$2.Errors.Meeting.Permissions.cannotMute);
        await this.sendRequest({
            type: "meetingMuteVideoOnJoin",
            meeting: meeting
        });
    }
    /** @internal */
    async pinAttendee(attendee) {
        await this.sendRequest({
            type: "attendeePin",
            attendeeId: attendee.id,
        });
    }
    /** @internal */
    async raiseAttendeeHand(attendee, setting) {
        if (attendee.id != this.attendeeId && !this._canUpdate())
            throw new Error(Constants$2.Errors.Meeting.Permissions.cannotUpdateAttendee);
        return await this.sendRequest({
            type: "attendeeRaiseHand",
            attendeeSetting: setting,
            attendee: attendee
        });
    }
    /** @internal */
    async removeAttendeePermission(attendeePermissionRequest) {
        if (!this._canUpdate())
            throw new Error(Constants$2.Errors.Meeting.Permissions.cannotRemovePermission);
        return await this.sendRequest({
            type: "attendeeRemovePermission",
            attendeePermissionRequest: attendeePermissionRequest
        });
    }
    /** @internal */
    async removeAttendeeSetting(attendee, setting) {
        if (attendee.id != this.attendeeId && !this._canUpdate())
            throw new Error(Constants$2.Errors.Meeting.Permissions.cannotUpdateAttendee);
        return await this.sendRequest({
            type: "attendeeRemoveSetting",
            attendeeSetting: setting,
            attendee: attendee,
        });
    }
    /** @internal */
    async subscribeToAttendee(attendeeId, reason) {
        return await this.sendRequest({
            type: "attendeeSubscribe",
            attendeeId: attendeeId,
            reason: reason
        });
    }
    /** @internal */
    async startRecordingMeeting(meeting) {
        if (!this._canRecord())
            throw new Error(Constants$2.Errors.Meeting.Permissions.cannotRecordMeeting);
        const response = await this.sendRequest({
            type: "meetingStartRecording",
            meeting: meeting
        });
        if (!response.meeting.isRecording)
            throw new Error(Constants$2.Errors.Meeting.Recording.cannotStart);
        return response;
    }
    /** @internal */
    async stopRecordingMeeting(meeting) {
        if (!this._canRecord())
            throw new Error(Constants$2.Errors.Meeting.Permissions.cannotRecordMeeting);
        const response = await this.sendRequest({
            type: "meetingStopRecording",
            meeting: meeting
        });
        if (response.meeting.isRecording)
            throw new Error(Constants$2.Errors.Meeting.Recording.cannotStop);
        return response;
    }
    /** @internal */
    async suppressAttendeeNoise(attendee) {
        if (attendee.id != this.attendeeId && !this._canUpdate())
            throw new Error(Constants$2.Errors.Meeting.Permissions.cannotSuppressNoise);
        await this.sendRequest({
            type: "attendeeSuppressNoise",
            attendee: attendee
        });
    }
    /** @internal */
    async suppressMeetingNoise(meeting) {
        if (!this._canUpdate())
            throw new Error(Constants$2.Errors.Meeting.Permissions.cannotSuppressNoise);
        await this.sendRequest({
            type: "meetingSuppressNoise",
            meeting: meeting
        });
    }
    /** @internal */
    async suppressMeetingNoiseOnJoin(meeting) {
        if (!this._canUpdate())
            throw new Error(Constants$2.Errors.Meeting.Permissions.cannotSuppressNoise);
        await this.sendRequest({
            type: "meetingSuppressNoiseOnJoin",
            meeting: meeting
        });
    }
    /** @internal */
    async unmuteAttendeeAudio(attendee) {
        if (attendee.id != this.attendeeId && !this._canUnmute())
            throw new Error(Constants$2.Errors.Meeting.Permissions.cannotUnmute);
        await this.sendRequest({
            type: "attendeeUnmuteAudioUser",
            attendee: attendee
        });
    }
    /** @internal */
    async unmuteAttendeeVideo(attendee) {
        if (attendee.id != this.attendeeId && !this._canUnmute())
            throw new Error(Constants$2.Errors.Meeting.Permissions.cannotUnmute);
        await this.sendRequest({
            type: "attendeeUnmuteVideoUser",
            attendee: attendee
        });
    }
    /** @internal */
    async unmuteMeetingAudio(meeting) {
        if (!this._canUnmute())
            throw new Error(Constants$2.Errors.Meeting.Permissions.cannotUnmute);
        await this.sendRequest({
            type: "meetingUnmuteAudio",
            meeting: meeting
        });
    }
    /** @internal */
    async unmuteMeetingAudioOnJoin(meeting) {
        if (!this._canUnmute())
            throw new Error(Constants$2.Errors.Meeting.Permissions.cannotUnmute);
        await this.sendRequest({
            type: "meetingUnmuteAudioOnJoin",
            meeting: meeting
        });
    }
    /** @internal */
    async unmuteMeetingVideo(meeting) {
        if (!this._canUnmute())
            throw new Error(Constants$2.Errors.Meeting.Permissions.cannotUnmute);
        await this.sendRequest({
            type: "meetingUnmuteVideo",
            meeting: meeting
        });
    }
    /** @internal */
    async unmuteMeetingVideoOnJoin(meeting) {
        if (!this._canUnmute())
            throw new Error(Constants$2.Errors.Meeting.Permissions.cannotUnmute);
        await this.sendRequest({
            type: "meetingUnmuteVideoOnJoin",
            meeting: meeting
        });
    }
    /** @internal */
    async unpinAttendee(attendee) {
        await this.sendRequest({
            type: "attendeeUnpin",
            attendeeId: attendee.id,
        });
    }
    /** @internal */
    async unsuppressAttendeeNoise(attendee) {
        if (attendee.id != this.attendeeId && !this._canUpdate())
            throw new Error(Constants$2.Errors.Meeting.Permissions.cannotUnsuppressNoise);
        await this.sendRequest({
            type: "attendeeUnsuppressNoise",
            attendee: attendee
        });
    }
    /** @internal */
    async unsuppressMeetingNoise(meeting) {
        if (!this._canUpdate())
            throw new Error(Constants$2.Errors.Meeting.Permissions.cannotUnsuppressNoise);
        await this.sendRequest({
            type: "meetingUnsuppressNoise",
            meeting: meeting
        });
    }
    /** @internal */
    async unsuppressMeetingNoiseOnJoin(meeting) {
        if (!this._canUpdate())
            throw new Error(Constants$2.Errors.Meeting.Permissions.cannotUnsuppressNoise);
        await this.sendRequest({
            type: "meetingUnsuppressNoiseOnJoin",
            meeting: meeting
        });
    }
    /** @internal */
    async updateAttendeeAvatarUrl(attendee) {
        if (attendee.id != this.attendeeId && !this._canUpdate())
            throw new Error(Constants$2.Errors.Meeting.Permissions.cannotUpdateAttendee);
        await this.sendRequest({
            type: "attendeeUpdateAvatarUrl",
            attendee: attendee,
        });
    }
    /** @internal */
    async updateAttendeeDisplayName(attendee) {
        if (attendee.id != this.attendeeId && !this._canUpdate())
            throw new Error(Constants$2.Errors.Meeting.Permissions.cannotUpdateAttendee);
        await this.sendRequest({
            type: "attendeeUpdateDisplayName",
            attendee: attendee,
        });
    }
    /** @internal */
    async updateAttendeeRole(attendee) {
        if (!this._canUpdate())
            throw new Error(Constants$2.Errors.Meeting.Permissions.cannotUpdateAttendee);
        return await this.sendRequest({
            type: "attendeeUpdateRole",
            attendee: attendee,
        });
    }
    /** @internal */
    async sendChatMessageNotification(notification) {
        if (!this._canSendChatMessage())
            throw new Error(Constants$2.Errors.Meeting.Chat.cannotSendMessage);
        return await this.sendRequest({
            type: "chatMessageNotification",
            chatMessageNotification: notification
        });
    }
    /** @internal */
    async sendChatChannelNotification(notification) {
        return await this.sendRequest({
            type: "chatChannelNotification",
            chatChannelNotification: notification
        });
    }
    /** @internal */
    async sendChatChannelAttendeeNotification(notification) {
        return await this.sendRequest({
            type: "chatChannelAttendeeNotification",
            chatChannelAttendeeNotification: notification
        });
    }
    //protected processConnectionStats(stats: Map<string, any>): void {
    //  this._stats.updateFromConnection(stats);
    //}
    updateStats() {
        return Promise.resolve();
    }
};

class ManagerStateMachine {
    get state() { return this._state; }
    constructor(initialState) {
        this._state = initialState ?? "new";
    }
    setState(state) {
        if (this.trySetState(state))
            return;
        throw new Error(`Cannot transition to '${state}' state while in '${this._state}' state.`);
    }
    trySetState(state) {
        switch (state) {
            case "busy":
            case "impaired":
                if (this._state != "started")
                    return false;
                break;
            case "error":
                break;
            case "initialized":
                if (this._state != "new" && this._state != "initialized")
                    return false;
                break;
            case "started":
                if (this._state != "starting")
                    return false;
                break;
            case "starting":
                if (this._state != "initialized" && this._state != "stopped")
                    return false;
                break;
            case "stopped":
                if (this._state != "starting" && this._state != "stopping" && this._state != "initialized")
                    return false;
                break;
            case "stopping":
                if (this._state != "started")
                    return false;
                break;
            default:
                return false;
        }
        this._state = state;
        return true;
    }
}

let Manager$2 = class Manager {
    get connection() { return this._connection; }
    get eventLogger() { return this._eventLogger; }
    get attendeeId() { return this._attendeeId; }
    get tenantSettings() { return this._tenantSettings; }
    get connectionState() { return this._connection?.state ?? "new"; }
    get connectionStateChanged() { return this._connectionStateChanged; }
    get isBusy() { return this.state == "busy"; }
    get isError() { return this.state == "error"; }
    get isImpaired() { return this.state == "impaired"; }
    get isInitialized() { return this.state == "initialized"; }
    get isStarted() { return this.state == "started"; }
    get isStarting() { return this.state == "starting"; }
    get isStopped() { return this.state == "stopped" || this.state == "new"; }
    get isStopping() { return this.state == "stopping"; }
    get meetingId() { return this._meetingId; }
    get room() { return this._room; }
    get started() { return this._stateEvents.get("started"); }
    get starting() { return this._stateEvents.get("starting"); }
    get stopped() { return this._stateEvents.get("stopped"); }
    get stopping() { return this._stateEvents.get("stopping"); }
    get state() { return this._stateMachine.state; }
    get stateChanged() { return this._stateChanged; }
    get url() { return this._url; }
    constructor() {
        this._connectionStateChanged = new EventOwner();
        this._stateChanged = new EventOwnerAsync();
        this._stateEvents = new Map();
        this._stateMachine = new ManagerStateMachine();
        this._connection = null;
        this._stateEvents.set("busy", new EventOwnerAsync());
        this._stateEvents.set("error", new EventOwnerAsync());
        this._stateEvents.set("impaired", new EventOwnerAsync());
        this._stateEvents.set("initialized", new EventOwnerAsync());
        this._stateEvents.set("new", new EventOwnerAsync());
        this._stateEvents.set("started", new EventOwnerAsync());
        this._stateEvents.set("starting", new EventOwnerAsync());
        this._stateEvents.set("stopped", new EventOwnerAsync());
        this._stateEvents.set("stopping", new EventOwnerAsync());
    }
    initialize(init) {
        this._attendeeId = init.attendeeId;
        this._tenantSettings = init.tenantSettings;
        this._eventLogger = init.eventLogger;
        this._meetingId = init.meetingId;
        this._room = init.room;
        this._type = init.type;
        this._url = init.url;
        this._onConnectionStateChanged = this.onConnectionStateChanged.bind(Reactive.wrap(this));
        this.setState("initialized");
    }
    close(reason) {
        this._connection?.close(reason);
        this._connection?.stateChanged.unbind(this._onConnectionStateChanged);
        this.destroyConnection(this._connection);
        this._connection = null;
    }
    async open(abortSignal, retryCounter = 0) {
        try {
            const [createConnectionDuration, connection] = await Utility.time(() => this.createConnection());
            this._eventLogger.debug("open.initialized", `${this._type} connection created.`, createConnectionDuration);
            this._connection = connection;
            this._connection.requestTimeout = this.requestTimeout;
            if (retryCounter == 0)
                void this._eventLogger.debug("open", `Opening ${this._type} connection for attendee ${this._attendeeId} in meeting ${this._meetingId}...`);
            this._connection.stateChanged.bind(this._onConnectionStateChanged);
            const [openConnectionDuration] = await Utility.time(() => this._connection.open(abortSignal));
            this._eventLogger.debug("open.succeeded", `${this._type} connection opened.`, openConnectionDuration);
        }
        catch (error) {
            // handle abort signal
            if (abortSignal?.aborted)
                throw error;
            // handle retry exhaustion
            if (retryCounter >= this.maxRetries)
                throw error;
            // handle retry
            const delay = 200 * Math.pow(2, retryCounter);
            void this._eventLogger.warning(error, "open", `Reopening ${this._type} connection for attendee ${this._attendeeId} in meeting ${this._meetingId} after ${delay.toLocaleString()}ms...`);
            await Utility.delay(delay);
            await this.open(abortSignal, retryCounter + 1);
        }
    }
    onConnectionStateChanged(e) {
        this._connectionStateChanged.dispatch(e);
    }
    async setState(state) {
        const previousState = this._stateMachine.state;
        this._stateMachine.setState(state);
        const e = {
            manager: this,
            previousState: previousState,
            state: state,
        };
        await this._stateEvents.get(state).dispatch(e);
        await this._stateChanged.dispatch(e);
    }
    async onStarted() { }
    async onStarting() { }
    async onStopped() { }
    async onStopping() { }
    async start(abortSignal) {
        if (this.isStarted)
            return;
        try {
            await this.setState("starting");
            await this.onStarting();
            await this.open(abortSignal, 0);
            await this.setState("started");
            await this.onStarted();
        }
        catch (error) {
            await this.setState("stopped");
            await this.onStopped();
            throw error;
        }
    }
    async stop(reason) {
        reason ??= "Media has been disabled.";
        if (this.isInitialized || this.isStopped)
            return;
        try {
            await this.setState("stopping");
            await this.onStopping();
            this.close(reason);
        }
        finally {
            await this.setState("stopped");
            await this.onStopped();
        }
    }
    updateStats() {
        return this._connection?.updateStats();
    }
    async iceRestart() {
        await this.connection.iceRestart();
    }
};

let Client$3 = class Client {
    get maxRetries() { return this._httpClient.maxRetries; }
    set maxRetries(value) { this._httpClient.maxRetries = value; }
    get requestTimeout() { return this._httpClient.requestTimeout; }
    set requestTimeout(value) { this._httpClient.requestTimeout = value; }
    constructor(init) {
        Guard.isNotNullOrUndefined(init, "init");
        Guard.isNotNullOrUndefined(init.edgeServerUrl, "init.edgeServerUrl");
        Guard.isNotNullOrUndefined(init.meetingSession, "init.meetingSession");
        this._init = init;
        this._httpClient = HttpClient.withTokenFactory(async () => {
            const token = await this._init.meetingSession.token();
            return {
                baseUrl: new URL(this._init.edgeServerUrl).origin,
                value: token.value
            };
        });
    }
    static deflate(offer) {
        return Base64.encode(deflateRaw_1(new TextEncoder().encode(offer)));
    }
    async negotiate(request, abortSignal) {
        Guard.isNotNullOrUndefined(request, "request");
        Guard.isNotNullOrUndefined(request.offer, "request.offer");
        return (await this._httpClient.post("/negotiate", {
            audioLevelIntervalDisplay: request.audioLevelIntervalDisplay,
            audioLevelIntervalUser: request.audioLevelIntervalUser,
            compatibilityMode: request.compatibilityMode,
            degradationPreference: request.degradationPreference,
            discardAudio: request.discardAudio,
            discardVideo: request.discardVideo,
            localLoopbackAudio: request.localLoopbackAudio,
            localLoopbackVideo: request.localLoopbackVideo,
            maxAudibleDisplay: request.maxAudibleDisplay,
            maxAudibleUser: request.maxAudibleUser,
            maxVisibleDisplay: request.maxVisibleDisplay,
            maxVisibleUser: request.maxVisibleUser,
            offerDeflate: Client.deflate(request.offer),
            sdkVersion: version$1,
            synchronizeAudioMetadata: true,
        }, abortSignal)).value;
    }
    reassign(edgeServerUrl) {
        Guard.isNotNullOrUndefined(edgeServerUrl, "edgeServerUrl");
        this._init.edgeServerUrl = edgeServerUrl;
    }
    async renegotiate(request, abortSignal) {
        Guard.isNotNullOrUndefined(request, "request");
        Guard.isNotNullOrUndefined(request.offer, "request.offer");
        return (await this._httpClient.post("/renegotiate", {
            offerDeflate: Client.deflate(request.offer),
        }, abortSignal)).value;
    }
};

class DocumentObserver {
    static get shared() {
        if (!this._shared)
            this._shared = new DocumentObserver();
        return this._shared;
    }
    get audioElements() { return this._audioElements; }
    get isStarted() { return this._isStarted; }
    get isStopped() { return !this._isStarted; }
    get updated() { return this._updated; }
    get videoElements() { return this._videoElements; }
    constructor() {
        this._audioElementMap = new Map();
        this._updated = new EventOwner();
        this._videoElementMap = new Map();
        this._isStarted = false;
        this._audioElementCollection = document.getElementsByTagName("audio");
        this._videoElementCollection = document.getElementsByTagName("video");
        DocumentObserver.initialize(this._audioElementCollection, this._audioElementMap);
        DocumentObserver.initialize(this._videoElementCollection, this._videoElementMap);
        this._audioElements = Array.from(this._audioElementCollection);
        this._videoElements = Array.from(this._videoElementCollection);
        this._mutationCallback = this.mutationCallback.bind(Reactive.wrap(this));
        this._mutationObserver = new MutationObserver(this._mutationCallback);
    }
    static getId(element) {
        return element.__lsid ?? null;
    }
    static setId(element) {
        const id = Utility.generateGuid();
        element.__lsid = id;
        return id;
    }
    static getUpdate(collection, map) {
        for (const element of collection) {
            if (!this.getId(element))
                this.setId(element);
        }
        const collectionById = {};
        for (const element of collection)
            collectionById[this.getId(element)] = element;
        // remove old
        const removed = [];
        for (const elementId of map.keys()) {
            if (collectionById[elementId])
                continue;
            removed.push(map.get(elementId));
            map.delete(elementId);
        }
        // add new
        const added = [];
        for (const element of collection) {
            const elementId = this.getId(element);
            if (map.get(elementId))
                continue;
            added.push(element);
            map.set(elementId, element);
        }
        return { added, removed };
    }
    static initialize(collection, map) {
        for (const element of collection)
            map.set(this.setId(element), element);
    }
    mutationCallback() {
        const audioUpdate = DocumentObserver.getUpdate(this._audioElementCollection, this._audioElementMap);
        const videoUpdate = DocumentObserver.getUpdate(this._videoElementCollection, this._videoElementMap);
        if (audioUpdate.added.length == 0 && audioUpdate.removed.length == 0 && videoUpdate.added.length == 0 && videoUpdate.removed.length == 0)
            return;
        this._audioElements = Array.from(this._audioElementCollection);
        this._videoElements = Array.from(this._videoElementCollection);
        this._updated.dispatch({
            audio: audioUpdate,
            video: videoUpdate,
        });
    }
    start() {
        if (this._isStarted)
            return;
        this._mutationObserver.observe(document.body, {
            childList: true,
            subtree: true,
        });
        this._isStarted = true;
    }
    stop() {
        if (!this._isStarted)
            return;
        this._mutationObserver.disconnect();
        this._isStarted = false;
    }
}

class ElementObserver {
    get isStarted() { return this._isStarted; }
    get isStopped() { return !this._isStarted; }
    get updated() { return this._updated; }
    constructor(element) {
        this._updated = new EventOwner();
        this._isStarted = false;
        this._element = element;
        this._mutationCallback = this.mutationCallback.bind(Reactive.wrap(this));
        this._mutationObserver = new MutationObserver(this._mutationCallback);
    }
    mutationCallback() {
        this._updated.dispatch({
            element: this._element,
        });
    }
    /**
     * For testing only.
     */
    /** @internal */
    mutate() {
        this.mutationCallback();
    }
    start() {
        if (this._isStarted)
            return;
        this._mutationObserver.observe(this._element, {
            attributes: true,
            attributeFilter: ["srcObject"],
        });
        this._isStarted = true;
    }
    stop() {
        if (!this._isStarted)
            return;
        this._mutationObserver.disconnect();
        this._isStarted = false;
    }
}

class UserAudioTrack extends LocalAudioTrack {
    static get contentHint() { return this._contentHint; }
    static set contentHint(value) { this._contentHint = value; }
    get deviceId() { return this._deviceId; }
    get isMuted() { return this._isMuted; }
    get isPaused() { return this.media?.attendee?.isAudioPaused ?? false; }
    get requestedAutoGainControl() { return this._requestedAutoGainControl; }
    get requestedEchoCancellation() { return this._requestedEchoCancellation; }
    get requestedDeviceId() { return this._requestedDeviceId; }
    get requestedDeviceRequired() { return this._requestedDeviceRequired; }
    get requestedNoiseSuppression() { return this._requestedNoiseSuppression; }
    constructor() {
        super();
        this._deviceId = null;
        this._isMuted = false;
        this._requestedAutoGainControl = true;
        this._requestedDeviceId = null;
        this._requestedDeviceRequired = false;
        this._requestedEchoCancellation = true;
        this._requestedNoiseSuppression = true;
        this._timeToCheckStreamDeviceIdAfterInputsUpdated = 2000;
        this._onAudioInputsUpdated = this.onAudioInputsUpdated.bind(Reactive.wrap(this));
    }
    async onAudioInputsUpdated(e) {
        // if we have one added device, with no label, and 1 total device, we have a microphone but no permissions
        if (e.added.length && e.added[0].label == '' && DeviceManager.shared.audioInputs.length == 1) {
            // if track is started, prompt for permission in case
            if (this.isStarted && this.isInFallbackMode)
                await DeviceManager.shared.promptForAudioPermissions();
        }
        if (this._deviceId == "default" || e.removed.find(d => d.id == this._deviceId) || e.added.find(d => d.id == this._requestedDeviceId) || this._deviceId == null) {
            this._deviceId = null;
            try {
                await this.replaceStream();
                await this.updateDeviceId();
            }
            catch (error) {
                Log.warn("Could not replace audio stream after device change.", error);
            }
        }
        // Workaround for LS2-8943: on iOS, if you plug in a new headset, it will "hotswap" a the device into an existing stream. 
        // As such, after the device list changes, we will wait a certain time and then update the device id with the stream's device id
        if (Utility.isMobileBrowser() && Utility.isSafari()) {
            window.setTimeout(async () => {
                await this.updateDeviceId();
            }, this._timeToCheckStreamDeviceIdAfterInputsUpdated);
        }
    }
    async updateDeviceId() {
        if (!this.stream)
            return;
        this._deviceId = this._requestedDeviceId;
        const settings = this.stream.getSettings();
        if (!settings.deviceId)
            return;
        this._deviceId = settings.deviceId;
    }
    /** @internal */
    muteInternal() {
        this._isMuted = true;
        if (this.stream)
            this.stream.enabled = false;
    }
    /** @internal */
    unmuteInternal() {
        this._isMuted = false;
        if (this.stream)
            this.stream.enabled = true;
    }
    async onStarted() {
        await DeviceManager.shared.refresh();
        DeviceManager.shared.audioInputsUpdated.bind(this._onAudioInputsUpdated);
        await this.updateDeviceId();
    }
    async onStarting() {
        await DeviceManager.shared.start();
    }
    async onStopping() {
        DeviceManager.shared.audioInputsUpdated.unbind(this._onAudioInputsUpdated);
    }
    prepareStream(stream) {
        try {
            if ("contentHint" in stream)
                stream.contentHint = UserAudioTrack.contentHint;
        }
        catch { /* best effort */ }
    }
    getConstraints() {
        const constraints = super.getConstraints();
        constraints.autoGainControl = { ideal: this._requestedAutoGainControl };
        constraints.echoCancellation = { ideal: this._requestedEchoCancellation };
        constraints.noiseSuppression = { ideal: this._requestedNoiseSuppression };
        if (this._requestedDeviceId) {
            if (this._requestedDeviceRequired) {
                constraints.deviceId = { exact: this._requestedDeviceId };
            }
            else {
                constraints.deviceId = { ideal: this._requestedDeviceId };
            }
        }
        return constraints;
    }
    async mute() {
        const attendee = this.media.attendee;
        if (attendee)
            await attendee.muteAudio();
        else
            this.muteInternal();
    }
    async setAutoGainControl(autoGainControl) {
        if (this._requestedAutoGainControl == autoGainControl)
            return;
        this._requestedAutoGainControl = autoGainControl;
        await this.stream?.applyConstraints(this.getConstraints());
    }
    async setDevice(deviceId, required) {
        if (this._isSettingDevice) {
            Log.warn('Ignoring request to set audio device as a previous request is still in progress.');
            return;
        }
        this._isSettingDevice = true;
        try {
            this._deviceId = null;
            this._requestedDeviceId = deviceId ?? null;
            this._requestedDeviceRequired = required ?? false;
            await this.replaceStream();
            await this.updateDeviceId();
        }
        finally {
            this._isSettingDevice = false;
            if (this.stream && deviceId && deviceId != this._deviceId) {
                // warn if stream is running and switching devices didn't work
                Log.warn(`Could not set audio device to id of ${deviceId}. Current device id is ${this._deviceId}. Requested device may not support requested given constraints: ${JSON.stringify(this.getConstraints())}`);
            }
            else {
                Log.info(`Set audio device id to ${this._deviceId}.`);
            }
        }
    }
    async setEchoCancellation(echoCancellation) {
        if (this._requestedEchoCancellation == echoCancellation)
            return;
        this._requestedEchoCancellation = echoCancellation;
        await this.stream?.applyConstraints(this.getConstraints());
    }
    async setNoiseSuppression(noiseSuppression) {
        if (this._requestedNoiseSuppression == noiseSuppression)
            return;
        this._requestedNoiseSuppression = noiseSuppression;
        await this.stream?.applyConstraints(this.getConstraints());
    }
    async unmute() {
        const attendee = this.media.attendee;
        if (attendee)
            await attendee.unmuteAudio();
        else
            this.unmuteInternal();
    }
    async useNextDevice(manager) {
        manager ??= DeviceManager.shared;
        await manager.start();
        const devices = manager.audioInputs;
        const currentDeviceId = this._deviceId ?? this._requestedDeviceId;
        const device = devices.next(currentDeviceId);
        if (device == null || device.id == currentDeviceId)
            return;
        await this.setDevice(device.id, this._requestedDeviceRequired);
    }
    async usePreviousDevice(manager) {
        manager ??= DeviceManager.shared;
        await manager.start();
        const devices = manager.audioInputs;
        const currentDeviceId = this._deviceId ?? this._requestedDeviceId;
        const device = devices.previous(currentDeviceId);
        if (device == null || device.id == currentDeviceId)
            return;
        await this.setDevice(device.id, this._requestedDeviceRequired);
    }
}
UserAudioTrack._contentHint = "speech";

var _a;
class RemoteAudioTrack extends AudioTrack {
    static get canRequestDeviceId() { return this._canRequestDeviceId; }
    static set canRequestDeviceId(value) { this._canRequestDeviceId = value; }
    get deviceId() { return this._deviceId; }
    get isMuted() { return (this._media.type == "user" && this._media.attendee?.isAudioMuted) ?? false; }
    get isPaused() { return (this._media.type == "user" && this._media.attendee?.isAudioPaused) ?? false; }
    get isRemote() { return true; }
    get media() { return this._media; }
    get requestedDeviceId() { return this._requestedDeviceId; }
    get stream() { return this._stream; }
    /** @event */
    get statusUpdated() { return this._statusUpdated; }
    /** @event */
    get streamBound() { return this._streamBound; }
    /** @event */
    get streamUnbound() { return this._streamUnbound; }
    /** @internal */
    constructor(media) {
        super();
        this._statusUpdated = new EventOwnerAsync();
        this._streamBound = new EventOwnerAsync();
        this._streamUnbound = new EventOwner();
        this._unsupportedMessage = "The current platform does not support audio output device selection.";
        this._deviceId = null;
        this._requestedDeviceId = null;
        this._sinkId = null;
        this._stream = null;
        this._targetSinkId = null;
        this._media = media;
        if (!RemoteAudioTrack.canRequestDeviceId)
            return;
        this._onDevicesUpdated = this.onDevicesUpdated.bind(Reactive.wrap(this));
        this._onDocumentObserverUpdated = this.onDocumentObserverUpdated.bind(Reactive.wrap(this));
        this._onElementObserverUpdated = this.onElementObserverUpdated.bind(Reactive.wrap(this));
    }
    async bindStream(stream) {
        Guard.isNotNullOrUndefined(stream, "stream");
        this.prepareStream(stream);
        this._stream = stream;
        this._stream.enabled = !this.isMuted;
        await this._streamBound.dispatch({
            track: this
        });
    }
    getSinkId() {
        const audioOutputDevices = DeviceManager.shared.audioOutputs;
        if (audioOutputDevices.length == 0)
            return null;
        for (const audioOutputDevice of audioOutputDevices) {
            if (audioOutputDevice.id == this._requestedDeviceId)
                return audioOutputDevice.id;
        }
        return audioOutputDevices[0].id;
    }
    async onDevicesUpdated(e) {
        if (this._deviceId == "default" || e.removed.find(d => d.id == this._deviceId) || e.added.find(d => d.id == this._requestedDeviceId)) {
            this._deviceId = null;
            await this.updateMediaElements();
            this.updateDeviceId();
        }
    }
    onDocumentObserverUpdated(e) {
        for (const audioElement of e.audio.added)
            this.startObserving(audioElement);
        for (const videoElement of e.video.added)
            this.startObserving(videoElement);
        for (const audioElement of e.audio.removed)
            this.stopObserving(audioElement);
        for (const videoElement of e.video.removed)
            this.stopObserving(videoElement);
        void (async () => {
            await this.updateMediaElements();
            this.updateDeviceId();
        })();
    }
    onElementObserverUpdated(e) {
        if (e.element.srcObject != this._media.stream)
            return;
        void this.tryUpdateMediaElement(e.element);
    }
    startObserving(element) {
        const elementObserver = new ElementObserver(element);
        elementObserver.updated.bind(this._onElementObserverUpdated);
        elementObserver.start();
        this.onElementObserverUpdated({ element });
        element.__observer = elementObserver;
    }
    stopObserving(element) {
        const elementObserver = element.__observer;
        elementObserver?.stop();
        delete element.__observer;
    }
    async tryUpdateMediaElement(element) {
        const currentSinkId = element.sinkId ?? "default";
        if (currentSinkId == this._targetSinkId)
            return true;
        try {
            await element.setSinkId(this._targetSinkId);
            return true;
        }
        catch (error) {
            Log.info(`Could not set ${element.nodeName.toLowerCase()} element sink ID to ${this._targetSinkId}.`, error);
            return false;
        }
    }
    unbindStream() {
        this._stream = null;
        this._streamUnbound.dispatch({
            track: this
        });
    }
    updateDeviceId() {
        this._deviceId = this._sinkId;
    }
    async updateMediaElements() {
        this._sinkId = null;
        this._targetSinkId = this.getSinkId();
        if (this._targetSinkId == null)
            return;
        // Update all audio and video elements with the updated sinkId.
        // Note: There's a potential edge case here. Since all audio/video elements on the page are updated, an element rendering something other than liveswitch streams are also switched.
        // I can't think of a reason why you'd want different sink ids for the webrtc elements vs other elements, but if that use-case exists, you could implement an ignore list and filter out those elements. 
        const promises = [...DocumentObserver.shared.audioElements, ...DocumentObserver.shared.videoElements]
            .map(element => this.tryUpdateMediaElement(element));
        const results = await Promise.all(promises);
        if (results.filter(result => !result).length)
            return;
        this._sinkId = this._targetSinkId;
    }
    /**
     * For internal testing only.
     */
    /** @internal */
    getElementObserver(element) {
        return element.__observer;
    }
    /** @internal */
    processStatusUpdated() {
        return this._statusUpdated.dispatch({
            track: this,
        });
    }
    /** @internal */
    async start(stream) {
        await this.onStarting();
        await this.bindStream(stream);
        await this.onStarted();
    }
    /** @internal */
    stop() {
        this.onStopping();
        this.unbindStream();
        this.onStopped();
    }
    async onStarted() {
        if (!RemoteAudioTrack.canRequestDeviceId)
            return;
        DeviceManager.shared.audioOutputsUpdated.bind(this._onDevicesUpdated);
        DocumentObserver.shared.updated.bind(this._onDocumentObserverUpdated);
        await this.updateMediaElements();
        this.updateDeviceId();
    }
    async onStarting() {
        if (!RemoteAudioTrack.canRequestDeviceId)
            return;
        await DeviceManager.shared.start();
        DocumentObserver.shared.start();
    }
    onStopped() { }
    onStopping() {
        if (!RemoteAudioTrack.canRequestDeviceId)
            return;
        DocumentObserver.shared.updated.unbind(this._onDocumentObserverUpdated);
        DeviceManager.shared.audioOutputsUpdated.unbind(this._onDevicesUpdated);
    }
    prepareStream(stream) {
        if (this._media.type == "display") {
            try {
                if ("contentHint" in stream)
                    stream.contentHint = DisplayAudioTrack.contentHint;
            }
            catch { /* best effort */ }
        }
        else {
            try {
                if ("contentHint" in stream)
                    stream.contentHint = UserAudioTrack.contentHint;
            }
            catch { /* best effort */ }
        }
    }
    async setDevice(deviceId) {
        if (!RemoteAudioTrack.canRequestDeviceId) {
            Log.warn(this._unsupportedMessage);
            return;
        }
        this._deviceId = null;
        this._requestedDeviceId = deviceId ?? null;
        await this.updateMediaElements();
        this.updateDeviceId();
    }
    async useNextDevice(manager) {
        if (!RemoteAudioTrack.canRequestDeviceId)
            throw new Error(this._unsupportedMessage);
        manager ??= DeviceManager.shared;
        await manager.start();
        const currentDeviceId = this._deviceId ?? this._requestedDeviceId;
        const device = manager.audioOutputs.next(currentDeviceId);
        if (device == null || device.id == currentDeviceId)
            return;
        await this.setDevice(device.id);
    }
    async usePreviousDevice(manager) {
        if (!RemoteAudioTrack.canRequestDeviceId)
            throw new Error(this._unsupportedMessage);
        manager ??= DeviceManager.shared;
        await manager.start();
        const currentDeviceId = this._deviceId ?? this._requestedDeviceId;
        const device = manager.audioOutputs.previous(currentDeviceId);
        if (device == null || device.id == currentDeviceId)
            return;
        await this.setDevice(device.id);
    }
}
_a = RemoteAudioTrack;
(() => {
    _a._canRequestDeviceId = true;
    _a._canRequestDeviceId &&= !!(globalThis.document?.createElement("audio")?.setSinkId);
    _a._canRequestDeviceId &&= !!(globalThis.document?.createElement("video")?.setSinkId);
})();

class UserVideoTrack extends LocalVideoTrack {
    static get contentHint() {
        return this._contentHint;
    }
    static set contentHint(value) {
        this._contentHint = value;
    }
    get deviceId() {
        return this._deviceId;
    }
    get deviceLabel() {
        return this._deviceLabel;
    }
    get facingMode() {
        return this._facingMode;
    }
    get isMuted() {
        return this._isMuted;
    }
    get isPaused() {
        return this.media?.attendee?.isVideoPaused ?? false;
    }
    get requestedDeviceId() {
        return this._requestedDeviceId;
    }
    get requestedDeviceRequired() {
        return this._requestedDeviceRequired;
    }
    constructor() {
        super();
        this._deviceId = null;
        this._facingMode = null;
        this._isMuted = false;
        this._isSettingDevice = false;
        this._deviceLabel = null;
        this._requestedDeviceId = null;
        this._requestedDeviceRequired = false;
        this._onVideoInputsUpdated = this.onVideoInputsUpdated.bind(Reactive.wrap(this));
    }
    async onVideoInputsUpdated(e) {
        // if we have one added device, with no label, and 1 total device, we have a camera but no permissions
        if (e.added.length && e.added[0].label == "" && DeviceManager.shared.videoInputs.length == 1) {
            // if track is started, prompt for permission in case
            if (this.isStarted && this.isInFallbackMode)
                await DeviceManager.shared.promptForVideoPermissions();
        }
        if (this._deviceId == "default" ||
            e.removed.find((d) => d.id == this._deviceId) ||
            e.added.find((d) => d.id == this._requestedDeviceId) ||
            this._deviceId == null) {
            this.clearDeviceInfo();
            try {
                await this.replaceStream();
                this.updateDeviceInfo();
            }
            catch (error) {
                Log.warn("Could not replace video stream after device change.", error);
            }
        }
    }
    clearDeviceInfo() {
        this._deviceId = null;
        this._facingMode = null;
        this._deviceLabel = null;
    }
    updateDeviceInfo() {
        if (!this.stream)
            return;
        if (this.isInFallbackMode)
            return; // we dont want to set device details from canvas
        this._deviceId = this._requestedDeviceId;
        if (this.stream.label)
            this._deviceLabel = this.stream.label;
        const settings = this.stream.getSettings();
        if (settings.deviceId)
            this._deviceId = settings.deviceId;
        if (settings.facingMode)
            this._facingMode = settings.facingMode;
    }
    /** @internal */
    muteInternal() {
        this._isMuted = true;
        if (this.stream)
            this.stream.enabled = false;
    }
    /** @internal */
    unmuteInternal() {
        this._isMuted = false;
        if (this.stream)
            this.stream.enabled = true;
    }
    async onStarted() {
        await DeviceManager.shared.refresh();
        DeviceManager.shared.videoInputsUpdated.bind(this._onVideoInputsUpdated);
        this.updateDeviceInfo();
    }
    async onStarting() {
        await DeviceManager.shared.start();
    }
    async onStopping() {
        DeviceManager.shared.videoInputsUpdated.unbind(this._onVideoInputsUpdated);
    }
    prepareStream(stream) {
        try {
            if ("contentHint" in stream)
                stream.contentHint = UserVideoTrack.contentHint;
        }
        catch {
            /* best effort */
        }
    }
    getConstraints() {
        // the super pulls in the right values for framerate
        const constraints = super.getConstraints();
        // Assuming this is still needed
        if (this._requestedDeviceId) {
            if (this._requestedDeviceRequired) {
                constraints.deviceId = { exact: this._requestedDeviceId };
            }
            else {
                constraints.deviceId = { ideal: this._requestedDeviceId };
            }
        }
        return constraints;
    }
    async mute() {
        const attendee = this.media.attendee;
        if (attendee)
            await attendee.muteVideo();
        else
            this.muteInternal();
    }
    async setDevice(deviceId, required) {
        if (this._isSettingDevice) {
            Log.warn("Ignoring request to set video device as a previous request is still in progress.");
            return;
        }
        this._isSettingDevice = true;
        try {
            this._deviceId = null;
            this._requestedDeviceId = deviceId ?? null;
            this._requestedDeviceRequired = required ?? false;
            await this.replaceStream();
            this.updateDeviceInfo();
        }
        finally {
            this._isSettingDevice = false;
            if (this.stream && deviceId && deviceId != this._deviceId) {
                // warn if stream is running and switching devices didn't work
                Log.warn(`Could not set video device to id of ${deviceId}. Current device id is ${this._deviceId}. Requested device may not support requested given constraints: ${JSON.stringify(this.getConstraints())}`);
            }
            else {
                Log.info(`Set video device id to ${this._deviceId}.`);
            }
        }
    }
    async unmute() {
        const attendee = this.media.attendee;
        if (attendee)
            await attendee.unmuteVideo();
        else
            this.unmuteInternal();
    }
    async useNextDevice(manager) {
        manager ??= DeviceManager.shared;
        await manager.start();
        const devices = manager.videoInputs;
        const currentDeviceId = this._deviceId ?? this._requestedDeviceId;
        const device = devices.next(currentDeviceId);
        if (device == null || device.id == currentDeviceId)
            return;
        await this.setDevice(device.id, this._requestedDeviceRequired);
    }
    async usePreviousDevice(manager) {
        manager ??= DeviceManager.shared;
        await manager.start();
        const devices = manager.videoInputs;
        const currentDeviceId = this._deviceId ?? this._requestedDeviceId;
        const device = devices.previous(currentDeviceId);
        if (device == null || device.id == currentDeviceId)
            return;
        await this.setDevice(device.id, this._requestedDeviceRequired);
    }
}
UserVideoTrack._contentHint = "motion";

class RemoteVideoTrack extends VideoTrack {
    get isDisabled() { return this.status == "disabled"; }
    get isMuted() { return (this._media.type == "user" && this._media.attendee?.isVideoMuted) ?? false; }
    get isPaused() { return (this._media.type == "user" && this._media.attendee?.isVideoPaused) ?? false; }
    get isRemote() { return true; }
    get media() { return this._media; }
    get priority() {
        const trackIndex = this.getTrackIndex();
        if (Utility.isNullOrUndefined(trackIndex))
            return null;
        return this._media.connection.getTrackPriority(this._media.type, "video", trackIndex);
    }
    get spatialLayerIndex() {
        const trackIndex = this.getTrackIndex();
        if (Utility.isNullOrUndefined(trackIndex))
            return null;
        return this._media.connection.getTrackSpatialLayerIndex(this._media.type, "video", trackIndex);
    }
    get status() {
        const trackIndex = this.getTrackIndex();
        if (Utility.isNullOrUndefined(trackIndex))
            return null;
        return this._media.connection.getTrackStatus(this._media.type, "video", trackIndex);
    }
    get stream() { return this._stream; }
    get temporalLayerIndex() {
        const trackIndex = this.getTrackIndex();
        if (Utility.isNullOrUndefined(trackIndex))
            return null;
        return this._media.connection.getTrackTemporalLayerIndex(this._media.type, "video", trackIndex);
    }
    /** @event */
    get statusUpdated() { return this._statusUpdated; }
    /** @event */
    get streamBound() { return this._streamBound; }
    /** @event */
    get streamUnbound() { return this._streamUnbound; }
    /** @internal */
    constructor(media) {
        super();
        this._media = null;
        this._statusUpdated = new EventOwnerAsync();
        this._streamBound = new EventOwnerAsync();
        this._streamUnbound = new EventOwner();
        this._stream = null;
        this._media = media;
    }
    async bindStream(stream) {
        Guard.isNotNullOrUndefined(stream, "stream");
        this.prepareStream(stream);
        this._stream = stream;
        this._stream.enabled = !this.isMuted;
        await this._streamBound.dispatch({
            track: this
        });
    }
    getTrackIndex() {
        if (!Utility.isNullOrUndefined(this._media.videoTrackIndex))
            return this._media.videoTrackIndex;
        return this._media.linkedRemoteVideo?.videoTrackIndex;
    }
    unbindStream() {
        this._stream = null;
        this._streamUnbound.dispatch({
            track: this
        });
    }
    /** @internal */
    processStatusUpdated() {
        return this._statusUpdated.dispatch({
            track: this,
        });
    }
    /** @internal */
    async start(stream) {
        await this.onStarting();
        await this.bindStream(stream);
        await this.onStarted();
    }
    /** @internal */
    stop() {
        this.onStopping();
        this.unbindStream();
        this.onStopped();
    }
    async onStarted() { }
    async onStarting() { }
    onStopped() { }
    onStopping() { }
    prepareStream(stream) {
        if (this._media.type == "display") {
            try {
                if ("contentHint" in stream)
                    stream.contentHint = DisplayVideoTrack.contentHint;
            }
            catch { /* best effort */ }
        }
        else {
            try {
                if ("contentHint" in stream)
                    stream.contentHint = UserVideoTrack.contentHint;
            }
            catch { /* best effort */ }
        }
    }
    async setPriority(priority) {
        const trackIndex = this.getTrackIndex();
        if (Utility.isNullOrUndefined(trackIndex))
            return;
        await this._media.connection.setTrackPriority(priority, this._media.type, "video", trackIndex);
    }
}

class RemoteMedia extends Media {
    /** @internal */
    get audioTrackIndex() { return this._audioTrackIndex; }
    /** @internal */
    set audioTrackIndex(value) { this._audioTrackIndex = value; }
    /** @internal */
    get connection() { return this._connection; }
    /** @internal */
    get immutableAudioTrack() { return this._immutableAudioTrack; }
    /** @internal */
    get immutableVideoTrack() { return this._immutableVideoTrack; }
    /** @internal */
    get linkedLocalMedia() { return this._linkedLocalMedia; }
    /** @internal */
    set linkedLocalMedia(value) { this._linkedLocalMedia = value; }
    /** @internal */
    get linkedRemoteAudio() { return this._linkedRemoteAudio; }
    /** @internal */
    set linkedRemoteAudio(value) {
        if (this._linkedRemoteAudio == value)
            return;
        if (this._audioTrack?.stream)
            this.stream.removeTrack(this._audioTrack.stream);
        this._linkedRemoteAudio = value;
        this._audioTrack = value?.immutableAudioTrack ?? this._immutableAudioTrack;
        if (this._audioTrack?.stream)
            this.stream.addTrack(this._audioTrack.stream);
    }
    /** @internal */
    get linkedRemoteVideo() { return this._linkedRemoteVideo; }
    /** @internal */
    set linkedRemoteVideo(value) {
        if (this._linkedRemoteVideo == value)
            return;
        if (this._videoTrack?.stream)
            this.stream.removeTrack(this._videoTrack.stream);
        this._linkedRemoteVideo = value;
        this._videoTrack = value?.immutableVideoTrack ?? this._immutableVideoTrack;
        if (this._videoTrack?.stream)
            this.stream.addTrack(this._videoTrack.stream);
    }
    /** @internal */
    get videoTrackIndex() { return this._videoTrackIndex; }
    /** @internal */
    set videoTrackIndex(value) { this._videoTrackIndex = value; }
    get attendee() { return this._attendee; }
    get audioTrack() { return this._audioTrack; }
    get isRemote() { return this.attendee?.id != this._localAttendeeId; }
    get stream() { return this._stream; }
    get videoTrack() { return this._videoTrack; }
    /** @event */
    get attendeeBound() { return this._attendeeBound; }
    /** @event */
    get attendeeUnbound() { return this._attendeeUnbound; }
    /** @internal */
    constructor(connection, localAttendeeId, type) {
        super(type);
        this._attendeeBound = new EventOwnerAsync();
        this._attendeeUnbound = new EventOwner();
        this._attendee = null;
        this._audioTrackIndex = null;
        this._linkedLocalMedia = null;
        this._linkedRemoteAudio = null;
        this._linkedRemoteVideo = null;
        this._videoTrackIndex = null;
        this._connection = connection;
        this._audioTrack = this._immutableAudioTrack = new RemoteAudioTrack(this);
        this._videoTrack = this._immutableVideoTrack = new RemoteVideoTrack(this);
        this._localAttendeeId = localAttendeeId;
        this._stream = new MediaStream();
    }
    /** @internal */
    async bindAttendee(attendee) {
        Guard.isNotNullOrUndefined(attendee, "attendee");
        if (this._attendee == attendee)
            return;
        const previousAttendee = this._attendee;
        this._attendee = attendee;
        if (this._attendee.id != this._localAttendeeId && !Utility.isNullOrUndefined(this._videoTrackIndex) && this.type == "user")
            await this._attendee.bindMedia(this);
        await this._attendeeBound.dispatch({
            attendee: attendee,
            media: this,
            previousAttendee: previousAttendee,
        });
    }
    /** @internal */
    async startAudioStream(trackStream) {
        await this.immutableAudioTrack.start(trackStream);
        this.stream.addTrack(trackStream);
    }
    /** @internal */
    async startVideoStream(trackStream) {
        await this.immutableVideoTrack.start(trackStream);
        this.stream.addTrack(trackStream);
    }
    /** @internal */
    stopAudioStream() {
        const trackStream = this.immutableAudioTrack?.stream;
        if (!trackStream)
            return;
        this.stream.removeTrack(trackStream);
        this.immutableAudioTrack.stop();
    }
    /** @internal */
    stopVideoStream() {
        const trackStream = this.immutableVideoTrack?.stream;
        if (!trackStream)
            return;
        this.stream.removeTrack(trackStream);
        this.immutableVideoTrack.stop();
    }
    /** @internal */
    unbindAttendee() {
        if (!this._attendee)
            return;
        const previousAttendee = this._attendee;
        if (this._attendee.id != this._localAttendeeId && !Utility.isNullOrUndefined(this._videoTrackIndex) && this.type == "user")
            this._attendee.unbindMedia();
        this._attendee = null;
        this._attendeeUnbound.dispatch({
            attendee: null,
            media: this,
            previousAttendee: previousAttendee,
        });
    }
    async setAudioDevice(deviceId) {
        await this.audioTrack?.setDevice(deviceId);
    }
    async useNextAudioDevice() {
        await this.audioTrack?.useNextDevice();
    }
    async usePreviousAudioDevice() {
        await this.audioTrack?.usePreviousDevice();
    }
}

class RemoteMediaCollection extends ReadOnlyCollection {
    static get empty() { return this._empty; }
    constructor() {
        super(remoteMedia => remoteMedia.id);
        this._elementMapByAttendeeId = new Map();
        this._elementMapByDisplayAudioTrackIndex = new Map();
        this._elementMapByDisplayVideoTrackIndex = new Map();
        this._elementMapByUserAudioTrackIndex = new Map();
        this._elementMapByUserVideoTrackIndex = new Map();
        this._onRemoteMediaAttendeeBound = this.onRemoteMediaAttendeeBound.bind(Reactive.wrap(this));
        this._onRemoteMediaAttendeeUnbound = this.onRemoteMediaAttendeeUnbound.bind(Reactive.wrap(this));
    }
    getElementMapByTrackIndex(mediaType, trackType) {
        if (mediaType == "display") {
            if (trackType == "audio") {
                return this._elementMapByDisplayAudioTrackIndex;
            }
            return this._elementMapByDisplayVideoTrackIndex;
        }
        if (trackType == "audio") {
            return this._elementMapByUserAudioTrackIndex;
        }
        return this._elementMapByUserVideoTrackIndex;
    }
    async onRemoteMediaAttendeeBound(e) {
        this._elementMapByAttendeeId.delete(e.previousAttendee?.id);
        this._elementMapByAttendeeId.set(e.attendee?.id, e.media);
    }
    onRemoteMediaAttendeeUnbound(e) {
        this._elementMapByAttendeeId.delete(e.previousAttendee?.id);
    }
    /** @internal */
    getByAttendeeId(attendeeId) {
        if (this._elementMapByAttendeeId.has(attendeeId)) {
            return this._elementMapByAttendeeId.get(attendeeId);
        }
        return undefined;
    }
    /** @internal */
    getByTrackIndex(trackIndex, mediaType, trackType) {
        const elementMapByTrackIndex = this.getElementMapByTrackIndex(mediaType, trackType);
        if (elementMapByTrackIndex.has(trackIndex)) {
            return elementMapByTrackIndex.get(trackIndex);
        }
        return undefined;
    }
    /** @internal */
    removeAll() {
        const elements = super.removeAll();
        this._elementMapByAttendeeId.clear();
        this._elementMapByDisplayAudioTrackIndex.clear();
        this._elementMapByDisplayVideoTrackIndex.clear();
        this._elementMapByUserAudioTrackIndex.clear();
        this._elementMapByUserVideoTrackIndex.clear();
        elements.forEach(element => {
            element.attendeeBound.unbind(this._onRemoteMediaAttendeeBound);
            element.attendeeUnbound.unbind(this._onRemoteMediaAttendeeUnbound);
        });
        return elements;
    }
    /** @internal */
    tryAdd(element) {
        if (super.tryAdd(element)) {
            element.attendeeBound.bind(this._onRemoteMediaAttendeeBound);
            element.attendeeUnbound.bind(this._onRemoteMediaAttendeeUnbound);
            if (!Utility.isNullOrUndefined(element.attendee?.id)) {
                this._elementMapByAttendeeId.set(element.attendee?.id, element);
            }
            if (!Utility.isNullOrUndefined(element.audioTrackIndex)) {
                this.getElementMapByTrackIndex(element.type, "audio").set(element.audioTrackIndex, element);
            }
            if (!Utility.isNullOrUndefined(element.videoTrackIndex)) {
                this.getElementMapByTrackIndex(element.type, "video").set(element.videoTrackIndex, element);
            }
            return true;
        }
        return false;
    }
    /** @internal */
    tryRemove(key) {
        const element = super.get(key);
        if (super.tryRemove(key)) {
            if (!Utility.isNullOrUndefined(element.attendee?.id)) {
                this._elementMapByAttendeeId.delete(element.attendee?.id);
            }
            if (!Utility.isNullOrUndefined(element.audioTrackIndex)) {
                this.getElementMapByTrackIndex(element.type, "audio").delete(element.audioTrackIndex);
            }
            if (!Utility.isNullOrUndefined(element.videoTrackIndex)) {
                this.getElementMapByTrackIndex(element.type, "video").delete(element.videoTrackIndex);
            }
            element.attendeeBound.unbind(this._onRemoteMediaAttendeeBound);
            element.attendeeUnbound.unbind(this._onRemoteMediaAttendeeUnbound);
            return true;
        }
        return false;
    }
}
RemoteMediaCollection._empty = new RemoteMediaCollection();

//TODO: this should be a class and contain base functionality for managing each track
class Track {
}

class StatisticConnection {
    constructor() {
        this.AttendeeId = null;
        this.DeviceId = null;
        this.ServerId = null;
        this.MediaType = null;
        this.CreatedOn = null;
        //candidate-pair
        this.Pair_Id = null;
        this.Pair_State = null;
        this.Pair_Timestamp = null;
        this.Pair_IsNominated = null;
        this.Pair_BytesReceived = null;
        this.Pair_BytesSent = null;
        this.Pair_RoundTripTimeCurrent = null;
        this.Pair_RoundTripTimeTotal = null;
        this.Pair_AvailableOutgoing = null;
        this.Pair_RequestsReceived = null;
        this.Pair_RequestsSent = null;
        this.Pair_ResponsesReceived = null;
        this.Pair_ResponsesSent = null;
        this.Pair_ConsentRequestsSent = null;
        //remote-candidate
        this.Rmt_Id = null;
        this.Rmt_IsRemote = null;
        this.Rmt_Ip = null;
        this.Rmt_Port = null;
        this.Rmt_Protocol = null;
        this.Rmt_CandidateType = null;
        this.Rmt_IsDeleted = null;
        //local-candidate
        this.Lcl_Id = null;
        this.Lcl_IsRemote = null;
        this.Lcl_Ip = null;
        this.Lcl_Port = null;
        this.Lcl_Protocol = null;
        this.Lcl_CandidateType = null;
        this.Lcl_Deleted = null;
        this.Lcl_NetworkAdapterType = null;
        this.Lcl_NetworkType = null;
        //codec
        this.Codec_MimeType = null;
        this.Codec_Channels = null;
        this.Codec_ClockRate = null;
    }
}

class StatisticAudio {
    constructor() {
        // TODO: Use javascript naming conventions
        this.AttendeeId = null;
        this.OriginAttendeeId = null;
        this.DeviceId = null;
        this.ServerId = null;
        this.MediaType = null;
        this.TrackIndex = null;
        this.TrackMid = null;
        this.TrackIdentifier = null;
        this.TrackPriority = null;
        this.IsClient = null;
        this.IsDisabled = null;
        this.IsMuted = null;
        this.CreatedOn = null;
        this.Json = null;
        //constraints
        this.BitrateActual = null;
        this.BitrateAllocation = null;
        this.BitrateConstraint = null;
        this.BitrateEstimated = null;
        this.BitrateServer = null;
        this.FramerateActual = null;
        this.FramerateConstraint = null;
        this.FramerateEstimated = null;
        this.FramerateServer = null;
        //internal is omitted
        //media-source
        this.Src_AudioLevel = null;
        this.Src_TotalAudioEnergy = null;
        this.Src_TotalSamplesDuration = null;
        //inbound-rtp
        this.Rtp_Kind = null;
        this.Rtp_SSRC = null;
        this.Rtp_IsRemote = null;
        this.Rtp_FecPacketsDiscarded = null;
        this.Rtp_FecPacketsReceived = null;
        this.Rtp_PacketsDiscarded = null;
        this.Rtp_PacketsLost = null;
        this.Rtp_PacketsReceived = null;
        this.Rtp_BytesReceived = null;
        this.Rtp_HeaderBytesReceived = null;
        this.Rtp_Jitter = null;
        //outbound-rtp
        this.Rtp_PacketsSent = null;
        this.Rtp_RetransmittedPacketsSent = null;
        this.Rtp_BytesSent = null;
        this.Rtp_HeaderBytesSent = null;
        this.Rtp_RetransmittedBytesSent = null;
        this.Rtp_TotalPacketSendDelay = null;
        this.Rtp_NackCount = null;
        //remote-inbound-rtp
        this.Rtp_Timestamp = null;
        this.Rtp_RoundTripTime = null;
        this.Rtp_RoundTripTimeMeasurements = null;
        this.Rtp_RoundTripTimeTotal = null;
        //remote-outbound-rtp
        this.Rtp_ReportsSent = null;
        //track
        this.Track_Kind = null;
        this.Track_IsEnded = null;
        this.Track_IsDetached = null;
        this.Track_IsRemote = null;
        this.Track_JitterBufferDelay = null;
        this.Track_JitterBufferFlushes = null;
        this.Track_JitterBufferEmittedCount = null;
        this.Track_JitterBufferMinimumDelay = null;
        this.Track_JitterBufferTargetDelay = null;
        this.Track_TotalAudioEnergy = null;
        this.Track_TotalSamplesReceived = null;
        this.Track_TotalSamplesDuration = null;
        this.Track_ConcealedSamples = null;
        this.Track_SilentConcealedSamples = null;
        this.Track_ConcealmentEvents = null;
        this.Track_InsertedSamples = null;
        this.Track_RemovedSamples = null;
        this.Track_DelayedPacketOutageSamples = null;
        this.Track_RelativePacketArrivalDelay = null;
        this.Track_InterruptionCount = null;
        this.Track_TotalInterruptionDuration = null;
        //transport
        this.Transport_State = null;
        this.Transport_Timestamp = null;
        this.Transport_BytesSent = null;
        this.Transport_BytesReceived = null;
        this.Transport_PacketsSent = null;
        this.Transport_PacketsReceived = null;
        //codec
        this.Codec_MimeType = null;
        this.Codec_Channels = null;
        this.Codec_ClockRate = null;
        this.Codec_SdpFmtpLine = null;
        //media-playout
        this.Mpo_SynthSamplesDuration = null;
        this.Mpo_SynthSamplesEvents = null;
        this.Mpo_TotalPlayoutDelay = null;
        this.Mpo_TotalSamplesCount = null;
        this.Mpo_TotalSamplesDuration = null;
    }
}

class StatisticVideo {
    constructor() {
        // TODO: Use javascript naming conventions
        this.AttendeeId = null;
        this.OriginAttendeeId = null;
        this.DeviceId = null;
        this.ServerId = null;
        this.MediaType = null;
        this.TrackIndex = null;
        this.TrackMid = null;
        this.TrackIdentifier = null;
        this.TrackPriority = null;
        this.SpatialLayerIndex = null;
        this.TemporalLayerIndex = null;
        this.ResolutionHeight = null;
        this.ResolutionWidth = null;
        this.IsClient = null;
        this.IsDeactivated = null;
        this.IsDisabled = null;
        this.IsMuted = null;
        this.IsPaused = null;
        this.CreatedOn = null;
        this.Json = null;
        //constraints
        this.BitrateActual = null;
        this.BitrateAllocation = null;
        this.BitrateConstraint = null;
        this.BitrateEstimated = null;
        this.BitrateServer = null;
        this.FramerateActual = null;
        this.FramerateConstraint = null;
        this.FramerateEstimated = null;
        this.FramerateServer = null;
        this.PixelCountActual = null;
        this.PixelCountConstraint = null;
        this.PixelCountEstimated = null;
        this.PixelCountServer = null;
        //internal omitted
        //media-source
        this.Src_FramesPerSecond = null;
        this.Src_Frames = null;
        //inbound-rtp
        this.Rtp_Kind = null;
        this.Rtp_SSRC = null;
        this.Rtp_IsRemote = null;
        this.Rtp_FirCount = null;
        this.Rtp_PliCount = null;
        this.Rtp_NackCount = null;
        this.Rtp_PacketsReceived = null;
        this.Rtp_BytesReceived = null;
        this.Rtp_HeaderBytesReceived = null;
        this.Rtp_PacketsLost = null;
        this.Rtp_FramesAssembled = null;
        this.Rtp_FramesDecoded = null;
        this.Rtp_KeyFramesDecoded = null;
        this.Rtp_TotalAssemblyTime = null;
        this.Rtp_TotalDecodeTime = null;
        this.Rtp_TotalInterframeDelay = null;
        this.Rtp_TotalProcessingDelay = null;
        this.Rtp_DecoderImplementation = null;
        //remote-inbound-rtp
        this.Rtp_Timestamp = null;
        this.Rtp_Jitter = null;
        this.Rtp_RoundTripTime = null;
        this.Rtp_RoundTripTimeMeasurements = null;
        this.Rtp_RoundTripTimeTotal = null;
        //outbound-rtp
        this.Rtp_PacketsSent = null;
        this.Rtp_RetransmittedPacketsSent = null;
        this.Rtp_BytesSent = null;
        this.Rtp_HeaderBytesSent = null;
        this.Rtp_RetransmittedBytesSent = null;
        this.Rtp_FramesEncoded = null;
        this.Rtp_KeyFramesEncoded = null;
        this.Rtp_TotalEncodeTime = null;
        this.Rtp_TotalEncodedBytesTarget = null;
        this.Rtp_FramesPerSecond = null;
        this.Rtp_FramesSent = null;
        this.Rtp_HugeFramesSent = null;
        this.Rtp_TotalPacketSendDelay = null;
        this.Rtp_QualityLimitationChanges = null;
        this.Rtp_QualityLimitationDurations = null;
        this.Rtp_QualityLimitationReason = null;
        this.Rtp_EncoderImplementation = null;
        this.Rtp_QpSum = null;
        this.Rtp_IsPowerEfficient = null;
        this.Rtp_ScalabilityMode = null;
        this.Rtp_TargetBitrate = null;
        //track
        this.Track_Kind = null;
        this.Track_IsEnded = null;
        this.Track_IsDetached = null;
        this.Track_IsRemote = null;
        this.Track_JitterBufferDelay = null;
        this.Track_JitterBufferEmittedCount = null;
        this.Track_JitterBufferMinimumDelay = null;
        this.Track_JitterBufferTargetDelay = null;
        this.Track_FramesReceived = null;
        this.Track_FramesDecoded = null;
        this.Track_FramesDelivered = null;
        this.Track_FramesDiscarded = null;
        this.Track_FramesDropped = null;
        this.Track_FramesTotal = null;
        this.Track_FreezeCount = null;
        this.Track_PauseCount = null;
        this.Track_TotalFreezesDuration = null;
        this.Track_TotalPausesDuration = null;
        this.Track_TotalFramesDuration = null;
        this.Track_FrameHeight = null;
        this.Track_FrameWidth = null;
        this.Track_FramesSent = null;
        this.Track_HugeFramesSent = null;
        //transport
        this.Transport_State = null;
        this.Transport_Timestamp = null;
        this.Transport_BytesSent = null;
        this.Transport_BytesReceived = null;
        this.Transport_PacketsSent = null;
        this.Transport_PacketsReceived = null;
        //codec
        this.Codec_MimeType = null;
        this.Codec_Channels = null;
        this.Codec_ClockRate = null;
        this.Codec_SdpFmtpLine = null;
    }
    getKeyFrameRequestCount() {
        const value = (this.Rtp_FirCount || 0) + (this.Rtp_PliCount || 0);
        return value > 0 ? value : null;
    }
}

//KB: this class calculates a bitrate over successive timestamps
class Bitrate {
    constructor() {
        this._lastBitrate = null;
        this._lastBytesTransferred = 0;
        this._lastBytesTransferredTimestamp = null;
    }
    calculate(bytesTransferred, timestamp) {
        let bitrate = this._lastBitrate;
        if (this._lastBytesTransferredTimestamp) {
            const deltaBytes = bytesTransferred - this._lastBytesTransferred;
            const deltaSeconds = (timestamp - this._lastBytesTransferredTimestamp) / 1000;
            if (deltaSeconds == 0)
                return bitrate;
            bitrate = Math.ceil(deltaBytes * 8 / deltaSeconds / 1000);
        }
        this._lastBitrate = bitrate;
        this._lastBytesTransferred = bytesTransferred;
        this._lastBytesTransferredTimestamp = timestamp;
        return bitrate;
    }
}

//KB: this class calculates a framerate over successive timestamps
class Framerate {
    constructor() {
        this._lastFrameRate = null;
        this._lastFramesTransferred = 0;
        this._lastFramesTransferredTimestamp = null;
    }
    calculate(framesTransferred, timestamp) {
        let frameRate = this._lastFrameRate;
        if (this._lastFramesTransferredTimestamp) {
            const deltaFrames = framesTransferred - this._lastFramesTransferred;
            const deltaSeconds = (timestamp - this._lastFramesTransferredTimestamp) / 1000;
            if (deltaSeconds == 0)
                return frameRate;
            frameRate = Math.ceil(deltaFrames / deltaSeconds);
        }
        this._lastFrameRate = frameRate;
        this._lastFramesTransferred = framesTransferred;
        this._lastFramesTransferredTimestamp = timestamp;
        return frameRate;
    }
}

// the order here is important as it is the order in which the tracks are processed in the SDP
const mediaTypes$1 = ["display", "user"];
const trackTypes$1 = ["audio", "video"];
const payloadTypeAudioUpdatedDisplay = 2;
const payloadTypeAudioUpdatedUser = 3;
const payloadTypeAudioRemovedDisplay = 4;
const payloadTypeAudioRemovedUser = 5;
let Connection$1 = class Connection extends Connection$3 {
    get audioDeviceId() {
        for (const mediaType of mediaTypes$1) {
            for (const media of this.getMedias(mediaType, "audio")) {
                return media.immutableAudioTrack.deviceId;
            }
        }
        return undefined;
    }
    get mediaActivated() { return this._mediaActivated; }
    //public get mediaChannelStats(): DataChannelStats { return this._mediaChannelStats; }
    get mediaDeactivated() { return this._mediaDeactivated; }
    //public get mediaStats(): MediaStats { return this._mediaStats; }
    get requestedAudioDeviceId() {
        for (const mediaType of mediaTypes$1) {
            for (const media of this.getMedias(mediaType, "audio")) {
                return media.immutableAudioTrack.requestedDeviceId;
            }
        }
        return undefined;
    }
    //public get stats(): ConnectionStats { return this._stats; }
    get trackLayerUpdated() { return this._trackLayerUpdated; }
    get trackPriorityUpdated() { return this._trackPriorityUpdated; }
    get trackStatusUpdated() { return this._trackStatusUpdated; }
    constructor(init) {
        super({
            attendeeId: init.attendeeId,
            eventLogger: new Logger(init.apiClient, "EdgeConnection", init.attendeeId, init.meetingId, init.clusterId),
            iceRestartEnabled: init.iceRestartEnabled,
            iceReconnectionTimeout: init.iceReconnectionTimeout,
            meetingId: init.meetingId,
            redAudioEnabled: init.redAudioEnabled,
            turnRequired: init.turnRequired,
            turnSession: init.turnSession,
            type: "Edge",
        });
        this._mediaActivated = new EventOwner();
        this._mediaDeactivated = new EventOwner();
        this._mediaNotificationQueue = new DispatchQueue();
        this._medias = new Map();
        this._mediasActive = new Map();
        this._tracks = new Map();
        this._trackLayerUpdated = new EventOwner();
        this._trackPriorityUpdated = new EventOwner();
        this._trackStatusUpdated = new EventOwner();
        this._videoElements = globalThis.document?.getElementsByTagName("video");
        this._trackList = null;
        //TODO: these need to all be from settings
        this._bitrateDecreaseStep = 0.10;
        this._bitrateIncreaseStep = 0.10;
        this._degradationPreference = "both";
        this._healthyCheckThreshold = 10;
        this._packetLossThreshold = 0.05;
        this._unhealthyCheckThreshold = 3;
        this._healthyCounter = 0;
        this._openMediaIndex = 0;
        this._openMediaTypeIndex = 0;
        this._openTrackTypeIndex = 0;
        this._mediaChannelBytesReceived = 0;
        this._mediaChannelBytesSent = 0;
        this._unhealthyCounter = 0;
        this._statsBatchAudio = [];
        this._statsBatchVideo = [];
        this._statsPollingInterval = 1; //how often to save the stats
        this._statsBatchSize = 5; //how many saves before sending to server
        this._currentStatCount = 0;
        this._init = init;
        this._client = init.client;
        this._maxVisibleUser = init.maxVisibleUser;
        this._pixelFeedback = init.pixelFeedback;
        this._subscribedView = init.subscribedView;
        this._onAudioAttendeeBound = this.onAudioAttendeeBound.bind(Reactive.wrap(this));
        this._onAudioAttendeeUnbound = this.onAudioAttendeeUnbound.bind(Reactive.wrap(this));
        this._onMediaChannelClose = this.onMediaChannelClose.bind(Reactive.wrap(this));
        this._onMediaChannelClosing = this.onMediaChannelClosing.bind(Reactive.wrap(this));
        this._onMediaChannelError = this.onMediaChannelError.bind(Reactive.wrap(this));
        this._onMediaChannelMessage = this.onMediaChannelMessage.bind(Reactive.wrap(this));
        this._onMediaChannelOpen = this.onMediaChannelOpen.bind(Reactive.wrap(this));
        this._onTrack = this.onTrack.bind(Reactive.wrap(this));
        this._onVideoAttendeeBound = this.onVideoAttendeeBound.bind(Reactive.wrap(this));
        this._onVideoAttendeeUnbound = this.onVideoAttendeeUnbound.bind(Reactive.wrap(this));
        this._onVideoFrameSizeChanged = this.onVideoFrameSizeChanged.bind(Reactive.wrap(this));
        // Trigger a keyframe request when the client reconnects to prevent any additional artifacting
        this.stateChanged.bind((ev) => {
            if (ev.state === "connected" && ev.previousState === "reconnecting") {
                this.sendKeyFrameRequest();
            }
        });
        this._mediaChannel = this.connection.createDataChannel("media");
        this._mediaChannel.binaryType = "arraybuffer";
        this._statsBatchAudio = [];
        this._statsBatchVideo = [];
        this._trackList = [];
        for (const mediaType of mediaTypes$1) {
            this._medias.set(mediaType, new Map());
            this._mediasActive.set(mediaType, new Map());
            this._tracks.set(mediaType, new Map());
            for (const trackType of trackTypes$1) {
                const medias = new RemoteMediaCollection();
                const mediasActive = new RemoteMediaCollection();
                const tracks = [];
                this._medias.get(mediaType).set(trackType, medias);
                this._mediasActive.get(mediaType).set(trackType, mediasActive);
                this._tracks.get(mediaType).set(trackType, tracks);
                let count = 0;
                if (mediaType == "display" && trackType == "audio")
                    count = init.maxAudibleDisplay;
                if (mediaType == "display" && trackType == "video")
                    count = init.maxVisibleDisplay;
                if (mediaType == "user" && trackType == "audio")
                    count = init.maxAudibleUser;
                if (mediaType == "user" && trackType == "video")
                    count = init.maxVisibleUser;
                for (let i = 0; i < count; i++) {
                    const media = new RemoteMedia(Reactive.wrap(this), init.attendeeId, mediaType);
                    if (trackType == "audio") {
                        media.audioTrackIndex = i;
                        media.attendeeBound.bind(this._onAudioAttendeeBound);
                        media.attendeeUnbound.bind(this._onAudioAttendeeUnbound);
                        mediasActive.tryAdd(media); // audio is always active
                    }
                    if (trackType == "video") {
                        media.attendeeBound.bind(this._onVideoAttendeeBound);
                        media.attendeeUnbound.bind(this._onVideoAttendeeUnbound);
                        media.videoTrack.frameSizeChanged.bind(this._onVideoFrameSizeChanged);
                        media.videoTrackIndex = i;
                    }
                    const transceiver = this.connection.addTransceiver(trackType, { direction: "recvonly" });
                    const trk = new Track();
                    trk.status = "enabled";
                    trk.media = media;
                    trk.mediaType = mediaType;
                    trk.trackType = trackType;
                    trk.index = i;
                    trk.priority = "low";
                    trk.spatialLayerIndex = 0;
                    trk.temporalLayerIndex = 0;
                    trk.statAudio = new StatisticAudio();
                    trk.statVideo = new StatisticVideo();
                    trk.statPair = new StatisticConnection();
                    trk.bitrateAudio = new Bitrate();
                    trk.bitrateVideo = new Bitrate();
                    trk.framerateVideo = new Framerate();
                    trk.viewSize = { width: -1, height: -1 };
                    trk.transceiver = transceiver;
                    tracks.push(trk);
                    medias.tryAdd(media);
                    this._trackList.push(tracks[tracks.length - 1]);
                }
            }
        }
        this.attachEventHandlers();
    }
    static isHidden(element) {
        if (element.style.display == "none")
            return true;
        if (element.style.visibility == "hidden")
            return true;
        if (!Utility.isNullOrUndefined(element.style.opacity)) {
            const opacity = parseFloat(element.style.opacity);
            if (opacity <= 0.05)
                return true;
        }
        return false;
    }
    async activateMedia(media, mediaType, trackType, attendeeId, add) {
        const mediasActive = this.getMediasActive(mediaType, trackType);
        const existingMedia = mediasActive.getByAttendeeId(attendeeId);
        if (existingMedia)
            this.deactivateMedia(existingMedia, mediaType, trackType);
        const attendee = Utility.isReplicatedAttendeeId(attendeeId) ? null : await this._subscribedView.subscribeToAttendee(attendeeId, "visibleMedia");
        const previousAttendee = media.attendee;
        if (attendee)
            await media.bindAttendee(attendee);
        if (add)
            mediasActive.tryAdd(media);
        this._mediaActivated.dispatch({
            attendee: attendee,
            attendeeId: attendeeId,
            connection: this,
            media: media,
            mediaType: mediaType,
            previousAttendee: previousAttendee,
            previousAttendeeId: previousAttendee?.id,
            trackType: trackType,
        });
    }
    deactivateMedia(media, mediaType, trackType) {
        const oldAttendee = media.attendee;
        if (!oldAttendee)
            return;
        if (trackType == "video")
            this.getMediasActive(mediaType, trackType).tryRemove(media.id);
        media.unbindAttendee();
        this._mediaDeactivated.dispatch({
            attendee: oldAttendee,
            attendeeId: oldAttendee?.id,
            connection: this,
            media: media,
            mediaType: mediaType,
            trackType: trackType,
        });
        if (trackType == "video") {
            const track = this._tracks.get(mediaType).get(trackType).find(t => t.media == media);
            if (track) {
                track.spatialLayerIndex = 0;
                track.status = "enabled";
                track.temporalLayerIndex = 0;
                track.viewSize = { width: -1, height: -1 };
            }
        }
    }
    getNextRemoteMedia() {
        while (this._openMediaTypeIndex < mediaTypes$1.length) {
            const mediaType = mediaTypes$1[this._openMediaTypeIndex];
            const trackType = trackTypes$1[this._openTrackTypeIndex];
            const medias = this.getMedias(mediaType, trackType);
            if (this._openMediaIndex < medias.length)
                return medias[this._openMediaIndex++];
            this._openMediaIndex = 0;
            this._openTrackTypeIndex++;
            if (this._openTrackTypeIndex < trackTypes$1.length)
                continue;
            this._openTrackTypeIndex = 0;
            this._openMediaTypeIndex++;
        }
    }
    async onAudioAttendeeBound(e) {
        this.tryLinkAudio(e.media, e.attendee?.id);
    }
    onAudioAttendeeUnbound(e) {
        this.tryLinkAudio(e.media, e.attendee?.id);
    }
    onMediaChannelClose() {
        const message = "Edge connection media channel has closed.";
        void this.eventLogger.debug("onMediaChannelClose", message);
    }
    onMediaChannelClosing() {
        const message = "Edge connection media channel is closing.";
        void this.eventLogger.debug("onMediaChannelClosing", message);
    }
    onMediaChannelError(ev) {
        const errDetail = ev.error?.errorDetail ?? ev.error ?? "";
        const message = `Edge connection media channel has failed. ${errDetail}`;
        void this.eventLogger.debug("onMediaChannelError", message);
    }
    onMediaChannelMessage(ev) {
        const arrayBuffer = ev.data;
        this._mediaChannelBytesReceived += arrayBuffer.byteLength;
        const buffer = new Uint8Array(arrayBuffer);
        if (buffer.length == 0)
            return;
        const payloadType = buffer[0];
        //KB: in-progress deprecating
        /*
        if (payloadType == payloadTypeAudioLevelsDisplay || payloadType == payloadTypeAudioLevelsUser) {
          if (buffer.length % 2 != 1) return;
          const mediaType = payloadType == payloadTypeAudioLevelsDisplay ? "display" : "user";
          const mediasActive = this.getMediasActive(mediaType, "audio");
          for (let i = 1; i < buffer.length; i += 2) {
            const trackIndex = buffer[i];
            const audioLevel = buffer[i + 1] / 255;
            mediasActive.getByTrackIndex(trackIndex, mediaType, "audio")?.audioTrack?.updateLevel(audioLevel);
          }
        } else */ if (payloadType == payloadTypeAudioUpdatedDisplay || payloadType == payloadTypeAudioUpdatedUser) {
            const mediaType = payloadType == payloadTypeAudioUpdatedDisplay ? "display" : "user";
            const trackIndex = buffer[1];
            const attendeeId = Utility.parseGuid(buffer.subarray(2, 18));
            void this._mediaNotificationQueue.dispatch(async () => {
                try {
                    await this.tryActivateMedia(attendeeId, mediaType, "audio", trackIndex);
                }
                catch (error) {
                    if (this.state != "closed")
                        throw error;
                }
            });
        }
        else if (payloadType == payloadTypeAudioRemovedDisplay || payloadType == payloadTypeAudioRemovedUser) {
            const mediaType = payloadType == payloadTypeAudioRemovedDisplay ? "display" : "user";
            const trackIndex = buffer[1];
            const attendeeId = Utility.parseGuid(buffer.subarray(2, 18));
            void this._mediaNotificationQueue.dispatch(async () => {
                this.tryDeactivateMedia(attendeeId, mediaType, "audio", trackIndex);
            });
        }
        //else {
        //  void this.eventLogger.warning("onMediaChannelMessage", "Unexpected "${payloadType}" edge media notification.");
        //}
    }
    onMediaChannelOpen() {
        const message = "Edge connection media channel has opened.";
        void this.eventLogger.debug("onMediaChannelOpen", message);
    }
    onTrack(ev) {
        const track = ev.track;
        void this.eventLogger.verbose("onTrack", `Remote ${track.kind} track raised.`);
        void this.eventQueue.dispatch(async () => {
            const start = performance.now();
            const media = this.getNextRemoteMedia();
            if (track.kind == "audio") {
                await media.startAudioStream(track);
            }
            else {
                await media.startVideoStream(track);
            }
            void this.eventLogger.debug("onTrack", `Remote ${track.kind} track ${track.id} bound to remote ${media.type} media.`, performance.now() - start);
        });
    }
    async onVideoAttendeeBound(e) {
        this.tryLinkVideo(e.media, e.attendee?.id);
    }
    onVideoAttendeeUnbound(e) {
        this.tryLinkVideo(e.media, e.attendee?.id);
    }
    onVideoFrameSizeChanged(e) {
        if (e.track.media.attendee?.isLocal)
            return;
        const status = (e.frameSize.width == 1 && e.frameSize.height == 1) ? "disabled" : "enabled";
        const track = e.track;
        this.updateTrackStatus(status, track.media.type, "video", track.media.videoTrackIndex, true);
    }
    async tryActivateMedia(attendeeId, mediaType, trackType, trackIndex) {
        if (Utility.isFakeAttendeeId(attendeeId))
            attendeeId = null;
        const mediasActive = this.getMediasActive(mediaType, trackType);
        const media = mediasActive.getByTrackIndex(trackIndex, mediaType, trackType);
        if (media) {
            if (attendeeId == media.attendee?.id)
                return false;
            if (attendeeId) {
                await this.activateMedia(media, mediaType, trackType, attendeeId, false);
                return true;
            }
            if (media.attendee?.id) {
                this.deactivateMedia(media, mediaType, trackType);
                return true;
            }
            return false;
        }
        if (attendeeId) {
            // audio is always active, so trackType is 'video' here
            const media = this.getMedias(mediaType, trackType).getByTrackIndex(trackIndex, mediaType, trackType);
            if (!media)
                return false;
            await this.activateMedia(media, mediaType, trackType, attendeeId, true);
            return true;
        }
    }
    tryDeactivateMedia(attendeeId, mediaType, trackType, trackIndex) {
        if (Utility.isFakeAttendeeId(attendeeId))
            attendeeId = null;
        const mediasActive = this.getMediasActive(mediaType, trackType);
        const media = mediasActive.getByTrackIndex(trackIndex, mediaType, trackType);
        if (!media || !media.attendee?.id || media.attendee?.id != attendeeId)
            return false;
        this.deactivateMedia(media, mediaType, trackType);
        return true;
    }
    //private isHealthy(packetLoss: number): boolean {
    //  return packetLoss < this._packetLossThreshold;
    //}
    //private tryHealthCheck(): boolean {
    //  //let unhealthyCount = 0;
    //  //const trackStatsDisplay = this.getTrackReceiverStats("display", "video");
    //  //for (const trackStatDisplay of trackStatsDisplay) {
    //  //  if (this.isHealthy(trackStatDisplay.packetLoss)) continue;
    //  //  unhealthyCount++;
    //  //}
    //  //const trackStatsUser = this.getTrackReceiverStats("user", "video");
    //  //for (const trackStatUser of trackStatsUser) {
    //  //  if (this.isHealthy(trackStatUser.packetLoss)) continue;
    //  //  unhealthyCount++;
    //  //}
    //  //if (unhealthyCount == 0) {
    //  //  void this.eventLogger.verbose("tryHealthCheck", "All edge video tracks are healthy.");
    //  //  return this.tryHealthCheckIncrease();
    //  //}
    //  //void this.eventLogger.debug("tryHealthCheck", "Some edge video tracks (${unhealthyCount}) are unhealthy.");
    //  //return this.tryHealthCheckDecrease();
    //  return true;
    //}
    //private tryHealthCheckDecrease(): boolean {
    //  this._healthyCounter = 0;
    //  this._unhealthyCounter++;
    //  if (this._unhealthyCounter < this._unhealthyCheckThreshold) return false;
    //  this._unhealthyCounter = 0;
    //  this.decreaseBitrate();
    //  return true;
    //}
    //private tryHealthCheckIncrease(): boolean {
    //  this._unhealthyCounter = 0;
    //  this._healthyCounter++;
    //  if (this._healthyCounter < this._healthyCheckThreshold) return false;
    //  this._healthyCounter = 0;
    //  this.increaseBitrate();
    //  return true;
    //}
    tryLinkAudio(audioMedia, attendeeId) {
        if (audioMedia.linkedRemoteVideo) {
            audioMedia.linkedRemoteVideo.linkedRemoteAudio = null;
            audioMedia.linkedRemoteVideo = null;
        }
        if (!attendeeId)
            return false;
        const videoMedia = this.getMedias(audioMedia.type, "video").getByAttendeeId(attendeeId);
        if (!videoMedia)
            return false;
        audioMedia.linkedRemoteVideo = videoMedia;
        videoMedia.linkedRemoteAudio = audioMedia;
        return true;
    }
    tryLinkVideo(videoMedia, attendeeId) {
        if (videoMedia.linkedRemoteAudio) {
            videoMedia.linkedRemoteAudio.linkedRemoteVideo = null;
            videoMedia.linkedRemoteAudio = null;
        }
        if (!attendeeId)
            return false;
        const audioMedia = this.getMedias(videoMedia.type, "audio").getByAttendeeId(attendeeId);
        if (!audioMedia)
            return false;
        audioMedia.linkedRemoteVideo = videoMedia;
        videoMedia.linkedRemoteAudio = audioMedia;
        return true;
    }
    tryViewSizeUpdate() {
        if (!this._pixelFeedback)
            return false;
        if (!this._videoElements)
            return false;
        const videoElements = Array.from(this._videoElements);
        const viewSizes = {
            display: [],
            user: [],
        };
        const viewportHeight = Math.max(globalThis.document.documentElement.clientHeight, globalThis.window.innerHeight);
        const viewportWidth = Math.max(globalThis.document.documentElement.clientWidth, globalThis.window.innerWidth);
        for (const mediaType of mediaTypes$1) {
            const tracks = this.getTracks(mediaType, "video");
            for (const track of tracks) {
                if (!track.media.attendee)
                    continue;
                if (track.media.attendee.isLocal)
                    continue;
                const trackIndex = track.index;
                const viewSize = { trackIndex, width: 0, height: 0 };
                if (track.media.stream) {
                    const videoSizes = videoElements.filter(ve => ve.srcObject == track.media.stream).map(ve => {
                        if (Connection.isHidden(ve))
                            return { width: 0, height: 0, pixels: 0 };
                        let rect = ve.getBoundingClientRect();
                        let width = rect.width;
                        let height = rect.height;
                        if (width > 0 && height > 0) {
                            if (rect.top < 0)
                                height += rect.top;
                            if (rect.left < 0)
                                width += rect.left;
                            if (rect.bottom > viewportHeight)
                                height += viewportHeight - rect.bottom;
                            if (rect.right > viewportWidth)
                                width += viewportWidth - rect.right;
                            width = Math.round(Math.max(width, 0));
                            height = Math.round(Math.max(height, 0));
                        }
                        return { width, height, pixels: width * height };
                    });
                    if (videoSizes.length) {
                        videoSizes.sort((a, b) => b.pixels - a.pixels);
                        const [{ width, height }] = videoSizes;
                        viewSize.width = width;
                        viewSize.height = height;
                    }
                }
                if (track.viewSize.width == viewSize.width && track.viewSize.height == viewSize.height)
                    continue;
                viewSizes[mediaType].push(viewSize);
                track.viewSize = viewSize;
                //void this.eventLogger.debug("tryViewSizeUpdate", `View size of ${mediaType} video track ${trackIndex} updated to ${viewSize.width}x${viewSize.height}.`);
            }
        }
        if (!viewSizes.display.length && !viewSizes.user.length)
            return false;
        this.sendNotification({
            type: "viewSizesUpdated",
            viewSizes: viewSizes,
        });
        return true;
    }
    updateTrackLayer(spatialLayerIndex, temporalLayerIndex, mediaType, trackType, trackIndex) {
        const track = this._tracks.get(mediaType).get(trackType)[trackIndex];
        const media = this.getMedias(mediaType, trackType).getByTrackIndex(trackIndex, mediaType, trackType);
        let updated = false;
        if (!Utility.isNullOrUndefined(spatialLayerIndex) && spatialLayerIndex != track.spatialLayerIndex) {
            updated = true;
            track.spatialLayerIndex = spatialLayerIndex;
            //void this.eventLogger.debug("updateTrackLayer", `Spatial layer index of ${mediaType} ${trackType} track ${trackIndex + 1} updated to ${spatialLayerIndex}.`);
        }
        if (!Utility.isNullOrUndefined(temporalLayerIndex) && temporalLayerIndex != track.temporalLayerIndex) {
            updated = true;
            track.temporalLayerIndex = temporalLayerIndex;
            //void this.eventLogger.debug("updateTrackLayer", `Temporal layer index of ${mediaType} ${trackType} track ${trackIndex + 1} updated to ${temporalLayerIndex}.`);
        }
        if (!updated)
            return;
        this._trackLayerUpdated.dispatch({
            connection: this,
            media: media,
            mediaType: mediaType,
            track: track,
            trackIndex: trackIndex,
            trackType: trackType,
        });
    }
    updateTrackStatus(status, mediaType, trackType, trackIndex, inband) {
        const track = this._tracks.get(mediaType).get(trackType)[trackIndex];
        const media = track.media;
        //const media = this.getMedias(mediaType, trackType).getByTrackIndex(trackIndex, mediaType, trackType);
        if (status == track.status)
            return;
        track.status = status;
        /*void this.eventLogger.debug("updateTrackStatus", `Status of ${mediaType} ${trackType} track ${trackIndex + 1} updated to ${status}.`, undefined, {
          inband: inband ? "true" : "false"
        });*/
        this._trackStatusUpdated.dispatch({
            connection: this,
            media: media,
            mediaType: mediaType,
            track: track,
            trackIndex: trackIndex,
            trackType: trackType,
        });
    }
    attachEventHandlers() {
        super.attachEventHandlers();
        this.connection.addEventListener("track", this._onTrack);
        this._mediaChannel.addEventListener("close", this._onMediaChannelClose);
        this._mediaChannel.addEventListener("closing", this._onMediaChannelClosing);
        this._mediaChannel.addEventListener("error", this._onMediaChannelError);
        this._mediaChannel.addEventListener("message", this._onMediaChannelMessage);
        this._mediaChannel.addEventListener("open", this._onMediaChannelOpen);
    }
    detachEventHandlers() {
        this.connection.removeEventListener("track", this._onTrack);
        this._mediaChannel.removeEventListener("close", this._onMediaChannelClose);
        this._mediaChannel.removeEventListener("closing", this._onMediaChannelClosing);
        this._mediaChannel.removeEventListener("error", this._onMediaChannelError);
        this._mediaChannel.removeEventListener("message", this._onMediaChannelMessage);
        this._mediaChannel.removeEventListener("open", this._onMediaChannelOpen);
        super.detachEventHandlers();
    }
    async negotiate(offer, abortSignal) {
        const response = await this._client.negotiate({
            audioLevelIntervalDisplay: this._init.audioLevelIntervalDisplay,
            audioLevelIntervalUser: this._init.audioLevelIntervalUser,
            compatibilityMode: this._init.compatibilityMode,
            degradationPreference: this._degradationPreference,
            discardAudio: this._init.discardAudio,
            discardVideo: this._init.discardVideo,
            localLoopbackAudio: this._init.localLoopbackAudio,
            localLoopbackVideo: this._init.localLoopbackVideo,
            maxAudibleUser: this.getMedias("user", "audio").count,
            maxAudibleDisplay: this.getMedias("display", "audio").count,
            maxVisibleUser: this.getMedias("user", "video").count,
            maxVisibleDisplay: this.getMedias("display", "video").count,
            offer: offer,
        }, abortSignal);
        if (!Utility.isNullOrUndefined(response.answer))
            return response.answer;
        if (Utility.isNullOrUndefined(response.serverUrl))
            throw new Error(`Unexpected response from edge server: ${JSON.stringify(response)}`);
        this._client.reassign(response.serverUrl);
        return await this.negotiate(offer, abortSignal);
    }
    async onOpening() {
        await super.onOpening();
        this._openMediaIndex = 0;
        this._openMediaTypeIndex = 0;
        this._openTrackTypeIndex = 0;
    }
    onTerminating() {
        for (const mediaType of mediaTypes$1) {
            for (const trackType of trackTypes$1) {
                const mediasActive = this.getMediasActive(mediaType, trackType);
                for (let i = mediasActive.length - 1; i >= 0; i--) {
                    this.deactivateMedia(mediasActive[i], mediaType, trackType);
                }
            }
            for (const media of this.getMedias(mediaType, "audio"))
                media.stopAudioStream();
            for (const media of this.getMedias(mediaType, "video"))
                media.stopVideoStream();
        }
        super.onTerminating();
    }
    onTerminated() {
        this._answerUpdated?.reject("Connection closed.");
        super.onTerminated();
    }
    processNotification(notification) {
        if (notification.type == "answerUpdated") {
            if (this._answerUpdated)
                this._answerUpdated.resolve(notification);
        }
        else if (notification.type == "layerUpdated") {
            void this._mediaNotificationQueue.dispatch(async () => {
                this.updateTrackLayer(notification.spatialLayerIndex, notification.temporalLayerIndex, notification.mediaType, notification.trackType, notification.trackIndex);
            });
        }
        else if (notification.type == "mediaUpdated" && notification.trackType != "audio") {
            void this._mediaNotificationQueue.dispatch(async () => {
                try {
                    await this.tryActivateMedia(notification.attendeeId, notification.mediaType, notification.trackType, notification.trackIndex);
                }
                catch (error) {
                    if (this.state != "closed")
                        throw error;
                }
            });
        }
        else if (notification.type == "mediaRemoved" && notification.trackType != "audio") {
            void this._mediaNotificationQueue.dispatch(async () => {
                this.tryDeactivateMedia(notification.attendeeId, notification.mediaType, notification.trackType, notification.trackIndex);
            });
        }
        else if (notification.type == "statusUpdated") {
            void this._mediaNotificationQueue.dispatch(async () => {
                this.updateTrackStatus(notification.status, notification.mediaType, notification.trackType, notification.trackIndex, false);
            });
        }
        else {
            void this.eventLogger.warning("processNotification", `Unexpected [${notification.type}] edge notification.`);
        }
    }
    async renegotiate(offer, abortSignal) {
        return (await this._client.renegotiate({
            offer: offer,
        }, abortSignal)).answer;
    }
    getExcludedIceCandidates() {
        return [];
    }
    /** @internal */
    getMedias(mediaType, trackType) {
        Guard.isNotNullOrUndefined(mediaType, "mediaType");
        Guard.isNotNullOrUndefined(trackType, "trackType");
        return this._medias.get(mediaType).get(trackType);
    }
    /** @internal */
    getMediasActive(mediaType, trackType) {
        Guard.isNotNullOrUndefined(mediaType, "mediaType");
        Guard.isNotNullOrUndefined(trackType, "trackType");
        return this._mediasActive.get(mediaType).get(trackType);
    }
    /** @internal */
    getTracks(mediaType, trackType) {
        Guard.isNotNullOrUndefined(mediaType, "mediaType");
        Guard.isNotNullOrUndefined(trackType, "trackType");
        return this._tracks.get(mediaType).get(trackType);
    }
    /** @internal */
    getTrackReceivers(mediaType, trackType) {
        Guard.isNotNullOrUndefined(mediaType, "mediaType");
        Guard.isNotNullOrUndefined(trackType, "trackType");
        return this._tracks.get(mediaType).get(trackType).map(x => x.transceiver.receiver);
    }
    decreaseBitrate(step) {
        this.sendNotification({
            bitrateStep: Math.max(0, Math.min(1, step ?? this._bitrateDecreaseStep)),
            type: "bitrateDecrease",
        });
    }
    sendKeyFrameRequest() {
        this.sendNotification({
            type: "keyFrameRequested",
            attendeeId: this.attendeeId
        });
    }
    getTrackPriority(mediaType, trackType, trackIndex) {
        Guard.isNotNullOrUndefined(mediaType, "mediaType");
        Guard.isNotNullOrUndefined(trackType, "trackType");
        Guard.isNotNullOrUndefined(trackType, "trackIndex");
        const tracks = this._tracks.get(mediaType).get(trackType);
        Guard.isGreaterThanOrEqualTo(trackIndex, 0, "trackIndex");
        Guard.isLessThan(trackIndex, tracks.length, "trackIndex");
        return tracks[trackIndex].priority;
    }
    getTrackSpatialLayerIndex(mediaType, trackType, trackIndex) {
        Guard.isNotNullOrUndefined(mediaType, "mediaType");
        Guard.isNotNullOrUndefined(trackType, "trackType");
        Guard.isNotNullOrUndefined(trackType, "trackIndex");
        const tracks = this._tracks.get(mediaType).get(trackType);
        Guard.isGreaterThanOrEqualTo(trackIndex, 0, "trackIndex");
        Guard.isLessThan(trackIndex, tracks.length, "trackIndex");
        return tracks[trackIndex].spatialLayerIndex;
    }
    getTrackStatus(mediaType, trackType, trackIndex) {
        Guard.isNotNullOrUndefined(mediaType, "mediaType");
        Guard.isNotNullOrUndefined(trackType, "trackType");
        Guard.isNotNullOrUndefined(trackType, "trackIndex");
        const tracks = this._tracks.get(mediaType).get(trackType);
        Guard.isGreaterThanOrEqualTo(trackIndex, 0, "trackIndex");
        Guard.isLessThan(trackIndex, tracks.length, "trackIndex");
        return tracks[trackIndex].status;
    }
    getTrackTemporalLayerIndex(mediaType, trackType, trackIndex) {
        Guard.isNotNullOrUndefined(mediaType, "mediaType");
        Guard.isNotNullOrUndefined(trackType, "trackType");
        Guard.isNotNullOrUndefined(trackType, "trackIndex");
        const tracks = this._tracks.get(mediaType).get(trackType);
        Guard.isGreaterThanOrEqualTo(trackIndex, 0, "trackIndex");
        Guard.isLessThan(trackIndex, tracks.length, "trackIndex");
        return tracks[trackIndex].temporalLayerIndex;
    }
    //public increaseBitrate(step?: number): void {
    //  this.sendNotification({
    //    bitrateStep: Math.max(0, Math.min(1, step ?? this._bitrateIncreaseStep)),
    //    type: "bitrateIncrease",
    //  });
    //}
    async setAudioDevice(deviceId) {
        for (const mediaType of mediaTypes$1) {
            for (const media of this.getMedias(mediaType, "audio")) {
                await media.immutableAudioTrack.setDevice(deviceId);
            }
        }
    }
    setMaxVisibleUser(maxVisibleUser) {
        Guard.isNotNullOrUndefined(maxVisibleUser, "maxVisibleUser");
        return this.eventQueue.dispatch(async () => {
            const maxVisibleUserUpdated = Math.min(maxVisibleUser, this.getMedias("user", "video").length);
            if (maxVisibleUserUpdated == this._maxVisibleUser)
                return;
            this._maxVisibleUser = maxVisibleUserUpdated;
            void this.eventLogger.debug("setMaxVisibleUser", `Setting max visible user media to ${maxVisibleUserUpdated}.`);
            this.sendNotification({
                type: "videoCountsUpdated",
                userVideoCount: maxVisibleUserUpdated
            });
        });
    }
    async setTrackPriority(priority, mediaType, trackType, trackIndex) {
        Guard.isNotNullOrUndefined(priority, "priority");
        Guard.isNotNullOrUndefined(mediaType, "mediaType");
        Guard.isNotNullOrUndefined(trackType, "trackType");
        Guard.isNotNullOrUndefined(trackType, "trackIndex");
        const tracks = this._tracks.get(mediaType).get(trackType);
        Guard.isGreaterThanOrEqualTo(trackIndex, 0, "trackIndex");
        Guard.isLessThan(trackIndex, tracks.length, "trackIndex");
        const track = tracks[trackIndex];
        const media = this.getMedias(mediaType, trackType).getByTrackIndex(trackIndex, mediaType, trackType);
        Guard.isNotNullOrUndefined(media, "media");
        return this.eventQueue.dispatch(async () => {
            if (priority == track.priority)
                return;
            track.priority = priority;
            void this.eventLogger.debug("setTrackPriority", `Setting priority of ${mediaType} ${trackType} track ${trackIndex + 1} to ${priority}.`);
            this.sendNotification({
                type: "priorityUpdated",
                priority: priority,
                mediaType: mediaType,
                trackType: trackType,
                trackIndex: trackIndex,
            });
            this._trackPriorityUpdated.dispatch({
                connection: this,
                media: media,
                mediaType: mediaType,
                track: track,
                trackIndex: trackIndex,
                trackType: trackType,
            });
        });
    }
    async useNextAudioDevice() {
        for (const mediaType of mediaTypes$1) {
            for (const media of this.getMedias(mediaType, "audio")) {
                await media.immutableAudioTrack.useNextDevice();
            }
        }
    }
    async usePreviousAudioDevice() {
        for (const mediaType of mediaTypes$1) {
            for (const media of this.getMedias(mediaType, "audio")) {
                await media.immutableAudioTrack.usePreviousDevice();
            }
        }
    }
    async updateStats() {
        if (this.isTerminated)
            return;
        //TODO: defensive cof
        for (const trk of this._trackList) {
            //void this.eventLogger.debug("updateStats", "Track ${trk.index} type = ${trk.trackType}.");
            //requires attribution
            if ((trk.media != null) && (trk.media.attendee != null)) {
                //void this.eventLogger.debug("updateStats", "Track ${trk.index} type = ${trk.trackType} for attendee ${trk.media.attendee?.id} on client attendee ${this.attendeeId}.");
                //don't collect info about my own track, unless we're using loopback
                if (this.attendeeId != trk.media.attendee?.id || this._init.localLoopbackVideo || this._init.localLoopbackAudio) {
                    const receiver = trk.transceiver?.receiver;
                    //no track, not bouund
                    if (receiver.track != null) {
                        // void this.eventLogger.debug("updateStats", "Track ${trk.index} type = ${trk.trackType} receiver ${receiver.track.kind}.");
                        //pull receiver stats
                        const statReport = await receiver.getStats();
                        const pairStat = new StatisticConnection();
                        pairStat.AttendeeId = this.attendeeId;
                        //first collect pair details
                        for (const [key, value] of statReport.entries()) {
                            if (value.type == "candidate-pair") {
                                pairStat.Pair_Timestamp = value.timestamp;
                                pairStat.Pair_BytesReceived = value.bytesReceived;
                                pairStat.Pair_BytesSent = value.bytesSent;
                                pairStat.Pair_RoundTripTimeCurrent = value.currentRoundTripTime;
                                pairStat.Pair_RoundTripTimeTotal = value.totalRoundTripTime;
                                pairStat.Pair_AvailableOutgoing = Math.round(value.availableOutgoingBitrate);
                                pairStat.Pair_RequestsReceived = value.requestsReceived;
                                pairStat.Pair_RequestsSent = value.requestsSent;
                                pairStat.Pair_ResponsesReceived = value.responsesReceived;
                                pairStat.Pair_ResponsesSent = value.responsesSent;
                                pairStat.Pair_ConsentRequestsSent = value.consentRequestsSent;
                                pairStat.Pair_IsNominated = value.nominated;
                            }
                            if (value.type == "remote-candidate") {
                                pairStat.Rmt_IsRemote = value.isRemote;
                                pairStat.Rmt_Ip = value.ip;
                                pairStat.Rmt_Port = value.port;
                                pairStat.Rmt_Protocol = value.protocol;
                                pairStat.Rmt_CandidateType = value.candidateType;
                                pairStat.Rmt_IsDeleted = value.deleted;
                            }
                            if (value.type == "local-candidate") {
                                pairStat.Lcl_IsRemote = value.isRemote;
                                pairStat.Lcl_Ip = value.ip;
                                pairStat.Lcl_Port = value.port;
                                pairStat.Lcl_Protocol = value.protocol;
                                pairStat.Lcl_CandidateType = value.candidateType;
                                pairStat.Lcl_Deleted = value.deleted;
                                pairStat.Lcl_NetworkAdapterType = value.networkAdapterType;
                                pairStat.Lcl_NetworkType = value.networkType;
                            }
                            if (!pairStat.Lcl_NetworkType && pairStat.Lcl_Ip) {
                                const candidate = this._currentIceCandidates.find(x => x.address == pairStat.Lcl_Ip);
                                if (candidate) {
                                    if (candidate.wifiCandidate) {
                                        pairStat.Lcl_NetworkAdapterType = "wifi";
                                        pairStat.Lcl_NetworkType = "wifi";
                                    }
                                    else if (candidate.lanCandidate) {
                                        pairStat.Lcl_NetworkAdapterType = "lan";
                                        pairStat.Lcl_NetworkType = "lan";
                                    }
                                    else {
                                        pairStat.Lcl_NetworkAdapterType = "cellular";
                                        pairStat.Lcl_NetworkType = "cellular";
                                    }
                                }
                            }
                        } //each entry
                        if (receiver.track.kind == "audio") {
                            const audioStat = new StatisticAudio();
                            audioStat.AttendeeId = this.attendeeId;
                            audioStat.OriginAttendeeId = trk.media.attendee?.id;
                            //NOTE: on server: Attendee.DeviceId;
                            audioStat.MediaType = trk.mediaType;
                            audioStat.CreatedOn = new Date();
                            audioStat.TrackIndex = trk.index;
                            audioStat.TrackPriority = trk.priority;
                            audioStat.IsClient = true;
                            audioStat.IsMuted = receiver.track.muted;
                            //TODO: IsNoiseSuppressed = _isAudioNoiseSuppressed;
                            //TODO: IsPaused = _isAudioPaused;
                            //TODO: BitrateAllocation, BitrateEstimated, BitrateConstraint, BitrateServer
                            //TODO: FramerateConstraint, FramerateEstimated, FramerateServer
                            for (const [key, value] of statReport.entries()) {
                                if (value.type == "media-source") {
                                    if (audioStat.Src_AudioLevel == null) {
                                        audioStat.Src_AudioLevel = value.audioLevel;
                                    }
                                    if (audioStat.Src_TotalAudioEnergy == null) {
                                        audioStat.Src_TotalAudioEnergy = value.totalAudioEnergy;
                                    }
                                    audioStat.Src_TotalSamplesDuration = value.totalSamplesDuration;
                                }
                                if (value.type == "media-playout") {
                                    audioStat.Mpo_SynthSamplesDuration = value.synthesizedSamplesDuration;
                                    audioStat.Mpo_SynthSamplesEvents = value.synthesizedSamplesEvents;
                                    audioStat.Mpo_TotalPlayoutDelay = value.totalPlayoutDelay;
                                    audioStat.Mpo_TotalSamplesCount = value.totalSamplesCount;
                                    audioStat.Mpo_TotalSamplesDuration = value.totalSamplesDuration;
                                }
                                if (value.type == "codec") {
                                    audioStat.Codec_MimeType = value.mimeType;
                                    audioStat.Codec_Channels = value.channels;
                                    audioStat.Codec_ClockRate = value.clockRate;
                                }
                                if (value.type == "inbound-rtp") {
                                    audioStat.Rtp_Kind = value.kind;
                                    audioStat.Rtp_SSRC = value.ssrc;
                                    audioStat.Rtp_Timestamp = value.timestamp;
                                    audioStat.TrackIdentifier = value.trackIdentifier;
                                    audioStat.TrackMid = value.mid;
                                    if (audioStat.Src_AudioLevel == null) {
                                        audioStat.Src_AudioLevel = value.audioLevel;
                                    }
                                    if (audioStat.Src_TotalAudioEnergy == null) {
                                        audioStat.Src_TotalAudioEnergy = value.totalAudioEnergy;
                                    }
                                    audioStat.Rtp_PacketsDiscarded = value.packetsDiscarded;
                                    audioStat.Rtp_PacketsLost = value.packetsLost;
                                    audioStat.Rtp_PacketsReceived = value.packetsReceived;
                                    audioStat.Rtp_BytesReceived = value.bytesReceived;
                                    audioStat.Rtp_HeaderBytesReceived = value.headerBytesReceived;
                                    audioStat.Rtp_FecPacketsReceived = value.fecPacketsReceived;
                                    audioStat.Rtp_FecPacketsDiscarded = value.fecPacketsDiscarded;
                                    audioStat.Rtp_Jitter = Math.round(value.jitter * 1000);
                                    if (audioStat.Track_InsertedSamples == null)
                                        audioStat.Track_InsertedSamples = value.insertedSamplesForDeceleration;
                                    if (audioStat.Track_ConcealedSamples == null)
                                        audioStat.Track_ConcealedSamples = value.concealedSamples;
                                    if (audioStat.Track_ConcealmentEvents == null)
                                        audioStat.Track_ConcealmentEvents = value.concealmentEvents;
                                    if (audioStat.Track_JitterBufferDelay == null)
                                        audioStat.Track_JitterBufferDelay = Math.round(value.jitterBufferDelay);
                                    if (audioStat.Track_JitterBufferEmittedCount == null)
                                        audioStat.Track_JitterBufferEmittedCount = value.jitterBufferEmittedCount;
                                    if (audioStat.Track_JitterBufferMinimumDelay == null)
                                        audioStat.Track_JitterBufferMinimumDelay = value.jitterBufferMinimumDelay;
                                    if (audioStat.Track_JitterBufferTargetDelay == null)
                                        audioStat.Track_JitterBufferTargetDelay = value.jitterBufferTargetDelay;
                                    if (audioStat.Track_SilentConcealedSamples == null)
                                        audioStat.Track_SilentConcealedSamples = value.silentConcealedSamples;
                                    if (audioStat.Track_RemovedSamples == null)
                                        audioStat.Track_RemovedSamples = value.removedSamplesForAcceleration;
                                    if (audioStat.Track_TotalSamplesReceived == null)
                                        audioStat.Track_TotalSamplesReceived = value.totalSamplesReceived;
                                    if (audioStat.Track_TotalSamplesDuration == null)
                                        audioStat.Track_TotalSamplesDuration = value.totalSamplesDuration;
                                    audioStat.BitrateActual = trk.bitrateAudio.calculate(audioStat.Rtp_BytesReceived, value.timestamp);
                                }
                                if (value.type == "remote-outbound-rtp") {
                                    audioStat.Rtp_ReportsSent = value.reportsSent;
                                    audioStat.Rtp_RoundTripTimeMeasurements = value.roundTripTimeMeasurements;
                                    audioStat.Rtp_RoundTripTime = value.totalRoundTripTime;
                                }
                                if (value.type == "track") {
                                    audioStat.Track_Kind = value.kind;
                                    audioStat.Track_IsEnded = value.ended;
                                    audioStat.Track_IsDetached = value.Track_IsDetached;
                                    audioStat.Track_IsRemote = value.remoteSource;
                                    if (audioStat.Track_TotalAudioEnergy == null) {
                                        audioStat.Track_TotalAudioEnergy = value.totalAudioEnergy;
                                    }
                                    if (audioStat.Track_InsertedSamples == null)
                                        audioStat.Track_InsertedSamples = value.insertedSamplesForDeceleration;
                                    if (audioStat.Track_ConcealedSamples == null)
                                        audioStat.Track_ConcealedSamples = value.concealedSamples;
                                    if (audioStat.Track_ConcealmentEvents == null)
                                        audioStat.Track_ConcealmentEvents = value.concealmentEvents;
                                    if (audioStat.Track_JitterBufferDelay == null)
                                        audioStat.Track_JitterBufferDelay = value.jitterBufferDelay;
                                    if (audioStat.Track_JitterBufferEmittedCount == null)
                                        audioStat.Track_JitterBufferEmittedCount = value.jitterBufferEmittedCount;
                                    if (audioStat.Track_JitterBufferMinimumDelay == null)
                                        audioStat.Track_JitterBufferMinimumDelay = value.jitterBufferMinimumDelay;
                                    if (audioStat.Track_JitterBufferTargetDelay == null)
                                        audioStat.Track_JitterBufferTargetDelay = value.jitterBufferTargetDelay;
                                    if (audioStat.Track_SilentConcealedSamples == null)
                                        audioStat.Track_SilentConcealedSamples = value.silentConcealedSamples;
                                    if (audioStat.Track_RemovedSamples == null)
                                        audioStat.Track_RemovedSamples = value.removedSamplesForAcceleration;
                                    if (audioStat.Track_TotalSamplesReceived == null)
                                        audioStat.Track_TotalSamplesReceived = value.totalSamplesReceived;
                                    if (audioStat.Track_TotalSamplesDuration == null)
                                        audioStat.Track_TotalSamplesDuration = value.totalSamplesDuration;
                                    if (audioStat.Track_InterruptionCount == null)
                                        audioStat.Track_InterruptionCount = value.interruptionCount;
                                    if (audioStat.Track_TotalInterruptionDuration == null)
                                        audioStat.Track_TotalInterruptionDuration = value.totalInterruptionDuration;
                                }
                                if (value.type == "transport") {
                                    audioStat.Transport_Timestamp = value.timestamp;
                                    audioStat.Transport_BytesSent = value.bytesSent;
                                    audioStat.Transport_BytesReceived = value.bytesReceived;
                                    audioStat.Transport_PacketsSent = value.packetsSent;
                                    audioStat.Transport_PacketsReceived = value.packetsReceived;
                                    audioStat.Transport_State = value.dtlsState;
                                }
                            } //foreach entry
                            //update internal values for state logic
                            if (trk.media.audioTrack != null) {
                                trk.media.audioTrack.updateStats(audioStat, pairStat);
                                //NOTE: tied to msg deprecation
                                if (audioStat.Src_AudioLevel != null) {
                                    trk.media.audioTrack.updateLevel(audioStat.Src_AudioLevel);
                                }
                            }
                            //only save the stat every polling interval
                            if ((this._statsPollingInterval % this._currentStatCount) == 0) {
                                const sectionsAudio = [];
                                for (const stats of statReport.values()) {
                                    if ((stats.type != "certificate") && (stats.type != "candidate-pair") && (stats.type != "local-candidate") && (stats.type != "remote-candidate")) {
                                        //NOTE: debugging only, makes huge results
                                        //sectionsAudio.push(stats);
                                        sectionsAudio.push(stats.type);
                                    }
                                }
                                audioStat.Json = JSON.stringify(sectionsAudio, null, 2);
                                this._statsBatchAudio.push(audioStat);
                            }
                        } //audio
                        if (receiver.track.kind == "video") {
                            const videoStat = new StatisticVideo();
                            videoStat.AttendeeId = this.attendeeId;
                            videoStat.OriginAttendeeId = trk.media.attendee?.id;
                            //NOTE: on server: Attendee.DeviceId;
                            videoStat.MediaType = trk.mediaType;
                            videoStat.CreatedOn = new Date();
                            videoStat.TrackIndex = trk.index;
                            videoStat.TrackPriority = trk.priority;
                            videoStat.SpatialLayerIndex = trk.spatialLayerIndex;
                            videoStat.TemporalLayerIndex = trk.temporalLayerIndex;
                            videoStat.PixelCountEstimated = trk.viewSize.height * trk.viewSize.width;
                            videoStat.IsClient = true;
                            videoStat.IsMuted = receiver.track.muted;
                            videoStat.IsDisabled = !receiver.track.enabled;
                            //TODO: BitrateAllocation, BitrateConstraint, BitrateEstimated, BitrateServer
                            //TODO: FramerateConstraint, FrameEstimated, FramerateServer
                            //TODO: PixelCountConstraint, PixelCountEstimated, PixelCountServer
                            for (const [key, value] of statReport.entries()) {
                                if (value.type == "codec") {
                                    videoStat.Codec_MimeType = value.mimeType;
                                    videoStat.Codec_Channels = value.channels;
                                    videoStat.Codec_ClockRate = value.clockRate;
                                }
                                if (value.type == "inbound-rtp") {
                                    videoStat.Rtp_Kind = value.kind;
                                    videoStat.Rtp_SSRC = value.ssrc;
                                    videoStat.Rtp_IsRemote = value.isRemote;
                                    videoStat.Rtp_Timestamp = value.timestamp;
                                    videoStat.TrackIdentifier = value.trackIdentifier;
                                    videoStat.TrackMid = value.mid;
                                    videoStat.Rtp_Jitter = Math.round(value.jitter * 1000);
                                    videoStat.Rtp_PacketsLost = value.packetsLost;
                                    videoStat.Rtp_PacketsReceived = value.packetsReceived;
                                    videoStat.Rtp_BytesReceived = value.bytesReceived;
                                    videoStat.Rtp_FirCount = value.firCount;
                                    videoStat.Rtp_PliCount = value.pliCount;
                                    videoStat.Rtp_NackCount = value.nackCount;
                                    videoStat.Track_PauseCount = value.pauseCount;
                                    videoStat.Track_FrameHeight = value.frameHeight;
                                    videoStat.Track_FrameWidth = value.frameWidth;
                                    if (videoStat.ResolutionHeight == null)
                                        videoStat.ResolutionHeight = value.frameHeight;
                                    if (videoStat.ResolutionWidth == null)
                                        videoStat.ResolutionWidth = value.frameWidth;
                                    videoStat.Rtp_FramesAssembled = value.framesAssembledFromMultiplePackets;
                                    videoStat.Rtp_FramesDecoded = value.framesDecoded;
                                    videoStat.Track_FramesDecoded = value.framesDecoded;
                                    videoStat.Track_FramesDropped = value.framesDropped;
                                    videoStat.Rtp_FramesPerSecond = value.framesPerSecond;
                                    videoStat.Track_FramesReceived = value.framesReceived;
                                    videoStat.Track_FreezeCount = value.freezeCount;
                                    videoStat.Rtp_KeyFramesDecoded = value.keyFramesDecoded;
                                    videoStat.Rtp_BytesReceived = value.bytesReceived;
                                    videoStat.Rtp_HeaderBytesReceived = value.headerBytesReceived;
                                    videoStat.Rtp_TotalAssemblyTime = value.totalAssemblyTime;
                                    videoStat.Rtp_TotalDecodeTime = value.totalDecodeTime;
                                    videoStat.Track_TotalFreezesDuration = value.totalFreezesDuration;
                                    videoStat.Track_TotalPausesDuration = value.totalPausesDuration;
                                    videoStat.Rtp_TotalInterframeDelay = value.totalInterFrameDelay;
                                    videoStat.Rtp_TotalProcessingDelay = value.totalProcessingDelay;
                                    videoStat.Rtp_QpSum = value.qpSum;
                                    videoStat.Rtp_IsPowerEfficient = value.powerEfficientDecoder;
                                    videoStat.Rtp_DecoderImplementation = value.decoderImplementation;
                                    videoStat.Track_JitterBufferDelay = value.jitterBufferDelay;
                                    videoStat.Track_JitterBufferEmittedCount = value.jitterBufferEmittedCount;
                                    videoStat.Track_JitterBufferMinimumDelay = value.jitterBufferMinimumDelay;
                                    videoStat.Track_JitterBufferTargetDelay = value.jitterBufferTargetDelay;
                                    videoStat.BitrateActual = trk.bitrateVideo.calculate(videoStat.Rtp_BytesReceived, value.timestamp);
                                    if (videoStat.FramerateActual == null) {
                                        if (value.framesPerSecond) {
                                            videoStat.FramerateActual = value.framesPerSecond;
                                        }
                                        else {
                                            videoStat.FramerateActual = trk.framerateVideo.calculate(videoStat.Track_FramesReceived, value.timestamp);
                                        }
                                    }
                                }
                                if (value.type == "transport") {
                                    videoStat.Transport_Timestamp = value.timestamp;
                                    videoStat.Transport_BytesSent = value.bytesSent;
                                    videoStat.Transport_BytesReceived = value.bytesReceived;
                                    videoStat.Transport_PacketsSent = value.packetsSent;
                                    videoStat.Transport_PacketsReceived = value.packetsReceived;
                                    videoStat.Transport_State = value.dtlsState;
                                }
                                if (value.type == "media-source") {
                                    videoStat.Src_FramesPerSecond = value.framesPerSecond;
                                    videoStat.Src_Frames = value.frames;
                                    if (videoStat.ResolutionHeight == null)
                                        videoStat.ResolutionHeight = value.height;
                                    if (videoStat.ResolutionWidth == null)
                                        videoStat.ResolutionWidth = value.width;
                                }
                            } //foreach entry
                            //aggregates
                            if (videoStat.ResolutionHeight == null) {
                                videoStat.ResolutionHeight = videoStat.Track_FrameHeight;
                            }
                            if (videoStat.ResolutionWidth == null) {
                                videoStat.ResolutionWidth = videoStat.Track_FrameWidth;
                            }
                            if ((videoStat.ResolutionHeight != null) && (videoStat.ResolutionWidth != null)) {
                                videoStat.PixelCountActual = videoStat.ResolutionHeight * videoStat.ResolutionWidth;
                            }
                            //only capture for "active" tracks ?? possibly value.bytesReceived also?
                            if (videoStat.Rtp_Timestamp != null) {
                                //NOTE: for local debugging
                                //void this.eventLogger.debug("edge.updateStats", "VideoTrack", 0,{
                                //  "currentStatCount": this._currentStatCount,
                                //  "originAttendeeId": videoStat.OriginAttendeeId,
                                //  "trk.index": trk.index,
                                //  "trk.priority": trk.priority,
                                //  "receiver.track.enabled": "" + receiver.track.enabled,
                                //  "receiver.track.muted": "" + receiver.track.muted
                                //});
                                //update internal values for state logic
                                if (trk.media.videoTrack != null) {
                                    trk.media.videoTrack.updateStats(videoStat, pairStat);
                                }
                                //only save the stat every polling interval
                                if ((this._statsPollingInterval % this._currentStatCount) == 0) {
                                    const sectionsVideo = [];
                                    for (const stats of statReport.values()) {
                                        if ((stats.type != "certificate") && (stats.type != "candidate-pair") && (stats.type != "local-candidate") && (stats.type != "remote-candidate")) {
                                            //NOTE: debugging only, makes huge results
                                            //sectionsVideo.push(stats);
                                            sectionsVideo.push(stats.type);
                                        }
                                    }
                                    videoStat.Json = JSON.stringify(sectionsVideo, null, 2);
                                    this._statsBatchVideo.push(videoStat);
                                }
                            } //only "active"
                        } //video
                        this._currentStatCount++;
                        //push on batch size
                        if (this._currentStatCount >= this._statsBatchSize) {
                            const batchAudio = this._statsBatchAudio.splice(0);
                            const batchVideo = this._statsBatchVideo.splice(0);
                            this.sendNotification({
                                type: "clientStats",
                                audioStatsDeflate: Utility.deflate(JSON.stringify(batchAudio)),
                                videoStatsDeflate: Utility.deflate(JSON.stringify(batchVideo)),
                            });
                            this._currentStatCount = 0;
                        } //send batch
                    } //enabled
                } //no reason to stat self
            } //has origin
        } //foreach sender
    } //updateStats
};

let Manager$1 = class Manager extends Manager$2 {
    get audioDeviceId() { return this.connection?.audioDeviceId ?? null; }
    get maxRetries() { return this._client.maxRetries; }
    set maxRetries(value) { this._client.maxRetries = value; }
    get requestedAudioDeviceId() { return this.connection?.requestedAudioDeviceId ?? this._requestedAudioDeviceId ?? null; }
    get requestTimeout() { return this._client.requestTimeout; }
    set requestTimeout(value) { this._client.requestTimeout = value; }
    constructor() {
        super();
        this._audibleMedias = new Map();
        this._localMedias = new Map();
        this._visibleMedias = new Map();
        this._requestedAudioDeviceId = null;
    }
    init(init) {
        super.initialize({
            attendeeId: init.attendeeId,
            eventLogger: new Logger(init.apiClient, "EdgeManager", init.attendeeId, init.meetingId, init.clusterId),
            meetingId: init.meetingId,
            redAudioEnabled: init.redAudioEnabled,
            type: "edge",
            url: init.edgeServerUrl
        });
        this._init = init;
        this._client = new Client$3(init);
        this._audibleMedias.set("display", init.audibleDisplayMedias);
        this._audibleMedias.set("user", init.audibleUserMedias);
        this._localLoopbackAudio = init.localLoopbackAudio;
        this._localLoopbackVideo = init.localLoopbackVideo;
        this._visibleMedias.set("display", init.visibleDisplayMedias);
        this._visibleMedias.set("user", init.visibleUserMedias);
        this._onAudibleDisplayMediaAdded = this.onAudibleDisplayMediaAdded.bind(Reactive.wrap(this));
        this._onAudibleDisplayMediaRemoved = this.onAudibleDisplayMediaRemoved.bind(Reactive.wrap(this));
        this._onAudibleUserMediaAdded = this.onAudibleUserMediaAdded.bind(Reactive.wrap(this));
        this._onAudibleUserMediaRemoved = this.onAudibleUserMediaRemoved.bind(Reactive.wrap(this));
        this._onMediaActivated = this.onMediaActivated.bind(Reactive.wrap(this));
        this._onMediaDeactivated = this.onMediaDeactivated.bind(Reactive.wrap(this));
        this._onTrackStatusUpdated = this.onTrackStatusUpdated.bind(Reactive.wrap(this));
        this._onVisibleDisplayMediaAdded = this.onVisibleDisplayMediaAdded.bind(Reactive.wrap(this));
        this._onVisibleDisplayMediaRemoved = this.onVisibleDisplayMediaRemoved.bind(Reactive.wrap(this));
        this._onVisibleUserMediaAdded = this.onVisibleUserMediaAdded.bind(Reactive.wrap(this));
        this._onVisibleUserMediaRemoved = this.onVisibleUserMediaRemoved.bind(Reactive.wrap(this));
    }
    onAudibleDisplayMediaAdded(e) {
        this._audibleMedias.get("display").tryAdd(e.element);
    }
    onAudibleDisplayMediaRemoved(e) {
        this._audibleMedias.get("display").tryRemove(e.element.id);
    }
    onAudibleUserMediaAdded(e) {
        this._audibleMedias.get("user").tryAdd(e.element);
    }
    onAudibleUserMediaRemoved(e) {
        this._audibleMedias.get("user").tryRemove(e.element.id);
    }
    onMediaActivated(e) {
        if (e.trackType == "video")
            this.tryLinkLocalMedia(e.media);
        if (e.previousAttendeeId)
            void this.eventLogger?.debug("onEdgeMediaActivated", `Attendee ${e.attendeeId} ${e.mediaType} ${e.trackType} has activated in place of ${e.previousAttendeeId}.`);
        else
            void this.eventLogger?.debug("onEdgeMediaActivated", `Attendee ${e.attendeeId} ${e.mediaType} ${e.trackType} has activated.`);
    }
    onMediaDeactivated(e) {
        if (e.trackType == "video")
            this.tryUnlinkLocalMedia(e.media);
        void this.eventLogger?.debug("onEdgeMediaDeactivated", `Attendee ${e.attendeeId} ${e.mediaType} ${e.trackType} has deactivated.`);
    }
    onTrackStatusUpdated(e) {
        if (e.trackType == "audio")
            return;
        if (e.track.status == "disabled")
            this.tryUnlinkLocalMedia(e.media);
        else if (e.track.status == "enabled")
            this.tryLinkLocalMedia(e.media);
    }
    onVisibleDisplayMediaAdded(e) {
        this._visibleMedias.get("display").tryAdd(e.element);
    }
    onVisibleDisplayMediaRemoved(e) {
        this._visibleMedias.get("display").tryRemove(e.element.id);
    }
    onVisibleUserMediaAdded(e) {
        this._visibleMedias.get("user").tryAdd(e.element);
    }
    onVisibleUserMediaRemoved(e) {
        this._visibleMedias.get("user").tryRemove(e.element.id);
    }
    tryLinkLocalMedia(remoteMedia) {
        if (this._localLoopbackVideo)
            return;
        if (remoteMedia.attendee?.id == this.attendeeId) {
            const localMedia = this._localMedias.get(remoteMedia.type);
            if (!localMedia)
                return;
            const visibleMedias = this._visibleMedias.get(remoteMedia.type);
            for (const visibleMedia of visibleMedias) {
                if (visibleMedia.id != remoteMedia.id)
                    continue;
                void this.eventLogger?.debug("tryLinkLocalMedia", `Replacing remote ${remoteMedia.type} media with local ${localMedia.type} media...`);
                remoteMedia.linkedLocalMedia = localMedia;
                visibleMedias.tryRemove(remoteMedia.id);
                visibleMedias.tryAdd(localMedia);
            }
        }
        else if (remoteMedia.linkedLocalMedia) {
            this.tryUnlinkLocalMedia(remoteMedia);
        }
        else {
            const visibleMedias = this._visibleMedias.get(remoteMedia.type);
            if (!visibleMedias.containsKey(remoteMedia.id)) {
                void this.eventLogger?.debug("tryLinkLocalMedia", `Adding remote ${remoteMedia.type} media...`);
                visibleMedias.tryAdd(remoteMedia);
            }
        }
    }
    tryUnlinkLocalMedia(remoteMedia) {
        if (this._localLoopbackVideo)
            return;
        if (!remoteMedia.linkedLocalMedia)
            return;
        const localMedia = this._localMedias.get(remoteMedia.type);
        if (!localMedia)
            return;
        if (remoteMedia.linkedLocalMedia == localMedia) {
            const visibleMedias = this._visibleMedias.get(remoteMedia.type);
            if (remoteMedia.attendee?.id) {
                void this.eventLogger?.debug("tryUnlinkLocalMedia", `Replacing local ${localMedia.type} media with remote ${remoteMedia.type} media...`);
                visibleMedias.tryReplace(localMedia.id, remoteMedia);
            }
            else {
                void this.eventLogger?.debug("tryUnlinkLocalMedia", `Removing local ${localMedia.type} media...`);
                visibleMedias.tryRemove(localMedia.id);
            }
        }
        remoteMedia.linkedLocalMedia = null;
    }
    async createConnection() {
        const connection = new Connection$1(Object.assign({
            attendeeId: this.attendeeId,
            client: this._client,
            meetingId: this.meetingId,
        }, this._init));
        if (this._requestedAudioDeviceId)
            await connection.setAudioDevice(this._requestedAudioDeviceId);
        const remoteAudibleDisplayMedias = connection.getMediasActive("display", "audio");
        const remoteAudibleUserMedias = connection.getMediasActive("user", "audio");
        const remoteVisibleDisplayMedias = connection.getMediasActive("display", "video");
        const remoteVisibleUserMedias = connection.getMediasActive("user", "video");
        for (const remoteAudibleDisplayMedia of remoteAudibleDisplayMedias)
            this._audibleMedias.get("display").tryAdd(remoteAudibleDisplayMedia);
        for (const remoteAudibleUserMedia of remoteAudibleUserMedias)
            this._audibleMedias.get("user").tryAdd(remoteAudibleUserMedia);
        for (const remoteVisibleDisplayMedia of remoteVisibleDisplayMedias)
            this._visibleMedias.get("display").tryAdd(remoteVisibleDisplayMedia);
        for (const remoteVisibleUserMedia of remoteVisibleUserMedias)
            this._visibleMedias.get("user").tryAdd(remoteVisibleUserMedia);
        connection.mediaActivated.bind(this._onMediaActivated);
        connection.mediaDeactivated.bind(this._onMediaDeactivated);
        connection.trackStatusUpdated.bind(this._onTrackStatusUpdated);
        remoteAudibleDisplayMedias.added.bind(this._onAudibleDisplayMediaAdded);
        remoteAudibleDisplayMedias.removed.bind(this._onAudibleDisplayMediaRemoved);
        remoteAudibleUserMedias.added.bind(this._onAudibleUserMediaAdded);
        remoteAudibleUserMedias.removed.bind(this._onAudibleUserMediaRemoved);
        remoteVisibleDisplayMedias.added.bind(this._onVisibleDisplayMediaAdded);
        remoteVisibleDisplayMedias.removed.bind(this._onVisibleDisplayMediaRemoved);
        remoteVisibleUserMedias.added.bind(this._onVisibleUserMediaAdded);
        remoteVisibleUserMedias.removed.bind(this._onVisibleUserMediaRemoved);
        return connection;
    }
    destroyConnection(connection) {
        const remoteAudibleDisplayMedias = connection.getMediasActive("display", "audio");
        const remoteAudibleUserMedias = connection.getMediasActive("user", "audio");
        const remoteVisibleDisplayMedias = connection.getMediasActive("display", "video");
        const remoteVisibleUserMedias = connection.getMediasActive("user", "video");
        for (const remoteAudibleDisplayMedia of remoteAudibleDisplayMedias)
            this._audibleMedias.get("display").tryRemove(remoteAudibleDisplayMedia.id);
        for (const remoteAudibleUserMedia of remoteAudibleUserMedias)
            this._audibleMedias.get("user").tryRemove(remoteAudibleUserMedia.id);
        for (const remoteVisibleDisplayMedia of remoteVisibleDisplayMedias)
            this._visibleMedias.get("display").tryRemove(remoteVisibleDisplayMedia.id);
        for (const remoteVisibleUserMedia of remoteVisibleUserMedias)
            this._visibleMedias.get("user").tryRemove(remoteVisibleUserMedia.id);
        connection.mediaActivated.unbind(this._onMediaActivated);
        connection.mediaDeactivated.unbind(this._onMediaDeactivated);
        connection.trackStatusUpdated.unbind(this._onTrackStatusUpdated);
        remoteAudibleDisplayMedias.added.unbind(this._onAudibleDisplayMediaAdded);
        remoteAudibleDisplayMedias.removed.unbind(this._onAudibleDisplayMediaRemoved);
        remoteAudibleUserMedias.added.unbind(this._onAudibleUserMediaAdded);
        remoteAudibleUserMedias.removed.unbind(this._onAudibleUserMediaRemoved);
        remoteVisibleDisplayMedias.added.unbind(this._onVisibleDisplayMediaAdded);
        remoteVisibleDisplayMedias.removed.unbind(this._onVisibleDisplayMediaRemoved);
        remoteVisibleUserMedias.added.unbind(this._onVisibleUserMediaAdded);
        remoteVisibleUserMedias.removed.unbind(this._onVisibleUserMediaRemoved);
    }
    //public decreaseBitrate(step?: number): boolean {
    //  if (!this.connection) return false;
    //  this.connection.decreaseBitrate(step);
    //  return true;
    //}
    //public getReceiverStats(mediaType: MediaType, trackType: TrackType): TrackStats[] {
    //  return this.connection?.getTrackReceiverStats(mediaType, trackType);
    //}
    //public increaseBitrate(step?: number): boolean {
    //  if (!this.connection) return false;
    //  this.connection.increaseBitrate(step);
    //  return true;
    //}
    async setAudioDevice(deviceId) {
        const connection = this.connection;
        if (connection) {
            await connection.setAudioDevice(deviceId);
            this._requestedAudioDeviceId = connection.requestedAudioDeviceId;
        }
        else {
            this._requestedAudioDeviceId = deviceId;
        }
    }
    async useNextAudioDevice() {
        const connection = this.connection;
        if (!connection)
            return;
        await connection.useNextAudioDevice();
        this._requestedAudioDeviceId = connection.requestedAudioDeviceId;
    }
    async usePreviousAudioDevice() {
        const connection = this.connection;
        if (!connection)
            return;
        await connection.usePreviousAudioDevice();
        this._requestedAudioDeviceId = connection.requestedAudioDeviceId;
    }
    setLocalMedia(mediaType, localMedia) {
        const previousLocalMedia = this._localMedias.get(mediaType);
        if (previousLocalMedia == localMedia)
            return;
        const remoteVideos = this.connection?.getMediasActive(mediaType, "video") ?? RemoteMediaCollection.empty;
        if (previousLocalMedia) {
            for (const remoteVideo of remoteVideos) {
                this.tryUnlinkLocalMedia(remoteVideo);
            }
        }
        this._localMedias.set(mediaType, localMedia);
        if (localMedia) {
            for (const remoteVideo of remoteVideos) {
                this.tryLinkLocalMedia(remoteVideo);
            }
        }
    }
    setMaxVisibleUser(maxVisibleUser) {
        return this.connection?.setMaxVisibleUser(maxVisibleUser);
    }
};

class ExternalSession {
    constructor(init) {
        Guard.isNotNullOrUndefined(init, "init");
        Guard.isNotNullOrUndefined(init.credentials, "init.credentials");
        this._credentials = init.credentials;
    }
    async addIceCandidate() { }
    async iceServer(abortSignal) {
        return {
            credential: this._credentials.password,
            urls: this._credentials.uris,
            username: this._credentials.username,
        };
    }
    async setIceInfo() { }
}

let Client$2 = class Client {
    get maxRetries() { return this._httpClient.maxRetries; }
    set maxRetries(value) { this._httpClient.maxRetries = value; }
    get requestTimeout() { return this._httpClient.requestTimeout; }
    set requestTimeout(value) { this._httpClient.requestTimeout = value; }
    get clusterId() { return this._httpClient.clusterId; }
    constructor(init) {
        Guard.isNotNullOrUndefined(init, "init");
        Guard.isNotNullOrUndefined(init.identity, "init.identity");
        this._init = init;
        this._httpClient = HttpClient.withTokenFactory(async () => {
            const token = await this._init.identity.token();
            return {
                baseUrl: new URL(token.clusterAssignment.meetingUrl).origin,
                value: token.token
            };
        });
    }
    async getToken(request, abortSignal) {
        Guard.isNotNullOrUndefined(request, "request");
        if (Utility.isNullOrUndefined(request.roomId) && Utility.isNullOrUndefined(request.roomKey))
            throw new Error("Parameters 'request.roomId' and 'request.roomKey' cannot both be null or undefined.");
        if (request.roomKey)
            Guard.isLengthWithinBounds(request.roomKey, "room.key", RoomKeyLength.Max, RoomKeyLength.Min);
        return (await this._httpClient.post("/token", {
            clientType: "SDK",
            meetingType: request.meetingType,
            passcode: request.passcode,
            persistentAttendee: request.persistentAttendee,
            roomId: request.roomId,
            roomKey: request.roomKey,
            sdkVersion: version$1,
            sourceLanguage: "JS",
            userDisplayName: request.displayName
        }, abortSignal)).value;
    }
};

let Session$1 = class Session {
    get maxRetries() { return this._client.maxRetries; }
    set maxRetries(value) { this._client.maxRetries = value; }
    get requestTimeout() { return this._client.requestTimeout; }
    set requestTimeout(value) { this._client.requestTimeout = value; }
    get clusterId() { return this._client.clusterId; }
    constructor(init) {
        this._isLeaving = false;
        this._roomLogId = null;
        this._token = null;
        this._tokenTimeout = 0;
        this._init = null;
        Guard.isNotNullOrUndefined(init, "init");
        Guard.isNotNullOrUndefined(init.identity, "init.identity");
        this._client = new Client$2(init);
        this._identity = init.identity;
        this._init = init;
        this._httpClient = HttpClient.withTokenFactory(async () => {
            if (Utility.isNullOrUndefined(this._token))
                throw new Error("Not joined.");
            const token = await this._init.identity.token();
            return {
                baseUrl: new URL(token.clusterAssignment.meetingUrl).origin,
                value: this._token.value
            };
        });
        this._refreshToken = this.refreshToken.bind(Reactive.wrap(this));
    }
    async getTokenInternal(options, abortSignal, retryCounter = 0) {
        try {
            if (retryCounter == 0) {
                this._roomLogId = options.roomId ? `(ID: ${options.roomId})` : `(key: ${options.roomKey})`;
                Log.debug(`Getting meeting token for room ${this._roomLogId}...`);
            }
            const response = await this._client.getToken({
                displayName: options?.displayName,
                meetingType: options?.meetingType,
                passcode: options.passcode,
                persistentAttendee: options?.persistentAttendee,
                roomKey: options.roomKey,
                roomId: options.roomId,
            }, abortSignal);
            this._token = { value: response.token, ttl: response.tokenTtl };
            this._tokenTimeout = globalThis.setTimeout(this._refreshToken, (this._token.ttl * 1000) - 60000); // within 1 minute of expiring
            return response;
        }
        catch (error) {
            // handle abort signal
            if (abortSignal?.aborted)
                throw error;
            // handle retry exhaustion
            if (retryCounter >= this.maxRetries)
                throw error;
            // handle non-ephemeral errors
            if (!(error instanceof AcceptedError))
                throw error;
            // handle retry
            const delay = 200 * Math.pow(2, retryCounter);
            Log.warn(`Could not get meeting token for room ${this._roomLogId}. Trying again after ${delay.toLocaleString()}ms.`, error);
            await Utility.delay(delay);
            return await this.getTokenInternal(options, abortSignal, retryCounter + 1);
        }
    }
    async refreshToken() {
        if (this._isLeaving)
            return;
        try {
            const response = (await this._httpClient.post("/token/refresh", null)).value;
            this._token = { value: response.token, ttl: response.tokenTtl };
            this._tokenTimeout = globalThis.setTimeout(this._refreshToken, (this._token.ttl * 1000) - 60000); // within 1 minute of expiring
        }
        catch (error) {
            if (Utility.isNodeProcess()) {
                // log and swallow. This process happens outside calling code and can't be caught by the process
                console.error(`Failed to refresh meeting token.`, error);
                return;
            }
            throw error;
        }
    }
    async getToken(options, abortSignal) {
        options ??= {};
        if (options.roomKey)
            Guard.isLengthWithinBounds(options.roomKey, "options.roomKey", RoomKeyLength.Max, RoomKeyLength.Min);
        if (options.roomId || options.roomKey)
            return await this.getTokenInternal(options, abortSignal);
        Log.debug(`Creating meeting...`);
        const response = (await new Client$6({
            identity: this._identity
        }).createMeeting({
            passcode: options.passcode,
            planType: "2TIER",
        }, abortSignal)).value;
        options.roomId = response.roomId;
        options.roomKey = response.roomKey;
        return await this.getTokenInternal(options, abortSignal);
    }
    leave() {
        this._isLeaving = true;
        if (this._token)
            globalThis.clearTimeout(this._tokenTimeout);
    }
    async reassignEdge(abortSignal) {
        if (Utility.isNullOrUndefined(this._httpClient))
            throw new Error("Not joined.");
        return (await this._httpClient.post("/reassign/edge", null, abortSignal)).value;
    }
    async token(abortSignal) {
        return this._token;
    }
};

class MeetingStateMachine {
    get state() { return this._state; }
    constructor(initialState) {
        this._state = initialState ?? "new";
    }
    setState(state) {
        if (this.state === state)
            return;
        if (this.trySetState(state))
            return;
        throw new Error(`Cannot transition to '${state}' state while in '${this._state}' state.`);
    }
    trySetState(state) {
        switch (state) {
            case "joined":
                if (this._state != "joining" && this._state != "reconnecting")
                    return false;
                break;
            case "joining":
                if (this._state != "new" && this._state != "left")
                    return false;
                break;
            case "leaving":
                if (this._state != "joined" && this._state != "joining" && this._state != "reconnecting")
                    return false;
                break;
            case "left":
                if (this._state != "leaving")
                    return false;
                break;
            case "reconnecting":
                if (this._state != "joined")
                    return false;
                break;
            default:
                return false;
        }
        this._state = state;
        return true;
    }
}

class MetricLogger {
    constructor(init) {
        this._attendeeLogsPath = "/attendeeLogs";
        this._meetingLogsPath = "/meetingLogs";
        this._tenantLogsPath = "/tenantLogs";
        this._userAccountLogsPath = "/userAccountLogs";
        this._httpClientWithMeetingToken = null;
        this._meetingSession = null;
        Guard.isNotNullOrUndefined(init, "init");
        Guard.isNotNullOrUndefined(init.identity, "init.identity");
        this._init = init;
        this._identity = init.identity;
        this._meetingSession = init.meetingSession;
        this._httpClientWithIdentityToken = HttpClient.withTokenFactory(async () => {
            const token = await this._init.identity.token();
            return {
                baseUrl: new URL(token.clusterAssignment.clusterUrl).origin,
                value: token.token
            };
        });
        if (init.meetingSession) {
            this.initHttpClientWithMeetingToken();
        }
    }
    set meetingSession(value) {
        this._meetingSession = value;
        this.initHttpClientWithMeetingToken();
    }
    async log(event) {
        Guard.isNotNullOrUndefined(event.metricType, "event.metricType");
        const databaseLog = this.getDatabaseLog(event);
        const [httpClient, path] = this.getHttpClientAndPath();
        await httpClient.post(path, databaseLog);
    }
    convertFromCamelCaseToDot(value) {
        return value.split(/(?=[A-Z])/).map(s => s.toLowerCase()).join(".");
    }
    convertFromCamelCaseToSentence(value) {
        const sentence = value.split(/(?=[A-Z])/).map(s => s.toLowerCase()).join(" ");
        return sentence.charAt(0).toUpperCase() + sentence.slice(1) + ".";
    }
    getDatabaseLog(event) {
        if (!metricTypes.includes(event.metricType))
            throw Error("Validation error: Invalid metric type.");
        if (event.metricType == "sdk" && !sdkMeetingMetricNames.includes(event.eventName))
            throw Error("Validation error: Invalid sdk metric type.");
        // is it a built-in eventName?
        if (appMeetingMetricNames.includes(event.eventName) || sdkMeetingMetricNames.includes(event.eventName)) {
            event.eventName = `${event.metricType}.${this.convertFromCamelCaseToDot(event.eventName)}`;
            event.eventMessage = event.eventMessage ?? this.convertFromCamelCaseToSentence(event.eventName);
        }
        return {
            createdOn: event.timestamp,
            eventDebug: JSON.stringify(event.eventDebug),
            eventDuration: Math.round(event.eventDuration),
            eventMessage: event.eventMessage ?? event.eventName,
            eventName: event.eventName,
            eventSeverity: "INFORMATION",
            eventType: "METRIC"
        };
    }
    getHttpClientAndPath() {
        return this._httpClientWithMeetingToken ? [this._httpClientWithMeetingToken, this._attendeeLogsPath] : [this._httpClientWithIdentityToken, this._userAccountLogsPath];
    }
    initHttpClientWithMeetingToken() {
        this._httpClientWithMeetingToken = HttpClient.withTokenFactory(async () => {
            const meetingToken = await this._meetingSession.token();
            const identityToken = await this._identity.token();
            return {
                baseUrl: new URL(identityToken.clusterAssignment.clusterUrl).origin,
                value: meetingToken.value
            };
        });
    }
}
const appMeetingMetricNames = [
    "connectionAttempt",
    "connectionDropped",
    "connectionError",
    "connectionSuccess",
    "joinAttempt",
    "joinError",
    "joinSuccess",
    "qualityDrop",
    "reconnectAttempt",
    "reconnectError",
    "reconnectSuccess",
    "rejoinAttempt",
    "rejoinError",
    "rejoinSuccess"
];
const sdkMeetingMetricNames = [
    "connectionAttemptControl",
    "connectionAttemptEdge",
    "connectionAttemptOriginDisplay",
    "connectionAttemptOriginUser",
    "connectionDroppedControl",
    "connectionDroppedEdge",
    "connectionDroppedOriginDisplay",
    "connectionDroppedOriginUser",
    "connectionErrorControl",
    "connectionErrorEdge",
    "connectionErrorOriginDisplay",
    "connectionErrorOriginUser",
    "connectionSuccessControl",
    "connectionSuccessEdge",
    "connectionSuccessOriginDisplay",
    "connectionSuccessOriginUser",
    "joinAttempt",
    "joinError",
    "joinSuccess",
    "qualityDrop",
    "reconnectAttemptControl",
    "reconnectAttemptEdge",
    "reconnectAttemptOriginDisplay",
    "reconnectAttemptOriginUser",
    "reconnectErrorControl",
    "reconnectErrorEdge",
    "reconnectErrorOriginDisplay",
    "reconnectErrorOriginUser",
    "reconnectSuccessControl",
    "reconnectSuccessEdge",
    "reconnectSuccessOriginDisplay",
    "reconnectSuccessOriginUser",
    "rejoinAttempt",
    "rejoinError",
    "rejoinSuccess"
];
const metricTypes = ["app", "sdk"];

let Client$1 = class Client {
    get maxRetries() { return this._httpClient.maxRetries; }
    set maxRetries(value) { this._httpClient.maxRetries = value; }
    get requestTimeout() { return this._httpClient.requestTimeout; }
    set requestTimeout(value) { this._httpClient.requestTimeout = value; }
    constructor(init) {
        Guard.isNotNullOrUndefined(init, "init");
        Guard.isNotNullOrUndefined(init.meetingSession, "init.meetingSession");
        Guard.isNotNullOrUndefined(init.originServerUrl, "init.originServerUrl");
        this._init = init;
        this._httpClient = HttpClient.withTokenFactory(async () => {
            const token = await this._init.meetingSession.token();
            return {
                baseUrl: new URL(this._init.originServerUrl).origin,
                value: token.value
            };
        });
    }
    static deflate(offer) {
        return Base64.encode(deflateRaw_1(new TextEncoder().encode(offer)));
    }
    async negotiate(request, abortSignal) {
        Guard.isNotNullOrUndefined(request, "request");
        Guard.isNotNullOrUndefined(request.mediaType, "request.mediaType");
        Guard.isNotNullOrUndefined(request.offer, "request.offer");
        return (await this._httpClient.post("/negotiate", {
            audioLevelInterval: request.audioLevelInterval,
            mediaType: request.mediaType,
            offerDeflate: Client.deflate(request.offer),
            replicationCount: request.replicationCount,
            sdkVersion: version$1,
        }, abortSignal)).value;
    }
    async renegotiate(request, abortSignal) {
        Guard.isNotNullOrUndefined(request, "request");
        Guard.isNotNullOrUndefined(request.mediaType, "request.mediaType");
        Guard.isNotNullOrUndefined(request.offer, "request.offer");
        return (await this._httpClient.post("/renegotiate", {
            offerDeflate: Client.deflate(request.offer),
            mediaType: request.mediaType,
        }, abortSignal)).value;
    }
};

class VideoUtility {
    static calculateBitrate(frameSize, frameRate, bitsPerPixel, baselineWidth, baselineHeight, bitrateExponent) {
        const baselinePixelCount = (baselineWidth ?? this._defaultBaselineWidth) * (baselineHeight ?? this._defaultBaselineHeight);
        const baselineBitrate = baselinePixelCount * frameRate * (bitsPerPixel ?? this._defaultBitsPerPixel) / 1000;
        const pixelScale = (frameSize.width * frameSize.height) / baselinePixelCount;
        return Math.ceil(Math.pow(pixelScale, bitrateExponent ?? this._defaultBitrateExponent) * baselineBitrate);
    }
    static calculateBitrateUsingPixelCount(pixelCount, frameRate, bitsPerPixel, baselineWidth, baselineHeight, bitrateExponent) {
        const baselinePixelCount = (baselineWidth ?? this._defaultBaselineWidth) * (baselineHeight ?? this._defaultBaselineHeight);
        const baselineBitrate = baselinePixelCount * frameRate * (bitsPerPixel ?? this._defaultBitsPerPixel) / 1000;
        const pixelScale = (pixelCount) / baselinePixelCount;
        return Math.ceil(Math.pow(pixelScale, bitrateExponent ?? this._defaultBitrateExponent) * baselineBitrate);
    }
    static calculateScaledResolution(frameSize, scaleResolutionDownBy) {
        const scaledHeight = Math.round(frameSize.height / scaleResolutionDownBy);
        const scaledWidth = Math.round(frameSize.width / scaleResolutionDownBy);
        return {
            height: scaledHeight,
            width: scaledWidth
        };
    }
    static calculateScaleResolutionDownBy(originalFrameSize, maxPixelCount, resolutionThrottle) {
        if (originalFrameSize || !maxPixelCount)
            return;
        resolutionThrottle ??= 1;
        const scaleResolutionDownBy = Math.max(1, Math.sqrt(originalFrameSize.width * originalFrameSize.height / (maxPixelCount * resolutionThrottle)));
        return scaleResolutionDownBy;
    }
}
VideoUtility._defaultBaselineHeight = 480;
VideoUtility._defaultBaselineWidth = 640;
VideoUtility._defaultBitrateExponent = 0.75;
VideoUtility._defaultBitsPerPixel = 0.05;

// Display Values
// Video
const VideoOriginFrameRateDisplayMin = "ORIGIN:FRAMERATE:DISPLAY:MIN";
const VideoOriginPixelCountDisplayMin = "ORIGIN:PIXELCOUNT:DISPLAY:MIN";
const VideoOriginJitterDisplayLow = "ORIGIN:JITTER:DISPLAY:LOW";
const VideoOriginJitterDisplayMedium = "ORIGIN:JITTER:DISPLAY:MEDIUM";
const VideoOriginJitterDisplayHigh = "ORIGIN:JITTER:DISPLAY:HIGH";
const VideoOriginPacketLossDisplayLow = "ORIGIN:PACKETLOSS:DISPLAY:LOW";
const VideoOriginPacketLossDisplayMedium = "ORIGIN:PACKETLOSS:DISPLAY:MEDIUM";
const VideoOriginPacketLossDisplayHigh = "ORIGIN:PACKETLOSS:DISPLAY:HIGH";
// User Values
// Video
const VideoOriginFrameRateUserMin = "ORIGIN:FRAMERATE:USER:MIN";
const VideoOriginPixelCountUserMin = "ORIGIN:PIXELCOUNT:USER:MIN";
const VideoOriginJitterUserLow = "ORIGIN:JITTER:USER:LOW";
const VideoOriginJitterUserMedium = "ORIGIN:JITTER:USER:MEDIUM";
const VideoOriginJitterUserHigh = "ORIGIN:JITTER:USER:HIGH";
const VideoOriginPacketLossUserLow = "ORIGIN:PACKETLOSS:USER:LOW";
const VideoOriginPacketLossUserMedium = "ORIGIN:PACKETLOSS:USER:MEDIUM";
const VideoOriginPacketLosUserHigh = "ORIGIN:PACKETLOSS:USER:HIGH";

class CodecHelper {
    static VP9Supported(userAgent) {
        try {
            for (let i = 0; i < this._regexVP9Devices.length; i++) {
                const regex = this._regexVP9Devices[i];
                if (regex.test(userAgent)) {
                    return true;
                }
            }
        }
        catch (err) {
            // TODO: Log error?
        }
        return false;
    }
    /**
     * Determines the codec priority that will be used for encoding/decoding. The codecs in the SDP offer
     * will be sorted based on the priorty determined in this function and will be negotiated based on their
     * availability on the server.
     * @param userAgent The userAgent of the browser. Used to determine the device the user is using
     * @param codecOverride The codec override that will be used instead of the preferred codecs
     * determined by the logic based on the user's device
     * @returns A sorted array of codec mime types
     */
    static getCodecPriority(userAgent, codecOverride = null) {
        if (codecOverride) {
            if (codecOverride === Constants$2.Codecs.H264) {
                return this._preferredH264;
            }
            else if (codecOverride === Constants$2.Codecs.VP8) {
                return this._preferredVP8;
            }
        }
        else if (Utility.isIOS() || Utility.isMac()) {
            return this._preferredH264;
        }
        /* MK - TODO: Add VP9 support in the future
        else if (this.VP9Supported(userAgent ?? navigator.userAgent)) {
            return this._preferredVP9;
        }
        */
        return this._preferredVP8;
    }
    static getSenderVideoCodecs(codecs, preferredOrder) {
        let sorted = codecs.sort((a, b) => {
            const indexA = preferredOrder.indexOf(a.mimeType);
            const indexB = preferredOrder.indexOf(b.mimeType);
            const orderA = indexA >= 0 ? indexA : Number.MAX_VALUE;
            const orderB = indexB >= 0 ? indexB : Number.MAX_VALUE;
            return orderA - orderB;
        });
        if (preferredOrder[0] === Constants$2.Codecs.H264) {
            sorted = this.prioritizeH264Codecs(sorted);
        }
        sorted = sorted.filter(codec => {
            // Filter out the VP9 profile-id=2 codec and the H264 profile-level-id=6XXXXXX codecs. These are not supported on the media server.
            if (codec.mimeType === Constants$2.Codecs.VP9 && /profile-id=2/.test(codec.sdpFmtpLine ?? "")) {
                return null;
            }
            else if (codec.mimeType === Constants$2.Codecs.H264 && /profile-level-id=6/.test(codec.sdpFmtpLine ?? "")) {
                return null;
            }
            return codec;
        });
        return sorted;
    }
    static prioritizeH264Codecs(codecs) {
        return codecs.sort((a, b) => {
            // Check if codec is H264
            const isH264A = a.mimeType === Constants$2.Codecs.H264;
            const isH264B = b.mimeType === Constants$2.Codecs.H264;
            // Define H264 profile priorities
            const getH264ProfilePriority = (codec) => {
                if (!codec || codec.mimeType !== Constants$2.Codecs.H264 || !codec.sdpFmtpLine)
                    return Number.MAX_SAFE_INTEGER; // Lowest priority for non-H264
                const fmtp = codec.sdpFmtpLine;
                // packetization-mode=1 is preferred for WebRTC
                if (/profile-level-id=4d00/.test(fmtp) && /packetization-mode=1/.test(fmtp))
                    return 1; // Main Profile
                if (/profile-level-id=4200/.test(fmtp) && /packetization-mode=1/.test(fmtp))
                    return 2; // Baseline Profile
                if (/profile-level-id=42e0/.test(fmtp) && /packetization-mode=1/.test(fmtp))
                    return 3; // Constrained Baseline Profile
                if (/profile-level-id=6400/.test(fmtp) && /packetization-mode=1/.test(fmtp))
                    return 4; // High Profile
                if (/profile-level-id=4d00/.test(fmtp) && /packetization-mode=0/.test(fmtp))
                    return 5; // Main Profile
                if (/profile-level-id=4200/.test(fmtp) && /packetization-mode=0/.test(fmtp))
                    return 6; // Baseline Profile
                if (/profile-level-id=42e0/.test(fmtp) && /packetization-mode=0/.test(fmtp))
                    return 7; // Constrained Baseline Profile
                if (/profile-level-id=6400/.test(fmtp) && /packetization-mode=0/.test(fmtp))
                    return 8; // High Profile
                return Number.MAX_SAFE_INTEGER; // Unrecognized profile, lower priority
            };
            // Get profile priorities for both codecs
            const priorityA = getH264ProfilePriority(a);
            const priorityB = getH264ProfilePriority(b);
            // Sort by profile priority if both are H264
            if (isH264A && isH264B)
                return priorityA - priorityB;
            // Prioritize H264 over other codecs
            if (isH264A && !isH264B)
                return -1;
            if (!isH264A && isH264B)
                return 1;
            // For non-H264 codecs, retain original order
            return 0;
        });
    }
}
/*
    H264 Codec Definition from libwebrtc for reference
    const char* profile_idc_iop_string;
    switch (profile_level_id.profile) {
    case H264Profile::kProfileConstrainedBaseline:
        profile_idc_iop_string = "42e0";
        break;
    case H264Profile::kProfileBaseline:
        profile_idc_iop_string = "4200";
        break;
    case H264Profile::kProfileMain:
        profile_idc_iop_string = "4d00";
        break;
    case H264Profile::kProfileConstrainedHigh:
        profile_idc_iop_string = "640c";
        break;
    case H264Profile::kProfileHigh:
        profile_idc_iop_string = "6400";
        break;
    case H264Profile::kProfilePredictiveHigh444:
        profile_idc_iop_string = "f400";
        break;
    // Unrecognized profile.
    default:
        return absl::nullopt;
    }
*/
CodecHelper._regexVP9Devices = [
    /pixel (2|3|4|5|6|7|8|9)a?/i,
    /SM-G960F|SM-G973F|SM-G980F|SM-G981B|SM-G991B|SM-S901B|SM-S911B|SM-N960F|SM-N970F|SM-N981B/i,
    /ONEPLUS A6000|ONEPLUS A7000|IN2010|LE2110|NE2210/i,
    /EML-L29|ELE-L29|ANA-NX9|HMA-L29|TAS-L29|NOH-NX9/i,
    /MI 8|MI 9|MI 10|MI 11|MI 12|Redmi Note 9 Pro|Redmi Note 10/i, // Xiaomi
];
// Leaving VP9 at the end of the this list in terms of preference since we're not going to use it for now
CodecHelper._preferredH264 = [Constants$2.Codecs.H264, Constants$2.Codecs.VP8, Constants$2.Codecs.VP9];
CodecHelper._preferredVP9 = [Constants$2.Codecs.VP9, Constants$2.Codecs.VP8, Constants$2.Codecs.H264];
CodecHelper._preferredVP8 = [Constants$2.Codecs.VP8, Constants$2.Codecs.H264, Constants$2.Codecs.VP9];

// Default
const medianIOSFrameRate = 15;
const defaultMinBitrate = 100;
const defaultMinFrameRateUser = 10;
const defaultMinFrameRateUserIOS = 10;
const defaultMinFrameRateDisplay = 3;
const defaultMinPixelCountDisplay = 921600; // 1280x720 - For screenshare, don't go below this resolution, otherwise it's unusuable especially when sharing text
const defaultScalingBackoffUser = 3;
const defaultScalingBackoffDisplay = 5;
const defaultIceRestartBackoff = 5;
const trackTypes = ["audio", "video"];
/*
 * Audio impairment default statuses.
 */
var AudioHealthIssues;
(function (AudioHealthIssues) {
    AudioHealthIssues["JITTERHIGH"] = "Jitter - High";
    AudioHealthIssues["JITTERMEDIUM"] = "Jitter - Medium";
    AudioHealthIssues["JITTERLOW"] = "Jitter - Low";
    AudioHealthIssues["PACKETLOSSHIGH"] = "Packet Loss - High";
    AudioHealthIssues["PACKETLOSSMEDIUM"] = "Packet Loss - Medium";
    AudioHealthIssues["PACKETLOSSLOW"] = "Packet Loss - Low";
    AudioHealthIssues["ROUNDTRIPTIMEHIGH"] = "Round Trip Time - High";
    AudioHealthIssues["ROUNDTRIPTIMEMEDIUM"] = "Round Trip Time - Medium";
    AudioHealthIssues["ROUNDTRIPTIMELOW"] = "Round Trip Time - Low";
})(AudioHealthIssues || (AudioHealthIssues = {}));
class Connection extends Connection$3 {
    get audioBitrateMax() {
        return this._clientConstraints?.audioBitrateMax;
    }
    get currentLevel() {
        return this._currentLevel;
    }
    get currentLevelAudioBitrate() {
        return this._clientConstraints?.audioBitrateMax / this._maxAudioBitrate;
    }
    get currentLevelVideoBitrate() {
        return this._clientConstraints?.videoBitrateMax / this._maxBitrate;
    }
    get currentLevelFrameRate() {
        return this._clientConstraints?.videoFrameRateMax / this._maxFrameRate;
    }
    get currentLevelPixelCount() {
        return this._clientConstraints?.videoPixelCountMax / this._maxPixelCount;
    }
    get media() {
        return this._media;
    }
    get mediaRejected() {
        return this._mediaRejected;
    }
    get mediaReplaced() {
        return this._mediaReplaced;
    }
    get mediaType() {
        return this._mediaType;
    }
    get priorityAudio() {
        return this._priorityAudio;
    }
    get priorityVideo() {
        return this._priorityVideo;
    }
    get videoBitrateMax() {
        return this._clientConstraints?.videoBitrateMax;
    }
    get videoPixelCountMax() {
        return this._clientConstraints?.videoPixelCountMax ?? this._maxPixelCount;
    }
    get videoFramerateMin() {
        return this._minFrameRate;
    }
    get videoHeightMin() {
        return this._minHeight;
    }
    get videoWidthMin() {
        return this._minWidth;
    }
    get videoFramerateMax() {
        return this._maxFrameRate;
    }
    get videoHeightMax() {
        return this._maxHeight;
    }
    get videoWidthMax() {
        return this._maxWidth;
    }
    constructor(init) {
        super({
            attendeeId: init.attendeeId,
            eventLogger: new Logger(init.apiClient, "OriginConnection", init.attendeeId, init.meetingId, init.clusterId),
            iceRestartEnabled: init.iceRestartEnabled,
            iceReconnectionTimeout: init.iceReconnectionTimeout,
            meetingId: init.meetingId,
            redAudioEnabled: init.redAudioEnabled,
            turnRequired: init.turnRequired,
            turnSession: init.turnSession,
            type: `Origin (${init.mediaType})`,
        });
        this._mediaNotificationQueue = new DispatchQueue();
        this._mediaRejected = new EventOwnerAsync();
        this._mediaReplaced = new EventOwnerAsync();
        this._rttHistory = new Array();
        this._transceivers = new Map();
        // Video impairment default thresholds
        this._availableBitrateThreshold = 100;
        this._availableBitrateFrameRateRecoveryThreshold = 200;
        this._bitrateSteadyThreshold = 3;
        this._bitrateIncreasesThreshold = 3;
        this._jitterHighThreshold = 160;
        this._jitterLowThreshold = 80;
        this._jitterMediumThreshold = 120;
        this._jitterRttHighThreshold = 120;
        this._jitterRttLowThreshold = 40;
        this._jitterRttMediumThreshold = 80;
        this._minBitrateStep = 200;
        this._nackHighThreshold = .15;
        this._nackLowThreshold = .075;
        this._nackMediumThreshold = .1;
        this._packetLossHighThreshold = 0.2;
        this._packetLossLowThreshold = 0.05;
        this._packetLossMediumThreshold = 0.1;
        this._pliThresholdHigh = 15;
        this._pliThresholdLow = 4;
        this._pliThresholdMedium = 8;
        this._recoveryThreshold = 7;
        this._rttAverageThreshold = 250;
        this._rttHistorySize = 10;
        this._rttHighThreshold = 400;
        this._rttLowThreshold = 300;
        this._rttMediumThreshold = 350;
        this._rttOffThreshold = 750;
        // ICE 
        this._currentCandidateIp = null;
        this._currentCandidateNetworkAdapterType = null;
        this._currentCandidateNetworkType = null;
        this._iceRestartThreshold = 2;
        this._iceRestartBackoff = defaultIceRestartBackoff;
        this._rttUnhealthyCount = 0;
        // Codecs - If present in the Tenant Settings, the preferred codec value will be used instead of the logic determined by the SDK
        this._preferredVideoCodec = null;
        this._bitrateIncreases = 0;
        this._bitrateSteady = 0;
        this._clientConstraints = null;
        this._codec = null;
        this._currentLevel = "high";
        this._currentRampUpSeconds = 0;
        this._customBandwidthAdaptationEnabled = true;
        this._degradationPreference = "balanced";
        this._encodingEnabled = true;
        this._estimatedConstraints = null;
        this._healthyChecks = 0;
        this._maxAudioBitrate = 96;
        this._maxBitrate = 2200;
        this._maxFrameRate = 25;
        this._maxHeight = 1080;
        this._maxPixelCount = 2073600;
        this._maxWidth = 1920;
        this._media = null;
        this._mediaChannelBytesReceived = 0;
        this._mediaChannelBytesSent = 0;
        this._minAudioBitrate = 10;
        this._minBitrate = defaultMinBitrate;
        this._minFrameRate = defaultMinFrameRateUser;
        this._minFrameRateSevereDegradation = 5;
        this._minHeight = 160;
        this._minPixelCount = 38400;
        this._minWidth = 240;
        this._priorityAudio = "high";
        this._priorityVideo = "high";
        this._rampUpSeconds = 5;
        this._rampUpSecondsMobile = 10;
        this._rampUpStartBitrate = Utility.isMobileBrowser() ? 600 : 1000;
        // On mobile, ramp up the pixel count starting at 960x540. Helps with lagging frame rate during the start of the call.
        this._rampUpStartPixelCount = Utility.isMobileBrowser() ? 518400 : this._maxPixelCount;
        this._rampedUp = false;
        this._rampedUpMobile = false;
        this._recoveryTime = 0;
        this._scalingBackoff = 0;
        this._serverConstraints = null;
        this._unhealthyChecks = 0;
        this._statsBatchAudio = [];
        this._statsBatchVideo = [];
        this._currentStatCount = 1;
        this._lastPairState = null;
        this._statsBatchSize = 5; // Batch size
        this._statsInterval = 1; // How often stats are collected
        this._bitrateAudio = new Bitrate();
        this._bitrateVideo = new Bitrate();
        this._framerateVideo = new Framerate();
        this._audioLevelInterval = init.audioLevelInterval;
        this._client = init.client;
        this._mediaOptions = init.mediaOptions;
        this._mediaType = init.mediaType;
        this._replicationCount = init.replicationCount;
        this._statsBatchAudio = [];
        this._statsBatchVideo = [];
        this._bitrateAudio = new Bitrate();
        this._bitrateVideo = new Bitrate();
        this._framerateVideo = new Framerate();
        this._codec = this._mediaOptions.codec;
        this._customBandwidthAdaptationEnabled = this._mediaOptions.customBandwidthAdaptationEnabled ??= true;
        this._degradationPreference = this._mediaOptions.degradationPreference ??= this._mediaType === "display" ? "maintain-resolution" : "maintain-framerate";
        // Only ramp up for user media. Display media should start at the best quality possible
        if (this._mediaType === "user" && this._customBandwidthAdaptationEnabled) {
            this._currentLevel = "medium";
        }
        else {
            this._minPixelCount = defaultMinPixelCountDisplay;
            this._rampUpStartBitrate = this._maxBitrate;
            this._rampUpStartPixelCount = this._maxPixelCount;
        }
        if (init.room) {
            const room = init.room;
            if (this._mediaType === "display") {
                if (room.minVideoBitrate)
                    this._minBitrate = room.minVideoBitrate;
                if (room.minVideoFramerateDisplay)
                    this._minFrameRate = room.minVideoFramerateDisplay;
                if (room.minVideoPixelCountDisplay && room.minVideoPixelCountDisplay > this._minPixelCount)
                    this._minPixelCount = room.minVideoPixelCountDisplay;
                if (room.maxAudioDisplay)
                    this._maxAudioBitrate = room.maxAudioDisplay;
                if (room.minAudioBitrate)
                    this._minAudioBitrate = room.minAudioBitrate;
            }
            else if (this._mediaType === "user") {
                if (room.minVideoBitrate)
                    this._minBitrate = room.minVideoBitrate;
                if (room.minVideoFramerateUser)
                    this._minFrameRate = Utility.isIOS() ? defaultMinFrameRateUserIOS : room.minVideoFramerateUser;
                if (room.minVideoPixelCountUser)
                    this._minPixelCount = room.minVideoPixelCountUser;
                if (room.minVideoHeightUser)
                    this._minHeight = room.minVideoHeightUser;
                if (room.minVideoWidthUser)
                    this._minHeight = room.minVideoWidthUser;
                if (room.maxVideoFramerateUser)
                    this._maxFrameRate = room.maxVideoFramerateUser;
                if (room.maxVideoHeightUser)
                    this._maxHeight = room.maxVideoHeightUser;
                if (room.maxVideoWidthUser)
                    this._maxWidth = room.maxVideoWidthUser;
                if (room.maxAudioBitrate)
                    this._maxAudioBitrate = room.maxAudioBitrate;
                if (room.minAudioBitrate)
                    this._minAudioBitrate = room.minAudioBitrate;
            }
            if (room.maxVideoBitrate)
                this._maxBitrate = room.maxVideoBitrate;
        }
        //TODO: change to eventLogger
        if (init.tenantSettings && init.tenantSettings.length > 0) {
            const settings = init.tenantSettings;
            settings.forEach((setting) => {
                try {
                    if (this._mediaType === "display") {
                        switch (setting.settingName) {
                            case VideoOriginFrameRateDisplayMin:
                                if (this._minFrameRate == 0) {
                                    this._minFrameRate = Number.parseFloat(setting.settingValue);
                                    Log.debug(`Set minFrametRate from TenantSetting: Value=${setting.settingValue}, MediaType=${this._mediaType}`);
                                }
                                break;
                            case VideoOriginPixelCountDisplayMin:
                                if (this._minPixelCount == 0) {
                                    this._minPixelCount = Number.parseInt(setting.settingValue);
                                    Log.debug(`Set minPixelCount from TenantSetting: Value=${setting.settingValue}, MediaType=${this._mediaType}`);
                                }
                                break;
                            case VideoOriginJitterDisplayLow: {
                                this._jitterLowThreshold = Number.parseInt(setting.settingValue);
                                Log.debug(`Set jitterLow from TenantSetting: Value=${setting.settingValue}, MediaType=${this._mediaType}`);
                                break;
                            }
                            case VideoOriginJitterDisplayMedium: {
                                this._jitterMediumThreshold = Number.parseInt(setting.settingValue);
                                Log.debug(`Set jitterMedium from TenantSetting: Value=${setting.settingValue}, MediaType=${this._mediaType}`);
                                break;
                            }
                            case VideoOriginJitterDisplayHigh: {
                                this._jitterHighThreshold = Number.parseInt(setting.settingValue);
                                Log.debug(`Set jitterHigh from TenantSetting: Value=${setting.settingValue}, MediaType=${this._mediaType}`);
                                break;
                            }
                            case VideoOriginPacketLossDisplayLow: {
                                this._packetLossLowThreshold = Number.parseFloat(setting.settingValue);
                                Log.debug(`Set packetLossLow from TenantSetting: Value=${setting.settingValue}, MediaType=${this._mediaType}`);
                                break;
                            }
                            case VideoOriginPacketLossDisplayMedium: {
                                this._packetLossMediumThreshold = Number.parseFloat(setting.settingValue);
                                Log.debug(`Set packetLossMedium from TenantSetting: Value=${setting.settingValue}, MediaType=${this._mediaType}`);
                                break;
                            }
                            case VideoOriginPacketLossDisplayHigh: {
                                this._packetLossHighThreshold = Number.parseFloat(setting.settingValue);
                                Log.debug(`Set packetLossHigh from TenantSetting: Value=${setting.settingValue}, MediaType=${this._mediaType}`);
                                break;
                            }
                        }
                    }
                    else if (this._mediaType === "user") {
                        switch (setting.settingName) {
                            case VideoOriginFrameRateUserMin:
                                if (this._minFrameRate == 0) {
                                    this._minFrameRate = Number.parseFloat(setting.settingValue);
                                    Log.debug(`Set minFrametRate from TenantSetting: Value=${setting.settingValue}, MediaType=${this._mediaType}`);
                                }
                                break;
                            case VideoOriginPixelCountUserMin:
                                if (this._minPixelCount == 0) {
                                    this._minPixelCount = Number.parseInt(setting.settingValue);
                                    Log.debug(`Set minPixelCount from TenantSetting: Value=${setting.settingValue}, MediaType=${this._mediaType}`);
                                }
                                break;
                            case VideoOriginJitterUserLow: {
                                this._jitterLowThreshold = Number.parseInt(setting.settingValue);
                                Log.debug(`Set jitterLow from TenantSetting: Value=${setting.settingValue}, MediaType=${this._mediaType}`);
                                break;
                            }
                            case VideoOriginJitterUserMedium: {
                                this._jitterMediumThreshold = Number.parseInt(setting.settingValue);
                                Log.debug(`Set jitterMedium from TenantSetting: Value=${setting.settingValue}, MediaType=${this._mediaType}`);
                                break;
                            }
                            case VideoOriginJitterUserHigh: {
                                this._jitterHighThreshold = Number.parseInt(setting.settingValue);
                                Log.debug(`Set jitterHigh from TenantSetting: Value=${setting.settingValue}, MediaType=${this._mediaType}`);
                                break;
                            }
                            case VideoOriginPacketLossUserLow: {
                                this._packetLossLowThreshold = Number.parseFloat(setting.settingValue);
                                Log.debug(`Set packetLossLow from TenantSetting: Value=${setting.settingValue}, MediaType=${this._mediaType}`);
                                break;
                            }
                            case VideoOriginPacketLossUserMedium: {
                                this._packetLossMediumThreshold = Number.parseFloat(setting.settingValue);
                                Log.debug(`Set packetLossMedium from TenantSetting: Value=${setting.settingValue}, MediaType=${this._mediaType}`);
                                break;
                            }
                            case VideoOriginPacketLosUserHigh: {
                                this._packetLossHighThreshold = Number.parseFloat(setting.settingValue);
                                Log.debug(`Set packetLossHigh from TenantSetting: Value=${setting.settingValue}, MediaType=${this._mediaType}`);
                                break;
                            }
                        }
                    }
                    switch (setting.settingName) {
                        case "ORIGIN:BITRATE:MIN":
                            if (this._minBitrate == 0) {
                                this._minBitrate = Number.parseInt(setting.settingValue);
                                Log.debug(`Set minBitrate from TenantSetting: Value=${setting.settingValue}`);
                            }
                            break;
                        case "ORIGIN:RAMPUP:SECONDS":
                            this._rampUpSeconds = Number.parseInt(setting.settingValue);
                            this._rampUpSecondsMobile = this._rampUpSeconds * 2;
                            Log.debug(`Set rampUpSeconds from TenantSetting: Value=${setting.settingValue}`);
                            break;
                        case "ORIGIN:CODEC:VIDEO":
                            if (setting.settingValue) {
                                if (Constants$2.Codecs.isValid(setting.settingValue)) {
                                    this._preferredVideoCodec = setting.settingValue;
                                    Log.info(`Set preferred video codec from TenantSetting: Value=${setting.settingValue}`);
                                }
                                else {
                                    Log.warn(`Invalid codec from TenantSetting: Value=${setting.settingValue}. Defaulting to client preference`);
                                }
                            }
                            break;
                    }
                }
                catch (err) {
                    //TODO: change to eventLogger
                    Log.error(`Error parsing TenantSetting: ${setting.settingName}=${setting.settingValue} Type=${setting.settingType}`, err);
                }
            });
        }
        // Defaults if values are not set by settings
        if (this._minBitrate == 0)
            this._minBitrate = defaultMinBitrate;
        if (this._minFrameRate == 0)
            this._minFrameRate = this._mediaType == "display" ? defaultMinFrameRateDisplay : Utility.isIOS() ? defaultMinFrameRateUserIOS : defaultMinFrameRateUser;
        if (this._minPixelCount == 0)
            this._minPixelCount = this._mediaType == "display" ? 1280 * 720 : this._minHeight * this._minWidth;
        if (this._jitterHighThreshold == 0)
            this._jitterHighThreshold = 120;
        if (this._jitterMediumThreshold == 0)
            this._jitterMediumThreshold = 80;
        if (this._jitterMediumThreshold == 0)
            this._jitterLowThreshold = 30;
        if (this._packetLossHighThreshold == 0)
            this._packetLossHighThreshold = 0.2;
        if (this._packetLossMediumThreshold == 0)
            this._packetLossMediumThreshold = 0.1;
        if (this._packetLossMediumThreshold == 0)
            this._packetLossLowThreshold = 0.03;
        this._onAudioTrackStreamBound = this.onAudioTrackStreamBound.bind(Reactive.wrap(this));
        this._onAudioTrackStreamUnbound = this.onAudioTrackStreamUnbound.bind(Reactive.wrap(this));
        this._onMediaChannelClose = this.onMediaChannelClose.bind(Reactive.wrap(this));
        this._onMediaChannelClosing = this.onMediaChannelClosing.bind(Reactive.wrap(this));
        this._onMediaChannelError = this.onMediaChannelError.bind(Reactive.wrap(this));
        this._onMediaChannelMessage = this.onMediaChannelMessage.bind(Reactive.wrap(this));
        this._onMediaChannelOpen = this.onMediaChannelOpen.bind(Reactive.wrap(this));
        this._onMediaStateChanged = this.onMediaStateChanged.bind(Reactive.wrap(this));
        this._onVideoTrackFrameSizeChanged = this.onVideoTrackFrameSizeChanged.bind(Reactive.wrap(this));
        this._onVideoTrackStreamBound = this.onVideoTrackStreamBound.bind(Reactive.wrap(this));
        this._onVideoTrackStreamUnbound = this.onVideoTrackStreamUnbound.bind(Reactive.wrap(this));
        this._mediaChannel = this.connection.createDataChannel("media");
        this._mediaChannel.binaryType = "arraybuffer";
        for (const trackType of trackTypes) {
            const trk = new Track();
            trk.status = "enabled";
            trk.mediaType = this._mediaType;
            trk.trackType = trackType;
            trk.index = this._transceivers.size;
            trk.priority = "high";
            trk.spatialLayerIndex = 0;
            trk.temporalLayerIndex = 0;
            trk.statAudio = new StatisticAudio();
            trk.statVideo = new StatisticVideo();
            trk.statPair = new StatisticConnection();
            trk.bitrateAudio = new Bitrate();
            trk.bitrateVideo = new Bitrate();
            trk.framerateVideo = new Framerate();
            const transceiver = this.connection.addTransceiver(trackType, {
                direction: "inactive",
            });
            trk.transceiver = transceiver;
            this._transceivers.set(trackType, trk);
            //this._senders.set(trackType, transceiver.sender);
            //this._senderStats.set(trackType, new TrackStats());
            if (trackType === "audio") {
                this.setPreferredAudioCodecsOrigin(transceiver);
            }
            else if (trackType === "video") {
                this.setPreferredVideoCodecsOrigin(transceiver);
            }
        }
        this.attachEventHandlers();
    }
    getSenderEncodings(parameters) {
        const encodings = parameters.encodings ?? [{}];
        parameters.encodings = encodings;
        return encodings;
    }
    onAudioTrackStreamBound() {
        const trackStream = this._media.audioTrack.stream;
        return this.eventQueue.dispatch(async () => {
            await this.tryReplaceSenderTrack("audio", trackStream);
            await this.updateTransceiverDirections();
        });
    }
    onAudioTrackStreamUnbound() {
        void this.eventQueue.dispatch(async () => {
            if (this.isTerminated)
                return;
            await this.tryReplaceSenderTrack("audio", null);
            await this.updateTransceiverDirections();
        });
    }
    onMediaChannelClose() {
        const message = `Origin ${this.mediaType} connection media channel has closed.`;
        void this.eventLogger.debug("onMediaChannelClose", message);
    }
    onMediaChannelClosing() {
        const message = `Origin ${this.mediaType} connection media channel is closing.`;
        void this.eventLogger.debug("onMediaChannelClosing", message);
    }
    onMediaChannelError(ev) {
        const errDetail = ev.error?.errorDetail ?? ev.error ?? "";
        const message = `Origin ${this.mediaType} connection media channel has failed. ${errDetail}`.trimEnd();
        void this.eventLogger.debug("onMediaChannelError", message);
    }
    //TODO: in-progess deprecating
    onMediaChannelMessage(ev) {
        //const arrayBuffer = <ArrayBuffer>ev.data;
        //this._mediaChannelBytesReceived += arrayBuffer.byteLength;
        //const buffer = new Uint8Array(arrayBuffer);
        //if (buffer.length == 0) return;
        //const payloadType = buffer[0];
        //if (payloadType == 0) {
        //  if (buffer.length == 1) return;
        //  const audioLevel = buffer[1] / 255;
        //  this._media?.audioTrack?.updateLevel(audioLevel);
        //}
    }
    onMediaChannelOpen() {
        const message = `Origin ${this.mediaType} connection media channel has opened.`;
        void this.eventLogger.debug("onMediaChannelOpen", message);
    }
    onMediaStateChanged() {
        return this.eventQueue.dispatch(async () => {
            await this.updateMediaBindings();
            await this.updateTransceiverDirections();
        });
    }
    onVideoTrackFrameSizeChanged() {
        void this.eventQueue.dispatch(async () => {
            await this.updateSenderParametersVideo();
        });
    }
    onVideoTrackStreamBound() {
        const trackStream = this._media.videoTrack.stream;
        return this.eventQueue.dispatch(async () => {
            await this.tryReplaceSenderTrack("video", trackStream);
            await this.updateTransceiverDirections();
        });
    }
    onVideoTrackStreamUnbound() {
        void this.eventQueue.dispatch(async () => {
            if (this.isTerminated)
                return;
            await this.tryReplaceSenderTrack("video", null);
            await this.updateTransceiverDirections();
        });
    }
    async tryReplaceSenderTrack(trackType, track) {
        const sender = this.getSender(trackType);
        try {
            if (this.state == "closed")
                return false;
            if (sender.track == track)
                return false;
            await sender.replaceTrack(track);
            if (trackType == "video")
                this.sendNotification({
                    type: "frameRateUpdated",
                    frameRate: track?.getSettings()?.frameRate ?? null,
                });
            return true;
        }
        catch (error) {
            const trkDetail = track == null ? "true" : "false";
            void this.eventLogger.warning(error, "tryReplaceSenderTrack", `Could not replace origin ${this._mediaType} ${trackType} sender track (null:${trkDetail}).`);
            return false;
        }
    }
    trySetTransceiverDirection(trackType, direction) {
        const transceiver = this.getTransceiver(trackType);
        try {
            if (this.state == "closed")
                return false;
            if (transceiver.direction == direction || transceiver.direction == "stopped" || transceiver.stopped /* legacy */)
                return false;
            transceiver.direction = direction;
            return true;
        }
        catch (error) {
            void this.eventLogger.warning(error, "trySetTransceiverDirection", `Could not set origin ${this._mediaType} ${trackType} transceiver direction to ${direction}.`);
            return false;
        }
    }
    // TODO: Update logic to update bitrate constraints based on isFeatured flag
    async updateConstraints(constraints) {
        void this.eventLogger.debug("updateConstraints", `Updating origin ${this._mediaType} constraints...`, null, {
            audioBitrateMax: constraints.audioBitrateMax,
            videoBitrateMax: constraints.videoBitrateMax,
            videoFrameRateMax: constraints.videoFrameRateMax,
            videoPixelCountMax: constraints.videoPixelCountMax,
        });
        if (this._estimatedConstraints == null) {
            this._estimatedConstraints = {
                audioBitrateMax: constraints.audioBitrateMax,
                videoBitrateMax: this._currentLevel === "medium" ? Math.min(this._rampUpStartBitrate, this._maxBitrate / 2) : this._maxBitrate,
                videoFrameRateMax: this._maxFrameRate,
                videoPixelCountMax: this._currentLevel === "medium" ? this._rampUpStartPixelCount : this._maxPixelCount,
            };
        }
        if (this._clientConstraints == null) {
            this._clientConstraints = {
                audioBitrateMax: constraints.audioBitrateMax,
                videoBitrateMax: this._currentLevel === "medium" ? Math.min(this._rampUpStartBitrate, this._maxBitrate / 2) : this._maxBitrate,
                videoFrameRateMax: this._maxFrameRate,
                videoPixelCountMax: this._currentLevel === "medium" ? this._rampUpStartPixelCount : this._maxPixelCount,
            };
        }
        if (this._serverConstraints == null) {
            this._serverConstraints = constraints;
        }
        else {
            Log.debug(`Updating server constraints: ${JSON.stringify(constraints)}`);
            this._serverConstraints.audioBitrateMax = constraints.audioBitrateMax;
            this._serverConstraints.videoBitrateMax = Math.max(this._minBitrate, constraints.videoBitrateMax);
            this._serverConstraints.videoFrameRateMax = Math.max(this._minFrameRate, constraints.videoFrameRateMax);
            this._serverConstraints.videoPixelCountMax = Math.max(this._minPixelCount, constraints.videoPixelCountMax);
            this._estimatedConstraints = this._serverConstraints;
            // If we are in a degraded state, only update the constraints from the server if the values are lower than what is currently set
            if (this._currentLevel != "high") {
                this._clientConstraints.audioBitrateMax = Math.min(this._clientConstraints.audioBitrateMax, constraints.audioBitrateMax);
                this._clientConstraints.videoBitrateMax = Math.min(this._clientConstraints.videoBitrateMax, constraints.videoBitrateMax);
                this._clientConstraints.videoFrameRateMax = Math.min(this._clientConstraints.videoFrameRateMax, constraints.videoFrameRateMax);
                this._clientConstraints.videoPixelCountMax = Math.min(this._clientConstraints.videoPixelCountMax, constraints.videoPixelCountMax);
            }
            else {
                // If we're not in a degraded state, update all of the values to the new server values
                this._clientConstraints.audioBitrateMax = this._serverConstraints.audioBitrateMax;
                this._clientConstraints.videoBitrateMax = this._serverConstraints.videoBitrateMax;
                this._clientConstraints.videoFrameRateMax = this._serverConstraints.videoFrameRateMax;
                this._clientConstraints.videoPixelCountMax = this._serverConstraints.videoPixelCountMax;
            }
        }
        await this.updateSenderParameters();
    }
    async updateMediaBindings() {
        await this.tryReplaceSenderTrack("audio", this._media?.audioTrack?.stream ?? null);
        await this.tryReplaceSenderTrack("video", this._media?.videoTrack?.stream ?? null);
    }
    async updateSenderParametersAudio() {
        const sender = this._transceivers.get("audio").transceiver.sender;
        const parameters = sender.getParameters();
        const encodings = this.getSenderEncodings(parameters);
        if (encodings && encodings.length > 0) {
            if (this._clientConstraints?.audioBitrateMax) {
                const maxBitrate = this._clientConstraints.audioBitrateMax * 1000;
                if (encodings[0].maxBitrate != maxBitrate) {
                    //void this.eventLogger.debug("updateSenderParametersAudio", "Setting origin ${this._mediaType} audio max bitrate...", null, {
                    //  maxBitrate: maxBitrate,
                    //});
                    encodings[0].maxBitrate = maxBitrate;
                }
            }
            encodings[0].priority = this._priorityAudio;
            try {
                await sender.setParameters(parameters);
            }
            catch (error) {
                void this.eventLogger.debug(error, "updateSenderParametersAudio", `Could not set origin ${this._mediaType} audio sender parameters.`);
            }
            Log.debug(`Sender Parameter Update: Enabled=${this._encodingEnabled}, Bitrate=${encodings[0].maxBitrate}, Priority=${encodings[0].priority}`);
        }
    }
    async updateSenderParametersVideo() {
        const sender = this._transceivers.get("video").transceiver.sender;
        const parameters = sender.getParameters();
        // Can't disable this so we tell WebRTC not to adjust resolution (best effort) - try to prevent PLIs from server
        parameters.degradationPreference = this._degradationPreference;
        const encodings = this.getSenderEncodings(parameters);
        if (encodings && encodings.length > 0) {
            if (this._clientConstraints?.videoBitrateMax) {
                const maxBitrate = Math.round(this._clientConstraints.videoBitrateMax * 1000);
                if (encodings[0].maxBitrate != maxBitrate) {
                    void this.eventLogger.debug("updateSenderParametersVideo", `Setting origin ${this._mediaType} video max bitrate...`, null, {
                        maxBitrate: maxBitrate,
                    });
                    encodings[0].maxBitrate = maxBitrate;
                }
            }
            if (this._clientConstraints?.videoFrameRateMax) {
                const maxFrameRate = this._clientConstraints.videoFrameRateMax;
                if (encodings[0].maxFramerate != maxFrameRate) {
                    void this.eventLogger.debug("updateSenderParametersVideo", `Setting origin ${this._mediaType} video max frame rate...`, null, {
                        maxFramerate: maxFrameRate,
                    });
                    encodings[0].maxFramerate = maxFrameRate;
                }
            }
            if (this._clientConstraints?.videoPixelCountMax) {
                const settings = sender.track?.getSettings();
                if (settings && settings.width && settings.height) {
                    const scaleResolutionDownBy = Math.max(1, Math.sqrt((settings.width * settings.height) / this._clientConstraints.videoPixelCountMax));
                    if (encodings[0].scaleResolutionDownBy != scaleResolutionDownBy) {
                        void this.eventLogger.debug("updateSenderParametersVideo", `Scaling down origin ${this._mediaType} video resolution...`, null, {
                            scaleResolutionDownBy: scaleResolutionDownBy,
                            videoWidth: settings.width,
                            videoHeight: settings.height,
                        });
                        encodings[0].scaleResolutionDownBy = scaleResolutionDownBy;
                    }
                }
            }
            encodings[0].active = this._encodingEnabled;
            encodings[0].priority = this._priorityVideo;
            encodings[0].networkPriority = this._priorityVideo;
            try {
                await sender.setParameters(parameters);
            }
            catch (error) {
                void this.eventLogger.debug(error, "updateSenderParametersVideo", `Could not set origin ${this._mediaType} video sender parameters.`);
            }
            Log.debug(`Sender Parameter Update: Enabled=${this._encodingEnabled}, Bitrate=${encodings[0].maxBitrate}, FrameRate=${encodings[0].maxFramerate}, ResolutionScale=${encodings[0].scaleResolutionDownBy}`);
        }
    }
    async updateSenderParameters() {
        await this.updateSenderParametersAudio();
        await this.updateSenderParametersVideo();
    }
    setPreferredAudioCodecsOrigin(audioTransceiver) {
        if (!this._supportsSetCodecPreferences || !this._redAudioEnabled) {
            return;
        }
        const { codecs } = RTCRtpSender.getCapabilities("audio");
        const redCodecIndex = codecs.findIndex((c) => c.mimeType === "audio/red");
        if (redCodecIndex == -1) {
            Log.info("audio/red codec not supported");
            return;
        }
        const redCodec = codecs[redCodecIndex];
        codecs.splice(redCodecIndex, 1);
        codecs.unshift(redCodec);
        const transceiver = audioTransceiver || this.connection.getTransceivers().find((x) => x.sender && x.sender.track.kind === "audio");
        transceiver.setCodecPreferences(codecs);
        Log.info(`audio/red codec preference set: ${JSON.stringify(codecs)}`);
    }
    setPreferredVideoCodecsOrigin(videoTransceiver) {
        if (!this._supportsSetCodecPreferences || this._mediaType === "display") {
            return;
        }
        const transceiver = videoTransceiver || this.connection.getTransceivers().find((x) => x.sender && x.sender.track.kind === "video");
        if (this._codec) {
            try {
                transceiver.setCodecPreferences([this._codec]);
                void this.eventLogger.information("setPreferredVideoCodecsOrigin", `Set preferred codec ${JSON.stringify(this._codec)} on ${this.type}`);
                return;
            }
            catch (err) {
                void this.eventLogger.error(err, "setPreferredVideoCodecsOrigin", `Failed to set preferred codec ${JSON.stringify(this._codec)} on ${this.type}. Using device preferred codecs`);
            }
        }
        const { codecs } = RTCRtpSender.getCapabilities("video");
        const preferredCodecs = CodecHelper.getCodecPriority(navigator.userAgent, this._preferredVideoCodec);
        let sortedCodecs = CodecHelper.getSenderVideoCodecs(codecs, preferredCodecs);
        try {
            transceiver.setCodecPreferences(sortedCodecs);
            void this.eventLogger.information("setPreferredVideoCodecsOrigin", `Set preferred codecs ${JSON.stringify(sortedCodecs)} on ${this.type}`);
        }
        catch (err) {
            if (err.name === "InvalidModificationError") {
                void this.eventLogger.warning(err, "setPreferredVideoCodecsOrigin", `Failed to set preferred codecs ${JSON.stringify(sortedCodecs)} on ${this.type}`);
            }
            try {
                transceiver.setCodecPreferences(sortedCodecs);
            }
            catch (err2) {
                void this.eventLogger.error(err2, "setPreferredVideoCodecsOrigin", `Failed to set filtered preferred codecs ${JSON.stringify(sortedCodecs)} on ${this.type}. Using browser defaults`);
            }
        }
    }
    async updateTransceiverDirections() {
        let updateOffer = false;
        if (this._media?.audioTrack?.stream) {
            if (this.trySetTransceiverDirection("audio", "sendonly"))
                updateOffer = true;
        }
        else {
            if (this.trySetTransceiverDirection("audio", "inactive"))
                updateOffer = true;
        }
        if (this._media?.videoTrack?.stream) {
            if (this.trySetTransceiverDirection("video", "sendonly"))
                updateOffer = true;
        }
        else {
            if (this.trySetTransceiverDirection("video", "inactive"))
                updateOffer = true;
        }
        if (!updateOffer || this.state == "new" || this.state == "closed")
            return;
        this.setPreferredVideoCodecsOrigin(this.getTransceiver("video"));
        let offer = (await this.connection.createOffer()).sdp;
        offer = await this.mungeOffer(offer);
        await this.connection.setLocalDescription({
            sdp: offer,
            type: "offer",
        });
        //TODO: use sendRequest once the server honors requests
        this.sendNotification({
            type: "offerUpdated",
            offer: offer,
        });
        this._answerUpdated = new PromiseCompletionSource();
        try {
            let answer = (await this._answerUpdated.promise).answer;
            answer = await this.mungeAnswer(answer);
            await this.connection.setRemoteDescription({
                sdp: answer,
                type: "answer",
            });
            await this.updateSenderParameters();
        }
        catch (error) {
            if (this._mediaType == "display")
                return; // display media rejected
            else
                Log.error(`Couldn't update transceiver directions. ${error}`);
        }
    }
    /** @internal */
    getSender(trackType) {
        Guard.isNotNullOrUndefined(trackType, "trackType");
        return this._transceivers.get(trackType).transceiver.sender;
    }
    setMaxAudio(trackType) {
        Guard.isNotNullOrUndefined(trackType, "trackType");
        return this._transceivers.get(trackType).transceiver.sender;
    }
    /** @internal */
    getTransceiver(trackType) {
        Guard.isNotNullOrUndefined(trackType, "trackType");
        return this._transceivers.get(trackType).transceiver;
    }
    /** @internal */
    async pauseInternal() {
        await this.tryReplaceSenderTrack("audio", null);
        await this.tryReplaceSenderTrack("video", null);
    }
    /** @internal */
    async resumeInternal() {
        await this.tryReplaceSenderTrack("audio", this._media?.audioTrack?.stream ?? null);
        await this.tryReplaceSenderTrack("video", this._media?.videoTrack?.stream ?? null);
    }
    getExcludedIceCandidates() {
        if (this._iceRestarting) {
            return [this._currentCandidateIp];
        }
        return [];
    }
    attachEventHandlers() {
        super.attachEventHandlers();
        this._mediaChannel.addEventListener("close", this._onMediaChannelClose);
        this._mediaChannel.addEventListener("closing", this._onMediaChannelClosing);
        this._mediaChannel.addEventListener("error", this._onMediaChannelError);
        this._mediaChannel.addEventListener("message", this._onMediaChannelMessage);
        this._mediaChannel.addEventListener("open", this._onMediaChannelOpen);
    }
    detachEventHandlers() {
        this._media?.stateChanged.unbind(this._onMediaStateChanged);
        this._media?.audioTrack?.streamBound.bind(this._onAudioTrackStreamBound);
        this._media?.audioTrack?.streamUnbound.bind(this._onAudioTrackStreamUnbound);
        this._media?.videoTrack?.streamBound.bind(this._onVideoTrackStreamBound);
        this._media?.videoTrack?.streamUnbound.bind(this._onVideoTrackStreamUnbound);
        this._mediaChannel.removeEventListener("close", this._onMediaChannelClose);
        this._mediaChannel.removeEventListener("closing", this._onMediaChannelClosing);
        this._mediaChannel.removeEventListener("error", this._onMediaChannelError);
        this._mediaChannel.removeEventListener("message", this._onMediaChannelMessage);
        this._mediaChannel.removeEventListener("open", this._onMediaChannelOpen);
        super.detachEventHandlers();
    }
    async negotiate(offer, abortSignal) {
        return (await this._client.negotiate({
            audioLevelInterval: this._audioLevelInterval,
            mediaType: this._mediaType,
            offer: offer,
            replicationCount: this._replicationCount,
        }, abortSignal)).answer;
    }
    async onOpened() {
        await super.onOpened();
        await this.updateMediaBindings();
        await this.updateTransceiverDirections();
        await this.updateSenderParameters();
    }
    onTerminated() {
        this._answerUpdated?.reject("Connection closed.");
        super.onTerminated();
    }
    processNotification(notification) {
        if (notification.type == "answerUpdated") {
            if (this._answerUpdated)
                this._answerUpdated.resolve(notification);
        }
        else if (notification.type == "constraintsUpdated") {
            void this._mediaNotificationQueue.dispatch(async () => {
                await this.updateConstraints(notification.constraints);
            });
        }
        else if (notification.type == "displayMediaRejected") {
            if (this._answerUpdated)
                this._answerUpdated.reject(new Error("Media rejected."));
            void this._mediaNotificationQueue.dispatch(async () => {
                await this._mediaRejected.dispatch({
                    connection: this,
                    media: this._media,
                    mediaType: this._mediaType,
                });
            });
        }
        else if (notification.type == "displayMediaReplaced") {
            void this._mediaNotificationQueue.dispatch(async () => {
                await this._mediaReplaced.dispatch({
                    connection: this,
                    media: this._media,
                    mediaType: this._mediaType,
                });
            });
        }
        else {
            void this.eventLogger.warning(null, "processNotification", `Unexpected ${notification.type} edge notification.`);
        }
    }
    async detectDegradation(track) {
        this._iceRestartBackoff--;
        if (!this._customBandwidthAdaptationEnabled) {
            Log.debug("Custom bandwidth adaptation is disabled");
            return;
        }
        if (!this._rampedUp || (Utility.isMobileBrowser() && !this._rampedUpMobile)) {
            Log.debug("Waiting for ramp up to complete");
            return;
        }
        const level = this.getDegradationLevel(this._media.videoTrack);
        const actualPixelCount = track.statVideo.Track_FrameHeight * track.statVideo.Track_FrameWidth;
        const availableBitrate = this._media.videoTrack.availableOutgoingBitrate ?? this._media.videoTrack.targetBitrate;
        const rtt = this._media.videoTrack.roundTripTime;
        let newAudioBitrate = this._clientConstraints.audioBitrateMax;
        let newVideoBitrate = this._clientConstraints.videoBitrateMax;
        let newFrameRate = this._clientConstraints.videoFrameRateMax;
        let newPixelCount = this._clientConstraints.videoPixelCountMax;
        let scale = false;
        const maxAudioBitrate = Math.min(this._maxAudioBitrate, this._serverConstraints.audioBitrateMax);
        const maxVideoBitrate = Math.min(this._maxBitrate, this._serverConstraints.videoBitrateMax);
        const maxFrameRate = Math.min(this._maxFrameRate, this._serverConstraints.videoFrameRateMax);
        const maxPixelCount = Math.min(this._maxPixelCount, this._serverConstraints.videoPixelCountMax);
        if (level === "none") {
            this._healthyChecks++;
            this._unhealthyChecks = 0;
            this._scalingBackoff = this.getScalingBackoff();
            if (this._currentLevel !== "high") {
                if (this._healthyChecks % 5 == 0) {
                    const healthyIntervals = this._healthyChecks / 5;
                    const bitrateStep = Math.max(this._minBitrateStep, newVideoBitrate * 0.1) * (Utility.isIOS() ? 1 : healthyIntervals);
                    // Recover audio first
                    if (newAudioBitrate != maxAudioBitrate) {
                        newAudioBitrate = maxAudioBitrate;
                    }
                    else {
                        newVideoBitrate = Math.min(availableBitrate, Math.min(maxVideoBitrate, newVideoBitrate + bitrateStep));
                        // Re-enable video once the network starts to recover
                        if (newVideoBitrate > this._availableBitrateThreshold) {
                            this._encodingEnabled = true;
                        }
                        // Only recover the framerate if the available bitrate is above 200kbps
                        // This prevents premature recovery on very slow/degraded networks and allows for a smoother experience for a longer duration
                        if (newVideoBitrate >= this._availableBitrateFrameRateRecoveryThreshold) {
                            if (Utility.isIOS()) {
                                newFrameRate = this._maxFrameRate;
                            }
                            else {
                                newFrameRate = Math.min(maxFrameRate, this.sanitizeFrameRate(Math.ceil(newFrameRate + (5 * healthyIntervals)), maxFrameRate));
                            }
                        }
                        let calculatedBitrate = VideoUtility.calculateBitrateUsingPixelCount(Math.min(maxPixelCount, actualPixelCount + this._minPixelCount), newFrameRate);
                        let buffer = Utility.isIOS() ? 1 : 1.1;
                        // If the target bitrate is greater than the bitrate required for the camera resolution + buffer
                        // We want to recover the resolution fast to prevent too many resolution changes and blips on the screen.
                        // So every cycle we try to significantly increase the pixel count but only if the newly calculated bitrate + buffer can handle it.
                        // Make sure the frame rate is also fully recovered before recovering resolution.
                        while (calculatedBitrate * buffer < newVideoBitrate && newPixelCount != maxPixelCount && newFrameRate == maxFrameRate) {
                            newPixelCount = Math.min(maxPixelCount, newPixelCount + this._minPixelCount);
                            calculatedBitrate = VideoUtility.calculateBitrateUsingPixelCount(Math.min(maxPixelCount, newPixelCount + this._minPixelCount), newFrameRate);
                            Log.debug(`Scaling up resolution: NewPixelCount=${newPixelCount}, PreviousPixelCount=${actualPixelCount}`);
                        }
                    }
                    scale = true;
                }
            }
        }
        else if (this._scalingBackoff <= 0) {
            this._healthyChecks = 0;
            this._unhealthyChecks++;
            this._currentLevel = level;
            if (level === "low") {
                // If the available bitrate is below 100kbps, the network must be really bad so we start sending the absolute minimum.
                // This may improve the experience at the edge of a WiFi network and on very slow/degraded networks
                if (availableBitrate < this._availableBitrateThreshold) {
                    newVideoBitrate = this._minBitrate;
                    newFrameRate = this.getFrameRate(level, newFrameRate, this._minFrameRateSevereDegradation);
                }
                else {
                    // If the bitrate is jumpy and inconsistent due to packet loss, make sure not to set it higher than the current bitrate if we're degraded
                    newVideoBitrate = Math.min(newVideoBitrate, Math.min(maxVideoBitrate, Math.max(this._minBitrate, availableBitrate)));
                    newFrameRate = this.getFrameRate(level, newFrameRate, this._minFrameRate);
                }
            }
            else if (level === "medium") {
                newVideoBitrate = Math.round(newVideoBitrate / 2);
                newFrameRate = this.getFrameRate(level, newFrameRate, this._minFrameRate);
            }
            else if (level === "step") {
                newVideoBitrate = Math.round(newVideoBitrate - Math.max(this._minBitrateStep, newVideoBitrate * 0.1));
                newFrameRate = this.getFrameRate(level, newFrameRate, this._minFrameRate);
            }
            // Don't fall below the minimum
            newVideoBitrate = Math.max(this._minBitrate, newVideoBitrate);
            newFrameRate = Math.max(this._minFrameRate, this.sanitizeFrameRate(newFrameRate, maxFrameRate));
            // Calculate the amount of bandwidth required to send video at the given constraints
            let calculatedBitrate = VideoUtility.calculateBitrateUsingPixelCount(actualPixelCount, newFrameRate);
            // If the bitrate required for the camera resolution is greater than the target bitrate, scale down the resolution
            while (calculatedBitrate > newVideoBitrate && newPixelCount != this._minPixelCount) {
                newPixelCount = Math.max(this._minPixelCount, newPixelCount - this._minPixelCount);
                calculatedBitrate = VideoUtility.calculateBitrateUsingPixelCount(newPixelCount, newFrameRate);
                Log.debug(`Scaling down resolution: NewPixelCount=${newPixelCount}, PreviousPixelCount=${actualPixelCount}`);
            }
            // Don't go above the available and leave a buffer of 15%
            if (newVideoBitrate > availableBitrate) {
                newVideoBitrate = Math.max(this._minBitrate, availableBitrate * 0.85);
            }
            this._scalingBackoff = this.getScalingBackoff();
            scale = true;
        }
        else {
            this._scalingBackoff--;
        }
        // If the network conditions are severely degraded, and we're still attempting to send media and conditions are not improving, disable the media track
        // in an attempt to help the network recover.
        if (newVideoBitrate < this._minBitrate && rtt > this._rttOffThreshold && this._recoveryTime >= this._recoveryThreshold) {
            Log.debug("Disabling video encoding");
            this._encodingEnabled = false;
            this._recoveryTime = 0;
            this._bitrateIncreases = 0;
            this._bitrateSteady = 0;
            scale = true;
        }
        else if (this.canEnableEncoding()) {
            Log.debug("Enabling video encoding");
            this._encodingEnabled = true;
            this._bitrateIncreases = 0;
            this._bitrateSteady = 0;
            scale = true;
        }
        if (newFrameRate == maxFrameRate && newVideoBitrate == maxVideoBitrate && newPixelCount == maxPixelCount && this._encodingEnabled) {
            this._currentLevel = "high";
        }
        // If RTT is unhealthy at any point, try an ICE restart in an attempt to find a better route and clear things up as long as we don't need to wait for the backoff
        // if (this._rttUnhealthyCount > this._iceRestartThreshold && this._iceRestartBackoff <= 0) {
        //   this._rttUnhealthyCount = 0;
        //   this._iceRestartBackoff = defaultIceRestartBackoff;
        //   await this.iceRestart();
        // }
        if (this._encodingEnabled) {
            this._recoveryTime++;
        }
        if (scale) {
            this._clientConstraints.audioBitrateMax = newAudioBitrate;
            this._clientConstraints.videoBitrateMax = newVideoBitrate;
            this._clientConstraints.videoFrameRateMax = newFrameRate;
            this._clientConstraints.videoPixelCountMax = newPixelCount;
            this._media.videoTrack.updateDegradationLevels(this.currentLevelVideoBitrate, this.currentLevelFrameRate, this.currentLevelPixelCount);
            this._media.audioTrack.currentLevelBitrate = this.currentLevelAudioBitrate;
            this.eventQueue.dispatch(async () => {
                await this.updateSenderParameters();
            });
        }
    }
    /**
     * Calculates a new frame rate based on the degradation level
     * @param level The degradation level
     * @param currentFrameRate The current frame rate
     * @param minFrameRate The minimum frame rate that can be used
     * @returns The newly calculated frame rate based on the degradation level that will be set on the encoder
     */
    getFrameRate(level, currentFrameRate, minFrameRate) {
        if (Utility.isIOS()) {
            return this._maxFrameRate;
        }
        let newFrameRate = currentFrameRate;
        if (level === "low") {
            newFrameRate = Math.min(newFrameRate, minFrameRate);
        }
        else if (level === "medium") {
            newFrameRate = Math.round(newFrameRate * (2 / 3));
        }
        else if (level === "step") {
            newFrameRate = Math.max(this._minFrameRate, newFrameRate - 3);
        }
        return newFrameRate;
    }
    getDegradationLevel(track) {
        const jitter = track.jitter;
        const packetLoss = track.getSenderPacketLoss();
        const packetsSent = track.currentPacketsSent;
        const nacks = track.nackCount;
        const nackPercentage = nacks / packetsSent;
        const plis = track.pliCount;
        const rtt = track.roundTripTime;
        const availableBitrate = this._media.videoTrack.availableOutgoingBitrate ?? this._media.videoTrack.targetBitrate;
        const maxBitrate = this._clientConstraints.videoBitrateMax;
        // If the available bitrate suddenly drops by more than 10% (20% for display media) even though all other conditions are fine, 
        // we need to step down. The algorithm will set the new bitrate to the available bitrate
        const bitrateDropModifier = this._mediaType == "display" ? 0.2 : 0.1;
        const bitrateDegraded = availableBitrate < (maxBitrate - (maxBitrate * bitrateDropModifier));
        let level = "none";
        // Keep a history of the RTT for the last 10 seconds to get an average
        this._rttHistory.unshift(rtt);
        if (this._rttHistory.length > this._rttHistorySize) {
            this._rttHistory.pop();
        }
        // TODO: Refactor logic into a class and add unit tests
        if (jitter >= this.getJitterThreshold("low") ||
            packetLoss > this._packetLossHighThreshold ||
            plis >= this._pliThresholdHigh ||
            nackPercentage >= this._nackHighThreshold) {
            // Scale immediately
            if (this._mediaType === "user") {
                this._scalingBackoff = 0;
            }
            else {
                this._scalingBackoff -= 1;
            }
            level = "low";
        }
        else if (jitter >= this.getJitterThreshold("medium") ||
            packetLoss >= this._packetLossMediumThreshold ||
            plis >= this._pliThresholdMedium ||
            nackPercentage >= this._nackMediumThreshold) {
            // See if we can handle this degradation for a another second
            if (this._mediaType === "user") {
                this._scalingBackoff -= 2;
            }
            level = "medium";
        }
        else if (bitrateDegraded ||
            jitter > this.getJitterThreshold("step") ||
            packetLoss >= this._packetLossLowThreshold ||
            plis >= this._pliThresholdLow ||
            nackPercentage >= this._nackLowThreshold) {
            if (this._mediaType === "user") {
                level = "step";
            }
        }
        // If the available bitrate dropped below the current max or the framerate suddenly degraded, scale immediately
        if (bitrateDegraded && this._mediaType === "user") {
            this._scalingBackoff = 0;
        }
        if (level !== "none") {
            Log.debug(`Degradation Stats: Level=${level}, Jitter=${jitter}, PacketLoss=${packetLoss}, NACKs=${nackPercentage}, PLIs=${plis}, RTT=${rtt}, BitrateDegraded=${bitrateDegraded}`);
        }
        return level;
    }
    getScalingBackoff() {
        return this._mediaType == "display" ? defaultScalingBackoffDisplay : defaultScalingBackoffUser;
    }
    /**
     * This method returns a jitter threshold based on if RTT is high or low.
     * The degradation level passed in is the target threshold we want to check for.
     * @param level The target degradation level
     * @returns The jitter threshold to check for
     */
    getJitterThreshold(level) {
        const rttAverage = this._rttHistory.reduce((total, current) => total + current) / this._rttHistory.length;
        if (rttAverage > this._rttAverageThreshold) {
            if (level === "low") {
                return this._jitterRttHighThreshold;
            }
            else if (level === "medium") {
                return this._jitterRttMediumThreshold;
            }
            else {
                return this._jitterRttLowThreshold;
            }
        }
        else {
            if (level === "low") {
                return this._jitterHighThreshold;
            }
            else if (level === "medium") {
                return this._jitterMediumThreshold;
            }
            else {
                return this._jitterLowThreshold;
            }
        }
    }
    sanitizeFrameRate(frameRate, maxFrameRate) {
        if (!Utility.isIOS()) {
            return frameRate;
        }
        /* IOS does not respect different frame rates other than 10, 15, and 30
          so we calculate the closest value we should set it to based on incoming frame rate.
          Less frame rate changes on iOS prevent chopiness because the the camera constraints change when the encoder constraints change (theory).
          Ex. frameRate==14: Math.round(14 / 10) = Math.round(1.4) = 1 * 10 = 10: Set to 10 (minimum)
          Ex. frameRate==18: Math.round(18 / 10) = Math.round(1.8) = 2 * 10 = 20: Set to 15 (median)
          Ex. frameRate==22: Math.round(22 / 10) = Math.round(2.2) = 2 * 10 = 20: Set to 15 (median)
          Ex. frameRate==25: Math.round(25 / 10) = Math.round(2.5) = 3 * 10 = 30: Set to 25 (max)
        */
        const estimatedFrameRate = Math.round(frameRate / 10) * 10;
        if (estimatedFrameRate == this._minFrameRate) {
            return this._minFrameRate;
        }
        else if (estimatedFrameRate < maxFrameRate) {
            return medianIOSFrameRate;
        }
        else {
            return maxFrameRate;
        }
    }
    canEnableEncoding() {
        let bitrateDecreasing = false;
        let bitrateIncreasing = false;
        if (this._media.videoTrack.targetBitrate > 0) {
            bitrateDecreasing = this._media.videoTrack.didTargetBitrateDecrease();
            bitrateIncreasing = this._media.videoTrack.didTargetBitrateIncrease();
        }
        else if (this._media.videoTrack.availableOutgoingBitrate > 0) {
            bitrateDecreasing = this._media.videoTrack.didAvailableOutgoingBitrateDecrease();
            bitrateIncreasing = this._media.videoTrack.didAvailableOutgoingBitrateIncrease();
        }
        if (!bitrateDecreasing) {
            this._bitrateSteady++;
        }
        else {
            this._bitrateSteady = 0;
            this._bitrateIncreases = 0;
        }
        if (this._bitrateSteady > this._bitrateSteadyThreshold) {
            this._bitrateSteady = 0;
            bitrateIncreasing = true;
        }
        if (bitrateIncreasing) {
            this._bitrateIncreases++;
        }
        Log.debug(`Bitrate Stats: Steady=${this._bitrateSteady}, Increases=${this._bitrateIncreases}`);
        if (this._bitrateIncreases >= this._bitrateIncreasesThreshold && !this._encodingEnabled) {
            return true;
        }
        return false;
    }
    async renegotiate(offer, abortSignal) {
        return (await this._client.renegotiate({
            mediaType: this._mediaType,
            offer: offer,
        }, abortSignal)).answer;
    }
    setMedia(media) {
        return this.eventQueue.dispatch(async () => {
            if (this._media == media)
                return;
            if (media?.connection && media.connection != this)
                await media.connection.setMedia(null);
            if (this._media) {
                this._media.stateChanged.unbind(this._onMediaStateChanged);
                this._media.audioTrack?.streamBound.unbind(this._onAudioTrackStreamBound);
                this._media.audioTrack?.streamUnbound.unbind(this._onAudioTrackStreamUnbound);
                this._media.videoTrack?.frameSizeChanged.unbind(this._onVideoTrackFrameSizeChanged);
                this._media.videoTrack?.streamBound.unbind(this._onVideoTrackStreamBound);
                this._media.videoTrack?.streamUnbound.unbind(this._onVideoTrackStreamUnbound);
                this._media.connection = null;
            }
            this._media = media;
            if (this._media) {
                this._media.stateChanged.bind(this._onMediaStateChanged);
                this._media.audioTrack?.streamBound.bind(this._onAudioTrackStreamBound);
                this._media.audioTrack?.streamUnbound.bind(this._onAudioTrackStreamUnbound);
                this._media.videoTrack?.frameSizeChanged.bind(this._onVideoTrackFrameSizeChanged);
                this._media.videoTrack?.streamBound.bind(this._onVideoTrackStreamBound);
                this._media.videoTrack?.streamUnbound.bind(this._onVideoTrackStreamUnbound);
                this._media.connection = this;
            }
            await this.updateMediaBindings();
            await this.updateTransceiverDirections();
        });
    }
    setPriorityAudio(priorityAudio) {
        Guard.isNotNullOrUndefined(priorityAudio, "priorityAudio");
        return this.eventQueue.dispatch(async () => {
            if (this._priorityAudio == priorityAudio)
                return;
            this._priorityAudio = priorityAudio;
            await this.updateSenderParametersAudio();
        });
    }
    setPriorityVideo(priorityVideo) {
        Guard.isNotNullOrUndefined(priorityVideo, "priorityVideo");
        return this.eventQueue.dispatch(async () => {
            if (this._priorityVideo == priorityVideo)
                return;
            this._priorityVideo = priorityVideo;
            await this.updateSenderParametersVideo();
        });
    }
    async updateStats() {
        if (this.isTerminated)
            return;
        //TODO: defensive cof
        const senderList = this.connection.getSenders();
        for (const sender of senderList) {
            if (sender.track != null) {
                //pull sender stats
                const statReport = await sender.getStats();
                const pairStat = new StatisticConnection();
                pairStat.AttendeeId = this.attendeeId;
                //first collect pair details
                for (const [key, value] of statReport.entries()) {
                    if (value.type == "candidate-pair") {
                        pairStat.Pair_Id = value.id;
                        pairStat.Pair_Timestamp = value.timestamp;
                        pairStat.Pair_BytesReceived = value.bytesReceived;
                        pairStat.Pair_BytesSent = value.bytesSent;
                        pairStat.Pair_RoundTripTimeCurrent = value.currentRoundTripTime;
                        pairStat.Pair_RoundTripTimeTotal = value.totalRoundTripTime;
                        pairStat.Pair_AvailableOutgoing = Math.round(value.availableOutgoingBitrate / 1000);
                        pairStat.Pair_RequestsReceived = value.requestsReceived;
                        pairStat.Pair_RequestsSent = value.requestsSent;
                        pairStat.Pair_ResponsesReceived = value.responsesReceived;
                        pairStat.Pair_ResponsesSent = value.responsesSent;
                        pairStat.Pair_ConsentRequestsSent = value.consentRequestsSent;
                        pairStat.Pair_IsNominated = value.nominated;
                    }
                    if (value.type == "remote-candidate") {
                        pairStat.Rmt_Id = value.id;
                        pairStat.Rmt_IsRemote = value.isRemote;
                        pairStat.Rmt_Ip = value.ip ?? value.address;
                        pairStat.Rmt_Port = value.port;
                        pairStat.Rmt_Protocol = value.protocol;
                        pairStat.Rmt_CandidateType = value.candidateType;
                        pairStat.Rmt_IsDeleted = value.deleted;
                        if (!pairStat.Rmt_Ip) {
                            pairStat.Rmt_Ip = this._currentIceCandidateRemoteIp;
                        }
                    }
                    if (value.type == "local-candidate") {
                        pairStat.Lcl_Id = value.id;
                        pairStat.Lcl_IsRemote = value.isRemote;
                        pairStat.Lcl_Ip = value.ip ?? value.address;
                        pairStat.Lcl_Port = value.port;
                        pairStat.Lcl_Protocol = value.protocol;
                        pairStat.Lcl_CandidateType = value.candidateType;
                        pairStat.Lcl_Deleted = value.deleted;
                        pairStat.Lcl_NetworkAdapterType = value.networkAdapterType;
                        pairStat.Lcl_NetworkType = value.networkType;
                        if (!pairStat.Lcl_NetworkType && pairStat.Lcl_Ip) {
                            const candidate = this._currentIceCandidates.find(x => x.address == pairStat.Lcl_Ip);
                            if (candidate) {
                                if (candidate.wifiCandidate) {
                                    pairStat.Lcl_NetworkAdapterType = "wifi";
                                    pairStat.Lcl_NetworkType = "wifi";
                                }
                                else if (candidate.lanCandidate) {
                                    pairStat.Lcl_NetworkAdapterType = "lan";
                                    pairStat.Lcl_NetworkType = "lan";
                                }
                                else {
                                    pairStat.Lcl_NetworkAdapterType = "cellular";
                                    pairStat.Lcl_NetworkType = "cellular";
                                }
                            }
                        }
                        if (sender.track.kind == "video") {
                            if (this._currentCandidateIp) {
                                if (this._currentCandidateIp != pairStat.Lcl_Ip || this._currentCandidateNetworkType != pairStat.Lcl_NetworkType) ;
                            }
                            this._currentCandidateIp = pairStat.Lcl_Ip;
                            this._currentCandidateNetworkAdapterType = pairStat.Lcl_NetworkAdapterType;
                            this._currentCandidateNetworkType = pairStat.Lcl_NetworkType;
                        }
                    }
                } //each entry
                if (sender.track.kind == "audio") {
                    const audioStat = new StatisticAudio();
                    audioStat.AttendeeId = this.attendeeId;
                    //NOTE: on server: Attendee.DeviceId;
                    audioStat.MediaType = this._mediaType;
                    audioStat.CreatedOn = new Date();
                    audioStat.TrackIndex = 0;
                    audioStat.IsClient = true;
                    audioStat.IsMuted = !sender.track.enabled;
                    //? audioStat.IsNoiseSuppressed = _isAudioNoiseSuppressed;
                    //? audioStat.IsPaused = _isAudioPaused;
                    audioStat.BitrateConstraint = this.audioBitrateMax;
                    //TODO: BitrateAllocation, BitrateServer
                    //FramerateActual, FramerateConstraint, FramerateEstimated, FramerateServer
                    for (const [key, value] of statReport.entries()) {
                        if (value.type == "media-source") {
                            audioStat.Src_AudioLevel = value.audioLevel;
                            audioStat.Src_TotalAudioEnergy = value.totalAudioEnergy;
                            audioStat.Src_TotalSamplesDuration = value.totalSamplesDuration;
                            if (audioStat.Src_AudioLevel != null) {
                                this._media?.audioTrack?.updateLevel(audioStat.Src_AudioLevel);
                            }
                        }
                        if (value.type == "codec") {
                            audioStat.Codec_MimeType = value.mimeType;
                            audioStat.Codec_Channels = value.channels;
                            audioStat.Codec_ClockRate = value.clockRate;
                            audioStat.Codec_SdpFmtpLine = value.sdpFmtpLine;
                        }
                        if (value.type == "outbound-rtp") {
                            audioStat.Rtp_Kind = value.kind;
                            audioStat.Rtp_SSRC = value.ssrc;
                            audioStat.TrackIdentifier = value.mediaSourceId;
                            audioStat.TrackMid = value.mid;
                            audioStat.Rtp_PacketsSent = value.packetsSent;
                            audioStat.Rtp_RetransmittedPacketsSent = value.retransmittedPacketsSent;
                            audioStat.Rtp_BytesSent = value.bytesSent;
                            audioStat.Rtp_HeaderBytesSent = value.headerBytesSent;
                            audioStat.Rtp_RetransmittedBytesSent = value.retransmittedBytesSent;
                            audioStat.Rtp_TotalPacketSendDelay = value.totalPacketSendDelay;
                            audioStat.Rtp_NackCount = value.nackCount;
                            audioStat.BitrateEstimated = Math.round(value.targetBitrate / 1000);
                            audioStat.BitrateActual = this._bitrateAudio.calculate(audioStat.Rtp_BytesSent, value.timestamp);
                        }
                        if (value.type == "remote-inbound-rtp") {
                            audioStat.Rtp_Timestamp = value.timestamp;
                            audioStat.Rtp_PacketsLost = value.packetsLost;
                            audioStat.Rtp_Jitter = Math.round(value.jitter * 1000);
                            audioStat.Rtp_RoundTripTime = Math.round(value.roundTripTime * 1000);
                            audioStat.Rtp_RoundTripTimeMeasurements = value.roundTripTimeMeasurements;
                            audioStat.Rtp_RoundTripTimeTotal = value.totalRoundTripTime;
                        }
                        if (value.type == "transport") {
                            audioStat.Transport_Timestamp = value.timestamp;
                            audioStat.Transport_BytesSent = value.bytesSent;
                            audioStat.Transport_BytesReceived = value.bytesReceived;
                            audioStat.Transport_PacketsSent = value.packetsSent;
                            audioStat.Transport_PacketsReceived = value.packetsReceived;
                            audioStat.Transport_State = value.dtlsState;
                        }
                    } //foreach entry
                    //only save the stat every polling interval
                    if (this._currentStatCount % this._statsInterval === 0) {
                        const sectionsAudio = [];
                        for (const stats of statReport.values()) {
                            if (stats.type != "certificate" && stats.type != "candidate-pair" && stats.type != "local-candidate" && stats.type != "remote-candidate") {
                                //NOTE: debugging only, makes huge results
                                //sectionsVideo.push(stats);
                                sectionsAudio.push(stats.type);
                            }
                        }
                        audioStat.Json = JSON.stringify(sectionsAudio, null, 2);
                        this._statsBatchAudio.push(audioStat);
                    }
                    this._media.audioTrack.updateStats(audioStat, pairStat);
                    const track = this._transceivers.get("audio");
                    if (track) {
                        track.statAudio = audioStat;
                    }
                } //audio
                if (sender.track.kind == "video") {
                    const videoStat = new StatisticVideo();
                    videoStat.AttendeeId = this.attendeeId;
                    //NOTE: on server: Attendee.DeviceId;
                    videoStat.MediaType = this._mediaType;
                    videoStat.CreatedOn = new Date();
                    videoStat.TrackIndex = 0;
                    videoStat.SpatialLayerIndex = 0; //only stats for the incoming
                    videoStat.TemporalLayerIndex = 0;
                    videoStat.IsClient = true;
                    videoStat.IsMuted = !sender.track.enabled;
                    //? videoStat.IsPaused = ;
                    //? videoStat.IsDisabled = ;
                    videoStat.BitrateConstraint = Math.round(this._clientConstraints.videoBitrateMax);
                    videoStat.FramerateConstraint = Math.round(this._clientConstraints.videoFrameRateMax);
                    videoStat.PixelCountConstraint = Math.round(this._clientConstraints.videoPixelCountMax);
                    videoStat.BitrateEstimated = Math.round(this._estimatedConstraints.videoBitrateMax);
                    videoStat.FramerateEstimated = Math.round(this._estimatedConstraints.videoFrameRateMax);
                    videoStat.PixelCountEstimated = Math.round(this._estimatedConstraints.videoPixelCountMax);
                    videoStat.BitrateServer = Math.round(this._serverConstraints.videoBitrateMax);
                    videoStat.FramerateServer = Math.round(this._serverConstraints.videoFrameRateMax);
                    videoStat.PixelCountServer = Math.round(this._serverConstraints.videoPixelCountMax);
                    videoStat.BitrateAllocation = pairStat.Pair_AvailableOutgoing;
                    for (const [key, value] of statReport.entries()) {
                        if (value.type == "codec") {
                            videoStat.Codec_MimeType = value.mimeType;
                            videoStat.Codec_Channels = value.channels;
                            videoStat.Codec_ClockRate = value.clockRate;
                            videoStat.Codec_SdpFmtpLine = value.sdpFmtpLine;
                        }
                        if (value.type == "outbound-rtp") {
                            videoStat.Rtp_Kind = value.kind;
                            videoStat.Rtp_SSRC = value.ssrc;
                            videoStat.Rtp_IsRemote = value.isRemote;
                            videoStat.TrackIdentifier = value.mediaSourceId;
                            videoStat.TrackMid = value.mid;
                            videoStat.Rtp_FirCount = value.firCount;
                            videoStat.Rtp_PliCount = value.pliCount;
                            videoStat.Rtp_NackCount = value.nackCount;
                            videoStat.Track_FrameWidth = value.frameWidth;
                            videoStat.Track_FrameHeight = value.frameHeight;
                            /*
                            if (videoStat.ResolutionHeight == null) videoStat.ResolutionHeight = value.frameHeight;
                            if (videoStat.ResolutionWidth == null) videoStat.ResolutionWidth = value.frameWidth;
                            */
                            videoStat.Rtp_PacketsSent = value.packetsSent;
                            videoStat.Rtp_RetransmittedPacketsSent = value.retransmittedPacketsSent;
                            videoStat.Rtp_BytesSent = value.bytesSent;
                            videoStat.Rtp_HeaderBytesSent = value.headerBytesSent;
                            videoStat.Rtp_RetransmittedBytesSent = value.retransmittedBytesSent;
                            videoStat.Rtp_FramesEncoded = value.framesEncoded;
                            videoStat.Rtp_KeyFramesEncoded = value.keyFramesEncoded;
                            videoStat.Rtp_TotalEncodeTime = value.totalEncodeTime;
                            videoStat.Rtp_TotalEncodedBytesTarget = value.totalEncodedBytesTarget;
                            videoStat.Rtp_TotalPacketSendDelay = value.totalPacketSendDelay;
                            videoStat.Rtp_FramesPerSecond = value.framesPerSecond;
                            videoStat.Rtp_FramesSent = value.framesSent;
                            videoStat.Rtp_HugeFramesSent = value.hugeFramesSent;
                            videoStat.Rtp_QualityLimitationChanges = value.qualityLimitationResolutionChanges;
                            videoStat.Rtp_QualityLimitationReason = value.qualityLimitationReason;
                            videoStat.Rtp_QualityLimitationDurations = JSON.stringify(value.qualityLimitationDurations);
                            videoStat.Rtp_EncoderImplementation = value.encoderImplementation;
                            videoStat.Rtp_QpSum = value.qpSum;
                            videoStat.Rtp_IsPowerEfficient = value.powerEfficientEncoder;
                            videoStat.Rtp_ScalabilityMode = value.scalabilityMode;
                            videoStat.Rtp_TargetBitrate = Math.round(value.targetBitrate / 1000);
                            videoStat.BitrateEstimated = Math.round(value.targetBitrate / 1000);
                            videoStat.BitrateActual = this._bitrateVideo.calculate(videoStat.Rtp_BytesSent, value.timestamp);
                            if (videoStat.Rtp_FramesPerSecond) {
                                videoStat.FramerateActual = videoStat.Rtp_FramesPerSecond;
                            }
                            else {
                                videoStat.FramerateActual = this._framerateVideo.calculate(videoStat.Rtp_FramesSent, value.timestamp);
                            }
                        }
                        if (value.type == "remote-inbound-rtp") {
                            videoStat.Rtp_Timestamp = value.timestamp;
                            videoStat.Rtp_PacketsLost = value.packetsLost;
                            videoStat.Rtp_Jitter = Math.round(value.jitter * 1000);
                            videoStat.Rtp_RoundTripTime = Math.round(value.roundTripTime * 1000);
                            videoStat.Rtp_RoundTripTimeMeasurements = value.roundTripTimeMeasurements;
                            videoStat.Rtp_RoundTripTimeTotal = value.totalRoundTripTime;
                        }
                        if (value.type == "media-source") {
                            videoStat.Src_FramesPerSecond = value.framesPerSecond;
                            videoStat.Src_Frames = value.frames;
                            if (videoStat.ResolutionHeight == null)
                                videoStat.ResolutionHeight = value.height;
                            if (videoStat.ResolutionWidth == null)
                                videoStat.ResolutionWidth = value.width;
                        }
                        if (value.type == "transport") {
                            videoStat.Transport_Timestamp = value.timestamp;
                            videoStat.Transport_BytesSent = value.bytesSent;
                            videoStat.Transport_BytesReceived = value.bytesReceived;
                            videoStat.Transport_PacketsSent = value.packetsSent;
                            videoStat.Transport_PacketsReceived = value.packetsReceived;
                            videoStat.Transport_State = value.dtlsState;
                        }
                    } //foreach entry
                    //aggregations
                    if (videoStat.ResolutionHeight == null) {
                        videoStat.ResolutionHeight = videoStat.Track_FrameHeight;
                    }
                    if (videoStat.ResolutionWidth == null) {
                        videoStat.ResolutionWidth = videoStat.Track_FrameWidth;
                    }
                    if (videoStat.Track_FrameHeight != null && videoStat.Track_FrameWidth != null) {
                        videoStat.PixelCountActual = videoStat.Track_FrameHeight * videoStat.Track_FrameWidth;
                    }
                    if (videoStat.ResolutionHeight != null && videoStat.ResolutionWidth != null) {
                        videoStat.PixelCountEstimated = videoStat.ResolutionHeight * videoStat.ResolutionWidth;
                    }
                    //only save the stat every polling interval
                    if (this._currentStatCount % this._statsInterval === 0) {
                        const sectionsVideo = [];
                        for (const stats of statReport.values()) {
                            if (stats.type != "certificate" && stats.type != "candidate-pair" && stats.type != "local-candidate" && stats.type != "remote-candidate") {
                                //NOTE: debugging only, makes huge results
                                //sectionsVideo.push(stats);
                                sectionsVideo.push(stats.type);
                            }
                        }
                        videoStat.Json = JSON.stringify(sectionsVideo, null, 2);
                        this._statsBatchVideo.push(videoStat);
                    }
                    this._media.videoTrack.updateStats(videoStat, pairStat);
                    const track = this._transceivers.get("video");
                    if (track) {
                        if (videoStat.Rtp_BytesSent > 0) {
                            this._currentRampUpSeconds++;
                            const availableBitrate = pairStat.Pair_AvailableOutgoing ?? videoStat.Rtp_TargetBitrate;
                            // If the available bitrate is lower than the current constraint, set ramped up to be true so that any degradation logic can proceed
                            this._rampedUp = this._currentRampUpSeconds >= this._rampUpSeconds || availableBitrate < videoStat.BitrateConstraint;
                            this._rampedUpMobile = this._currentRampUpSeconds >= this._rampUpSecondsMobile || availableBitrate < videoStat.BitrateConstraint;
                        }
                        track.statVideo = videoStat;
                        await this.detectDegradation(track);
                    }
                } //video
            } //has track
        } //foreach sender
        this._currentStatCount++;
        if (this._currentStatCount % this._statsBatchSize === 0) {
            try {
                const batchAudio = this._statsBatchAudio.splice(0);
                const batchVideo = this._statsBatchVideo.splice(0);
                this.sendNotification({
                    type: "clientStats",
                    audioStatsDeflate: Utility.deflate(JSON.stringify(batchAudio)),
                    videoStatsDeflate: Utility.deflate(JSON.stringify(batchVideo)),
                });
            }
            catch (err) {
                void this.eventLogger.error(err, "sendOriginClientStats", err.message, null);
            }
        }
    } //updateStats
}

class Manager extends Manager$2 {
    get maxRetries() { return this._client.maxRetries; }
    set maxRetries(value) { this._client.maxRetries = value; }
    get media() { return this._media; }
    get requestTimeout() { return this._client.requestTimeout; }
    set requestTimeout(value) { this._client.requestTimeout = value; }
    constructor() {
        super();
        this._media = null;
        this._onMediaRejected = this.onMediaRejected.bind(Reactive.wrap(this));
        this._onMediaReplaced = this.onMediaReplaced.bind(Reactive.wrap(this));
    }
    init(init) {
        super.initialize({
            attendeeId: init.attendeeId,
            tenantSettings: init.tenantSettings,
            eventLogger: new Logger(init.apiClient, "OriginManager", init.attendeeId, init.meetingId, init.clusterId),
            meetingId: init.meetingId,
            redAudioEnabled: init.redAudioEnabled,
            room: init.room,
            type: "origin",
            url: init.originServerUrl
        });
        this._init = init;
        this._client = new Client$1(init);
    }
    async onMediaRejected() {
        const media = this.media;
        if (!media)
            return;
        await media.stop();
        void this.eventLogger?.debug("onMediaRejected", `Local ${media.type} media has been rejected and stopped.`);
    }
    async onMediaReplaced() {
        const media = this.media;
        if (!media)
            return;
        await media.stop();
        void this.eventLogger?.debug("onMediaReplaced", `Local ${media.type} media has been replaced and stopped.`);
    }
    /** @internal */
    pauseInternal() {
        return this.connection?.pauseInternal();
    }
    /** @internal */
    resumeInternal() {
        return this.connection?.resumeInternal();
    }
    async createConnection() {
        const connection = new Connection(Object.assign({
            attendeeId: this.attendeeId,
            client: this._client,
            tenantSettings: this.tenantSettings,
            meetingId: this.meetingId,
        }, this._init));
        connection.mediaRejected.bind(this._onMediaRejected);
        connection.mediaReplaced.bind(this._onMediaReplaced);
        if (this.media)
            await connection.setMedia(this._media);
        return connection;
    }
    destroyConnection(connection) {
        connection.mediaRejected.unbind(this._onMediaRejected);
        connection.mediaReplaced.unbind(this._onMediaReplaced);
    }
    //public getSenderStats(trackType: TrackType): TrackStats {
    //  return this.connection?.getSenderStats(trackType);
    //}
    async setMedia(media, attendee, closing, abortSignal) {
        if (media == this._media)
            return;
        if (media) {
            Guard.isNotNullOrUndefined(attendee, "attendee");
            this._media = media;
            await media.bindAttendee(attendee);
            media.room = this.room;
            // synchronize muted state
            // - if attendee is muted and local media is not, mute local media
            // - if local media is muted and attendee is not, mute attendee
            if (media.type == "user") {
                const userMedia = media;
                const audioTrack = userMedia.audioTrack;
                if (audioTrack) {
                    if (attendee.isAudioMuted && !audioTrack.isMuted)
                        audioTrack.muteInternal();
                    if (!attendee.isAudioMuted && audioTrack.isMuted)
                        await attendee.muteAudio();
                }
                const videoTrack = userMedia.videoTrack;
                if (videoTrack) {
                    if (attendee.isVideoMuted && !videoTrack.isMuted)
                        videoTrack.muteInternal();
                    if (!attendee.isVideoMuted && videoTrack.isMuted)
                        await attendee.muteVideo();
                }
            }
            await this.connection?.setMedia(media);
        }
        else {
            if (!closing)
                await this.connection?.setMedia(null);
            this._media.unbindAttendee();
            this._media = null;
        }
    }
}

class RTCMissingError extends Error {
    constructor(message) {
        super(message);
        this.name = "RTCMissingError";
    }
}

class SubscribedAttendeeCollection extends ReadOnlyCollection {
    /** @internal */
    constructor() {
        super(attendee => attendee.id);
    }
    /** @internal */
    load(init) {
        Guard.isNotNullOrUndefined(init, "init");
        Guard.isNotNullOrUndefined(init.controlConnection, "init.controlConnection");
        Guard.isNotNullOrUndefined(init.meeting, "init.meeting");
        this._controlConnection = init.controlConnection;
        this._meeting = init.meeting;
    }
    /** @internal */
    async pinAttendee(attendee) {
        const subscribedAttendee = this.get(attendee.id);
        if (!subscribedAttendee) {
            const pinnedAttendee = new Attendee({
                controlConnection: this._controlConnection,
                isLocal: this._meeting.localAttendee.id == attendee.id,
                model: attendee,
                meeting: this._meeting,
            });
            pinnedAttendee.isPinned = true;
            this.tryAdd(pinnedAttendee);
        }
        else {
            subscribedAttendee.isPinned = true;
        }
    }
    /** @internal */
    processResponse(attendees) {
        attendees.values.forEach((a) => {
            const attendee = this.get(a.id);
            if (!attendee) {
                const joinedAttendee = new Attendee({
                    controlConnection: this._controlConnection,
                    isLocal: this._meeting.localAttendee.id == a.id,
                    model: a,
                    meeting: this._meeting,
                });
                this.tryAdd(joinedAttendee);
            }
            else {
                attendee.model = a;
            }
        });
    }
    /** @internal */
    async subscribeToAttendee(attendeeId, reason) {
        let subscribedAttendee = this.get(attendeeId);
        if (!subscribedAttendee) {
            // tell the server that we need to be subscribed to this attendee
            const msg = await this._controlConnection.subscribeToAttendee(attendeeId, reason);
            subscribedAttendee = new Attendee({
                controlConnection: this._controlConnection,
                isLocal: this._meeting.localAttendee.id == msg.attendee.id,
                model: msg.attendee,
                meeting: this._meeting,
            });
            this.tryAdd(subscribedAttendee);
        }
        return subscribedAttendee;
    }
    /** @internal */
    tryAddAttendee(attendee) {
        if (!attendee)
            return false;
        const subscribedAttendee = new Attendee({
            controlConnection: this._controlConnection,
            isLocal: this._meeting.localAttendee.id == attendee.id,
            model: attendee,
            meeting: this._meeting,
        });
        return this.tryAdd(subscribedAttendee);
    }
    /** @internal */
    async unpinAttendee(attendeeId) {
        const pinnedAttendee = this.get(attendeeId);
        if (pinnedAttendee) {
            pinnedAttendee.isPinned = false;
        }
    }
}

class Client {
    get maxRetries() { return this._httpClient.maxRetries; }
    set maxRetries(value) { this._httpClient.maxRetries = value; }
    get requestTimeout() { return this._httpClient.requestTimeout; }
    set requestTimeout(value) { this._httpClient.requestTimeout = value; }
    constructor(init) {
        Guard.isNotNullOrUndefined(init, "init");
        Guard.isNotNullOrUndefined(init.meetingSession, "init.meetingSession");
        Guard.isNotNullOrUndefined(init.turnServerUrl, "init.turnServerUrl");
        this._init = init;
        this._httpClient = HttpClient.withTokenFactory(async () => {
            const token = await this._init.meetingSession.token();
            return {
                baseUrl: new URL(this._init.turnServerUrl).origin,
                value: token.value
            };
        });
    }
    async getCredentials(abortSignal) {
        return (await this._httpClient.get("/credentials?munge=true", abortSignal)).value.credentials;
    }
    async setIceInfo(iceInfo, abortSignal) {
        await this._httpClient.post("/ice", {
            localPassword: iceInfo.localPassword,
            localUsernameFragment: iceInfo.localUsernameFragment,
            relayPorts: iceInfo.relayPorts,
            remoteIPAddress: iceInfo.remoteIPAddress,
            remotePassword: iceInfo.remotePassword,
            remoteUsernameFragment: iceInfo.remoteUsernameFragment,
        }, abortSignal);
    }
}

class Session {
    get maxRetries() { return this._client.maxRetries; }
    set maxRetries(value) { this._client.maxRetries = value; }
    get requestTimeout() { return this._client.requestTimeout; }
    set requestTimeout(value) { this._client.requestTimeout = value; }
    constructor(init) {
        Guard.isNotNullOrUndefined(init, "init");
        this._client = new Client(init);
        this._tcpAllowed = init.tcpAllowed;
        this._tlsAllowed = init.tlsAllowed;
        this._udpAllowed = init.udpAllowed;
    }
    async iceServer(abortSignal) {
        const credentials = await this.credentials(abortSignal);
        const uris = [];
        for (const uri of credentials.uris) {
            const isSecure = uri.startsWith("turns:");
            const isUdp = uri.endsWith("?transport=udp");
            if (!this._tcpAllowed && !isUdp && !isSecure)
                continue;
            if (!this._tlsAllowed && !isUdp && isSecure)
                continue;
            if (!this._udpAllowed && isUdp)
                continue;
            uris.push(uri);
        }
        return {
            credential: credentials.password,
            urls: uris,
            username: credentials.username,
        };
    }
    async credentials(abortSignal) {
        if (this._credentials && this._credentialsRefreshAfterTime && new Date().getTime() < this._credentialsRefreshAfterTime)
            return this._credentials;
        this._credentials = await this._client.getCredentials(abortSignal);
        this._credentialsRefreshAfterTime = new Date().getTime() + (this._credentials.ttl * 1000) - 60000; // within 1 minute of expiring
        for (let i = 0; i < this._credentials.uris.length; i++) {
            const uri = this._credentials.uris[i];
            if (uri.indexOf("?transport=") != -1)
                continue;
            const uriUdp = `${uri}?transport=udp`;
            const uriTcp = `${uri}?transport=tcp`;
            Log.info(`Transforming TURN URI from ${uri} to ${uriUdp} and ${uriTcp}`);
            this._credentials.uris.splice(i, 1, uriUdp, uriTcp);
            i++;
        }
        return this._credentials;
    }
    async setIceInfo(iceInfo, abortSignal) {
        await this._client.setIceInfo(iceInfo, abortSignal);
    }
}

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

var dist = {};

var ContentType = {};

Object.defineProperty(ContentType, "__esModule", { value: true });
ContentType.ContentType = void 0;
ContentType.ContentType = {
    Inline: "INLINE",
    Multipart: "MULTIPART",
    Stream: "STREAM",
    Simple: "SIMPLE",
};

var MediaType = {};

Object.defineProperty(MediaType, "__esModule", { value: true });
MediaType.MediaType = void 0;
MediaType.MediaType = {
    Audio: "AUDIO",
    Image: "IMAGE",
    Video: "VIDEO",
    File: "FILE",
};

var ProcessingType = {};

Object.defineProperty(ProcessingType, "__esModule", { value: true });
ProcessingType.ProcessingType = void 0;
ProcessingType.ProcessingType = {
    None: "NONE",
    Assemble: "ASSEMBLE",
};

var UploadClient$1 = {};

var UploadQueue$1 = {};

function commonjsRequire(path) {
	throw new Error('Could not dynamically require "' + path + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
}

var localforage = {exports: {}};

/*!
    localForage -- Offline Storage, Improved
    Version 1.10.0
    https://localforage.github.io/localForage
    (c) 2013-2017 Mozilla, Apache License 2.0
*/

(function (module, exports) {
	(function(f){{module.exports=f();}})(function(){return (function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof commonjsRequire=="function"&&commonjsRequire;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw (f.code="MODULE_NOT_FOUND", f)}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r);}return n[o].exports}var i=typeof commonjsRequire=="function"&&commonjsRequire;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(_dereq_,module,exports){
	(function (global){
	var Mutation = global.MutationObserver || global.WebKitMutationObserver;

	var scheduleDrain;

	{
	  if (Mutation) {
	    var called = 0;
	    var observer = new Mutation(nextTick);
	    var element = global.document.createTextNode('');
	    observer.observe(element, {
	      characterData: true
	    });
	    scheduleDrain = function () {
	      element.data = (called = ++called % 2);
	    };
	  } else if (!global.setImmediate && typeof global.MessageChannel !== 'undefined') {
	    var channel = new global.MessageChannel();
	    channel.port1.onmessage = nextTick;
	    scheduleDrain = function () {
	      channel.port2.postMessage(0);
	    };
	  } else if ('document' in global && 'onreadystatechange' in global.document.createElement('script')) {
	    scheduleDrain = function () {

	      // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
	      // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
	      var scriptEl = global.document.createElement('script');
	      scriptEl.onreadystatechange = function () {
	        nextTick();

	        scriptEl.onreadystatechange = null;
	        scriptEl.parentNode.removeChild(scriptEl);
	        scriptEl = null;
	      };
	      global.document.documentElement.appendChild(scriptEl);
	    };
	  } else {
	    scheduleDrain = function () {
	      setTimeout(nextTick, 0);
	    };
	  }
	}

	var draining;
	var queue = [];
	//named nextTick for less confusing stack traces
	function nextTick() {
	  draining = true;
	  var i, oldQueue;
	  var len = queue.length;
	  while (len) {
	    oldQueue = queue;
	    queue = [];
	    i = -1;
	    while (++i < len) {
	      oldQueue[i]();
	    }
	    len = queue.length;
	  }
	  draining = false;
	}

	module.exports = immediate;
	function immediate(task) {
	  if (queue.push(task) === 1 && !draining) {
	    scheduleDrain();
	  }
	}

	}).call(this,typeof commonjsGlobal !== "undefined" ? commonjsGlobal : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {});
	},{}],2:[function(_dereq_,module,exports){
	var immediate = _dereq_(1);

	/* istanbul ignore next */
	function INTERNAL() {}

	var handlers = {};

	var REJECTED = ['REJECTED'];
	var FULFILLED = ['FULFILLED'];
	var PENDING = ['PENDING'];

	module.exports = Promise;

	function Promise(resolver) {
	  if (typeof resolver !== 'function') {
	    throw new TypeError('resolver must be a function');
	  }
	  this.state = PENDING;
	  this.queue = [];
	  this.outcome = void 0;
	  if (resolver !== INTERNAL) {
	    safelyResolveThenable(this, resolver);
	  }
	}

	Promise.prototype["catch"] = function (onRejected) {
	  return this.then(null, onRejected);
	};
	Promise.prototype.then = function (onFulfilled, onRejected) {
	  if (typeof onFulfilled !== 'function' && this.state === FULFILLED ||
	    typeof onRejected !== 'function' && this.state === REJECTED) {
	    return this;
	  }
	  var promise = new this.constructor(INTERNAL);
	  if (this.state !== PENDING) {
	    var resolver = this.state === FULFILLED ? onFulfilled : onRejected;
	    unwrap(promise, resolver, this.outcome);
	  } else {
	    this.queue.push(new QueueItem(promise, onFulfilled, onRejected));
	  }

	  return promise;
	};
	function QueueItem(promise, onFulfilled, onRejected) {
	  this.promise = promise;
	  if (typeof onFulfilled === 'function') {
	    this.onFulfilled = onFulfilled;
	    this.callFulfilled = this.otherCallFulfilled;
	  }
	  if (typeof onRejected === 'function') {
	    this.onRejected = onRejected;
	    this.callRejected = this.otherCallRejected;
	  }
	}
	QueueItem.prototype.callFulfilled = function (value) {
	  handlers.resolve(this.promise, value);
	};
	QueueItem.prototype.otherCallFulfilled = function (value) {
	  unwrap(this.promise, this.onFulfilled, value);
	};
	QueueItem.prototype.callRejected = function (value) {
	  handlers.reject(this.promise, value);
	};
	QueueItem.prototype.otherCallRejected = function (value) {
	  unwrap(this.promise, this.onRejected, value);
	};

	function unwrap(promise, func, value) {
	  immediate(function () {
	    var returnValue;
	    try {
	      returnValue = func(value);
	    } catch (e) {
	      return handlers.reject(promise, e);
	    }
	    if (returnValue === promise) {
	      handlers.reject(promise, new TypeError('Cannot resolve promise with itself'));
	    } else {
	      handlers.resolve(promise, returnValue);
	    }
	  });
	}

	handlers.resolve = function (self, value) {
	  var result = tryCatch(getThen, value);
	  if (result.status === 'error') {
	    return handlers.reject(self, result.value);
	  }
	  var thenable = result.value;

	  if (thenable) {
	    safelyResolveThenable(self, thenable);
	  } else {
	    self.state = FULFILLED;
	    self.outcome = value;
	    var i = -1;
	    var len = self.queue.length;
	    while (++i < len) {
	      self.queue[i].callFulfilled(value);
	    }
	  }
	  return self;
	};
	handlers.reject = function (self, error) {
	  self.state = REJECTED;
	  self.outcome = error;
	  var i = -1;
	  var len = self.queue.length;
	  while (++i < len) {
	    self.queue[i].callRejected(error);
	  }
	  return self;
	};

	function getThen(obj) {
	  // Make sure we only access the accessor once as required by the spec
	  var then = obj && obj.then;
	  if (obj && (typeof obj === 'object' || typeof obj === 'function') && typeof then === 'function') {
	    return function appyThen() {
	      then.apply(obj, arguments);
	    };
	  }
	}

	function safelyResolveThenable(self, thenable) {
	  // Either fulfill, reject or reject with error
	  var called = false;
	  function onError(value) {
	    if (called) {
	      return;
	    }
	    called = true;
	    handlers.reject(self, value);
	  }

	  function onSuccess(value) {
	    if (called) {
	      return;
	    }
	    called = true;
	    handlers.resolve(self, value);
	  }

	  function tryToUnwrap() {
	    thenable(onSuccess, onError);
	  }

	  var result = tryCatch(tryToUnwrap);
	  if (result.status === 'error') {
	    onError(result.value);
	  }
	}

	function tryCatch(func, value) {
	  var out = {};
	  try {
	    out.value = func(value);
	    out.status = 'success';
	  } catch (e) {
	    out.status = 'error';
	    out.value = e;
	  }
	  return out;
	}

	Promise.resolve = resolve;
	function resolve(value) {
	  if (value instanceof this) {
	    return value;
	  }
	  return handlers.resolve(new this(INTERNAL), value);
	}

	Promise.reject = reject;
	function reject(reason) {
	  var promise = new this(INTERNAL);
	  return handlers.reject(promise, reason);
	}

	Promise.all = all;
	function all(iterable) {
	  var self = this;
	  if (Object.prototype.toString.call(iterable) !== '[object Array]') {
	    return this.reject(new TypeError('must be an array'));
	  }

	  var len = iterable.length;
	  var called = false;
	  if (!len) {
	    return this.resolve([]);
	  }

	  var values = new Array(len);
	  var resolved = 0;
	  var i = -1;
	  var promise = new this(INTERNAL);

	  while (++i < len) {
	    allResolver(iterable[i], i);
	  }
	  return promise;
	  function allResolver(value, i) {
	    self.resolve(value).then(resolveFromAll, function (error) {
	      if (!called) {
	        called = true;
	        handlers.reject(promise, error);
	      }
	    });
	    function resolveFromAll(outValue) {
	      values[i] = outValue;
	      if (++resolved === len && !called) {
	        called = true;
	        handlers.resolve(promise, values);
	      }
	    }
	  }
	}

	Promise.race = race;
	function race(iterable) {
	  var self = this;
	  if (Object.prototype.toString.call(iterable) !== '[object Array]') {
	    return this.reject(new TypeError('must be an array'));
	  }

	  var len = iterable.length;
	  var called = false;
	  if (!len) {
	    return this.resolve([]);
	  }

	  var i = -1;
	  var promise = new this(INTERNAL);

	  while (++i < len) {
	    resolver(iterable[i]);
	  }
	  return promise;
	  function resolver(value) {
	    self.resolve(value).then(function (response) {
	      if (!called) {
	        called = true;
	        handlers.resolve(promise, response);
	      }
	    }, function (error) {
	      if (!called) {
	        called = true;
	        handlers.reject(promise, error);
	      }
	    });
	  }
	}

	},{"1":1}],3:[function(_dereq_,module,exports){
	(function (global){
	if (typeof global.Promise !== 'function') {
	  global.Promise = _dereq_(2);
	}

	}).call(this,typeof commonjsGlobal !== "undefined" ? commonjsGlobal : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {});
	},{"2":2}],4:[function(_dereq_,module,exports){

	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function getIDB() {
	    /* global indexedDB,webkitIndexedDB,mozIndexedDB,OIndexedDB,msIndexedDB */
	    try {
	        if (typeof indexedDB !== 'undefined') {
	            return indexedDB;
	        }
	        if (typeof webkitIndexedDB !== 'undefined') {
	            return webkitIndexedDB;
	        }
	        if (typeof mozIndexedDB !== 'undefined') {
	            return mozIndexedDB;
	        }
	        if (typeof OIndexedDB !== 'undefined') {
	            return OIndexedDB;
	        }
	        if (typeof msIndexedDB !== 'undefined') {
	            return msIndexedDB;
	        }
	    } catch (e) {
	        return;
	    }
	}

	var idb = getIDB();

	function isIndexedDBValid() {
	    try {
	        // Initialize IndexedDB; fall back to vendor-prefixed versions
	        // if needed.
	        if (!idb || !idb.open) {
	            return false;
	        }
	        // We mimic PouchDB here;
	        //
	        // We test for openDatabase because IE Mobile identifies itself
	        // as Safari. Oh the lulz...
	        var isSafari = typeof openDatabase !== 'undefined' && /(Safari|iPhone|iPad|iPod)/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent) && !/BlackBerry/.test(navigator.platform);

	        var hasFetch = typeof fetch === 'function' && fetch.toString().indexOf('[native code') !== -1;

	        // Safari <10.1 does not meet our requirements for IDB support
	        // (see: https://github.com/pouchdb/pouchdb/issues/5572).
	        // Safari 10.1 shipped with fetch, we can use that to detect it.
	        // Note: this creates issues with `window.fetch` polyfills and
	        // overrides; see:
	        // https://github.com/localForage/localForage/issues/856
	        return (!isSafari || hasFetch) && typeof indexedDB !== 'undefined' &&
	        // some outdated implementations of IDB that appear on Samsung
	        // and HTC Android devices <4.4 are missing IDBKeyRange
	        // See: https://github.com/mozilla/localForage/issues/128
	        // See: https://github.com/mozilla/localForage/issues/272
	        typeof IDBKeyRange !== 'undefined';
	    } catch (e) {
	        return false;
	    }
	}

	// Abstracts constructing a Blob object, so it also works in older
	// browsers that don't support the native Blob constructor. (i.e.
	// old QtWebKit versions, at least).
	// Abstracts constructing a Blob object, so it also works in older
	// browsers that don't support the native Blob constructor. (i.e.
	// old QtWebKit versions, at least).
	function createBlob(parts, properties) {
	    /* global BlobBuilder,MSBlobBuilder,MozBlobBuilder,WebKitBlobBuilder */
	    parts = parts || [];
	    properties = properties || {};
	    try {
	        return new Blob(parts, properties);
	    } catch (e) {
	        if (e.name !== 'TypeError') {
	            throw e;
	        }
	        var Builder = typeof BlobBuilder !== 'undefined' ? BlobBuilder : typeof MSBlobBuilder !== 'undefined' ? MSBlobBuilder : typeof MozBlobBuilder !== 'undefined' ? MozBlobBuilder : WebKitBlobBuilder;
	        var builder = new Builder();
	        for (var i = 0; i < parts.length; i += 1) {
	            builder.append(parts[i]);
	        }
	        return builder.getBlob(properties.type);
	    }
	}

	// This is CommonJS because lie is an external dependency, so Rollup
	// can just ignore it.
	if (typeof Promise === 'undefined') {
	    // In the "nopromises" build this will just throw if you don't have
	    // a global promise object, but it would throw anyway later.
	    _dereq_(3);
	}
	var Promise$1 = Promise;

	function executeCallback(promise, callback) {
	    if (callback) {
	        promise.then(function (result) {
	            callback(null, result);
	        }, function (error) {
	            callback(error);
	        });
	    }
	}

	function executeTwoCallbacks(promise, callback, errorCallback) {
	    if (typeof callback === 'function') {
	        promise.then(callback);
	    }

	    if (typeof errorCallback === 'function') {
	        promise["catch"](errorCallback);
	    }
	}

	function normalizeKey(key) {
	    // Cast the key to a string, as that's all we can set as a key.
	    if (typeof key !== 'string') {
	        console.warn(key + ' used as a key, but it is not a string.');
	        key = String(key);
	    }

	    return key;
	}

	function getCallback() {
	    if (arguments.length && typeof arguments[arguments.length - 1] === 'function') {
	        return arguments[arguments.length - 1];
	    }
	}

	// Some code originally from async_storage.js in
	// [Gaia](https://github.com/mozilla-b2g/gaia).

	var DETECT_BLOB_SUPPORT_STORE = 'local-forage-detect-blob-support';
	var supportsBlobs = void 0;
	var dbContexts = {};
	var toString = Object.prototype.toString;

	// Transaction Modes
	var READ_ONLY = 'readonly';
	var READ_WRITE = 'readwrite';

	// Transform a binary string to an array buffer, because otherwise
	// weird stuff happens when you try to work with the binary string directly.
	// It is known.
	// From http://stackoverflow.com/questions/14967647/ (continues on next line)
	// encode-decode-image-with-base64-breaks-image (2013-04-21)
	function _binStringToArrayBuffer(bin) {
	    var length = bin.length;
	    var buf = new ArrayBuffer(length);
	    var arr = new Uint8Array(buf);
	    for (var i = 0; i < length; i++) {
	        arr[i] = bin.charCodeAt(i);
	    }
	    return buf;
	}

	//
	// Blobs are not supported in all versions of IndexedDB, notably
	// Chrome <37 and Android <5. In those versions, storing a blob will throw.
	//
	// Various other blob bugs exist in Chrome v37-42 (inclusive).
	// Detecting them is expensive and confusing to users, and Chrome 37-42
	// is at very low usage worldwide, so we do a hacky userAgent check instead.
	//
	// content-type bug: https://code.google.com/p/chromium/issues/detail?id=408120
	// 404 bug: https://code.google.com/p/chromium/issues/detail?id=447916
	// FileReader bug: https://code.google.com/p/chromium/issues/detail?id=447836
	//
	// Code borrowed from PouchDB. See:
	// https://github.com/pouchdb/pouchdb/blob/master/packages/node_modules/pouchdb-adapter-idb/src/blobSupport.js
	//
	function _checkBlobSupportWithoutCaching(idb) {
	    return new Promise$1(function (resolve) {
	        var txn = idb.transaction(DETECT_BLOB_SUPPORT_STORE, READ_WRITE);
	        var blob = createBlob(['']);
	        txn.objectStore(DETECT_BLOB_SUPPORT_STORE).put(blob, 'key');

	        txn.onabort = function (e) {
	            // If the transaction aborts now its due to not being able to
	            // write to the database, likely due to the disk being full
	            e.preventDefault();
	            e.stopPropagation();
	            resolve(false);
	        };

	        txn.oncomplete = function () {
	            var matchedChrome = navigator.userAgent.match(/Chrome\/(\d+)/);
	            var matchedEdge = navigator.userAgent.match(/Edge\//);
	            // MS Edge pretends to be Chrome 42:
	            // https://msdn.microsoft.com/en-us/library/hh869301%28v=vs.85%29.aspx
	            resolve(matchedEdge || !matchedChrome || parseInt(matchedChrome[1], 10) >= 43);
	        };
	    })["catch"](function () {
	        return false; // error, so assume unsupported
	    });
	}

	function _checkBlobSupport(idb) {
	    if (typeof supportsBlobs === 'boolean') {
	        return Promise$1.resolve(supportsBlobs);
	    }
	    return _checkBlobSupportWithoutCaching(idb).then(function (value) {
	        supportsBlobs = value;
	        return supportsBlobs;
	    });
	}

	function _deferReadiness(dbInfo) {
	    var dbContext = dbContexts[dbInfo.name];

	    // Create a deferred object representing the current database operation.
	    var deferredOperation = {};

	    deferredOperation.promise = new Promise$1(function (resolve, reject) {
	        deferredOperation.resolve = resolve;
	        deferredOperation.reject = reject;
	    });

	    // Enqueue the deferred operation.
	    dbContext.deferredOperations.push(deferredOperation);

	    // Chain its promise to the database readiness.
	    if (!dbContext.dbReady) {
	        dbContext.dbReady = deferredOperation.promise;
	    } else {
	        dbContext.dbReady = dbContext.dbReady.then(function () {
	            return deferredOperation.promise;
	        });
	    }
	}

	function _advanceReadiness(dbInfo) {
	    var dbContext = dbContexts[dbInfo.name];

	    // Dequeue a deferred operation.
	    var deferredOperation = dbContext.deferredOperations.pop();

	    // Resolve its promise (which is part of the database readiness
	    // chain of promises).
	    if (deferredOperation) {
	        deferredOperation.resolve();
	        return deferredOperation.promise;
	    }
	}

	function _rejectReadiness(dbInfo, err) {
	    var dbContext = dbContexts[dbInfo.name];

	    // Dequeue a deferred operation.
	    var deferredOperation = dbContext.deferredOperations.pop();

	    // Reject its promise (which is part of the database readiness
	    // chain of promises).
	    if (deferredOperation) {
	        deferredOperation.reject(err);
	        return deferredOperation.promise;
	    }
	}

	function _getConnection(dbInfo, upgradeNeeded) {
	    return new Promise$1(function (resolve, reject) {
	        dbContexts[dbInfo.name] = dbContexts[dbInfo.name] || createDbContext();

	        if (dbInfo.db) {
	            if (upgradeNeeded) {
	                _deferReadiness(dbInfo);
	                dbInfo.db.close();
	            } else {
	                return resolve(dbInfo.db);
	            }
	        }

	        var dbArgs = [dbInfo.name];

	        if (upgradeNeeded) {
	            dbArgs.push(dbInfo.version);
	        }

	        var openreq = idb.open.apply(idb, dbArgs);

	        if (upgradeNeeded) {
	            openreq.onupgradeneeded = function (e) {
	                var db = openreq.result;
	                try {
	                    db.createObjectStore(dbInfo.storeName);
	                    if (e.oldVersion <= 1) {
	                        // Added when support for blob shims was added
	                        db.createObjectStore(DETECT_BLOB_SUPPORT_STORE);
	                    }
	                } catch (ex) {
	                    if (ex.name === 'ConstraintError') {
	                        console.warn('The database "' + dbInfo.name + '"' + ' has been upgraded from version ' + e.oldVersion + ' to version ' + e.newVersion + ', but the storage "' + dbInfo.storeName + '" already exists.');
	                    } else {
	                        throw ex;
	                    }
	                }
	            };
	        }

	        openreq.onerror = function (e) {
	            e.preventDefault();
	            reject(openreq.error);
	        };

	        openreq.onsuccess = function () {
	            var db = openreq.result;
	            db.onversionchange = function (e) {
	                // Triggered when the database is modified (e.g. adding an objectStore) or
	                // deleted (even when initiated by other sessions in different tabs).
	                // Closing the connection here prevents those operations from being blocked.
	                // If the database is accessed again later by this instance, the connection
	                // will be reopened or the database recreated as needed.
	                e.target.close();
	            };
	            resolve(db);
	            _advanceReadiness(dbInfo);
	        };
	    });
	}

	function _getOriginalConnection(dbInfo) {
	    return _getConnection(dbInfo, false);
	}

	function _getUpgradedConnection(dbInfo) {
	    return _getConnection(dbInfo, true);
	}

	function _isUpgradeNeeded(dbInfo, defaultVersion) {
	    if (!dbInfo.db) {
	        return true;
	    }

	    var isNewStore = !dbInfo.db.objectStoreNames.contains(dbInfo.storeName);
	    var isDowngrade = dbInfo.version < dbInfo.db.version;
	    var isUpgrade = dbInfo.version > dbInfo.db.version;

	    if (isDowngrade) {
	        // If the version is not the default one
	        // then warn for impossible downgrade.
	        if (dbInfo.version !== defaultVersion) {
	            console.warn('The database "' + dbInfo.name + '"' + " can't be downgraded from version " + dbInfo.db.version + ' to version ' + dbInfo.version + '.');
	        }
	        // Align the versions to prevent errors.
	        dbInfo.version = dbInfo.db.version;
	    }

	    if (isUpgrade || isNewStore) {
	        // If the store is new then increment the version (if needed).
	        // This will trigger an "upgradeneeded" event which is required
	        // for creating a store.
	        if (isNewStore) {
	            var incVersion = dbInfo.db.version + 1;
	            if (incVersion > dbInfo.version) {
	                dbInfo.version = incVersion;
	            }
	        }

	        return true;
	    }

	    return false;
	}

	// encode a blob for indexeddb engines that don't support blobs
	function _encodeBlob(blob) {
	    return new Promise$1(function (resolve, reject) {
	        var reader = new FileReader();
	        reader.onerror = reject;
	        reader.onloadend = function (e) {
	            var base64 = btoa(e.target.result || '');
	            resolve({
	                __local_forage_encoded_blob: true,
	                data: base64,
	                type: blob.type
	            });
	        };
	        reader.readAsBinaryString(blob);
	    });
	}

	// decode an encoded blob
	function _decodeBlob(encodedBlob) {
	    var arrayBuff = _binStringToArrayBuffer(atob(encodedBlob.data));
	    return createBlob([arrayBuff], { type: encodedBlob.type });
	}

	// is this one of our fancy encoded blobs?
	function _isEncodedBlob(value) {
	    return value && value.__local_forage_encoded_blob;
	}

	// Specialize the default `ready()` function by making it dependent
	// on the current database operations. Thus, the driver will be actually
	// ready when it's been initialized (default) *and* there are no pending
	// operations on the database (initiated by some other instances).
	function _fullyReady(callback) {
	    var self = this;

	    var promise = self._initReady().then(function () {
	        var dbContext = dbContexts[self._dbInfo.name];

	        if (dbContext && dbContext.dbReady) {
	            return dbContext.dbReady;
	        }
	    });

	    executeTwoCallbacks(promise, callback, callback);
	    return promise;
	}

	// Try to establish a new db connection to replace the
	// current one which is broken (i.e. experiencing
	// InvalidStateError while creating a transaction).
	function _tryReconnect(dbInfo) {
	    _deferReadiness(dbInfo);

	    var dbContext = dbContexts[dbInfo.name];
	    var forages = dbContext.forages;

	    for (var i = 0; i < forages.length; i++) {
	        var forage = forages[i];
	        if (forage._dbInfo.db) {
	            forage._dbInfo.db.close();
	            forage._dbInfo.db = null;
	        }
	    }
	    dbInfo.db = null;

	    return _getOriginalConnection(dbInfo).then(function (db) {
	        dbInfo.db = db;
	        if (_isUpgradeNeeded(dbInfo)) {
	            // Reopen the database for upgrading.
	            return _getUpgradedConnection(dbInfo);
	        }
	        return db;
	    }).then(function (db) {
	        // store the latest db reference
	        // in case the db was upgraded
	        dbInfo.db = dbContext.db = db;
	        for (var i = 0; i < forages.length; i++) {
	            forages[i]._dbInfo.db = db;
	        }
	    })["catch"](function (err) {
	        _rejectReadiness(dbInfo, err);
	        throw err;
	    });
	}

	// FF doesn't like Promises (micro-tasks) and IDDB store operations,
	// so we have to do it with callbacks
	function createTransaction(dbInfo, mode, callback, retries) {
	    if (retries === undefined) {
	        retries = 1;
	    }

	    try {
	        var tx = dbInfo.db.transaction(dbInfo.storeName, mode);
	        callback(null, tx);
	    } catch (err) {
	        if (retries > 0 && (!dbInfo.db || err.name === 'InvalidStateError' || err.name === 'NotFoundError')) {
	            return Promise$1.resolve().then(function () {
	                if (!dbInfo.db || err.name === 'NotFoundError' && !dbInfo.db.objectStoreNames.contains(dbInfo.storeName) && dbInfo.version <= dbInfo.db.version) {
	                    // increase the db version, to create the new ObjectStore
	                    if (dbInfo.db) {
	                        dbInfo.version = dbInfo.db.version + 1;
	                    }
	                    // Reopen the database for upgrading.
	                    return _getUpgradedConnection(dbInfo);
	                }
	            }).then(function () {
	                return _tryReconnect(dbInfo).then(function () {
	                    createTransaction(dbInfo, mode, callback, retries - 1);
	                });
	            })["catch"](callback);
	        }

	        callback(err);
	    }
	}

	function createDbContext() {
	    return {
	        // Running localForages sharing a database.
	        forages: [],
	        // Shared database.
	        db: null,
	        // Database readiness (promise).
	        dbReady: null,
	        // Deferred operations on the database.
	        deferredOperations: []
	    };
	}

	// Open the IndexedDB database (automatically creates one if one didn't
	// previously exist), using any options set in the config.
	function _initStorage(options) {
	    var self = this;
	    var dbInfo = {
	        db: null
	    };

	    if (options) {
	        for (var i in options) {
	            dbInfo[i] = options[i];
	        }
	    }

	    // Get the current context of the database;
	    var dbContext = dbContexts[dbInfo.name];

	    // ...or create a new context.
	    if (!dbContext) {
	        dbContext = createDbContext();
	        // Register the new context in the global container.
	        dbContexts[dbInfo.name] = dbContext;
	    }

	    // Register itself as a running localForage in the current context.
	    dbContext.forages.push(self);

	    // Replace the default `ready()` function with the specialized one.
	    if (!self._initReady) {
	        self._initReady = self.ready;
	        self.ready = _fullyReady;
	    }

	    // Create an array of initialization states of the related localForages.
	    var initPromises = [];

	    function ignoreErrors() {
	        // Don't handle errors here,
	        // just makes sure related localForages aren't pending.
	        return Promise$1.resolve();
	    }

	    for (var j = 0; j < dbContext.forages.length; j++) {
	        var forage = dbContext.forages[j];
	        if (forage !== self) {
	            // Don't wait for itself...
	            initPromises.push(forage._initReady()["catch"](ignoreErrors));
	        }
	    }

	    // Take a snapshot of the related localForages.
	    var forages = dbContext.forages.slice(0);

	    // Initialize the connection process only when
	    // all the related localForages aren't pending.
	    return Promise$1.all(initPromises).then(function () {
	        dbInfo.db = dbContext.db;
	        // Get the connection or open a new one without upgrade.
	        return _getOriginalConnection(dbInfo);
	    }).then(function (db) {
	        dbInfo.db = db;
	        if (_isUpgradeNeeded(dbInfo, self._defaultConfig.version)) {
	            // Reopen the database for upgrading.
	            return _getUpgradedConnection(dbInfo);
	        }
	        return db;
	    }).then(function (db) {
	        dbInfo.db = dbContext.db = db;
	        self._dbInfo = dbInfo;
	        // Share the final connection amongst related localForages.
	        for (var k = 0; k < forages.length; k++) {
	            var forage = forages[k];
	            if (forage !== self) {
	                // Self is already up-to-date.
	                forage._dbInfo.db = dbInfo.db;
	                forage._dbInfo.version = dbInfo.version;
	            }
	        }
	    });
	}

	function getItem(key, callback) {
	    var self = this;

	    key = normalizeKey(key);

	    var promise = new Promise$1(function (resolve, reject) {
	        self.ready().then(function () {
	            createTransaction(self._dbInfo, READ_ONLY, function (err, transaction) {
	                if (err) {
	                    return reject(err);
	                }

	                try {
	                    var store = transaction.objectStore(self._dbInfo.storeName);
	                    var req = store.get(key);

	                    req.onsuccess = function () {
	                        var value = req.result;
	                        if (value === undefined) {
	                            value = null;
	                        }
	                        if (_isEncodedBlob(value)) {
	                            value = _decodeBlob(value);
	                        }
	                        resolve(value);
	                    };

	                    req.onerror = function () {
	                        reject(req.error);
	                    };
	                } catch (e) {
	                    reject(e);
	                }
	            });
	        })["catch"](reject);
	    });

	    executeCallback(promise, callback);
	    return promise;
	}

	// Iterate over all items stored in database.
	function iterate(iterator, callback) {
	    var self = this;

	    var promise = new Promise$1(function (resolve, reject) {
	        self.ready().then(function () {
	            createTransaction(self._dbInfo, READ_ONLY, function (err, transaction) {
	                if (err) {
	                    return reject(err);
	                }

	                try {
	                    var store = transaction.objectStore(self._dbInfo.storeName);
	                    var req = store.openCursor();
	                    var iterationNumber = 1;

	                    req.onsuccess = function () {
	                        var cursor = req.result;

	                        if (cursor) {
	                            var value = cursor.value;
	                            if (_isEncodedBlob(value)) {
	                                value = _decodeBlob(value);
	                            }
	                            var result = iterator(value, cursor.key, iterationNumber++);

	                            // when the iterator callback returns any
	                            // (non-`undefined`) value, then we stop
	                            // the iteration immediately
	                            if (result !== void 0) {
	                                resolve(result);
	                            } else {
	                                cursor["continue"]();
	                            }
	                        } else {
	                            resolve();
	                        }
	                    };

	                    req.onerror = function () {
	                        reject(req.error);
	                    };
	                } catch (e) {
	                    reject(e);
	                }
	            });
	        })["catch"](reject);
	    });

	    executeCallback(promise, callback);

	    return promise;
	}

	function setItem(key, value, callback) {
	    var self = this;

	    key = normalizeKey(key);

	    var promise = new Promise$1(function (resolve, reject) {
	        var dbInfo;
	        self.ready().then(function () {
	            dbInfo = self._dbInfo;
	            if (toString.call(value) === '[object Blob]') {
	                return _checkBlobSupport(dbInfo.db).then(function (blobSupport) {
	                    if (blobSupport) {
	                        return value;
	                    }
	                    return _encodeBlob(value);
	                });
	            }
	            return value;
	        }).then(function (value) {
	            createTransaction(self._dbInfo, READ_WRITE, function (err, transaction) {
	                if (err) {
	                    return reject(err);
	                }

	                try {
	                    var store = transaction.objectStore(self._dbInfo.storeName);

	                    // The reason we don't _save_ null is because IE 10 does
	                    // not support saving the `null` type in IndexedDB. How
	                    // ironic, given the bug below!
	                    // See: https://github.com/mozilla/localForage/issues/161
	                    if (value === null) {
	                        value = undefined;
	                    }

	                    var req = store.put(value, key);

	                    transaction.oncomplete = function () {
	                        // Cast to undefined so the value passed to
	                        // callback/promise is the same as what one would get out
	                        // of `getItem()` later. This leads to some weirdness
	                        // (setItem('foo', undefined) will return `null`), but
	                        // it's not my fault localStorage is our baseline and that
	                        // it's weird.
	                        if (value === undefined) {
	                            value = null;
	                        }

	                        resolve(value);
	                    };
	                    transaction.onabort = transaction.onerror = function () {
	                        var err = req.error ? req.error : req.transaction.error;
	                        reject(err);
	                    };
	                } catch (e) {
	                    reject(e);
	                }
	            });
	        })["catch"](reject);
	    });

	    executeCallback(promise, callback);
	    return promise;
	}

	function removeItem(key, callback) {
	    var self = this;

	    key = normalizeKey(key);

	    var promise = new Promise$1(function (resolve, reject) {
	        self.ready().then(function () {
	            createTransaction(self._dbInfo, READ_WRITE, function (err, transaction) {
	                if (err) {
	                    return reject(err);
	                }

	                try {
	                    var store = transaction.objectStore(self._dbInfo.storeName);
	                    // We use a Grunt task to make this safe for IE and some
	                    // versions of Android (including those used by Cordova).
	                    // Normally IE won't like `.delete()` and will insist on
	                    // using `['delete']()`, but we have a build step that
	                    // fixes this for us now.
	                    var req = store["delete"](key);
	                    transaction.oncomplete = function () {
	                        resolve();
	                    };

	                    transaction.onerror = function () {
	                        reject(req.error);
	                    };

	                    // The request will be also be aborted if we've exceeded our storage
	                    // space.
	                    transaction.onabort = function () {
	                        var err = req.error ? req.error : req.transaction.error;
	                        reject(err);
	                    };
	                } catch (e) {
	                    reject(e);
	                }
	            });
	        })["catch"](reject);
	    });

	    executeCallback(promise, callback);
	    return promise;
	}

	function clear(callback) {
	    var self = this;

	    var promise = new Promise$1(function (resolve, reject) {
	        self.ready().then(function () {
	            createTransaction(self._dbInfo, READ_WRITE, function (err, transaction) {
	                if (err) {
	                    return reject(err);
	                }

	                try {
	                    var store = transaction.objectStore(self._dbInfo.storeName);
	                    var req = store.clear();

	                    transaction.oncomplete = function () {
	                        resolve();
	                    };

	                    transaction.onabort = transaction.onerror = function () {
	                        var err = req.error ? req.error : req.transaction.error;
	                        reject(err);
	                    };
	                } catch (e) {
	                    reject(e);
	                }
	            });
	        })["catch"](reject);
	    });

	    executeCallback(promise, callback);
	    return promise;
	}

	function length(callback) {
	    var self = this;

	    var promise = new Promise$1(function (resolve, reject) {
	        self.ready().then(function () {
	            createTransaction(self._dbInfo, READ_ONLY, function (err, transaction) {
	                if (err) {
	                    return reject(err);
	                }

	                try {
	                    var store = transaction.objectStore(self._dbInfo.storeName);
	                    var req = store.count();

	                    req.onsuccess = function () {
	                        resolve(req.result);
	                    };

	                    req.onerror = function () {
	                        reject(req.error);
	                    };
	                } catch (e) {
	                    reject(e);
	                }
	            });
	        })["catch"](reject);
	    });

	    executeCallback(promise, callback);
	    return promise;
	}

	function key(n, callback) {
	    var self = this;

	    var promise = new Promise$1(function (resolve, reject) {
	        if (n < 0) {
	            resolve(null);

	            return;
	        }

	        self.ready().then(function () {
	            createTransaction(self._dbInfo, READ_ONLY, function (err, transaction) {
	                if (err) {
	                    return reject(err);
	                }

	                try {
	                    var store = transaction.objectStore(self._dbInfo.storeName);
	                    var advanced = false;
	                    var req = store.openKeyCursor();

	                    req.onsuccess = function () {
	                        var cursor = req.result;
	                        if (!cursor) {
	                            // this means there weren't enough keys
	                            resolve(null);

	                            return;
	                        }

	                        if (n === 0) {
	                            // We have the first key, return it if that's what they
	                            // wanted.
	                            resolve(cursor.key);
	                        } else {
	                            if (!advanced) {
	                                // Otherwise, ask the cursor to skip ahead n
	                                // records.
	                                advanced = true;
	                                cursor.advance(n);
	                            } else {
	                                // When we get here, we've got the nth key.
	                                resolve(cursor.key);
	                            }
	                        }
	                    };

	                    req.onerror = function () {
	                        reject(req.error);
	                    };
	                } catch (e) {
	                    reject(e);
	                }
	            });
	        })["catch"](reject);
	    });

	    executeCallback(promise, callback);
	    return promise;
	}

	function keys(callback) {
	    var self = this;

	    var promise = new Promise$1(function (resolve, reject) {
	        self.ready().then(function () {
	            createTransaction(self._dbInfo, READ_ONLY, function (err, transaction) {
	                if (err) {
	                    return reject(err);
	                }

	                try {
	                    var store = transaction.objectStore(self._dbInfo.storeName);
	                    var req = store.openKeyCursor();
	                    var keys = [];

	                    req.onsuccess = function () {
	                        var cursor = req.result;

	                        if (!cursor) {
	                            resolve(keys);
	                            return;
	                        }

	                        keys.push(cursor.key);
	                        cursor["continue"]();
	                    };

	                    req.onerror = function () {
	                        reject(req.error);
	                    };
	                } catch (e) {
	                    reject(e);
	                }
	            });
	        })["catch"](reject);
	    });

	    executeCallback(promise, callback);
	    return promise;
	}

	function dropInstance(options, callback) {
	    callback = getCallback.apply(this, arguments);

	    var currentConfig = this.config();
	    options = typeof options !== 'function' && options || {};
	    if (!options.name) {
	        options.name = options.name || currentConfig.name;
	        options.storeName = options.storeName || currentConfig.storeName;
	    }

	    var self = this;
	    var promise;
	    if (!options.name) {
	        promise = Promise$1.reject('Invalid arguments');
	    } else {
	        var isCurrentDb = options.name === currentConfig.name && self._dbInfo.db;

	        var dbPromise = isCurrentDb ? Promise$1.resolve(self._dbInfo.db) : _getOriginalConnection(options).then(function (db) {
	            var dbContext = dbContexts[options.name];
	            var forages = dbContext.forages;
	            dbContext.db = db;
	            for (var i = 0; i < forages.length; i++) {
	                forages[i]._dbInfo.db = db;
	            }
	            return db;
	        });

	        if (!options.storeName) {
	            promise = dbPromise.then(function (db) {
	                _deferReadiness(options);

	                var dbContext = dbContexts[options.name];
	                var forages = dbContext.forages;

	                db.close();
	                for (var i = 0; i < forages.length; i++) {
	                    var forage = forages[i];
	                    forage._dbInfo.db = null;
	                }

	                var dropDBPromise = new Promise$1(function (resolve, reject) {
	                    var req = idb.deleteDatabase(options.name);

	                    req.onerror = function () {
	                        var db = req.result;
	                        if (db) {
	                            db.close();
	                        }
	                        reject(req.error);
	                    };

	                    req.onblocked = function () {
	                        // Closing all open connections in onversionchange handler should prevent this situation, but if
	                        // we do get here, it just means the request remains pending - eventually it will succeed or error
	                        console.warn('dropInstance blocked for database "' + options.name + '" until all open connections are closed');
	                    };

	                    req.onsuccess = function () {
	                        var db = req.result;
	                        if (db) {
	                            db.close();
	                        }
	                        resolve(db);
	                    };
	                });

	                return dropDBPromise.then(function (db) {
	                    dbContext.db = db;
	                    for (var i = 0; i < forages.length; i++) {
	                        var _forage = forages[i];
	                        _advanceReadiness(_forage._dbInfo);
	                    }
	                })["catch"](function (err) {
	                    (_rejectReadiness(options, err) || Promise$1.resolve())["catch"](function () {});
	                    throw err;
	                });
	            });
	        } else {
	            promise = dbPromise.then(function (db) {
	                if (!db.objectStoreNames.contains(options.storeName)) {
	                    return;
	                }

	                var newVersion = db.version + 1;

	                _deferReadiness(options);

	                var dbContext = dbContexts[options.name];
	                var forages = dbContext.forages;

	                db.close();
	                for (var i = 0; i < forages.length; i++) {
	                    var forage = forages[i];
	                    forage._dbInfo.db = null;
	                    forage._dbInfo.version = newVersion;
	                }

	                var dropObjectPromise = new Promise$1(function (resolve, reject) {
	                    var req = idb.open(options.name, newVersion);

	                    req.onerror = function (err) {
	                        var db = req.result;
	                        db.close();
	                        reject(err);
	                    };

	                    req.onupgradeneeded = function () {
	                        var db = req.result;
	                        db.deleteObjectStore(options.storeName);
	                    };

	                    req.onsuccess = function () {
	                        var db = req.result;
	                        db.close();
	                        resolve(db);
	                    };
	                });

	                return dropObjectPromise.then(function (db) {
	                    dbContext.db = db;
	                    for (var j = 0; j < forages.length; j++) {
	                        var _forage2 = forages[j];
	                        _forage2._dbInfo.db = db;
	                        _advanceReadiness(_forage2._dbInfo);
	                    }
	                })["catch"](function (err) {
	                    (_rejectReadiness(options, err) || Promise$1.resolve())["catch"](function () {});
	                    throw err;
	                });
	            });
	        }
	    }

	    executeCallback(promise, callback);
	    return promise;
	}

	var asyncStorage = {
	    _driver: 'asyncStorage',
	    _initStorage: _initStorage,
	    _support: isIndexedDBValid(),
	    iterate: iterate,
	    getItem: getItem,
	    setItem: setItem,
	    removeItem: removeItem,
	    clear: clear,
	    length: length,
	    key: key,
	    keys: keys,
	    dropInstance: dropInstance
	};

	function isWebSQLValid() {
	    return typeof openDatabase === 'function';
	}

	// Sadly, the best way to save binary data in WebSQL/localStorage is serializing
	// it to Base64, so this is how we store it to prevent very strange errors with less
	// verbose ways of binary <-> string data storage.
	var BASE_CHARS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';

	var BLOB_TYPE_PREFIX = '~~local_forage_type~';
	var BLOB_TYPE_PREFIX_REGEX = /^~~local_forage_type~([^~]+)~/;

	var SERIALIZED_MARKER = '__lfsc__:';
	var SERIALIZED_MARKER_LENGTH = SERIALIZED_MARKER.length;

	// OMG the serializations!
	var TYPE_ARRAYBUFFER = 'arbf';
	var TYPE_BLOB = 'blob';
	var TYPE_INT8ARRAY = 'si08';
	var TYPE_UINT8ARRAY = 'ui08';
	var TYPE_UINT8CLAMPEDARRAY = 'uic8';
	var TYPE_INT16ARRAY = 'si16';
	var TYPE_INT32ARRAY = 'si32';
	var TYPE_UINT16ARRAY = 'ur16';
	var TYPE_UINT32ARRAY = 'ui32';
	var TYPE_FLOAT32ARRAY = 'fl32';
	var TYPE_FLOAT64ARRAY = 'fl64';
	var TYPE_SERIALIZED_MARKER_LENGTH = SERIALIZED_MARKER_LENGTH + TYPE_ARRAYBUFFER.length;

	var toString$1 = Object.prototype.toString;

	function stringToBuffer(serializedString) {
	    // Fill the string into a ArrayBuffer.
	    var bufferLength = serializedString.length * 0.75;
	    var len = serializedString.length;
	    var i;
	    var p = 0;
	    var encoded1, encoded2, encoded3, encoded4;

	    if (serializedString[serializedString.length - 1] === '=') {
	        bufferLength--;
	        if (serializedString[serializedString.length - 2] === '=') {
	            bufferLength--;
	        }
	    }

	    var buffer = new ArrayBuffer(bufferLength);
	    var bytes = new Uint8Array(buffer);

	    for (i = 0; i < len; i += 4) {
	        encoded1 = BASE_CHARS.indexOf(serializedString[i]);
	        encoded2 = BASE_CHARS.indexOf(serializedString[i + 1]);
	        encoded3 = BASE_CHARS.indexOf(serializedString[i + 2]);
	        encoded4 = BASE_CHARS.indexOf(serializedString[i + 3]);

	        /*jslint bitwise: true */
	        bytes[p++] = encoded1 << 2 | encoded2 >> 4;
	        bytes[p++] = (encoded2 & 15) << 4 | encoded3 >> 2;
	        bytes[p++] = (encoded3 & 3) << 6 | encoded4 & 63;
	    }
	    return buffer;
	}

	// Converts a buffer to a string to store, serialized, in the backend
	// storage library.
	function bufferToString(buffer) {
	    // base64-arraybuffer
	    var bytes = new Uint8Array(buffer);
	    var base64String = '';
	    var i;

	    for (i = 0; i < bytes.length; i += 3) {
	        /*jslint bitwise: true */
	        base64String += BASE_CHARS[bytes[i] >> 2];
	        base64String += BASE_CHARS[(bytes[i] & 3) << 4 | bytes[i + 1] >> 4];
	        base64String += BASE_CHARS[(bytes[i + 1] & 15) << 2 | bytes[i + 2] >> 6];
	        base64String += BASE_CHARS[bytes[i + 2] & 63];
	    }

	    if (bytes.length % 3 === 2) {
	        base64String = base64String.substring(0, base64String.length - 1) + '=';
	    } else if (bytes.length % 3 === 1) {
	        base64String = base64String.substring(0, base64String.length - 2) + '==';
	    }

	    return base64String;
	}

	// Serialize a value, afterwards executing a callback (which usually
	// instructs the `setItem()` callback/promise to be executed). This is how
	// we store binary data with localStorage.
	function serialize(value, callback) {
	    var valueType = '';
	    if (value) {
	        valueType = toString$1.call(value);
	    }

	    // Cannot use `value instanceof ArrayBuffer` or such here, as these
	    // checks fail when running the tests using casper.js...
	    //
	    // TODO: See why those tests fail and use a better solution.
	    if (value && (valueType === '[object ArrayBuffer]' || value.buffer && toString$1.call(value.buffer) === '[object ArrayBuffer]')) {
	        // Convert binary arrays to a string and prefix the string with
	        // a special marker.
	        var buffer;
	        var marker = SERIALIZED_MARKER;

	        if (value instanceof ArrayBuffer) {
	            buffer = value;
	            marker += TYPE_ARRAYBUFFER;
	        } else {
	            buffer = value.buffer;

	            if (valueType === '[object Int8Array]') {
	                marker += TYPE_INT8ARRAY;
	            } else if (valueType === '[object Uint8Array]') {
	                marker += TYPE_UINT8ARRAY;
	            } else if (valueType === '[object Uint8ClampedArray]') {
	                marker += TYPE_UINT8CLAMPEDARRAY;
	            } else if (valueType === '[object Int16Array]') {
	                marker += TYPE_INT16ARRAY;
	            } else if (valueType === '[object Uint16Array]') {
	                marker += TYPE_UINT16ARRAY;
	            } else if (valueType === '[object Int32Array]') {
	                marker += TYPE_INT32ARRAY;
	            } else if (valueType === '[object Uint32Array]') {
	                marker += TYPE_UINT32ARRAY;
	            } else if (valueType === '[object Float32Array]') {
	                marker += TYPE_FLOAT32ARRAY;
	            } else if (valueType === '[object Float64Array]') {
	                marker += TYPE_FLOAT64ARRAY;
	            } else {
	                callback(new Error('Failed to get type for BinaryArray'));
	            }
	        }

	        callback(marker + bufferToString(buffer));
	    } else if (valueType === '[object Blob]') {
	        // Conver the blob to a binaryArray and then to a string.
	        var fileReader = new FileReader();

	        fileReader.onload = function () {
	            // Backwards-compatible prefix for the blob type.
	            var str = BLOB_TYPE_PREFIX + value.type + '~' + bufferToString(this.result);

	            callback(SERIALIZED_MARKER + TYPE_BLOB + str);
	        };

	        fileReader.readAsArrayBuffer(value);
	    } else {
	        try {
	            callback(JSON.stringify(value));
	        } catch (e) {
	            console.error("Couldn't convert value into a JSON string: ", value);

	            callback(null, e);
	        }
	    }
	}

	// Deserialize data we've inserted into a value column/field. We place
	// special markers into our strings to mark them as encoded; this isn't
	// as nice as a meta field, but it's the only sane thing we can do whilst
	// keeping localStorage support intact.
	//
	// Oftentimes this will just deserialize JSON content, but if we have a
	// special marker (SERIALIZED_MARKER, defined above), we will extract
	// some kind of arraybuffer/binary data/typed array out of the string.
	function deserialize(value) {
	    // If we haven't marked this string as being specially serialized (i.e.
	    // something other than serialized JSON), we can just return it and be
	    // done with it.
	    if (value.substring(0, SERIALIZED_MARKER_LENGTH) !== SERIALIZED_MARKER) {
	        return JSON.parse(value);
	    }

	    // The following code deals with deserializing some kind of Blob or
	    // TypedArray. First we separate out the type of data we're dealing
	    // with from the data itself.
	    var serializedString = value.substring(TYPE_SERIALIZED_MARKER_LENGTH);
	    var type = value.substring(SERIALIZED_MARKER_LENGTH, TYPE_SERIALIZED_MARKER_LENGTH);

	    var blobType;
	    // Backwards-compatible blob type serialization strategy.
	    // DBs created with older versions of localForage will simply not have the blob type.
	    if (type === TYPE_BLOB && BLOB_TYPE_PREFIX_REGEX.test(serializedString)) {
	        var matcher = serializedString.match(BLOB_TYPE_PREFIX_REGEX);
	        blobType = matcher[1];
	        serializedString = serializedString.substring(matcher[0].length);
	    }
	    var buffer = stringToBuffer(serializedString);

	    // Return the right type based on the code/type set during
	    // serialization.
	    switch (type) {
	        case TYPE_ARRAYBUFFER:
	            return buffer;
	        case TYPE_BLOB:
	            return createBlob([buffer], { type: blobType });
	        case TYPE_INT8ARRAY:
	            return new Int8Array(buffer);
	        case TYPE_UINT8ARRAY:
	            return new Uint8Array(buffer);
	        case TYPE_UINT8CLAMPEDARRAY:
	            return new Uint8ClampedArray(buffer);
	        case TYPE_INT16ARRAY:
	            return new Int16Array(buffer);
	        case TYPE_UINT16ARRAY:
	            return new Uint16Array(buffer);
	        case TYPE_INT32ARRAY:
	            return new Int32Array(buffer);
	        case TYPE_UINT32ARRAY:
	            return new Uint32Array(buffer);
	        case TYPE_FLOAT32ARRAY:
	            return new Float32Array(buffer);
	        case TYPE_FLOAT64ARRAY:
	            return new Float64Array(buffer);
	        default:
	            throw new Error('Unkown type: ' + type);
	    }
	}

	var localforageSerializer = {
	    serialize: serialize,
	    deserialize: deserialize,
	    stringToBuffer: stringToBuffer,
	    bufferToString: bufferToString
	};

	/*
	 * Includes code from:
	 *
	 * base64-arraybuffer
	 * https://github.com/niklasvh/base64-arraybuffer
	 *
	 * Copyright (c) 2012 Niklas von Hertzen
	 * Licensed under the MIT license.
	 */

	function createDbTable(t, dbInfo, callback, errorCallback) {
	    t.executeSql('CREATE TABLE IF NOT EXISTS ' + dbInfo.storeName + ' ' + '(id INTEGER PRIMARY KEY, key unique, value)', [], callback, errorCallback);
	}

	// Open the WebSQL database (automatically creates one if one didn't
	// previously exist), using any options set in the config.
	function _initStorage$1(options) {
	    var self = this;
	    var dbInfo = {
	        db: null
	    };

	    if (options) {
	        for (var i in options) {
	            dbInfo[i] = typeof options[i] !== 'string' ? options[i].toString() : options[i];
	        }
	    }

	    var dbInfoPromise = new Promise$1(function (resolve, reject) {
	        // Open the database; the openDatabase API will automatically
	        // create it for us if it doesn't exist.
	        try {
	            dbInfo.db = openDatabase(dbInfo.name, String(dbInfo.version), dbInfo.description, dbInfo.size);
	        } catch (e) {
	            return reject(e);
	        }

	        // Create our key/value table if it doesn't exist.
	        dbInfo.db.transaction(function (t) {
	            createDbTable(t, dbInfo, function () {
	                self._dbInfo = dbInfo;
	                resolve();
	            }, function (t, error) {
	                reject(error);
	            });
	        }, reject);
	    });

	    dbInfo.serializer = localforageSerializer;
	    return dbInfoPromise;
	}

	function tryExecuteSql(t, dbInfo, sqlStatement, args, callback, errorCallback) {
	    t.executeSql(sqlStatement, args, callback, function (t, error) {
	        if (error.code === error.SYNTAX_ERR) {
	            t.executeSql('SELECT name FROM sqlite_master ' + "WHERE type='table' AND name = ?", [dbInfo.storeName], function (t, results) {
	                if (!results.rows.length) {
	                    // if the table is missing (was deleted)
	                    // re-create it table and retry
	                    createDbTable(t, dbInfo, function () {
	                        t.executeSql(sqlStatement, args, callback, errorCallback);
	                    }, errorCallback);
	                } else {
	                    errorCallback(t, error);
	                }
	            }, errorCallback);
	        } else {
	            errorCallback(t, error);
	        }
	    }, errorCallback);
	}

	function getItem$1(key, callback) {
	    var self = this;

	    key = normalizeKey(key);

	    var promise = new Promise$1(function (resolve, reject) {
	        self.ready().then(function () {
	            var dbInfo = self._dbInfo;
	            dbInfo.db.transaction(function (t) {
	                tryExecuteSql(t, dbInfo, 'SELECT * FROM ' + dbInfo.storeName + ' WHERE key = ? LIMIT 1', [key], function (t, results) {
	                    var result = results.rows.length ? results.rows.item(0).value : null;

	                    // Check to see if this is serialized content we need to
	                    // unpack.
	                    if (result) {
	                        result = dbInfo.serializer.deserialize(result);
	                    }

	                    resolve(result);
	                }, function (t, error) {
	                    reject(error);
	                });
	            });
	        })["catch"](reject);
	    });

	    executeCallback(promise, callback);
	    return promise;
	}

	function iterate$1(iterator, callback) {
	    var self = this;

	    var promise = new Promise$1(function (resolve, reject) {
	        self.ready().then(function () {
	            var dbInfo = self._dbInfo;

	            dbInfo.db.transaction(function (t) {
	                tryExecuteSql(t, dbInfo, 'SELECT * FROM ' + dbInfo.storeName, [], function (t, results) {
	                    var rows = results.rows;
	                    var length = rows.length;

	                    for (var i = 0; i < length; i++) {
	                        var item = rows.item(i);
	                        var result = item.value;

	                        // Check to see if this is serialized content
	                        // we need to unpack.
	                        if (result) {
	                            result = dbInfo.serializer.deserialize(result);
	                        }

	                        result = iterator(result, item.key, i + 1);

	                        // void(0) prevents problems with redefinition
	                        // of `undefined`.
	                        if (result !== void 0) {
	                            resolve(result);
	                            return;
	                        }
	                    }

	                    resolve();
	                }, function (t, error) {
	                    reject(error);
	                });
	            });
	        })["catch"](reject);
	    });

	    executeCallback(promise, callback);
	    return promise;
	}

	function _setItem(key, value, callback, retriesLeft) {
	    var self = this;

	    key = normalizeKey(key);

	    var promise = new Promise$1(function (resolve, reject) {
	        self.ready().then(function () {
	            // The localStorage API doesn't return undefined values in an
	            // "expected" way, so undefined is always cast to null in all
	            // drivers. See: https://github.com/mozilla/localForage/pull/42
	            if (value === undefined) {
	                value = null;
	            }

	            // Save the original value to pass to the callback.
	            var originalValue = value;

	            var dbInfo = self._dbInfo;
	            dbInfo.serializer.serialize(value, function (value, error) {
	                if (error) {
	                    reject(error);
	                } else {
	                    dbInfo.db.transaction(function (t) {
	                        tryExecuteSql(t, dbInfo, 'INSERT OR REPLACE INTO ' + dbInfo.storeName + ' ' + '(key, value) VALUES (?, ?)', [key, value], function () {
	                            resolve(originalValue);
	                        }, function (t, error) {
	                            reject(error);
	                        });
	                    }, function (sqlError) {
	                        // The transaction failed; check
	                        // to see if it's a quota error.
	                        if (sqlError.code === sqlError.QUOTA_ERR) {
	                            // We reject the callback outright for now, but
	                            // it's worth trying to re-run the transaction.
	                            // Even if the user accepts the prompt to use
	                            // more storage on Safari, this error will
	                            // be called.
	                            //
	                            // Try to re-run the transaction.
	                            if (retriesLeft > 0) {
	                                resolve(_setItem.apply(self, [key, originalValue, callback, retriesLeft - 1]));
	                                return;
	                            }
	                            reject(sqlError);
	                        }
	                    });
	                }
	            });
	        })["catch"](reject);
	    });

	    executeCallback(promise, callback);
	    return promise;
	}

	function setItem$1(key, value, callback) {
	    return _setItem.apply(this, [key, value, callback, 1]);
	}

	function removeItem$1(key, callback) {
	    var self = this;

	    key = normalizeKey(key);

	    var promise = new Promise$1(function (resolve, reject) {
	        self.ready().then(function () {
	            var dbInfo = self._dbInfo;
	            dbInfo.db.transaction(function (t) {
	                tryExecuteSql(t, dbInfo, 'DELETE FROM ' + dbInfo.storeName + ' WHERE key = ?', [key], function () {
	                    resolve();
	                }, function (t, error) {
	                    reject(error);
	                });
	            });
	        })["catch"](reject);
	    });

	    executeCallback(promise, callback);
	    return promise;
	}

	// Deletes every item in the table.
	// TODO: Find out if this resets the AUTO_INCREMENT number.
	function clear$1(callback) {
	    var self = this;

	    var promise = new Promise$1(function (resolve, reject) {
	        self.ready().then(function () {
	            var dbInfo = self._dbInfo;
	            dbInfo.db.transaction(function (t) {
	                tryExecuteSql(t, dbInfo, 'DELETE FROM ' + dbInfo.storeName, [], function () {
	                    resolve();
	                }, function (t, error) {
	                    reject(error);
	                });
	            });
	        })["catch"](reject);
	    });

	    executeCallback(promise, callback);
	    return promise;
	}

	// Does a simple `COUNT(key)` to get the number of items stored in
	// localForage.
	function length$1(callback) {
	    var self = this;

	    var promise = new Promise$1(function (resolve, reject) {
	        self.ready().then(function () {
	            var dbInfo = self._dbInfo;
	            dbInfo.db.transaction(function (t) {
	                // Ahhh, SQL makes this one soooooo easy.
	                tryExecuteSql(t, dbInfo, 'SELECT COUNT(key) as c FROM ' + dbInfo.storeName, [], function (t, results) {
	                    var result = results.rows.item(0).c;
	                    resolve(result);
	                }, function (t, error) {
	                    reject(error);
	                });
	            });
	        })["catch"](reject);
	    });

	    executeCallback(promise, callback);
	    return promise;
	}

	// Return the key located at key index X; essentially gets the key from a
	// `WHERE id = ?`. This is the most efficient way I can think to implement
	// this rarely-used (in my experience) part of the API, but it can seem
	// inconsistent, because we do `INSERT OR REPLACE INTO` on `setItem()`, so
	// the ID of each key will change every time it's updated. Perhaps a stored
	// procedure for the `setItem()` SQL would solve this problem?
	// TODO: Don't change ID on `setItem()`.
	function key$1(n, callback) {
	    var self = this;

	    var promise = new Promise$1(function (resolve, reject) {
	        self.ready().then(function () {
	            var dbInfo = self._dbInfo;
	            dbInfo.db.transaction(function (t) {
	                tryExecuteSql(t, dbInfo, 'SELECT key FROM ' + dbInfo.storeName + ' WHERE id = ? LIMIT 1', [n + 1], function (t, results) {
	                    var result = results.rows.length ? results.rows.item(0).key : null;
	                    resolve(result);
	                }, function (t, error) {
	                    reject(error);
	                });
	            });
	        })["catch"](reject);
	    });

	    executeCallback(promise, callback);
	    return promise;
	}

	function keys$1(callback) {
	    var self = this;

	    var promise = new Promise$1(function (resolve, reject) {
	        self.ready().then(function () {
	            var dbInfo = self._dbInfo;
	            dbInfo.db.transaction(function (t) {
	                tryExecuteSql(t, dbInfo, 'SELECT key FROM ' + dbInfo.storeName, [], function (t, results) {
	                    var keys = [];

	                    for (var i = 0; i < results.rows.length; i++) {
	                        keys.push(results.rows.item(i).key);
	                    }

	                    resolve(keys);
	                }, function (t, error) {
	                    reject(error);
	                });
	            });
	        })["catch"](reject);
	    });

	    executeCallback(promise, callback);
	    return promise;
	}

	// https://www.w3.org/TR/webdatabase/#databases
	// > There is no way to enumerate or delete the databases available for an origin from this API.
	function getAllStoreNames(db) {
	    return new Promise$1(function (resolve, reject) {
	        db.transaction(function (t) {
	            t.executeSql('SELECT name FROM sqlite_master ' + "WHERE type='table' AND name <> '__WebKitDatabaseInfoTable__'", [], function (t, results) {
	                var storeNames = [];

	                for (var i = 0; i < results.rows.length; i++) {
	                    storeNames.push(results.rows.item(i).name);
	                }

	                resolve({
	                    db: db,
	                    storeNames: storeNames
	                });
	            }, function (t, error) {
	                reject(error);
	            });
	        }, function (sqlError) {
	            reject(sqlError);
	        });
	    });
	}

	function dropInstance$1(options, callback) {
	    callback = getCallback.apply(this, arguments);

	    var currentConfig = this.config();
	    options = typeof options !== 'function' && options || {};
	    if (!options.name) {
	        options.name = options.name || currentConfig.name;
	        options.storeName = options.storeName || currentConfig.storeName;
	    }

	    var self = this;
	    var promise;
	    if (!options.name) {
	        promise = Promise$1.reject('Invalid arguments');
	    } else {
	        promise = new Promise$1(function (resolve) {
	            var db;
	            if (options.name === currentConfig.name) {
	                // use the db reference of the current instance
	                db = self._dbInfo.db;
	            } else {
	                db = openDatabase(options.name, '', '', 0);
	            }

	            if (!options.storeName) {
	                // drop all database tables
	                resolve(getAllStoreNames(db));
	            } else {
	                resolve({
	                    db: db,
	                    storeNames: [options.storeName]
	                });
	            }
	        }).then(function (operationInfo) {
	            return new Promise$1(function (resolve, reject) {
	                operationInfo.db.transaction(function (t) {
	                    function dropTable(storeName) {
	                        return new Promise$1(function (resolve, reject) {
	                            t.executeSql('DROP TABLE IF EXISTS ' + storeName, [], function () {
	                                resolve();
	                            }, function (t, error) {
	                                reject(error);
	                            });
	                        });
	                    }

	                    var operations = [];
	                    for (var i = 0, len = operationInfo.storeNames.length; i < len; i++) {
	                        operations.push(dropTable(operationInfo.storeNames[i]));
	                    }

	                    Promise$1.all(operations).then(function () {
	                        resolve();
	                    })["catch"](function (e) {
	                        reject(e);
	                    });
	                }, function (sqlError) {
	                    reject(sqlError);
	                });
	            });
	        });
	    }

	    executeCallback(promise, callback);
	    return promise;
	}

	var webSQLStorage = {
	    _driver: 'webSQLStorage',
	    _initStorage: _initStorage$1,
	    _support: isWebSQLValid(),
	    iterate: iterate$1,
	    getItem: getItem$1,
	    setItem: setItem$1,
	    removeItem: removeItem$1,
	    clear: clear$1,
	    length: length$1,
	    key: key$1,
	    keys: keys$1,
	    dropInstance: dropInstance$1
	};

	function isLocalStorageValid() {
	    try {
	        return typeof localStorage !== 'undefined' && 'setItem' in localStorage &&
	        // in IE8 typeof localStorage.setItem === 'object'
	        !!localStorage.setItem;
	    } catch (e) {
	        return false;
	    }
	}

	function _getKeyPrefix(options, defaultConfig) {
	    var keyPrefix = options.name + '/';

	    if (options.storeName !== defaultConfig.storeName) {
	        keyPrefix += options.storeName + '/';
	    }
	    return keyPrefix;
	}

	// Check if localStorage throws when saving an item
	function checkIfLocalStorageThrows() {
	    var localStorageTestKey = '_localforage_support_test';

	    try {
	        localStorage.setItem(localStorageTestKey, true);
	        localStorage.removeItem(localStorageTestKey);

	        return false;
	    } catch (e) {
	        return true;
	    }
	}

	// Check if localStorage is usable and allows to save an item
	// This method checks if localStorage is usable in Safari Private Browsing
	// mode, or in any other case where the available quota for localStorage
	// is 0 and there wasn't any saved items yet.
	function _isLocalStorageUsable() {
	    return !checkIfLocalStorageThrows() || localStorage.length > 0;
	}

	// Config the localStorage backend, using options set in the config.
	function _initStorage$2(options) {
	    var self = this;
	    var dbInfo = {};
	    if (options) {
	        for (var i in options) {
	            dbInfo[i] = options[i];
	        }
	    }

	    dbInfo.keyPrefix = _getKeyPrefix(options, self._defaultConfig);

	    if (!_isLocalStorageUsable()) {
	        return Promise$1.reject();
	    }

	    self._dbInfo = dbInfo;
	    dbInfo.serializer = localforageSerializer;

	    return Promise$1.resolve();
	}

	// Remove all keys from the datastore, effectively destroying all data in
	// the app's key/value store!
	function clear$2(callback) {
	    var self = this;
	    var promise = self.ready().then(function () {
	        var keyPrefix = self._dbInfo.keyPrefix;

	        for (var i = localStorage.length - 1; i >= 0; i--) {
	            var key = localStorage.key(i);

	            if (key.indexOf(keyPrefix) === 0) {
	                localStorage.removeItem(key);
	            }
	        }
	    });

	    executeCallback(promise, callback);
	    return promise;
	}

	// Retrieve an item from the store. Unlike the original async_storage
	// library in Gaia, we don't modify return values at all. If a key's value
	// is `undefined`, we pass that value to the callback function.
	function getItem$2(key, callback) {
	    var self = this;

	    key = normalizeKey(key);

	    var promise = self.ready().then(function () {
	        var dbInfo = self._dbInfo;
	        var result = localStorage.getItem(dbInfo.keyPrefix + key);

	        // If a result was found, parse it from the serialized
	        // string into a JS object. If result isn't truthy, the key
	        // is likely undefined and we'll pass it straight to the
	        // callback.
	        if (result) {
	            result = dbInfo.serializer.deserialize(result);
	        }

	        return result;
	    });

	    executeCallback(promise, callback);
	    return promise;
	}

	// Iterate over all items in the store.
	function iterate$2(iterator, callback) {
	    var self = this;

	    var promise = self.ready().then(function () {
	        var dbInfo = self._dbInfo;
	        var keyPrefix = dbInfo.keyPrefix;
	        var keyPrefixLength = keyPrefix.length;
	        var length = localStorage.length;

	        // We use a dedicated iterator instead of the `i` variable below
	        // so other keys we fetch in localStorage aren't counted in
	        // the `iterationNumber` argument passed to the `iterate()`
	        // callback.
	        //
	        // See: github.com/mozilla/localForage/pull/435#discussion_r38061530
	        var iterationNumber = 1;

	        for (var i = 0; i < length; i++) {
	            var key = localStorage.key(i);
	            if (key.indexOf(keyPrefix) !== 0) {
	                continue;
	            }
	            var value = localStorage.getItem(key);

	            // If a result was found, parse it from the serialized
	            // string into a JS object. If result isn't truthy, the
	            // key is likely undefined and we'll pass it straight
	            // to the iterator.
	            if (value) {
	                value = dbInfo.serializer.deserialize(value);
	            }

	            value = iterator(value, key.substring(keyPrefixLength), iterationNumber++);

	            if (value !== void 0) {
	                return value;
	            }
	        }
	    });

	    executeCallback(promise, callback);
	    return promise;
	}

	// Same as localStorage's key() method, except takes a callback.
	function key$2(n, callback) {
	    var self = this;
	    var promise = self.ready().then(function () {
	        var dbInfo = self._dbInfo;
	        var result;
	        try {
	            result = localStorage.key(n);
	        } catch (error) {
	            result = null;
	        }

	        // Remove the prefix from the key, if a key is found.
	        if (result) {
	            result = result.substring(dbInfo.keyPrefix.length);
	        }

	        return result;
	    });

	    executeCallback(promise, callback);
	    return promise;
	}

	function keys$2(callback) {
	    var self = this;
	    var promise = self.ready().then(function () {
	        var dbInfo = self._dbInfo;
	        var length = localStorage.length;
	        var keys = [];

	        for (var i = 0; i < length; i++) {
	            var itemKey = localStorage.key(i);
	            if (itemKey.indexOf(dbInfo.keyPrefix) === 0) {
	                keys.push(itemKey.substring(dbInfo.keyPrefix.length));
	            }
	        }

	        return keys;
	    });

	    executeCallback(promise, callback);
	    return promise;
	}

	// Supply the number of keys in the datastore to the callback function.
	function length$2(callback) {
	    var self = this;
	    var promise = self.keys().then(function (keys) {
	        return keys.length;
	    });

	    executeCallback(promise, callback);
	    return promise;
	}

	// Remove an item from the store, nice and simple.
	function removeItem$2(key, callback) {
	    var self = this;

	    key = normalizeKey(key);

	    var promise = self.ready().then(function () {
	        var dbInfo = self._dbInfo;
	        localStorage.removeItem(dbInfo.keyPrefix + key);
	    });

	    executeCallback(promise, callback);
	    return promise;
	}

	// Set a key's value and run an optional callback once the value is set.
	// Unlike Gaia's implementation, the callback function is passed the value,
	// in case you want to operate on that value only after you're sure it
	// saved, or something like that.
	function setItem$2(key, value, callback) {
	    var self = this;

	    key = normalizeKey(key);

	    var promise = self.ready().then(function () {
	        // Convert undefined values to null.
	        // https://github.com/mozilla/localForage/pull/42
	        if (value === undefined) {
	            value = null;
	        }

	        // Save the original value to pass to the callback.
	        var originalValue = value;

	        return new Promise$1(function (resolve, reject) {
	            var dbInfo = self._dbInfo;
	            dbInfo.serializer.serialize(value, function (value, error) {
	                if (error) {
	                    reject(error);
	                } else {
	                    try {
	                        localStorage.setItem(dbInfo.keyPrefix + key, value);
	                        resolve(originalValue);
	                    } catch (e) {
	                        // localStorage capacity exceeded.
	                        // TODO: Make this a specific error/event.
	                        if (e.name === 'QuotaExceededError' || e.name === 'NS_ERROR_DOM_QUOTA_REACHED') {
	                            reject(e);
	                        }
	                        reject(e);
	                    }
	                }
	            });
	        });
	    });

	    executeCallback(promise, callback);
	    return promise;
	}

	function dropInstance$2(options, callback) {
	    callback = getCallback.apply(this, arguments);

	    options = typeof options !== 'function' && options || {};
	    if (!options.name) {
	        var currentConfig = this.config();
	        options.name = options.name || currentConfig.name;
	        options.storeName = options.storeName || currentConfig.storeName;
	    }

	    var self = this;
	    var promise;
	    if (!options.name) {
	        promise = Promise$1.reject('Invalid arguments');
	    } else {
	        promise = new Promise$1(function (resolve) {
	            if (!options.storeName) {
	                resolve(options.name + '/');
	            } else {
	                resolve(_getKeyPrefix(options, self._defaultConfig));
	            }
	        }).then(function (keyPrefix) {
	            for (var i = localStorage.length - 1; i >= 0; i--) {
	                var key = localStorage.key(i);

	                if (key.indexOf(keyPrefix) === 0) {
	                    localStorage.removeItem(key);
	                }
	            }
	        });
	    }

	    executeCallback(promise, callback);
	    return promise;
	}

	var localStorageWrapper = {
	    _driver: 'localStorageWrapper',
	    _initStorage: _initStorage$2,
	    _support: isLocalStorageValid(),
	    iterate: iterate$2,
	    getItem: getItem$2,
	    setItem: setItem$2,
	    removeItem: removeItem$2,
	    clear: clear$2,
	    length: length$2,
	    key: key$2,
	    keys: keys$2,
	    dropInstance: dropInstance$2
	};

	var sameValue = function sameValue(x, y) {
	    return x === y || typeof x === 'number' && typeof y === 'number' && isNaN(x) && isNaN(y);
	};

	var includes = function includes(array, searchElement) {
	    var len = array.length;
	    var i = 0;
	    while (i < len) {
	        if (sameValue(array[i], searchElement)) {
	            return true;
	        }
	        i++;
	    }

	    return false;
	};

	var isArray = Array.isArray || function (arg) {
	    return Object.prototype.toString.call(arg) === '[object Array]';
	};

	// Drivers are stored here when `defineDriver()` is called.
	// They are shared across all instances of localForage.
	var DefinedDrivers = {};

	var DriverSupport = {};

	var DefaultDrivers = {
	    INDEXEDDB: asyncStorage,
	    WEBSQL: webSQLStorage,
	    LOCALSTORAGE: localStorageWrapper
	};

	var DefaultDriverOrder = [DefaultDrivers.INDEXEDDB._driver, DefaultDrivers.WEBSQL._driver, DefaultDrivers.LOCALSTORAGE._driver];

	var OptionalDriverMethods = ['dropInstance'];

	var LibraryMethods = ['clear', 'getItem', 'iterate', 'key', 'keys', 'length', 'removeItem', 'setItem'].concat(OptionalDriverMethods);

	var DefaultConfig = {
	    description: '',
	    driver: DefaultDriverOrder.slice(),
	    name: 'localforage',
	    // Default DB size is _JUST UNDER_ 5MB, as it's the highest size
	    // we can use without a prompt.
	    size: 4980736,
	    storeName: 'keyvaluepairs',
	    version: 1.0
	};

	function callWhenReady(localForageInstance, libraryMethod) {
	    localForageInstance[libraryMethod] = function () {
	        var _args = arguments;
	        return localForageInstance.ready().then(function () {
	            return localForageInstance[libraryMethod].apply(localForageInstance, _args);
	        });
	    };
	}

	function extend() {
	    for (var i = 1; i < arguments.length; i++) {
	        var arg = arguments[i];

	        if (arg) {
	            for (var _key in arg) {
	                if (arg.hasOwnProperty(_key)) {
	                    if (isArray(arg[_key])) {
	                        arguments[0][_key] = arg[_key].slice();
	                    } else {
	                        arguments[0][_key] = arg[_key];
	                    }
	                }
	            }
	        }
	    }

	    return arguments[0];
	}

	var LocalForage = function () {
	    function LocalForage(options) {
	        _classCallCheck(this, LocalForage);

	        for (var driverTypeKey in DefaultDrivers) {
	            if (DefaultDrivers.hasOwnProperty(driverTypeKey)) {
	                var driver = DefaultDrivers[driverTypeKey];
	                var driverName = driver._driver;
	                this[driverTypeKey] = driverName;

	                if (!DefinedDrivers[driverName]) {
	                    // we don't need to wait for the promise,
	                    // since the default drivers can be defined
	                    // in a blocking manner
	                    this.defineDriver(driver);
	                }
	            }
	        }

	        this._defaultConfig = extend({}, DefaultConfig);
	        this._config = extend({}, this._defaultConfig, options);
	        this._driverSet = null;
	        this._initDriver = null;
	        this._ready = false;
	        this._dbInfo = null;

	        this._wrapLibraryMethodsWithReady();
	        this.setDriver(this._config.driver)["catch"](function () {});
	    }

	    // Set any config values for localForage; can be called anytime before
	    // the first API call (e.g. `getItem`, `setItem`).
	    // We loop through options so we don't overwrite existing config
	    // values.


	    LocalForage.prototype.config = function config(options) {
	        // If the options argument is an object, we use it to set values.
	        // Otherwise, we return either a specified config value or all
	        // config values.
	        if ((typeof options === 'undefined' ? 'undefined' : _typeof(options)) === 'object') {
	            // If localforage is ready and fully initialized, we can't set
	            // any new configuration values. Instead, we return an error.
	            if (this._ready) {
	                return new Error("Can't call config() after localforage " + 'has been used.');
	            }

	            for (var i in options) {
	                if (i === 'storeName') {
	                    options[i] = options[i].replace(/\W/g, '_');
	                }

	                if (i === 'version' && typeof options[i] !== 'number') {
	                    return new Error('Database version must be a number.');
	                }

	                this._config[i] = options[i];
	            }

	            // after all config options are set and
	            // the driver option is used, try setting it
	            if ('driver' in options && options.driver) {
	                return this.setDriver(this._config.driver);
	            }

	            return true;
	        } else if (typeof options === 'string') {
	            return this._config[options];
	        } else {
	            return this._config;
	        }
	    };

	    // Used to define a custom driver, shared across all instances of
	    // localForage.


	    LocalForage.prototype.defineDriver = function defineDriver(driverObject, callback, errorCallback) {
	        var promise = new Promise$1(function (resolve, reject) {
	            try {
	                var driverName = driverObject._driver;
	                var complianceError = new Error('Custom driver not compliant; see ' + 'https://mozilla.github.io/localForage/#definedriver');

	                // A driver name should be defined and not overlap with the
	                // library-defined, default drivers.
	                if (!driverObject._driver) {
	                    reject(complianceError);
	                    return;
	                }

	                var driverMethods = LibraryMethods.concat('_initStorage');
	                for (var i = 0, len = driverMethods.length; i < len; i++) {
	                    var driverMethodName = driverMethods[i];

	                    // when the property is there,
	                    // it should be a method even when optional
	                    var isRequired = !includes(OptionalDriverMethods, driverMethodName);
	                    if ((isRequired || driverObject[driverMethodName]) && typeof driverObject[driverMethodName] !== 'function') {
	                        reject(complianceError);
	                        return;
	                    }
	                }

	                var configureMissingMethods = function configureMissingMethods() {
	                    var methodNotImplementedFactory = function methodNotImplementedFactory(methodName) {
	                        return function () {
	                            var error = new Error('Method ' + methodName + ' is not implemented by the current driver');
	                            var promise = Promise$1.reject(error);
	                            executeCallback(promise, arguments[arguments.length - 1]);
	                            return promise;
	                        };
	                    };

	                    for (var _i = 0, _len = OptionalDriverMethods.length; _i < _len; _i++) {
	                        var optionalDriverMethod = OptionalDriverMethods[_i];
	                        if (!driverObject[optionalDriverMethod]) {
	                            driverObject[optionalDriverMethod] = methodNotImplementedFactory(optionalDriverMethod);
	                        }
	                    }
	                };

	                configureMissingMethods();

	                var setDriverSupport = function setDriverSupport(support) {
	                    if (DefinedDrivers[driverName]) {
	                        console.info('Redefining LocalForage driver: ' + driverName);
	                    }
	                    DefinedDrivers[driverName] = driverObject;
	                    DriverSupport[driverName] = support;
	                    // don't use a then, so that we can define
	                    // drivers that have simple _support methods
	                    // in a blocking manner
	                    resolve();
	                };

	                if ('_support' in driverObject) {
	                    if (driverObject._support && typeof driverObject._support === 'function') {
	                        driverObject._support().then(setDriverSupport, reject);
	                    } else {
	                        setDriverSupport(!!driverObject._support);
	                    }
	                } else {
	                    setDriverSupport(true);
	                }
	            } catch (e) {
	                reject(e);
	            }
	        });

	        executeTwoCallbacks(promise, callback, errorCallback);
	        return promise;
	    };

	    LocalForage.prototype.driver = function driver() {
	        return this._driver || null;
	    };

	    LocalForage.prototype.getDriver = function getDriver(driverName, callback, errorCallback) {
	        var getDriverPromise = DefinedDrivers[driverName] ? Promise$1.resolve(DefinedDrivers[driverName]) : Promise$1.reject(new Error('Driver not found.'));

	        executeTwoCallbacks(getDriverPromise, callback, errorCallback);
	        return getDriverPromise;
	    };

	    LocalForage.prototype.getSerializer = function getSerializer(callback) {
	        var serializerPromise = Promise$1.resolve(localforageSerializer);
	        executeTwoCallbacks(serializerPromise, callback);
	        return serializerPromise;
	    };

	    LocalForage.prototype.ready = function ready(callback) {
	        var self = this;

	        var promise = self._driverSet.then(function () {
	            if (self._ready === null) {
	                self._ready = self._initDriver();
	            }

	            return self._ready;
	        });

	        executeTwoCallbacks(promise, callback, callback);
	        return promise;
	    };

	    LocalForage.prototype.setDriver = function setDriver(drivers, callback, errorCallback) {
	        var self = this;

	        if (!isArray(drivers)) {
	            drivers = [drivers];
	        }

	        var supportedDrivers = this._getSupportedDrivers(drivers);

	        function setDriverToConfig() {
	            self._config.driver = self.driver();
	        }

	        function extendSelfWithDriver(driver) {
	            self._extend(driver);
	            setDriverToConfig();

	            self._ready = self._initStorage(self._config);
	            return self._ready;
	        }

	        function initDriver(supportedDrivers) {
	            return function () {
	                var currentDriverIndex = 0;

	                function driverPromiseLoop() {
	                    while (currentDriverIndex < supportedDrivers.length) {
	                        var driverName = supportedDrivers[currentDriverIndex];
	                        currentDriverIndex++;

	                        self._dbInfo = null;
	                        self._ready = null;

	                        return self.getDriver(driverName).then(extendSelfWithDriver)["catch"](driverPromiseLoop);
	                    }

	                    setDriverToConfig();
	                    var error = new Error('No available storage method found.');
	                    self._driverSet = Promise$1.reject(error);
	                    return self._driverSet;
	                }

	                return driverPromiseLoop();
	            };
	        }

	        // There might be a driver initialization in progress
	        // so wait for it to finish in order to avoid a possible
	        // race condition to set _dbInfo
	        var oldDriverSetDone = this._driverSet !== null ? this._driverSet["catch"](function () {
	            return Promise$1.resolve();
	        }) : Promise$1.resolve();

	        this._driverSet = oldDriverSetDone.then(function () {
	            var driverName = supportedDrivers[0];
	            self._dbInfo = null;
	            self._ready = null;

	            return self.getDriver(driverName).then(function (driver) {
	                self._driver = driver._driver;
	                setDriverToConfig();
	                self._wrapLibraryMethodsWithReady();
	                self._initDriver = initDriver(supportedDrivers);
	            });
	        })["catch"](function () {
	            setDriverToConfig();
	            var error = new Error('No available storage method found.');
	            self._driverSet = Promise$1.reject(error);
	            return self._driverSet;
	        });

	        executeTwoCallbacks(this._driverSet, callback, errorCallback);
	        return this._driverSet;
	    };

	    LocalForage.prototype.supports = function supports(driverName) {
	        return !!DriverSupport[driverName];
	    };

	    LocalForage.prototype._extend = function _extend(libraryMethodsAndProperties) {
	        extend(this, libraryMethodsAndProperties);
	    };

	    LocalForage.prototype._getSupportedDrivers = function _getSupportedDrivers(drivers) {
	        var supportedDrivers = [];
	        for (var i = 0, len = drivers.length; i < len; i++) {
	            var driverName = drivers[i];
	            if (this.supports(driverName)) {
	                supportedDrivers.push(driverName);
	            }
	        }
	        return supportedDrivers;
	    };

	    LocalForage.prototype._wrapLibraryMethodsWithReady = function _wrapLibraryMethodsWithReady() {
	        // Add a stub for each driver API method that delays the call to the
	        // corresponding driver method until localForage is ready. These stubs
	        // will be replaced by the driver methods as soon as the driver is
	        // loaded, so there is no performance impact.
	        for (var i = 0, len = LibraryMethods.length; i < len; i++) {
	            callWhenReady(this, LibraryMethods[i]);
	        }
	    };

	    LocalForage.prototype.createInstance = function createInstance(options) {
	        return new LocalForage(options);
	    };

	    return LocalForage;
	}();

	// The actual localForage object that we expose as a module or via a
	// global. It's extended by pulling in one of our other libraries.


	var localforage_js = new LocalForage();

	module.exports = localforage_js;

	},{"3":3}]},{},[4])(4)
	}); 
} (localforage));

var localforageExports = localforage.exports;

var UploadState = {};

Object.defineProperty(UploadState, "__esModule", { value: true });
UploadState.UploadState = void 0;
UploadState.UploadState = {
    Completed: "COMPLETED",
    Retry: "RETRY",
    Failed: "FAILED",
    NotStarted: "NOT_STARTED",
    Started: "STARTED",
};

var StreamState = {};

Object.defineProperty(StreamState, "__esModule", { value: true });
StreamState.StreamState = void 0;
StreamState.StreamState = {
    Created: "CREATED",
    Open: "OPEN",
    Closing: "CLOSING",
    Finalizing: "FINALIZING",
    Closed: "CLOSED",
    ERROR: "ERROR",
};

var __awaiter$2 = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator$2 = (commonjsGlobal && commonjsGlobal.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault$1 = (commonjsGlobal && commonjsGlobal.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(UploadQueue$1, "__esModule", { value: true });
UploadQueue$1.UploadQueue = void 0;
var localforage_1 = __importDefault$1(localforageExports);
var UploadState_1$1 = UploadState;
var StreamState_1 = StreamState;
var UploadQueue = /** @class */ (function () {
    function UploadQueue(finalizeFunc) {
        this.retryAttempts = 3;
        this.storage = localforage_1.default.createInstance({
            name: "UploadQueue",
            storeName: "uploads",
        });
        this.processingQueue = localforage_1.default.createInstance({
            name: "UploadQueue",
            storeName: "processingQueue",
        });
        this.streamTasks = localforage_1.default.createInstance({
            name: "UploadQueue",
            storeName: "streamTasks",
        });
        this.finalizeFunc = finalizeFunc;
    }
    UploadQueue.prototype.getStreamTask = function (id) {
        return __awaiter$2(this, void 0, void 0, function () {
            return __generator$2(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.streamTasks.getItem(id)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    UploadQueue.prototype.QueueUpload = function (upload) {
        return __awaiter$2(this, void 0, void 0, function () {
            var streamTask;
            return __generator$2(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(upload.StreamId !== null)) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.getStreamTask(upload.StreamId)];
                    case 1:
                        streamTask = _a.sent();
                        if (streamTask == null) {
                            throw new Error("Stream task not found");
                        }
                        streamTask.uploads.push(upload.Id);
                        return [4 /*yield*/, this.streamTasks.setItem(upload.StreamId, streamTask)];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3: return [4 /*yield*/, this.storage.setItem(upload.Id, upload)];
                    case 4:
                        _a.sent();
                        return [4 /*yield*/, this.processingQueue.setItem(upload.Id, UploadState_1$1.UploadState.NotStarted)];
                    case 5:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    UploadQueue.prototype.QueueStreamBytes = function (streamId, data) {
        return __awaiter$2(this, void 0, void 0, function () {
            var streamTask, upload;
            return __generator$2(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getStreamTask(streamId)];
                    case 1:
                        streamTask = _a.sent();
                        if (streamTask == null) {
                            throw new Error("Stream task not found");
                        }
                        if (streamTask.State == StreamState_1.StreamState.Closed ||
                            streamTask.State == StreamState_1.StreamState.Finalizing)
                            throw new Error("Stream is closed");
                        upload = {
                            Id: crypto.randomUUID(),
                            Attempts: 0,
                            StreamId: streamId,
                            MediaId: null,
                            UploadUrl: streamTask.uploadUrl + "/" + streamTask.sequence,
                            Content: data,
                            ContentRange: "bytes ".concat(streamTask.bytes, "-").concat(streamTask.bytes + data.byteLength - 1, "/*"),
                        };
                        streamTask.uploads.push(upload.Id);
                        streamTask.bytes += upload.Content.byteLength;
                        streamTask.sequence++;
                        streamTask.State = StreamState_1.StreamState.Open;
                        return [4 /*yield*/, this.streamTasks.setItem(streamId, streamTask)];
                    case 2:
                        _a.sent();
                        return [4 /*yield*/, this.storage.setItem(upload.Id, upload)];
                    case 3:
                        _a.sent();
                        return [4 /*yield*/, this.processingQueue.setItem(upload.Id, UploadState_1$1.UploadState.NotStarted)];
                    case 4:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    UploadQueue.prototype.CreateStreamTask = function (uploadUrl, finalizeUrl) {
        return __awaiter$2(this, void 0, void 0, function () {
            var streamTask;
            return __generator$2(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        streamTask = {
                            Id: crypto.randomUUID(),
                            State: UploadState_1$1.UploadState.NotStarted,
                            uploads: [],
                            bytes: 0,
                            sequence: 0,
                            uploadUrl: uploadUrl,
                            finalizeUrl: finalizeUrl,
                        };
                        return [4 /*yield*/, this.streamTasks.setItem(streamTask.Id, streamTask)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, streamTask.Id];
                }
            });
        });
    };
    UploadQueue.prototype.GetQueuedTasks = function () {
        return __awaiter$2(this, void 0, void 0, function () {
            var keys, tasks, i, key, state;
            return __generator$2(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.processingQueue.keys()];
                    case 1:
                        keys = _a.sent();
                        tasks = [];
                        i = 0;
                        _a.label = 2;
                    case 2:
                        if (!(i < keys.length)) return [3 /*break*/, 5];
                        key = keys[i];
                        return [4 /*yield*/, this.processingQueue.getItem(key)];
                    case 3:
                        state = _a.sent();
                        if (state == UploadState_1$1.UploadState.NotStarted) {
                            tasks.push(key);
                        }
                        _a.label = 4;
                    case 4:
                        i++;
                        return [3 /*break*/, 2];
                    case 5: return [2 /*return*/, tasks];
                }
            });
        });
    };
    UploadQueue.prototype.GetProcessingTasks = function () {
        return __awaiter$2(this, void 0, void 0, function () {
            var keys, tasks, i, key, state;
            return __generator$2(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.processingQueue.keys()];
                    case 1:
                        keys = _a.sent();
                        tasks = [];
                        i = 0;
                        _a.label = 2;
                    case 2:
                        if (!(i < keys.length)) return [3 /*break*/, 5];
                        key = keys[i];
                        return [4 /*yield*/, this.processingQueue.getItem(key)];
                    case 3:
                        state = _a.sent();
                        if (state == UploadState_1$1.UploadState.Started) {
                            tasks.push(key);
                        }
                        _a.label = 4;
                    case 4:
                        i++;
                        return [3 /*break*/, 2];
                    case 5: return [2 /*return*/, tasks];
                }
            });
        });
    };
    UploadQueue.prototype.GetNextUpload = function () {
        return __awaiter$2(this, void 0, void 0, function () {
            var keys, i, key, state;
            return __generator$2(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.processingQueue.keys()];
                    case 1:
                        keys = _a.sent();
                        i = 0;
                        _a.label = 2;
                    case 2:
                        if (!(i < keys.length)) return [3 /*break*/, 6];
                        key = keys[i];
                        return [4 /*yield*/, this.processingQueue.getItem(key)];
                    case 3:
                        state = _a.sent();
                        if (!(state == UploadState_1$1.UploadState.NotStarted || state == UploadState_1$1.UploadState.Retry)) return [3 /*break*/, 5];
                        return [4 /*yield*/, this.storage.getItem(key)];
                    case 4: return [2 /*return*/, _a.sent()];
                    case 5:
                        i++;
                        return [3 /*break*/, 2];
                    case 6: return [2 /*return*/, null];
                }
            });
        });
    };
    UploadQueue.prototype.SetUploadState = function (uploadId, state) {
        var _a;
        return __awaiter$2(this, void 0, void 0, function () {
            var upload, currentState, _b, streamTask;
            return __generator$2(this, function (_c) {
                switch (_c.label) {
                    case 0: return [4 /*yield*/, this.storage.getItem(uploadId)];
                    case 1:
                        upload = _c.sent();
                        if (upload == null)
                            throw new Error("Upload not found");
                        return [4 /*yield*/, this.processingQueue.getItem(uploadId)];
                    case 2:
                        currentState = _c.sent();
                        console.info("Upload ".concat(uploadId, " - ").concat(currentState, " -> ").concat(state));
                        _b = state;
                        switch (_b) {
                            case UploadState_1$1.UploadState.Started: return [3 /*break*/, 3];
                            case UploadState_1$1.UploadState.Completed: return [3 /*break*/, 6];
                            case UploadState_1$1.UploadState.Failed: return [3 /*break*/, 11];
                        }
                        return [3 /*break*/, 12];
                    case 3:
                        upload.Attempts = upload.Attempts ? upload.Attempts + 1 : 1;
                        return [4 /*yield*/, this.storage.setItem(uploadId, upload)];
                    case 4:
                        _c.sent();
                        return [4 /*yield*/, this.processingQueue.setItem(uploadId, state)];
                    case 5:
                        _c.sent();
                        return [3 /*break*/, 13];
                    case 6: return [4 /*yield*/, this.processingQueue.setItem(uploadId, UploadState_1$1.UploadState.Completed)];
                    case 7:
                        _c.sent();
                        if (!(upload.StreamId !== null)) return [3 /*break*/, 10];
                        return [4 /*yield*/, this.getStreamTask(upload.StreamId)];
                    case 8:
                        streamTask = _c.sent();
                        if (streamTask == null)
                            throw new Error("Stream task not found");
                        if (!(streamTask.State === StreamState_1.StreamState.Finalizing)) return [3 /*break*/, 10];
                        return [4 /*yield*/, this.FinalizeStream(upload.StreamId)];
                    case 9:
                        _c.sent();
                        _c.label = 10;
                    case 10: return [3 /*break*/, 13];
                    case 11:
                        {
                            //Check to see if we have tried more times than the limit
                            if (((_a = upload.Attempts) !== null && _a !== void 0 ? _a : 0 >= this.retryAttempts) ? this.retryAttempts : 0) {
                                //If under the limit, set the state to retry
                                console.warn("Upload failed - retrying", uploadId);
                                this.processingQueue.setItem(uploadId, UploadState_1$1.UploadState.Retry);
                            }
                            else {
                                //If over the limit, set the state to failed
                                console.error("Upload retries exhausted - setting to failed", uploadId);
                                this.processingQueue.setItem(uploadId, UploadState_1$1.UploadState.Failed);
                            }
                        }
                        return [3 /*break*/, 13];
                    case 12:
                        this.processingQueue.setItem(uploadId, state);
                        return [3 /*break*/, 13];
                    case 13: return [2 /*return*/];
                }
            });
        });
    };
    //set all Started uploads back to NoStarted
    UploadQueue.prototype.ResetUploads = function () {
        return __awaiter$2(this, void 0, void 0, function () {
            var keys, i, key, state;
            return __generator$2(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.processingQueue.keys()];
                    case 1:
                        keys = _a.sent();
                        i = 0;
                        _a.label = 2;
                    case 2:
                        if (!(i < keys.length)) return [3 /*break*/, 6];
                        key = keys[i];
                        return [4 /*yield*/, this.processingQueue.getItem(key)];
                    case 3:
                        state = _a.sent();
                        if (!(state == UploadState_1$1.UploadState.Started)) return [3 /*break*/, 5];
                        return [4 /*yield*/, this.processingQueue.setItem(key, UploadState_1$1.UploadState.NotStarted)];
                    case 4:
                        _a.sent();
                        _a.label = 5;
                    case 5:
                        i++;
                        return [3 /*break*/, 2];
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    UploadQueue.prototype.ClearUploads = function () {
        return __awaiter$2(this, void 0, void 0, function () {
            return __generator$2(this, function (_a) {
                this.processingQueue.clear();
                this.storage.clear();
                this.streamTasks.clear;
                return [2 /*return*/];
            });
        });
    };
    UploadQueue.prototype.Cleanup = function () {
        return __awaiter$2(this, void 0, void 0, function () {
            var keys, i, key, state, streamTaskKeys, i, key, streamTask;
            return __generator$2(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.processingQueue.keys()];
                    case 1:
                        keys = _a.sent();
                        i = 0;
                        _a.label = 2;
                    case 2:
                        if (!(i < keys.length)) return [3 /*break*/, 7];
                        key = keys[i];
                        return [4 /*yield*/, this.processingQueue.getItem(key)];
                    case 3:
                        state = _a.sent();
                        if (!(state == UploadState_1$1.UploadState.Completed || state == UploadState_1$1.UploadState.Failed)) return [3 /*break*/, 6];
                        return [4 /*yield*/, this.processingQueue.removeItem(key)];
                    case 4:
                        _a.sent();
                        return [4 /*yield*/, this.storage.removeItem(key)];
                    case 5:
                        _a.sent();
                        _a.label = 6;
                    case 6:
                        i++;
                        return [3 /*break*/, 2];
                    case 7: return [4 /*yield*/, this.streamTasks.keys()];
                    case 8:
                        streamTaskKeys = _a.sent();
                        i = 0;
                        _a.label = 9;
                    case 9:
                        if (!(i < streamTaskKeys.length)) return [3 /*break*/, 13];
                        key = streamTaskKeys[i];
                        return [4 /*yield*/, this.streamTasks.getItem(key)];
                    case 10:
                        streamTask = _a.sent();
                        if (!(streamTask && streamTask.State == StreamState_1.StreamState.Closed)) return [3 /*break*/, 12];
                        return [4 /*yield*/, this.streamTasks.removeItem(key)];
                    case 11:
                        _a.sent();
                        _a.label = 12;
                    case 12:
                        i++;
                        return [3 /*break*/, 9];
                    case 13: return [2 /*return*/];
                }
            });
        });
    };
    UploadQueue.prototype.FinalizeUpload = function (uploadId) {
        return __awaiter$2(this, void 0, void 0, function () {
            var upload;
            return __generator$2(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.storage.getItem(uploadId)];
                    case 1:
                        upload = _a.sent();
                        if (upload == null)
                            throw new Error("Upload not found");
                        return [2 /*return*/];
                }
            });
        });
    };
    UploadQueue.prototype.FinalizeStream = function (streamId) {
        return __awaiter$2(this, void 0, void 0, function () {
            var streamTask, i, state, response, i, upload, e_1;
            return __generator$2(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getStreamTask(streamId)];
                    case 1:
                        streamTask = _a.sent();
                        if (streamTask == null)
                            throw new Error("Stream task not found");
                        i = 0;
                        _a.label = 2;
                    case 2:
                        if (!(i < streamTask.uploads.length)) return [3 /*break*/, 6];
                        return [4 /*yield*/, this.processingQueue.getItem(streamTask.uploads[i])];
                    case 3:
                        state = _a.sent();
                        if (!(state !== UploadState_1$1.UploadState.Completed)) return [3 /*break*/, 5];
                        console.log("Uploads processing - Setting stream to finalizing");
                        streamTask.State = StreamState_1.StreamState.Finalizing;
                        return [4 /*yield*/, this.streamTasks.setItem(streamId, streamTask)];
                    case 4:
                        _a.sent();
                        return [2 /*return*/];
                    case 5:
                        i++;
                        return [3 /*break*/, 2];
                    case 6:
                        console.log("Uploads completed - Finalizing and closing stream");
                        _a.label = 7;
                    case 7:
                        _a.trys.push([7, 17, , 18]);
                        return [4 /*yield*/, this.finalizeFunc(streamTask.finalizeUrl)];
                    case 8:
                        response = _a.sent();
                        if (!(response && response.length > 0)) return [3 /*break*/, 14];
                        console.log("Finalize failed - Requeueing media");
                        i = 0;
                        _a.label = 9;
                    case 9:
                        if (!(i < response.length)) return [3 /*break*/, 13];
                        return [4 /*yield*/, this.storage.getItem(response[i])];
                    case 10:
                        upload = _a.sent();
                        if (upload == null)
                            throw new Error("Upload not found");
                        return [4 /*yield*/, this.processingQueue.setItem(upload.Id, UploadState_1$1.UploadState.NotStarted)];
                    case 11:
                        _a.sent();
                        _a.label = 12;
                    case 12:
                        i++;
                        return [3 /*break*/, 9];
                    case 13: return [3 /*break*/, 16];
                    case 14:
                        streamTask.State = StreamState_1.StreamState.Closed;
                        return [4 /*yield*/, this.streamTasks.setItem(streamId, streamTask)];
                    case 15:
                        _a.sent();
                        _a.label = 16;
                    case 16: return [3 /*break*/, 18];
                    case 17:
                        e_1 = _a.sent();
                        //Finalize failed. Get the list of failed media and requeue them
                        console.warn("Finalize failed", e_1);
                        return [3 /*break*/, 18];
                    case 18: return [2 /*return*/];
                }
            });
        });
    };
    return UploadQueue;
}());
UploadQueue$1.UploadQueue = UploadQueue;

var UploadProcessor$1 = {};

var __awaiter$1 = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator$1 = (commonjsGlobal && commonjsGlobal.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(UploadProcessor$1, "__esModule", { value: true });
var UploadQueue_1$1 = UploadQueue$1;
var UploadState_1 = UploadState;
var UploadProcessor = /** @class */ (function () {
    function UploadProcessor(tokenFactory, clientConfiguration) {
        var _this = this;
        this.requests = {};
        this.uploadProgress = {};
        this.tokenFactory = tokenFactory;
        this.isProcessing = false;
        this.configuration = clientConfiguration;
        this.uploadQueue = new UploadQueue_1$1.UploadQueue(function (url) { return __awaiter$1(_this, void 0, void 0, function () {
            var token;
            return __generator$1(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.tokenFactory()];
                    case 1:
                        token = _a.sent();
                        return [2 /*return*/, UploadProcessor.finalize(url, token)];
                }
            });
        }); });
        this.uploadQueue.ResetUploads();
    }
    UploadProcessor.finalize = function (finalizeUrl, authToken, iteration) {
        if (iteration === void 0) { iteration = 0; }
        return __awaiter$1(this, void 0, void 0, function () {
            var response, retryValues;
            return __generator$1(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, fetch(finalizeUrl, {
                            method: "POST",
                            headers: {
                                "Content-Type": "application/json",
                                Authorization: "Bearer ".concat(authToken),
                            },
                        })];
                    case 1:
                        response = _a.sent();
                        if (!(response.status === 424)) return [3 /*break*/, 8];
                        if (iteration === 3) {
                            throw new Error("Failed to finalize");
                        }
                        return [4 /*yield*/, response.json()];
                    case 2:
                        retryValues = (_a.sent());
                        if (!(retryValues.length === 0)) return [3 /*break*/, 5];
                        console.log("Nothing to resend - Retrying finalize");
                        return [4 /*yield*/, new Promise(function (resolve) { return setTimeout(resolve, 5000); })];
                    case 3:
                        _a.sent();
                        return [4 /*yield*/, UploadProcessor.finalize(finalizeUrl, authToken, iteration + 1)];
                    case 4: return [2 /*return*/, _a.sent()];
                    case 5:
                        //Resend bad chunks
                        console.log("Resending requested chunks");
                        return [4 /*yield*/, response.json()];
                    case 6: return [2 /*return*/, _a.sent()];
                    case 7: return [3 /*break*/, 9];
                    case 8:
                        if (response.status === 102 ||
                            response.status === 202 ||
                            response.status === 200) {
                            //Done
                            return [2 /*return*/];
                        }
                        else if (response.status === 304) {
                            //Failed to start processing
                            throw new Error("Failed to start processing");
                        }
                        else {
                            throw new Error("Failed to finalize");
                        }
                    case 9: return [2 /*return*/];
                }
            });
        });
    };
    UploadProcessor.prototype.doUpload = function (upload) {
        return __awaiter$1(this, void 0, void 0, function () {
            var authToken, xhr;
            var _this = this;
            return __generator$1(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (upload.ContentRange === null)
                            throw new Error("ContentRange is null");
                        return [4 /*yield*/, this.tokenFactory()];
                    case 1:
                        authToken = _a.sent();
                        xhr = new XMLHttpRequest();
                        xhr.open("PUT", upload.UploadUrl);
                        xhr.setRequestHeader("Authorization", "Bearer ".concat(authToken));
                        xhr.setRequestHeader("Content-Type", "application/octet-stream");
                        xhr.setRequestHeader("Content-Range", upload.ContentRange);
                        xhr.onreadystatechange = function () {
                            if (xhr.readyState === XMLHttpRequest.DONE) {
                                if (xhr.status === 200 || xhr.status === 201 || xhr.status === 202) {
                                    _this.uploadQueue.SetUploadState(upload.Id, UploadState_1.UploadState.Completed);
                                }
                                else {
                                    _this.uploadQueue.SetUploadState(upload.Id, UploadState_1.UploadState.Failed);
                                    console.error("Upload failed");
                                }
                                delete _this.requests[upload.Id];
                            }
                        };
                        xhr.upload.onprogress = function (e) {
                            if (e.lengthComputable) {
                                _this.uploadProgress[upload.Id] = (e.loaded / e.total) * 100;
                            }
                        };
                        xhr.send(upload.Content);
                        this.requests[upload.Id] = xhr;
                        return [2 /*return*/];
                }
            });
        });
    };
    UploadProcessor.prototype.processQueue = function () {
        return __awaiter$1(this, void 0, void 0, function () {
            var uploadTasks, tasksToStart, i, upload, e_1;
            return __generator$1(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.isProcessing)
                            return [2 /*return*/];
                        this.isProcessing = true;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 12, , 13]);
                        _a.label = 2;
                    case 2:
                        if (!this.isProcessing) return [3 /*break*/, 11];
                        return [4 /*yield*/, this.uploadQueue.GetProcessingTasks()];
                    case 3:
                        uploadTasks = _a.sent();
                        tasksToStart = uploadTasks.length < this.configuration.MaxConcurrentUploads
                            ? this.configuration.MaxConcurrentUploads - uploadTasks.length
                            : 0;
                        i = 0;
                        _a.label = 4;
                    case 4:
                        if (!(i < tasksToStart)) return [3 /*break*/, 9];
                        return [4 /*yield*/, this.uploadQueue.GetNextUpload()];
                    case 5:
                        upload = _a.sent();
                        if (upload == null) {
                            return [3 /*break*/, 9];
                        }
                        console.info("Starting upload", upload);
                        return [4 /*yield*/, this.uploadQueue.SetUploadState(upload.Id, UploadState_1.UploadState.Started)];
                    case 6:
                        _a.sent();
                        return [4 /*yield*/, this.doUpload(upload)];
                    case 7:
                        _a.sent();
                        _a.label = 8;
                    case 8:
                        i++;
                        return [3 /*break*/, 4];
                    case 9: return [4 /*yield*/, new Promise(function (resolve) { return setTimeout(resolve, 5000); })];
                    case 10:
                        _a.sent();
                        return [3 /*break*/, 2];
                    case 11: return [3 /*break*/, 13];
                    case 12:
                        e_1 = _a.sent();
                        console.error(e_1);
                        this.isProcessing = false;
                        return [3 /*break*/, 13];
                    case 13: return [2 /*return*/];
                }
            });
        });
    };
    UploadProcessor.prototype.Start = function () {
        this.processQueue();
    };
    UploadProcessor.prototype.Stop = function () {
        this.isProcessing = false;
    };
    UploadProcessor.prototype.IsProcessing = function () {
        return this.isProcessing;
    };
    return UploadProcessor;
}());
UploadProcessor$1.default = UploadProcessor;

var Constants$1 = {};

Object.defineProperty(Constants$1, "__esModule", { value: true });
var Constants = /** @class */ (function () {
    function Constants() {
    }
    // Error messages
    Constants.NO_AUTH_TOKEN = "No auth token or token factory provided";
    Constants.INVALID_MEDIA_TYPE = "Invalid media type";
    Constants.UPLOAD_PLAN_CEATE_FAILED = "Failed to create upload plan";
    Constants.NO_UPLOAD_INSTRUCTIONS = "No upload instructions returned";
    Constants.INVALID_CONTENT_RANGE = "Instruction has invalid content range";
    Constants.UPLOAD_FAILED = "Failed to upload content";
    Constants.DOWNLOAD_FAILED = "Failed to download media";
    // HTTP related
    Constants.POST = "POST";
    Constants.GET = "GET";
    Constants.CONTENT_TYPE = "Content-Type";
    Constants.CONTENT_LENGTH = "Content-Length";
    Constants.AUTHORIZATION = "Authorization";
    Constants.APPLICATION_JSON = "application/json";
    Constants.CONTENT_DISPOSITION = "Content-Disposition";
    Constants.ATTACHMENT = "attachment";
    Constants.LOCATION = "Location";
    Constants.INLINE = "inline";
    Constants.FILENAME = "filename=";
    // Other
    Constants.BYTES = "bytes";
    return Constants;
}());
Constants$1.default = Constants;

var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (commonjsGlobal && commonjsGlobal.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (commonjsGlobal && commonjsGlobal.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(UploadClient$1, "__esModule", { value: true });
var ContentType_1 = ContentType;
var MediaType_1 = MediaType;
var ProcessingType_1 = ProcessingType;
var UploadQueue_1 = UploadQueue$1;
var UploadProcessor_1 = __importDefault(UploadProcessor$1);
var Constants_1 = __importDefault(Constants$1);
var UploadClient = /** @class */ (function () {
    function UploadClient(options) {
        var _this = this;
        this.configuration = options.configuration;
        this.uploadQueue = new UploadQueue_1.UploadQueue(function (url) { return __awaiter(_this, void 0, void 0, function () {
            var token;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.tokenFactory()];
                    case 1:
                        token = _a.sent();
                        return [2 /*return*/, UploadProcessor_1.default.finalize(url, token)];
                }
            });
        }); });
        if (options.authToken) {
            this.tokenFactory = function () { return Promise.resolve(options.authToken); };
        }
        else if (options.tokenFactory) {
            this.tokenFactory = options.tokenFactory;
        }
        else {
            throw new Error(Constants_1.default.NO_AUTH_TOKEN);
        }
        this.uploadProcessor = new UploadProcessor_1.default(this.tokenFactory, options.configuration);
    }
    UploadClient.prototype.readFileAsDataURL = function (file) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        var reader = new FileReader();
                        reader.onload = function (event) {
                            var _a;
                            resolve((_a = event.target) === null || _a === void 0 ? void 0 : _a.result);
                        };
                        reader.onerror = function (error) {
                            reject(error);
                        };
                        reader.readAsDataURL(file);
                    })];
            });
        });
    };
    UploadClient.prototype.setAuthToken = function (authToken) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.tokenFactory = function () { return Promise.resolve(authToken); };
                this.uploadProcessor = new UploadProcessor_1.default(this.tokenFactory, this.configuration);
                return [2 /*return*/];
            });
        });
    };
    UploadClient.prototype.createInlineUploadIntent = function (mediaName, fileName, mediaType, mediaValue, mimeType) {
        var UploadIntent = {
            FileName: fileName,
            MediaName: mediaName,
            MediaType: mediaType,
            MediaValue: mediaValue,
            MimeType: mimeType,
            ContentType: ContentType_1.ContentType.Inline,
            ProcessingType: ProcessingType_1.ProcessingType.None,
            Content: null,
        };
        return UploadIntent;
    };
    UploadClient.prototype.createFileUploadIntent = function (file, mediaType) {
        //See if file size is under the limit. If So, this is a simple upload with only a single contant.
        if (file.size <= this.configuration.MaxFileLength) {
            var UploadIntent = {
                FileName: file.name,
                MediaName: file.name,
                MediaType: mediaType,
                MediaValue: null,
                MimeType: file.type,
                ContentType: ContentType_1.ContentType.Simple,
                ProcessingType: ProcessingType_1.ProcessingType.None,
                Content: [
                    {
                        SequenceNumber: 0,
                        ContentUnit: Constants_1.default.BYTES,
                        ContentSize: file.size,
                        ContentRangeBeg: 0,
                        ContentRangeEnd: file.size,
                    },
                ],
            };
            return UploadIntent;
        }
        else {
            //If the file size is over the limit, break the file into chunks and create and upload intent with content for each of the pieces
            var chunkSize = this.configuration.MaxFileLength;
            var chunks = Math.ceil(file.size / chunkSize);
            var content = [];
            for (var i = 0; i < chunks; i++) {
                var start = i * chunkSize;
                var end = Math.min(start + chunkSize, file.size);
                content.push({
                    ContentUnit: Constants_1.default.BYTES,
                    ContentSize: file.size,
                    ContentRangeBeg: start,
                    ContentRangeEnd: end,
                    SequenceNumber: i,
                });
            }
            var UploadIntent = {
                FileName: file.name,
                MediaName: file.name,
                MediaType: mediaType,
                MediaValue: null,
                MimeType: file.type,
                ContentType: ContentType_1.ContentType.Multipart,
                ProcessingType: ProcessingType_1.ProcessingType.Assemble,
                Content: content,
            };
            return UploadIntent;
        }
    };
    UploadClient.prototype.createStreamingUploadIntent = function (mediaName, fileName, mediaType, mimeType) {
        var UploadIntent = {
            FileName: fileName,
            MediaName: mediaName,
            MediaType: mediaType,
            MediaValue: null,
            MimeType: mimeType,
            ContentType: ContentType_1.ContentType.Stream,
            ProcessingType: ProcessingType_1.ProcessingType.Assemble,
            Content: null,
        };
        return UploadIntent;
    };
    UploadClient.prototype.createUploadIntentAsync = function (file, mediaType) {
        return __awaiter(this, void 0, void 0, function () {
            var uploadIntent, _a, base64;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = mediaType;
                        switch (_a) {
                            case MediaType_1.MediaType.Image: return [3 /*break*/, 1];
                            case MediaType_1.MediaType.File: return [3 /*break*/, 5];
                            case MediaType_1.MediaType.Video: return [3 /*break*/, 5];
                            case MediaType_1.MediaType.Audio: return [3 /*break*/, 5];
                        }
                        return [3 /*break*/, 6];
                    case 1:
                        if (!(file.size <= this.configuration.MaxInlineContentLength)) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.readFileAsDataURL(file)];
                    case 2:
                        base64 = _b.sent();
                        uploadIntent = this.createInlineUploadIntent(file.name, file.name, mediaType, base64, file.type);
                        return [3 /*break*/, 4];
                    case 3:
                        uploadIntent = this.createFileUploadIntent(file, mediaType);
                        _b.label = 4;
                    case 4: return [3 /*break*/, 7];
                    case 5:
                        {
                            uploadIntent = this.createFileUploadIntent(file, mediaType);
                        }
                        return [3 /*break*/, 7];
                    case 6:
                        {
                            throw new Error(Constants_1.default.INVALID_MEDIA_TYPE);
                        }
                    case 7: return [2 /*return*/, uploadIntent];
                }
            });
        });
    };
    UploadClient.prototype.createUploadPlan = function (uploadPath, authToken, uploadIntent) {
        return __awaiter(this, void 0, void 0, function () {
            var response, uploadPlan, location_1, mediaId;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, fetch("".concat(this.configuration.StorageServiceUrlBase, "/").concat(uploadPath), {
                            method: Constants_1.default.POST,
                            headers: {
                                "Content-Type": Constants_1.default.APPLICATION_JSON,
                                Authorization: "Bearer ".concat(authToken),
                            },
                            body: JSON.stringify(uploadIntent),
                        })];
                    case 1:
                        response = _a.sent();
                        if (!(response.status == 200)) return [3 /*break*/, 3];
                        return [4 /*yield*/, response.json()];
                    case 2:
                        uploadPlan = (_a.sent());
                        if (uploadPlan.UploadInstructions == null ||
                            uploadPlan.UploadInstructions.length == 0) {
                            throw new Error(Constants_1.default.NO_UPLOAD_INSTRUCTIONS);
                        }
                        return [3 /*break*/, 6];
                    case 3:
                        if (!(response.status == 201)) return [3 /*break*/, 5];
                        location_1 = response.headers.get(Constants_1.default.LOCATION);
                        return [4 /*yield*/, response.text()];
                    case 4:
                        mediaId = _a.sent();
                        return [2 /*return*/, {
                                mediaId: mediaId,
                                downloadUrl: location_1,
                                inlineContent: uploadIntent.MediaValue || undefined,
                            }];
                    case 5: throw new Error(Constants_1.default.UPLOAD_PLAN_CEATE_FAILED);
                    case 6: return [2 /*return*/, {
                            mediaId: uploadPlan.MediaId,
                            uploadPlan: uploadPlan,
                        }];
                }
            });
        });
    };
    UploadClient.prototype.processUploadPlan = function (file, uploadPlan) {
        return __awaiter(this, void 0, void 0, function () {
            var _i, _a, instruction, contentData, upload;
            var _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _i = 0, _a = uploadPlan.UploadInstructions;
                        _c.label = 1;
                    case 1:
                        if (!(_i < _a.length)) return [3 /*break*/, 4];
                        instruction = _a[_i];
                        if (instruction.ContentRangeBeg == null ||
                            instruction.ContentRangeEnd == null)
                            throw new Error(Constants_1.default.INVALID_CONTENT_RANGE);
                        contentData = file.slice(Number(instruction.ContentRangeBeg), Number(instruction.ContentRangeEnd));
                        _b = {
                            Id: crypto.randomUUID(),
                            Attempts: 0,
                            StreamId: null,
                            MediaId: instruction.MediaId,
                            UploadUrl: instruction.Url,
                            ContentRange: "bytes ".concat(instruction.ContentRangeBeg, "-").concat(instruction.ContentRangeEnd - 1, "/").concat(file.size)
                        };
                        return [4 /*yield*/, contentData.arrayBuffer()];
                    case 2:
                        upload = (_b.Content = _c.sent(),
                            _b);
                        this.uploadQueue.QueueUpload(upload);
                        _c.label = 3;
                    case 3:
                        _i++;
                        return [3 /*break*/, 1];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Starts processing the upload tasks.
     */
    UploadClient.prototype.BeginUploadTaskProcessing = function () {
        this.uploadProcessor.Start();
    };
    /**
     * Stops processing the upload tasks.
     */
    UploadClient.prototype.StopUploadTaskProcessing = function () {
        this.uploadProcessor.Stop();
    };
    /**
     * Checks if the upload tasks are being processed.
     * @returns True if the upload tasks are being processed, false otherwise.
     */
    UploadClient.prototype.IsProcessing = function () {
        return this.uploadProcessor.IsProcessing();
    };
    /**
     * Uploads a meeting recording asynchronously.
     * @param meetingId - The ID of the meeting.
     * @param file - The file to upload.
     * @param mediaType - The type of the media.
     * @returns
     */
    UploadClient.prototype.UploadMeetingRecordingAsync = function (meetingId, file, mediaType) {
        return __awaiter(this, void 0, void 0, function () {
            var uploadIntent, uploadPath, token, uploadResult;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.createUploadIntentAsync(file, mediaType)];
                    case 1:
                        uploadIntent = _a.sent();
                        uploadPath = "meeting/".concat(meetingId, "/recording/");
                        return [4 /*yield*/, this.tokenFactory()];
                    case 2:
                        token = _a.sent();
                        return [4 /*yield*/, this.createUploadPlan(uploadPath, token, uploadIntent)];
                    case 3:
                        uploadResult = _a.sent();
                        if (uploadResult.uploadPlan) {
                            //Upload content
                            void this.processUploadPlan(file, uploadResult.uploadPlan);
                            this.BeginUploadTaskProcessing();
                        }
                        return [2 /*return*/, uploadResult];
                }
            });
        });
    };
    /**
     * Streams a meeting recording asynchronously.
     * @param meetingId - The ID of the meeting.
     * @param mediaType - The type of the media.
     * @param mediaName - The name of the media.
     * @param fileName - The name of the file.
     * @param mimeType - The MIME type of the media.
     * @returns A promise that resolves with the streaming functions or null if the streaming failed.
     */
    UploadClient.prototype.StreamMeetingRecordingAsync = function (meetingId, mediaType, mediaName, fileName, mimeType) {
        return __awaiter(this, void 0, void 0, function () {
            var path, streamingIntent, uploadPlan, token, response, e_1, streamId, queueFunc, finalizeFunc;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        path = "meeting/".concat(meetingId, "/recording/");
                        streamingIntent = this.createStreamingUploadIntent(mediaName, fileName, mediaType, mimeType);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 5, , 6]);
                        return [4 /*yield*/, this.tokenFactory()];
                    case 2:
                        token = _a.sent();
                        return [4 /*yield*/, fetch("".concat(this.configuration.StorageServiceUrlBase, "/").concat(path), {
                                method: "POST",
                                headers: {
                                    Authorization: "Bearer ".concat(token),
                                },
                                body: JSON.stringify(streamingIntent),
                            })];
                    case 3:
                        response = _a.sent();
                        if (response.status != 200) {
                            throw new Error(Constants_1.default.UPLOAD_FAILED);
                        }
                        return [4 /*yield*/, response.json()];
                    case 4:
                        uploadPlan = (_a.sent());
                        return [3 /*break*/, 6];
                    case 5:
                        e_1 = _a.sent();
                        console.error(e_1);
                        return [2 /*return*/, null];
                    case 6:
                        if (uploadPlan == null ||
                            uploadPlan.UploadInstructions.length == 0 ||
                            uploadPlan.FinalizeUrl == null) {
                            console.error(Constants_1.default.UPLOAD_PLAN_CEATE_FAILED);
                            return [2 /*return*/, null];
                        }
                        return [4 /*yield*/, this.uploadQueue.CreateStreamTask(uploadPlan.UploadInstructions[0].Url, uploadPlan.FinalizeUrl)];
                    case 7:
                        streamId = _a.sent();
                        queueFunc = function (data) { return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                this.uploadQueue.QueueStreamBytes(streamId, data);
                                return [2 /*return*/];
                            });
                        }); };
                        finalizeFunc = function () { return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                this.uploadQueue.FinalizeStream(streamId);
                                return [2 /*return*/];
                            });
                        }); };
                        return [2 /*return*/, { queueFunc: queueFunc, finalizeFunc: finalizeFunc }];
                }
            });
        });
    };
    /**
     * Uploads an attendee attachment asynchronously.
     * @param attendeeId - The ID of the attendee.
     * @param file - The file to upload.
     * @param mediaType - The type of the media.
     * @returns A promise that resolves with the upload result.
     */
    UploadClient.prototype.UploadAttendeeAttachmentAsync = function (attendeeId, file, mediaType) {
        return __awaiter(this, void 0, void 0, function () {
            var uploadIntent, uploadPath, token, uploadResult;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.createUploadIntentAsync(file, mediaType)];
                    case 1:
                        uploadIntent = _a.sent();
                        uploadPath = "attendee/".concat(attendeeId, "/attachment/");
                        return [4 /*yield*/, this.tokenFactory()];
                    case 2:
                        token = _a.sent();
                        return [4 /*yield*/, this.createUploadPlan(uploadPath, token, uploadIntent)];
                    case 3:
                        uploadResult = _a.sent();
                        if (uploadResult.uploadPlan) {
                            //Upload content
                            void this.processUploadPlan(file, uploadResult.uploadPlan);
                            this.BeginUploadTaskProcessing();
                        }
                        return [2 /*return*/, uploadResult];
                }
            });
        });
    };
    /**
     * Lists the media files associated with an attendee asynchronously.
     * @param attendeeId - The ID of the attendee.
     * @returns A promise that resolves with the list of media files.
     */
    UploadClient.prototype.ListAttendeeMediaAsync = function (attendeeId) {
        return __awaiter(this, void 0, void 0, function () {
            var path, token, response, attendeeMediaList;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        path = "attendee/".concat(attendeeId);
                        return [4 /*yield*/, this.tokenFactory()];
                    case 1:
                        token = _a.sent();
                        return [4 /*yield*/, fetch("".concat(this.configuration.StorageServiceUrlBase, "/").concat(path), {
                                method: Constants_1.default.GET,
                                headers: {
                                    Authorization: "Bearer ".concat(token),
                                },
                            })];
                    case 2:
                        response = _a.sent();
                        if (response.status != 200) {
                            throw new Error(Constants_1.default.UPLOAD_FAILED);
                        }
                        return [4 /*yield*/, response.json()];
                    case 3:
                        attendeeMediaList = (_a.sent());
                        return [2 /*return*/, attendeeMediaList];
                }
            });
        });
    };
    /**
     * Lists the media files associated with a meeting asynchronously.
     * @param meetingId - The ID of the meeting.
     * @returns A promise that resolves with the list of media files.
     */
    UploadClient.prototype.ListMeetingMediaAsync = function (meetingId) {
        return __awaiter(this, void 0, void 0, function () {
            var path, token, response, meetingMediaList;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        path = "meeting/".concat(meetingId);
                        return [4 /*yield*/, this.tokenFactory()];
                    case 1:
                        token = _a.sent();
                        return [4 /*yield*/, fetch("".concat(this.configuration.StorageServiceUrlBase, "/").concat(path), {
                                method: Constants_1.default.GET,
                                headers: {
                                    Authorization: "Bearer ".concat(token),
                                },
                            })];
                    case 2:
                        response = _a.sent();
                        if (response.status != 200) {
                            throw new Error(Constants_1.default.UPLOAD_FAILED);
                        }
                        return [4 /*yield*/, response.json()];
                    case 3:
                        meetingMediaList = (_a.sent());
                        return [2 /*return*/, meetingMediaList];
                }
            });
        });
    };
    UploadClient.prototype.BuildMediaDownloadUrl = function (mediaId, mediaCategory) {
        return "".concat(this.configuration.StorageServiceUrlBase, "/v1/d/").concat(mediaCategory, "/").concat(mediaId);
    };
    /**
     * Downloads a media file asynchronously.
     * @param downloadUrl - The URL to download the media file from.
     * @returns - A promise that resolves with the file name and object URL.
     */
    UploadClient.prototype.DownloadMedia = function (downloadUrl) {
        return __awaiter(this, void 0, void 0, function () {
            var token, response, iteration, timeout_base, _a, media, mediaUrl, disposition;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.tokenFactory()];
                    case 1:
                        token = _b.sent();
                        return [4 /*yield*/, fetch(downloadUrl, {
                                method: "GET",
                                headers: {
                                    Authorization: "Bearer ".concat(token),
                                },
                            })];
                    case 2:
                        response = _b.sent();
                        iteration = 0;
                        timeout_base = 5000;
                        _a = response.status;
                        switch (_a) {
                            case 202: return [3 /*break*/, 3];
                            case 304: return [3 /*break*/, 3];
                            case 424: return [3 /*break*/, 5];
                            case 500: return [3 /*break*/, 5];
                        }
                        return [3 /*break*/, 6];
                    case 3: 
                    //wait and retry
                    return [4 /*yield*/, new Promise(function (resolve) {
                            iteration++;
                            //Primitive backoff
                            var timeout = timeout_base * iteration > 60000 ? 60000 : timeout_base * iteration;
                            setTimeout(resolve, timeout);
                        })];
                    case 4:
                        //wait and retry
                        _b.sent();
                        return [2 /*return*/, this.DownloadMedia(downloadUrl)];
                    case 5: throw new Error(Constants_1.default.DOWNLOAD_FAILED);
                    case 6: return [4 /*yield*/, response.blob()];
                    case 7:
                        media = _b.sent();
                        mediaUrl = URL.createObjectURL(media);
                        disposition = response.headers.get(Constants_1.default.CONTENT_DISPOSITION);
                        if (disposition && disposition.includes(Constants_1.default.ATTACHMENT)) {
                            return [2 /*return*/, {
                                    fileName: disposition.split(Constants_1.default.FILENAME)[1].replace(/"/g, "") || "",
                                    objectUrl: mediaUrl,
                                }];
                        }
                        else {
                            return [2 /*return*/, { fileName: "", objectUrl: mediaUrl }];
                        }
                }
            });
        });
    };
    /**
     * Downloads a media file asynchronously.
     * @param mediaId - The ID of the media file.
     * @param mediaCategory - The category of the media file.
     * @returns - A promise that resolves with the file information.
     */
    UploadClient.prototype.GetMediaFile = function (mediaId, mediaCategory) {
        return __awaiter(this, void 0, void 0, function () {
            var token, downloadUrl, response, iteration, timeout_base, _a, disposition, contentType, contentLength, fileName, _b, fileName, dataUrl, blob, _c;
            var _d, _e;
            return __generator(this, function (_f) {
                switch (_f.label) {
                    case 0: return [4 /*yield*/, this.tokenFactory()];
                    case 1:
                        token = _f.sent();
                        downloadUrl = this.BuildMediaDownloadUrl(mediaId, mediaCategory);
                        return [4 /*yield*/, fetch(downloadUrl, {
                                method: "GET",
                                headers: {
                                    Authorization: "Bearer ".concat(token),
                                },
                            })];
                    case 2:
                        response = _f.sent();
                        iteration = 0;
                        timeout_base = 5000;
                        _a = response.status;
                        switch (_a) {
                            case 202: return [3 /*break*/, 3];
                            case 304: return [3 /*break*/, 3];
                            case 424: return [3 /*break*/, 5];
                            case 500: return [3 /*break*/, 5];
                        }
                        return [3 /*break*/, 6];
                    case 3: 
                    //wait and retry
                    return [4 /*yield*/, new Promise(function (resolve) {
                            iteration++;
                            //Primitive backoff
                            var timeout = timeout_base * iteration > 60000 ? 60000 : timeout_base * iteration;
                            setTimeout(resolve, timeout);
                        })];
                    case 4:
                        //wait and retry
                        _f.sent();
                        return [2 /*return*/, this.GetMediaFile(mediaId, mediaCategory)];
                    case 5: throw new Error(Constants_1.default.DOWNLOAD_FAILED);
                    case 6:
                        disposition = response.headers.get(Constants_1.default.CONTENT_DISPOSITION);
                        contentType = response.headers.get(Constants_1.default.CONTENT_TYPE) || "";
                        contentLength = response.headers.get(Constants_1.default.CONTENT_LENGTH) ? parseInt(response.headers.get(Constants_1.default.CONTENT_LENGTH)) : 0;
                        if (!disposition) return [3 /*break*/, 12];
                        if (!disposition.includes(Constants_1.default.ATTACHMENT)) return [3 /*break*/, 8];
                        fileName = disposition.split(Constants_1.default.FILENAME)[1].replace(/"/g, "") || "";
                        _d = {
                            FileName: fileName,
                            FileSize: contentLength,
                            ContentType: contentType
                        };
                        _b = File.bind;
                        return [4 /*yield*/, response.blob()];
                    case 7: return [2 /*return*/, (_d.Content = new (_b.apply(File, [void 0, [_f.sent()], fileName]))(),
                            _d)];
                    case 8:
                        if (!disposition.includes(Constants_1.default.INLINE)) return [3 /*break*/, 12];
                        fileName = mediaId;
                        return [4 /*yield*/, response.text()];
                    case 9:
                        dataUrl = _f.sent();
                        return [4 /*yield*/, fetch(dataUrl)];
                    case 10: return [4 /*yield*/, (_f.sent()).blob()];
                    case 11:
                        blob = _f.sent();
                        return [2 /*return*/, {
                                FileName: fileName,
                                FileSize: contentLength,
                                ContentType: contentType,
                                InlineContent: dataUrl,
                                Content: new File([blob], fileName)
                            }];
                    case 12:
                        _e = {
                            FileName: mediaId,
                            FileSize: contentLength,
                            ContentType: contentType
                        };
                        _c = File.bind;
                        return [4 /*yield*/, response.blob()];
                    case 13: return [2 /*return*/, (_e.Content = new (_c.apply(File, [void 0, [_f.sent()], "file"]))(),
                            _e)];
                }
            });
        });
    };
    return UploadClient;
}());
UploadClient$1.default = UploadClient;

(function (exports) {
	var __importDefault = (commonjsGlobal && commonjsGlobal.__importDefault) || function (mod) {
	    return (mod && mod.__esModule) ? mod : { "default": mod };
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.UploadClient = exports.ProcessingType = exports.MediaType = exports.ContentType = void 0;
	var ContentType_1 = ContentType;
	Object.defineProperty(exports, "ContentType", { enumerable: true, get: function () { return ContentType_1.ContentType; } });
	var MediaType_1 = MediaType;
	Object.defineProperty(exports, "MediaType", { enumerable: true, get: function () { return MediaType_1.MediaType; } });
	var ProcessingType_1 = ProcessingType;
	Object.defineProperty(exports, "ProcessingType", { enumerable: true, get: function () { return ProcessingType_1.ProcessingType; } });
	var UploadClient_1 = UploadClient$1;
	Object.defineProperty(exports, "UploadClient", { enumerable: true, get: function () { return __importDefault(UploadClient_1).default; } }); 
} (dist));

const mediaTypes = ["display", "user"];
class Meeting {
    /** @internal */
    get metricLogger() { return this._metricLogger; }
    /** @event */
    get attendeeJoined() { return this._attendeeJoined; }
    /** @event */
    get attendeeLeft() { return this._attendeeLeft; }
    /** @event */
    get audioUnmuteDisabled() { return this._audioUnmuteDisabled; }
    /** @event */
    get audioUnmuteEnabled() { return this._audioUnmuteEnabled; }
    /** @event */
    get blocked() { return this._blocked; }
    /** @event */
    get joined() { return this._stateEvents.get("joined"); }
    /** @event */
    get joining() { return this._stateEvents.get("joining"); }
    /** @event */
    get kicked() { return this._kicked; }
    /** @event */
    get leaving() { return this._stateEvents.get("leaving"); }
    /** @event */
    get left() { return this._stateEvents.get("left"); }
    /** @event */
    get reconnecting() { return this._stateEvents.get("reconnecting"); }
    /** @event */
    get recordingFailed() { return this._recordingFailed; }
    /** @event */
    get recordingStarted() { return this._recordingStarted; }
    /** @event */
    get recordingStopped() { return this._recordingStopped; }
    /** @event */
    get stateChanged() { return this._stateChanged; }
    /** @event */
    get videoUnmuteDisabled() { return this._videoUnmuteDisabled; }
    /** @event */
    get videoUnmuteEnabled() { return this._videoUnmuteEnabled; }
    get attendees() { return this._attendees; }
    get audibleDisplayMedias() { return this._audibleDisplayMedias; }
    get audibleMedias() { return this._audibleMedias; }
    get audibleUserMedias() { return this._audibleUserMedias; }
    get audioInputDeviceId() { return this.localUserMedia?.audioDeviceId ?? null; }
    get audioOutputDeviceId() { return this._edgeManager?.audioDeviceId ?? null; }
    get canReceiveMedia() { return this._localAttendee?.canReceiveMedia ?? false; }
    get canSendDisplayMedia() {
        if (this.filterModeDisplay == "REJECT" && this._model && this._visibleDisplayMedias.length >= this._model.maxVideoDisplay)
            return false;
        return this._localAttendee?.canSendDisplayMedia ?? false;
    }
    get canSendUserMedia() { return this._localAttendee?.canSendUserMedia ?? false; }
    get chat() { return this._chat; }
    get edgeManager() { return this._edgeManager; }
    get filterModeDisplay() { return this._model?.filterModeDisplay ?? null; }
    get filterModeUser() { return this._model?.filterModeUser ?? null; }
    get hasFailed() { return this._hasFailed; }
    get hasLobby() { return !(this._model?.lobbyType == "NONE"); }
    get hasSip() { return this._model?.hasSip ?? false; }
    get id() { return this._model?.id ?? null; }
    get isAudioMutedOnJoin() { return this._model?.muteAudioOnJoin ?? false; }
    get isAudioUnmuteDisabledOnJoin() { return !(this._model?.allowUnmuteAudioOnJoin == true); }
    get isChatEnabled() { return this._model?.allowChat ?? false; }
    get isJoined() { return this.state == "joined"; }
    get isJoining() { return this.state == "joining"; }
    get isLeaving() { return this.state == "leaving"; }
    get isLeft() { return this.state == "left"; }
    get isNoiseSuppressedOnJoin() { return this._model?.suppressNoiseOnJoin ?? false; }
    get isReady() { return this._isReady; }
    get isReconnecting() { return this.state == "reconnecting"; }
    get isRecording() { return this._model?.isRecording ?? false; }
    get isRecordingEnabled() { return this._model?.allowRecording ?? false; }
    get isSipEnabled() { return this._model?.allowSip ?? false; }
    get isVideoMutedOnJoin() { return this._model?.muteVideoOnJoin ?? false; }
    get isVideoUnmuteDisabledOnJoin() { return !(this._model?.allowUnmuteVideoOnJoin == true); }
    get joinOptions() { return this._joinOptions; }
    get localAttendee() { return this._localAttendee ?? null; }
    get localDisplayMedia() { return this._localMedias.get("display") ?? null; }
    get localUserMedia() { return this._localMedias.get("user") ?? null; }
    get maxRetries() { return this._maxRetries; }
    set maxRetries(value) { this._maxRetries = value; }
    get maxVisibleDisplayMedias() { return this._maxVisibleDisplayMedias ?? null; }
    set maxVisibleDisplayMedias(value) { this._maxVisibleDisplayMedias = value; }
    get maxVisibleUserMedias() { return this._maxVisibleUserMedias ?? null; }
    set maxVisibleUserMedias(value) { this._maxVisibleUserMedias = value; }
    get maxVisibleUserMediasDuringDisplayMedia() { return this._maxVisibleUserMediasDuringDisplayMedia; }
    set maxVisibleUserMediasDuringDisplayMedia(value) { this._maxVisibleUserMediasDuringDisplayMedia = value; }
    get originDisplayManager() { return this._originManagers.get("display"); }
    get originUserManager() { return this._originManagers.get("user"); }
    get remoteMediaDisabled() { return this._remoteMediaDisabled; }
    get requestTimeout() { return this._requestTimeout; }
    set requestTimeout(value) { this._requestTimeout = value; }
    get requestedAudioInputDeviceId() { return this.localUserMedia?.requestedAudioDeviceId ?? null; }
    get requestedAudioInputDeviceRequired() { return this.localUserMedia?.requestedAudioDeviceRequired ?? false; }
    get requestedAudioOutputDeviceId() { return this._edgeManager?.requestedAudioDeviceId ?? null; }
    get requestedVideoInputDeviceId() { return this.localUserMedia?.requestedVideoDeviceId ?? null; }
    get requestedVideoInputDeviceRequired() { return this.localUserMedia?.requestedVideoDeviceRequired ?? false; }
    get roomId() { return this._model?.roomId ?? null; }
    get roomKey() { return this._model?.roomKey ?? null; }
    get state() { return this._stateMachine.state; }
    get statsInterval() { return this._statsInterval; }
    get timings() { return this._timings; }
    get type() { return this._model?.type ?? null; }
    get videoInputDeviceId() { return this.localUserMedia?.videoDeviceId ?? null; }
    get videoInputFacingMode() { return this.localUserMedia?.videoFacingMode ?? null; }
    get visibleDisplayMedias() { return this._visibleDisplayMedias; }
    get visibleMedias() { return this._visibleMedias; }
    get visibleUserMedias() { return this._visibleUserMedias; }
    constructor(init) {
        this._attendeeJoined = new EventOwnerAsync();
        this._attendeeLeft = new EventOwnerAsync();
        this._audibleDisplayMedias = new MediaCollection();
        this._audibleMedias = new MediaCollection();
        this._audibleUserMedias = new MediaCollection();
        this._audioUnmuteDisabled = new EventOwnerAsync();
        this._audioUnmuteEnabled = new EventOwnerAsync();
        this._blocked = new EventOwnerAsync();
        this._eventQueue = new DispatchQueue();
        this._kicked = new EventOwnerAsync();
        this._localMedias = new Map();
        this._originManagers = new Map();
        this._recordingFailed = new EventOwnerAsync();
        this._recordingStarted = new EventOwnerAsync();
        this._recordingStopped = new EventOwnerAsync();
        this._stateChanged = new EventOwnerAsync();
        this._stateEvents = new Map();
        this._stateMachine = new MeetingStateMachine();
        this._videoUnmuteDisabled = new EventOwnerAsync();
        this._videoUnmuteEnabled = new EventOwnerAsync();
        this._visibleDisplayMedias = new MediaCollection();
        this._visibleMedias = new MediaCollection();
        this._visibleUserMedias = new MediaCollection();
        this._timings = {};
        this._chat = new Chat();
        this._controlConnection = null;
        this._edgeManager = new Manager$1();
        this._eventLogger = null;
        this._hasFailed = false;
        // TODO: remove this when issues with eden vue app can be sorted: showing components, mainly attendees, before isReady (everything connected) causes huge delays
        this._isReady = null;
        this._joinOptions = null;
        this._localAttendee = null;
        this._maxRetries = 2;
        this._maxVisibleDisplayMedias = null;
        this._maxVisibleUserMedias = null;
        this._maxVisibleUserMediasDuringDisplayMedia = null;
        this._model = null;
        this._remoteMediaDisabled = false;
        this._requestTimeout = 30000;
        this._session = null;
        this._statsInterval = 1000; //this always need to be a second, state machine logic requires it
        this._statsTimeoutId = 0;
        this._tokenResponse = null;
        this._turnSession = null;
        this._uploadClient = null;
        this.initEdgeManager = (edgeServerUrl) => {
            this._edgeManager.init({
                apiClient: this._apiClient,
                attendeeId: this._tokenResponse.attendeeId,
                audibleDisplayMedias: this._audibleDisplayMedias,
                audibleUserMedias: this._audibleUserMedias,
                audioLevelIntervalDisplay: this._joinOptions.audioLevelInterval,
                audioLevelIntervalUser: this._joinOptions.audioLevelInterval,
                clusterId: this._session.clusterId,
                compatibilityMode: this._joinOptions.remoteCompatibilityMode,
                discardAudio: this._joinOptions.remoteDiscardAudio,
                discardVideo: this._joinOptions.remoteDiscardVideo,
                edgeServerUrl: edgeServerUrl,
                iceRestartEnabled: this._joinOptions.iceOptions.restartEnabled,
                iceReconnectionTimeout: this._joinOptions.iceOptions.reconnectionTimeout,
                localLoopbackAudio: this._joinOptions.localLoopbackAudio,
                localLoopbackVideo: this._joinOptions.localLoopbackVideo,
                maxAudibleDisplay: this._model.maxAudioDisplay,
                maxAudibleUser: this._model.maxAudioUser,
                maxVisibleDisplay: Math.min(this._model.maxVideoDisplay, this._maxVisibleDisplayMedias),
                maxVisibleUser: Math.min(this._model.maxVideoUser, this._maxVisibleUserMedias),
                meetingId: this._tokenResponse.meetingId,
                meetingSession: this._session,
                pixelFeedback: this._joinOptions.remotePixelFeedback,
                redAudioEnabled: this._joinOptions.redAudioEnabled,
                subscribedView: this._subscribedView,
                turnRequired: this._joinOptions.turnOptions.required,
                turnSession: this._turnSession,
                visibleDisplayMedias: this._visibleDisplayMedias,
                visibleUserMedias: this._visibleUserMedias,
            });
            this._edgeManager.connectionStateChanged.bind(this.onEdgeConnectionStateChanged.bind(Reactive.wrap(this)));
            this._edgeManager.maxRetries = this._maxRetries;
            this._edgeManager.requestTimeout = this._requestTimeout;
            // return edgeManager;
        };
        Guard.isNotNullOrUndefined(init, "init");
        Guard.isNotNullOrUndefined(init.identity, "init.identity");
        this._identity = init.identity;
        this._apiClient = new Client$6({
            identity: this._identity
        });
        this._metricLogger = new MetricLogger({
            identity: this._identity
        });
        this._uploadClient = new dist.UploadClient({
            configuration: init.uploadClientConfiguration,
            tokenFactory: async () => {
                const token = await this._identity.token();
                return token.token;
            }
        });
        this.attachConnectionHandlers();
        this._attendees = new AttendeeCollection();
        this._subscribedView = new SubscribedAttendeeCollection();
        this._stateEvents.set("joined", new EventOwnerAsync());
        this._stateEvents.set("joining", new EventOwnerAsync());
        this._stateEvents.set("leaving", new EventOwnerAsync());
        this._stateEvents.set("left", new EventOwnerAsync());
        this._stateEvents.set("reconnecting", new EventOwnerAsync());
        this._originManagers.set("display", new Manager());
        this._originManagers.set("user", new Manager());
        this._audibleDisplayMedias.added.bind(this.onAudibleDisplayMediaAdded.bind(Reactive.wrap(this)));
        this._audibleDisplayMedias.removed.bind(this.onAudibleDisplayMediaRemoved.bind(Reactive.wrap(this)));
        this._audibleUserMedias.added.bind(this.onAudibleUserMediaAdded.bind(Reactive.wrap(this)));
        this._audibleUserMedias.removed.bind(this.onAudibleUserMediaRemoved.bind(Reactive.wrap(this)));
        this._visibleDisplayMedias.added.bind(this.onVisibleDisplayMediaAdded.bind(Reactive.wrap(this)));
        this._visibleDisplayMedias.removed.bind(this.onVisibleDisplayMediaRemoved.bind(Reactive.wrap(this)));
        this._visibleUserMedias.added.bind(this.onVisibleUserMediaAdded.bind(Reactive.wrap(this)));
        this._visibleUserMedias.removed.bind(this.onVisibleUserMediaRemoved.bind(Reactive.wrap(this)));
    }
    attachConnectionHandlers() {
        if ("connection" in navigator) {
            navigator.connection.addEventListener('change', this.handleNetworkChange.bind(this));
        }
        window.addEventListener("offline", this.handleBrowserOffline.bind(this));
        window.addEventListener("online", this.handleBrowserOnline.bind(this));
        // TODO: MK - Leaving this example here for reference. We can add a Socket as another mechanism to detect poor network conditions
        // Need to standup a socket app or endpoint in Eden to be able to ping/pong between client server and measure latency of responses
        /*
        let socket = new WebSocket("wss://echo.websocket.org");
    
        socket.onclose = async (evt) => {
          if (!evt.wasClean) {
            await this.iceRestart();
          }
        }
    
        let pingTimeout: any = 0;
        let pingInterval;
        let pingStartTime: number = Date.now();
        const PING_TIMEOUT = 500;
    
        // Start pinging at intervals
        socket.onopen = () => {
          console.log("WebSocket connected");
          pingInterval = setInterval(() => {
            this._eventQueue.dispatch(async () => {
              if (socket.readyState === WebSocket.OPEN) {
                pingStartTime = Date.now();
                socket.send(JSON.stringify({ type: 'ping' }));
                pingTimeout = setTimeout(() => {
                  console.log("Network offline: No pong response within 500ms.");
                  socket.close(); // Optionally close the WebSocket
                }, PING_TIMEOUT);
              }
            })
          }, 2000);
        };
    
        socket.onmessage = async (ev: MessageEvent) => {
          clearTimeout(pingTimeout); // Clear timeout if response received
          const pingDuration = Date.now() - pingStartTime;
          if (pingDuration > PING_TIMEOUT) {
            await this.iceRestart();
          } else {
            console.log("Ping successful:", pingDuration, "ms");
          }
        }
        */
    }
    detachConnectionHandlers() {
        if ("connection" in navigator) {
            navigator.connection.removeEventListener('change', this.handleNetworkChange);
        }
        window.removeEventListener("offline", this.handleBrowserOffline);
        window.removeEventListener("online", this.handleBrowserOnline);
    }
    async handleNetworkChange(evt) {
        if ("connection" in navigator) {
            console.log(evt);
            const connection = navigator.connection;
            void this._eventLogger?.information("handleNetworkChange", `Browser network change: Type=${connection.type ?? connection.effectiveType}, RTT=${connection.rtt}, Downlink=${connection.downlink}`);
        }
    }
    async handleBrowserOnline(evt) {
        void this._eventLogger?.information("handleBrowserOnline", `Browser online`);
        await this.iceRestart();
    }
    async handleBrowserOffline(evt) {
        void this._eventLogger?.information("handleBrowserOffline", `Browser offline`);
    }
    stopChatInternal() {
        void this._chat?.stop();
    }
    async startChatInternal() {
        if (!this._model.allowChat)
            return;
        await this._chat.start();
    }
    async setState(state) {
        const previousState = this._stateMachine.state;
        this._stateMachine.setState(state);
        const e = {
            meeting: this,
            previousState: previousState,
            state: state,
        };
        await this._stateEvents.get(state).dispatch(e);
        await this._stateChanged.dispatch(e);
    }
    trySetState(state) {
        const previousState = this._stateMachine.state;
        if (!this._stateMachine.trySetState(state))
            return false;
        const e = {
            meeting: this,
            previousState: previousState,
            state: state,
        };
        void this._stateEvents.get(state).dispatch(e);
        void this._stateChanged.dispatch(e);
        return true;
    }
    async unjoin(abortSignal) {
        this._attendees.removeAll();
        this._subscribedView.removeAll();
        this.detachConnectionHandlers();
        this.tryStopStats();
        await this._chat?.stop();
        // unbind local media from edge, if applicable
        for (const mediaType of mediaTypes) {
            this._edgeManager?.setLocalMedia(mediaType, null);
        }
        // unbind local media from origin, if applicable
        const setMediaPromises = [];
        for (const mediaType of mediaTypes) {
            const originManager = this._originManagers.get(mediaType);
            if (!originManager)
                continue;
            void this._eventLogger?.debug("join", `Unbinding local ${mediaType} media from origin...`);
            setMediaPromises.push(originManager.setMedia(null, null, true, abortSignal));
        }
        await Promise.allSettled(setMediaPromises);
        // disconnect edge and, if applicable, origin
        void this._eventLogger?.debug("join", `Disconnecting...`);
        const stopPromises = [];
        if (this._edgeManager)
            stopPromises.push(this._edgeManager.stop("Attendee has left."));
        for (const mediaType of mediaTypes) {
            const localMedia = this._localMedias.get(mediaType);
            if (localMedia)
                localMedia.unbindAttendee();
            const originManager = this._originManagers.get(mediaType);
            if (!originManager)
                continue;
            stopPromises.push(originManager.stop("Attendee has left."));
        }
        await Promise.allSettled(stopPromises);
        // unlink data model
        this._localAttendee = null;
        this._model = null;
        // close control
        this._controlConnection?.close("Attendee has left.");
        // destroy CEOT
        this._originManagers.delete("display");
        this._originManagers.delete("user");
        this._edgeManager = null;
        this._controlConnection = null;
        // leave session
        this._session?.leave();
        this._session = null;
    }
    join(options, abortSignal) {
        this._joinOptions = initializeJoinOptions(options);
        return this._eventQueue.dispatch(async () => {
            if (this.state == "joined" || this.state == "reconnecting")
                return;
            const joinStart = performance.now();
            void this.setState("joining");
            this._hasFailed = false;
            try {
                if (Utility.isNullOrUndefined(globalThis.RTCPeerConnection))
                    throw new RTCMissingError("WebRTC is disabled or not implemented.");
                // initialize session
                this._session = new Session$1({
                    identity: this._identity,
                });
                this._joinOptions.onProgress({ meeting: this, progress: 0.1 });
                await this.getMeetingTokenAndInitializeLoggers(abortSignal);
                void this.logClientMetric({ eventName: "joinAttempt" });
                this._joinOptions.onProgress({ meeting: this, progress: 0.4 });
                if (this._joinOptions.turnOptions.enabled) {
                    await this.configureTurn();
                }
                this._joinOptions.onProgress({ meeting: this, progress: 0.7 });
                await this.connectControl();
                this._localAttendee = new Attendee({
                    controlConnection: this._controlConnection,
                    isLocal: true,
                    meeting: Reactive.wrap(this),
                    model: this._controlConnection.attendee,
                });
                // everything relies on this (attendee list, chat, remote media, etc)
                this._subscribedView.load({
                    controlConnection: this._controlConnection,
                    meeting: Reactive.wrap(this),
                });
                // if permissions change, take appropriate action
                this._localAttendee.permissionsUpdated.bind(async (e) => {
                    await this.processLocalPermissionUpdate();
                });
                //TODO: factor in device capabilities?
                if (Utility.isNullOrUndefined(this._maxVisibleDisplayMedias))
                    this._maxVisibleDisplayMedias = this._model.maxVideoDisplay;
                if (Utility.isNullOrUndefined(this._maxVisibleUserMedias))
                    this._maxVisibleUserMedias = this._model.maxVideoUser;
                if (Utility.isNullOrUndefined(this._maxVisibleUserMediasDuringDisplayMedia))
                    this._maxVisibleUserMediasDuringDisplayMedia = this._model.maxVideoUser;
                this._joinOptions.onProgress({ meeting: this, progress: 1.0 });
                void this.setState("joined");
                const duration = Math.round(performance.now() - joinStart);
                void this._eventLogger.information("join.succeeded", `Joined meeting ${this.id} in room ${this.roomId} as attendee ${this.localAttendee.id}.`, duration);
                void this.logClientMetric({ eventDuration: duration, eventName: "joinSuccess" });
                this._timings.meetingJoinCompleted = duration;
                // we don't await this as we want the join to complete here and return to the caller
                void this.loadOptionalServices();
            }
            catch (error) {
                void this._eventLogger?.error(error, "join.failed", "Could not join meeting.");
                void this.logClientMetric({ eventDuration: performance.now() - joinStart, eventName: "joinError", eventDebug: { "error": error.message } });
                void this.setState("leaving");
                void this._eventLogger?.debug(error, "join", "Leaving meeting (failed to join)...");
                await this.unjoin();
                void this.setState("left");
                void this._eventLogger?.debug(error, "join", "Left meeting (failed to join).");
                throw error;
            }
        });
    }
    async loadOptionalServices(abortSignal) {
        const start = performance.now();
        if (this._model.allowChat) {
            this._chat.init({
                apiClient: this._apiClient,
                controlConnection: this._controlConnection,
                localAttendee: this._localAttendee,
                subscribedView: this._subscribedView,
                uploadClient: this._uploadClient,
            });
        }
        void this._attendees.init({
            controlConnection: this._controlConnection,
            localAttendee: this._localAttendee,
            subscribedView: this._subscribedView,
            attendeePageSize: this._joinOptions.attendeePageSize,
            attendeeSortType: this._joinOptions.attendeeSortType,
        });
        const mediaPromises = [];
        this.initEdgeManager(this._tokenResponse.edgeServerUrl);
        let edgeConnectionPromise;
        if (this._joinOptions.useRemoteMedia) {
            edgeConnectionPromise = this.connectEdge();
            mediaPromises.push(edgeConnectionPromise);
        }
        await this.initializeOriginManagers();
        if (this._joinOptions.useScreenShare)
            mediaPromises.push(this.connectOriginDisplay());
        if (this._joinOptions.useCamera || this._joinOptions.useMicrophone)
            mediaPromises.push(this.connectOriginUser());
        const optionalServicesPromises = [];
        if (this._joinOptions.useAttendeeList)
            optionalServicesPromises.push(this.startAttendeeList(this.joinOptions, abortSignal));
        if (this._joinOptions.useChat)
            optionalServicesPromises.push(this.startChat(abortSignal));
        if (this._joinOptions.linkLocalAndRemoteMedia) {
            await Promise.all(mediaPromises);
        }
        // we need to bind local media regardless of if edge/origin are started on join, so that they're ready for later if required
        const mediaBindingPromises = [];
        mediaBindingPromises.push(this.bindEdgeLocalMedia(edgeConnectionPromise)); // replace local media in the visible media collection
        mediaBindingPromises.push(this.bindOriginLocalMedia("display", abortSignal));
        mediaBindingPromises.push(this.bindOriginLocalMedia("user", abortSignal));
        void this._eventLogger.debug("join", `Starting stats...`);
        this.tryStartStats();
        await Promise.all([
            Promise.all(optionalServicesPromises),
            Promise.all(mediaPromises),
            Promise.all(mediaBindingPromises)
        ]);
        this._timings.optionalServicesCompleted = Math.round(performance.now() - start);
        this._isReady = true;
    }
    async getMeetingTokenAndInitializeLoggers(abortSignal) {
        const start = performance.now();
        try {
            this._tokenResponse = await this._session.getToken(this._joinOptions, abortSignal);
        }
        catch (error) {
            // special case: since we're failing when getting the meeting token, the joinAttempt metric needs to be logged here and will wind up in the userAccountLogs table since we don't have an attendee yet
            // otherwise, this join attempt will be logged in the main join function and log to the attendeeLogs table
            void this.logClientMetric({ eventName: "joinAttempt" });
            throw error;
        }
        // init loggers
        this._eventLogger = new Logger(this._apiClient, "Meeting", this._tokenResponse.attendeeId, this._tokenResponse.meetingId, this._session.clusterId);
        this._metricLogger.meetingSession = this._session;
        void this._eventLogger.information("join.tokenReceived", `Received token for meeting ${this._tokenResponse.meetingId}.`, performance.now() - start);
        this._timings.meetingTokenReceived = Math.round(performance.now() - start);
        void this._eventLogger.debug("join", `Control server URL is ${new URL(this._tokenResponse.controlServerUrl).origin}.`);
        void this._eventLogger.debug("join", `Edge server URL is ${new URL(this._tokenResponse.edgeServerUrl).origin}`);
        void this._eventLogger.debug("join", `Origin server URL is ${new URL(this._tokenResponse.originServerUrl).origin}`);
        void this._eventLogger.debug("join", `TURN server URL is ${new URL(this._tokenResponse.turnServerUrl).origin}`);
    }
    async configureTurn() {
        const start = performance.now();
        // initialize TURN session and get initial credentials
        if (this._joinOptions.turnOptions.externalCredentials) {
            this._turnSession = new ExternalSession({
                credentials: this._joinOptions.turnOptions.externalCredentials,
            });
        }
        else {
            this._turnSession = new Session({
                meetingSession: this._session,
                turnServerUrl: this._tokenResponse.turnServerUrl,
                tcpAllowed: this._joinOptions.turnOptions.tcpAllowed,
                tlsAllowed: this._joinOptions.turnOptions.tlsAllowed,
                udpAllowed: this._joinOptions.turnOptions.udpAllowed,
            });
        }
        if (this._turnSession) {
            const iceServer = await this._turnSession.iceServer();
            const duration = Math.round(performance.now() - start);
            this._timings.turnCredentialsReceived = duration;
            void this._eventLogger.information("join.turnConfigured", `Configured TURN: ${(iceServer?.urls ?? []).join(", ")}`, duration);
        }
    }
    async connectControl(abortSignal) {
        // initialize control client
        const controlClient = new Client$4({
            controlServerUrl: this._tokenResponse.controlServerUrl,
            meetingSession: this._session,
        });
        controlClient.maxRetries = this._maxRetries;
        controlClient.requestTimeout = this._requestTimeout;
        // initialize control connection
        this._controlConnection = new Connection$2({
            apiClient: this._apiClient,
            attendeeId: this._tokenResponse.attendeeId,
            canBlock: () => this._localAttendee?.canBlock ?? false,
            canCreateChatChannel: () => this._localAttendee?.canCreateChatChannel ?? false,
            canDeleteChatChannel: () => this._localAttendee?.canDeleteChatChannel ?? false,
            canDeleteChatMessage: () => this._localAttendee?.canDeleteChatMessage ?? false,
            canEnableChat: () => this._localAttendee?.canEnableChat ?? false,
            canKick: () => this._localAttendee?.canKick ?? false,
            canMute: () => this._localAttendee?.canMute ?? false,
            canRecord: () => this._localAttendee?.canRecord ?? false,
            canSendChatMessage: () => this._localAttendee?.canSendChatMessage ?? false,
            canUnmute: () => this._localAttendee?.canUnmute ?? false,
            canUpdate: () => this._localAttendee?.canUpdate ?? false,
            client: controlClient,
            clusterId: this._session.clusterId,
            iceRestartEnabled: this._joinOptions.iceOptions.restartEnabled,
            iceReconnectionTimeout: this._joinOptions.iceOptions.reconnectionTimeout,
            meetingId: this._tokenResponse.meetingId,
            turnRequired: this._joinOptions.turnOptions.required,
            turnSession: this._turnSession,
        });
        this._controlConnection.attendeeAdmitted.bind(this.processAttendeeAdmitted.bind(Reactive.wrap(this)));
        this._controlConnection.attendeeAudioMuted.bind(this.processAttendeeAudioMuted.bind(Reactive.wrap(this)));
        this._controlConnection.attendeeAudioUnmuted.bind(this.processAttendeeAudioUnmuted.bind(Reactive.wrap(this)));
        this._controlConnection.attendeeAudioUnmuteDisabled.bind(this.processAttendeeAudioUnmuteDisabled.bind(Reactive.wrap(this)));
        this._controlConnection.attendeeAudioUnmuteEnabled.bind(this.processAttendeeAudioUnmuteEnabled.bind(Reactive.wrap(this)));
        this._controlConnection.attendeeBlockedFromLobby.bind(this.processAttendeeBlockedFromLobby.bind(Reactive.wrap(this)));
        this._controlConnection.attendeeBlockedFromRoom.bind(this.processAttendeeBlockedFromRoom.bind(Reactive.wrap(this)));
        this._controlConnection.attendeeHandLowered.bind(this.processAttendeeHandLowered.bind(Reactive.wrap(this)));
        this._controlConnection.attendeeHandRaised.bind(this.processAttendeeHandRaised.bind(Reactive.wrap(this)));
        this._controlConnection.attendeeJoined.bind(this.processAttendeeJoined.bind(Reactive.wrap(this)));
        this._controlConnection.attendeeKicked.bind(this.processAttendeeKicked.bind(Reactive.wrap(this)));
        this._controlConnection.attendeeLeft.bind(this.processAttendeeLeft.bind(Reactive.wrap(this)));
        this._controlConnection.attendeeNoiseSuppressed.bind(this.processAttendeeNoiseSuppressed.bind(Reactive.wrap(this)));
        this._controlConnection.attendeeNoiseUnsuppressed.bind(this.processAttendeeNoiseUnsuppressed.bind(Reactive.wrap(this)));
        this._controlConnection.attendeePausedUpdated.bind(this.processAttendeePausedUpdated.bind(Reactive.wrap(this)));
        this._controlConnection.attendeePermissionAdded.bind(this.processAttendeePermissionAdded.bind(Reactive.wrap(this)));
        this._controlConnection.attendeePermissionRemoved.bind(this.processAttendeePermissionRemoved.bind(Reactive.wrap(this)));
        this._controlConnection.attendeeSettingAdded.bind(this.processAttendeeSettingAdded.bind(Reactive.wrap(this)));
        this._controlConnection.attendeeSettingRemoved.bind(this.processAttendeeSettingRemoved.bind(Reactive.wrap(this)));
        this._controlConnection.attendeePinned.bind(this.processAttendeePinned.bind(Reactive.wrap(this)));
        this._controlConnection.attendeeQualityEdgeUpdated.bind(this.processAttendeeQualityEdgeUpdated.bind(Reactive.wrap(this)));
        this._controlConnection.attendeeQualityOriginUpdated.bind(this.processAttendeeQualityOriginUpdated.bind(Reactive.wrap(this)));
        this._controlConnection.attendeeUnpinned.bind(this.processAttendeeUnpinned.bind(Reactive.wrap(this)));
        this._controlConnection.attendeeUpdated.bind(this.processAttendeeUpdated.bind(Reactive.wrap(this)));
        this._controlConnection.attendeeVideoMuted.bind(this.processAttendeeVideoMuted.bind(Reactive.wrap(this)));
        this._controlConnection.attendeeVideoUnmuted.bind(this.processAttendeeVideoUnmuted.bind(Reactive.wrap(this)));
        this._controlConnection.attendeeVideoUnmuteDisabled.bind(this.processAttendeeVideoUnmuteDisabled.bind(Reactive.wrap(this)));
        this._controlConnection.attendeeVideoUnmuteEnabled.bind(this.processAttendeeVideoUnmuteEnabled.bind(Reactive.wrap(this)));
        this._controlConnection.meetingAudioMuted.bind(this.processMeetingAudioMuted.bind(Reactive.wrap(this)));
        this._controlConnection.meetingAudioUnmuted.bind(this.processMeetingAudioUnmuted.bind(Reactive.wrap(this)));
        this._controlConnection.meetingAudioUnmuteDisabled.bind(this.processMeetingAudioUnmuteDisabled.bind(Reactive.wrap(this)));
        this._controlConnection.meetingAudioUnmuteEnabled.bind(this.processMeetingAudioUnmuteEnabled.bind(Reactive.wrap(this)));
        this._controlConnection.meetingChatDisabled.bind(this.processMeetingChatDisabled.bind(Reactive.wrap(this)));
        this._controlConnection.meetingChatEnabled.bind(this.processMeetingChatEnabled.bind(Reactive.wrap(this)));
        this._controlConnection.meetingNoiseSuppressed.bind(this.processMeetingNoiseSuppressed.bind(Reactive.wrap(this)));
        this._controlConnection.meetingNoiseUnsuppressed.bind(this.processMeetingNoiseUnsuppressed.bind(Reactive.wrap(this)));
        this._controlConnection.meetingRecordingDisabled.bind(this.processMeetingRecordingDisabled.bind(Reactive.wrap(this)));
        this._controlConnection.meetingRecordingEnabled.bind(this.processMeetingRecordingEnabled.bind(Reactive.wrap(this)));
        this._controlConnection.meetingRecordingStarted.bind(this.processMeetingRecordingStarted.bind(Reactive.wrap(this)));
        this._controlConnection.meetingRecordingStopped.bind(this.processMeetingRecordingStopped.bind(Reactive.wrap(this)));
        this._controlConnection.meetingVideoMuted.bind(this.processMeetingVideoMuted.bind(Reactive.wrap(this)));
        this._controlConnection.meetingUpdated.bind(this.processMeetingUpdated.bind(Reactive.wrap(this)));
        this._controlConnection.meetingVideoUnmuted.bind(this.processMeetingVideoUnmuted.bind(Reactive.wrap(this)));
        this._controlConnection.meetingVideoUnmuteDisabled.bind(this.processMeetingVideoUnmuteDisabled.bind(Reactive.wrap(this)));
        this._controlConnection.meetingVideoUnmuteEnabled.bind(this.processMeetingVideoUnmuteEnabled.bind(Reactive.wrap(this)));
        this._controlConnection.stateChanged.bind(this.onControlConnectionStateChanged.bind(Reactive.wrap(this)));
        this._controlConnection.subscribedAttendees.bind(this.processSubscribedAttendees.bind(Reactive.wrap(this)));
        // connect control
        const start = performance.now();
        void this._eventLogger.debug("join", `Connecting...`);
        try {
            void this.logClientMetric({ eventName: "connectionAttemptControl", eventDebug: { "serverUrl": this._tokenResponse.controlServerUrl } });
            await this._controlConnection.open(abortSignal);
            this._model = this._controlConnection.meeting;
            void this.logClientMetric({ eventName: "connectionSuccessControl", eventDuration: performance.now() - start });
        }
        catch (error) {
            void this.logClientMetric({ eventName: "connectionErrorControl", eventDebug: { "error": error.message }, eventDuration: performance.now() - start });
            throw (error);
        }
        this._timings.controlConnectionOpened = Math.round(performance.now() - start);
        void this._eventLogger.information("join.controlConnected", `Connected to control server.`, performance.now() - start);
    }
    async connectEdge(abortSignal) {
        if (!this.canReceiveMedia || this._remoteMediaDisabled)
            return;
        const start = performance.now();
        this.initEdgeManager(this._tokenResponse.edgeServerUrl);
        return new Promise(async (resolve, reject) => {
            try {
                while (this._edgeManager && this._edgeManager.state != "started") {
                    let attempts = 0;
                    // fail out if aborted
                    if (abortSignal?.aborted == true) {
                        if (abortSignal.reason)
                            throw new Error(`Abort signalled. (${abortSignal.reason})`);
                        throw new Error("Abort signalled.");
                    }
                    try {
                        void this.logClientMetric({ eventName: "connectionAttemptEdge", eventDebug: { "serverUrl": this._edgeManager.url, "attemptIndex": attempts++ } });
                        await this._edgeManager.start(abortSignal);
                        this._timings.edgeConnectionOpened = Math.round(performance.now() - start);
                        void this.logClientMetric({ eventName: "connectionSuccessEdge", eventDuration: performance.now() - start });
                        void this._eventLogger.information("join.edgeConnected", `Connected to edge server.`, performance.now() - start);
                        resolve();
                    }
                    catch (error) {
                        void this.logClientMetric({ eventName: "connectionErrorEdge", eventDebug: { "error": error.message }, eventDuration: performance.now() - start });
                        void this._eventLogger.warning(error, "join", `Reassigning...`);
                        const edgeServerUrl = (await this._session.reassignEdge()).serverUrl;
                        if (!edgeServerUrl) {
                            this._eventLogger.debug("join", `Reassignment failed. No other servers available.`);
                            throw error;
                        }
                        this._eventLogger.debug("join", `Edge server URL is now ${new URL(edgeServerUrl).origin}.`);
                        this.initEdgeManager(edgeServerUrl);
                    }
                }
            }
            catch (error) {
                reject(error);
            }
        });
    }
    async connectOriginDisplay(abortSignal) {
        if (this.canSendDisplayMedia) {
            const start = performance.now();
            const originManager = this._originManagers.get("display");
            if (originManager) {
                void this.logClientMetric({ eventName: "connectionAttemptOriginDisplay", eventDebug: { "serverUrl": originManager.url } });
                const originPromise = originManager.start(abortSignal);
                originPromise
                    .then(() => {
                    const duration = Math.round(performance.now() - start);
                    this._timings.originDisplayConnection = duration;
                    void this.logClientMetric({ eventName: "connectionSuccessOriginDisplay", eventDuration: duration });
                    void this._eventLogger.information("join.originDisplayConnected", `Connected to origin (display) server.`, duration);
                })
                    .catch((error) => { void this.logClientMetric({ eventName: "connectionErrorOriginDisplay", eventDebug: { "error": error.message }, eventDuration: performance.now() - start }); });
                return originPromise;
            }
        }
    }
    async connectOriginUser(abortSignal) {
        if (this.canSendUserMedia) {
            const start = performance.now();
            const originManager = this._originManagers.get("user");
            if (originManager) {
                void this.logClientMetric({ eventName: "connectionAttemptOriginUser", eventDebug: { "serverUrl": originManager.url } });
                const originPromise = originManager.start(abortSignal);
                return originPromise
                    .then(() => {
                    const duration = Math.round(performance.now() - start);
                    this._timings.originUserConnectionOpened = duration;
                    void this.logClientMetric({ eventName: "connectionSuccessOriginUser", eventDuration: duration });
                    void this._eventLogger.information("join.originUserConnected", `Connected to origin (user) server.`, duration);
                })
                    .catch((error) => { void this.logClientMetric({ eventName: "connectionErrorOriginUser", eventDebug: { "error": error.message }, eventDuration: performance.now() - start }); });
            }
        }
    }
    async bindEdgeLocalMedia(edgeConnectionPromise) {
        await edgeConnectionPromise;
        const start = performance.now();
        //TODO: bind but paused
        let mediaBound = false;
        for (const mediaType of mediaTypes) {
            const localMedia = this._localMedias.get(mediaType);
            if (!localMedia)
                continue;
            mediaBound = true;
            void this._eventLogger.debug("join", `Binding local ${mediaType} media to edge...`);
            this._edgeManager?.setLocalMedia(mediaType, localMedia);
        }
        if (mediaBound) {
            const duration = Math.round(performance.now() - start);
            this._timings.edgeLocalMediaBound = duration;
            void this._eventLogger.information("join.edgeLocalMediaBound", `Bound local media to edge manager.`, duration);
        }
    }
    async bindOriginLocalMedia(mediaType, abortSignal) {
        const start = performance.now();
        const localMedia = this._localMedias.get(mediaType);
        if (!localMedia)
            return;
        const originManager = this._originManagers.get(mediaType);
        if (!originManager)
            return;
        void this._eventLogger.debug("join", `Binding local ${mediaType} media to origin...`);
        await originManager.setMedia(localMedia, this._localAttendee, false, abortSignal);
        await this.validateUserMedia(localMedia, mediaType);
        const duration = Math.round(performance.now() - start);
        if (mediaType == "display") {
            this._timings.originDisplayMediaBound = duration;
        }
        if (mediaType == "user")
            this._timings.originUserMediaBound = duration;
        void this._eventLogger.information(`join.originLocalMediaBound.${mediaType}`, `Bound local ${mediaType} media to origin manager.`, duration);
    }
    async startAttendeeList(joinOptions, abortSignal) {
        let start = performance.now();
        try {
            await this._attendees.start();
            const duration = Math.round(performance.now() - start);
            this._timings.attendeeListStarted = duration;
            void this._eventLogger.information("join.attendeeListLoaded", `Loaded attendee list.`, duration, {
                "pageSize": this.attendees.pageSize,
                "attendeesLoaded": this.attendees.count,
                "attendeesTotal": this.attendees.totalCount
            });
        }
        catch (error) {
            void this._eventLogger.error(error, "join.attendeeListFailed", "Attendee list failed to load.", performance.now() - start);
        }
    }
    async startChat(abortSignal) {
        const start = performance.now();
        try {
            await this.startChatInternal();
            const duration = Math.round(performance.now() - start);
            this._timings.chatStarted = duration;
            if (this.isChatEnabled)
                void this._eventLogger.information("join.chatLoaded", `Loaded chat.`, duration);
        }
        catch (error) {
            void this._eventLogger.error(error, "join.chatFailed", "Chat failed to load.", performance.now() - start);
        }
    }
    async initializeOriginManagers() {
        // TODO: This should be done earlier. Identity token has a tenantId. Seems the tenantSettings endpoint not set up to use the token.
        const tenantSettingStart = performance.now();
        const tenantSettingsResponse = await this._apiClient.listTenantSettingsByTenantId(this._controlConnection.tenantId);
        if (tenantSettingsResponse.values) {
            this._tenantSettings = tenantSettingsResponse.values;
            void this._eventLogger.information("join.clusterSettingsLoaded", `Loaded ${this._tenantSettings.length} tenant settings.`, performance.now() - tenantSettingStart);
        }
        for (const mediaType of mediaTypes) {
            if (mediaType == "display" && !this._model.maxAudioDisplay && !this._model.maxVideoDisplay)
                continue;
            if (mediaType == "user" && !this._model.maxAudioUser && !this._model.maxVideoUser)
                continue;
            this._originManagers.get(mediaType).init({
                apiClient: this._apiClient,
                attendeeId: this._tokenResponse.attendeeId,
                audioLevelInterval: this._joinOptions.audioLevelInterval,
                clusterId: this._session.clusterId,
                iceRestartEnabled: this._joinOptions.iceOptions.restartEnabled,
                iceReconnectionTimeout: this._joinOptions.iceOptions.reconnectionTimeout,
                mediaOptions: mediaType == "display" ? this._joinOptions.localDisplayOptions : this._joinOptions.localUserOptions,
                mediaType: mediaType,
                meetingId: this._tokenResponse.meetingId,
                meetingSession: this._session,
                originServerUrl: this._tokenResponse.originServerUrl,
                redAudioEnabled: this._joinOptions.redAudioEnabled,
                replicationCount: mediaType == "user" ? this._joinOptions.userReplicationCount : undefined,
                room: this._controlConnection.room,
                tenantSettings: this._tenantSettings,
                turnRequired: this._joinOptions.turnOptions.required,
                turnSession: this._turnSession,
            });
            this._originManagers.get(mediaType).connectionStateChanged.bind(this.onOriginConnectionStateChanged.bind(Reactive.wrap(this)));
            this._originManagers.get(mediaType).maxRetries = this._maxRetries;
            this._originManagers.get(mediaType).requestTimeout = this._requestTimeout;
        }
    }
    leave(abortSignal) {
        return this._eventQueue.dispatch(async () => {
            if (this.state == "left" || this.state == "new")
                return;
            this.setState("leaving");
            void this._eventLogger?.debug("leave", "Leaving meeting...");
            await this.unjoin(abortSignal);
            this.setState("left");
            void this._eventLogger?.debug("leave", "Left meeting.");
        });
    }
    async log(event) {
        await this._metricLogger.log({
            eventDebug: event.eventDebug,
            eventDuration: event.eventDuration,
            eventMessage: event.eventMessage,
            eventName: event.eventName,
            metricType: "app",
            timestamp: new Date
        });
    }
    async iceRestart() {
        if (!this.allConnected()) {
            return;
        }
        try {
            await Promise.all([
                this._edgeManager?.iceRestart(),
                this._originManagers.get("user")?.iceRestart(),
                this._originManagers.get("display")?.iceRestart(),
                this._controlConnection?.iceRestart()
            ]);
        }
        catch (error) {
            void this._eventLogger?.warning(error, "iceRestart", "ICE restart failed");
        }
    }
    /** @ internal */
    async logClientMetric(event) {
        await this._metricLogger.log({
            eventDebug: event.eventDebug,
            eventDuration: event.eventDuration,
            eventMessage: event.eventMessage,
            eventName: event.eventName,
            metricType: "sdk",
            timestamp: new Date
        });
    }
    //#region Connection Event Handlers
    allConnected() {
        if (this._controlConnection && this._controlConnection.state != "connected")
            return false;
        if (this._edgeManager && this._edgeManager.connectionState != "connected")
            return false;
        for (const mediaType of mediaTypes) {
            const originManager = this._originManagers.get(mediaType);
            if (originManager && originManager.isStarted && originManager.connectionState != "connected")
                return false;
        }
        return true;
    }
    onControlConnectionStateChanged(e) {
        void this._eventQueue.dispatch(async () => {
            if (e.state == "reconnecting") {
                void this.logClientMetric({ eventName: "reconnectAttemptControl", eventDuration: e.previousStateDuration });
                void this._eventLogger?.debug("onControlConnectionStateChanged", "Control connection is reconnecting...");
                if (this.trySetState("reconnecting")) {
                    await this.tryPauseOriginMedia();
                }
            }
            if (e.state == "connected" && e.previousState == "reconnecting") {
                void this.logClientMetric({ eventName: "reconnectSuccessControl", eventDuration: e.previousStateDuration });
                void this._eventLogger?.debug("onControlConnectionStateChanged", "Control connection has reconnected.");
                if (this.allConnected() && this.trySetState("joined"))
                    await this.tryResumeOriginMedia();
            }
            if (e.state == "failed" && this.state != "leaving" && this.state != "left") {
                if (e.previousState == "reconnecting")
                    void this.logClientMetric({ eventName: "reconnectErrorControl", eventDuration: e.previousStateDuration });
                else
                    void this.logClientMetric({ eventName: "connectionDroppedControl", eventDuration: e.previousStateDuration });
                this._hasFailed = true;
                this.setState("leaving");
                void this._eventLogger?.debug("onControlConnectionStateChanged", `Leaving meeting (control connection ${e.state})...`);
                await this.unjoin();
                this.setState("left");
                void this._eventLogger?.debug("onControlConnectionStateChanged", `Left meeting (control connection ${e.state}).`);
            }
            if (e.state == "closed" && this.state != "leaving" && this.state != "left") {
                this.setState("leaving");
                void this._eventLogger?.debug("onControlConnectionStateChanged", `Leaving meeting (control connection ${e.state})...`);
                await this.unjoin();
                this.setState("left");
                void this._eventLogger?.debug("onControlConnectionStateChanged", `Left meeting (control connection ${e.state}).`);
            }
        });
    }
    onEdgeConnectionStateChanged(e) {
        void this._eventQueue.dispatch(async () => {
            if (e.state == "reconnecting") {
                void this.logClientMetric({ eventName: "reconnectAttemptEdge", eventDuration: e.previousStateDuration });
                void this._eventLogger?.debug("onEdgeConnectionStateChanged", "Edge connection is reconnecting...");
                if (this.trySetState("reconnecting")) {
                    await this.tryPauseOriginMedia();
                }
            }
            if (e.state == "connected" && e.previousState == "reconnecting") {
                void this.logClientMetric({ eventName: "reconnectSuccessEdge", eventDuration: e.previousStateDuration });
                void this._eventLogger?.debug("onEdgeConnectionStateChanged", "Edge connection has reconnected.");
                if (this.allConnected() && this.trySetState("joined"))
                    await this.tryResumeOriginMedia();
            }
            if (e.state == "failed" && this.state != "leaving" && this.state != "left") {
                if (e.previousState == "reconnecting")
                    void this.logClientMetric({ eventName: "reconnectErrorEdge", eventDuration: e.previousStateDuration });
                else
                    void this.logClientMetric({ eventName: "connectionDroppedEdge", eventDuration: e.previousStateDuration });
                this._hasFailed = true;
                this.setState("leaving");
                void this._eventLogger?.debug("onEdgeConnectionStateChanged", `Leaving meeting (edge connection ${e.state})...`);
                await this.unjoin();
                this.setState("left");
                void this._eventLogger?.debug("onEdgeConnectionStateChanged", `Left meeting (edge connection ${e.state}).`);
            }
        });
    }
    onOriginConnectionStateChanged(e) {
        void this._eventQueue.dispatch(async () => {
            const mediaType = e.connection.mediaType;
            if (e.state == "reconnecting") {
                void this.logClientMetric({ eventName: mediaType == "user" ? "reconnectAttemptOriginUser" : "reconnectAttemptOriginDisplay", eventDuration: e.previousStateDuration });
                void this._eventLogger?.debug("onOriginConnectionStateChanged", `Origin (${mediaType}) connection is reconnecting...`);
                if (this.trySetState("reconnecting")) {
                    await this.tryPauseOriginMedia();
                }
            }
            if (e.state == "connected" && e.previousState == "reconnecting") {
                void this.logClientMetric({ eventName: mediaType == "user" ? "reconnectSuccessOriginUser" : "reconnectSuccessOriginDisplay", eventDuration: e.previousStateDuration });
                void this._eventLogger?.debug("onOriginConnectionStateChanged", `Origin (${mediaType}) connection has reconnected.`);
                if (this.allConnected() && this.trySetState("joined"))
                    await this.tryResumeOriginMedia();
            }
            if (e.state == "failed" && this.state != "leaving" && this.state != "left") {
                if (e.previousState == "reconnecting")
                    void this.logClientMetric({ eventName: mediaType == "user" ? "reconnectErrorOriginUser" : "reconnectErrorOriginDisplay", eventDuration: e.previousStateDuration });
                else
                    void this.logClientMetric({ eventName: mediaType == "user" ? "connectionDroppedOriginUser" : "connectionDroppedOriginDisplay", eventDuration: e.previousStateDuration });
                this._hasFailed = true;
                this.setState("leaving");
                void this._eventLogger?.debug("onOriginConnectionStateChanged", `Leaving meeting (origin connection ${e.state})...`);
                await this.unjoin();
                this.setState("left");
                void this._eventLogger?.debug("onOriginConnectionStateChanged", `Left meeting (origin connection ${e.state}).`);
            }
        });
    }
    async tryPauseOriginMedia() {
        void this._eventLogger.debug("tryPauseLocalUserMedia", `Pausing origin media...`);
        await this._originManagers.get("display")?.pauseInternal();
        await this._originManagers.get("user")?.pauseInternal();
    }
    async tryResumeOriginMedia() {
        void this._eventLogger.debug("tryResumeLocalUserMedia", `Resuming origin media...`);
        await this._originManagers.get("display")?.resumeInternal();
        await this._originManagers.get("user")?.resumeInternal();
    }
    //#endregion
    //#region Control Operations
    async disableAudioUnmute() {
        const controlConnection = this._controlConnection;
        if (!controlConnection)
            throw new Error(Constants$2.Errors.Meeting.notJoined);
        await controlConnection.disableMeetingAudioUnmute(this._model); // TODO: why send the whole model?
        await this.processMeetingAudioUnmuteDisabled({
            attendee: this._localAttendee.model,
            exclusions: [this._localAttendee.id],
            meeting: this._model,
        });
    }
    async disableAudioUnmuteOnJoin() {
        const controlConnection = this._controlConnection;
        if (!controlConnection)
            throw new Error(Constants$2.Errors.Meeting.notJoined);
        const sendModel = Object.assign({}, this._model, { allowUnmuteAudioOnJoin: false });
        await controlConnection.disableMeetingAudioUnmuteOnJoin(sendModel); // TODO: why send the whole model?
        await this.processMeetingUpdated({ meeting: sendModel });
    }
    /**
     * Disables chat on a meeting level, for all attendees.
     */
    async disableChat() {
        const controlConnection = this._controlConnection;
        if (!controlConnection)
            throw new Error(Constants$2.Errors.Meeting.notJoined);
        await controlConnection.disableChat(this._model); // TODO: why send the whole model?
        this._model.allowChat = false;
        await this._chat.stop();
    }
    async disableVideoUnmute() {
        const controlConnection = this._controlConnection;
        if (!controlConnection)
            throw new Error(Constants$2.Errors.Meeting.notJoined);
        await controlConnection.disableMeetingVideoUnmute(this._model); // TODO: why send the whole model?
        await this.processMeetingVideoUnmuteDisabled({
            attendee: this._localAttendee.model,
            exclusions: [this._localAttendee.id],
            meeting: this._model,
        });
    }
    async disableVideoUnmuteOnJoin() {
        const controlConnection = this._controlConnection;
        if (!controlConnection)
            throw new Error(Constants$2.Errors.Meeting.notJoined);
        const sendModel = Object.assign({}, this._model, { allowUnmuteVideoOnJoin: false });
        await controlConnection.disableMeetingVideoUnmuteOnJoin(sendModel); // TODO: why send the whole model?
        await this.processMeetingUpdated({ meeting: sendModel });
    }
    async enableAudioUnmute() {
        const controlConnection = this._controlConnection;
        if (!controlConnection)
            throw new Error(Constants$2.Errors.Meeting.notJoined);
        await controlConnection.enableMeetingAudioUnmute(this._model); // TODO: why send the whole model?
        await this.processMeetingAudioUnmuteEnabled({
            attendee: this._localAttendee.model,
            exclusions: [this._localAttendee.id],
            meeting: this._model,
        });
    }
    async enableAudioUnmuteOnJoin() {
        const controlConnection = this._controlConnection;
        if (!controlConnection)
            throw new Error(Constants$2.Errors.Meeting.notJoined);
        const sendModel = Object.assign({}, this._model, { allowUnmuteAudioOnJoin: true });
        await controlConnection.enableMeetingAudioUnmuteOnJoin(sendModel); // TODO: why send the whole model?
        await this.processMeetingUpdated({ meeting: sendModel });
    }
    /**
     * Enables chat at the meeting level, for all attendees.
     */
    async enableChat() {
        const controlConnection = this._controlConnection;
        if (!controlConnection)
            throw new Error(Constants$2.Errors.Meeting.notJoined);
        await controlConnection.enableChat(this._model); // TODO: why send the whole model?
        this._model.allowChat = true;
        await this.startChatInternal();
    }
    async enableVideoUnmute() {
        const controlConnection = this._controlConnection;
        if (!controlConnection)
            throw new Error(Constants$2.Errors.Meeting.notJoined);
        await controlConnection.enableMeetingVideoUnmute(this._model); // TODO: why send the whole model?
        await this.processMeetingVideoUnmuteEnabled({
            attendee: this._localAttendee.model,
            exclusions: [this._localAttendee.id],
            meeting: this._model,
        });
    }
    async enableVideoUnmuteOnJoin() {
        const controlConnection = this._controlConnection;
        if (!controlConnection)
            throw new Error(Constants$2.Errors.Meeting.notJoined);
        const sendModel = Object.assign({}, this._model, { allowUnmuteVideoOnJoin: true });
        await controlConnection.enableMeetingVideoUnmuteOnJoin(sendModel); // TODO: why send the whole model?
        await this.processMeetingUpdated({ meeting: sendModel });
    }
    async muteAudio() {
        const controlConnection = this._controlConnection;
        if (!controlConnection)
            throw new Error(Constants$2.Errors.Meeting.notJoined);
        await controlConnection.muteMeetingAudio(this._model); // TODO: why send the whole model?
        await this.processMeetingAudioMuted({
            attendee: this._localAttendee.model,
            exclusions: [this._localAttendee.id],
            meeting: this._model,
        });
    }
    async muteAudioOnJoin() {
        const controlConnection = this._controlConnection;
        if (!controlConnection)
            throw new Error(Constants$2.Errors.Meeting.notJoined);
        const sendModel = Object.assign({}, this._model, { muteAudioOnJoin: true });
        await controlConnection.muteMeetingAudioOnJoin(sendModel); // TODO: why send the whole model?
        await this.processMeetingUpdated({ meeting: sendModel });
    }
    async muteVideo() {
        const controlConnection = this._controlConnection;
        if (!controlConnection)
            throw new Error(Constants$2.Errors.Meeting.notJoined);
        await controlConnection.muteMeetingVideo(this._model); // TODO: why send the whole model?
        await this.processMeetingVideoMuted({
            attendee: this._localAttendee.model,
            exclusions: [this._localAttendee.id],
            meeting: this._model,
        });
    }
    async muteVideoOnJoin() {
        const controlConnection = this._controlConnection;
        if (!controlConnection)
            throw new Error(Constants$2.Errors.Meeting.notJoined);
        const sendModel = Object.assign({}, this._model, { muteVideoOnJoin: true });
        await controlConnection.muteMeetingVideoOnJoin(sendModel); // TODO: why send the whole model?
        await this.processMeetingUpdated({ meeting: sendModel });
    }
    async startRecording() {
        const controlConnection = this._controlConnection;
        if (!controlConnection)
            throw new Error(Constants$2.Errors.Meeting.notJoined);
        const response = await controlConnection.startRecordingMeeting(this._model); // TODO: why send the whole model?
        await this.processMeetingRecordingStarted({ meeting: response.meeting });
    }
    async stopRecording() {
        const controlConnection = this._controlConnection;
        if (!controlConnection)
            throw new Error(Constants$2.Errors.Meeting.notJoined);
        const response = await controlConnection.stopRecordingMeeting(this._model); // TODO: why send the whole model?
        await this.processMeetingRecordingStopped({ meeting: response.meeting });
    }
    async suppressNoise() {
        const controlConnection = this._controlConnection;
        if (!controlConnection)
            throw new Error(Constants$2.Errors.Meeting.notJoined);
        await controlConnection.suppressMeetingNoise(this._model); // TODO: why send the whole model?
        await this.processMeetingNoiseSuppressed({
            attendee: this._localAttendee.model,
            exclusions: [],
            meeting: this._model,
        });
    }
    async suppressNoiseOnJoin() {
        const controlConnection = this._controlConnection;
        if (!controlConnection)
            throw new Error(Constants$2.Errors.Meeting.notJoined);
        const sendModel = Object.assign({}, this._model, { suppressNoiseOnJoin: true });
        await controlConnection.suppressMeetingNoiseOnJoin(sendModel); // TODO: why send the whole model?
        await this.processMeetingUpdated({ meeting: sendModel });
    }
    async unmuteAudio() {
        const controlConnection = this._controlConnection;
        if (!controlConnection)
            throw new Error(Constants$2.Errors.Meeting.notJoined);
        await controlConnection.unmuteMeetingAudio(this._model); // TODO: why send the whole model?
        await this.processMeetingAudioUnmuted({
            attendee: this._localAttendee.model,
            exclusions: [this._localAttendee.id],
            meeting: this._model,
        });
    }
    async unmuteAudioOnJoin() {
        const controlConnection = this._controlConnection;
        if (!controlConnection)
            throw new Error(Constants$2.Errors.Meeting.notJoined);
        const sendModel = Object.assign({}, this._model, { muteAudioOnJoin: false });
        await controlConnection.unmuteMeetingAudioOnJoin(sendModel); // TODO: why send the whole model?
        await this.processMeetingUpdated({ meeting: sendModel });
    }
    async unmuteVideo() {
        const controlConnection = this._controlConnection;
        if (!controlConnection)
            throw new Error(Constants$2.Errors.Meeting.notJoined);
        await controlConnection.unmuteMeetingVideo(this._model); // TODO: why send the whole model?
        await this.processMeetingVideoUnmuted({
            attendee: this._localAttendee.model,
            exclusions: [this._localAttendee.id],
            meeting: this._model,
        });
    }
    async unmuteVideoOnJoin() {
        const controlConnection = this._controlConnection;
        if (!controlConnection)
            throw new Error(Constants$2.Errors.Meeting.notJoined);
        const sendModel = Object.assign({}, this._model, { muteVideoOnJoin: false });
        await controlConnection.unmuteMeetingVideoOnJoin(sendModel); // TODO: why send the whole model?
        await this.processMeetingUpdated({ meeting: sendModel });
    }
    async unsuppressNoise() {
        const controlConnection = this._controlConnection;
        if (!controlConnection)
            throw new Error(Constants$2.Errors.Meeting.notJoined);
        await controlConnection.unsuppressMeetingNoise(this._model); // TODO: why send the whole model?
        await this.processMeetingNoiseUnsuppressed({
            attendee: this._localAttendee.model,
            exclusions: [],
            meeting: this._model,
        });
    }
    async unsuppressNoiseOnJoin() {
        const controlConnection = this._controlConnection;
        if (!controlConnection)
            throw new Error(Constants$2.Errors.Meeting.notJoined);
        const sendModel = Object.assign({}, this._model, { suppressNoiseOnJoin: false });
        await controlConnection.unsuppressMeetingNoiseOnJoin(sendModel); // TODO: why send the whole model?
        await this.processMeetingUpdated({ meeting: sendModel });
    }
    //#endregion
    //#region Device Operations
    setAudioInputDevice(deviceId, required) {
        return this.localUserMedia?.setAudioDevice(deviceId, required);
    }
    setAudioOutputDevice(deviceId) {
        return this._edgeManager?.setAudioDevice(deviceId);
    }
    setVideoInputDevice(deviceId, required) {
        return this.localUserMedia?.setVideoDevice(deviceId, required);
    }
    useNextAudioInputDevice() {
        return this.localUserMedia?.useNextAudioDevice();
    }
    useNextAudioOutputDevice() {
        return this._edgeManager?.useNextAudioDevice();
    }
    async useNextVideoInputDevice() {
        return this.localUserMedia?.useNextVideoDevice();
    }
    async usePreviousAudioInputDevice() {
        return this.localUserMedia?.usePreviousAudioDevice();
    }
    async usePreviousAudioOutputDevice() {
        return this._edgeManager?.usePreviousAudioDevice();
    }
    async usePreviousVideoInputDevice() {
        return this.localUserMedia?.usePreviousVideoDevice();
    }
    //#endregion
    //#region Media Operations
    onAudibleDisplayMediaAdded(e) {
        this._audibleMedias.tryAdd(e.element);
    }
    onAudibleDisplayMediaRemoved(e) {
        this._audibleMedias.tryRemove(e.element.id);
    }
    onAudibleUserMediaAdded(e) {
        this._audibleMedias.tryAdd(e.element);
    }
    onAudibleUserMediaRemoved(e) {
        this._audibleMedias.tryRemove(e.element.id);
    }
    onVisibleDisplayMediaAdded(e) {
        this._visibleMedias.tryAdd(e.element);
        if (!this._maxVisibleUserMediasDuringDisplayMedia)
            return;
        void this.setMaxVisibleUser(this._maxVisibleUserMediasDuringDisplayMedia);
    }
    onVisibleDisplayMediaRemoved(e) {
        this._visibleMedias.tryRemove(e.element.id);
        if (this._visibleDisplayMedias.length > 0)
            return;
        void this.setMaxVisibleUser(this._maxVisibleUserMedias);
    }
    onVisibleUserMediaAdded(e) {
        this._visibleMedias.tryAdd(e.element);
    }
    onVisibleUserMediaRemoved(e) {
        this._visibleMedias.tryRemove(e.element.id);
    }
    async setLocalMedia(mediaType, localMedia, abortSignal) {
        const originManager = this._originManagers.get(mediaType);
        if (originManager.isInitialized || originManager.isStarted) {
            if (localMedia) {
                // why do we start it here?
                // TODO: uncomment this?
                // if ((mediaType == "display" && this.canSendDisplayMedia) || (mediaType == "user" && this.canSendUserMedia)) await originManager.start();
                await this.validateUserMedia(localMedia, mediaType);
                await originManager.setMedia(localMedia, this._localAttendee, false, abortSignal);
            }
            else {
                await originManager.setMedia(null, null, false, abortSignal);
                // why do we stop here? commenting out for now
                //await originManager.stop("Local media has been disabled.");
            }
        }
        this._edgeManager?.setLocalMedia(mediaType, localMedia);
        this._localMedias.set(mediaType, localMedia);
        localMedia?.started.bind(async () => {
            await this.validateUserMedia(localMedia, mediaType);
        });
    }
    async setMaxVisibleUser(maxVisibleUser) {
        await this._edgeManager?.setMaxVisibleUser(maxVisibleUser);
    }
    //public decreaseRemoteBitrate(step?: number): boolean {
    //  if (!this._edgeManager) return false;
    //  this._edgeManager.decreaseBitrate(step);
    //  return true;
    //}
    // public async disableRemoteMedia(): Promise<void> {
    //   return this._eventQueue.dispatch(async () => {
    //     if (this._remoteMediaDisabled) return;
    //     await this._edgeManager?.stop("Remote media has been disabled.");
    //     this._remoteMediaDisabled = true;
    //   });
    // }
    // public async enableRemoteMedia(): Promise<void> {
    //   return this._eventQueue.dispatch(async () => {
    //     if (!this._remoteMediaDisabled) return;
    //     await this._edgeManager?.start();
    //     this._remoteMediaDisabled = false;
    //   });
    // }
    //public increaseRemoteBitrate(step?: number): boolean {
    //  if (!this._edgeManager) return false;
    //  this._edgeManager.increaseBitrate(step);
    //  return true;
    //}
    setLocalDisplayMedia(localDisplayMedia, abortSignal) {
        return this._eventQueue.dispatch(async () => {
            return this.setLocalMedia("display", localDisplayMedia, abortSignal);
        });
    }
    setLocalUserMedia(localUserMedia, abortSignal) {
        return this._eventQueue.dispatch(async () => {
            return this.setLocalMedia("user", localUserMedia, abortSignal);
        });
    }
    //#endregion
    //#region Stats
    tryStartStats() {
        if (this.state != "joined" && this.state != "reconnecting")
            return;
        if (this._statsTimeoutId)
            return;
        this._statsTimeoutId = setTimeout(this.updateStats.bind(Reactive.wrap(this)), this.statsInterval);
    }
    tryStopStats() {
        if (this._statsTimeoutId)
            clearTimeout(this._statsTimeoutId);
    }
    async updateStats() {
        performance.now();
        this._statsTimeoutId = 0;
        const originManagerDisplay = this._originManagers.get("display");
        const originManagerUser = this._originManagers.get("user");
        try {
            const timestamp = performance.now();
            //await this._controlConnection?.updateStats();
            await originManagerUser?.updateStats();
            await originManagerDisplay?.updateStats();
            await this._edgeManager?.updateStats();
            //this._controlChannelStats.aggregate([
            //  this._controlConnection?.controlChannelStats,
            //  this._edgeManager?.controlChannelStats,
            //  originManagerDisplay?.controlChannelStats,
            //  originManagerUser?.controlChannelStats
            //].filter(x => x));
            //this._mediaChannelStats.aggregate([
            //  this._edgeManager?.mediaChannelStats,
            //  originManagerDisplay?.mediaChannelStats,
            //  originManagerUser?.mediaChannelStats
            //].filter(x => x));
            //this._mediaStats.aggregate([
            //  this._edgeManager?.mediaStats,
            //  originManagerDisplay?.mediaStats,
            //  originManagerUser?.mediaStats
            //].filter(x => x));
        }
        catch (error) {
            void this._eventLogger?.warning(error, "updateStats", "Could not update stats.");
        }
        this.tryStartStats();
    }
    //#endregion
    //#region Control Event Handlers
    async processAttendeeAdmitted(e) {
        if (e && e.attendee.id == this._localAttendee.id) ;
    }
    /** @internal */
    async processAttendeeAudioMuted(e) {
        if (e.attendee.id) {
            await this._subscribedView.get(e.attendee.id)?.processMuteAudio();
            if (this._localAttendee.id == e.attendee.id) {
                await this._localAttendee.processMuteAudio();
                this.localUserMedia?.muteAudioInternal();
            }
        }
    }
    /** @internal */
    async processAttendeeAudioUnmuted(e) {
        if (e.attendee.id) {
            await this._subscribedView.get(e.attendee.id)?.processUnmuteAudio();
            if (this._localAttendee.id == e.attendee.id) {
                await this._localAttendee.processUnmuteAudio();
                this.localUserMedia?.unmuteAudioInternal();
            }
        }
    }
    async processAttendeeBlockedFromLobby(e) {
        if (e && e.attendee.id == this._localAttendee.id) {
            await this._blocked.dispatch({
                meeting: this
            });
        }
    }
    async processAttendeeBlockedFromRoom(e) {
        if (e && e.attendee?.id == this._localAttendee.id) {
            await this.leave();
            await this._blocked.dispatch({
                meeting: this
            });
        }
        else if (e && this._attendees.get(e.attendee.id)) {
            await this._attendees.tryRemoveAndUpdate(e.attendee.id);
        }
    }
    /** @internal */
    async processAttendeeHandLowered(e) {
        if (e.attendeeSetting) {
            await this._subscribedView.get(e.attendeeSetting.attendeeId)?.setHandLowered();
            if (e.attendeeSetting.attendeeId == this._localAttendee.id) {
                await this._localAttendee.setHandLowered();
            }
        }
    }
    /** @internal */
    async processAttendeeSettingAdded(e) {
        if (e.attendeeSetting) {
            await this._subscribedView.get(e.attendeeSetting.attendeeId)?.processSettingAdded(e.attendeeSetting);
            if (e.attendeeSetting.attendeeId == this._localAttendee.id) {
                await this._localAttendee.processSettingAdded(e.attendeeSetting);
            }
        }
    }
    /** @internal */
    async processAttendeeSettingRemoved(e) {
        if (e.attendeeSetting) {
            await this._subscribedView.get(e.attendeeSetting.attendeeId)?.processSettingRemoved(e.attendeeSetting);
            if (e.attendeeSetting.attendeeId == this._localAttendee.id) {
                await this._localAttendee.processSettingRemoved(e.attendeeSetting);
            }
        }
    }
    /** @internal */
    async processAttendeeHandRaised(e) {
        if (e.attendeeSetting) {
            await this._subscribedView.get(e.attendeeSetting.attendeeId)?.setHandRaised();
            if (e.attendeeSetting.attendeeId == this._localAttendee.id) {
                await this._localAttendee.setHandRaised();
            }
        }
    }
    async processAttendeeJoined(e) {
        if (this._attendees.statusFilter != "ACTIVE")
            return;
        if (e.attendeeNotification) {
            this._attendees.totalCount = e.attendeeNotification.attendeeCount;
        }
        if (e.attendee) {
            let joinedAttendee = this._subscribedView.get(e.attendee.id);
            if (!joinedAttendee) {
                joinedAttendee = new Attendee({
                    controlConnection: this._controlConnection,
                    isLocal: this._localAttendee.id == e.attendee.id,
                    meeting: Reactive.wrap(this),
                    model: e.attendee,
                });
                this._subscribedView.tryAdd(joinedAttendee);
            }
            else {
                joinedAttendee.model = e.attendee;
            }
            // only add them to the visible attendee list if there is room on the current page
            if (this._attendees.count < this._attendees.pageSize) {
                this._attendees.tryAdd(joinedAttendee);
            }
            await this._attendeeJoined.dispatch({
                meeting: this,
                attendee: joinedAttendee
            });
        }
    }
    async processAttendeeKicked(e) {
        if (e && e.attendee?.id == this._localAttendee.id) {
            await this.leave();
            await this._kicked.dispatch({
                meeting: this
            });
        }
    }
    async processAttendeeLeft(e) {
        if (e.attendeeNotification) {
            this._attendees.totalCount = e.attendeeNotification.attendeeCount;
        }
        if (e.attendee) {
            this._subscribedView.tryRemove(e.attendee.id);
            const leftAttendee = this._attendees.get(e.attendee.id);
            if (leftAttendee && await this._attendees.tryRemoveAndUpdate(leftAttendee.id)) {
                await this._attendeeLeft.dispatch({
                    meeting: this,
                    attendee: leftAttendee,
                });
            }
        }
    }
    async processAttendeeNoiseSuppressed(e) {
        if (e.attendee.id) {
            await this._subscribedView.get(e.attendee.id)?.processSuppressNoise();
            if (this._localAttendee.id == e.attendee.id) {
                await this._localAttendee.processSuppressNoise();
            }
        }
    }
    async processAttendeeNoiseUnsuppressed(e) {
        if (e.attendee.id) {
            await this._subscribedView.get(e.attendee.id)?.processUnsuppressNoise();
            if (this._localAttendee.id == e.attendee.id) {
                await this._localAttendee.processUnsuppressNoise();
            }
        }
    }
    /** @internal */
    async processAttendeePausedUpdated(e) {
        if (e.attendee) {
            const attendee = this._subscribedView.get(e.attendee.id);
            if (attendee) {
                await attendee.processPausedUpdated(e.attendee);
            }
            if (e.attendee.id == this._localAttendee.id) {
                await this._localAttendee.processPausedUpdated(e.attendee);
            }
        }
    }
    async processLocalPermissionUpdate() {
        if (this.canReceiveMedia)
            await this._edgeManager?.start();
        else
            await this._edgeManager?.stop("Permission to receive media has been removed.");
        if (this.localDisplayMedia && this.canSendDisplayMedia)
            await this._originManagers.get("display")?.start();
        else
            await this._originManagers.get("display")?.stop("Permission to send display media has been removed.");
        if (this.localUserMedia && this.canSendUserMedia)
            await this._originManagers.get("user")?.start();
        else
            await this._originManagers.get("user")?.stop("Permission to send user media has been removed.");
    }
    /** @internal */
    async processAttendeePermissionAdded(e) {
        if (e.attendeePermission &&
            e.attendeePermission.attendeePermission.attendeeId &&
            e.attendeePermission.attendeePermission.permissionId) {
            const permission = e.attendeePermission;
            const attendee = this._subscribedView.get(permission.attendeePermission.attendeeId);
            await attendee.processPermissionAdded(permission.permissionName);
            if (this._localAttendee.id == permission.attendeePermission.attendeeId) {
                await this._localAttendee.processPermissionAdded(permission.permissionName);
                await this.processLocalPermissionUpdate();
            }
        }
    }
    /** @internal */
    async processAttendeePermissionRemoved(e) {
        if (e.attendeePermission &&
            e.attendeePermission.attendeePermission.attendeeId &&
            e.attendeePermission.permissionName &&
            e.attendeePermission.permissionType) {
            const permission = e.attendeePermission;
            const attendee = this._subscribedView.get(permission.attendeePermission.attendeeId);
            if (attendee) {
                await attendee.processPermissionRemoved(permission.permissionName);
            }
            if (this._localAttendee.id == permission.attendeePermission.attendeeId) {
                await this._localAttendee.processPermissionRemoved(permission.permissionName);
                await this.processLocalPermissionUpdate();
            }
        }
    }
    /** @internal */
    async processAttendeePinned(e) {
        if (e.attendee) {
            this._subscribedView.pinAttendee(e.attendee);
        }
    }
    /** @internal */
    async processAttendeeQualityEdgeUpdated(e) {
        if (e.attendee) {
            const attendee = this._subscribedView.get(e.attendee.id);
            if (attendee) {
                await attendee.processQualityEdgeUpdate(e.attendee);
            }
            if (e.attendee.id == this._localAttendee.id) {
                await this._localAttendee.processQualityEdgeUpdate(e.attendee);
            }
        }
    }
    /** @internal */
    async processAttendeeQualityOriginUpdated(e) {
        if (e.attendee) {
            const attendee = this._subscribedView.get(e.attendee.id);
            if (attendee) {
                await attendee.processQualityOriginUpdate(e.attendee);
            }
            if (e.attendee.id == this._localAttendee.id) {
                await this._localAttendee.processQualityOriginUpdate(e.attendee);
            }
        }
    }
    /** @internal */
    async processAttendeeUnpinned(e) {
        if (e.attendee) {
            this._subscribedView.unpinAttendee(e.attendee.id);
        }
    }
    /** @internal */
    async processAttendeeUpdated(e) {
        if (e.attendee) {
            const attendee = this._subscribedView.get(e.attendee.id);
            if (attendee) {
                await attendee.processUpdate(e.attendee);
            }
            if (e.attendee.id == this._localAttendee.id) {
                await this._localAttendee.processUpdate(e.attendee);
            }
        }
        if (e.attendeeNotification && e.attendeeNotification.attendeeCount) {
            this._attendees.totalCount = e.attendeeNotification.attendeeCount;
        }
    }
    /** @internal */
    async processAttendeeVideoMuted(e) {
        if (e.attendee.id) {
            await this._subscribedView.get(e.attendee.id)?.processMuteVideo();
            if (this._localAttendee.id == e.attendee.id) {
                await this._localAttendee.processMuteVideo();
                this.localUserMedia?.muteVideoInternal();
            }
        }
    }
    /** @internal */
    async processAttendeeVideoUnmuted(e) {
        if (e.attendee.id) {
            await this._subscribedView.get(e.attendee.id)?.processUnmuteVideo();
            if (this._localAttendee.id == e.attendee.id) {
                await this._localAttendee.processUnmuteVideo();
                this.localUserMedia?.unmuteVideoInternal();
            }
        }
    }
    /** @internal */
    async processAttendeeAudioUnmuteDisabled(e) {
        if (e.attendee.id) {
            await this._subscribedView.get(e.attendee.id)?.processDisableAudioUnmute();
            if (e.attendee.id == this._localAttendee.id) {
                await this._localAttendee.processDisableAudioUnmute();
            }
        }
    }
    /** @internal */
    async processAttendeeAudioUnmuteEnabled(e) {
        if (e.attendee.id) {
            await this._subscribedView.get(e.attendee.id)?.processEnableAudioUnmute();
            if (e.attendee.id == this._localAttendee.id) {
                await this._localAttendee.processEnableAudioUnmute();
            }
        }
    }
    /** @internal */
    async processAttendeeVideoUnmuteDisabled(e) {
        if (e.attendee.id) {
            await this._subscribedView.get(e.attendee.id)?.processDisableVideoUnmute();
            if (e.attendee.id == this._localAttendee.id) {
                await this._localAttendee.processDisableVideoUnmute();
            }
        }
    }
    /** @internal */
    async processAttendeeVideoUnmuteEnabled(e) {
        if (e.attendee.id) {
            await this._subscribedView.get(e.attendee.id)?.processEnableVideoUnmute();
            if (e.attendee.id == this._localAttendee.id) {
                await this._localAttendee.processEnableVideoUnmute();
            }
        }
    }
    async processMeetingAudioMuted(e) {
        const exclusions = new Map(e.exclusions.map(e => [e, e]));
        if (!exclusions.has(this._localAttendee.id)) {
            await this._localAttendee.processMuteAudio();
            this.localUserMedia?.muteAudioInternal();
        }
        this._subscribedView.forEach(async (a) => {
            if (!exclusions.has(a.id))
                await a.processMuteAudio();
        });
    }
    async processMeetingAudioUnmuted(e) {
        const exclusions = new Map(e.exclusions.map(e => [e, e]));
        if (!exclusions.has(this._localAttendee.id)) {
            await this._localAttendee.processUnmuteAudio();
            this.localUserMedia?.unmuteAudioInternal();
        }
        this._subscribedView.forEach(async (a) => {
            if (!exclusions.has(a.id))
                await a.processUnmuteAudio();
        });
    }
    async processMeetingAudioUnmuteDisabled(e) {
        const exclusions = new Map(e.exclusions.map(e => [e, e]));
        if (!exclusions.has(this._localAttendee.id))
            await this._localAttendee.processDisableAudioUnmute();
        this._subscribedView.forEach(async (a) => {
            if (!exclusions.has(a.id))
                await a.processDisableAudioUnmute();
        });
    }
    async processMeetingAudioUnmuteEnabled(e) {
        const exclusions = new Map(e.exclusions.map(e => [e, e]));
        if (!exclusions.has(this._localAttendee.id))
            await this._localAttendee.processEnableAudioUnmute();
        this._subscribedView.forEach(async (a) => {
            if (!exclusions.has(a.id))
                await a.processEnableAudioUnmute();
        });
    }
    async processMeetingChatDisabled(e) {
        this._model.allowChat = e.meeting.allowChat;
        this.stopChatInternal();
    }
    async processMeetingChatEnabled(e) {
        this._model.allowChat = e.meeting.allowChat;
        await this.startChatInternal();
    }
    async processMeetingNoiseSuppressed(e) {
        const exclusions = new Map(e.exclusions.map(e => [e, e]));
        if (!exclusions.has(this._localAttendee.id))
            await this._localAttendee.processSuppressNoise();
        this._subscribedView.forEach(async (a) => {
            if (!exclusions.has(a.id))
                await a.processSuppressNoise();
        });
    }
    async processMeetingNoiseUnsuppressed(e) {
        const exclusions = new Map(e.exclusions.map(e => [e, e]));
        if (!exclusions.has(this._localAttendee.id))
            await this._localAttendee.processUnsuppressNoise();
        this._subscribedView.forEach(async (a) => {
            if (!exclusions.has(a.id))
                await a.processUnsuppressNoise();
        });
    }
    async processMeetingRecordingDisabled(e) {
        this._model.allowRecording = e.meeting.allowRecording;
    }
    async processMeetingRecordingEnabled(e) {
        this._model.allowRecording = e.meeting.allowRecording;
    }
    async processMeetingRecordingStarted(e) {
        this._model.isRecording = e.meeting["isRecording"] != undefined;
        await this._recordingStarted.dispatch({ meeting: this });
    }
    async processMeetingRecordingStopped(e) {
        this._model.isRecording = e.meeting["isRecording"] != undefined;
        await this._recordingStopped.dispatch({ meeting: this });
    }
    async processMeetingVideoMuted(e) {
        const exclusions = new Map(e.exclusions.map(e => [e, e]));
        if (!exclusions.has(this._localAttendee.id)) {
            await this._localAttendee.processMuteVideo();
            this.localUserMedia?.muteVideoInternal();
        }
        this._subscribedView.forEach(async (a) => {
            if (!exclusions.has(a.id))
                await a.processMuteVideo();
        });
    }
    async processMeetingVideoUnmuted(e) {
        const exclusions = new Map(e.exclusions.map(e => [e, e]));
        if (!exclusions.has(this._localAttendee.id)) {
            await this._localAttendee.processUnmuteVideo();
            this.localUserMedia?.unmuteVideoInternal();
        }
        this._subscribedView.forEach(async (a) => {
            if (!exclusions.has(a.id))
                await a.processUnmuteVideo();
        });
    }
    async processMeetingVideoUnmuteDisabled(e) {
        const exclusions = new Map(e.exclusions.map(e => [e, e]));
        if (!exclusions.has(this._localAttendee.id))
            await this._localAttendee.processDisableVideoUnmute();
        this._subscribedView.forEach(async (a) => {
            if (!exclusions.has(a.id))
                await a.processDisableVideoUnmute();
        });
    }
    async processMeetingVideoUnmuteEnabled(e) {
        const exclusions = new Map(e.exclusions.map(e => [e, e]));
        if (!exclusions.has(this._localAttendee.id))
            await this._localAttendee.processEnableVideoUnmute();
        this._subscribedView.forEach(async (a) => {
            if (!exclusions.has(a.id))
                await a.processEnableVideoUnmute();
        });
    }
    /** @internal */
    async processMeetingUpdated(e) {
        const allowAudioUnmute = e.meeting.allowUnmuteAudioOnJoin;
        if (allowAudioUnmute === true || allowAudioUnmute === false) {
            if (allowAudioUnmute) {
                await this._audioUnmuteEnabled.dispatch({
                    meeting: this
                });
            }
            else {
                await this._audioUnmuteDisabled.dispatch({
                    meeting: this
                });
            }
        }
        const allowVideoUnmute = e.meeting.allowUnmuteVideoOnJoin;
        if (allowVideoUnmute === true || allowVideoUnmute === false) {
            if (allowVideoUnmute) {
                await this._videoUnmuteEnabled.dispatch({
                    meeting: this
                });
            }
            else {
                await this._videoUnmuteDisabled.dispatch({
                    meeting: this
                });
            }
        }
        this._model.muteAudioOnJoin = e.meeting["muteAudioOnJoin"] ?? false;
        this._model.muteVideoOnJoin = e.meeting["muteVideoOnJoin"] ?? false;
        this._model.allowUnmuteAudioOnJoin = e.meeting["allowUnmuteAudioOnJoin"] ?? false;
        this._model.allowUnmuteVideoOnJoin = e.meeting["allowUnmuteVideoOnJoin"] ?? false;
        this._model.suppressNoiseOnJoin = e.meeting["suppressNoiseOnJoin"] ?? false;
    }
    async processSubscribedAttendees(e) {
        this._subscribedView.processResponse(e.attendees);
    }
    async validateUserMedia(media, type) {
        if (!media || !this._model)
            return;
        if (type === "display") {
            await media.videoTrack?.setFrameRate(this._model.maxVideoFramerateDisplay);
            await media.videoTrack?.setFrameSize({ height: this._model.maxVideoHeightDisplay, width: this._model.maxVideoWidthDisplay });
        }
        if (this._joinOptions.advancedOptions.restartVideoTrackIos && Utility.isMobileSafari() && type === "user" && media.videoTrack.isStarted) {
            // iOS requires a video track restart for framerate / framesize changes to take effect
            // however, there are other side effects seen when routing through a canvas, ex: blur
            // thus, this feature will be toggleable with the advanced join option
            await media.videoTrack?.reload();
        }
    }
}
function initializeJoinOptions(options) {
    // sanitize input
    options ??= {};
    options.advancedOptions ??= {};
    options.iceOptions ??= {};
    options.localDisplayOptions ??= {};
    options.localUserOptions ??= {};
    options.onLobby ??= () => { };
    options.onProgress ??= () => { };
    options.turnOptions ??= {};
    if (Utility.isNullOrUndefined(options.advancedOptions.restartVideoTrackIos))
        options.advancedOptions.restartVideoTrackIos = false;
    if (Utility.isNullOrUndefined(options.iceOptions.restartEnabled))
        options.iceOptions.restartEnabled = false;
    if (Utility.isNullOrUndefined(options.iceOptions.reconnectionTimeout))
        options.iceOptions.reconnectionTimeout = 10000;
    if (Utility.isNullOrUndefined(options.linkLocalAndRemoteMedia))
        options.linkLocalAndRemoteMedia = true;
    if (Utility.isNullOrUndefined(options.localDisplayOptions.customBandwidthAdaptationEnabled))
        options.localDisplayOptions.customBandwidthAdaptationEnabled = true;
    if (Utility.isNullOrUndefined(options.localDisplayOptions.degradationPreference))
        options.localDisplayOptions.degradationPreference = "maintain-resolution";
    if (Utility.isNullOrUndefined(options.localLoopbackAudio))
        options.localLoopbackAudio = false;
    if (Utility.isNullOrUndefined(options.localLoopbackVideo))
        options.localLoopbackVideo = false;
    if (Utility.isNullOrUndefined(options.localUserOptions.customBandwidthAdaptationEnabled))
        options.localUserOptions.customBandwidthAdaptationEnabled = true;
    if (Utility.isNullOrUndefined(options.localUserOptions.degradationPreference))
        options.localUserOptions.degradationPreference = options.localUserOptions.customBandwidthAdaptationEnabled ? "maintain-resolution" : "maintain-framerate";
    if (Utility.isNullOrUndefined(options.receiveMedia))
        options.receiveMedia = true;
    if (Utility.isNullOrUndefined(options.redAudioEnabled))
        options.redAudioEnabled = true;
    if (Utility.isNullOrUndefined(options.remoteCompatibilityMode))
        options.remoteCompatibilityMode = false;
    if (Utility.isNullOrUndefined(options.remoteDiscardAudio))
        options.remoteDiscardAudio = false;
    if (Utility.isNullOrUndefined(options.remoteDiscardVideo))
        options.remoteDiscardVideo = false;
    if (Utility.isNullOrUndefined(options.remotePixelFeedback))
        options.remotePixelFeedback = false;
    if (Utility.isNullOrUndefined(options.sendUserMedia))
        options.sendUserMedia = true;
    if (Utility.isNullOrUndefined(options.turnOptions.enabled))
        options.turnOptions.enabled = true;
    if (Utility.isNullOrUndefined(options.turnOptions.required))
        options.turnOptions.required = false;
    if (Utility.isNullOrUndefined(options.turnOptions.tcpAllowed))
        options.turnOptions.tcpAllowed = false;
    if (Utility.isNullOrUndefined(options.turnOptions.tlsAllowed))
        options.turnOptions.tlsAllowed = true;
    if (Utility.isNullOrUndefined(options.turnOptions.udpAllowed))
        options.turnOptions.udpAllowed = true;
    if (Utility.isNullOrUndefined(options.useAttendeeList))
        options.useAttendeeList = true;
    if (Utility.isNullOrUndefined(options.useCamera))
        options.useCamera = true;
    if (Utility.isNullOrUndefined(options.useChat))
        options.useChat = true;
    if (Utility.isNullOrUndefined(options.useMicrophone))
        options.useMicrophone = true;
    if (Utility.isNullOrUndefined(options.useRemoteMedia))
        options.useRemoteMedia = true;
    if (Utility.isNullOrUndefined(options.useScreenShare))
        options.useScreenShare = true;
    return options;
}

class PermissionCollection extends ReadOnlyCollection {
    /** @internal */
    constructor() {
        super(permission => permission);
    }
}

class UserMedia extends LocalMedia {
    get audioDeviceId() { return this.audioTrack?.deviceId ?? null; }
    get audioTrack() { return super.audioTrack; }
    get requestedAudioDeviceId() { return this.audioTrack?.requestedDeviceId ?? null; }
    get requestedAudioDeviceRequired() { return this.audioTrack?.requestedDeviceRequired ?? false; }
    get requestedVideoDeviceId() { return this.videoTrack?.requestedDeviceId ?? null; }
    get requestedVideoDeviceRequired() { return this.videoTrack?.requestedDeviceRequired ?? false; }
    get videoDeviceId() { return this.videoTrack?.deviceId ?? null; }
    get videoFacingMode() { return this.videoTrack?.facingMode ?? null; }
    get videoTrack() { return super.videoTrack; }
    constructor(audio, video, deviceOptions = {}) {
        super(audio ? new UserAudioTrack() : null, "user", video ? new UserVideoTrack() : null, deviceOptions);
    }
    getStream(constraints) {
        return globalThis.navigator.mediaDevices.getUserMedia(constraints);
    }
    /** @internal */
    muteAudioInternal() {
        this.audioTrack?.muteInternal();
    }
    /** @internal */
    muteVideoInternal() {
        this.videoTrack?.muteInternal();
    }
    /** @internal */
    unmuteAudioInternal() {
        this.audioTrack?.unmuteInternal();
    }
    /** @internal */
    unmuteVideoInternal() {
        this.videoTrack?.unmuteInternal();
    }
    muteAudio() {
        return this.audioTrack?.mute();
    }
    muteVideo() {
        return this.videoTrack?.mute();
    }
    async setAudioDevice(deviceId, required) {
        await this.audioTrack?.setDevice(deviceId, required);
    }
    async setVideoDevice(deviceId, required) {
        await this.videoTrack?.setDevice(deviceId, required);
    }
    unmuteAudio() {
        return this.audioTrack?.unmute();
    }
    unmuteVideo() {
        return this.videoTrack?.unmute();
    }
    async useNextAudioDevice() {
        await this.audioTrack?.useNextDevice();
    }
    async useNextVideoDevice() {
        await this.videoTrack?.useNextDevice();
    }
    async usePreviousAudioDevice() {
        await this.audioTrack?.usePreviousDevice();
    }
    async usePreviousVideoDevice() {
        await this.videoTrack?.usePreviousDevice();
    }
}

class DatabaseEntity {
}

class PlanTemplateItem extends DatabaseEntity {
}

var Index = /*#__PURE__*/Object.freeze({
    __proto__: null,
    DatabaseEntity: DatabaseEntity,
    PlanTemplateItem: PlanTemplateItem
});

export { Client$6 as ApiClient, Attendee, AttendeeCollection, AttendeeConnectionStatus$1 as AttendeeConnectionStatus, AudioTrack, BadRequestError, BadRequestField, Chat, Channel as ChatChannel, ChannelCollection as ChatChannelCollection, Member as ChatMember, MemberCollection as ChatMemberCollection, Message as ChatMessage, MessageCollection as ChatMessageCollection, ConsoleLogger, DisplayAudioTrack, DisplayMedia, DisplayVideoTrack, EventOwner, EventOwnerAsync, HttpClient, Identity, Client$5 as IdentityClient, InternalServerError, LocalAudioTrack, LocalMedia, LocalVideoTrack, Log, Media, MediaCollection, DeviceCollection as MediaDeviceCollection, DeviceManager as MediaDeviceManager, Meeting, PermissionCollection, RTCMissingError, ReadOnlyCollection, RemoteAudioTrack, RemoteMedia, RemoteMediaCollection, RemoteVideoTrack, UnauthorizedError, UserAudioTrack, UserMedia, UserVideoTrack, VideoTrack, Vue, Index as models, version$1 as version };
//# sourceMappingURL=liveswitch.mjs.map
